


  
  

  var faTurnUp = {
    prefix: 'fasr',
    iconName: 'turn-up',
    icon: [
      384,
      512,
      [10548,"level-up-alt"],
      'f3bf',
      
      'M120 320l0 48H72 48 0l0 48 0 48 0 48H48 216h48V464 256 208h40 8 40V160L225.9 33.9 192 0 158.1 33.9 32 160l0 48H72h8 40v48l0 64zM99.9 160L192 67.9 284.1 160H264 216v48l0 256H48l0-48h72l48 0V368l0-160V160H120 99.9z'
      
    ]
  };

  
    var faLevelUpAlt = faTurnUp;
  

  
  

  var faMessageText = {
    prefix: 'fasr',
    iconName: 'message-text',
    icon: [
      512,
      512,
      ["comment-alt-text"],
      'e1e6',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM168 112H144v48h24 64V296v24h48V296 160h64 24V112H344 256 168z'
      
    ]
  };

  
    var faCommentAltText = faMessageText;
  

  
  

  var faSquareZ = {
    prefix: 'fasr',
    iconName: 'square-z',
    icon: [
      448,
      512,
      [],
      'e288',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM336 160.8l-5.7 6.7L187.7 336H312h24v48H312 136 112V351.2l5.7-6.7L260.3 176H136 112V128h24H312h24v32.8z'
      
    ]
  };

  

  
  

  var faPersonCircleCheck = {
    prefix: 'fasr',
    iconName: 'person-circle-check',
    icon: [
      576,
      512,
      [],
      'e53e',
      
      'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM94.8 128h14.1H211.1h14.1l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6L224 224.9V488v24H176V488 352H144V488v24H96V488 224.9L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128zM144 304h32V176H144V304zm144 64a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z'
      
    ]
  };

  

  
  

  var faHandHoldingMedical = {
    prefix: 'fasr',
    iconName: 'hand-holding-medical',
    icon: [
      576,
      512,
      [],
      'e05c',
      
      'M224 0h96V80h80v96H320v80H224V176H144V80h80V0zM160.7 304H168 384h24v24 46.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H424 24 0V464H24 416.6l91.7-62.8-15-24-80.4 51L407 432h-7H368 320 296 256 232V384h24 40 24 40V352H175.3l-90 60-6 4H72 24 0V368H24 64.7l90-60 6-4z'
      
    ]
  };

  

  
  

  var faGraduationCap = {
    prefix: 'fasr',
    iconName: 'graduation-cap',
    icon: [
      640,
      512,
      [127891,"mortar-board"],
      'f19d',
      
      'M640 176l-12.8 4.5-14.2 5L320 288 126.3 220.2 80 263v83.8c15.4 25.1 27.8 68.4 0 133.2L0 464s32.5-46.5 48-96.9V256v-7l5.1-4.8 38.9-36L26.9 185.4l-14.2-5L0 176V144l12.8-4.5 14.2-5L320 32 613.1 134.6l14.2 5L640 144v32zM320 237.1L540.4 160 320 82.9 99.6 160l41.9 14.7 172.9-64.8 11.2 30-137 51.4 131.4 46zm-176.4 23l46.6 16.3-13 123.5c4.8 3.5 12.8 8 24.6 12.6C230 423.6 272 432 320 432s90-8.4 118.3-19.4c11.8-4.6 19.8-9.2 24.6-12.6l-13-123.5 46.6-16.3L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.6-147.8zM467.4 396a.7 .7 0 1 0 -1.2-.7 .7 .7 0 1 0 1.2 .7zm-294.8 0a.7 .7 0 1 0 1.2-.6 .7 .7 0 1 0 -1.2 .6z'
      
    ]
  };

  
    var faMortarBoard = faGraduationCap;
  

  
  

  var faMessageMiddle = {
    prefix: 'fasr',
    iconName: 'message-middle',
    icon: [
      512,
      512,
      ["comment-middle-alt"],
      'e1e1',
      
      'M173.7 416H48 0V368 48 0H48 464h48V48 368v48H464 338.3l-50.7 59.1L256 512l-31.6-36.9L173.7 416zM464 368V48H48V368H173.7h22.1l14.4 16.8L256 438.2l45.8-53.5L316.2 368h22.1H464z'
      
    ]
  };

  
    var faCommentMiddleAlt = faMessageMiddle;
  

  
  

  var faVideo = {
    prefix: 'fasr',
    iconName: 'video',
    icon: [
      576,
      512,
      ["video-camera"],
      'f03d',
      
      'M48 112V400H336V112H48zM0 64H48 336h48v48 48V352v48 48H336 48 0V400 112 64zM416 314.3l112 56V141.7l-112 56V144L528 88l48-24v53.7V394.3 448l-48-24L416 368V314.3z'
      
    ]
  };

  
    var faVideoCamera = faVideo;
  

  
  

  var faSquareSlidersVertical = {
    prefix: 'fasr',
    iconName: 'square-sliders-vertical',
    icon: [
      448,
      512,
      ["sliders-v-square"],
      'f3f2',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zm120 96H120v24 32H104 80v48h24 16V360v24h48V360 232h16 24V184H184 168V152 128zm160 24V128H280v24V280H264 240v48h24 16v32 24h48V360 328h16 24V280H344 328V152z'
      
    ]
  };

  
    var faSlidersVSquare = faSquareSlidersVertical;
  

  
  

  var faPlusMinus = {
    prefix: 'fasr',
    iconName: 'plus-minus',
    icon: [
      384,
      512,
      [],
      'e43c',
      
      'M216 32V8H168V32 152H48 24v48H48 168V320v24h48V320 200H336h24V152H336 216V32zM8 464v48H32 352h24V464H352 32 8z'
      
    ]
  };

  

  
  

  var faBulldozer = {
    prefix: 'fasr',
    iconName: 'bulldozer',
    icon: [
      640,
      512,
      [],
      'e655',
      
      'M56 32H32V56 176v24 24 97.6C12.2 341.8 0 369.5 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-20.4-5.5-39.5-15-56h47v56 9.3l6.2 6.9 80 88 35.5-32.3L560 390.7V249.3l73.8-81.1-35.5-32.3-80 88-6.2 6.9V240v56H448V200 176H424 376V120 96H328v24 56H275L213.7 45.8 207.2 32H192 56zM221.9 176H80V80h96.8l45.2 96zM400 292.6c-10.1-3-20.9-4.6-32-4.6H112c-11.1 0-21.9 1.6-32 4.6V224H400v68.6zM112 336H368c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64zm32 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBarcode = {
    prefix: 'fasr',
    iconName: 'barcode',
    icon: [
      512,
      512,
      [],
      'f02a',
      
      'M48 32H0V480H48V32zm80 0H96V480h32V32zm80 0H160V480h48V32zm112 0H272V480h48V32zm144 0V480h48V32H464zm-64 0V480h32V32H400z'
      
    ]
  };

  

  
  

  var faFileMp4 = {
    prefix: 'fasr',
    iconName: 'file-mp4',
    icon: [
      512,
      512,
      [],
      'e649',
      
      'M48 464H64v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zm208-96V496v16H224V496 421.8l-17.9 33.7-13.9 26.2-14.3-26L160 423v73 16H128V496 368 352l16 0 4 0 9.5 0 4.6 8.3 29.7 54 28.5-53.8 4.5-8.5 9.6 0 5.6 0 16 0v16zm48-16h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H320v32 16H288V496 448 368 352h16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H320v48h16zm80 16V432 368 352h32v16 48h32V368 352h32v16 64 64 16H480V496 448H432 416z'
      
    ]
  };

  

  
  

  var faShieldKeyhole = {
    prefix: 'fasr',
    iconName: 'shield-keyhole',
    icon: [
      512,
      512,
      [],
      'e248',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM312 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6V328v24h48V328 258.6c18.9-9 32-28.3 32-50.6z'
      
    ]
  };

  

  
  

  var faReflectVertical = {
    prefix: 'fasr',
    iconName: 'reflect-vertical',
    icon: [
      512,
      512,
      [],
      'e665',
      
      'M0 232l24 0 464 0 24 0 0 48-24 0L24 280 0 280l0-48zM222.1 353.9L256 320l33.9 33.9L400 464l16 16 0 32-32 0-3.9 0L368 512l-224 0-12.1 0-3.9 0-32 0 0-32 16-16L222.1 353.9zM332.1 464L256 387.9 179.9 464l152.2 0zM256 192l-33.9-33.9L112 48 96 32 96 0l32 0 3.9 0L144 0 368 0l12.1 0L384 0l32 0 0 32L400 48 289.9 158.1 256 192zm0-67.9L332.1 48 179.9 48 256 124.1z'
      
    ]
  };

  

  
  

  var faSquareShareNodes = {
    prefix: 'fasr',
    iconName: 'square-share-nodes',
    icon: [
      448,
      512,
      ["share-alt-square"],
      'f1e1',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM352 176c0 26.5-21.5 48-48 48c-9.8 0-18.9-2.9-26.5-7.9L197.7 256l79.9 39.9c7.6-5 16.7-7.9 26.5-7.9c26.5 0 48 21.5 48 48s-21.5 48-48 48c-25.5 0-46.4-20-47.9-45.1l-85.6-42.8c-7.6 5-16.7 7.9-26.5 7.9c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.8 0 18.9 2.9 26.5 7.9l85.6-42.8C257.6 148 278.5 128 304 128c26.5 0 48 21.5 48 48z'
      
    ]
  };

  
    var faShareAltSquare = faSquareShareNodes;
  

  
  

  var faComet = {
    prefix: 'fasr',
    iconName: 'comet',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M304 16L253.6 45.2 101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3l88.2-152.3L496 208l-7.5 .6L438 212.5l-1.9 .1 17.7-49.5L491.1 58.4 512 0 453.6 20.9 348.9 58.3 299.4 75.9l.1-1.9 3.9-50.5L304 16zM125.3 174.9l123.8-71.7L245.9 146l69.7-24.9L432.7 79.3 390.9 196.5 366 266.1l42.8-3.3L337.1 386.7C309.4 434.5 258.3 464 203 464c-85.6 0-155-69.4-155-155c0-55.3 29.5-106.4 77.3-134.1zm117.3 91L208 196.8l-34.6 69.1L96 277l56 53.8-13.2 76L208 370.9l69.2 35.9-13.2-76L320 277l-77.4-11.1z'
      
    ]
  };

  

  
  

  var faJetFighter = {
    prefix: 'fasr',
    iconName: 'jet-fighter',
    icon: [
      640,
      512,
      ["fighter-jet"],
      'f0fb',
      
      'M160 0h24H296h24V48H296h-3.1l11.7 16.1L386 176H488h3.7l3.5 1.1 128 40 16.8 5.3V240v32 17.6l-16.8 5.3-128 40-3.5 1.1H488 386L292.9 464H296h24v48H296 184 160V464h24 8V336H177.9l-41 41-7 7H120 56 32V360 280H24 0V232H24h8V152 128H56h64 9.9l7 7 41 41H192V48h-8H160V0zm80 176h86.7L265.8 92.3 240 56.8V176zM80 280v56h30.1l41-41 7-7H168 484.3l102.4-32L484.3 224H168h-9.9l-7-7-41-41H80v56h24 24v48H104 80zm160 56V455.2L326.7 336H240z'
      
    ]
  };

  
    var faFighterJet = faJetFighter;
  

  
  

  var faPageCaretUp = {
    prefix: 'fasr',
    iconName: 'page-caret-up',
    icon: [
      384,
      512,
      ["file-caret-up"],
      'e42a',
      
      'M336 131.9V464H48V48H252.1L336 131.9zM384 112L272 0H48 0V48 464v48H48 336h48V464 112zM96 320H288V288l-96-96L96 288v32z'
      
    ]
  };

  
    var faFileCaretUp = faPageCaretUp;
  

  
  

  var faHandshakeSimple = {
    prefix: 'fasr',
    iconName: 'handshake-simple',
    icon: [
      640,
      512,
      [129309,"handshake-alt"],
      'f4c6',
      
      'M272.8 64H200h-9.5l-6.9 6.5L122.3 128H56 32v48H56h75.8 9.5l6.9-6.5L209.5 112h15.3l48-48zM328 64h-9.5l-6.9 6.5-136 128-17 16 15.5 17.4 64 72 16.2 18.3 18-16.6L340.1 243 432 334.9v1.8l-49 49-9.7-9.7-17-17-17 17L309.4 406l-21-21-17-17-17 17-23.3 23.3-21.3-21.3-17-17-7-7-52-52-7-7h-9.9H56 32v48H56h51l45 45 7 7 17 17 38.2 38.2 17 17 17-17 23.3-23.3 21 21 17 17 17-17L356.3 427l9.7 9.7 17 17 17-17L468.5 368H584h24V320H584 485l-1.2-1.2L375.4 210.4l.8-.8 17.6-16.3-32.6-35.3-17.6 16.3-86 79.4-32.3-36.3L337.5 112h77.4l65.2 57.9 6.8 6.1H496h88 24V128H584 505.1L439.9 70.1 433.1 64H424 328z'
      
    ]
  };

  
    var faHandshakeAlt = faHandshakeSimple;
  

  
  

  var faEyes = {
    prefix: 'fasr',
    iconName: 'eyes',
    icon: [
      640,
      512,
      [],
      'e367',
      
      'M255.6 385.2C231.4 416.6 201.5 432 172 432s-59.4-15.4-83.6-46.8c-9.1-11.9-17.1-25.7-23.5-41.2c9.2 5.1 19.8 8 31.1 8c35.3 0 64-28.7 64-64s-28.7-64-64-64c-19 0-36.1 8.3-47.8 21.4c2-47.8 17.7-89.3 40.2-118.6C112.6 95.4 142.5 80 172 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2zM320 141.8C290 76.1 235 32 172 32C77 32 0 132.3 0 256S77 480 172 480c63 0 118-44.1 148-109.8C350 435.9 405 480 468 480c95 0 172-100.3 172-224s-77-224-172-224c-63 0-118 44.1-148 109.8zm42.8 206.6c6.6 2.3 13.7 3.6 21.2 3.6c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.8 0-28.5 5-39.3 13.5c3.3-44.4 18.5-83 39.8-110.6C408.6 95.4 438.5 80 468 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2C527.4 416.6 497.5 432 468 432s-59.4-15.4-83.6-46.8c-8.2-10.7-15.5-23.1-21.6-36.7z'
      
    ]
  };

  

  
  

  var faCircleJ = {
    prefix: 'fasr',
    iconName: 'circle-j',
    icon: [
      512,
      512,
      [],
      'e112',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360V128H288v24V288c0 26.5-21.5 48-48 48s-48-21.5-48-48v-8V256H144v24 8c0 53 43 96 96 96s96-43 96-96V152z'
      
    ]
  };

  

  
  

  var faGalleryThumbnails = {
    prefix: 'fasr',
    iconName: 'gallery-thumbnails',
    icon: [
      576,
      512,
      [],
      'e3aa',
      
      'M528 48V304H48V48H528zM48 0H0V48 304v48H48 528h48V304 48 0H528 48zM96 416H0v96H96V416zm160 0H160v96h96V416zm64 0v96h96V416H320zm256 96V416H480v96h96z'
      
    ]
  };

  

  
  

  var faHandPointLeft = {
    prefix: 'fasr',
    iconName: 'hand-point-left',
    icon: [
      512,
      512,
      [],
      'f0a5',
      
      'M0 104L0 80l24 0 216 0 0-16 24 0 56 0 0 0 24 0s0 0 0 0c92.8 0 168 75.2 168 168l0 48c0 92.7-75.1 167.9-167.9 168c0 0-.1 0-.1 0l0 0-88 0-40 0-24 0 0-24 0-56-16 0 0-24 0-56-8 0-24 0 0-24 0-56L24 208 0 208l0-24 0-80zM256 400l80 0 0-32-96 0 0 32 16 0zm128-6.8c46.6-16.5 80-60.9 80-113.2l0-48c0-66.3-53.7-120-120-120c0 0 0 0 0 0l-24 0 0 0-32 0 0 72 0 56 32 0 0-56 0-24 48 0 0 24 0 56 0 24 0 24 0 32 16 0 0 24 0 49.2zM240 160l0-32L48 128l0 32 96 0 24 0 72 0zm0 80l0-32-48 0 0 32 8 0 40 0zm-16 48l0 32 96 0 0-32-56 0-40 0z'
      
    ]
  };

  

  
  

  var faPineapple = {
    prefix: 'fasr',
    iconName: 'pineapple',
    icon: [
      512,
      512,
      [],
      'e31f',
      
      'M512 96l-40 40 24 24-57.1 22.9L448 192V320L256 512H128L0 384V256L192 64H320l9.1 9.1L352 16l24 24L416 0l10 30 70-14L482 86l30 10zM236.1 464L400 300.1V211.9L300.1 112H211.9L48 275.9v88.2L147.9 464h88.2zM176 201.4l11.3 11.3L208 233.4l20.7-20.7L240 201.4 262.6 224l-11.3 11.3-32 32L208 278.6l-11.3-11.3-32-32L153.4 224 176 201.4zm-80 80l11.3 11.3L128 313.4l20.7-20.7L160 281.4 182.6 304l-11.3 11.3-32 32L128 358.6l-11.3-11.3-32-32L73.4 304 96 281.4zm160 0l11.3 11.3L288 313.4l20.7-20.7L320 281.4 342.6 304l-11.3 11.3-32 32L288 358.6l-11.3-11.3-32-32L233.4 304 256 281.4zm-80 80l11.3 11.3L208 393.4l20.7-20.7L240 361.4 262.6 384l-11.3 11.3-32 32L208 438.6l-11.3-11.3-32-32L153.4 384 176 361.4z'
      
    ]
  };

  

  
  

  var faCloudQuestion = {
    prefix: 'fasr',
    iconName: 'cloud-question',
    icon: [
      640,
      512,
      [],
      'e492',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM232 216c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L344 296.4V304v24H296V304 282.5 268.6l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H288c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 152h48v48H296V368z'
      
    ]
  };

  

  
  

  var faFaceWoozy = {
    prefix: 'fasr',
    iconName: 'face-woozy',
    icon: [
      512,
      512,
      [],
      'e3a2',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 208c0-35.3-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64s32-28.7 32-64zM213.8 247.3l23.3-5.8-11.6-46.6-23.3 5.8-64 16-23.3 5.8 11.6 46.6 23.3-5.8 64-16zm.4-139.7L187.6 89.8l-8.9 13.3c-23.2 34.8-58.4 53.2-71.7 57.7l-15.2 5.1 10.1 30.4 15.2-5.1c18.6-6.2 60.3-28.3 88.3-70.3l8.9-13.3zM385.8 360.1l16.1-17.8-35.5-32.3-16.1 17.8L319 362.3c-3.3 3.6-7.9 5.7-12.8 5.7c-3.5 0-6.9-1.1-9.8-3l-11.7-8.1c-24-16.5-54.7-19.4-81.4-7.7c-11.7 5.2-25.3 3.7-35.7-3.9l-9.4-6.9-19.3-14.2-28.4 38.7 19.3 14.2 9.4 6.9c24.2 17.8 56 21.2 83.4 9.1c11.4-5 24.5-3.8 34.8 3.3l11.7 8.1c10.9 7.5 23.8 11.5 37 11.5c18.4 0 36-7.8 48.3-21.4l31.3-34.5z'
      
    ]
  };

  

  
  

  var faKipSign = {
    prefix: 'fasr',
    iconName: 'kip-sign',
    icon: [
      384,
      512,
      [],
      'e1c4',
      
      'M335.6 82.2l18.2-15.6L322.6 30.2 304.4 45.8 112 210.7V56 32H64V56 232H24 0v48H24 64V457v24h48V457 301.3L304.4 466.2l18.2 15.6 31.2-36.4-18.2-15.6L160.9 280H360h24V232H360 160.9L335.6 82.2z'
      
    ]
  };

  

  
  

  var faFileGif = {
    prefix: 'fasr',
    iconName: 'file-gif',
    icon: [
      512,
      512,
      [],
      'e645',
      
      'M48 464H160v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zm176-72c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v16H288V392c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8H272V432h16 16 16v16 24c0 22.1-17.9 40-40 40H264c-22.1 0-40-17.9-40-40V392zm160-24V496v16H352V496 368 352h32v16zm48-16h48 16v32H480 448v32h32 16v32H480 448v48 16H416V496 432 368 352h16z'
      
    ]
  };

  

  
  

  var faMasksTheater = {
    prefix: 'fasr',
    iconName: 'masks-theater',
    icon: [
      640,
      512,
      [127917,"theater-masks"],
      'f630',
      
      'M169.8 373.5c-49.4-22.2-84.4-52.3-90.8-90.3L50.3 111.2c2.4-2.7 5.7-6.1 10.3-9.8c17.1-14 53.5-35 126.1-47.1c40.9-6.8 71.8-7.3 94.7-5c3-1.3 6.2-2.6 9.5-3.8c20.4-7.5 46.6-13.2 80.3-14.5C353.4 16.3 300.5-13.5 178.8 6.9C21 33.3 0 101.7 0 101.7L31.7 291.1C52.8 417.3 252.7 448.8 252.7 448.8s.8-.4 2.3-1.3c-14.7-16.6-28.7-35.7-39.4-57c-14-4.2-29.9-9.8-45.8-17zm29.9-98.4l8.6-51.5c-41.8 8.7-70.2 47.6-66.1 89.8c15.1-17.3 34.7-30.8 57.5-38.3zM184 147.2c-9.2 9.5-21.4 16.3-35.4 18.6s-27.8-.1-39.5-6.1c-.6 4.1-.6 8.4 .1 12.7c3.6 21.8 24.3 36.5 46.1 32.8s36.5-24.3 32.8-46.1c-.7-4.3-2.1-8.3-4-12zM387.3 511.5s199.9-31.4 221.1-157.7L640 164.4s-21-68.4-178.8-94.8s-199.9 31.4-199.9 31.4L229.6 290.4C208.4 416.7 387.3 511.5 387.3 511.5zM305.7 126.4c3.1-1.8 7.4-3.9 13-5.9c20.7-7.7 62-15.7 134.6-3.5s109 33.2 126.1 47.1c4.6 3.8 7.9 7.1 10.3 9.8L561 345.9c-6.4 38-41.3 68.1-90.8 90.3c-23.1 10.4-46 17.5-63.4 21.9c-4.1 1.1-7.8 1.9-11.1 2.7c-2.9-1.8-6.1-3.8-9.6-6.2c-14.9-9.9-34.3-24-52.8-41.4c-39.5-37.1-62.8-77-56.4-115l28.8-171.9zM405.8 243.4c1.9-3.7 3.3-7.7 4-12c3.6-21.8-11.1-42.4-32.9-46.1s-42.4 11.1-46.1 32.8c-.7 4.3-.7 8.6-.1 12.7c11.8-6 25.5-8.4 39.5-6.1s26.2 9.1 35.4 18.6zM532 264.5c1.9-3.7 3.3-7.7 4-12c3.6-21.8-11.1-42.4-32.8-46.1s-42.4 11.1-46.1 32.8c-.7 4.3-.7 8.6-.1 12.7c11.8-6 25.5-8.4 39.6-6.1s26.2 9.1 35.4 18.6zm3.7 36.6c-34.1 19.6-75 28-116.8 21s-77.7-28.2-103.6-57.9c-5.5 58 34.7 111.2 93 121s113.7-27.5 127.4-84.1z'
      
    ]
  };

  
    var faTheaterMasks = faMasksTheater;
  

  
  

  var faStapler = {
    prefix: 'fasr',
    iconName: 'stapler',
    icon: [
      640,
      512,
      [],
      'e5af',
      
      'M448 384v48H32v48H448h48 48 48 48V432 336 288 240L255.6 47.8C234.8 37.4 211.9 32 188.6 32C131.9 32 80 64.1 54.6 114.8L22 180 0 224l47.7 11.9L64 240V360v24H88 448zm0-48H112V252l336 84zm96 96H496V336 298.5l-36.4-9.1L69.7 191.9l27.8-55.6C114.8 101.8 150 80 188.6 80c15.8 0 31.4 3.7 45.6 10.8L592 269.7V288v48 96H544z'
      
    ]
  };

  

  
  

  var faD = {
    prefix: 'fasr',
    iconName: 'd',
    icon: [
      384,
      512,
      [100],
      '44',
      
      'M0 32H24 160c123.7 0 224 100.3 224 224s-100.3 224-224 224H24 0V456 56 32zM48 80V432H160c97.2 0 176-78.8 176-176s-78.8-176-176-176H48z'
      
    ]
  };

  

  
  

  var faBedFront = {
    prefix: 'fasr',
    iconName: 'bed-front',
    icon: [
      512,
      512,
      ["bed-alt"],
      'f8f7',
      
      'M32 32V192H80V128H240v64h32V128H432v64h48V32H32zM24 224H0v24V392v64 24H48V456 416H464v40 24h48V456 392 248 224H488 24zM464 368H48V272H464v96z'
      
    ]
  };

  
    var faBedAlt = faBedFront;
  

  
  

  var faHorizontalRule = {
    prefix: 'fasr',
    iconName: 'horizontal-rule',
    icon: [
      640,
      512,
      [8213],
      'f86c',
      
      'M0 232H24 616h24v48H616 24 0V232z'
      
    ]
  };

  

  
  

  var faTrowel = {
    prefix: 'fasr',
    iconName: 'trowel',
    icon: [
      512,
      512,
      [],
      'e589',
      
      'M409.9 198.1L376 232l-31-31L233 313l53.1 53.1L320 400l-33.9 33.9L280 440 53.1 498.4 0 512l13.6-53.1L72 232l6.1-6.1L112 192l33.9 33.9L199 279 311 167l-31-31 33.9-33.9 68.1-68.1L416 0l33.9 33.9 28.1 28.1L512 96l-33.9 33.9-68.1 68.1zM376 164.1L444.1 96 416 67.9 347.9 136 376 164.1zm-125.8 234L113.9 261.8 66.7 445.3l183.5-47.2z'
      
    ]
  };

  

  
  

  var faUmbrella = {
    prefix: 'fasr',
    iconName: 'umbrella',
    icon: [
      576,
      512,
      [],
      'f0e9',
      
      'M312 0V24 48.9C436.7 58.6 539.7 143.3 568.2 256c.4 1.4 .7 2.8 1 4.2c.8 3.3 1.5 6.7 2.2 10.1c.5 2.7 1 5.5 1.5 8.3c.4 2.4 .7 4.9 1.1 7.4l2.3 18.1H558h-6.5-7.2l-4.8-5.3c-2.3-2.6-4.8-5.1-7.5-7.3c-2.2-1.9-4.4-3.6-6.7-5.2C512.5 277.2 496.9 272 480 272c-30.1 0-56.3 16.6-70 41.2c-6.4 11.5-10 24.7-10 38.8H384 368c0-14.1-3.6-27.3-10-38.8c-13.7-24.6-39.9-41.2-70-41.2s-56.3 16.6-70 41.2c-6.4 11.5-10 24.7-10 38.8H192 176c0-14.1-3.6-27.3-10-38.8C152.3 288.6 126.1 272 96 272c-16.9 0-32.5 5.2-45.4 14.1c-2.3 1.6-4.6 3.4-6.7 5.2c-2.6 2.3-5.1 4.7-7.5 7.3L31.6 304H24.4 18-.2l2.3-18.1c.3-2.5 .7-4.9 1.1-7.4c.4-2.8 .9-5.5 1.5-8.3c.7-3.4 1.4-6.7 2.2-10.1c.3-1.4 .7-2.8 1-4.2C36.3 143.3 139.3 58.6 264 48.9V24 0h48zm72 267.3c23.5-26.6 57.8-43.3 96-43.3c9.1 0 18 1 26.5 2.8C469 150.3 386.2 96 288 96s-181 54.3-218.5 130.8C78 224.9 86.9 224 96 224c38.2 0 72.5 16.8 96 43.3c23.5-26.6 57.8-43.3 96-43.3s72.5 16.8 96 43.3zM288 304c8.7 0 16.9 2.3 24 6.4V438.6c0 40.6-32.9 73.4-73.4 73.4c-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7-10.7-21.5 42.9-21.5 10.7 21.5 2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1c14.1 0 25.4-11.4 25.4-25.4V310.4c7.1-4.1 15.3-6.4 24-6.4z'
      
    ]
  };

  

  
  

  var faCameraCctv = {
    prefix: 'fasr',
    iconName: 'camera-cctv',
    icon: [
      576,
      512,
      ["cctv"],
      'f8ac',
      
      'M0 224l24-42.1L128 0 522.1 154.8 576 176l-47.7 32.8-34 23.4 0 0L381 310.1 320 352l-90.1-36L182.4 440.5 176.5 456H160 48v32 24H0V488 432 376 352H48v24 32h95.5l41.9-109.9L45 242 0 224zm314 73.9L474.3 187.6 149.1 59.9 69 199.9l244.9 98zM520 400L387.7 344.3l142.6-98.1L576 264 520 400z'
      
    ]
  };

  
    var faCctv = faCameraCctv;
  

  
  

  var faGrid2 = {
    prefix: 'fasr',
    iconName: 'grid-2',
    icon: [
      512,
      512,
      [],
      'e196',
      
      'M80 80v96h96V80H80zM32 32H80h96 48V80v96 48H176 80 32V176 80 32zM80 336v96h96V336H80zM32 288H80h96 48v48 96 48H176 80 32V432 336 288zM432 80H336v96h96V80zM336 32h96 48V80v96 48H432 336 288V176 80 32h48zm0 304v96h96V336H336zm-48-48h48 96 48v48 96 48H432 336 288V432 336 288z'
      
    ]
  };

  

  
  

  var faSack = {
    prefix: 'fasr',
    iconName: 'sack',
    icon: [
      512,
      512,
      [],
      'f81c',
      
      'M382.9 48L360.2 80.9 333 120.4c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416v48 48H464 48 0V464 416C0 274.8 89.4 185.5 150.8 139.9c10.4-7.7 20-14.2 28.2-19.4L151.8 80.9 129.1 48 96 0h58.3H357.7 416L382.9 48zM464 416c0-139-102.9-220.6-156.9-255.2L293.3 152H218.7l-13.8 8.8C150.9 195.4 48 277 48 416v48H464V416zM286 104l7.5-10.8L324.6 48H187.4l31.1 45.2L226 104h60z'
      
    ]
  };

  

  
  

  var faCircleT = {
    prefix: 'fasr',
    iconName: 'circle-t',
    icon: [
      512,
      512,
      [],
      'e124',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144H128v48h24 80V360v24h48V360 192h80 24V144H360 256 152z'
      
    ]
  };

  

  
  

  var faBuildingColumns = {
    prefix: 'fasr',
    iconName: 'building-columns',
    icon: [
      512,
      512,
      ["bank","institution","museum","university"],
      'f19c',
      
      'M48 192H0V144L256 0 512 144v48H464 48zm366.1-48L256 55.1 97.9 144H228.3c-2.7-4.7-4.3-10.2-4.3-16c0-17.7 14.3-32 32-32s32 14.3 32 32c0 5.8-1.6 11.3-4.3 16H414.1zM64 224h48V384h64V224h48V384h64V224h48V384h64V224h48V384h8 24v48H456 56 32V384H56h8V224zM24 464H488h24v48H488 24 0V464H24z'
      
    ]
  };

  
    var faBank = faBuildingColumns;
  
    var faInstitution = faBuildingColumns;
  
    var faMuseum = faBuildingColumns;
  
    var faUniversity = faBuildingColumns;
  

  
  

  var faPersonMilitaryPointing = {
    prefix: 'fasr',
    iconName: 'person-military-pointing',
    icon: [
      576,
      512,
      [],
      'e54a',
      
      'M224 16V64H416V0L224 16zm48 338.1V272h73.5L272 354.1zM224 272V464v48h48 96 48V464 324.2l64 111.7 11.9 20.8 41.7-23.9-11.9-20.8-100.8-176-4.8-8.4V224l-2.1 0H400l-32 0H272 224l0 0H56 32v48H56 224h0zm144 46.8V384H309.7L368 318.8zM272 432h96v32H272V432zM241.6 96c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H347.7c2.7 4.7 4.3 10.2 4.3 16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H241.6z'
      
    ]
  };

  

  
  

  var faUsersGear = {
    prefix: 'fasr',
    iconName: 'users-gear',
    icon: [
      640,
      512,
      ["users-cog"],
      'f509',
      
      'M224 80A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm368 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM196 192H48L0 320H235.3c-26.6-23.5-43.3-57.8-43.3-96c0-11 1.4-21.8 4-32zm418.1 59.1L592 192H444c2.6 10.2 4 21 4 32h32 64 32v32 17.1l0 0 14.8-8.6 23.3-13.5zM320 128c-53 0-96 43-96 96s43 96 96 96c19.9 0 38.3-6 53.7-16.4l15.8-27.3 16-27.7 6.3 3.7c2.7-8.9 4.2-18.4 4.2-28.2c0-53-43-96-96-96zm25.7 224H176L142.4 464 128 512h50.1 223l-11.7-20.3-16-27.7H192.5l19.2-64H356.3l12.9-7.4L384 384l-14.9-8.6-27.7-16 4.3-7.4zM272 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm272 69.5V256H480v37.5c-11.2 4-21.5 10-30.4 17.6l-32.5-18.7-32 55.4 32.5 18.7c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-32.5 18.7 32 55.4L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6V512h64V474.5c11.2-4 21.5-10 30.4-17.6l32.5 18.7 32-55.4-32.5-18.7c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l32.5-18.7-32-55.4L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'
      
    ]
  };

  
    var faUsersCog = faUsersGear;
  

  
  

  var faMagnifyingGlassDollar = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-dollar',
    icon: [
      512,
      512,
      ["search-dollar"],
      'f688',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm20.1-304V91.9H187.9V112v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304v20.1h40.2V304v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.4-3.2-21-4.4V112z'
      
    ]
  };

  
    var faSearchDollar = faMagnifyingGlassDollar;
  

  
  

  var faX = {
    prefix: 'fasr',
    iconName: 'x',
    icon: [
      384,
      512,
      [120],
      '58',
      
      'M3 32L162.5 256 3 480H62L192 297.4 322 480h58.9L221.5 256 380.9 32H322L192 214.6 62 32H3z'
      
    ]
  };

  

  
  

  var faSkullCow = {
    prefix: 'fasr',
    iconName: 'skull-cow',
    icon: [
      640,
      512,
      [],
      'f8de',
      
      'M0 95.5C0 166.1 57.2 224 128 224l16 0V336v48h48 25.6L256 512H384l38.4-128H448h48V336 224h16c70.8 0 128-57.9 128-128.5C640 61 621 26.2 600 0L576 16c1 3.1 2.2 6.4 3.4 9.9l0 0c5.8 16.4 12.7 35.8 11.1 51.8C587.7 106.3 563.7 128 535 128l-39 0V96H448 192 144v32l-39 0c-28.7 0-52.7-21.7-55.6-50.3c-1.6-16 5.3-35.5 11.1-51.8C61.8 22.4 63 19.1 64 16L40 0C19 26.2 0 61 0 95.5zM253.3 336H217.6 192V144H448V336H422.4 386.7l-10.3 34.2L348.3 464H291.7l-28.1-93.8L253.3 336zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faComputerSpeaker = {
    prefix: 'fasr',
    iconName: 'computer-speaker',
    icon: [
      640,
      512,
      [],
      'f8b2',
      
      'M288 480V432H120 96v48h24H288zM48 32H0V80 336v48H48 288V336H48V80H288V32H48zM592 80V432H368V80H592zM368 32H320V80 432v48h48H592h48V432 80 32H592 368zM480 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM448 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faFerrisWheel = {
    prefix: 'fasr',
    iconName: 'ferris-wheel',
    icon: [
      512,
      512,
      [],
      'e174',
      
      'M208 0h96V45.4c18 4.1 35.1 10.4 51.1 18.6H448v92.9c8.2 16 14.6 33.1 18.6 51.1H512v48c0 25.6-20.1 46.5-45.3 47.9c-4.1 18-10.4 35.1-18.7 51.1V400c0 25.1-19.2 45.7-43.8 47.8l-32.8-69.7c8.3-7.9 15.9-16.6 22.5-26.1c14.6-21 24.6-45.5 28.4-72h-90c2.4-7.6 3.7-15.6 3.7-24c0-8.4-1.3-16.4-3.7-24h90c-1.2-8.2-2.9-16.2-5.3-24c-5.2-17.3-13-33.5-23.2-48c-1.1-1.6-2.2-3.1-3.3-4.6L326.9 219c-7.6-14.5-19.5-26.4-33.9-33.9l63.6-63.6c-1.5-1.1-3.1-2.2-4.6-3.3c-14.5-10.1-30.7-18-48-23.2c-7.8-2.3-15.8-4.1-24-5.3v90c-7.6-2.4-15.6-3.7-24-3.7s-16.4 1.3-24 3.7v-90c-8.2 1.2-16.2 2.9-24 5.3c-17.3 5.2-33.5 13-48 23.2c-1.6 1.1-3.1 2.2-4.6 3.3L219 185.1c-14.5 7.6-26.4 19.5-33.9 33.9l-63.6-63.6c-1.1 1.5-2.2 3.1-3.3 4.6c-10.1 14.5-18 30.7-23.2 48c-2.3 7.8-4.1 15.8-5.3 24h90c-2.4 7.6-3.7 15.6-3.7 24c0 8.4 1.3 16.4 3.7 24h-90c3.8 26.5 13.8 51 28.4 72c6.6 9.4 14.1 18.2 22.5 26.1l-32.8 69.7C83.2 445.7 64 425.1 64 400V355.1c-8.3-16-14.6-33.1-18.7-51.1C20.1 302.5 0 281.6 0 256V208H45.4c4.1-18 10.4-35.1 18.6-51.1V112 64h92.9c16-8.3 33.1-14.6 51.1-18.6V0zM135.5 464L219 286.6c-6.9-8.3-11-19-11-30.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 11.6-4.1 22.3-11 30.6L376.5 464l7.5 16v32H336 176 128V480l7.5-16zm53 0H323.4L256 320.7 188.6 464z'
      
    ]
  };

  

  
  

  var faDollarSign = {
    prefix: 'fasr',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      'M184 24V0H136V24 71.7c-3.1 .1-6.2 .3-9.3 .6c-23.2 1.9-47.2 7.4-67.2 20.1C38.7 105.6 23.5 126 18 154.2c-3.9 20.3-2 38.8 6.1 55.2c8 16 20.9 27.6 34.8 36.2c26.2 16.2 61.9 25.3 92.9 33.2l2.3 .6c33.9 8.6 62.6 16.1 81.7 28c9 5.6 14.3 11.2 17.1 16.9c2.7 5.3 4.2 12.8 2 24.5c-2.9 14.7-13.4 26.9-34.5 34.9c-21.6 8.2-52 10.9-87.6 5.9c-22.6-3.3-61.8-12.7-83-22.1l-21.9-9.7L8.3 401.5l21.9 9.7C57 423.2 101.1 433.4 126 437l.1 0c3.3 .5 6.6 .9 9.9 1.2V488v24h48V488 439.4c19.3-1.3 37.4-4.9 53.5-11c31.9-12.1 57.7-35.2 64.5-70.6c3.9-20.3 2-38.8-6.1-55.2c-8-16-20.9-27.6-34.8-36.2c-26.2-16.2-61.9-25.3-92.9-33.2l-2.3-.6c-33.9-8.6-62.6-16.1-81.7-28c-9-5.6-14.3-11.2-17.1-16.9c-2.7-5.3-4.2-12.8-2-24.5c2.9-14.8 10.1-24 20.2-30.4c10.9-6.9 26.3-11.2 45.3-12.7c38.3-3.1 83.1 5.3 113.9 12.5l23.4 5.5 11-46.7L255.5 86c-18.7-4.4-44.2-9.7-71.5-12.5V24z'
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faCircleWaveformLines = {
    prefix: 'fasr',
    iconName: 'circle-waveform-lines',
    icon: [
      512,
      512,
      ["waveform-circle"],
      'e12d',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368V120H208v24V368v24h48V368 144zm80 56V176H288v24V312v24h48V312 200zM176 216V192H128v24 80 24h48V296 216zm240 24V216H368v24 32 24h48V272 240z'
      
    ]
  };

  
    var faWaveformCircle = faCircleWaveformLines;
  

  
  

  var faFaceNoseSteam = {
    prefix: 'fasr',
    iconName: 'face-nose-steam',
    icon: [
      512,
      512,
      [],
      'e382',
      
      'M256 464c-21.6 0-42.4-3.3-61.9-9.4c-3.1 8.6-8.1 16.7-15 23.6c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C198.4 507 226.6 512 256 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-7-7-12-15.2-15.1-23.9c-19 5.7-39.2 8.8-60 8.8zm97.8-7.5c4.7 4.7 10.4 7.6 16.4 8.8c-2.1 4.3-3.1 9-3.1 13.7c0 .7 0 1.3 .1 2c.4 7.6 3.5 15 9.3 20.8c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2c12.5-12.5 12.5-32.8 0-45.3c-4.3-4.3-9.5-7.1-15-8.5l0 0c-1.9-.5-3.8-.8-5.8-.9c-5.4-.3-10.8 .7-15.7 3.1c-1-5.2-3.3-10.1-6.9-14.4c-.6-.7-1.2-1.4-1.8-2c-3.6-3.6-7.9-6.2-12.5-7.7l0 0c-11.1-3.7-23.9-1.1-32.8 7.7c-4.4 4.4-7.2 9.7-8.5 15.3L320 320.9l49.1 81.8c-5.6 1.3-10.9 4.2-15.3 8.5c-12.5 12.5-12.5 32.8 0 45.3zM464 256c0 21.3-3.2 41.8-9.1 61.1c8.5 3.1 16.5 8.1 23.4 14.9c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1c8.9-26.1 13.8-54 13.8-83.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4c7.2-7.2 15.7-12.3 24.7-15.4C51 296.8 48 276.8 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208zM143 481.4c0-.5 .1-.9 .1-1.4c.1-2 0-4.1-.2-6.1c-.4-3.3-1.4-6.5-2.9-9.6c6-1.2 11.7-4.1 16.4-8.8c12.5-12.5 12.5-32.8 0-45.3c-4.4-4.4-9.7-7.2-15.3-8.5L190.2 320l-81.8 49.1c-1.3-5.6-4.2-10.9-8.5-15.3c-8.6-8.6-20.8-11.3-31.6-8.1c0 0 0 0 0 0c-5 1.5-9.7 4.2-13.6 8.1c-.7 .6-1.3 1.3-1.9 2c-3.6 4.3-5.9 9.2-6.9 14.4c-4.9-2.4-10.3-3.4-15.7-3.1c-1.5 .1-3.1 .3-4.6 .6c0 0 0 0 0 0c-5.9 1.2-11.6 4.1-16.2 8.7c-12.5 12.5-12.5 32.8 0 45.3c2.1 2.1 4.3 3.8 6.7 5.2C1.7 445.6 3 472.7 20.3 489.9s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c5.4-5.4 8.5-12.3 9.2-19.4zM315.3 187.3c9.3-9.3 38.2-32.3 73.7-44.1l-10.1-30.4c-41.3 13.8-74.2 39.9-86.3 51.9l22.6 22.6zM112 224H96v32h16 96 16V224H208 112zm192 0H288v32h16 96 16V224H400 304zM122.9 143.2c35.5 11.8 64.4 34.8 73.7 44.1l22.6-22.6c-12-12-45-38.1-86.3-51.9l-10.1 30.4z'
      
    ]
  };

  

  
  

  var faTurkishLiraSign = {
    prefix: 'fasr',
    iconName: 'turkish-lira-sign',
    icon: [
      384,
      512,
      ["try","turkish-lira"],
      'e2bb',
      
      'M112 32V56v56.2L249.4 72.9l23.1-6.6 13.2 46.2-23.1 6.6L112 162.1v46.1l137.4-39.3 23.1-6.6 13.2 46.2-23.1 6.6L112 258.1V432h88c75.1 0 136-60.9 136-136V280 256h48v24 16c0 101.6-82.4 184-184 184H88 64V456 271.8l-25.4 7.3-23.1 6.6L2.3 239.5l23.1-6.6 38.6-11V175.8l-25.4 7.3-23.1 6.6L2.3 143.5l23.1-6.6 38.6-11V56 32h48z'
      
    ]
  };

  
    var faTry = faTurkishLiraSign;
  
    var faTurkishLira = faTurkishLiraSign;
  

  
  

  var faPrint = {
    prefix: 'fasr',
    iconName: 'print',
    icon: [
      512,
      512,
      [9113,128424,128438],
      'f02f',
      
      'M112 160V48H364.1L400 83.9V160h48V64L384 0H112 64V48 160h48zM384 368v96H128V368H384zM128 320H80v32H48V240H464V352H432V320H384 128zm304 80h32 48V352 240 192H464 48 0v48V352v48H48 80v64 48h48H384h48V464 400z'
      
    ]
  };

  

  
  

  var faCommentXmark = {
    prefix: 'fasr',
    iconName: 'comment-xmark',
    icon: [
      512,
      512,
      ["comment-times"],
      'f4b5',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM353.9 176L320 142.1l-17 17-47 47-47-47-17-17L158.1 176l17 17 47 47-47 47-17 17L192 337.9l17-17 47-47 47 47 17 17L353.9 304l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faCommentTimes = faCommentXmark;
  

  
  

  var faFaceSmileRelaxed = {
    prefix: 'fasr',
    iconName: 'face-smile-relaxed',
    icon: [
      512,
      512,
      [],
      'e392',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm124 77.3L164 306.7C176 324.8 211.9 352 256 352s80-27.2 92-45.3L388 333.3C368 363.2 317.9 400 256 400s-112-36.8-132-66.7zm91.5-99c-20-27.1-59.8-27.1-79.8 0l-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8zm80.2 0l-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0z'
      
    ]
  };

  

  
  

  var faArrowsSpin = {
    prefix: 'fasr',
    iconName: 'arrows-spin',
    icon: [
      512,
      512,
      [],
      'e4bb',
      
      'M257.1 87.5c-11.3 0-22.4 1.1-33.1 3.3V42.1c10.8-1.7 21.9-2.5 33.1-2.5c55.4 0 105.9 20.9 144.2 55.2L448 48l16 16V192H336l-16-16 47.3-47.3c-29.5-25.6-68-41.2-110.2-41.2zm-216 168c0-55.2 20.7-105.5 54.7-143.7L48 64 64 48H192V176l-16 16-46.1-46.1c-25.4 29.4-40.7 67.8-40.7 109.7c0 11.1 1.1 22 3.1 32.5H43.6c-1.6-10.6-2.4-21.4-2.4-32.5zm71.1 160.2L64 464 48 448l0-128H176l16 16-45.7 45.7c29.6 26 68.4 41.8 110.9 41.8c10.5 0 20.9-1 30.9-2.8v48.6c-10.1 1.4-20.4 2.2-30.9 2.2c-55.7 0-106.6-21.1-144.9-55.8zM336 320l46.9 46.9c26.3-29.6 42.2-68.7 42.2-111.4c0-10.8-1-21.3-3-31.5h48.7c1.5 10.3 2.3 20.8 2.3 31.5c0 56-21.3 107-56.2 145.4L464 448l-16 16H320V336l16-16z'
      
    ]
  };

  

  
  

  var faExclamation = {
    prefix: 'fasr',
    iconName: 'exclamation',
    icon: [
      64,
      512,
      [10069,10071,61738],
      '21',
      
      'M56 56V32H8V56 344v24H56V344 56zm8 360H0v64H64V416z'
      
    ]
  };

  

  
  

  var faTentArrowsDown = {
    prefix: 'fasr',
    iconName: 'tent-arrows-down',
    icon: [
      576,
      512,
      [],
      'e581',
      
      'M217.9 138l-17.9 15.9-72 64L112 232.1 96.1 217.9l-72-64L6.1 138 38 102.1l17.9 15.9L88 146.6 88 24V0h48l0 24V146.6l32.1-28.5L186 102.1 217.9 138zm352 0l-17.9 15.9-72 64L464 232.1l-15.9-14.2-72-64L358.1 138 390 102.1l17.9 15.9L440 146.6V24 0h48V24 146.6l32.1-28.5L538 102.1 569.9 138zM112.5 512H64l6.9-48L96 288 288 160 480 288l25.1 176 6.9 48H463.5h-351zM264 233.7L140.5 316 119.3 464H264V233.7zm48 0V360l62.4 104h82.3L435.5 316 312 233.7z'
      
    ]
  };

  

  
  

  var faPlane = {
    prefix: 'fasr',
    iconName: 'plane',
    icon: [
      576,
      512,
      [],
      'f072',
      
      'M562.1 219.3c7.6 9.5 13.9 22 13.9 36.7c0 29.1-23 49.4-41.4 60.4C514.9 328.2 490.2 336 470 336H370.5L276.8 499.9 269.9 512H256l-80 0H144.2l8.7-30.6L194.5 336 164 336l-40.8 54.4L116 400H104 32-1.3L9.2 368.4 46.7 256 9.2 143.6-1.3 112H32h72l12 0 7.2 9.6L164 176l30.5 0L152.9 30.6 144.2 0 176 0l80 0 13.9 0 6.9 12.1L370.5 176l99.5 0c20.3 0 45.1 8.1 64.6 20c10 6.1 19.9 13.8 27.5 23.3zM509.8 237c-14-8.5-30.2-13-39.7-13l-113.5 0H342.6l-6.9-12.1L242.1 48H207.8l41.5 145.4 8.7 30.6-31.8 0L152 224H140l-7.2-9.6L92 160H65.3l29.5 88.4 2.5 7.6-2.5 7.6L65.3 352H92l40.8-54.4L140 288h12l74.3 0h31.8l-8.7 30.6L207.8 464h34.3l93.7-163.9 6.9-12.1h13.9H470c9.7 0 26-4.4 39.8-12.8C525 266.1 528 258.4 528 256c0-.6-.2-2.8-3.3-6.7c-3.1-3.9-8.1-8.2-14.9-12.3z'
      
    ]
  };

  

  
  

  var faFaceSadTear = {
    prefix: 'fasr',
    iconName: 'face-sad-tear',
    icon: [
      512,
      512,
      [128546,"sad-tear"],
      'f5b4',
      
      'M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm137.6 83.2c-6.2 8.3-9.6 18.4-9.6 28.8c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L176 288l-38.4 51.2zM256 352c30.7 0 58.7 11.5 80 30.6l17.9 16 32-35.8-17.9-16C338.3 320.2 299 304 256 304v48zm47.6-144a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faSadTear = faFaceSadTear;
  

  
  

  var faBlockBrickFire = {
    prefix: 'fasr',
    iconName: 'block-brick-fire',
    icon: [
      640,
      512,
      ["firewall"],
      'e3dc',
      
      'M176 80v48h56 48 56V80H176zm-48 48V80H80v48h48zM80 176v56H232V176H80zm0 160h48V280H80v56zm0 48v48H232V384H176 128 80zm96-48H288.7c-.5 5.2-.7 10.5-.7 15.8c0 11 .9 21.7 2.7 32.2H280v48h25.5c8.1 17.6 18.8 33.8 31.5 48H80 32V432 80 32H80 432h48V80v66.6l-27.4-27.4L431 132.7c-15.3 9.6-35 24.4-54.8 43.3H280v56h48.5c-9.9 14.6-18.9 30.7-25.9 48H176v56zM432 128V80H384v48h48zm16 32l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  
    var faFirewall = faBlockBrickFire;
  

  
  

  var faUserInjured = {
    prefix: 'fasr',
    iconName: 'user-injured',
    icon: [
      448,
      512,
      [],
      'f728',
      
      'M224 208c-44.2 0-80-35.8-80-80h32H304c0 44.2-35.8 80-80 80zM150.7 96C163 67.7 191.2 48 224 48c1.2 0 2.5 0 3.7 .1L170.2 96H150.7zM264.6 59c14.5 8.5 26 21.5 32.8 37H220.2l44.4-37zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM65 464L96 363.2V464H65zm239 0H261.3l-32-48H304v48zm32 0V400 384H320 208l-21.3-32H348.5L383 464H336zm48-160H64L14.8 464 0 512H50.2 397.8 448l-14.8-48L384 304z'
      
    ]
  };

  

  
  

  var faBrainCircuit = {
    prefix: 'fasr',
    iconName: 'brain-circuit',
    icon: [
      512,
      512,
      [],
      'e0c6',
      
      'M232 0h48 40c36.3 0 67.5 22 80.9 53.4c24.2 14.3 41.5 38.9 45.9 67.8C471.7 138.6 488 167.4 488 200c0 8-1 15.8-2.8 23.3C501.9 242.8 512 268.2 512 296c0 30.6-12.2 58.2-32 78.4l0 .8 0 .9c0 47.3-34.1 86.5-79.1 94.5c-16.4 25-44.7 41.5-76.9 41.5H280 232 188c-32.2 0-60.5-16.5-76.9-41.5c-45-8-79.1-47.3-79.1-94.5c0-.5 0-1.1 0-1.6C12.2 354.2 0 326.6 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.4 41.1-78.8c4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0h40zM152 88.7c-20.7 3.5-36.9 20.1-39.6 41c-.3 2.1-.4 4.2-.4 6.3c0 5.7 1 11.2 2.8 16.3c-7.8 .8-15.1 3.5-21.3 7.7c-11.5 7.6-19.6 20.1-21.2 34.6c-.2 1.8-.3 3.6-.3 5.5c0 14.5 6.5 27.6 16.7 36.4c-15.5 6.1-28.1 18-34.9 33.1C50.1 277.6 48 286.5 48 296c0 23.9 13.1 44.8 32.6 55.8c1.5 .9 3.1 1.7 4.7 2.4c-.6 1.2-1.2 2.4-1.7 3.6C81.3 363.4 80 369.5 80 376c0 21.8 14.6 40.3 34.6 46.1c4.3 1.2 8.8 1.9 13.4 1.9c5.6 0 11-1 16-2.7c.3 9.5 3.6 18.3 9 25.4c7.3 9.5 18.4 16 31 17.1c1.3 .1 2.7 .2 4 .2h44V424v-4-4V288H176v27.3c14.1 6.2 24 20.3 24 36.7c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-16.4 9.9-30.5 24-36.7V272 256h16 72V160H212.7c-6.2 14.1-20.3 24-36.7 24c-22.1 0-40-17.9-40-40s17.9-40 40-40c16.4 0 30.5 9.9 36.7 24H232V96 88 48H192c-2.7 0-5.4 .3-8 .8c-18.3 3.7-32 19.8-32 39.2l0 .7zM176 128a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM359 446.7c5.4-7.1 8.7-15.9 9-25.4c5 1.8 10.4 2.7 16 2.7c4.7 0 9.2-.7 13.4-1.9c20-5.8 34.6-24.2 34.6-46.1c0-6.5-1.3-12.6-3.6-18.3c-.5-1.2-1.1-2.4-1.7-3.6c1.6-.7 3.2-1.5 4.7-2.4c19.4-11 32.6-31.8 32.6-55.8c0-9.5-2.1-18.4-5.7-26.5c-6.9-15.1-19.4-27-34.9-33.1c10.2-8.8 16.7-21.8 16.7-36.4c0-1.8-.1-3.7-.3-5.5c-1.6-14.4-9.7-26.9-21.2-34.6c-6.2-4.1-13.5-6.8-21.3-7.7c1.8-5.1 2.8-10.6 2.8-16.3c0-2.1-.1-4.2-.4-6.3c-2.7-20.9-18.9-37.6-39.6-41l0-.7c0-19.4-13.7-35.5-32-39.2c-2.6-.5-5.3-.8-8-.8H280V88v8 32h72 16v16 43.3c14.1 6.2 24 20.3 24 36.7c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-16.4 9.9-30.5 24-36.7V160H280V320h51.3c6.2-14.1 20.3-24 36.7-24c22.1 0 40 17.9 40 40s-17.9 40-40 40c-16.4 0-30.5-9.9-36.7-24H280v64 4 4 40h44c1.3 0 2.7-.1 4-.2c12.6-1.1 23.7-7.6 31-17.1zM176 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM352 208a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSkiBootSki = {
    prefix: 'fasr',
    iconName: 'ski-boot-ski',
    icon: [
      640,
      512,
      [],
      'e3cd',
      
      'M372.2 0l-3.7 19.5L366 32H176 156.6l-4.1 19-72 336-6.2 29H104 456h24V392 288 273.7l-12.6-6.8-88.5-47.6 16.7-86.7 10-52 10-52L421.1 0H372.2zM262.3 80h94.4l-8.4 43.5-7 36.5H304 288v32h16 31.3l-6.2 32H288 272v32h16 57.9L432 302.3V368H133.7l24-112h55 13l2.7-12.7L262.3 80zm-32.7 0l-30 144H164.5L195.4 80h34.3zM640 408V384H592v24 56H24 0v48H24 616h24V488 408z'
      
    ]
  };

  

  
  

  var faKeyboardBrightnessLow = {
    prefix: 'fasr',
    iconName: 'keyboard-brightness-low',
    icon: [
      640,
      512,
      [],
      'e1c1',
      
      'M344 128H296v48h48V128zM112 368H64v48h48V368zm104 0H192v48h24H424h24V368H424 216zm312 0v48h48V368H528zM484 202L450.1 236 484 269.9 518 236 484 202zM156 202L122 236 156 269.9 189.9 236 156 202z'
      
    ]
  };

  

  
  

  var faBenchTree = {
    prefix: 'fasr',
    iconName: 'bench-tree',
    icon: [
      640,
      512,
      [],
      'e2e7',
      
      'M554.8 132.7L578.7 150c8.2 5.9 13.3 15.3 13.3 26v32H432V176c0-10.6 5.1-20.1 13.3-26l23.9-17.3-4.6-29.1c-.4-2.5-.6-5-.6-7.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 2.6-.2 5.2-.6 7.6l-4.6 29.1zM417.2 111.1C397.1 125.7 384 149.3 384 176v32 48h48 56V488v24h48V488 256h56 48V208 176c0-26.7-13.1-50.3-33.2-64.9c.8-4.9 1.2-10 1.2-15.1c0-53-43-96-96-96s-96 43-96 96c0 5.1 .4 10.2 1.2 15.1zM80 240H304v32H80V240zM32 192v48 32 48H56v32H32 24 0v48H24h8v88 24H80V488 400H304v88 24h48V488 400h8 24V352H360h-8H328V320h24V272 240 192H304 80 32zm72 128H280v32H104V320z'
      
    ]
  };

  

  
  

  var faCircle3 = {
    prefix: 'fasr',
    iconName: 'circle-3',
    icon: [
      512,
      512,
      [],
      'e0f0',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-384H184 160v48h24 66.3l-50.5 46.3-7.8 7.1v34.7l24.1-.1 51.5-.3c20.1-.1 36.4 16.1 36.4 36.2c0 20-16.2 36.2-36.2 36.2H242.7c-14 0-26.8-7.9-33-20.4l-4.2-8.3-42.9 21.5 4.2 8.3c14.4 28.8 43.8 47 76 47h25.2c46.5 0 84.2-37.7 84.2-84.2c0-43.3-32.6-78.9-74.6-83.6l50.8-46.5 7.8-7.1V128H312z'
      
    ]
  };

  

  
  

  var faCardsBlank = {
    prefix: 'fasr',
    iconName: 'cards-blank',
    icon: [
      640,
      512,
      [],
      'e4df',
      
      'M399.4 347.8L228.5 446.4 65.6 164.2 236.4 65.6 399.4 347.8zM210.9 512l41.6-24 170.9-98.7 41.6-24-24-41.6L278 41.6 254 0 212.4 24 0 146.7 186.9 470.4l24 41.6zM320 486v26H640V64H327.9L492.7 349.4l16 27.7-27.7 16L320 486z'
      
    ]
  };

  

  
  

  var faBone = {
    prefix: 'fasr',
    iconName: 'bone',
    icon: [
      576,
      512,
      [129460],
      'f5d7',
      
      'M131.8 224l-3.9-43.7C126 160 108.8 144 88 144c-22.1 0-40 17.9-40 40c0 13.5 6.6 25.4 17 32.8l15 10.5v57.4L65 295.2c-10.4 7.3-17 19.3-17 32.8c0 22.1 17.9 40 40 40c20.8 0 38-16 39.8-36.3l3.9-43.7h43.9H400.4h43.9l3.9 43.7C450 352 467.2 368 488 368c22.1 0 40-17.9 40-40c0-13.5-6.6-25.4-17-32.8l-15-10.5V227.3l15-10.5c10.4-7.3 17-19.3 17-32.8c0-22.1-17.9-40-40-40c-20.8 0-38 16-39.8 36.3L444.2 224H400.4 175.6 131.8zm268.6-48c4-44.9 41.7-80 87.6-80c48.6 0 88 39.4 88 88c0 12.3-2.5 24-7.1 34.7c-6.5 15.1-17 28-30.3 37.3c13.3 9.3 23.8 22.2 30.3 37.3c4.6 10.6 7.1 22.4 7.1 34.7c0 48.6-39.4 88-88 88c-45.9 0-83.6-35.1-87.6-80H175.6c-4 44.9-41.7 80-87.6 80c-48.6 0-88-39.4-88-88c0-12.3 2.5-24 7.1-34.7c6.5-15.1 17-28 30.3-37.3c-13.3-9.3-23.8-22.2-30.3-37.3C2.5 208 0 196.3 0 184c0-48.6 39.4-88 88-88c45.9 0 83.6 35.1 87.6 80H400.4z'
      
    ]
  };

  

  
  

  var faFileCheck = {
    prefix: 'fasr',
    iconName: 'file-check',
    icon: [
      384,
      512,
      [],
      'f316',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zm33 267.6l17-17L272 216.7l-17 17-89.7 89.7L129 287l-17-17L78.1 304l17 17 53.3 53.3 17 17 17-17L289 267.6z'
      
    ]
  };

  

  
  

  var faArrowUpFromWaterPump = {
    prefix: 'fasr',
    iconName: 'arrow-up-from-water-pump',
    icon: [
      576,
      512,
      [],
      'e4b6',
      
      'M561.9 112L545 95 465 15l-17-17L431 15 351 95l-17 17L368 145.9l17-17 39-39L424 256H288V0H64V256H48 0v48V415c13 0 27.6-4.3 40.7-10.3c2.5-1.1 4.9-2.4 7.3-3.7V304H528v97c2.4 1.3 4.8 2.5 7.3 3.7c13.1 6 27.7 10.3 40.7 10.3V304 256H528 472l0-166.1 39 39 17 17L561.9 112zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V464c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4c-13 11.6-24.8 22.2-40.2 30.9C39.4 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1z'
      
    ]
  };

  

  
  

  var faBoot = {
    prefix: 'fasr',
    iconName: 'boot',
    icon: [
      512,
      512,
      [129406],
      'f782',
      
      'M384 0H0V128H384V0zM0 464v16l32 32H96l32-32 32 32h64l32-32 32 32h64l32-32 32 32h64l32-32V464 448 416 288L352 240V160H304v32H240 224v32h16 64v16 16H240 224v32h16H345l119 35.7V416H48V160H0V416v32 16z'
      
    ]
  };

  

  
  

  var faTruckContainer = {
    prefix: 'fasr',
    iconName: 'truck-container',
    icon: [
      640,
      512,
      [],
      'f4dc',
      
      'M0 32H24 376h24V56 288v24H352V288 80H48V288v24H0V288 56 32zM608 400c0 44.2-35.8 80-80 80s-80-35.8-80-80H432 288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32H432V256 168 144h24 88 11.4l7.2 8.8 72 88 5.4 6.6V256v32V400H608zM585 256l-52.4-64H480v64H585zM136 136V264v24H88V264 136 112h48v24zm88 0V264v24H176V264 136 112h48v24zm88 0V264v24H264V264 136 112h48v24zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faPenFancySlash = {
    prefix: 'fasr',
    iconName: 'pen-fancy-slash',
    icon: [
      640,
      512,
      [],
      'e210',
      
      'M396.5 285.1L541.4 145.3 576 112 542.1 78.1 497.9 33.9 464 0 430.7 34.6 277.9 193 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L396.5 285.1zM316 222.6L464.6 68.5l42.9 42.9-149.3 144L316 222.6zM128 272L64 480l32 32 208-64 32.3-80.7-39.3-31-29 72.6L155 443.6 198.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L132.4 421l34.8-113 62.3-24.9L186 248.8 128 272z'
      
    ]
  };

  

  
  

  var faToggleLargeOff = {
    prefix: 'fasr',
    iconName: 'toggle-large-off',
    icon: [
      576,
      512,
      [],
      'e5b0',
      
      'M336 112H48V400H336V112zm48 336H336 48 0V400 112 64H48 336h48H528h48v48V400v48H528 384zm0-336V400H528V112H384z'
      
    ]
  };

  

  
  

  var faLightSwitchOff = {
    prefix: 'fasr',
    iconName: 'light-switch-off',
    icon: [
      384,
      512,
      [],
      'e018',
      
      'M168 464V448h48v16H336V48H216V64H168V48H48V464H168zM48 512H0V464 48 0H48 336h48V48 464v48H336 48zM240 256V144H144V256h96zM144 416H96V368 144 96h48 96 48v48V368v48H240 144z'
      
    ]
  };

  

  
  

  var faCupcake = {
    prefix: 'fasr',
    iconName: 'cupcake',
    icon: [
      448,
      512,
      [129473],
      'e402',
      
      'M224 0H179.2L204 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7H148c-45 0-81.8 35.4-83.9 79.9C26.5 159.6 0 196.7 0 240v56 24H24 424h24V296 240c0-43.3-26.4-80.4-64-96C382.5 64.2 317.4 0 237.3 0H224zm40 57.3c0-1.9-.1-3.8-.3-5.7c41.7 11.5 72.3 49.7 72.3 95.1c0 3.1-.4 6.1-1.1 8.9l-6.1 24.8 25.1 4.5c26.2 4.7 46 27.6 46 55.1v32H48V240c0-27.4 19.7-50.3 45.8-55.1l24.6-4.5L112.9 156c-.6-2.6-.9-5.2-.9-8c0-19.9 16.1-36 36-36h61.3c30.2 0 54.7-24.5 54.7-54.7zM96 512h51.9l-20-160H69.3L96 512zm84.1 0h87.8l20-160H160.1l20 160zm120 0H352l26.7-160H320.1l-20 160z'
      
    ]
  };

  

  
  

  var faBugSlash = {
    prefix: 'fasr',
    iconName: 'bug-slash',
    icon: [
      640,
      512,
      [],
      'e490',
      
      'M477.6 348c1.6-9.1 2.4-18.4 2.4-28v-8h72 24V264H552 480V208 193.9l57-57 17-17L520 86.1l-17 17-57 57H432 235.4L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L477.6 348zM297.2 208H432V312.6L297.2 208zM344 367l-48-37.8V429.4c-50.3-11-88-55.8-88-109.4V259.9l-48-37.8V264H88 64v48H88h72v8c0 27.2 6.8 52.8 18.8 75.3l-64.6 64.6-17 17 33.9 33.9 17-17 59.7-59.7C236.7 462.5 276.3 480 320 480c43 0 82.1-17 110.8-44.6l-38.2-30.1c-13.7 11.7-30.3 20.1-48.6 24.1V367zM224 96v32H416V96c0-53-43-96-96-96s-96 43-96 96z'
      
    ]
  };

  

  
  

  var faFaceSadSweat = {
    prefix: 'fasr',
    iconName: 'face-sad-sweat',
    icon: [
      576,
      512,
      [],
      'e38a',
      
      'M496 256c0 114.9-93.1 208-208 208c-65.5 0-124-30.3-162.1-77.7c-4 17-13.4 32-26.4 42.9C146.3 480.1 213.4 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256l16-21.3 25.6 34.1L81.3 279c-.8-7.6-1.3-15.2-1.3-23C80 141.1 173.1 48 288 48s208 93.1 208 208zM36.4 303.5L9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48c12 0 22.9-4.4 31.3-11.6C89.5 395.6 96 382.5 96 368c0-10.4-3.4-20.5-9.6-28.8L68 314.7 48 288 36.4 303.5zM342.8 425.9l35.1-32.7-16.4-17.5C347.3 360.3 322.6 344 288 344s-59.3 16.3-73.5 31.6l-16.4 17.5 35.1 32.7 16.4-17.5c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4l16.4 17.5zM367.6 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-192-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.7-100.7L238.6 160 216 137.4l-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zM337.4 160l11.3 11.3 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4L360 137.4 337.4 160z'
      
    ]
  };

  

  
  

  var faLocationPinSlash = {
    prefix: 'fasr',
    iconName: 'location-pin-slash',
    icon: [
      640,
      512,
      ["map-marker-slash"],
      'f60c',
      
      'M457.5 332.4L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L153.5 96.4C186.6 38.8 248.8 0 320 0C426 0 512 86 512 192c0 39.4-23.7 90.6-54.5 140.4zM191.9 126.2L419.4 302.8c7.2-11.9 13.9-23.8 19.9-35.4C456.3 234 464 208.3 464 192c0-79.5-64.5-144-144-144c-55.8 0-104.2 31.8-128.1 78.2zM402.1 412.8c-18.4 24.3-36.1 46-50.3 62.8C332.8 498.1 320 512 320 512s-12.8-13.9-31.8-36.4c-53.5-63.4-156.1-195.2-160.1-278.7l62.6 49.3c2.9 6.7 6.2 13.7 10 21.1c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c13-15.6 28.5-34.7 44.4-55.8l37.7 29.7z'
      
    ]
  };

  
    var faMapMarkerSlash = faLocationPinSlash;
  

  
  

  var faWindWarning = {
    prefix: 'fasr',
    iconName: 'wind-warning',
    icon: [
      640,
      512,
      ["wind-circle-exclamation"],
      'f776',
      
      'M224 432c61.8 0 116.1-31.8 147.5-80h54.9c-36 75.7-113.1 128-202.4 128C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208H399.3C391.2 150.3 315.8 80 224 80C126.8 80 48 158.8 48 256s78.8 176 176 176zM544 224H478c-2.1-16.5-5.7-32.6-10.8-48H544c26.5 0 48-21.5 48-48s-21.5-48-48-48H504 480V32h24 40c53 0 96 43 96 96s-43 96-96 96zM448 480V432h24 64c30.9 0 56-25.1 56-56s-25.1-56-56-56H344 320V272h24H536c57.4 0 104 46.6 104 104s-46.6 104-104 104H472 448zM248 128v24V264v24H200V264 152 128h48zM200 368V320h48v48H200z'
      
    ]
  };

  
    var faWindCircleExclamation = faWindWarning;
  

  
  

  var faPaperclipVertical = {
    prefix: 'fasr',
    iconName: 'paperclip-vertical',
    icon: [
      384,
      512,
      [],
      'e3c2',
      
      'M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108V344c0 39.8-32.2 72-72 72s-72-32.2-72-72V152 128h48v24V344c0 13.3 10.7 24 24 24s24-10.7 24-24V108c0-33.1-26.9-60-60-60s-60 26.9-60 60V368c0 53 43 96 96 96s96-43 96-96V152 128h48v24V368c0 79.5-64.5 144-144 144s-144-64.5-144-144V108z'
      
    ]
  };

  

  
  

  var faHundredPoints = {
    prefix: 'fasr',
    iconName: 'hundred-points',
    icon: [
      512,
      512,
      [128175,"100"],
      'e41c',
      
      'M171.2 99.6L158.3 220.2C153.5 265 188.5 304 233.5 304c38.7 0 71.2-29.2 75.3-67.6l12.9-120.6C326.5 71 291.5 32 246.5 32c-38.7 0-71.2 29.2-75.3 67.6zM246.5 80c16.5 0 29.3 14.3 27.5 30.7L261.1 231.2c-1.5 14.1-13.4 24.8-27.5 24.8c-16.5 0-29.3-14.3-27.5-30.7l12.9-120.6C220.4 90.7 232.3 80 246.5 80zm109.7 21.5l-7.4 88.4C345.1 234.1 380 272 424.3 272c39.4 0 72.3-30.2 75.6-69.5l7.4-88.4C510.9 69.9 476 32 431.7 32c-39.4 0-72.3 30.2-75.6 69.5zM431.7 80c16.3 0 29.1 13.9 27.7 30.1L452 198.5c-1.2 14.4-13.3 25.5-27.7 25.5c-16.3 0-29.1-13.9-27.7-30.1l7.4-88.4C405.2 91.1 417.2 80 431.7 80zM28.1 431.7l464-80-8.2-47.3-464 80 8.2 47.3zM41.4 109.9L75 95 44.4 339.5 93.8 331 127.8 58.6 94.6 34.1l-72 32L.5 75.9l18.9 43.8 22.1-9.8zM219.9 479.7l240-40-7.9-47.3-240 40 7.9 47.3z'
      
    ]
  };

  
    var fa100 = faHundredPoints;
  

  
  

  var faDown = {
    prefix: 'fasr',
    iconName: 'down',
    icon: [
      384,
      512,
      ["arrow-alt-down"],
      'f354',
      
      'M224 272l0-48 0-144-64 0 0 144 0 48-48 0-60.1 0L192 412.1 332.1 272 272 272l-48 0zm112-48l48 0 0 48 0 16L225.9 446.1 192 480l-33.9-33.9L0 288l0-16 0-48 48 0 16 0 48 0 0-48 0-96 0-48 48 0 64 0 48 0 0 48 0 96 0 48 48 0 16 0z'
      
    ]
  };

  
    var faArrowAltDown = faDown;
  

  
  

  var faNoteSticky = {
    prefix: 'fasr',
    iconName: 'note-sticky',
    icon: [
      448,
      512,
      [62026,"sticky-note"],
      'f249',
      
      'M48 80V432H288V320H400V80H48zM288 480H48 0V432 80 32H48 400h48V80 320v32L320 480H288z'
      
    ]
  };

  
    var faStickyNote = faNoteSticky;
  

  
  

  var faDiceD12 = {
    prefix: 'fasr',
    iconName: 'dice-d12',
    icon: [
      512,
      512,
      [],
      'f6ce',
      
      'M0 187.4v35.2 102L68.6 443.4l88 50.8L187.4 512H324.6l30.8-17.8 88-50.8L512 324.6v-102V187.4L443.4 68.6 415.3 52.3 324.6 0H187.4L96.7 52.3 68.6 68.6 0 187.4zm103.2-82.7L232 145.6v96.1l-99.1 53.1L48 203.7v-3.4l55.2-95.5zM280 145.6l128.8-40.8L464 200.3v3.4l-84.9 91L280 241.6V145.6zM353.3 72L256 102.8 158.7 72l41.5-24 111.5 0 41.5 24zM464 274v37.7l-55.7 96.5-31.4 18.1L405.2 337 464 274zM315.3 462l-3.5 2H200.3l-3.5-2L156.9 336.3 256 283.2l99.1 53.1L315.3 462zM135.1 426.4l-31.3-18.1L48 311.7V274l58.8 63 28.3 89.4z'
      
    ]
  };

  

  
  

  var faGramophone = {
    prefix: 'fasr',
    iconName: 'gramophone',
    icon: [
      384,
      512,
      [],
      'f8bd',
      
      'M108.8 2.6l40.6 10.2 1.1 3.2 0 .1 .3 .7c.3 .7 .7 1.7 1.3 3.2c1.2 2.9 3.2 7.3 6 12.8c5.7 11.1 14.8 27 28.2 45.1c26.9 36.2 71.4 81.5 141.3 116.8c17.3 8.7 31.7 22.9 40.1 40.4c1.8 3.5 3.3 7.2 4.5 11H376v24l0 .3 0 .3c0 45-36.5 81.4-81.4 81.4H184l-24 0V304h24H294c18.7 0 33.9-15.1 34-33.7c-.1-5.4-1.5-10.7-4.1-15.6c-3.1-4.9-7.7-7.8-12.4-8.6c-8.6-1.4-19-2.6-30.9-3l-1.3 0c-48.2-1.3-121.5 10.4-207.2 71L29.2 303.4l3.6-13.5 72-272 4-15.3zM135.6 89L94.8 243.4c42.5-23.1 81.9-36 116.7-42.6c1.1-.2 2.2-.4 3.2-.6c8.5-1.5 16.7-2.7 24.6-3.5c-41.1-30.1-70.7-62.3-91.5-90.2c-4.5-6.1-8.6-11.9-12.3-17.5zM24 464h8V432 384H80 304h48v48 32h8 24v48H360h-8H304 80 32 24 0V464H24zm280-32H80v32H304V432z'
      
    ]
  };

  

  
  

  var faJar = {
    prefix: 'fasr',
    iconName: 'jar',
    icon: [
      320,
      512,
      [],
      'e516',
      
      'M32 0V48H288V0H32zM272 128v96H48V128H272zm0 240v96H48V368H272zM48 80H0v48V464v48H48 272h48V464 128 80H272 48z'
      
    ]
  };

  

  
  

  var faMagnet = {
    prefix: 'fasr',
    iconName: 'magnet',
    icon: [
      448,
      512,
      [129522],
      'f076',
      
      'M0 32H24 136h24V56 256c0 35.3 28.7 64 64 64s64-28.7 64-64V56 32h24H424h24V56 256c0 123.7-100.3 224-224 224S0 379.7 0 256V56 32zM48 256c0 97.2 78.8 176 176 176s176-78.8 176-176V192H336v64c0 61.9-50.1 112-112 112s-112-50.1-112-112V192H48v64z'
      
    ]
  };

  

  
  

  var faCircle2 = {
    prefix: 'fasr',
    iconName: 'circle-2',
    icon: [
      512,
      512,
      [],
      'e0ef',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM193.7 146.5l-16.2 12.3-19.1 14.5 29.1 38.2L206.5 197l16.2-12.3c7.2-5.5 16.1-8.4 25.3-8.3l3.4 .1c20.3 .3 36.6 16.8 36.6 37.1c0 10.3-4.2 20.1-11.7 27.1L167.6 342.5l-7.6 7.1V384h24H328h24V336H328 244.7l64.4-60.4C326.3 259.5 336 237 336 213.5c0-46.5-37.3-84.4-83.8-85.1l-3.4-.1c-19.9-.3-39.3 6.1-55.1 18.1z'
      
    ]
  };

  

  
  

  var fa1 = {
    prefix: 'fasr',
    iconName: '1',
    icon: [
      256,
      512,
      [],
      '31',
      
      'M112.7 32H120h8 24V56 432h80 24v48H232 128 24 0V432H24h80V95.5L13.3 156 0 164.8V107.2L106.7 36l6-4z'
      
    ]
  };

  

  
  

  var faFalafel = {
    prefix: 'fasr',
    iconName: 'falafel',
    icon: [
      576,
      512,
      [129478],
      'e40a',
      
      'M151.7 120.1L136 152l15.7 31.9-.6 32.4L118.2 208 91.3 230.8l-34.1 7.3L42.7 270.6 15.1 292.4l.6 35.7L0 360l15.7 31.9-.6 35.7 27.6 21.8 14.6 32.5 34.1 7.3L118.2 512l33.8-8.6 33.8 8.6 26.9-22.8 34.1-7.3 14.6-32.5 26.7-21 26.7 21 14.6 32.5 34.1 7.3L390.2 512l33.8-8.6 33.8 8.6 26.9-22.8 34.1-7.3 14.6-32.5 27.6-21.8-.3-15.1c-17.3 5.4-36.1 3.9-52.1-.5c-1.3-.4-2.6-.7-3.9-1.1l-1.1 .8-9.2 7.3-4.8 10.7-4.6 10.3-10.3 2.2-11.8 2.5-9.2 7.8-8 6.8-9.9-2.5-11.8-3-11.8 3-9.9 2.5-8-6.8-9.2-7.8-11.8-2.5-10.3-2.2-4.6-10.3L353.6 419l-9.2-7.3-8.9-7.1 .2-11.9 .2-11.6-5.1-10.4L325.5 360l5.3-10.8 5.1-10.4-.2-11.6-.2-11.9 8.9-7.1 9.2-7.3 4.8-10.7 4.6-10.3 10.3-2.2 11.4-2.4c-2.6-21.6 1.2-45.4 19.1-63.3c6.3-6.3 13.3-10.8 20.6-14l-.2-14L440 152l-15.7-31.9 .6-35.7L397.3 62.6 382.8 30.1l-34.1-7.3L321.8 0 288 8.6 254.2 0 227.3 22.8l-34.1 7.3L178.7 62.6 151.1 84.4l.6 35.7zM560.9 296.6c-1.7-2.9-3.5-5.8-5.5-8.6c-5.5-8.1-12.1-16.1-19.7-23.7c-2.9-2.9-5.9-5.7-8.9-8.3c-12.4-10.8-25.5-19-38.3-24.4c-1.8-.8-3.6-1.5-5.4-2.2c-23-8.4-44.1-7.3-56.6 5.1c-7.3 7.3-10.7 17.6-10.6 29.5c.3 23.8 14.7 54.1 40.3 79.6c17.8 17.8 37.9 30.2 56.4 36.2c21.5 6.9 40.9 5.3 52.7-6.4c4.5-4.5 7.5-10 9.1-16.4c4.2-16.6-.8-38.6-13.7-60.4zM199.5 107.3l8.9-7.1 9.2-7.3 4.8-10.7 4.6-10.3 10.3-2.2 11.8-2.5 9.2-7.8 8-6.8 9.9 2.5 11.8 3 11.8-3 9.9-2.5 8 6.8 9.2 7.8 11.8 2.5 10.3 2.2 4.6 10.3L358.4 93l9.2 7.3 8.9 7.1-.2 11.9-.2 11.6 5.1 10.4 5.3 10.8-5.3 10.8-5.1 10.4 .2 11.6 .2 11.9-8.9 7.1-9.2 7.3-4.8 10.7-4.6 10.3-10.3 2.2-11.8 2.5-9.2 7.8-8 6.8-9.9-2.5-11.8-3-11.8 3-9.9 2.5-8-6.8-9.2-7.8-11.8-2.5-10.3-2.2-4.6-10.3L217.6 211l-9.2-7.3-8.9-7.1 .2-11.9 .2-11.6-5.1-10.4L189.5 152l5.3-10.8 5.1-10.4-.2-11.6-.2-11.9zm-136 208l8.9-7.1 9.2-7.3 4.8-10.7 4.6-10.3 10.3-2.2 11.8-2.5 9.2-7.8 8-6.8 9.9 2.5 11.8 3 11.8-3 9.9-2.5 8 6.8 9.2 7.8 11.8 2.5 10.3 2.2 4.6 10.3 4.8 10.7 9.2 7.3 8.9 7.1-.2 11.9-.2 11.6 5.1 10.4 5.3 10.8-5.3 10.8-5.1 10.4 .2 11.6 .2 11.9-8.9 7.1-9.2 7.3-4.8 10.7-4.6 10.3-10.3 2.2-11.8 2.5-9.2 7.8-8 6.8-9.9-2.5-11.8-3-11.8 3-9.9 2.5-8-6.8-9.2-7.8-11.8-2.5-10.3-2.2-4.6-10.3L81.6 419l-9.2-7.3-8.9-7.1 .2-11.9 .2-11.6-5.1-10.4L53.5 360l5.3-10.8 5.1-10.4-.2-11.6-.2-11.9zM112 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm224-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faPenSwirl = {
    prefix: 'fasr',
    iconName: 'pen-swirl',
    icon: [
      512,
      512,
      [],
      'e214',
      
      'M330 137.9L374.1 182 265.7 290.4l-50.4 6.3 6.3-50.4L330 137.9zM425 199l17-17 36.1-36.1L512 112 478.1 78.1 433.9 33.9 400 0 366.1 33.9 330 70 313 87l-17 17L176 224l-9.9 78.9L160 352l49.1-6.1L288 336 408 216l17-17zm-17-50.9L363.9 104 400 67.9 444.1 112 408 148.1zM324.7 17.6C302.9 11.4 279.8 8 256 8C119 8 8 119 8 256S119 504 256 504h24V456H256C145.5 456 56 366.5 56 256S145.5 56 256 56c9.7 0 19.3 .7 28.7 2l40-40.4zM454.1 228.4c1.2 9 1.9 18.2 1.9 27.6c0 57.4-46.6 104-104 104H328v48h24c83.9 0 152-68.1 152-152c0-23.6-3.3-46.4-9.4-68l-40.4 40.5z'
      
    ]
  };

  

  
  

  var faCommentExclamation = {
    prefix: 'fasr',
    iconName: 'comment-exclamation',
    icon: [
      512,
      512,
      [],
      'f4af',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM280 112H232v24V248v24h48V248 136 112zM232 352h48V304H232v48z'
      
    ]
  };

  

  
  

  var faGripDots = {
    prefix: 'fasr',
    iconName: 'grip-dots',
    icon: [
      448,
      512,
      [],
      'e410',
      
      'M352 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-160 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM224 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faSquareFull = {
    prefix: 'fasr',
    iconName: 'square-full',
    icon: [
      512,
      512,
      [11035,11036,128997,128998,128999,129000,129001,129002,129003],
      'f45c',
      
      'M464 48V464H48V48H464zM48 0H0V48 464v48H48 464h48V464 48 0H464 48z'
      
    ]
  };

  

  
  

  var faStopwatch20 = {
    prefix: 'fasr',
    iconName: 'stopwatch-20',
    icon: [
      448,
      512,
      [],
      'e06f',
      
      'M304 0H144V48h56V97.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120l31-31 17-17L408 102.1l-17 17-29.2 29.2c-31.1-27.5-70.4-45.9-113.8-50.9V48h56V0zM64 304a160 160 0 1 1 320 0A160 160 0 1 1 64 304zm172-48v80c0 28.7 23.3 52 52 52s52-23.3 52-52V256c0-28.7-23.3-52-52-52s-52 23.3-52 52zm52-12c6.6 0 12 5.4 12 12v80c0 6.6-5.4 12-12 12s-12-5.4-12-12V256c0-6.6 5.4-12 12-12zm-135.7 8.1c2.5-4.9 7.5-8.1 13.1-8.1h.7c7.7 0 13.9 6.2 13.9 13.9c0 3.7-1.5 7.2-4.1 9.9l-35.3 35.3c-15.8 15.8-24.6 37.1-24.6 59.4V368v20h20 64 20V348H200 158.5c2.2-6.2 5.7-11.9 10.4-16.6l35.3-35.3C214.3 286 220 272.2 220 257.9c0-29.8-24.2-53.9-53.9-53.9h-.7c-20.7 0-39.6 11.7-48.8 30.2l-6.4 12.9 35.8 17.9 6.4-12.9z'
      
    ]
  };

  

  
  

  var faShieldExclamation = {
    prefix: 'fasr',
    iconName: 'shield-exclamation',
    icon: [
      512,
      512,
      [],
      'e247',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM280 128H232v24V264v24h48V264 152 128zM232 320v48h48V320H232z'
      
    ]
  };

  

  
  

  var faCloudSun = {
    prefix: 'fasr',
    iconName: 'cloud-sun',
    icon: [
      640,
      512,
      [9925],
      'f6c4',
      
      'M121.3 0L104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104 42-29.4c8.8-37.6 34.2-68.7 68-85.4c-7.5 1.9-15.3 2.9-23.4 2.9c-53 0-96-43-96-96s43-96 96-96s96 43 96 96l0 1.1c18.4-10.7 39.8-16.8 62.5-17.1L416 121.3 312 104 294.7 0 208 60.7 121.3 0zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm96.6 64c26.5 0 48 21.5 48 48v8h49c3.5-13.8 16.1-24 31-24c17.7 0 32 14.3 32 32v40 24h24H560c17.7 0 32 14.3 32 32v32H560h-7.4-24v0h-88 0H304.4l0 0H272.6 240V416c0-26.5 21.5-48 48-48h8.6 24V344 320c0-26.5 21.5-48 48-48zm208 240H616h24V488 432c0-38.5-27.2-70.7-63.4-78.3V336c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C434 242.6 403.4 224 368.6 224c-53 0-96 43-96 96v1.2c-45.7 7.4-80.6 47-80.6 94.8v72 24h24 24.8l0 0h31.8 24 144 0 112 24v0z'
      
    ]
  };

  

  
  

  var faSyringe = {
    prefix: 'fasr',
    iconName: 'syringe',
    icon: [
      512,
      512,
      [128137],
      'f48e',
      
      'M435.2 1.3L401.3 35.2l17 17 3.8 3.8L384 94.1 329 39l-17-17L278.1 56l17 17 72 72 72 72 17 17L489.9 200l-17-17-55-55L456 89.9l3.8 3.8 17 17 33.9-33.9-17-17L473 39 452.2 18.2l-17-17zM271.4 94.6L71 295l-7 7V312 414.1L18.2 459.8l-17 17 33.9 33.9 17-17L97.9 448H200h9.9l7-7L417.4 240.6l-1-1-33-33L190.1 400H112V321.9l29.7-29.7 23 23L176 326.6 198.6 304l-11.3-11.3-23-23 41.4-41.4 23 23L240 262.6 262.6 240l-11.3-11.3-23-23 41.4-41.4 23 23L304 198.6 326.6 176l-11.3-11.3-23-23 13.1-13.1-33-33-1-1z'
      
    ]
  };

  

  
  

  var faBoombox = {
    prefix: 'fasr',
    iconName: 'boombox',
    icon: [
      640,
      512,
      [128254],
      'f8a5',
      
      'M48 0H72 568h24V24 160h48v48V464v48H592 48 0V464 208 160H48V24 0zM544 48H96V160h96V128h64v32h32V128h64v32h32V128h64v32h96V48zm48 160H48V464H592V208zM176 240a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm48 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faUserNurse = {
    prefix: 'fasr',
    iconName: 'user-nurse',
    icon: [
      448,
      512,
      [],
      'f82f',
      
      'M96 128V48L224 0 352 48v80h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM208 40V64H184V96h24v24h32V96h24V64H240V40H208zM189 456.9L105.4 368H98.6l-32 96H195.7l-6.7-7.1zM381.4 464l-32-96h-6.8L259 456.9l-6.7 7.1H381.4zM321.9 320H384l48 144 16 48H397.4 50.6 0l16-48L64 320h62.1L191 389l33 35 33-35 64.9-69z'
      
    ]
  };

  

  
  

  var faTrashCheck = {
    prefix: 'fasr',
    iconName: 'trash-check',
    icon: [
      448,
      512,
      [],
      'e2af',
      
      'M160 0H147.2L140 10.7 93.8 80H80.1 32 0v48H35.6L64 512H384l28.4-384H448V80H416 367.9 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM108.6 464L83.7 128H364.3L339.4 464H108.6zM318.1 246.1L332.3 232 304 203.7l-14.1 14.1L200 307.7l-25.9-25.9L160 267.7 131.7 296l14.1 14.1 40 40L200 364.3l14.1-14.1 104-104z'
      
    ]
  };

  

  
  

  var faBridgeSuspension = {
    prefix: 'fasr',
    iconName: 'bridge-suspension',
    icon: [
      640,
      512,
      [],
      'e4cd',
      
      'M120 8H105.2L98.5 21.3c-21.1 42.2-56.8 71.4-96 97.9l26.9 39.8c25.1-17 51.6-36.8 74.6-62V240H24 0v48H24 616h24V240H616 536V96.9c22.9 25.3 49.4 45 74.6 62l26.9-39.8c-39.2-26.5-74.9-55.7-96-97.9L534.8 8H520 504 490.1l-6.9 12.1C447.6 82.4 389.4 120 320 120s-127.6-37.6-163.2-99.9L149.9 8H136 120zM488 94.2V240H440V133.9c17.5-11 33.6-24.3 48-39.8zm-96 62.4V240H344V166.8c16.7-1.7 32.7-5.2 48-10.2zm-96 10.2V240H248V156.5c15.3 5.1 31.3 8.5 48 10.3zm-96-32.9V240H152V94.2c14.4 15.4 30.5 28.8 48 39.8zM0 336v48H24 96V488v24h24 96 24V488 384H400V488v24h24 96 24V488 384h72 24V336H616 520 496v24V464H448V360 336H424 216 192v24V464H144V360 336H120 24 0z'
      
    ]
  };

  

  
  

  var faTrainTram = {
    prefix: 'fasr',
    iconName: 'train-tram',
    icon: [
      448,
      512,
      [128650],
      'e5b4',
      
      'M63.3 0H72 376h8.7l6.7 5.6 48 40L408.6 82.4 367.3 48H248V96h88 48v48V400v48H353.9l47 47 17 17H350.1l-64-64H161.9l-64 64H30.1l0 0 17-17 47-47H64V400 144 96h48 88V48H80.7L39.4 82.4 8.6 45.6l48-40L63.3 0zM336 144H112v96H336V144zM112 400H336V288H112V400zm48-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faStarshipFreighter = {
    prefix: 'fasr',
    iconName: 'starship-freighter',
    icon: [
      576,
      512,
      [],
      'e03a',
      
      'M400 256c0-97.2-78.8-176-176-176S48 158.8 48 256s78.8 176 176 176c14.8 0 29.1-1.8 42.8-5.2L208 350.7c-45.4-7.6-80-47.1-80-94.7c0-53 43-96 96-96s96 43 96 96c0 1.3 0 2.7-.1 4l60 77.7C392.7 313.3 400 285.5 400 256zm40 112h3.6L528 335.2V280H446.7c-3.4 31.8-13.4 61.6-28.7 88h22zm6.7-136H528V176.8l-118.2-46c19.9 29.5 32.9 63.9 36.9 101.1zM576 368l-64 24.9V512H440 368 332.6L311 484l-9.9-12.9C275.9 477 250 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2L576 144V256 368zM88 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm152-80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm77 198.7l7.2 9.3H368h72 24V416H440 379.8L300.7 313.7c-9.7 12.9-22.6 23.3-37.5 30l85.8 111z'
      
    ]
  };

  

  
  

  var faUserLarge = {
    prefix: 'fasr',
    iconName: 'user-large',
    icon: [
      512,
      512,
      ["user-alt"],
      'f406',
      
      'M352 144a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-240 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM72 464H440l-40-96H112L72 464zm8-144H432l60 144 20 48H460 52 0l20-48L80 320z'
      
    ]
  };

  
    var faUserAlt = faUserLarge;
  

  
  

  var faCirclesOverlap = {
    prefix: 'fasr',
    iconName: 'circles-overlap',
    icon: [
      640,
      512,
      [],
      'e600',
      
      'M192 288c0 40.8 10.9 79 30 112c-96.3-1.1-174-79.5-174-176c0-97.2 78.8-176 176-176c38.9 0 74.8 12.6 104 34C248 116.2 192 195.5 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224S100.3 448 224 448zm192 16c-38.9 0-74.8-12.6-104-34C392 395.8 448 316.5 448 224c0-40.8-10.9-79-30-112c96.3 1.1 174 79.5 174 176c0 97.2-78.8 176-176 176z'
      
    ]
  };

  

  
  

  var faRulerVertical = {
    prefix: 'fasr',
    iconName: 'ruler-vertical',
    icon: [
      256,
      512,
      [],
      'f548',
      
      'M208 48V96H160 144v32h16 48v64H160 144v32h16 48v64H160 144v32h16 48v64H160 144v32h16 48v48H48V48H208zM48 0H0V48 464v48H48 208h48V464 48 0H208 48z'
      
    ]
  };

  

  
  

  var faRightLeftLarge = {
    prefix: 'fasr',
    iconName: 'right-left-large',
    icon: [
      640,
      512,
      [],
      'e5e1',
      
      'M157.2 504L7.9 336 157.2 168H240v64H448v64h13.2L567.9 176 461.2 56H448v64H296V72H400V8h82.8L632.1 176 482.8 344H400V280H192V216H178.8L72.1 336 178.8 456H192V392H344v48H240v64H157.2z'
      
    ]
  };

  

  
  

  var faArrowDownFromArc = {
    prefix: 'fasr',
    iconName: 'arrow-down-from-arc',
    icon: [
      512,
      512,
      [],
      'e614',
      
      'M134.4 381.1l-16.3-17.6 35.2-32.7 16.3 17.6L232 415.6l0-231.7v-24h48l0 24V415.6l62.4-67.2 16.3-17.6 35.2 32.7-16.3 17.6-104 112L256 512l-17.6-18.9-104-112zM256 47.9c-114.9 0-208 93.1-208 208H0C0 114.5 114.6-.1 256-.1s256 114.6 256 256v24H464v-24c0-114.9-93.1-208-208-208z'
      
    ]
  };

  

  
  

  var faFlower = {
    prefix: 'fasr',
    iconName: 'flower',
    icon: [
      448,
      512,
      [10047,127804],
      'f7ff',
      
      'M192.9 100.9C177.6 87.8 157.8 80 136 80c-48.6 0-88 39.4-88 88c0 21.8 7.8 41.6 20.9 56.9L95.3 256 68.9 287.1C55.8 302.4 48 322.2 48 344c0 48.6 39.4 88 88 88c21.8 0 41.6-7.8 56.9-20.9L224 384.7l31.1 26.4C270.4 424.2 290.2 432 312 432c48.6 0 88-39.4 88-88c0-21.8-7.8-41.6-20.9-56.9L352.7 256l26.4-31.1C392.2 209.6 400 189.8 400 168c0-48.6-39.4-88-88-88c-21.8 0-41.6 7.8-56.9 20.9L224 127.3l-31.1-26.4zM448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM224 352l-33.9-33.9-28.1-28.1L128 256l33.9-33.9 28.1-28.1L224 160l33.9 33.9 28.1 28.1L320 256l-33.9 33.9-28.1 28.1L224 352zm0-67.9L252.1 256 224 227.9 195.9 256 224 284.1z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMinus = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-minus',
    icon: [
      512,
      512,
      ["search-minus"],
      'f010',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM136 184H112v48h24H280h24V184H280 136z'
      
    ]
  };

  
    var faSearchMinus = faMagnifyingGlassMinus;
  

  
  

  var faCalendarHeart = {
    prefix: 'fasr',
    iconName: 'calendar-heart',
    icon: [
      448,
      512,
      [],
      'e0d3',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zM112 299.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L224 432.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z'
      
    ]
  };

  

  
  

  var faMask = {
    prefix: 'fasr',
    iconName: 'mask',
    icon: [
      576,
      512,
      [],
      'f6fa',
      
      'M242.3 304H272h32 29.7l13.3 26.5L381.7 400H400c37.4 0 69.2-12.4 91.2-33c21.5-20.2 36.8-51.1 36.8-95c0-46.8-13-83.5-43.4-109.7C452.9 134.9 394.3 112 288 112s-164.9 22.9-196.6 50.3C61 188.5 48 225.2 48 272c0 43.9 15.3 74.8 36.8 95c22 20.6 53.7 33 91.2 33h18.3l34.7-69.5L242.3 304zM224 448H176C80 448 0 384 0 272S64 64 288 64s288 96 288 208s-80 176-176 176H352l-37.2-74.3-.2-.3L304 352H272l-10.7 21.3-.2 .3L224 448zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faTreeDecorated = {
    prefix: 'fasr',
    iconName: 'tree-decorated',
    icon: [
      448,
      512,
      [],
      'f7dc',
      
      'M392 208.6V192l-14-16L255.9 36.4 224 0 192.1 36.4 70 176 56 192v16.6V224h48L69.7 272 35.4 320 24 336v27.8V368H72h8L45.7 416 11.4 464 0 480v32H48 400h48V480l-11.4-16-34.3-48L368 368h8 48v-4.2V336l-11.4-16-34.3-48L344 224h48V208.6zM314.2 176H250.7l54.2 75.9L353.6 320H274.7l54.2 75.9L377.6 464H70.4l48.6-68.1L173.3 320H94.4l48.6-68.1L197.3 176H133.8L224 72.9 314.2 176zM224 280a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm64 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBrush = {
    prefix: 'fasr',
    iconName: 'brush',
    icon: [
      384,
      512,
      [],
      'f55d',
      
      'M48 288V48H96v96 16h32V144 48h64v64 16h32V112 48H336V288H48zM0 384H48h80V512H256V384h80 48V336 48 0H336 48 0V48 336v48zm192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faMugSaucer = {
    prefix: 'fasr',
    iconName: 'mug-saucer',
    icon: [
      640,
      512,
      ["coffee"],
      'f0f4',
      
      'M432 80V336H144V80H432zM144 32H96V80 336v48h48H432h48V336 288h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H480 448 432 144zM512 240H480V80h32c44.2 0 80 35.8 80 80s-35.8 80-80 80zM24 432H0v48H24 552h24V432H552 24z'
      
    ]
  };

  
    var faCoffee = faMugSaucer;
  

  
  

  var faGarlic = {
    prefix: 'fasr',
    iconName: 'garlic',
    icon: [
      512,
      512,
      [129476],
      'e40e',
      
      'M208 48v64 23.1V144v5.1l-3 4.2-57.4 80.4c-12.7 17.8-19.6 39.2-19.6 61.1V304c0 53 43 96 96 96s96-43 96-96v-9.2c0-21.9-6.8-43.3-19.6-61.1L283 209.3c-28-39.1-43-86-43-134.1V48H208zm64 0V75.2c0 41.4 12.9 81.8 37 115.5l17.4 24.4c16.6 23.3 25.5 51.1 25.5 79.7V304c0 38.2-16.8 72.5-43.3 96h62.9c51.1 0 92.5-41.4 92.5-92.5c0-28.1-12.8-54.7-34.7-72.2L322 149.5l-18-14.4V112 48H272zM139.3 400C112.8 376.5 96 342.2 96 304v-9.2c0-28.6 8.9-56.5 25.6-79.7l18.1-25.4-57 45.6C60.8 252.9 48 279.4 48 307.5c0 50.7 40.8 91.9 91.3 92.5zM304 0h48V48v64l107.3 85.8c33.3 26.7 52.7 67 52.7 109.7C512 385.1 449.1 448 371.5 448H376v40 24H328V488 448H312v40 24H264V488 448H248v40 24H200V488 448H184v40 24H136V488 448h4.5C62.9 448 0 385.1 0 307.5c0-42.7 19.4-83 52.7-109.7L160 112V48 0h48 96z'
      
    ]
  };

  

  
  

  var faCommentArrowUp = {
    prefix: 'fasr',
    iconName: 'comment-arrow-up',
    icon: [
      512,
      512,
      [],
      'e144',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM280 328V217.9l31 31 17 17L361.9 232l-17-17-72-72-17-17-17 17-72 72-17 17L184 265.9l17-17 31-31V328v24h48V328z'
      
    ]
  };

  

  
  

  var faRectangleWide = {
    prefix: 'fasr',
    iconName: 'rectangle-wide',
    icon: [
      640,
      512,
      [],
      'f2fc',
      
      'M592 112V400H48V112H592zM48 64H0v48V400v48H48 592h48V400 112 64H592 48z'
      
    ]
  };

  

  
  

  var faWindowMinimize = {
    prefix: 'fasr',
    iconName: 'window-minimize',
    icon: [
      512,
      512,
      [128469],
      'f2d1',
      
      'M512 432H0v48H512V432z'
      
    ]
  };

  

  
  

  var faFileInvoice = {
    prefix: 'fasr',
    iconName: 'file-invoice',
    icon: [
      384,
      512,
      [],
      'f570',
      
      'M48 464H336V160H224V48H48V464zM48 0H256L384 128V464v48H336 48 0V464 48 0H48zM80 96H96h80 16v32H176 96 80V96zm0 64H96h80 16v32H176 96 80V160zM192 384h16 80 16v32H288 208 192V384zM304 224V352H80V224H304z'
      
    ]
  };

  

  
  

  var faHandDots = {
    prefix: 'fasr',
    iconName: 'hand-dots',
    icon: [
      512,
      512,
      ["allergies"],
      'f461',
      
      'M192 0h24 80 24l0 24v8h56 24V56 96h56 24v24V304v24h0c0 101.6-82.4 184-184 184h-8.5c-67.9 0-133-27-181-75L13.9 344.5 7 337.5l-7-7v-9.9V277.8v-9.9l7-7 35.2-35.2 17-17 17 17 28.3 28.3 7.5 7.5V56 32h24 56 0V24 0zM160 80V304v9.9l-7 7-7.7 7.7-17 17-17-17L70.5 287.9 59.2 276.6 48 287.8v22.9l92.5 92.5c39 39 91.9 60.9 147.1 60.9H296c75.1 0 136-60.9 136-136V304 280h0V144H400v88 24H352V232 112 88h0V80H320V232v24H272V232 56 48H240v8V80h0V232v24H192V232 80H160zm80 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faAllergies = faHandDots;
  

  
  

  var faArrowDownToDottedLine = {
    prefix: 'fasr',
    iconName: 'arrow-down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e095',
      
      'M64 416v64H0V416H64zm96 0v64H96V416h64zm32 0h64v64H192V416zm160 0v64H288V416h64zm32 0h64v64H384V416zM241.5 360.4L224 379l-17.5-18.6-128-136L62.1 207l35-32.9 16.4 17.5L200 283.5V200 72 48h48V72 200v83.5l86.5-91.9L351 174.1l35 32.9-16.4 17.5-128 136z'
      
    ]
  };

  

  
  

  var faClockTwelveThirty = {
    prefix: 'fasr',
    iconName: 'clock-twelve-thirty',
    icon: [
      512,
      512,
      [],
      'e359',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 152V392v24H232V392 152 128h48v24z'
      
    ]
  };

  

  
  

  var faOnion = {
    prefix: 'fasr',
    iconName: 'onion',
    icon: [
      448,
      512,
      [129477],
      'e427',
      
      'M173.5 120.8c-.4 .8-.8 1.8-1.4 3c-1.5 3.2-3.6 7.9-6.2 13.7c-5.1 11.7-12 28.2-18.9 46.9c-13.9 38.1-27 83.8-27 119.5c0 32.5 9.2 60.2 18.5 79.8c3.8 8.1 7.6 14.7 10.8 19.7c17.4 5.8 36.1 9.6 55.3 11.4C194.2 389.7 184 354.2 184 312c0-61.9 6.1-128.6 12.1-179.6c1.7-14.3 3.4-27.5 5-38.9l-2.4-4.8c-7.5 11.9-16.1 22.6-25.2 32.2zm55.1 9.3c-.2 2-.5 4-.7 6C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2c1.7 4 3.3 7.7 4.9 11c21.3-1.7 41.9-5.9 61-12.4c3.3-4.4 7.1-10.2 11-17.2c9.9-17.9 19.7-43.2 19.7-73.6c0-37.1-15.8-88.6-32.6-132.5c-8.3-21.6-16.6-40.7-22.8-54.5c-.8-1.8-1.6-3.5-2.3-5.1c-8.7-9.4-17-19.7-24.3-31.3l-20.7 41.5zm100.2 38.4c16.8 43.9 34.6 100.1 34.6 143.5c0 25.2-5.5 47.4-12.6 65.7C382.1 355.2 400 325.3 400 288c0-56.7-28-84.2-70.4-118.8c-.3-.2-.5-.4-.8-.7zM102.6 381.4C94.6 360.5 88 334.1 88 304c0-41.6 14.9-91.9 29-130.5c.6-1.5 1.1-3.1 1.7-4.6c-.1 .1-.2 .1-.3 .2C76 203.8 48 231.3 48 288c0 37.7 18.2 67.7 50 90.2c1.5 1.1 3.1 2.1 4.6 3.2zM276.7 34c11.6 39.7 43.1 65.3 76 92C399 163.7 448 203.5 448 288c0 80-57.5 134.7-130.9 160l9.2 23.1 8.9 22.3-44.6 17.8-8.9-22.3-11.6-29.1c-7.3 1.2-14.7 2.2-22.1 2.9V488v24H200V488 462.7c-7.4-.7-14.8-1.6-22.1-2.9l-11.6 29.1-8.9 22.3-44.6-17.8 8.9-22.3 9.2-23.1C57.5 422.7 0 368 0 288c0-84.5 49-124.3 95.3-162c32.9-26.7 64.4-52.4 76-92c1.6-5.5 2.8-11.3 3.6-17.5c.7-5.3 1-10.8 1-16.5h10.3H208l13.8 27.7L224 32l2.2-4.3L240 0h21.7H272c0 5.8 .4 11.3 1 16.5c.8 6.1 2 11.9 3.6 17.5z'
      
    ]
  };

  

  
  

  var faUserClock = {
    prefix: 'fasr',
    iconName: 'user-clock',
    icon: [
      640,
      512,
      [],
      'f4fd',
      
      'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM65 464H348.5c12.3 18.8 28 35.1 46.3 48H50.2 0l14.8-48L64 304H332c-5.9 15.1-9.8 31.2-11.3 48H99.5L65 464zm287-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80H480v16 64 16h16 48 16V352H544 512V304 288z'
      
    ]
  };

  

  
  

  var faCloudShowers = {
    prefix: 'fasr',
    iconName: 'cloud-showers',
    icon: [
      512,
      512,
      [],
      'f73f',
      
      'M368 128v48h48c26.5 0 48 21.5 48 48v48H416 96 48V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 320H48 96 416h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48 48zm136 32H88v24 80 24h48V456 376 352zm192 0H280v24 80 24h48V456 376 352zm-96 56V384H184v24 80 24h48V488 408zm192-24H376v24 80 24h48V488 408 384z'
      
    ]
  };

  

  
  

  var faThumbsUp = {
    prefix: 'fasr',
    iconName: 'thumbs-up',
    icon: [
      512,
      512,
      [61575,128077],
      'f164',
      
      'M224 32h24 96 24V56 89c0 30.3-5.9 59.8-16.9 87H448h40 24v24 80 24H496v40 24H472v40 24H448v24 24H424 384 272 259.9h-7.3l-6-4-10.1-6.7-76.5-51V360.6l103.1 68.8 4 2.7H272 384h16V408 384h24V344 320h24V280 256h16V224H448 311.9 268.4l23.2-36.8C309.8 158.3 320 124.4 320 89V80H272v9c0 49.8-27.2 95.6-70.9 119.4l-4.6 2.5-18.6 10.1-5.4 2.9h-6.1H164h-4V176h.3l13.2-7.2 4.6-2.5C206.4 150.9 224 121.2 224 89V56 32zM128 192V480H0V192H128z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm-24-96h48V296 232h64 24V184H296 232V120l0-24H184v24 64H120 96v48h24 64v64 24z'
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faIdCardClip = {
    prefix: 'fasr',
    iconName: 'id-card-clip',
    icon: [
      576,
      512,
      ["id-card-alt"],
      'f47f',
      
      'M352 0H224V128H352V0zM192 64H48 0v48V464v48H48 528h48V464 112 64H528 384v48H528V464H48V112H192V64zm96 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM176 432H400l-32-96H208l-32 96z'
      
    ]
  };

  
    var faIdCardAlt = faIdCardClip;
  

  
  

  var faEarthAsia = {
    prefix: 'fasr',
    iconName: 'earth-asia',
    icon: [
      512,
      512,
      [127759,"globe-asia"],
      'f57e',
      
      'M367.6 431.6L352 416H288V352l64-64h64v32h38c6.5-20.2 10-41.7 10-64c0-98.4-68.3-180.8-160-202.4V112l-32 32v80H224v96H160l-32-32H50.4C65.8 387.7 152 464 256 464c41.1 0 79.3-11.9 111.6-32.4zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 384H128V352h64v32zM352 128v64H320V128h32zM256 256h32v64H256V256z'
      
    ]
  };

  
    var faGlobeAsia = faEarthAsia;
  

  
  

  var faHotel = {
    prefix: 'fasr',
    iconName: 'hotel',
    icon: [
      512,
      512,
      [127976],
      'f594',
      
      'M512 0H0V48H32V464H0v48H512V464H480V48h32V0zM432 464H304V384h48c0-53-43-96-96-96s-96 43-96 96h48v80H80V48H432V464zM192 96H128v64h64V96zm32 0v64h64V96H224zm160 0H320v64h64V96zM128 192v64h64V192H128zm160 0H224v64h64V192zm32 0v64h64V192H320z'
      
    ]
  };

  

  
  

  var fa9 = {
    prefix: 'fasr',
    iconName: '9',
    icon: [
      320,
      512,
      [],
      '39',
      
      'M48 192c0 61.9 50.1 112 112 112c32.3 0 61.5-13.7 81.9-35.6l5.1-6.3C263.2 242.3 272 217.5 272 192c0-61.9-50.1-112-112-112S48 130.1 48 192zM174.3 351.4c-4.7 .4-9.5 .6-14.3 .6C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 41.5-15.8 79.4-41.8 107.8L131.4 480H69.5L174.3 351.4z'
      
    ]
  };

  

  
  

  var faAlbumCollection = {
    prefix: 'fasr',
    iconName: 'album-collection',
    icon: [
      512,
      512,
      [],
      'f8a0',
      
      'M32 0H56 456h24V48H456 56 32V0zM400 336c0 57.4-64.5 104-144 104s-144-46.6-144-104s64.5-104 144-104s144 46.6 144 104zM40 80H472h24v48H472 40 16V80H40zM82.9 464H429.1l29.1-256H53.8L82.9 464zM472 512H40L5.5 208 0 160H48.3 463.7 512l-5.5 48L472 512zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24z'
      
    ]
  };

  

  
  

  var faGifts = {
    prefix: 'fasr',
    iconName: 'gifts',
    icon: [
      640,
      512,
      [],
      'f79c',
      
      'M200.4 40.6L209 18.3 164.3 1l-8.6 22.4L144.7 51.6 134.6 23.8 126.4 1.2 81.2 17.6l8.2 22.6 7.9 21.6L68.9 43.8 48.6 30.9 22.9 71.4 43.1 84.2 61.6 96H48 0v48V464v48H48 192V464H48V144h96c0 0 0 0 0 0h80 16 16.4c8.1-12.7 18.9-23.5 31.6-31.6V96H240 226.4l18.5-11.8 20.2-12.9L239.4 30.9 219.1 43.8 192.7 60.6l7.7-19.9zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272 224v48V464v48h48H592h48V464 272 224H592h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zm0 72h72 56 8v72H272V272zm0 120H408v72H272V392zm320 0v72H456V392H592zM456 344V272h8 56 72v72H456zm88-144c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z'
      
    ]
  };

  

  
  

  var faCircle4 = {
    prefix: 'fasr',
    iconName: 'circle-4',
    icon: [
      512,
      512,
      [],
      'e0f1',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320-64v24 56h8 24v48H328h-8v40 24H272V360 320H176 144.4l8.5-30.4L197.8 128h49.8l-40 144H272V216 192h48z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fasr',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm97.9-320L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faCalendarMinus = {
    prefix: 'fasr',
    iconName: 'calendar-minus',
    icon: [
      448,
      512,
      [],
      'f272',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zM296 352H152 128V304h24H296h24v48H296z'
      
    ]
  };

  

  
  

  var faBandage = {
    prefix: 'fasr',
    iconName: 'bandage',
    icon: [
      640,
      512,
      [129657,"band-aid"],
      'f462',
      
      'M448 144V368H592V144H448zM192 96H448 592h48v48V368v48H592 448 192 48 0V368 144 96H48 192zm0 272V144H48V368H192zm80-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faBandAid = faBandage;
  

  
  

  var faClapperboardPlay = {
    prefix: 'fasr',
    iconName: 'clapperboard-play',
    icon: [
      512,
      512,
      [],
      'e132',
      
      'M48 432V208H464V432H48zM336 160l80-80h48V96l-64 64H336zm-96 0H176l80-80h64l-80 80zM80 160H48V128L96 80h64L80 160zm432 24V160 80 32H464 48 0V80v80 24 24V432v48H48 464h48V432 208 184zM344 320L208 232V408l136-88z'
      
    ]
  };

  

  
  

  var faSensorCloud = {
    prefix: 'fasr',
    iconName: 'sensor-cloud',
    icon: [
      640,
      512,
      ["sensor-smoke"],
      'e02c',
      
      'M48 80H400V224c17.2 0 33.5 3.9 48 10.8V80 32H400 48 0V80 432v48H48 224V432H48V80zm96 72V128H96v24V264v24h48V264 152zm96 0V128H192v24V264v24h48V264 152zm16 280v80h80 16H544h16 80V432c0-38.7-27.5-71-64-78.4V344c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80v17.6c-36.5 7.4-64 39.7-64 78.4z'
      
    ]
  };

  
    var faSensorSmoke = faSensorCloud;
  

  
  

  var faBookUser = {
    prefix: 'fasr',
    iconName: 'book-user',
    icon: [
      448,
      512,
      [],
      'f7e7',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7h48l32-96H320l32 96h48V48H88C65.9 48 48 65.9 48 88V358.7zM176 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faWatchSmart = {
    prefix: 'fasr',
    iconName: 'watch-smart',
    icon: [
      384,
      512,
      [],
      'e2cc',
      
      'M64 0H320V64h16 48v48V400v48H336 320v64H64V448H48 0V400 112 64H48 64V0zM48 112V400H336V112H48zm168 72v60.8l39.4 32.8 18.4 15.4-30.7 36.9-18.4-15.4-48-40-8.6-7.2V256 184 160h48v24z'
      
    ]
  };

  

  
  

  var faBrain = {
    prefix: 'fasr',
    iconName: 'brain',
    icon: [
      512,
      512,
      [129504],
      'f5dc',
      
      'M280 464V424v-4-4V96 88 48h40c2.7 0 5.4 .3 8 .8c18.3 3.7 32 19.8 32 39.2l0 .7c20.7 3.5 36.9 20.1 39.6 41c.3 2.1 .4 4.2 .4 6.3c0 5.7-1 11.2-2.8 16.3c7.8 .8 15.1 3.5 21.3 7.7c11.5 7.6 19.6 20.1 21.2 34.6c.2 1.8 .3 3.6 .3 5.5c0 14.5-6.5 27.6-16.7 36.4c15.5 6.1 28.1 18 34.9 33.1c3.7 8.1 5.7 17.1 5.7 26.5c0 23.9-13.1 44.8-32.6 55.8c-1.5 .9-3.1 1.7-4.7 2.4c.6 1.2 1.2 2.4 1.7 3.6c2.3 5.6 3.6 11.8 3.6 18.3c0 21.8-14.6 40.3-34.6 46.1c-4.3 1.2-8.8 1.9-13.4 1.9c-5.6 0-11-1-16-2.7c-.3 9.5-3.6 18.3-9 25.4c-7.3 9.5-18.4 16-31 17.1c-1.3 .1-2.7 .2-4 .2H280zm-92 48h44 48 44c32.2 0 60.5-16.5 76.9-41.5c45-8 79.1-47.3 79.1-94.5c0-.5 0-1.1 0-1.6c19.8-20.2 32-47.8 32-78.4c0-27.8-10.1-53.2-26.8-72.7C487 215.8 488 208 488 200c0-32.6-16.3-61.4-41.1-78.8c-4.5-28.9-21.8-53.5-45.9-67.8C387.5 22 356.3 0 320 0H280 232 192c-36.3 0-67.5 22-80.9 53.4C86.9 67.7 69.6 92.3 65.1 121.2C40.3 138.6 24 167.4 24 200c0 8 1 15.8 2.8 23.3C10.1 242.8 0 268.2 0 296c0 30.6 12.2 58.2 32 78.4c0 .5 0 1.1 0 1.6c0 47.3 34.1 86.5 79.1 94.5c16.4 25 44.7 41.5 76.9 41.5zM112.4 129.7c2.7-20.9 18.9-37.6 39.6-41l0-.7c0-19.4 13.7-35.5 32-39.2c2.6-.5 5.3-.8 8-.8h40V88v8V416v4 4 40H188c-1.3 0-2.7-.1-4-.2c-12.6-1.1-23.7-7.6-31-17.1c-5.4-7.1-8.7-15.9-9-25.4c-5 1.8-10.4 2.7-16 2.7c-4.7 0-9.2-.7-13.4-1.9C94.6 416.3 80 397.8 80 376c0-6.5 1.3-12.6 3.6-18.3c.5-1.2 1.1-2.4 1.7-3.6c-1.6-.7-3.2-1.5-4.7-2.4C61.1 340.8 48 319.9 48 296c0-9.5 2.1-18.4 5.7-26.5c6.9-15.1 19.4-27 34.9-33.1C78.5 227.6 72 214.5 72 200c0-1.8 .1-3.7 .3-5.5c1.6-14.4 9.7-26.9 21.2-34.6c6.2-4.1 13.5-6.8 21.3-7.7c-1.8-5.1-2.8-10.6-2.8-16.3c0-2.1 .1-4.2 .4-6.3z'
      
    ]
  };

  

  
  

  var faPompebled = {
    prefix: 'fasr',
    iconName: 'pompebled',
    icon: [
      512,
      512,
      [],
      'e43d',
      
      'M254.3 22.9c45.2 31.3 55.3 91.5 37.8 147.5c45.1-35.8 103.7-47.5 148.6-15.3c64.5 45.8 71.6 140 25.7 207.9l0 0C386.6 480.7 219.2 541.8 98.6 455.3L112.5 436 98.6 455.4c0 0 0 0 0 0C-21.6 369.5-25.7 190 54 72.3c0 0 0 0 0 0L73.8 85.6 54 72.2c0 0 0 0 0 0C100 3.7 189.2-23 254.3 22.9zm-27.4 39c-38.1-27-98.4-15-133.3 37l-.1 .1C23.6 202.2 33.3 350.1 126.3 416.6l0 0c91.8 65.8 230.5 23 300.4-80.2C461.8 284.6 451.6 221.3 413 194l-.1-.1c-25.9-18.6-74.1-11.6-112.2 34.5l-14.2 17.2-18.1-13.1-26.2-18.9L225 201.3l10.2-18.5c29.2-53 18.4-102.4-8.1-120.7l-.2-.2 0 0z'
      
    ]
  };

  

  
  

  var faBowlingBall = {
    prefix: 'fasr',
    iconName: 'bowling-ball',
    icon: [
      512,
      512,
      [],
      'f436',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faUnicorn = {
    prefix: 'fasr',
    iconName: 'unicorn',
    icon: [
      640,
      512,
      [129412],
      'f727',
      
      'M440 48h32 8 3.2L528 115.3v61.1l-42.7 19L457 167l-7-7H440h-8H408v24 17.7 4.8l1.8 4.4c4 9.6 6.2 20.2 6.2 31.4c0 23.5-9.6 44.1-24.7 58.8l-7.3 7.1v10.1V464H336V346.2 326.8l-19-4c-2.1-.4-4.2-1-6.3-1.6l-88-25.7-31.4-9.2 .7 32.7c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L172 385.8l-2.7 7.3 2.1 7.5L188.9 464H139.1l-18.2-65.6-2.1-7.5 2.7-7.3 20.6-54.8 3.3-8.7-3.5-8.6-25.3-63.3c-3-7.6-4.6-15.7-4.6-23.9c0-35.5 28.8-64.2 64.2-64.2h22.6H256h57 21.2l2.6-21C343.2 87.7 387 48 440 48zM551.5 64L540.8 48H560V0H536 508.8 496 480h-8H440C369.9 0 310.9 47.5 293.3 112H256 198.9 176.2c-38.1 0-71.8 19-92.1 48.1C37.3 162.1 0 200.7 0 248v64 24H48V312 248c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6L76.6 366.7l-5.5 14.6-2.7 7.3 2.1 7.5 4.2 15.1 23.1 83.2 4.9 17.6h18.2 99.6 31.6l-8.5-30.4-24-86.3 13-34.8c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5V488v24h24 96 24V488 327.8c19.8-22.6 32-52.3 32-85.5l0-.3 10.7 10.7 15.1-6.7 72-32 14.3-6.3V192 108v-6.7L640 80V64H551.5zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faDice = {
    prefix: 'fasr',
    iconName: 'dice',
    icon: [
      640,
      512,
      [127922],
      'f522',
      
      'M33.9 257.9L0 224l33.9-33.9L190.1 33.9 224 0l33.9 33.9L414.1 190.1 448 224l-33.9 33.9L257.9 414.1 224 448l-33.9-33.9L33.9 257.9zM67.9 224L224 380.1 380.1 224 224 67.9 67.9 224zM320 512V397.3L470.6 246.6 493.3 224l-22.6-22.6-9.4-9.4H640V512H320zM480 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 160a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-88 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 136a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm88-136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faSquareEnvelope = {
    prefix: 'fasr',
    iconName: 'square-envelope',
    icon: [
      448,
      512,
      ["envelope-square"],
      'f199',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM96 160H352v28.2L224 255.4 96 188.2V160zM231.4 287.6L352 224.3V352H96V224.3l120.6 63.3 7.4 3.9 7.4-3.9z'
      
    ]
  };

  
    var faEnvelopeSquare = faSquareEnvelope;
  

  
  

  var faPersonWalkingArrowRight = {
    prefix: 'fasr',
    iconName: 'person-walking-arrow-right',
    icon: [
      640,
      512,
      [],
      'e552',
      
      'M256 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM82.6 201.5l36.3-18.2-22.7 68c-7.4 22.1-.3 46.5 17.8 61.2l104.6 85 22.1 88.2 5.8 23.3 46.6-11.6-5.8-23.3-24-96-1.9-7.8-6.2-5-54.4-44.2 25.7-82.3 6.4 23.4 1.7 6.1L239 273l40 40L313 279l-35.5-35.5-22.3-81.9-3.6-13.2-13.2-3.6-88-24-8.8-2.4-8.2 4.1-80 40-7.9 3.9-3.5 8.1-24 56L8.5 252.6l44.1 18.9 9.5-22.1 20.5-47.9zm59.2 65.1l30-90.1 22.1 6c-.3 .8-.6 1.5-.9 2.3L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zM75.5 402.5L18.2 459.8l-17 17 33.9 33.9 17-17L113 433l3.5-3.5 1.8-4.6 20.4-51.1-39-31.7L75.5 402.5zM541.8 159l-17-17L490.9 176l17 17 39 39H392 368v48h24H546.9l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80z'
      
    ]
  };

  

  
  

  var faRectangleBarcode = {
    prefix: 'fasr',
    iconName: 'rectangle-barcode',
    icon: [
      576,
      512,
      ["barcode-alt"],
      'f463',
      
      'M48 80V432H528V80H48zM0 32H48 528h48V80 432v48H528 48 0V432 80 32zm144 96V384H96V128h48zm64 0V384H176V128h32zm32 0h48V384H240V128zm160 0V384H352V128h48zm48 0h32V384H448V128z'
      
    ]
  };

  
    var faBarcodeAlt = faRectangleBarcode;
  

  
  

  var faSquareS = {
    prefix: 'fasr',
    iconName: 'square-s',
    icon: [
      448,
      512,
      [],
      'e27d',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1l-22.9-7.3 14.7-45.7 22.9 7.3c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7l23.2 6-11.9 46.5-23.2-6c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z'
      
    ]
  };

  

  
  

  var faTurnDown = {
    prefix: 'fasr',
    iconName: 'turn-down',
    icon: [
      384,
      512,
      [10549,"level-down-alt"],
      'f3be',
      
      'M120 192l0-48H72 48 0L0 96 0 48 0 0H48 216h48V48 256v48h40 8 40v48L225.9 478.1 192 512l-33.9-33.9L32 352l0-48H72h8 40V256l0-64zM99.9 352L192 444.1 284.1 352H264 216V304l0-256H48l0 48h72l48 0v48l0 160v48H120 99.9z'
      
    ]
  };

  
    var faLevelDownAlt = faTurnDown;
  

  
  

  var faWheelchairMove = {
    prefix: 'fasr',
    iconName: 'wheelchair-move',
    icon: [
      448,
      512,
      ["wheelchair-alt"],
      'e2ce',
      
      'M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM188.9 52l13.3 6.3 152 72 30.8 14.6L361 169l-71 71H416h30.7l-7.5 29.8-40 160-5.8 23.3-46.6-11.6 5.8-23.3L385.3 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c1.2 0 2.5 0 3.7 0l67.1-67.1L195.1 108l-60.3 46.9-18.9 14.7L86.3 131.8l18.9-14.7 72-56L188.9 52zm114 107.1l-33.8-16-57.4 57.4c11.9 4.1 23.2 9.5 33.7 16.1l57.6-57.6zM160 464a112 112 0 1 0 0-224 112 112 0 1 0 0 224z'
      
    ]
  };

  
    var faWheelchairAlt = faWheelchairMove;
  

  
  

  var faFaceGrimace = {
    prefix: 'fasr',
    iconName: 'face-grimace',
    icon: [
      512,
      512,
      [128556,"grimace"],
      'f57f',
      
      'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144 320v48h32V320H144zm64 0v48h32V320H208zm96 48V320H272v48h32zm32 0h32V320H336v48zM144 288H368h32v32 48 32H368 144 112V368 320 288h32zm.4-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faGrimace = faFaceGrimace;
  

  
  

  var faChessPawnPiece = {
    prefix: 'fasr',
    iconName: 'chess-pawn-piece',
    icon: [
      256,
      512,
      ["chess-pawn-alt"],
      'f444',
      
      'M128 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm73.4 144H224V240H211.2c8.2-14.1 12.8-30.5 12.8-48c0-53-43-96-96-96s-96 43-96 96c0 17.5 4.7 33.9 12.8 48H32v48H54.6l-3.6 64H99.1l3.6-64H128h25.3l3.6 64h48.1l-3.6-64zM53.8 464l17.8-32H184.5l17.8 32H53.8zM256 461.9L212.7 384H43.3L0 461.9V464v48H48 208h48V464v-2.1z'
      
    ]
  };

  
    var faChessPawnAlt = faChessPawnPiece;
  

  
  

  var faArrowsUpDown = {
    prefix: 'fasr',
    iconName: 'arrows-up-down',
    icon: [
      320,
      512,
      ["arrows-v"],
      'f07d',
      
      'M177 18.2l-17-17-17 17-96 96-17 17L64 165.1l17-17 55-55V418.9l-55-55-17-17L30.1 380.8l17 17 96 96 17 17 17-17 96-96 17-17L256 346.9l-17 17-55 55V93.1l55 55 17 17 33.9-33.9-17-17-96-96z'
      
    ]
  };

  
    var faArrowsV = faArrowsUpDown;
  

  
  

  var faWaterLadder = {
    prefix: 'fasr',
    iconName: 'water-ladder',
    icon: [
      576,
      512,
      ["ladder-water","swimming-pool"],
      'f5c5',
      
      'M128 128c0-53 43-96 96-96s96 43 96 96v8 24H272V136v-8c0-26.5-21.5-48-48-48s-48 21.5-48 48v96.2H384V128c0-53 43-96 96-96s96 43 96 96v8 24H528V136v-8c0-26.5-21.5-48-48-48s-48 21.5-48 48V248.2 369c-2.4 1.3-4.8 2.5-7.3 3.7C411.6 378.7 397 383 384 383V272.2H176v109c-8.3-1.8-16.8-4.8-24.7-8.5c-8.1-3.7-15.2-8.1-23.3-13.7V248.2 128zM79 456.9C59.7 467.8 31.5 480 0 480V432c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.8 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  
    var faLadderWater = faWaterLadder;
  
    var faSwimmingPool = faWaterLadder;
  

  
  

  var faCalendarDay = {
    prefix: 'fasr',
    iconName: 'calendar-day',
    icon: [
      448,
      512,
      [],
      'f783',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zM224 256V384H96V256H224z'
      
    ]
  };

  

  
  

  var faBellRing = {
    prefix: 'fasr',
    iconName: 'bell-ring',
    icon: [
      512,
      512,
      [],
      'e62c',
      
      'M288 0H224V51.2C151 66 96 130.6 96 208v88L32 368v48H80 432h48V368l-64-72V208c0-77.4-55-142-128-156.8V0zm80 314.2l12.1 13.6L415.8 368H96.2l35.7-40.1L144 314.2V296 208c0-61.9 50.1-112 112-112s112 50.1 112 112v88 18.2zM320 448H256 192c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM112.6 49.4L79.4 14.6C30.5 61.2 0 127.1 0 200H48c0-59.3 24.8-112.7 64.6-150.6zM464 200h48c0-72.9-30.5-138.8-79.4-185.4L399.4 49.4C439.2 87.3 464 140.7 464 200z'
      
    ]
  };

  

  
  

  var faAudioDescriptionSlash = {
    prefix: 'fasr',
    iconName: 'audio-description-slash',
    icon: [
      640,
      512,
      [],
      'e0a8',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-12.9-10V432 80 32H560 80 70.5L48.4 14.8zm84 65.2H560V412l-94.8-73.6C493.3 321.7 512 291 512 256c0-53-43-96-96-96H360 336v24 54.1l-93.9-72.9-2.2-5.2h-4.4l-103-80zM420.6 303.8L384 275.4V208h32c26.5 0 48 21.5 48 48c0 25-19 45.5-43.4 47.8zM32 432v48H80 487.4l-60.9-48H80V159L32 121.2V432zm94.4-80h52.2l10.3-24.2h70.4L269.5 352h52.2l-1.7-3.9-78.5-61.9 .7 1.6H205.9l9.5-22.2-39.1-30.8L126.4 352z'
      
    ]
  };

  

  
  

  var faFileSpreadsheet = {
    prefix: 'fasr',
    iconName: 'file-spreadsheet',
    icon: [
      384,
      512,
      [],
      'f65b',
      
      'M48 48H224V160H336V464H48V48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM176 256v48H112V256h64zm-64 80h64v48H112V336zm96 0h64v48H208V336zm-16 80h16 64 32V384 336 320 304 256 224H272 208 192 176 112 80v32 48 16 16 48 32h32 64 16zm16-112V256h64v48H208z'
      
    ]
  };

  

  
  

  var faWheat = {
    prefix: 'fasr',
    iconName: 'wheat',
    icon: [
      512,
      512,
      [],
      'f72d',
      
      'M270.3 33.7l-.3 .3c-16.9 17.4-27 38.9-30.4 61.2L224 80l-30.5 28.6c-19.4 18.2-30.8 41.6-34.2 66L144 160l-29.6 27.8C68.2 231.1 67.1 304 111.8 348.7l8.7 8.7 0 0L18.2 459.8l-17 17 33.9 33.9 17-17L154.5 391.4l8.8 8.8c44.7 44.7 117.5 43.6 160.8-2.5L352 368l-9.1-9.5c18.1-4 35.3-13.4 49-27.9L432 288l-10-10.3c16.8-3.9 32.8-12.5 45.9-25.6l10.2-10.2L512 208l-29.5-29.5c-1.5-1.5-3-2.9-4.5-4.3c-11.3-10.3-24.1-18.2-37.6-23.7C481.2 142.8 512 107 512 64V48 0H464 448c-43 0-78.8 30.9-86.5 71.6C356 58.1 348.1 45.4 337.8 34c-1.1-1.2-2.3-2.5-3.5-3.7l-.9-.9L304 0 271.2 32.8l-.9 .9zm33.5 34.4c23 26.9 25.3 65.5 6.8 94.7l-5.5-5.5c-24.6-24.6-25-64.1-1.3-89.2zM224.9 235.6c-24.6-24.6-24.9-64-1.5-89c24.5 26.8 27.5 66.4 8.8 96.3l-7.3-7.3zm-79.2 79.2c-24.4-24.4-24.9-63.3-2.1-88.4c24.3 26.6 27.4 65.7 9.2 95.5l-7.1-7.1zm139.8 53.5c-25 22.9-64 22.3-88.4-2L190 359c29.9-18.2 69-15.1 95.6 9.3zm79.9-79.7l-8.5 9.1c-18.6 19.7-49.7 20.2-68.9 1.1L269 279.7c30-18.8 69.7-15.8 96.5 8.9zm-16.3-87.2c29.2-18.5 67.8-16.2 94.7 6.8l-10 10c-18.7 18.7-49.1 18.7-67.9 0l-16.8-16.8zM448 48h16V64c0 22.1-17.9 40-40 40H408V88c0-22.1 17.9-40 40-40z'
      
    ]
  };

  

  
  

  var faTurnLeft = {
    prefix: 'fasr',
    iconName: 'turn-left',
    icon: [
      512,
      512,
      [],
      'e636',
      
      'M160 248l48 0 160 0 48 0 0 48 0 136 48 0 0-232-256 0-48 0 0-48 0-20.1L67.9 224 160 316.1l0-20.1 0-48zM33.9 257.9L0 224l33.9-33.9L160 64l48 0 0 40 0 8 0 40 48 0 208 0 48 0 0 48 0 232 0 48-48 0-48 0-48 0 0-48 0-88 0-48-48 0-64 0-48 0 0 40 0 8 0 40-48 0L33.9 257.9z'
      
    ]
  };

  

  
  

  var faCircleCaretRight = {
    prefix: 'fasr',
    iconName: 'circle-caret-right',
    icon: [
      512,
      512,
      ["caret-circle-right"],
      'f330',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 128l-32 0 0 256 32 0L368 256 240 128z'
      
    ]
  };

  
    var faCaretCircleRight = faCircleCaretRight;
  

  
  

  var faHands = {
    prefix: 'fasr',
    iconName: 'hands',
    icon: [
      576,
      512,
      ["sign-language","signing"],
      'f2a7',
      
      'M576 261.5l0-177.9-130.6 0L395.5 0 340.1 32 321.6 0l-97 56 15.5 25.7L316 117.4 290.1 73.6l13.9-8 37.7 64 2 .9c26.3 12.4 49.3 29.8 67.8 50.9l12.3-7.1L364.1 73.6l13.9-8 85.8 145.7 32.3-9.2 0-70.5 32 0 0 129.9c0 38.5-22.5 73.4-57.5 89.2l-1.1 .5-5.7 3.3c-1.1 21.3-5.5 41.7-12.7 60.7c7.7-3 15.2-6.6 22.5-10.9l17.9-10.4C542.9 370 576 318.4 576 261.5zM223.1 109.1L201.3 98.8l-10.2 21.7-34.1 72.4L150 208H88 56 32v24 40H24 0v24 64 24H24h8v40 24l24 0 8 0v40 24H88h32H264c92.8 0 168-75.2 168-168V320v-8c0-3.5-.3-6.9-.9-10.2c-6.3-61.4-44.3-115.7-101-142.3l-70.9-33.3-36.2-17zm2.1 89.4l-14.5-6.8 13.6-29 14.5 6.8 70.9 33.3c41.6 19.6 69.4 59.6 73.7 104.7l.1 1.4 .3 1.3c.1 .5 .2 1.1 .2 1.7v8 24c0 66.3-53.7 120-120 120H120h-8V448h72 24V400H184l-72 0-24 0-8 0V384H184h24V336H184 72l-24 0V320h8H80l104 0h24V272H184 80V256h8H240.1 260l9.2-36.8-18.9-8.9-25.1-11.8z'
      
    ]
  };

  
    var faSignLanguage = faHands;
  
    var faSigning = faHands;
  

  
  

  var faLifeRing = {
    prefix: 'fasr',
    iconName: 'life-ring',
    icon: [
      512,
      512,
      [],
      'f1cd',
      
      'M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81l17-17L448 30.1 431 47 419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47l-17-17L30.1 64 47 81 58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431l-17 17L64 481.9l17-17 11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465l17 17L481.9 448l-17-17-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faMoneyBill1Wave = {
    prefix: 'fasr',
    iconName: 'money-bill-1-wave',
    icon: [
      576,
      512,
      ["money-bill-wave-alt"],
      'f53b',
      
      'M276.1 405.2l5.6-1.4 0 0c55.2-14.1 117.5-30 182.8-28.1c4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9c-49.9-1.8-103.1 11.1-164.1 26.6l-5.6 1.4c-55.2 14.1-117.5 30-182.8 28.1C107.4 167.7 80.5 192 48 192V368c35.3 0 63.9 28.6 64 63.9c49.9 1.8 103.1-11.1 164.1-26.6zM0 60.3c16 8.2 32 14.3 48 18.7c80 22.1 160 1.7 240-18.7c96-24.5 192-48.9 288 0V398.9v52.8c-16-8.2-32-14.3-48-18.7c-80-22.1-160-1.7-240 18.7c-96 24.5-192 48.9-288 0V113.1 60.3zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM256 192v32h16v64h-8H248v32h16 8 32 8 16V288H312h-8V208 192H288 272 256z'
      
    ]
  };

  
    var faMoneyBillWaveAlt = faMoneyBill1Wave;
  

  
  

  var faEngine = {
    prefix: 'fasr',
    iconName: 'engine',
    icon: [
      640,
      512,
      [],
      'e16e',
      
      'M424 112l-24 0-72 0v32h88l96 64V400v48H464 224l-51.2-64H128 80V336 280H48v72 24H0V352 160 136H48v24 72H80V192 144h48 32 32 88V112l-72 0H184V64h24H400h24v48zM210.3 354l36.8 46H464V233.7L401.5 192H192 160 128V336h44.8 23.1l14.4 18zM544 192h96V448H544V192zM224 288H160V224h64v64zm32-64h64v64H256V224zm160 0v64H352V224h64z'
      
    ]
  };

  

  
  

  var faTire = {
    prefix: 'fasr',
    iconName: 'tire',
    icon: [
      512,
      512,
      [],
      'f631',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 .9l39.2 12.8c.5-4.5 .8-9 .8-13.6c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5c0 .3 0 .6 0 .9zm-14.9 45.6c-10 14-24.4 24.6-41.2 29.9l0 41.3c34.4-7 63.5-28.7 80.4-58.3l-39.3-12.8zM232 373.6l0-41.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3zm-95.2-104L176 256.9c0-.3 0-.6 0-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 196.4 136 224.8 136 256c0 4.6 .3 9.2 .8 13.6zm93.6-89.5c8-2.7 16.6-4.2 25.6-4.2s17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8L228.8 178l1.6 2.2zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 88a168 168 0 1 1 0 336 168 168 0 1 1 0-336z'
      
    ]
  };

  

  
  

  var faScannerGun = {
    prefix: 'fasr',
    iconName: 'scanner-gun',
    icon: [
      576,
      512,
      ["scanner"],
      'f488',
      
      'M576 32H416V80H576V32zM118 413.7L64.3 382.1 132.6 256h73.6L118 413.7zM261.2 256H304h48V208 80 32H304 112C50.1 32 0 82.1 0 144c0 50.9 34 93.9 80.4 107.5L0 400l94.6 55.7L136 480l23.4-41.9L261.2 256zM416 192v48H576V192H416zM576 432H416v48H576V432zM416 128v32H576V128H416zM576 288H416v32H576V288zM416 352v32H576V352H416zM112 80H304V208H288 233 112c-35.3 0-64-28.7-64-64s28.7-64 64-64z'
      
    ]
  };

  
    var faScanner = faScannerGun;
  

  
  

  var faAlignRight = {
    prefix: 'fasr',
    iconName: 'align-right',
    icon: [
      448,
      512,
      [],
      'f038',
      
      'M424 40h24V88H424 184 160V40h24H424zm0 128h24v48H424 24 0V168H24 424zm24 128v48H424 184 160V296h24H424h24zM424 424h24v48H424 24 0V424H24 424z'
      
    ]
  };

  

  
  

  var faWindowFlip = {
    prefix: 'fasr',
    iconName: 'window-flip',
    icon: [
      512,
      512,
      ["window-alt"],
      'f40f',
      
      'M512 32H0V160v48 16V432v48H48l416 0h48V432 224 208 160 32zM48 224H464l0 208L48 432l0-208zM384 96h64v64H384V96zm-32 0v64H288V96h64zM192 96h64v64H192V96z'
      
    ]
  };

  
    var faWindowAlt = faWindowFlip;
  

  
  

  var faInputText = {
    prefix: 'fasr',
    iconName: 'input-text',
    icon: [
      640,
      512,
      [],
      'e1bf',
      
      'M48 112V400H592V112H48zM0 64H48 592h48v48V400v48H592 48 0V400 112 64zm328 96h52c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60H328 304V328v-8V256 192v-8V160h24zm24 72h28c6.6 0 12-5.4 12-12s-5.4-12-12-12H352v24zm44 72c6.6 0 12-5.4 12-12s-5.4-12-12-12H380 352v24h44zM203.4 160l2.8 7.1 72 180 2 4.9H228.6L219 328H149l-9.6 24H87.8l2-4.9 72-180 2.8-7.1h38.9zm-3.7 120L184 240.6 168.2 280h31.5z'
      
    ]
  };

  

  
  

  var faHandHoldingBox = {
    prefix: 'fasr',
    iconName: 'hand-holding-box',
    icon: [
      576,
      512,
      [],
      'f47b',
      
      'M224 48v80l64-32 64 32V48h80V208H144V48h80zM144 0H96V48 208v48h48H432h48V208 48 0H432 144zm24 304h-7.3l-6 4-90 60H24 0v48H24 72h7.3l6-4 90-60H360v32H320 296 256 232v48h24 40 24 48 32 7l5.9-3.7 80.4-51 15 24L416.6 464H24 0v48H24 424h7.4l6.1-4.2 116.8-80 19-13-12.2-19.5-40-64-12.8-20.5-20.4 13L408 374.5V328 304H384 168z'
      
    ]
  };

  

  
  

  var faDungeon = {
    prefix: 'fasr',
    iconName: 'dungeon',
    icon: [
      512,
      512,
      [],
      'f6d9',
      
      'M0 256C0 114.6 114.6 0 256 0S512 114.6 512 256V512H0V256zM320 143c15.1 7.5 28.7 17.6 40.2 29.6l62.2-41.5c-19.3-25.6-44.3-46.7-73.2-61.2L320 143zm-.4-85.1c-20-6.4-41.4-9.9-63.6-9.9s-43.6 3.5-63.6 9.9L222 132c10.9-2.6 22.3-4 34-4s23.1 1.4 34 4l29.6-74.1zm-230 73.3l62.2 41.5c11.5-12.1 25.1-22.1 40.2-29.6L162.8 70c-28.9 14.5-53.9 35.5-73.2 61.2zm290 67C390 215.4 396.8 235 399.1 256H464c0-35.4-8.8-68.7-24.4-97.8l-60 40zm-307.2-40C56.8 187.3 48 220.6 48 256h64.9c2.3-21 9.1-40.6 19.5-57.9l-60-40zM112 288H48v72h64V288zm288 0v72h64V288H400zM48 392v72h64V392H48zm352 0v72h64V392H400zM272 192V176H240v16V448v16h32V448 192zm-64 32V208H176v16V448v16h32V448 224zm128 0V208H304v16V448v16h32V448 224z'
      
    ]
  };

  

  
  

  var faRoadCircleExclamation = {
    prefix: 'fasr',
    iconName: 'road-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e565',
      
      'M95.6 432L196.2 80H296v24 24h48V104 80h99.8l32.3 113.1c6.5-.7 13.2-1.1 19.9-1.1c10.4 0 20.6 .9 30.5 2.6L480 32H344 296 160L45.7 432 32 480H81.9 360.2c-21.9-26.6-36.2-59.7-39.5-96H296v24 24H95.6zM344 216V192H296v24 80 24h30.6c4.1-14.4 10-28.1 17.4-40.8V216zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-240v16 80 16H480V368 288 272h32zm0 176H480V416h32v32z'
      
    ]
  };

  

  
  

  var faPaperPlane = {
    prefix: 'fasr',
    iconName: 'paper-plane',
    icon: [
      512,
      512,
      [61913],
      'f1d8',
      
      'M0 288l55.6 23.8L192 370.3V376v64 56l48 16 73.3-89.7 88.9 38.1L448 480l6.6-49.4L504.1 59.5 512 0 459.6 29.4 52.7 258.4 0 288zM408.8 411L268.4 350.8 444.9 140.2 408.8 411zM222.3 331.1L108.3 282.2 401.5 117.2 222.3 331.1z'
      
    ]
  };

  

  
  

  var faColumns3 = {
    prefix: 'fasr',
    iconName: 'columns-3',
    icon: [
      640,
      512,
      [],
      'e361',
      
      'M448 80V432H592V80H448zm-48 0H240V432H400V80zM192 432V80H48V432H192zM0 32H48 592h48V80 432v48H592 48 0V432 80 32z'
      
    ]
  };

  

  
  

  var faRightLeft = {
    prefix: 'fasr',
    iconName: 'right-left',
    icon: [
      512,
      512,
      ["exchange-alt"],
      'f362',
      
      'M512 128l-33.9 33.9L384 256H336V208 152H24 0V104H24 336V48 0h48l94.1 94.1L512 128zm-67.9 0L384 67.9V188.1L444.1 128zM488 360h24v48H488 176v56 48H128L33.9 417.9 0 384l33.9-33.9L128 256h48v48 56H488zM128 444.1V323.9L67.9 384 128 444.1z'
      
    ]
  };

  
    var faExchangeAlt = faRightLeft;
  

  
  

  var faMessageDollar = {
    prefix: 'fasr',
    iconName: 'message-dollar',
    icon: [
      512,
      512,
      ["comment-alt-dollar"],
      'f650',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM276 112V92H236v20 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5l0 0c7.9 2.7 20.3 7 29.9 9.1V304v20h40V304v-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l0 0 0 0-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V112z'
      
    ]
  };

  
    var faCommentAltDollar = faMessageDollar;
  

  
  

  var faGridHorizontal = {
    prefix: 'fasr',
    iconName: 'grid-horizontal',
    icon: [
      448,
      512,
      [],
      'e307',
      
      'M40 168v48H88V168H40zM0 128H40 88h40v40 48 40H88 40 0V216 168 128zM40 328v48H88V328H40zM0 288H40 88h40v40 48 40H88 40 0V376 328 288zM248 168H200v48h48V168zm-48-40h48 40v40 48 40H248 200 160V216 168 128h40zm0 200v48h48V328H200zm-40-40h40 48 40v40 48 40H248 200 160V376 328 288zM408 168H360v48h48V168zm-48-40h48 40v40 48 40H408 360 320V216 168 128h40zm0 200v48h48V328H360zm-40-40h40 48 40v40 48 40H408 360 320V376 328 288z'
      
    ]
  };

  

  
  

  var faCircleO = {
    prefix: 'fasr',
    iconName: 'circle-o',
    icon: [
      512,
      512,
      [],
      'e119',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-256a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z'
      
    ]
  };

  

  
  

  var faScannerKeyboard = {
    prefix: 'fasr',
    iconName: 'scanner-keyboard',
    icon: [
      512,
      512,
      [],
      'f489',
      
      'M128 0V64h48V0H128zM304 0V64h48V0H304zM256 0H224V64h32V0zM384 0V288h32V0H384zM512 0H464V288h48V0zM48 144H304V464H48V144zm0-48H0v48V464v48H48 304h48V464 144 96H304 48zM272 256V176H80v80H272zM160 304H80v48h80V304zM80 384v48h80V384H80zm192-80H192v48h80V304zm-80 80v48h80V384H192z'
      
    ]
  };

  

  
  

  var faHillRockslide = {
    prefix: 'fasr',
    iconName: 'hill-rockslide',
    icon: [
      576,
      512,
      [],
      'e508',
      
      'M0 30.1L41 71 441 471l41 41H424 24 0V488 88 30.1zM48 145.9V464H366.1L48 145.9zM248 128l36-64 72 0 36 64-36 64H284l-36-64zM448 372V300l64-36 64 36v72l-64 36-64-36zM128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faMaskFace = {
    prefix: 'fasr',
    iconName: 'mask-face',
    icon: [
      640,
      512,
      [],
      'e1d7',
      
      'M196.8 176l12.1-8.1L292.8 112h54.3l83.9 55.9 12.1 8.1h14.5H496v48c0 59.5-29.5 112.1-74.7 143.9l-3.1 .8 .3 1.2c-28.1 19-62 30.1-98.5 30.1s-70.4-11.1-98.5-30.1l.3-1.2-3.1-.8C173.5 336.1 144 283.5 144 224V176h38.3 14.5zM96 224c0 45.1 13.4 87.2 36.3 122.3L48 325.3V176H96v48zM18.2 367.3l180.7 45.2C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l180.7-45.2 18.2-4.5V344 152 128H616 544 512 496 457.7L369.8 69.4 361.7 64H352 288h-9.7l-8.1 5.4L182.3 128H144 128 96 24 0v24V344v18.7l18.2 4.5zm573.8-42l-84.3 21.1c23-35.2 36.3-77.2 36.3-122.3V176h48V325.3zM208 192H192v32h16H432h16V192H432 208zm-16 64v32h16H432h16V256H432 208 192zm48 64H224v32h16H400h16V320H400 240z'
      
    ]
  };

  

  
  

  var faBottleDroplet = {
    prefix: 'fasr',
    iconName: 'bottle-droplet',
    icon: [
      320,
      512,
      [],
      'e4c4',
      
      'M64 0L80 0V0h48 64 40 8l16 0 0 48-16 0V152.2c38.6 25.8 64 69.8 64 119.8V464v48H256 64 16V464 272c0-49.9 25.4-93.9 64-119.8V48L64 48 64 0zM192 48l-64 0V152.2v25.6l-21.3 14.3C80.9 209.4 64 238.8 64 272V464H256V272c0-33.2-16.9-62.6-42.7-79.9L192 177.9V152.2 48zM160 384c-26.5 0-48-21.5-48-48c0-32 48-80 48-80s48 48 48 80s-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faTurnDownRight = {
    prefix: 'fasr',
    iconName: 'turn-down-right',
    icon: [
      512,
      512,
      [],
      'e455',
      
      'M352 264l-48 0-160 0-48 0 0-48L96 80 48 80l0 232 256 0 48 0 0 48 0 20.1L444.1 288 352 195.9l0 20.1 0 48zm126.1-9.9L512 288l-33.9 33.9L352 448l-48 0 0-40 0-8 0-40-48 0L48 360 0 360l0-48L0 80 0 32l48 0 48 0 48 0 0 48 0 88 0 48 48 0 64 0 48 0 0-40 0-8 0-40 48 0L478.1 254.1z'
      
    ]
  };

  

  
  

  var faFaceThinking = {
    prefix: 'fasr',
    iconName: 'face-thinking',
    icon: [
      512,
      512,
      [],
      'e39b',
      
      'M464 256c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.6-.3l-10.1 27.7c-2.5 6.8-5.8 13.1-9.8 18.8c10.3 1.3 20.8 1.9 31.4 1.9c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 45 11.6 87.3 32 124V352 296H51.8c-2.5-12.9-3.8-26.3-3.8-40c0-57.1 23-108.8 60.2-146.4L122 133.8l13.9-7.9 7.1-4c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3 12.1 10.4 20.8-24.3-12.1-10.4-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-5.4 3.1C157.9 66.5 204.8 48 256 48c114.9 0 208 93.1 208 208zM308 290.9l-7.5-2.2-136-40-15.3-4.5-9 30.7 15.4 4.5 106.4 31.3L308 290.9zM176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 328H64v24V488v24H88h88 16.8l5.7-15.8 31.8-87.5 49.8-18.1 22.6-8.2-16.4-45.1-22.6 8.2L112 400.6V352 328z'
      
    ]
  };

  

  
  

  var faShare = {
    prefix: 'fasr',
    iconName: 'share',
    icon: [
      512,
      512,
      ["mail-forward"],
      'f064',
      
      'M50.3 427c35.8 37.4 77.7 53 77.7 53s-30.1-30.1-31.9-75.7c-.1-1.4-.1-2.8-.1-4.3c0-61.9 50.1-112 112-112h32 48v48 12.2 .9V384h32l16-14.7L476.5 240.6 512 208l-35.5-32.6L336 46.7 320 32H288V66.9v.9V80v48H240 176C78.8 128 0 206.8 0 304c0 54.8 23.5 95 50.3 123zm5.8-77.6C51.1 336 48 321 48 304c0-70.7 57.3-128 128-128H288h48V128 111.8L441 208 336 304.2V288 240H288 208c-70.7 0-130.6 45.8-151.8 109.4z'
      
    ]
  };

  
    var faMailForward = faShare;
  

  
  

  var faDownLeft = {
    prefix: 'fasr',
    iconName: 'down-left',
    icon: [
      384,
      512,
      [],
      'e16a',
      
      'M136 267.9l33.9-33.9L272 131.9 316.1 176 214.1 278.1 180.1 312l33.9 33.9L252.1 384H64V195.9l38.1 38.1L136 267.9zM97.9 161.9L64 128 30.1 161.9 16 176V384v48H64 272l14.1-14.1L320 384l-33.9-33.9-4.1-4.1L248 312l33.9-33.9 68.1-68.1L384 176l-33.9-33.9L305.9 97.9 272 64 238.1 97.9l-68.1 68.1L136 200l-33.9-33.9-4.1-4.1z'
      
    ]
  };

  

  
  

  var faDatabase = {
    prefix: 'fasr',
    iconName: 'database',
    icon: [
      448,
      512,
      [],
      'f1c0',
      
      'M48 206v50 21.4L141.8 336H306.2L400 277.4V256 206l-80 50H128L48 206zM0 176V128 80L128 0H320L448 80v48 48 80 48V432L320 512H128L0 432V304 256 176zm400-48V106.6L306.2 48H141.8L48 106.6V128v21.4L141.8 208H306.2L400 149.4V128zM48 405.4L141.8 464H306.2L400 405.4V334l-80 50H128L48 334v71.4z'
      
    ]
  };

  

  
  

  var faNoteMedical = {
    prefix: 'fasr',
    iconName: 'note-medical',
    icon: [
      448,
      512,
      [],
      'e200',
      
      'M400 80V320H288V432H48V80H400zM48 480H288h32L448 352V320 80 32H400 48 0V80 432v48H48zM192 128v64H128v64h64v64h64V256h64V192H256V128H192z'
      
    ]
  };

  

  
  

  var faTriangleExclamation = {
    prefix: 'fasr',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      'M27.4 432L0 480H55.3 456.7 512l-27.4-48L283.6 80.4 256 32 228.4 80.4 27.4 432zm401.9 0H82.7L256 128.7 429.3 432zM232 296v24h48V296 208H232v88zm48 104V352H232v48h48z'
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  

  
  

  var faSnake = {
    prefix: 'fasr',
    iconName: 'snake',
    icon: [
      512,
      512,
      [128013],
      'f716',
      
      'M417 202.2L512 160V64L368 0 284 48H168C84.1 48 16 116.1 16 200c0 59.5 34.2 111.1 84 136c20.5 10.2 43.5 16 68 16h88 0 .1 0 36.1H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H292.3 256.1l-.1 0H168 96l-2.5 1.7L43.3 419.2 0 448l43.3 28.8L96 512h79.9l.1 0H320c79.5 0 144-64.5 144-144c0-44.6-20.3-84.5-52.2-110.9c-11.7-9.7-25-17.6-39.4-23.2c-2.7-1.1-5.5-2-8.3-2.9c-13.9-4.5-28.7-6.9-44.1-6.9H284 271.3 168c-13.3 0-24-10.7-24-24s10.7-24 24-24H284l36 20.6L368 224l49-21.8zm-46.2-32l-62.9-35.9L296.7 128H284 168c-39.8 0-72 32.2-72 72s32.2 72 72 72H320c53 0 96 43 96 96s-43 96-96 96l-143.9 0-.1 0-.1 0h-.1H110.5l-24-16 24-16H256l0 0h.1H320c35.3 0 64-28.7 64-64s-28.7-64-64-64H168c-57.4 0-104-46.6-104-104s46.6-104 104-104H284h12.7l11.1-6.3 62.9-35.9L464 95.2v33.6l-93.3 41.5zM384 88a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faHandcuffs = {
    prefix: 'fasr',
    iconName: 'handcuffs',
    icon: [
      640,
      512,
      [],
      'e4f8',
      
      'M234.9 14L298 2.9l11.1 63L246 77.1 234.9 14zM96 160h34.7L160 130.7 189.3 160H224v45.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.6 39.5-122 96-146.7V160zm64 304a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 352c0-25.9-5.1-50.5-14.4-73.1c16.8-32.7 44.5-58.8 78.4-73.6V160h34.7L480 130.7 509.3 160H544v45.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm240 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM201.4 43.7l34.9 53.7-53.7 34.9L147.7 78.6l53.7-34.9zm237.2 0l53.7 34.9-34.9 53.7L403.7 97.4l34.9-53.7zM405.1 14L394 77.1 330.9 66 342 2.9l63 11.1z'
      
    ]
  };

  

  
  

  var faInhaler = {
    prefix: 'fasr',
    iconName: 'inhaler',
    icon: [
      576,
      512,
      [],
      'f5f9',
      
      'M576 72L528.7 243.4 395.2 110 416 32 576 72zM374.1 272H337.3 240V432H449.9l33-121.2-94-94-5.3 19.6L374.1 272zm29.2-108.6L536.6 296.6 486.6 480H240 192V432 272 224h48 97.3l12.5-46.3 14.4-53.5 39.2 39.2zM0 256a32 32 0 1 1 64 0A32 32 0 1 1 0 256zm0 96a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faBookJournalWhills = {
    prefix: 'fasr',
    iconName: 'book-journal-whills',
    icon: [
      448,
      512,
      ["journal-whills"],
      'f66a',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zm77.6-191.3l23.2 23.2 12.3-12.3-28.8-28.9c10.9-22.7 28.7-41.5 50.6-53.8c-18.6 29.6-12 68.5 15.3 90.2c-15.4 16.1-20.9 39.2-14.3 60.3c6.4 21.2 24 37.3 45.7 41.8l1.5-35.8-10.5 7.8-6.3-5.9 8.6-15.6-19.7-4.1v-8.6l19.7-4.1-9.4-15.6 6.3-5.9 13.1 8.9 5-125h8.7l5.2 126.6 15.4-10.5 6.1 5.9-9.3 15.6 19.7 4.1v8.6l-19.7 4 9.3 15.7-6.1 5.9-13.8-9.4 1.5 37.4c21.7-4.5 39.3-20.6 45.7-41.8c6.6-21.2 1.1-44.4-14.3-60.3c27.3-21.7 33.8-60.6 15.3-90.2c22.1 12.3 39.7 31.1 50.6 53.8l-28.8 28.9 12.3 12.3 23.2-23.2c3.3 11.1 5.6 22.5 5.6 34.5c0 .3 0 .5-.1 .8s-.1 .5-.1 .8L323.9 239l11.5 13.1 25.8-22.5c-12.7 54.2-60.9 94.6-118.9 94.6s-106.2-40.4-118.9-94.6l25.8 22.5L160.7 239l-40.5-35.5c0-.3 0-.5-.1-.8s-.1-.5-.1-.8c0-12 2.3-23.5 5.6-34.5z'
      
    ]
  };

  
    var faJournalWhills = faBookJournalWhills;
  

  
  

  var faBookOpen = {
    prefix: 'fasr',
    iconName: 'book-open',
    icon: [
      576,
      512,
      [128214,128366],
      'f518',
      
      'M288 480s-64.7-38.8-144-40c-28.7-.4-66.4 6-96 12.4C20.5 458.2 0 464 0 464V414.3 72s64-40 160-40c72 0 128 24 128 24s64-24 128-24c96 0 160 40 160 40V414.3 464s-20.5-5.8-48-11.6c-29.6-6.3-67.3-12.8-96-12.4c-79.3 1.2-144 40-144 40zm240-76.7V101.9c-3.7-1.5-7.7-3.1-12.1-4.7C491.8 88.6 457.4 80 416 80c-26.6 0-54.3 5.1-76.4 10.6c-10.8 2.7-19.8 5.4-26 7.4c-.6 .2-1.2 .4-1.7 .5V416c.4-.2 .9-.3 1.3-.5c29.3-11.1 71-22.8 118-23.5c31-.5 68 5.5 96.7 11.3zM264 416V98.2c-.6-.2-1.2-.4-1.9-.7c-5.3-1.9-13.2-4.5-23.3-7.1C218.7 85.2 190.8 80 160 80c-41.4 0-75.8 8.6-99.9 17.2c-4.4 1.6-8.5 3.2-12.1 4.7V403.3c28.8-5.8 65.8-11.8 96.7-11.3c47 .7 88.6 12.5 118 23.5c.4 .2 .9 .3 1.3 .5z'
      
    ]
  };

  

  
  

  var faChevronsRight = {
    prefix: 'fasr',
    iconName: 'chevrons-right',
    icon: [
      512,
      512,
      ["chevron-double-right"],
      'f324',
      
      'M273 239l17 17-17 17L81 465l-17 17L30.1 448l17-17 175-175L47 81l-17-17L64 30.1 81 47 273 239zm192 0l17 17-17 17L273 465l-17 17L222.1 448l17-17 175-175L239 81l-17-17L256 30.1l17 17L465 239z'
      
    ]
  };

  
    var faChevronDoubleRight = faChevronsRight;
  

  
  

  var faCorner = {
    prefix: 'fasr',
    iconName: 'corner',
    icon: [
      448,
      512,
      [],
      'e3fe',
      
      'M0 160H24 424h24v24V360v24H400V360 208H24 0V160z'
      
    ]
  };

  

  
  

  var faBahtSign = {
    prefix: 'fasr',
    iconName: 'baht-sign',
    icon: [
      320,
      512,
      [],
      'e0ac',
      
      'M160 0H112V64H48 0v48V232v48V400v48H48h64v64h48V448h52c59.6 0 108-48.4 108-108c0-42.1-24.1-78.5-59.2-96.4C277.7 224.6 288 199.5 288 172c0-59.6-48.4-108-108-108H160V0zM112 112V232H48V112h64zm48 120V112h20c33.1 0 60 26.9 60 60s-26.9 60-60 60H160zm-48 48V400H48V280h64zm48 120V280h20 32c33.1 0 60 26.9 60 60s-26.9 60-60 60H160z'
      
    ]
  };

  

  
  

  var faCowbell = {
    prefix: 'fasr',
    iconName: 'cowbell',
    icon: [
      448,
      512,
      [],
      'f8b3',
      
      'M128 0h24H296h24V24 96h64l54.4 272 9.6 48H399 49 0l9.6-48L64 96h64V24 0zM272 48H176V96h96V48zM103.4 144L58.6 368H389.4L344.6 144H103.4zM288 448c0 35.3-28.7 64-64 64s-64-28.7-64-64H288z'
      
    ]
  };

  

  
  

  var faLightbulbDollar = {
    prefix: 'fasr',
    iconName: 'lightbulb-dollar',
    icon: [
      384,
      512,
      [],
      'f670',
      
      'M320 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7l0 0 0 0 0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8l0 0c-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM112 416v96H272V416H112zm96.8-304V96h-32v16 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8-9.5 30.6 15.3 4.8c1.6 .5 3.3 1 5 1.6l0 0 0 0 0 0 0 0c7.1 2.3 15.1 4.9 23.7 6.6v11.4 16h32v-16V262.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L226.7 125c-5.6-1.4-11.6-2.7-17.9-3.7V112z'
      
    ]
  };

  

  
  

  var faTireRugged = {
    prefix: 'fasr',
    iconName: 'tire-rugged',
    icon: [
      512,
      512,
      [],
      'f634',
      
      'M192.7 0H171l-2.2 21.6-1.9 19.3-15-12.3L135.1 14.9 119.7 30.2 30.2 119.7 14.9 135.1l13.8 16.8 12.3 15-19.3 1.9L0 171v21.7V319.3 341l21.6 2.2 19.3 1.9-12.3 15L14.9 376.9l15.4 15.4 89.5 89.5 15.4 15.4 16.8-13.8 15-12.3 1.9 19.3L171 512h21.7H319.3 341l2.2-21.6 1.9-19.3 15 12.3 16.8 13.8 15.4-15.4 89.5-89.5 15.4-15.4-13.8-16.8-12.3-15 19.3-1.9L512 341V319.3 192.7 171l-21.6-2.2-19.3-1.9 12.3-15 13.8-16.8-15.4-15.4L392.3 30.2 376.9 14.9 360.1 28.6l-15 12.3-1.9-19.3L341 0H319.3 192.7zm20.4 61.3L214.4 48h83.1l1.3 13.3 1.5 15.4 14.6 5c7.7 2.6 15.2 5.7 22.4 9.3l13.9 6.9 12-9.8 10.4-8.5 58.8 58.8L424 148.7l-9.8 12 6.9 13.9c3.6 7.2 6.7 14.7 9.3 22.4l5 14.6 15.4 1.5 13.3 1.3v83.1l-13.3 1.3-15.4 1.5-5 14.6c-2.6 7.7-5.7 15.2-9.3 22.4l-6.9 13.9 9.8 12 8.5 10.4-58.8 58.8L363.3 424l-12-9.8L337.5 421c-7.2 3.6-14.7 6.7-22.4 9.3l-14.6 5-1.5 15.4L297.6 464H214.4l-1.3-13.3-1.5-15.4-14.6-5c-7.7-2.6-15.2-5.7-22.4-9.3l-13.9-6.9-12 9.8-10.4 8.5L79.5 373.7 88 363.3l9.8-12L91 337.5c-3.6-7.2-6.7-14.7-9.3-22.4l-5-14.6-15.4-1.5L48 297.6V214.4l13.3-1.3 15.4-1.5 5-14.6c2.6-7.7 5.7-15.2 9.3-22.4l6.9-13.9-9.8-12-8.5-10.4 58.8-58.8L148.7 88l12 9.8L174.5 91c7.2-3.6 14.7-6.7 22.4-9.3l14.6-5 1.5-15.4zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM232 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-67.3 42.3a24 24 0 1 1 45.7 14.8 24 24 0 1 1 -45.7-14.8zm152.4-15.4a24 24 0 1 1 14.8 45.7 24 24 0 1 1 -14.8-45.7zm-4.6 122.7a24 24 0 1 1 -28.2-38.8 24 24 0 1 1 28.2 38.8zm-79.3-5.3a24 24 0 1 1 -38.8-28.2 24 24 0 1 1 38.8 28.2z'
      
    ]
  };

  

  
  

  var faRectangleXmark = {
    prefix: 'fasr',
    iconName: 'rectangle-xmark',
    icon: [
      512,
      512,
      [62164,"rectangle-times","times-rectangle","window-close"],
      'f410',
      
      'M48 80V432H464V80H48zM0 32H48 464h48V80 432v48H464 48 0V432 80 32zM353.9 192l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z'
      
    ]
  };

  
    var faRectangleTimes = faRectangleXmark;
  
    var faTimesRectangle = faRectangleXmark;
  
    var faWindowClose = faRectangleXmark;
  

  
  

  var faHandBackPointRibbon = {
    prefix: 'fasr',
    iconName: 'hand-back-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a0',
      
      'M96 0h24 80 24V24 160h48 24v24 8h48 24v24 8h40 24v24 40 96 8c0 66.3-53.7 120-120 120H186.6c-26.9 0-53.3-7.1-76.6-20.7l-2.6-1.5C60.7 462.5 32 412.5 32 358.5V320 309.4l7.9-7.1 56.1-51V176H32l43.6-48L32 80H96V24 0zm48 176v72 13.8V264v8.4V344v16H112V344 301.5L80 330.6v27.9c0 37 19.6 71.2 51.6 89.8l2.6 1.5-11.7 20 11.7-20c15.9 9.3 34 14.2 52.4 14.2H312c39.8 0 72-32.2 72-72v-8V288 272H344 320V248v-8H272 248V216v-8H200 176V184v-8H144zm32-96V48H144V80h32z'
      
    ]
  };

  

  
  

  var faCartFlatbedSuitcase = {
    prefix: 'fasr',
    iconName: 'cart-flatbed-suitcase',
    icon: [
      640,
      512,
      ["luggage-cart"],
      'f59d',
      
      'M0 0H24h80 24V24 416h80H496 616h24v48H616 544c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c0 26.5-21.5 48-48 48s-48-21.5-48-48H104 80V440 48H24 0V0zM304 0h24H472h24V24 96h64 48v48V304v48H560 240 192V304 144 96h48 64V24 0zm48 96h96V48H352V96zM240 144V304h48V144H240zm96 0V304H464V144H336zM560 304V144H512V304h48z'
      
    ]
  };

  
    var faLuggageCart = faCartFlatbedSuitcase;
  

  
  

  var faEarthEurope = {
    prefix: 'fasr',
    iconName: 'earth-europe',
    icon: [
      512,
      512,
      ["globe-europe"],
      'f7a2',
      
      'M272 463.4V432H208l-48-48V272H304l48 48h32l32 32h24.6c5.3-10.2 9.8-20.9 13.4-32H432l-48-48V192h32V160H352v48H272 256v32H192V208l80-80V112H224V80l32-32C141.1 48 48 141.1 48 256s93.1 208 208 208c5.4 0 10.7-.2 16-.6zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 123.3l-32 32L144 166.6 121.4 144l11.3-11.3 32-32L176 89.4 198.6 112l-11.3 11.3z'
      
    ]
  };

  
    var faGlobeEurope = faEarthEurope;
  

  
  

  var faPrintSlash = {
    prefix: 'fasr',
    iconName: 'print-slash',
    icon: [
      640,
      512,
      [],
      'f686',
      
      'M482.7 352H496h16 16V240H338.5L482.7 352zM276.6 192H528h48v48V352v48H544.6l76.4 59.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L128 76.6V48 0h48H448l64 64v96H464V83.9L428.1 48H176v65.9L276.6 192zm-93.9 48H112V352h32V320h48 92.3l60.9 48H192v96H448V449l48 37.8V512H448 192 144V464 400H112 64V352 240 192h48 9.8l60.9 48z'
      
    ]
  };

  

  
  

  var faRug = {
    prefix: 'fasr',
    iconName: 'rug',
    icon: [
      640,
      512,
      [],
      'e569',
      
      'M24 64H0v48H24h8v40H24 0v48H24h8v32H24 0v48H24h8v32H24 0v48H24h8v40H24 0v48H24 56 80 560h24 32 24V400H616h-8V360h8 24V312H616h-8V280h8 24V232H616h-8V200h8 24V152H616h-8V112h8 24V64H616 584 560 80 56 24zm56 48h48V400H80V360 312 280 232 200 152 112zM464 400H176V112H464V400zm48 0V112h48v40 48 32 48 32 48 40H512z'
      
    ]
  };

  

  
  

  var faUserTag = {
    prefix: 'fasr',
    iconName: 'user-tag',
    icon: [
      640,
      512,
      [],
      'f507',
      
      'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM65 464L99.5 352H320V304H64L14.8 464 0 512H50.2 397.8 448l-8.3-27.1-72.5-72.5L383 464H65zm447 48L640 384 480 224H384l-32 32v96L512 512zM408 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faImagePortrait = {
    prefix: 'fasr',
    iconName: 'image-portrait',
    icon: [
      384,
      512,
      ["portrait"],
      'f3e0',
      
      'M48 48l0 416H336l0-416L48 48zM384 0V48l0 416v48H336 48L0 512V464 48 0H48 336h48zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 96l32 96H80l32-96H272z'
      
    ]
  };

  
    var faPortrait = faImagePortrait;
  

  
  

  var faPersonFalling = {
    prefix: 'fasr',
    iconName: 'person-falling',
    icon: [
      512,
      512,
      [],
      'e546',
      
      'M320 24l0-24H272V24v88.5L110.1 186.1 96 192.5V208 360v24h48l0-24 0-112.2L307.9 501 348.2 475 263.6 344.3 327 304l46.3 0 64.8 72.1 16.1 17.8 35.7-32.1-16.1-17.8-72-80-7.2-7.9H384l-63.7 0h-.6l-19 0-53.8-79.3 59-26.8 14.1-6.4 0-15.5 0-104zM263.9 287.2L237.5 304 176 208.9l26.6-12.1 61.3 90.4zM112 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faBriefcase = {
    prefix: 'fasr',
    iconName: 'briefcase',
    icon: [
      512,
      512,
      [128188],
      'f0b1',
      
      'M152 0H128V24 96H48 0v48V280 432v48H48 464h48V432 280 144 96H464 384V24 0H360 152zM464 256H320 192 48V144H152 360 464V256zM320 304H464V432H48V304H192v48H320V304zM336 96H176V48H336V96z'
      
    ]
  };

  

  
  

  var faPotFood = {
    prefix: 'fasr',
    iconName: 'pot-food',
    icon: [
      640,
      512,
      [127858],
      'e43f',
      
      'M112 0H64V24c0 45.1 21.2 69 37.7 87.5l.4 .4C117.5 129.3 128 141.5 128 168v24h48V168c0-45.1-21.2-69-37.7-87.5l-.4-.4C122.5 62.7 112 50.5 112 24V0zM224 0H176V24c0 45.1 21.2 69 37.7 87.5l.4 .4C229.5 129.3 240 141.5 240 168v24h48V168c0-45.1-21.2-69-37.7-87.5l-.4-.4C234.5 62.7 224 50.5 224 24V0zm16 464V443.1l-26.7-13.2c-55.1-27.3-93.9-82.4-97.8-147.5l-.6-10.3H525.1l-.6 10.3c-3.8 65.1-42.7 120.3-97.8 147.5L400 443.1V464H240zM65.9 256H40 16v48H40 69.5C80.2 378.6 127.4 440.9 192 472.9V512h48H400h48V472.9c64.6-32 111.8-94.3 122.5-168.9H600h24V256H600 574.1l1.9-32H527.9 112.1 64l1.9 32zM432 112c-50.7 0-93.6 33.7-107.4 80H539.4c-13.8-46.3-56.6-80-107.4-80z'
      
    ]
  };

  

  
  

  var faCloudMoon = {
    prefix: 'fasr',
    iconName: 'cloud-moon',
    icon: [
      640,
      512,
      [],
      'f6c3',
      
      'M550.4 24.7c-61.2 16.6-106.2 72.5-106.2 139c0 79.5 64.5 144 144 144c16.3 0 32-2.7 46.7-7.7c-32.1 41.6-82.5 68.4-139.1 68.4c-13.3 0-26.3-1.5-38.8-4.3c-10.8-14.2-24.9-25.7-41.2-33.4c-2.5-52.9-41.6-96.2-92.6-105.1c-2.1-10.8-3.2-22-3.2-33.4C320 94.9 398.7 16 495.8 16c19.1 0 37.4 3 54.6 8.7zM176.6 272c-26.5 0-48 21.5-48 48v24 24h-24H96c-26.5 0-48 21.5-48 48v48H80.6h31.8l0 0H248.6h0 88v0h24H368h32V432c0-17.7-14.3-32-32-32h-7.4-24V376 336c0-17.7-14.3-32-32-32c-14.9 0-27.5 10.2-31 24h-49v-8c0-26.5-21.5-48-48-48zm208 240v0h-24-112 0-144-24H48.8l0 0H24 0V488 416c0-47.8 34.9-87.4 80.6-94.8V320c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.7-14.4 45.8-14.4c44.2 0 80 35.8 80 80v17.7c36.2 7.6 63.4 39.8 63.4 78.3v56 24H424 384.6z'
      
    ]
  };

  

  
  

  var faLocationPen = {
    prefix: 'fasr',
    iconName: 'location-pen',
    icon: [
      384,
      512,
      ["map-marker-edit"],
      'f607',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zM240.8 96l47.3 47.3L259 172.4l-47.3-47.3L240.8 96zm-51.7 51.7L236.4 195l-85.2 85.2L96 288.1l7.9-55.3 85.2-85.2z'
      
    ]
  };

  
    var faMapMarkerEdit = faLocationPen;
  

  
  

  var faSlashForward = {
    prefix: 'fasr',
    iconName: 'slash-forward',
    icon: [
      320,
      512,
      [],
      '2f',
      
      'M311 0H257.7L9 512H62.3L311 0z'
      
    ]
  };

  

  
  

  var faShieldQuartered = {
    prefix: 'fasr',
    iconName: 'shield-quartered',
    icon: [
      512,
      512,
      [],
      'e575',
      
      'M232 60.8V200H69.9c-4.7-27.7-6.3-53.1-5.8-74L232 60.8zM81 248H232V447.4c-66.9-37.8-108.8-94.3-134.1-152.6C91.1 279.2 85.5 263.5 81 248zM280 447.3V248H431c-4.5 15.5-10.1 31.2-16.9 46.8C388.8 353.1 346.9 409.5 280 447.3zM442.1 200H280V60.8L448 126c.5 20.9-1.1 46.3-5.8 74zm53.4-87l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9z'
      
    ]
  };

  

  
  

  var faHandFist = {
    prefix: 'fasr',
    iconName: 'hand-fist',
    icon: [
      448,
      512,
      [9994,"fist-raised"],
      'f6de',
      
      'M128 0h24 80 24V24v8h56 24V56 96h56 24v24V232c0 0 0 0 0 .1V256c0 51.2-25.3 96.4-64 123.9V488v24H304V488 366.9 353l12-6.9c26.7-15.5 45.9-42.4 50.8-74.1H312 288V248v-8H256v40 24H232 152 128V256h24 56V224H152 80v16 16.1c0 48.4 33.2 89.1 78 100.6l18 4.6V380 488v24H128V488 397.3C74.1 376 35.4 324.7 32.2 264H32v-8V240v-8V200 176H48V56 32H72h56V24 0zM368 168l0-24H336v72 8h32l0-32V168zM128 80H96v96h32V80zm80 96l0-120 0-8H176v8V176h32zm48 16h32V120 96 80H256l0 112z'
      
    ]
  };

  
    var faFistRaised = faHandFist;
  

  
  

  var faAirplay = {
    prefix: 'fasr',
    iconName: 'airplay',
    icon: [
      576,
      512,
      [],
      'e089',
      
      'M48 80H528V368H424.7l44.7 40.2 8.7 7.8H528h48V368 80 32H528 48 0V80 368v48H48 97.9l8.7-7.8L151.3 368H48V80zm80 400h48H400h48V432L288 288 128 432v48zM288 352.6L376.2 432H199.8L288 352.6z'
      
    ]
  };

  

  
  

  var faLamp = {
    prefix: 'fasr',
    iconName: 'lamp',
    icon: [
      448,
      512,
      [],
      'f4ca',
      
      'M51.3 256H0l18-48L96 0H352l78 208 18 48H396.7 51.3zm18-48H378.7l-60-160H129.3l-60 160zM144 320V288h48v32 19.9l-13.9 13.9 0 0c-.1 .1-.4 .4-.7 .8c-.8 .9-2.1 2.3-3.7 4.3c-3.3 4.1-7.9 10.2-12.5 17.8C151.7 392.4 144 411.8 144 432c0 12.2 3.8 23.2 8.5 32H295.5c4.7-8.8 8.5-19.8 8.5-32c0-18.8-7.6-38.1-17.3-54.7c-4.7-7.9-9.4-14.4-12.8-18.7c-1.7-2.2-3.1-3.8-3.9-4.7c-.4-.5-.7-.8-.8-.9l0 0 0 0-.1-.1c0 0 0 0 0 0L256 339.2V320 288h48v32s48 50.5 48 112c0 48-32 80-32 80H128s-32-32-32-80c0-64 48-112 48-112z'
      
    ]
  };

  

  
  

  var faArrowsSplitUpAndLeft = {
    prefix: 'fasr',
    iconName: 'arrows-split-up-and-left',
    icon: [
      512,
      512,
      [],
      'e4bc',
      
      'M241 148.2l-17 17-33.9-33.9 17-17 89-89V24h1.3l5.8-5.8 17-17 17 17 5.8 5.8H344v1.3l89 89 17 17L416 165.1l-17-17-55-55V264v24 96 24 56H488h24v48H488 320 296V488 408 384 312H93.1l55 55 17 17-33.9 33.9-17-17-89-89H24v-1.3L18.2 305l-17-17 17-17 5.8-5.8V264h1.3l89-89 17-17L165.1 192l-17 17-55 55H296V93.1l-55 55z'
      
    ]
  };

  

  
  

  var faSquareW = {
    prefix: 'fasr',
    iconName: 'square-w',
    icon: [
      448,
      512,
      [],
      'e285',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM377.5 144L311.1 374.6l-5 17.4H270.5l-5.3-16.7L224 246.7 182.9 375.3 177.5 392H141.9l-5-17.4L70.5 144h50l40.7 141.5 39.9-124.8 5.3-16.7h35l5.3 16.7 39.9 124.8L327.5 144h50z'
      
    ]
  };

  

  
  

  var faTruckArrowRight = {
    prefix: 'fasr',
    iconName: 'truck-arrow-right',
    icon: [
      640,
      512,
      [],
      'e58b',
      
      'M48 48V368H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h48V48H48zM480 512c-53 0-96-43-96-96h-8-8H320 256c0 53-43 96-96 96s-96-43-96-96H48 0V368 48 0H48 368h48V48 96h56 9.9l7 7L601 215l7 7V232 368h8 24v48H616 576c0 53-43 96-96 96zM416 240H558.1l-96-96H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM241 95l80 80 17 17-17 17-80 80-17 17L190.1 272l17-17 39-39H112 88V168h24H246.1l-39-39-17-17L224 78.1l17 17z'
      
    ]
  };

  

  
  

  var faDiagramSuccessor = {
    prefix: 'fasr',
    iconName: 'diagram-successor',
    icon: [
      512,
      512,
      [],
      'e47a',
      
      'M369 119l-17-17L318.1 136l17 17 64 64 17 17 17-17 64-64 17-17L480 102.1l-17 17-23 23L440 56l0-24-24 0L288 32l-48 0-32 0L48 32 0 32 0 80l0 96 0 48 48 0 192 0 48 0 0-48 0-96 104 0 0 62.1-23-23zM512 288L0 288 0 480l512 0 0-192zM240 176L48 176l0-96 160 0 32 0 0 96z'
      
    ]
  };

  

  
  

  var faCartFlatbedBoxes = {
    prefix: 'fasr',
    iconName: 'cart-flatbed-boxes',
    icon: [
      640,
      512,
      ["dolly-flatbed-alt"],
      'f475',
      
      'M24 0H0V48H24 80V440v24h24 56c0 26.5 21.5 48 48 48s48-21.5 48-48H448c0 26.5 21.5 48 48 48s48-21.5 48-48h72 24V416H616 496 208 128V24 0H104 24zM240 80H368V304H240V80zM192 32V80 304v48h48H368h48V304 80 32H368 240 192zM496 80h64v64H496V80zM448 32V80v64 48h48 64 48V144 80 32H560 496 448zM592 272v32H496V272h96zm-96-48H448v48 32 48h48 96 48V304 272 224H592 496z'
      
    ]
  };

  
    var faDollyFlatbedAlt = faCartFlatbedBoxes;
  

  
  

  var faAngleLeft = {
    prefix: 'fasr',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      'M30.1 256l17-17L207 79l17-17L257.9 96l-17 17L97.9 256 241 399l17 17L224 449.9l-17-17L47 273l-17-17z'
      
    ]
  };

  

  
  

  var faBuildings = {
    prefix: 'fasr',
    iconName: 'buildings',
    icon: [
      512,
      512,
      [],
      'e0cc',
      
      'M464 48V464H272V48H464zM272 0H224V48 464v48h48H464h48V464 48 0H464 272zM192 128H24 0v24V488v24H24 192V464H48V176H192V128zM160 320H96v64h64V320zm176 32h64V288H336v64zM160 224H96v64h64V224zM336 96v64h64V96H336zm64 160V192H336v64h64z'
      
    ]
  };

  

  
  

  var faHouseCircleCheck = {
    prefix: 'fasr',
    iconName: 'house-circle-check',
    icon: [
      640,
      512,
      [],
      'e509',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 394.8c-18.3-12.9-34.1-29.2-46.3-48H336v0H240V320h86.6c4.9-17.2 12.3-33.4 21.8-48H216 192v24V464H112V212.8L288 63.5 447.5 198.8c15.4-4.4 31.7-6.8 48.5-6.8c6.4 0 12.7 .3 18.8 1L303.5 13.7zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faSwordLaser = {
    prefix: 'fasr',
    iconName: 'sword-laser',
    icon: [
      512,
      512,
      [],
      'e03b',
      
      'M480 0L230 226.2 285.8 282 512 32 480 0zM185 231l-17-17L134.1 248l17 17L0 416v48l32 32 16 16H96L247 361l17 17L297.9 344l-17-17-96-96zm0 67.9L213.1 327l-12.7 12.7-28.1-28.1L185 298.9zm-35.3 35.3l28.1 28.1-12.4 12.4-28.1-28.1 12.4-12.4zm-6.9 63.2L76.1 464H67.9l-1.9-1.9L48 444.1v-8.2l66.6-66.6 28.1 28.1z'
      
    ]
  };

  

  
  

  var faTomato = {
    prefix: 'fasr',
    iconName: 'tomato',
    icon: [
      512,
      512,
      [],
      'e330',
      
      'M235.4 1.4L250.6 20 232 35.2C250.6 20 250.6 20 250.6 20l0 0 0 0 .1 .1 .1 .2 .4 .5c.3 .4 .8 1 1.3 1.7c1.1 1.4 2.5 3.4 4.3 6c3.4 5 8 12.2 12.5 21c4.5 8.8 9.3 19.5 12.8 31.7C364.9 88.5 424.5 128 424.5 128L368 144l16 48L256 144h0L128 192l16-48L87.5 128s60.3-39.9 143.7-46.9c-1.4-3.3-2.9-6.5-4.5-9.6c-3.5-6.7-6.9-12.2-9.5-15.9c-1.3-1.9-2.3-3.3-3-4.2c-.3-.4-.6-.8-.7-.9l-.1-.2L198.2 31.8 235.4 1.4zM0 304c0-62.4 26.1-112.6 68.7-148.1l10.1 2.9 24.3 6.9-5.4 16.2-5.9 17.8C64.2 225.7 48 260.4 48 304c0 49.8 21.1 88 56.2 115c36.2 27.9 89.2 45 151.8 45s115.5-17.1 151.8-45c35.1-27 56.2-65.2 56.2-115c0-43.6-16.2-78.3-43.7-104.3l-5.9-17.8L409 165.7l24.3-6.9 10.1-2.8C485.9 191.4 512 241.6 512 304c0 130.9-114.6 208-256 208S0 434.9 0 304z'
      
    ]
  };

  

  
  

  var faBatteryThreeQuarters = {
    prefix: 'fasr',
    iconName: 'battery-three-quarters',
    icon: [
      576,
      512,
      ["battery-4"],
      'f241',
      
      'M496 144V368H48V144H496zM48 96H0v48V368v48H48 496h48V368 320h32V192H544V144 96H496 48zm304 96H96V320H352V192z'
      
    ]
  };

  
    var faBattery4 = faBatteryThreeQuarters;
  

  
  

  var faCheck = {
    prefix: 'fasr',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      'M448 130L431 147 177.5 399.2l-16.9 16.9-16.9-16.9L17 273.1 0 256.2l33.9-34 17 16.9L160.6 348.3 397.1 112.9l17-16.9L448 130z'
      
    ]
  };

  

  
  

  var faIceSkate = {
    prefix: 'fasr',
    iconName: 'ice-skate',
    icon: [
      576,
      512,
      [9976],
      'f7ac',
      
      'M320 0V24 128v32 22l174.7 51 17.3 5v18V360v24H488 56 32V360 112 93.7l17.6-4.9L272 27.5V24 0h48zM272 128V77.3l-192 53V336H464V274L292.6 224H240 224V192h16 32V160H240 224V128h16 32zM576 408v24 56 24H552 408 120 24 0V464H24 96V440 416h48v24 24H384V440 416h48v24 24h96V432 408h48z'
      
    ]
  };

  

  
  

  var faUserPlus = {
    prefix: 'fasr',
    iconName: 'user-plus',
    icon: [
      640,
      512,
      [],
      'f234',
      
      'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM99.5 352H348.5L383 464H65L99.5 352zM384 304H64L14.8 464 0 512H50.2 397.8 448l-14.8-48L384 304zm120 32h48V312 248h64 24V200H616 552V136 112H504v24 64H440 416v48h24 64v64 24z'
      
    ]
  };

  

  
  

  var faBook = {
    prefix: 'fasr',
    iconName: 'book',
    icon: [
      448,
      512,
      [128212],
      'f02d',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zM152 112H328h24v48H328 152 128V112h24zm0 80H328h24v48H328 152 128V192h24z'
      
    ]
  };

  

  
  

  var faTurkey = {
    prefix: 'fasr',
    iconName: 'turkey',
    icon: [
      640,
      512,
      [],
      'f725',
      
      'M584 56c0 5.6-.8 11-2.3 16c.8 0 1.6 0 2.3 0c30.9 0 56 25.1 56 56s-25.1 56-56 56c-20.3 0-38-10.8-47.9-26.9l-47.6 33.6c-30 21.2-46.5 55.8-63 90.3c-8.7 18.2-17.3 36.4-28 52.5c-6.2 9.4-13.9 18.1-23.2 25.6c-48.1 38.9-118.6 31.5-157.5-16.6s-31.5-118.6 16.6-157.5c24-19.5 53.7-27.3 82.2-24.3c15 1.6 30.7 3 45.8 2.1C334.3 150.4 308.5 144 288 144c-40.6 0-101.6 24.8-154 71.7C82.5 262 48 322 48 384v80H288 528V384c0-46.8-19.6-92.5-51.5-132c9-14.9 18.4-26.7 30.5-35.2l1.7-1.2C548.7 262.9 576 321 576 384v80 48H528 288 48 0V464 384C0 224 176 96 288 96c39.9 0 87.9 16.2 133.1 44.3L486.8 94C477.6 84 472 70.7 472 56c0-30.9 25.1-56 56-56s56 25.1 56 56z'
      
    ]
  };

  

  
  

  var faClipboardListCheck = {
    prefix: 'fasr',
    iconName: 'clipboard-list-check',
    icon: [
      384,
      512,
      [],
      'f737',
      
      'M336 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H80 48 0v48V464v48H48 336h48V464 112 64H336zM80 112v48H192 304V112h32V464H48V112H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm3.3 155.3L182.6 224 160 201.4l-11.3 11.3L112 249.4 99.3 236.7 88 225.4 65.4 248l11.3 11.3 24 24L112 294.6l11.3-11.3 48-48zM192 256v32h16 80 16V256H288 208 192zm-16 96H160v32h16H288h16V352H288 176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRectangle = {
    prefix: 'fasr',
    iconName: 'rectangle',
    icon: [
      512,
      512,
      [9644,"rectangle-landscape"],
      'f2fa',
      
      'M464 112V400H48V112H464zM48 64H0v48V400v48H48 464h48V400 112 64H464 48z'
      
    ]
  };

  
    var faRectangleLandscape = faRectangle;
  

  
  

  var faCommentSms = {
    prefix: 'fasr',
    iconName: 'comment-sms',
    icon: [
      512,
      512,
      ["sms"],
      'f7cd',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM152 176H132.8C112.5 176 96 192.5 96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8H112 96v32h16 27.2c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8H152h16V176h-8v0h-8zm40 16v96 16h32V288 240l19.2 25.6L256 282.7l12.8-17.1L288 240v48 16h32V288 192 176H296l-4.8 6.4L256 229.3l-35.2-46.9L216 176H192v16zm144 20.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8H352 336v32h16 27.2c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8H392h16V176H392h-8v0H372.7c-20.3 .1-36.7 16.6-36.7 36.8z'
      
    ]
  };

  
    var faSms = faCommentSms;
  

  
  

  var faBasketShoppingMinus = {
    prefix: 'fasr',
    iconName: 'basket-shopping-minus',
    icon: [
      576,
      512,
      [],
      'e652',
      
      'M245.3 51.1l11.1-21.3L213.8 7.6 202.7 28.9 117.6 192H81.5 32 0v48H44l68 272H464l68-272h44V192H544 494.5 458.4L373.3 28.9 362.2 7.6 319.6 29.8l11.1 21.3L404.2 192H171.8L245.3 51.1zM93.5 240h389l-56 224h-277l-56-224zM224 328H200v48h24H352h24V328H352 224z'
      
    ]
  };

  

  
  

  var faTableList = {
    prefix: 'fasr',
    iconName: 'table-list',
    icon: [
      512,
      512,
      ["th-list"],
      'f00b',
      
      'M192 80v88H464V80H192zm-48 0H48v88h96V80zM48 216v80h96V216H48zm0 128v88h96V344H48zm144 88H464V344H192v88zM464 296V216H192v80H464zM0 32H48 464h48V80 432v48H464 48 0V432 80 32z'
      
    ]
  };

  
    var faThList = faTableList;
  

  
  

  var faHandBackPointDown = {
    prefix: 'fasr',
    iconName: 'hand-back-point-down',
    icon: [
      448,
      512,
      [],
      'e19e',
      
      'M104 512l-24 0 0-24 0-227.2-56.1-51L16 202.6 16 192l0-38.5C16 99.5 44.7 49.5 91.4 22.2L94 20.7C117.3 7.1 143.7 0 170.6 0L296 0c66.3 0 120 53.7 120 120l0 8 0 96 0 40 0 24-24 0-40 0 0 8 0 24-24 0-48 0 0 8 0 24-24 0-48 0 0 136 0 24-24 0-80 0zM232 272l24 0 48 0 0-8 0-24 24 0 40 0 0-16 0-96 0-8c0-39.8-32.2-72-72-72L170.6 48c-18.4 0-36.5 4.9-52.4 14.2l-11.7-20 11.7 20-2.6 1.5C83.6 82.3 64 116.5 64 153.5l0 27.9 32 29.1L96 168l0-16 32 0 0 16 0 71.6 0 8.4 0 2.2 0 13.8 0 200 32 0 0-136 0-24 24 0 48 0 0-8 0-24z'
      
    ]
  };

  

  
  

  var faH5 = {
    prefix: 'fasr',
    iconName: 'h5',
    icon: [
      640,
      512,
      [],
      'e412',
      
      'M48 88V64H0V88 248 424v24H48V424 272H272V424v24h48V424 248 88 64H272V88 224H48V88zM440 64H419.3l-3.1 20.4-24 160L388.1 272H416 528c35.3 0 64 28.7 64 64s-28.7 64-64 64H466.2c-14.3 0-26.8-9.5-30.8-23.2l-4.4-15.4-46.2 13.2 4.4 15.4c9.8 34.3 41.2 58 76.9 58H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H443.9l16.8-112H584h24V64H584 440z'
      
    ]
  };

  

  
  

  var fa4 = {
    prefix: 'fasr',
    iconName: '4',
    icon: [
      384,
      512,
      [],
      '34',
      
      'M152.8 32h53l-.1 .2L77.8 304H272V152 128h48v24V304h40 24v48H360 320V456v24H272V456 352H40 2.2l16.1-34.2L152.8 32z'
      
    ]
  };

  

  
  

  var faSoftServe = {
    prefix: 'fasr',
    iconName: 'soft-serve',
    icon: [
      384,
      512,
      [127846,"creemee"],
      'e400',
      
      'M192 0H147.2L172 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7H140c-42 0-76 34-76 76v20C26.4 175.7 0 212.7 0 256v56 24H24 48v48H81.8L96 512H288l14.2-128H336V336h24 24V312 256c0-44.5-28-82.5-67.3-97.3c2.1-7.2 3.3-14.8 3.3-22.7v-8C320 57.3 262.7 0 192 0zM336 288H48V256c0-27.3 19.5-50 45.3-55l5.3-1H112h24V152H112V140c0-15.5 12.5-28 28-28h37.3c29.7 0 53.9-23.7 54.7-53.3c23.9 13.8 40 39.7 40 69.3v8c0 5.8-1.5 11.3-4.3 16H216 192v48h24 4.4 58.8 .8c30.9 0 56 25.1 56 56v32z'
      
    ]
  };

  
    var faCreemee = faSoftServe;
  

  
  

  var faFaceViewfinder = {
    prefix: 'fasr',
    iconName: 'face-viewfinder',
    icon: [
      512,
      512,
      [],
      'e2ff',
      
      'M0 0V24 136v24H48V136 48h88 24V0H136 24 0zM352 0V48h24 88v88 24h48V136 24 0H488 376 352zM48 352H0v24V488v24H24 136h24V464H136 48V376 352zm464 0H464v24 88H376 352v48h24H488h24V488 376 352zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-112c-21.6 0-39.8-14.2-45.9-33.8l-30.6 9.4C189.6 312.2 220 336 256 336s66.4-23.8 76.5-56.4l-30.6-9.4c-6 19.6-24.3 33.8-45.9 33.8z'
      
    ]
  };

  

  
  

  var faGripDotsVertical = {
    prefix: 'fasr',
    iconName: 'grip-dots-vertical',
    icon: [
      256,
      512,
      [],
      'e411',
      
      'M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faSpinnerScale = {
    prefix: 'fasr',
    iconName: 'spinner-scale',
    icon: [
      512,
      512,
      [],
      'e62a',
      
      'M244 52h24V64c0 6.6-5.4 12-12 12s-12-5.4-12-12V52zM204 12V52 64c0 28.7 23.3 52 52 52s52-23.3 52-52V52 12H268 244 204zm20 436v32h32 32V448c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256V224H448c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V256zM64 220H28v36 36H64c19.9 0 36-16.1 36-36s-16.1-36-36-36zM391.8 97.6l22.6 22.6-11.3 11.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l11.3-11.3zM420 69.3L391.8 41 363.5 69.3 352.2 80.6c-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0l11.3-11.3L471 120.2 442.7 92 420 69.3zM97.6 369.1L75 391.8l22.6 22.6L120.2 437l22.6-22.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0zm316.8 45.3L437 391.8l-22.6-22.6c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L391.8 437l22.6-22.6zM114.6 125.9l-5.7-5.7 11.3-11.3 5.7 5.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0zm39.6-39.6l-5.7-5.7L120.2 52.4 92 80.6 80.6 92 52.4 120.2l28.3 28.3 5.7 5.7c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9z'
      
    ]
  };

  

  
  

  var faM = {
    prefix: 'fasr',
    iconName: 'm',
    icon: [
      448,
      512,
      [109],
      '4d',
      
      'M0 32V56 456v24H48V456 136.1l156 237 20 30.5 20-30.5 156-237V456v24h48V456 56 32H411.1l-7.1 10.8L224 316.3 44 42.8 36.9 32H0z'
      
    ]
  };

  

  
  

  var faDesktop = {
    prefix: 'fasr',
    iconName: 'desktop',
    icon: [
      576,
      512,
      [61704,128421,"desktop-alt"],
      'f390',
      
      'M528 48H48V256H528V48zm48 208v48 64 48H528 364.3l8 48H424h24v48H424 352 224 152 128V464h24 51.7l8-48H48 0V368 304 256 48 0H48 528h48V48 256zM48 304v64H528V304H48zM260.3 416l-8 48h71.3l-8-48H260.3z'
      
    ]
  };

  
    var faDesktopAlt = faDesktop;
  

  
  

  var faDiceD8 = {
    prefix: 'fasr',
    iconName: 'dice-d8',
    icon: [
      512,
      512,
      [],
      'f6d2',
      
      'M232 488l24 24 24-24 9.9-9.9L473.3 294.7l4.7-4.7L512 256l-18.9-18.9-15.1-15.1L289.9 33.9 280 24 256 0 232 24l-9.9 9.9L33.9 222.1 18.9 237.1 0 256l33.9 33.9 4.7 4.7L222.1 478.1 232 488zm0-67.9l-89.9-89.9L232 361.1v59zM69.4 254.5L232 91.9V310.4L69.4 254.5zM280 91.9L442.6 254.5 280 310.4V91.9zm0 269.2l89.9-30.9L280 420.1v-59z'
      
    ]
  };

  

  
  

  var faShower = {
    prefix: 'fasr',
    iconName: 'shower',
    icon: [
      512,
      512,
      [128703],
      'f2cc',
      
      'M24 32H0V56 456v24H48V456 80h62.1l19.6 19.6c-27.8 43.4-22.8 101.7 15.1 139.6l7 7-.8 .8-17 17L168 297.9l17-17L345 121l17-17L328 70.1 311 87l-.8 .8L303.4 81l-.2-.2c-37.9-37.9-96.2-43-139.6-15.1L137 39l-7-7H120 24zm245.5 83l6.8 6.8-90.5 90.5-7-7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l.2 .2 0 0zM416 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faDoNotEnter = {
    prefix: 'fasr',
    iconName: 'do-not-enter',
    icon: [
      512,
      512,
      [],
      'f5ec',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm416-48v96H96V208H416z'
      
    ]
  };

  

  
  

  var faGaugeSimpleHigh = {
    prefix: 'fasr',
    iconName: 'gauge-simple-high',
    icon: [
      512,
      512,
      [61668,"tachometer","tachometer-fast"],
      'f62a',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-14-5.1-26.8-13.7-36.6L366 161.7l9.7-22-43.9-19.3-9.7 22L254.4 296c-30.2 .8-54.4 25.6-54.4 56c0 30.9 25.1 56 56 56s56-25.1 56-56z'
      
    ]
  };

  
    var faTachometer = faGaugeSimpleHigh;
  
    var faTachometerFast = faGaugeSimpleHigh;
  

  
  

  var faArrowDownBigSmall = {
    prefix: 'fasr',
    iconName: 'arrow-down-big-small',
    icon: [
      576,
      512,
      ["sort-size-down"],
      'f88c',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM432 432V368H368v64h64zm-64 48H320V432 368 320h48 64 48v48 64 48H432 368zm0-272H496V80H368V208zm-48 48V208 80 32h48H496h48V80 208v48H496 368 320z'
      
    ]
  };

  
    var faSortSizeDown = faArrowDownBigSmall;
  

  
  

  var faCalendarLines = {
    prefix: 'fasr',
    iconName: 'calendar-lines',
    icon: [
      448,
      512,
      ["calendar-note"],
      'e0d5',
      
      'M152 24l0-24L104 0l0 24 0 40L0 64l0 80 0 48L0 464l0 48 48 0 352 0 48 0 0-48 0-272 0-48 0-80L344 64l0-40 0-24L296 0l0 24 0 40L152 64l0-40zM48 192l352 0 0 272L48 464l0-272zm48 64l0 48 256 0 0-48L96 256zm160 96L96 352l0 48 160 0 0-48z'
      
    ]
  };

  
    var faCalendarNote = faCalendarLines;
  

  
  

  var faScaleBalanced = {
    prefix: 'fasr',
    iconName: 'scale-balanced',
    icon: [
      640,
      512,
      [9878,"balance-scale"],
      'f24e',
      
      'M520 48H393.3C381 19.7 352.8 0 320 0s-61 19.7-73.3 48H120 96V96h24H241.6c5.8 28.6 26.9 51.7 54.4 60.3V464H120 96v48h24H320 520h24V464H520 344V156.3c27.5-8.6 48.6-31.7 54.4-60.3H520h24V48H520zM97.5 128l-6.7 12.9-88 168L0 314.1V320v32 9.9l7 7 40 40 7 7H64 192h9.9l7-7 40-40 7-7 0-9.9 0-32v-5.9l-2.7-5.2-88-168L158.5 128H144 112 97.5zm29 48h3l75.4 144H51.1l75.4-144zM496 128H481.5l-6.7 12.9-88 168-2.7 5.2V320v32 9.9l7 7 40 40 7 7H448 576h9.9l7-7 40-40 7-7V352 320v-5.9l-2.7-5.2-88-168L542.5 128H528 496zM435.1 320l75.4-144h3l75.4 144H435.1zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faBalanceScale = faScaleBalanced;
  

  
  

  var faDrawPolygon = {
    prefix: 'fasr',
    iconName: 'draw-polygon',
    icon: [
      448,
      512,
      [],
      'f5ee',
      
      'M80 96A16 16 0 1 0 48 96a16 16 0 1 0 32 0zm8 59.3V356.7c16 6.5 28.9 19.3 35.3 35.3H324.7c2.1-5.2 4.9-10.1 8.2-14.5L298 319.2c-3.2 .5-6.6 .8-10 .8c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.7 .3 10 .8l34.9-58.2c-3.3-4.4-6.1-9.3-8.2-14.5H123.3c-6.5 16-19.3 28.9-35.3 35.3zM374.1 352.8c3.2-.5 6.6-.8 9.9-.8c35.3 0 64 28.7 64 64s-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40H123.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V155.3C16.5 145.9 0 122.9 0 96C0 60.7 28.7 32 64 32c26.9 0 49.9 16.5 59.3 40H324.7c9.5-23.5 32.5-40 59.3-40c35.3 0 64 28.7 64 64s-28.7 64-64 64c-3.4 0-6.7-.3-9.9-.8l-34.9 58.2c8.1 10.7 12.9 24.1 12.9 38.5s-4.8 27.8-12.9 38.5l34.9 58.2zM400 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm336-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faFaceMonocle = {
    prefix: 'fasr',
    iconName: 'face-monocle',
    icon: [
      512,
      512,
      [],
      'e380',
      
      'M448 336.1V224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v83.5c0 1 0 2 0 3C377.9 434.8 320.4 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c16.7 0 32.9 2 48.4 5.7c-6.9 2.8-13.3 6.6-19.2 11.2L262 83.5l-12.5 10 20 25 12.5-10 23.2-18.6c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7 13.3 8.9 5.7-8.5C433.6 131.8 464 190.4 464 256c0 28.4-5.7 55.5-16 80.1zm5.7 82.5C490.1 374.4 512 317.7 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c67.1 0 128.2-25.8 173.9-68.1c10.4 20.4 26.2 38 46.3 50.6l11.4 7.1 17-27.1-11.4-7.1c-18.5-11.5-32.2-28.8-39.4-48.7zM256 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm-79.6-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 336v32h16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4l7.2 14.3 28.6-14.3-7.2-14.3c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336H144z'
      
    ]
  };

  

  
  

  var faRss = {
    prefix: 'fasr',
    iconName: 'rss',
    icon: [
      448,
      512,
      ["feed"],
      'f09e',
      
      'M448 480C448 232.6 247.4 32 0 32V80c220.9 0 400 179.1 400 400h48zm-144 0C304 312.1 167.9 176 0 176v48c141.4 0 256 114.6 256 256h48zM48 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faFeed = faRss;
  

  
  

  var faArrowTrendDown = {
    prefix: 'fasr',
    iconName: 'arrow-trend-down',
    icon: [
      576,
      512,
      [],
      'e097',
      
      'M352 416h24H552h24V392 216 192H528v24V334.1L337 143l-17-17-17 17-111 111L52.2 114.2l-17-17L1.3 131.2l17 17L175 305l17 17 17-17 111-111L494.1 368H376 352v48z'
      
    ]
  };

  

  
  

  var faCookieBite = {
    prefix: 'fasr',
    iconName: 'cookie-bite',
    icon: [
      512,
      512,
      [],
      'f564',
      
      'M118 121.7L218.5 68c19 52.5 62.4 93.4 116.4 109.1c15.4 53.2 55.2 95.9 106.5 115.5L394 390.3l-104.7 56L172 429.7 86.6 346.8 66 229.1 118 121.7zM489.9 255.2c-61.5-6.7-109.9-57.1-113.7-119.5C313.8 132 263.5 83.6 256.8 22.1L213.9 16 81.7 86.7 16 222.1 42 370.4 149.8 475l148.3 21 132.3-70.7L496 289.9l-6.1-34.7zM160 224l32-32-32-32-32 32 32 32zm96 32l32 32 32-32-32-32-32 32zm-96 96l32 32 32-32-32-32-32 32zm160 0l32 32 32-32-32-32-32 32z'
      
    ]
  };

  

  
  

  var faPeopleSimple = {
    prefix: 'fasr',
    iconName: 'people-simple',
    icon: [
      512,
      512,
      [],
      'e21b',
      
      'M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM78 208H178l4 96H144 112 74l4-96zM24 352H64V488v24h48V488 352h32V488v24h48V488 352h40l-2-48-6-144H32L26 304l-2 48zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM356.2 208h55.6l36.6 128H319.6l36.6-128zM448 160H320L269.7 336 256 384h49.9H320V488v24h48V488 384h32V488v24h48V488 384h14.1H512l-13.7-48L448 160z'
      
    ]
  };

  

  
  

  var faFaceAngry = {
    prefix: 'fasr',
    iconName: 'face-angry',
    icon: [
      512,
      512,
      [128544,"angry"],
      'f556',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm54.8-102.1l35.1-32.7-16.4-17.5C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6l-16.4 17.5 35.1 32.7 16.4-17.5c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4l16.4 17.5zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z'
      
    ]
  };

  
    var faAngry = faFaceAngry;
  

  
  

  var faFunction = {
    prefix: 'fasr',
    iconName: 'function',
    icon: [
      640,
      512,
      [],
      'f661',
      
      'M72 0H96 200h24V48H200 120V192h48 24v48H168 120V456v24H96 24 0V432H24 72V240H24 0V192H24 72V24 0zM272 320c0 57.5 16.4 110.9 44.3 155.2l-40.6 25.6C243 448.9 224 386.7 224 320s19-128.9 51.7-180.8l40.6 25.6C288.4 209.1 272 262.5 272 320zm320 0c0-57.5-16.4-110.9-44.3-155.2l40.6-25.6C621 191.1 640 253.3 640 320s-19 128.9-51.7 180.8l-40.6-25.6C575.6 430.9 592 377.5 592 320zM393 247l39 39 39-39 17-17L521.9 264l-17 17-39 39 39 39 17 17L488 409.9l-17-17-39-39-39 39-17 17L342.1 376l17-17 39-39-39-39-17-17L376 230.1l17 17z'
      
    ]
  };

  

  
  

  var faBorderAll = {
    prefix: 'fasr',
    iconName: 'border-all',
    icon: [
      448,
      512,
      [],
      'f84c',
      
      'M400 80V232H248V80H400zm0 200V432H248V280H400zM200 232H48V80H200V232zM48 280H200V432H48V280zM48 32H0V80 432v48H48 400h48V432 80 32H400 48z'
      
    ]
  };

  

  
  

  var faAnchor = {
    prefix: 'fasr',
    iconName: 'anchor',
    icon: [
      576,
      512,
      [9875],
      'f13d',
      
      'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216 192v48h24 48V464H120V352h72L96 256 0 352H72V488v24H96 288 480h24V488 352h72l-96-96-96 96h72V464H312V240h48 24V192H360 312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80z'
      
    ]
  };

  

  
  

  var faCircleQuarter = {
    prefix: 'fasr',
    iconName: 'circle-quarter',
    icon: [
      512,
      512,
      [],
      'e11f',
      
      'M53.6 208C71.6 131.7 131.7 71.6 208 53.6V208H53.6zM4.5 208C1.5 223.5 0 239.6 0 256H48 208h48V208 48 0c-16.4 0-32.5 1.5-48 4.5C105.1 24 24 105.1 4.5 208z'
      
    ]
  };

  

  
  

  var faBookQuran = {
    prefix: 'fasr',
    iconName: 'book-quran',
    icon: [
      448,
      512,
      ["quran"],
      'f687',
      
      'M360 0c48.6 0 88 39.4 88 88V424h-.4c.3 2.6 .4 5.3 .4 8c0 44.2-35.8 80-80 80H24 0V464H24h8V400H24 0V376 24 0H24 360zM80 400v64H368c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zm288-48c11.4 0 22.2 2.4 32 6.7V88c0-22.1-17.9-40-40-40H48V352H368zM288 144l14.8 35.6 38.4 3.1L312 207.8l8.9 37.5L288 225.2l-32.9 20.1 8.9-37.5-29.3-25.1 38.4-3.1L288 144zM184 200c0 48.4 39.1 87.7 87.5 88c-16.1 10.1-35.1 16-55.5 16c-57.4 0-104-46.6-104-104s46.6-104 104-104c20.4 0 39.4 5.9 55.5 16c-48.3 .3-87.5 39.6-87.5 88z'
      
    ]
  };

  
    var faQuran = faBookQuran;
  

  
  

  var faDeleteRight = {
    prefix: 'fasr',
    iconName: 'delete-right',
    icon: [
      576,
      512,
      [],
      'e154',
      
      'M0 448H48 400L576 256 400 64H48 0v48V400v48zM510.9 256l-132 144H48V112H378.9l132 144zM321.9 192L288 158.1l-17 17-47 47-47-47-17-17L126.1 192l17 17 47 47-47 47-17 17L160 353.9l17-17 47-47 47 47 17 17L321.9 320l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  

  
  

  var faFileCirclePlus = {
    prefix: 'fasr',
    iconName: 'file-circle-plus',
    icon: [
      576,
      512,
      [58606],
      'e494',
      
      'M48 464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 48 0H48 256L384 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48V464zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  

  
  

  var faTornado = {
    prefix: 'fasr',
    iconName: 'tornado',
    icon: [
      448,
      512,
      [127786],
      'f76f',
      
      'M0 45.6c0 .8 0 1.6 0 2.4c.8 89.8 48.7 172.7 126.2 218.2l116.4 68.5c19.2 11.3 34.7 27.9 44.6 47.8c9.2 18.4 13.3 38.8 11.9 59.1c-.3 3.8-.7 7.6-1.3 11.4L288 512l56.1-44.9 52.2-41.8C429 399.2 448 359.7 448 317.9c0-29.8-9.7-58.7-27.5-82.6l-55.6-74.2C356.5 150 352 136.5 352 122.6c0-17 6.8-33.4 18.8-45.4L400 48l16-16V0H384h-3.9H368 48 0V45.6zM330.2 361c-11.2-22.5-27.5-42-47.3-57H398.9c.7 4.6 1.1 9.2 1.1 13.9c0 27.2-12.4 53-33.6 70l-21.6 17.2c-2.7-15.2-7.6-30.1-14.6-44zM203.5 256l-52.9-31.1c-22-12.9-41.1-29.6-56.6-48.9H317.5c2.6 4.8 5.6 9.5 8.9 13.9L376 256H203.5zM65 128C54.3 103.1 48.3 76 48 48H332.4C314.2 68.5 304 95 304 122.6c0 1.8 0 3.6 .1 5.4H65z'
      
    ]
  };

  

  
  

  var faFireFlameCurved = {
    prefix: 'fasr',
    iconName: 'fire-flame-curved',
    icon: [
      384,
      512,
      ["fire-alt"],
      'f7e4',
      
      'M72 192.1C26.9 224.4 0 276.5 0 332.2C0 431.5 80.5 512 179.8 512h21.8C302.3 512 384 430.3 384 329.5c0-67.2-28.4-131.3-78.1-176.5L223.7 78.3c-5.3-4.8-9.4-10.8-12.1-17.3c-2.4-5.7-3.6-11.9-3.6-18.3V0L178.9 25.9C173 31.1 167.8 36.7 163 42.8c-1 1.3-2 2.6-3 3.9c-9.2 12.7-15.9 27-19.9 42.1c-2.8 10.5-4.2 21.4-4.2 32.5c0 13.2 2 26.2 6 38.7c3.6 11.3 8.8 22.2 15.5 32.2L168 208l22.7 34.1c6.1 9.1 9.3 19.7 9.3 30.7V288c0 22.1-17.9 40-40 40s-40-17.9-40-40V222.5v-4.8-.6V160L96.6 175.6 76.7 188.9c-1.6 1.1-3.2 2.2-4.7 3.3zm0 66.7V288c0 48.6 39.4 88 88 88s88-39.4 88-88V272.7c0-20.4-6-40.3-17.3-57.3l-33.3-49.9c-8.7-13.1-13.4-28.5-13.4-44.2c0-4.6 .4-9.2 1.2-13.7c2 2.2 4 4.2 6.2 6.2l82.2 74.7c39.7 36.1 62.4 87.3 62.4 141C336 403.8 275.8 464 201.5 464H179.8C107 464 48 405 48 332.2c0-26.8 8.6-52.4 24-73.4z'
      
    ]
  };

  
    var faFireAlt = faFireFlameCurved;
  

  
  

  var faArrowUpZA = {
    prefix: 'fasr',
    iconName: 'arrow-up-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-up-alt"],
      'f882',
      
      'M328 32V80h24 78.1l-95 95-7 7V192v8 24h24H480h24V176H480 401.9l95-95 7-7V64 56 32H480 352 328zM160 33.3l-17 17-96 96-17 17L64 197.1l17-17 55-55V456v24h48V456 125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM400.6 272l-6.4 14L304.9 480h52.8l14.7-32H456c1.2 0 2.3-.1 3.4-.2L474.2 480h52.8L437.8 286l-6.4-14H400.6zM416 353.4L437.4 400H394.6L416 353.4z'
      
    ]
  };

  
    var faSortAlphaUpAlt = faArrowUpZA;
  

  
  

  var faPersonWalkingArrowLoopLeft = {
    prefix: 'fasr',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
      640,
      512,
      [],
      'e551',
      
      'M256 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM82.6 201.5l36.3-18.2-22.7 68c-7.4 22.1-.3 46.5 17.8 61.2l104.6 85 22.1 88.2 5.8 23.3 46.6-11.6-5.8-23.3-24-96-1.9-7.8-6.2-5-54.4-44.2 25.7-82.3 6.4 23.4 1.7 6.1L239 273l40 40L313 279l-35.5-35.5-22.3-81.9-3.6-13.2-13.2-3.6-88-24-8.8-2.4-8.2 4.1-80 40-7.9 3.9-3.5 8.1-24 56L8.5 252.6l44.1 18.9 9.5-22.1 20.5-47.9zm59.2 65.1l30-90.1 22.1 6c-.3 .8-.6 1.5-.9 2.3L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zM75.5 402.5L18.2 459.8l-17 17 33.9 33.9 17-17L113 433l3.5-3.5 1.8-4.6 20.4-51.1-39-31.7L75.5 402.5zM447 449l17 17L497.9 432l-17-17-39-39H616h24V352 88 64H616L344 64H320v48h24l248 0V328H441.9l39-39 17-17L464 238.1l-17 17-80 80-17 17 17 17 80 80z'
      
    ]
  };

  

  
  

  var faClone = {
    prefix: 'fasr',
    iconName: 'clone',
    icon: [
      512,
      512,
      [],
      'f24d',
      
      'M48 464H304V384h48v80 48H304 48 0V464 208 160H48h80v48H48V464zM208 304H464V48H208V304zm-48 48V304 48 0h48H464h48V48 304v48H464 208 160z'
      
    ]
  };

  

  
  

  var faLinkSlash = {
    prefix: 'fasr',
    iconName: 'link-slash',
    icon: [
      640,
      512,
      ["chain-broken","chain-slash","unlink"],
      'f127',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-131-101.7 90.4-90.4c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4 31.6 36.1 6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6l-94.7 94.7-45.8-35.6c24-53.2 13.9-117.6-29.4-160.9c-52.4-52.4-135.1-55.9-191.6-10.7L48.4 14.8zM224.5 151.5c36.9-22.8 86-18.2 118 13.9c25.9 25.9 34 63.2 23.8 96.2L224.5 151.5zM352.6 373.8c-20.2-2.7-39.7-11.7-55.2-27.3c-9.8-9.8-17-21.2-21.7-33.3l-54.2-42.7c-2.2 39.6 11.9 79.9 41.9 109.9c38.8 38.8 94.2 50.8 143.4 36l-54.2-42.7zm-236-186L59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4-31.6-36.1-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6l60.9-60.9-38-29.9z'
      
    ]
  };

  
    var faChainBroken = faLinkSlash;
  
    var faChainSlash = faLinkSlash;
  
    var faUnlink = faLinkSlash;
  

  
  

  var faPlugCircleExclamation = {
    prefix: 'fasr',
    iconName: 'plug-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e55d',
      
      'M120 24V0H72V24v88h48V24zm192 0V0H264V24v88h48V24zM24 144H0v48H24h8v64c0 80.2 59 146.6 136 158.2V512h48V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8 24V144H360h-8H304 80 32 24zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64H416V416h32v32zm0-176v16 80 16H416V368 288 272h32z'
      
    ]
  };

  

  
  

  var faHandHolding = {
    prefix: 'fasr',
    iconName: 'hand-holding',
    icon: [
      576,
      512,
      [],
      'f4bd',
      
      'M168 304h-7.3l-6 4-90 60H24 0v48H24 72h7.3l6-4 90-60H360v32H320 296 256 232v48h24 40 24 48 32 7l5.9-3.7 80.4-51 15 24L416.6 464H24 0v48H24 424h7.4l6.1-4.2 116.8-80 19-13-12.2-19.5-40-64-12.8-20.5-20.4 13L408 374.5V328 304H384 168z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueWink = {
    prefix: 'fasr',
    iconName: 'face-grin-tongue-wink',
    icon: [
      512,
      512,
      [128540,"grin-tongue-wink"],
      'f58b',
      
      'M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4V363.5c19.9-18 34.3-41.6 40.4-68.1c-39.3 14.9-86.2 23.5-136.5 23.5s-97.2-8.6-136.5-23.5c6.1 26.6 20.6 50.2 40.6 68.2V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.5 234.3l32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8c20-27.1 59.8-27.1 79.8 0zM336.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V352h48v24h32V352h48v64z'
      
    ]
  };

  
    var faGrinTongueWink = faFaceGrinTongueWink;
  

  
  

  var faCirclePlus = {
    prefix: 'fasr',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      ["plus-circle"],
      'f055',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 368h48V344 280h64 24V232H344 280V168 144H232v24 64H168 144v48h24 64v64 24z'
      
    ]
  };

  
    var faPlusCircle = faCirclePlus;
  

  
  

  var faShoePrints = {
    prefix: 'fasr',
    iconName: 'shoe-prints',
    icon: [
      640,
      512,
      [],
      'f54b',
      
      'M331.3 112l10.1 5.1 112.1 56.1L592 138.5V98.6L444.1 49.3 304 72.7V112h16 11.3zM304 160H256V112 32L448 0 640 64V176L448 224 320 160H304zM128 32h96V160H128V32zm75.3 368H192 176v39.3l140.1 23.4L464 413.4V373.5L325.6 338.9 213.5 394.9 203.3 400zM176 352h16l128-64 192 48V448L320 512 128 480V400 352h48zM0 480V352H96V480H0z'
      
    ]
  };

  

  
  

  var faDragon = {
    prefix: 'fasr',
    iconName: 'dragon',
    icon: [
      640,
      512,
      [128009],
      'f6d5',
      
      'M272 0h24H424h24 72 11l7.2 8.4 96 112 5.8 6.7V136v64 24H616 520h-9.9l-7-7-23-23V212l131.2 98.4 19.2 14.4L640 332v12 24 72 48 24H616 568 520 432 24 0V488 424 400H24 53.4l343-32.4-45.7-49.8-8.4-9.2-6.3-6.9v-9.3V280l0-8V248l0-92-49.7-22.1L272 127.6V112v-8V88.4l14.3-6.3 28-12.5L284.3 53 272 46.1V32 24 0zM424 48H374.2l5.4 3 42.1 23.4-44 19.5L346.1 108l23.7 10.5 14.3 6.3v15.6L384 248v24l0 8v3.1l2.1 2.3 78.3 85.4L497 406.4l-48.1 4.5-392.2 37-1.1 .1H54.5 48v16H432h88 48 24V440 368 356l-9.6-7.2L441.6 243.2 432 236V224 168 144h24 32 9.9l7 7 25 25H592V144.9L509 48H448 424zm94.7 39.7c-1.8 5.3-5.5 10.1-10.8 13.1c-11.5 6.6-26.2 2.7-32.8-8.8c-2.9-5-3.8-10.6-2.9-15.9l46.4 11.6zm1.3-8.1v.9c0-.3 0-.6 0-.9zM160 96l144 86.4V280v34.2l5.3 5.8H96l80-80L0 256 160 96z'
      
    ]
  };

  

  
  

  var faWifiWeak = {
    prefix: 'fasr',
    iconName: 'wifi-weak',
    icon: [
      640,
      512,
      ["wifi-1"],
      'f6aa',
      
      'M264 424a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z'
      
    ]
  };

  
    var faWifi1 = faWifiWeak;
  

  
  

  var faBorderBottom = {
    prefix: 'fasr',
    iconName: 'border-bottom',
    icon: [
      448,
      512,
      [],
      'f84d',
      
      'M448 480L0 480l0-48 448 0 0 48zm0-96l-64 0 0-64 64 0 0 64zM0 384l0-64 64 0 0 64L0 384zm256 0l-64 0 0-64 64 0 0 64zM384 192l0-64 64 0 0 64-64 0zM64 192L0 192l0-64 64 0 0 64zm128 0l0-64 64 0 0 64-64 0zm256 96l-64 0 0-64 64 0 0 64zM0 288l0-64 64 0 0 64L0 288zm256 0l-64 0 0-64 64 0 0 64zM384 96l0-64 64 0 0 64-64 0zM64 96L0 96 0 32l64 0 0 64zm128 0l0-64 64 0 0 64-64 0zM352 288l-64 0 0-64 64 0 0 64zM288 96l0-64 64 0 0 64-64 0zM160 96L96 96l0-64 64 0 0 64zM96 288l0-64 64 0 0 64-64 0z'
      
    ]
  };

  

  
  

  var faVolumeSlash = {
    prefix: 'fasr',
    iconName: 'volume-slash',
    icon: [
      640,
      512,
      [128263],
      'f2e2',
      
      'M48.4 14.8L29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7-95.1-73.8C557 351.3 576 305.9 576 256c0-62.8-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2c0 38.8-15.3 74-40.3 99.9l-38.2-29.7C468.3 308.7 480 283.7 480 256c0-31.4-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l5.9 7.9L352 250.5V80 32H304L195.2 128.7 48.4 14.8zM233.7 158.7L304 96.2v117l-70.3-54.6zM80 160H32v48 96 48H80h80L304 480h48V432 373.3l-48-37.8v80.3L191.9 316.1 178.2 304H160 80V208h62.1L81.2 160H80z'
      
    ]
  };

  

  
  

  var faSdCard = {
    prefix: 'fasr',
    iconName: 'sd-card',
    icon: [
      384,
      512,
      [],
      'f7c2',
      
      'M336 48V464H48V147.9L147.9 48H336zM128 0L0 128V464v48H48 336h48V464 48 0H336 128zm48 96V80H144V96v64 16h32V160 96zm64 0V80H208V96v64 16h32V160 96zm64 0V80H272V96v64 16h32V160 96z'
      
    ]
  };

  

  
  

  var faAmpGuitar = {
    prefix: 'fasr',
    iconName: 'amp-guitar',
    icon: [
      512,
      512,
      [],
      'f8a1',
      
      'M256 0c-48.9 0-92.5 28.8-121.6 53.8c-10.7 9.2-20 18.3-27.5 26.2H48 0v48 96 24 24V464v48H48 464h48V464 272 248 224 128 80H464 405.1c-7.5-7.9-16.8-17.1-27.5-26.2C348.5 28.8 304.9 0 256 0zm0 48c26.4 0 53.6 13.8 77.7 32H178.3c24.1-18.2 51.4-32 77.7-32zM464 272V464H48V272H464zm0-48H48V128H464v96zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 304v32h32V304H368zm-32 48v32h32V352H336zm64 48H368v32h32V400zM272 352v32h32V352H272zm64-16V304H304v32h32zm-32 96h32V400H304v32zm-64-80H208v32h32V352zm0-48v32h32V304H240zm32 96H240v32h32V400zM144 352v32h32V352H144zm64-48H176v32h32V304zm-32 96v32h32V400H176zm-64-48H80v32h32V352zm0-48v32h32V304H112zm32 96H112v32h32V400zm256-48v32h32V352H400z'
      
    ]
  };

  

  
  

  var faLighthouse = {
    prefix: 'fasr',
    iconName: 'lighthouse',
    icon: [
      640,
      512,
      [],
      'e612',
      
      'M416 160H368 272 224h-8H192v48h23.3L168.7 464 152 464H128v48h24H288h64H488h24V464H488l-16.7 0L424.7 208H448V160H424h-8zm0-32V101.7 96h16 16V64L416 48 320 0 224 48 192 64V96h16 16v5.7V128h48V96 77.7l48-24 48 24V96v32h48zm-48 80l7.9 0 46.5 256H352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H217.5l46.5-256 7.9 0h96zM33.5 1.9L14.6 46.1l112 48 22.1 9.5 18.9-44.1-22.1-9.5-112-48zM167.5 196.6l-18.9-44.1-22.1 9.5-112 48 18.9 44.1 112-48 22.1-9.5zm327-146.7l-22.1 9.5 18.9 44.1 22.1-9.5 112-48L606.6 1.9l-112 48zm0 156.1l112 48 18.9-44.1-112-48-22.1-9.5-18.9 44.1 22.1 9.5z'
      
    ]
  };

  

  
  

  var faBahai = {
    prefix: 'fasr',
    iconName: 'bahai',
    icon: [
      576,
      512,
      ["haykal"],
      'f666',
      
      'M318.8 109.3l-10-35.5L288 0 267.2 73.8l-10 35.5-11.4 40.6-34.9-23.6-31-21L115.7 61.8l32.6 70.4 15.1 32.6 17.8 38.5-42.2 4-36.6 3.5L24 218.1l71.2 33.4L128.1 267 166.6 285l-30 30.1-25.4 25.4L55.8 395.9l75.8-19.3 36.1-9.2 41-10.4-3.4 42.1-2.9 36.2L196.3 512l45.1-62.3 21.9-30.2L288 385.4l24.7 34.1 21.9 30.2L379.7 512l-6.1-76.7-2.9-36.2L367.3 357l41 10.4 36.1 9.2 75.8 19.3-55.3-55.4-25.4-25.4-30-30.1L447.9 267l32.8-15.4L552 218.1l-78.3-7.4L437 207.2l-42.2-4 17.8-38.5 15.1-32.6 32.6-70.4-64.2 43.5-31 21-34.9 23.6-11.4-40.6zm44.8 66.3l-5 10.8-23.8 51.3 56.3 5.3 11.4 1.1-10 4.7L340.9 273l40.2 40.3 7.9 7.9-11.9-3-54.2-13.8 4.5 55.8 1 12.8-8-11.1L288 317.2l-32.4 44.7-8 11.1 1-12.8 4.5-55.8-54.2 13.8-11.9 3 7.9-7.9L235.1 273l-51.5-24.2-10-4.7 11.4-1.1 56.3-5.3-23.8-51.3-5-10.8 10.9 7.4 45.9 31.1 15-53.4 3.7-13 3.7 13 15 53.4L352.6 183l10.9-7.4z'
      
    ]
  };

  
    var faHaykal = faBahai;
  

  
  

  var faUserDoctorMessage = {
    prefix: 'fasr',
    iconName: 'user-doctor-message',
    icon: [
      640,
      512,
      ["user-md-chat"],
      'f82e',
      
      'M304 128a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM224 0a128 128 0 1 0 0 256A128 128 0 1 0 224 0zM50.2 512L99.5 352H136v50.3c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V352H280v50c-27.6 7.1-48 32.2-48 62v32 16h16 24 16V480H272h-8V464c0-17.7 14.3-32 32-32s32 14.3 32 32v16h-8H304v32h16 24 16V496 464c0-29.8-20.4-54.9-48-62V352h36.5l49.2 160H448L384 304H64L0 512H50.2zM152 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM384 0V224h64v64l96-64h96V0H384z'
      
    ]
  };

  
    var faUserMdChat = faUserDoctorMessage;
  

  
  

  var faTrailer = {
    prefix: 'fasr',
    iconName: 'trailer',
    icon: [
      640,
      512,
      [],
      'e041',
      
      'M0 32H24 536h24V56 336h56 24v48H616 288c0 53-43 96-96 96s-96-43-96-96H24 0V360 56 32zM108.8 336c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H512V80H48V336h60.8zM160 112v24 96 24H112V232 136 112h48zm96 0v24 96 24H208V232 136 112h48zm96 0v24V280v24H304V280 136 112h48zm96 0v24V280v24H400V280 136 112h48zM240 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faBoxHeart = {
    prefix: 'fasr',
    iconName: 'box-heart',
    icon: [
      448,
      512,
      [],
      'f49d',
      
      'M200 160V80H95.2L59.6 160H200zm188.4 0L352.8 80H248v80H388.4zM48 208V432H400V208H48zM64 32H384l64 144V432v48H400 48 0V432 176L64 32zM224 400l-84.8-74c-22.1-19.3-23.3-53.3-2.5-74.1c19.8-19.8 51.9-19.8 71.8 0L224 267.4l15.5-15.5c19.8-19.8 51.9-19.8 71.8 0c20.8 20.8 19.6 54.8-2.5 74.1L224 400z'
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fasr',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M152 24V0H104V24 64H0v80 48V464v48H48 400h48V464 192 144 64H344V24 0H296V24 64H152V24zM48 192H400V464H48V192z'
      
    ]
  };

  

  
  

  var faBoothCurtain = {
    prefix: 'fasr',
    iconName: 'booth-curtain',
    icon: [
      512,
      512,
      [],
      'f734',
      
      'M0 0H24 144V48H48V488v24H0V488 24 0zM416 0h72 24V24 96 392v96 24H464V488 459.9c-7.5 2.7-15.6 4.1-24 4.1c-18.4 0-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3s-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3c-39.8 0-72-32.2-72-72V48 0h48 48 48 48 7.8H416zM368 48H320V392c0 13.3 10.7 24 24 24s24-10.7 24-24V48zm96 344V96 48H416V96 392c0 13.3 10.7 24 24 24s24-10.7 24-24zM224 48V392c0 13.3 10.7 24 24 24s24-10.7 24-24V48H224z'
      
    ]
  };

  

  
  

  var faCloudMoonRain = {
    prefix: 'fasr',
    iconName: 'cloud-moon-rain',
    icon: [
      576,
      512,
      [],
      'f73c',
      
      'M429.2 107.1c0 53 42.8 96 95.6 96c18.8 0 36.4-5.5 51.2-14.9c-20.7 39-60.9 65.9-107.5 67.8c-11-23.3-29.9-42.2-53.1-53.2c-2.2-47.4-33.7-87.1-76.7-101.2C350.9 43.5 402.1 0 463.5 0c18.8 0 36.7 4.1 52.8 11.5c-48.8 4.4-87 45.5-87 95.6zM64 416h56L56 512H0l64-96zm96 0h56l-64 96H96l64-96zm152 0l-64 96H192l64-96h56zm40 0h56l-64 96H288l64-96zM176.6 144c-26.5 0-48 21.5-48 48v24 24h-24H96c-26.5 0-48 21.5-48 48v48H80.6h31.8l0 0H248.6h0 88v0h24H368h32V304c0-17.7-14.3-32-32-32h-7.4-24V248 208c0-17.7-14.3-32-32-32c-14.9 0-27.5 10.2-31 24h-49v-8c0-26.5-21.5-48-48-48zm208 240v0h-24-112 0-144-24H48.8l0 0H24 0V360 288c0-47.8 34.9-87.4 80.6-94.8V192c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.7-14.4 45.8-14.4c44.2 0 80 35.8 80 80v17.7c36.2 7.6 63.4 39.8 63.4 78.3v56 24H424 384.6z'
      
    ]
  };

  

  
  

  var faUpDown = {
    prefix: 'fasr',
    iconName: 'up-down',
    icon: [
      256,
      512,
      [8597,11021,"arrows-alt-v"],
      'f338',
      
      'M200 224V176h8 40 8V128L161.9 33.9 128 0 94.1 33.9 0 128v48H8 48h8v48 64 48H48 8 0v48l94.1 94.1L128 512l33.9-33.9L256 384V336h-8H208h-8V288 224zM188.1 384L128 444.1 67.9 384H104V336 176 128H67.9L128 67.9 188.1 128H152v48V336v48h36.1z'
      
    ]
  };

  
    var faArrowsAltV = faUpDown;
  

  
  

  var faPencilMechanical = {
    prefix: 'fasr',
    iconName: 'pencil-mechanical',
    icon: [
      512,
      512,
      [],
      'e5ca',
      
      'M488 136l-16-16 40-40L432 0 392 40 376 24 342.1 57.9 317 83 265 31l-17-17L231 31 103 159l-17 17L120 209.9l17-17 111-111 35 35L64 336 32 448 0 480l32 32 32-32 0 0 112-32L454.1 169.9 488 136zM183 373.1L138.9 329 376 91.9 420.1 136 183 373.1zm-34.9 33l-59 16.9 16.9-59 42.2 42.2z'
      
    ]
  };

  

  
  

  var faTurtle = {
    prefix: 'fasr',
    iconName: 'turtle',
    icon: [
      576,
      512,
      [128034],
      'f726',
      
      'M336 240V208c0-70.7-57.3-128-128-128S80 137.3 80 208v32H336zm48 0v48H336 80 32V240 208c0-97.2 78.8-176 176-176s176 78.8 176 176v32zm96 48c-5.5 0-10.9-.7-16-2v58 24H440 352v64 48H304 272 224V432 368H192v64 48H144 112 64V432 368H24 0V320H24 64h48 32 48 32 48 32 48 64V224 192 112h64c53 0 96 43 96 96v80H480zM272 368v64h32V368H272zm-160 0v64h32V368H112zM496 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCaravanSimple = {
    prefix: 'fasr',
    iconName: 'caravan-simple',
    icon: [
      640,
      512,
      ["caravan-alt"],
      'e000',
      
      'M48 80V368h60.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H528V192c0-61.9-50.1-112-112-112H48zM96 416H48 0V368 80 32H48 416c88.4 0 160 71.6 160 160V368l40 0h24v48H616l-40 0H528 288c0 53-43 96-96 96s-96-43-96-96zm0-288H288V256H96V128zm352 0V256H320V128H448zM240 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faCaravanAlt = faCaravanSimple;
  

  
  

  var faPersonWalkingLuggage = {
    prefix: 'fasr',
    iconName: 'person-walking-luggage',
    icon: [
      576,
      512,
      [],
      'e554',
      
      'M480 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM306.6 201.5l36.3-18.2-22.7 68c-7.4 22.1-.3 46.5 17.8 61.2l104.6 85 22.1 88.2 5.8 23.3 46.6-11.6-5.8-23.3-24-96-1.9-7.8-6.2-5-54.4-44.2 25.7-82.3 6.4 23.4 1.7 6.1L463 273l40 40L537 279l-35.5-35.5-22.3-81.9-3.6-13.2-13.2-3.6-88-24-8.8-2.4-8.2 4.1-80 40-7.9 3.9-3.5 8.1-24 56-9.5 22.1 44.1 18.9 9.5-22.1 20.5-47.9zm59.2 65.1l30-90.1 22.1 6c-.3 .8-.6 1.5-.9 2.3L384.7 288.6l-16.3-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zM299.5 402.5l-57.3 57.3-17 17 33.9 33.9 17-17L337 433l3.5-3.5 1.8-4.6 20.4-51.1-39-31.7-24.1 60.4zM134.9 511.9l23.1-40 5.6-9.5 98.2-166.3-27.6-16.3-29.8 50.5L120 281.6 24 447.9l110.9 64z'
      
    ]
  };

  

  
  

  var faParagraphLeft = {
    prefix: 'fasr',
    iconName: 'paragraph-left',
    icon: [
      384,
      512,
      ["paragraph-rtl"],
      'f878',
      
      'M304 48h24 24V0H328 224 200 168 144C82.1 0 32 50.1 32 112s50.1 112 112 112h32v72 24h48V296 224 200 48h32l0 248v24h48V296 48zM176 48V176H144c-35.3 0-64-28.7-64-64s28.7-64 64-64h24 8zM121.5 373.2l18-15.9-31.8-36-18 15.9L20.9 398 .6 416l20.4 18 68.8 60.8 18 15.9 31.8-36-18-15.9L100.2 440H360h24V392H360 100.2l21.3-18.8z'
      
    ]
  };

  
    var faParagraphRtl = faParagraphLeft;
  

  
  

  var faBagsShopping = {
    prefix: 'fasr',
    iconName: 'bags-shopping',
    icon: [
      576,
      512,
      [128717],
      'f847',
      
      'M176 96c0-26.5 21.5-48 48-48s48 21.5 48 48v64H176V96zm-48 64H48 0v48V432v48H48 160V432H48V208H400v16h48V208 160H400 320V96c0-53-43-96-96-96s-96 43-96 96v64zm448 96H192V512H576V256zM320 336v16c0 35.3 28.7 64 64 64s64-28.7 64-64V336 320h32v16 16c0 53-43 96-96 96s-96-43-96-96V336 320h32v16z'
      
    ]
  };

  

  
  

  var faFan = {
    prefix: 'fasr',
    iconName: 'fan',
    icon: [
      512,
      512,
      [],
      'f863',
      
      'M259.1 126.7l-6.2 62.4 61.9-10.3c10.5-1.8 22.9-2.8 37.3-2.8l.2 0c25.4-.1 52.7 14.5 75.5 43.5c10.9 13.9 19.8 29.9 26 46.5l-66.3-6.6-56.7-5.7 4 56.8c.9 12.4 1.4 26.3 1.4 41.6l0 .2c.1 25.4-14.5 52.7-43.5 75.5c-13.9 10.9-29.9 19.8-46.5 26l6.8-68.3 6.2-62.4-61.9 10.3C186.7 335 174.4 336 160 336l-.2 0c-25.4 .1-52.7-14.5-75.5-43.5c-10.9-13.9-19.8-29.9-26-46.5l68.3 6.8 62.4 6.2-10.3-61.9C177 186.8 176 174.4 176 160l0-.2c-.1-25.4 14.5-52.7 43.5-75.5c13.9-10.9 29.9-19.8 46.5-26l-6.8 68.3zM512 320c0-16.2-2.2-32.7-6.4-48.9c-19-73.7-78.4-141.3-150.2-143.1c-1.1 0-2.3 0-3.4 0c-16.8 0-31.8 1.2-45.2 3.5l4.9-49.2 3.4-34.2L320 0c-16.2 0-32.7 2.2-48.9 6.4C197.4 25.5 129.8 84.8 128 156.6c0 1.1 0 2.3 0 3.4c0 16.7 1.2 31.7 3.5 45.2l-49.2-4.9-34.2-3.4L0 192c0 16.2 2.2 32.7 6.4 48.9C25.5 314.6 84.8 382.2 156.6 384c1.1 0 2.3 0 3.4 0c16.8 0 31.8-1.2 45.2-3.5l-4.9 49.2-3.4 34.2L192 512c16.2 0 32.7-2.2 48.9-6.4c73.7-19.1 141.3-78.4 143.1-150.2c0-1.1 0-2.3 0-3.4c0-16.3-.5-31.3-1.5-45l48.4 4.8 33 3.3L512 320zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faBlockBrick = {
    prefix: 'fasr',
    iconName: 'block-brick',
    icon: [
      448,
      512,
      ["wall-brick"],
      'e3db',
      
      'M144 80v48h56 48 56V80H144zM96 128V80H48v48H96zM48 176v56H200V176H48zm0 160H96V280H48v56zm0 48v48H200V384H144 96 48zm96-48H304V280H144v56zm208 0h48V280H352v56zm48 48H352 304 248v48H400V384zm0-208H248v56H400V176zm0-48V80H352v48h48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32z'
      
    ]
  };

  
    var faWallBrick = faBlockBrick;
  

  
  

  var faVoicemail = {
    prefix: 'fasr',
    iconName: 'voicemail',
    icon: [
      640,
      512,
      [],
      'f897',
      
      'M144 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM251.3 336c22.8-25.5 36.7-59.1 36.7-96c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 36.9 13.9 70.5 36.7 96H251.3zM496 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faPersonArrowDownToLine = {
    prefix: 'fasr',
    iconName: 'person-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e538',
      
      'M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H126.8l-6.9 12.4-75.3 136L33 297.4l42 23.3 11.6-21L128 224.9V464H24 0v48H24 128h48 32 48H616h24V464H616 256V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136L257.2 128H243.1 140.9zM208 464H176V352h32V464zm0-160H176V176h32V304zM472 56l0 281.7-47.9-43.5-32.3 35.5 88 80L496 424.4l16.1-14.7 88-80-32.3-35.5L520 337.7 520 56V32l-48 0V56z'
      
    ]
  };

  

  
  

  var faObjectIntersect = {
    prefix: 'fasr',
    iconName: 'object-intersect',
    icon: [
      512,
      512,
      [],
      'e49d',
      
      'M96 48H48V96H0V48 0H48 96V48zm32 0V0h96V48H128zM0 128H48v96H0V128zm352 32v48 48 48 48H304 224 208 160V304 256 208 160h48 80 16 48zM160 416h48v48h48v48H208 160V464 416zM352 48V96H304V48H256V0h48 48V48zm64 160V160h48 48v48 48H464V208H416zM96 304v48H48 0V304 256H48v48H96zM288 464h96v48H288V464zm176 48H416V464h48V416h48v48 48H464zm48-128H464V288h48v96zM208 208v96h96V208H208z'
      
    ]
  };

  

  
  

  var faChimney = {
    prefix: 'fasr',
    iconName: 'chimney',
    icon: [
      448,
      512,
      [],
      'f78b',
      
      'M48 80v96H400V80H48zM0 32H48 400h48V80v96 48H416V360 464v24H368V464 384H288v80 24H240V464 384H184 80v80 24H32V464 360 224H0V176 80 32zM80 224V336h80V224H80zm128 0V336h56H368V224H208z'
      
    ]
  };

  

  
  

  var faVialCircleCheck = {
    prefix: 'fasr',
    iconName: 'vial-circle-check',
    icon: [
      512,
      512,
      [],
      'e596',
      
      'M0 32H32 80h96 48 32V80H224V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V80H0V32zM80 80V192h96V80H80zm0 160V384c0 26.5 21.5 48 48 48s48-21.5 48-48V240H80zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L424 313.4l-11.3 11.3L352 385.4l-28.7-28.7L312 345.4 289.4 368l11.3 11.3 40 40L352 430.6l11.3-11.3 72-72L446.6 336z'
      
    ]
  };

  

  
  

  var faInfinity = {
    prefix: 'fasr',
    iconName: 'infinity',
    icon: [
      640,
      512,
      [8734,9854],
      'f534',
      
      'M0 96H24 192h10.4l7.1 7.6L320 221 430.5 103.6l7.1-7.6H448 616h24v24V392v24H616 448 437.6l-7.1-7.6L320 291 209.5 408.4l-7.1 7.6H192 24 0V392 120 96zM287 256L181.6 144H48V368H181.6L287 256zm65.9 0L458.4 368H592V144H458.4L353 256z'
      
    ]
  };

  

  
  

  var faCassetteVhs = {
    prefix: 'fasr',
    iconName: 'cassette-vhs',
    icon: [
      576,
      512,
      [128252,"vhs"],
      'f8ec',
      
      'M48 432V160H528V432H48zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM352 336H224V256H352v80zM144 296c0-19.4 13.7-35.5 32-39.2v78.4c-18.3-3.7-32-19.8-32-39.2zm288 0c0 19.4-13.7 35.5-32 39.2V256.8c18.3 3.7 32 19.8 32 39.2zM96 296c0 48.6 39.4 88 88 88H392c48.6 0 88-39.4 88-88s-39.4-88-88-88H184c-48.6 0-88 39.4-88 88z'
      
    ]
  };

  
    var faVhs = faCassetteVhs;
  

  
  

  var faChartColumn = {
    prefix: 'fasr',
    iconName: 'chart-column',
    icon: [
      512,
      512,
      [],
      'e0e3',
      
      'M48 32V56 432H488h24v48H488 24 0V456 56 32H48zM192 224v24 80 24H144V328 248 224h48zm96-72V328v24H240V328 152 128h48v24zm96 40v24V328v24H336V328 216 192h48zM480 88V328v24H432V328 88 64h48V88z'
      
    ]
  };

  

  
  

  var faHippo = {
    prefix: 'fasr',
    iconName: 'hippo',
    icon: [
      640,
      512,
      [129435],
      'f6ed',
      
      'M418.4 24.6l23.2 27.9c9.6-2.9 19.8-4.5 30.3-4.5h32c13.9 0 27.2 2.7 39.3 7.7l21.2-29.6L603.5 54 582.4 83.6c16 18.3 25.7 42.2 25.7 68.4v.4c19.6 17.6 32 43.1 32 71.6s-12.4 54-32 71.6V352H544V320H480v32H416V314.5c-37.3-13.2-64-48.7-64-90.5c0-19.6 5.9-37.9 16-53.1V152c0-9 1.1-17.7 3.3-26l-33.6-14H256 216c-75.1 0-136 60.9-136 136v40 4.6l-1.7 4.3-32 80L1.7 359.1 32 283.4V248C32 146.4 114.4 64 216 64h40 86.5 4.8l4.4 1.9 42.1 17.6c1.9-2.2 3.9-4.2 5.9-6.2L381.6 55.4l36.9-30.7zM544 272l0 0 0 0c26.5 0 48-21.5 48-48c0-14.2-6.1-26.9-16-35.8l-16-14.3V152.4 152c0-30.9-25.1-56-56-56H472c-30.9 0-56 25.1-56 56v18.9 14.5l-8 12.1c-5 7.6-8 16.6-8 26.5c0 26.5 21.5 48 48 48l96 0zM408 432V384h48v72 24H432 320 296V456 407.6c-26.4 5.4-53.6 5.4-80 0V456v24H192 88 64V456 392 368h48v24 40h56V376 343.3l31.2 9.8 11.3 3.6c29.6 9.3 61.4 9.3 91 0l11.3-3.6 31.2-9.8V376v56h64zm40-288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-72 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faTransformerBolt = {
    prefix: 'fasr',
    iconName: 'transformer-bolt',
    icon: [
      384,
      512,
      [],
      'e2a4',
      
      'M136 0H88V24v8H64 48V64H64 88h48 24 16V32H160 136V24 0zM296 0H248V24v8H224 208V64h16 24 48 24 16V32H320 296V24 0zM64 96H48v32H64h96 16V96H160 64zm160 0H208v32h16 96 16V96H320 224zM24 160H0v48H24h8V464H24 0v48H24 56 328h32 24V464H360h-8V208h8 24V160H360 328 56 24zM80 464V208H304V464H80zm96-112l-24 80h24l96-88V320H208l24-80H208l-96 88v24h64z'
      
    ]
  };

  

  
  

  var faT = {
    prefix: 'fasr',
    iconName: 't',
    icon: [
      384,
      512,
      [116],
      '54',
      
      'M24 32H0V80H24 168V456v24h48V456 80H360h24V32H360 192 24z'
      
    ]
  };

  

  
  

  var faOilCan = {
    prefix: 'fasr',
    iconName: 'oil-can',
    icon: [
      640,
      512,
      [],
      'f613',
      
      'M280 112h72V64H160v48h72v48H144 96 48 0v48 96l96 42.7V368v48h48H384h48L640 192l-32-32-2 .4-2.6 .5L448 192l-64-32H280V112zM48 208H96v86.1L48 272.8V208zm378.5 26.9l14.7 7.4 16.2-3.2 90.1-18L411.1 368H384 144V315.5 208H372.7l53.9 26.9z'
      
    ]
  };

  

  
  

  var faUpRightAndDownLeftFromCenter = {
    prefix: 'fasr',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
      512,
      512,
      ["expand-alt"],
      'f424',
      
      'M265.9 150.1l28.1-28.1L328 88l-6.1-6.1L294.1 54.1 288 48l33.9-33.9L336 0H464h48V48 176l-14.1 14.1L464 224l-6.1-6.1-27.9-27.9L424 184l-33.9 33.9-28.1 28.1L328 280l-33.9-33.9-28.1-28.1L232 184l33.9-33.9zm96-96L395.9 88l-33.9 33.9L299.9 184 328 212.1l62.1-62.1L424 116.1l33.9 33.9 6.1 6.1V48H355.9l6.1 6.1zM280 328l-33.9 33.9-28.1 28.1L184 424l6.1 6.1 27.9 27.9L224 464l-33.9 33.9L176 512H48 0V464 336l14.1-14.1L48 288l6.1 6.1 27.9 27.9L88 328l33.9-33.9 28.1-28.1L184 232l33.9 33.9 28.1 28.1L280 328zM150.1 457.9L116.1 424l33.9-33.9L212.1 328 184 299.9l-62.1 62.1L88 395.9 54.1 361.9 48 355.9V464H156.1l-6.1-6.1z'
      
    ]
  };

  
    var faExpandAlt = faUpRightAndDownLeftFromCenter;
  

  
  

  var faHashtag = {
    prefix: 'fasr',
    iconName: 'hashtag',
    icon: [
      448,
      512,
      [62098],
      '23',
      
      'M447.5 136H424 352.5L373.3 32h-49L303.5 136h-111L213.3 32h-49L143.5 136H56 48.5l-9.6 48H56h77.9L105.1 328H24 10.1L.5 376H24 95.5L74.7 480h49l20.8-104h111L234.7 480h49l20.8-104H392h7.5l9.6-48H392 314.1l28.8-144H424h13.9l9.6-48zM182.9 184h111L265.1 328h-111l28.8-144z'
      
    ]
  };

  

  
  

  var faFaceExplode = {
    prefix: 'fasr',
    iconName: 'face-explode',
    icon: [
      512,
      512,
      ["exploding-head"],
      'e2fe',
      
      'M120 160c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56H352 320v56l38.4 24 51.2-32 51.2 32 2.5-1 46.3-17.8c1.5 11.4 2.3 23 2.3 34.8c0 5.3-.2 10.7-.5 15.9C503.3 405.9 392 512 256 512S8.7 405.9 .5 271.9C.2 266.7 0 261.3 0 256c0-11.8 .8-23.4 2.3-34.8L48.7 239l2.5 1 51.2-32 51.2 32L192 216V160H160 120zM461 291.3l-5.3 2.1-20.3-12.7-25.8-16.1-25.8 16.1-25.4 15.9L333 280.7l-25.8-16.1-25.8 16.1L256 296.6l-25.4-15.9-25.8-16.1L179 280.7l-25.4 15.9-25.4-15.9-25.8-16.1L76.6 280.7 56.3 293.4 51 291.3C67.8 389.4 153.2 464 256 464s188.2-74.6 205-172.7zM176.4 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 368c26.5 0 48 21.5 48 48v16H208V416c0-26.5 21.5-48 48-48z'
      
    ]
  };

  
    var faExplodingHead = faFaceExplode;
  

  
  

  var faSquareXmark = {
    prefix: 'fasr',
    iconName: 'square-xmark',
    icon: [
      448,
      512,
      [10062,"times-square","xmark-square"],
      'f2d3',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM321.9 192l-17 17-47 47 47 47 17 17L288 353.9l-17-17-47-47-47 47-17 17L126.1 320l17-17 47-47-47-47-17-17L160 158.1l17 17 47 47 47-47 17-17L321.9 192z'
      
    ]
  };

  
    var faTimesSquare = faSquareXmark;
  
    var faXmarkSquare = faSquareXmark;
  

  
  

  var faFacePouting = {
    prefix: 'fasr',
    iconName: 'face-pouting',
    icon: [
      512,
      512,
      [],
      'e387',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 414.6c29.1-19.3 64.9-30.6 103.6-30.6s74.5 11.4 103.6 30.6c-4.7-53-49.3-94.6-103.6-94.6s-98.8 41.6-103.6 94.6zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z'
      
    ]
  };

  

  
  

  var faContainerStorage = {
    prefix: 'fasr',
    iconName: 'container-storage',
    icon: [
      640,
      512,
      [],
      'f4b7',
      
      'M24 32H0V80H24h8V432H24 0v48H24h8H80 560h48 8 24V432H616h-8V80h8 24V32H616h-8H560 80 32 24zM80 432V80H560V432H80zm96-280V128H128v24V360v24h48V360 152zm112 0V128H240v24V360v24h48V360 152zm112 0V128H352v24V360v24h48V360 152zm112 0V128H464v24V360v24h48V360 152z'
      
    ]
  };

  

  
  

  var faEarthOceania = {
    prefix: 'fasr',
    iconName: 'earth-oceania',
    icon: [
      512,
      512,
      ["globe-oceania"],
      'e47b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM387.3 379.3l-24 24L352 414.6 329.4 392l11.3-11.3 24-24L376 345.4 398.6 368l-11.3 11.3zM288 400v32H224V400h64zM416 256v64H384V256h32zM192 160V128h96v64H224l-32-32zM96 336V288l64-64h32v32h32V224h32l64 64v80H224l-32-32H96z'
      
    ]
  };

  
    var faGlobeOceania = faEarthOceania;
  

  
  

  var faGopuram = {
    prefix: 'fasr',
    iconName: 'gopuram',
    icon: [
      512,
      512,
      [],
      'f664',
      
      'M144 0V24v8h48V24 0h48V24v8h32V24 0h48V24v8h48V24 0h48V24v8V64 80v8 40h32v48 48h32v48 64h32v48 80 48H464 48 0V464 384 336H32V272 224H64V176 128H96V88 80 64 32 24 0h48zm0 88v40H368V88 80H144v8zm-32 88v48h48V176H144 112zm208 48V176H192v48h32c0-17.7 14.3-32 32-32s32 14.3 32 32h32zm32-48v48h48V176H368 352zM80 336h48V272H112 80v64zm80 0h64V320c0-17.7 14.3-32 32-32s32 14.3 32 32v16h64V272H160v64zm224 0h48V272H400 384v64zM128 464h80V448c0-26.5 21.5-48 48-48s48 21.5 48 48v16h80V384H352 160 128v80zm288 0h48V384H432 416v80zM48 384v80H96V384H80 48z'
      
    ]
  };

  

  
  

  var faMelon = {
    prefix: 'fasr',
    iconName: 'melon',
    icon: [
      512,
      512,
      [],
      'e310',
      
      'M464 256c0-35.6-8.9-69.1-24.7-98.4c-5.8 53.3-27.3 124.6-92.2 189.5s-136.2 86.4-189.5 92.2C186.9 455.1 220.4 464 256 464c114.9 0 208-93.1 208-208zM79.1 365.5c7.4-59.4 28.3-143.2 85.7-200.6c62.2-62.2 139-83 195-89.1C329.3 58.1 293.8 48 256 48C141.1 48 48 141.1 48 256c0 40.2 11.4 77.7 31.1 109.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 90c-3.2 17.4-5 33.4-6.1 47.1c9.9 0 21.4-.6 33.9-2.3c44.2-5.8 101.6-24.5 154.7-77.7S385 202.6 390.8 158.4c1.8-13.8 2.3-26.3 2.2-36.9c-12.3 .3-26.9 1.4-42.9 3.9c-47.6 7.4-104.8 26.7-151.4 73.4C160 237.6 140.1 294.3 130.7 346z'
      
    ]
  };

  

  
  

  var faLightbulbCflOn = {
    prefix: 'fasr',
    iconName: 'lightbulb-cfl-on',
    icon: [
      640,
      512,
      [],
      'e5a7',
      
      'M320 0V48.7l-160 40V39.3L314.2 .7c2.1-.5 4.3-.8 6.4-.7H320zM160 135.3l320-80v49.5l-320 80V135.3zm0 96l320-80v49.5l-320 80V231.3zm194.2 47.5L480 247.3v49.5l-96 24V384l32 0v96H344v8 24H296V488v-8H224V384h32V302.9l48-12V384l32 0V302 283.3l18.2-4.5zM55.3 16l6 4 24 16 20 13.3L78.7 89.3 58.7 76l-24-16-6-4L8.7 42.7 35.3 2.7 55.3 16zM611.3 56l-6 4-24 16-20 13.3L534.7 49.3l20-13.3 24-16 6-4 20-13.3 26.6 39.9L611.3 56zM24 160H72 96v48H72 24 0V160H24zm544 0h48 24v48H616 568 544V160h24zM85.3 332l-24 16-6 4-20 13.3L8.7 325.3l20-13.3 6-4 24-16 20-13.3 26.6 39.9L85.3 332zm496-39.9l24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9 20 13.3z'
      
    ]
  };

  

  
  

  var faCardHeart = {
    prefix: 'fasr',
    iconName: 'card-heart',
    icon: [
      384,
      512,
      [],
      'e3eb',
      
      'M48 48V464H336V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM80 219.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L192 352.1l-11.1-10.7L98.2 261.8C86.6 250.7 80 235.3 80 219.2z'
      
    ]
  };

  

  
  

  var faShieldHeart = {
    prefix: 'fasr',
    iconName: 'shield-heart',
    icon: [
      512,
      512,
      [],
      'e574',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM144 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2z'
      
    ]
  };

  

  
  

  var faVacuum = {
    prefix: 'fasr',
    iconName: 'vacuum',
    icon: [
      640,
      512,
      [],
      'e04d',
      
      'M243.4 48H528c35.3 0 64 28.7 64 64c0 30.7-21.7 56.5-50.6 62.6C507.8 145.6 463.9 128 416 128H400 352v48V292c10.2-2.6 21-4 32-4c5.4 0 10.8 .3 16 1V176h16c79.5 0 144 64.5 144 144V464H502.7c-7.5 18.6-19.3 35-34 48H560h48V464 320c0-39.5-11.9-76.1-32.3-106.6c38-17.9 64.3-56.6 64.3-101.4C640 50.1 589.9 0 528 0H224 204.6l-4 19L156.9 224H206L243.4 48zM199.2 256H150.1L122.9 384H64L0 448v16 48H48 176h48V464 432 384H176h-4.1l27.2-128zM384 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM51.9 464l32-32H176v32H51.9zM400 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faBroom = {
    prefix: 'fasr',
    iconName: 'broom',
    icon: [
      576,
      512,
      [129529],
      'f51a',
      
      'M336 208L544 0l32 32L368 240l34.1 34.1 1.1 1.1L416 288v32l-75.5 21.6 .1 .6c7.1 46.4-8.3 93.4-41.5 126.7C271.5 496.5 234 512 194.9 512L48 512H35.9 32 0V480l16-16 32-32 16-16 32-32H64v-2.9c0-9 .8-17.9 2.4-26.6c1.1-6.2 2.7-12.4 4.6-18.4c7.1-22.1 19.4-42.4 36.1-59.2c33.2-33.2 80.2-48.6 126.7-41.5l.6 .1L256 160h32l12.8 12.8 1.1 1.1L336 208zm-49.1 18.7l-8 28.1 42.3 42.3 28.1-8-62.4-62.4zm4.8 113l-55.4-55.4-9.8-1.5c-31.3-4.8-63 5.6-85.4 28c-7.5 7.5-13.6 16-18.3 25.2h89.1l-81.9 81.9L83.9 464l111.1 0c26.4 0 51.7-10.5 70.3-29.1c22.4-22.4 32.8-54.1 28-85.4l-1.5-9.8z'
      
    ]
  };

  

  
  

  var faCoinBlank = {
    prefix: 'fasr',
    iconName: 'coin-blank',
    icon: [
      512,
      512,
      [],
      'e3fb',
      
      'M256 304c64 0 119.6-14.7 157.5-36c39.4-22.2 50.5-45.3 50.5-60s-11.1-37.8-50.5-60C375.6 126.7 320 112 256 112s-119.6 14.7-157.5 36C59.1 170.2 48 193.3 48 208s11.1 37.8 50.5 60c37.9 21.3 93.5 36 157.5 36zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 48 0 64c0 70.7-114.6 128-256 128S0 390.7 0 320l0-64 0-48zM256 352c-13.6 0-27-.6-40-1.7l0 48c12.9 1.1 26.3 1.7 40 1.7s27.1-.6 40-1.7l0-48c-13 1.1-26.4 1.7-40 1.7zM120 330l0 47.7c18.7 7 40.3 12.7 64 16.6l0-48.1c-22.8-3.8-44.3-9.2-64-16.2zM88 316.7C73 309.3 59.6 301 48 292l0 28c0 6.8 6.2 24.2 40 43.1l0-46.5zm240 29.6l0 48.1c23.7-3.9 45.3-9.6 64-16.6l0-47.7c-19.7 7-41.2 12.5-64 16.2zM464 320l0-28c-11.6 9.1-25 17.4-40 24.7l0 46.5c33.8-18.9 40-36.3 40-43.1z'
      
    ]
  };

  

  
  

  var faCircleArrowUpLeft = {
    prefix: 'fasr',
    iconName: 'circle-arrow-up-left',
    icon: [
      512,
      512,
      [],
      'e0fb',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 144H144v24V328v24h48V328 225.9L327 361l17 17L377.9 344l-17-17-135-135H320h24V144H320 168z'
      
    ]
  };

  

  
  

  var faCircleG = {
    prefix: 'fasr',
    iconName: 'circle-g',
    icon: [
      512,
      512,
      [],
      'e10f',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80c20.5 0 39.2 7.7 53.3 20.4l32-35.8C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128V232H360 280 256v48h24 52.3c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faSkeleton = {
    prefix: 'fasr',
    iconName: 'skeleton',
    icon: [
      512,
      512,
      [],
      'f620',
      
      'M280 0V24 64H424h24v48H424 280v48H488h24v48H488 280v48H392h24v48H392 280v85.7L368 352h80v96l-64 64H128L64 448V352h80l88 37.7V304H120 96V256h24H232V208H24 0V160H24 232V112H88 64V64H88 232V24 0h48zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleCurrency = {
    prefix: 'fasr',
    iconName: 'display-chart-up-circle-currency',
    icon: [
      640,
      512,
      [],
      'e5e5',
      
      'M48 48H528V194.9c17 3.1 33.1 8.7 48 16.3V48 0H528 48 0V48 368v48H48 211.7l-8 48H152 128v48h24 72H352h42.8c-18.3-12.9-34.1-29.2-46.3-48H323.7 280 252.3l8-48H280h35.7 11c-4.3-15.3-6.6-31.4-6.6-48H48V48zm432 72V96H456 376 352v48h24 22.1L304 238.1l-63-63-17-17-17 17L103 279 137 313l87-87 63 63 17 17 17-17 111-111V200v4c15.1-5.9 31.2-9.8 48-11.3V120zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM521.4 393.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-25.3 25.3-22.6-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-25.3-25.3 22.6-22.6L460.7 310c21.6-13.2 49.1-13.2 70.7 0l25.3-25.3 22.6 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l25.3 25.3-22.6 22.6L531.3 426z'
      
    ]
  };

  

  
  

  var faPersonBiking = {
    prefix: 'fasr',
    iconName: 'person-biking',
    icon: [
      640,
      512,
      [128692,"biking"],
      'f84a',
      
      'M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 384A80 80 0 1 1 48 384a80 80 0 1 1 160 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM592 384a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM340.9 115.8l-13.4-8.5-13.1 9-72.1 49.6c-40.2 27.6-36 88.2 7.6 110l54.1 27V416v24h48V416 288 273.2l-13.3-6.6-67.4-33.7c-10.9-5.4-11.9-20.6-1.9-27.5l59-40.6 74.6 47.5L409 216h7 64 24V168H480 423l-82.1-52.2z'
      
    ]
  };

  
    var faBiking = faPersonBiking;
  

  
  

  var faTemperatureLow = {
    prefix: 'fasr',
    iconName: 'temperature-low',
    icon: [
      512,
      512,
      [],
      'f76b',
      
      'M416 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM416 0a96 96 0 1 1 0 192A96 96 0 1 1 416 0zM160 256v16 50.8c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272 256h32zM80 294.5L69.3 307.7C56 324.2 48 345.1 48 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L208 294.5v-17V48H80V277.5v17zM208 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S0 447.6 0 368c0-34.3 12-65.8 32-90.5V48 0H80 208z'
      
    ]
  };

  

  
  

  var faCodeCommit = {
    prefix: 'fasr',
    iconName: 'code-commit',
    icon: [
      640,
      512,
      [],
      'f386',
      
      'M224 160V352H416V160H224zm-48-48h48H416h48v48 72H616h24v48H616 464v72 48H416 224 176V352 280H24 0V232H24 176V160 112z'
      
    ]
  };

  

  
  

  var faFileMusic = {
    prefix: 'fasr',
    iconName: 'file-music',
    icon: [
      384,
      512,
      [],
      'f8b6',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zm48 208V184.9L282.4 193l-128 48L144 244.9V256v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V299.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V240 208z'
      
    ]
  };

  

  
  

  var faClockOne = {
    prefix: 'fasr',
    iconName: 'clock-one',
    icon: [
      512,
      512,
      [],
      'e34e',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120v56.7l20-30 13.3-20 39.9 26.6-13.3 20-64 96L232 256V120 96h48v24z'
      
    ]
  };

  

  
  

  var faCompassSlash = {
    prefix: 'fasr',
    iconName: 'compass-slash',
    icon: [
      640,
      512,
      [],
      'f5e9',
      
      'M536 393.4l84.9 65.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 85 66C180.1 31.1 246.4 0 320 0C461.4 0 576 114.6 576 256c0 50.6-14.7 97.7-40 137.4zm-364.6-283l98.9 76.8L448 128 395.8 284.5l102.1 79.3C517 332.4 528 295.5 528 256c0-114.9-93.1-208-208-208c-58.2 0-110.8 23.9-148.5 62.4zM468.1 464.8C426.3 494.5 375.2 512 320 512C178.6 512 64 397.4 64 256c0-33.6 6.5-65.8 18.3-95.2L122 192.1c-6.5 20.1-10 41.6-10 63.9c0 114.9 93.1 208 208 208c39.7 0 76.8-11.1 108.4-30.5l39.7 31.3zM313.9 343.4L192 384l36.1-108.3 85.8 67.6z'
      
    ]
  };

  

  
  

  var faMusic = {
    prefix: 'fasr',
    iconName: 'music',
    icon: [
      512,
      512,
      [127925],
      'f001',
      
      'M512-.3V32 144 368s0 0 0 0c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c17.5 0 33.9 3.9 48 10.7V176.3L192 257.9V432v0c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c17.5 0 33.9 3.9 48 10.7V240 128 110.1l17.1-5.1 320-96L512-.3zM464 368c0-9.8-12.9-32-48-32s-48 22.2-48 32s12.9 32 48 32s48-22.1 48-32c0 0 0 0 0 0zM96 400c-35.1 0-48 22.2-48 32s12.9 32 48 32s48-22.1 48-32v0c0-9.8-12.9-32-48-32zm96-192.3l272-81.6V64.3L192 145.9v61.9z'
      
    ]
  };

  

  
  

  var faYinYang = {
    prefix: 'fasr',
    iconName: 'yin-yang',
    icon: [
      512,
      512,
      [9775],
      'f6ad',
      
      'M464 256c0-64.3-29.2-121.8-75-160c4.6 13.8 7 28.6 7 44c0 77.3-62.7 140-140 140c-50.9 0-92.2 41.2-92.2 92s41.3 92 92.2 92c114.9 0 208-93.1 208-208zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM122.8 415.8c-4.5-13.8-7-28.5-7-43.8c0-77.4 62.9-140 140.2-140c50.8 0 92-41.2 92-92s-41.2-92-92-92C141.1 48 48 141.1 48 256c0 64.2 29.1 121.6 74.8 159.8zM216 144l40-40 40 40-40 40-40-40zm40 184l40 40-40 40-40-40 40-40z'
      
    ]
  };

  

  
  

  var faSendBackward = {
    prefix: 'fasr',
    iconName: 'send-backward',
    icon: [
      512,
      512,
      [],
      'f87f',
      
      'M352 0H0V352H128V160 128h32H352V0zM208 208H464V464H208V208zm-48-48v48V464v48h48H464h48V464 208 160H464 208 160z'
      
    ]
  };

  

  
  

  var faCheese = {
    prefix: 'fasr',
    iconName: 'cheese',
    icon: [
      512,
      512,
      [],
      'f7ef',
      
      'M48 304V432H464V304H48zm416-48c0-91.9-70.5-167.4-160.4-175.3L78.2 256H464zM0 256L288 32c123.7 0 224 100.3 224 224V432v48H464 48 0V432 256z'
      
    ]
  };

  

  
  

  var faSquareStar = {
    prefix: 'fasr',
    iconName: 'square-star',
    icon: [
      448,
      512,
      [],
      'e27f',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM271 191.3l105.1 15.3-76.1 74.2 18 104.7L224 336l-94 49.4 18-104.7L71.8 206.6 177 191.3 224 96l47 95.3z'
      
    ]
  };

  

  
  

  var faWineGlassEmpty = {
    prefix: 'fasr',
    iconName: 'wine-glass-empty',
    icon: [
      320,
      512,
      ["wine-glass-alt"],
      'f5ce',
      
      'M62.3 197c-5.2 57.5 40 107 97.7 107s102.9-49.5 97.7-107L244.2 48H75.8L62.3 197zm-47.8-4.3L32 0H288l17.5 192.7c7 77.4-47.4 145.2-121.5 157.4V464h88v48H160 48V464h88V350C61.9 337.8 7.4 270.1 14.5 192.7z'
      
    ]
  };

  
    var faWineGlassAlt = faWineGlassEmpty;
  

  
  

  var faPenSlash = {
    prefix: 'fasr',
    iconName: 'pen-slash',
    icon: [
      640,
      512,
      [],
      'e213',
      
      'M409.1 294.9L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L265 183l149-149L448 0l33.9 33.9 60.1 60.1L576 128l-33.9 33.9L409.1 294.9zM303.2 212.6l67.7 52.5 75.1-75.1-60.1-60.1-82.7 82.7zm36.8 151.3L224 480 115 501.8 64 512l10.2-51L96 352 196.9 251.1l38 29.9-94.6 94.6-15 75.1 75.1-15L302.1 334l38 29.9z'
      
    ]
  };

  

  
  

  var faMoon = {
    prefix: 'fasr',
    iconName: 'moon',
    icon: [
      384,
      512,
      [9214,127769],
      'f186',
      
      'M287.6 41.2c-20.2-6-41.5-9.2-63.6-9.2c-10.6 0-21 .7-31.1 2.1C83.9 49.3 0 142.9 0 256C0 379.7 100.3 480 224 480c28.3 0 55.3-5.2 80.2-14.8c10.7-4.1 21.1-9 31-14.7c17.9-10.3 34.3-22.9 48.6-37.6c-15.5 4.1-31.8 6.2-48.6 6.2c-12.6 0-25-1.2-36.9-3.6c-88.1-17.3-154.6-95.1-154.6-188.4c0-58.9 26.4-111.6 68.1-146.8c4-3.4 8.1-6.6 12.3-9.6c18.9-13.6 40.4-23.7 63.6-29.7zM126.4 109.5c-19.6 34.8-30.7 74.9-30.7 117.7c0 86.2 45.4 161.9 113.6 204.2C118.9 423.9 48 348.2 48 256c0-61.1 31.1-114.9 78.4-146.5z'
      
    ]
  };

  

  
  

  var faArrowUpFromLine = {
    prefix: 'fasr',
    iconName: 'arrow-up-from-line',
    icon: [
      384,
      512,
      [8613,"arrow-from-bottom"],
      'f342',
      
      'M209.3 50.5L192 32.6 174.7 50.5 46.7 183.3 30.1 200.6l34.6 33.3 16.7-17.3 86.7-90L168 328l0 24 48 0 0-24 0-201.3 86.7 90 16.7 17.3 34.6-33.3-16.7-17.3L209.3 50.5zM24 432L0 432l0 48 24 0 336 0 24 0 0-48-24 0L24 432z'
      
    ]
  };

  
    var faArrowFromBottom = faArrowUpFromLine;
  

  
  

  var faCarrot = {
    prefix: 'fasr',
    iconName: 'carrot',
    icon: [
      512,
      512,
      [129365],
      'f787',
      
      'M320 80c0 40 7.3 55.3 32 80s40 32 80 32s80-40 80-40s-32-40-80-40c-32 0-40 8-40 8s8-8 8-40c0-48-40-80-40-80s-40 40-40 80zM28.1 447.5L0 512l64.5-28.1 157.1-68.3 2.3 2.3 5.9-5.9 62.6-27.2c45.9-19.9 75.5-65.2 75.5-115.2C368 200.2 311.8 144 242.4 144c-50 0-95.3 29.7-115.2 75.5L28.1 447.5zm204.4-88.9L209 335l-17-17L158.1 352l17 17 10.2 10.2L92.6 419.4l78.6-180.7c.2-.4 .3-.7 .5-1.1L207 273l17 17L257.9 256l-17-17-36.9-36.9c11.5-6.5 24.6-10.1 38.3-10.1c42.9 0 77.6 34.8 77.6 77.6c0 30.9-18.3 58.9-46.7 71.2l-40.8 17.7z'
      
    ]
  };

  

  
  

  var faAmpersand = {
    prefix: 'fasr',
    iconName: 'ampersand',
    icon: [
      448,
      512,
      [],
      '26',
      
      'M104 32H80V56v74c0 25.2 9.1 49.5 25.7 68.5L145.6 244 76.4 292.5C48.6 311.9 32 343.7 32 377.7V456v24H56 256h13l7.1-10.9 28.4-43.4L351.9 480h63.8l-2.4-2.8L331.8 384l80.3-122.9-40.2-26.3-73 111.6-82-93.8 58.7-41.1c27.8-19.5 44.4-51.3 44.4-85.2V56 32H296 104zM248.1 172.2l-63 44.1-43.3-49.5C132.9 156.6 128 143.5 128 130V80H272v46.3c0 18.3-8.9 35.4-23.9 45.9zM103.9 331.8l73.5-51.4 94.3 107.8L243 432H80V377.7c0-18.3 8.9-35.4 23.9-45.9z'
      
    ]
  };

  

  
  

  var faAtomSimple = {
    prefix: 'fasr',
    iconName: 'atom-simple',
    icon: [
      512,
      512,
      ["atom-alt"],
      'f5d3',
      
      'M89.6 422.4c7.9 7.9 31.4 16.9 80.4 .6c13.2-4.4 27.2-10.4 41.6-17.9c-18.9-14.4-37.7-30.8-55.8-48.9s-34.5-36.9-48.9-55.8c-7.5 14.4-13.5 28.4-17.9 41.6c-16.3 49-7.3 72.5 .6 80.4zM76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3s-118.2 28.1-200.3-21.1c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256zM107 211.6c14.4-18.9 30.8-37.7 48.9-55.8s36.9-34.5 55.8-48.9c-14.4-7.5-28.4-13.5-41.6-17.9c-49-16.3-72.5-7.3-80.4 .6s-16.9 31.4-.6 80.4c4.4 13.2 10.4 27.2 17.9 41.6zM256 134c-22.1 15.5-44.5 34.1-66.2 55.8s-40.3 44.1-55.8 66.2c15.5 22.1 34.1 44.5 55.8 66.2s44.1 40.3 66.2 55.8c22.1-15.5 44.5-34.1 66.2-55.8s40.3-44.1 55.8-66.2c-15.5-22.1-34.1-44.5-55.8-66.2s-44.1-40.3-66.2-55.8zm149 77.7c7.5-14.4 13.5-28.4 17.9-41.6c16.3-49 7.3-72.5-.6-80.4s-31.4-16.9-80.4-.6c-13.2 4.4-27.2 10.4-41.6 17.9c18.9 14.4 37.7 30.8 55.8 48.9s34.5 36.9 48.9 55.8zm0 88.7c-14.4 18.9-30.8 37.7-48.9 55.8s-36.9 34.5-55.8 48.9c14.4 7.5 28.4 13.5 41.6 17.9c49 16.3 72.5 7.3 80.4-.6s16.9-31.4 .6-80.4c-4.4-13.2-10.4-27.2-17.9-41.6zM256 296l-40-40 40-40 40 40-40 40z'
      
    ]
  };

  
    var faAtomAlt = faAtomSimple;
  

  
  

  var faPenLine = {
    prefix: 'fasr',
    iconName: 'pen-line',
    icon: [
      576,
      512,
      [],
      'e212',
      
      'M10.2 461L0 512l51-10.2L160 480 478.1 161.9 512 128 478.1 94.1 417.9 33.9 384 0 350.1 33.9 32 352 10.2 461zm51-10.2l15-75.1L321.9 129.9l60.1 60.1L136.3 435.8l-75.1 15zM248 464H224v48h24H552h24V464H552 248z'
      
    ]
  };

  

  
  

  var faDog = {
    prefix: 'fasr',
    iconName: 'dog',
    icon: [
      576,
      512,
      [128021],
      'f6d3',
      
      'M336 319.8v59.8V464h48V274.3L302.2 224H290.7 144 112.1l-.1 .9V464h48V379.6 319.8l58.4 12.9c9.5 2.1 19.4 3.2 29.6 3.2s20.1-1.1 29.6-3.2L336 319.8zm1.1-130.7l52 32L394 192h40.7H480c26.5 0 48-21.5 48-48V112H496 476.1L462.1 97.9 444.1 80H368 355.3L338 183.9l-.9 5.2zm-272.9 31c-1.1-.3-2.2-.7-3.3-1.1c-17.3-6-32.2-17.3-42.8-32.2C12 178.2 7.3 168.2 4.6 157.4l0 0 0 0L.7 141.8l46.6-11.6 3.9 15.5 0 0C55.6 163.5 71.6 176 90 176h54H290.7L313.5 39.3l3.1-18.7L320 0h24l3.4 4.6 16.7 22.3L368 32h96l32 32h32 48v48 32c0 53-43 96-96 96H434.7L432 256V464v48H384 336 288V464 428.6 379.6c-10.4 2.3-21.1 3.7-32 4.2c-2.7 .1-5.3 .2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2v48.9V464v48H160 112 64V464 224c0-1.3 .1-2.6 .2-3.8zM416 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faWandMagic = {
    prefix: 'fasr',
    iconName: 'wand-magic',
    icon: [
      512,
      512,
      ["magic"],
      'f0d0',
      
      'M112 512l33.9-33.9L478.1 145.9 512 112 478.1 78.1 433.9 33.9 400 0 366.1 33.9 33.9 366.1 0 400l33.9 33.9 44.1 44.1L112 512zM359 197.1L314.9 153 400 67.9 444.1 112 359 197.1zM325.1 231L112 444.1 67.9 400 281 186.9 325.1 231z'
      
    ]
  };

  
    var faMagic = faWandMagic;
  

  
  

  var faTents = {
    prefix: 'fasr',
    iconName: 'tents',
    icon: [
      640,
      512,
      [],
      'e582',
      
      'M591.5 352h-134l-6.9-48h134L563.5 156 416 57.7 272.1 153.6l-30.4-20.2-12.9-8.6L416 0 608 128l25.1 176 6.9 48H591.5zM48.5 512H0l6.9-48L32 288 224 160 416 288l25.1 176 6.9 48H399.5 48.5zM200 233.7L76.5 316 55.3 464H200V233.7zm48 0V360l62.4 104h82.3L371.5 316 248 233.7z'
      
    ]
  };

  

  
  

  var faCricketBatBall = {
    prefix: 'fasr',
    iconName: 'cricket-bat-ball',
    icon: [
      512,
      512,
      [127951,"cricket"],
      'f449',
      
      'M493.8 52.2l17-17L476.8 1.3l-17 17L328 150.1 297.9 120 264 86.1 230.1 120 .2 349.8C-.2 367.1 .6 384 3.8 401c4 21.4 13.1 51.4 35.2 71.9c20.6 22.1 50.6 31.2 71.9 35.2c17 3.2 34 4 51.2 3.6L392 281.9 425.9 248 392 214.1 361.9 184 493.8 52.2zM294.1 184l0 0L328 217.9l0 0L358.1 248l-40 40H224V193.9l40-40L294.1 184zM176 241.9V312v24h24 70.1L142.5 463.6c-7.9-.4-15.4-1.2-22.6-2.6c-18.4-3.5-35.8-10.1-45.7-20.7L73 439l-1.3-1.2c-10.6-9.9-17.3-27.3-20.7-45.7c-1.4-7.3-2.2-14.7-2.6-22.6L176 241.9zM400 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faCricket = faCricketBatBall;
  

  
  

  var faDiagramCells = {
    prefix: 'fasr',
    iconName: 'diagram-cells',
    icon: [
      512,
      512,
      [],
      'e475',
      
      'M512 224V32H0V224l512 0zM464 336v96l-96 0H144 48l0-96 416 0zm48 96V336 288H464L48 288H0v48 96 48H48l416 0h48V432z'
      
    ]
  };

  

  
  

  var faFaceDiagonalMouth = {
    prefix: 'fasr',
    iconName: 'face-diagonal-mouth',
    icon: [
      512,
      512,
      [129764],
      'e47e',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm358.1 79.2l-184 48-23.2 6.1-12.1-46.4 23.2-6.1 184-48 23.2-6.1 12.1 46.4-23.2 6.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faTentArrowTurnLeft = {
    prefix: 'fasr',
    iconName: 'tent-arrow-turn-left',
    icon: [
      576,
      512,
      [],
      'e580',
      
      'M121.9 52.8L101.2 72H456c66.3 0 120 53.7 120 120v40 24H528V232 192c0-39.8-32.2-72-72-72H103.4l21.3 18.8 18 15.9-31.8 36-18-15.9L24.1 114 4.2 96.4l19.4-18L89.3 17.6 106.9 1.3l32.6 35.2L121.9 52.8zM112.5 512H64l6.9-48L96 288 288 160 480 288l25.1 176 6.9 48H463.5h-351zM264 233.7L140.5 316 119.3 464H264V233.7zm48 0V360l62.4 104h82.3L435.5 316 312 233.7z'
      
    ]
  };

  

  
  

  var faBanParking = {
    prefix: 'fasr',
    iconName: 'ban-parking',
    icon: [
      512,
      512,
      ["parking-circle-slash"],
      'f616',
      
      'M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L161.9 128H168h24 88c53 0 96 43 96 96c0 32.1-15.8 60.6-40 78l83.1 83.1zM216 176v6.1l85.1 85.1C317 259.3 328 242.9 328 224c0-26.5-21.5-48-48-48H216zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216.4 64H216v40 24H168V360 296 271.6L216.4 320z'
      
    ]
  };

  
    var faParkingCircleSlash = faBanParking;
  

  
  

  var faPenNib = {
    prefix: 'fasr',
    iconName: 'pen-nib',
    icon: [
      512,
      512,
      [10001],
      'f5ad',
      
      'M374.1 198.1l0 0-3.6 10.7L314.2 377.6 84.5 450.1 187.3 347.3c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7L61.9 427.5l72.5-229.7 168.8-56.3 10.7-3.6 0 0 60.1 60.1zM48 512l304-96 64-192 62.1-62.1L512 128 478.1 94.1 417.9 33.9 384 0 350.1 33.9 288 96 96 160 0 464l48 48z'
      
    ]
  };

  

  
  

  var faScythe = {
    prefix: 'fasr',
    iconName: 'scythe',
    icon: [
      640,
      512,
      [],
      'f710',
      
      'M352 0C161.2 0 64.9 110.2 24.4 176C7.1 204 0 224 0 224H52.5 509.4l9.9-48H82.4c7.4-9.9 16.1-20.3 26.1-30.7C154.9 97.2 231 48 352 48H545.8l9.9-48H352zM637.5 0h-49L528.9 288H408 384v48h24H518.9L482.5 512h49L568 336h0v-.2L637.5 0z'
      
    ]
  };

  

  
  

  var faHouseChimneyWindow = {
    prefix: 'fasr',
    iconName: 'house-chimney-window',
    icon: [
      576,
      512,
      [],
      'e00d',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 488h24V488 253.5l24.5 20.8 31.1-36.6L511.3 190c.5-1.9 .7-3.9 .7-6V88 64H464V88v61.9L303.5 13.7zM464 212.8V464H112V212.8L288 63.5 464 212.8zM256 288V224h64v64H256zM208 176v48 64 48h48 64 48V288 224 176H320 256 208z'
      
    ]
  };

  

  
  

  var faCircleChevronLeft = {
    prefix: 'fasr',
    iconName: 'circle-chevron-left',
    icon: [
      512,
      512,
      ["chevron-circle-left"],
      'f137',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM167 239l-17 17 17 17L271 377l17 17L321.9 360l-17-17-87-87 87-87 17-17L288 118.1l-17 17L167 239z'
      
    ]
  };

  
    var faChevronCircleLeft = faCircleChevronLeft;
  

  
  

  var faGolfBallTee = {
    prefix: 'fasr',
    iconName: 'golf-ball-tee',
    icon: [
      384,
      512,
      ["golf-ball"],
      'f450',
      
      'M336 192c0 55.7-31.7 104.1-78 128h77.1c30.4-34 48.9-78.8 48.9-128C384 86 298 0 192 0S0 86 0 192c0 49.2 18.5 94 48.9 128H126c-46.3-23.9-78-72.3-78-128c0-79.5 64.5-144 144-144s144 64.5 144 144zM226.1 248.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8zm-52.3-49.3c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8zM64 400h96V512h64V400h96V352H64v48z'
      
    ]
  };

  
    var faGolfBall = faGolfBallTee;
  

  
  

  var faHouseMedical = {
    prefix: 'fasr',
    iconName: 'house-medical',
    icon: [
      576,
      512,
      [],
      'e3b2',
      
      'M288 .5l15.5 13.2 264 224-31.1 36.6L512 253.5V488v24H488 88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zm0 62.9L112 212.8V464H464V212.8L288 63.5zM256 192h64v64h64v64H320v64H256V320H192V256h64V192z'
      
    ]
  };

  

  
  

  var faPersonSeat = {
    prefix: 'fasr',
    iconName: 'person-seat',
    icon: [
      384,
      512,
      [],
      'e21e',
      
      'M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 32H88v24V304c0 30.9 25.1 56 56 56h40 75l13.2 99.2L275 480h21 64 24V432H360 317l-13.2-99.2L301 312H280 208V256h56 24V208H264 208V184 160H184 112zm48 48V312H144c-4.4 0-8-3.6-8-8V208h24zM48 152V128H0v24V424v24H24 200h24V400H200 48V152z'
      
    ]
  };

  

  
  

  var faDitto = {
    prefix: 'fasr',
    iconName: 'ditto',
    icon: [
      320,
      512,
      [],
      '22',
      
      'M72 252L48 108V80H96v28L72 252zM144 32H96 48 0V80v32L32 304h80l32-192V80 32zM248 252L224 108V80h48v28L248 252zM320 32H272 224 176V80v32l32 192h80l32-192V80 32z'
      
    ]
  };

  

  
  

  var faPhonePlus = {
    prefix: 'fasr',
    iconName: 'phone-plus',
    icon: [
      640,
      512,
      [],
      'f4d2',
      
      'M336.4 369.2l31.9 18.4 26-26 33.2-33.2L521.7 366l-17.8 97.9C289.4 459.7 116.3 286.6 112.1 72L210 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM576 336L416 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L304 160 240 0 64 32l0 32c0 247.4 200.6 448 448 448h32l32-176zM456 224h48V200 136h64 24V88H568 504V24 0H456V24 88H392 368v48h24 64v64 24z'
      
    ]
  };

  

  
  

  var faGlassesRound = {
    prefix: 'fasr',
    iconName: 'glasses-round',
    icon: [
      576,
      512,
      [128083,"glasses-alt"],
      'f5f5',
      
      'M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6l0 0-.3 1c-5.3 19-10.6 38-16.5 60.9C80.4 217 107.2 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c28.8 0 55.6 9 77.6 24.3c-5.9-22.9-11.1-41.9-16.5-60.9l-.3-1 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7V272v48 24s0 0 0 0c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128H271.8c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344v0V320 272v-2.8l.6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM528 344a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zM48 344c0 48.6 39.4 88 88 88s88-39.4 88-88s-39.4-88-88-88s-88 39.4-88 88v0z'
      
    ]
  };

  
    var faGlassesAlt = faGlassesRound;
  

  
  

  var faBinary = {
    prefix: 'fasr',
    iconName: 'binary',
    icon: [
      384,
      512,
      [],
      'e33b',
      
      'M248 0h56 24V24 176h32 24v48H360 304 248 224V176h24 32V48H248 224V0h24zM24 288H80h24v24V464h32 24v48H136 80 24 0V464H24 56V336H24 0V288H24zM0 0H24 168h24V24 200v24H168 24 0V200 24 0zM48 48V176h96V48H48zM216 288H360h24v24V488v24H360 216 192V488 312 288h24zm24 176h96V336H240V464z'
      
    ]
  };

  

  
  

  var faAvocado = {
    prefix: 'fasr',
    iconName: 'avocado',
    icon: [
      512,
      512,
      [],
      'e0aa',
      
      'M382 265.7l53.9-53.9c37.5-37.5 37.5-98.3 0-135.8s-98.3-37.5-135.8 0L246.2 130l-14.5 14.5-20.5-.4c-42.1-.9-84.4 14.7-116.5 46.8c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c32.1-32.1 47.7-74.3 46.8-116.5l-.4-20.5L382 265.7zm87.8-19.9L416 299.7c1.1 54.7-19.2 109.7-60.9 151.4c-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c41.7-41.7 96.7-62 151.4-60.9l53.9-53.9c56.2-56.2 147.4-56.2 203.6 0s56.2 147.4 0 203.6zM283.2 347.2c-41.7 41.7-102.1 49.1-134.8 16.4s-25.3-93 16.4-134.8s102.1-49.1 134.8-16.4s25.3 93-16.4 134.8z'
      
    ]
  };

  

  
  

  var faGunSlash = {
    prefix: 'fasr',
    iconName: 'gun-slash',
    icon: [
      640,
      512,
      [],
      'e19c',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L412.4 297.4 432.9 240H472h9.9l7-7 25-25H584h24V184 88 64H584 560V56 32H512V56v8H111.8L48.4 14.8zM173.6 112H512h48v48H504h-9.9l-7 7-25 25H312 276.6l-103-80zM338.5 240h43.5l-9.4 26.4-34-26.4zM80 192V159L32 121.2V216v24H56h68L76 432 64 480h49.5H240l32-128h52.9l-85.5-67.4L202.5 432h-77l48-192h9.3l-60.9-48H80z'
      
    ]
  };

  

  
  

  var faArrowsRepeat1 = {
    prefix: 'fasr',
    iconName: 'arrows-repeat-1',
    icon: [
      512,
      512,
      ["repeat-1-alt"],
      'f366',
      
      'M0 280V256 128 104H24 370.7L319.9 57.8 302.1 41.6 334.4 6.1l17.8 16.1 88 80 7.9 7.1V120v8 24H424 48V256v24H0zm512-48v24V384v24H488 141.3l50.9 46.2 17.8 16.1-32.3 35.5-17.8-16.1-88-80L64 402.6V392v-8V360H88 464V256 232h48zM240 192h24 24v24 80 24H240V296 240H216V192h24z'
      
    ]
  };

  
    var faRepeat1Alt = faArrowsRepeat1;
  

  
  

  var faArrowUpShortWide = {
    prefix: 'fasr',
    iconName: 'arrow-up-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-up-alt"],
      'f885',
      
      'M111 50.2l17-17 17 17 96 96 17 17L224 197.1l-17-17-55-55V456v24H104V456 125.1l-55 55-17 17L-1.9 163.2l17-17 96-96zM312 48h48 24V96H360 312 288V48h24zm0 128H424h24v48H424 312 288V176h24zm0 128H488h24v48H488 312 288V304h24zm0 128H552h24v48H552 312 288V432h24z'
      
    ]
  };

  
    var faSortAmountUpAlt = faArrowUpShortWide;
  

  
  

  var faShield = {
    prefix: 'fasr',
    iconName: 'shield',
    icon: [
      512,
      512,
      [128737,"shield-blank"],
      'f132',
      
      'M256 51.5L64.1 126c-1 43.5 6.9 106.9 33.8 168.8c28.2 64.9 77 127.7 158.1 164.8c81.1-37.1 129.9-99.9 158.1-164.8C441 232.9 448.9 169.5 448 126L256 51.5zm238.3 41l1.2 20.5c2.9 50-4.9 126.3-37.3 200.9c-32.7 75.2-91.1 150-189.4 192.6L256 512l-12.7-5.5C144.9 463.9 86.5 389.2 53.9 313.9C21.4 239.3 13.6 162.9 16.6 113l1.2-20.5L36.9 85 244.4 4.5 256 0l11.6 4.5L475.1 85l19.2 7.4z'
      
    ]
  };

  
    var faShieldBlank = faShield;
  

  
  

  var faFileExport = {
    prefix: 'fasr',
    iconName: 'file-export',
    icon: [
      576,
      512,
      ["arrow-right-from-file"],
      'f56e',
      
      'M336 368v96H48V48H224V160H336v96h48V128L256 0H48 0V48 464v48H48 336h48V464 368H336zM481 223l-17-17L430.1 240l17 17 31 31H216 192v48h24H478.1l-31 31-17 17L464 417.9l17-17 72-72 17-17-17-17-72-72z'
      
    ]
  };

  
    var faArrowRightFromFile = faFileExport;
  

  
  

  var faPhoneMissed = {
    prefix: 'fasr',
    iconName: 'phone-missed',
    icon: [
      640,
      512,
      [],
      'e226',
      
      'M120 0H232h24V48H232 177.9l80 80H366.1L475.8 18.2l17-17 33.9 33.9-17 17L393 169l-7 7H376 248h-9.9l-7-7-87-87V136v24H96V136 24 0h24zM416 464V384c-62.3-20.8-129.7-20.8-192 0v80L64 512 0 352c37.3-48 153.6-144 320-144s282.7 96 320 144L576 512 416 464zM176 384V349.4l32.8-10.9c72.2-24.1 150.2-24.1 222.4 0L464 349.4V384v44.3l83.7 25.1 36.6-91.5C540.8 319.1 446.8 256 320 256S99.2 319.1 55.6 361.9l36.6 91.5L176 428.3V384z'
      
    ]
  };

  

  
  

  var faFireSmoke = {
    prefix: 'fasr',
    iconName: 'fire-smoke',
    icon: [
      640,
      512,
      [],
      'f74b',
      
      'M353 64.1c17.2-19.5 31-32 31-32s96 86.4 96 160c0 27.9-7.1 54.1-19.7 76.9l-23 6.2c-12.3-13.3-26.9-24.5-43.1-33c8.1-20.4 7.1-44.6-4.2-65.2c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 11.9 2.1 22.7 6 32.1c-16.3 8.5-31 19.8-43.3 33.1l-23-6.2c-12.5-22.8-19.7-49-19.7-76.9c0-88.4 128-192 128-192s32.6 26.4 65 64zM640 512l-112 0c-.9 0-1.7 0-2.6 0L320 512l-207.9 0-.1 0-16 0-48 0L0 512l0-48 0-64c0-9.6 1.2-19.3 3.8-29c16-59.7 77.4-95.2 137.2-79.2l73.5 19.7C237.6 278 276.2 256 320 256s82.4 22 105.5 55.5L499 291.8c59.7-16 121.2 19.4 137.2 79.2c2.6 9.7 3.8 19.4 3.8 29l0 112zM96 464l16 0 .1 0L320 464l205.4 0 .5 0 .5 0c.5 0 1 0 1.5 0c0 0 0 0 0 0l64 0 0-64s0 0 0 0c0-5.4-.7-11-2.2-16.6c-9.1-34.1-44.2-54.4-78.4-45.3l-73.5 19.7-32.7 8.8L386 338.7c-14.5-21.1-38.6-34.7-66-34.7s-51.5 13.7-66 34.7l-19.2 27.9-32.7-8.8-73.5-19.7c-34.1-9.1-69.2 11.1-78.4 45.3C48.7 389 48 394.6 48 400l0 64 48 0z'
      
    ]
  };

  

  
  

  var faFaceGrinBeamSweat = {
    prefix: 'fasr',
    iconName: 'face-grin-beam-sweat',
    icon: [
      512,
      512,
      [128517,"grin-beam-sweat"],
      'f583',
      
      'M476.8 126.3C497.1 120.8 512 102.7 512 81c0-18-28.3-55.2-43.5-75.1c-1.7-2.2-3.2-4.2-4.5-5.9c-1.1 1.5-2.4 3.1-3.7 4.9c-10.7 14-28.7 37.4-38.1 56.4c-.1 .1-.1 .3-.2 .4c-3.7 7.4-6 14.2-6 19.3c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM396.2 41.8C356 15.4 307.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-12.6 5-24.6 8.8-32.6c1.1-2.2 2.2-4.4 3.4-6.6zm-3.8 253.6c-39.3 14.9-86.2 23.5-136.5 23.5s-97.2-8.6-136.5-23.5C133.2 355.2 189.1 400 255.9 400s122.7-44.8 136.5-104.6zM120 232s28-32 56-32s56 32 56 32c0-40-28-80-56-80s-56 40-56 80zm216-80c-28 0-56 40-56 80c0 0 28-32 56-32s56 32 56 32c0-40-28-80-56-80z'
      
    ]
  };

  
    var faGrinBeamSweat = faFaceGrinBeamSweat;
  

  
  

  var faTrumpet = {
    prefix: 'fasr',
    iconName: 'trumpet',
    icon: [
      640,
      512,
      [127930],
      'f8e3',
      
      'M595.4 48H608h8 24V72 408v24H616h-8H595.4l-7.1-10.4 0 0 0 0 0 0-.1-.2-.6-.9c-.6-.8-1.5-2-2.7-3.6c-2.4-3.2-6-7.9-10.7-13.5c-9.4-11.3-23.1-26.4-40-41.4C499.5 331.3 455.1 304 408 304h-8V416h8c30.9 0 56-25.1 56-56c0-3.1-.2-6.1-.7-9c15.9 8.2 31.5 19.2 46.2 31.9C499 429.3 457.6 464 408 464h-8H352 312 264 224 176h-8c-57.4 0-104-46.6-104-104c0-20.6 6-39.8 16.3-56H48v8 24H0V312 280 200 168 144H48v24 8H176v-8V144h48v24 8h40v-8V144h48v24 8h40v-8V144h48v24 8h8c47.1 0 91.5-27.3 126.1-57.9c16.9-15 30.6-30.1 40-41.4c4.7-5.7 8.3-10.3 10.7-13.5c1.2-1.6 2.1-2.8 2.7-3.6l.6-.9 .1-.2 0 0 0 0 0 0L595.4 48zM168 256H352h56c64.9 0 120.5 36.7 157.9 70.1c9.7 8.6 18.4 17.2 26.1 25.3V128.7c-7.6 8-16.4 16.7-26.1 25.3C528.5 187.3 472.9 224 408 224H48v32H168zm0 48c-30.9 0-56 25.1-56 56s25.1 56 56 56h8V304h-8zm56 0V416h40V304H224zm88 0V416h40V304H312z'
      
    ]
  };

  

  
  

  var faClockRotateLeft = {
    prefix: 'fasr',
    iconName: 'clock-rotate-left',
    icon: [
      512,
      512,
      ["history"],
      'f1da',
      
      'M48 106.7V56 32H0V56 168v24H24 136h24V144H136 80.7c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5l-20-13.3-26.5 40 20 13.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM280 128H232v24V256v9.9l7 7 72 72 17 17L361.9 328l-17-17-65-65V152 128z'
      
    ]
  };

  
    var faHistory = faClockRotateLeft;
  

  
  

  var faNestingDolls = {
    prefix: 'fasr',
    iconName: 'nesting-dolls',
    icon: [
      640,
      512,
      [],
      'e3ba',
      
      'M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112V224H80V112zM192 50.9c-11.9 24.4-35.8 41.9-64 44.7c-.1 16.5 6.1 33.1 18.7 45.6c25 25 65.5 25 90.5 0c12.6-12.6 18.8-29.1 18.7-45.6c-28.2-2.8-52.1-20.3-64-44.7zM288 512s48-80 48-128V352c0-70.7 57.3-128 128-128s128 57.3 128 128v32c0 48 48 128 48 128H288zM392 352c-2.7 0-5.4-.1-8-.4c-.1 20.6 7.7 41.2 23.4 57c31.2 31.2 81.9 31.2 113.1 0c15.7-15.7 23.5-36.4 23.4-57c-2.6 .3-5.3 .4-8 .4c-31.7 0-59-18.4-72-45.1c-13 26.7-40.3 45.1-72 45.1zM250.7 512H48s-48-48-48-128c0-44.4 20.2-84.4 37.9-119.4l0 0 0 0c1.5-2.9 2.9-5.8 4.3-8.6H336c-10.8 14.3-19.2 30.5-24.7 48H71.9C57.9 332.9 48 358 48 384c0 30.2 9 54.3 18.1 71c1.8 3.3 3.6 6.3 5.3 9h206c-3.7 7.5-7.2 14.2-10.1 19.4c-2.1 3.9-3.9 7-5.1 9.1c-.6 1-1.1 1.8-1.4 2.4l-.3 .6-.1 .1 0 0 0 0 0 0 0 0L250.7 512z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMusic = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-music',
    icon: [
      512,
      512,
      [],
      'e65f',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm80-306.8l-77.8 19.5L192 133.2V152v57.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48v0V170.7l48-12V109.2z'
      
    ]
  };

  

  
  

  var faChairOffice = {
    prefix: 'fasr',
    iconName: 'chair-office',
    icon: [
      448,
      512,
      [],
      'f6c1',
      
      'M304 48V224h48V48 0H304 144 96V48 224h48V48H304zM64 152V128H16v24 48 24H64V200 152zm368 0V128H384v24 48 24h48V200 152zM248 400H368h48V368l-6.9-16L368 256H80L38.9 352 32 368v32H80 200v64H152 128v48h24 72 72 24V464H296 248V400zM111.7 304H336.3l20.6 48H248 200 91.1l20.6-48z'
      
    ]
  };

  

  
  

  var faFishCooked = {
    prefix: 'fasr',
    iconName: 'fish-cooked',
    icon: [
      576,
      512,
      [],
      'f7fe',
      
      'M101.4 200.4l30.5 15.3 24.4-23.8C202.5 146.9 267.1 112 320 112c68.9 0 120.8 37.2 157.9 79.6c18.4 21 32.1 42.2 41.2 58.1c1.2 2.2 2.4 4.3 3.5 6.2c-1.1 2-2.2 4.1-3.5 6.2c-9.1 16-22.8 37.2-41.2 58.1C440.8 362.8 388.9 400 320 400c-56.9 0-126.7-40.3-172.3-88.7l-27.2-28.9L87 303.7 64.1 318.3l14-49.1L81.9 256l-3.8-13.2-18-63.1 41.3 20.7zM320 64c-70.4 0-146.4 44.1-197.1 93.5L48 120 0 96v48l1.9 6.6L32 256 3.1 357.1 0 368v48l48-30.5 64.8-41.2C163.1 397.6 244.7 448 320 448c176 0 256-192 256-192s-80-192-256-192zm-4.7 107.3L326.6 160 304 137.4l-11.3 11.3-64 64L217.4 224 240 246.6l11.3-11.3 64-64zm112 16L438.6 176 416 153.4l-11.3 11.3-160 160L233.4 336 256 358.6l11.3-11.3 160-160zm16 112L454.6 288 432 265.4l-11.3 11.3-64 64L345.4 352 368 374.6l11.3-11.3 64-64z'
      
    ]
  };

  

  
  

  var faPenPaintbrush = {
    prefix: 'fasr',
    iconName: 'pen-paintbrush',
    icon: [
      576,
      512,
      ["pencil-paintbrush"],
      'f618',
      
      'M42.2 461L32 512l51-10.2L192 480 510.1 161.9 544 128 510.1 94.1 449.9 33.9 416 0 382.1 33.9 64 352 42.2 461zm51-10.2l15-75.1L353.9 129.9l60.1 60.1L168.3 435.8l-75.1 15zM392 512h72 48 16 24 24V464H560h-8H528 512V416 392c0-50.5-31.2-93.7-75.3-111.4l-39.6 39.6c37.4 2.6 66.9 33.8 66.9 71.8v72H392c-38.1 0-69.2-29.5-71.8-66.9l-39.6 39.6C298.3 480.8 341.5 512 392 512zM116.2 18.2l-17-17-17 17-64 64-17 17 17 17L136.4 234.3l33.9-33.9L69.1 99.2 99.2 69.1 200.4 170.3l33.9-33.9L116.2 18.2z'
      
    ]
  };

  
    var faPencilPaintbrush = faPenPaintbrush;
  

  
  

  var faBrowser = {
    prefix: 'fasr',
    iconName: 'browser',
    icon: [
      512,
      512,
      [128468],
      'f37e',
      
      'M464 432l0-272H48l0 272 416 0zm48-272V432v48H464L48 480H0l0-48V160 96 80 32H48 64 448h16 48V80l0 16v64z'
      
    ]
  };

  

  
  

  var faFireplace = {
    prefix: 'fasr',
    iconName: 'fireplace',
    icon: [
      640,
      512,
      [],
      'f79a',
      
      'M592 48V80H48V48H592zM48 0H0V48 80v48H32V488v24H56h80 24V488 368c0-88.4 71.6-160 160-160s160 71.6 160 160V488v24h24 80 24V488 128h32V80 48 0H592 48zM80 464V128H560V464H528V368c0-114.9-93.1-208-208-208s-208 93.1-208 208v96H80zM297.5 265.6c-29.9 18.7-89.6 71.7-89.6 134.4c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.7-13.4-67.2-67.2-112l-22.4 22.4-44.8-44.8zm67.2 168.1c0 24.7-20.1 44.8-44.8 44.8s-44.8-20.1-44.8-44.8c0-33.6 44.8-67.2 44.8-67.2s44.8 33.6 44.8 67.2z'
      
    ]
  };

  

  
  

  var faDiceD10 = {
    prefix: 'fasr',
    iconName: 'dice-d10',
    icon: [
      512,
      512,
      [],
      'f6cd',
      
      'M232 491l24 21 24-21L475.9 319.6l13.2-11.5L512 288l-26.1-29.4-5.7-6.5L297.4 46.6l-9.3-10.4L274.3 20.6 256 0 237.7 20.6 223.9 36.1l-9.3 10.4L31.9 252.1l-5.7 6.5L0 288l22.9 20.1 13.2 11.5L232 491zM82.8 296.7l79.5-15.1L232 332.2v95L82.8 296.7zM196.5 247L256 73.8 315.5 247 256 290.3 196.5 247zm141.4-82.7l70.7 79.5L362.2 235l-24.3-70.7zm91.3 132.3L280 427.2v-95l69.7-50.7 79.5 15.1zM174.1 164.4L149.8 235l-46.4 8.8 70.7-79.5z'
      
    ]
  };

  

  
  

  var faQrcode = {
    prefix: 'fasr',
    iconName: 'qrcode',
    icon: [
      448,
      512,
      [],
      'f029',
      
      'M48 80v96h96V80H48zM0 32H48h96 48V80v96 48H144 48 0V176 80 32zM48 336v96h96V336H48zM0 288H48h96 48v48 96 48H144 48 0V432 336 288zM400 80H304v96h96V80zM304 32h96 48V80v96 48H400 304 256V176 80 32h48zm80 416v32H352V448h32zm32 0h32v32H416V448zm32-160v32 96H352V384H320v96H256V384 288h96v32h64V288h32zM120 104v48H72V104h48zM72 360h48v48H72V360zM376 104v48H328V104h48z'
      
    ]
  };

  

  
  

  var faSubtitlesSlash = {
    prefix: 'fasr',
    iconName: 'subtitles-slash',
    icon: [
      640,
      512,
      [],
      'e610',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-12.9-10V432 80 32H560 80 70.5L48.4 14.8zm84 65.2H560V412l-48-37.3V336H488 462.1l-61.8-48H408h80 24V240H488 408 384v35.4L132.4 80zM32 432v48H80 487.4l-60.9-48H80V159L32 121.2V432zM152 240H128v48h24 91.7l-60.9-48H152zm136 96v48h24 53.5l-60.9-48H288zm-160 0v48h24 80 24V336H232 152 128z'
      
    ]
  };

  

  
  

  var faAlbumCircleUser = {
    prefix: 'fasr',
    iconName: 'album-circle-user',
    icon: [
      576,
      512,
      [],
      'e48d',
      
      'M48 80H400V194.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7V80 32H400 48 0V80 432v48H48 296.2c-11.8-14.3-21.4-30.5-28.2-48H48V80zm176 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c-1.4-9.1-2.2-18.4-2.2-27.9c0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-63.3 77.7c-20.4 21.2-49 34.3-80.7 34.3s-60.3-13.2-80.7-34.3L376 416H488l24.7 29.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faPancakes = {
    prefix: 'fasr',
    iconName: 'pancakes',
    icon: [
      512,
      512,
      [129374],
      'e42d',
      
      'M256 160c123.7 0 224-28.7 224-64s-100.3-64-224-64S32 60.7 32 96c0 17.4 24.4 33.2 64 44.8V264v24h48V264 151.4c19.6 3.2 41.2 5.7 64 7.1V216v24h48V216 160zM192 64h16 96 16V96H304 208 192V64zM64 163.8c-12.1-4.7-23.1-10.1-32.3-16.3c-9.1-6.2-19.6-15.3-26-27.8C2 127.1 0 135.2 0 144c0 15.3 6 28.6 16.9 40C6 195.4 0 208.7 0 224s6 28.6 16.9 40C6 275.4 0 288.7 0 304s6 28.6 16.9 40C6 355.4 0 368.7 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-15.3-6-28.6-16.9-40C506 332.6 512 319.3 512 304s-6-28.6-16.9-40C506 252.6 512 239.3 512 224s-6-28.6-16.9-40C506 172.6 512 159.3 512 144c0-8.8-2-16.9-5.7-24.3c-6.3 12.4-16.9 21.6-26 27.8C465 157.7 445 165.8 423.2 172c-8.2 2.3-17 4.5-26.2 6.5c-29.9 7.1-67 11.5-109 12.9V216v23.5c66.1-2.2 124.4-11.4 164.9-28.5c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8l0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4c-32.9 11.1-79.2 18-133.7 19.9v.5H176v44.5c25.2 2.3 52.1 3.5 80 3.5c79.2 0 150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8l0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 344.8 324.4 352 256 352s-126.4-7.2-165.6-20.4c-19.7-6.6-31.4-13.7-37.4-19.4c-4.9-4.6-4.9-6.9-4.9-8l0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9c1.6 .7 3.2 1.3 4.9 2V264 240.1c-4.8-2.8-8.5-5.5-11.1-7.9c-4.9-4.6-4.9-6.9-4.9-8l0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9c1.6 .7 3.2 1.3 4.9 2V163.8zM59.1 371c47 19.8 117.7 29 196.9 29s150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8l0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 424.8 324.4 432 256 432s-126.4-7.2-165.6-20.4c-19.7-6.6-31.4-13.8-37.4-19.4c-4.9-4.6-4.9-6.9-4.9-8l0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9z'
      
    ]
  };

  

  
  

  var faCamcorder = {
    prefix: 'fasr',
    iconName: 'camcorder',
    icon: [
      576,
      512,
      [128249,"video-handheld"],
      'f8a8',
      
      'M72 32H48V56 160H0v48V432v48H48 336h48V432 398.5v-157V208 160H336 96V80H296h24V32H296 72zM48 208H336V432H48V208zM528 459.7L576 480V427.9 212.1 160l-48 20.3L416 227.7v52.1l112-47.4V407.6L416 360.2v52.1l112 47.4zM80 240v48h24H280h24V240H280 104 80z'
      
    ]
  };

  
    var faVideoHandheld = faCamcorder;
  

  
  

  var faAnglesLeft = {
    prefix: 'fasr',
    iconName: 'angles-left',
    icon: [
      512,
      512,
      [171,"angle-double-left"],
      'f100',
      
      'M47 239l-17 17 17 17L207 433l17 17L257.9 416l-17-17L97.9 256 241 113l17-17L224 62.1 207 79 47 239zm192 0l-17 17 17 17L399 433l17 17L449.9 416l-17-17-143-143L433 113l17-17L416 62.1 399 79 239 239z'
      
    ]
  };

  
    var faAngleDoubleLeft = faAnglesLeft;
  

  
  

  var faBuilding = {
    prefix: 'fasr',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687,127970],
      'f1ad',
      
      'M48 48V464h96V352h96V464h96V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM88 88h80v80H88V88zm208 0v80H216V88h80zM88 216h80v80H88V216zm208 0v80H216V216h80z'
      
    ]
  };

  

  
  

  var faTicketSimple = {
    prefix: 'fasr',
    iconName: 'ticket-simple',
    icon: [
      576,
      512,
      ["ticket-alt"],
      'f3ff',
      
      'M0 112V64H48 528h48v48 48 48c-26.5 0-48 21.5-48 48s21.5 48 48 48v48 48 48H528 48 0V400 352 304c26.5 0 48-21.5 48-48s-21.5-48-48-48V160 112zm48 60.8c28.7 16.6 48 47.6 48 83.2s-19.3 66.6-48 83.2V400H528V339.2c-28.7-16.6-48-47.6-48-83.2s19.3-66.6 48-83.2V112H48v60.8z'
      
    ]
  };

  
    var faTicketAlt = faTicketSimple;
  

  
  

  var faAward = {
    prefix: 'fasr',
    iconName: 'award',
    icon: [
      384,
      512,
      [],
      'f559',
      
      'M236.2 26.9L192 0 147.8 26.9 96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2L25.7 288l45.4 24.8L96 358.3l51.8-1.2L192 384l44.2-26.9 51.8 1.2 24.8-45.4L358.3 288l-1.2-51.8L384 192l-26.9-44.2L358.3 96 312.8 71.2 288 25.7l-51.8 1.2zm23.7 47.5l10.8 19.8 6.8 12.4 12.4 6.8 19.8 10.8-.5 22.5-.3 14.1 7.3 12L327.8 192l-11.7 19.3-7.3 12 .3 14.1 .5 22.5-19.8 10.8-12.4 6.8-6.8 12.4-10.8 19.8-22.5-.5-14.1-.3-12 7.3L192 327.8l-19.3-11.7-12-7.3-14.1 .3-22.5 .5-10.8-19.8-6.8-12.4-12.4-6.8L74.4 259.9l.5-22.5 .3-14.1-7.3-12L56.2 192l11.7-19.3 7.3-12-.3-14.1-.5-22.5 19.8-10.8 12.4-6.8 6.8-12.4 10.8-19.8 22.5 .5 14.1 .3 12-7.3L192 56.2l19.3 11.7 12 7.3 14.1-.3 22.5-.5zM256 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM0 456H75.8L128 512l43.4-103.1-32.3-19.7-42.4 1-19.5 .5-9.3-17.1L49.2 339.3 0 456zm256 56l52.2-56H384L334.9 339.3l-18.8 34.3-9.3 17.1-19.5-.5-42.4-1-32.3 19.7L256 512z'
      
    ]
  };

  

  
  

  var faUserGroupSimple = {
    prefix: 'fasr',
    iconName: 'user-group-simple',
    icon: [
      640,
      512,
      [],
      'e603',
      
      'M104 136a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm160 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm216 88a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM98.6 336H221.4l32 96H66.6l32-96zM256 288H64L16 432 0 480H50.6 269.4 320l-16-48L256 288zm384 0H320l64 192H576l64-192z'
      
    ]
  };

  

  
  

  var faConveyorBeltEmpty = {
    prefix: 'fasr',
    iconName: 'conveyor-belt-empty',
    icon: [
      640,
      512,
      [],
      'e150',
      
      'M112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64H528c35.3 0 64-28.7 64-64s-28.7-64-64-64H112zM0 400c0-61.9 50.1-112 112-112H528c61.9 0 112 50.1 112 112s-50.1 112-112 112H112C50.1 512 0 461.9 0 400zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faFlagPennant = {
    prefix: 'fasr',
    iconName: 'flag-pennant',
    icon: [
      448,
      512,
      [128681,"pennant"],
      'f456',
      
      'M48 24V0H0V24v8V80 304v48V488v24H48V488 350.7L382.9 217.8 448 192l-65.1-25.8L48 33.3V24zm0 60.9L317.9 192 48 299.1V84.9z'
      
    ]
  };

  
    var faPennant = faFlagPennant;
  

  
  

  var faPersonFallingBurst = {
    prefix: 'fasr',
    iconName: 'person-falling-burst',
    icon: [
      640,
      512,
      [],
      'e547',
      
      'M510.7 79l36.6-5.1 54.2-7.6-19.4 51.2L569 152l26.8 25.5 39.7 37.7-52.1 16.7-35.2 11.3L545 280l-4.7 54.6-45.6-30.3L464 283.7l-30.8 20.5-19 12.7-32-45.7-2.4-28L357.6 236l-8.4-12L320 224h0l-27.6-8.8 39.7-37.7L359 152l-13.1-34.6L326.4 66.3l54.2 7.6L417.3 79l18.8-31.8L464 0l27.9 47.1L510.7 79zM527.9 125l-10.6 1.5-31.7 4.4-16.3-27.5L464 94.2l-5.4 9.2-16.3 27.5-31.7-4.4L400.1 125l3.8 10 11.4 29.9-23.2 22-7.7 7.3 10.1 3.3 30.4 9.8 2.7 31.9 .9 10.6 8.9-5.9L464 226l26.6 17.7 8.9 5.9 .9-10.6 2.7-31.9 30.4-9.8 10.1-3.3-7.7-7.3-23.2-22L524.1 135l3.8-10zM256 0l0 24 0 104 0 15.5-14.1 6.4-59 26.8L236.7 256l83.3 0h12.5l7.2 10.2 56 80 13.8 19.7-39.3 27.5-13.8-19.7L307.5 304l-49.6 0c-1.3 1.5-2.9 2.8-4.6 4l-53.9 36 77.9 120.4 13 20.1L250 510.6l-13-20.2L80 247.8 80 360l0 24H32V360 208 192.5l14.1-6.4L208 112.5V24 0h48zM173.3 303.6l26-17.3-60.7-89.5L112 208.9l61.3 94.7zM0 80a48 48 0 1 1 96 0A48 48 0 1 1 0 80z'
      
    ]
  };

  

  
  

  var faArrowRightToLine = {
    prefix: 'fasr',
    iconName: 'arrow-right-to-line',
    icon: [
      448,
      512,
      [8677,"arrow-to-right"],
      'f340',
      
      'M448 88l0-24-48 0 0 24 0 336 0 24 48 0 0-24 0-336zM312.4 273.5L331 256l-18.6-17.5-136-128L159 94.1l-32.9 35 17.5 16.4L235.5 232 152 232 24 232 0 232l0 48 24 0 128 0 83.5 0-91.9 86.5L126.1 383l32.9 35 17.5-16.4 136-128z'
      
    ]
  };

  
    var faArrowToRight = faArrowRightToLine;
  

  
  

  var faAnt = {
    prefix: 'fasr',
    iconName: 'ant',
    icon: [
      640,
      512,
      [],
      'e680',
      
      'M512 0L498.4 0l-7 11.7L469.6 48C413.3 49.3 368 95.4 368 152c0 15.5 3.4 30.2 9.5 43.4c-8.1-2.2-16.7-3.4-25.5-3.4c-24.5 0-46.8 9.1-63.7 24.2C270.8 169.4 225.7 136 172.8 136C77.4 136 0 213.4 0 308.8L0 360l0 24 24 0 95.8 0-71 124.3L46.7 512l55.3 0 73.1-128 8.9 0c5.6 0 11.1-.4 16.5-1.2L128.8 508.2l-2.2 3.8 55.3 0 94.3-165c4.6 5.9 9.8 11.2 15.7 15.9l-4.7 7.9-.3 .4L208.7 508.1l-2.2 3.9 55.3 0 66.7-116.8 7.5-12.6c5.2 .9 10.6 1.3 16 1.3c13.6 0 26.5-2.8 38.2-7.9l45.2 45.2L469.8 512l51.3 0L478.4 399.5l-1.8-4.8L473 391l-44.7-44.7c2.2-2.8 4.2-5.8 6.1-8.9l97.2 69.4 33 105.1 50.3 0-40-127.2-2.4-7.7-6.5-4.7-112-80-5.9-4.2 0-.2c0-13-2.6-25.5-7.3-36.8c9.9 3.1 20.4 4.8 31.3 4.8l112 0 24 0 0-24 0-50.3c0-57.6-36.4-106.6-87.4-125.5l5-8.3L584 48l24 0 0-48L584 0 512 0zM472 96l2.3 0c47.3 0 85.7 38.4 85.7 85.7l0 26.3-88 0c-30.9 0-56-25.1-56-56s25.1-56 56-56zM352 336a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM48 308.8C48 239.9 103.9 184 172.8 184c41.5 0 75.2 33.7 75.2 75.2l0 12.8c0 35.3-28.7 64-64 64L48 336l0-27.2zM520 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faLineColumns = {
    prefix: 'fasr',
    iconName: 'line-columns',
    icon: [
      512,
      512,
      [],
      'f870',
      
      'M24 40H200h24V88H200 24 0V40H24zm0 128H200h24v48H200 24 0V168H24zM0 296H24 200h24v48H200 24 0V296zM24 424H200h24v48H200 24 0V424H24zM288 168h24H488h24v48H488 312 288V168zM312 40H488h24V88H488 312 288V40h24zM288 296h24H488h24v48H488 312 288V296zm24 128H488h24v48H488 312 288V424h24z'
      
    ]
  };

  

  
  

  var faCardSpade = {
    prefix: 'fasr',
    iconName: 'card-spade',
    icon: [
      384,
      512,
      [],
      'e3ec',
      
      'M48 48V464H336V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM192 120.8l39.6 39.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-8.4-8.4V336h16 16v32H224 208 176 160 144V336h16 16V295.2l-8.4 8.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64L192 120.8z'
      
    ]
  };

  

  
  

  var faSpade = {
    prefix: 'fasr',
    iconName: 'spade',
    icon: [
      512,
      512,
      [9824],
      'f2f4',
      
      'M39.8 408.2C90 458.3 169.6 461.1 223 416.5c3.1-2.6 6.1-5.3 9-8.2V464H184 160v48h24 48 48 48 24V464H328 280V408.3c2.9 2.9 5.9 5.6 9 8.2c53.4 44.6 133 41.8 183.2-8.4c53.1-53.1 53.1-139.2 0-192.3L256 0 39.8 215.8c-53.1 53.1-53.1 139.2 0 192.3zm33.9-33.9c-34.4-34.4-34.4-90.1 0-124.4l0 0L256 67.8 438.2 249.8l0 0c34.4 34.4 34.4 90.1 0 124.4c-34.3 34.3-90 34.4-124.3 .1l-23.7-24L256 315.6l-34.2 34.7-23.7 24c-34.4 34.3-90 34.2-124.3-.1z'
      
    ]
  };

  

  
  

  var faArrowTurnDown = {
    prefix: 'fasr',
    iconName: 'arrow-turn-down',
    icon: [
      384,
      512,
      ["level-down"],
      'f149',
      
      'M24 48L0 48 0 0 24 0 192 0l24 0 0 24 0 394.9 79-79 17-17 33.9 33.9-17 17-113 113 0 1.3-1.3 0-5.8 5.8-17 17-17-17-5.8-5.8-1.3 0 0-1.3L55 373.8l-17-17L72 322.9l17 17 79 79L168 48 24 48z'
      
    ]
  };

  
    var faLevelDown = faArrowTurnDown;
  

  
  

  var faBorderRight = {
    prefix: 'fasr',
    iconName: 'border-right',
    icon: [
      448,
      512,
      [],
      'f852',
      
      'M448 32l0 448-48 0 0-448 48 0zm-96 0l0 64-64 0 0-64 64 0zm0 448l-64 0 0-64 64 0 0 64zm0-256l0 64-64 0 0-64 64 0zM160 96L96 96l0-64 64 0 0 64zm0 320l0 64-64 0 0-64 64 0zm0-128l-64 0 0-64 64 0 0 64zM256 32l0 64-64 0 0-64 64 0zm0 448l-64 0 0-64 64 0 0 64zm0-256l0 64-64 0 0-64 64 0zM64 96L0 96 0 32l64 0 0 64zm0 320l0 64L0 480l0-64 64 0zm0-128L0 288l0-64 64 0 0 64zM256 128l0 64-64 0 0-64 64 0zM64 192L0 192l0-64 64 0 0 64zm0 128l0 64L0 384l0-64 64 0zm192 64l-64 0 0-64 64 0 0 64z'
      
    ]
  };

  

  
  

  var faKnifeKitchen = {
    prefix: 'fasr',
    iconName: 'knife-kitchen',
    icon: [
      576,
      512,
      [128298],
      'f6f5',
      
      'M480 0L278.6 201.4 392.5 315.2 448 272V208L568 88 480 0zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm72-72a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM400 368l-34.6-34.6-33.9 33.9c-11.7 10.1-26.1 21.7-42.8 33.2C240.4 434 178.1 464 112 464c-9 0-17.7-.8-25.9-2.2L256 291.9l33.9-33.9L256 224l-33.9 33.9L35.2 444.8 0 480s18 12 46.6 21.3C64.7 507.2 87.2 512 112 512c110 0 204.9-68.1 253.5-110.6c4.4-3.8 8.4-7.5 12-10.9C392 377 400 368 400 368z'
      
    ]
  };

  

  
  

  var faUpFromBracket = {
    prefix: 'fasr',
    iconName: 'up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e590',
      
      'M256 224l0-48 48 0 28.1 0L224 67.9 115.9 176l28.1 0 48 0 0 48 0 80 64 0 0-80zm1.9-190.1L384 160l0 16 0 48-32 0-16 0-32 0 0 48 0 32 0 48-48 0-64 0-48 0 0-48 0-32 0-48-32 0-16 0-32 0 0-48 0-16L190.1 33.9 224 0l33.9 33.9zM48 344l0 120 352 0 0-120 0-24 48 0 0 24 0 144 0 24-24 0L24 512 0 512l0-24L0 344l0-24 48 0 0 24z'
      
    ]
  };

  

  
  

  var faMercury = {
    prefix: 'fasr',
    iconName: 'mercury',
    icon: [
      384,
      512,
      [9791],
      'f223',
      
      'M50.6 0C62 28.6 81.7 52.9 106.9 69.9C52.7 99.9 16 157.7 16 224c0 89.1 66.2 162.7 152 174.4V424H136 112v48h24 32v16 24h48V488 472h32 24V424H248 216V398.4c85.8-11.7 152-85.3 152-174.4c0-66.3-36.7-124.1-90.9-154.1C302.3 52.9 322 28.6 333.4 0H279.7C261.2 28.9 228.8 48 192 48s-69.2-19.1-87.7-48H50.6zM192 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z'
      
    ]
  };

  

  
  

  var faTransgender = {
    prefix: 'fasr',
    iconName: 'transgender',
    icon: [
      512,
      512,
      [9895,"transgender-alt"],
      'f225',
      
      'M128 0H104 24 0V24v80 24H48V104 81.9L78.1 112l-7 7-17 17L88 169.9l17-17 7-7 15.2 15.2C107.6 187.7 96 220.5 96 256c0 80.2 59 146.6 136 158.2V432H216 192v48h24 16v8 24h48V488v-8h16 24V432H296 280V414.2c77-11.6 136-78 136-158.2c0-35.5-11.6-68.3-31.2-94.9L464 81.9V104v24h48V104 24 0H488 408 384V48h24 22.1l-79.2 79.2C324.3 107.6 291.5 96 256 96s-68.3 11.6-94.9 31.2L145.9 112l7-7 17-17L136 54.1 119 71l-7 7L81.9 48H104h24V0zM256 368c-61.9 0-112-50.1-112-112c0-28.3 10.5-54.2 27.8-73.9l10.3-10.3C201.8 154.5 227.7 144 256 144s54.2 10.5 73.9 27.8l10.3 10.3C357.5 201.8 368 227.7 368 256c0 61.9-50.1 112-112 112z'
      
    ]
  };

  
    var faTransgenderAlt = faTransgender;
  

  
  

  var faSimCard = {
    prefix: 'fasr',
    iconName: 'sim-card',
    icon: [
      384,
      512,
      [],
      'f7c4',
      
      'M48 48V464H336V147.9L236.1 48H48zM256 0L384 128V464v48H336 48 0V464 48 0H48 256zM80 240h64v80H80V240zm0 192V352h80 48v80H80zm224 0H240V352h64v80zm0-192v80H224 176V240H304z'
      
    ]
  };

  

  
  

  var faDiceFour = {
    prefix: 'fasr',
    iconName: 'dice-four',
    icon: [
      448,
      512,
      [9859],
      'f524',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faMandolin = {
    prefix: 'fasr',
    iconName: 'mandolin',
    icon: [
      512,
      512,
      [],
      'f6f9',
      
      'M448 0L368 48l-31 93.1-49 49C206.9 187.4 0 194.5 0 336c0 97.2 78.8 176 176 176c141.5 0 148.6-206.9 145.9-287.9l49-49L464 144l48-80L448 0zM168.3 245.3c24.5-4.3 49.3-6.3 71.6-7.1l-51.5 51.5c-4-1.1-8.1-1.6-12.4-1.6c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-4.3-.6-8.5-1.6-12.4l51.5-51.5c-.8 22.3-2.8 47.1-7.1 71.6c-6.5 36.9-17.3 68.6-32.8 90.1c-14 19.3-31.3 30.2-57.9 30.2c-70.7 0-128-57.3-128-128c0-26.6 10.9-43.9 30.2-57.9c21.5-15.6 53.2-26.4 90.1-32.8z'
      
    ]
  };

  

  
  

  var faMeter = {
    prefix: 'fasr',
    iconName: 'meter',
    icon: [
      512,
      512,
      [],
      'e1e8',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 152v48 24H144V200 152 128h48v24zm88 0v48 24H232V200 152 128h48v24zm88 0v48 24H320V200 152 128h48v24z'
      
    ]
  };

  

  
  

  var faFaceGrinHearts = {
    prefix: 'fasr',
    iconName: 'face-grin-hearts',
    icon: [
      512,
      512,
      [128525,"grin-hearts"],
      'f584',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-21.6 80.5-80.6-21.6c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-80.6 21.6L273.1 178c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z'
      
    ]
  };

  
    var faGrinHearts = faFaceGrinHearts;
  

  
  

  var faSplotch = {
    prefix: 'fasr',
    iconName: 'splotch',
    icon: [
      512,
      512,
      [],
      'f5bc',
      
      'M187.7 400.2c1.4-.1 2.9-.2 4.3-.2c31.6 0 62.3 10.8 87 30.5L320.8 464h25.5l-2.5-22.6c-6.6-59.1 18.6-117.3 66.2-153L464 248V225.3L420.7 209c-47.5-17.8-84.4-56.1-100.4-104.2L301.4 48H278.5L257.7 73c-38.8 46.5-99.5 68.6-159.1 57.7L48 121.5v24.2l43.1 65.9c12.7 19.4 19.7 41.9 20.2 65c.7 27.8-8.1 55-24.8 77.3L64 384v27.4l123.7-11.2zM64 459.6L16 464V415.8 368l32.2-43c10.2-13.6 15.6-30.3 15.2-47.4c-.3-14.2-4.6-28-12.4-39.8L0 160V112.8 64l48 8.7 59.1 10.8c42.5 7.7 86-8 113.7-41.2L256 0h80l29.9 89.7c11.4 34.4 37.8 61.7 71.7 74.4L512 192v80l-73.2 54.9c-34 25.5-52 67-47.3 109.3l3.1 27.9 5.3 48H351.7 304l-55-44c-16.2-12.9-36.3-20-57-20L64 459.6z'
      
    ]
  };

  

  
  

  var faSquareN = {
    prefix: 'fasr',
    iconName: 'square-n',
    icon: [
      448,
      512,
      [],
      'e277',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm288 96h48v24V360v24H300.9l-7.2-8.5L160 217.5V360v24H112V360 152 128h35.1l7.2 8.5L288 294.5V152 128z'
      
    ]
  };

  

  
  

  var faArrowUpRightDots = {
    prefix: 'fasr',
    iconName: 'arrow-up-right-dots',
    icon: [
      576,
      512,
      [],
      'e4b7',
      
      'M152 0H128V48h24 86.1L23 263l-17 17L40 313.9l17-17 215-215V168v24h48V168 24 0H296 152zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faSquareFragile = {
    prefix: 'fasr',
    iconName: 'square-fragile',
    icon: [
      448,
      512,
      ["box-fragile","square-wine-glass-crack"],
      'f49b',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm128 80h48l32 64-32 32 80 64-32-64 48-32-32-64h80V224c0 47.6-34.6 87.1-80 94.7V368h48v32H160V368h48V318.7c-45.4-7.6-80-47.1-80-94.7V112z'
      
    ]
  };

  
    var faBoxFragile = faSquareFragile;
  
    var faSquareWineGlassCrack = faSquareFragile;
  

  
  

  var faLockKeyholeOpen = {
    prefix: 'fasr',
    iconName: 'lock-keyhole-open',
    icon: [
      576,
      512,
      ["lock-open-alt"],
      'f3c2',
      
      'M432 48c-44.2 0-80 35.8-80 80v64h48 48v48V464v48H400 48 0V464 240 192H48 304V128C304 57.3 361.3 0 432 0s128 57.3 128 128v72 24H512V200 128c0-44.2-35.8-80-80-80zM400 240H48V464H400V240zM256 376H192 168V328h24 64 24v48H256z'
      
    ]
  };

  
    var faLockOpenAlt = faLockKeyholeOpen;
  

  
  

  var faConveyorBeltArm = {
    prefix: 'fasr',
    iconName: 'conveyor-belt-arm',
    icon: [
      640,
      512,
      [],
      'e5f8',
      
      'M128 0h24H328h24V48H328 259l-4.5 26.9c6 5 10.8 11.4 13.9 18.8l198.8 26.5 12.8 1.7v48.4V192v16H448V192 166.1L262 141.3c-8.8 11.4-22.6 18.7-38 18.7c-26.5 0-48-21.5-48-48c0-20.6 13-38.1 31.2-45l3.2-19H152 128V0zm96 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM416 240h96v48h16c61.9 0 112 50.1 112 112s-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-56.4 41.7-103.1 96-110.9V240h96v48h64V240h96v48h64V240zM48 400c0 35.3 28.7 64 64 64H528c35.3 0 64-28.7 64-64s-28.7-64-64-64H512 416 352 256 192 112c-35.3 0-64 28.7-64 64zm80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faWarehouse = {
    prefix: 'fasr',
    iconName: 'warehouse',
    icon: [
      640,
      512,
      [],
      'f494',
      
      'M320 6.1l9 3.7 296 120 15 6.1V152 488v24H592V488 168.2L320 57.9 48 168.2V488v24H0V488 152 135.8l15-6.1L311 9.8l9-3.7zM96 192h24H520h24v24V488v24H520v0H120v0H96V488 216 192zm48 272H496V424H144v40zm0-88H496V328H144v48zm0-96H496V240H144v40z'
      
    ]
  };

  

  
  

  var faSunBright = {
    prefix: 'fasr',
    iconName: 'sun-bright',
    icon: [
      512,
      512,
      ["sun-alt"],
      'e28f',
      
      'M280 24V88v24H232V88 24 0h48V24zm157 84.9l-45.3 45.3-17 17-33.9-33.9 17-17L403.1 75l17-17L454 92l-17 17zM108.9 75l45.3 45.3 17 17-33.9 33.9-17-17L75 108.9 58 92 92 58l17 17zM24 232H88h24v48H88 24 0V232H24zm400 0h64 24v48H488 424 400V232h24zM154.2 391.8L108.9 437 92 454 58 420l17-17 45.3-45.3 17-17 33.9 33.9-17 17zm237.6-33.9L437 403.1l17 17L420 454l-17-17-45.3-45.3-17-17 33.9-33.9 17 17zM280 424v64 24H232V488 424 400h48v24zm40-168a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'
      
    ]
  };

  
    var faSunAlt = faSunBright;
  

  
  

  var faGears = {
    prefix: 'fasr',
    iconName: 'gears',
    icon: [
      640,
      512,
      ["cogs"],
      'f085',
      
      'M127.2 12h15 51.5 15L213 26.4l8.3 28.8c8.7 3.9 17 8.6 24.6 14.2L275 62.3l14.6-3.6 7.5 13 25.8 44.6 7.5 13L320 140.2l-20.8 21.6c.5 4.7 .8 9.4 .8 14.2s-.3 9.5-.8 14.2L320 211.8l10.4 10.8-7.5 13-25.8 44.6-7.5 13L275 289.7l-29.1-7.2c-7.6 5.6-15.9 10.4-24.6 14.2L213 325.6 208.8 340h-15H142.2h-15L123 325.6l-8.4-28.8c-8.7-3.9-17-8.6-24.6-14.2l-29.1 7.2-14.6 3.6-7.5-13L13.1 235.7l-7.5-13L16 211.8l20.8-21.6c-.5-4.7-.8-9.4-.8-14.2s.3-9.5 .8-14.2L16 140.2 5.6 129.3l7.5-13L38.8 71.7l7.5-13 14.6 3.6 29.1 7.2c7.6-5.6 15.8-10.4 24.6-14.2L123 26.4 127.2 12zm30 40l-6.9 23.8-2.9 9.9-9.8 3.4c-11 3.8-21.1 9.7-29.8 17.2l-7.8 6.8-10-2.5L66 104.7 55.2 123.3l17.2 17.9 7.1 7.4-1.9 10.1C76.6 164.3 76 170.1 76 176s.6 11.7 1.6 17.3l1.9 10.1-7.1 7.4L55.2 228.7 66 247.3 90 241.4l10-2.5 7.8 6.8c8.7 7.5 18.8 13.4 29.8 17.3l9.8 3.4 2.9 9.9 6.9 23.8h21.5l6.9-23.8 2.9-9.9 9.8-3.4c11-3.8 21.1-9.7 29.8-17.3l7.8-6.8 10 2.5 24.1 5.9 10.7-18.6-17.1-17.9-7.1-7.4 1.9-10.1c1.1-5.6 1.6-11.3 1.6-17.3s-.6-11.7-1.6-17.3l-1.9-10.1 7.1-7.4 17.1-17.9L270 104.7l-24.1 5.9-10 2.5-7.8-6.8c-8.7-7.5-18.8-13.4-29.8-17.3l-9.8-3.4-2.9-9.9L178.7 52H157.3zM128 176a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM628 303.2v15 51.5 15L613.6 389l-28.8 8.3c-3.9 8.7-8.6 17-14.2 24.6l7.2 29.1 3.6 14.6-13 7.5-44.6 25.8-13 7.5L499.8 496l-21.6-20.8c-4.7 .5-9.4 .8-14.2 .8s-9.5-.3-14.2-.8L428.2 496l-10.8 10.4-13-7.5-44.6-25.8-13-7.5 3.6-14.6 7.2-29.1c-5.6-7.6-10.4-15.9-14.2-24.6L314.4 389 300 384.8v-15V318.2v-15l14.4-4.2 28.8-8.4c3.9-8.7 8.6-17 14.2-24.6l-7.2-29.1-3.6-14.6 13-7.5 44.6-25.8 13-7.5L428.2 192l21.6 20.8c4.7-.5 9.4-.8 14.2-.8s9.5 .3 14.2 .8L499.8 192l10.8-10.4 13 7.5 44.6 25.8 13 7.5-3.6 14.6-7.2 29.1c5.6 7.6 10.4 15.8 14.2 24.6l28.8 8.4 14.4 4.2zm-40 30l-23.8-6.9-9.9-2.9-3.4-9.8c-3.8-11-9.7-21.1-17.2-29.8l-6.8-7.8 2.5-10 5.9-24.1-18.6-10.7-17.9 17.2-7.4 7.1-10.1-1.9c-5.6-1.1-11.3-1.6-17.3-1.6s-11.7 .6-17.3 1.6l-10.1 1.9-7.4-7.1-17.9-17.2L392.7 242l5.9 24.1 2.5 10-6.8 7.8c-7.5 8.7-13.4 18.8-17.3 29.8l-3.4 9.8-9.9 2.9L340 333.3v21.5l23.8 6.9 9.9 2.9 3.4 9.8c3.8 11 9.7 21.1 17.3 29.8l6.8 7.8-2.5 10L392.7 446l18.6 10.7 17.9-17.1 7.4-7.1 10.1 1.9c5.6 1.1 11.3 1.6 17.3 1.6s11.7-.6 17.3-1.6l10.1-1.9 7.4 7.1 17.9 17.1L535.3 446l-5.9-24.1-2.5-10 6.8-7.8c7.5-8.7 13.4-18.8 17.3-29.8l3.4-9.8 9.9-2.9 23.8-6.9V333.3zM464 304a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  
    var faCogs = faGears;
  

  
  

  var faPartyHorn = {
    prefix: 'fasr',
    iconName: 'party-horn',
    icon: [
      512,
      512,
      [],
      'e31b',
      
      'M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.1 136l17-17 8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4 47.7 5.3-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153l-17 17L150.1 136zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3 5.3 47.7-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345l-17 17L342.1 328l17-17zM503.5 42.3l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5-18.3 15.5-31-36.6 18.3-15.5 10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5 31 36.6zM63.9 448.1l79.4-30.9L94.8 368.7 63.9 448.1zM234 381.9l-104-104-16.3 41.9 78.4 78.4L234 381.9zM93 240.9L112 192l37.1 37.1L282.9 362.9 320 400l-48.9 19L32 512 0 480 93 240.9z'
      
    ]
  };

  

  
  

  var faPeace = {
    prefix: 'fasr',
    iconName: 'peace',
    icon: [
      512,
      512,
      [9774],
      'f67c',
      
      'M232 462.6v-156L111.3 405.4c32 31 74 51.9 120.7 57.2zM80.9 368.3L232 244.6V49.4C128.4 61.3 48 149.2 48 256c0 41.4 12.1 79.9 32.9 112.3zm319.8 37.1L280 306.6v156c46.7-5.4 88.7-26.2 120.7-57.2zm30.4-37.1C451.9 335.9 464 297.4 464 256c0-106.8-80.4-194.7-184-206.6V244.6L431.1 368.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faRobot = {
    prefix: 'fasr',
    iconName: 'robot',
    icon: [
      640,
      512,
      [129302],
      'f544',
      
      'M344 24V0H296V24 96H144 96v48V464v48h48H496h48V464 144 96H496 344V24zM296 144h48H496V464H144V144H296zM64 224H0V416H64V224zm576 0H576V416h64V224zM192 384v32h16 32 16V384H240 208 192zm144 0H304 288v32h16 32 16V384H336zm64 0H384v32h16 32 16V384H432 400zM280 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm120 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'
      
    ]
  };

  

  
  

  var faWhale = {
    prefix: 'fasr',
    iconName: 'whale',
    icon: [
      640,
      512,
      [128011],
      'f72c',
      
      'M160 0l24 104 104 24-80 80-83.8-12-8 11.6L80.9 259.1c-5.7 8.3-8 18.5-6.3 28.4C77.7 306.3 93.9 320 113 320h1c9.1 0 17.9-3.1 25-8.8l123.8-99.1C330.9 157.7 415.5 128 502.7 128H592h48v48V432v48H592 162.4C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2l35.6-35.6L92 164 80 80 160 0zM592 432V176H502.7c-76.3 0-150.3 26-209.9 73.6L169 348.7c-15.6 12.5-35 19.3-55 19.3h-1c-24.3 0-46.5-10-62.5-26.5c11 51.7 56.9 90.5 111.9 90.5H592zM392 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faArrowUpTriangleSquare = {
    prefix: 'fasr',
    iconName: 'arrow-up-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-up"],
      'f88a',
      
      'M296 224h56.6H479.4 536l-30-48L444.3 77.3 416 32 387.7 77.3 326 176l-30 48zm86.6-48L416 122.6 449.4 176H382.6zM160 33.3l-17 17-96 96-17 17L64 197.1l17-17 55-55V456v24h48V456 125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM368 432V336h96v96H368zM320 288v48 96 48h48 96 48V432 336 288H464 368 320z'
      
    ]
  };

  
    var faSortShapesUp = faArrowUpTriangleSquare;
  

  
  

  var faTowerControl = {
    prefix: 'fasr',
    iconName: 'tower-control',
    icon: [
      448,
      512,
      [],
      'e2a2',
      
      'M160 0h24 40 40 24V48H264 248V96h56 16v16 16h88 32.3L431 158.9 387.5 304H392h24l0 48H392 368V488v24H320V488 352l-192 0V488v24H80V488 352H56 32l0-48H56h4.5L17 158.9 7.7 128H40h88V112 96h16 56V48H184 160V0zM337.3 304l38.4-128H320V304h17.3zM272 304V176H176V304l96 0zm-144 0V176H72.3l38.4 128H128z'
      
    ]
  };

  

  
  

  var faSpinner = {
    prefix: 'fasr',
    iconName: 'spinner',
    icon: [
      512,
      512,
      [],
      'f110',
      
      'M288 0V64H224V0h64zm81.1 414.4l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zM224 448h64v64H224V448zM52.4 97.6L97.6 52.4l45.3 45.3L97.6 142.9 52.4 97.6zM64 224v64H0V224H64zM52.4 414.4l45.3-45.3 45.3 45.3L97.6 459.6 52.4 414.4zM512 224v64H448V224h64z'
      
    ]
  };

  

  
  

  var faCircleQuarters = {
    prefix: 'fasr',
    iconName: 'circle-quarters',
    icon: [
      512,
      512,
      [],
      'e3f8',
      
      'M108.9 403.1L256 256 403.1 403.1C440.7 365.4 464 313.4 464 256s-23.3-109.4-60.9-147.1L256 256 108.9 108.9C71.3 146.6 48 198.6 48 256s23.3 109.4 60.9 147.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faRotate = {
    prefix: 'fasr',
    iconName: 'rotate',
    icon: [
      512,
      512,
      [128260,"sync-alt"],
      'f2f1',
      
      'M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9L367 129l-21.1 21.1L312 184l33.9 33.9L352 224h96 48V176 80l-6.1-6.1L456 40 422.1 73.9 401 95l-5.1-5.1C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3L94 187.1zM417.9 325.2C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L145 383l21.1-21.1L200 328l-33.9-33.9L160 288H64 16v48 96l6.1 6.1L56 472l33.9-33.9L111 417l5.1 5.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9l-44.1-18.9zM387.9 176L448 115.9V176H387.9zM124.1 336L64 396.1V336h60.1z'
      
    ]
  };

  
    var faSyncAlt = faRotate;
  

  
  

  var faCircleTrash = {
    prefix: 'fasr',
    iconName: 'circle-trash',
    icon: [
      512,
      512,
      ["trash-circle"],
      'e126',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 128h41.4l11.3-11.3 4.7-4.7H224h64 6.6l4.7 4.7L310.6 128H352h16v32H352 160 144V128h16zm0 64H352L336 384H176L160 192z'
      
    ]
  };

  
    var faTrashCircle = faCircleTrash;
  

  
  

  var faHandPeace = {
    prefix: 'fasr',
    iconName: 'hand-peace',
    icon: [
      512,
      512,
      [9996],
      'f25b',
      
      'M210.3 3.3L186.5 .8 184 24.6 174 119 147.6 43.8l-8-22.6-22.6 8L41.5 55.7l-22.6 8 8 22.6L80.9 240H64v24 56 0 24 0c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168v-8V312 256 184 160H424 368v-8V128H344 301.8l9.5-90 2.5-23.9-23.9-2.5L210.3 3.3zM288 181.7c2.2-1.6 4.1-3.5 5.7-5.7H320v8 72H288V181.7zM253.5 128H240v24 88H216.6l-5.4-15.3 18-171.2L261 56.9 253.5 128zM110.3 82.4L165.7 240H131.8L80.1 93l30.2-10.6zM400 256v32H368v-8V208h32v48zm0 80v8c0 66.3-53.7 120-120 120H232c-66.3 0-120-53.7-120-120l0 0 0-24 0 0 0-32H240v32H184 160v48h24 80 24V344 304h32v8 24h24 56z'
      
    ]
  };

  

  
  

  var faDial = {
    prefix: 'fasr',
    iconName: 'dial',
    icon: [
      576,
      512,
      ["dial-med-high"],
      'e15b',
      
      'M320 0H256V64h64V0zM128 64H64v64h64V64zm384 0H448v64h64V64zm0 192v64h64V256H512zm0 192H448v64h64V448zM64 448v64h64V448H64zM0 256v64H64V256H0zm208.8-47.2c37.9-37.9 96.2-43 139.6-15.1L271 271l-17 17L288 321.9l17-17 77.4-77.4c27.8 43.4 22.8 101.7-15.1 139.6c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4zm192.3-33.9A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9z'
      
    ]
  };

  
    var faDialMedHigh = faDial;
  

  
  

  var faAlt = {
    prefix: 'fasr',
    iconName: 'alt',
    icon: [
      640,
      512,
      [],
      'e08a',
      
      'M464 64H453l-7.2 8.4L165 400H24 0v48H24 176h11l7.2-8.4L475 112H616h24V64H616 464zM440 400H416v48h24H616h24V400H616 440z'
      
    ]
  };

  

  
  

  var faDiagramLeanCanvas = {
    prefix: 'fasr',
    iconName: 'diagram-lean-canvas',
    icon: [
      640,
      512,
      [],
      'e156',
      
      'M512 80V296h80V80H512zm-48 0H400v88h64V80zM352 80H288V296h64V80zM240 80H176v88h64V80zM128 80H48V296h80V80zM48 344v88H296V344H48zm296 88H592V344H344v88zM0 32H48 592h48V80 432v48H592 48 0V432 80 32zM240 296V216H176v80h64zm224-80H400v80h64V216z'
      
    ]
  };

  

  
  

  var faMugTeaSaucer = {
    prefix: 'fasr',
    iconName: 'mug-tea-saucer',
    icon: [
      640,
      512,
      [],
      'e1f5',
      
      'M144 80V336H432V80H248v24l40 40V256H176V144l40-40V80H144zM96 32h48H432h16 32 32c70.7 0 128 57.3 128 128s-57.3 128-128 128H480v48 48H432 144 96V336 80 32zM480 240h32c44.2 0 80-35.8 80-80s-35.8-80-80-80H480V240zM24 432H552h24v48H552 24 0V432H24z'
      
    ]
  };

  

  
  

  var faTtyAnswer = {
    prefix: 'fasr',
    iconName: 'tty-answer',
    icon: [
      640,
      512,
      ["teletype-answer"],
      'e2b9',
      
      'M272.4 369.2l31.9 18.4 26-26 33.2-33.2L457.7 366l-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM352 64H288v64h64V64zm-64 96v64h64V160H288zM448 64H384v64h64V64zm32 0v64h64V64H480zm160 0H576v64h64V64zm-64 96v64h64V160H576zm-32 0H384v64H544V160z'
      
    ]
  };

  
    var faTeletypeAnswer = faTtyAnswer;
  

  
  

  var faSpeakers = {
    prefix: 'fasr',
    iconName: 'speakers',
    icon: [
      640,
      512,
      [],
      'f8e0',
      
      'M224 232v56.8c-10.2-10.4-24.3-16.8-40-16.8c-30.9 0-56 25.1-56 56s25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V424c-12.3 5.1-25.8 8-40 8c-57.4 0-104-46.6-104-104s46.6-104 104-104c14.2 0 27.7 2.8 40 8zM240 48H48V464H240v48H48 0V464 48 0H48 240V48zM184 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM320 48V464H592V48H320zM272 0h48H592h48V48 464v48H592 320 272V464 48 0zM456 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM352 328a104 104 0 1 1 208 0 104 104 0 1 1 -208 0zm104 56a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  

  
  

  var faFaceVomit = {
    prefix: 'fasr',
    iconName: 'face-vomit',
    icon: [
      576,
      512,
      [],
      'e3a0',
      
      'M496 256c0 63.4-28.3 120.1-73 158.3c5.8 9.5 14.8 17 25.9 20.7l16.7 5.6C513.9 393.9 544 328.5 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.1-3.7 20.1-11.1 25.9-20.7C108.3 376.1 80 319.4 80 256C80 141.1 173.1 48 288 48s208 93.1 208 208zM262.9 208L144 144l45.7 64L144 272l118.9-64zM432 144L313.1 208 432 272l-45.7-64L432 144zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm544-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 396.1V337.8c10.8 4.3 18.7 8.5 23.1 11.5l13.3 8.9 17.8-26.6-13.3-8.9C406.3 310.3 355.2 288 288 288s-118.3 22.3-136.9 34.7l-13.3 8.9 17.8 26.6 13.3-8.9c4.4-3 12.3-7.2 23.1-11.5v58.3c0 31-19.8 58.5-49.2 68.3L96 480v32H480V480l-46.8-15.6c-29.4-9.8-49.2-37.3-49.2-68.3zM304 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faHammer = {
    prefix: 'fasr',
    iconName: 'hammer',
    icon: [
      576,
      512,
      [128296],
      'f6e3',
      
      'M504 136l-33.9-33.9L405.5 37.5C381.5 13.5 348.9 0 315 0H291.5c-23.2 0-46 6.3-65.9 18.2l-.8 .5L176 48l50.9 25.4L272 96v48l78.1 78.1L384 256l16-16 33.9 33.9 4.1 4.1 1 1-4.8 4.8-17 17 33.9 33.9 17-17 89.6-89.6 17-17-33.9-33.9L527 191l-1-1-4.1-4.1L488 152l16-16zm-67.9 0l-16 16 33.9 33.9L492.1 224 472 244.1l-38.1-38.1L400 172.1l-16 16-64-64V96 66.3L293.5 53.1 284 48.3c2.5-.2 4.9-.3 7.4-.3H315c21.2 0 41.6 8.4 56.6 23.4L436.1 136zM264 181.3L0 416l96 96L330.7 248 264 181.3z'
      
    ]
  };

  

  
  

  var faPersonPraying = {
    prefix: 'fasr',
    iconName: 'person-praying',
    icon: [
      448,
      512,
      [128720,"pray"],
      'f683',
      
      'M224 64a64 64 0 1 1 128 0A64 64 0 1 1 224 64zm-64 80h16 48 13.4l7 11.4 49.4 80.2 82.7-70 18.3-15.5 31 36.6-18.3 15.5-104 88-21.3 18-14.6-23.8-17.2-27.9L194.4 391l114 68.4 11.7 7V480v8 24H296 56 32V464H56 222.7L119.2 401.9c-30.6-18.4-43.2-56.5-29.4-89.4l64-153.7L160 144zm-7.2 222.1l66.6-159.8L210.6 192H192L134.1 330.9c-4.6 11-.4 23.7 9.8 29.8l8.9 5.3z'
      
    ]
  };

  
    var faPray = faPersonPraying;
  

  
  

  var faCloudsSun = {
    prefix: 'fasr',
    iconName: 'clouds-sun',
    icon: [
      640,
      512,
      [],
      'f746',
      
      'M121.3 0L104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104 42-29.4c8.8-37.6 34.2-68.7 68-85.4c-7.5 1.9-15.3 2.9-23.4 2.9c-53 0-96-43-96-96s43-96 96-96c36.6 0 68.4 20.5 84.6 50.6c7.5-23.3 23.6-42.6 44.5-54.4L312 104 294.7 0 208 60.7 121.3 0zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm134.6-32H438l12.6-28.8c5-11.4 16.3-19.2 29.3-19.2c15.4 0 28.4 11 31.3 25.5l7.8 38.5h39.2 9.6c13.2 0 24 10.7 24 24v24H576 553.7c18.8 11.3 33.9 28.1 43.4 48H624h15.9v-48V216c0-39.8-32.2-72-72-72h-9.6c-7.4-36.5-39.7-64-78.4-64c-32.8 0-61 19.7-73.3 48H384c-35.3 0-64 28.6-64 64c0 3 .2 6 .6 8.9c14.6-5.8 30.6-9 47.3-9l.1 0c.1-8.8 7.2-15.9 16-15.9h22.6zm-38 96c26.5 0 48 21.5 48 48v8h49c3.5-13.8 16.1-24 31-24c17.7 0 32 14.3 32 32v40 24h24H560c17.7 0 32 14.3 32 32v32H560h-7.4-24v0h-88 0H304.4l0 0H272.6 240V416c0-26.5 21.5-48 48-48h8.6 24V344 320c0-26.5 21.5-48 48-48zm208 240H616h24V488 432c0-38.5-27.2-70.7-63.4-78.3V336c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C434 242.6 403.4 224 368.6 224c-53 0-96 43-96 96v1.2c-45.7 7.4-80.6 47-80.6 94.8v72 24h24 24.8l0 0h31.8 24 144 0 112 24v0z'
      
    ]
  };

  

  
  

  var faTrophy = {
    prefix: 'fasr',
    iconName: 'trophy',
    icon: [
      576,
      512,
      [127942],
      'f091',
      
      'M312 378.4c4-1.6 8.4-3.6 13.1-6.1c33.8-6 95.5-22 149.5-63.7C530.1 265.7 576 196.5 576 88V64H552 446.4c.3-5.2 .5-10.6 .7-16c.6-15.3 .9-31.3 .9-48H400 176 128c0 16.7 .3 32.7 .9 48c.2 5.4 .4 10.8 .7 16H24 0V88C0 196.5 45.9 265.7 101.5 308.6c53.9 41.7 115.7 57.6 149.5 63.7c4.7 2.5 9.1 4.5 13.1 6.1V464H184 160v48h24H288 392h24V464H392 312V378.4zM445.2 270.6c-17.5 13.6-36.3 24-54.4 32c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-6 78.4-41.3 127.3-81.9 158.6zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-18.1-8-36.8-18.4-54.4-32C90.2 239.3 54.9 190.4 48.9 112zm128-64H399.1c-6.1 153.1-40.8 224.7-68 257.3c-14.7 17.7-28.1 25-36 28.2c-3.1 1.2-5.6 1.9-7.2 2.3c-1.6-.3-4.1-1-7.2-2.3c-7.9-3.1-21.2-10.5-36-28.2C217.7 272.7 183 201.1 176.9 48z'
      
    ]
  };

  

  
  

  var faWheatSlash = {
    prefix: 'fasr',
    iconName: 'wheat-slash',
    icon: [
      640,
      512,
      [],
      'e339',
      
      'M334.3 33.7l-.3 .3c-16.9 17.4-27 38.9-30.4 61.2L288 80l-30.5 28.6c-13.9 13.1-23.7 28.8-29.4 45.7L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L455.6 330.9c.1-.1 .2-.2 .3-.4L496 288l-10-10.3c16.8-3.9 32.8-12.5 45.9-25.6l10.2-10.2L576 208l-29.5-29.5c-1.5-1.5-3-2.9-4.5-4.3c-11.3-10.3-24.1-18.2-37.6-23.7C545.2 142.8 576 107 576 64V48 0H528 512c-43 0-78.8 30.9-86.5 71.6C420 58.1 412.1 45.4 401.8 34c-1.1-1.2-2.3-2.5-3.5-3.7l-.9-.9L368 0 335.2 32.8l-.9 .9zm83 267.6L374 267.6c19.9-.4 39.9 6.7 55.6 21l-8.5 9.1c-1.2 1.3-2.4 2.4-3.7 3.5zM306.9 215.5L270.2 187c.7-14.7 6.5-29.1 17.2-40.5c17.5 19.2 24.1 44.9 19.5 69zM175.8 348.7l8.7 8.7 0 0L82.2 459.8l-17 17 33.9 33.9 17-17L218.5 391.4l8.8 8.8c43.9 43.9 115 43.6 158.6-.2l-38.2-30.1c-25.1 21.2-62.7 20.1-86.5-3.7L254 359c22.3-13.6 49.7-15.3 73.3-5.2L228.4 276c.8 15.8-3 31.9-11.5 45.9l-7.1-7.1c-17.8-17.8-22.9-43.4-15.4-65.6l-39-30.7c-21.5 42-14.9 95 20.5 130.3zm192-280.6c23 26.9 25.3 65.5 6.8 94.7l-5.5-5.5c-24.6-24.6-25-64.1-1.3-89.2zm45.4 133.3c29.2-18.5 67.8-16.2 94.7 6.8l-10 10c-18.7 18.7-49.1 18.7-67.9 0l-16.8-16.8zM512 48h16V64c0 22.1-17.9 40-40 40H472V88c0-22.1 17.9-40 40-40z'
      
    ]
  };

  

  
  

  var faThumbtack = {
    prefix: 'fasr',
    iconName: 'thumbtack',
    icon: [
      384,
      512,
      [128204,128392,"thumb-tack"],
      'f08d',
      
      'M264.6 218.2l17.9 13c18.8 13.8 32.7 32.1 41.9 49.6c5.1 9.7 8 17.7 9.7 23.2H216V216 192H168v24 88H49.4c.2-1 .5-2.1 .9-3.2c1.9-6.5 4.9-14.4 9.4-22.9c9-17 22.6-34.5 41.2-47.6l18.6-13 1.7-22.6L132.4 48H251.6l11.4 148.2 1.7 22zM216 352H336h48V312c0-2.3-.2-4.9-.7-8c-4.1-25.8-26-77.6-72.5-111.5L299.7 48H328h24V0H328 296 88 56 32V48H56 84.3l-11 143C26.1 224.1 4.2 275.6 .6 304c-.4 2.9-.6 5.6-.6 8v40H48 168V488v24h48V488 352z'
      
    ]
  };

  
    var faThumbTack = faThumbtack;
  

  
  

  var faSignatureSlash = {
    prefix: 'fasr',
    iconName: 'signature-slash',
    icon: [
      640,
      512,
      [],
      'e3cb',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L565.2 416H616h24V368H616 503.3l-61.8-48H552h24V272H552 450.1l28.5-79.9 16.1-45.2-45.8 14.2-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96c-37.4 0-69.8 21.4-85.7 52.6L48.4 14.8zM177.7 115.2C183.3 94.9 201.9 80 224 80c26.5 0 48 21.5 48 48v7.9c0 16.9-.9 33.7-2.6 50.5l-91.7-71.2zM343.5 243.9l73.7-22.8-22.4 62.7-51.3-39.9zM406.2 416l-60.9-48H304.1c-7 16.3-14.8 32.4-23.3 48H406.2zM112.9 265.1L96 270.3V288 456v24h24 72 13.6l7-11.7 29.3-48.8c18.5-30.8 33.8-63.3 45.7-97l-40-31.6c-11.5 36.3-27.2 71.2-46.8 103.9L178.4 432H144V305.7l87.7-27.1-45.8-36.1-73 22.6zM64 368H24 0v48H24 64V368z'
      
    ]
  };

  

  
  

  var faPhoneHangup = {
    prefix: 'fasr',
    iconName: 'phone-hangup',
    icon: [
      640,
      512,
      [],
      'e225',
      
      'M416 272v96l160 32 64-160C602.7 192 486.4 96 320 96S37.3 192 0 240L64 400l160-32V272c62.3-20.8 129.7-20.8 192 0zM176 328.6L93.7 345.1 55.6 249.9C99.2 207.1 193.2 144 320 144s220.8 63.1 264.4 105.9l-38.1 95.2L464 328.6V272 237.4l-32.8-10.9c-72.2-24.1-150.2-24.1-222.4 0L176 237.4V272v56.6z'
      
    ]
  };

  

  
  

  var faFaceSmile = {
    prefix: 'fasr',
    iconName: 'face-smile',
    icon: [
      512,
      512,
      [128578,"smile"],
      'f118',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm124 77.3L164 306.7C176 324.8 211.9 352 256 352s80-27.2 92-45.3L388 333.3C368 363.2 317.9 400 256 400s-112-36.8-132-66.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faSmile = faFaceSmile;
  

  
  

  var faPersonSign = {
    prefix: 'fasr',
    iconName: 'person-sign',
    icon: [
      512,
      512,
      [],
      'f757',
      
      'M144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM88 128H72.4l-6.3 14.3-64 144 43.9 19.5L80 229.1V488v24h48V488 352h52.2L208 413.2V488v24h48V488 408v-5.2l-2.2-4.7L216 314.8V210.4L245.3 247l4.1 5.2 6.2 2.3 44.5 16.7-11 30.3L280.8 324l45.1 16.4 8.2-22.6 45-123.7 35 13 45 16.7 16.1-45.2L512 75.6 433 46.2l10-27.4L397.9 2.4 388 29.5 353.8 16.7 308.8 0 292.7 45.2 256 148.4l78.2 29.1L316.5 226l-37.9-14.2L218.7 137l-7.2-9H200 88zm80 176H128V176h40V304zM337.7 62l113.2 42.1L430.3 162 317.1 119.9 337.7 62z'
      
    ]
  };

  

  
  

  var faDisplay = {
    prefix: 'fasr',
    iconName: 'display',
    icon: [
      576,
      512,
      [],
      'e163',
      
      'M48 48H528V368H48V48zM0 416H48 211.7l-8 48H152 128v48h24 72H352h72 24V464H424 372.3l-8-48H528h48V368 48 0H528 48 0V48 368v48zm315.7 0l8 48H252.3l8-48h55.3z'
      
    ]
  };

  

  
  

  var faCoinVertical = {
    prefix: 'fasr',
    iconName: 'coin-vertical',
    icon: [
      384,
      512,
      [],
      'e3fd',
      
      'M204 413.5c-22.2 39.4-45.3 50.5-60 50.5s-37.8-11.1-60-50.5C62.7 375.6 48 320 48 256s14.7-119.6 36-157.5C106.2 59.1 129.3 48 144 48s37.8 11.1 60 50.5c21.3 37.9 36 93.5 36 157.5s-14.7 119.6-36 157.5zM0 256C0 397.4 64.5 512 144 512h48 64c70.7 0 128-114.6 128-256S326.7 0 256 0H192 144C64.5 0 0 114.6 0 256zm286.3 40c1.2-13 1.7-26.4 1.7-40s-.6-27-1.7-40h48c1.1 12.9 1.7 26.3 1.7 40s-.6 27.1-1.7 40h-48zm-4 32h48.1c-3.9 23.7-9.6 45.3-16.6 64H266c7-19.7 12.5-41.2 16.2-64zM228 464c9.1-11.6 17.4-25 24.7-40h46.5c-18.9 33.8-36.3 40-43.1 40H228zM330.3 184H282.2c-3.8-22.8-9.2-44.3-16.2-64h47.7c7 18.7 12.7 40.3 16.6 64zM299.1 88H252.7C245.3 73 237 59.6 228 48h28c6.8 0 24.2 6.2 43.1 40zM120 256c0-40.2 5.2-75.7 12.9-100.3c3.7-11.8 7.7-19.9 11.1-24.7c3.4 4.8 7.3 12.9 11.1 24.7c7.8 24.6 12.9 60 12.9 100.3s-5.2 75.7-12.9 100.3c-3.7 11.8-7.7 19.9-11.1 24.7c-3.4-4.8-7.3-12.9-11.1-24.7c-7.8-24.6-12.9-60-12.9-100.3zm27.4-128.8a.2 .2 0 1 0 .1 .4 .2 .2 0 1 0 -.1-.4zm-6.6 .1a.2 .2 0 1 0 -.5 .1 .2 .2 0 1 0 .5-.1zm-.2 257.4a.2 .2 0 1 0 -.1-.4 .2 .2 0 1 0 .1 .4zm6.6-.1a.2 .2 0 1 0 .5-.1 .2 .2 0 1 0 -.5 .1zM144 80c-17.7 0-30.3 11.3-37.9 21.6c-8 10.7-14.2 24.6-18.9 39.7C77.6 171.7 72 212.3 72 256s5.6 84.3 15.2 114.7c4.8 15.1 10.9 29 18.9 39.7c7.7 10.3 20.2 21.6 37.9 21.6s30.3-11.3 37.9-21.6c8-10.7 14.2-24.6 18.9-39.7c9.6-30.4 15.2-71 15.2-114.7s-5.6-84.3-15.2-114.7c-4.8-15.1-10.9-29-18.9-39.7C174.3 91.3 161.7 80 144 80z'
      
    ]
  };

  

  
  

  var faLocationCheck = {
    prefix: 'fasr',
    iconName: 'location-check',
    icon: [
      384,
      512,
      ["map-marker-check"],
      'f606',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zM182.3 278.3l-17 17-17-17L81.7 211.6l33.9-33.9 49.7 49.7 103-103 33.9 33.9-120 120z'
      
    ]
  };

  
    var faMapMarkerCheck = faLocationCheck;
  

  
  

  var faConveyorBelt = {
    prefix: 'fasr',
    iconName: 'conveyor-belt',
    icon: [
      640,
      512,
      [],
      'f46e',
      
      'M464 48V208H176V48h80v96l64-48 64 48V48h80zm0-48H384 256 176 128V48 208v48h48H464h48V208 48 0H464zM592 400c0 35.3-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64H528c35.3 0 64 28.7 64 64zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H112zm48 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faGlassWaterDroplet = {
    prefix: 'fasr',
    iconName: 'glass-water-droplet',
    icon: [
      384,
      512,
      [],
      'e4f5',
      
      'M77.4 373.9c29.2 9 61.6 3.3 86.1-16.4c16.7-13.3 40.4-13.3 57 0c24.5 19.6 56.9 25.4 86.1 16.4l-7 90.1H84.4l-7-90.1zm-4.3-55L51.9 48H332.1L310.9 318.9l-9.7 5.4c-16.2 9-36.2 7.3-50.7-4.3c-34.2-27.4-82.8-27.4-117 0C119 331.6 99 333.3 82.8 324.3l-9.7-5.4zM40 512H344L380.2 48 384 0H335.9 48.1 0L3.8 48 40 512zM144.1 149.9c-10.4 11.7-16.1 26.7-16.1 42.4c0 35.2 28.8 63.8 64 63.8s64-28.5 64-63.8c0-15.6-5.7-30.7-16.1-42.4L192 96l-47.9 53.9z'
      
    ]
  };

  

  
  

  var faTruckMoving = {
    prefix: 'fasr',
    iconName: 'truck-moving',
    icon: [
      640,
      512,
      [],
      'f4df',
      
      'M48 80V326.7c9.8-4.3 20.6-6.7 32-6.7c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32H432V80H48zM208 480c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80V352 304 80 32H48 432h48V80v64h64 11.4l7.2 8.8 72 88 5.4 6.6V256v32V400H608c0 44.2-35.8 80-80 80s-80-35.8-80-80h-8-8H288c0 44.2-35.8 80-80 80zM532.6 192H480v64H585l-52.4-64zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faPercent = {
    prefix: 'fasr',
    iconName: 'percent',
    icon: [
      384,
      512,
      [62101,62785,"percentage"],
      '25',
      
      'M369 113l17-17L352 62.1 335 79 15 399l-17 17L32 449.9l17-17L369 113zM16 80v96h96V80H16zM272 336v96h96V336H272z'
      
    ]
  };

  
    var faPercentage = faPercent;
  

  
  

  var faHandMiddleFinger = {
    prefix: 'fasr',
    iconName: 'hand-middle-finger',
    icon: [
      448,
      512,
      [128405],
      'f806',
      
      'M184 0H160V24 184H112 88v24 50.5L39.9 302.2 32 309.4V320v38.5c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7H312c66.3 0 120-53.7 120-120v-8V288 248 224H408 360v-8V192H336 288V24 0H264 184zm56 240h24 48v8 24h24 48v16 96 8c0 39.8-32.2 72-72 72H186.6c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5C99.6 429.7 80 395.5 80 358.5V330.6l24-21.8V344v16h32V344 279.7 269.1 264 248 232h48 24V208 48h32V216v24z'
      
    ]
  };

  

  
  

  var faBrightnessLow = {
    prefix: 'fasr',
    iconName: 'brightness-low',
    icon: [
      512,
      512,
      [],
      'e0ca',
      
      'M224 48v64h64V48H224zm32 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM173.3 128L128 82.7 82.7 128 128 173.3 173.3 128zM48 288h64l0-64H48v64zm80 141.3L173.3 384 128 338.7 82.7 384 128 429.3zM288 400H224v64h64V400zm96-61.3L338.7 384 384 429.3 429.3 384 384 338.7zM400 224v64h64V224H400zm-16-50.7L429.3 128 384 82.7 338.7 128 384 173.3z'
      
    ]
  };

  

  
  

  var faGaugeCircleMinus = {
    prefix: 'fasr',
    iconName: 'gauge-circle-minus',
    icon: [
      640,
      512,
      [],
      'e497',
      
      'M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6V120 96h48v24V301.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 208a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16V352H560 432 416v32l16 0 128 0h16z'
      
    ]
  };

  

  
  

  var faCarTilt = {
    prefix: 'fasr',
    iconName: 'car-tilt',
    icon: [
      640,
      512,
      [],
      'f5e5',
      
      'M69.5 79.4L85.9 75 338.7 7.3l16-4.3 9.7 13.4 73.1 100.8 2.5-.7 46.4-12.4 12.4 46.4L529.8 266l12.4 46.4 0 0 19.9 74.4-44.6 12-19.9-74.4-1.7 .5L112.6 427.4l-1.7 .5 9.7 36.1H616h24v48H616 94.4l-8.2 2.2-.6-2.2H24 0V464H24 72.7l-6.5-24.2L60 416.5l-6.2-23.1L22.9 278 10.4 231.6l46.4-12.4 1.7-.5L68.2 96.3l1.3-16.9zM335.2 57.9L114.7 117l-7 88.6 280.1-75.1L335.2 57.9zM69.2 265.6l30.9 115.5L483.4 278.4 452.4 162.9 69.2 265.6zm43.5 50.2a30.8 30.8 0 1 1 59.5-15.9 30.8 30.8 0 1 1 -59.5 15.9zM402.2 206.4a30.8 30.8 0 1 1 15.9 59.5 30.8 30.8 0 1 1 -15.9-59.5z'
      
    ]
  };

  

  
  

  var faVrCardboard = {
    prefix: 'fasr',
    iconName: 'vr-cardboard',
    icon: [
      640,
      512,
      [],
      'f729',
      
      'M346.8 341.7L400 448H592h48V400 112 64H592 48 0v48V400v48H48 240l53.2-106.3 .2-.3L304 320h32l10.7 21.3 .2 .3zM210.3 400H48V112H592V400H429.7L378.9 298.5 365.7 272H336 304 274.3l-13.3 26.5L210.3 400zM224 240A64 64 0 1 0 96 240a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faShieldMinus = {
    prefix: 'fasr',
    iconName: 'shield-minus',
    icon: [
      512,
      512,
      [],
      'e249',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM184 232H160v48h24H328h24V232H328 184z'
      
    ]
  };

  

  
  

  var faThermometer = {
    prefix: 'fasr',
    iconName: 'thermometer',
    icon: [
      512,
      512,
      [],
      'f491',
      
      'M369.8 64.2c10.4-10.4 24.4-16.2 39-16.2c30.5 0 55.2 24.7 55.2 55.2c0 14.6-5.8 28.7-16.2 39L222.1 368H144V289.9l29.7-29.7 31 31L216 302.6 238.6 280l-11.3-11.3-31-31 41.4-41.4 31 31L280 238.6 302.6 216l-11.3-11.3-31-31 41.4-41.4 31 31L344 174.6 366.6 152l-11.3-11.3-31-31 45.5-45.5zM96 280V382.1L18.2 459.8l-17 17 33.9 33.9 17-17L129.9 416H232h9.9l7-7L481.8 176.2c19.4-19.4 30.2-45.6 30.2-73C512 46.2 465.8 0 408.8 0c-27.4 0-53.6 10.9-73 30.2L103 263l-7 7V280z'
      
    ]
  };

  

  
  

  var faCloudMinus = {
    prefix: 'fasr',
    iconName: 'cloud-minus',
    icon: [
      640,
      512,
      [],
      'e35d',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM248 264H392h24v48H392 248 224V264h24z'
      
    ]
  };

  

  
  

  var faTrafficLight = {
    prefix: 'fasr',
    iconName: 'traffic-light',
    icon: [
      320,
      512,
      [128678],
      'f637',
      
      'M48 48V352c0 61.9 50.1 112 112 112s112-50.1 112-112V48H48zM0 0H48 272h48V48 352c0 88.4-71.6 160-160 160S0 440.4 0 352V48 0zM160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-168a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-72a48 48 0 1 1 0-96 48 48 0 1 1 0 96z'
      
    ]
  };

  

  
  

  var faCloudMusic = {
    prefix: 'fasr',
    iconName: 'cloud-music',
    icon: [
      640,
      512,
      [],
      'f8ae',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM416 184v32V344c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V239.1l-96 36V376c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V264 232 220.9l10.4-3.9 128-48 21.6-8.1V184z'
      
    ]
  };

  

  
  

  var faDownToDottedLine = {
    prefix: 'fasr',
    iconName: 'down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e408',
      
      'M64 480V416H0v64H64zm96 0V416H96v64h64zm32 0h64V416H192v64zm160 0V416H288v64h64zm32 0h64V416H384v64zM256 160v48h48 28.1L224 316.1 115.9 208H144h48V160 80h64v80zm1.9 190.1L384 224V208 160H352 336 304V112 80 32H256 192 144V80v32 48H112 96 64v48 16L190.1 350.1 224 384l33.9-33.9z'
      
    ]
  };

  

  
  

  var faFaceExpressionless = {
    prefix: 'fasr',
    iconName: 'face-expressionless',
    icon: [
      512,
      512,
      [],
      'e373',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 72H352h24v48H352 160 136V328h24zM128 192h16 64 16v32H208 144 128V192zm176 0h64 16v32H368 304 288V192h16z'
      
    ]
  };

  

  
  

  var faBabyCarriage = {
    prefix: 'fasr',
    iconName: 'baby-carriage',
    icon: [
      512,
      512,
      ["carriage-baby"],
      'f77d',
      
      'M123 0L256 192H400V120 96h24 64 24v48H488 448v48 32c0 28-6.1 55.6-17.7 81.1c-11.6 25.5-28.6 48.4-49.5 67.5c-21 19.1-45.6 34-72.5 44.1S252.8 432 224 432s-57.4-5.2-84.3-15.3s-51.5-25-72.5-44.1s-37.9-42-49.5-67.5C6.1 279.6 0 252 0 224V192H.1C3.1 108 52.3 35.8 123 0zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM56.1 272c1.5 4.5 3.3 8.9 5.3 13.2c8.8 19.4 21.8 37 38.2 51.9s35.7 26.6 57.1 34.7s44.2 12.2 67.4 12.2s46-4.1 67.4-12.2s40.8-19.8 57.1-34.7s29.3-32.5 38.2-51.9c2-4.3 3.7-8.8 5.3-13.2c3.6-10.4 6-21.1 7.2-32H48.9c1.2 10.9 3.6 21.6 7.2 32z'
      
    ]
  };

  
    var faCarriageBaby = faBabyCarriage;
  

  
  

  var faRadio = {
    prefix: 'fasr',
    iconName: 'radio',
    icon: [
      512,
      512,
      [128251],
      'f8d7',
      
      'M485.7 55.3L509 49.6 497.6 3 474.3 8.7l-456 112L0 125.2V128v16 32V304v24V464v48H48 464h48V464 176 128H464 189.8l296-72.7zM48 176H464V464H48V328 304 176zM352 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM112 240H96v32h16 96 16V240H208 112zM96 304H80v32H96 224h16V304H224 96zm16 64H96v32h16 96 16V368H208 112z'
      
    ]
  };

  

  
  

  var faEllipsisStroke = {
    prefix: 'fasr',
    iconName: 'ellipsis-stroke',
    icon: [
      512,
      512,
      ["ellipsis-h-alt"],
      'f39b',
      
      'M72 232l48 0 0 48-48 0 0-48zM32 280l0 40 40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48zm200-48l48 0 0 48-48 0 0-48zm-40 48l0 40 40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48zm200 0l0-48 48 0 0 48-48 0zm-40 40l40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48 0 40z'
      
    ]
  };

  
    var faEllipsisHAlt = faEllipsisStroke;
  

  
  

  var faBatteryQuarter = {
    prefix: 'fasr',
    iconName: 'battery-quarter',
    icon: [
      576,
      512,
      ["battery-2"],
      'f243',
      
      'M496 144V368H48V144H496zM48 96H0v48V368v48H48 496h48V368 320h32V192H544V144 96H496 48zm144 96H96V320h96V192z'
      
    ]
  };

  
    var faBattery2 = faBatteryQuarter;
  

  
  

  var faVideoSlash = {
    prefix: 'fasr',
    iconName: 'video-slash',
    icon: [
      640,
      512,
      [],
      'f4e2',
      
      'M29.4 .1l19 14.7L111.8 64H368h48v48 48V288v12.2L560 412V370.3 352 288 141.7l-112 56V144L560 88l48-24v53.7V352v42.3V448v1.3l12.9 10 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1zM368 262.9V112H173.6L368 262.9zM416 440v8H368 80 32V400 121.2L80 159V400H368V385.9l48 37.8V440z'
      
    ]
  };

  

  
  

  var faFrame = {
    prefix: 'fasr',
    iconName: 'frame',
    icon: [
      448,
      512,
      [],
      'e495',
      
      'M448 144l0-48-64 0 0-64-48 0 0 64L112 96l0-64L64 32l0 64L0 96l0 48 64 0 0 224L0 368l0 48 64 0 0 64 48 0 0-64 224 0 0 64 48 0 0-64 64 0 0-48-64 0 0-224 64 0zM112 368l0-224 224 0 0 224-224 0z'
      
    ]
  };

  

  
  

  var faComputerClassic = {
    prefix: 'fasr',
    iconName: 'computer-classic',
    icon: [
      448,
      512,
      [],
      'f8b1',
      
      'M400 48V384H48V48H400zM48 0H0V48 384v48H32v32 48H80 368h48V464 432h32V384 48 0H400 48zM80 432H368v32H80V432zM80 80V240H368V80H80zM208 304v32h16H352h16V304H352 224 208zm-88 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPumpSoap = {
    prefix: 'fasr',
    iconName: 'pump-soap',
    icon: [
      448,
      512,
      [],
      'e06b',
      
      'M112 0h24H248h24V24 40h64 9.9l7 7 56 56 17 17L392 153.9l-17-17-49-49H272v40H224V48H160v80H112V24 0zM80.1 512H32l3.3-48L56 160H328l20.7 304 3.3 48H303.9 80.1zm220.5-48L283.2 208H100.8L83.4 464H300.6zM192 272l43.7 54.2c7.9 9.8 12.3 22 12.3 34.7c0 30.5-24.7 55.2-55.2 55.2h-1.7c-30.5 0-55.2-24.7-55.2-55.2c0-12.6 4.3-24.9 12.3-34.7L192 272z'
      
    ]
  };

  

  
  

  var faCarRear = {
    prefix: 'fasr',
    iconName: 'car-rear',
    icon: [
      512,
      512,
      ["car-alt"],
      'f5de',
      
      'M102.7 32H120 392h17.3l5.5 16.4L457.3 176H464h48v48V352v48H480v80H432V400H80v80H32V400H0V352 224 176H48h6.7L97.2 48.4 102.7 32zm272 48H137.3l-32 96H406.7l-32-96zM48 224v32h80v48H48v48H192V288H320v64H464V304H384V256h80V224H48z'
      
    ]
  };

  
    var faCarAlt = faCarRear;
  

  
  

  var faRetweet = {
    prefix: 'fasr',
    iconName: 'retweet',
    icon: [
      576,
      512,
      [],
      'f079',
      
      'M0 208H48 72V392v24H96 296h24V368H296 120V208h24 48V160L129.9 97.9 96 64 62.1 97.9 0 160v48zm96-76.1L124.1 160H67.9L96 131.9zM576 304H528 504V120 96H480 280 256v48h24H456V304H432 384v48l62.1 62.1L480 448l33.9-33.9L576 352V304zm-96 76.1L451.9 352h56.2L480 380.1z'
      
    ]
  };

  

  
  

  var faClockFive = {
    prefix: 'fasr',
    iconName: 'clock-five',
    icon: [
      512,
      512,
      [],
      'e349',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V248.7l60 90 13.3 20-39.9 26.6-13.3-20-64-96-4-6V256 120 96h48v24z'
      
    ]
  };

  

  
  

  var faSignalWeak = {
    prefix: 'fasr',
    iconName: 'signal-weak',
    icon: [
      640,
      512,
      ["signal-1"],
      'f68c',
      
      'M88 384v24 80 24H40V488 408 384H88z'
      
    ]
  };

  
    var faSignal1 = faSignalWeak;
  

  
  

  var faChevronRight = {
    prefix: 'fasr',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M321.9 256l-17 17L113 465l-17 17L62.1 448l17-17 175-175L79 81l-17-17L96 30.1l17 17L305 239l17 17z'
      
    ]
  };

  

  
  

  var faGenderless = {
    prefix: 'fasr',
    iconName: 'genderless',
    icon: [
      384,
      512,
      [],
      'f22d',
      
      'M192 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352z'
      
    ]
  };

  

  
  

  var faBriefcaseMedical = {
    prefix: 'fasr',
    iconName: 'briefcase-medical',
    icon: [
      512,
      512,
      [],
      'f469',
      
      'M128 0h24H360h24V24 96h80 48v48V432v48H464 48 0V432 144 96H48h80V24 0zM336 48H176V96H336V48zM48 144V432H464V144H360 152 48zm176 48h64v64h64v64H288v64H224V320H160V256h64V192z'
      
    ]
  };

  

  
  

  var faTurntable = {
    prefix: 'fasr',
    iconName: 'turntable',
    icon: [
      576,
      512,
      [],
      'f8e4',
      
      'M528 80V432H48V80H528zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zm448 80H448v24V281.9l-45.1 82.6-11.5 21.1 42.1 23 11.5-21.1 48-88 2.9-5.4V288 136 112zM368 256A144 144 0 1 0 80 256a144 144 0 1 0 288 0zm-176 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faPersonToDoor = {
    prefix: 'fasr',
    iconName: 'person-to-door',
    icon: [
      576,
      512,
      [58704],
      'e433',
      
      'M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM136 112h-8l-6.4 4.8-64 48L38.4 179.2l28.8 38.4 19.2-14.4L144 160h33.4l-31.8 95.4c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L215.4 512h50.3l45.3-144.8 5.8-18.5-16.9-9.5-43.4-24.4 28.1-84.4 12.5 40.8 5.2 16.9H320h72 24V240H392 337.7l-26.8-87.1-3.9-12.6-12.7-3.5-88-24-3.1-.8H200 136zm55.1 158.5l34.2-102.7 27 7.4L213.8 290.7l-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5zM103.4 368H24 0v48H24h96 16.6l5.9-15.5 18-47.9-4.9-2.8c-14.1-8-25.4-19.3-33-32.6L103.4 368zM528 48V464H432V320H384V464v48h48 96 48V464 48 0H528 432 384V48 208h48V48h96z'
      
    ]
  };

  

  
  

  var faDisease = {
    prefix: 'fasr',
    iconName: 'disease',
    icon: [
      512,
      512,
      [],
      'f7fa',
      
      'M276.4 88L267 102.1c-31.8 47.7-88.6 72.3-145.1 62.9L62.3 155c-7.4-1.2-14.2 4.5-14.2 12c0 3.2 1.3 6.3 3.6 8.6L17.7 209.6C6.4 198.3 .1 183 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-10c-7.9 0-15.8 .9-23.6 2.6L86.1 432.4c-36 8-70.1-19.4-70.1-56.2c0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42c0-15.6-6.2-30.5-17.2-41.5L17.7 209.6l33.9-33.9 29.2 29.2c20 20 31.2 47.1 31.2 75.4c0 28.7-11.6 56.2-32.1 76.3L66.9 369.4c-1.8 1.8-2.9 4.3-2.9 6.8c0 6.1 5.7 10.7 11.6 9.3l62.3-13.8c11.2-2.5 22.6-3.7 34-3.7h10c38.1 0 75.2 13 104.9 36.8l30.9 24.7c2 1.6 4.5 2.5 7 2.5c6.2 0 11.3-5 11.3-11.3l0-25.2c0-54.7 33.6-103.7 84.6-123.5l36.9-14.3c4-1.5 6.6-5.3 6.6-9.6c0-5-3.5-9.2-8.4-10.1l-28-5.1c-55.4-10.1-99.4-52.4-111.8-107.4L308.8 94c-1.8-8.2-9.1-14-17.5-14c-6 0-11.6 3-14.9 8zM120 224l40-40 40 40-40 40-40-40zm128 96l40-40 40 40-40 40-40-40zm56-88l-24-24 24-24 24 24-24 24z'
      
    ]
  };

  

  
  

  var faNotdef = {
    prefix: 'fasr',
    iconName: 'notdef',
    icon: [
      384,
      512,
      [],
      'e1fe',
      
      'M0 0H24 360h24V24 488v24H360 24 0V488 24 0zM48 421.8L162.8 256 48 90.2V421.8zM77.2 464H306.8L192 298.2 77.2 464zm144-208L336 421.8V90.2L221.2 256zM306.8 48H77.2L192 213.8 306.8 48z'
      
    ]
  };

  

  
  

  var faTrashCanUndo = {
    prefix: 'fasr',
    iconName: 'trash-can-undo',
    icon: [
      448,
      512,
      ["trash-can-arrow-turn-left","trash-undo-alt"],
      'f896',
      
      'M160 0H147.2L140 10.7 93.8 80H80 32 0v48H32V464v48H80 368h48V464 128h32V80H416 368 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM80 464V128H368V464H80zM241.9 210L210 174.1l-17.9 15.9-72 64L99.9 272l20.2 17.9 72 64L210 369.9 241.9 334l-17.9-15.9L199.1 296H240c22.1 0 40 17.9 40 40v24 24h48V360 336c0-48.6-39.4-88-88-88H199.1l24.8-22.1L241.9 210z'
      
    ]
  };

  
    var faTrashCanArrowTurnLeft = faTrashCanUndo;
  
    var faTrashUndoAlt = faTrashCanUndo;
  

  
  

  var faFilterSlash = {
    prefix: 'fasr',
    iconName: 'filter-slash',
    icon: [
      640,
      512,
      [],
      'e17d',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L408.3 294.2 576 96V80 32H528 112 70.5L48.4 14.8zm84 65.2H526.7L370.3 264.7 132.4 80zM288 360.9v-38l-48-37.8V384l112 89.6L400 512V450.5 411.2l-48-37.8v38.8l-64-51.2z'
      
    ]
  };

  

  
  

  var faTablePivot = {
    prefix: 'fasr',
    iconName: 'table-pivot',
    icon: [
      512,
      512,
      [],
      'e291',
      
      'M0 32H128V160H0V32zM160 160V32H512V480H0V192H128V432H464V160H160zm208 32l48 48v16H384v80 16H368 288v32H272l-48-48 48-48h16v32h64V256H320V240l48-48z'
      
    ]
  };

  

  
  

  var faHandLizard = {
    prefix: 'fasr',
    iconName: 'hand-lizard',
    icon: [
      512,
      512,
      [],
      'f258',
      
      'M0 64H24 344h11.7l7.2 9.2 144 184 5.1 6.5V272 424v24H464V424 280.3L332.3 112H48v48H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H112v48H288h6.9l5.8 3.6 64 40 11.3 7V400v24 24H328V424 413.3L281.1 384H88 64V360 264 240H88 240c8.8 0 16-7.2 16-16s-7.2-16-16-16H24 0V184 88 64z'
      
    ]
  };

  

  
  

  var faMoneyBillSimple = {
    prefix: 'fasr',
    iconName: 'money-bill-simple',
    icon: [
      576,
      512,
      [],
      'e1f1',
      
      'M48 112V400H528V112H48zM0 64H48 528h48v48V400v48H528 48 0V400 112 64zm288 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faClouds = {
    prefix: 'fasr',
    iconName: 'clouds',
    icon: [
      640,
      512,
      [],
      'f744',
      
      'M390.4 188.8c4.6 3.5 9 7.2 13.1 11.1c12.2-4.5 25.3-7.2 39-7.8c3.6-10 5.5-20.9 5.5-32.1c0-53-43-96-96-96H309.2C291.2 26.2 252.7 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192v48 48H48 96h64.9c1.9-17.1 6.8-33.3 14.1-48H96 48V192c0-26.5 21.4-47.9 47.9-48l1 0 41.9 .2 5.9-41.5C149.1 71.8 175.8 48 208 48c25.5 0 47.5 14.9 57.9 36.6l13 27.4h30.3H352c26.5 0 48 21.5 48 48c0 10.8-3.6 20.8-9.6 28.8zM496 320v48h48c26.5 0 48 21.5 48 48v48H544 224 176V416c0-20.8 13.3-38.7 32-45.3l32-11.3V325.5 304c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM128 512h48 48H544h48 48V464 416c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C375.3 210.8 341.9 192 304 192c-61.9 0-112 50.1-112 112v21.5c-37.3 13.2-64 48.7-64 90.5v48 48z'
      
    ]
  };

  

  
  

  var faBacteria = {
    prefix: 'fasr',
    iconName: 'bacteria',
    icon: [
      640,
      512,
      [],
      'e059',
      
      'M323.9 17.2l-7.5 16.3-.3 .6c14.6 7.9 26.9 20.2 34.7 35.5L361 66.7l17.3-4.9 9.9 34.6-17.3 4.9-11 3.1c.8 17.6-4.1 34.6-13.2 48.8l8 8L367.4 174 342 199.5l-12.7-12.7-8-8c-7.9 5.1-16.8 8.9-26.4 11.1c-5.9 1.4-11.4 2.9-16.6 4.6l3 10.6 4.9 17.3-34.6 9.9-4.9-17.3-1.6-5.6c-17.8 10.8-29 23.4-36.5 34.5l8.5 3.6 16.5 7.1-14.2 33.1-16.5-7.1-9.6-4.1c-.8 2.9-1.4 5.8-1.8 8.7c-1.4 13.3-6 25.6-12.7 36.2l8 8L199.5 342 174 367.5l-12.7-12.7-8-8c-14.1 9-31 13.9-48.8 13.2l-3.1 11-4.9 17.3-34.6-9.9L66.7 361l2.9-10.3c-15.1-7.8-27.5-19.9-35.5-34.7l-.6 .3-16.3 7.5L2.1 291.2l16.3-7.5 5.7-2.6c-.2-4.2-.2-8.4 .2-12.6c1.1-12.1 3.8-24.2 7-35.9c.2-.8 .4-1.5 .7-2.3l-8.7-3.5L6.6 220 20 186.6l16.7 6.7 7.4 3c4.6-10.7 10.3-22.2 17.4-34c1.4-2.4 2.9-4.8 4.5-7.3l-11.2-9L40.7 134.8l22.5-28.1 14.1 11.2L87.3 126c10.2-12.2 22-24.1 35.5-35.3L117 82 107 67l30-20 10 15 4.9 7.4c13.7-8.8 28.7-16.8 45.2-23.9l-3.6-8.5-7.1-16.5L219.5 6.4l7.1 16.5 4.4 10.3c8.4-2.6 17.1-4.9 26.2-7c8-1.9 16.1-2.5 23.9-2l2.6-5.7 7.5-16.3 32.7 15.1zM143.8 279.9c.1-.7 .2-1.4 .3-2.1c3.2-20.9 11.7-39.5 20.3-53.8c18-30 52.2-65.4 119.7-80.9c19.4-4.5 31.5-23.8 27-43.2s-23.8-31.5-43.2-27c-88.4 20.4-138.2 69-165.3 114.1c-13.3 22.1-20.8 42.9-25 58.3c-2.8 10-4.7 19.2-5.5 27.6c-1.8 19.8 12.8 37.2 32.6 39c19.6 1.8 36.9-12.5 39-31.9zm352.4-47.8c-.1 .7-.2 1.4-.3 2.1c-3.2 20.9-11.7 39.5-20.3 53.8c-18 30-52.2 65.4-119.7 80.9c-19.4 4.5-31.4 23.8-27 43.2s23.8 31.5 43.2 27c88.4-20.4 138.2-69 165.3-114.1c13.3-22.1 20.8-42.9 25-58.3c2.8-10 4.7-19.2 5.5-27.6c1.8-19.8-12.8-37.2-32.6-39c-19.6-1.8-36.9 12.5-39 31.9zm39.3-80l3.1-11 4.9-17.3 34.6 9.9-4.9 17.3-2.9 10.3c15.1 7.8 27.5 19.9 35.5 34.7l.6-.3 16.3-7.5 15.1 32.7-16.3 7.5-5.7 2.6c.2 4.2 .2 8.4-.2 12.6c-1.1 12.1-3.8 24.2-7 35.9c-.2 .8-.4 1.5-.7 2.3l8.7 3.5 16.7 6.7L620 325.4l-16.7-6.7-7.4-3c-4.6 10.7-10.3 22.2-17.4 34c-1.4 2.4-3 4.8-4.5 7.3l11.2 9 14.1 11.2-22.5 28.1-14.1-11.2L552.7 386c-10.2 12.2-22 24.1-35.5 35.3L523 430l10 15-30 20-10-15-4.9-7.4c-13.7 8.8-28.7 16.8-45.2 23.9l3.6 8.5 7.1 16.5-33.1 14.2-7.1-16.5-4.4-10.3c-8.4 2.6-17.1 4.9-26.2 7c-8 1.9-16.1 2.5-23.9 2l-2.6 5.7-7.5 16.3-32.7-15.1 7.5-16.3 .3-.6c-14.6-7.9-26.9-20.2-34.7-35.5l-10.3 2.9-17.3 4.9-9.9-34.6 17.3-4.9 11-3.1c-.8-17.6 4.1-34.6 13.2-48.8l-8-8L272.5 338 298 312.5l12.7 12.7 8 8c7.9-5.1 16.8-8.9 26.4-11.1c5.9-1.4 11.4-2.9 16.6-4.6l-3-10.6-4.9-17.3 34.6-9.9 4.9 17.3 1.6 5.6c17.8-10.8 29-23.4 36.5-34.5l-8.5-3.6-16.5-7.1 14.2-33.1 16.5 7.1 9.6 4.1c.8-2.9 1.4-5.8 1.8-8.7c1.4-13.3 5.9-25.6 12.7-36.2l-8-8L440.5 170 466 144.5l12.7 12.7 8 8c14.1-9 31-13.9 48.8-13.2zM192 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM400 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fasr',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M-1.9 256l17-17L207 47l17-17L257.9 64 241 81 65.9 256 241 431l17 17L224 481.9l-17-17L15 273l-17-17z'
      
    ]
  };

  

  
  

  var faArrowLeftToArc = {
    prefix: 'fasr',
    iconName: 'arrow-left-to-arc',
    icon: [
      512,
      512,
      [],
      'e616',
      
      'M279.7 134.4l-112 104L148.7 256l18.9 17.6 112 104 17.6 16.3 32.7-35.2-17.6-16.3L245.1 280 488 280l24 0 0-48-24 0-242.9 0 67.2-62.4 17.6-16.3-32.7-35.2-17.6 16.3zM48 256C48 141.1 141.1 48 256 48l24 0 0-48L256 0C114.6 0 0 114.6 0 256S114.6 512 256 512l24 0 0-48-24 0C141.1 464 48 370.9 48 256z'
      
    ]
  };

  

  
  

  var faNose = {
    prefix: 'fasr',
    iconName: 'nose',
    icon: [
      448,
      512,
      [],
      'e5bd',
      
      'M164.8 38.4L400 352V464H313.9l-17-17-56-56-7-7H224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64H424h24V488 344v-8l-4.8-6.4-240-320L164.8 38.4zM214.1 432l32 32H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h22.1zM141 303.5l23.5-5-10.1-46.9-23.5 5-22.8 4.9C45.1 274.9 0 330.7 0 395.2c0 40.6 18 79.1 49.2 105.1l7.4 6.2 30.7-36.9-7.4-6.2C59.7 446.5 48 421.5 48 395.2c0-41.9 29.2-78 70.2-86.8l22.8-4.9z'
      
    ]
  };

  

  
  

  var faHollyBerry = {
    prefix: 'fasr',
    iconName: 'holly-berry',
    icon: [
      512,
      512,
      [],
      'f7aa',
      
      'M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM92.6 300.3L8 336.2l30.2 77-5.5 44.8L26.1 512l50.7-19.5 41.7-16 37.7 4.2L204 486l5.2-47.7 3.8-34.6L256 386l43.1 17.6 3.8 34.6L308 486l47.7-5.3 37.7-4.2 41.7 16L485.9 512l-6.6-53.9-5.5-44.8 30.2-77-84.6-35.9L412 219.9l-88.9 5-45.1-16.4-6.7-2.4 .1-6.1L223 214.6l-34.1 10.3-88.9-5-7.5 80.4zM270 256.7L306.7 270l9.3 3.4 9.8-.6 42.7-2.4 3.2 34.3 2.7 28.6 26.4 11.2 41.6 17.6-13.2 33.6L424.7 407l1.5 12.1 2.4 19.5-17.9-6.9-10.9-4.2-11.6 1.3L350.5 433l-3.8-34.5L343.7 370l-26.5-10.8-28.5-11.6-19.5-59.3 .7-31.5zM143.5 270.4l42.7 2.4 8.5 .5 8.1-2.5 19-5.8-.5 22-.2 8.2 2.6 7.8 12.8 39-41.7 17.1L168.3 370l-3.1 28.4L161.5 433l-37.6-4.1-11.6-1.3-10.9 4.2-17.9 6.9 2.4-19.5L87.3 407l-4.4-11.3L69.7 362.2l41.6-17.6 26.4-11.2 2.7-28.6 3.2-34.3z'
      
    ]
  };

  

  
  

  var faLinkHorizontalSlash = {
    prefix: 'fasr',
    iconName: 'link-horizontal-slash',
    icon: [
      640,
      512,
      ["chain-horizontal-slash"],
      'e1cc',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-45.3-35.2c38.8-25.8 64.4-69.9 64.4-120c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5-3.2 47.9 8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 39.4-23.7 73.2-57.6 87.9L415.1 299.5c20.6-24.9 32.9-56.9 32.9-91.6C448 128.4 383.6 64 304.1 64H143.9c-9.7 0-19.3 1-28.5 2.8l-67-52zM173.6 112H304.1c52.9 0 95.9 42.9 95.9 95.9c0 23.6-8.6 45.4-22.9 62.2L173.6 112zM385.8 400H335.9c-53 0-95.9-42.9-95.9-95.9c0-6 .6-12 1.6-17.7l-40.8-32.1c-5.7 15.6-8.9 32.4-8.9 49.8C192 383.6 256.4 448 335.9 448H446.8l-60.9-48zM67.8 149.5L30.1 119.7C11.2 144.1 0 174.7 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5 3.2-47.9-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-22 7.4-42.2 19.8-58.4z'
      
    ]
  };

  
    var faChainHorizontalSlash = faLinkHorizontalSlash;
  

  
  

  var faDrumstickBite = {
    prefix: 'fasr',
    iconName: 'drumstick-bite',
    icon: [
      512,
      512,
      [],
      'f6d7',
      
      'M233.5 352l-58.4 58.3C185.6 421.1 192 435.8 192 452c0 33.1-26.9 60-60 60s-60-26.9-60-60V440H60c-33.1 0-60-26.9-60-60s26.9-60 60-60c16.2 0 30.9 6.4 41.6 16.8L160 278.5V256 232 176C160 78.8 238.8 0 336 0c76.3 0 141.3 48.6 165.7 116.5c6.1 17 9.7 35.3 10.2 54.3C497.4 163.9 481.1 160 464 160l-1 0c-61.4 .5-111 50.5-111 112c0 10.5 1.5 20.8 4.2 30.4c4.7 16.5 13 31.5 24.1 44c-14.1 3.7-29 5.6-44.3 5.6H325.4 280 256 233.5zM208 270.1L241.9 304H256h51.2c-2.1-10.3-3.2-21-3.2-32c0-82.7 62.8-150.8 143.4-159.1C425.4 74.1 383.7 48 336 48c-70.7 0-128 57.3-128 128v80 14.1z'
      
    ]
  };

  

  
  

  var faDinosaur = {
    prefix: 'fasr',
    iconName: 'dinosaur',
    icon: [
      640,
      512,
      [],
      'e5fe',
      
      'M432 0h-8.9l-6.7 5.8-56 48L352 61V72v40 9.9l7 7 24 24 7 7H400h72c13.3 0 24 10.7 24 24v40H455.3l-34.4-22.9C380.7 174.3 333.5 160 285.2 160c-60.8 0-119.5 22.7-164.5 63.6L7.9 326.2 0 333.4V344 488v24H24 296h24V488 410.6 389.3l-21.2-2.5L160 370.6V352H136 112v24 16 21.4l21.2 2.5L272 432v32H48V354.6l105.1-95.5c36.2-32.9 83.3-51.1 132.2-51.1c38.8 0 76.7 11.5 109 33l40.5 27 6 4H448h72 24V248 184c0-39.8-32.2-72-72-72H409.9l-9.9-9.9V83l40.9-35h22.3C534.3 48 592 105.7 592 176.8V195c0 72.1-32 140.4-87.4 186.5l-8.6 7.2 0 11.2 0 64H480l-16 0H432V432 396.6l-32.8 13.1-.1 0c-.2 .1-.5 .2-.9 .3c-.9 .3-2.4 .8-4.6 1.5c-4.2 1.3-10.8 3.1-19.5 5c-6.2 1.3-13.6 2.6-22.1 3.8v48.4c12.3-1.5 23-3.4 31.9-5.2l.1 0V488v24h24 56 24l32 0h24l0-24 0-77c61-55 96-133.4 96-215.9V176.8C640 79.2 560.8 0 463.2 0H432zm48 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faAngleUp = {
    prefix: 'fasr',
    iconName: 'angle-up',
    icon: [
      448,
      512,
      [8963],
      'f106',
      
      'M224 126.1l17 17L401 303l17 17L384 353.9l-17-17-143-143L81 337l-17 17L30.1 320l17-17L207 143l17-17z'
      
    ]
  };

  

  
  

  var faMessageMinus = {
    prefix: 'fasr',
    iconName: 'message-minus',
    icon: [
      512,
      512,
      ["comment-alt-minus"],
      'f4a7',
      
      'M160 464v48l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464zm117.4-87.9L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM184 184H160v48h24H328h24V184H328 184z'
      
    ]
  };

  
    var faCommentAltMinus = faMessageMinus;
  

  
  

  var faFill = {
    prefix: 'fasr',
    iconName: 'fill',
    icon: [
      512,
      512,
      [],
      'f575',
      
      'M33.9 305.9L0 272l33.9-33.9L127 145 39 57l-17-17L56 6.1 73 23l88 88 77.1-77.1L272 0l33.9 33.9L478.1 206.1 512 240l-33.9 33.9L273.9 478.1 240 512l-33.9-33.9L33.9 305.9zm127-127L67.9 272l16 16H396.1l48-48L272 67.9 194.9 145 225 175l17 17L208 225.9l-17-17L161 178.9z'
      
    ]
  };

  

  
  

  var faGlassHalf = {
    prefix: 'fasr',
    iconName: 'glass-half',
    icon: [
      384,
      512,
      ["glass-half-empty","glass-half-full"],
      'e192',
      
      'M70.6 288H313.4L299.6 464H84.4L70.6 288zm-3.8-48L51.9 48H332.1l-15 192H66.9zM40 512H344L380.2 48 384 0H335.9 48.1 0L3.8 48 40 512z'
      
    ]
  };

  
    var faGlassHalfEmpty = faGlassHalf;
  
    var faGlassHalfFull = faGlassHalf;
  

  
  

  var faMessageCode = {
    prefix: 'fasr',
    iconName: 'message-code',
    icon: [
      512,
      512,
      [],
      'e1df',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM217 161l17-17L200 110.1l-17 17-64 64-17 17 17 17 64 64 17 17L233.9 272l-17-17-47-47 47-47zM329 127l-17-17L278.1 144l17 17 47 47-47 47-17 17L312 305.9l17-17 64-64 17-17-17-17-64-64z'
      
    ]
  };

  

  
  

  var faSchoolFlag = {
    prefix: 'fasr',
    iconName: 'school-flag',
    icon: [
      576,
      512,
      [],
      'e56e',
      
      'M312 0H416V96H318.1l89.6 64H552h24v24V488v24H552 336 240 24 0V488 184 160H24 168.3L264 91.6V24 0h24 24zM528 464V208H400h-7.7l-6.3-4.5-98.1-70-98.1 70-6.3 4.5H176 48V464H240V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64H528zM240 240a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-80 16v64H96V256h64zm256 0h64v64H416V256zM160 352v64H96V352h64zm320 0v64H416V352h64z'
      
    ]
  };

  

  
  

  var faTablet = {
    prefix: 'fasr',
    iconName: 'tablet',
    icon: [
      448,
      512,
      ["tablet-android"],
      'f3fb',
      
      'M48 48V464H400V48H48zM0 0H48 400h48V48 464v48H400 48 0V464 48 0zM192 400h64 16v32H256 192 176V400h16z'
      
    ]
  };

  
    var faTabletAndroid = faTablet;
  

  
  

  var faCommentQuote = {
    prefix: 'fasr',
    iconName: 'comment-quote',
    icon: [
      512,
      512,
      [],
      'e14c',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM240 144H128V256h64v32H168 144v48h24 48 24V312 256 208 184 144zm144 0H272V256h64v32H312 288v48h24 48 24V312 256 208 184 144z'
      
    ]
  };

  

  
  

  var faCameraSlash = {
    prefix: 'fasr',
    iconName: 'camera-slash',
    icon: [
      640,
      512,
      [],
      'e0d9',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L576 424.4V144 96H528 437.3L416 32H224L202.7 96H153L48.4 14.8zM214.8 144h22.5l10.9-32.8L258.6 80H381.4l10.4 31.2L402.7 144h34.6H528V387.2l-98.3-76.3c1.5-7.4 2.3-15 2.3-22.8c0-61.9-50.1-112-112-112c-17.7 0-34.4 4.1-49.3 11.4L214.8 144zM382.5 274.2L317.9 224c.7 0 1.4 0 2.1 0c30.6 0 56.2 21.5 62.5 50.2zM487.4 480l-60.9-48H112V184.2L64 146.4V432v48h48H487.4zM370.6 388l-45.9-36.1c-1.6 .1-3.1 .2-4.7 .2c-31.8 0-58.2-23.2-63.2-53.6L211 262.2c-1.9 8.3-3 16.9-3 25.8c0 61.9 50.1 112 112 112c18.2 0 35.4-4.3 50.6-12z'
      
    ]
  };

  

  
  

  var faCloudBoltSun = {
    prefix: 'fasr',
    iconName: 'cloud-bolt-sun',
    icon: [
      640,
      512,
      ["thunderstorm-sun"],
      'f76e',
      
      'M121.3 0L208 60.7 294.7 0l13.2 79c-20.5 10.9-37.7 27.3-49.6 47.2c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2v97.8L121.3 416 104 312 0 294.7 60.7 208 0 121.3 104 104 121.3 0zM294.7 416l-.1-.1h.2l0 .1zM242.1 168.4c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6zM368.6 144c-26.5 0-48 21.5-48 48v24 24h-24H288c-26.5 0-48 21.5-48 48v48h16v8.4V384H240.8l0 0H216 192V360 288c0-47.8 34.9-87.4 80.6-94.8V192c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.7-14.4 45.8-14.4c44.2 0 80 35.8 80 80v17.7c36.2 7.6 63.4 39.8 63.4 78.3v56 24H616 576.6v0h-24H544V336h8.6H560h32V304c0-17.7-14.3-32-32-32h-7.4-24V248 208c0-17.7-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16H416.6v0c0-26.5-21.5-48-48-48zM336 512l40-128H288V360L464 224 424 352h88v24L336 512z'
      
    ]
  };

  
    var faThunderstormSun = faCloudBoltSun;
  

  
  

  var faBellSlash = {
    prefix: 'fasr',
    iconName: 'bell-slash',
    icon: [
      640,
      512,
      [61943,128277],
      'f1f6',
      
      'M544 399.6V368l-64-72V208c0-77.4-55-142-128-156.8V0H288V51.2c-42.9 8.7-79.5 34.5-102.5 70.1L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L544 399.6zM223.7 150.9C243.2 118 279 96 320 96c61.9 0 112 50.1 112 112v88 16.6L223.7 150.9zM406.2 416l-60.9-48h-185l35.7-40.1L208 314.2V296 259.9l-48-37.8V296L96 368v48h48H406.2zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z'
      
    ]
  };

  

  
  

  var faStoreLock = {
    prefix: 'fasr',
    iconName: 'store-lock',
    icon: [
      640,
      512,
      [],
      'e4a6',
      
      'M579.6 103.8c14.4 22.8 15.6 49.9 6.7 72.6c-13.5-8.3-29-13.8-45.5-15.6c.2-.4 .3-.8 .5-1.2c4.1-9.5 3.6-20.7-2.1-29.9L486 48H154l-53.2 81.7c-5.7 9.1-6.2 20.3-2.1 29.9c3.9 9.3 11 14.8 19.9 16c2 .3 4 .4 5.8 .4c11.8 0 22.3-5.1 29.6-13.2l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2c11.8 0 22.3-5.1 29.6-13.2l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2c11.9 0 22.3-5.1 29.6-13.2l35.5-39.3 35.6 39.2c1.3 1.4 2.6 2.7 4.1 3.9c-21.7 7.8-40.2 22.2-53.3 40.7c-14.4 10.4-32.1 16.7-51.5 16.7c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 12c-14.4 10.6-32.4 17-52 17c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 11.9c-14.4 10.6-32.4 17-52 17l0 0c-4 0-8.1-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L128 0H512l67.6 103.8zM144 336H384l0 48H144v80H384l0 48H144 96V464 384 336 252.6c3.9 1 7.9 1.7 12 2.3l.1 0c5.3 .7 10.7 1.1 16.3 1.1c6.7 0 13.3-.6 19.6-1.6V336zm384-96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H416V320h32V272z'
      
    ]
  };

  

  
  

  var faEyeDropperHalf = {
    prefix: 'fasr',
    iconName: 'eye-dropper-half',
    icon: [
      512,
      512,
      [],
      'e173',
      
      'M208 177.9l-9-9-8-8-17-17L208 110.1l17 17 8 8 33.9-33.9 71.3-71.3c19.1-19.1 45-29.8 72-29.8C466.4 0 512 45.6 512 101.8c0 27-10.7 52.9-29.8 72l-71.3 71.3L377 279l8 8 17 17L368 337.9l-17-17-8-8-9-9-25-25L233 202.9l-25-25zM372.1 63.8L266.9 169 343 245.1 448.2 139.9c10.1-10.1 15.8-23.8 15.8-38.1C464 72.1 439.9 48 410.2 48c-14.3 0-28 5.7-38.1 15.8zM180.4 195.6l33.9 33.9L123.9 320H260.1l22.3-22.3 33.9 33.9L168 480H80L40 512 0 472l32-40V344L180.4 195.6z'
      
    ]
  };

  

  
  

  var faBezierCurve = {
    prefix: 'fasr',
    iconName: 'bezier-curve',
    icon: [
      640,
      512,
      [],
      'f55b',
      
      'M352 80v64H288V80h64zM288 32H240V80v8H123.3C113.9 64.5 90.9 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40h79C138.2 173.8 93.9 241.5 88.5 320H80 32v48 64 48H80h64 48V432 368 320H144h-7.3C142.4 253.9 183 197.8 240 170.3V192h48 64 48V170.3c57 27.6 97.6 83.7 103.3 149.7H496 448v48 64 48h48 64 48V432 368 320H560h-8.5c-5.3-78.5-49.7-146.2-113.8-184h79c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64s-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H400V80 32H352 288zM48 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm512 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 368v64H80V368h64zm352 0h64v64H496V368z'
      
    ]
  };

  

  
  

  var faSignalStreamSlash = {
    prefix: 'fasr',
    iconName: 'signal-stream-slash',
    icon: [
      640,
      512,
      [],
      'e250',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-81.3-63.1C562.8 354.7 576 306.9 576 256c0-67.4-23.2-129.4-61.9-178.5l-37.7 29.7C508.7 148.2 528 199.8 528 256c0 39.8-9.7 77.3-26.8 110.3l-51.7-40.2c9.4-21.5 14.5-45.2 14.5-70.2c0-41.2-14.2-79.1-37.9-109.1l-37.7 29.7C405.7 198.5 416 226 416 256c0 13.7-2.2 27-6.2 39.4L48.4 14.8zM163.8 225l-40.3-31.7C116.1 212.8 112 233.9 112 256c0 41.2 14.2 79.1 37.9 109.1l37.7-29.7C170.3 313.5 160 286 160 256c0-10.7 1.3-21.1 3.8-31zM71.5 152.3L33 122C11.9 162 0 207.6 0 256c0 67.4 23.2 129.4 61.9 178.5l37.7-29.7C67.3 363.8 48 312.2 48 256c0-37.1 8.4-72.3 23.5-103.7z'
      
    ]
  };

  

  
  

  var faFolderCheck = {
    prefix: 'fasr',
    iconName: 'folder-check',
    icon: [
      512,
      512,
      [],
      'e64e',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm97 97L241 369l-17 17-17-17-64-64-17-17L160 254.1l17 17 47 47L335 207l17-17L385.9 224l-17 17z'
      
    ]
  };

  

  
  

  var faSquareDivide = {
    prefix: 'fasr',
    iconName: 'square-divide',
    icon: [
      448,
      512,
      [],
      'e26a',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm256 96v64H192V128h64zM136 232H312h24v48H312 136 112V232h24zm56 88h64v64H192V320z'
      
    ]
  };

  

  
  

  var faSignHanging = {
    prefix: 'fasr',
    iconName: 'sign-hanging',
    icon: [
      512,
      512,
      ["sign"],
      'f4d9',
      
      'M112 0V24 64l376 0h24v48H488l-376 0V488v24H64V488 112H24 0V64l24 0H64V24 0h48zm80 192V336H432V192H192zm-48-48h48H432h48v48V336v48H432 192 144V336 192 144z'
      
    ]
  };

  
    var faSign = faSignHanging;
  

  
  

  var faVacuumRobot = {
    prefix: 'fasr',
    iconName: 'vacuum-robot',
    icon: [
      512,
      512,
      [],
      'e04e',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm335-79c-43.6-43.6-114.4-43.6-158.1 0L143 143c62.4-62.4 163.5-62.4 225.9 0s62.4 163.5 0 225.9L335 335c43.6-43.6 43.6-114.4 0-158.1zM224 201.4l11.3 11.3 64 64L310.6 288 288 310.6l-11.3-11.3-64-64L201.4 224 224 201.4zm-80 16l11.3 11.3 128 128L294.6 368 272 390.6l-11.3-11.3-128-128L121.4 240 144 217.4zm-16 80l11.3 11.3 64 64L214.6 384 192 406.6l-11.3-11.3-64-64L105.4 320 128 297.4z'
      
    ]
  };

  

  
  

  var faAngle = {
    prefix: 'fasr',
    iconName: 'angle',
    icon: [
      448,
      512,
      [],
      'e08c',
      
      'M0 480V450.1l2.7-5.2 208-400 11.1-21.3 42.6 22.1L253.3 67.1 63.5 432H424h24v48H424 24 0zM311.5 247.4l-40.8 25.6c-14.8-20.1-32-38.3-51.3-54.1L242 175.5c26.5 20.4 49.9 44.7 69.5 71.9zm-15.6 66.4l40.8-25.6c16.8 32 28.7 66.9 34.7 103.8H322.7c-5.3-27.6-14.4-53.9-26.8-78.2z'
      
    ]
  };

  

  
  

  var faOliveBranch = {
    prefix: 'fasr',
    iconName: 'olive-branch',
    icon: [
      640,
      512,
      [],
      'e317',
      
      'M0 64S48 0 128 0c60.2 0 102.3 36.3 119.4 54.2L357.8 2.3C361 .8 364.5 0 368 0H616h24V48H616 373.4L191.9 133.4C189.1 219.3 118.6 288 32 288H16 0V272 256c0-61.4 34.5-114.6 85.2-141.5C31.2 100.4 0 64 0 64zM399.4 427c19.3-25.7 32.6-63.3 32.6-107s-13.3-81.3-32.6-107c-19.2-25.7-42.2-37-63.4-37s-44.2 11.4-63.4 37C253.3 238.7 240 276.4 240 320s13.3 81.3 32.6 107c19.2 25.7 42.2 37 63.4 37s44.2-11.4 63.4-37zM336 512c-79.5 0-144-86-144-192s64.5-192 144-192s144 86 144 192s-64.5 192-144 192zm129.7-40.2c9.4-13.1 17.6-27.5 24.4-43.1c3.6 .8 7.1 1.5 10.5 2c31.1 4.6 55-3.6 70.2-19.3c15.4-16 23.9-42.1 19.2-76c-4.7-33.8-22.2-71.6-53.2-103.7c-18-18.7-37.7-32.5-57.2-41.7c-4.9-8.8-10.3-17.2-16.2-25c-10.5-14-22.7-26.5-36.2-36.9c48.2 1.6 101.3 25.8 144.2 70.3c75 77.8 90.2 188.1 33.9 246.4c-34.1 35.4-86.8 43.5-139.6 27z'
      
    ]
  };

  

  
  

  var faPlugCircleMinus = {
    prefix: 'fasr',
    iconName: 'plug-circle-minus',
    icon: [
      576,
      512,
      [],
      'e55e',
      
      'M120 24V0H72V24v88h48V24zm192 0V0H264V24v88h48V24zM24 144H0v48H24h8v64c0 80.2 59 146.6 136 158.2V512h48V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8 24V144H360h-8H304 80 32 24zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 16H496 368 352V352h16H496h16v32z'
      
    ]
  };

  

  
  

  var faArrowTrendUp = {
    prefix: 'fasr',
    iconName: 'arrow-trend-up',
    icon: [
      576,
      512,
      [],
      'e098',
      
      'M352 96h24H552h24v24V296v24H528V296 177.9L337 369l-17 17-17-17-111-111L52.2 397.8l-17 17L1.3 380.8l17-17L175 207l17-17 17 17 111 111L494.1 144H376 352V96z'
      
    ]
  };

  

  
  

  var faStore = {
    prefix: 'fasr',
    iconName: 'store',
    icon: [
      576,
      512,
      [],
      'f54e',
      
      'M483.4 224c-19.6 0-37.6-6.5-52.1-17.2c-4.7-3.5-9.1-7.4-13-11.8c-3.9 4.3-8.2 8.2-12.9 11.7c-14.5 10.8-32.5 17.3-52.3 17.3c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 12c-14.4 10.6-32.4 17-52 17c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 11.9c-14.4 10.6-32.4 17-52 17c0 0 0 0 0 0c-4 0-8.1-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L96 0H480l67.6 103.8c29.7 46.9 3.4 112-52.1 119.4c-4 .5-7.9 .8-12.1 .8c0 0 0 0 0 0zm-391-48c11.8 0 22.3-5.1 29.6-13.2l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2c11.8 0 22.3-5.1 29.6-13.2l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2c11.9 0 22.3-5.1 29.6-13.2l35.5-39.3 35.6 39.2c7.4 8.2 18 13.2 29.7 13.2c2 0 3.8-.1 5.8-.4c9-1.2 16.1-6.8 20.1-16c4.1-9.5 3.6-20.7-2.1-29.9L454 48H122L68.8 129.7c-5.7 9.1-6.2 20.3-2.1 29.9c3.9 9.3 11 14.8 19.9 16c2 .3 4 .4 5.8 .4zM112 336H464V254.4c6.3 1 12.8 1.6 19.4 1.6c5.6 0 10.9-.4 16.2-1.1l.1 0c4.2-.6 8.3-1.3 12.3-2.3V336v48 80 48H464 112 64V464 384 336 252.6c3.9 1 7.9 1.7 12 2.3l.1 0c5.3 .7 10.7 1.1 16.3 1.1c6.7 0 13.3-.6 19.6-1.6V336zm352 48H112v80H464V384z'
      
    ]
  };

  

  
  

  var faDisplayArrowDown = {
    prefix: 'fasr',
    iconName: 'display-arrow-down',
    icon: [
      576,
      512,
      [],
      'e164',
      
      'M48 0H224V48H48V368H528V48H352V0H528h48V48 368v48H528 364.3l8 48H424h24v48H424 352 224 152 128V464h24 51.7l8-48H48 0V368 48 0H48zM323.7 464l-8-48H260.3l-8 48h71.3zM312 24V198.1l39-39 17-17L401.9 176l-17 17-80 80-17 17-17-17-80-80-17-17L208 142.1l17 17 39 39V24 0h48V24z'
      
    ]
  };

  

  
  

  var faCircleGf = {
    prefix: 'fasr',
    iconName: 'circle-gf',
    icon: [
      512,
      512,
      [],
      'e67f',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM184 128c39.8 0 72 32.2 72 72l0 24-48 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8-24 0 0-48 24 0 24 0 24 0 0 24 0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112c0-39.8 32.2-72 72-72zm104 0l24 0 64 0 24 0 0 48-24 0-40 0 0 64 24 0 24 0 0 48-24 0-24 0 0 72 0 24-48 0 0-24 0-72 0-48 0-88 0-24z'
      
    ]
  };

  

  
  

  var faChartScatter = {
    prefix: 'fasr',
    iconName: 'chart-scatter',
    icon: [
      512,
      512,
      [],
      'f7ee',
      
      'M48 56V32H0V56 456v24H24 488h24V432H488 48V56zm176 72H160v64h64V128zM192 288H128v64h64V288zm128-64H256v64h64V224zm32 128h64V288H352v64zM448 96H384v64h64V96z'
      
    ]
  };

  

  
  

  var faFaceEyesXmarks = {
    prefix: 'fasr',
    iconName: 'face-eyes-xmarks',
    icon: [
      512,
      512,
      [],
      'e374',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM137 135l23 23 23-23 17-17L233.9 152l-17 17-23 23 23 23 17 17L200 265.9l-17-17-23-23-23 23-17 17L86.1 232l17-17 23-23-23-23-17-17L120 118.1l17 17zm192 0l23 23 23-23 17-17L425.9 152l-17 17-23 23 23 23 17 17L392 265.9l-17-17-23-23-23 23-17 17L278.1 232l17-17 23-23-23-23-17-17L312 118.1l17 17zM256 304c44.2 0 80 35.8 80 80v16H176V384c0-44.2 35.8-80 80-80z'
      
    ]
  };

  

  
  

  var faPlanetMoon = {
    prefix: 'fasr',
    iconName: 'planet-moon',
    icon: [
      576,
      512,
      [],
      'e01f',
      
      'M512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM224 464c97.2 0 176-78.8 176-176c0-82.2-56.4-151.3-132.6-170.6L176 224l32 32H320v64L264 424H224V352H192V288l-64-64H60c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176zM0 288c0-52.3 17.9-100.5 48-138.6c1-1.3 2.1-2.6 3.2-3.9C92.2 95.7 154.4 64 224 64c13.3 0 26.4 1.2 39.1 3.4C368.2 85.9 448 177.6 448 288c0 123.7-100.3 224-224 224S0 411.7 0 288z'
      
    ]
  };

  

  
  

  var faFolderMinus = {
    prefix: 'fasr',
    iconName: 'folder-minus',
    icon: [
      512,
      512,
      [],
      'f65d',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zM184 272H328h24v48H328 184 160V272h24z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleArrowRight = {
    prefix: 'fasr',
    iconName: 'floppy-disk-circle-arrow-right',
    icon: [
      576,
      512,
      ["save-circle-arrow-right"],
      'e180',
      
      'M48 480H0V432 80 32H48 336L448 144v48.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9v-31l-80-80V184v24H296 104 80V184 80H48V432H268c6.9 17.5 16.4 33.7 28.2 48H48zM224 256c22.1 0 41.6 11.2 53.1 28.3C263.7 309.2 256 337.7 256 368c0 2.5 .1 4.9 .2 7.4c-9.4 5.5-20.4 8.6-32.2 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64zM128 80v80H272V80H128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-78.6L417.4 312l11.3 11.3L457.4 352H368 352v32h16 89.4l-28.7 28.7L417.4 424 440 446.6l11.3-11.3 56-56L518.6 368l-11.3-11.3-56-56L440 289.4z'
      
    ]
  };

  
    var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
  

  
  

  var faPhotoFilm = {
    prefix: 'fasr',
    iconName: 'photo-film',
    icon: [
      640,
      512,
      ["photo-video"],
      'f87c',
      
      'M240 48V304h15.6l69.1-94.2L344 183.4l19.4 26.4L380 232.4l56-85.6L456 116.1l20.1 30.7L578.8 304H592V48H240zM192 0h48H592h48V48 304v48H592 240 192V304 48 0zM136 128h24v48 88V376v8 80H352V384h48v80h64V384h48v80 48H464 400 376 352 160 136 112 48 0V464 176 128H48h64 24zm-24 48H48v64h64V176zM48 464h64V400H48v64zm0-112h64V288H48v64zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faPhotoVideo = faPhotoFilm;
  

  
  

  var faVideoArrowDownLeft = {
    prefix: 'fasr',
    iconName: 'video-arrow-down-left',
    icon: [
      576,
      512,
      [],
      'e2c8',
      
      'M336 112V400H48V112H336zM48 64H0v48V400v48H48 336h48V400 352 160 112 64H336 48zM528 370.3l-112-56V368l112 56 48 24V394.3 117.7 64L528 88 416 144v53.7l112-56V370.3zM232 352h24V304H232 177.9L281 201l17-17L264 150.1l-17 17-103 103V216 192H96v24V328v24h24H232z'
      
    ]
  };

  

  
  

  var faCandleHolder = {
    prefix: 'fasr',
    iconName: 'candle-holder',
    icon: [
      448,
      512,
      [128367],
      'f6bc',
      
      'M160 144c17.7 0 32-14.3 32-32c0 0 0 0 0-.1c-.1-.6-.9-4.9-5.9-13.4c-5.2-8.9-12.9-18.6-21.6-28.3c-1.5-1.6-3-3.3-4.5-4.8c-1.5 1.6-3 3.2-4.5 4.8c-8.8 9.7-16.4 19.4-21.6 28.3c-5 8.5-5.7 12.7-5.9 13.4c0 .1 0 .1 0 .1c0 17.7 14.3 32 32 32zM160 0s80 64 80 112c0 44.2-35.8 80-80 80s-80-35.8-80-80C80 64 160 0 160 0zM0 464H24 48V272 224H96 224h48v48V464h36.1c-2.7-7.5-4.1-15.6-4.1-24c0-39.8 32.2-72 72-72s72 32.2 72 72c0 39.7-32.2 71.9-71.8 72l-.1 0H376 272 224 96 48 24 0V464zM224 272H176v56 24H128V328 272H96V464H224V272zM376 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faClockTen = {
    prefix: 'fasr',
    iconName: 'clock-ten',
    icon: [
      512,
      512,
      [],
      'e354',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120v91.2L173.3 172l-20-13.3-26.6 39.9 20 13.3 96 64L280 300.8V256 120 96H232v24z'
      
    ]
  };

  

  
  

  var faSirenOn = {
    prefix: 'fasr',
    iconName: 'siren-on',
    icon: [
      640,
      512,
      [],
      'e02e',
      
      'M69.3 36l48 32 20 13.3-26.6 39.9L90.7 108l-48-32-20-13.3L49.3 22.7 69.3 36zM597.3 76l-48 32-20 13.3L502.7 81.3l20-13.3 48-32 20-13.3 26.6 39.9L597.3 76zM24 192H88h24v48H88 24 0V192H24zm528 0h64 24v48H616 552 528V192h24zM490 304H441.6l-20-160H218.4l-20 160H150L176 96H464l26 208zm-246.1 0l12.2-98 1.8-14h32.2l-2.2 18-11.8 94H243.9zM496 384H144v48H496V384zM144 336H496h48v48 48 48H496 144 96V432 384 336h48z'
      
    ]
  };

  

  
  

  var faRocket = {
    prefix: 'fasr',
    iconName: 'rocket',
    icon: [
      512,
      512,
      [],
      'f135',
      
      'M224 391.8c-25.3 11-42.6 17.9-42.6 17.9l-80.8-80.8s6.9-16.5 17.9-41L0 287.6 80 128l119.9 0c2.5-4 4.9-7.7 7.3-11.3C296.6-15.1 433.7-7.9 502.7 9.3c17.2 68.9 24.5 206-107.4 295.4c-3.6 2.4-7.3 4.9-11.3 7.3L384 432 224 512l0-120.2zm-31.4-38.8c13.8-5.9 31.3-13.5 50.4-22.2c45-20.5 95.1-45.3 125.3-65.8C460 202.9 470.2 113 461.7 50.3C399 41.8 309.1 52 247 143.7C226.4 174 201.1 224 180.2 268.6c-8.8 18.7-16.5 35.9-22.5 49.5l35 35zM368 104a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  

  
  

  var faClockEleven = {
    prefix: 'fasr',
    iconName: 'clock-eleven',
    icon: [
      512,
      512,
      [],
      'e347',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120v56.7l-20-30-13.3-20-39.9 26.6 13.3 20 64 96L280 256V120 96H232v24z'
      
    ]
  };

  

  
  

  var faLassoSparkles = {
    prefix: 'fasr',
    iconName: 'lasso-sparkles',
    icon: [
      576,
      512,
      [],
      'e1c9',
      
      'M291.3 0c-1.1 0-2.2 0-3.3 0C128.9 0 0 78.8 0 176c0 60.6 50.2 114.1 126.6 145.8l44.3 20.5c22.6 10.4 37.1 33 37.1 57.9c0 35.2-28.6 63.8-63.8 63.8H56 32v48H56h88.2C205.9 512 256 461.9 256 400.2c0-17.8-4.2-34.9-11.9-50.2c14.3 1.3 29 2 43.9 2c159.1 0 288-78.8 288-176c0-76.2-79.2-141.1-190.1-165.6l6.5 13.1L449 51.8V81.1c48.5 23.4 79 57.3 79 94.9c0 70.7-107.5 128-240 128S48 246.7 48 176c0-58.1 72.7-107.2 172.2-122.8l59.3-29.7L291.3 0zM469.3 405.3L416 432l53.3 26.7L496 512l26.7-53.3L576 432l-53.3-26.7L496 352l-26.7 53.3zM336 0L309.3 53.3 256 80l53.3 26.7L336 160l26.7-53.3L416 80 362.7 53.3 336 0z'
      
    ]
  };

  

  
  

  var faFaceDisappointed = {
    prefix: 'fasr',
    iconName: 'face-disappointed',
    icon: [
      512,
      512,
      [],
      'e36f',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5-35.1-32.7 16.4-17.5C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5zM222.6 256l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 233.4 222.6 256zm78.1 11.3L289.4 256 312 233.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faFileCircleInfo = {
    prefix: 'fasr',
    iconName: 'file-circle-info',
    icon: [
      576,
      512,
      [58604],
      'e493',
      
      'M48 464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 48 0H48 256L384 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48V464zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm15.3 64h-32v32h32V288zm1.2 64l-16 0L416 352l-16 0 0 32 16 0 .5 0v48l-.5 0-16 0 0 32 16 0 32 0h.5l15.5 0 0-32-15.5 0V368 352z'
      
    ]
  };

  

  
  

  var faArrowLeftFromArc = {
    prefix: 'fasr',
    iconName: 'arrow-left-from-arc',
    icon: [
      512,
      512,
      [],
      'e615',
      
      'M130.9 134.4L148.5 118l32.7 35.2-17.6 16.3L96.4 232 328 232l24 0 0 48-24 0L96.4 280l67.2 62.4 17.6 16.3-32.7 35.2-17.6-16.3-112-104L0 256l18.9-17.6 112-104zM464 256c0-114.9-93.1-208-208-208l-24 0 0-48 24 0C397.4 0 512 114.6 512 256s-114.6 256-256 256l-24 0 0-48 24 0c114.9 0 208-93.1 208-208z'
      
    ]
  };

  

  
  

  var faMap = {
    prefix: 'fasr',
    iconName: 'map',
    icon: [
      576,
      512,
      [62072,128506],
      'f279',
      
      'M168 373.4l-120 40V130.6l120-40V373.4zm192 48l-144-48V90.6l144 48V421.4zm48 0V138.6l120-40V381.4l-120 40zM0 480l48-16 144-48 192 64 192-64V82.6 32L528 48 384 96 192 32 0 96V429.4 480z'
      
    ]
  };

  

  
  

  var faUserHairLong = {
    prefix: 'fasr',
    iconName: 'user-hair-long',
    icon: [
      448,
      512,
      [],
      'e45b',
      
      'M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16 48L48 240v32H224 400V240l-48-48V144 128C352 57.3 294.7 0 224 0zM66.6 464l32-96H349.4l32 96H66.6zM64 320L16 464 0 512H50.6 397.4 448l-16-48L384 320H64z'
      
    ]
  };

  

  
  

  var faAxeBattle = {
    prefix: 'fasr',
    iconName: 'axe-battle',
    icon: [
      512,
      512,
      [],
      'f6b3',
      
      'M511 215c-5.1 59.5-29 103.2-50.5 131.3C441.3 371.4 424 384 424 384s-6.3-20.1-21.8-44.4c-17.3-26.9-46-59-90.2-74.4V215c52 13.6 88.9 44.8 113.3 74.7c3 3.7 5.8 7.4 8.5 11c11-17.8 21.3-40.6 26.6-68.5l-6.3-6.3L420.1 192l33.9-33.9 6.3-6.3c-5.3-28-15.6-50.8-26.6-68.5c-2.6 3.6-5.5 7.3-8.5 11C400.9 124.2 364 155.4 312 169V118.8c44.2-15.4 72.9-47.5 90.2-74.4C417.7 20.1 424 0 424 0s17.3 12.6 36.5 37.7C482 65.7 506 109.5 511 169l-23 23 23 23zM109.8 44.4c17.3 26.9 46 59 90.2 74.4V169c-52-13.6-88.9-44.8-113.3-74.7c-3-3.7-5.8-7.4-8.5-11C62.5 108.8 48 144.8 48 192s14.5 83.2 30.3 108.7c2.6-3.6 5.5-7.3 8.5-11C111.1 259.8 148 228.6 200 215v50.2c-44.2 15.4-72.9 47.5-90.2 74.4C94.3 363.9 88 384 88 384s-17.3-12.6-36.5-37.7C27.3 314.8 0 263.3 0 192S27.3 69.2 51.5 37.7C70.7 12.6 88 0 88 0s6.3 20.1 21.8 44.4zM280 56V488v24H232V488 56 32h48V56z'
      
    ]
  };

  

  
  

  var faCars = {
    prefix: 'fasr',
    iconName: 'cars',
    icon: [
      640,
      512,
      [],
      'f85b',
      
      'M87.1 0H104 312h16.9l5.7 15.9 40 112 0 .1h-51L295.1 48H120.9L92.3 128H323.7L312 128l-22.8 0-7.4 21.6L272.6 176H48v80H192l0 16 0 32H48v64H0V304 272 256 176 128H41.4l0-.1 40-112L87.1 0zM112 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm193.4-16.1l5.7-15.9H328 536h16.9l5.7 15.9L592.9 272H640v48 80 16 32 64H592V448H272v64H224V448 416 400 320 272h47.1l34.3-96.1zM576.6 320c-.4 0-.7 0-1.1 0H288.6c-.4 0-.7 0-1.1 0H272v80H592V320H576.6zM344.9 208l-22.9 64H541.9l-22.9-64H344.9zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faShekelSign = {
    prefix: 'fasr',
    iconName: 'shekel-sign',
    icon: [
      448,
      512,
      [8362,"ils","shekel","sheqel","sheqel-sign"],
      'f20b',
      
      'M40 32H16V56 456v24H64V456 80H184c39.8 0 72 32.2 72 72V336v24h48V336 152c0-66.3-53.7-120-120-120H40zM312 480c66.3 0 120-53.7 120-120V56 32H384V56 360c0 39.8-32.2 72-72 72H192V184 160H144v24V456v24h24H312z'
      
    ]
  };

  
    var faIls = faShekelSign;
  
    var faShekel = faShekelSign;
  
    var faSheqel = faShekelSign;
  
    var faSheqelSign = faShekelSign;
  

  
  

  var faTally2 = {
    prefix: 'fasr',
    iconName: 'tally-2',
    icon: [
      640,
      512,
      [],
      'e295',
      
      'M152 64V40H104V64 448v24h48V448 64zm128 0V40H232V64 448v24h48V448 64z'
      
    ]
  };

  

  
  

  var faTeeth = {
    prefix: 'fasr',
    iconName: 'teeth',
    icon: [
      576,
      512,
      [],
      'f62e',
      
      'M48 80v93.4C63.9 150.8 90.2 136 120 136c15.2 0 29.5 3.9 42 10.7c16.1-21.1 41.4-34.7 70-34.7c21.3 0 40.8 7.5 56 20.1c15.2-12.6 34.7-20.1 56-20.1c31.1 0 58.5 16.2 74.1 40.5c11.5-5.5 24.3-8.5 37.9-8.5c29.8 0 56.1 14.8 72 37.4V80H48zm0 282.6V432H528V362.6c-15.9 22.6-42.2 37.4-72 37.4c-21.3 0-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1c-29.8 0-56.1-14.8-72-37.4zM0 32H48 528h48V80 432v48H528 48 0V432 80 32zM384 288H368 352 336 320 304v16 8c0 9 3 17.3 8 24c1.1 1.4 2.2 2.8 3.5 4c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c1.2-1.3 2.4-2.6 3.4-4c5-6.7 8-15 8-24v-8V288zm112 0H464 448 432 416v16 8c0 9 3 17.3 8 24c1.1 1.4 2.2 2.8 3.4 4c7.3 7.4 17.4 12 28.6 12c13.1 0 24.7-6.3 32-16c5-6.7 8-15 8-24V288zm-48-24h16 32V240v-8c0-5.7-1.2-11.1-3.3-16c-6.2-14.1-20.3-24-36.7-24c-9 0-17.3 3-24 8l0 0c-5.5 4.1-9.9 9.6-12.7 16c-2.1 4.9-3.3 10.3-3.3 16v8 16 8h16 16zM304 200v8 32 16h16 16 16 16 16V240v-8V208v-8c0-5.1-1-10-2.7-14.5C375.5 170.6 361 160 344 160c-11.2 0-21.3 4.6-28.6 12c-7.1 7.2-11.4 17.1-11.4 28zm-72-40c-15.2 0-28.4 8.5-35.2 21c-3.1 5.7-4.8 12.1-4.8 19v8 16 16 16h16 16 16 16 16V240 208v-8c0-10.9-4.4-20.8-11.4-28c-7.3-7.4-17.4-12-28.6-12zM192 288v16 8c0 9 3 17.3 8 24c1.1 1.4 2.2 2.8 3.5 4c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c1.2-1.3 2.4-2.6 3.5-4c5-6.7 8-15 8-24v-8V288H256l-16 0-16 0H208 192zm-32 0H144 128 112 80v16 8c0 9 3 17.3 8 24c7.3 9.7 18.9 16 32 16c11.2 0 21.3-4.6 28.6-12c1.2-1.3 2.4-2.6 3.5-4c5-6.7 8-15 8-24v-8V288zM120 184c-16.4 0-30.5 9.9-36.7 24c-2.1 4.9-3.3 10.3-3.3 16v16 16h32 16 16 16V240 224c0-5.7-1.2-11.1-3.3-16c-1.2-2.9-2.8-5.5-4.7-8c-2.2-2.9-4.8-5.5-7.7-7.7c-6.7-5.2-15.2-8.3-24.3-8.3z'
      
    ]
  };

  

  
  

  var faBlender = {
    prefix: 'fasr',
    iconName: 'blender',
    icon: [
      512,
      512,
      [],
      'f517',
      
      'M0 0H24 128h32 16.2H462.5 512L500 48l-20 80L428 336h4 48v48 80 48H432 144 96V464 384 336h48 12l-6.7-80H24 0V232 24 0zM406.5 224H304 288V192h16H414.5l16-64H304 288V96h16H438.5l12-48H180.2l24 288H378.5l28-112zM144 384v80H432V384H416 160 144zM48 48V208h97.3L132 48H48zM288 400a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faWrenchSimple = {
    prefix: 'fasr',
    iconName: 'wrench-simple',
    icon: [
      384,
      512,
      [],
      'e2d1',
      
      'M273.9 193.9L288 179.9V160 84.7c29.5 26.4 48 64.7 48 107.3c0 48.1-23.6 90.8-60 117l-20 14.4V348v68 48 48h48V464 348c48.5-34.9 80-91.7 80-156c0-71.1-38.6-133.1-96-166.3C273.1 17.1 257 10.4 240 6V56.2 160l-14.1 14.1L192 208l-33.9-33.9L144 160V56.2 6c-17 4.4-33.1 11-48 19.6C38.6 58.9 0 120.9 0 192c0 64.2 31.5 121.1 80 156V464v48h48V464 416 348 323.4L108 309c-36.5-26.2-60-68.9-60-117c0-42.6 18.5-81 48-107.3V160v19.9l14.1 14.1 48 48L192 275.9l33.9-33.9 48-48z'
      
    ]
  };

  

  
  

  var faPeanut = {
    prefix: 'fasr',
    iconName: 'peanut',
    icon: [
      512,
      512,
      [],
      'e430',
      
      'M512 148c0 40.6-16.4 77.4-42.9 104.2l-.9 .9c-14.1 14-30.3 24.6-47.6 31.7c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2c-.5 .6-1.1 1.1-1.7 1.7C225.1 495.8 188.5 512 148 512H48 0V464 364c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30C234.4 74 245 57.8 259.1 43.6l.4-.4c14.2-14.1 30.5-24.8 47.8-32C324.8 4 343.9 0 364 0H464h48V48 148zM148 464c27.4 0 52.1-10.9 70.2-28.7l32.7 33.2-32.7-33.2c.4-.4 .8-.7 1.1-1.1l0 0c9.4-9.5 16.4-20.4 21.1-31.9l0 0c2.7-6.4 4.7-13.2 5.9-20.2l.1-.4 .1-.4c5.3-26.6 15.3-63.2 43.4-91.3s64.7-38.2 91.3-43.4l.4-.1 .4-.1c7-1.3 13.8-3.3 20.2-5.9l0 0c11.6-4.8 22.6-11.9 32.2-21.4l0 0 .6-.6 0 0c18-18.1 29-42.9 29-70.4V48H364c-13.6 0-26.5 2.7-38.3 7.6l0 0c-11.7 4.8-22.7 12-32.3 21.6l-.3 .3 0 0c-9.6 9.6-16.7 20.6-21.5 32.2l0 0c-2.7 6.4-4.7 13.2-5.9 20.2l-.1 .4-.1 .4c-5.3 26.6-15.3 63.2-43.4 91.3s-64.7 38.2-91.3 43.4l-.4 .1-.4 .1c-7 1.3-13.8 3.3-20.2 5.9l0 0C98 276.4 87 283.6 77.3 293.3c-9.7 9.7-16.9 20.7-21.7 32.4l0 0C50.7 337.5 48 350.4 48 364V464H148zM372.8 136a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-192 192a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM200 372.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM372.8 200a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM200 308.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z'
      
    ]
  };

  

  
  

  var faBuildingMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'building-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e61c',
      
      'M48 48H336V205.7c13.8-13.5 30-24.6 48-32.4V48 0H336 48 0V48 464v48H48 336h48V466.7c-18-7.8-34.2-18.9-48-32.4V464H240V352H144V464H48V48zM296 216H216v80h73.8c1.3-9 3.4-17.7 6.2-26.1V216zM88 88v80h80V88H88zm208 0H216v80h80V88zM88 216v80h80V216H88zm360 24.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.5-8.2 72-22.1l63.1 62.7 17 16.9 33.8-34-17-16.9-63-62.6c13.9-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faCakeSlice = {
    prefix: 'fasr',
    iconName: 'cake-slice',
    icon: [
      512,
      512,
      [127856,"shortcake"],
      'e3e5',
      
      'M464 304v.4 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4H48V304H464zM48 432V384H464v.2 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1H48zm464 0v-.1-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V429v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V425v-.2-.2-.2V424v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.3-.3-.3-.3-.3V419v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V416v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V412v-.3-.3-.3-.3-.3-.3-.3-.3-.3V409v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4-.4-.4-.4V396v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V392v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V387v-.4-.4-.4-.4V385v-.4-.4-.4-.4V383v-.4-.4-.4-.4V381v-.4-.4-.4-.4-.4-.4V378v-.4-.4-.4-.4-.4-.4V375v-.4-.4-.4-.4-.4-.4V372v-.4-.4-.4-.4-.5-.4-.5-.5-.5-.5V367v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V360v-.5V359v-.5V358v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V348v-.5V347v-.5V346v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V339v-.5V338v-.5-.5-.5-.6-.6-.6-.6-.6V333v-.6-.6-.6-.6-.6-.6V329v-.6-.6-.6-.6-.6-.6V325v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V318v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V310v-.6-.6-.6-.6-.6-.6-.6V305v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V298v-.7-.7V296v-.7-.7V294v-.7-.7-.7-.7-.7-.7-.7-.7V288v-.7-.7V286v-.7-.7V284v-.7-.7-.7-.7-.7-.7-.7-.7-.7V277v-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7V259v-.7-.7-.7V256c0-74.3-32.8-130.8-76.1-168.2C393.6 51.2 340.3 32 296 32H284.9l-8.7 6.9-264 208L0 256.5V272 432v16 32H32 48 464h16 32V448v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V447 447v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V446 446v-.1-.1-.1-.1-.1-.1-.1-.1-.1V445v-.1-.1-.1-.1-.1-.1-.1-.1-.1V444v-.1-.1-.1-.1-.1-.1-.1V443v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V441v-.1-.1-.1-.1-.1-.1V440v-.1-.1-.1-.1-.1-.1V439v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V437v-.2-.2-.2-.2-.2V436v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V434v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V432z'
      
    ]
  };

  
    var faShortcake = faCakeSlice;
  

  
  

  var faEquals = {
    prefix: 'fasr',
    iconName: 'equals',
    icon: [
      448,
      512,
      [62764],
      '3d',
      
      'M40 144H16v48H40 408h24V144H408 40zm0 176H16v48H40 408h24V320H408 40z'
      
    ]
  };

  

  
  

  var faH2 = {
    prefix: 'fasr',
    iconName: 'h2',
    icon: [
      640,
      512,
      [],
      'f314',
      
      'M48 88V64H0V88 248 424v24H48V424 272H272V424v24h48V424 248 88 64H272V88 224H48V88zm442.7 24h9.2c42.1 0 76.2 34.1 76.2 76.2c0 21.3-8.9 41.5-24.5 56L375.7 406.4l-7.7 7.1V448h24H616h24V400H616 453.4L584.1 279.4c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64h-9.2c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4-18.2 15.6 31.2 36.4 18.2-15.6 29.7-25.4C457.9 118 474 112 490.7 112z'
      
    ]
  };

  

  
  

  var faArrowRightFromLine = {
    prefix: 'fasr',
    iconName: 'arrow-right-from-line',
    icon: [
      448,
      512,
      [8614,"arrow-from-left"],
      'f343',
      
      'M48 88l0-24L0 64 0 88 0 424l0 24 48 0 0-24L48 88zM429.2 273.5L447.8 256l-18.6-17.5-136-128L275.8 94.1l-32.9 35 17.5 16.4L352.3 232 152 232l-24 0 0 48 24 0 200.3 0-91.9 86.5L242.9 383l32.9 35 17.5-16.5 136-128z'
      
    ]
  };

  
    var faArrowFromLeft = faArrowRightFromLine;
  

  
  

  var faIslandTropical = {
    prefix: 'fasr',
    iconName: 'island-tropical',
    icon: [
      512,
      512,
      [127965,"island-tree-palm"],
      'f811',
      
      'M112 96H62.2c0-36 38.4-96 128-96c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c89.6 0 128 60 128 96H448L416 96l-32 32H319.4c3.5 15.4 7.2 35.7 9.5 59.7c4.4 45.4 3.7 104.4-13.9 167.1c52.6 11.3 93.3 55 100 109.1c.7 5.2 1 10.6 1 16v32H368 80 32V480c0-5.4 .3-10.8 1-16c7.9-63.1 61.7-112 127-112h24.9c26-56.3 38-110.2 43.3-151.1c1.3-9.9 2.2-19 2.8-27.1l-83.1 83.1c-25.5-25.5-40.7-95 22.6-158.4c1.3-1.3 2.7-2.7 4.1-3.9L144 64 112 96zM237.3 352h28.5c18.5-59.2 19.5-115.9 15.3-159.7c-.6-6.1-1.3-12-2-17.5c-.7 9.6-1.7 20.5-3.3 32.4c-5.2 39.6-16 90.6-38.5 144.9zM288 400H160c-38.7 0-71 27.5-78.4 64H366.4c-7.4-36.5-39.7-64-78.4-64z'
      
    ]
  };

  
    var faIslandTreePalm = faIslandTropical;
  

  
  

  var faBracketSquare = {
    prefix: 'fasr',
    iconName: 'bracket-square',
    icon: [
      192,
      512,
      ["bracket","bracket-left"],
      '5b',
      
      'M0 32H24h96 24V80H120 48V432h72 24v48H120 24 0V456 56 32z'
      
    ]
  };

  
    var faBracket = faBracketSquare;
  
    var faBracketLeft = faBracketSquare;
  

  
  

  var faHighlighterLine = {
    prefix: 'fasr',
    iconName: 'highlighter-line',
    icon: [
      576,
      512,
      [],
      'e1af',
      
      'M169.9 329.9L184 315.9V296 248.6l22.5-16.2 113 113L303.4 368H256 236.1l-14.1 14.1L184 420.1 131.9 368l38.1-38.1zm178-24L246 204.1 442.9 62.8l46.4 46.4L347.9 306zM448 0L136 224v72L64 368l15 15L7 455l-7 7V472v16 24H24h96 9.9l7-7 32-32 14.7 14.7 .3 .3 .2-.2 33.7-33.7L256 416h72L552 104 448 0zM135 439l-25 25H65.9l47-47L135 439zm145 25H256v48h24H552h24V464H552 280z'
      
    ]
  };

  

  
  

  var faFlaskGear = {
    prefix: 'fasr',
    iconName: 'flask-gear',
    icon: [
      640,
      512,
      [],
      'e5f1',
      
      'M272 228.5V214.9 48H176V214.9v13.6l-7.1 11.6L100 352H325.5l-35.6 20.5L360 493.8V512H48 0V464 422.9l128-208V48h-8H96V0h24 8 48 96 48 8 24V48H328h-8V214.9l19 30.9-27.3 47.3-32.6-53L272 228.5zm164-22.1h88.1v42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8V497H436V454.8c-8-3.4-15.6-7.7-22.5-12.9l-34.9 20.1-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9V206.4zm92.1 145.3a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z'
      
    ]
  };

  

  
  

  var faCopyright = {
    prefix: 'fasr',
    iconName: 'copyright',
    icon: [
      512,
      512,
      [169],
      'f1f9',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80c28.7 0 53.8 15.1 68 37.8l40.8-25.4C342.2 152.2 301.9 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c45.9 0 86.2-24.2 108.7-60.5L324 298.2c-14.2 22.8-39.3 37.8-68 37.8c-44.2 0-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faSymbols = {
    prefix: 'fasr',
    iconName: 'symbols',
    icon: [
      512,
      512,
      [128291,"icons-alt"],
      'f86e',
      
      'M24 0H200h24V48H200 24 0V0H24zm0 80H200h24v48H200 136v72 24H88V200 128H24 0V80H24zM512 2.7V32 176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V61.3L352 83.7V208v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V64 44.3l19.3-3.9 160-32L512 2.7zM288 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm222.7 3.2l-17 17L340.2 493.8l-17 17-33.9-33.9 17-17L459.8 306.2l17-17 33.9 33.9zM480 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM40 256h88 24v24 32.5c0 27-12.4 52.6-33.7 69.2l31.9 28.5 24-26.4 16.1-17.8 35.5 32.3-16.1 17.8-23.7 26.1 18.7 16.7 17.9 16-32 35.8-17.9-16-19-17-24 26.4-7.1 7.9H112 24 0V488 471.3c0-35.7 15.9-69.5 43.3-92.3C25.9 362.4 16 339.4 16 315.3V280 256H40zm48.4 88.2c9.8-7.6 15.6-19.3 15.6-31.7V304H64v11.3c0 11.4 4.9 22.3 13.4 29.8l4.5 4 6.5-5zm-12.3 70C60.3 426.3 50.4 444.4 48.4 464h53L118 445.8 79.6 411.5l-3.5 2.7z'
      
    ]
  };

  
    var faIconsAlt = faSymbols;
  

  
  

  var faRulerCombined = {
    prefix: 'fasr',
    iconName: 'ruler-combined',
    icon: [
      512,
      512,
      [],
      'f546',
      
      'M288 272H240V224l0-176V0H192 48 0V48 272 464v48H48 240l224 0h48V464 320 272H464 288zm96 48v64 16h32V384 320h48V464l-224 0H48l0-192L48 48l144 0 0 48-64 0H112v32h16l64 0v64H128l-16 0v32h16l64 0 0 48 0 16H128 112v32h16 64l0 64v16h32V384 320h16 48v64 16h32V384 320h64z'
      
    ]
  };

  

  
  

  var faSquareQ = {
    prefix: 'fasr',
    iconName: 'square-q',
    icon: [
      448,
      512,
      [],
      'e27b',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM224 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c13.9 0 26.9-3.5 38.3-9.7L206.1 256h61.5l28.3 35.3c5.3-10.7 8.2-22.6 8.2-35.3c0-44.2-35.8-80-80-80zm0 208c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 28.1-9 54-24.4 75.1L369.9 384H308.5l-15.9-19.9C272.7 376.7 249.2 384 224 384z'
      
    ]
  };

  

  
  

  var faLinesLeaning = {
    prefix: 'fasr',
    iconName: 'lines-leaning',
    icon: [
      384,
      512,
      [],
      'e51e',
      
      'M190.7 63.7L198.4 41 153 25.6l-7.7 22.7-136 400L1.6 471 47 486.4l7.7-22.7 136-400zM292.2 37.2l-47.1-9.4-4.7 23.5-80 400-4.7 23.5 47.1 9.4 4.7-23.5 80-400 4.7-23.5zM384 32H336V56 456v24h48V456 56 32z'
      
    ]
  };

  

  
  

  var faArrowDownToBracket = {
    prefix: 'fasr',
    iconName: 'arrow-down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e094',
      
      'M241 345l-17 17-17-17L79 217l-17-17L96 166.1l17 17 87 87L200 24l0-24 48 0 0 24 0 246.1 87-87 17-17L385.9 200l-17 17L241 345zM48 344l0 120 352 0 0-120 0-24 48 0 0 24 0 144 0 24-24 0L24 512 0 512l0-24L0 344l0-24 48 0 0 24z'
      
    ]
  };

  

  
  

  var faArrowDownUpLock = {
    prefix: 'fasr',
    iconName: 'arrow-down-up-lock',
    icon: [
      640,
      512,
      [],
      'e4b0',
      
      'M128 505.9l17-17 88-88 17-17L216 350.1l-17 17-47 47V280H416v-8c0-14.1 2.6-27.6 7.4-40H344V97.9l47 47 17 17L441.9 128l-17-17L337 23l-17-17L303 23l-88 88-17 17L232 161.9l17-17 47-47V232H152 104 24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80V414.1L57 367l-17-17L6.1 384l17 17 88 88 17 17zM104 192h48V56 32H104V56 192zM296 320V456v24h48V456 320H296zm232-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48H416V512H640V320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faTrashArrowUp = {
    prefix: 'fasr',
    iconName: 'trash-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore"],
      'f829',
      
      'M160 0H147.2L140 10.7 93.8 80H80.1 32 0v48H35.6L64 512H384l28.4-384H448V80H416 367.9 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM108.6 464L83.7 128H364.3L339.4 464H108.6zM238.1 193.9L224 179.7l-14.1 14.1-64 64L131.7 272 160 300.3l14.1-14.1L204 256.3V384v20h40V384 256.3l29.9 29.9L288 300.3 316.3 272l-14.1-14.1-64-64z'
      
    ]
  };

  
    var faTrashRestore = faTrashArrowUp;
  

  
  

  var faKeySkeleton = {
    prefix: 'fasr',
    iconName: 'key-skeleton',
    icon: [
      448,
      512,
      [128477],
      'f6f3',
      
      'M400 144a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm48 0c0 79.5-64.5 144-144 144c-31.1 0-59.9-9.9-83.4-26.6l-87.4 87.4 47 47 17 17-33.9 33.9-17-17-47-47L69.1 412.8l47 47 17 17L99.2 510.7l-17-17-64-64-17-17 17-17L186.6 227.4C169.9 203.9 160 175.1 160 144C160 64.5 224.5 0 304 0s144 64.5 144 144z'
      
    ]
  };

  

  
  

  var faDownFromBracket = {
    prefix: 'fasr',
    iconName: 'down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e66b',
      
      'M192 288l0 48-48 0-28.1 0L224 444.1 332.1 336 304 336l-48 0 0-48 0-80-64 0 0 80zm-1.9 190.1L64 352l0-16 0-48 32 0 16 0 32 0 0-48 0-32 0-48 48 0 64 0 48 0 0 48 0 32 0 48 32 0 16 0 32 0 0 48 0 16L257.9 478.1 224 512l-33.9-33.9zM400 168l0-120L48 48l0 120 0 24L0 192l0-24L0 24 0 0 24 0 424 0l24 0 0 24 0 144 0 24-48 0 0-24z'
      
    ]
  };

  

  
  

  var faTractor = {
    prefix: 'fasr',
    iconName: 'tractor',
    icon: [
      640,
      512,
      [128668],
      'f722',
      
      'M96 0h24H288h16.2l6 15.1 58 144.9H480V88 82.3l2.5-5.1 16-32 10.7-21.5 42.9 21.5L541.5 66.7 528 93.7V160h88 24v24 88 11.7l-9.2 7.2L591.2 322c-16.2-10.1-35-16.4-55.1-17.7L592 260.3V208H504 296.9l37.5 37.5L306 273.9c2.2 4.6 4.1 9.3 5.8 14.1H352v48h94.4c-14.1 13.1-25 29.5-31.6 48H352 311.8c-1.7 4.8-3.7 9.5-5.8 14.1l28.4 28.4-67.9 67.9L238.1 466c-4.6 2.2-9.3 4.1-14.1 5.8V512H128V471.8c-4.8-1.7-9.5-3.7-14.1-5.8L85.5 494.4 17.6 426.5 46 398.1c-2.2-4.6-4.1-9.3-5.8-14.1H0V288H40.2c1.7-4.8 3.7-9.5 5.8-14.1L17.6 245.5l67.9-67.9L96 188.1V24 0zM271.8 48H144V160h80 92.6L271.8 48zM176 416a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm352 48a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-128a88 88 0 1 1 0 176 88 88 0 1 1 0-176z'
      
    ]
  };

  

  
  

  var faQuoteLeft = {
    prefix: 'fasr',
    iconName: 'quote-left',
    icon: [
      448,
      512,
      [8220,"quote-left-alt"],
      'f10d',
      
      'M0 216C0 149.7 53.7 96 120 96h16 24v48H136 120c-39.8 0-72 32.2-72 72v8h96 48v48 96 48H144 48 0V368 320 272 224v-8zm48 56v48 48h96V272H48zm352 0H304v48 48h96V272zM256 320V272 224v-8c0-66.3 53.7-120 120-120h16 24v48H392 376c-39.8 0-72 32.2-72 72v8h96 48v48 96 48H400 304 256V368 320z'
      
    ]
  };

  
    var faQuoteLeftAlt = faQuoteLeft;
  

  
  

  var faUsersLine = {
    prefix: 'fasr',
    iconName: 'users-line',
    icon: [
      640,
      512,
      [],
      'e592',
      
      'M83.2 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192H224l10.7 32h-9.1H203.4l-7.8 20.8L179.4 288H32l32-96zm399.8 96l-16.2-43.2L439.8 224H417.6 405.3L416 192H576l32 96H463.8zm-46.2-32l12 32 18 48 18 48H414.3 228.9 177.6l18-48 18-48 12-32h19.7H394.7h22.9zM435.2 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM246.9 336H396.3l-12-32H258.9l-12 32zM24 432H616h24v48H616 24 0V432H24z'
      
    ]
  };

  

  
  

  var faBaby = {
    prefix: 'fasr',
    iconName: 'baby',
    icon: [
      448,
      512,
      [],
      'f77c',
      
      'M224 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM96 101.5l17 17 28.3 28.3L186.5 192h75l45.3-45.3L335 118.5l17-17 17 17L425.5 175l17 17-17 17-28.3 28.3L336 298.5v1.3l44.4 63.5 11.8 16.9 7.1 10.2-4.2 11.7-7 19.5-24 67.2-8.1 22.6-22.6-8.1-75.3-26.9-22.6-8.1 8.1-22.6 12.9-36.1-6.7-9.6H198.1l-6.7 9.6 12.9 36.1 8.1 22.6-22.6 8.1-75.3 26.9-22.6 8.1-8.1-22.6-24-67.2-7-19.5-4.2-11.7 7.1-10.2 11.9-16.9L112 299.8v-1.3L50.7 237.3 22.5 209l-17-17 17-17L79 118.5l17-17zM84.7 203.3l64 64 4.3 4.3 7 7V288H288v-9.4l7-7 4.3-4.3 64-64L374.6 192 352 169.4l-11.3 11.3L288.4 233l-7 7h-9.9H176.6h-9.9l-7-7-52.3-52.3L96 169.4 73.4 192l11.3 11.3zM305.8 340.4l-24.2 21.2 .4 .6 21 30 7.1 10.2L306 414.1l-9 25.1L327.1 450l15.9-44.6 2.8-7.8-4.7-6.8-35.3-50.4zM166.4 361.6l-24.2-21.2-35.3 50.4-4.7 6.8 2.8 7.8L120.9 450 151 439.2l-9-25.1-4.2-11.7 7.1-10.2 21-30 .4-.6z'
      
    ]
  };

  

  
  

  var faCirclePhoneFlip = {
    prefix: 'fasr',
    iconName: 'circle-phone-flip',
    icon: [
      512,
      512,
      ["phone-circle-alt"],
      'e11c',
      
      'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm56 128l72 16 0 16c0 123.7-100.3 224-224 224H144l-16-72 72-40 33.5 41.9c34.2-18.1 62.3-46.2 80.4-80.4L272 200l40-72z'
      
    ]
  };

  
    var faPhoneCircleAlt = faCirclePhoneFlip;
  

  
  

  var faBuildingShield = {
    prefix: 'fasr',
    iconName: 'building-shield',
    icon: [
      576,
      512,
      [],
      'e4d8',
      
      'M48 48H336V226.9l48-18.6V48 0H336 48 0V48 464v48H48 336h26.1c-19.2-13.7-35.7-30-49.5-48H240V352H144V464H48V48zM296 216H216v80l40 0V257.8l40-15.5V216zM88 88v80h80V88H88zm208 0H216v80h80V88zM88 216v80h80V216H88zm439.3 96.4c-5.2 61-38.8 121.7-95.3 148V275.5l95.3 36.9zM432 512c96-32 144-130.2 144-216V279.8L432 224 288 279.8V296c0 85.8 48 184 144 216z'
      
    ]
  };

  

  
  

  var faCartCircleXmark = {
    prefix: 'fasr',
    iconName: 'cart-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e3f4',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H510.7L475.3 193.2c6.8-.8 13.7-1.2 20.7-1.2c10 0 19.7 .8 29.2 2.4L561 80l15-48H525.7 122l-2.4-12.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faFaceSmileTongue = {
    prefix: 'fasr',
    iconName: 'face-smile-tongue',
    icon: [
      512,
      512,
      [],
      'e394',
      
      'M419.5 453c-44.3 36.9-101.3 59-163.5 59C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 27.2-4.2 53.4-12.1 77.9c9.1 23.9 7.8 51.5-6 75.4c-16 27.6-44.7 43.2-74.4 43.6zm-56.2-18.8l-44.2-27.4c-19.5 8-40.8 12.4-63.1 12.4c-70.4 0-130.1-43.8-157.5-105.5l-9.7-21.9 43.9-19.4 9.7 21.9c20.4 46.1 64.1 76.9 113.6 76.9c56.5 0 105.6-40.3 120.8-97.4L385 243l27.3 16.5 49 29.5c1.7-10.7 2.6-21.7 2.6-33c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c39.3 0 76-10.9 107.3-29.8zM120 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zM398.5 399.6c18.8 11 42.9 4.7 53.8-14.2c11-19.1 4.5-43.6-14.6-54.6l-.4-.2 0 0-24.7-14.9c-11.2 24.5-27.5 46.1-47.6 63.2l33.5 20.8zM336 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80z'
      
    ]
  };

  

  
  

  var faPesoSign = {
    prefix: 'fasr',
    iconName: 'peso-sign',
    icon: [
      384,
      512,
      [],
      'e222',
      
      'M72 32H48V56v72H0v48H48v48H0v48H48v72V456v24H96V456 368h88c67 0 124.9-39.2 151.8-96H384V224H350.3c1.1-7.8 1.7-15.9 1.7-24s-.6-16.2-1.7-24H384V128H335.8C308.9 71.2 251 32 184 32H72zm208 96H96V80h88c39.3 0 74.1 18.9 96 48zM96 176H301.6c1.6 7.8 2.4 15.8 2.4 24s-.8 16.2-2.4 24H96V176zm184 96c-21.9 29.1-56.7 48-96 48H96V272H280z'
      
    ]
  };

  

  
  

  var faClawMarks = {
    prefix: 'fasr',
    iconName: 'claw-marks',
    icon: [
      576,
      512,
      [],
      'f6c2',
      
      'M67.2 1.3l17 17L193 127l7 7V144v40h40 9.9l7 7L385 319l7 7V336v40h40 9.9l7 7 76.8 76.8 17 17-33.9 33.9-17-17L422.1 424H368 344V400 345.9L230.1 232H176 152V208 153.9L50.2 52.2l-17-17L67.2 1.3zm0 224l17 17L161 319l7 7V336v40h40 9.9l7 7 76.8 76.8 17 17-33.9 33.9-17-17L198.1 424H144 120V400 345.9L50.2 276.2l-17-17 33.9-33.9zm241-207L321 31l7 7V48 88h40 9.9l7 7 64 64 7 7V176v40h40 9.9l7 7 12.8 12.8 17 17-33.9 33.9-17-17-5.8-5.8H432 408V240 185.9L358.1 136H304 280V112 57.9l-5.8-5.8-17-17L291.2 1.3l17 17z'
      
    ]
  };

  

  
  

  var faRhombus = {
    prefix: 'fasr',
    iconName: 'rhombus',
    icon: [
      448,
      512,
      [],
      'e23b',
      
      'M192.1 475.6L224 512l31.9-36.4L448 256 255.9 36.4 224 0 192.1 36.4 0 256 192.1 475.6zM224 439.1L63.8 256 224 72.9 384.2 256 224 439.1z'
      
    ]
  };

  

  
  

  var faChalkboardUser = {
    prefix: 'fasr',
    iconName: 'chalkboard-user',
    icon: [
      640,
      512,
      ["chalkboard-teacher"],
      'f51c',
      
      'M592 48H208v57.3c-14.8-6-31-9.3-48-9.3V48 0h48H592h48V48 368v48H592 544 520 392 368 324.6l-14.4-48H368V296 272h24H520h24v24 72h48V48zM496 368V320H416v48h80zM208 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zm.5 240h191l-19.2-64H83.7L64.5 464zM48 352H272l33.6 112L320 512H269.9 50.1 0l14.4-48L48 352z'
      
    ]
  };

  
    var faChalkboardTeacher = faChalkboardUser;
  

  
  

  var faArrowsUpDownLeftRight = {
    prefix: 'fasr',
    iconName: 'arrows-up-down-left-right',
    icon: [
      512,
      512,
      ["arrows"],
      'f047',
      
      'M273 18.2l-17-17-17 17-72 72-17 17L184 141.1l17-17 31-31V232H93.1l31-31 17-17-33.9-33.9-17 17-72 72-17 17 17 17 72 72 17 17L141.1 328l-17-17-31-31H232V420.2l-30.7-32-16.6-17.3-34.7 33.2 16.6 17.3 72 75.2L256 514.7l17.3-18.1 72-75.2 16.6-17.3-34.7-33.2-16.6 17.3-30.7 32V280H418.9l-31 31-17 17 33.9 33.9 17-17 72-72 17-17-17-17-72-72-17-17L370.9 184l17 17 31 31H280V93.1l31 31 17 17 33.9-33.9-17-17-72-72z'
      
    ]
  };

  
    var faArrows = faArrowsUpDownLeftRight;
  

  
  

  var faFaceSmirking = {
    prefix: 'fasr',
    iconName: 'face-smirking',
    icon: [
      512,
      512,
      [],
      'e397',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm382.3 88.9l-1.9 4.8c-12.2 30.4-41.6 50.3-74.3 50.3H184 160V352h24H306.1c13.1 0 24.9-8 29.7-20.1l1.9-4.8 8.9-22.3 44.6 17.8-8.9 22.3zM208 224c0 17.7-14.3 32-32 32s-32-14.3-32-32H112 96V192h16 64c17.7 0 32 14.3 32 32zm192 0c0 17.7-14.3 32-32 32s-32-14.3-32-32H304 288V192h16 64c17.7 0 32 14.3 32 32z'
      
    ]
  };

  

  
  

  var faXmark = {
    prefix: 'fasr',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M345 137l17-17L328 86.1l-17 17-119 119L73 103l-17-17L22.1 120l17 17 119 119L39 375l-17 17L56 425.9l17-17 119-119L311 409l17 17L361.9 392l-17-17-119-119L345 137z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faCloudCheck = {
    prefix: 'fasr',
    iconName: 'cloud-check',
    icon: [
      640,
      512,
      [],
      'e35c',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM433 241L305 369l-17 17-17-17-64-64-17-17L224 254.1l17 17 47 47L399 207l17-17L449.9 224l-17 17z'
      
    ]
  };

  

  
  

  var faFort = {
    prefix: 'fasr',
    iconName: 'fort',
    icon: [
      640,
      512,
      [],
      'e486',
      
      'M136 112H88 48v16 48H80h96V128 112H136zm56 112V464h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v80h64V224H416 224 192zM496 464h64V224H496V464zM144 224H80V464h64V224zM256 512H80 32V464 224H0V176 128 112 64 48 0H40h8V16 48 64H88V48 16 0h8 32 8V16 48 64h40V48 16 0h8 40V48 64v48 16 48H416V128 112 64 48 0h40 8V16 48 64h40V48 16 0h8 32 8V16 48 64h40V48 16 0h8 40V48 64v48 16 48 48H608V464v48H560 384 256zM592 176V128 112H552 504 464v16 48h96 32z'
      
    ]
  };

  

  
  

  var faComputer = {
    prefix: 'fasr',
    iconName: 'computer',
    icon: [
      640,
      512,
      [],
      'e4e5',
      
      'M400 80V336H281.3 264 184 166.7 48V80H400zM48 384H150.7l-16 48H64v48h54.7H152 296h33.3H384V432H313.3l-16-48H400h48V336 80 32H400 48 0V80 336v48H48zm137.3 48l16-48h45.4l16 48H185.3zM528 80h64v32H528V80zm0 80h64v32H528V160zm64 80V432H528V240h64zM480 32V80 432v48h48 64 48V432 80 32H592 528 480zm80 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faExpand = {
    prefix: 'fasr',
    iconName: 'expand',
    icon: [
      448,
      512,
      [],
      'f065',
      
      'M136 32h24V80H136 48v88 24H0V168 56 32H24 136zM0 344V320H48v24 88h88 24v48H136 24 0V456 344zM424 32h24V56 168v24H400V168 80H312 288V32h24H424zM400 344V320h48v24V456v24H424 312 288V432h24 88V344z'
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fasr',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M248 72V48H200V72 232H40 16v48H40 200V440v24h48V440 280H408h24V232H408 248V72z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faHatBeach = {
    prefix: 'fasr',
    iconName: 'hat-beach',
    icon: [
      640,
      512,
      [],
      'e606',
      
      'M197.9 201.4C225.6 215.1 270 224 320 224c23.6 0 46-2 66-5.5c-1.3-4.2-2-8.7-2-13.2c0-22 15.7-40.4 36.6-44.4C397.1 131.1 360.8 112 320 112c-57.2 0-105.7 37.6-122.1 89.4zM320 64c70.2 0 130.8 41.1 159 100.5c6.1-2.9 12.8-4.5 19.7-4.5c25 0 45.3 20.3 45.3 45.3c0 12-4.8 23.5-13.3 32L528 240l2.7 2.7c.8 .8 1.6 1.6 2.3 2.5L624.9 282l15.1 6v16.2V320c0 17.6-8.9 34.5-25.1 49.8c-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7l16.5-17.4L25.1 369.8C8.9 354.5 0 337.6 0 320V304.2 288l15.1-6 129.2-51.7C149.3 137.6 226.1 64 320 64zM429.3 320c-16.7 0-31.3-9-39.1-22.5c-21.2 4.1-45 6.5-70.2 6.5c-62.4 0-116.5-14.3-142.9-35.2l-.8 .3L48 320.5c.2 1.5 1.5 6.4 10.1 14.5c10.3 9.8 27.8 20.8 53.4 31C162.5 386.3 236.2 400 320 400s157.5-13.7 208.4-34.1c25.6-10.2 43.1-21.2 53.4-31c8.6-8.1 9.9-13 10.1-14.5l-54.7-21.9c-8 12.9-22.2 21.4-38.5 21.4c-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3zM464 272l32-32-32-32-32 32 32 32z'
      
    ]
  };

  

  
  

  var faSquarePhone = {
    prefix: 'fasr',
    iconName: 'square-phone',
    icon: [
      448,
      512,
      ["phone-square"],
      'f098',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm168 96l40 72-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L280 272l72 40-16 72H320C196.3 384 96 283.7 96 160l0-16 72-16z'
      
    ]
  };

  
    var faPhoneSquare = faSquarePhone;
  

  
  

  var fa2 = {
    prefix: 'fasr',
    iconName: '2',
    icon: [
      320,
      512,
      [],
      '32',
      
      'M147.5 32c-39.4 0-77.1 15.6-105 43.5L18.7 99.4l-17 17 33.9 33.9 17-17 23.9-23.9C95.4 90.6 120.9 80 147.5 80h7.3c51.5 0 93.2 41.7 93.2 93.2c0 25.8-10.7 50.4-29.5 68L7.6 438.5 0 445.6V480H24 296h24V432H296 84.8L251.3 276.3c28.5-26.7 44.7-64 44.7-103.1C296 95.2 232.8 32 154.8 32h-7.3z'
      
    ]
  };

  

  
  

  var faGun = {
    prefix: 'fasr',
    iconName: 'gun',
    icon: [
      576,
      512,
      [],
      'e19b',
      
      'M528 56V32H480V56v8H24 0V88 216v24H24 92L44 432 32 480H81.5 208l32-128H344h16.9l5.7-15.9L400.9 240H440h9.9l7-7 25-25H552h24V184 88 64H552 528V56zM252 304l16-64h81.9l-22.9 64H252zm-33.5-64l-48 192h-77l48-192h77zM280 192H230.5 104 48V112H480h48v48H472h-9.9l-7 7-25 25H280z'
      
    ]
  };

  

  
  

  var faChildCombatant = {
    prefix: 'fasr',
    iconName: 'child-combatant',
    icon: [
      576,
      512,
      ["child-rifle"],
      'e4e0',
      
      'M160 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0A64 64 0 1 0 112 64a64 64 0 1 0 128 0zM134.5 160H120.4l-6.9 12.3L51 284.3l-11.7 21 41.9 23.4 11.7-21 19-34.1V488v24h48V488 384h32V488v24h48V488 273.6l19 34.1 11.7 21 41.9-23.4-11.7-21-62.5-112L231.6 160H217.5h-83zM192 336H160V208h32V336zM416 0H400V32h16v96H400v16 32 16H352v48 96 48h16 32 16v48 32 48h46.5H464h48l-12-48-16-64h60V352H480V325.3L544 304V192H496v72l-16 5.3V176 128H464V0H448 416zm16 336H416 400V240h32v96z'
      
    ]
  };

  
    var faChildRifle = faChildCombatant;
  

  
  

  var faKeynote = {
    prefix: 'fasr',
    iconName: 'keynote',
    icon: [
      512,
      512,
      [],
      'f66c',
      
      'M304 0H192V24h-8c-48.6 0-88 39.4-88 88v48H64L0 256v48 48H48 464h48V304 256l-64-96H144V112c0-22.1 17.9-40 40-40h8V96H304c26.5 0 48-21.5 48-48s-21.5-48-48-48zM89.7 208H422.3L464 270.5V304H48V270.5L89.7 208zM128 464v48h24H256 360h24V464H360 280V384H232v80H152 128z'
      
    ]
  };

  

  
  

  var faShareFromSquare = {
    prefix: 'fasr',
    iconName: 'share-from-square',
    icon: [
      576,
      512,
      [61509,"share-square"],
      'f14d',
      
      'M400 240V192H352 336 302.5c-54.1 0-100.2 33.9-118.3 81.6C179 263.4 176 252.3 176 240c0-61.9 50.1-112 112-112h64 48V80 67.9L492.1 160 400 252.1V240zM224 318.5c0-1.2 0-2.3 .1-3.4c1.8-41.8 36.2-75.1 78.5-75.1H304h32 16v32 16 32h48L526.1 193.9 560 160l-33.9-33.9L400 0H352V32 48 80H304 288c-88.4 0-160 71.6-160 160c0 44.7 23.3 77.4 50 100.3c35.9 30.8 78 43.7 78 43.7s-32-26.2-32-65.5zM24 32H0V56 488v24H24 456h24V488 384 360H432v24 80H48V80h88 24V32H136 24z'
      
    ]
  };

  
    var faShareSquare = faShareFromSquare;
  

  
  

  var faGrip = {
    prefix: 'fasr',
    iconName: 'grip',
    icon: [
      448,
      512,
      ["grip-horizontal"],
      'f58d',
      
      'M408 376l0-48-48 0 0 48 48 0zm40 40l-40 0-48 0-40 0 0-40 0-48 0-40 40 0 48 0 40 0 0 40 0 48 0 40zM408 184l0-48-48 0 0 48 48 0zm40 40l-40 0-48 0-40 0 0-40 0-48 0-40 40 0 48 0 40 0 0 40 0 48 0 40zM200 376l48 0 0-48-48 0 0 48zm48 40l-48 0-40 0 0-40 0-48 0-40 40 0 48 0 40 0 0 40 0 48 0 40-40 0zm0-232l0-48-48 0 0 48 48 0zm40 40l-40 0-48 0-40 0 0-40 0-48 0-40 40 0 48 0 40 0 0 40 0 48 0 40zM40 376l48 0 0-48-48 0 0 48zm48 40l-48 0L0 416l0-40 0-48 0-40 40 0 48 0 40 0 0 40 0 48 0 40-40 0zm0-232l0-48-48 0 0 48 48 0zm40 40l-40 0-48 0L0 224l0-40 0-48L0 96l40 0 48 0 40 0 0 40 0 48 0 40z'
      
    ]
  };

  
    var faGripHorizontal = faGrip;
  

  
  

  var faJackOLantern = {
    prefix: 'fasr',
    iconName: 'jack-o-lantern',
    icon: [
      576,
      512,
      [127875],
      'f30e',
      
      'M233.1 109.8L288 0l64 32v83c1.3 .8 2.7 1.7 4 2.6C376 104.1 399.1 96 424 96c45.4 0 84 26.5 110.2 64.2C560.5 198 576 248.9 576 304s-15.5 106-41.8 143.8C508 485.5 469.4 512 424 512c-24.9 0-48-8.1-68-21.6c-20 13.6-43.1 21.6-68 21.6s-48-8.1-68-21.6c-20 13.6-43.1 21.6-68 21.6c-45.4 0-84-26.5-110.2-64.2C15.5 410 0 359.1 0 304s15.5-106 41.8-143.8C68 122.5 106.6 96 152 96c24.9 0 48 8.1 68 21.6c4.2-2.9 8.6-5.5 13.1-7.9zM48 304c0 46.5 13.2 87.6 33.2 116.4C101.3 449.3 126.7 464 152 464c18 0 35.8-7.4 51.9-21.9L220 427.6l16.1 14.5C252.2 456.6 270 464 288 464s35.8-7.4 51.9-21.9L356 427.6l16.1 14.5C388.2 456.6 406 464 424 464c25.3 0 50.7-14.7 70.8-43.6c20-28.8 33.2-69.9 33.2-116.4s-13.2-87.6-33.2-116.4C474.7 158.7 449.3 144 424 144c-18 0-35.8 7.4-51.9 21.9L356 180.4l-16.1-14.5C323.8 151.4 306 144 288 144s-35.8 7.4-51.9 21.9L220 180.4l-16.1-14.5C187.8 151.4 170 144 152 144c-25.3 0-50.7 14.7-70.8 43.6C61.2 216.4 48 257.5 48 304zm112-16l48-80 48 80H160zm160 0l48-80 48 80H320zm160 0s-10.2 54.6-64 92.4V360H368v44.2c-22.1 7.3-48.5 11.8-80 11.8s-57.9-4.5-80-11.8V360H160v20.4C106.2 342.6 96 288 96 288s57.8 34.7 144 45.1V360h48V336c112 0 192-48 192-48z'
      
    ]
  };

  

  
  

  var faUserVneckHair = {
    prefix: 'fasr',
    iconName: 'user-vneck-hair',
    icon: [
      448,
      512,
      [],
      'e462',
      
      'M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0zM184.8 451.7l8.7 12.3H66.6l32-96h27.1l59.1 83.7zM381.4 464H254.5l8.7-12.3L322.3 368h27.1l32 96zM384 320H297.4l-44 62.4L224 424l-29.4-41.6-44-62.4H64L16 464 0 512H50.6 397.4 448l-16-48L384 320z'
      
    ]
  };

  

  
  

  var faPartyBell = {
    prefix: 'fasr',
    iconName: 'party-bell',
    icon: [
      512,
      512,
      [],
      'e31a',
      
      'M70.3 309.8L309.8 70.3c-67-37.5-153.3-27.7-210.3 29.3s-66.7 143.3-29.3 210.3zM65.6 65.6c75.8-75.8 192.5-85.9 279.2-30.3c13.3 8.5 25.9 18.6 37.6 30.3L348.5 99.5 99.5 348.5 65.6 382.4C54 370.7 43.9 358.1 35.3 344.8C-20.3 258.1-10.2 141.4 65.6 65.6zM480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 480a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM376 150.1l17 17 8.3 8.3c16.7 16.7 38.6 27.2 62.1 29.8l27.4 3-5.3 47.7-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6L359 201l-17-17L376 150.1zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4-47.7 5.3-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1L167 393l-17-17L184 342.1l17 17zM469.7 503.5l-8.5-10c-12.5-14.8-19.1-33.7-18.6-53c.5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8c.2-7.6-2.4-15-7.3-20.7l-8.5-10-15.5-18.3 36.6-31 15.5 18.3 8.5 10c12.5 14.8 19.1 33.7 18.6 53c-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8c-.2 7.6 2.4 15 7.3 20.7l8.5 10-36.6 31z'
      
    ]
  };

  

  
  

  var faPaintbrushPencil = {
    prefix: 'fasr',
    iconName: 'paintbrush-pencil',
    icon: [
      576,
      512,
      [],
      'e206',
      
      'M193.9 33.9l94.8 94.8-33.9 33.9-32.8-32.8-60.1 60.1 32.8 32.8-9.2 9.2-1.5 0c-14.7 0-28.9 2-42.3 5.7L65.9 161.9 32 128 65.9 94.1l60.1-60.1L160 0l33.9 33.9zM413.2 321.1l33.9-33.9L512 352l21.8 109L544 512l-51-10.2L384 480l-45.7-45.7c3.7-13.5 5.7-27.7 5.7-42.3l0-1.7 9.1-9.1 54.6 54.6 75.1 15-15-75.1-54.6-54.6zM476.8 1.3l17 17 64 64 17 17-17 17L302.3 371.7c1.1 6.6 1.7 13.4 1.7 20.3c0 66.3-53.7 120-120 120H112 64 48 24 0V464H16h8H48 64V416 392c0-66.3 53.7-120 120-120c6.9 0 13.7 .6 20.3 1.7L459.8 18.2l17-17zM184 320c-39.8 0-72 32.2-72 72v72h72c39.8 0 72-32.2 72-72c0-9.4-1.8-18.3-5-26.5L210.5 325c-8.2-3.3-17.2-5-26.5-5zM506.9 99.2L476.8 69.1 306.2 239.7l30.1 30.1L506.9 99.2z'
      
    ]
  };

  

  
  

  var faBarsFilter = {
    prefix: 'fasr',
    iconName: 'bars-filter',
    icon: [
      448,
      512,
      [],
      'e0ad',
      
      'M0 64H448v48H0V64zM64 224H384v48H64V224zM288 384v48H160V384H288z'
      
    ]
  };

  

  
  

  var faHandSparkles = {
    prefix: 'fasr',
    iconName: 'hand-sparkles',
    icon: [
      640,
      512,
      [],
      'e05d',
      
      'M280 0H256V24v8h0H200 176V56 261.5l-7.5-7.5-28.3-28.3-17-17-17 17L71 260.9l-7 7v9.9 42.7 9.9l7 7 6.9 6.9L170.5 437c48 48 113.1 75 181 75H360c46.3 0 88.6-17.1 120.9-45.3l-51.2-21.9C409.4 457 385.5 464 360 464h-8.5c-55.2 0-108.1-21.9-147.1-60.9L112 310.6V287.8l11.2-11.2 11.3 11.3 40.8 40.8 17 17 17-17L217 321l7-7V304 80h32V232v24h48V232 80h0V56 48h32v8V232v24h48V232 80h32v8h0v24V232v24h48V232 144h32V280h0v24 24c0 26.3-7.4 50.8-20.3 71.6l37.2-15.9L544 311v-7V120 96H520 464V56 32H440 384V24l0-24H360 280zM56 88L0 112l56 24 24 56 24-56 40-17.1V105.1L104 88 80 32 56 88zM304 320l-16 32-32 16 32 16 16 32 16-32 32-16-32-16-16-32zm232 88l-56 24 56 24 24 56 24-56 56-24-56-24-24-56-24 56z'
      
    ]
  };

  

  
  

  var faVolumeXmark = {
    prefix: 'fasr',
    iconName: 'volume-xmark',
    icon: [
      576,
      512,
      ["volume-mute","volume-times"],
      'f6a9',
      
      'M159.9 316.1L146.2 304H128 48V208h80 18.2l13.6-12.1L272 96.2V415.8L159.9 316.1zM0 352H48h80L272 480h48V432 80 32H272L128 160H48 0v48 96 48zM441 183l-17-17L390.1 200l17 17 39 39-39 39-17 17L424 345.9l17-17 39-39 39 39 17 17L569.9 312l-17-17-39-39 39-39 17-17L536 166.1l-17 17-39 39-39-39z'
      
    ]
  };

  
    var faVolumeMute = faVolumeXmark;
  
    var faVolumeTimes = faVolumeXmark;
  

  
  

  var faBurgerGlass = {
    prefix: 'fasr',
    iconName: 'burger-glass',
    icon: [
      640,
      512,
      [],
      'e0ce',
      
      'M64.4 208l20 256H256v48H40L3.8 48 0 0H48.1 335.9 384l-3.8 48-9.9 126.7c-24.6 8.7-44.5 20.5-60.4 33.3H64.4zm-3.7-48H323.4l8.7-112H51.9l8.8 112zM336 301.1v35H592v-35c-.7-1.3-1.6-3.1-2.8-5.1c-3.5-5.8-9.3-13.8-18.5-22c-3.1-2.8-6.7-5.7-10.8-8.5c-.7 8.2-7.6 14.6-15.9 14.6c-8.8 0-16-7.2-16-16c0-4.9 2.2-9.4 5.8-12.3c-14.7-5.7-33-10-55.7-11.3c1.2 2.3 1.9 4.9 1.9 7.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.3 1.9-7.6c-22.7 1.3-41 5.6-55.7 11.3c3.5 2.9 5.8 7.4 5.8 12.3c0 8.8-7.2 16-16 16c-8.3 0-15.2-6.4-15.9-14.6c-4.1 2.8-7.7 5.7-10.8 8.5c-9.2 8.2-15 16.2-18.5 22c-1.2 2-2.1 3.7-2.8 5.1zm0 115v48H592v-48H336zm-48-40v-8-8-64-4l1.3-3.8 22.7 7.8c-22.7-7.8-22.7-7.8-22.7-7.8l0 0 0-.1 .1-.2 .2-.4c.1-.3 .3-.7 .5-1.2c.4-.9 .9-2.2 1.6-3.6c1.3-3 3.3-6.9 6.1-11.5c5.6-9.2 14.4-21.2 27.6-33c27-24.1 70.7-46.1 138.7-46.1s111.7 22 138.7 46.1c13.3 11.8 22.1 23.8 27.6 33c2.8 4.6 4.8 8.6 6.1 11.5c.7 1.5 1.2 2.7 1.6 3.6c.2 .5 .3 .9 .5 1.2l.2 .4 .1 .2 0 .1 0 0c0 0 0 0-22.7 7.8l22.7-7.8 1.3 3.8v4 64 8 8 8 8 96 24H616 312 288v-24-96-8-8z'
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'fasr',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      'M400 336H176V48H332.1L400 115.9V336zM448 96L352 0H176 128V48 336v48h48H400h48V336 96zM48 128H0v48V464v48H48 272h48V464 416H272v48H48V176H96V128H48z'
      
    ]
  };

  

  
  

  var faSnowmanHead = {
    prefix: 'fasr',
    iconName: 'snowman-head',
    icon: [
      448,
      512,
      ["frosty-head"],
      'f79b',
      
      'M336 144v48H112V144H336zM64 48V192H24 0v48H24 48.7C28 272.3 16 310.8 16 352c0 64.3 29.2 121.8 75.1 160H356.9c45.9-38.2 75.1-95.7 75.1-160c0-41.2-12-79.7-32.7-112H424h24V192H424 384V48 0H336 112 64V48zm0 304c0-43.6 17.4-83.1 45.7-112H112 336h2.3c28.3 28.9 45.7 68.4 45.7 112c0 43.6-17.4 83.1-45.7 112H109.7C81.4 435.1 64 395.6 64 352zm88-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 448l27.8-48.7c2.7-4.8 4.2-10.2 4.2-15.7c0-17.5-14.2-31.6-31.6-31.6h-.8c-17.5 0-31.6 14.2-31.6 31.6c0 5.5 1.4 10.9 4.2 15.7L224 448z'
      
    ]
  };

  
    var faFrostyHead = faSnowmanHead;
  

  
  

  var faSidebar = {
    prefix: 'fasr',
    iconName: 'sidebar',
    icon: [
      512,
      512,
      [],
      'e24e',
      
      'M224 80V432H464V80H224zM0 32H48 464h48V80 432v48H464 48 0V432 80 32zM64 96v48h96V96H64zm96 96H64v48h96V192zM64 288v48h96V288H64z'
      
    ]
  };

  

  
  

  var faChartPyramid = {
    prefix: 'fasr',
    iconName: 'chart-pyramid',
    icon: [
      512,
      512,
      [],
      'e0e6',
      
      'M27.4 432L0 480H55.3 456.7 512l-27.4-48L283.6 80.4 256 32 228.4 80.4 27.4 432zM301.3 208H210.7L256 128.7 301.3 208zm27.4 48l36.6 64H146.7l36.6-64H328.7zm64 112l36.6 64H82.7l36.6-64H392.7z'
      
    ]
  };

  

  
  

  var faPedestal = {
    prefix: 'fasr',
    iconName: 'pedestal',
    icon: [
      448,
      512,
      [],
      'e20d',
      
      'M368 48H80V432H32V48 0H80 368h48V48 432H368V48zM24 464H424h24v48H424 24 0V464H24zm96-352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM304 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faDiagramProject = {
    prefix: 'fasr',
    iconName: 'diagram-project',
    icon: [
      576,
      512,
      ["project-diagram"],
      'f542',
      
      'M144 80v96H48V80h96zM48 32H0V80v96 48H48h96 10l70 93.3V336v96 48h48 96 48V432 336 288H368 272 262l-70-93.3V176 152H384v24 48h48 96 48V176 80 32H528 432 384V80v24H192V80 32H144 48zM368 336v96H272V336h96zM432 80h96v96H432V80z'
      
    ]
  };

  
    var faProjectDiagram = faDiagramProject;
  

  
  

  var faJetFighterUp = {
    prefix: 'fasr',
    iconName: 'jet-fighter-up',
    icon: [
      512,
      512,
      [],
      'e518',
      
      'M248 0H232.8l-6.5 13.8-64 136-2.3 4.9V160v42.6L48 272V248 224H0v24 54.1c-5 4.5-8 11-8 17.9v40c0 7.1 3.1 13.5 8 17.9V392v24H48V392v-8H154.6l-38.2 54.2-4.4 6.2V452v36 24h24H376h24V488 452v-7.6l-4.4-6.2L357.4 384H464v8 24h48V392 377.9c4.9-4.4 8-10.8 8-17.9V320c0-6.9-3-13.4-8-17.9V248 224H464v24 24L352 202.6V160v-5.4l-2.3-4.9-64-136L279.2 0H264 248zM48 328.4l112-69.3V336H48v-7.6zm304-69.3l112 69.3V336H352V259.1zM208 165.4l48-102 48 102V384v7.6l4.4 6.2L352 459.6V464H280V424 400H232v24 40H160v-4.4l43.6-61.8 4.4-6.2V384 165.4z'
      
    ]
  };

  

  
  

  var faAwardSimple = {
    prefix: 'fasr',
    iconName: 'award-simple',
    icon: [
      384,
      512,
      [],
      'e0ab',
      
      'M236.2 26.9L192 0 147.8 26.9 96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2L25.7 288l45.4 24.8L96 358.3l3.5-.1 48.3-1.1L192 384l44.2-26.9 48.3 1.1 3.5 .1 24.8-45.4L358.3 288l-1.2-51.8L384 192l-26.9-44.2L358.3 96 312.8 71.2 288 25.7l-51.8 1.2zm23.7 47.5l10.8 19.8 6.8 12.4 12.4 6.8 19.8 10.8-.5 22.5-.3 14.1 7.3 12L327.8 192l-11.7 19.3-7.3 12 .3 14.1 .5 22.5-19.8 10.8-12.4 6.8-6.8 12.4-10.8 19.8-22.5-.5-14.1-.3-12 7.3L192 327.8l-19.3-11.7-12-7.3-14.1 .3-22.5 .5-10.8-19.8-6.8-12.4-12.4-6.8L74.4 259.9l.5-22.5 .3-14.1-7.3-12L56.2 192l11.7-19.3 7.3-12-.3-14.1-.5-22.5 19.8-10.8 12.4-6.8 6.8-12.4 10.8-19.8 22.5 .5 14.1 .3 12-7.3L192 56.2l19.3 11.7 12 7.3 14.1-.3 22.5-.5zM256 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 512l128-48 128 48L291.9 390.4l-4.7-.1-42.4-1-36.2 22.1L192 421.5l-16.6-10.1-36.2-22.1-42.4 1-4.7 .1L64 512z'
      
    ]
  };

  

  
  

  var faCircleP = {
    prefix: 'fasr',
    iconName: 'circle-p',
    icon: [
      512,
      512,
      [],
      'e11a',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H160v24V288v72 24h48V360 312h68c50.8 0 92-41.2 92-92s-41.2-92-92-92H184zm92 136H208V176h68c24.3 0 44 19.7 44 44s-19.7 44-44 44z'
      
    ]
  };

  

  
  

  var faBaseball = {
    prefix: 'fasr',
    iconName: 'baseball',
    icon: [
      512,
      512,
      [9918,129358,"baseball-ball"],
      'f433',
      
      'M248 463.8c0-12.2 1-24.2 3-35.8l47.3 7.9c-1.3 7.9-2.1 15.9-2.3 24.2C378.8 444 444 378.8 460.2 296c-8.2 .2-16.3 1-24.2 2.3L428 251c11.7-2 23.6-3 35.8-3C459.7 139.5 372.5 52.3 264 48.2c0 12.2-1 24.2-3 35.8L213.7 76c1.3-7.9 2.1-15.9 2.3-24.2C133.2 68 68 133.2 51.9 216c8.2-.2 16.3-1 24.2-2.3L84 261c-11.7 2-23.6 3-35.8 3C52.3 372.5 139.5 459.7 248 463.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM206.4 104l45.3 16C230.5 180.1 183.5 227.9 124 250.3l-16.9-44.9c46.3-17.4 82.9-54.6 99.4-101.3zm99.1 304l-45.3-16c21.2-60.1 68.2-107.9 127.7-130.3l16.9 44.9c-46.3 17.4-82.9 54.6-99.4 101.3z'
      
    ]
  };

  
    var faBaseballBall = faBaseball;
  

  
  

  var faGlobeStand = {
    prefix: 'fasr',
    iconName: 'globe-stand',
    icon: [
      448,
      512,
      [],
      'f5f6',
      
      'M23 359l-17 17L40 409.9l17-17 10.5-10.5c34.3 27.7 74.9 43.8 116.5 48.3V464H64v48H352V464H232V430.7c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L393 57l17-17L376 6.1 359 23 332.5 49.6l-17 17 17 17c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0l-17-17-17 17L23 359zm89-151a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm240 0A144 144 0 1 0 64 208a144 144 0 1 0 288 0z'
      
    ]
  };

  

  
  

  var faFaceTongueSweat = {
    prefix: 'fasr',
    iconName: 'face-tongue-sweat',
    icon: [
      576,
      512,
      [],
      'e39e',
      
      'M496 256c0 81.7-47.1 152.4-115.7 186.4c2.4-8.4 3.7-17.3 3.7-26.4V400.7c10.2-7.2 16-15.7 16-24.7c0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7V416c0 9.2 1.3 18 3.7 26.4c-27.2-13.5-51-32.7-69.8-56.1c-4 17-13.4 32-26.4 42.9C146.3 480.1 213.4 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256l16-21.3 25.6 34.1L81.3 279c-.8-7.6-1.3-15.2-1.3-23C80 141.1 173.1 48 288 48s208 93.1 208 208zM96 368c0-10.4-3.4-20.5-9.6-28.8L68 314.7 48 288 36.4 303.5 9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48c12 0 22.9-4.4 31.3-11.6C89.5 395.6 96 382.5 96 368zm239.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm31-144L216 137.4l-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4L238.6 160zm110.1 11.3l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4L360 137.4 337.4 160l11.3 11.3zM288 480c-35.3 0-64-28.7-64-64V368h48v24h32V368h48v48c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faCircleRadiation = {
    prefix: 'fasr',
    iconName: 'circle-radiation',
    icon: [
      512,
      512,
      [9762,"radiation-alt"],
      'f7ba',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-52-90.1C128.2 145.1 96 196.8 96 256l104 0zm28 48.5l-52 90.1c23.5 13.6 50.9 21.4 80 21.4s56.5-7.8 80-21.4l-52-90.1c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l104 0c0-59.2-32.2-110.9-80-138.6l-52 90.1c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faRadiationAlt = faCircleRadiation;
  

  
  

  var faMusicNoteSlash = {
    prefix: 'fasr',
    iconName: 'music-note-slash',
    icon: [
      640,
      512,
      ["music-alt-slash"],
      'f8d0',
      
      'M304 213.2L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L352 250.5V196.9L512 160V49.3 0L464 11.1 304 48v80 30.7V208v5.2zm48 160.1l-48-37.8v30.8c-18.1-9-40.2-14.3-64-14.3c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V373.3zM352 128V86.2L464 60.3v61.5L352 147.7V128zM291.3 414.5c11.3 8.1 12.7 14.9 12.7 17.5s-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C177.4 441.4 176 434.6 176 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5z'
      
    ]
  };

  
    var faMusicAltSlash = faMusicNoteSlash;
  

  
  

  var faMango = {
    prefix: 'fasr',
    iconName: 'mango',
    icon: [
      512,
      512,
      [],
      'e30f',
      
      'M368 102.1v-49C385.2 79 414.6 96 448 96h40 24V72c0-39.8-32.2-72-72-72H376h-8H352 320V24 96c-49.1 0-98.3 18.7-135.8 56.2c-45.8 37.3-67.9 78.9-88.4 117.9c-19 36-36.8 69.7-71.1 95.4L-1.8 384 0 448l43.9 20.7s100.1 43.3 244.1 43.3c166.5 0 224-147.4 224-224c0-49.1-18.7-98.3-56.2-135.8c-16.6-16.6-35.6-29.6-55.8-38.8v54.8c7.7 5.2 15 11.1 21.8 17.9C450 214.3 464 251.1 464 288c0 28.5-11.3 74.2-39.8 111.7C397.2 435.3 354.9 464 288 464c-67.3 0-124.3-10.1-164.4-20.2c-20-5-35.6-10-46.1-13.6c-5.2-1.8-9.1-3.3-11.6-4.3c-1.2-.5-2-.8-2.5-1l-16.3-7.7-.2-8.7 5.3-3.7 .7-.5 .7-.5c43.1-32.3 65.5-74.8 83.8-109.5c1.1-2.1 2.2-4.2 3.3-6.2c19.6-37 37.9-69.4 74-98.7l1.9-1.6 1.7-1.7c28.1-28.1 65-42.2 101.8-42.2v24 24h48V168 152.2 102.1zM416 304H384c0 44.2-35.8 80-80 80v32c61.9 0 112-50.1 112-112z'
      
    ]
  };

  

  
  

  var faLinkHorizontal = {
    prefix: 'fasr',
    iconName: 'link-horizontal',
    icon: [
      640,
      512,
      ["chain-horizontal"],
      'e1cb',
      
      'M143.9 64C64.4 64 0 128.4 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5 3.2-47.9-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-52.9 42.9-95.9 95.9-95.9H304.1c52.9 0 95.9 42.9 95.9 95.9c0 50.5-39.1 92.3-89.5 95.6l-8.1 .5 3.2 47.9 8.1-.5c75.6-5 134.3-67.8 134.3-143.5C448 128.4 383.6 64 304.1 64H143.9zM496.1 448C575.6 448 640 383.6 640 304.1c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5-3.2 47.9 8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 52.9-42.9 95.9-95.9 95.9H335.9c-53 0-95.9-42.9-95.9-95.9c0-50.5 39.1-92.3 89.5-95.7l7.1-.5-3.2-47.9-7.1 .5C250.7 165.6 192 228.4 192 304.1C192 383.6 256.4 448 335.9 448H496.1z'
      
    ]
  };

  
    var faChainHorizontal = faLinkHorizontal;
  

  
  

  var faPhoneIntercom = {
    prefix: 'fasr',
    iconName: 'phone-intercom',
    icon: [
      512,
      512,
      [],
      'e434',
      
      'M128 80V432H48V80h80zM48 480h80 48H464h48V432 80 32H464 176 128 48 0V80 432v48H48zm128-48V80H464V432H176zm80-48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-96v32h16 64 16V288H416 352 336zm0 64v32h16 64 16V352H416 352 336zm96-240H208V240H432V112z'
      
    ]
  };

  

  
  

  var faSquareChevronLeft = {
    prefix: 'fasr',
    iconName: 'square-chevron-left',
    icon: [
      448,
      512,
      ["chevron-square-left"],
      'f32a',
      
      'M48 432l352 0 0-352L48 80l0 352zM0 480l0-48L0 80 0 32l48 0 352 0 48 0 0 48 0 352 0 48-48 0L48 480 0 480zM135 239L239 135l17-17L289.9 152l-17 17-87 87 87 87 17 17L256 393.9l-17-17L135 273l-17-17 17-17z'
      
    ]
  };

  
    var faChevronSquareLeft = faSquareChevronLeft;
  

  
  

  var faClapperboard = {
    prefix: 'fasr',
    iconName: 'clapperboard',
    icon: [
      512,
      512,
      [],
      'e131',
      
      'M48 208V432H464V208H48zm352-48l64-64V80H416l-80 80h64zM320 80H256l-80 80h64l80-80zM160 80H96L48 128v32H80l80-80zm352 80v24 24V432v48H464 48 0V432 208 184 160 80 32H48 464h48V80v80z'
      
    ]
  };

  

  
  

  var faDiamondHalfStroke = {
    prefix: 'fasr',
    iconName: 'diamond-half-stroke',
    icon: [
      512,
      512,
      [],
      'e5b8',
      
      'M33.9 289.9L0 256l33.9-33.9L222.1 33.9 256 0l33.9 33.9L478.1 222.1 512 256l-33.9 33.9L289.9 478.1 256 512l-33.9-33.9L33.9 289.9zM256 67.9V444.1L444.1 256 256 67.9z'
      
    ]
  };

  

  
  

  var faSquareArrowDown = {
    prefix: 'fasr',
    iconName: 'square-arrow-down',
    icon: [
      448,
      512,
      ["arrow-square-down"],
      'f339',
      
      'M400 432l0-352L48 80l0 352 352 0zm48 48l-48 0L48 480 0 480l0-48L0 80 0 32l48 0 352 0 48 0 0 48 0 352 0 48zM207 377l-88-88-17-17L136 238.1l17 17 47 47L200 152l0-24 48 0 0 24 0 150.1 47-47 17-17L345.9 272l-17 17-88 88-17 17-17-17z'
      
    ]
  };

  
    var faArrowSquareDown = faSquareArrowDown;
  

  
  

  var faArrowRightLongToLine = {
    prefix: 'fasr',
    iconName: 'arrow-right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d5',
      
      'M640 88V424v24H592V424 88 64h48V88zM512 256l-17 17L359 409l-17 17L308.1 392l17-17 95-95L24 280H0l0-48H24l396.1 0-95-95-17-17 33.9-33.9 17 17L495 239l17 17z'
      
    ]
  };

  

  
  

  var faCircleHalfStroke = {
    prefix: 'fasr',
    iconName: 'circle-half-stroke',
    icon: [
      512,
      512,
      [9680,"adjust"],
      'f042',
      
      'M464 256c0-114.9-93.1-208-208-208V464c114.9 0 208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faAdjust = faCircleHalfStroke;
  

  
  

  var faStarfighter = {
    prefix: 'fasr',
    iconName: 'starfighter',
    icon: [
      640,
      512,
      [],
      'e037',
      
      'M258.8 0H280h80 21.2l2.6 21 27.4 219H488h24v24 88h56V168H544V120h24V96 72h48V96v24h24v48H616V448v24H568V448v-2.7L512 464v16H488h-8v32H416V480H392 368 272 248 224v32H160V480h-8H128V464L72 445.3V448v24H24V448 168H0V120H24V96 72H72V96v24H96v48H72V352h56V264 240h24 76.8L256.2 21l2.6-21zM368 432V281.5L338.8 48H301.2L272 281.5V432h96zm48 0h48V288H416V432zM224 288H176V432h48V288zm96-64c17.7 0 32 14.3 32 32v64H288V256c0-17.7 14.3-32 32-32z'
      
    ]
  };

  

  
  

  var faUserGraduate = {
    prefix: 'fasr',
    iconName: 'user-graduate',
    icon: [
      448,
      512,
      [],
      'f501',
      
      'M224 0L408.1 39.5l32.7 7L448 48V80l-7.2 1.5-32.7 7L224 128 48 90.3V168l16 88H0l16-88V83.4L7.2 81.5 0 80V48l7.2-1.5 32.7-7L224 0zM189 456.9L105.4 368H98.6l-32 96H195.7l-6.7-7.1zM381.4 464l-32-96h-6.8L259 456.9l-6.7 7.1H381.4zM321.9 320H384l48 144 16 48H397.4 50.6 0l16-48L64 320h62.1L191 389l33 35 33-35 64.9-69zM96 160V133.3l48 10.3V160c0 44.2 35.8 80 80 80s80-35.8 80-80V143.6l48-10.3V160c0 70.7-57.3 128-128 128s-128-57.3-128-128z'
      
    ]
  };

  

  
  

  var faObjectUnion = {
    prefix: 'fasr',
    iconName: 'object-union',
    icon: [
      512,
      512,
      [],
      'e49f',
      
      'M112 352h48v48 64 48h48H464h48V464 208 160H464 400 352V112 48 0H304 48 0V48 304v48H48h64zM48 304V48H304V160v48h48H464V464H208V352 304H160 48z'
      
    ]
  };

  

  
  

  var faCartShoppingFast = {
    prefix: 'fasr',
    iconName: 'cart-shopping-fast',
    icon: [
      640,
      512,
      [],
      'e0dc',
      
      'M64 0H88h72 19.9l3.7 19.5L186 32H589.7 640L625 80 560 288H234.7l9.1 48H552h24v48H552 224 204.1l-3.7-19.5L140.1 48H88 64V0zM195.1 80l30.5 160H524.7l50-160H195.1zM192 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM24 96h80 24v48H104 24 0V96H24zm0 80h96 24v48H120 24 0V176H24zm0 80H136h24v48H136 24 0V256H24z'
      
    ]
  };

  

  
  

  var faHexagonExclamation = {
    prefix: 'fasr',
    iconName: 'hexagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e417',
      
      'M55.3 256L155.9 80H356.1L456.7 256 356.1 432H155.9L55.3 256zM128 32L0 256 128 480H384L512 256 384 32H128zm152 96H232v24V264v24h48V264 152 128zM232 320v48h48V320H232z'
      
    ]
  };

  

  
  

  var faMusicNote = {
    prefix: 'fasr',
    iconName: 'music-note',
    icon: [
      384,
      512,
      ["music-alt"],
      'f8cf',
      
      'M224 128V86.2L336 60.3v61.5L224 147.7V128zm-48 80V366.3c-18.1-9-40.2-14.3-64-14.3C50.1 352 0 387.8 0 432s50.1 80 112 80s112-35.8 112-80V196.9L384 160V49.3 0L336 11.1 176 48v80 30.7V208zM163.3 414.5c11.3 8.1 12.7 14.9 12.7 17.5s-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C49.4 441.4 48 434.6 48 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5z'
      
    ]
  };

  
    var faMusicAlt = faMusicNote;
  

  
  

  var faWaffle = {
    prefix: 'fasr',
    iconName: 'waffle',
    icon: [
      512,
      512,
      [129479],
      'e466',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 112v32l64 0V112 96h32v16 32h64V112 96h32v16 32h32 16v32H400 368v64h32 16v32H400 368v64h32 16v32H400 368v32 16H336V400 368H272v32 16H240V400 368H176v32 16H144V400 368H112 96V336h16 32V272H112 96V240h16 32V176H112 96V144h16 32V112 96h32v16zm0 128l64 0V176l-64 0v64zm96 0h64V176H272v64zm0 32v64h64V272H272zm-32 0H176v64h64V272z'
      
    ]
  };

  

  
  

  var faCloudFog = {
    prefix: 'fasr',
    iconName: 'cloud-fog',
    icon: [
      640,
      512,
      [127787,"fog"],
      'f74e',
      
      'M432 128v48h48c26.5 0 48 21.5 48 48v48H480 160 112V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM64 320h48 48H480h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C311.3 18.8 277.9 0 240 0C178.1 0 128 50.1 128 112v21.5C90.7 146.6 64 182.2 64 224v48 48zM0 368v48H24 552h24V368H552 24 0zm64 96v48H88 200h24V464H200 88 64zm208 0v48h24H616h24V464H616 296 272z'
      
    ]
  };

  
    var faFog = faCloudFog;
  

  
  

  var faFish = {
    prefix: 'fasr',
    iconName: 'fish',
    icon: [
      576,
      512,
      [128031],
      'f578',
      
      'M132 219.4L163.6 232l22.2-25.8c35.7-41.3 85.7-78.6 150.2-78.6c61.2 0 109.3 33.5 144.7 72.4c17.4 19.2 30.7 38.5 39.5 53.1c.6 1 1.1 1.9 1.7 2.8c-.5 .9-1.1 1.8-1.7 2.8c-8.9 14.6-22.1 34-39.5 53.1c-35.4 38.9-83.6 72.4-144.7 72.4c-64.4 0-114.5-37.2-150.2-78.6L163.6 280 132 292.6 70.7 317.2l19.9-39.8L101.3 256 90.6 234.7 70.7 194.8 132 219.4zM336 432c160 0 240-176 240-176s-80-176-240-176c-84.3 0-146.4 48.9-186.3 95.1L32 128 0 160l48 96L0 352l32 32 117.7-47.1C189.6 383.1 251.7 432 336 432zm80-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faCircleStar = {
    prefix: 'fasr',
    iconName: 'circle-star',
    icon: [
      512,
      512,
      ["star-circle"],
      'e123',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm42.3-314.2L256 112l-42.3 85.8L119 211.5l68.5 66.7-16.2 94.2L256 328l84.6 44.5-16.2-94.2L393 211.5l-94.6-13.8z'
      
    ]
  };

  
    var faStarCircle = faCircleStar;
  

  
  

  var faCircle1 = {
    prefix: 'fasr',
    iconName: 'circle-1',
    icon: [
      512,
      512,
      [],
      'e0ee',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM241.8 128l-5.4 3L176 164.5v54.9l11.7-6.5L232 188.3V336H176v48h80 80V336H280V152 128H256h-8-6.2z'
      
    ]
  };

  

  
  

  var faCommentHeart = {
    prefix: 'fasr',
    iconName: 'comment-heart',
    icon: [
      512,
      512,
      [],
      'e5c8',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM144 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2z'
      
    ]
  };

  

  
  

  var faStarSharp = {
    prefix: 'fasr',
    iconName: 'star-sharp',
    icon: [
      576,
      512,
      [],
      'e28b',
      
      'M351.6 195.6L313.3 77.7 288.1 0 262.8 77.7 224.5 195.6h-124H18.9l66.1 48 100.3 72.9L146.9 434.3 121.7 512l66.1-48 100.3-72.9L388.3 464l66.1 48-25.2-77.7L390.9 316.4l100.3-72.9 66.1-48H475.6h-124zm57.9 48l-46.8 34-28.2 20.5 10.8 33.2 17.9 55.1-46.8-34-28.2-20.5-28.2 20.5-46.8 34 17.9-55.1 10.8-33.2-28.2-20.5-46.8-34h57.9 34.9l10.8-33.2 17.9-55.1 17.9 55.1 10.8 33.2h34.9 57.9z'
      
    ]
  };

  

  
  

  var faUserMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'user-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e5c5',
      
      'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM65 464L99.5 352H291.2c-2.1-10.3-3.2-21-3.2-32c0-5.4 .3-10.7 .8-16H64L14.8 464 0 512H50.2 397.8 448l-9.9-32.3c-21.4-1.3-41.6-6.8-59.9-15.7H65zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.5-8.2 72-22.1l63.1 62.7 17 16.9 33.8-34-17-16.9-63-62.6c13.9-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faTruckFast = {
    prefix: 'fasr',
    iconName: 'truck-fast',
    icon: [
      640,
      512,
      ["shipping-fast"],
      'f48b',
      
      'M368 48H112V96H240h16v32H240 16 0V96H16 64V48 0h48H368h48V48 96h56 9.9l7 7L601 215l7 7V232 368h8 24v48H616 576c0 53-43 96-96 96s-96-43-96-96h-8-8H320 256c0 53-43 96-96 96s-96-43-96-96V368 288h48v44.8c14.1-8.2 30.5-12.8 48-12.8c35.5 0 66.6 19.3 83.2 48H320h48V48zm48 96v96H558.1l-96-96H416zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM48 160H272h16v32H272 48 32V160H48zM16 224H240h16v32H240 16 0V224H16z'
      
    ]
  };

  
    var faShippingFast = faTruckFast;
  

  
  

  var faLacrosseStickBall = {
    prefix: 'fasr',
    iconName: 'lacrosse-stick-ball',
    icon: [
      576,
      512,
      [],
      'e3b6',
      
      'M344 48v0l.3 0c22.9 0 53 15.2 78.8 40.9s40.9 55.9 40.9 78.8l0 .3h0c0 37.4-24 70.7-59.5 82.5l-44.1 14.7-4.2 1.4-3.4 2.8-61.9 50.7c-12.6 10.3-28.3 15.9-44.5 15.9c-38.8 0-70.3-31.5-70.3-70.3c0-16.2 5.6-32 15.9-44.5l50.7-61.9 2.8-3.4 1.4-4.2 14.7-44.1C273.3 72 306.6 48 344 48zm0-48V0C285.9 0 234.3 37.2 215.9 92.3l-13.3 39.9-47.9 58.5c-17.3 21.1-26.7 47.6-26.7 74.9c0 24 7.1 46.3 19.4 65L18.2 459.8l-17 17 33.9 33.9 17-17L181.4 364.6c18.6 12.3 41 19.4 65 19.4c27.3 0 53.8-9.4 74.9-26.7l58.5-47.9 39.9-13.3c55.1-18.4 92.3-70 92.3-128.1h0l0-.3c0-40.8-24.8-82.5-55-112.7S385.1 0 344.3 0L344 0zM464 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faSquareChevronRight = {
    prefix: 'fasr',
    iconName: 'square-chevron-right',
    icon: [
      448,
      512,
      ["chevron-square-right"],
      'f32b',
      
      'M400 80L48 80l0 352 352 0 0-352zm48-48l0 48 0 352 0 48-48 0L48 480 0 480l0-48L0 80 0 32l48 0 352 0 48 0zM313 273L209 377l-17 17L158.1 360l17-17 87-87-87-87-17-17L192 118.1l17 17L313 239l17 17-17 17z'
      
    ]
  };

  
    var faChevronSquareRight = faSquareChevronRight;
  

  
  

  var faPersonSnowboarding = {
    prefix: 'fasr',
    iconName: 'person-snowboarding',
    icon: [
      512,
      512,
      [127938,"snowboarding"],
      'f7ce',
      
      'M384 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM24 278.1l17 17 28.4 28.4 27 10.4-7.8-18.7 22.2-9.2L192 272l0-68.2c0-21.2 12-40.6 31-50.1L284.4 123l-30.8-3.1-12.5-1.2-6.1-11-40-72 42-23.3 33.9 61 67.5 6.8 7.4 .7 5.7 4.8 152 128 18.4 15.5-30.9 36.7-18.4-15.5-68.2-57.5-82.3 43.9 52.5 40.2 13.9 10.6-5.9 16.5-40 112-3.8 10.5L436.4 464H472h24v48H472 432h-4.4l-4.1-1.6-376-144-4.8-1.8L39 361 7 329l-17-17L24 278.1zM294 409.4l3.4-9.5 34.1-95.5-91.5-70 0 53.6v16l-14.8 6.2-91.2 38 160 61.3zM259.6 189l20.5 15.7 84.6-45.1-17.2-14.5L259.6 189z'
      
    ]
  };

  
    var faSnowboarding = faPersonSnowboarding;
  

  
  

  var faArrowsRetweet = {
    prefix: 'fasr',
    iconName: 'arrows-retweet',
    icon: [
      640,
      512,
      ["retweet-alt"],
      'f361',
      
      'M145 82.2l-17-17-17 17-88 88-17 17L40 221.1l17-17 47-47V392v24h24H328h24V368H328 152V157.1l47 47 17 17 33.9-33.9-17-17-88-88zM312 96H288v48h24H488V354.9l-47-47-17-17-33.9 33.9 17 17 88 88 17 17 17-17 88-88 17-17L600 290.9l-17 17-47 47V120 96H512 312z'
      
    ]
  };

  
    var faRetweetAlt = faArrowsRetweet;
  

  
  

  var faUserHeadset = {
    prefix: 'fasr',
    iconName: 'user-headset',
    icon: [
      448,
      512,
      [],
      'f82d',
      
      'M224 32C135.6 32 64 103.6 64 192v32H32V192C32 86 118 0 224 0S416 86 416 192V304v16H400 272 224 176V256h96v32H384V192c0-88.4-71.6-160-160-160zM14.4 464L48 352h96 6.6H176h48 48 25.4H400l33.6 112L448 512H397.9 50.1 0l14.4-48zM144 291.9c-29.3-23.5-48-59.5-48-99.9c0-70.7 57.3-128 128-128s128 57.3 128 128c0 23.3-6.2 45.2-17.1 64H304V224 192c0-44.2-35.8-80-80-80s-80 35.8-80 80v32 67.9zM83.7 400L64.5 464h319l-19.2-64H83.7z'
      
    ]
  };

  

  
  

  var faY = {
    prefix: 'fasr',
    iconName: 'y',
    icon: [
      384,
      512,
      [121],
      '59',
      
      'M1.1 32L168 295V456v24h48V456 295L382.9 32H326L192 243.2 58 32H1.1z'
      
    ]
  };

  

  
  

  var faCarBurst = {
    prefix: 'fasr',
    iconName: 'car-burst',
    icon: [
      640,
      512,
      ["car-crash"],
      'f5e1',
      
      'M204.5 44.7L176 0 147.5 44.7 127.7 75.8 91.1 71.9 38.4 66.3l17.2 50.1 12 34.9L41.6 177.5 4.4 215.2 54.3 233 89 245.4 93.4 282l6.3 52.6 35.7-22.1 18.1-67.7-2.7 1.7-12.3 7.6-1.7-14.4-3.5-29.5-28-10-13.6-4.9L101.7 185l20.9-21.2L113 135.7 108.3 122l14.4 1.5 29.6 3.2 16-25.1L176 89.4l7.8 12.2 5.6 8.9 .1-.2 30.9 8.3 15.9 4.3 2.6-.3 35.5-52.1-13.5 1.4-36.7 3.9L204.5 44.7zm380.8 73.6l-16.4-4.4L344 53.6l-16.4-4.4L318 63.3l-66 96.8-39.9-10.7-12.4 46.4-24.7 92.4-12.4 46.4 0 0-17.7 66.1 39.7 10.6 17.7-66.1 6.7 1.8 330.3 88.5 6.7 1.8-17.7 66.1L567.9 514l23.3-86.8 0 0 6.9-25.7 24.7-92.4 12.4-46.4-39.9-10.7-8.8-116.8-1.3-17zM348.1 104.4l191.9 51.4 6.2 83.1-245-65.7 46.9-68.8zM576.4 296.7l-24.7 92.4L221.3 300.6 246 208.2l330.3 88.5zm-85 26.7a27.4 27.4 0 1 0 52.9 14.2 27.4 27.4 0 1 0 -52.9-14.2zM272.8 293.2a27.4 27.4 0 1 0 14.2-52.9 27.4 27.4 0 1 0 -14.2 52.9z'
      
    ]
  };

  
    var faCarCrash = faCarBurst;
  

  
  

  var faBoxDollar = {
    prefix: 'fasr',
    iconName: 'box-dollar',
    icon: [
      448,
      512,
      ["box-usd"],
      'f4a0',
      
      'M200 160V80H95.2L59.6 160H200zm188.4 0L352.8 80H248v80H388.4zM244 208v16 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2 0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6V416v16H400V208H244zm-40 0H48V432H204V416v-6.4c-9.5-2.2-22-6.4-29.9-9.1l0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.2c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1v-6V208zM64 32H384l64 144V432v48H400 48 0V432 176L64 32z'
      
    ]
  };

  
    var faBoxUsd = faBoxDollar;
  

  
  

  var faWind = {
    prefix: 'fasr',
    iconName: 'wind',
    icon: [
      512,
      512,
      [],
      'f72e',
      
      'M288 0V48h24 44c24.3 0 44 19.7 44 44s-19.7 44-44 44H24 0v48H24 356c50.8 0 92-41.2 92-92s-41.2-92-92-92H312 288zm64 416h24 44c50.8 0 92-41.2 92-92s-41.2-92-92-92H24 0v48H24 420c24.3 0 44 19.7 44 44s-19.7 44-44 44H376 352v48zM120 512h44c50.8 0 92-41.2 92-92s-41.2-92-92-92H24 0v48H24 164c24.3 0 44 19.7 44 44s-19.7 44-44 44H120 96v48h24z'
      
    ]
  };

  

  
  

  var faCircleExclamationCheck = {
    prefix: 'fasr',
    iconName: 'circle-exclamation-check',
    icon: [
      640,
      512,
      [],
      'e10d',
      
      'M48 256C48 141.1 141.1 48 256 48c84.1 0 156.7 50 189.4 121.9l43.7-19.9C448.8 61.6 359.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c72.9 0 138.8-30.5 185.4-79.4l-34.8-33.1C368.7 439.2 315.3 464 256 464C141.1 464 48 370.9 48 256zM280 152V128H232v24V264v24h48V264 152zm0 216V320H232v48h48zM633.9 192L600 158.1l-17 17-111 111-47-47-17-17L374.1 256l17 17 64 64 17 17 17-17L617 209l17-17z'
      
    ]
  };

  

  
  

  var faWreathLaurel = {
    prefix: 'fasr',
    iconName: 'wreath-laurel',
    icon: [
      640,
      512,
      [],
      'e5d2',
      
      'M237.1 50.9l-.7 11.8c-1.1 20.3-17.4 36.6-37.7 37.7l-11.8 .7 .7-11.8c1.1-20.3 17.4-36.6 37.7-37.7l11.8-.7zm2.7-48.2l-17.2 1c-40.1 2.2-73 31.2-81.2 69.4C136.2 65.6 130 58.8 123 52.6c-5.8-5.1-12.2-9.7-19.1-13.8l-.2-.1-20.7-12-32 55.4c-17.4 30.2-19.2 65.1-7.8 95.4c-6.1-1-12.4-1.5-18.8-1.5l-.3 0H0l0 64c0 34.9 15.9 66 40.9 86.5c-5.8 2.2-11.5 4.9-17.1 8.1l-.2 .1-20.7 12 32 55.4C63.1 451 122.8 470.6 173.7 450c4.7-1.9 9.4-4.2 13.9-6.8l.3-.2 4.8-2.8c4.7 3.3 9.6 6.3 14.5 9.2l-33.9 17 21.5 42.9L253.7 480l66.3 0 0 0 .1 0h66.2l58.9 29.5 21.5-42.9-64-32-5.1-2.5H392 320c-97.2 0-176-78.8-176-176c0-38.2 11.6-75.2 32.8-106.3l24.6-1.4c44.8-2.5 80.5-38.2 83-83l1-17.2L288 0 239.8 2.7zM463.2 149.7C484.4 180.8 496 217.8 496 256c0 62.5-32.6 117.3-81.6 148.6l17.9 9 30.4 15.2 18.4 9.2 39.1 19.5c34.3-3.7 66.4-23.2 85-55.4l32-55.4-20.7-12-.2-.1c-5.6-3.2-11.3-5.9-17.1-8.1C624.1 306 640 274.8 640 240l0-64H616l-.3 0c-6.4 0-12.7 .5-18.8 1.5c11.4-30.3 9.6-65.2-7.8-95.4l-32-55.4-20.7 12-.2 .1c-6.9 4-13.3 8.6-19.1 13.8c-7 6.2-13.2 13.1-18.4 20.5c-8.2-38.2-41-67.2-81.2-69.4l-17.2-1L352 0l2.7 48.2 1 17.2c2.5 44.8 38.2 80.5 83 83l24.6 1.4zM414.7 51.6c20.3 1.1 36.6 17.4 37.7 37.7l.7 11.8-11.8-.7c-20.3-1.1-36.6-17.4-37.7-37.7l-.7-11.8 11.8 .7zM96.3 302.3c-27.9-7-48.6-32.3-48.6-62.4l0-12.3C76 237.5 96.3 264.4 96.3 296l0 6.3zM543.7 296c0-31.6 20.3-58.5 48.6-68.3l0 12.3c0 30.1-20.7 55.4-48.6 62.4l0-6.3zM149.4 408c-27.7 7.9-58.2-3.7-73.3-29.7L70 367.6c29.4-5.6 60.4 7.5 76.3 34.9l3.2 5.5zM106.3 178.8l-3.2 5.5C82.4 164.2 77.1 132 92.2 106l6.1-10.7c19.6 22.6 23.7 56.1 7.9 83.5zm430.6 5.5l-3.2-5.5c-15.8-27.4-11.7-60.8 7.9-83.5l6.1 10.7c15 26.1 9.8 58.3-10.9 78.3zM490.6 408l3.2-5.5c15.8-27.4 46.9-40.5 76.3-34.9l-6.2 10.6c-15.1 26.1-45.6 37.6-73.3 29.7z'
      
    ]
  };

  

  
  

  var faMegaphone = {
    prefix: 'fasr',
    iconName: 'megaphone',
    icon: [
      576,
      512,
      [128227],
      'f675',
      
      'M576 32H528V61.7L48 192.6V184 160H0v24 21.7V224v64 18.3V328v24H48V328v-8.6l117.6 32.1C162 361.7 160 372.6 160 384c0 53 43 96 96 96c46.9 0 86-33.6 94.3-78.1L528 450.3V480h48V432 80 32zM528 400.6L48 269.7V242.3L528 111.4V400.6zM208 384c0-7.1 1.5-13.8 4.3-19.8l91.5 24.9c-2.6 24.1-23 42.8-47.7 42.8c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faUserShield = {
    prefix: 'fasr',
    iconName: 'user-shield',
    icon: [
      640,
      512,
      [],
      'f505',
      
      'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM65 464L99.5 352H325.9c-3.4-16.1-5.3-32.3-5.7-48H64L14.8 464 0 512H50.2 397.8h28.3c-19.2-13.7-35.7-30-49.5-48H65zM591.3 312.4c-5.2 61-38.8 121.7-95.3 148V275.5l95.3 36.9zM496 512c96-32 144-130.2 144-216V279.8L496 224 352 279.8V296c0 85.8 48 184 144 216z'
      
    ]
  };

  

  
  

  var faMushroom = {
    prefix: 'fasr',
    iconName: 'mushroom',
    icon: [
      512,
      512,
      [127812],
      'e425',
      
      'M16 272C16 139.5 123.5 32 256 32s240 107.5 240 240v24 24H472 40 16V296 272zM146.2 114.5C96.5 149.2 64 206.8 64 272H448c0-18.7-2.7-36.8-7.7-53.9C431.8 231.3 416.9 240 400 240c-26.5 0-48-21.5-48-48c0-26.2 21-47.5 47.1-48c-25-28-58.2-48.6-95.8-58.1c.4 3.3 .6 6.7 .6 10.1c0 44.2-35.8 80-80 80c-37.8 0-69.5-26.2-77.8-61.5zM179.7 352h48.6l-12.3 80h80.1l-12.3-80h48.6l12.3 80 7.4 48H303.4 208.6 160l7.4-48 12.3-80zM144 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faPlanetRinged = {
    prefix: 'fasr',
    iconName: 'planet-ringed',
    icon: [
      512,
      512,
      [129680],
      'e020',
      
      'M502.6 26.4c1.7-12 1.2-18.3 1.2-18.3s-6.3-.4-18.3 1.2c-7.7 1.1-17.7 3-30 6.4c-20.3 5.7-46.8 15.7-78.6 32.9c15.2 8.9 29.6 19.5 42.9 32c6.5-3.1 12.7-5.8 18.5-8.2l1.8-.8-.7 1.9c-5.7 14-13.5 30.3-24 48.8C377.3 76.9 320 48 256 48C141.1 48 48 141.1 48 256c0 64 28.9 121.3 74.4 159.4c-18.4 10.5-34.8 18.3-48.8 24l-1.9 .7 .8-1.8c2.4-5.8 5.1-11.9 8.2-18.5c-12.5-13.3-23.2-27.7-32-42.9c-17.2 31.8-27.1 58.2-32.9 78.6c-3.4 12.2-5.4 22.3-6.4 30c-1.7 12-1.2 18.3-1.2 18.3s6.3 .4 18.3-1.2c7.7-1.1 17.7-3 30-6.4c26.9-7.6 64.5-22.5 111.1-51.9C194.4 456.9 224.4 464 256 464c114.9 0 208-93.1 208-208c0-31.6-7.1-61.6-19.7-88.5c29.3-46.6 44.3-84.2 51.9-111.1c3.4-12.2 5.4-22.3 6.4-30zM388 165.6c-24.3 34.9-57.3 75.2-102.3 120.2s-85.2 78-120.2 102.3C123.6 359.2 96 310.8 96 256c0-88.4 71.6-160 160-160c54.8 0 103.2 27.6 132 69.6zM215.8 410.9c31.6-23.8 66.4-53.7 103.9-91.2s67.4-72.3 91.2-103.9c3.3 12.8 5.1 26.3 5.1 40.2c0 88.4-71.6 160-160 160c-13.9 0-27.3-1.8-40.2-5.1z'
      
    ]
  };

  

  
  

  var faUserDoctorHair = {
    prefix: 'fasr',
    iconName: 'user-doctor-hair',
    icon: [
      448,
      512,
      [],
      'e458',
      
      'M304 128c0-11.4-2.4-22.2-6.7-32H256L240 80l-32 32H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zm3.5 224L50.2 512H0L64 304H384l64 208H397.8L348.5 352H312v50c27.6 7.1 48 32.2 48 62v32 16H344 320 304V480h16 8V464c0-17.7-14.3-32-32-32s-32 14.3-32 32v16h8 16v32H272 248 232V496 464c0-29.8 20.4-54.9 48-62V352H168v50.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V352H99.5zM176 456a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faSquareY = {
    prefix: 'fasr',
    iconName: 'square-y',
    icon: [
      448,
      512,
      [],
      'e287',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM200 295.9L88.6 144h59.5L224 247.4 299.8 144h59.5L248 295.9V376v24H200V376 295.9z'
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fasr',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 60.2 25.6 114.5 66.5 152.5L144 320H368l29.5 88.5c40.9-38 66.5-92.2 66.5-152.5zM333.4 368H178.6l-23.3 70c29.8 16.6 64.2 26 100.7 26s70.9-9.4 100.7-26l-23.3-70zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216-56a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 88a88 88 0 1 1 0-176 88 88 0 1 1 0 176z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faJugDetergent = {
    prefix: 'fasr',
    iconName: 'jug-detergent',
    icon: [
      384,
      512,
      [],
      'e519',
      
      'M224 0H96V48H64V96H256V48H224V0zM336 176V464H48V256c0-44.2 35.8-80 80-80H336zM128 128C57.3 128 0 185.3 0 256V464v48H48 336h48V464 176 128H336 128zM288 384V224H224V384h64z'
      
    ]
  };

  

  
  

  var faDiagramSubtask = {
    prefix: 'fasr',
    iconName: 'diagram-subtask',
    icon: [
      512,
      512,
      [],
      'e479',
      
      'M0 32H512V224H152V360h72V336 288h48H464h48v48 96 48H464 272 224V432 408H128 104V384 224H0V32zM464 336H272v96H464V336z'
      
    ]
  };

  

  
  

  var faListCheck = {
    prefix: 'fasr',
    iconName: 'list-check',
    icon: [
      512,
      512,
      ["tasks"],
      'f0ae',
      
      'M150.9 69.4l13.4-14.9L134.5 27.8 121.1 42.6 63.2 107 38.1 81.9 24 67.7-4.3 96 9.9 110.1l40 40L64.8 165l14.1-15.7 72-80zm0 160l13.4-14.9-29.7-26.8-13.4 14.9L63.2 267 38.1 241.9 24 227.7-4.3 256 9.9 270.1l40 40L64.8 325l14.1-15.7 72-80zM192 72v48h24H488h24V72H488 216 192zm0 160v48h24H488h24V232H488 216 192zM160 392v48h24H488h24V392H488 184 160zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faShrimp = {
    prefix: 'fasr',
    iconName: 'shrimp',
    icon: [
      512,
      512,
      [129424],
      'e448',
      
      'M24 32H0V56v96 24H24 65c9.8 98.8 93.1 176 194.5 176h77.3c17.3 0 31.2 14 31.2 31.2c0 22-22.1 37.1-42.6 29.1l-68.7-26.7L224 372.9V408v48 24h24 88c97.2 0 176-78.8 176-176s-78.8-176-176-176H48V80H424V32H24zM259.5 304c-74.8 0-136.7-55.8-146.2-128H296V304H259.5zm84.5 .3V176.2c39.7 2.4 74.5 23 96.3 53.5L362 308.1c-5.7-1.9-11.7-3.2-18-3.8zm57 32.6l60.1-60.1c1.9 8.8 2.9 17.8 2.9 27.2c0 42-20.2 79.3-51.4 102.6c2.2-7.3 3.4-15.1 3.4-23.4c0-17.3-5.5-33.3-15-46.3zM224 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCircleDivide = {
    prefix: 'fasr',
    iconName: 'circle-divide',
    icon: [
      512,
      512,
      [],
      'e106',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-320V128H224v64h64zM168 232H144v48h24H344h24V232H344 168zm56 152h64V320H224v64z'
      
    ]
  };

  

  
  

  var faBorderLeft = {
    prefix: 'fasr',
    iconName: 'border-left',
    icon: [
      448,
      512,
      [],
      'f84f',
      
      'M0 480L0 32l48 0 0 448L0 480zm96 0l0-64 64 0 0 64-64 0zM96 32l64 0 0 64L96 96l0-64zm0 256l0-64 64 0 0 64-64 0zM288 416l64 0 0 64-64 0 0-64zm0-320l0-64 64 0 0 64-64 0zm0 128l64 0 0 64-64 0 0-64zM192 480l0-64 64 0 0 64-64 0zm0-448l64 0 0 64-64 0 0-64zm0 256l0-64 64 0 0 64-64 0zM384 416l64 0 0 64-64 0 0-64zm0-320l0-64 64 0 0 64-64 0zm0 128l64 0 0 64-64 0 0-64zM192 384l0-64 64 0 0 64-64 0zm192-64l64 0 0 64-64 0 0-64zm0-128l0-64 64 0 0 64-64 0zM192 128l64 0 0 64-64 0 0-64z'
      
    ]
  };

  

  
  

  var faTv = {
    prefix: 'fasr',
    iconName: 'tv',
    icon: [
      640,
      512,
      [63717,"television","tv-alt"],
      'f26c',
      
      'M48 48V368H592V48H48zM0 0H48 592h48V48 368v48H592 48 0V368 48 0zM120 464H520h24v48H520 120 96V464h24z'
      
    ]
  };

  
    var faTelevision = faTv;
  
    var faTvAlt = faTv;
  

  
  

  var faDownFromDottedLine = {
    prefix: 'fasr',
    iconName: 'down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e407',
      
      'M256 256v48h48 28.1L224 412.1 115.9 304H144h48V256 176h64v80zm1.9 190.1L384 320V304 256H352 336 304V208 176 128H256 192 144v48 32 48H112 96 64v48 16L190.1 446.1 224 480l33.9-33.9zM64 96V32H0V96H64zm96 0V32H96V96h64zm32-64V96h64V32H192zM352 96V32H288V96h64zm32 0h64V32H384V96z'
      
    ]
  };

  

  
  

  var faArrowUp = {
    prefix: 'fasr',
    iconName: 'arrow-up',
    icon: [
      384,
      512,
      [8593],
      'f062',
      
      'M209 50.2l-17-17-17 17L21.4 203.8l-17 17 33.9 33.9 17-17L168 125.1V456v24h48V456 125.1L328.6 237.8l17 17 33.9-33.9-17-17L209 50.2z'
      
    ]
  };

  

  
  

  var faBoneBreak = {
    prefix: 'fasr',
    iconName: 'bone-break',
    icon: [
      640,
      512,
      [],
      'f5d8',
      
      'M344 32V8H296V32v72 24h48V104 32zM201 71l-17-17L150.1 88l17 17 48 48 17 17L265.9 136l-17-17L201 71zM473 105l17-17L456 54.1 439 71l-48 48-17 17L408 169.9l17-17 48-48zM292.6 240.3L172.9 261.2c-11.8-43.1-55-70.9-100.2-63C24.9 206.6-7.1 251.8 1.4 299.3c2.1 12 6.7 23 13 32.6c9 13.6 21.6 24.4 36.3 31.2C39.2 374.5 31.1 389 27.3 404.8c-2.6 11.2-3.1 23.1-1 35.1c8.4 47.5 54.1 79.1 101.9 70.8c45.2-7.9 76.2-48.7 72.4-93.2L320 396.6l119.3 20.9c-3.8 44.5 27.2 85.3 72.4 93.2c47.9 8.4 93.5-23.3 101.9-70.8c2.1-12 1.7-23.9-1-35.1c-3.8-15.8-11.9-30.3-23.4-41.7c14.7-6.8 27.3-17.6 36.3-31.2c6.3-9.6 10.9-20.6 13-32.6c8.4-47.5-23.5-92.7-71.4-101.1c-45.2-7.9-88.4 19.9-100.2 63L347.4 240.3l-6.7 47.1 161.3 28.2 11.5-42c5.3-19.5 25-32.2 45.5-28.6c21.8 3.8 36.3 24.4 32.4 45.9c-2.3 13.2-10.9 23.7-22.5 29l-16.6 7.7-10 56.1 12.9 12.9c9 8.9 13.4 21.7 11.1 34.9c-3.8 21.6-24.6 36-46.3 32.2c-20.5-3.6-34.7-22.1-32.9-42.3l3.7-43.3L320 348.3 149.2 378.1l3.7 43.3c1.7 20.2-12.4 38.7-32.9 42.3c-21.8 3.8-42.5-10.6-46.3-32.2c-2.3-13.2 2.1-26 11.1-34.9l12.9-12.9-10-56.1-16.6-7.7c-11.5-5.4-20.1-15.9-22.5-29c-3.8-21.6 10.7-42.1 32.4-45.9c20.5-3.6 40.2 9.1 45.5 28.6l11.5 42 161.3-28.2-6.7-47.1z'
      
    ]
  };

  

  
  

  var faLandmarkDome = {
    prefix: 'fasr',
    iconName: 'landmark-dome',
    icon: [
      512,
      512,
      ["landmark-alt"],
      'f752',
      
      'M280 0V24v9.5C369.5 44.6 439.9 117.4 447.3 208H456h24v48H456h-8H400 112 64 56 32V208H56h8.7C72.1 117.4 142.5 44.6 232 33.5V24 0h48zM112.9 208H399.1c-8-72-69-128-143.1-128s-135.2 56-143.1 128zm-.9 80v96h64V288h48v96h64V288h48v96h64V288h48v96h8 24v48H456 64 40V384H64V288h48zM8 464H32 488h24v48H488 32 8V464z'
      
    ]
  };

  
    var faLandmarkAlt = faLandmarkDome;
  

  
  

  var faBrazilianRealSign = {
    prefix: 'fasr',
    iconName: 'brazilian-real-sign',
    icon: [
      512,
      512,
      [],
      'e46c',
      
      'M424 24V0H376V24 65.2C326.2 72.9 288 116 288 168c0 43.7 27.4 82.8 68.4 97.7l70.7 25.7c22.1 8 36.8 29.1 36.8 52.6c0 30.9-25.1 56-56 56h-6.6c-17.7 0-35.2-4.6-50.6-13.4l-27-15.4-23.8 41.7 27 15.4c15.2 8.7 31.8 14.6 48.9 17.6V488v24h48V488 446.8c49.8-7.7 88-50.8 88-102.8c0-43.7-27.4-82.8-68.4-97.7l-70.7-25.7c-22.1-8-36.8-29.1-36.8-52.6c0-30.9 25.1-56 56-56h12.3c15.3 0 30.4 2.9 44.6 8.6l14.3 5.7 17.8-44.6L466.7 76C453 70.5 438.6 66.9 424 65.2V24zM0 32V56 280 480H48V304h59.9l56.3 176h50.4L156.7 299C214 283 256 230.4 256 168c0-75.1-60.9-136-136-136H24 0zM48 256V80h72c48.6 0 88 39.4 88 88s-39.4 88-88 88H48z'
      
    ]
  };

  

  
  

  var faHatWinter = {
    prefix: 'fasr',
    iconName: 'hat-winter',
    icon: [
      512,
      512,
      [],
      'f7a8',
      
      'M279.3 23.8L256 0 232.7 23.8l-33.3-.4 .4 33.3L176 80l23.8 23.3-.4 33.3 33.3-.4L256 160l23.3-23.8 33.3 .4-.4-33.3L336 80 312.2 56.7l.4-33.3-33.3 .4zM48 416H0v96H48 464h48V416H464 48zM167.5 132C43.1 194.8 32 384 32 384H80.1c.1-1.5 .3-3.7 .6-6.3c.7-6.5 2-16 4.2-27.4c.4-2 .8-4.1 1.2-6.2l5.8-3.3L136 315.6l44.1 25.2 11.2 6.4 11.5-5.7L256 314.8l53.3 26.6 11.5 5.7 11.2-6.4L376 315.6l44.1 25.2 5.8 3.3c.4 2.1 .8 4.2 1.2 6.2c2.1 11.5 3.4 21 4.2 27.4c.3 2.6 .5 4.7 .6 6.3H480s-11.1-189.2-135.5-252l.1 4.2L345 169l-32.8-.4-4.3-.1c45.7 16.3 74.6 54.5 94.2 98.9c1.5 3.5 3 6.9 4.4 10.4l-18.5-10.6L376 260.4l-11.9 6.8-44.8 25.6-52.5-26.3L256 261.2l-10.7 5.4-52.5 26.3-44.8-25.6L136 260.4l-11.9 6.8-18.5 10.6c1.4-3.5 2.8-6.9 4.4-10.4c19.6-44.4 48.6-82.5 94.2-98.9l-4.3 .1L167 169l.4-32.8 0-4.2z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlay = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-play',
    icon: [
      512,
      512,
      [],
      'e660',
      
      'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1l124 124 17 17L478.1 512l-17-17-124-124zM145.8 116.2l24 14 110.2 64L303.9 208 280 221.8l-110.2 64-24 14V272 144 116.2z'
      
    ]
  };

  

  
  

  var faPersonHarassing = {
    prefix: 'fasr',
    iconName: 'person-harassing',
    icon: [
      576,
      512,
      [],
      'e549',
      
      'M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM44.9 299.8L96 209.5V488v24h48V488 352h32V488v24h48V488 214.2l61.6 73.3 36.7-30.9-100.9-120-7.2-8.6H203.1 100.9h-14L80 140.2 3.1 276.2l41.8 23.6zM144 176h32V304H144V176zM304 32H288V64h16 56 16V32H360 304zM496 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16 56h-9.9l-7 7-32 32-7 7V352v61l-37.7-44.5L379 372.3 315 487.5l42 23.3L404.1 426 449 479.1c13.2 15.6 31.1 26.3 50.7 30.7c5.2 1.5 10.7 2.2 16.3 2.2c.6 0 1.2 0 1.8 0c.7 0 1.5 0 2.2 0v-.1c31.3-2.1 56-28.1 56-59.9V320 296H552 512zm5.4 167.9c-1.9-.1-3.7-.3-5.6-.7c-4.6-1.7-7.8-6.1-7.8-11.2V361.9L521.9 344H528V452c0 6.2-4.6 11.2-10.6 11.9zM272.8 90.5l-14.3 28.6 14.3 7.2 48 24 14.3 7.2 14.3-28.6-14.3-7.2-48-24-14.3-7.2z'
      
    ]
  };

  

  
  

  var faNfcPen = {
    prefix: 'fasr',
    iconName: 'nfc-pen',
    icon: [
      576,
      512,
      [],
      'e1fa',
      
      'M48 80H400V284.4l48-48V80 32H400 48 0V80 432v48H48 258l6.9-48H48V80zM368 316.4V136 112H344 224 200v24 78.4c-14.3 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.8-9.7-33.3-24-41.6V160h72V352H128V160h8 24V112H136 104 80v24V376v24h24H284.4L368 316.4zm137-92.6l-41.3 41.3 71 71L576 294.8l-71-71zm-63.9 63.9L299.9 429 288 511.9 370.9 500 512.1 358.7l-71-71z'
      
    ]
  };

  

  
  

  var faChessKing = {
    prefix: 'fasr',
    iconName: 'chess-king',
    icon: [
      448,
      512,
      [9818],
      'f43f',
      
      'M248 24V0H200V24 56H168 144v48h24 32v40H48 0v48 24L59.1 352h52.3L48 206V192H200h48H400v14L336.5 352h52.3L448 216V192 144H400 248V104h32 24V56H280 248V24zM84.7 464l16.6-32H346.8l16.6 32H84.7zM416 461.3L376 384H72L32 461.3V464v48H80 368h48V464v-2.7z'
      
    ]
  };

  

  
  

  var faRankingStar = {
    prefix: 'fasr',
    iconName: 'ranking-star',
    icon: [
      640,
      512,
      [],
      'e561',
      
      'M351.8 62.3l69 11-49.4 49.5L382.3 192 320 160.3 257.7 192l10.9-69.1L219.2 73.3l69-11L320 0l31.8 62.3zM272 304V464h96V304H272zm-48-48h48 96 48v48V464v48H368 272 224V464 304 256zM48 368v96h96V368H48zM0 320H48h96 48v48 96 48H144 48 0V464 368 320zm592 80H496v64h96V400zm-96-48h96 48v48 64 48H592 496 448V464 400 352h48z'
      
    ]
  };

  

  
  

  var faPhoneOffice = {
    prefix: 'fasr',
    iconName: 'phone-office',
    icon: [
      576,
      512,
      [],
      'f67d',
      
      'M144 48V368h80V48H144zM96 0h48 80 48V32h48 24 24H528h48V80v64 24 24V464v48H528 48 0V464 80 32H48 96V0zm0 80H48V464H528V192H344 320V168 80H272V368v48H224 144 96V368 80zm432 0H368v64H528V80zM320 240h64v64H320V240zm64 96v64H320V336h64zm32-96h64v64H416V240zm64 96v64H416V336h64z'
      
    ]
  };

  

  
  

  var faEnvelopes = {
    prefix: 'fasr',
    iconName: 'envelopes',
    icon: [
      576,
      512,
      [],
      'e170',
      
      'M528 80H144v25.4L336 242.5 528 105.4V80zm0 84.4L349.9 291.5l-13.9 10-13.9-10L144 164.4V336H528V164.4zM144 32H528h48V80 336v48H528 144 96V336 80 32h48zM48 96v24V432H456h24v48H456 24 0V456 120 96H48z'
      
    ]
  };

  

  
  

  var faDownLong = {
    prefix: 'fasr',
    iconName: 'down-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-down"],
      'f309',
      
      'M192 352l0-48 0-256-64 0 0 256 0 48-48 0-12.1 0L160 444.1 252.1 352 240 352l-48 0zm1.9 126.1L160 512l-33.9-33.9L0 352l0-48 32 0 16 0 32 0 0-48L80 48 80 0l48 0 64 0 48 0 0 48 0 208 0 48 32 0 16 0 32 0 0 48L193.9 478.1z'
      
    ]
  };

  
    var faLongArrowAltDown = faDownLong;
  

  
  

  var faJugBottle = {
    prefix: 'fasr',
    iconName: 'jug-bottle',
    icon: [
      640,
      512,
      [],
      'e5fb',
      
      'M96 0H224V48h32V96H64V48H96V0zM416 512V175.1L448.3 160H575.7L640 190.1V256l-24 24 24 24v64l-24 24 24 24v64l-32 32H416zM128 176c-44.2 0-80 35.8-80 80V464H336V176H128zM0 256c0-70.7 57.3-128 128-128H336h16 32v32 16 14.1V480v32H352 336 48 32 0V480 464 256zm288-32V384H224V224h64zM448 64H576v64H448V64z'
      
    ]
  };

  

  
  

  var faSdCards = {
    prefix: 'fasr',
    iconName: 'sd-cards',
    icon: [
      448,
      512,
      [],
      'e240',
      
      'M400 368V48H227.9L144 131.9V368H400zM96 112L208 0H400h48V48 368v48H400 144 96V368 112zM48 96v24V464H360h24v48H360 24 0V488 120 96H48zm256 0v64 16H272V160 96 80h32V96zm64 0v64 16H336V160 96 80h32V96z'
      
    ]
  };

  

  
  

  var faTowerCell = {
    prefix: 'fasr',
    iconName: 'tower-cell',
    icon: [
      576,
      512,
      [],
      'e585',
      
      'M48 128c0-38.6 9.1-75.1 25.3-107.4L32 0 17.4 29.2C6.1 60 0 93.3 0 128s6.1 68 17.4 98.8L32 256l41.3-20.6C57.1 203.1 48 166.6 48 128zm56 0c0 29.6 7 57.5 19.4 82.3l42.9-21.5c-9.2-18.3-14.3-39-14.3-60.8s5.2-42.5 14.3-60.8L123.4 45.7C111 70.5 104 98.4 104 128zM452.6 45.7L409.7 67.2c9.2 18.3 14.3 39 14.3 60.8s-5.2 42.5-14.3 60.8l42.9 21.5C465 185.5 472 157.6 472 128s-7-57.5-19.4-82.3zM528 128c0 38.6-9.1 75.1-25.3 107.4L544 256l14.6-29.2C569.9 196 576 162.7 576 128s-6.1-68-17.4-98.8L544 0 502.7 20.6C518.9 52.9 528 89.4 528 128zM496 512L336.9 169.3c9.4-11.1 15.1-25.6 15.1-41.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 15.7 5.7 30.2 15.1 41.3L80 512h52.9l37.1-80H405.9l37.1 80H496zM288 192c2.1 0 4.3-.1 6.4-.3L339.1 288H236.9l44.7-96.3c2.1 .2 4.2 .3 6.4 .3zM192.3 384L216 333.1V336H361.4l22.3 48H192.3z'
      
    ]
  };

  

  
  

  var faSchoolLock = {
    prefix: 'fasr',
    iconName: 'school-lock',
    icon: [
      640,
      512,
      [],
      'e56f',
      
      'M466.7 144l-11.4-6.8L320 56 184.7 137.2 173.3 144H160 48V464H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64v80l0 48H48 0V464 144 96H48 160L320 0 480 96H592h48v48V272c0-38.1-19-71.7-48-91.9V144H480 466.7zM160 192v96H96V192h64zm0 128v96H96V320h64zm80-128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm96-48H304v16 32 16h16 24 16V176H344h-8V160 144zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H416V320h32V272z'
      
    ]
  };

  

  
  

  var faCircleEllipsis = {
    prefix: 'fasr',
    iconName: 'circle-ellipsis',
    icon: [
      512,
      512,
      [],
      'e10a',
      
      'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM192 224l0 64-64 0 0-64 64 0zm192 0l0 64-64 0 0-64 64 0zm-160 0l64 0 0 64-64 0 0-64z'
      
    ]
  };

  

  
  

  var faWatermelonSlice = {
    prefix: 'fasr',
    iconName: 'watermelon-slice',
    icon: [
      512,
      512,
      [],
      'e337',
      
      'M208 464c141.4 0 256-114.6 256-256c0-49.2-13.9-95.2-37.9-134.2L398.9 101c21 33.3 33.1 72.7 33.1 115c0 119.3-96.7 216-216 216c-42.3 0-81.7-12.1-115-33.1L73.8 426.1c39 24.1 85 37.9 134.2 37.9zM35.2 396.8l28.1-28.1 33.9-33.9L334.8 97.2l33.9-33.9 28.1-28.1 34-34c11 11.8 21 24.5 30 37.9C493.1 87.4 512 145.5 512 208c0 167.9-136.1 304-304 304c-62.5 0-120.6-18.9-168.9-51.2c-13.4-9-26.1-19-37.9-30l34-34zM216 384c92.8 0 168-75.2 168-168c0-28.9-7.3-56.2-20.2-79.9l-22.6 22.6 6.1 6.1L358.6 176 336 198.6l-11.3-11.3-6.1-6.1-57.4 57.4 6.1 6.1L278.6 256 256 278.6l-11.3-11.3-6.1-6.1-57.4 57.4 6.1 6.1L198.6 336 176 358.6l-11.3-11.3-6.1-6.1-22.6 22.6c23.8 12.9 51 20.2 79.9 20.2zM331.3 228.7l16 16L358.6 256 336 278.6l-11.3-11.3-16-16L297.4 240 320 217.4l11.3 11.3zm-80 80l16 16L278.6 336 256 358.6l-11.3-11.3-16-16L217.4 320 240 297.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faHandHoldingMagic = {
    prefix: 'fasr',
    iconName: 'hand-holding-magic',
    icon: [
      576,
      512,
      [],
      'f6e5',
      
      'M176 76c0 15.5 12.5 28 28 28h84 24v48H288 204c-42 0-76-34-76-76s34-76 76-76H328c66.3 0 120 53.7 120 120s-53.7 120-120 120H280v24 24H232V264 216 192h24 72c39.8 0 72-32.2 72-72s-32.2-72-72-72H204c-15.5 0-28 12.5-28 28zM160.7 304H168 384h24v24 46.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H424 24 0V464H24 416.6l91.7-62.8-15-24-80.4 51L407 432h-7H368 320 296 256 232V384h24 40 24 40V352H175.3l-90 60-6 4H72 24 0V368H24 64.7l90-60 6-4z'
      
    ]
  };

  

  
  

  var faListUl = {
    prefix: 'fasr',
    iconName: 'list-ul',
    icon: [
      512,
      512,
      ["list-dots"],
      'f0ca',
      
      'M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm120 8H160v48h24H488h24V72H488 184zm0 160H160v48h24H488h24V232H488 184zm0 160H160v48h24H488h24V392H488 184zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faListDots = faListUl;
  

  
  

  var faCodeCompare = {
    prefix: 'fasr',
    iconName: 'code-compare',
    icon: [
      512,
      512,
      [],
      'e13a',
      
      'M192 416l96-96h32v72h16c39.8 0 72-32.2 72-72V160h-8H352V112 48 0h48 64 48V48v64 48H464h-8V320c0 66.3-53.7 120-120 120H320v72H288l-96-96zM400 48v64h64V48H400zM320 96l-96 96H192V120H176c-39.8 0-72 32.2-72 72V352h8 48v48 64 48H112 48 0V464 400 352H48h8V192c0-66.3 53.7-120 120-120h16V0h32l96 96zM48 400v64h64V400H48z'
      
    ]
  };

  

  
  

  var faDropletDegree = {
    prefix: 'fasr',
    iconName: 'droplet-degree',
    icon: [
      512,
      512,
      ["dewpoint"],
      'f748',
      
      'M336 320c0-14.5-7.4-39.2-24.7-72.8c-16.5-32-39-66.6-62.3-99c-20.2-28.1-40.5-53.9-57-74.1c-16.5 20.2-36.8 46-57 74.1c-23.3 32.4-45.8 66.9-62.3 99C55.4 280.8 48 305.5 48 320c0 79.5 64.5 144 144 144s144-64.5 144-144zM0 320C0 241.2 106.1 102.8 160.5 36.9C179.3 14.1 192 0 192 0s12.7 14.1 31.5 36.9C277.9 102.8 384 241.2 384 320c0 106-86 192-192 192S0 426 0 320zM464 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faDewpoint = faDropletDegree;
  

  
  

  var faSkullCrossbones = {
    prefix: 'fasr',
    iconName: 'skull-crossbones',
    icon: [
      448,
      512,
      [9760,128369],
      'f714',
      
      'M290.1 185.8L272 200.3v23.2V240H176V223.4 200.3l-18.1-14.4C138.4 170.4 128 149.5 128 128c0-39 37.5-80 96-80s96 41 96 80c0 21.5-10.4 42.4-29.9 57.8zM368 128C368 57.3 303.5 0 224 0S80 57.3 80 128c0 37.9 18.5 72 48 95.4V240v48h48 96 48V240 223.4c29.5-23.4 48-57.5 48-95.4zm58.4 128L405 266.7 223.9 357.2 42.8 266.7 21.3 256-.1 298.9l21.5 10.7L170.2 384 21.3 458.4-.1 469.1l21.5 42.9 21.5-10.7 181.1-90.5L405 501.4l21.5 10.7 21.5-42.9-21.5-10.7L277.6 384l148.8-74.4 21.5-10.7L426.4 256zM208 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faClub = {
    prefix: 'fasr',
    iconName: 'club',
    icon: [
      512,
      512,
      [9827],
      'f327',
      
      'M351.7 136.8l2.5 34 32.9 8.8C431.4 191.5 464 232 464 280c0 57.4-46.6 104-104 104c-27.5 0-52.5-10.6-71.2-28.1L256 325l-32.8 30.8C204.5 373.4 179.5 384 152 384C94.6 384 48 337.4 48 280c0-48 32.6-88.5 76.9-100.4l32.9-8.8 2.5-34C163.9 87.1 205.4 48 256 48s92.1 39.1 95.7 88.8zm47.9-3.5C394.1 58.7 331.9 0 256 0S117.9 58.7 112.4 133.2C47.7 150.6 0 209.8 0 280c0 83.9 68.1 152 152 152c29.4 0 56.8-8.3 80-22.7V464H184 160v48h24 48 48 48 24V464H328 280V409.3c23.2 14.4 50.6 22.7 80 22.7c83.9 0 152-68.1 152-152c0-70.2-47.7-129.4-112.4-146.8z'
      
    ]
  };

  

  
  

  var faHospitals = {
    prefix: 'fasr',
    iconName: 'hospitals',
    icon: [
      576,
      512,
      [],
      'f80e',
      
      'M304 48H528V256H320v48H528v48H320v48H528v64H320v48H528h48V464 48 0H528 304 256V48 64h48V48zM408 80v40H368v48h40v40h48V168h40V120H456V80H408zM168 176H120v40H80v48h40v40h48V264h40V216H168V176zM48 144H240V352H48V144zm0 256H240v64H48V400zM0 96v48V464v48H48 240h48V464 144 96H240 48 0z'
      
    ]
  };

  

  
  

  var faBookArrowRight = {
    prefix: 'fasr',
    iconName: 'book-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0b9',
      
      'M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H424h24V464H424h-8V400h8 24V376 288H400v64H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H400v80h48V24 0H424 88zM368 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H368zM537 111l-17-17L486.1 128l17 17 39 39H256v48H542.1l-39 39-17 17L520 321.9l17-17 80-80 17-17-17-17-80-80z'
      
    ]
  };

  

  
  

  var faBellPlus = {
    prefix: 'fasr',
    iconName: 'bell-plus',
    icon: [
      448,
      512,
      [],
      'f849',
      
      'M256 0H192V51.2C119 66 64 130.6 64 208v88L0 368v48H48 400h48V368l-64-72V208c0-77.4-55-142-128-156.8V0zm80 314.2l12.1 13.6L383.8 368H64.2l35.7-40.1L112 314.2V296 208c0-61.9 50.1-112 112-112s112 50.1 112 112v88 18.2zM288 448H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM248 152H200v24 40H160 136v48h24 40v40 24h48V304 264h40 24V216H288 248V176 152z'
      
    ]
  };

  

  
  

  var faBatteryFull = {
    prefix: 'fasr',
    iconName: 'battery-full',
    icon: [
      576,
      512,
      [128267,"battery","battery-5"],
      'f240',
      
      'M496 144V368H48V144H496zM48 96H0v48V368v48H48 496h48V368 320h32V192H544V144 96H496 48zm400 96H96V320H448V192z'
      
    ]
  };

  
    var faBattery = faBatteryFull;
  
    var faBattery5 = faBatteryFull;
  

  
  

  var faChevronDown = {
    prefix: 'fasr',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M256 417.9l17-17L465 209l17-17L448 158.1l-17 17-175 175L81 175l-17-17L30.1 192l17 17L239 401l17 17z'
      
    ]
  };

  

  
  

  var faMoneyBillSimpleWave = {
    prefix: 'fasr',
    iconName: 'money-bill-simple-wave',
    icon: [
      576,
      512,
      [],
      'e1f2',
      
      'M276.1 405.2l5.6-1.4c72.9-18.6 158.2-40.4 246.2-20.2V91.8c-69.1-24.1-140.4-7.4-228.1 15l-5.6 1.4C221.3 126.8 136.1 148.6 48 128.4V420.2c69.1 24.1 140.4 7.4 228.1-15zM0 60.3c16 8.2 32 14.3 48 18.7c80 22.1 160 1.7 240-18.7c96-24.5 192-48.9 288 0V398.9v52.8c-16-8.2-32-14.3-48-18.7c-80-22.1-160-1.7-240 18.7c-96 24.5-192 48.9-288 0V113.1 60.3zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z'
      
    ]
  };

  

  
  

  var faHandsHoldingDiamond = {
    prefix: 'fasr',
    iconName: 'hands-holding-diamond',
    icon: [
      640,
      512,
      ["hand-receiving"],
      'f47c',
      
      'M320 256L448 128 320 0 192 128 320 256zM144 64H120 24 0V88 392v9.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112H96V312v9.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16L233.9 392l-16-16-1-1-16-16-23-23L208 305.9l88 88V488v24h24 24V488 393.9l88-88L462.1 336l-23 23 0 0-16 16-17 17L440 425.9l17-17 16-16 0 0 40-40 17-17 7-7 7-7V312 112h48V382.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V392 88 64H616 520 496V88 302.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88 64z'
      
    ]
  };

  
    var faHandReceiving = faHandsHoldingDiamond;
  

  
  

  var faTransporter2 = {
    prefix: 'fasr',
    iconName: 'transporter-2',
    icon: [
      512,
      512,
      [],
      'e044',
      
      'M64 32L48 0 32 32 0 48 32 64 48 96 64 64 96 48 64 32zM480 352l-16-32-16 32-32 16 32 16 16 32 16-32 32-16-32-16zM120 464H96v48h24H392h24V464H392 120zM256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H192.9l-7.2 9.7L121.4 224h59.8H192h48V176h32v48h48 10.7 59.8l-64.2-86.3-7.2-9.7H307.1 204.9zM112 256H96v32h16H400h16V256H400 112zm64 64H160v32h16H336h16V320H336 176zm0 64H160v32h16H336h16V384H336 176z'
      
    ]
  };

  

  
  

  var faPersonCircleExclamation = {
    prefix: 'fasr',
    iconName: 'person-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e53f',
      
      'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM94.8 128h14.1H211.1h14.1l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6L224 224.9V488v24H176V488 352H144V488v24H96V488 224.9L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128zM144 304h32V176H144V304zm288-80a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224V416H416v32h32zm0-176H416v16 80 16h32V368 288 272z'
      
    ]
  };

  

  
  

  var faSuitcaseRolling = {
    prefix: 'fasr',
    iconName: 'suitcase-rolling',
    icon: [
      384,
      512,
      [],
      'f5c1',
      
      'M120 0H96V24 128H48 0v48V432v48H48 64v8 24h48V488v-8H272v8 24h48V488v-8h16 48V432 176 128H336 288V24 0H264 120zM240 128H144V48h96v80zM48 176H336V432H48V176zm48 48v48h24H264h24V224H264 120 96zm0 112v48h24H264h24V336H264 120 96z'
      
    ]
  };

  

  
  

  var faDisplaySlash = {
    prefix: 'fasr',
    iconName: 'display-slash',
    icon: [
      640,
      512,
      ["desktop-slash"],
      'e2fa',
      
      'M91.2 48L503.3 368H560V48H91.2zM32 2.1V0H80 560h48V48 368v48H565.2l55.8 43.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l2.6 2zM80 368H345L406 416h-9.6l8 48H456h10.9L480 474.3V512H456 384 256 184 160V464h24 51.7l8-48H80 32V368 121.4l48 37.8V368zm267.7 48H292.3l-8 48h71.3l-8-48z'
      
    ]
  };

  
    var faDesktopSlash = faDisplaySlash;
  

  
  

  var faCircleMicrophoneLines = {
    prefix: 'fasr',
    iconName: 'circle-microphone-lines',
    icon: [
      512,
      512,
      ["microphone-circle-alt"],
      'e117',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 96V256c0 26.5 21.5 48 48 48s48-21.5 48-48H280 264V224h16 24V192H280 264V160h16 24V96H208zM176 256V232H128v24c0 62.5 44.8 114.5 104 125.8V392v24h48V392 381.8c59.2-11.2 104-63.3 104-125.8V232H336v24c0 44.2-35.8 80-80 80s-80-35.8-80-80z'
      
    ]
  };

  
    var faMicrophoneCircleAlt = faCircleMicrophoneLines;
  

  
  

  var faSquarePen = {
    prefix: 'fasr',
    iconName: 'square-pen',
    icon: [
      448,
      512,
      ["pen-square","pencil-square"],
      'f14b',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM112 288L220.7 179.3l80 80L192 368 96 384l16-96zm256-96l-44.7 44.7-80-80L288 112l80 80z'
      
    ]
  };

  
    var faPenSquare = faSquarePen;
  
    var faPencilSquare = faSquarePen;
  

  
  

  var faTablePicnic = {
    prefix: 'fasr',
    iconName: 'table-picnic',
    icon: [
      512,
      512,
      [],
      'e32d',
      
      'M64 64H88 424h24v48H424 351.6l48.1 128H488h24v48H488 417.8 366.5h-221H94.2 24L0 288l0 0V240H24h88.3l48.1-128H88 64V64zM378.5 320h51.3l48.1 128H426.6L378.5 320zM85.4 448H34.1L82.2 320h51.3L85.4 448zM211.6 112L163.5 240H348.5L300.4 112H211.6z'
      
    ]
  };

  

  
  

  var faReceipt = {
    prefix: 'fasr',
    iconName: 'receipt',
    icon: [
      384,
      512,
      [129534],
      'f543',
      
      'M93.5 437.1L73.2 426.9l-20.7 9.2-4.5 2V73.9l4.5 2 20.7 9.2L93.5 74.9l41-20.5 33.7 19.3L192 87.3l23.8-13.6 33.7-19.3 41 20.5 20.3 10.1 20.7-9.2 4.5-2V438.1l-4.5-2-20.7-9.2-20.3 10.1-41 20.5-33.7-19.3L192 424.7l-23.8 13.6-33.7 19.3-41-20.5zM0 512l48-21.3L72 480l64 32 56-32 56 32 64-32 24 10.7L384 512V459.5 52.5 0L336 21.3 312 32 248 0 192 32 136 0 72 32 48 21.3 0 0V52.5 459.5 512zM120 144H96v48h24H264h24V144H264 120zM96 320v48h24H264h24V320H264 120 96zm24-88H96v48h24H264h24V232H264 120z'
      
    ]
  };

  

  
  

  var faFilePen = {
    prefix: 'fasr',
    iconName: 'file-pen',
    icon: [
      576,
      512,
      [128221,"file-edit"],
      'f31c',
      
      'M48 464H260.3l-6.9 48H48 0V464 48 0H48 256L384 128V300.4l-48 48V160H224V48H48V464zM505 223.8l71 71-41.3 41.3-71-71L505 223.8zm-63.9 63.9l71 71L370.9 500 288 511.9 299.9 429 441.1 287.8z'
      
    ]
  };

  
    var faFileEdit = faFilePen;
  

  
  

  var faWalkieTalkie = {
    prefix: 'fasr',
    iconName: 'walkie-talkie',
    icon: [
      384,
      512,
      [],
      'f8ef',
      
      'M112 0V24 96h48V64h64V96h32V64h64V96h40 24v24V312v9.9l-7 7-25 25V488v24H328 56 32V488 353.9L7 329l-7-7V312 120 96H24 64V24 0h48zM48 144V302.1l25 25 7 7V344 464H304V344v-9.9l7-7 25-25V144H320 256 224 160 112 64 48zm88 48H248h24v48H248 136 112V192h24zm0 80H248h24v48H248 136 112V272h24z'
      
    ]
  };

  

  
  

  var faWand = {
    prefix: 'fasr',
    iconName: 'wand',
    icon: [
      512,
      512,
      [],
      'f72a',
      
      'M112 512l32-35.9L397.7 192H448V135.7L512 64 448 0 161.3 256H96v58.3L35.9 368 0 400l34 34 44 44 34 34zm-2-69.9L69.9 402 444.7 67.3 110 442.1z'
      
    ]
  };

  

  
  

  var faCartArrowDown = {
    prefix: 'fasr',
    iconName: 'cart-arrow-down',
    icon: [
      576,
      512,
      [],
      'f218',
      
      'M0 0H24 96h19.9l3.7 19.5 42 220.5H462.2l63-208h50.2L503 271l-5.2 17H480 170.7l9.1 48H488h24v48H488 160 140.1l-3.7-19.5L76.1 48H24 0V0zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 24l0 86.1 23-23 17-17L417.9 104l-17 17-64 64-17 17-17-17-64-64-17-17L256 70.1l17 17 23 23L296 24V0h48V24z'
      
    ]
  };

  

  
  

  var faColon = {
    prefix: 'fasr',
    iconName: 'colon',
    icon: [
      192,
      512,
      [],
      '3a',
      
      'M72 112v48h48V112H72zM24 64H72h48 48v48 48 48H120 72 24V160 112 64zM72 352v48h48V352H72zM24 304H72h48 48v48 48 48H120 72 24V400 352 304z'
      
    ]
  };

  

  
  

  var faCartFlatbedEmpty = {
    prefix: 'fasr',
    iconName: 'cart-flatbed-empty',
    icon: [
      640,
      512,
      ["dolly-flatbed-empty"],
      'f476',
      
      'M0 0H24h80 24V24 416h80H496 616h24v48H616 544c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c0 26.5-21.5 48-48 48s-48-21.5-48-48H104 80V440 48H24 0V0z'
      
    ]
  };

  
    var faDollyFlatbedEmpty = faCartFlatbedEmpty;
  

  
  

  var faLobster = {
    prefix: 'fasr',
    iconName: 'lobster',
    icon: [
      512,
      512,
      [129438],
      'e421',
      
      'M80 96V2C74.9 .7 69.5 0 64 0C28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64l.7 0 66 44 6 4H144h32v16H131.8L87.2 233.7l-14.3-7.2L58.5 255.2l14.3 7.2 48 24 3.4 1.7H128h48v16H114.6L69.1 288.8l-15.2-5.1L43.8 314.1l15.2 5.1 48 16 2.5 .8H112h64v16H160h-3.8l-3.4 1.7-32 16-14.3 7.2 14.3 28.6 14.3-7.2L163.8 384H176l24.5 68.5C176.8 461.8 160 485 160 512H352c0-27-16.8-50.2-40.5-59.5L336 384h12.2l28.6 14.3 14.3 7.2 14.3-28.6-14.3-7.2-32-16-3.4-1.7H352 336V336h64 2.6l2.5-.8 48-16 15.2-5.1-10.1-30.4-15.2 5.1L397.4 304H336V288h48 3.8l3.4-1.7 48-24 14.3-7.2-14.3-28.6-14.3 7.2L380.2 256H336V240h32 7.3l6-4 66-44c.2 0 .5 0 .7 0c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96L389.1 38.8C385.8 46.6 384 55.1 384 64v64c0 14.9 5.1 28.6 13.6 39.4L360.7 192H335.5c-2.6-22.5-16-42.9-31.5-59.2V53.6l34.6-5.8 15.8-2.6-5.3-31.6-15.8 2.6-48 8L272 26.4V40v65.6c-3.2-2.2-6.3-4.1-9-5.8c-4.3-2.6-9.7-2.6-14 0c-2.8 1.6-5.8 3.6-9 5.8V40 26.4l-13.4-2.2-48-8-15.8-2.6-5.3 31.6 15.8 2.6L208 53.6v79.2c-15.5 16.3-28.9 36.7-31.5 59.2H151.3l-36.9-24.6c8.5-10.9 13.6-24.6 13.6-39.4V64c0-8.9-1.8-17.4-5.1-25.2L80 96zM288 200v40 16 32 16 32 16 23.7L262.2 448H249.8L224 375.7V352 336 304 288 256 240 200c0-6.6 3.8-17 15.4-30.3c5.2-6 11-11.4 16.6-16c5.7 4.7 11.5 10.1 16.6 16C284.2 183 288 193.4 288 200z'
      
    ]
  };

  

  
  

  var faBracketCurly = {
    prefix: 'fasr',
    iconName: 'bracket-curly',
    icon: [
      256,
      512,
      ["bracket-curly-left"],
      '7b',
      
      'M88 32H64V56 182.1L7 239l-7 7v19.9l7 7 57 57V456v24H88 200h24V432H200 112V320v-9.9l-7-7-47-47 47-47 7-7V192 80h88 24V32H200 88z'
      
    ]
  };

  
    var faBracketCurlyLeft = faBracketCurly;
  

  
  

  var faTaxiBus = {
    prefix: 'fasr',
    iconName: 'taxi-bus',
    icon: [
      640,
      512,
      [],
      'e298',
      
      'M48 128v80H168V128H48zm0 128V376H192l0 48H80v32 24H32V456 424H24 0V400 88 82.3l2.5-5.1C11 60.4 31 41.2 61.3 26.4C92.2 11.3 135.2 0 192 0C312.9 0 365.4 45.2 381.5 77.3l2.5 5.1V88v8H336v32H216v80h45.6l-11.1 32.1-1.8 0-56.7-.4V256H48zM321.4 80C301.9 65.2 263.6 48 192 48c-50.4 0-86.1 10-109.7 21.6c-7.1 3.5-13 7-17.9 10.4H192 321.4zM104 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM368 128H496v32h40 16.9l5.7 15.9L592.9 272H640v48 80 16 32 64H592V448H272v64H224V448 416 400 320 272h47.1l34.3-96.1 5.7-15.9H328h40V128zM575.4 320H288.6c-.4 0-.7 0-1.1 0H272v80H592V320H576.6c-.4 0-.7 0-1.1 0zm-33.5-48l-22.9-64H344.9l-22.9 64H541.9zM312 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faPeach = {
    prefix: 'fasr',
    iconName: 'peach',
    icon: [
      512,
      512,
      [],
      'e20b',
      
      'M288 280c0-66.3-53.7-120-120-120s-120 53.7-120 120c0 48.1 42.1 93.7 105 132c29.2 17.8 58.8 31.5 81.3 40.7c8.5 3.5 15.9 6.3 21.7 8.5c5.8-2.1 13.2-5 21.7-8.5c22.5-9.3 52.1-22.9 81.3-40.7c62.9-38.3 105-83.9 105-132c0-66.3-53.7-120-120-120c-17.4 0-33.9 3.7-48.8 10.3C320.6 199.7 336 238.1 336 280H288zM151.6 112.8C118.3 93.4 96 57.3 96 16V0h48c61.9 0 112 50.1 112 112C256 50.1 306.1 0 368 0h48V16c0 41.3-22.3 77.4-55.6 96.8C445.5 121 512 192.7 512 280c0 152-256 232-256 232s-256-80-256-232c0-87.3 66.5-159 151.6-167.2z'
      
    ]
  };

  

  
  

  var faNairaSign = {
    prefix: 'fasr',
    iconName: 'naira-sign',
    icon: [
      448,
      512,
      [],
      'e1f6',
      
      'M88 32H64V56 256H24 0v48H24 64V456v24h48V456 304H226.7L334.6 469.1l7.1 10.9h13H360h24V456 304h40 24V256H424 384V56 32H336V56 256H252.7L113.4 42.9 106.3 32h-13H88zM284 304h52v79.5L284 304zm-88.7-48H112V128.5L195.3 256z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleXmark = {
    prefix: 'fasr',
    iconName: 'floppy-disk-circle-xmark',
    icon: [
      576,
      512,
      ["floppy-disk-times","save-circle-xmark","save-times"],
      'e181',
      
      'M48 480H0V432 80 32H48 336L448 144v48.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9v-31l-80-80V184v24H296 104 80V184 80H48V432H268c6.9 17.5 16.4 33.7 28.2 48H48zM224 256c22.1 0 41.6 11.2 53.1 28.3C263.7 309.2 256 337.7 256 368c0 2.5 .1 4.9 .2 7.4c-9.4 5.5-20.4 8.6-32.2 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64zM128 80v80H272V80H128zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z'
      
    ]
  };

  
    var faFloppyDiskTimes = faFloppyDiskCircleXmark;
  
    var faSaveCircleXmark = faFloppyDiskCircleXmark;
  
    var faSaveTimes = faFloppyDiskCircleXmark;
  

  
  

  var faLocationQuestion = {
    prefix: 'fasr',
    iconName: 'location-question',
    icon: [
      384,
      512,
      ["map-marker-question"],
      'f60b',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zM104 152c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4V240v24H168V240 218.5 204.6l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H160c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 200V304h48v48H168z'
      
    ]
  };

  
    var faMapMarkerQuestion = faLocationQuestion;
  

  
  

  var faSignalGood = {
    prefix: 'fasr',
    iconName: 'signal-good',
    icon: [
      640,
      512,
      ["signal-3"],
      'f68e',
      
      'M344 192v24V488v24H296V488 216 192h48zM216 288v24V488v24H168V488 312 288h48zM88 384v24 80 24H40V488 408 384H88z'
      
    ]
  };

  
    var faSignal3 = faSignalGood;
  

  
  

  var faTrashCanArrowUp = {
    prefix: 'fasr',
    iconName: 'trash-can-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore-alt"],
      'f82a',
      
      'M160 0H147.2L140 10.7 93.8 80H80 32 0v48H32V464v48H80 368h48V464 128h32V80H416 368 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM80 464V128H368V464H80zM224 166.1l-17 17-80 80-17 17L144 313.9l17-17 39-39V416h48V257.9l39 39 17 17L337.9 280l-17-17-80-80-17-17z'
      
    ]
  };

  
    var faTrashRestoreAlt = faTrashCanArrowUp;
  

  
  

  var faChevronsDown = {
    prefix: 'fasr',
    iconName: 'chevrons-down',
    icon: [
      512,
      512,
      ["chevron-double-down"],
      'f322',
      
      'M239 273l17 17 17-17L465 81l17-17L448 30.1 431 47l-175 175L81 47l-17-17L30.1 64 47 81 239 273zm0 192l17 17 17-17L465 273l17-17L448 222.1l-17 17-175 175L81 239l-17-17L30.1 256l17 17L239 465z'
      
    ]
  };

  
    var faChevronDoubleDown = faChevronsDown;
  

  
  

  var faPersonDotsFromLine = {
    prefix: 'fasr',
    iconName: 'person-dots-from-line',
    icon: [
      576,
      512,
      ["diagnoses"],
      'f470',
      
      'M288 128a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM288 0a88 88 0 1 1 0 176A88 88 0 1 1 288 0zM202.2 208H208 368h5.8l5.1 2.6 172.8 88 21.4 10.9-21.8 42.8-21.4-10.9L400 275.2V432H352V256H224V432H176V275.2L46.1 341.4 24.7 352.3 2.9 309.5l21.4-10.9 172.8-88 5.1-2.6zM0 464H24 552h24v48H552 24 0V464zM56 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM488 176a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faDiagnoses = faPersonDotsFromLine;
  

  
  

  var faTableTennisPaddleBall = {
    prefix: 'fasr',
    iconName: 'table-tennis-paddle-ball',
    icon: [
      640,
      512,
      [127955,"ping-pong-paddle-ball","table-tennis"],
      'f45d',
      
      'M304 480l-25.3-25.3-34-34-32.7 35.2-19.4 20.9L160 512l-34-34L98 450 64 416l35.2-32.7 20.9-19.4 35.2-32.7-34-34L96 272l0-108.8 97.6-97.6c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3c-12.7-9.6-27.3-17-43.1-21.3c27.1-64 14.5-140.9-37.7-193.1c-68.7-68.7-180.2-68.7-248.9 0l-47 47L375.7 341.8c-9.9 13.9-17.1 29.8-20.8 47.1L146.6 180.5l-2.6 2.6v69l45.2 45.2 35.2 35.2-36.5 33.9-54.8 50.8 25.6 25.6 50.8-54.8 33.9-36.5 35.2 35.2L323.9 432H353c2.2 17.3 7.8 33.5 16.1 48H304zm224-64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faPingPongPaddleBall = faTableTennisPaddleBall;
  
    var faTableTennis = faTableTennisPaddleBall;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1l124 124 17 17L478.1 512l-17-17-124-124z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faRupiahSign = {
    prefix: 'fasr',
    iconName: 'rupiah-sign',
    icon: [
      512,
      512,
      [],
      'e23d',
      
      'M0 32H24h96c75.1 0 136 60.9 136 136c0 62.4-42 115-99.3 131l57.9 181H164.2L107.9 304H48V480H0V280 56 32zM48 256h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48V256zm264-96h88c61.9 0 112 50.1 112 112s-50.1 112-112 112H336V488v24H288V488 184 160h24zm88 176c35.3 0 64-28.7 64-64s-28.7-64-64-64H336V336h64z'
      
    ]
  };

  

  
  

  var faTableCellsRowLock = {
    prefix: 'fasr',
    iconName: 'table-cells-row-lock',
    icon: [
      640,
      512,
      [],
      'e67a',
      
      'M48 296l104 0 0-80L48 216l0 80zm0 136l104 0 0-88L48 344l0 88zm264 0l0-88-112 0 0 88 112 0zm72-136l0 48-24 0 0 88 24 0 0 48L48 480 0 480l0-48L0 80 0 32l48 0 416 0 48 0 0 48 0 81.1c-34.7 5-64.2 25.8-81 54.9l-71 0 0 80 24 0zM200 216l0 80 112 0 0-80-112 0zm328 24c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z'
      
    ]
  };

  

  
  

  var faBurgerLettuce = {
    prefix: 'fasr',
    iconName: 'burger-lettuce',
    icon: [
      512,
      512,
      [],
      'e3e3',
      
      'M32 224V192s0-6.1 1.7-16C40.6 135.5 75.9 32 256 32s215.4 103.5 222.3 144c1.7 9.9 1.7 16 1.7 16v32H432 80 32zm67.3-84.5c-9.1 13-14 26.2-16.6 36.5H429.3c-2.6-10.3-7.5-23.4-16.6-36.5c-8.4-12-22-26.2-44.8-37.7c.1 .7 .1 1.5 .1 2.2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.1 2.4-9.6 6.1-12.6c-19.2-6-42.8-10.2-72.1-11.2c1.3 2.3 2 4.9 2 7.8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.5 2-7.8c-29.3 1-52.9 5.2-72.1 11.2c3.7 2.9 6.1 7.5 6.1 12.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 .1-1.5 .1-2.2c-22.8 11.5-36.4 25.7-44.8 37.7zM80 432H432V400H80v32zM32 352H80 432h48v48 32 48H432 80 32V432 400 352zM176.2 249.4l79.8 29 79.8-29 8.2-3 8.2 3 79.7 29 55.7-20.9 16.9 44.9-64 24-8.3 3.1-8.3-3-79.8-29-79.8 29-8.2 3-8.2-3-79.8-29-79.8 29-8.3 3-8.3-3.1-64-24 16.9-44.9 55.7 20.9 79.7-29 8.2-3 8.2 3z'
      
    ]
  };

  

  
  

  var faSquareDownLeft = {
    prefix: 'fasr',
    iconName: 'square-down-left',
    icon: [
      448,
      512,
      [],
      'e26b',
      
      'M48 432V80H400V432H48zM0 480H48 400h48V432 80 32H400 48 0V80 432v48zM128 192V352H288l24-24-52-52 76-76-56-56-76 76-52-52-24 24z'
      
    ]
  };

  

  
  

  var faCupTogo = {
    prefix: 'fasr',
    iconName: 'cup-togo',
    icon: [
      448,
      512,
      ["coffee-togo"],
      'f6c5',
      
      'M72.8 0L66.3 13.7 34.8 80H24 0v48H24 50 400h24 24V80H424h-9.2L381.5 13.3 374.8 0H360 88 72.8zM88 80l15.2-32h242l16 32H88zM47.4 160L80 512H368l32.6-352H352.4l-5.9 64H101.5l-5.9-64H47.4zm68.9 224H331.6l-7.4 80H123.8l-7.4-80z'
      
    ]
  };

  
    var faCoffeeTogo = faCupTogo;
  

  
  

  var faFont = {
    prefix: 'fasr',
    iconName: 'font',
    icon: [
      448,
      512,
      [],
      'f031',
      
      'M201.8 46.9L207.9 32h32.3l6.1 14.9L351.1 304h.9v2.1L403.4 432H424h24v48H424 312 288V432h24 39.5l-32.7-80H129.1L96.5 432H136h24v48H136 24 0V432H24 44.6L96 306.1V304h.9L201.8 46.9zM148.7 304H299.3L224 119.5 148.7 304z'
      
    ]
  };

  

  
  

  var faPlay = {
    prefix: 'fasr',
    iconName: 'play',
    icon: [
      384,
      512,
      [9654],
      'f04b',
      
      'M0 32V87.6 424.4 480l48-28L336.4 283.8 384 256l-47.6-27.8L48 60 0 32zm48 83.6L288.7 256 48 396.4V115.6z'
      
    ]
  };

  

  
  

  var faTreeCity = {
    prefix: 'fasr',
    iconName: 'tree-city',
    icon: [
      640,
      512,
      [],
      'e587',
      
      'M312 0H288V24 488v24h48V488 48H464V216v24h24 56 48V488v24h48V488 216 192H616 592V120 96H544v24 72H512V24 0H488 312zm56 80v64h64V80H368zm64 96H368v64h64V176zm-64 96v64h64V272H368zm192 0H496v64h64V272zm-64 96v64h64V368H496zM222 176c1-5 2-10 2-16c0-53-43-96-96-96c-54 0-96 43-96 96c0 6 0 11 1 16C13 190 0 214 0 240v80H80 96V512h64V320h16 80V240c0-26-14-50-34-64z'
      
    ]
  };

  

  
  

  var faFileMinus = {
    prefix: 'fasr',
    iconName: 'file-minus',
    icon: [
      384,
      512,
      [],
      'f318',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM120 288H96v48h24H264h24V288H264 120z'
      
    ]
  };

  

  
  

  var faEarListen = {
    prefix: 'fasr',
    iconName: 'ear-listen',
    icon: [
      512,
      512,
      ["assistive-listening-systems"],
      'f2a2',
      
      'M508 177.6l3.5 17.7-47.1 9.4L460.9 187c-11.8-58.9-47.1-110.5-97.8-142.7L388.9 3.8C450.6 43 493.6 105.8 508 177.6zM240 112c-70.7 0-128 57.3-128 128v24H64V240c0-97.2 78.8-176 176-176s176 78.8 176 176c0 50.8-21.6 96.6-56 128.7V376c0 75.1-60.9 136-136 136H200V464h24c48.6 0 88-39.4 88-88V357.9 346.5l8.8-7.2C349.7 315.7 368 280 368 240c0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40v24H152V240c0-48.6 39.4-88 88-88s88 39.4 88 88v24H280V240c0-22.1-17.9-40-40-40zM168 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM24 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm57-97l64 64 17 17L128 481.9l-17-17L47 401l-17-17L64 350.1l17 17z'
      
    ]
  };

  
    var faAssistiveListeningSystems = faEarListen;
  

  
  

  var faLink = {
    prefix: 'fasr',
    iconName: 'link',
    icon: [
      640,
      512,
      [128279,"chain"],
      'f0c1',
      
      'M59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4-31.6-36.1-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1L377.7 334l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8zm520.6 22.4c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4 31.6 36.1 6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4-36.1-31.6-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2z'
      
    ]
  };

  
    var faChain = faLink;
  

  
  

  var faBallotCheck = {
    prefix: 'fasr',
    iconName: 'ballot-check',
    icon: [
      448,
      512,
      [],
      'f733',
      
      'M400 48V464H48V48H400zM48 0H0V48 464v48H48 400h48V464 48 0H400 48zM80 96v64h64V96H80zm64 320V352H80v64h64zm32-312v48h24H344h24V104H344 200 176zm32 128v48h24H344h24V232H344 232 208zM176 360v48h24H344h24V360H344 200 176zm-4.7-116.7L182.6 232 160 209.4l-11.3 11.3L112 257.4 99.3 244.7 88 233.4 65.4 256l11.3 11.3 24 24L112 302.6l11.3-11.3 48-48z'
      
    ]
  };

  

  
  

  var faGrillHot = {
    prefix: 'fasr',
    iconName: 'grill-hot',
    icon: [
      448,
      512,
      [],
      'e5a5',
      
      'M144 0V24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4V104v24H144V104v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6V24 0h48zM256 0V24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4V104v24H256V104v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6V24 0h48zM400 160h48c0 16.5-1.8 32.5-5.2 48c-14.1 64.6-56.1 118.8-112.7 149.3l48 111.9 9.5 22.1-44.1 18.9-9.5-22.1L327 472H155.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l11.8-27.5C61.3 326.8 19.3 272.6 5.2 208C1.8 192.5 0 176.5 0 160H48 400zM285.6 375.4C266.1 381 245.4 384 224 384s-42.1-3-61.6-8.6L147.5 410c3.2 4.3 5.8 9 7.8 14H306.5l-20.8-48.6zM224 336c80.6 0 148.5-54.1 169.4-128H54.6C75.5 281.9 143.4 336 224 336zM120 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faLandmarkMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'landmark-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e622',
      
      'M448 288c-16.7 0-32.8-2.6-48-7.3V384H336V242.3c-5.8-5.7-11.1-11.8-16-18.3H288V384H224V224H176V384H112V224H64V384H56 32v48H56 456h24V384H456h-8V288zM256 0L0 144v48H48 301.3c-6.5-14.9-10.8-31.1-12.5-48H97.9L256 55.1l40.1 22.6c5.1-15.4 12.5-29.8 21.8-42.8L256 0zM0 464v48H24 488h24V464H488 24 0zM448 48.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.5-8.2 72-22.1l63.1 62.7 17 16.9 33.8-34-17-16.9-63-62.6c13.9-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faBoxesStacked = {
    prefix: 'fasr',
    iconName: 'boxes-stacked',
    icon: [
      576,
      512,
      [62625,"boxes","boxes-alt"],
      'f468',
      
      'M400 48V192h48V48 0H400 176 128V48 192h48V48h72v80h80V48h72zM352 512H528h48V464 272 224H528 352v48h24v80h80V272h72V464H352v48zM272 272V464H48V272h72v80h80V272h72zM48 224H0v48V464v48H48 272h48V464 272 224H272 48z'
      
    ]
  };

  
    var faBoxes = faBoxesStacked;
  
    var faBoxesAlt = faBoxesStacked;
  

  
  

  var faTimer = {
    prefix: 'fasr',
    iconName: 'timer',
    icon: [
      512,
      512,
      [],
      'e29e',
      
      'M256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-37.9 8.2-73.8 23-106.1c6-13.2 13.1-25.8 21.2-37.6c0-.1 .1-.1 .1-.2C53.4 98.7 63.6 86.3 75 75l33.9 33.9c-9.2 9.2-17.6 19.3-25 30.1c0 .1-.1 .1-.1 .2c-21.2 31.2-34.2 68.5-35.7 108.7c-.1 2.7-.2 5.4-.2 8.1c0 114.9 93.1 208 208 208s208-93.1 208-208c0-106.8-80.4-194.7-184-206.6V104v24H256 232V104 24 0h24zM176 142.1l17 17 80 80 17 17L256 289.9l-17-17-80-80-17-17L176 142.1z'
      
    ]
  };

  

  
  

  var faSpeaker = {
    prefix: 'fasr',
    iconName: 'speaker',
    icon: [
      384,
      512,
      [],
      'f8df',
      
      'M336 48V464H48V48H336zM48 0H0V48 464v48H48 336h48V464 48 0H336 48zM232 120a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM192 432a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM136 328a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z'
      
    ]
  };

  

  
  

  var faCarBus = {
    prefix: 'fasr',
    iconName: 'car-bus',
    icon: [
      640,
      512,
      [],
      'f85a',
      
      'M48 128v80H168V128H48zm0 128V376H192l0 48H80v32 24H32V456 424H24 0V400 88 82.3l2.5-5.1C11 60.4 31 41.2 61.3 26.4C92.2 11.3 135.2 0 192 0C312.9 0 365.4 45.2 381.5 77.3l2.5 5.1V88v40l-48 0H216v80h45.6l-11.1 32.1-1.8 0-56.7-.4V256H48zM321.4 80C301.9 65.2 263.6 48 192 48c-50.4 0-86.1 10-109.7 21.6c-7.1 3.5-13 7-17.9 10.4H192 321.4zM104 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM311.1 160H328 536h16.9l5.7 15.9L592.9 272H640v48 80 16 32 64H592V448H272v64H224V448 416 400 320 272h47.1l34.3-96.1 5.7-15.9zM576.6 320c-.4 0-.7 0-1.1 0H288.6c-.4 0-.7 0-1.1 0H272v80H592V320H576.6zM519.1 208H344.9l-22.9 64H541.9l-22.9-64zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faStarHalf = {
    prefix: 'fasr',
    iconName: 'star-half',
    icon: [
      576,
      512,
      [61731],
      'f089',
      
      'M148.1 328.5L129.7 456.3l-8 55.7 51.7-22.2 138.7-59.6V85.9 0l-48 71.2L201.6 164 76.2 185.7l-57.3 9.9 40.5 41.7 88.7 91.2zM116.7 227.4l93-16.1 20.2-3.5 11.4-17 22.7-33.7V398.6l-82.7 35.5 14.2-98.8L199 312l-16.4-16.9-65.8-67.7z'
      
    ]
  };

  

  
  

  var faMoneyFromBracket = {
    prefix: 'fasr',
    iconName: 'money-from-bracket',
    icon: [
      640,
      512,
      [],
      'e312',
      
      'M24 0H616h24V24 168v24H592V168 48H48V168v24H0V168 24 0H24zM464 400V96h48l0 392v24H488 152l-24 0V488l0-392h48l0 304c35.3 0 64 28.7 64 64H400c0-35.3 28.7-64 64-64zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z'
      
    ]
  };

  

  
  

  var faCheckToSlot = {
    prefix: 'fasr',
    iconName: 'check-to-slot',
    icon: [
      576,
      512,
      ["vote-yea"],
      'f772',
      
      'M144 80V360H432V80H144zM96 360V80 32h48H432h48V80 360h24v48H480 432 144 96 72V360H96zM64 288v48H48v96H528V336H512V288h16 48v48 96 48H528 48 0V432 336 288H48 64zM385 179.6L278.3 286.3l-17 17-17-17L191 233l-17-17L208 182.1l17 17 36.4 36.4L351 145.7l17-17 33.9 33.9-17 17z'
      
    ]
  };

  
    var faVoteYea = faCheckToSlot;
  

  
  

  var faCloudHail = {
    prefix: 'fasr',
    iconName: 'cloud-hail',
    icon: [
      512,
      512,
      [],
      'f739',
      
      'M368 128v48h48c26.5 0 48 21.5 48 48v48H416 96 48V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 320H48 96 416h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48 48zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faMeterFire = {
    prefix: 'fasr',
    iconName: 'meter-fire',
    icon: [
      640,
      512,
      [],
      'e1eb',
      
      'M256 48c70.2 0 132.2 34.8 169.9 88c1.8-1.2 3.5-2.3 5.1-3.3l21.6-13.5L493.4 160C455.4 66.2 363.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.5 0 65.5-6.4 94.8-18.1c-12.7-11.5-23.8-24.7-33-39.2c-19.5 6.1-40.3 9.3-61.8 9.3C141.1 464 48 370.9 48 256S141.1 48 256 48zM368 152V128H320v24 48 24h14.1c2.9-4 5.9-7.9 8.9-11.7c8-10.1 16.5-19.5 25-28.2V152zm-176 0V128H144v24 48 24h48V200 152zm88 0V128H232v24 48 24h48V200 152zm168 8c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z'
      
    ]
  };

  

  
  

  var faSquareE = {
    prefix: 'fasr',
    iconName: 'square-e',
    icon: [
      448,
      512,
      [],
      'e26d',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm152 96H296h24v48H296 176v56h88 24v48H264 176v56H296h24v48H296 152 128V360 256 152 128h24z'
      
    ]
  };

  

  
  

  var faHeadSideHeart = {
    prefix: 'fasr',
    iconName: 'head-side-heart',
    icon: [
      512,
      512,
      [],
      'e1aa',
      
      'M112 361.7v19.6V448v16 48H96 64V480 464 381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1V264v24 16 32H496 480 464 448v48 16 16 32H416 400 368 320v16 16 16 16H288 272V464 448 400h48 80V336 288h48 16V270.1l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48H224C126.8 48 48 127 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zm0-174.5c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L224 320.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z'
      
    ]
  };

  

  
  

  var faParagraph = {
    prefix: 'fasr',
    iconName: 'paragraph',
    icon: [
      448,
      512,
      [182],
      'f1dd',
      
      'M32 192c0-88.4 71.6-160 160-160h64H424h24V80H424 384l0 376v24H336V456l0-376H288V456v24H240V456 352H192c-88.4 0-160-71.6-160-160zM240 304V80H192C130.1 80 80 130.1 80 192s50.1 112 112 112h48z'
      
    ]
  };

  

  
  

  var faFax = {
    prefix: 'fasr',
    iconName: 'fax',
    icon: [
      512,
      512,
      [128224,128439],
      'f1ac',
      
      'M152 0H128V24 128H48 0v48V464v48H48 96h32 48H488h24V488 216 192H488 176V176 128 48H390.1L432 89.9V160h48V80 70.1l-7-7L417 7l-7-7H400 152zm24 240H464V464H176V240zM128 464H96 48V176h80v40 24V464zM304 272H240v64h64V272zm-64 96v64h64V368H240zm160-96H336v64h64V272zm-64 96v64h64V368H336z'
      
    ]
  };

  

  
  

  var faDeerRudolph = {
    prefix: 'fasr',
    iconName: 'deer-rudolph',
    icon: [
      576,
      512,
      [],
      'f78f',
      
      'M256 0V16 40c0 13.3 10.7 24 24 24h8 8c13.3 0 24-10.7 24-24V16 0h32V16 40c0 8.6-1.9 16.7-5.4 24H408h8c13.3 0 24-10.7 24-24V16 0h32V16 40c0 20.7-11.2 38.7-27.9 48.4l43.7 39.7c7.3-9.8 19-16.2 32.1-16.2c22.1 0 40 17.9 40 40s-17.9 40-40 40v40 24H496 409.3l-16.1 48.2c-.8 2.4-1.2 5-1.2 7.6V488v24H368 288 264V488 376H216h-3.9l-3.7-1.2L192 369.3v10.2l-9 7.2L156.4 408l26.1 71.8L194.3 512H160 80 63.2l-5.7-15.8-32-88-2.9-7.9 2.6-7.9L40 348.1V329.9l-8-8V336H0V320 272c0-28.5 12.5-54.2 32.2-71.8C49.8 180.5 75.5 168 104 168H295l7.2-24H256V112l60.3-15.1 .3-.9H296h-8-8c-30.9 0-56-25.1-56-56V16 0h32zM144 336V302.7l31.6 10.5L219.9 328H288h24v24V464h32V311.8c0-7.7 1.2-15.4 3.7-22.8l21.5-64.6 5.5-16.4H392h80V178.6L398.7 112H361.9l-26 86.9L330.8 216H312.9 104c-26.5 0-48 21.5-48 48v14.1l25 25 7 7V320v32 3.9l-1.2 3.7L73.4 399.7 96.8 464h28.9l-20.3-55.8L99.6 392 113 381.3l31-24.8V336zM400 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faFishBones = {
    prefix: 'fasr',
    iconName: 'fish-bones',
    icon: [
      576,
      512,
      [],
      'e304',
      
      'M32 96L0 128 64 256 0 384l32 32 64-64V304 280h40v72 24h48V352 280h48v72 24h48V352 280h48v72 24h48V352 280h40v72 11.8 7.8V400h32l16-18L576 256 464 130l-16-18H416v28.4 7.8V160v72H376V160 136H328v24 72H280V160 136H232v24 72H184V160 136H136v24 72H96V208 160L32 96zM464 202.2L511.8 256 464 309.8V202.2z'
      
    ]
  };

  

  
  

  var faHeartCircleBolt = {
    prefix: 'fasr',
    iconName: 'heart-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e4fc',
      
      'M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1l4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-14.4-6.6-29.8-11.4-45.9-14c2.7-8.5 4.1-17.4 4.1-26.4c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm24 64L352 384h66.7L408 448l104-96H445.3L456 288z'
      
    ]
  };

  

  
  

  var faIceCream = {
    prefix: 'fasr',
    iconName: 'ice-cream',
    icon: [
      448,
      512,
      [127848],
      'f810',
      
      'M224 0C140.9 0 72.6 63.3 64.8 144.4C28.4 148 0 178.7 0 216v48 24H24 64h72.4H311.6 384h40 24V264 216c0-37.3-28.4-68-64.8-71.6C375.4 63.3 307.1 0 224 0zM112 160c0-61.9 50.1-112 112-112s112 50.1 112 112c0 2.2-.1 4.4-.2 6.6L334.3 192h25.4H376c13.3 0 24 10.7 24 24v24H384 311.6 136.4 64 48V216c0-13.3 10.7-24 24-24H88.2h25.4l-1.5-25.4c-.1-2.2-.2-4.4-.2-6.6zM224 512L347.4 320H100.6L224 512z'
      
    ]
  };

  

  
  

  var faScrubber = {
    prefix: 'fasr',
    iconName: 'scrubber',
    icon: [
      512,
      512,
      [],
      'f2f8',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faDrum = {
    prefix: 'fasr',
    iconName: 'drum',
    icon: [
      512,
      512,
      [129345],
      'f569',
      
      'M501.2 76.1l20.1-13.2L494.9 22.8 474.8 35.9 370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 24.9 14.9 44.5 33.2 58.7c18.5 14.3 43.6 25.5 72 33.9C147.4 473 199.8 480 256 480s108.6-7 150.8-19.5c28.4-8.4 53.5-19.6 72-33.9C497.1 412.5 512 392.9 512 368V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3-20.1 13.2 26.3 40.2 20.1-13.2 111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6zM424 293.2c15-5.6 28.4-12 40-19V368c0 4.1-2.3 11.2-14.5 20.7c-6.5 5-15 10-25.5 14.6V293.2zM280 319.5c34.4-1.3 66.9-5.6 96-12.2V419.1c-27.9 6.7-60.5 11.1-96 12.5v-112zM136 307.4c29.1 6.6 61.6 10.8 96 12.2v112c-35.5-1.4-68.1-5.8-96-12.5V307.4zM48 274.2c11.6 7 25 13.4 40 19V403.3c-10.4-4.7-18.9-9.6-25.5-14.6C50.3 379.2 48 372.1 48 368V274.2z'
      
    ]
  };

  

  
  

  var faKite = {
    prefix: 'fasr',
    iconName: 'kite',
    icon: [
      640,
      512,
      [129665],
      'f6f4',
      
      'M285.4 354.6l0 0L480 160 592 272v11.3L285.4 354.6zM480 160L368 48H592L480 160zM615.2 327.2l24.8-5.8V296 48 32 0H608 592 344 318.6l-5.8 24.8-79.5 342-.5 2-1.4 5.8-.4 .4-89 89H120V356.7l-24-10-24 10V488v24H96h56 9.9l7-7 96-96 .4-.4 5.8-1.4 2-.5 342-79.5zM0 128v48H24 72V286L0 256v96l72-30 24-10 24 10 72 30V256l-72 30V152 128H96 24 0z'
      
    ]
  };

  

  
  

  var faRectangleTerminal = {
    prefix: 'fasr',
    iconName: 'rectangle-terminal',
    icon: [
      512,
      512,
      [],
      'e236',
      
      'M464 80V432H48V80H464zM48 32H0V80 432v48H48 464h48V432 80 32H464 48zM86.1 169.5l17.7 16.2L180.5 256l-76.7 70.3L86.1 342.5l32.4 35.4 17.7-16.2 96-88L251.5 256l-19.3-17.7-96-88-17.7-16.2L86.1 169.5zM248 336H224v48h24H392h24V336H392 248z'
      
    ]
  };

  

  
  

  var faAngle90 = {
    prefix: 'fasr',
    iconName: 'angle-90',
    icon: [
      448,
      512,
      [],
      'e08d',
      
      'M48 56V32H0V56 456v24H24 424h24V432H424 48V56zM96 97.6v48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384h48.3c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z'
      
    ]
  };

  

  
  

  var faPersonWalkingWithCane = {
    prefix: 'fasr',
    iconName: 'person-walking-with-cane',
    icon: [
      512,
      512,
      ["blind"],
      'f29d',
      
      'M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-56 32H104.4l-6.3 14.3-64 144 43.9 19.5L120 211.1v68.7c0 17.8 8.5 34.6 22.9 45.2L240 396.2V488v24h48V488 384 371.8l-9.8-7.2-38.2-28V207.3l68 102 13.3 20 39.9-26.6-13.3-20-96-144L244.8 128H232 120zm48 151.8V176h24V301.4l-20.7-15.2c-2.1-1.5-3.3-3.9-3.3-6.5zm175.4 70.1l99.9 144.2 9.1 13.2L478.6 489l-9.1-13.2L370.4 332.6c-3.2 3.7-7 7.1-11.3 10c-5 3.3-10.3 5.7-15.7 7.3zm-215.8 3.6L89.6 512h49.4l30.7-127.8-42-30.8z'
      
    ]
  };

  
    var faBlind = faPersonWalkingWithCane;
  

  
  

  var faTransporterEmpty = {
    prefix: 'fasr',
    iconName: 'transporter-empty',
    icon: [
      512,
      512,
      [],
      'e046',
      
      'M96 464h24H392h24v48H392 120 96V464z'
      
    ]
  };

  

  
  

  var faHotdog = {
    prefix: 'fasr',
    iconName: 'hotdog',
    icon: [
      512,
      512,
      [127789],
      'f80f',
      
      'M449.9 129.9l-320 320c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l320-320c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9zm33.9 33.9c37.5-37.5 37.5-98.3 0-135.8s-98.3-37.5-135.8 0l-320 320c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0l320-320zm-6.5 57.5l-256 256L256 512 512 256l-34.7-34.7zM34.7 290.7l256-256L256 0 0 256l34.7 34.7zm371.8-140l14.6-6.5-13-29.2-14.6 6.5-72 32-4.9 2.2-2.6 4.7-37.6 67.7-59.6 29.8-4.4 2.2-2.4 4.3-37.8 68-68 37.8-14 7.8 15.5 28 14-7.8 72-40 4-2.2 2.2-4 37.6-67.7 59.6-29.8 4.4-2.2 2.4-4.3 37.4-67.3 67.1-29.8z'
      
    ]
  };

  

  
  

  var faEarMuffs = {
    prefix: 'fasr',
    iconName: 'ear-muffs',
    icon: [
      640,
      512,
      [],
      'f795',
      
      'M112 0h24H504h24V24 201.6c-12-6.1-25.6-9.6-40-9.6c-2.7 0-5.4 .1-8 .4V48H160V192.4c-2.6-.2-5.3-.4-8-.4c-14.4 0-28 3.5-40 9.6V24 0zM480 224.6c2.6-.4 5.3-.6 8-.6c12 0 23.2 3.8 32.3 10.2c5-1.5 10.3-2.2 15.7-2.2c19.9 0 37.5 10.4 47.4 26.1c23.4 6.7 40.6 28.3 40.6 53.9c0 5.1-.7 10.1-2 14.9c11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9c0 25.6-17.2 47.2-40.6 53.9C573.5 493.6 555.9 504 536 504c-5.5 0-10.7-.8-15.7-2.2C511.2 508.2 500 512 488 512c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-28.2 20.9-51.6 48-55.4zM152 224c2.7 0 5.4 .2 8 .6c27.1 3.9 48 27.2 48 55.4c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-12 0-23.2-3.8-32.3-10.2c-5 1.5-10.3 2.2-15.7 2.2c-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1 .7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9c0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7 .8 15.7 2.2C128.8 227.8 140 224 152 224zm-6.9 84L159 284c.7-1.1 1-2.4 1-4c0-4.4-3.6-8-8-8c-1.8 0-3.3 .5-4.6 1.4l-18.9 13.4-22.2-6.5c-.7-.2-1.4-.3-2.3-.3c-2.8 0-5.3 1.4-6.8 3.8l-9.8 15.5-17.6 5c-3.4 1-5.8 4.1-5.8 7.7c0 .8 .1 1.5 .3 2.2L72 342.3 50.6 362.1c-1.7 1.5-2.6 3.6-2.6 5.9s.9 4.4 2.6 5.9L72 393.7l-7.7 28.1c-.2 .6-.3 1.3-.3 2.2c0 3.6 2.4 6.7 5.8 7.7l17.6 5 9.8 15.5c1.5 2.4 4 3.8 6.8 3.8c.9 0 1.6-.1 2.3-.3l22.2-6.5 18.9 13.4c1.3 .9 2.8 1.4 4.6 1.4c4.4 0 8-3.6 8-8c0-1.5-.4-2.8-1-4l-13.9-24L159 404c.7-1.1 1-2.4 1-4c0-1.8-.5-3.3-1.4-4.5L139.4 368l19.2-27.5c.9-1.3 1.4-2.8 1.4-4.5c0-1.5-.4-2.8-1-4l-13.9-24zm336-24l13.9 24L481 332c-.7 1.1-1 2.4-1 4c0 1.8 .5 3.3 1.4 4.5L500.6 368l-19.2 27.5c-.9 1.3-1.4 2.8-1.4 4.5c0 1.5 .4 2.8 1 4l13.9 24L481 452c-.7 1.1-1 2.4-1 4c0 4.4 3.6 8 8 8c1.8 0 3.3-.5 4.6-1.4l18.9-13.4 22.2 6.5c.7 .2 1.4 .3 2.3 .3c2.8 0 5.3-1.4 6.8-3.8l9.8-15.5 17.6-5c3.4-1 5.8-4.1 5.8-7.7c0-.8-.1-1.5-.3-2.2L568 393.7l21.4-19.8c1.7-1.5 2.6-3.6 2.6-5.9s-.9-4.4-2.6-5.9L568 342.3l7.7-28.1c.2-.6 .3-1.3 .3-2.2c0-3.6-2.4-6.7-5.8-7.7l-17.6-5-9.8-15.5c-1.5-2.4-4-3.8-6.8-3.8c-.9 0-1.6 .1-2.3 .3l-22.2 6.5-18.9-13.4c-1.3-.9-2.8-1.4-4.6-1.4c-4.4 0-8 3.6-8 8c0 1.5 .4 2.8 1 4z'
      
    ]
  };

  

  
  

  var faRouteInterstate = {
    prefix: 'fasr',
    iconName: 'route-interstate',
    icon: [
      512,
      512,
      [],
      'f61b',
      
      'M268.7 11.6L256 3.7l-12.7 7.9C186.9 46.9 130.2 48 52.7 32.5L28.1 27.5 24.3 52.4C8 158.5 11.5 250.1 46.3 326.2c35.2 77 100.6 134.6 200.5 175.9l9.7 4 9.5-4.4c97.3-44.9 162.4-102.3 198-178.1c35.4-75.3 40-165.1 23.6-271.4l-3.8-24.8-24.6 4.9C381.8 48 325.1 46.9 268.7 11.6zM63.7 192H447.8c-2.9 42-11.8 78.7-27.1 111.3c-28.4 60.3-80.4 109.5-165.2 150.4C169.5 416.2 117.8 367.2 90 306.3C74.7 272.9 66.2 235.1 63.7 192z'
      
    ]
  };

  

  
  

  var faBroccoli = {
    prefix: 'fasr',
    iconName: 'broccoli',
    icon: [
      512,
      512,
      [129382],
      'e3e2',
      
      'M256 0c-37.2 0-69.5 21.2-85.4 52.1C162.2 49.4 153.3 48 144 48c-48.6 0-88 39.4-88 88v32.7C23 183.9 0 217.2 0 256c0 53 43 96 96 96H416c53 0 96-43 96-96c0-39.2-23.4-72.8-57-87.8l1-31.5 0-.4V136c0-48.6-39.4-88-88-88c-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zM208.4 89.7C211.5 66.2 231.6 48 256 48s44.5 18.2 47.6 41.7l5.6 42.9 33.4-27.5c6.9-5.7 15.7-9.1 25.4-9.1c22 0 39.8 17.7 40 39.7l-1.6 49-.7 20.3 19.9 4c21.9 4.4 38.4 23.8 38.4 47c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48c0-22.8 15.9-42 37.3-46.8l18.7-4.2V185.8 136c0-22.1 17.9-40 40-40c9.7 0 18.5 3.4 25.4 9.1l33.4 27.5 5.6-42.9zM200 512H312c18.4-55.3 44.9-100.1 63.9-128H280l-24 48-24-48H136.1c19.1 27.9 45.5 72.7 63.9 128z'
      
    ]
  };

  

  
  

  var faFaceSmilingHands = {
    prefix: 'fasr',
    iconName: 'face-smiling-hands',
    icon: [
      640,
      512,
      [],
      'e396',
      
      'M529.4 250.7l-1.4 1.4C525.9 139.1 433.6 48 320 48s-205.9 91.1-208 204.2l-1.4-1.4L88 228.1 65.4 250.7 64 252.1C66.1 112.5 179.9 0 320 0S573.9 112.5 576 252.1l-1.3-1.3L552 228.1l-22.6 22.6zM256 334.4v-1.9c16.8 10.8 39.1 19.5 64 19.5s47.2-8.7 64-19.5v1.9 52.3c-19 8.1-40.7 13.3-64 13.3s-45-5.2-64-13.3V334.4zM228.9 495.3c9.9-12.6 17.5-27.2 22.1-43c21.6 7.6 44.8 11.7 69 11.7s47.4-4.1 69-11.7c4.6 15.8 12.2 30.4 22.1 43c-28.3 10.8-59 16.7-91.1 16.7s-62.8-5.9-91.1-16.7zM240 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zM76.7 307.3L65.4 296 88 273.4l11.3 11.3L184 369.4v-15-20h40v20V384v20 12.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9L12.7 435.3 1.4 424 24 401.4l11.3 11.3 24 24 9.4-9.4-56-56L1.4 360 24 337.4l11.3 11.3 56 56 9.4-9.4-72-72L17.4 312 40 289.4l11.3 11.3 72 72 9.4-9.4-56-56zm486.6 0l-56 56 9.4 9.4 72-72L600 289.4 622.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L616 337.4 638.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L616 401.4 638.6 424l-11.3 11.3-48.8 48.8C560.7 502 536.4 512 511.2 512c-52.6 0-95.2-42.6-95.2-95.2V404 384 354.4v-20h40v20 15l84.7-84.7L552 273.4 574.6 296l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faOilCanDrip = {
    prefix: 'fasr',
    iconName: 'oil-can-drip',
    icon: [
      640,
      512,
      [],
      'e205',
      
      'M352 112H280v48H384l64 32 155.3-31.1 2.6-.5 2-.4 32 32L432 416H384 144 96V368 346.7L0 304V208 160H48 96h48 88V112H160V64H352v48zM96 208H48v64.8l48 21.3V208zm345.3 34.3l-14.7-7.4L372.7 208H144V315.5 368H384h27.1L547.5 221l-90.1 18-16.2 3.2zM592 448c-26.5 0-48-21.5-48-48c0-32 48-96 48-96s48 64 48 96s-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faObjectsAlignLeft = {
    prefix: 'fasr',
    iconName: 'objects-align-left',
    icon: [
      512,
      512,
      [],
      'e3be',
      
      'M0 512L0 0 48 0l0 512L0 512zM176 176l288 0 0-64-288 0 0 64zm-48-64l0-48 48 0 288 0 48 0 0 48 0 64 0 48-48 0-288 0-48 0 0-48 0-64zm48 288l160 0 0-64-160 0 0 64zm-48-64l0-48 48 0 160 0 48 0 0 48 0 64 0 48-48 0-160 0-48 0 0-48 0-64z'
      
    ]
  };

  

  
  

  var faDharmachakra = {
    prefix: 'fasr',
    iconName: 'dharmachakra',
    icon: [
      512,
      512,
      [9784],
      'f655',
      
      'M232 0l1.3 33.1c-44.8 4.5-85.7 22.2-118.8 49.2L92 58 58 92l24.3 22.5c-27 33.1-44.7 74-49.2 118.8L0 232v48l33.1-1.3c4.5 44.8 22.2 85.7 49.2 118.8L58 420 92 454l22.5-24.3c33.1 27 74 44.7 118.8 49.2L232 512h48l-1.3-33.1c44.8-4.5 85.7-22.2 118.8-49.2L420 454 454 420l-24.3-22.5c27-33.1 44.7-74 49.2-118.8L512 280V232l-33.1 1.3c-4.5-44.8-22.2-85.7-49.2-118.8L454 92 420 58 397.5 82.4c-33.1-27-74-44.7-118.8-49.2L280 0H232zM147.2 394.3l54.7-59c10.7 7.4 23.1 12.6 36.4 15.1l-3.1 80.4c-33-3.9-63.1-16.9-87.9-36.4zm29.5-84.2l-59.1 54.7c-19.5-24.8-32.5-55-36.4-87.9l80.4-3.1c2.5 13.3 7.7 25.6 15.1 36.4zm-95.5-75c3.9-33 16.9-63.1 36.4-87.9l59.1 54.7c-7.4 10.7-12.6 23.1-15.1 36.4l-80.4-3.1zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-54.1-31.3l-54.7-59.1c24.8-19.5 55-32.5 87.9-36.4l3.1 80.4c-13.3 2.5-25.6 7.7-36.4 15.1zm75-95.5c33 3.9 63.1 16.9 87.9 36.4l-54.7 59.1c-10.7-7.4-23.1-12.6-36.4-15.1l3.1-80.4zm87.9 313.1c-24.8 19.5-55 32.5-87.9 36.4l-3.1-80.4c13.3-2.5 25.6-7.7 36.4-15.1l54.7 59zm29.5-29.5l-59-54.7c7.4-10.7 12.6-23.1 15.1-36.4l80.4 3.1c-3.9 33-16.9 63.1-36.4 87.9zm0-217.6c19.5 24.8 32.5 55 36.4 87.9l-80.4 3.1c-2.5-13.3-7.7-25.6-15.1-36.4l59-54.7z'
      
    ]
  };

  

  
  

  var faCircleUpLeft = {
    prefix: 'fasr',
    iconName: 'circle-up-left',
    icon: [
      512,
      512,
      [],
      'e128',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 320l24 24 52-52 76 76 56-56-76-76 52-52-24-24H160V320z'
      
    ]
  };

  

  
  

  var faCloudHailMixed = {
    prefix: 'fasr',
    iconName: 'cloud-hail-mixed',
    icon: [
      512,
      512,
      [],
      'f73a',
      
      'M368 128v48h48c26.5 0 48 21.5 48 48v48H416 96 48V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 320H48 96 416h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48 48zm104 32H48L19.2 416h56L104 352zm120 0H168L96 512h56l72-160zm56 0l-28.8 64h56L336 352H280zm176 0H400L328 512h56l72-160zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faDiagramSankey = {
    prefix: 'fasr',
    iconName: 'diagram-sankey',
    icon: [
      576,
      512,
      [],
      'e158',
      
      'M298.5 32H312 552h24V80H552 325.5l-81 132.5-7 11.5H224 24 0V176H24 210.5l81-132.5 7-11.5zM150.6 320H24 0V272H24 552h24v48H552 205.9l64 112H552h24v48H552 256 242.1l-6.9-12.1L150.6 320z'
      
    ]
  };

  

  
  

  var faBarsStaggered = {
    prefix: 'fasr',
    iconName: 'bars-staggered',
    icon: [
      512,
      512,
      ["reorder","stream"],
      'f550',
      
      'M0 64H448v48H0V64zM64 224H512v48H64V224zM448 384v48H0V384H448z'
      
    ]
  };

  
    var faReorder = faBarsStaggered;
  
    var faStream = faBarsStaggered;
  

  
  

  var faUserBountyHunter = {
    prefix: 'fasr',
    iconName: 'user-bounty-hunter',
    icon: [
      448,
      512,
      [],
      'e2bf',
      
      'M323 120C309.4 78 270 48 224 48s-85.4 30-99 72H323zm5.5 36.4L248 171.5v95.9l9.9-1.7c8.4-48.3 43-79.4 71.5-95.4l-.9-13.8zm-209 0l-.9 13.8c28.5 16 63.1 47.1 71.5 95.4l9.9 1.7V171.5l-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2l8.3 128.2 1.4 21.4-21.2 3.7-136 24c-2.8 .5-5.6 .5-8.3 0l-136-24-21.2-3.7L64 271.2V256 16 0H80 96h16V32H96V70zM64.5 464H160l64-48 64 48h95.5l-19.2-64H83.7L64.5 464zM48 352H400l33.6 112L448 512H397.9 50.1 0l14.4-48L48 352z'
      
    ]
  };

  

  
  

  var faChessRook = {
    prefix: 'fasr',
    iconName: 'chess-rook',
    icon: [
      448,
      512,
      [9820],
      'f447',
      
      'M32 32H56 392h24V56 208v12l-9.6 7.2-53 39.8 9.4 85H314.5l-10.4-93.3L302.6 245l11-8.2L368 196V80H304v24 24H256V104 80H192v24 24H144V104 80H80V196l54.4 40.8 11 8.2-1.5 13.6L133.5 352H85.2l9.4-85-53-39.8L32 220V208 56 32zm69.2 400L84.7 464H363.3l-16.6-32H101.2zM416 464v48H368 80 32V464v-2.7L72 384H376l40 77.3V464zM192 288V224c0-17.7 14.3-32 32-32s32 14.3 32 32v64H192z'
      
    ]
  };

  

  
  

  var faWineBottle = {
    prefix: 'fasr',
    iconName: 'wine-bottle',
    icon: [
      512,
      512,
      [],
      'f72f',
      
      'M417.9 0H400l0 0L375 25l0 0 10.7 10.7-1 1-83.6 83.6c-41.9-10.8-88.2 .2-120.9 32.9L33.9 299.5 0 333.5l33.9 33.9L144.6 478.1 178.5 512l33.9-33.9L358.7 331.8c32.8-32.8 43.8-79.1 32.9-120.9l83.6-83.6 1-1L487 137l25-25V94.1L417.9 0zM357.8 176.9l-19.4 19.4 6.9 26.6c6.5 25 .4 52.4-18 72.4L216.7 184.7c20.1-18.4 47.4-24.4 72.4-18l26.6 6.9 19.4-19.4 83.6-83.6 22.6 22.6-83.6 83.6zM104.7 296.7L215.3 407.3l-36.8 36.8L67.9 333.5l36.8-36.8z'
      
    ]
  };

  

  
  

  var faWhiskeyGlassIce = {
    prefix: 'fasr',
    iconName: 'whiskey-glass-ice',
    icon: [
      512,
      512,
      ["glass-whiskey-rocks"],
      'f7a1',
      
      'M105.6 432H406.4l18.2-127.7-22.1 22.1L345.9 383 312 416.9 278.1 383l-56.6-56.6-33.9-33.9 33.9-33.9 56.6-56.6L312 168l33.9 33.9 56.6 56.6 25.1 25.1L456.7 80H55.3L88 308.6V224 176h48 96 26.7l-48 48H136v96h33.8l48 48H136 96.5l9.1 64zM448 480H64L6.9 80 0 32H48.5h415H512l-6.9 48L448 480zM312 235.9l-56.6 56.6L312 349l56.6-56.6L312 235.9z'
      
    ]
  };

  
    var faGlassWhiskeyRocks = faWhiskeyGlassIce;
  

  
  

  var faPollPeople = {
    prefix: 'fasr',
    iconName: 'poll-people',
    icon: [
      640,
      512,
      [],
      'f759',
      
      'M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM592 80v64H480V80H592zM272 32H224V80v64 48h48H592h48V144 80 32H592 272zM592 368v64H352V368H592zM272 320H224v48 64 48h48H592h48V432 368 320H592 272zM80 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM32 128L0 224H160l-32-96H32zM160 512l-32-96H32L0 512H160z'
      
    ]
  };

  

  
  

  var faHospital = {
    prefix: 'fasr',
    iconName: 'hospital',
    icon: [
      640,
      512,
      [62589,127973,"hospital-alt","hospital-wide"],
      'f0f8',
      
      'M184 0H160V24 80H24 0v24 88 48 48 48V488v24H24h0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 .1 .1 .1H25 25h.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1H26h.1 .1 .1 .1 .1 .1 .1 .1 .1 .1H27h.1 .1 .1 .1 .1 .1 .1 .1H28h.1 .1 .1 .1 .1 .1 .1H29h.1 .1 .1 .1 .1 .1 .1H30h.1 .1 .1 .1 .1 .1H31h.2 .2 .2 .2 .2H32h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H34h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H36h.2 .2 .2 .2H37h.2 .2 .2 .2H38h.2 .2 .2 .2H39h.2 .2 .2 .2 .2 .2 .2 .2H41h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H44h.2 .2 .2H45h.2 .2 .2H46h.3 .3 .3H47h.3 .3 .3H48h.3 .3 .3 .3 .3 .3 .3 .3 .3 .3H51h.3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H57h.3 .3 .3 .3 .3 .3 .3 .3 .3H60h.3 .3H61h.3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .4 .4 .4 .4 .4 .4H76h.4 .4 .4 .4 .4 .4 .4 .4 .4 .4H80h.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4H89h.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5v0H456h8v0H616h24V488 336 288 240 192 104 80H616 480V24 0H456 184zM592 192H536 512v48h24 56v48H536 512v48h24 56V464H480V336 128H592v64zM104 240h24V192H104 48V128H160V464h-.1-.5-.5-.5H158h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H151h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H145h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H140h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H135h-.5-.5-.5-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H123h-.4-.4-.4-.4-.4-.4-.4-.4H119h-.4-.4-.4-.4-.4-.4H116h-.4-.4-.4-.4-.4-.4H113h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H105h-.4-.4-.4-.4H103h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H89h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H80h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H76h-.4-.4-.4-.4-.4-.4-.4-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H61h-.3-.3H60h-.3-.3-.3-.3-.3-.3-.3-.3-.3H57h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H51h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H48h0V336h56 24V288H104 48V240h56zM208 464V48H432V336 464H368V352H272V464H208zM296 80v40H256v48h40v40h48V168h40V120H344V80H296z'
      
    ]
  };

  
    var faHospitalAlt = faHospital;
  
    var faHospitalWide = faHospital;
  

  
  

  var faLampDesk = {
    prefix: 'fasr',
    iconName: 'lamp-desk',
    icon: [
      512,
      512,
      [],
      'e014',
      
      'M347.3 97.9L309.3 59.9C301.6 52.3 291.3 48 280.6 48C258.2 48 240 66.2 240 88.6c0 10.8 4.3 21.1 11.9 28.7l38.1 38.1L304 169.4v19.9 62.9L444.1 112H381.3 361.4L347.3 97.9zM381.3 64H464l14.1 14.1L512 112l-33.9 33.9L432 192l-48 48-46.1 46.1L304 320l-33.9-33.9L256 272V189.3l-13.7-13.7c-.6 .7-1.3 1.4-2 2.1l-93.1 86L204.4 464H360h24v48H360 24 0V464H24 154.5L96.9 262.6l-4.1-14.2 10.9-10 104-96c.5-.5 1-.9 1.5-1.3C198.1 126 192 107.6 192 88.6C192 39.7 231.7 0 280.6 0c23.5 0 46 9.3 62.6 25.9L381.3 64zM480 240c0 26.5-21.5 48-48 48c-14 0-26.5-6-35.3-15.5l67.8-67.8C474 213.5 480 226 480 240z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenText = {
    prefix: 'fasr',
    iconName: 'envelope-open-text',
    icon: [
      512,
      512,
      [],
      'f658',
      
      'M112 48V215.6L64 183V48 0h48H400h48V48 183l-48 32.6V48H112zM256 410l-27-18.3L48 268.9V464H464V268.9L283 391.7 256 410zM464 210.9l48-32.6v58V464v48H464 48 0V464 236.3v-58l48 32.6L256 352 464 210.9zM184 96H328h24v48H328 184 160V96h24zm0 80H328h24v48H328 184 160V176h24z'
      
    ]
  };

  

  
  

  var faSquareAmpersand = {
    prefix: 'fasr',
    iconName: 'square-ampersand',
    icon: [
      448,
      512,
      [],
      'e260',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm136 96h24 96 24v24 35.7c0 20.4-9.7 39.6-26.2 51.6l-18 13.2 28.6 29.9 27.7-40.1 13.7-19.7 39.5 27.3-13.7 19.7-33.3 48.1 60.9 63.6c.8 .8 1.5 1.7 2.2 2.6H295.4l-24.8-25.9-10.8 15.6L252.6 384H240 224 136 112V360 320.3c0-22.9 10.9-44.5 29.4-58.1l21.9-16.1-7.3-7.7c-12.8-13.4-20-31.2-20-49.8V152 128zm66.4 89.6l23.1-16.9c4.1-3 6.5-7.8 6.5-12.9V176H184v12.7c0 6.2 2.4 12.1 6.7 16.6l11.7 12.2zm-5.6 63.6l-27 19.8c-6.2 4.5-9.8 11.7-9.8 19.4V336h67.4l9.2-13.3-39.8-41.5z'
      
    ]
  };

  

  
  

  var faGaugeHigh = {
    prefix: 'fasr',
    iconName: 'gauge-high',
    icon: [
      512,
      512,
      [62461,"tachometer-alt","tachometer-alt-fast"],
      'f625',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 408c30.9 0 56-25.1 56-56c0-14-5.1-26.8-13.7-36.6L366 161.7l9.7-22-43.9-19.3-9.7 22L254.4 296c-30.2 .8-54.4 25.6-54.4 56c0 30.9 25.1 56 56 56zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faTachometerAlt = faGaugeHigh;
  
    var faTachometerAltFast = faGaugeHigh;
  

  
  

  var faSquareThisWayUp = {
    prefix: 'fasr',
    iconName: 'square-this-way-up',
    icon: [
      448,
      512,
      ["box-up"],
      'f49f',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM352 352v48H96V352H352zm-72-32V192H240V176l64-64 64 64v16H328V320H280zM120 192H80V176l64-64 64 64v16H168V320H120V192z'
      
    ]
  };

  
    var faBoxUp = faSquareThisWayUp;
  

  
  

  var faSection = {
    prefix: 'fasr',
    iconName: 'section',
    icon: [
      256,
      512,
      [],
      'e447',
      
      'M48.4 90.6c2.8-15.9 12.5-27.3 29-34.6c17.6-7.7 42.8-10.5 73.1-5.6L153.7 30l-3.3 20.5c9.7 1.6 39.9 7.6 49.1 10.1l12.7-46.3C200.7 11.1 168.7 4.8 158.1 3C121.8-2.8 86.5-.5 58 12.1C28.6 25.1 6.7 49 1 83.3c-.1 .4-.1 .8-.2 1.2c-2.2 19.5 .4 37 7.9 52.3c7.4 15.2 18.8 26.6 31.4 35.3c2.4 1.7 4.9 3.3 7.4 4.8C24.2 189.8 6.8 210.7 1.7 239.4c-.1 .4-.1 .9-.2 1.3c-2.3 18.8 .4 35.8 8.1 50.7c7.6 14.6 19.1 25.5 31.6 33.7c22.9 15.1 53.3 23.9 79.2 31.5l3.6 1c29 8.5 52.3 15.7 67.7 26.7c7.1 5.1 11.4 10.2 13.7 15.6c2.3 5.3 3.6 12.8 1.6 24.2c-2.5 14.2-11.6 25.1-28.5 32.2c-17.7 7.4-43.1 9.9-73.3 5.3c-14.9-2.4-40.4-10.8-61-17.7c-4.5-1.5-8.8-2.9-12.7-4.2L16.6 485.5c3 1 6.5 2.1 10.5 3.5l0 0 0 0 0 0c20.3 6.7 51.4 17.1 70.6 20.2l.1 0c36 5.5 70.9 3.3 99.1-8.5c29-12.1 51.4-34.8 57.3-68.1c3.4-19 1.9-36.3-4.8-51.8c-6.7-15.3-17.6-26.8-29.8-35.6c0 0 0 0 0 0c17.7-13.5 30.5-32.7 34.7-58c3.3-19.7 1.8-37.5-4.7-53.4c-6.5-15.8-17.3-27.9-29.6-37.2c-23.2-17.5-55.1-27.4-81.8-35.6l-.7-.2c-29.3-9-53.3-16.5-69.9-28.1c-7.7-5.4-12.7-11-15.7-17c-2.8-5.8-4.6-13.7-3.4-25.1zM163.2 319.3c-8.6-2.8-17-5.2-25-7.6l-.8-.2C108.3 303 84.2 295.9 67.6 285c-7.8-5.1-12.6-10.3-15.4-15.7c-2.6-5-4.3-11.9-3.2-22.1c2.7-13.9 11.7-24.6 28.4-31.6c13-5.4 30.2-8.3 50.5-7.5c26.9 8.4 48.6 15.8 63.1 26.8c7.1 5.4 11.6 10.9 14.1 17.1c2.5 6.1 3.9 14.7 1.8 27.2c-3.3 19.4-17.2 33.8-43.7 40.1z'
      
    ]
  };

  

  
  

  var faSquare0 = {
    prefix: 'fasr',
    iconName: 'square-0',
    icon: [
      448,
      512,
      [],
      'e255',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm224 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48s-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faInbox = {
    prefix: 'fasr',
    iconName: 'inbox',
    icon: [
      512,
      512,
      [],
      'f01c',
      
      'M48 336v96H464V336H382.8l-25.4 50.7L350.8 400H336 176 161.2l-6.6-13.3L129.2 336H48zm406.5-48l-52-208h-293l-52 208H144h14.8l6.6 13.3L190.8 352H321.2l25.4-50.7 6.6-13.3H368h86.5zM0 432V320L72 32H440l72 288V432v48H464 48 0V432z'
      
    ]
  };

  

  
  

  var faFaceSunglasses = {
    prefix: 'fasr',
    iconName: 'face-sunglasses',
    icon: [
      512,
      512,
      [],
      'e398',
      
      'M256 464C141.1 464 48 370.9 48 256c0-21.8 3.4-42.8 9.6-62.5L80 272H208l22.9-80h50.3L304 272H432l22.4-78.5c6.2 19.7 9.6 40.7 9.6 62.5c0 114.9-93.1 208-208 208zM240 144V128H92c38.1-48.7 97.4-80 164-80s125.9 31.3 164 80H272v16H240zm16 368A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-96c61.9 0 112-36.8 132-66.7L348 322.7C336 340.8 300.1 368 256 368s-80-27.2-92-45.3L124 349.3c19.9 29.9 70 66.7 132 66.7z'
      
    ]
  };

  

  
  

  var faSocks = {
    prefix: 'fasr',
    iconName: 'socks',
    icon: [
      512,
      512,
      [129510],
      'f696',
      
      'M288 0H176 128V48 96v24 24V272L38.4 339.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2c-8-14.8-13.1-31.4-14.7-49l-35.7 26.8c-8.3 6.2-18.4 9.6-28.8 9.6c-26.5 0-48-21.5-48-48c0-15.1 7.1-29.3 19.2-38.4L38.4 339.2l28.8 38.4 89.6-67.2L176 296V272 144H288V120 96H176V48H288V0zm80 144h96V344L316.8 454.4c-8.3 6.2-18.4 9.6-28.8 9.6c-26.5 0-48-21.5-48-48c0-15.1 7.1-29.3 19.2-38.4l89.6-67.2L368 296V272 144zM320 272l-89.6 67.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2L512 368V144 120 96 48 0H464 368 320V48 96v24 24V272zM368 96V48h96V96H368z'
      
    ]
  };

  

  
  

  var faGrid4 = {
    prefix: 'fasr',
    iconName: 'grid-4',
    icon: [
      448,
      512,
      [],
      'e198',
      
      'M0 32H89.6v89.6H0V32zM0 151.5H89.6v89.6H0V151.5zM89.6 270.9v89.6H0V270.9H89.6zM0 390.4H89.6V480H0V390.4zM119.5 32h89.6v89.6H119.5V32zm0 119.5h89.6v89.6H119.5V151.5zm89.6 119.5v89.6H119.5V270.9h89.6zM119.5 390.4h89.6V480H119.5V390.4zM328.5 32v89.6H238.9V32h89.6zm0 119.5v89.6H238.9V151.5h89.6zM238.9 270.9h89.6v89.6H238.9V270.9zm89.6 119.5V480H238.9V390.4h89.6zM358.4 32H448v89.6H358.4V32zm0 119.5H448v89.6H358.4V151.5zM448 270.9v89.6H358.4V270.9H448zM358.4 390.4H448V480H358.4V390.4z'
      
    ]
  };

  

  
  

  var faBatteryEmpty = {
    prefix: 'fasr',
    iconName: 'battery-empty',
    icon: [
      576,
      512,
      ["battery-0"],
      'f244',
      
      'M48 144V368H496V144H48zM0 96H48 496h48v48 48h32V320H544v48 48H496 48 0V368 144 96z'
      
    ]
  };

  
    var faBattery0 = faBatteryEmpty;
  

  
  

  var faSnowflakeDroplets = {
    prefix: 'fasr',
    iconName: 'snowflake-droplets',
    icon: [
      640,
      512,
      [],
      'e5c1',
      
      'M344 24V0H296V24 70.1L279.4 53.4l-17-17L228.5 70.4l17 17L296 137.9v76.5l-66.2-38.2-18.5-69.1L205 83.9 158.7 96.3l6.2 23.2 6.1 22.7-26-15-20.8-12-24 41.6 20.8 12 26 15-22.7 6.1-23.2 6.2 12.4 46.4 23.2-6.2 69.1-18.5L272 256l-66.2 38.2-69.1-18.5-23.2-6.2-11.3 42.3 2.6 5.1 19.5 5.2 22.7 6.1-26 15-2 1.2 22 42.7 4-2.3 26-15-6.1 22.7-6.2 23.2L205 428.1l6.2-23.2 18.5-69.1L296 297.6v76.5l-50.6 50.6-17 17 33.9 33.9 17-17L296 441.9V488v24h48V488 441.9l16.6 16.6 17 17 33.9-33.9-17-17L344 374.1V297.6l66.2 38.2 18.5 69.1 6.2 23.2 46.4-12.4-6.2-23.2L469 369.8l26 15 4 2.3 22-42.7-2-1.2-26-15 22.7-6.1 19.5-5.2 2.6-5.1-11.3-42.3-23.2 6.2-69.1 18.5L368 256l66.2-38.2 69.1 18.5 23.2 6.2 12.4-46.4-23.2-6.2L493 183.8l26-15 20.8-12-24-41.6-20.8 12-26 15 6.1-22.7 6.2-23.2L435 83.9l-6.2 23.2-18.5 69.1L344 214.4V137.9l50.6-50.6 17-17L377.6 36.5l-17 17L344 70.1V24zM520.3 417.4c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L576 320l-55.7 97.4zM64 320L8.3 417.4C2.9 427 0 437.8 0 448.8C0 483.7 28.3 512 63.2 512h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L64 320z'
      
    ]
  };

  

  
  

  var faDove = {
    prefix: 'fasr',
    iconName: 'dove',
    icon: [
      512,
      512,
      [128330],
      'f4ba',
      
      'M224 0c-.9 .8-2 1.7-3.2 2.8l0 0c-13.7 11.8-45.7 39.4-68.6 82.1c25.6 37.5 65.2 61.6 103.8 75.8V160c0-11.9 1.6-23.5 4.7-34.4C236.6 90.6 220.9 48.5 224 0zm16 188.8c-46.8-18.1-96.6-50.4-124.9-103.2c-5.3-10-9.9-20.7-13.6-32.2c-2.2-6.8-4-14-5.5-21.4c-1.7 2.6-4.5 6.1-8.1 10.4c-7.4 9.1-17.8 22.1-27.7 38.4C45.5 105.3 32 137.4 32 176c0 54.4 17.4 97.3 39.8 129.8c10.4 15.1 21.9 28 33.3 38.8L56 363l-10.5 3.9L0 384l24.1 42.2L64 496l128 16 73.1-64H320c88.4 0 160-71.6 160-160V120l4.6-8L512 64H456.7 384c-51 0-92.7 39.7-95.8 89.9c-.1 2-.2 4.1-.2 6.1v43.1c-14.9-3.2-31.2-7.9-48-14.4zM432 112v8V288c0 61.9-50.1 112-112 112H265.1h-18l-13.6 11.9-56.9 49.8L93.8 451.3 69.7 409.1 122 389.5l71.9-27-55.8-52.8C109 282.2 80 239.1 80 176c0-15.6 3.1-30 7.9-42.9c50.9 72.2 134.6 105.1 190 117l58 12.4V203.1 160c0-26.5 21.5-48 48-48h48zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faHandBackPointRight = {
    prefix: 'fasr',
    iconName: 'hand-back-point-right',
    icon: [
      512,
      512,
      [],
      'e1a1',
      
      'M512 136l0-24-24 0-227.2 0-51-56.1L202.6 48 192 48l-38.5 0C99.5 48 49.5 76.7 22.2 123.4L20.7 126C7.1 149.3 0 175.7 0 202.6L0 328c0 66.3 53.7 120 120 120l8 0 96 0 40 0 24 0 0-24 0-40 8 0 24 0 0-24 0-48 8 0 24 0 0-24 0-48 136 0 24 0 0-24 0-80zM272 264l0 24 0 48-8 0-24 0 0 24 0 40-16 0-96 0-8 0c-39.8 0-72-32.2-72-72l0-125.4c0-18.4 4.9-36.5 14.2-52.4l-20-11.7 20 11.7 1.5-2.6c18.6-32 52.8-51.6 89.8-51.6l27.9 0 29.1 32L168 128l-16 0 0 32 16 0 71.6 0 8.4 0 2.2 0 13.8 0 200 0 0 32-136 0-24 0 0 24 0 48-8 0-24 0z'
      
    ]
  };

  

  
  

  var faHatChef = {
    prefix: 'fasr',
    iconName: 'hat-chef',
    icon: [
      512,
      512,
      [],
      'f86b',
      
      'M163.1 118.4L124.8 89.6c-8-6-17.9-9.6-28.8-9.6c-26.5 0-48 21.5-48 48v1.4c0 4.9 .7 9.8 2.2 14.5L99.5 304h52L128.2 170.7 125.5 155l31.5-5.5 2.7 15.8L183.9 304H240V160 144h32v16V304h56.1l24.1-138.7 2.7-15.8 31.5 5.5-2.7 15.8L360.6 304h52l49.3-160.1c1.4-4.7 2.2-9.6 2.2-14.5V128c0-26.5-21.5-48-48-48c-10.9 0-20.8 3.5-28.8 9.6l-38.4 28.8L320 80c-14.7-19.5-37.9-32-64-32s-49.3 12.5-64 32l-28.8 38.4zM448 352H64L4.3 158C1.5 148.7 0 139.1 0 129.4V128C0 75 43 32 96 32c21.6 0 41.6 7.1 57.6 19.2C177 20.1 214.1 0 256 0s79 20.1 102.4 51.2l0 0c16-12 36-19.2 57.6-19.2c53 0 96 43 96 96v1.4c0 9.7-1.4 19.4-4.3 28.6L448 352zM64 384h48v80H400V384h48v80 48H400 112 64V464 384z'
      
    ]
  };

  

  
  

  var faGameBoard = {
    prefix: 'fasr',
    iconName: 'game-board',
    icon: [
      448,
      512,
      [],
      'f867',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM304 96H224v80H144V96H64v80h80v80H64v80h80v80h80V336h80v80h80V336H304V256h80V176H304V96zM224 256v80H144V256h80zm0 0V176h80v80H224z'
      
    ]
  };

  

  
  

  var faPersonBurst = {
    prefix: 'fasr',
    iconName: 'person-burst',
    icon: [
      640,
      512,
      [],
      'e53b',
      
      'M222.7 79L203.9 47.1 176 0 148.1 47.1 129.3 79 92.6 73.8 38.4 66.3l19.4 51.2L71 152 44.1 177.5 4.4 215.2l52.1 16.7 35.2 11.3L95 280l4.7 54.6 45.6-30.3L176 283.7l30.8 20.5 45.6 30.3L257 280l3.2-36.9 35.2-11.3 18.1-5.8 15.9-28.2-21.6-20.4L281 152l13.1-34.6 19.4-51.2-54.2 7.6L222.7 79zM239.9 125l-3.8 10-11.4 29.9 23.2 22 7.7 7.3-10.1 3.3-30.4 9.8-2.7 31.9-.9 10.6-8.9-5.9L176 226l-26.6 17.7-8.9 5.9-.9-10.6-2.7-31.9-30.4-9.8-10.1-3.3 7.7-7.3 23.2-22L115.9 135l-3.8-10 10.6 1.5 31.7 4.4 16.3-27.5 5.4-9.2 5.4 9.2 16.3 27.5 31.7-4.4 10.6-1.5zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H414.8l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21L416 224.9V488v24h48V488 352h32V488v24h48V488 224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136L545.2 128H531.1 428.9zM496 304H464V176h32V304z'
      
    ]
  };

  

  
  

  var faCrateApple = {
    prefix: 'fasr',
    iconName: 'crate-apple',
    icon: [
      512,
      512,
      ["apple-crate"],
      'f6b1',
      
      'M160 54.9V64h9.1C199.4 64 224 39.4 224 9.1V0h-9.1C184.6 0 160 24.6 160 54.9zm192 0V64h9.1C391.4 64 416 39.4 416 9.1V0h-9.1C376.6 0 352 24.6 352 54.9zM160 98.3L96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6H81.7c-1.1-6.5-1.7-13.3-1.7-20.6c0-15.3 3.8-29 8.7-37.2c1.8-2.9 3.3-4.5 4.2-5.2l53.9 15.4 13.2 3.8 13.2-3.8L227.1 129c.9 .8 2.4 2.3 4.2 5.2c4.9 8.2 8.7 21.9 8.7 37.2c0 7.2-.6 14.1-1.7 20.6h48.5c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4L160 98.3zm320 73.1c0-43.6-20.4-91.4-64-91.4L352 98.3 291.4 81c3 3.8 5.8 7.7 8.3 11.8c8.4 13.8 13.9 29.5 17 45.4l22.1 6.3 13.2 3.8 13.2-3.8L419.1 129c.9 .8 2.4 2.3 4.2 5.2c4.9 8.2 8.7 21.9 8.7 37.2c0 7.2-.6 14.1-1.7 20.6h48.5c.8-6.7 1.2-13.5 1.2-20.6zM464 272v72H48V272H464zM48 464V392H464v72H48zm0-240H0v48V464v48H48 464h48V464 272 224H464 48zm368 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faAppleCrate = faCrateApple;
  

  
  

  var faFileSvg = {
    prefix: 'fasr',
    iconName: 'file-svg',
    icon: [
      512,
      512,
      [],
      'e64b',
      
      'M48 464H96v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zM205.7 352H232h16v32H232 205.7c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7H176 160V480h16 34.3c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C169.8 430.8 160 415 160 397.7c0-25.2 20.4-45.7 45.7-45.7zM320 368v35c0 17.3 3.1 34.4 9.2 50.6l6.8 18.2 6.8-18.2c6.1-16.2 9.2-33.3 9.2-50.6V368 352h32v16 35c0 21.1-3.8 42-11.2 61.8L359 501.6 355.1 512H344 328 316.9L313 501.6l-13.8-36.8C291.8 445 288 424.1 288 403V368 352h32v16zm96 24c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v16H480V392c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8H464V432h16 16 16v16 24c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392z'
      
    ]
  };

  

  
  

  var faEarthAmericas = {
    prefix: 'fasr',
    iconName: 'earth-americas',
    icon: [
      512,
      512,
      [127758,"earth","earth-america","globe-americas"],
      'f57d',
      
      'M437.6 154.4L400 192v80h63.4C455.2 379.4 365.5 464 256 464C141.1 464 48 370.9 48 256c0-19.5 2.7-38.4 7.7-56.3L96 240h48l48 48v64l32 32v48h64V400l64-64V256H224l-32-32V192h80V160l-32-32V112l32-32V48.6C343.2 54 404.4 95.3 437.6 154.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faEarth = faEarthAmericas;
  
    var faEarthAmerica = faEarthAmericas;
  
    var faGlobeAmericas = faEarthAmericas;
  

  
  

  var faHexagonImage = {
    prefix: 'fasr',
    iconName: 'hexagon-image',
    icon: [
      512,
      512,
      [],
      'e504',
      
      'M103.3 340l-48-84L155.9 80H356.1L456.7 256 417 325.6l-76.2-91.8-18.5-22.2-18.5 22.2L232.2 320l-38.9-40.6-17.8-18.6-17.3 19-55 60.2zM128 32L0 256 128 480H384L512 256 384 32H128zM232 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faEraser = {
    prefix: 'fasr',
    iconName: 'eraser',
    icon: [
      576,
      512,
      [],
      'f12d',
      
      'M160 480H320l0 0H520h24V432H520 368L526.1 273.9 560 240l-33.9-33.9L369.9 49.9 336 16 302.1 49.9 49.9 302.1 16 336l33.9 33.9L160 480zm140.1-48H296v0H179.9l-96-96L217.9 201.9 374.1 358.1 300.1 432z'
      
    ]
  };

  

  
  

  var faBullseyePointer = {
    prefix: 'fasr',
    iconName: 'bullseye-pointer',
    icon: [
      512,
      512,
      [],
      'f649',
      
      'M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 5.5 .2 10.9 .6 16.3L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l13.8-46.9c5.4 .4 10.8 .6 16.3 .6zm-2.4-48l14.3-48.6C324.2 361.4 368 313.8 368 256c0-61.9-50.1-112-112-112c-57.8 0-105.4 43.8-111.4 100.1L96 258.4c0-.8 0-1.6 0-2.4c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-.8 0-1.6 0-2.4 0zM0 320l272-80L192 512l-48-96-1.4-1.4-96 96L1.4 465.4l96-96L96 368 0 320z'
      
    ]
  };

  

  
  

  var faDroplet = {
    prefix: 'fasr',
    iconName: 'droplet',
    icon: [
      384,
      512,
      [128167,"tint"],
      'f043',
      
      'M336 320c0-14.5-7.4-39.2-24.7-72.8c-16.5-32-39-66.6-62.3-99c-20.2-28.1-40.5-53.9-57-74.1c-16.5 20.2-36.8 46-57 74.1c-23.3 32.4-45.8 66.9-62.3 99C55.4 280.8 48 305.5 48 320c0 79.5 64.5 144 144 144s144-64.5 144-144zM0 320C0 241.2 106.1 102.8 160.5 36.9C179.3 14.1 192 0 192 0s12.7 14.1 31.5 36.9C277.9 102.8 384 241.2 384 320c0 106-86 192-192 192S0 426 0 320zm200 48v48c-57.4 0-104-46.6-104-104h48c0 30.9 25.1 56 56 56z'
      
    ]
  };

  
    var faTint = faDroplet;
  

  
  

  var faCircleWifi = {
    prefix: 'fasr',
    iconName: 'circle-wifi',
    icon: [
      512,
      512,
      [],
      'e67d',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm399.5 .5C364.4 216.9 313.1 192 256 192s-108.4 24.9-143.5 64.5l-34-34C122.4 174.3 185.7 144 256 144s133.6 30.3 177.5 78.5l-34 34zm-36.1 36.1l-34.4 34.4C313.3 303.5 286.4 288 256 288s-57.3 15.5-73.1 38.9l-34.4-34.4c24.9-32 63.7-52.6 107.4-52.6s82.5 20.6 107.4 52.6zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faNotebook = {
    prefix: 'fasr',
    iconName: 'notebook',
    icon: [
      512,
      512,
      [],
      'e201',
      
      'M240 48H432V464H240V48zm-48 0V464H112V416h24 24V368H136 112V280h24 24V232H136 112V144h24 24V96H136 112V48h80zM64 416v48 48h48H432h48V464 48 0H432 112 64V48 96H24 0v48H24 64v88H24 0v48H24 64v88H24 0v48H24 64z'
      
    ]
  };

  

  
  

  var faFolderMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'folder-magnifying-glass',
    icon: [
      512,
      512,
      ["folder-search"],
      'e18b',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm64 128c0 17.8-4.9 34.5-13.3 48.9L361 359.2l17 17L344 410.1l-17-17-38.4-38.4C274.4 363.2 257.8 368 240 368c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faFolderSearch = faFolderMagnifyingGlass;
  

  
  

  var faCandyCorn = {
    prefix: 'fasr',
    iconName: 'candy-corn',
    icon: [
      640,
      512,
      [],
      'f6bd',
      
      'M320 32v96L448 416h64L640 128V32s-32-32-160-32S320 32 320 32zM592 61.3v47.7C566.6 104.3 516.2 96 480 96s-86.6 8.3-112 12.9V61.3c18.2-6 52.8-13.3 112-13.3s93.8 7.3 112 13.3zM479.2 368l-37.6-84.5c12.2-1.8 26.6-3.5 38.4-3.5s26.2 1.7 38.4 3.5L480.8 368h-1.6zM0 330.9l67.9 67.9L362 511.9l45.3-45.3L294.2 172.5l-67.9-67.9s-45.3 0-135.8 90.5S0 330.9 0 330.9zM213 159.3L246.7 193c-21.2 14.7-62.7 44.4-88.3 70.1s-55.4 67.1-70.1 88.3L54.6 317.7c8.7-17.1 27.9-46.7 69.8-88.6s71.5-61.1 88.6-69.8zM350.2 455.9l-86.3-33.2c7.3-9.9 16.3-21.3 24.7-29.6s19.7-17.3 29.6-24.7l33.2 86.3-1.1 1.1z'
      
    ]
  };

  

  
  

  var faMessageQuote = {
    prefix: 'fasr',
    iconName: 'message-quote',
    icon: [
      512,
      512,
      ["comment-alt-quote"],
      'e1e4',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM240 112H128V224h64v32H168 144v48h24 48 24V280 224 176 152 112zm144 0H272V224h64v32H312 288v48h24 48 24V280 224 176 152 112z'
      
    ]
  };

  
    var faCommentAltQuote = faMessageQuote;
  

  
  

  var faUserRobotXmarks = {
    prefix: 'fasr',
    iconName: 'user-robot-xmarks',
    icon: [
      448,
      512,
      [],
      'e4a7',
      
      'M240 16V0H208V16 64H112 64v48V272v48h48H336h48V272 112 64H336 240V16zm96 96V272H304V240H272v32H240V240H208v32H176V240H144v32H112V112H336zM83.7 400H364.3l19.2 64H304V432 416H272v16 32H240V432 416H208v16 32H176V432 416H144v16 32H64.5l19.2-64zM224 512h64H397.9 448l-14.4-48L400 352H48L14.4 464 0 512H50.1 160h64zM32 128H0V256H32V128zm416 0H416V256h32V128zm-304 5.4L125.4 152l9.3 9.3L149.4 176l-14.7 14.7-9.3 9.3L144 218.6l9.3-9.3L168 194.6l14.7 14.7 9.3 9.3L210.6 200l-9.3-9.3L186.6 176l14.7-14.7 9.3-9.3L192 133.4l-9.3 9.3L168 157.4l-14.7-14.7-9.3-9.3zm121.3 9.3l-9.3-9.3L237.4 152l9.3 9.3L261.4 176l-14.7 14.7-9.3 9.3L256 218.6l9.3-9.3L280 194.6l14.7 14.7 9.3 9.3L322.6 200l-9.3-9.3L298.6 176l14.7-14.7 9.3-9.3L304 133.4l-9.3 9.3L280 157.4l-14.7-14.7z'
      
    ]
  };

  

  
  

  var faArrowDown = {
    prefix: 'fasr',
    iconName: 'arrow-down',
    icon: [
      384,
      512,
      [8595],
      'f063',
      
      'M175 461.8l17 17 17-17L362.6 308.2l17-17-33.9-33.9-17 17L216 386.9 216 56l0-24-48 0 0 24 0 330.8L55.4 274.2l-17-17L4.5 291.2l17 17L175 461.8z'
      
    ]
  };

  

  
  

  var faPersonSwimming = {
    prefix: 'fasr',
    iconName: 'person-swimming',
    icon: [
      576,
      512,
      [127946,"swimmer"],
      'f5c4',
      
      'M32 160a64 64 0 1 0 128 0A64 64 0 1 0 32 160zM96 382.2c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V368c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l0 0-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l0 0-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4c-13 11.6-24.8 22.2-40.2 30.9C39.4 360.2 19.7 368 0 368v48c31.5 0 59.7-12.2 79-23.1c6.5-3.7 12.2-7.4 16.9-10.7zM269 204.9L401.3 316.8c7.9-1.8 15.9-4.7 23.4-8.2c8.4-3.9 15.8-8.5 24.2-14.4L303.1 170.9 329.9 144H456h24V96H456 320h-9.9l-7 7L167 239l-7 7V256v56.3c10.7 4 21.8 6.7 32 6.7c5.2 0 10.5-.7 16-1.9V265.9l61-61z'
      
    ]
  };

  
    var faSwimmer = faPersonSwimming;
  

  
  

  var faTRex = {
    prefix: 'fasr',
    iconName: 't-rex',
    icon: [
      640,
      512,
      [],
      'e629',
      
      'M423.9 48l-.1 0C393.1 48 368 73.1 368 104v8.7l-5.6 6.7-40 48-7.2 8.6H304 288c-61.9 0-112 50.1-112 112v24H152 112 96.6l-6.4-13.9L61.3 235.4l-4.7 11.8c-5.7 14.2-8.6 29.3-8.6 44.6V296c0 57.4 46.6 104 104 104h40V376 352h48v24 30.1L297.9 464H384V448c0-8.8-7.2-16-16-16H344 331.2L324 421.3l-16-24L299.8 385l7.4-12.9L336 321.6V320c0-26.5-21.5-48-48-48H272V224h16c53 0 96 43 96 96v8 6.4l-3.2 5.5L356.2 383l.6 1H368c35.3 0 64 28.7 64 64v40 24H408 288h-9.9l-7-7-57-57H152C68.1 448 0 379.9 0 296v-4.3c0-21.4 4.1-42.5 12-62.4l21.7-54.3 6-15.1H56h8H79.4l6.4 13.9L127.4 264h2.4c11.6-77 78-136 158.2-136h4.8l27.6-33.2C325 41.8 369.5 0 423.8 0h.1 .1 88 14.8l6.6 13.3 9.5 19C597.1 35.8 640 80.9 640 136v64 24H616 588l-16.8 22.4L564 256H552 460l-15.3 20.5 55 30.6 12.3 6.9V328v32 24H464V360 342.1l-48.1-26.7c-.7-21.5-6.4-41.6-15.9-59.4l28.8-38.4L436 208h12 92l-12 0h-6.6l-4.7-4.7L489.4 176H464 448V144h16 32 6.6l4.7 4.7L534.6 176l57.4 0V136c0-30.9-25.1-56-56-56h-8H513.2l-6.6-13.3L497.2 48H424l-.1 0 0 0zM456 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faPretzel = {
    prefix: 'fasr',
    iconName: 'pretzel',
    icon: [
      512,
      512,
      [129384],
      'e441',
      
      'M56 184.2c0 52.5 20.3 100.3 53.5 135.9l19-26.8C103.3 264 88 225.9 88 184.2c0-39.9 32.3-72.2 72.2-72.2H164c42 0 76 34 76 76v5.1c0 16.8-5.2 33.2-14.9 46.9l-45.9 64.9-15.6 22 0 0-18 25.4 0 0-12.9 18.2-4.5 6.3L119 389.8l26.1 18.5 9.2-13.1 9.3-13.2L174 367.4l17 5.8c20.3 7 42.2 10.8 65 10.8c11.2 0 22.3-.9 33-2.7l-21-29.7c-3.9 .3-7.9 .4-11.9 .4c-9.2 0-18.3-.7-27.2-2.2l-38-6.2 22.2-31.4 23.3-32.9L256 251.7l19.6 27.6 11.5 16.3 11.8 16.6 22.2 31.4L338 367.4l0 0L348.3 382l9.3 13.1 9.2 13.1L393 389.8l-9.3-13.1-4.5-6.3-12.9-18.2L383.6 338c44.3-36.7 72.4-92 72.4-153.8C456 126.7 409.3 80 351.8 80H348c-29.3 0-55.8 11.6-75.3 30.6L256 126.8l-16.7-16.3C219.8 91.6 193.3 80 164 80h-3.8C102.7 80 56 126.7 56 184.2zM81.2 360C36.1 315.1 8 253 8 184.2C8 100.1 76.1 32 160.2 32H164c34.4 0 66.2 11.2 92 30c25.8-18.9 57.6-30 92-30h3.8C435.8 32 504 100.1 504 184.2c0 68.7-28.1 130.9-73.2 175.8l15.3 21.6 13.9 19.6L440.3 415l-65.3 46.2-19.6 13.9-13.9-19.6-1.8-2.6 0 0-20.6-29.1C299 429.2 277.8 432 256 432s-43-2.8-63.2-8.1l-22.5 31.7-13.9 19.6-19.6-13.9L71.6 415.1 52 401.2l13.9-19.6 1.9-2.6 0 0 13.5-19zM136 184.2c0 25.3 7.9 48.9 21.4 68.3l28.5-40.2c4-5.6 6.1-12.3 6.1-19.1V188c0-15.5-12.5-28-28-28h-3.8c-13.4 0-24.2 10.8-24.2 24.2zM320 188v5.1c0 6.9 2.1 13.5 6.1 19.1l28.5 40.2c13.5-19.4 21.4-42.9 21.4-68.3c0-13.4-10.8-24.2-24.2-24.2H348c-15.5 0-28 12.5-28 28zm28-76h3.8c39.9 0 72.2 32.3 72.2 72.2c0 49.4-21.5 93.9-55.5 124.6l-20.1 18.1-15.6-22L286.9 240c-9.7-13.7-14.9-30.1-14.9-46.9V188c0-42 34-76 76-76z'
      
    ]
  };

  

  
  

  var faQuotes = {
    prefix: 'fasr',
    iconName: 'quotes',
    icon: [
      576,
      512,
      [],
      'e234',
      
      'M0 96C0 43 43 0 96 0h8 24V48H104 96C69.5 48 48 69.5 48 96H96h48v48 48 48H96 48 0V192 168 144 96zm48 48v24 24H96V144H48zM176 96c0-53 43-96 96-96h8 24V48H280h-8c-26.5 0-48 21.5-48 48h48 48v48 48 48H272 224 176V192 168 144 96zm48 72v24h48V144H224v24zM576 416c0 53-43 96-96 96h-8H448V464h24 8c26.5 0 48-21.5 48-48H480 432V368 320 272h48 48 48v48 24 24 48zm-48-48V344 320H480v48h48zM400 416c0 53-43 96-96 96h-8H272V464h24 8c26.5 0 48-21.5 48-48H304 256V368 320 272h48 48 48v48 24 24 48zm-48-72V320H304v48h48V344z'
      
    ]
  };

  

  
  

  var faGreaterThan = {
    prefix: 'fasr',
    iconName: 'greater-than',
    icon: [
      384,
      512,
      [62769],
      '3e',
      
      'M0 64.9L370 234.2l14 6.4v30.8l-14 6.4L0 447.2V394.4L302.3 256 0 117.6V64.9z'
      
    ]
  };

  

  
  

  var faFile = {
    prefix: 'fasr',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462,128196,128459],
      'f15b',
      
      'M336 464V160H224V48H48V464H336zM48 0H256L384 128V464v48H336 48 0V464 48 0H48z'
      
    ]
  };

  

  
  

  var faBoxOpenFull = {
    prefix: 'fasr',
    iconName: 'box-open-full',
    icon: [
      640,
      512,
      ["box-full"],
      'f49c',
      
      'M312.8 157.6l7.2 .9 167.3-20.9 44.1-93L444.6 3.5 384 131.5c0-1.2 0-2.3 0-3.5C384 57.3 326.7 0 256 0S128 57.3 128 128c0 2.2 .1 4.3 .2 6.5l65.5 8.2c-1.1-4.7-1.7-9.6-1.7-14.7c0-35.3 28.7-64 64-64s64 28.7 64 64c0 10.7-2.6 20.7-7.2 29.6zM64 160L0 288l224 64 96-160L64 160zM576 339.6l-48 13.7v57.2l-184 46V312 288H296v24V456.5l-184-46V353.3L64 339.6V448l256 64 256-64V339.6zM640 288L576 160 320 192l96 160 224-64z'
      
    ]
  };

  
    var faBoxFull = faBoxOpenFull;
  

  
  

  var faCrab = {
    prefix: 'fasr',
    iconName: 'crab',
    icon: [
      512,
      512,
      [129408],
      'e3ff',
      
      'M128 0C57.3 0 0 57.3 0 128v64 15.4l13.9 6.4 85 39.2c-2.2 3.6-4.2 7.2-6 11H61.7L34.7 250.5 13.3 239.8-8.2 282.7l21.5 10.7 32 16 5.1 2.5H56 80.2c-.2 2.6-.2 5.3-.2 8v1.4l-23.6 7.9L51 331l-4 4L15 367l-17 17L32 417.9l17-17 28-28 30-10L125 381 88.4 393.2 83 395l-4 4L47 431l-17 17L64 481.9l17-17 28-28 54-18 2.2 2.2L140.3 435 128 441.9V456v32 24h48V488 470.1L214.1 449l-.5-1h85l-.5 1L336 470.1V488v24h48V488 456 441.9L371.7 435l-24.9-13.8L349 419l54 18 28 28 17 17L481.9 448l-17-17-32-32-4-4-5.4-1.8L387 381 405 363l30 10 28 28 17 17L513.9 384l-17-17-32-32-4-4-5.4-1.8L432 321.4V320c0-2.7-.1-5.4-.2-8H456h5.7l5.1-2.5 32-16 21.5-10.7-21.5-42.9-21.5 10.7L450.3 264H419.1c-1.8-3.8-3.9-7.4-6-11l85-39.2 13.9-6.4V192 128C512 57.3 454.7 0 384 0H320l64 64H320c0 35.3 28.7 64 64 64h80v48.6L378.7 216c-16.9-12.2-37-20.3-58.7-23V152 128H272v24 40H240V152 128H192v24 41c-21.7 2.7-41.7 10.9-58.7 23L48 176.6V128h80c35.3 0 64-28.7 64-64H128L192 0H128zM272 240h32c42.9 0 77.9 33.8 79.9 76.2L300.1 400H211.9l-83.8-83.8c2-42.4 37-76.2 79.9-76.2h32 32z'
      
    ]
  };

  

  
  

  var faLocationDot = {
    prefix: 'fasr',
    iconName: 'location-dot',
    icon: [
      384,
      512,
      ["map-marker-alt"],
      'f3c5',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faMapMarkerAlt = faLocationDot;
  

  
  

  var faDialMedLow = {
    prefix: 'fasr',
    iconName: 'dial-med-low',
    icon: [
      576,
      512,
      [],
      'e160',
      
      'M320 0H256V64h64V0zM128 64H64v64h64V64zm384 0H448v64h64V64zm0 192v64h64V256H512zm0 192H448v64h64V448zM64 448v64h64V448H64zM0 256v64H64V256H0zM208.8 367.2c-37.9-37.9-43-96.2-15.1-139.6L271 305l17 17L321.9 288l-17-17-77.4-77.4c43.4-27.8 101.7-22.8 139.6 15.1c43.7 43.7 43.7 114.7 0 158.4s-114.7 43.7-158.4 0zM174.9 174.9A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9z'
      
    ]
  };

  

  
  

  var faCircle0 = {
    prefix: 'fasr',
    iconName: 'circle-0',
    icon: [
      512,
      512,
      [],
      'e0ed',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96V224c0-53-43-96-96-96zm-48 96c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V224z'
      
    ]
  };

  

  
  

  var faHandshakeAngle = {
    prefix: 'fasr',
    iconName: 'handshake-angle',
    icon: [
      640,
      512,
      ["hands-helping"],
      'f4c4',
      
      'M312 320h24V296 240H464v64h-8H432v24 32H408 384v24 16l-8 0H352l-32 0-80 0h-9.9l-7 7-52.8 52.8-17 17 33.9 33.9 17-17L249.9 448l70.1 0 32 0h24l32 0h24V424 408h24 24V384 352h8 24V328 281.9 214.1 192H488 336V168 144H288v24V272H240V112H432h9.9l7-7 52.8-52.8 17-17L484.8 1.3l-17 17L422.1 64H216 192V88 296v24h24 96zM544 182.1v67.9l77.8-77.8 17-17-33.9-33.9-17 17L544 182.1zM160 128H120 96v24V262.1L18.2 339.8l-17 17 33.9 33.9 17-17L137 289l7-7V272 176h16V128z'
      
    ]
  };

  
    var faHandsHelping = faHandshakeAngle;
  

  
  

  var faAccentGrave = {
    prefix: 'fasr',
    iconName: 'accent-grave',
    icon: [
      192,
      512,
      [],
      '60',
      
      'M80 74.9l45.2 76.8L110.4 48H80V74.9zM152 0l25.1 176 6.9 48H135.5 112L32 88V48 0H80h72z'
      
    ]
  };

  

  
  

  var faPaintRoller = {
    prefix: 'fasr',
    iconName: 'paint-roller',
    icon: [
      512,
      512,
      [],
      'f5aa',
      
      'M368 48H48v96H368V48zM48 0H368h48V48 72v48 24 48H368 48 0V144 48 0H48zM248 320h40V512H160V320h40V256 232h24H464V120H448V72h40 24V96 256v24H488 248v40z'
      
    ]
  };

  

  
  

  var faTrafficLightStop = {
    prefix: 'fasr',
    iconName: 'traffic-light-stop',
    icon: [
      320,
      512,
      [],
      'f63a',
      
      'M48 48V352c0 61.9 50.1 112 112 112s112-50.1 112-112V48H48zM0 0H48 272h48V48 352c0 88.4-71.6 160-160 160S0 440.4 0 352V48 0zM144 376a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-120a48 48 0 1 1 0-96 48 48 0 1 1 0 96z'
      
    ]
  };

  

  
  

  var faPhoneSlash = {
    prefix: 'fasr',
    iconName: 'phone-slash',
    icon: [
      640,
      512,
      [],
      'f3dd',
      
      'M164.2 346.6L19 459.3 0 474l29.4 37.9 19-14.7L620.9 52.7l19-14.7L610.5 .1l-19 14.7L278 258.2c-11.1-13.3-21-27.6-29.7-42.6L303.9 160 239.9 0 63.9 32l0 32c0 107.1 37.6 205.5 100.3 282.6zM240 287.7l-37.9 29.4c-54.8-67-88.3-152.2-90.2-245.1l97.9-17.8 37.7 94.2-33.2 33.2-26 26 18.4 31.9c9.8 17 21 33.1 33.3 48.1zm-5.8 128C310.5 476 407 512 511.9 512h32l32-176L416.3 272.2l-2.8 2.2-53.2 53.2c-2.7-1.6-5.5-3.2-8.1-4.9L312.4 354c7.8 5.4 15.8 10.4 23.9 15.1l31.9 18.4 26-26 33.2-33.2L521.6 366l-17.8 97.9c-86.4-1.7-166.1-30.8-230.7-79l-38.9 30.6z'
      
    ]
  };

  

  
  

  var faStarOfLife = {
    prefix: 'fasr',
    iconName: 'star-of-life',
    icon: [
      512,
      512,
      [],
      'f621',
      
      'M328 75.9V48 0H280 232 184V48 75.9v55.4l-48-27.7L111.9 89.6l-41.6-24-24 41.6-24 41.6-24 41.6 41.6 24L64 228.3 112 256 64 283.7 39.9 297.6l-41.6 24 24 41.6 24 41.6 24 41.6 41.6-24L136 408.4l48-27.7v55.4V464v48h48 48 48V464 436.1 380.7l48 27.7 24.1 13.9 41.6 24 24-41.6 24-41.6 24-41.6-41.6-24L448 283.7 400 256l48-27.7 24.1-13.9 41.6-24-24-41.6-24-41.6-24-41.6-41.6 24L376 103.6l-48 27.7V75.9zm96.1 55.3l24 41.6L376 214.4 304 256l72 41.6 72.1 41.6-24 41.6L352 339.1l-72-41.6v83.1V464H232V380.7 297.6l-72 41.6L87.9 380.8l-24-41.6L136 297.6 208 256l-72-41.6L63.9 172.8l24-41.6L160 172.9l72 41.6V131.3 48h48v83.3 83.1l72-41.6 72.1-41.6z'
      
    ]
  };

  

  
  

  var faPlugCircleXmark = {
    prefix: 'fasr',
    iconName: 'plug-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e560',
      
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7L502.6 320zM120 0V24v88H72V24 0h48zM312 0V24v88H264V24 0h48zM0 144H24h8H80 304h48 8 24v48H360h-8v19.2c-18 9.2-34.2 21.4-48 36V192H80v64c0 61.9 50.1 112 112 112c24.3 0 46.9-7.8 65.2-20.9c-.8 6.9-1.2 13.9-1.2 20.9c0 11.4 1.1 22.5 3.1 33.3c-13.5 6.2-28 10.7-43.1 12.9V512H168V414.2C91 402.6 32 336.2 32 256V192H24 0V144z'
      
    ]
  };

  

  
  

  var faHexagonCheck = {
    prefix: 'fasr',
    iconName: 'hexagon-check',
    icon: [
      512,
      512,
      [],
      'e416',
      
      'M55.3 256L155.9 80H356.1L456.7 256 356.1 432H155.9L55.3 256zM128 32L0 256 128 480H384L512 256 384 32H128zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z'
      
    ]
  };

  

  
  

  var faBowlSpoon = {
    prefix: 'fasr',
    iconName: 'bowl-spoon',
    icon: [
      512,
      512,
      [129379],
      'e3e0',
      
      'M112 144c-42.6 0-64-28.2-64-48s21.4-48 64-48h64V96v48H112zM112 0C50.1 0 0 43 0 96s50.1 96 112 96h64 48V144 120H488h24V72H488 224V48 0H176 112zm64 443.1l-26.7-13.2c-55.1-27.3-93.9-82.4-97.8-147.5L50.9 272H461.1l-.6 10.3c-3.8 65.1-42.7 120.3-97.8 147.5L336 443.1V464H176V443.1zM2.8 272l.8 13.2C8.5 368.1 58 438.2 128 472.9V512h48H336h48V472.9c70-34.6 119.5-104.8 124.4-187.7l.8-13.2 2.8-48H463.9 48.1 0l2.8 48z'
      
    ]
  };

  

  
  

  var faSuperscript = {
    prefix: 'fasr',
    iconName: 'superscript',
    icon: [
      512,
      512,
      [],
      'f12b',
      
      'M408 0H384V48h24 16V176H408 384v48h24 16 48 16 24V176H488 472V24 0H448 408zM24 64H0v48H24 51.2l96 144-96 144H24 0v48H24 64 76.8L84 437.3l92-138 92 138 7.1 10.7H288h40 24V400H328 300.8l-96-144 96-144H328h24V64H328 288 275.2L268 74.7l-92 138L84 74.7 76.8 64H64 24z'
      
    ]
  };

  

  
  

  var faArrowsFromLine = {
    prefix: 'fasr',
    iconName: 'arrows-from-line',
    icon: [
      448,
      512,
      [],
      'e0a4',
      
      'M241 18.2l-17-17-17 17-64 64-17 17L160 133.1l17-17 23-23V168v24h48V168 93.1l23 23 17 17 33.9-33.9-17-17-64-64zM248 344V320H200v24 74.9l-23-23-17-17-33.9 33.9 17 17 64 64 17 17 17-17 64-64 17-17L288 378.9l-17 17-23 23V344zM24 232H0v48H24 424h24V232H424 24z'
      
    ]
  };

  

  
  

  var faFilePpt = {
    prefix: 'fasr',
    iconName: 'file-ppt',
    icon: [
      512,
      512,
      [],
      'e64a',
      
      'M48 464H96v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zM288 352h16 32c30.9 0 56 25.1 56 56s-25.1 56-56 56H320v32 16H288V496 448 368 352zm32 80h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H320v48zM160 352h16 32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32 16H160V496 448 368 352zm32 80h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48zm224-80h16 32 32 16v32H496 480V496v16H448V496 384H432 416V352z'
      
    ]
  };

  

  
  

  var faPinata = {
    prefix: 'fasr',
    iconName: 'pinata',
    icon: [
      512,
      512,
      [],
      'e3c3',
      
      'M272 24V0H224V24 48H24 0V72 176v17.3l16.4 5.5L96 225.3V488v24h24H232h24V488 408h96v80 24h24H488h24V488 248 224H488 272V96 48 24zM48 96H224V221.2l-23.3 9.3-25.6-12.8-6.4-3.2-6.7 2.7L144 224.4V208 190.7l-16.4-5.5L48 158.7V96zM205.9 262.9l18.1-7.2V272h24H464v30.1l-8.8-4.4-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-10.1 4V258.8l23.3-9.3 25.6 12.8 6.4 3.2 6.7-2.7zM144 335.6l15.3-6.1 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 16.7 8.4v54.5l-18.1-7.2-6.7-2.7-6.4 3.2-25.6 12.8-7.3-2.9V384 360H376 232 208v24 11.6l-7.3 2.9-25.6-12.8-6.4-3.2-6.7 2.7L144 392.4V335.6zm0 91.2l23.3-9.3 25.6 12.8 6.4 3.2 6.7-2.7 2.1-.8v34H144V426.8zm296.7-9.3l23.3 9.3V464H400V430l2.1 .8 6.7 2.7 6.4-3.2 25.6-12.8zM176 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faXmarkLarge = {
    prefix: 'fasr',
    iconName: 'xmark-large',
    icon: [
      448,
      512,
      [],
      'e59b',
      
      'M52.2 50.2l-17-17L1.3 67.2l17 17L190.1 256 18.2 427.8l-17 17 33.9 33.9 17-17L224 289.9 395.8 461.8l17 17 33.9-33.9-17-17L257.9 256 429.8 84.2l17-17L412.8 33.3l-17 17L224 222.1 52.2 50.2z'
      
    ]
  };

  

  
  

  var faCandyBar = {
    prefix: 'fasr',
    iconName: 'candy-bar',
    icon: [
      640,
      512,
      [127851,"chocolate-bar"],
      'e3e8',
      
      'M0 320V224H128v96H0zM0 448V352H128v96H0zm288 0H160V352H288V320H160V224H288V192H160V64H288h48H592h48v48V400v48H592 336 288zm48-336V400H592V112H336zM33.1 192C47.3 177.6 56 157.8 56 136c0-6.2-.7-12.2-2-18c5.8 1.3 11.8 2 18 2c21.8 0 41.6-8.7 56-22.9V160h0v32l0 0H33.1z'
      
    ]
  };

  
    var faChocolateBar = faCandyBar;
  

  
  

  var faBell = {
    prefix: 'fasr',
    iconName: 'bell',
    icon: [
      448,
      512,
      [61602,128276],
      'f0f3',
      
      'M256 0H192V51.2C119 66 64 130.6 64 208v88L0 368v48H48 400h48V368l-64-72V208c0-77.4-55-142-128-156.8V0zm80 314.2l12.1 13.6L383.8 368H64.2l35.7-40.1L112 314.2V296 208c0-61.9 50.1-112 112-112s112 50.1 112 112v88 18.2zM288 448H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z'
      
    ]
  };

  

  
  

  var faTemperatureFull = {
    prefix: 'fasr',
    iconName: 'temperature-full',
    icon: [
      320,
      512,
      ["temperature-4","thermometer-4","thermometer-full"],
      'f2c7',
      
      'M96 294.5L85.3 307.7C72 324.2 64 345.1 64 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L224 294.5v-17V48H96V277.5v17zM224 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5V48 0H96 224zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112 96h32v16V322.8c18.6 6.6 32 24.4 32 45.3z'
      
    ]
  };

  
    var faTemperature4 = faTemperatureFull;
  
    var faThermometer4 = faTemperatureFull;
  
    var faThermometerFull = faTemperatureFull;
  

  
  

  var faBee = {
    prefix: 'fasr',
    iconName: 'bee',
    icon: [
      576,
      512,
      [],
      'e0b2',
      
      'M216 1.4l11.3 11.3 26.8 26.8C264.4 34.7 275.9 32 288 32s23.6 2.7 33.9 7.5l26.8-26.8L360 1.4 382.6 24 371.3 35.3 347.8 58.8C360.4 73 368 91.6 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112c0 61.9-53.6 104.9-112.9 111.2c.6-5.1 .9-10.2 .9-15.2c0-11.2-1-22.2-3.1-32.8c40.5-5.1 67.1-34 67.1-63.2c0-32.2-32.3-64-80-64c-37.3 0-65.2 19.5-75.6 43.3C408.5 213.5 432 256 432 304c0 96-144 208-144 208s-144-112-144-208c0-48 23.5-90.5 59.6-116.7C193.2 163.5 165.3 144 128 144c-47.7 0-80 31.8-80 64c0 29.2 26.5 58.1 67.1 63.2c-2 10.6-3.1 21.6-3.1 32.8c0 5 .3 10.1 .9 15.2C53.6 312.9 0 269.9 0 208C0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9c-.3-2.9-.5-5.9-.5-8.9c0-20.4 7.6-39 20.2-53.2L204.7 35.3 193.4 24 216 1.4zM384 304H192c0 8.7 2.4 19.4 7.7 32H376.3c5.3-12.6 7.7-23.3 7.7-32zM251.7 411.9c12.6 14.1 25.4 26.6 36.3 36.7c10.9-10.1 23.7-22.7 36.3-36.7c8.1-9 15.9-18.4 23.1-27.9H228.6c7.2 9.5 15 18.9 23.1 27.9zM288 208c-35.5 0-66.6 19.3-83.2 48H371.2c-16.6-28.7-47.6-48-83.2-48z'
      
    ]
  };

  

  
  

  var faPodcast = {
    prefix: 'fasr',
    iconName: 'podcast',
    icon: [
      448,
      512,
      [],
      'f2ce',
      
      'M316 374.1c50.4-31 84-86.6 84-150.1c0-97.2-78.8-176-176-176S48 126.8 48 224c0 63.5 33.6 119.1 84 150l8.3 57.8C58 398.6 0 318.1 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 94.1-58 174.6-140.2 207.8l8.3-57.8zm3.3-42.1L313 324l-23.7-29.6C308.2 276.9 320 251.8 320 224c0-53-43-96-96-96s-96 43-96 96c0 27.8 11.8 52.9 30.7 70.4L135 324l-6.3 7.9C98.8 305.5 80 267 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 43-18.8 81.5-48.7 107.9zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM160 344l32-40h64l32 40L264 512H184L160 344zm77.5 13.8l-4.6-5.8H215.1l-4.6 5.8L224 452.6l13.5-94.8z'
      
    ]
  };

  

  
  

  var faCalendarUsers = {
    prefix: 'fasr',
    iconName: 'calendar-users',
    icon: [
      640,
      512,
      [],
      'e5e2',
      
      'M248 0V24 64H392V24 0h48V24 64H544v80 48H528 496 480 160 144 112 96V144 64H200V24 0h48zm12.8 512L244 464H396l-16.8 48H260.8zM112 224a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM224 512H0l32-96H192l32 96zM448 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM608 416l32 96H416l32-96H608z'
      
    ]
  };

  

  
  

  var faSquareEllipsisVertical = {
    prefix: 'fasr',
    iconName: 'square-ellipsis-vertical',
    icon: [
      448,
      512,
      [],
      'e26f',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM192 320h64v64H192V320zm0-32V224h64v64H192zm0-160h64v64H192V128z'
      
    ]
  };

  

  
  

  var faClockTwo = {
    prefix: 'fasr',
    iconName: 'clock-two',
    icon: [
      512,
      512,
      [],
      'e35a',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120v91.2L338.7 172l20-13.3 26.6 39.9-20 13.3-96 64L232 300.8V256 120 96h48v24z'
      
    ]
  };

  

  
  

  var faSquareC = {
    prefix: 'fasr',
    iconName: 'square-c',
    icon: [
      448,
      512,
      [],
      'e266',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM144 256c0 44.2 35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C310.2 359.8 269.9 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L292 213.8c-14.2-22.8-39.3-37.8-68-37.8c-44.2 0-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faSquareH = {
    prefix: 'fasr',
    iconName: 'square-h',
    icon: [
      448,
      512,
      ["h-square"],
      'f0fd',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM336 152V256 360v24H288V360 280H160l0 80v24H112V360 280l0-48V152 128h48v24 80H288V152 128h48v24z'
      
    ]
  };

  
    var faHSquare = faSquareH;
  

  
  

  var faBookCopy = {
    prefix: 'fasr',
    iconName: 'book-copy',
    icon: [
      576,
      512,
      [],
      'e0be',
      
      'M192 88c0-48.6 39.4-88 88-88H552h24V24 136v24V280v24H552h-8v64h8 24v48H552 520 272c-44.2 0-80-35.8-80-80V88zM528 48H280c-22.1 0-40 17.9-40 40V262.7c9.8-4.3 20.6-6.7 32-6.7H520h8V160 136 48zM272 304c-17.7 0-32 14.3-32 32s14.3 32 32 32H496V304H272zM160 96v48H88c-22.1 0-40 17.9-40 40V358.7c9.8-4.3 20.6-6.7 32-6.7h81.1c2.5 17.7 9.2 34 18.9 48H80c-17.7 0-32 14.3-32 32s14.3 32 32 32H304V448h48v16h8 24v48H360 328 80c-44.2 0-80-35.8-80-80V184c0-48.6 39.4-88 88-88h72z'
      
    ]
  };

  

  
  

  var faBed = {
    prefix: 'fasr',
    iconName: 'bed',
    icon: [
      640,
      512,
      [128716],
      'f236',
      
      'M48 56V32H0V56 360v96 24H48V456 384H312 592v80 24h48V464 360 248c0-66.3-53.7-120-120-120H312 288v24V336H48V56zM592 248v88H336V176H520c39.8 0 72 32.2 72 72zM128 216a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm128 0A88 88 0 1 0 80 216a88 88 0 1 0 176 0z'
      
    ]
  };

  

  
  

  var faPersonFairy = {
    prefix: 'fasr',
    iconName: 'person-fairy',
    icon: [
      640,
      512,
      [],
      'e608',
      
      'M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm14 144l-4 96h38 32 38l-4-96H270zM216 352l2-48 6-144H416l6 144 2 48H384V488v24H336V488 352H304V488v24H256V488 352H216zm32.3-224H193.3 177.9C141.4 100.3 96.7 83 48 80.4V112c0 71.4 33.3 134.9 85.4 176l18.1 14.3 18.1 14.3-13.6 18.7L142.5 354c-16.3 22.3-26.9 49-29.7 78c43.3-.2 82.5-17.6 111.2-45.7v61C191.7 468 153.2 480 112 480H88 64V456v-8c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V56 32H24 34.9c84.9 0 161.1 37.1 213.4 96zM592 80.4c-48.7 2.7-93.4 20-129.9 47.6H446.7h-55C444 69.1 520.2 32 605.1 32H616h24V56v56c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448v8 24H552 528c-41.2 0-79.7-12-112-32.7v-61c28.7 28.2 67.9 45.5 111.2 45.7c-2.9-29-13.5-55.7-29.7-78l-13.6-18.7-13.6-18.7 18.1-14.3L506.6 288C558.7 246.9 592 183.4 592 112V80.4z'
      
    ]
  };

  

  
  

  var faMedal = {
    prefix: 'fasr',
    iconName: 'medal',
    icon: [
      512,
      512,
      [127941],
      'f5a2',
      
      'M227.2 100.7L160 0H57.7 0L32 48l87.4 131.1c12.1-10.5 25.3-19.6 39.6-27.2L89.7 48h44.6l59.6 89.4c16.4-5.1 33.7-8.3 51.6-9.2l-18.4-27.5zM480 48L512 0H454.3 352L284.8 100.7l-18.4 27.5c17.9 .9 35.2 4 51.6 9.2L377.7 48h44.6L353 152c14.3 7.5 27.5 16.7 39.6 27.2L480 48zM256 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-272l-28.2 57.2-63.1 9.2 45.7 44.5-10.8 62.8L256 384l56.4 29.7-10.8-62.8 45.7-44.5-63.1-9.2L256 240z'
      
    ]
  };

  

  
  

  var faTemperatureArrowUp = {
    prefix: 'fasr',
    iconName: 'temperature-arrow-up',
    icon: [
      576,
      512,
      ["temperature-up"],
      'e040',
      
      'M112 294.5l-10.7 13.2C88 324.2 80 345.1 80 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L240 294.5v-17V48H112V277.5v17zM240 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S32 447.5 32 368c0-34.3 12-65.8 32-90.5V48 0h48H240zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112 96h32v16V322.7c18.6 6.6 32 24.4 32 45.3zM448 20.1l17.8 19.8 72 80 16.1 17.8-35.7 32.1-16.1-17.8L472 118.5 472 456v24H424V456l0-337.5-30.2 33.5-16.1 17.8-35.7-32.1 16.1-17.8 72-80L448 20.1z'
      
    ]
  };

  
    var faTemperatureUp = faTemperatureArrowUp;
  

  
  

  var faFileCircleXmark = {
    prefix: 'fasr',
    iconName: 'file-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e5a1',
      
      'M48 464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 48 0H48 256L384 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48V464zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faTruckDroplet = {
    prefix: 'fasr',
    iconName: 'truck-droplet',
    icon: [
      640,
      512,
      [],
      'e58c',
      
      'M48 48V368H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h48V48H48zM480 512c-53 0-96-43-96-96h-8-8H320 256c0 53-43 96-96 96s-96-43-96-96H48 0V368 48 0H48 368h48V48 96h56 9.9l7 7L601 215l7 7V232 368h8 24v48H616 576c0 53-43 96-96 96zm78.1-272l-96-96H416v96H558.1zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c-39.8 0-72-29.6-72-66s72-126 72-126s72 89.5 72 126s-32.2 66-72 66z'
      
    ]
  };

  

  
  

  var faDrone = {
    prefix: 'fasr',
    iconName: 'drone',
    icon: [
      512,
      512,
      [],
      'f85f',
      
      'M224 112C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c5.2 0 10.2-.3 15.2-1L88.7 171.6C64.9 162.3 48 139.1 48 112c0-35.3 28.7-64 64-64c27.1 0 50.3 16.9 59.6 40.7L223 127.2c.7-5 1-10.1 1-15.2zm-10.7 47.9l-39.8-29.9L128 96 96 128l34.1 45.4 29.9 39.8 .1 .1v85.3l-.1 .1-29.9 39.8L96 384l32 32 45.4-34.1 39.8-29.9 .1-.1h85.3l.1 .1 39.8 29.9L384 416l32-32-34.1-45.4-29.9-39.8-.1-.1V213.3l.1-.1 29.9-39.8L416 128 384 96l-45.4 34.1-39.8 29.9-.1 .1H213.3l-.1-.1zM223 384.8l-51.3 38.5C162.3 447.1 139.1 464 112 464c-35.3 0-64-28.7-64-64c0-27.1 16.9-50.3 40.7-59.6L127.2 289c-5-.7-10.1-1-15.2-1C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-5.2-.3-10.2-1-15.2zM288 112c0 5.2 .3 10.2 1 15.2l51.3-38.5C349.7 64.9 372.9 48 400 48c35.3 0 64 28.7 64 64c0 27.1-16.9 50.3-40.7 59.6L384.8 223c5 .7 10.1 1 15.2 1c61.9 0 112-50.1 112-112S461.9 0 400 0S288 50.1 288 112zm1 272.8c-.7 5-1 10.1-1 15.2c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-5.2 0-10.2 .3-15.2 1l38.5 51.3c23.8 9.3 40.7 32.5 40.7 59.6c0 35.3-28.7 64-64 64c-27.1 0-50.3-16.9-59.6-40.7L289 384.8zM304 208v96H208V208h96z'
      
    ]
  };

  

  
  

  var faDiceD20 = {
    prefix: 'fasr',
    iconName: 'dice-d20',
    icon: [
      512,
      512,
      [],
      'f6cf',
      
      'M232 498.3L256 512l24-13.7L466.2 391.9 480 384V358.4 348 157.5 128l-22.9-13.1L283.7 15.8 269.9 7.9 256 0 242.1 7.9l-13.8 7.9L54.9 114.9 32 128v29.5V348v10.4V384l13.8 7.9L232 498.3zm-74.4-97.8l74.4 5.7V443l-74.4-42.5zM280 406.2l74.4-5.7L280 443V406.2zM432 268l-32-53.4 32-22.9V268zm-56.5-94.8L332.1 98.7l82 46.9-38.6 27.6zM179.9 98.7l-43.4 74.4L97.9 145.6l82-46.9zM112 214.7L80 268V191.8l32 22.9zM88.6 347l56-93.4L210 356.4 88.6 347zM302 356.4l65.4-102.7 56 93.4L302 356.4zm-46-17.1L187.7 232H324.3L256 339.3zM185.8 184L256 63.6 326.2 184H185.8z'
      
    ]
  };

  

  
  

  var faBeerMug = {
    prefix: 'fasr',
    iconName: 'beer-mug',
    icon: [
      512,
      512,
      ["beer-foam"],
      'e0b3',
      
      'M168.1 69.4L160.9 80H148.1 135.2h-9.8l-7-6.9C112.6 67.5 104.7 64 96 64C78.3 64 64 78.3 64 96s14.3 32 32 32c8.7 0 16.6-3.5 22.4-9.1l7-6.9h9.8 12.9 12.8l7.1 10.6c8.7 12.9 23.3 21.4 39.9 21.4s31.3-8.4 39.9-21.4l7.1-10.6h12.8 12 10.2l7.1 7.3c6 6.2 14.3 10 23.5 10c18 0 32.6-14.6 32.6-32.6s-14.6-32.6-32.6-32.6c-8.8 0-16.8 3.5-22.7 9.2l-7 6.8h-9.7H267.9 255.1l-7.1-10.6C239.3 56.4 224.6 48 208 48s-31.3 8.4-39.9 21.4zM208 0c27 0 51.3 11.1 68.7 29c12.6-8.2 27.7-13 43.9-13c44.5 0 80.6 36.1 80.6 80.6s-36.1 80.6-80.6 80.6c-16.5 0-31.9-5-44.7-13.5c-17.4 17.4-41.4 28.2-68 28.2c-26.9 0-51.2-11.1-68.6-28.8C126.9 171.3 112 176 96 176c-44.2 0-80-35.8-80-80s35.8-80 80-80c16 0 30.9 4.7 43.4 12.8C156.8 11.1 181.1 0 208 0zM80 206.9V464H336V432.6c0-.4 0-.7 0-1.1V208.2c32.3-4.4 60.2-22.5 77.8-48.2H488h24v24V376v15.7L497.6 398 384 447.7V464v48H336 80 32V464 187.9c14 9.8 30.3 16.4 48 18.9zM320.2 97.1l-.4-.5 .5-.4c.1-.1 .2-.1 .2-.2l0 0c0 0 .1 0 .2 0s.2 0 .2 0l0 0c0 0 .1 .1 .2 .2s.1 .2 .2 .2l0 0c0 0 0 .1 0 .2s0 .2 0 .2l0 0c0 0-.1 .1-.2 .2s-.2 .1-.2 .2l0 0c0 0-.1 0-.2 0s-.2 0-.2 0l0 0c0 0-.1-.1-.2-.2zM464 208H384V395.3l80-35V208zM160 240V400v16H128V400 240 224h32v16zm64 0V400v16H192V400 240 224h16 16v16zm64 0V400v16H256V400 240 224h32v16z'
      
    ]
  };

  
    var faBeerFoam = faBeerMug;
  

  
  

  var faFileHeart = {
    prefix: 'fasr',
    iconName: 'file-heart',
    icon: [
      384,
      512,
      [],
      'e176',
      
      'M48 48H224V160H336V464H48V48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM93.7 305.1c0 14.3 5.9 28 16.4 37.8l70.9 66.4L192 419.5l10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8c0-28.6-23.2-51.8-51.8-51.8H235c-14 0-27.5 5.3-37.8 14.9l-5.2 4.8-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9h-3.5c-28.6 0-51.8 23.2-51.8 51.8z'
      
    ]
  };

  

  
  

  var faMessageDots = {
    prefix: 'fasr',
    iconName: 'message-dots',
    icon: [
      512,
      512,
      ["comment-alt-dots","messaging"],
      'f4a3',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faCommentAltDots = faMessageDots;
  
    var faMessaging = faMessageDots;
  

  
  

  var faHandBackPointLeft = {
    prefix: 'fasr',
    iconName: 'hand-back-point-left',
    icon: [
      512,
      512,
      [],
      'e19f',
      
      'M0 136l0-24 24 0 227.2 0 51-56.1 7.1-7.9L320 48l38.5 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 328c0 66.3-53.7 120-120 120l-8 0-96 0-40 0-24 0 0-24 0-40-8 0-24 0 0-24 0-48-8 0-24 0 0-24 0-48L24 240 0 240l0-24 0-80zM240 264l0 24 0 48 8 0 24 0 0 24 0 40 16 0 96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l20-11.7-20 11.7-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-27.9 0-29.1 32 42.5 0 16 0 0 32-16 0-71.6 0-8.4 0-2.2 0L248 160 48 160l0 32 136 0 24 0 0 24 0 48 8 0 24 0z'
      
    ]
  };

  

  
  

  var faArrowsLeftRightToLine = {
    prefix: 'fasr',
    iconName: 'arrows-left-right-to-line',
    icon: [
      640,
      512,
      [],
      'e4ba',
      
      'M48 64V88l0 336v24H0l0-24L0 88 0 64l48 0zm209.9 88l-17 17-63 63 284.1 0-63-63-17-17L416 118.1l17 17L537 239l17 17-17 17L433 377l-17 17L382.1 360l17-17 63-63-284.1 0 63 63 17 17L224 393.9l-17-17L103 273l-17-17 17-17L207 135l17-17L257.9 152zM640 88V424v24H592V424 88 64l48 0V88z'
      
    ]
  };

  

  
  

  var faBluetooth = {
    prefix: 'fasr',
    iconName: 'bluetooth',
    icon: [
      384,
      512,
      [],
      'f293',
      
      'M168 0l38.4 28.8 128 96 23.7 17.8-22.3 19.5L228.4 256l107.4 93.9 22.3 19.5-23.7 17.8-128 96L168 512V464 308.9L79.8 386.1 61.7 401.9 30.1 365.7l18.1-15.8L155.6 256 48.2 162.1 30.1 146.3l31.6-36.1 18.1 15.8L168 203.1V48 0zm48 308.9V416l65.9-49.4L216 308.9zm0-105.8l65.9-57.7L216 96V203.1z'
      
    ]
  };

  

  
  

  var faChartSimpleHorizontal = {
    prefix: 'fasr',
    iconName: 'chart-simple-horizontal',
    icon: [
      448,
      512,
      [],
      'e474',
      
      'M400 240L48 240l0 32 352 0 0-32zm48 32l0 48-48 0L48 320 0 320l0-48 0-32 0-48 48 0 352 0 48 0 0 48 0 32zM208 400L48 400l0 32 160 0 0-32zm48 32l0 48-48 0L48 480 0 480l0-48 0-32 0-48 48 0 160 0 48 0 0 48 0 32zm80-320l0-32L48 80l0 32 288 0zm48 48l-48 0L48 160 0 160l0-48L0 80 0 32l48 0 288 0 48 0 0 48 0 32 0 48z'
      
    ]
  };

  

  
  

  var faMountainSun = {
    prefix: 'fasr',
    iconName: 'mountain-sun',
    icon: [
      640,
      512,
      [],
      'e52f',
      
      'M560 0a80 80 0 1 1 0 160A80 80 0 1 1 560 0zM48 454.8V464H464v-9.2L256 149.3 48 454.8zM227 106.6L256 64l29 42.6L412.5 293.9l38.7-58.4L480 192l28.8 43.5L640 433.7V464v48H592 512 464h-7H48 0V464 440L227 106.6zM512 440v24h80V448.2L480 279l-38.3 57.8L512 440z'
      
    ]
  };

  

  
  

  var faCabin = {
    prefix: 'fasr',
    iconName: 'cabin',
    icon: [
      512,
      512,
      [],
      'e46d',
      
      'M256 58.2L427.3 176H84.7L256 58.2zM432 121L256 0 0 176v48H48 464h48V176l-32-22V32H432v89zM32 272v48H192V272H32zm0 192v48H192V464H32zm160-96H32v48H192V368zm128-96v48H480V272H320zM480 464H320v48H480V464zM320 368v48H480V368H320zM256 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faCircleX = {
    prefix: 'fasr',
    iconName: 'circle-x',
    icon: [
      512,
      512,
      [],
      'e12e',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM381.1 128H321.3L256 215.8 190.7 128H130.9l95.2 128L130.9 384h59.8L256 296.2 321.3 384h59.8L285.9 256l95.2-128z'
      
    ]
  };

  

  
  

  var faFamilyDress = {
    prefix: 'fasr',
    iconName: 'family-dress',
    icon: [
      512,
      512,
      [],
      'e301',
      
      'M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm36.2 144L63.6 336H144v48H112V488v24H64V488 384H49.9 0l13.7-48L64 160H177.6c-1 5.2-1.6 10.5-1.6 16c0 11.4 2.4 22.2 6.7 32H155.8 128 100.2zm229.1 0c4.3-9.8 6.7-20.6 6.7-32c0-5.5-.6-10.8-1.6-16H448l50.3 176L512 384H462.1 448V488v24H400V488 384H368V336h80.4L411.8 208H384 356.2 329.3zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm-64 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm80 240v48H304v96H208V416H176V368 304 256h48 64 48v48 64zm-112 0h64V304H224v64z'
      
    ]
  };

  

  
  

  var faBookOpenReader = {
    prefix: 'fasr',
    iconName: 'book-open-reader',
    icon: [
      512,
      512,
      ["book-reader"],
      'f5da',
      
      'M256 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144A96 96 0 1 0 256 0a96 96 0 1 0 0 192zm0 48s-53.2-39.9-208-46.9c-15-.7-31-1.1-48-1.1v48V416v48c160 0 256 48 256 48s96-48 256-48V416 240 192c-17 0-33 .4-48 1.1C309.2 200.1 256 240 256 240zm208 1.1V417.4c-62.8 3.6-114.4 13.9-152.6 24.3c-11.7 3.2-22.2 6.4-31.4 9.5V282l4-3 .3-.2c.9-.6 2.9-1.7 6.1-3.3c6.4-3.2 17.9-8.2 35.3-13.5c28.4-8.5 73-17.7 138.2-20.9zm-232 210c-9.2-3-19.6-6.3-31.4-9.5C162.4 431.3 110.8 421 48 417.4V241.1c65.2 3.1 109.8 12.3 138.2 20.9c17.5 5.2 28.9 10.2 35.3 13.5c3.2 1.6 5.2 2.8 6.1 3.3l.3 .2 4 3V451.2z'
      
    ]
  };

  
    var faBookReader = faBookOpenReader;
  

  
  

  var faMicrophoneStand = {
    prefix: 'fasr',
    iconName: 'microphone-stand',
    icon: [
      512,
      512,
      [127908],
      'f8cb',
      
      'M477.8 203.9l-1 1-16 16-16 16-1 1c-22 21.5-50.2 32.9-78.7 34.1l-18 15.1L280 343.6V352 488v24H232V488 384L80 512 0 432 225 164.9l15.1-18c1.2-28.6 12.6-56.8 34.1-78.7l.9-1 0 0 16-16 16-16 0 0 1-.9c46.9-45.9 122.2-45.6 168.7 1s46.9 121.8 1 168.7zm-67.9 0L308.1 102.1c-15.5 16.1-22.1 37.7-19.6 58.4l1.6 1.6 59.9 59.9 1.6 1.6c20.7 2.4 42.3-4.1 58.4-19.6zm33-134.8c-27.8-27.8-72.7-28.1-100.8-1L443.9 169.9c27.2-28.2 26.8-73.1-1-100.8zM313.1 253L259 198.9 65.1 429.2l17.7 17.7L313.1 253z'
      
    ]
  };

  

  
  

  var faUserHairMullet = {
    prefix: 'fasr',
    iconName: 'user-hair-mullet',
    icon: [
      448,
      512,
      ["business-front","party-back","trian-balbot"],
      'e45c',
      
      'M304 128c0-5.5-.6-10.8-1.6-16H272 260l-7.2-9.6L224 64l-28.8 38.4L188 112H176 145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zm47-16c.7 5.2 1 10.6 1 16v16c0 21.7-5.4 42.1-14.9 59.9L352 256l-32 16-24-16-8 32H256l-16.9-16.9c-5 .6-10 .9-15.1 .9s-10.2-.3-15.1-.9L192 288H160l-8-32-24 16L96 256l14.9-52.1C101.4 186.1 96 165.7 96 144V128c0-5.4 .3-10.8 1-16H88V64h24 1.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64H336h24v48h-9zM66.6 464H381.4l-32-96H98.6l-32 96zM64 320H384l48 144 16 48H397.4 50.6 0l16-48L64 320z'
      
    ]
  };

  
    var faBusinessFront = faUserHairMullet;
  
    var faPartyBack = faUserHairMullet;
  
    var faTrianBalbot = faUserHairMullet;
  

  
  

  var faPodiumStar = {
    prefix: 'fasr',
    iconName: 'podium-star',
    icon: [
      448,
      512,
      [],
      'f758',
      
      'M288 0H176V24h-8c-48.6 0-88 39.4-88 88v32H24 0v48H24 424h24V144H424 128V112c0-22.1 17.9-40 40-40h8V96H288c26.5 0 48-21.5 48-48s-21.5-48-48-48zM47.3 224L80 512H368l32.7-288H352.4L325.1 464H122.9L95.6 224H47.3zm201.6 85.8L224 256l-24.8 53.8-58.9 7 43.5 40.2-11.6 58.1 51.7-29 51.7 29-11.6-58.1 43.5-40.2-58.9-7z'
      
    ]
  };

  

  
  

  var faUserTieHair = {
    prefix: 'fasr',
    iconName: 'user-tie-hair',
    icon: [
      448,
      512,
      [],
      'e45f',
      
      'M304 144V128c0-11.4-2.4-22.2-6.7-32H256L240 80l-32 32H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 0c70.7 0 128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128C96 57.3 153.3 0 224 0zM209.1 359.2L176 304h48 48l-33.1 55.2 15.9 59.2L304 320h80l48 144 16 48H397.4 280 261.7 186.3 168 50.6 0l16-48L64 320h80l49.2 98.4 15.9-59.2zM381.4 464l-32-96H333.7l-48 96h95.7zM114.3 368H98.6l-32 96h95.7l-48-96z'
      
    ]
  };

  

  
  

  var faHandHoldingHand = {
    prefix: 'fasr',
    iconName: 'hand-holding-hand',
    icon: [
      512,
      512,
      [],
      'e4f7',
      
      'M149.3 270.2h-6.5l-5.4 3.6-80 53.3H21.3 0v42.7H21.3 64h6.5l5.4-3.6 80-53.3H320v28.4H284.4 263.1 227.6 206.2V384h21.3 35.6 21.3 42.7 28.4 6.2l5.2-3.3 71.5-45.4 13.3 21.3-81.5 55.8H21.3 0v42.7H21.3 376.9h6.6l5.4-3.7 103.8-71.1 16.9-11.6-10.8-17.3-35.6-56.9-11.4-18.2-18.1 11.5-71.1 45.1V291.6 270.2H341.3h-192zm213.3-28.4h6.5l5.4-3.6 80-53.3h36.2H512V142.2H490.7 448h-6.5l-5.4 3.6-80 53.3H192V170.7h35.6 21.3 35.6 21.3V128H284.4 248.9 227.6 184.9 156.4h-6.2l-5.2 3.3L73.5 176.7 60.2 155.4l81.5-55.8h349H512V56.9H490.7 135.1h-6.6l-5.4 3.7L19.2 131.7 2.4 143.3l10.8 17.3 35.6 56.9 11.4 18.2 18.1-11.5 71.1-45.1v41.3 21.3h21.3 192z'
      
    ]
  };

  

  
  

  var faCar = {
    prefix: 'fasr',
    iconName: 'car',
    icon: [
      512,
      512,
      [128664,"automobile"],
      'f1b9',
      
      'M120 32H102.7L97.2 48.4 54.7 176H48 0v48V352v48 80H48V400H464v80h48V400 352 224 176H464h-6.7L414.8 48.4 409.3 32H392 120zM406.7 176H105.3l32-96H374.7l32 96zM464 224V352H48V224H464zM144 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faAutomobile = faCar;
  

  
  

  var faBoxBallot = {
    prefix: 'fasr',
    iconName: 'box-ballot',
    icon: [
      576,
      512,
      [128499],
      'f735',
      
      'M176 48V208H400V48H176zM128 0h48H400h48V48 208v48H400 176 128V208 48 0zM48 160H96v48H48V320H528V208H480V160h48 48v48V320v24 24 96 48H528 48 0V464 368 344 320 208 160H48zM528 368H48v96H528V368z'
      
    ]
  };

  

  
  

  var faCircleS = {
    prefix: 'fasr',
    iconName: 'circle-s',
    icon: [
      512,
      512,
      [],
      'e121',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c1.1-6.2 5-11.8 15.4-15.8c11-4.3 27.6-6 47.8-2.9c6 .9 20.6 4 27.3 5.7l23.3 6 11.9-46.5-23.3-6c-7.7-2-23.9-5.5-32-6.7c-25.6-3.9-51.3-2.6-72.6 5.7c-21.9 8.6-40.3 25.7-45 52c-2.6 14.4-1.3 28 4.4 40.3c5.6 12.1 14.7 20.8 24.1 27.2c17.2 11.6 40.3 18.1 58.6 23.2l2 .6c21.1 5.9 36.7 10.6 46.8 17.4c4.5 3 6.5 5.6 7.4 7.7c.9 1.9 1.8 5.2 .6 11.6c-1.1 6.2-5 11.8-15.4 15.8c-11 4.3-27.5 6-47.7 2.9c-12.2-1.9-36.1-8.9-50-13.4l-22.9-7.3-14.7 45.7 22.9 7.3c13.6 4.4 40.9 12.5 57.3 15.1l0 0 .1 0c25.6 3.9 51.3 2.6 72.6-5.7c21.9-8.6 40.3-25.7 45-52c2.6-14.4 1.4-28-4.4-40.3c-5.6-12.1-14.7-20.8-24.1-27.2c-17.2-11.6-40.3-18.1-58.6-23.2l-2-.6c-21.1-5.9-36.7-10.6-46.8-17.4c-4.5-3-6.5-5.6-7.4-7.7c-.9-1.9-1.8-5.2-.6-11.6z'
      
    ]
  };

  

  
  

  var faCreditCard = {
    prefix: 'fasr',
    iconName: 'credit-card',
    icon: [
      576,
      512,
      [62083,128179,"credit-card-alt"],
      'f09d',
      
      'M528 80v48H48V80H528zm0 144V432H48V224H528zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM192 336H96v48h96V336zm192 0H224v48H384V336z'
      
    ]
  };

  
    var faCreditCardAlt = faCreditCard;
  

  
  

  var faBowlChopsticks = {
    prefix: 'fasr',
    iconName: 'bowl-chopsticks',
    icon: [
      512,
      512,
      [],
      'e2e9',
      
      'M0 128V96L512 0V48L0 128zm0 16l512-16v48H0V144zM176 464H336V443.1l26.7-13.2c55.1-27.3 93.9-82.4 97.8-147.5l.6-10.3H50.9l.6 10.3c3.8 65.1 42.7 120.3 97.8 147.5L176 443.1V464zM3.6 285.2L2.8 272 0 224H48.1 463.9 512l-2.8 48-.8 13.2C503.5 368.1 454 438.2 384 472.9V512H336 176 128V472.9C58 438.2 8.5 368.1 3.6 285.2z'
      
    ]
  };

  

  
  

  var faBug = {
    prefix: 'fasr',
    iconName: 'bug',
    icon: [
      512,
      512,
      [],
      'f188',
      
      'M256 0c-53 0-96 43-96 96v32H352V96c0-53-43-96-96-96zM73 103l-17-17L22.1 120l17 17 57 57V208v56H24 0v48H24 96v8c0 27.2 6.8 52.8 18.8 75.3L50.2 459.8l-17 17 33.9 33.9 17-17 59.7-59.7C172.7 462.5 212.3 480 256 480s83.3-17.5 112.2-45.9l59.7 59.7 17 17 33.9-33.9-17-17-64.6-64.6c12-22.4 18.8-48.1 18.8-75.3v-8h72 24V264H488 416V208 193.9l57-57 17-17L456 86.1l-17 17-57 57H368 144 129.9L73 103zM232 429.4c-50.3-11-88-55.8-88-109.4V208H368V320c0 53.6-37.7 98.4-88 109.4V280 256H232v24V429.4z'
      
    ]
  };

  

  
  

  var faHandsHoldingCircle = {
    prefix: 'fasr',
    iconName: 'hands-holding-circle',
    icon: [
      640,
      512,
      [],
      'e4fb',
      
      'M320 256A128 128 0 1 0 320 0a128 128 0 1 0 0 256zM144 64H120 24 0V88 392v9.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112H96V312v9.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16L233.9 392l-16-16-1-1-16-16-23-23L208 305.9l88 88V488v24h24 24V488 393.9l88-88L462.1 336l-23 23 0 0-16 16-17 17L440 425.9l17-17 16-16 0 0 40-40 17-17 7-7 7-7V312 112h48V382.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V392 88 64H616 520 496V88 302.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88 64z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassWaveform = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-waveform',
    icon: [
      512,
      512,
      [],
      'e661',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm24-280V112H184v24V280v24h48V280 136zm-80 32V144H104v24 80 24h48V248 168zm160 16V160H264v24 48 24h48V232 184z'
      
    ]
  };

  

  
  

  var faEnvelopeDot = {
    prefix: 'fasr',
    iconName: 'envelope-dot',
    icon: [
      576,
      512,
      ["envelope-badge"],
      'e16f',
      
      'M496 160A80 80 0 1 0 496 0a80 80 0 1 0 0 160zm16 240V190.9c-5.2 .7-10.6 1.1-16 1.1c-23.5 0-45.4-7.3-63.4-19.7L256 293.8 48 150.8V112H388.6c-3-10.1-4.6-20.9-4.6-32c0-5.4 .4-10.8 1.1-16H48 0v48 64V400v48H48 464h48V400zM464 209V400H48V209L256 352 464 209z'
      
    ]
  };

  
    var faEnvelopeBadge = faEnvelopeDot;
  

  
  

  var faToolbox = {
    prefix: 'fasr',
    iconName: 'toolbox',
    icon: [
      512,
      512,
      [129520],
      'f552',
      
      'M128 32l24 0 208 0 24 0 0 24 0 72 48 0 80 80 0 96 0 48 0 80 0 48-48 0L48 480 0 480l0-48 0-80 0-48 0-96 80-80 48 0 0-72 0-24zM48 352l0 80 416 0 0-80-96 0 0 16 0 24-48 0 0-24 0-16-128 0 0 16 0 24-48 0 0-24 0-16-96 0zm416-48l0-76.1L412.1 176 99.9 176 48 227.9 48 304l96 0 0-16 0-24 48 0 0 24 0 16 128 0 0-16 0-24 48 0 0 24 0 16 96 0zM336 80L176 80l0 48 160 0 0-48z'
      
    ]
  };

  

  
  

  var faPersonThroughWindow = {
    prefix: 'fasr',
    iconName: 'person-through-window',
    icon: [
      640,
      512,
      [],
      'e5a9',
      
      'M304 48l0 82.8L139.1 235.7 128 242.8l0 13.2 0 144H48V48H304zm48 0H592V400H510.3L499 385.4l-80-104-7.2-9.4H400l-67 0-47.4-72.6 55.3-35.2 11.1-7.1 0-13.2V48zm97.7 352H365.9l32 48H592h48V400 48 0H592 48 0V48 400v48H48 303.9l36.2 53.5 39.7-26.9L297.2 352.5 343.6 320l44.6 0 61.5 80zm-178.3 0H176l0-130.8 4.7-3L271.4 400zm-1.1-87.3l-49-72.3 23.9-15.2 47.1 72.2-22 15.4zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faBells = {
    prefix: 'fasr',
    iconName: 'bells',
    icon: [
      640,
      512,
      [],
      'f77f',
      
      'M217.9 251.6l35.3 97.1-11.3 44.4L0 305l12.9-35.6 67.2-48 36.4-100c25.7-70.5 103.6-106.8 174-81.2c.9 .3 1.7 .6 2.5 1c-71.1 42-104.5 130-75.2 210.4zM97.5 374.6l117.9 42.9c-11.3 18.3-31.5 30.4-54.5 30.4c-35.4 0-64.1-28.7-64.1-64c0-3.2 .2-6.3 .7-9.3zm497.4-20.5l-6.2 2.3-56 20.4L416.5 419l-56 20.4-81.7 29.7 0 0-13.7-37.6 0 0 2.4-9.3L286.7 347 248 240.6c-27-74.2 11.2-156.2 85.4-183.2s156.3 11.3 183.3 85.5l38.7 106.4 63 45.3 7.8 5.6L640 337.7l0 0-45.1 16.4zM545.2 416c0 2.5-.1 5-.4 7.5C541.1 455.3 514 480 481.2 480c-17 0-32.5-6.6-43.9-17.4c-3.1-2.9-5.9-6.2-8.4-9.7l52.4-19.1L530.3 416l14.7-5.4c.1 1.8 .2 3.6 .2 5.4zm18.6-101.6l-36.4-26.1-12-8.6-5.1-13.9L471.6 159.3c-17.9-49.3-72.5-74.7-121.8-56.8s-74.7 72.4-56.8 121.7l38.7 106.4 5.1 13.9-3.7 14.4-11.1 43.4 241.7-88z'
      
    ]
  };

  

  
  

  var faGrid2Plus = {
    prefix: 'fasr',
    iconName: 'grid-2-plus',
    icon: [
      512,
      512,
      [],
      'e197',
      
      'M176 80H80v96h96V80zM80 32h96 48V80v96 48H176 80 32V176 80 32H80zm96 304H80v96h96V336zM80 288h96 48v48 96 48H176 80 32V432 336 288H80zM336 80v96h96V80H336zM288 32h48 96 48V80v96 48H432 336 288V176 80 32zM408 272v24 64h64 24v48H472 408v64 24H360V472 408H296 272V360h24 64V296 272h48z'
      
    ]
  };

  

  
  

  var faKitMedical = {
    prefix: 'fasr',
    iconName: 'kit-medical',
    icon: [
      576,
      512,
      ["first-aid"],
      'f479',
      
      'M144 432V80H432V432H144zm-48 0H48V80H96V432zM120 32H96 48 0V80 432v48H48 96h24 24H432h24 24 48 48V432 80 32H528 480 456 432 144 120zM528 432H480V80h48V432zM256 160v64H192v64h64v64h64V288h64V224H320V160H256z'
      
    ]
  };

  
    var faFirstAid = faKitMedical;
  

  
  

  var faChessPawn = {
    prefix: 'fasr',
    iconName: 'chess-pawn',
    icon: [
      320,
      512,
      [9823],
      'f443',
      
      'M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120H243.4l10.7 80H205.7L195 272H160 125l-10.7 80H65.9l10.7-80H64 40V224H64c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72h24v48H256zM69.2 432L52.7 464H267.3l-16.6-32H69.2zM320 464v48H272 48 0V464v-2.7L40 384H280l40 77.3V464z'
      
    ]
  };

  

  
  

  var faNfcSlash = {
    prefix: 'fasr',
    iconName: 'nfc-slash',
    icon: [
      640,
      512,
      [],
      'e1fc',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L544 399.6V80 32H496 144 96V51.8l-47.6-37zM144 89V80H496V362.3l-32-24.8V136 112H440 320 296v24 71l-60.6-47H256V112H232 200 176v1.9L144 89zM416 300.2l-48.4-37.6c.3-2.2 .4-4.4 .4-6.6c0-17.8-9.7-33.3-24-41.6V160h72V300.2zM487.4 480l-60.9-48H144V209.5L96 171.6V432v48h48H487.4zM385.8 400l-60.9-48H224V272.5l-48-37.8V376v24h24H385.8z'
      
    ]
  };

  

  
  

  var faEllipsis = {
    prefix: 'fasr',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ["ellipsis-h"],
      'f141',
      
      'M24 296l0-80 80 0 0 80-80 0zm160 0l0-80 80 0 0 80-80 0zm160-80l80 0 0 80-80 0 0-80z'
      
    ]
  };

  
    var faEllipsisH = faEllipsis;
  

  
  

  var faAnchorCircleXmark = {
    prefix: 'fasr',
    iconName: 'anchor-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4ac',
      
      'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216 192v48h24 48V464H120V352h72L96 256 0 352H72V488v24H96 288 394.8c-18.3-12.9-34.1-29.2-46.3-48H312V240h48 15.2c2.8-2.7 5.8-5.3 8.8-7.8V192H360 312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faTentDoublePeak = {
    prefix: 'fasr',
    iconName: 'tent-double-peak',
    icon: [
      576,
      512,
      [],
      'e627',
      
      'M48 464H264V240H48V464zM312 240L416 464H528V240H312zm-48-48h48H528V175.3c-45.2-26.7-85.1-61.5-117.7-102.4C374.9 98.1 332.2 112 288 112s-86.9-13.9-122.3-39.2c-32.7 41-72.6 75.7-117.7 102.4V192H264zM7.9 142.7C55.4 117.5 97 82.7 130.1 40.6c7.1-9.1 13.9-18.5 20.2-28.2l8-12.3 8.5 9.5c8.1 9.1 17.1 17.2 26.9 24.2C220.9 53.2 253.8 64 288 64s67.1-10.8 94.4-30.3c9.8-7 18.8-15.1 26.9-24.2L417.8 0l8 12.3c6.3 9.7 13 19.2 20.2 28.2c33.1 42.1 74.6 76.9 122.2 102.2l7.9 4.2V464v48H528 48 0V464 146.9l7.9-4.2z'
      
    ]
  };

  

  
  

  var faTicketsAirline = {
    prefix: 'fasr',
    iconName: 'tickets-airline',
    icon: [
      640,
      512,
      ["tickets-perforated-plane","tickets-plane"],
      'e29b',
      
      'M144 80H592v54.2c-24.1 15.7-40 42.9-40 73.8s15.9 58.1 40 73.8V336H144V80zm496 88V120 80 32H592 144 96V80 336v48h48H592h48V336 296 248c-22.1 0-40-17.9-40-40s17.9-40 40-40zM512 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM264 96l26.7 80H248l-24-32H192l16 64-16 64h32l24-32h42.7L264 320h56l46.7-80h40.3c16.1 0 31.5-6.4 42.8-17.7c7.9-7.9 7.9-20.7 0-28.5C438.4 182.4 423 176 406.9 176H366.7L320 96H264zM48 120V96H0v24V456v24H24 520h24V432H520 48V120z'
      
    ]
  };

  
    var faTicketsPerforatedPlane = faTicketsAirline;
  
    var faTicketsPlane = faTicketsAirline;
  

  
  

  var faArrowRightLong = {
    prefix: 'fasr',
    iconName: 'arrow-right-long',
    icon: [
      512,
      512,
      ["long-arrow-right"],
      'f178',
      
      'M495 273l17-17-17-17L359 103l-17-17L308.1 120l17 17 95 95L24 232 0 232l0 48 24 0 396.1 0-95 95-17 17 33.9 33.9 17-17L495 273z'
      
    ]
  };

  
    var faLongArrowRight = faArrowRightLong;
  

  
  

  var faUserLock = {
    prefix: 'fasr',
    iconName: 'user-lock',
    icon: [
      640,
      512,
      [],
      'f502',
      
      'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM99.5 352L65 464H320h63 1l0 48H50.2 0l14.8-48L64 304H384l0 0 0 48H348.5 320 99.5zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H416V320h32V272z'
      
    ]
  };

  

  
  

  var faThumbsDown = {
    prefix: 'fasr',
    iconName: 'thumbs-down',
    icon: [
      512,
      512,
      [61576,128078],
      'f165',
      
      'M224 480h24 96 24V456 423c0-30.3-5.9-59.8-16.9-87H448h40 24V312 232 208H496V168 144H472V104 80H448V56 32H424 384 272 259.9h-7.3l-6 4-10.1 6.7L160 93.8v57.7L263.1 82.7l4-2.7H272 384h16v24 24h24v40 24h24v40 24h16v32H448 311.9 268.4l23.2 36.8C309.8 353.7 320 387.6 320 423v9H272v-9c0-49.8-27.2-95.6-70.9-119.4l-4.6-2.5-18.6-10.1-5.4-2.9h-6.1H164h-4v48h.3l13.2 7.2 4.6 2.5C206.4 361.2 224 390.8 224 423v33 24zm-96-96V96H0V384H128z'
      
    ]
  };

  

  
  

  var faGripLines = {
    prefix: 'fasr',
    iconName: 'grip-lines',
    icon: [
      448,
      512,
      [],
      'f7a4',
      
      'M448 216l0-48L0 168l0 48 448 0zm0 128l0-48L0 296l0 48 448 0z'
      
    ]
  };

  

  
  

  var faHeadSideCough = {
    prefix: 'fasr',
    iconName: 'head-side-cough',
    icon: [
      640,
      512,
      [],
      'e061',
      
      'M112 381.2V361.7l-13.7-14C66.1 314.7 48 270.4 48 224.2C48 127 126.8 48 224 48h32c76.3 0 138.8 59.4 143.7 134.5l1.1 16.5 11 12.3L464 270.1V288H448 400v40 8 12l-80 20v40l80 6.7V424v24H296 272v24 16 24h48V496H424h24V472 424 360 336h16 16 16 16V304 288 264 251.8l-8.1-9.1-56.3-63.4C441.1 79.2 357.8 0 256 0H224C100.2 0 0 100.6 0 224.2c0 58.7 23 115.1 64 157V464v16 32H96h16V464 448 381.2zM368 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM488 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM616 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM576 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM576 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faPanFood = {
    prefix: 'fasr',
    iconName: 'pan-food',
    icon: [
      640,
      512,
      [129368],
      'e42b',
      
      'M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 320 0a256 256 0 1 0 0 512zM48 160H0v24V328v24H48V328 184 160zm592 24V160H592v24V328v24h48V328 184zM244.3 200L216 171.7l-14.1 14.1-32 32L155.7 232 184 260.3l14.1-14.1 32-32L244.3 200zM320 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM440 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM230.6 304l8-8L216 273.4l-11.3 11.3-8 8-8 8L177.4 312 200 334.6l8-8 16 16V376c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56H246.6l-16-16zM448 192l-96 96 10.6 10.6c13.7 13.7 32.4 21.4 51.8 21.4l4.1 0c14 0 27.6-4.8 38.5-13.5c14.6-11.7 23.1-29.4 23.1-48.1v-4.8c0-19-7.5-37.2-21-50.6l-11-11zM320 80c-39.8 0-72 32.2-72 72v8H392v-8c0-39.8-32.2-72-72-72z'
      
    ]
  };

  

  
  

  var faPersonDollyEmpty = {
    prefix: 'fasr',
    iconName: 'person-dolly-empty',
    icon: [
      512,
      512,
      [],
      'f4d1',
      
      'M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM0 488l0 24 48 0 0-24 0-109.9L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 488zM24 128H0v24V272.4c0 17.2 7.9 33.4 21.4 44l92.2 72.4L131.2 512h48.5L159.8 372.6l-1.4-9.5-7.6-5.9L120 332.9V328 246.2L139.8 277l7.1 11H160h63.3l27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6 23.3-5.8-11.6-46.6-23.3 5.8L339.7 410.3c-10-13.7-25.3-23.3-42.9-25.7L247.3 186.2l-5.8-23.3-46.6 11.6 5.8 23.3L211.3 240H173.1L108.2 139l-7.1-11H88 24zm48 56V295.2L51.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3V176H72v8zM272 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faCarTunnel = {
    prefix: 'fasr',
    iconName: 'car-tunnel',
    icon: [
      512,
      512,
      [],
      'e4de',
      
      'M256 48C141.1 48 48 141.1 48 256V488v24H0V488 256C0 114.6 114.6 0 256 0S512 114.6 512 256V488v24H464V488 256c0-114.9-93.1-208-208-208zM175.1 224H336.9h17.4l5.4 16.6L385.4 320H392h24v24V488v24H368V488v-8H144v8 24H96V488 344 320h24 6.5l25.7-79.4 5.4-16.6h17.5zM368 432V368H144v64H368zM335 320l-15.6-48H192.6L177 320H335zM160 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faOmega = {
    prefix: 'fasr',
    iconName: 'omega',
    icon: [
      448,
      512,
      [],
      'f67a',
      
      'M224 80C126.8 80 48 158.8 48 256c0 66.6 36.9 124.5 91.5 154.5l12.5 6.8 0 14.2 0 24.5 0 24H128 24 0V432H24 85.4C33.4 391 0 327.4 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 71.4-33.4 135-85.4 176H424h24v48H424 320 296V456 431.5 417.3l12.5-6.8C363.1 380.5 400 322.6 400 256c0-97.2-78.8-176-176-176z'
      
    ]
  };

  

  
  

  var faMountains = {
    prefix: 'fasr',
    iconName: 'mountains',
    icon: [
      640,
      512,
      [9968],
      'f6fd',
      
      'M48 432v-9.2L256 117.3 464 422.8V432H48zM256 32L227 74.6 0 408v24 48H48 457h7 48H640V401.7L480 160 412.5 261.9 285 74.6 256 32z'
      
    ]
  };

  

  
  

  var faAngleDown = {
    prefix: 'fasr',
    iconName: 'angle-down',
    icon: [
      448,
      512,
      [8964],
      'f107',
      
      'M224 385.9l17-17L401 209l17-17L384 158.1l-17 17-143 143L81 175l-17-17L30.1 192l17 17L207 369l17 17z'
      
    ]
  };

  

  
  

  var faAirConditioner = {
    prefix: 'fasr',
    iconName: 'air-conditioner',
    icon: [
      576,
      512,
      [],
      'f8f4',
      
      'M48 48V208H528V48H48zM0 0H48 528h48V48 208v48H528 48 0V208 48 0zM120 128H456h24v48H456 120 96V128h24zM368 288V392c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14.8-8-27.7-20-34.7l24.1-41.5C478.3 331 496 359.4 496 392c0 48.6-39.4 88-88 88s-88-39.4-88-88V288h48zM208 424V288h48V424c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-32.6 17.7-61 43.9-76.2L148 389.3c-12 7-20 19.9-20 34.7c0 22.1 17.9 40 40 40s40-17.9 40-40z'
      
    ]
  };

  

  
  

  var faSquareQuestion = {
    prefix: 'fasr',
    iconName: 'square-question',
    icon: [
      448,
      512,
      ["question-square"],
      'f2fd',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM136 184c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4V272v24H200V272 250.5 236.6l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H192c-4.4 0-8 3.6-8 8l0 6.5-48 0V184zm64 152h48v48H200V336z'
      
    ]
  };

  
    var faQuestionSquare = faSquareQuestion;
  

  
  

  var faOilTemperature = {
    prefix: 'fasr',
    iconName: 'oil-temperature',
    icon: [
      576,
      512,
      ["oil-temp"],
      'f614',
      
      'M264 0h24 72 24V48H360 312V96h48 24v48H360 312v83.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V120 24 0zm24 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM136.6 303.1c11.8 6.7 25.8 12.8 40.3 15.4c2.4 18.2 9.1 35 19.1 49.4c-1.3 0-2.7 .1-4.1 .1c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7C59.7 355.8 31.5 368 0 368V320c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9zM288 416l-.2 0-.5 .4c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4m192.2 .2l-.2 0zm.5 .4l-.5-.4zm0 0l0 0zm0 0l0 0zm40 30.7c-15.4-8.7-27-19.1-40-30.7zM384 464c-19.7 0-39.5-7.8-55.3-16.9zm55.3-16.9c-15.9 9-35.6 16.9-55.3 16.9zm40-30.7c-13 11.6-24.6 22-40 30.7zm0 0l0 0zm.7-.6l-.7 .6zm.7 .6l-.7-.6zm40 30.7c-15.4-8.7-27-19.1-40-30.7zm0 0c15.9 9 35.7 16.9 55.4 16.9zM576 512V464zm-79.1-23.1c19.3 11 47.6 23.1 79.1 23.1zm-17-10.7c4.8 3.3 10.5 7 17 10.7zM463 488.9c6.5-3.7 12.2-7.4 16.9-10.7zM384 512c31.5 0 59.7-12.2 79.1-23.1zm-79.1-23.1c19.3 11 47.6 23.1 79.1 23.1zM288 478.2c4.7 3.3 10.5 7 16.9 10.7zM271 488.9c6.5-3.7 12.2-7.4 16.9-10.7zM192 512c31.5 0 59.7-12.2 79.1-23.1zm-79.1-23.1c19.3 11 47.6 23.1 79.1 23.1zM96 478.2c4.7 3.3 10.5 7 16.9 10.7zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7zM0 512c31.5 0 59.7-12.2 79-23.1zm0-48v48zm55.3-16.9C39.4 456.2 19.7 464 0 464zm40.2-30.9c-13 11.6-24.8 22.2-40.2 30.9zm303.5-97.6c14.5-2.7 28.4-8.7 40.3-15.4c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6 0 0 0 0c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.8 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1c-1.3 0-2.7 0-4-.1c10-14.4 16.7-31.2 19.1-49.4z'
      
    ]
  };

  
    var faOilTemp = faOilTemperature;
  

  
  

  var faFaceDrooling = {
    prefix: 'fasr',
    iconName: 'face-drooling',
    icon: [
      512,
      512,
      [],
      'e372',
      
      'M48 256c0 114.9 93.1 208 208 208v48C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 80.8-37.5 152.9-96 199.9V388.9c30-36 48-82.4 48-132.9c0-114.9-93.1-208-208-208S48 141.1 48 256zm110.8-32.4l-7.6 22.8-45.5-15.2 7.6-22.8c3.8-11.3 12.2-26.8 25.8-39.8C153.2 155.2 173.5 144 200 144h24v48H200c-11.9 0-20.9 4.8-27.9 11.4c-7.4 7-11.8 15.5-13.4 20.2zm-11 70.7l15 18.7c18.7 23.4 49.8 47 93.3 47s74.5-23.6 93.3-47l15-18.7 37.5 30-15 18.7c-.9 1.1-1.8 2.2-2.7 3.3V496v16H352V496 376.4c-9.5 7-20.2 13.3-32 18.5V464v16H288V464 404.9c-10 2-20.7 3.1-32 3.1c-62.6 0-106.2-34.3-130.7-65l-15-18.7 37.5-30zm192.1-90.9c-7-6.6-16-11.4-27.9-11.4H288V144h24c26.5 0 46.8 11.2 60.9 24.6c13.7 13 22.1 28.5 25.8 39.8l7.6 22.8-45.5 15.2-7.6-22.8c-1.6-4.7-6-13.2-13.4-20.2z'
      
    ]
  };

  

  
  

  var faDisplayCode = {
    prefix: 'fasr',
    iconName: 'display-code',
    icon: [
      576,
      512,
      ["desktop-code"],
      'e165',
      
      'M528 48H48V368H528V48zM48 416H0V368 48 0H48 528h48V48 368v48H528 364.3l8 48H424h24v48H424 352 224 152 128V464h24 51.7l8-48H48zm212.3 0l-8 48h71.3l-8-48H260.3zM249 177l-31 31 31 31 17 17L232 289.9l-17-17-48-48-17-17 17-17 48-48 17-17L265.9 160l-17 17zM361 143l48 48 17 17-17 17-48 48-17 17L310.1 256l17-17 31-31-31-31-17-17L344 126.1l17 17z'
      
    ]
  };

  
    var faDesktopCode = faDisplayCode;
  

  
  

  var faLessThan = {
    prefix: 'fasr',
    iconName: 'less-than',
    icon: [
      384,
      512,
      [62774],
      '3c',
      
      'M384 64.9L14 234.2 0 240.6v30.8l14 6.4L384 447.2V394.4L81.7 256 384 117.6V64.9z'
      
    ]
  };

  

  
  

  var faArrowDownShortWide = {
    prefix: 'fasr',
    iconName: 'arrow-down-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-desc","sort-amount-down-alt"],
      'f884',
      
      'M111 461.8l17 17 17-17 96-96 17-17L224 314.9l-17 17-55 55V56 32H104V56 386.9l-55-55-17-17L-1.9 348.8l17 17 96 96zM312 48H288V96h24 48 24V48H360 312zm0 128H288v48h24H424h24V176H424 312zm0 128H288v48h24H488h24V304H488 312zm0 128H288v48h24H552h24V432H552 312z'
      
    ]
  };

  
    var faSortAmountDesc = faArrowDownShortWide;
  
    var faSortAmountDownAlt = faArrowDownShortWide;
  

  
  

  var faFlorinSign = {
    prefix: 'fasr',
    iconName: 'florin-sign',
    icon: [
      384,
      512,
      [],
      'e184',
      
      'M315.3 32c-36 0-68.3 21.9-81.7 55.3L179 224H32v48H159.8L105.8 406.9C99.7 422 85 432 68.7 432H24 0v48H24 68.7c36 0 68.3-21.9 81.7-55.3L211.4 272H352V224H230.6l47.5-118.9C284.3 90 299 80 315.3 80H360h24V32H360 315.3z'
      
    ]
  };

  

  
  

  var faChartMixed = {
    prefix: 'fasr',
    iconName: 'chart-mixed',
    icon: [
      512,
      512,
      ["analytics"],
      'f643',
      
      'M495 82.7l18.7-15-30-37.5L465 45.3 320.1 161.2l-113-91.8L192.7 57.7l-15 11-152 112L6.4 194.9l28.5 38.6 19.3-14.2 137-101 113.6 92.3 15 12.2L335 210.7l160-128zM200 264V440H184V264h16zm-16-40H144v40V440v40h40 16 40V440 264 224H200 184zM72 360v80H56V360H72zM56 320H16v40 80 40H56 72h40V440 360 320H72 56zm256 8h16V440H312V328zm-40-40v40V440v40h40 16 40V440 328 288H328 312 272zm184-24V440H440V264h16zm-16-40H400v40V440v40h40 16 40V440 264 224H456 440z'
      
    ]
  };

  
    var faAnalytics = faChartMixed;
  

  
  

  var faArrowsTurnToDots = {
    prefix: 'fasr',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      'M255 31l-80 80-17 17 17 17 80 80 17 17L305.9 208l-17-17-39-39L464 152v80 24h48V232 128 104l-24 0-238.1 0 39-39 17-17L272 14.1 255 31zM257 287l-17-17L206.1 304l17 17 39 39L24 360H0v24V488v24H48V488 408l214.1 0-39 39-17 17L240 497.9l17-17 80-80 17-17-17-17-80-80zm255 97a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 64a64 64 0 1 0 0 128A64 64 0 1 0 64 64z'
      
    ]
  };

  

  
  

  var faGrill = {
    prefix: 'fasr',
    iconName: 'grill',
    icon: [
      448,
      512,
      [],
      'e5a3',
      
      'M400 80V96c0 97.2-78.8 176-176 176S48 193.2 48 96V80H400zM48 32H0V80 96c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64H316.7l13.2 30.8 4 9.3 9.5 22.1 44.1-18.9-9.5-22.1-4-9.3L318.8 299C395.1 263.3 448 185.8 448 96V80 32H400 48zM296.2 368H151.8l22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4s33.4-1.9 49.3-5.4L296.2 368zM96 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCircleDown = {
    prefix: 'fasr',
    iconName: 'circle-down',
    icon: [
      512,
      512,
      [61466,"arrow-alt-circle-down"],
      'f358',
      
      'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM368 288V256H304V128l-96 0 0 128H144v32l112 96 112-96z'
      
    ]
  };

  
    var faArrowAltCircleDown = faCircleDown;
  

  
  

  var faPersonRunningFast = {
    prefix: 'fasr',
    iconName: 'person-running-fast',
    icon: [
      512,
      512,
      [],
      'e5ff',
      
      'M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 112h8 64 3.2l3.1 .8 88 24 12.7 3.5 3.9 12.6L433.7 240H488h24v48H488 416 398.3l-5.2-16.9-12.5-40.8-28.1 84.4 43.4 24.4 16.9 9.5-5.8 18.5L361.6 512H311.4l43.9-140.6-88-49.5c-23.4-13.2-34.2-41.1-25.7-66.5L273.4 160H240l-57.6 43.2-3.8 2.9-28.8-38.4 3.8-2.9 64-48L224 112zm97.4 55.8L287.1 270.5c-1.2 3.6 .3 7.6 3.7 9.5l19 10.7 38.5-115.6-27-7.4zM218.5 317.1c7.7 13.3 18.9 24.7 33 32.6l4.9 2.8-18 47.9L232.6 416H216 120 96V368h24 79.4l19.1-50.9zM16 95.8H144h16v32H144 16 0v-32H16zm-16 64H16 80 96v32H80 16 0v-32zm16 64H144h16v32H144 16 0v-32H16z'
      
    ]
  };

  

  
  

  var faTurnLeftDown = {
    prefix: 'fasr',
    iconName: 'turn-left-down',
    icon: [
      384,
      512,
      [],
      'e637',
      
      'M264 192l0-48 48 0 24 0 48 0 0-48 0-48 0-48L336 0 168 0 120 0l0 48 0 208 0 48-40 0-8 0-40 0 0 48L158.1 478.1 192 512l33.9-33.9L352 352l0-48-40 0-8 0-40 0 0-48 0-64zm20.1 160L192 444.1 99.9 352l20.1 0 48 0 0-48 0-256 168 0 0 48-72 0-48 0 0 48 0 160 0 48 48 0 20.1 0z'
      
    ]
  };

  

  
  

  var faWaveTriangle = {
    prefix: 'fasr',
    iconName: 'wave-triangle',
    icon: [
      640,
      512,
      [],
      'f89a',
      
      'M176.1 15.1L195.5 42 464.1 415.1 596.6 233.8l38.8 28.3-152 208-19.5 26.7L444.5 470 175.9 96.9 43.4 278.2 4.6 249.8l152-208 19.5-26.7z'
      
    ]
  };

  

  
  

  var faImagePolaroid = {
    prefix: 'fasr',
    iconName: 'image-polaroid',
    icon: [
      448,
      512,
      [],
      'f8c4',
      
      'M400 368H48v64H400V368zM75.3 320l57.3-78.2L152 215.4l19.4 26.4L188 264.4l56-85.6L264 148.1l20.1 30.7L376.4 320H400V80H48V320H75.3zM448 320v24 24 64 48H400 48 0V432 368 344 320 80 32H48 400h48V80 320zM80 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faIndustry = {
    prefix: 'fasr',
    iconName: 'industry',
    icon: [
      576,
      512,
      [],
      'f275',
      
      'M192 123.3V80 32H144 80 32V80 432v48H80 496h48V432 148.7 96l-48 21.8-80 36.4L368 176V148.7 123.3 96l-48 21.8-80 36.4L192 176V123.3zm128 47.3V176v74.5l67.9-30.8L496 170.5V432H80V80h64v96 74.5l67.9-30.8L320 170.5z'
      
    ]
  };

  

  
  

  var faBoreHole = {
    prefix: 'fasr',
    iconName: 'bore-hole',
    icon: [
      512,
      512,
      [],
      'e4c3',
      
      'M280 24V228.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V24 0h48V24zM240 288a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM464 176H400V288c0 79.5-64.5 144-144 144s-144-64.5-144-144V176H48V464H464V176zM112 128h48v48V288c0 53 43 96 96 96s96-43 96-96V176 128h48 64 48v48V464v48H464 48 0V464 176 128H48h64z'
      
    ]
  };

  

  
  

  var faArrowsRepeat = {
    prefix: 'fasr',
    iconName: 'arrows-repeat',
    icon: [
      512,
      512,
      ["repeat-alt"],
      'f364',
      
      'M0 256v24H48V256 152H366.1l-47 47-17 17L336 249.9l17-17 88-88 17-17-17-17L353 23l-17-17L302.1 40l17 17 47 47H24 0v24V256zm504 0V232H456v24V360H145.9l47-47 17-17L176 262.1l-17 17L71 367l-17 17 17 17 88 88 17 17L209.9 472l-17-17-47-47H480h24V384 256z'
      
    ]
  };

  
    var faRepeatAlt = faArrowsRepeat;
  

  
  

  var faHorseHead = {
    prefix: 'fasr',
    iconName: 'horse-head',
    icon: [
      640,
      512,
      [],
      'f7ab',
      
      'M455.3 26.2L449.2 1.7 425.1 9 263 58C144.8 93.7 64 202.6 64 326V488v24H88 416h42l-21.3-36.2-59-100.3 28.3 32.3 7.2 8.2H424h80 12l7.2-9.6 48-64 7.5-10.1-4-11.9-56-168L515 141l-11.4-3.8L453 120.4l5.8-2.9 17.2-8.6-4.7-18.7-16-64zM220.1 330.4c25.4 30.4 63 44.8 99.8 41.6L374 464H112V326c0-102.3 67-192.5 164.9-222.1l138-41.7L420 83.1 389.3 98.5 376 105.2V120v8 17.3l16.4 5.5L477 179l48.2 144.7L492 368H434.9l-48.8-55.8-14.9-17-17.9 13.9-1.2 .9c-29.3 22.8-71.3 18.2-95.1-10.3l-22.6-27.1-15.4-18.4-36.9 30.7 15.4 18.4 22.6 27.1zM360 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCircleDollar = {
    prefix: 'fasr',
    iconName: 'circle-dollar',
    icon: [
      512,
      512,
      ["dollar-circle","usd-circle"],
      'f2e8',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM276.2 149.4c18.3 2.6 36.2 7 54.1 11.5l-10.5 41.9c-16.3-4.1-32.5-8.1-49.1-10.6c-16.4-2.4-30.1-.5-39.3 3.5c-11 4.7-18 16.2-6.3 23.7c8.5 5.4 21.5 9.2 39.4 14.3l.8 .2c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2V400H233V361.1c-11.7-2.6-26.7-7.4-36.6-10.6l0 0c-6.6-2.1-13.1-4.2-19.7-6.2c-2.3-.7-4.5-1.4-6.8-2.1l12.9-41.2c2.2 .7 4.4 1.4 6.6 2.1c7.3 2.3 14.6 4.6 21.9 6.9l0 0c12.1 3.9 26.4 8.4 34.5 9.7c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c3.9-21.5 19.9-35.8 37.8-43.5c5.8-2.5 12.1-4.4 18.6-5.7V112h43.2v37.4z'
      
    ]
  };

  
    var faDollarCircle = faCircleDollar;
  
    var faUsdCircle = faCircleDollar;
  

  
  

  var faFaceLaughWink = {
    prefix: 'fasr',
    iconName: 'face-laugh-wink',
    icon: [
      512,
      512,
      ["laugh-wink"],
      'f59c',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM258.2 408c-69.2 0-126.1-52.6-132.8-120H391c-6.7 67.4-63.6 120-132.8 120zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm151.3 26.3l-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0z'
      
    ]
  };

  
    var faLaughWink = faFaceLaughWink;
  

  
  

  var faSignalFair = {
    prefix: 'fasr',
    iconName: 'signal-fair',
    icon: [
      640,
      512,
      ["signal-2"],
      'f68d',
      
      'M216 288v24V488v24H168V488 312 288h48zM88 384v24 80 24H40V488 408 384H88z'
      
    ]
  };

  
    var faSignal2 = faSignalFair;
  

  
  

  var faHouseTree = {
    prefix: 'fasr',
    iconName: 'house-tree',
    icon: [
      640,
      512,
      [],
      'e1b3',
      
      'M575.2 208h.8V160L416 0 277 125.1l37.3 31 100-90L508.1 160H448v47.1l27.6 32.1L544.8 320H544 480v51.9l30.1 30.1L572.1 464H416v48H592h48V464l-48-48-48-48h16 48v-3.9V320l-54.9-64L512 208h16 47.2zM48 278.5l144-120 144 120V464H48V278.5zM0 256V464v48H48 336h48V464 256L192 96 0 256zm240 16H144v96h96V272z'
      
    ]
  };

  

  
  

  var faHockeyStickPuck = {
    prefix: 'fasr',
    iconName: 'hockey-stick-puck',
    icon: [
      640,
      512,
      [],
      'e3ae',
      
      'M307.9 320L466.7 13 509.3 35l-240 464-6.7 13H248 24 0V488 344 320H24 304h3.9zM283 368H144v96h89.4L283 368zM48 368v96H96V368H48zm384 64v32H592V432H432zm-48-48h48H592h48v48 32 48H592 432 384V464 432 384z'
      
    ]
  };

  

  
  

  var faLaptopArrowDown = {
    prefix: 'fasr',
    iconName: 'laptop-arrow-down',
    icon: [
      640,
      512,
      [],
      'e1c6',
      
      'M256 32H112 64V80 320h48V80H256V32zM384 80H528V320h48V80 32H528 384V80zM344 32H296V56 238.1l-39-39-17-17L206.1 216l17 17 80 80 17 17 17-17 80-80 17-17L400 182.1l-17 17-39 39V56 32zM83.9 432l-32-32H588.1l-32 32H83.9zM576 480l64-64V400 352H592 48 0v48 16l64 64H576z'
      
    ]
  };

  

  
  

  var faBracketsSquare = {
    prefix: 'fasr',
    iconName: 'brackets-square',
    icon: [
      448,
      512,
      ["brackets"],
      'f7e9',
      
      'M24 32H0V56 456v24H24h96 24V432H120 48V80h72 24V32H120 24zm400 0H328 304V80h24 72V432H328 304v48h24 96 24V456 56 32H424z'
      
    ]
  };

  
    var faBrackets = faBracketsSquare;
  

  
  

  var faFaceSmileHearts = {
    prefix: 'fasr',
    iconName: 'face-smile-hearts',
    icon: [
      640,
      512,
      [],
      'e390',
      
      'M519.2 376c-10.1-.1-20.2 3.7-27.8 11.4c-7.6 7.7-11.4 17.8-11.4 27.9c0 .1 0 .2 0 .3c0 10.5 4.2 20.6 11.6 28L560 512l68.4-68.4c7.4-7.4 11.6-17.5 11.6-28c0-21.9-17.7-39.6-39.6-39.6c-10.5 0-20.6 4.2-28 11.6L560 400l-12.4-12.4c-7.4-7.4-17.5-11.6-28-11.6c-.1 0-.3 0-.4 0zm37.1-21.3C569 324.3 576 291 576 256c0-24.5-3.4-48.2-9.9-70.6l-6.6-23.1-46.1 13.2 6.6 23.1c5.2 18.2 8 37.4 8 57.4c0 31.8-7.1 61.9-19.9 88.8c16.4-2.5 33.6 .8 48.1 9.9zM448.2 419.8C412.8 447.5 368.3 464 320 464c-50.4 0-96.6-17.9-132.6-47.7c-3.4 9.1-8.8 17.7-16.1 25l-13.1 13.1C202.4 490.4 258.7 512 320 512c55.2 0 106.4-17.5 148.2-47.2c-12.3-12.6-19-28.6-20-44.9zM122.1 320.1C115.5 299.9 112 278.4 112 256c0-114.9 93.1-208 208-208c30.7 0 59.9 6.7 86.1 18.6l21.8 9.9 19.9-43.7-21.8-9.9C393.6 8.2 357.7 0 320 0C178.6 0 64 114.6 64 256c0 25.7 3.8 50.5 10.8 73.8c1.8 1.1 3.5 2.2 5.2 3.4c12.5-9 27.3-13.4 42-13.2zM320 400c61.9 0 112-36.8 132-66.7L412 306.7C400 324.8 364.1 352 320 352s-80-27.2-92-45.3L188 333.3c19.9 29.9 70 66.7 132 66.7zM199.7 234.3c20-27.1 59.8-27.1 79.8 0l32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8zm239.8 0l32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8c20-27.1 59.8-27.1 79.8 0zM80 376L67.6 363.6c-7.4-7.4-17.5-11.6-28-11.6C17.7 352 0 369.7 0 391.6c0 10.5 4.2 20.6 11.6 28L80 488l68.4-68.4c7.4-7.4 11.6-17.5 11.6-28c0-21.9-17.7-39.6-39.6-39.6c-10.5 0-20.6 4.2-28 11.6L80 376zM547.6 11.6C540.2 4.2 530.1 0 519.6 0C497.7 0 480 17.7 480 39.6c0 10.5 4.2 20.6 11.6 28L560 136l68.4-68.4c7.4-7.4 11.6-17.5 11.6-28C640 17.7 622.3 0 600.4 0c-10.5 0-20.6 4.2-28 11.6L560 24 547.6 11.6z'
      
    ]
  };

  

  
  

  var faSquare8 = {
    prefix: 'fasr',
    iconName: 'square-8',
    icon: [
      448,
      512,
      [],
      'e25d',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zm184 96H216c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0H216s0 0 0 0zm0 48c0 0 0 0 0 0h16c0 0 0 0 0 0h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-17.7 0-32-14.3-32-32s14.3-32 32-32h8z'
      
    ]
  };

  

  
  

  var faSquareArrowLeft = {
    prefix: 'fasr',
    iconName: 'square-arrow-left',
    icon: [
      448,
      512,
      ["arrow-square-left"],
      'f33a',
      
      'M48 432l352 0 0-352L48 80l0 352zM0 480l0-48L0 80 0 32l48 0 352 0 48 0 0 48 0 352 0 48-48 0L48 480 0 480zM103 239l88-88 17-17L241.9 168l-17 17-47 47L328 232l24 0 0 48-24 0-150.1 0 47 47 17 17L208 377.9l-17-17-88-88-17-17 17-17z'
      
    ]
  };

  
    var faArrowSquareLeft = faSquareArrowLeft;
  

  
  

  var faGuitar = {
    prefix: 'fasr',
    iconName: 'guitar',
    icon: [
      512,
      512,
      [],
      'f7a6',
      
      'M363.3 114.7L376 64 448 0l64 64-64 72-50.7 12.7-43.8 43.8c38.2 50.8 41.4 115.2 4.6 152c-12 12-26.8 19.7-43.2 23.4c-18.1 4.1-33.5 20.8-34.5 39.4c-1.4 27.9-11.7 53.8-31.2 73.4C200.3 529.4 112 520.3 51.8 460.2S-17.4 311.7 31.4 262.8C51 243.2 76.9 233 104.8 231.5c18.5-.9 35.3-16.4 39.4-34.5c3.7-16.4 11.4-31.2 23.4-43.2c36.8-36.8 101.2-33.6 152 4.6l43.8-43.8zm-78.1 78.1c-36-24.5-70.6-18.1-83.8-5c-5 5-8.6 11.5-10.5 19.8c-8.3 37-41.6 69.7-83.8 71.9c-17.6 .9-31.7 7.1-41.9 17.3c-23.9 23.9-27.9 81.2 20.4 129.5s105.6 44.3 129.5 20.4c10.1-10.1 16.4-24.3 17.3-41.9c2.1-42.2 34.9-75.4 71.9-83.8c8.3-1.9 14.8-5.5 19.8-10.5c13.2-13.2 19.6-47.8-5-83.8l-64.8 64.8c1.1 4 1.6 8.1 1.6 12.4c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.3 0 8.5 .6 12.4 1.6l64.8-64.8z'
      
    ]
  };

  

  
  

  var faScreenUsers = {
    prefix: 'fasr',
    iconName: 'screen-users',
    icon: [
      640,
      512,
      ["users-class"],
      'f63d',
      
      'M80 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0A64 64 0 1 0 32 320a64 64 0 1 0 128 0zm32 192l-32-96H32L0 512H192zM304 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm32 192l-32-96H256l-32 96H416zM544 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm64 32H480l-32 96H640l-32-96zM560 48H80V225.3c-18.3 3.1-34.8 11.3-48 23.1V48 0H80 560h48V48 248.4c-13.2-11.8-29.7-20.1-48-23.1V48z'
      
    ]
  };

  
    var faUsersClass = faScreenUsers;
  

  
  

  var faTrashCanSlash = {
    prefix: 'fasr',
    iconName: 'trash-can-slash',
    icon: [
      640,
      512,
      ["trash-alt-slash"],
      'e2ad',
      
      'M512 374.7V128h32V80H512 464 450.2L404 10.7 396.8 0H384 256 243.2L236 10.7 189.8 80H176 132.4l-84-65.2L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L512 374.7zm-48-37.3l-48-37.3V192 176H384v16 83.4l-48-37.3V192 176H304v16 21.2L194.2 128H464V337.5zm0 124.1V464H176V234.7l-48-37.8V464v48h48H464h48V499.4l-48-37.8zM304 335.5V400v16h32V400 360.7l-32-25.2zm-80-63V400v16h32V400 297.7l-32-25.2zM247.5 80l21.3-32H371.2l21.3 32h-145z'
      
    ]
  };

  
    var faTrashAltSlash = faTrashCanSlash;
  

  
  

  var faSun = {
    prefix: 'fasr',
    iconName: 'sun',
    icon: [
      512,
      512,
      [9728],
      'f185',
      
      'M193.1 23.2L256 57.1l62.9-33.9L362 0l14.1 46.9 20.5 68.4 68.4 20.5L512 150l-23.2 43.1L454.9 256l33.9 62.9L512 362l-46.9 14.1-68.4 20.5-20.5 68.4L362 512l-43.1-23.2L256 454.9l-62.9 33.9L150 512l-14.1-46.9-20.5-68.4L46.9 376.1 0 362l23.2-43.1L57.1 256 23.2 193.1 0 150l46.9-14.1 68.4-20.5 20.5-68.4L150 0l43.1 23.2zm85.7 76.1L256 111.6 233.2 99.4 179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2L111.6 256 99.4 278.8 70.2 333l59 17.7 24.8 7.4 7.4 24.8 17.7 59 54.2-29.2L256 400.4l22.8 12.3L333 441.8l17.7-59 7.4-24.8 24.8-7.4 59-17.7-29.2-54.2L400.4 256l12.3-22.8L441.8 179l-59-17.7-24.8-7.4-7.4-24.8L333 70.2 278.8 99.4zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm64 112a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faObjectsAlignCenterHorizontal = {
    prefix: 'fasr',
    iconName: 'objects-align-center-horizontal',
    icon: [
      512,
      512,
      [],
      'e3bc',
      
      'M432 176L80 176l0-64 352 0 0 64zm48-64l0-48-48 0L280 64l0-64L232 0l0 64L80 64 32 64l0 48 0 64 0 48 48 0 152 0 0 64-88 0-48 0 0 48 0 64 0 48 48 0 88 0 0 64 48 0 0-64 88 0 48 0 0-48 0-64 0-48-48 0-88 0 0-64 152 0 48 0 0-48 0-64zM368 400l-224 0 0-64 224 0 0 64z'
      
    ]
  };

  

  
  

  var faChampagneGlass = {
    prefix: 'fasr',
    iconName: 'champagne-glass',
    icon: [
      320,
      512,
      ["glass-champagne"],
      'f79e',
      
      'M88.4 176H231.6l5.4 39.8c6.4 46.7-29.9 88.2-77 88.2s-83.3-41.5-77-88.2L88.4 176zM95 128l10.9-80H214.1L225 128H95zM64 0L35.5 209.3C26.3 276.6 72 337.4 136 349.7V464H72 48v48H72h88 88 24V464H248 184V349.7c64-12.3 109.7-73.1 100.5-140.4L256 0H64z'
      
    ]
  };

  
    var faGlassChampagne = faChampagneGlass;
  

  
  

  var faTrashUndo = {
    prefix: 'fasr',
    iconName: 'trash-undo',
    icon: [
      448,
      512,
      ["trash-arrow-turn-left"],
      'f895',
      
      'M160 0H147.2L140 10.7 93.8 80H80.1 32 0v48H35.6L64 512H384l28.4-384H448V80H416 367.9 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM108.6 464L83.7 128H364.3L339.4 464H108.6zM244.2 209.7l-26.6-29.9-14.9 13.3-72 64L113.9 272l16.8 14.9 72 64 14.9 13.3 26.6-29.9L229.3 321 196.6 292H240c24.3 0 44 19.7 44 44v24 20h40V360 336c0-46.4-37.6-84-84-84H196.6l32.7-29.1 14.9-13.3z'
      
    ]
  };

  
    var faTrashArrowTurnLeft = faTrashUndo;
  

  
  

  var faRubleSign = {
    prefix: 'fasr',
    iconName: 'ruble-sign',
    icon: [
      384,
      512,
      [8381,"rouble","rub","ruble"],
      'f158',
      
      'M88 32H64V56 272H0v48H64v48H0v48H64v40 24h48V456 416H320V368H112V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H88zM240 272H112V80H240c53 0 96 43 96 96s-43 96-96 96z'
      
    ]
  };

  
    var faRouble = faRubleSign;
  
    var faRub = faRubleSign;
  
    var faRuble = faRubleSign;
  

  
  

  var faNotes = {
    prefix: 'fasr',
    iconName: 'notes',
    icon: [
      512,
      512,
      [],
      'e202',
      
      'M144 416H96V368 80 32h48H432h48V80 320l-96 96H144zM432 288V80H144V368H352V288h80zM320 464v48H296 24 0V488 152 128l48 0v24l0 312H296h24z'
      
    ]
  };

  

  
  

  var faGearCode = {
    prefix: 'fasr',
    iconName: 'gear-code',
    icon: [
      512,
      512,
      [],
      'e5e8',
      
      'M328 0l14.6 66.8c11.9 5.5 23.3 12 33.8 19.6l65.2-20.8 72 124.7-50.6 46.1c.6 6.4 .9 12.9 .9 19.5s-.3 13.1-.9 19.5l50.6 46.1-72 124.7-65.2-20.8c-10.6 7.5-21.9 14.1-33.8 19.6L328 512H184l-14.6-66.8c-11.9-5.5-23.3-12-33.8-19.6L70.3 446.4l-72-124.7 50.6-46.1c-.6-6.4-.9-12.9-.9-19.5s.3-13.1 .9-19.5L-1.7 190.4l72-124.7 65.2 20.8c10.6-7.5 21.9-14.1 33.8-19.6L184 0H328zm63 132.2l-22.9 7.3-19.5-13.9c-8.2-5.8-16.9-10.9-26-15.1l-21.8-10-5.1-23.4L289.4 48H222.6l-6.4 29.1-5.1 23.4-21.8 10c-9.2 4.2-17.9 9.3-26 15.1l-19.5 13.9L121 132.2l-28.4-9L59.2 180.9l22 20.1 17.7 16.1-2.2 23.8c-.5 5-.7 10-.7 15.1s.2 10.1 .7 15.1l2.2 23.8L81.2 311l-22 20.1 33.4 57.8 28.4-9 22.9-7.3 19.5 13.9c8.2 5.8 16.9 10.9 26 15.1l21.8 10 5.1 23.4 6.4 29.1h66.7l6.4-29.1 5.1-23.4 21.8-10c9.2-4.2 17.9-9.3 26-15.1l19.5-13.9 22.9 7.3 28.4 9 33.4-57.8L430.8 311l-17.7-16.1 2.2-23.8c.5-5 .7-10 .7-15.1s-.2-10.1-.7-15.1l-2.2-23.8L430.8 201l22.1-20.1-33.4-57.8-28.4 9zm-99.3 31.1l-32 192L256.4 375 217 368.4l3.3-19.7 32-192 3.3-19.7 39.5 6.6-3.3 19.7zm-93.6 66.9L172.3 256l25.9 25.9L212.3 296 184 324.3l-14.1-14.1-40-40L115.7 256l14.1-14.1 40-40L184 187.7 212.3 216l-14.1 14.1zm144-28.3l40 40L396.3 256l-14.1 14.1-40 40L328 324.3 299.7 296l14.1-14.1L339.7 256l-25.9-25.9L299.7 216 328 187.7l14.1 14.1z'
      
    ]
  };

  

  
  

  var faYenSign = {
    prefix: 'fasr',
    iconName: 'yen-sign',
    icon: [
      320,
      512,
      [165,"cny","jpy","rmb","yen"],
      'f157',
      
      'M2.2 32L113.7 224H40 16v48H40h96v48H40 16v48H40h96v88 24h48V456 368h96 24V320H280 184V272h96 24V224H280 206.3L317.8 32H262.3L160 208.2 57.7 32H2.2z'
      
    ]
  };

  
    var faCny = faYenSign;
  
    var faJpy = faYenSign;
  
    var faRmb = faYenSign;
  
    var faYen = faYenSign;
  

  
  

  var faPlaneCircleXmark = {
    prefix: 'fasr',
    iconName: 'plane-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e557',
      
      'M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106l0 51.5 87.6 50C407 215 391.8 225 378.4 237l-78.3-44.8L288 185.4l0-13.9 0-65.5c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8 .2-6.7 3.3c-3.9 3.1-8.2 8.1-12.3 14.9c-8.5 14-13 30.2-13 39.7l0 65.5 0 13.9-12.1 6.9L48 285.9l0 34.3 145.4-41.5 30.6-8.7 0 31.8 0 66.3 0 12-9.6 7.2L160 428l0 32.4 88.9-27.4 7.1-2.2 7.1 2.2 81.8 25.2c12.7 21.2 29.8 39.6 49.9 53.8L384 512l-24 0-3.6 0-3.4-1.1L256 481.1l-96.9 29.8-3.4 1.1-3.6 0-16 0-24 0 0-24 0-72 0-12 9.6-7.2L176 356l0-22.5L30.6 375.1 0 383.8 0 352l0-80 0-13.9 12.1-6.9L176 157.5l0-51.5c0-20.3 8.1-45.1 20-64.6c6.1-10 13.8-19.9 23.3-27.5zm99.3 264.8l22.2 6.3c-13.3 24.7-20.8 53-20.8 83c0 13.5 1.5 26.7 4.4 39.3l-26.8-20.1L288 380l0-12 0-66.3 0-31.8 30.6 8.7zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faToilet = {
    prefix: 'fasr',
    iconName: 'toilet',
    icon: [
      448,
      512,
      [128701],
      'f7d8',
      
      'M0 0V48H24 424h24V0H424 24 0zM81.6 182.9l-1.6 .5V80H32V207.1l-.4 .4C17.5 219.4 8 235.7 8 256c0 72.7 33.4 120.2 78.4 148.3c.9 .5 1.7 1.1 2.6 1.6L75.3 464 64 512h49.3H334.7 384l-11.3-48L359 405.9c.9-.5 1.7-1 2.6-1.6c45-28.1 78.4-75.6 78.4-148.3c0-20.3-9.5-36.6-23.6-48.5l-.4-.4V80H368V183.4l-1.6-.5C328.4 172 277.7 168 224 168s-104.4 4-142.4 14.9zm51.9 243.2C164.8 436.4 196.9 440 224 440s59.2-3.6 90.5-13.9l8.9 37.9H124.6l8.9-37.9zm-21.7-62.5c-14.7-9.2-27.8-21.2-37.6-36.9c2.4 .8 4.9 1.5 7.4 2.3C119.6 340 170.3 344 224 344s104.4-4 142.4-14.9c2.5-.7 4.9-1.5 7.4-2.3c-9.8 15.7-22.9 27.6-37.6 36.9C303 384.4 259.9 392 224 392s-79-7.6-112.2-28.3zM385.4 268c-6.1 5.1-16.5 10.4-32.2 15C321.7 292 276.4 296 224 296s-97.7-4-129.1-13.1c-15.8-4.5-26.2-9.8-32.3-15c-5.4-4.6-6.6-8.2-6.6-12s1.2-7.4 6.6-12c6.1-5.1 16.5-10.4 32.3-15C126.3 220 171.6 216 224 216s97.7 4 129.1 13.1c15.8 4.5 26.2 9.8 32.2 15c5.4 4.6 6.6 8.2 6.6 12s-1.2 7.4-6.6 12zM128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z'
      
    ]
  };

  

  
  

  var faMars = {
    prefix: 'fasr',
    iconName: 'mars',
    icon: [
      448,
      512,
      [9794],
      'f222',
      
      'M312 32H288V80h24 54.1l-83.7 83.7C252.8 141.3 215.9 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-39.9-13.3-76.8-35.7-106.3L400 113.9V168v24h48V168 56 32H424 312zM48 304a128 128 0 1 1 256 0A128 128 0 1 1 48 304z'
      
    ]
  };

  

  
  

  var faVault = {
    prefix: 'fasr',
    iconName: 'vault',
    icon: [
      576,
      512,
      [],
      'e2c5',
      
      'M48 48V432H528V48H48zM0 0H48 528h48V48 432v48H528 512v8 24H464V488v-8H112v8 24H64V488v-8H48 0V432 48 0zM320 240a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM80 240a144 144 0 1 1 288 0A144 144 0 1 1 80 240zm144-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272-16c0 17.8-9.7 33.3-24 41.6V328v24H424V328 217.6c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftUp = {
    prefix: 'fasr',
    iconName: 'arrow-turn-left-up',
    icon: [
      384,
      512,
      [],
      'e634',
      
      'M329 138.2l17 17L312 189.1l-17-17-79-79L216 464l144 0 24 0 0 48-24 0-168 0-24 0 0-24 0-394.9-79 79-17 17L38.1 155.2l17-17 113-113 0-1.3 1.3 0 5.8-5.8 17-17 17 17 5.8 5.8 1.3 0 0 1.3 113 113z'
      
    ]
  };

  

  
  

  var faPersonSimple = {
    prefix: 'fasr',
    iconName: 'person-simple',
    icon: [
      256,
      512,
      [],
      'e220',
      
      'M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM74 304h38 32 38l-4-96H78l-4 96zM64 352H24l2-48 6-144H224l6 144 2 48H192V488v24H144V488 352H112V488v24H64V488 352z'
      
    ]
  };

  

  
  

  var faOilWell = {
    prefix: 'fasr',
    iconName: 'oil-well',
    icon: [
      576,
      512,
      [],
      'e532',
      
      'M482 73.7c-4.6-17.1-22.1-27.2-39.2-22.6l58 216.4c17.1-4.6 27.2-22.1 22.6-39.2L482 73.7zm-51.6-69c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-46.4 12.4-12.4-46.4-23.1-86.3L96 280.5V464h44.1L198 294.3l55.6-14.4L229.1 352h85.9l-27.6-80.8 46.6-12.1 70 204.9H552h24v48H552 24 0V464H24 48V184 160H96v24 46.9l135.7-35.2 17.6-51.5 5.5-16.2h34.3l5.5 16.2 11 32.3 113.1-29.3L396.4 63.5 384 17.1 430.4 4.7zM353.2 464l-21.9-64H212.7l-21.9 64H353.2z'
      
    ]
  };

  

  
  

  var faGlassWater = {
    prefix: 'fasr',
    iconName: 'glass-water',
    icon: [
      384,
      512,
      [],
      'e4f4',
      
      'M63.2 192.2c32.5 16.2 71.7 12.2 100.3-10.7c16.7-13.3 40.4-13.3 57 0c28.6 22.9 67.8 26.9 100.3 10.7L299.6 464H84.4L63.2 192.2zm-4.5-57.3L51.9 48H332.1l-6.8 86.9-24.1 13.4c-16.2 9-36.2 7.3-50.7-4.3c-34.2-27.4-82.8-27.4-117 0C119 155.6 99 157.3 82.8 148.3L58.7 134.9zM40 512H344L380.2 48 384 0H335.9 48.1 0L3.8 48 40 512z'
      
    ]
  };

  

  
  

  var faTrashCanCheck = {
    prefix: 'fasr',
    iconName: 'trash-can-check',
    icon: [
      448,
      512,
      [],
      'e2a9',
      
      'M160 0H147.2L140 10.7 93.8 80H80 32 0v48H32V464v48H80 368h48V464 128h32V80H416 368 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM80 464V128H368V464H80zM337 241l17-17L320 190.1l-17 17-111 111-47-47-17-17L94.1 288l17 17 64 64 17 17 17-17L337 241z'
      
    ]
  };

  

  
  

  var faBolt = {
    prefix: 'fasr',
    iconName: 'bolt',
    icon: [
      448,
      512,
      [9889,"zap"],
      'f0e7',
      
      'M311.6 161.7l22-87.8L352 0 291.1 45.7 32 240v48l68.2 9.1 47.9 6.4-11.7 46.9-22 87.8L96 512l60.9-45.7L416 272V224l-68.2-9.1-47.9-6.4 11.7-46.9zm36 101.7L175.4 392.5l19.3-77.4 13-52.1-53.3-7.1-54.1-7.2L272.6 119.5l-19.3 77.4-13 52.1 53.3 7.1 54.1 7.2z'
      
    ]
  };

  
    var faZap = faBolt;
  

  
  

  var faMessageSlash = {
    prefix: 'fasr',
    iconName: 'message-slash',
    icon: [
      640,
      512,
      ["comment-alt-slash"],
      'f4a9',
      
      'M272 480l-48 32V464v-9.7V416H176 112 64V368 146.4l48 37.8V368H224h48v48 6.3l69.4-46.2L349 371l57.1 45H368l-96 64zM112 64.2L503.3 368H528V48H112V64.2zM64 26.9V0h48H528h48V48 368v48H565.2l55.8 43.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L64 26.9z'
      
    ]
  };

  
    var faCommentAltSlash = faMessageSlash;
  

  
  

  var faShieldCat = {
    prefix: 'fasr',
    iconName: 'shield-cat',
    icon: [
      512,
      512,
      [],
      'e572',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM224 208l-64-64V272c0 53 43 96 96 96s96-43 96-96V144l-64 64H224zm-8 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faCaravan = {
    prefix: 'fasr',
    iconName: 'caravan',
    icon: [
      640,
      512,
      [],
      'f8ff',
      
      'M416 80c61.9 0 112 50.1 112 112V368H480V176 128H432 368 320v48V368H275.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H48V80H416zM48 416H96c0 53 43 96 96 96s96-43 96-96h32 48 64 48 48 48l40 0h24V368H616l-40 0V192c0-88.4-71.6-160-160-160H48 0V80 368v48H48zM432 224H416 392v48h24 16v96H368V176h64v48zM288 128H96V256H288V128zM192 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faArrowUpArrowDown = {
    prefix: 'fasr',
    iconName: 'arrow-up-arrow-down',
    icon: [
      576,
      512,
      ["sort-up-down"],
      'e099',
      
      'M433 461.8l-17 17-17-17-96-96-17-17L320 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96zM177 50.2l96 96 17 17L256 197.1l-17-17-55-55V456v24H136V456 125.1l-55 55-17 17L30.1 163.2l17-17 96-96 17-17 17 17z'
      
    ]
  };

  
    var faSortUpDown = faArrowUpArrowDown;
  

  
  

  var faHandWave = {
    prefix: 'fasr',
    iconName: 'hand-wave',
    icon: [
      544,
      512,
      [],
      'e1a7',
      
      'M348.2 0H336 320V32h16 12.2c15.9 0 30.4 9 37.5 23.2l28.6-14.3C401.8 15.8 376.2 0 348.2 0zm-191 23.4l-17 17L83.7 97l-17 17 17 17 5.7 5.7L49.8 176.2l-17 17 17 17 28.3 28.3L38.5 278l-17 17 17 17L180.2 453.7C217.6 491 268.2 512 321 512l7 0 2.5 0 0 0C439.8 510.6 528 421.6 528 312v-5.9l0-.5 0-157.7v-40l0-24-24 0-80 0-24 0v24 40V153L269.4 22.5l-17-17-17 17L195.9 62.1 174.2 40.4l-17-17zM479.3 326.6C472 403.7 407 464 328 464c-2 0-4 0-5.9-.1l-10-.4-.2 .2c-36.7-2.2-71.5-17.8-97.7-44L89.4 295 112 272.3l5.7 5.7 56.6 56.6 17 17 33.9-33.9-17-17L151.6 244l-17-17 0 0-5.7-5.7-28.3-28.3 22.6-22.6 11.3 11.3L230.8 278l17 17L281.7 261l-17-17-96.2-96.2-17-17-11.3-11.3-5.7-5.7 22.6-22.6L178.9 113l17 17 0 0 91.5 91.5 17 17 33.9-33.9-17-17L229.8 96l22.6-22.6L403.1 224H448V211l0-63.1 0-16 32 0v16l0 157.7c0 1.8 0 3.7-.1 5.5l-.6 15.5zM63.8 397.7l-2.3-15.8-31.7 4.5 2.3 15.8 1.2 8.5c5 35.2 32.7 62.9 67.9 67.9l8.5 1.2 15.8 2.3 4.5-31.7-15.8-2.3-8.5-1.2c-21.1-3-37.7-19.6-40.7-40.7l-1.2-8.5z'
      
    ]
  };

  

  
  

  var faFolderGear = {
    prefix: 'fasr',
    iconName: 'folder-gear',
    icon: [
      512,
      512,
      ["folder-cog"],
      'e187',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm12 32v32.8c9.8 3.5 18.8 8.7 26.6 15.4L339 207.7l28 48.5-28.4 16.4c.9 5 1.4 10.1 1.4 15.4s-.5 10.4-1.4 15.4L367 319.7l-28 48.5-28.4-16.4c-7.8 6.6-16.8 11.9-26.6 15.4V400H228V367.2c-9.8-3.5-18.8-8.7-26.6-15.4L173 368.2l-28-48.5 28.4-16.4c-.9-5-1.4-10.1-1.4-15.4s.5-10.4 1.4-15.4L145 256.2l28-48.5 28.4 16.4c7.8-6.6 16.8-11.9 26.6-15.4V176h56zm7 112a35 35 0 1 0 -70 0 35 35 0 1 0 70 0z'
      
    ]
  };

  
    var faFolderCog = faFolderGear;
  

  
  

  var faFolderMedical = {
    prefix: 'fasr',
    iconName: 'folder-medical',
    icon: [
      512,
      512,
      [],
      'e18c',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm-48 48h64v64h64v64H288v64H224V320H160V256h64V192z'
      
    ]
  };

  

  
  

  var faCameraWebSlash = {
    prefix: 'fasr',
    iconName: 'camera-web-slash',
    icon: [
      640,
      512,
      ["webcam-slash"],
      'f833',
      
      'M592 512l0 0H524.1 172.8 112l37.3-48 52.3-67.3C142.8 358.1 104 291.6 104 216c0-12.2 1-24.1 2.9-35.7L152 215.8l0 .2c0 92.8 75.2 168 168 168c13.6 0 26.9-1.6 39.6-4.7L406.2 416h-4.4c-25.2 10.3-52.8 16-81.7 16c-26.2 0-51.4-4.7-74.7-13.3L210.1 464H467.1L528 512h64zM144.8 89.6C184 35.3 247.9 0 320 0C439.3 0 536 96.7 536 216c0 52.7-18.8 100.9-50.2 138.4L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 96.4 74.8zM447.9 325c25-29.3 40.1-67.4 40.1-109c0-92.8-75.2-168-168-168c-56.7 0-106.8 28.1-137.3 71.1l38 29.5C242.3 116.8 278.7 96 320 96c66.3 0 120 53.7 120 120c0 30.5-11.4 58.3-30.1 79.5l38 29.5zm-76-59C384.3 253 392 235.4 392 216c0-39.8-32.2-72-72-72c-25.9 0-48.5 13.6-61.2 34.1l113.1 87.8z'
      
    ]
  };

  
    var faWebcamSlash = faCameraWebSlash;
  

  
  

  var faSaxophoneFire = {
    prefix: 'fasr',
    iconName: 'saxophone-fire',
    icon: [
      640,
      512,
      ["sax-hot"],
      'f8db',
      
      'M0 153.6C0 81.9 68.3 21.3 102.4 0l51.2 51.2 25.6-25.6c61.4 51.2 76.8 106.7 76.8 128c0 7.6-.7 15.1-2 22.4H176.4c-10.6-32.3-48.4-60.7-48.4-60.7s-37.8 28.3-48.4 60.7H2c-1.3-7.3-2-14.8-2-22.4zM478.1 64H488h88 9.9l7 7 40 40 7 7V128v32 24H616 539.1L312.2 449.8c-33.7 39.5-83 62.2-134.9 62.2h-5.5C76.9 512 0 435.1 0 340.2c0-9.5 .8-18.9 2.3-28.2l9.3-56H0V208H19.7 24 40 232h16 18.3H272v48H248.8l-20.2 55.4 1 .8L318 224l-16-16L336 174.1l16 16L366 176l-16-16L384 126.1l16 16L414 128l-16-16L432 78.1l16 16 23-23 7-7zM249 360.8l-14.7 14.7-16.6-12.4-32-23.8-14.3-10.7 6.1-16.8L197.7 256H60.3L49.7 319.9c-1.1 6.7-1.7 13.5-1.7 20.3C48 408.6 103.4 464 171.8 464h5.5c37.8 0 73.8-16.6 98.3-45.4L509.7 144.4l7.2-8.4H528h62.1l-24-24H497.9l-16 16 0 0L448 161.9l0 0L433.9 176l0 0L400 209.9l0 0L385.9 224l0 0L352 257.9l0 0L249 360.8zM120 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faSaxHot = faSaxophoneFire;
  

  
  

  var faFileArrowDown = {
    prefix: 'fasr',
    iconName: 'file-arrow-down',
    icon: [
      384,
      512,
      ["file-download"],
      'f56d',
      
      'M48 48H224V160H336V464H48V48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM216 232V208H168v24V334.1l-31-31-17-17L86.1 320l17 17 72 72 17 17 17-17 72-72 17-17L264 286.1l-17 17-31 31V232z'
      
    ]
  };

  
    var faFileDownload = faFileArrowDown;
  

  
  

  var faCompactDisc = {
    prefix: 'fasr',
    iconName: 'compact-disc',
    icon: [
      512,
      512,
      [128191,128192,128440],
      'f51f',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384V96C167.6 96 96 167.6 96 256h32c0-70.7 57.3-128 128-128zm96 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-120 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faToiletPortable = {
    prefix: 'fasr',
    iconName: 'toilet-portable',
    icon: [
      320,
      512,
      [],
      'e583',
      
      'M24 0H0V24 488v24H48V488v-8H272v8 24h48V488 24 0H296 24zM272 432H48V144H272v80H224v96h48V432zM48 96V48H272V96H48z'
      
    ]
  };

  

  
  

  var faBrakeWarning = {
    prefix: 'fasr',
    iconName: 'brake-warning',
    icon: [
      640,
      512,
      [],
      'e0c7',
      
      'M320 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM104.1 88.8l-40.4-26L50.7 83C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173l13 20.2 40.4-26L91.1 403C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147l13-20.2zm472.2-26l-40.4 26 13 20.2c27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147l-13 20.2 40.4 26 13-20.2C621.4 379.1 640 319.7 640 256s-18.6-123.1-50.7-173l-13-20.2zM344 128H296v24V264v24h48V264 152 128zM296 368h48V320H296v48z'
      
    ]
  };

  

  
  

  var faCircleHalf = {
    prefix: 'fasr',
    iconName: 'circle-half',
    icon: [
      512,
      512,
      [],
      'e110',
      
      'M208 53.6V458.4C116.3 436.8 48 354.4 48 256s68.3-180.8 160-202.4zm0-49.1C89.6 27 0 131 0 256S89.6 485 208 507.5c15.5 3 31.6 4.5 48 4.5V464 48 0c-16.4 0-32.5 1.5-48 4.5z'
      
    ]
  };

  

  
  

  var faWindsock = {
    prefix: 'fasr',
    iconName: 'windsock',
    icon: [
      512,
      512,
      [],
      'f777',
      
      'M48 0V24 96h80V48l48 10 336 70V288L176 358l-48 10V320H48V488v24H0V488 296 120 24 0H48zm0 144V272h80V144H48zm128-37V309l64-13.3V120.4L176 107zm112 23.3V285.6L368 269V147l-80-16.7zM416 157V259l48-10V167l-48-10z'
      
    ]
  };

  

  
  

  var faMound = {
    prefix: 'fasr',
    iconName: 'mound',
    icon: [
      576,
      512,
      [],
      'e52d',
      
      'M491.2 368H84.8l99-165c22-36.6 61.5-59 104.2-59s82.3 22.4 104.2 59l99 165zm56 0L433.4 178.3C402.7 127.2 347.6 96 288 96s-114.7 31.2-145.4 82.3L28.8 368 0 416H56 520h56l-28.8-48z'
      
    ]
  };

  

  
  

  var faPeoplePants = {
    prefix: 'fasr',
    iconName: 'people-pants',
    icon: [
      640,
      512,
      [],
      'e219',
      
      'M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H94.8l-6.9 12.4-75.3 136L1 297.4l42 23.3 11.6-21L96 224.9V488v24h48V488 352h32V488v24h48V488 224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136L225.2 128H211.1 108.9zM176 304H144V176h32V304zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H414.8l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21L416 224.9V488v24h48V488 352h32V488v24h48V488 224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136L545.2 128H531.1 428.9zM496 304H464V176h32V304z'
      
    ]
  };

  

  
  

  var faGridRound2Plus = {
    prefix: 'fasr',
    iconName: 'grid-round-2-plus',
    icon: [
      512,
      512,
      [],
      'e5dc',
      
      'M80 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM80 384a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faHurricane = {
    prefix: 'fasr',
    iconName: 'hurricane',
    icon: [
      384,
      512,
      [],
      'f751',
      
      'M216 24.7V-1.5L189.9 .8C83.5 9.9 0 99.2 0 208C0 309.2 72.3 393.5 168 412.2v74.6 26.2l26.1-2.2C300.5 501.5 384 412.2 384 303.4c0-101.2-72.3-185.5-168-204.2V24.7zM48 208C48 133.4 99 70.8 168 53v67 22l21.9 1.9C271.8 151 336 219.7 336 303.4c0 74.5-51 137.2-120 155v-67-22l-21.9-1.9C112.2 360.4 48 291.7 48 208zm128 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faUpload = {
    prefix: 'fasr',
    iconName: 'upload',
    icon: [
      512,
      512,
      [],
      'f093',
      
      'M280 360v24H232V360 97.9l-95 95-17 17L86.1 176l17-17L239 23l17-17 17 17L409 159l17 17L392 209.9l-17-17-95-95V360zm32-8V304H464h48v48V464v48H464 48 0V464 352 304H48 200v48H48V464H464V352H312zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faUpFromLine = {
    prefix: 'fasr',
    iconName: 'up-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-bottom"],
      'f346',
      
      'M224 256l0-48 48 0 28.1 0L192 99.9 83.9 208l28.1 0 48 0 0 48 0 80 64 0 0-80zm1.9-190.1L352 192l0 16 0 48-32 0-16 0-32 0 0 48 0 32 0 48-48 0-64 0-48 0 0-48 0-32 0-48-32 0-16 0-32 0 0-48 0-16L158.1 65.9 192 32l33.9 33.9zM24 432l336 0 24 0 0 48-24 0L24 480 0 480l0-48 24 0z'
      
    ]
  };

  
    var faArrowAltFromBottom = faUpFromLine;
  

  
  

  var faMoneyCheckDollarPen = {
    prefix: 'fasr',
    iconName: 'money-check-dollar-pen',
    icon: [
      640,
      512,
      ["money-check-edit-alt"],
      'f873',
      
      'M48 112H528V220.4L564.4 184l0 0L576 172.4V112 64H528 48 0v48V400v48H48 326.6l4.4-30.6L348.4 400H48V112zM256 272v48h96V272H256zm192-96H256v48H448V176zM180 140H140v20 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5l0 0c7.9 2.7 20.3 7 29.9 9.1V352v20h40V352v-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l0 0 0 0 0 0-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V160 140zm389 83.8l-41.3 41.3 71 71L640 294.8l-71-71zm-63.9 63.9L363.9 429 352 511.9 434.9 500 576.1 358.7l-71-71z'
      
    ]
  };

  
    var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
  

  
  

  var faCodeMerge = {
    prefix: 'fasr',
    iconName: 'code-merge',
    icon: [
      448,
      512,
      [],
      'f387',
      
      'M48 48v64h64V48H48zM0 0H48h64 48V48v64 48H112h-6.8c7.7 49.8 50.8 88 102.8 88h80v-8V192h48 64 48v48 64 48H400 336 288V304v-8H208c-40.2 0-76.8-15.6-104-41.1V352h8 48v48 64 48H112 48 0V464 400 352H48h8V160H48 0V112 48 0zM48 400v64h64V400H48zM400 240H336v64h64V240z'
      
    ]
  };

  

  
  

  var faStop = {
    prefix: 'fasr',
    iconName: 'stop',
    icon: [
      384,
      512,
      [9209],
      'f04d',
      
      'M336 112V400H48V112H336zM48 64H0v48V400v48H48 336h48V400 112 64H336 48z'
      
    ]
  };

  

  
  

  var faUpLong = {
    prefix: 'fasr',
    iconName: 'up-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-up"],
      'f30c',
      
      'M128 160v48l0 256h64l0-256V160h48 12.1L160 67.9 67.9 160H80h48zM126.1 33.9L160 0l33.9 33.9L320 160v48H288 272 240v48l0 208v48H192 128 80V464l0-208 0-48H48 32 0l0-48L126.1 33.9z'
      
    ]
  };

  
    var faLongArrowAltUp = faUpLong;
  

  
  

  var faBlockQuote = {
    prefix: 'fasr',
    iconName: 'block-quote',
    icon: [
      448,
      512,
      [],
      'e0b5',
      
      'M24 72H0v48H24 424h24V72H424 24zM152 232H128v48h24H424h24V232H424 152zM128 392v48h24H424h24V392H424 152 128zM0 424v24H48V424l0-176V224H0v24V424z'
      
    ]
  };

  

  
  

  var faTruckPickup = {
    prefix: 'fasr',
    iconName: 'truck-pickup',
    icon: [
      640,
      512,
      [128763],
      'f63c',
      
      'M248 32H224V56 176H80 32v48 96H24 0v48H24h8H80h1.3c-.9 5.2-1.3 10.5-1.3 16c0 53 43 96 96 96s96-43 96-96c0-5.5-.5-10.8-1.3-16h98.7c-.9 5.2-1.3 10.5-1.3 16c0 53 43 96 96 96s96-43 96-96c0-5.5-.5-10.8-1.3-16H560h48 8 24V320H616h-8V224 176H560 507.7L402.9 41.3 395.7 32H384 248zM560 320H544h-8.4c-17.6-19.6-43.1-32-71.6-32s-54 12.4-71.6 32H384 256h-8.4c-17.6-19.6-43.1-32-71.6-32s-54 12.4-71.6 32H96 80V224H560v96zM446.9 176H272V80H372.3l74.7 96zM128 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faTowerBroadcast = {
    prefix: 'fasr',
    iconName: 'tower-broadcast',
    icon: [
      576,
      512,
      ["broadcast-tower"],
      'f519',
      
      'M528 128c0-38.2-8.9-74.3-24.8-106.3l43-21.3C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-43-21.3c15.9-32 24.8-68.1 24.8-106.3zM48 128c0 38.2 8.9 74.3 24.8 106.3l-43 21.3C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5l43 21.3C56.9 53.7 48 89.8 48 128zm64 0c0-28 6.5-54.5 18.2-77.9l43 21.3C164.8 88.4 160 107.6 160 128s4.8 39.6 13.2 56.7l-43 21.3C118.5 182.5 112 156 112 128zm352 0c0 28-6.5 54.5-18.2 77.9l-43-21.3c8.5-17.1 13.2-36.3 13.2-56.7s-4.8-39.6-13.2-56.7l43-21.3C457.5 73.5 464 100 464 128zm-112 0c0 26.9-16.5 49.9-40 59.3V488v24H264V488 187.3c-23.5-9.5-40-32.5-40-59.3c0-35.3 28.7-64 64-64s64 28.7 64 64z'
      
    ]
  };

  
    var faBroadcastTower = faTowerBroadcast;
  

  
  

  var faLoveseat = {
    prefix: 'fasr',
    iconName: 'loveseat',
    icon: [
      512,
      512,
      ["couch-small"],
      'f4cc',
      
      'M96 80H416V192h48V80 32H416 96 48V80 192H96V80zm0 192V432H48V272H96zM48 224H0v48V432v48H48 96h48V448H368v32h48 48 48V432 272 224H464 416 368v48 16H144V272 224H96 48zm96 112H368v64H144V336zm272-64h48V432H416V272z'
      
    ]
  };

  
    var faCouchSmall = faLoveseat;
  

  
  

  var faPeopleDress = {
    prefix: 'fasr',
    iconName: 'people-dress',
    icon: [
      640,
      512,
      [],
      'e217',
      
      'M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H94.8l-6.9 12.4-75.3 136L1 297.4l42 23.3 11.6-21L100 217.7 63 336 48 384H96V488v24h48V488 384h32V488v24h48V488 384h48l-15-48L220 217.7l45.4 81.9 11.6 21 42-23.3-11.6-21-75.3-136L225.2 128H211.1 192 128 108.9zm4.4 208L160 186.5 206.7 336H113.3zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H414.8l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21L420 217.7 383 336l-15 48h48V488v24h48V488 384h32V488v24h48V488 384h48l-15-48L540 217.7l45.4 81.9 11.6 21 42-23.3-11.6-21-75.3-136L545.2 128H531.1 512 448 428.9zM480 186.5L526.7 336H433.3L480 186.5z'
      
    ]
  };

  

  
  

  var faHandHoldingSkull = {
    prefix: 'fasr',
    iconName: 'hand-holding-skull',
    icon: [
      576,
      512,
      [],
      'e1a4',
      
      'M192 128c0 29.9 20.4 58.1 53.8 71.8l16.7 6.9-2 18L258.8 240h58.4l-1.7-15.3-2-18 16.7-6.9C363.6 186.1 384 157.9 384 128c0-41.1-39.6-80-96-80s-96 38.9-96 80zM288 0c76.2 0 144 54.2 144 128c0 46.7-27.7 86.1-66.9 108.2l2.8 25.2 3 26.7H344 232 205.2l3-26.7 2.8-25.2C171.7 214.1 144 174.7 144 128C144 54.2 211.8 0 288 0zM248 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM160.7 304H168 384h24v24 46.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H424 24 0V464H24 416.6l91.7-62.8-15-24-80.4 51L407 432h-7H368 320 296 256 232V384h24 40 24 40V352H175.3l-90 60-6 4H72 24 0V368H24 64.7l90-60 6-4z'
      
    ]
  };

  

  
  

  var faBanana = {
    prefix: 'fasr',
    iconName: 'banana',
    icon: [
      576,
      512,
      [],
      'e2e5',
      
      'M288.1 55c10.3 27.7 15.9 57.7 15.9 89c0 39.6-9 77.1-25 110.6l41.4 24.6C340.6 238.4 352 192.5 352 144c0-23.8-2.7-47-7.9-69.2l2.5-1.7C380 114.3 400 166.8 400 224c0 16-1.6 31.7-4.6 46.9l50.3-10.6c1.5-11.9 2.3-24 2.3-36.3c0-84.7-36.6-160.9-94.8-213.6L288.1 55zM420.3 347.4l43.9-9.2L535 409l17 17L585.9 392l-17-17-80-80-9.2-9.2-12.7 2.7-27.7 5.8L324.2 318.6l-60.9-36.1v0l-39.1-23.2-11.5-6.8-11.8 6.2-92 48L87.6 317.8l22.2 42.6 21.3-11.1 80.2-41.8 22.1 13.1C186.7 369.5 120.9 400 48 400H0v0 48 64 0H48l112 0c107 0 200.4-58.4 250.1-145c.7-1.2 1.3-2.3 2-3.5c2.9-5.3 5.7-10.6 8.3-16.1z'
      
    ]
  };

  

  
  

  var faHouseTurret = {
    prefix: 'fasr',
    iconName: 'house-turret',
    icon: [
      640,
      512,
      [],
      'e1b4',
      
      'M0 0H24 96h48 64 48 72 24V24 134.3l-48 40V48H256V88v24H208V88 48H144V88v24H96V88 48H48V206.9l57.9 65.2 6.1 6.8V288 488v24H64V488 297.1L6.1 231.9 0 225.1V216 24 0zM304 216l48-40 96-80L640 256V464v48H592 304 256V464 256l48-40zM176 144c22.1 0 40 17.9 40 40v56H136V184c0-22.1 17.9-40 40-40zM304 278.5V464H592V278.5l-144-120-144 120zM496 272v96H400V272h96z'
      
    ]
  };

  

  
  

  var faChartScatterBubble = {
    prefix: 'fasr',
    iconName: 'chart-scatter-bubble',
    icon: [
      512,
      512,
      [],
      'e0e9',
      
      'M48 32V56 432H488h24v48H488 24 0V456 56 32H48zM176 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm200 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM240 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm168 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCircleVideo = {
    prefix: 'fasr',
    iconName: 'circle-video',
    icon: [
      512,
      512,
      ["video-circle"],
      'e12b',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 176V336H288V176H144zM320 288l64 48V176l-64 48v64z'
      
    ]
  };

  
    var faVideoCircle = faCircleVideo;
  

  
  

  var faGameBoardSimple = {
    prefix: 'fasr',
    iconName: 'game-board-simple',
    icon: [
      448,
      512,
      ["game-board-alt"],
      'f868',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zm32 80V256H224V112H80zM224 256V400H368V256H224z'
      
    ]
  };

  
    var faGameBoardAlt = faGameBoardSimple;
  

  
  

  var faSkull = {
    prefix: 'fasr',
    iconName: 'skull',
    icon: [
      512,
      512,
      [128128],
      'f54c',
      
      'M368 373.9v25V464H320V440 416H272v24 24H240V440 416H192v24 24H144V398.9v-25l-20.4-14.3C75.9 326.2 48 276.9 48 224c0-91.4 86.9-176 208-176s208 84.6 208 176c0 52.9-27.9 102.2-75.6 135.6L368 373.9zm48 25c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9V464v48h48H368h48V464 398.9zM224 256a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm120 56a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  

  
  

  var faTimelineArrow = {
    prefix: 'fasr',
    iconName: 'timeline-arrow',
    icon: [
      640,
      512,
      [],
      'e29d',
      
      'M96 64v64h8 48 8V64H96zm64 112h-8v56H328V176h-8H272V128 64 16h48 64 48V64v64 48H384h-8v56H538.3l-50.5-46.3-17.7-16.2 32.4-35.4 17.7 16.2 96 88L635.5 256l-19.3 17.7-96 88-17.7 16.2-32.4-35.4 17.7-16.2L538.3 280H248v56h8 48v48 64 48H256 192 144V448 384 336h48 8V280H24 0V232H24h80V176H96 48V128 64 16H96h64 48V64v64 48H160zm40 208h-8v64h64V384h-8H200zM384 64H320v64h64V64z'
      
    ]
  };

  

  
  

  var faBowlRice = {
    prefix: 'fasr',
    iconName: 'bowl-rice',
    icon: [
      512,
      512,
      [],
      'e2eb',
      
      'M200 32h16 24V80H216 200 176V32h24zm-24 72h24 16 24v48H216 200 176V104zM56 176H72 96v48H72 56 32V176H56zm192 0h16 24v48H264 248 224V176h24zm-96 0h16 24v48H168 152 128V176h24zM80 104h24 16 24v48H120 104 80V104zm264 72h16 24v48H360 344 320V176h24zm-72-72h24 16 24v48H312 296 272V104zm168 72h16 24v48H456 440 416V176h24zm-72-72h24 16 24v48H408 392 368V104zM272 32h24 16 24V80H312 296 272V32zM144 431.8v.2H368v-.2V401.5l27.4-13c33.7-16 58.6-47.1 66.2-84.5H50.4c7.6 37.4 32.5 68.5 66.2 84.5l27.4 13v30.3zm-48 0C46.1 408.1 9.8 360.6 1.7 304C.6 296.2 0 288.1 0 280V256H48 464h48v24c0 8.1-.6 16.2-1.7 24c-8.1 56.6-44.4 104.1-94.3 127.8v.2 48H368 144 96V432v-.2z'
      
    ]
  };

  

  
  

  var faMillSign = {
    prefix: 'fasr',
    iconName: 'mill-sign',
    icon: [
      384,
      512,
      [],
      'e1ed',
      
      'M168 251.5L73.6 495.3l44.8 17.3L168 384.5V424v24h48V424 260.5l44.3-114.4c5-1.4 10.3-2.1 15.7-2.1c33.1 0 60 26.9 60 60V424v24h48V424 204c0-58.4-46.4-106-104.4-107.9l30.7-79.4L265.6-.7 222.8 110c-11.8 6.7-22.3 15.6-30.8 26.1C172.2 111.6 141.9 96 108 96c-22.2 0-42.8 6.7-60 18.2V96H0V204v4V424v24H48V424 208v-4c0-33.1 26.9-60 60-60s60 26.9 60 60v47.5z'
      
    ]
  };

  

  
  

  var faBalloons = {
    prefix: 'fasr',
    iconName: 'balloons',
    icon: [
      640,
      512,
      [],
      'e2e4',
      
      'M163.2 329.6l0 0 .7-.6c.7-.5 1.8-1.4 3.3-2.6c3-2.4 7.4-6.1 12.7-10.9c10.8-9.7 25.1-23.6 39.3-40.4C249.1 239.7 272 198.7 272 160c0-61.9-50.1-112-112-112S48 98.1 48 160c0 38.7 22.9 79.7 52.7 115.1c14.2 16.9 28.5 30.8 39.3 40.4c5.4 4.8 9.8 8.5 12.7 10.9c1.5 1.2 2.6 2.1 3.3 2.6l.7 .6 0 0 0 0 0 0 0 0 0 0L160 332l3.1-2.3 0 0 0 0 0 0 0 0zM128 368s-128-96-128-208C0 71.6 71.6 0 160 0s160 71.6 160 160c0 112-128 208-128 208l12.8 32L224 448H172.3 147.7 96l19.2-48L128 368zm48-232c-22.1 0-40 17.9-40 40H88c0-48.6 39.4-88 88-88v48zm176 24c0-9.9-.7-19.6-2.2-29c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 112-128 208-128 208l12.8 32L544 512H492.3 467.7 416l19.2-48L448 432s-100.3-75.2-123.3-170.1C340.6 231.6 352 197 352 160zM483.2 393.6l.7-.6c.7-.5 1.8-1.4 3.3-2.6c3-2.4 7.4-6.1 12.7-10.9c10.8-9.7 25.1-23.6 39.3-40.4C569.1 303.7 592 262.7 592 224c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 38.7 22.9 79.7 52.7 115.1c14.2 16.9 28.5 30.8 39.3 40.4c5.4 4.8 9.8 8.5 12.7 10.9c1.5 1.2 2.6 2.1 3.3 2.6l.7 .6 0 0 0 0 0 0 0 0 0 0L480 396l3.1-2.3 0 0 0 0 0 0 0 0 0 0zM456 240H408c0-48.6 39.4-88 88-88v48c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleDollar = {
    prefix: 'fasr',
    iconName: 'chart-pie-simple-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e605',
      
      'M496 192c-46.8 0-89.3 18.2-120.8 48H272V.6c5.3-.4 10.6-.6 16-.6C401 0 494.5 83.7 509.8 192.5c-4.6-.4-9.2-.5-13.8-.5zM272 288h67.2c-7.6 14.9-13.2 31-16.3 48H224 176V288 90.9C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192c34.5 0 66.9-9.1 94.9-25c6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 161.6 74.5 68.6 176 40.6c15.4-4.3 31.5-7 48-8.1V80.7 240v48h48zm80 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L529.9 301c-5.6-1.4-11.6-2.7-17.9-3.7V288 272H480v16 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8L436 425.2l15.3 4.8c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4 16h32v-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z'
      
    ]
  };

  

  
  

  var faArrowUpWideShort = {
    prefix: 'fasr',
    iconName: 'arrow-up-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-up"],
      'f161',
      
      'M111 50.2l17-17 17 17 96 96 17 17L224 197.1l-17-17-55-55V456v24H104V456 125.1l-55 55-17 17L-1.9 163.2l17-17 96-96zM312 480H288V432h24 48 24v48H360 312zm0-128H288V304h24H424h24v48H424 312zm0-128H288V176h24H488h24v48H488 312zm0-128H288V48h24H552h24V96H552 312z'
      
    ]
  };

  
    var faSortAmountUp = faArrowUpWideShort;
  

  
  

  var faUtensils = {
    prefix: 'fasr',
    iconName: 'utensils',
    icon: [
      448,
      512,
      [61685,127860,"cutlery"],
      'f2e7',
      
      'M8.1 165.3L26.5 0H74.8L56 169.3V184c0 22.1 17.9 40 40 40h8 48 8c22.1 0 40-17.9 40-40V169.3L184.1 26.7 181.2 0h48.3l2.4 21.3 16 144 .1 1.3V168v16c0 48.6-39.4 88-88 88h-8V488v24H104V488 272H96c-48.6 0-88-39.4-88-88V168v-1.3l.1-1.3zM104 24V0h48V24 168v24H104V168 24zM336 176V304h64V248 224 55.1c-7.1 3.6-14.9 8.5-22.6 15.2C357.7 87.4 336 118.3 336 176zm64 176H336 288V304 176C288 57.1 364.4 14.5 400 3.3C407.5 1 413.2 0 416 0h32V48 224v24 56 48V488v24H400V488 352z'
      
    ]
  };

  
    var faCutlery = faUtensils;
  

  
  

  var faRotateRight = {
    prefix: 'fasr',
    iconName: 'rotate-right',
    icon: [
      512,
      512,
      ["redo-alt","rotate-forward"],
      'f2f9',
      
      'M372.2 123.8C341.2 96.5 300.5 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2l28.8 38.4C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.8 0 110.5 21.9 150.2 57.8l15.9-15.9L456 40l33.9 33.9L496 80v96 48H448 352l-6.1-6.1L312 184l33.9-33.9 26.3-26.3zm75.8-7.9L387.9 176H448V115.9z'
      
    ]
  };

  
    var faRedoAlt = faRotateRight;
  
    var faRotateForward = faRotateRight;
  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fasr',
    iconName: 'arrow-right-arrow-left',
    icon: [
      448,
      512,
      [8644,"exchange"],
      'f0ec',
      
      'M18.2 402.9L111 495.7l17 17 33.9-33.9-17-17L93.1 409.9l330.9 0 24 0 0-48-24 0-330.9 0 55-55 17-17L131.2 256l-17 17-96 96-17 17 17 17zm411.5-256l17-17-17-17-96-96-17-17L282.9 33.9l17 17 55 55L24 105.9l-24 0 0 48 24 0 330.9 0-55 55-17 17 33.9 33.9 17-17 96-96z'
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faGolfClub = {
    prefix: 'fasr',
    iconName: 'golf-club',
    icon: [
      512,
      512,
      [],
      'f451',
      
      'M466.5 13.3L293 360.4 31 281 0 271.6V304 488v24H24 256h14.8l6.6-13.3 232-464L466.5 13.3zM48 336.3L271.2 404l-30 60H48V448H80 96V416H80 48V400H80 96V368H80 48V336.3z'
      
    ]
  };

  

  
  

  var faCastle = {
    prefix: 'fasr',
    iconName: 'castle',
    icon: [
      640,
      512,
      [],
      'e0de',
      
      'M176 24V0H128V24 224H48V184 160H0v24V488v24H24 616h24V488 184 160H592v24 40H512V24 0H464V24 64H400V24 0H352V24 64H288V24 0H240V24 64H176V24zm0 88H464V224H176V112zM48 272H592V464H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H48V272z'
      
    ]
  };

  

  
  

  var faKiwiBird = {
    prefix: 'fasr',
    iconName: 'kiwi-bird',
    icon: [
      576,
      512,
      [],
      'f535',
      
      'M313.7 304l-14.3 16c-26.4 29.5-64.7 48-107.3 48c-79.5 0-144-64.5-144-144s64.5-144 144-144c42.6 0 80.9 18.5 107.3 48l14.3 16h21.5H448c44.2 0 80 35.8 80 80v80H335.1 313.7zM335.1 96C300 56.7 248.9 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456v24h48V456 410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456v24h48V456 405.1c30.7-10.9 57.8-29.3 79.1-53.1H464L576 480V352 304 224c0-70.7-57.3-128-128-128H335.1zM472 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faBlanketFire = {
    prefix: 'fasr',
    iconName: 'blanket-fire',
    icon: [
      640,
      512,
      [],
      'e3da',
      
      'M24 0H0V24 224v24 24V424v24H24 313.8c-8.6-14.9-15.3-31-19.7-48H48V272H306c7.8-17.4 17.6-33.5 28.1-48H48V48H400V155.1c11.3-9.2 21.9-16.7 31-22.4l17-10.6V24 0H424 24zM288 351.8c0-13.7 1.6-27 4.5-39.8H120 96v48h24H288.2c-.1-2.7-.2-5.4-.2-8.2zM448 160c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z'
      
    ]
  };

  

  
  

  var faButter = {
    prefix: 'fasr',
    iconName: 'butter',
    icon: [
      640,
      512,
      [129480],
      'e3e4',
      
      'M464 112V288H416V112H112V288H64V112 64h48H416h24 24 64 48v48V288H528V112H464zM0 320H24 616h24v48H616h-8v80H32V368H24 0V320z'
      
    ]
  };

  

  
  

  var faHelmetBattle = {
    prefix: 'fasr',
    iconName: 'helmet-battle',
    icon: [
      576,
      512,
      [],
      'f6eb',
      
      'M64 256H0V224L64 0V256zm32-32C96 80 288 0 288 0s192 80 192 224c0 80 32 192 32 192L320 512H256L64 416s32-112 32-192zM449 359.9c-8.2-38.8-17-90.8-17-135.9c0-49.6-33.5-93.3-77.8-128.4C333 78.8 311.5 65.8 295.1 57c-2.5-1.4-4.9-2.6-7.1-3.8c-2.2 1.2-4.6 2.4-7.1 3.8c-16.3 8.8-37.8 21.9-59.1 38.7C177.5 130.7 144 174.4 144 224c0 45.1-8.9 97.1-17 135.9c-2.3 11.1-4.7 21.4-6.8 30.5L264 462.3V288l-88-32V224H400v32l-88 32V462.3l143.9-71.9c-2.2-9.1-4.5-19.4-6.8-30.5zM512 0l64 224v32H512V0z'
      
    ]
  };

  

  
  

  var faCircleA = {
    prefix: 'fasr',
    iconName: 'circle-a',
    icon: [
      512,
      512,
      [],
      'e0f7',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240.8 112l-6.5 13.8L120.6 368h53l22.5-48H315.8l22.5 48h53L277.7 125.8 271.2 112H240.8zM256 192.5L293.3 272H218.7L256 192.5z'
      
    ]
  };

  

  
  

  var faDiceOne = {
    prefix: 'fasr',
    iconName: 'dice-one',
    icon: [
      448,
      512,
      [9856],
      'f525',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faPotato = {
    prefix: 'fasr',
    iconName: 'potato',
    icon: [
      512,
      512,
      [129364],
      'e440',
      
      'M129.9 241.9l4.2-4.2 3-5.1L179 163l69.7-41.8 5.1-3 4.2-4.2L294.9 77c18.6-18.6 43.8-29 70.1-29c54.7 0 99.1 44.4 99.1 99.1c0 26.3-10.4 51.5-29 70.1l-4.9 4.9-4.8 4.8-3.3 5.9L350 362.3l-96.9 41.5-8.5 3.6-6.5 6.5L217.1 435c-18.6 18.6-43.8 29-70.1 29C92.4 464 48 419.6 48 364.9c0-26.3 10.4-51.5 29-70.1l52.9-52.9zM224 80l-80 48L96 208 43.1 260.9C15.5 288.5 0 325.9 0 364.9C0 446.2 65.8 512 147.1 512c39 0 76.4-15.5 104-43.1L272 448l112-48 80-144 4.9-4.9c27.6-27.6 43.1-65 43.1-104C512 65.8 446.2 0 364.9 0c-39 0-76.4 15.5-104 43.1L224 80zm152 88H328v48h48V168zM216 232H168v48h48V232zM136 360v48h48V360H136z'
      
    ]
  };

  

  
  

  var faFileMedical = {
    prefix: 'fasr',
    iconName: 'file-medical',
    icon: [
      384,
      512,
      [],
      'f477',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM160 224v64H96v64h64v64h64V352h64V288H224V224H160z'
      
    ]
  };

  

  
  

  var faPipe = {
    prefix: 'fasr',
    iconName: 'pipe',
    icon: [
      64,
      512,
      [],
      '7c',
      
      'M56 0V24 488v24H8V488 24 0H56z'
      
    ]
  };

  

  
  

  var faMoonOverSun = {
    prefix: 'fasr',
    iconName: 'moon-over-sun',
    icon: [
      512,
      512,
      ["eclipse-alt"],
      'f74a',
      
      'M256 57.1L193.1 23.2 150 0 135.9 46.9l-20.5 68.4L46.9 135.9 0 150l23.2 43.1L57.1 256 23.2 318.9 0 362l46.9 14.1 68.4 20.5 20.5 68.4L150 512l43.1-23.2L256 454.9l62.9 33.9L362 512l14.1-46.9 20.5-68.4 68.4-20.5L512 362l-23.2-43.1L454.9 256l33.9-62.9L512 150l-46.9-14.1-68.4-20.5L376.1 46.9 362 0 318.9 23.2 256 57.1zm77 13.1l17.7 59 7.4 24.8 24.8 7.4 59 17.7-29.2 54.2L400.4 256l12.3 22.8L441.8 333l-59 17.7-24.8 7.4-7.4 24.8-17.7 59-54.2-29.2L256 400.4l-22.8 12.3L179 441.8l-17.7-59-7.4-24.8-24.8-7.4L70.2 333l29.2-54.2L111.6 256 99.4 233.2 70.2 179l59-17.7 24.8-7.4 7.4-24.8 17.7-59 54.2 29.2L256 111.6l22.8-12.3L333 70.2zM368 256a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-76.9 53.5c-31.8-10.5-54.7-40.1-54.7-75.1c0-15.4 4.4-29.8 12.1-41.9c2.5-.3 4.9-.4 7.5-.4c35.3 0 64 28.7 64 64c0 22.4-11.5 42.1-28.9 53.5z'
      
    ]
  };

  
    var faEclipseAlt = faMoonOverSun;
  

  
  

  var faSeatAirline = {
    prefix: 'fasr',
    iconName: 'seat-airline',
    icon: [
      448,
      512,
      [],
      'e244',
      
      'M48 24V0H0V24 160v5.1l2.1 4.7 104 232 6.4 14.2H128h88v48H120 96v48h24H360h24V464H360 264V416H368h16l6.2-14.8 40-96L444 272H408 100.5L86.2 240H328h24V192H328 64.6L48 154.9V24zm95.5 344L122 320H372l-20 48H143.5z'
      
    ]
  };

  

  
  

  var faB = {
    prefix: 'fasr',
    iconName: 'b',
    icon: [
      320,
      512,
      [98],
      '42',
      
      'M24 32H0V56 232v24 24V456v24H24 196c68.5 0 124-55.5 124-124c0-48.2-27.5-90-67.8-110.5c22.1-21.8 35.8-52 35.8-85.5v-8c0-66.3-53.7-120-120-120H24zM168 232H48V80H168c39.8 0 72 32.2 72 72v8c0 39.8-32.2 72-72 72zM48 280H168h24 4c42 0 76 34 76 76s-34 76-76 76H48V280z'
      
    ]
  };

  

  
  

  var faSquareDownRight = {
    prefix: 'fasr',
    iconName: 'square-down-right',
    icon: [
      448,
      512,
      [],
      'e26c',
      
      'M400 432V80H48V432H400zm48 48H400 48 0V432 80 32H48 400h48V80 432v48zM320 192V352H160l-24-24 52-52-76-76 56-56 76 76 52-52 24 24z'
      
    ]
  };

  

  
  

  var faLaptopMedical = {
    prefix: 'fasr',
    iconName: 'laptop-medical',
    icon: [
      640,
      512,
      [],
      'f812',
      
      'M112 80H528V320h48V80 32H528 112 64V80 320h48V80zM51.9 400H588.1l-32 32H83.9l-32-32zM640 416V400 352H592 48 0v48 16l64 64H576l64-64zM288 128v64H224v64h64v64h64V256h64V192H352V128H288z'
      
    ]
  };

  

  
  

  var faFlyingDisc = {
    prefix: 'fasr',
    iconName: 'flying-disc',
    icon: [
      640,
      512,
      [],
      'e3a9',
      
      'M486.4 89.6c7.9 7.9 16.9 31.4 .6 80.4c-15.3 45.9-49.5 101-100.7 152.2S279.9 407.6 234 422.9c-49 16.3-72.5 7.3-80.4-.6c-5.6-5.6-11.8-19.2-9-44.3c19.9 19.2 45.3 20.8 62.5 18.9c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c1.9-17.2 .3-42.6-18.9-62.5c25.1-2.8 38.7 3.3 44.3 9zM201.2 175.4C104.3 281.9 67.6 404.2 119.7 456.3c55.3 55.3 189.8 10.5 300.5-100.2S575.6 111 520.3 55.7C468.2 3.6 345.9 40.3 239.5 137.1c-6.6 6-13.2 12.2-19.7 18.7c-6.5 6.5-12.7 13-18.6 19.6zm35.6 32.2c5.4-6 11.1-11.9 17-17.8c5.9-5.9 11.9-11.6 17.9-17c57.9-52.3 116.2-78.4 135.5-59.1c21.4 21.4-12.7 90.1-76.1 153.4s-132.1 97.4-153.4 76.1c-19.4-19.4 6.8-77.7 59.1-135.6z'
      
    ]
  };

  

  
  

  var faCalendarWeek = {
    prefix: 'fasr',
    iconName: 'calendar-week',
    icon: [
      448,
      512,
      [],
      'f784',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zm-48 64v96H96V256H352z'
      
    ]
  };

  

  
  

  var faCarCircleBolt = {
    prefix: 'fasr',
    iconName: 'car-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e342',
      
      'M120 32H103L97.3 48.1 52.6 176H48 0v48V352v48 80H48V400H322.9c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16H48V224H394.8c28.6-20.2 63.5-32 101.2-32c5.4 0 10.7 .2 16 .7V176H464h-4.6L414.7 48.1 409 32H392 120zM408.6 176H103.4L137 80H375l33.6 96zM112 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm24-224l-10.7 64H576L472 448l10.7-64H416l104-96z'
      
    ]
  };

  

  
  

  var faVectorCircle = {
    prefix: 'fasr',
    iconName: 'vector-circle',
    icon: [
      512,
      512,
      [],
      'e2c6',
      
      'M232 40V88h48V40H232zM192 0h40 48 40V40v9.6c67.8 21 121.4 74.5 142.4 142.4H472h40v40 48 40H472h-9.6c-21 67.8-74.5 121.4-142.4 142.4V472v40H280 232 192V472v-9.6C124.2 441.4 70.6 387.8 49.6 320H40 0V280 232 192H40h9.6C70.6 124.2 124.2 70.6 192 49.6V40 0zm0 100.6c-41.3 17-74.3 50.1-91.4 91.4H128v40 48 40H100.6c17 41.3 50.1 74.3 91.4 91.4V384h40 48 40v27.4c41.3-17 74.3-50.1 91.4-91.4H384V280 232 192h27.4c-17-41.3-50.1-74.3-91.4-91.4V128H280 232 192V100.6zM472 232H424v48h48V232zM280 424H232v48h48V424zM88 232H40v48H88V232z'
      
    ]
  };

  

  
  

  var faHouse = {
    prefix: 'fasr',
    iconName: 'house',
    icon: [
      576,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      'M288 .5l15.5 13.2 264 224-31.1 36.6L512 253.5V488v24H488 88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zm0 62.9L112 212.8V464h80V296 272h24H360h24v24V464h80V212.8L288 63.5zM240 464h96V320H240V464z'
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faHeartCircleExclamation = {
    prefix: 'fasr',
    iconName: 'heart-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4fe',
      
      'M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1l4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-14.4-6.6-29.8-11.4-45.9-14c2.7-8.5 4.1-17.4 4.1-26.4c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224V416H416v32h32zm0-176H416v16 80 16h32V368 288 272z'
      
    ]
  };

  

  
  

  var faCourtSport = {
    prefix: 'fasr',
    iconName: 'court-sport',
    icon: [
      640,
      512,
      [],
      'e643',
      
      'M48 80v48H80h48v48V336v48H80 48v48H296V365.4c-50.3-11-88-55.8-88-109.4s37.7-98.4 88-109.4V80H48zM344 365.4V432H592V384H560 512V336 176 128h48 32V80H344v66.6c50.3 11 88 55.8 88 109.4s-37.7 98.4-88 109.4zm0-168.8V315.3c23.5-9.5 40-32.5 40-59.3s-16.5-49.9-40-59.3zm-48 0c-23.5 9.5-40 32.5-40 59.3s16.5 49.9 40 59.3V196.7zM48 176V336H80V176H48zM560 336h32V176H560V336zM0 32H48 592h48V80 432v48H592 48 0V432 80 32z'
      
    ]
  };

  

  
  

  var faOutdent = {
    prefix: 'fasr',
    iconName: 'outdent',
    icon: [
      448,
      512,
      ["dedent"],
      'f03b',
      
      'M0 40H24 424h24V88H424 24 0V40zM192 168h24H424h24v48H424 216 192V168zm24 128H424h24v48H424 216 192V296h24zM0 424H24 424h24v48H424 24 0V424zm128-72L0 256l128-96V352z'
      
    ]
  };

  
    var faDedent = faOutdent;
  

  
  

  var faFaceWorried = {
    prefix: 'fasr',
    iconName: 'face-worried',
    icon: [
      512,
      512,
      [],
      'e3a3',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM255.6 400c-38.7 0-74.5 11.4-103.6 30.6c4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 411.4 294.3 400 255.6 400zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H192zm141 .9c-4.3-.6-8.6-.9-13-.9H304V128h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faFaceDotted = {
    prefix: 'fasr',
    iconName: 'face-dotted',
    icon: [
      512,
      512,
      [129765],
      'e47f',
      
      'M256 0c-13.6 0-27 1.1-40 3.1L192.3 6.8l7.5 47.4 23.7-3.7C234 48.9 244.9 48 256 48s22 .9 32.6 2.5l23.7 3.7 7.5-47.4L296 3.1C283 1.1 269.6 0 256 0zM133.7 87.7l19.4-14.1L124.9 34.8 105.5 48.9C83.8 64.7 64.7 83.8 48.9 105.5L34.8 124.9l38.8 28.2 14.1-19.4c12.8-17.6 28.4-33.2 46.1-46.1zM406.5 48.9L387.1 34.8 358.8 73.6l19.4 14.1c17.6 12.8 33.2 28.4 46 46.1l14.1 19.4 38.8-28.2-14.1-19.4c-15.8-21.7-34.9-40.8-56.6-56.6zM50.5 223.4l3.7-23.7L6.8 192.3 3.1 216C1.1 229 0 242.4 0 256s1.1 27 3.1 40l3.7 23.7 47.4-7.5-3.7-23.7C48.9 278 48 267.1 48 256s.9-22 2.5-32.6zM508.9 216l-3.7-23.7-47.4 7.5 3.7 23.7c1.7 10.6 2.5 21.5 2.5 32.6s-.9 22-2.5 32.6l-3.7 23.7 47.4 7.5 3.7-23.7c2.1-13.1 3.1-26.4 3.1-40s-1.1-27-3.1-40zM87.7 378.3L73.6 358.8 34.8 387.1l14.1 19.4c15.8 21.7 34.9 40.8 56.6 56.6l19.4 14.1 28.2-38.8-19.4-14.1c-17.6-12.8-33.2-28.4-46.1-46zm375.4 28.2l14.1-19.4-38.8-28.2-14.1 19.4c-12.8 17.6-28.4 33.2-46 46l-19.4 14.1 28.2 38.8 19.4-14.1c21.7-15.8 40.8-34.9 56.6-56.6zm-239.7 55l-23.7-3.7-7.5 47.4 23.7 3.7c13.1 2.1 26.4 3.1 40 3.1s27-1.1 40-3.1l23.7-3.7-7.5-47.4-23.7 3.7C278 463.1 267.1 464 256 464s-22-.9-32.6-2.5zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328H160v48h24H328h24V328H328 184z'
      
    ]
  };

  

  
  

  var faIdCard = {
    prefix: 'fasr',
    iconName: 'id-card',
    icon: [
      576,
      512,
      [62147,"drivers-license"],
      'f2c2',
      
      'M528 160V432H314.7L288 352H128l-26.7 80H48V160H528zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48H352v48h24 80 24V208H456 376zm0 96H352v48h24 80 24V304H456 376z'
      
    ]
  };

  
    var faDriversLicense = faIdCard;
  

  
  

  var faBookSkull = {
    prefix: 'fasr',
    iconName: 'book-skull',
    icon: [
      448,
      512,
      ["book-dead"],
      'f6b7',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM48 432c0 17.7 14.3 32 32 32H368V400H80c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zM288 195.2V224H192V195.2c-19.4-11.7-32-30.3-32-51.2c0-35.3 35.8-64 80-64s80 28.7 80 64c0 20.9-12.6 39.5-32 51.2zM224 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM133.9 219.8l15.2 5.1L240 255.1l90.9-30.3 15.2-5.1 10.1 30.4-15.2 5.1L290.6 272l50.5 16.8 15.2 5.1-10.1 30.4-15.2-5.1L240 288.9l-90.9 30.3-15.2 5.1-10.1-30.4 15.2-5.1L189.4 272l-50.5-16.8-15.2-5.1 10.1-30.4z'
      
    ]
  };

  
    var faBookDead = faBookSkull;
  

  
  

  var faAlignCenter = {
    prefix: 'fasr',
    iconName: 'align-center',
    icon: [
      448,
      512,
      [],
      'f037',
      
      'M120 40H96V88h24H328h24V40H328 120zM24 168H0v48H24 424h24V168H424 24zM96 296v48h24H328h24V296H328 120 96zM24 424H0v48H24 424h24V424H424 24z'
      
    ]
  };

  

  
  

  var faFaceMeh = {
    prefix: 'fasr',
    iconName: 'face-meh',
    icon: [
      512,
      512,
      [128528,"meh"],
      'f11a',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328H160v48h24H328h24V328H328 184z'
      
    ]
  };

  
    var faMeh = faFaceMeh;
  

  
  

  var faCodePullRequestClosed = {
    prefix: 'fasr',
    iconName: 'code-pull-request-closed',
    icon: [
      512,
      512,
      [],
      'e3f9',
      
      'M80 48v64h64V48H80zM32 0H80h64 48V48v64 48H144h-8V352h8 48v48 64 48H144 80 32V464 400 352H80h8V160H80 32V112 48 0zM377 23l23 23 23-23 17-17L473.9 40 457 57l-23 23 23 23 17 17L440 153.9l-17-17-23-23-23 23-17 17L326.1 120l17-17 23-23L343 57l-17-17L360 6.1l17 17zm47 177v24V352h8 48v48 64 48H432 368 320V464 400 352h48 8V224 200h48zM80 400v64h64V400H80zm288 0v64h64V400H368z'
      
    ]
  };

  

  
  

  var faMobile = {
    prefix: 'fasr',
    iconName: 'mobile',
    icon: [
      384,
      512,
      [128241,"mobile-android","mobile-phone"],
      'f3ce',
      
      'M64 48V464H320V48H64zM16 0H64 320h48V48 464v48H320 64 16V464 48 0zM160 400h64 16v32H224 160 144V400h16z'
      
    ]
  };

  
    var faMobileAndroid = faMobile;
  
    var faMobilePhone = faMobile;
  

  
  

  var faUserPilot = {
    prefix: 'fasr',
    iconName: 'user-pilot',
    icon: [
      448,
      512,
      [],
      'e2c0',
      
      'M48 80L80 99.2V128c16 10.7 67.2 32 144 32s128-21.3 144-32V99.2L400 80V48L224 0 48 48V80zM183.2 65.7L224 86.1l40.8-20.4 14.3-7.2 14.3 28.6-14.3 7.2-48 24-7.2 3.6-7.2-3.6-48-24-14.3-7.2 14.3-28.6 14.3 7.2zM98.1 168.8C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4zm97.1 285.6L208 464H64.5l19.2-64h39l72.5 54.4zM383.5 464H240l12.8-9.6L325.3 400h39l19.2 64zM400 352H309.3L224 416l-85.3-64H48L14.4 464 0 512H50.1 397.9 448l-14.4-48L400 352z'
      
    ]
  };

  

  
  

  var faForward = {
    prefix: 'fasr',
    iconName: 'forward',
    icon: [
      512,
      512,
      [9193],
      'f04e',
      
      'M468.7 284.8L512 256l-43.3-28.8L272 96 224 64v57.7 76.7L48 92.8 0 64v56V392v56l48-28.8L224 313.6v76.7V448l48-32L468.7 284.8zM224 257.6L48 363.2V148.8L224 254.4v3.2zm48 100.7V153.7L425.5 256 272 358.3z'
      
    ]
  };

  

  
  

  var faLoader = {
    prefix: 'fasr',
    iconName: 'loader',
    icon: [
      512,
      512,
      [],
      'e1d4',
      
      'M280 24V0H232V24v80 24h48V104 24zm0 384V384H232v24 80 24h48V488 408zM0 232v48H24h80 24V232H104 24 0zm408 0H384v48h24 80 24V232H488 408zM454 92L420 58l-17 17-56.6 56.6-17 17 33.9 33.9 17-17L437 108.9l17-17zM165.5 380.4l17-17-33.9-33.9-17 17L75 403.1 58 420 92 454l17-17 56.6-56.6zM92 58L58 92l17 17 56.6 56.6 17 17 33.9-33.9-17-17L108.9 75 92 58zM380.5 346.5l-17-17-33.9 33.9 17 17L403.1 437l17 17L454 420l-17-17-56.6-56.6z'
      
    ]
  };

  

  
  

  var faGlass = {
    prefix: 'fasr',
    iconName: 'glass',
    icon: [
      384,
      512,
      [129371],
      'f804',
      
      'M61.9 176H322.1L299.6 464H84.4L61.9 176zm-3.8-48L51.9 48H332.1l-6.2 80H58.1zM40 512H344L380.2 48 384 0H335.9 48.1 0L3.8 48 40 512z'
      
    ]
  };

  

  
  

  var faFileCircleCheck = {
    prefix: 'fasr',
    iconName: 'file-circle-check',
    icon: [
      576,
      512,
      [],
      'e5a0',
      
      'M48 464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 48 0H48 256L384 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48V464zm240-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z'
      
    ]
  };

  

  
  

  var faRotateExclamation = {
    prefix: 'fasr',
    iconName: 'rotate-exclamation',
    icon: [
      512,
      512,
      [],
      'e23c',
      
      'M256 80c-72.7 0-135.2 44.1-162 107.1L49.8 168.3C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9L448 142.1V88 64h48V88 200v24H472 360 336V176h24 54.1l-52.1-52.1C333.8 95.8 295.7 80 256 80zM116.1 422.1L64 369.9V424v24H16V424 312 288H40 152h24v48H152 97.9l52.1 52.1C178.2 416.2 216.3 432 256 432c72.6 0 135-43.9 161.9-106.8L462 344.1C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9zM280 128v24V264v24H232V264 152 128h48zM232 368V320h48v48H232z'
      
    ]
  };

  

  
  

  var faScribble = {
    prefix: 'fasr',
    iconName: 'scribble',
    icon: [
      512,
      512,
      [],
      'e23f',
      
      'M183.3 21.4C198.3 7.7 218 0 238.4 0h1C283.9 0 320 36.1 320 80.6c0 21.4-8.5 41.9-23.6 57L89.5 344.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L374.5 151.6c15.1-15.1 35.6-23.6 57-23.6c44.5 0 80.6 36.1 80.6 80.6c0 21.4-8.5 41.9-23.6 57L384.2 369.8c-10.4 10.3-16.2 24.4-16.2 39c0 30.5 24.7 55.2 55.2 55.2h4.4c5.6 0 11.2-.9 16.6-2.7l36.2-12.1 15.2 45.5-36.2 12.1c-10.2 3.4-21 5.2-31.8 5.2h-4.4c-57 0-103.2-46.2-103.2-103.2c0-27.4 10.9-53.6 30.2-73L454.5 231.6c6.1-6.1 9.5-14.4 9.5-23c0-18-14.6-32.6-32.6-32.6c-8.6 0-16.9 3.4-23 9.5L169.5 424.4c-15.1 15.1-35.6 23.6-57 23.6C68.1 448 32 411.9 32 367.4c0-21.4 8.5-41.9 23.6-57L262.5 103.6c6.1-6.1 9.5-14.4 9.5-23c0-18-14.6-32.6-32.6-32.6h-1c-8.4 0-16.5 3.2-22.7 8.8L40.2 217.7 7.8 182.3 183.3 21.4z'
      
    ]
  };

  

  
  

  var faCommentsQuestion = {
    prefix: 'fasr',
    iconName: 'comments-question',
    icon: [
      640,
      512,
      [],
      'e14e',
      
      'M96.7 271.5l-11 27.4-7.1 17.6 70-16.2 10.1-2.3 10.2 2.1c12.4 2.5 25.5 3.9 39 3.9c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 26.5 10.2 51.8 29.2 73.4l19.5 22.2zM57 370.9L0 384l21.7-54.3 19.4-48.6C15.3 251.8 0 215.4 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-16.7 0-32.9-1.7-48.5-4.8L57 370.9zm188.2 10.6c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.5 0 26.6-1.3 39-3.9l10.2-2.1 10.1 2.3 70.1 16.2-7.1-17.6-11-27.4 19.5-22.2c19-21.5 29.2-46.9 29.2-73.4c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 39.4-15.3 75.8-41.2 105.1l19.4 48.6L640 512l-57-13.1L480.5 475.2c-15.6 3.1-31.8 4.8-48.5 4.8c-82 0-153-40.2-186.8-98.5zM146.7 125c0-21.4 17.3-38.7 38.7-38.7h40.3c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 181.4v5.9 16H192v-16V172.1v-9.3l8-4.6 31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7H185.3c-3.7 0-6.7 3-6.7 6.7l0 4.6-32 0 0-4.6zM191 232.7h34v34H191v-34z'
      
    ]
  };

  

  
  

  var faCommentCaptions = {
    prefix: 'fasr',
    iconName: 'comment-captions',
    icon: [
      512,
      512,
      [],
      'e146',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM120 192H96v48h24H264h24V192H264 120zm224 0H320v48h24 48 24V192H392 344zM136 272H112v48h24 32 24V272H168 136zm112 0H224v48h24H376h24V272H376 248z'
      
    ]
  };

  

  
  

  var faEyeDropper = {
    prefix: 'fasr',
    iconName: 'eye-dropper',
    icon: [
      512,
      512,
      ["eye-dropper-empty","eyedropper"],
      'f1fb',
      
      'M377 279l1-1L482.2 173.8c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8L233.9 134.1l-1 1-8-8-17-17L174.1 144l17 17L351 321l17 17L401.9 304l-17-17-8-8zm-94.5 18.6L148.1 432H80V363.9L214.3 229.5l-33.9-33.9L32 344v88L0 472l40 40 40-32h88L316.4 331.6l-33.9-33.9zM448.2 139.9L344 244.1 267.9 168 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1z'
      
    ]
  };

  
    var faEyeDropperEmpty = faEyeDropper;
  
    var faEyedropper = faEyeDropper;
  

  
  

  var faCloudBinary = {
    prefix: 'fasr',
    iconName: 'cloud-binary',
    icon: [
      640,
      512,
      [],
      'e601',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM176 176h16 64 16v16 64 16H256 192 176V256 192 176zm32 32v32h32V208H208zm80-32h16 16 16v16 64 16H304V256 208H288V176zm96 0h64 16v16 64 16H448 384 368V256 192 176h16zm16 64h32V208H400v32zM192 304h16 16 16v16 64 16H208V384 336H192V304zm80 0h16 64 16v16 64 16H352 288 272V384 320 304zm32 32v32h32V336H304zm96-32h16 16v16 64 16H400V384 336H384V304h16z'
      
    ]
  };

  

  
  

  var faOven = {
    prefix: 'fasr',
    iconName: 'oven',
    icon: [
      448,
      512,
      [],
      'e01d',
      
      'M400 48V160H48V48H400zm0 160V464H48V208H400zM48 0H0V48 464v48H48 400h48V464 48 0H400 48zm80 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 112H80V432H368V240zM144 288H304h16v32H304 144 128V288h16z'
      
    ]
  };

  

  
  

  var faDeleteLeft = {
    prefix: 'fasr',
    iconName: 'delete-left',
    icon: [
      576,
      512,
      [9003,"backspace"],
      'f55a',
      
      'M576 448H528 176L0 256 176 64H528h48v48V400v48zM65.1 256l132 144H528V112H197.1L65.1 256zm188.9-64L288 158.1l17 17 47 47 47-47 17-17L449.9 192l-17 17-47 47 47 47 17 17L416 353.9l-17-17-47-47-47 47-17 17L254.1 320l17-17 47-47-47-47-17-17z'
      
    ]
  };

  
    var faBackspace = faDeleteLeft;
  

  
  

  var faFaceGrin = {
    prefix: 'fasr',
    iconName: 'face-grin',
    icon: [
      512,
      512,
      [128512,"grin"],
      'f580',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faGrin = faFaceGrin;
  

  
  

  var faCloudSnow = {
    prefix: 'fasr',
    iconName: 'cloud-snow',
    icon: [
      512,
      512,
      [127784],
      'f742',
      
      'M368 128v48h48c26.5 0 48 21.5 48 48v48H416 96 48V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 320H48 96 416h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48 48zm88 32H40v24 16H24 0v48H24 40v16 24H88V456 440h16 24V392H104 88V376 352zm192 32H232v24 16H216 192v48h24 16v16 24h48V488 472h16 24V424H296 280V408 384zm192-8V352H424v24 16H408 384v48h24 16v16 24h48V456 440h16 24V392H488 472V376z'
      
    ]
  };

  

  
  

  var faShelves = {
    prefix: 'fasr',
    iconName: 'shelves',
    icon: [
      640,
      512,
      ["inventory"],
      'f480',
      
      'M48 0V24 160H592V24 0h48V24 160v24 24V416v24 24 24 24H592V488 464H48v24 24H0V488 464 440 416 208 184 160 24 0H48zm0 416H592V208H48V416zM352 0H480V128H352V0zM224 256V384H96V256H224zm160 0V384H256V256H384z'
      
    ]
  };

  
    var faInventory = faShelves;
  

  
  

  var faAnglesUpDown = {
    prefix: 'fasr',
    iconName: 'angles-up-down',
    icon: [
      448,
      512,
      [],
      'e60d',
      
      'M239 498.7l160-128 18.7-15-30-37.5-18.7 15-145 116L79 333.3l-18.7-15-30 37.5 18.7 15 160 128 15 12 15-12zm0-485.5l-15-12-15 12L49 141.3l-18.7 15 30 37.5 18.7-15 145-116 145 116 18.7 15 30-37.5-18.7-15L239 13.3z'
      
    ]
  };

  

  
  

  var faDownload = {
    prefix: 'fasr',
    iconName: 'download',
    icon: [
      512,
      512,
      [],
      'f019',
      
      'M280 24V0H232V24 294.1l-95-95-17-17L86.1 216l17 17L239 369l17 17 17-17L409 233l17-17L392 182.1l-17 17-95 95V24zM128.8 304H48 0v48V464v48H48 464h48V464 352 304H464 383.2l-48 48H464V464H48V352H176.8l-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faArrowsDownToLine = {
    prefix: 'fasr',
    iconName: 'arrows-down-to-line',
    icon: [
      576,
      512,
      [],
      'e4b8',
      
      'M552 432L24 432 0 432l0 48 24 0 528 0 24 0 0-48-24 0zM536 238.1l-17 17-47 47L472 56l0-24-48 0 0 24 0 246.1-47-47-17-17L326.1 272l17 17 88 88 17 17 17-17 88-88 17-17L536 238.1zm-320 0l-17 17-47 47L152 56l0-24-48 0 0 24 0 246.1L57 255l-17-17L6.1 272l17 17 88 88 17 17 17-17 88-88 17-17L216 238.1z'
      
    ]
  };

  

  
  

  var faTugrikSign = {
    prefix: 'fasr',
    iconName: 'tugrik-sign',
    icon: [
      384,
      512,
      [],
      'e2ba',
      
      'M24 32H0V80H24 168V205.3L58.2 232.7l-23.3 5.8 11.6 46.6 23.3-5.8L168 254.7v46.5L58.2 328.7l-23.3 5.8 11.6 46.6 23.3-5.8L168 350.7V456v24h48V456 338.7l109.8-27.5 23.3-5.8-11.6-46.6-23.3 5.8L216 289.3V242.7l109.8-27.5 23.3-5.8-11.6-46.6-23.3 5.8L216 193.3V80H360h24V32H360 192 24z'
      
    ]
  };

  

  
  

  var faBatterySlash = {
    prefix: 'fasr',
    iconName: 'battery-slash',
    icon: [
      640,
      512,
      [],
      'f377',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L565.2 416H576V368 320h32V192H576V144 96H528 153L48.4 14.8zM214.8 144H528V368H503.3L214.8 144zM345.2 368H80V159L32 121.2V144 368v48H80 406.2l-60.9-48z'
      
    ]
  };

  

  
  

  var faClockSixThirty = {
    prefix: 'fasr',
    iconName: 'clock-six-thirty',
    icon: [
      512,
      512,
      [],
      'e353',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V256 232H232v24V392v24h48V392z'
      
    ]
  };

  

  
  

  var faShip = {
    prefix: 'fasr',
    iconName: 'ship',
    icon: [
      576,
      512,
      [128674],
      'f21a',
      
      'M192 0H384V64h72 24V88 243l56.9 22.8 30.9 12.4-21.5 25.4-88 104-36.6-31 66.5-78.6L288 217.8 87.8 297.9l66.5 78.6-36.6 31-88-104L8.2 278.1l30.9-12.4L96 243V88 64h24 72V0zM432 223.8V112H144V223.8l135.1-54 8.9-3.6 8.9 3.6 135.1 54zM79 488.9C59.7 499.8 31.5 512 0 512V464c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  

  
  

  var faGameConsoleHandheld = {
    prefix: 'fasr',
    iconName: 'game-console-handheld',
    icon: [
      384,
      512,
      [],
      'f8bb',
      
      'M48 48V464H336V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM232 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM144 288v32h32v32H144v32H112V352H80V320h32V288h32zM288 96V256H96V96H288z'
      
    ]
  };

  

  
  

  var faPersonSledding = {
    prefix: 'fasr',
    iconName: 'person-sledding',
    icon: [
      512,
      512,
      ["sledding"],
      'f7cb',
      
      'M400 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 128h24H325.6h9.9l7 7 16 16 17.9 17.9-18.8 16.9-87 78.1H352h24v24 96 19.7l64.2 33.3 37.1-18.5 21.5-10.7 21.5 42.9-21.5 10.7-48 24-10.9 5.5-10.9-5.6-416-216L-8.4 258.2l22.1-42.6 21.3 11.1 124.1 64.4c-4.3-11.5-2.2-25.4 8.8-35.1l90.7-80H152 128V128zM328 312H199.3L328 378.8V312z'
      
    ]
  };

  
    var faSledding = faPersonSledding;
  

  
  

  var faBuildingCircleXmark = {
    prefix: 'fasr',
    iconName: 'building-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4d4',
      
      'M48 48H336V294.6c11.1-24.3 27.7-45.5 48-62.3V48 0H336 48 0V48 464v48H48 336h48v-8.2c-20.3-16.8-36.9-38.1-48-62.3V464H240V352H144V464H48V48zM88 88v80h80V88H88zm208 0H216v80h80V88zM88 216v80h80V216H88zm208 0H216v80h80V216zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faSprinkler = {
    prefix: 'fasr',
    iconName: 'sprinkler',
    icon: [
      512,
      512,
      [],
      'e035',
      
      'M48 24A24 24 0 1 0 0 24a24 24 0 1 0 48 0zM24 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM88 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm312 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM464 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM424 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-40-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM240 362.9l-15.6-14.3L175.8 304H232h48 56.2l-48.7 44.6L272 362.9V384v80H240V384 362.9zM232 256H144 96v40l8.7 8L192 384v80 48h48 32 48V464 384l87.3-80 8.7-8V256H368 280V88 64H232V88 256z'
      
    ]
  };

  

  
  

  var faFaceLying = {
    prefix: 'fasr',
    iconName: 'face-lying',
    icon: [
      512,
      512,
      [],
      'e37e',
      
      'M431.3 368H352 328V320h24 88c13.3 0 24-10.7 24-24s-10.7-24-24-24H288 264V224h24H440c7.7 0 15.1 1.2 22.1 3.4C448.1 126.1 361.2 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c73.6 0 138.3-38.3 175.3-96zm67.4-30.3C464.6 439 368.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 8.8-.4 17.6-1.3 26.2c.9 4.5 1.3 9.1 1.3 13.8c0 15.6-4.9 30-13.3 41.7zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM195.2 390.4l-14.4 19.2-38.4-28.8 14.4-19.2C175.7 336.4 206 320 240 320c14.7 0 28.8 3.1 41.6 8.7l22 9.6-19.2 44-22-9.6c-6.8-3-14.4-4.6-22.4-4.6c-18.3 0-34.6 8.8-44.8 22.4z'
      
    ]
  };

  

  
  

  var faCloudRain = {
    prefix: 'fasr',
    iconName: 'cloud-rain',
    icon: [
      512,
      512,
      [9926,127783],
      'f73d',
      
      'M368 128v48h48c26.5 0 48 21.5 48 48v48H416 96 48V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 320H48 96 416h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48 48zm96 48L55.1 436.1c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8L96 368zm160 0l-40.9 68.1c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8L256 368zm119.1 68.1c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8L416 368l-40.9 68.1z'
      
    ]
  };

  

  
  

  var faShovelSnow = {
    prefix: 'fasr',
    iconName: 'shovel-snow',
    icon: [
      512,
      512,
      [],
      'f7c3',
      
      'M400 0L366.1 33.9l-6.9 6.9c-14.9 14.9-23.2 35-23.2 56c0 13.1 3.2 25.5 8.8 36.4L255 223l-63-63L38.8 274.9 0 304l34.3 34.3L173.7 477.7 208 512l29.1-38.8L352 320l-63-63 89.8-89.8c10.9 5.7 23.3 8.8 36.4 8.8c21 0 41.1-8.3 56-23.2l6.9-6.9L512 112 478.1 78.1 433.9 33.9 400 0zm0 67.9L444.1 112l-6.9 6.9c-5.8 5.9-13.8 9.1-22.1 9.1C398 128 384 114 384 96.8c0-8.3 3.3-16.2 9.1-22.1l6.9-6.9zM73.1 309.2l114.4-85.8L288.6 324.5 202.8 438.9 73.1 309.2zm117.1-7.1L204.3 288 176 259.7l-14.1 14.1-32 32L115.7 320 144 348.3l14.1-14.1 32-32zm48 48L252.3 336 224 307.7l-14.1 14.1-32 32L163.7 368 192 396.3l14.1-14.1 32-32z'
      
    ]
  };

  

  
  

  var faCableCar = {
    prefix: 'fasr',
    iconName: 'cable-car',
    icon: [
      512,
      512,
      [57551,128673,"tram"],
      'f7da',
      
      'M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-8a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 272v80H80V272h80zm48 0h96v80H208V272zm144 0h80v80H352V272zm80 128v64H80V400H184 328 432zM80 224H32v48V464v48H80 432h48V464 272 224H432 280V147.4l205-43.9 23.5-5L498.4 51.5l-23.5 5-224 48-224 48-23.5 5 10.1 46.9 23.5-5 195-41.8V224H80z'
      
    ]
  };

  
    var faTram = faCableCar;
  

  
  

  var faGarage = {
    prefix: 'fasr',
    iconName: 'garage',
    icon: [
      640,
      512,
      [],
      'e009',
      
      'M320 6.1l9 3.7 296 120 15 6.1V152 488v24H592V488 168.2L320 57.9 48 168.2V488v24H0V488 152 135.8l15-6.1L311 9.8l9-3.7zM96 192h24H520h24v24V488v24H496V488 368H144V488v24H96V488 216 192zm48 128H496V240H144v80zm136 96h80 24v48H360 280 256V416h24z'
      
    ]
  };

  

  
  

  var faSwap = {
    prefix: 'fasr',
    iconName: 'swap',
    icon: [
      640,
      512,
      [],
      'e609',
      
      'M64 160H16V120l7.5-8L95.2 35.2 128 0l32.8 35.2L232.5 112l7.5 8v40H192 152V432H296V56 32h24l192 0h24V56 212 352h40 48v40l-7.5 8-71.7 76.8L512 512l-32.8-35.2L407.5 400l-7.5-8V352h48 40V212l0-132L344 80V456v24H320 128 104V456 160H64zm102.9-48L128 70.3 89.1 112h77.7zm384 288H473.1L512 441.7 550.9 400z'
      
    ]
  };

  

  
  

  var faN = {
    prefix: 'fasr',
    iconName: 'n',
    icon: [
      384,
      512,
      [110],
      '4e',
      
      'M0 56V32H35.2l7.2 8.6L336 390.1V56 32h48V56 456v24H348.8l-7.2-8.6L48 121.9V456v24H0V456 56z'
      
    ]
  };

  

  
  

  var faPeoplePulling = {
    prefix: 'fasr',
    iconName: 'people-pulling',
    icon: [
      576,
      512,
      [],
      'e535',
      
      'M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zm365.5 70.4l8.8 2.4h0l88 24h0l13.2 3.6 3.6 13.2 22.3 81.9L569 279l8 8L543 321l-8-8-40-40-4.5-4.5-1.7-6.1-6.4-23.4-25.7 82.3 54.4 44.2 6.2 5 1.9 7.8 24 96 5.8 23.3-46.6 11.6-5.8-23.3-22.1-88.2L370 312.6c-18.1-14.7-25.2-39.1-17.8-61.2l22.7-68-35.7 17.9-20.7 55.2-10 26.6-24.6-14.3L160.7 197l62.7 285.8 6.4 29.1H180.7l-4.1-18.9L145.6 352H114.7l35.1 160H100.7L48 271.9V328v24H0V328 152 128H24 131.1h6.5l5.6 3.3L281.9 212l15.8-37 3.1-8.3 .6-.3 7.9-3.9h0l80-40h0l8.2-4.1zm30.3 58l-30 90.1c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3 32.4-103.8c.2-.8 .5-1.6 .9-2.3l-22.1-6zM76.1 176l28.1 128H135L106.9 176H76.1zM416 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM331.5 402.5l24.1-60.4 39 31.7-20.4 51.1-1.8 4.6L369 433l-60.8 60.8-17 17-33.9-33.9 17-17 57.3-57.3z'
      
    ]
  };

  

  
  

  var faEyeEvil = {
    prefix: 'fasr',
    iconName: 'eye-evil',
    icon: [
      640,
      512,
      [],
      'f6db',
      
      'M285.3 130l10.3-14.2L320 82l24.4 33.8L354.7 130l17 4.2c13.5 3.4 26.1 8 37.7 13.6l14.2 6.9 15.5-2.9 25.2-4.6-12.6 25.4 16.5 23.4c4.7 6.7 8.7 13.7 11.7 20.8l6.9 16.2 15.7 7.9L532.7 256l-30.1 15.1-15.7 7.9-6.9 16.2c-3 7.1-7 14.1-11.7 20.8l-16.5 23.4 12.6 25.4-25.2-4.6-15.5-2.9-14.2 6.9c-11.6 5.6-24.3 10.3-37.7 13.6l-17 4.2-10.3 14.2L320 430l-24.4-33.8L285.3 382l-17-4.2c-13.5-3.4-26.1-8-37.7-13.6l-14.2-6.9-15.5 2.9-25.2 4.6 12.6-25.4-16.5-23.4c-4.8-6.7-8.7-13.7-11.7-20.8l-6.9-16.2-15.7-7.9L107.3 256l30.1-15.1 15.7-7.9 6.9-16.2c3-7.1 7-14.1 11.7-20.8l16.5-23.4-12.6-25.4 25.2 4.6 15.5 2.9 14.2-6.9c11.6-5.6 24.3-10.3 37.7-13.6l17-4.2zm5.1-89L256.7 87.7c-16.6 4.2-32.4 9.9-47.1 17L149 93.5 90 82.7l26.7 53.7 15.9 32c-6.6 9.4-12.2 19.3-16.6 29.6L53.7 229.2 0 256l53.7 26.8L116 314c4.4 10.3 10 20.2 16.6 29.6l-15.9 32L90 429.3l59-10.9 60.6-11.2c14.7 7.1 30.4 12.9 47.1 17L290.4 471 320 512l29.6-41 33.7-46.7c16.6-4.2 32.4-9.9 47.1-17L491 418.5l59 10.9-26.7-53.7-15.9-32c6.6-9.4 12.2-19.3 16.6-29.6l62.3-31.2L640 256l-53.7-26.8L524 198c-4.4-10.3-10-20.2-16.6-29.6l15.9-32L550 82.7 491 93.5l-60.6 11.2c-14.7-7.1-30.4-12.9-47.1-17L349.6 41 320 0 290.4 41zM256 245.5c12.3 4.1 25.1 7.1 38.3 8.8C303.7 276 320 288 320 288s16.3-12 25.6-33.6c13.2-1.7 26-4.7 38.3-8.8c0 .8 0 1.6 0 2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-.8 0-1.6 0-2.5zM217.9 228c-1.3 6.5-1.9 13.1-1.9 20c0 57.4 46.6 104 104 104s104-46.6 104-104c0-6.8-.7-13.5-1.9-20c-2.5-12.7-7.3-24.6-13.9-35.2c-.5-.8-1-1.5-1.5-2.3c-25 16.1-54.7 25.5-86.7 25.5s-61.7-9.4-86.7-25.5c-.5 .8-1 1.5-1.5 2.3c-6.6 10.6-11.4 22.5-13.9 35.2z'
      
    ]
  };

  

  
  

  var faUserHair = {
    prefix: 'fasr',
    iconName: 'user-hair',
    icon: [
      448,
      512,
      [],
      'e45a',
      
      'M304 144V128c0-11.4-2.4-22.2-6.7-32H256L240 80l-32 32H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 0c70.7 0 128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128C96 57.3 153.3 0 224 0zM66.6 464H381.4l-32-96H98.6l-32 96zM64 320H384l48 144 16 48H397.4 50.6 0l16-48L64 320z'
      
    ]
  };

  

  
  

  var faShuttlecock = {
    prefix: 'fasr',
    iconName: 'shuttlecock',
    icon: [
      512,
      512,
      [],
      'f45b',
      
      'M217 0h15 72 24V24 80h80 24v24 80h56 24v24 72 15l-13.5 6.6-251 121.9c-.7 1.4-1.7 2.7-2.8 3.8l-51.5 51.5c-21.2 21.2-50 33.1-80 33.1C50.7 512 0 461.3 0 398.9c0-30 11.9-58.8 33.1-80l51.5-51.5c1.2-1.2 2.5-2.1 3.8-2.8l121.9-251L217 0zm5.4 382.3l80-38.9 48-92.1-81.5 25.7L193 353l29.4 29.4zM384 186.8V128H325.2l-4.4 2.3-28.1 88.9 88.9-28.1 2.3-4.4zM168.5 209.6l-38.9 80L159 319l75.9-75.9 25.7-81.5-92.1 48zm35.2-72.4L280 97.4V48H247l-43.3 89.2zM188.1 416L96 323.9 73.3 346.6l92.1 92.1L188.1 416zm-48.4 42.3l-86-86C50 380.6 48 389.6 48 398.9c0 36 29.2 65.1 65.1 65.1c9.2 0 18.3-2 26.6-5.7zM414.6 232l-39.7 76.3L464 265V232H414.6z'
      
    ]
  };

  

  
  

  var faCalculator = {
    prefix: 'fasr',
    iconName: 'calculator',
    icon: [
      384,
      512,
      [128425],
      'f1ec',
      
      'M336 176H48V464H336V176zm0-48V48H48v80H336zm48 0v24 24V464v48H336 48 0V464 176 152 128 48 0H48 336h48V48v80zM80 208h48v48H80V208zm48 88v48H80V296h48zM80 384H216v48H80V384zM216 208v48H168V208h48zm-48 88h48v48H168V296zm136-88v48H256V208h48zm-48 88h48v48H256V296zm48 88v48H256V384h48z'
      
    ]
  };

  

  
  

  var faImages = {
    prefix: 'fasr',
    iconName: 'images',
    icon: [
      576,
      512,
      [],
      'f302',
      
      'M144 80H528V336H490.8L388.1 178.9 368 148.1l-20.1 30.7-52.2 79.8-12.4-16.9L264 215.4l-19.4 26.4L175.6 336H144V80zM96 32V80 336v48h48H528h48V336 80 32H528 144 96zM48 120V96H0v24V456v24H24 456h24V432H456 48V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faVenusDouble = {
    prefix: 'fasr',
    iconName: 'venus-double',
    icon: [
      640,
      512,
      [9890],
      'f226',
      
      'M192 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM368 176c0 89.1-66.2 162.7-152 174.4V400h48 24v48H264 216v40 24H168V488 448H120 96V400h24 48V350.4C82.2 338.7 16 265.1 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c10.9-11.7 20.5-24.6 28.5-38.6C393.7 294.9 419.8 304 448 304c70.7 0 128-57.3 128-128s-57.3-128-128-128c-28.2 0-54.3 9.1-75.5 24.6c-8-14-17.6-26.9-28.5-38.6C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 89.1-66.2 162.7-152 174.4V400h48 24v48H520 472v40 24H424V488 448H376 352V400h24 48V350.4c-29.7-4-57-15.5-80-32.4z'
      
    ]
  };

  

  
  

  var faRightFromLine = {
    prefix: 'fasr',
    iconName: 'right-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-left"],
      'f347',
      
      'M224 288l48 0 0 48 0 28.1L380.1 256 272 147.9l0 28.1 0 48-48 0-80 0 0 64 80 0zm190.1 1.9L288 416l-16 0-48 0 0-32 0-16 0-32-48 0-32 0-48 0 0-48 0-64 0-48 48 0 32 0 48 0 0-32 0-16 0-32 48 0 16 0L414.1 222.1 448 256l-33.9 33.9zM48 88l0 336 0 24L0 448l0-24L0 88 0 64l48 0 0 24z'
      
    ]
  };

  
    var faArrowAltFromLeft = faRightFromLine;
  

  
  

  var faPersonHiking = {
    prefix: 'fasr',
    iconName: 'person-hiking',
    icon: [
      384,
      512,
      ["hiking"],
      'f6ec',
      
      'M288 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 96H48L0 272l96 16L144 96zm240 88V160H336v24 24H308.8L268 146.7l-5.4-8.1-9.5-2-56-12-23.1-5-5.3 23.1-27.7 121c-4.7 20.4 2.4 41.7 18.4 55.2L240 387.1V488v24h48V488 376 364.9l-8.5-7.2-33.1-28 22.4-95.2 7.2 10.9 7.1 10.7H296h40V488v24h48V488 184zM205.3 294.9l-14.9-12.6c-2.3-1.9-3.3-5-2.6-7.9l22.4-97.9 21.9 4.7L205.3 294.9zm-81 32.8L72.3 512h49.9l41.6-147.5-24.8-21c-5.6-4.7-10.5-10.1-14.6-15.8z'
      
    ]
  };

  
    var faHiking = faPersonHiking;
  

  
  

  var faClosedCaptioning = {
    prefix: 'fasr',
    iconName: 'closed-captioning',
    icon: [
      576,
      512,
      [],
      'f20a',
      
      'M528 80V432H48V80H528zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM200 208c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-46.9-44.6-81.1-44.6c-53 0-96 43-96 96s43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C232 295.1 217 304 200 304c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-47-44.6-81.1-44.6c-53 0-96 43-96 96s43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C424 295.1 409 304 392 304c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faBadminton = {
    prefix: 'fasr',
    iconName: 'badminton',
    icon: [
      576,
      512,
      [],
      'e33a',
      
      'M228.9 100.9C193.7 136.1 176 180.4 176 221c0 31.9 10.9 61.1 32.4 82.6c48.2 48.2 138.8 43.5 202.7-20.5C446.3 247.9 464 203.6 464 163c0-31.9-10.9-61.1-32.4-82.6S380.8 48 349 48c-40.6 0-84.9 17.7-120.1 52.9zM194.9 66.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-70.3 70.3-178.8 90.2-252.3 36.2L161 385l23 23-33.9 33.9-36.1 36.1L80 512 46.1 478.1 33.9 465.9 0 432l33.9-33.9 36.1-36.1L104 328l23 23 31.8-31.8C137.9 290.5 128 256 128 221c0-54.2 23.4-110.5 66.9-154zM116.1 408L104 395.9 67.9 432 80 444.1 116.1 408zM512 352c26.5 0 48 21.5 48 48v32H464V400c0-26.5 21.5-48 48-48zm-48.5 96h97.1l11.1 39 4.4 15.4-30.8 8.8-4.4-15.4L528 450.6V496v16H496V496 450.6l-12.9 45.2-4.4 15.4L448 502.4l4.4-15.4 11.1-39z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleExclamation = {
    prefix: 'fasr',
    iconName: 'house-medical-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e512',
      
      'M288 .5l15.5 13.2L514.8 193c-6.2-.7-12.5-1-18.8-1c-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8V464H348.5c12.3 18.8 28 35.1 46.3 48H88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224V416H480v32h32zm0-176H480v16 80 16h32V368 288 272z'
      
    ]
  };

  

  
  

  var faGearComplexCode = {
    prefix: 'fasr',
    iconName: 'gear-complex-code',
    icon: [
      512,
      512,
      [],
      'e5eb',
      
      'M216 0H197.1l-4.4 18.4L180 71l-1.1 .4L132.8 43.2l-16.1-9.9L103.3 46.7 46.7 103.3 33.3 116.6l9.9 16.1 28.2 46.2L71 180 18.4 192.7 0 197.1V216v80 18.9l18.4 4.4L71 332l.4 1.1L43.2 379.3l-9.9 16.1 13.4 13.4 56.6 56.6 13.4 13.4 16.1-9.9 46.2-28.2 1.1 .4 12.7 52.6 4.4 18.4H216h80 18.9l4.4-18.4L332 441l1.1-.4 46.2 28.2 16.1 9.9 13.4-13.4 56.6-56.6 13.4-13.4-9.9-16.1-28.2-46.2 .4-1.1 52.6-12.7 18.4-4.4V296 216 197.1l-18.4-4.4L441 180l-.4-1.1 28.2-46.2 9.9-16.1-13.4-13.4L408.7 46.7 395.4 33.3l-16.1 9.9L333.1 71.4 332 71 319.3 18.4 314.9 0H296 216zm7.6 94.6L234.9 48h42.2l11.3 46.6 3.1 12.9 12.6 4.2c6.8 2.3 13.5 5 19.9 8.2l11.9 6 11.4-6.9 40.9-25L418 123.8l-25 40.9L386 176.1l6 11.9c3.2 6.4 6 13 8.2 19.9l4.2 12.6 12.9 3.1L464 234.9v42.2l-46.6 11.3-12.9 3.1-4.2 12.6c-2.3 6.8-5 13.5-8.2 19.9l-6 11.9 6.9 11.4 25 40.9L388.2 418l-40.9-25L335.9 386 324 392c-6.4 3.2-13 6-19.9 8.2l-12.6 4.2-3.1 12.9L277.1 464H234.9l-11.3-46.6-3.1-12.9-12.6-4.2c-6.8-2.3-13.5-5-19.9-8.2l-11.9-6L164.8 393l-40.9 25L94 388.2l25-40.9 6.9-11.4L120 324c-3.2-6.4-6-13-8.2-19.9l-4.2-12.6-12.9-3.1L48 277.1V234.9l46.6-11.3 12.9-3.1 4.2-12.6c2.3-6.8 5-13.5 8.2-19.9l6-11.9L119 164.8 94 123.8 123.8 94l40.9 25 11.4 6.9 11.9-6c6.4-3.2 13-6 19.9-8.2l12.6-4.2 3.1-12.9zm68.1 68.7l3.3-19.7L255.6 137l-3.3 19.7-32 192L217 368.4l39.5 6.6 3.3-19.7 32-192zm-93.6 66.9L212.3 216 184 187.7l-14.1 14.1-40 40L115.7 256l14.1 14.1 40 40L184 324.3 212.3 296l-14.1-14.1L172.3 256l25.9-25.9zm144-28.3L328 187.7 299.7 216l14.1 14.1L339.7 256l-25.9 25.9L299.7 296 328 324.3l14.1-14.1 40-40L396.3 256l-14.1-14.1-40-40z'
      
    ]
  };

  

  
  

  var faCirclePhoneHangup = {
    prefix: 'fasr',
    iconName: 'circle-phone-hangup',
    icon: [
      512,
      512,
      ["phone-circle-down"],
      'e11d',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM378.7 304L416 246.8l-10.7-10.4c-82.5-80.5-216.2-80.5-298.7 0L96 246.8 133.3 304 208 283.2l-5.6-49.1c34.9-10.5 72.3-10.5 107.2 0L304 283.2 378.7 304z'
      
    ]
  };

  
    var faPhoneCircleDown = faCirclePhoneHangup;
  

  
  

  var faCompressWide = {
    prefix: 'fasr',
    iconName: 'compress-wide',
    icon: [
      512,
      512,
      [],
      'f326',
      
      'M160 88V64H112V88v88H24 0v48H24 136h24V200 88zM24 288H0v48H24h88v88 24h48V424 312 288H136 24zM400 88V64H352V88 200v24h24H488h24V176H488 400V88zM376 288H352v24V424v24h48V424 336h88 24V288H488 376z'
      
    ]
  };

  

  
  

  var faFaceSpiralEyes = {
    prefix: 'fasr',
    iconName: 'face-spiral-eyes',
    icon: [
      512,
      512,
      [],
      'e485',
      
      'M464 256c0-114.9-93.1-208-208-208c-71 0-133.6 35.5-171.1 89.8c18.5-21.6 45.8-36.5 76.6-37.7l12-.5 1 24-12 .5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2l-.1-.1 .5 5.8c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-1.2-11.3 0-22.5 3-33.3C53.5 201.5 48 228.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm337.6 36.5l12-.5c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2l.1 .1-.5-5.8c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5l-12 .5-1-24zM281 402.7l-25-20-25 20-13.7 11L202.7 404l-31.6-21.1L161 393l-17 17L110.1 376l17-17 24-24 13.9-13.9L181.3 332l33.4 22.3 26.3-21 15-12 15 12 26.3 21L330.7 332l16.4-10.9L361 335l24 24 17 17L368 409.9l-17-17-10.1-10.1L309.3 404l-14.6 9.7-13.7-11z'
      
    ]
  };

  

  
  

  var faArrowUpFromArc = {
    prefix: 'fasr',
    iconName: 'arrow-up-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b4',
      
      'M134.4 130.9l-16.3 17.6 35.2 32.7 16.3-17.6L232 96.3 232 328v24h48l0-24V96.3l62.4 67.2 16.3 17.6 35.2-32.7-16.3-17.6-104-112L256-.1 238.4 18.9l-104 112zM256 464C141.1 464 48 370.9 48 256H0C0 397.4 114.6 512 256 512s256-114.6 256-256V232H464v24c0 114.9-93.1 208-208 208z'
      
    ]
  };

  

  
  

  var faPipeValve = {
    prefix: 'fasr',
    iconName: 'pipe-valve',
    icon: [
      512,
      512,
      [],
      'e439',
      
      'M280 56V32H232V56 77.6L96 64v64l136-13.6V192H48v-8V160H0v24 32V424v32 24H48V456v-8H464v8 24h48V456 424 216 184 160H464v24 8H280V114.4L416 128V64L280 77.6V56zM48 400V240H256 464V400H48z'
      
    ]
  };

  

  
  

  var faClockFiveThirty = {
    prefix: 'fasr',
    iconName: 'clock-five-thirty',
    icon: [
      512,
      512,
      [],
      'e34a',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V335.3l20 30 13.3 20 39.9-26.6-13.3-20-64-96L232 256V392v24h48V392z'
      
    ]
  };

  

  
  

  var faPersonRifle = {
    prefix: 'fasr',
    iconName: 'person-rifle',
    icon: [
      576,
      512,
      [],
      'e54e',
      
      'M240 0c-44.2 0-80 35.8-80 80s35.8 80 80 80c43.9 0 79.5-35.3 80-79V79c-.5-43.7-36.1-79-80-79zM160 192H144.1l-6.2 14.6-88 208-9.4 22.1 44.2 18.7 9.4-22.1L152 296.5V512h48V240h72V512h48V277.6l0-85.6H160zM208 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM416 0H400V32h16v96H400v16 32 16H352v48 96 48h16 32 16v48 32 48h46.5H464h48l-12-48-16-64h60V352H480V325.3L544 304V192H496v72l-16 5.3V176 128H464V0H448 416zm16 336H416 400V240h32v96z'
      
    ]
  };

  

  
  

  var faDiagramNext = {
    prefix: 'fasr',
    iconName: 'diagram-next',
    icon: [
      512,
      512,
      [],
      'e476',
      
      'M512 224V32H0V224H232v86.1l-23-23-17-17L158.1 304l17 17 64 64 17 17 17-17 64-64 17-17L320 270.1l-17 17-23 23V224H512zM48 288H0v48 96 48H48l416 0h48V432 336 288H464l-80.8 0 16 16-32 32H464v96H368 144l-96 0 0-96h96.8l-32-32 16-16L48 288z'
      
    ]
  };

  

  
  

  var faChartTreeMap = {
    prefix: 'fasr',
    iconName: 'chart-tree-map',
    icon: [
      512,
      512,
      [],
      'e0ea',
      
      'M176 80V192H48V80H176zM48 32H0V80 192v48H48 176h48V192 80 32H176 48zM176 320V432H48V320H176zM48 272H0v48V432v48H48 176h48V432 320 272H176 48zM304 80H464v32H304V80zM256 32V80v32 48h48H464h48V112 80 32H464 304 256zM464 240v32H304V240H464zM304 192H256v48 32 48h48H464h48V272 240 192H464 304zm0 208H464v32H304V400zm-48-48v48 32 48h48H464h48V432 400 352H464 304 256z'
      
    ]
  };

  

  
  

  var faTty = {
    prefix: 'fasr',
    iconName: 'tty',
    icon: [
      512,
      512,
      ["teletype"],
      'f1e4',
      
      'M322 253.2V188.8c-42.3-17.2-89.7-17.2-132 0v64.4L32 288-8 152.6C22.8 112.4 118.7 32 256 32s233.2 80.4 264 120.6L480 288 322 253.2zM142 188.8V156.4l29.9-12.2c53.9-21.9 114.2-21.9 168.1 0L370 156.4v32.3 25.9l76.6 16.9 19.7-66.8C431 130.1 356.3 80 256 80S81 130.1 45.6 164.7l19.7 66.8L142 214.6V188.8zM32 320H96v64H32V320zm0 96H96v64H32V416zm160-96v64H128V320h64zm32 0h64v64H224V320zm160 0v64H320V320h64zm32 0h64v64H416V320zm64 96v64H416V416h64zm-352 0H384v64H128V416z'
      
    ]
  };

  
    var faTeletype = faTty;
  

  
  

  var faLaptopFile = {
    prefix: 'fasr',
    iconName: 'laptop-file',
    icon: [
      640,
      512,
      [],
      'e51d',
      
      'M464 48H112V320H320v64H32L0 352V320H64V48 0h48H464h48V48 96H464V48zM400 464H592V256H512V176H400V464zM544 128l96 96V464v48H592 400 352V464 176 128h48H544z'
      
    ]
  };

  

  
  

  var faFlagUsa = {
    prefix: 'fasr',
    iconName: 'flag-usa',
    icon: [
      448,
      512,
      [],
      'f74d',
      
      'M48 0V24 52l85-21.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0L400 40l48-24V69.7v62.7 51.3 52.7 51.3V384l-55.5 20.8c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L48 404l0 84v24H0V488 416 366.5 313.2 264 217.2 168 64 24 0H48zm0 252.9l68.5-15.8c39.8-9.2 81.4-6.9 119.9 6.6l41.9 14.7c37.1 13 77.6 12.5 114.5-1.3l7.3-2.7V201.6c-42.9 14.9-89.4 15.9-132.9 2.8l-49.3-14.8c-28-8.4-57.6-9.3-86.1-2.8L48 206.2v46.7zm128-179v60.7c18.8 .6 37.5 3.6 55.6 9l49.3 14.8c35.2 10.6 72.9 9.3 107.3-3.6l11.8-4.4V93c-56.4 22.9-120.2 20.6-175-6.8c-15.3-7.7-32.1-11.8-49-12.3zM400 305.4c-44.7 14.4-93.1 13.9-137.6-1.7L220.5 289c-30-10.5-62.3-12.3-93.3-5.1L48 302.2v52.4l68.6-17.2c52.2-13.1 107.4-7 155.6 17.1c32.2 16.1 69.7 18.1 103.4 5.4l24.4-9.1V305.4zM96 104a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 152a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCitrus = {
    prefix: 'fasr',
    iconName: 'citrus',
    icon: [
      512,
      512,
      [],
      'e2f4',
      
      'M288 112v16h16 80c53 0 96-43 96-96V16 0H464 384c-31 0-58.7 14.7-76.2 37.6c-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7c-13.5 9.1-28.8 15.7-45.3 19.1c23.9 32 38 71.7 38 114.6c0 106-86 192-192 192S64 378 64 272S150 80 256 80c11.2 0 22.2 1 32.9 2.8c-.6 4.3-.9 8.7-.9 13.2v16z'
      
    ]
  };

  

  
  

  var faLightsHoliday = {
    prefix: 'fasr',
    iconName: 'lights-holiday',
    icon: [
      640,
      512,
      [],
      'f7b2',
      
      'M12.8 88C2.3 109.6 2.3 109.6 2.3 109.6l0 0 0 0 .1 .1 .4 .2 1.2 .6c1 .5 2.5 1.2 4.5 2c3.9 1.7 9.4 4 16.7 6.8c14.5 5.5 35.7 12.8 63 20C142.8 153.7 221.7 168 320 168s177.2-14.3 231.8-28.8c27.3-7.2 48.5-14.5 63-20c7.3-2.8 12.9-5.1 16.7-6.8c1.9-.8 3.4-1.5 4.5-2l1.2-.6 .4-.2 .1-.1 0 0 0 0s0 0-10.5-21.6s-10.5-21.6-10.5-21.6l-.1 .1-.8 .4c-.7 .3-1.9 .9-3.5 1.6c-3.2 1.4-8.1 3.4-14.6 5.9c-13.1 5-32.7 11.7-58.2 18.5C488.4 106.3 413.7 120 320 120s-168.4-13.7-219.4-27.2C75 86 55.4 79.3 42.3 74.3c-6.5-2.5-11.4-4.5-14.6-5.9c-1.6-.7-2.8-1.2-3.5-1.6l-.8-.4-.1-.1 0 0 0 0 0 0s0 0-10.5 21.6zM116 222.6c-34-1.5-66.5 18.9-78.7 52.6C15.4 335.3 68.7 422.8 68.7 422.8s97.1-32.8 119-92.9c12.3-33.7 .5-70.2-26.5-90.9l15.5-42.6c-16.9-2.8-32.8-6-47.7-9.4L116 222.6zm180 37.1c-32.5 10.2-56 40.5-56 76.3c0 64 80 128 80 128s80-64 80-128c0-35.8-23.5-66.1-56-76.3v-52c-7.9 .2-15.9 .3-24 .3s-16.1-.1-24-.3v52zM478.9 239c-27 20.7-38.8 57.2-26.5 90.9c21.9 60.1 119 92.9 119 92.9s53.3-87.5 31.4-147.6c-12.3-33.7-44.7-54.1-78.7-52.6L511 187c-14.8 3.4-30.8 6.6-47.7 9.4L478.9 239zM82.4 291.6c6-16.6 24.4-25.2 41-19.1s25.2 24.4 19.1 41c-4.8 13.3-21.5 29.3-46.7 43.9c-1.4 .8-2.8 1.6-4.2 2.4c-.6-1.5-1.1-3-1.7-4.5c-9.9-27.4-12.4-50.4-7.5-63.7zM288 336c0-17.7 14.3-32 32-32s32 14.3 32 32c0 14.1-10.2 34.9-28.9 57.3c-1 1.3-2.1 2.5-3.1 3.7c-1-1.2-2.1-2.4-3.1-3.7C298.2 370.9 288 350.1 288 336zm228.6-63.5c16.6-6 35 2.5 41 19.1c4.8 13.3 2.3 36.2-7.5 63.7c-.6 1.5-1.1 3-1.7 4.5c-1.4-.8-2.8-1.6-4.2-2.4c-25.2-14.7-41.9-30.7-46.7-43.9c-6-16.6 2.5-35 19.1-41z'
      
    ]
  };

  

  
  

  var faPipeCollar = {
    prefix: 'fasr',
    iconName: 'pipe-collar',
    icon: [
      512,
      512,
      [],
      'e437',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zm48 0c0 46.4-12.3 89.8-33.9 127.4l33.2 32.1L512 512l-96.6-.7-32.1-33.2C345.8 499.7 302.4 512 256 512c-46.5 0-90.2-12.4-127.8-34.1L95.9 511.3H0V415.4l33.6-32.5C12.2 345.5 0 302.2 0 256c0-46.4 12.3-89.9 33.9-127.4L0 95.9V0H95.9l32.8 33.9C166.1 12.3 209.6 0 256 0c46.2 0 89.5 12.2 126.9 33.6L415.4 0h95.9V95.9l-33.4 32.3C499.6 165.8 512 209.5 512 256zm-144 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zM80 64A16 16 0 1 0 48 64a16 16 0 1 0 32 0zm0 384a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faPersonDressSimple = {
    prefix: 'fasr',
    iconName: 'person-dress-simple',
    icon: [
      256,
      512,
      [],
      'e21c',
      
      'M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM63.6 336H192.4L155.8 208H100.2L63.6 336zM64 160H192l50.3 176L256 384H206.1 192V488v24H144V488 384H112V488v24H64V488 384H49.9 0l13.7-48L64 160z'
      
    ]
  };

  

  
  

  var faCircleB = {
    prefix: 'fasr',
    iconName: 'circle-b',
    icon: [
      512,
      512,
      [],
      'e0fd',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v24 80 24 24 80 24h24H292c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76H184 160zm144 76c0 15.5-12.5 28-28 28H208V176h68c15.5 0 28 12.5 28 28zM208 336V280h68 16c15.5 0 28 12.5 28 28s-12.5 28-28 28H208z'
      
    ]
  };

  

  
  

  var faRightLong = {
    prefix: 'fasr',
    iconName: 'right-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-right"],
      'f30b',
      
      'M352 224l-48 0L48 224l0 64 256 0 48 0 0 48 0 12.1L444.1 256 352 163.9l0 12.1 0 48zm126.1-1.9L512 256l-33.9 33.9L352 416l-48 0 0-32 0-16 0-32-48 0L48 336 0 336l0-48 0-64 0-48 48 0 208 0 48 0 0-32 0-16 0-32 48 0L478.1 222.1z'
      
    ]
  };

  
    var faLongArrowAltRight = faRightLong;
  

  
  

  var faLaptopSlash = {
    prefix: 'fasr',
    iconName: 'laptop-slash',
    icon: [
      640,
      512,
      [],
      'e1c7',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-13.6-10.6L640 416V400 352H592 482.7L132.4 80H528V320h48V80 32H528 112 70.5L48.4 14.8zM544.6 400h43.6l-19 19-24.5-19zM112 184.4L64 146.6V320h48V184.4zM385.7 400l-60.9-48H48 0v48 16l64 64H487.2l-60.9-48H83.9l-32-32H385.7z'
      
    ]
  };

  

  
  

  var faCoin = {
    prefix: 'fasr',
    iconName: 'coin',
    icon: [
      512,
      512,
      [129689],
      'f85c',
      
      'M98.5 268C59.1 245.8 48 222.7 48 208s11.1-37.8 50.5-60c37.9-21.3 93.5-36 157.5-36s119.6 14.7 157.5 36c39.4 22.2 50.5 45.3 50.5 60s-11.1 37.8-50.5 60C375.6 289.3 320 304 256 304s-119.6-14.7-157.5-36zM256 64C114.6 64 0 128.5 0 208l0 48 0 64c0 70.7 114.6 128 256 128s256-57.3 256-128l0-64 0-48c0-79.5-114.6-144-256-144zM216 350.3c13 1.1 26.4 1.7 40 1.7s27-.6 40-1.7l0 48c-12.9 1.1-26.3 1.7-40 1.7s-27.1-.6-40-1.7l0-48zm-32-4l0 48.1c-23.7-3.9-45.3-9.6-64-16.6l0-47.7c19.7 7 41.2 12.5 64 16.2zM48 292c11.6 9.1 25 17.4 40 24.7l0 46.5C54.2 344.2 48 326.8 48 320l0-28zM328 394.3l0-48.1c22.8-3.8 44.3-9.2 64-16.2l0 47.7c-18.7 7-40.3 12.7-64 16.6zm96-31.2l0-46.5c15-7.3 28.4-15.6 40-24.7l0 28c0 6.8-6.2 24.2-40 43.1zM256 184c40.2 0 75.7 5.2 100.3 12.9c11.8 3.7 19.9 7.7 24.7 11.1c-4.8 3.4-12.9 7.3-24.7 11.1c-24.6 7.8-60 12.9-100.3 12.9s-75.7-5.2-100.3-12.9c-11.8-3.7-19.9-7.7-24.7-11.1c4.8-3.4 12.9-7.3 24.7-11.1c24.6-7.8 60-12.9 100.3-12.9zm128.8 27.4a.2 .2 0 1 0 -.4 .1 .2 .2 0 1 0 .4-.1zm-.1-6.6a.2 .2 0 1 0 -.1-.5 .2 .2 0 1 0 .1 .5zm-257.4-.2a.2 .2 0 1 0 .4-.1 .2 .2 0 1 0 -.4 .1zm.1 6.6a.2 .2 0 1 0 .1 .5 .2 .2 0 1 0 -.1-.5zM432 208c0-17.7-11.3-30.3-21.6-37.9c-10.7-8-24.6-14.2-39.7-18.9c-30.4-9.6-71-15.2-114.7-15.2s-84.3 5.6-114.7 15.2c-15.1 4.8-29 10.9-39.7 18.9C91.3 177.7 80 190.3 80 208s11.3 30.3 21.6 37.9c10.7 8 24.6 14.2 39.7 18.9c30.4 9.6 71 15.2 114.7 15.2s84.3-5.6 114.7-15.2c15.1-4.8 29-10.9 39.7-18.9c10.3-7.7 21.6-20.2 21.6-37.9z'
      
    ]
  };

  

  
  

  var faPowerOff = {
    prefix: 'fasr',
    iconName: 'power-off',
    icon: [
      512,
      512,
      [9211],
      'f011',
      
      'M280 24V0H232V24 264v24h48V264 24zM56 262c0-63.4 30.7-119.7 78.2-154.7L105.8 68.7C46.5 112.3 8 182.7 8 262C8 394.6 115.5 502 248 502s240-107.5 240-240c0-79.3-38.5-149.7-97.8-193.3l-28.5 38.6c47.5 35 78.2 91.2 78.2 154.7c0 106-86 192-192 192S56 368 56 262z'
      
    ]
  };

  

  
  

  var faTicket = {
    prefix: 'fasr',
    iconName: 'ticket',
    icon: [
      576,
      512,
      [127903],
      'f145',
      
      'M0 64v48 48 48c26.5 0 48 21.5 48 48s-21.5 48-48 48v48 48 48H48 528h48V400 352 304c-26.5 0-48-21.5-48-48s21.5-48 48-48V160 112 64H528 48 0zM96 256c0-35.5-19.3-66.6-48-83.2V112H528v60.8c-28.7 16.6-48 47.6-48 83.2s19.3 66.6 48 83.2V400H48V339.2c28.7-16.6 48-47.6 48-83.2zm80-48H400v96H176V208zm-48-48v48 96 48h48H400h48V304 208 160H400 176 128z'
      
    ]
  };

  

  
  

  var faSwordLaserAlt = {
    prefix: 'fasr',
    iconName: 'sword-laser-alt',
    icon: [
      512,
      512,
      [],
      'e03c',
      
      'M232.4 224L480 0l32 32L338.3 224H232.4zM129.9 478.1L96 512 62.1 478.1 33.9 449.9 0 416l33.9-33.9L160 256H284.1 352l-48 48L129.9 478.1zm39.4-107.3L236.1 304H179.9l-38.6 38.6 28.1 28.1zm-22.6 22.6l-28.1-28.1L67.9 416 96 444.1l50.7-50.7z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fasr',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M24 56h80v80H24V56zm0 160h80v80H24V216zm80 160v80H24V376h80z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faRouter = {
    prefix: 'fasr',
    iconName: 'router',
    icon: [
      576,
      512,
      [],
      'f8da',
      
      'M352 48c58.8 0 112.5 21.8 153.4 57.9l31.7-36C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9l31.7 36C239.5 69.8 293.2 48 352 48zm24 200V224H328v24 56H48 0v48V464v48H48 528h48V464 352 304H528 376V248zM48 352H528V464H48V352zm160 32H160v48h48V384zM80 384v48h48V384H80zM276.5 186.7C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7l30.2-37.3C428.8 126 392 112 352 112s-76.8 14-105.7 37.4l30.2 37.3z'
      
    ]
  };

  

  
  

  var faWandSparkles = {
    prefix: 'fasr',
    iconName: 'wand-sparkles',
    icon: [
      512,
      512,
      [],
      'f72b',
      
      'M144 476.1L112 512 78 478 34 434 0 400l35.9-32L96 314.3V256h65.3L448 0l64 64-64 71.7V192H397.7L144 476.1zM444.7 67.3L69.9 402 110 442.1 444.7 67.3zM432 448l-24-56-56-24 56-24 24-56 24 56 56 24-56 24-24 56zM56 168L0 144l56-24L80 64l24 56 56 24-56 24L80 224 56 168zM208 96L192 64 160 48l32-16L208 0l16 32 32 16L224 64 208 96z'
      
    ]
  };

  

  
  

  var faSquareU = {
    prefix: 'fasr',
    iconName: 'square-u',
    icon: [
      448,
      512,
      [],
      'e281',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM160 160V280c0 35.3 28.7 64 64 64s64-28.7 64-64V160 136h48v24V280c0 61.9-50.1 112-112 112s-112-50.1-112-112V160 136h48v24z'
      
    ]
  };

  

  
  

  var faPersonPregnant = {
    prefix: 'fasr',
    iconName: 'person-pregnant',
    icon: [
      384,
      512,
      [],
      'e31e',
      
      'M240 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 384h32V488v24h48V488 384h16 16V488v24h48V488 384h48 48V336 320c0-46.8-33.4-85.7-77.7-94.3L256 128H216 192 148.6 132.9 118.5l-6.8 12.7-76.9 144L23.5 305.9l42.3 22.6 11.3-21.2L96 272.1V336v48zM216 176h.2l11 58.6 6 32.1 32.1 6.2c22.1 4.3 38.8 23.8 38.8 47.1v16H192 144V182.2l0 0V176h3.3H176h16 24z'
      
    ]
  };

  

  
  

  var faFlask = {
    prefix: 'fasr',
    iconName: 'flask',
    icon: [
      448,
      512,
      [],
      'f0c3',
      
      'M272 214.9V48H176V214.9v13.6l-7.1 11.6L119.7 320H328.3l-49.2-79.9L272 228.5V214.9zM320 48V214.9l128 208V464v48H400 48 0V464 422.9l128-208V48h-8H96V0h24 8 48 96 48 8 24V48H328h-8z'
      
    ]
  };

  

  
  

  var faSwordsLaser = {
    prefix: 'fasr',
    iconName: 'swords-laser',
    icon: [
      640,
      512,
      [],
      'e03d',
      
      'M128 32L352 279.6V173.7L160 0 128 32zM640 416l-33.9-33.9L432 208l-48-48 0 67.9V352L510.1 478.1 544 512l33.9-33.9 28.1-28.1L640 416zM432 275.9l66.7 66.7-28.1 28.1L432 332.1V275.9zM572.1 416L544 444.1l-50.7-50.7 28.1-28.1L572.1 416zM203.8 249.9L185 231l-17-17L134.1 248l17 17L0 416v48l32 32 16 16H96L247 361l17 17L297.9 344l-17-17-18.8-18.8 36.3-40.1L246.8 211l-43 38.9zM411.9 142.6L512 32 480 0 369.4 100.1l37.3 37.3 5.3 5.3zM185 298.9L213.1 327l-12.7 12.7-28.1-28.1L185 298.9zm-7.2 63.4l-12.4 12.4-28.1-28.1 12.4-12.4 28.1 28.1zm-35 35L76.1 464H67.9l-1.9-1.9L48 444.1v-8.2l66.6-66.6 28.1 28.1z'
      
    ]
  };

  

  
  

  var faCentSign = {
    prefix: 'fasr',
    iconName: 'cent-sign',
    icon: [
      384,
      512,
      [],
      'e3f5',
      
      'M240 0V24 72.5C277.9 75 313 88 341.9 108.4l-27.7 39.2C289.7 130.3 259.2 120 226 120c-82 0-146 62.2-146 136s64 136 146 136c33.3 0 63.7-10.3 88.2-27.6l27.7 39.2C313 424 277.9 437 240 439.5V488v24H192V488 437.2C102 422 32 347.7 32 256s70-166 160-181.2V24 0h48z'
      
    ]
  };

  

  
  

  var faHamsa = {
    prefix: 'fasr',
    iconName: 'hamsa',
    icon: [
      512,
      512,
      [],
      'f665',
      
      'M208 0H184V24v8H112 88V56 256H24 0v24 56 9.9l7 7 95.4 95.4c40.7 40.7 96 63.6 153.5 63.6s112.8-22.9 153.5-63.6L505 353l7-7V336 280 256H488 424V56 32H400 328V24 0H304 208zM328 80h48V280v24h24 64v22.1l-88.4 88.4C343.9 446.2 300.9 464 256 464s-87.9-17.8-119.6-49.5L48 326.1V304h64 24V280 80h48V200v24h24 24V200 56 48h48v8V200v24h24 24V200 80zM160 352s48 64 96 64s96-64 96-64s-48-64-96-64s-96 64-96 64zm96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faMapPin = {
    prefix: 'fasr',
    iconName: 'map-pin',
    icon: [
      320,
      512,
      [128205],
      'f276',
      
      'M64 144a96 96 0 1 1 192 0A96 96 0 1 1 64 144zM184 286c68.1-11.4 120-70.7 120-142C304 64.5 239.5 0 160 0S16 64.5 16 144c0 71.4 51.9 130.6 120 142V488v24h48V488 286z'
      
    ]
  };

  

  
  

  var faCroissant = {
    prefix: 'fasr',
    iconName: 'croissant',
    icon: [
      512,
      512,
      [129360],
      'f7f6',
      
      'M61.2 169c24.1-46 61.9-83.7 107.9-107.8l110 202.2-15.6 15.6L61.2 169zM190.4 0C100.9 30.3 30.2 100.9 0 190.4l14.3 7.8C5 226.4 0 256.6 0 288c0 49.4 12.4 95.9 34.3 136.5c7.6 14.1 16.3 27.5 26.1 40l.2 .3 23.8-18.5c26.9 29 60.5 51.7 98.2 65.7L224 480l-16-96V350.2l35.3-27.5L272 338.4 338.4 272l-15.6-28.7L350.2 208H384l96 16 32-41.3c-14.1-37.8-36.8-71.3-65.7-98.2l18.5-23.8-.3-.2c-12.6-9.7-25.9-18.5-40-26.1C383.9 12.4 337.4 0 288 0c-31.4 0-61.6 5-89.8 14.3L190.4 0zM416.7 122.6c14.6 14.2 27.2 30.5 37.2 48.4l-62-10.3L388 160h-.4l29.1-37.4zM160 387.6v.4l.7 3.9 10.3 62c-17.9-10-34.3-22.6-48.4-37.2L160 387.6zM48 288c0-23 3.2-45.3 9.3-66.4l140 76.2L72.9 394.5C56.9 362.4 48 326.3 48 288zM394.5 72.9L297.7 197.3l-76.1-140C242.7 51.2 265 48 288 48c38.3 0 74.4 8.9 106.5 24.9z'
      
    ]
  };

  

  
  

  var faNetworkWired = {
    prefix: 'fasr',
    iconName: 'network-wired',
    icon: [
      640,
      512,
      [],
      'f6ff',
      
      'M400 48v96H240V48H400zM240 0H192V48v96 48h48 56v40H24 0v48H24 136v40H80 32v48 96 48H80 240h48V464 368 320H240 184V280H456v40H400 352v48 96 48h48H560h48V464 368 320H560 504V280H616h24V232H616 344V192h56 48V144 48 0H400 240zM80 368H240v96H80V368zm480 0v96H400V368H560z'
      
    ]
  };

  

  
  

  var faFolderTree = {
    prefix: 'fasr',
    iconName: 'folder-tree',
    icon: [
      576,
      512,
      [],
      'f802',
      
      'M48 24V0H0V24 136 424v24H24 256V400H48V160H256V112H48V24zM412.1 80H432h96v96H336V48h44.1l17.9 17.9L412.1 80zM528 32H432L400 0H336 288V48 176v48h48H528h48V176 80 32H528zM412.1 368H432h96v96H336V336h44.1l17.9 17.9L412.1 368zM528 320H432l-32-32H336 288v48V464v48h48H528h48V464 368 320H528z'
      
    ]
  };

  

  
  

  var faPeople = {
    prefix: 'fasr',
    iconName: 'people',
    icon: [
      640,
      512,
      [],
      'e216',
      
      'M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H94.8l-6.9 12.4-75.3 136L1 297.4l42 23.3 11.6-21L96 224.9V488v24h48V488 352h32V488v24h48V488 224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136L225.2 128H211.1 108.9zM176 304H144V176h32V304zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H414.8l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21L420 217.7 383 336l-15 48h48V488v24h48V488 384h32V488v24h48V488 384h48l-15-48L540 217.7l45.4 81.9 11.6 21 42-23.3-11.6-21-75.3-136L545.2 128H531.1 512 448 428.9zM480 186.5L526.7 336H433.3L480 186.5z'
      
    ]
  };

  

  
  

  var faCauldron = {
    prefix: 'fasr',
    iconName: 'cauldron',
    icon: [
      448,
      512,
      [],
      'f6bf',
      
      'M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM74.2 252.5c9.6-17.7 20.1-33.2 28.6-44.5H224 345.2c8.5 11.4 19 26.9 28.6 44.5c15.9 29.2 26.2 58.5 26.2 81.9c0 39.2-18.3 70-49.4 92.5C318.3 450.2 272.6 464 224 464s-94.3-13.8-126.6-37.1C66.3 404.4 48 373.6 48 334.4c0-23.3 10.3-52.6 26.2-81.9zM44.6 208C22.5 243.4 0 290.8 0 334.4c0 37.4 11.9 69.4 32 95.5V512H80V473c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v39h48V429.9c20.1-26.1 32-58.1 32-95.5c0-43.6-22.5-91-44.6-126.4H448V160H368 224 80 0v48H44.6z'
      
    ]
  };

  

  
  

  var faSliders = {
    prefix: 'fasr',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ["sliders-h"],
      'f1de',
      
      'M0 392l0 48 24 0 56 0 0 8 0 48 48 0 64 0 48 0 0-48 0-8 248 0 24 0 0-48-24 0-248 0 0-8 0-48-48 0-64 0-48 0 0 48 0 8-56 0L0 392zM0 232l0 48 24 0 248 0 0 8 0 48 48 0 64 0 48 0 0-48 0-8 56 0 24 0 0-48-24 0-56 0 0-8 0-48-48 0-64 0-48 0 0 48 0 8L24 232 0 232zM112 120l0 8 0 48 48 0 64 0 48 0 0-48 0-8 216 0 24 0 0-48-24 0L272 72l0-8 0-48-48 0-64 0-48 0 0 48 0 8L24 72 0 72l0 48 24 0 88 0zM320 288l0-64 64 0 0 64-64 0zM128 384l64 0 0 64-64 0 0-64zm32-256l0-64 64 0 0 64-64 0z'
      
    ]
  };

  
    var faSlidersH = faSliders;
  

  
  

  var faOutlet = {
    prefix: 'fasr',
    iconName: 'outlet',
    icon: [
      448,
      512,
      [],
      'e01c',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM80 256c0-77 57.6-112 57.6-112H310.4s57.6 35 57.6 112s-57.6 112-57.6 112H137.6s-57.6-35-57.6-112zm96-48V192H144v16 48 16h32V256 208zm128 0V192H272v16 48 16h32V256 208zM200 296v24h48V296c0-13.3-10.7-24-24-24s-24 10.7-24 24z'
      
    ]
  };

  

  
  

  var faFilterList = {
    prefix: 'fasr',
    iconName: 'filter-list',
    icon: [
      512,
      512,
      [],
      'e17c',
      
      'M152 232V212.1l-14.1-14.1L51.9 112H300.1l-86.1 86.1L200 212.1V232 362.4l-48-29.3V232zM0 64v48 16L104 232V360l96 58.7L248 448V391.7 232L352 128V112 64H304 48 0zm384 8v48h24 80 24V72H488 408 384zM344 232H320v48h24H488h24V232H488 344zm0 160H320v48h24H488h24V392H488 344z'
      
    ]
  };

  

  
  

  var faKhanda = {
    prefix: 'fasr',
    iconName: 'khanda',
    icon: [
      512,
      512,
      [9772],
      'f66d',
      
      'M192 48L256 0l64 48s-6.6 10.6-14.5 27.5C342.5 93.8 368 131.9 368 176s-25.5 82.2-62.5 100.5C313.4 293.4 320 304 320 304l-48 36v22.6l34.5-23.7 .1-.1C363.8 299.5 416 256 416 180.6c0-23-3.5-48.8-9-72.2c-5.9-24.9-14.1-47.1-23-60.4c0 0 28.4 12.1 58.4 37.6C476.2 114.2 512 159.8 512 224c0 96-112 192-112 192l-83.4-45.3L284.2 393l46.1 31.7c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V423.4L199.8 451c-1.5 11.8-11.6 21-23.8 21c-13.3 0-24-10.7-24-24s10.7-24 24-24c2 0 3.9 .2 5.7 .7L227.8 393l-32.4-22.3L112 416s-112-96-112-192C0 159.8 35.8 114.2 69.6 85.6C99.6 60.1 128 48 128 48c-8.9 13.4-17.1 35.6-23 60.4c-5.5 23.4-9 49.1-9 72.2c0 75.4 52.2 118.9 109.4 158.2l.1 .1L240 362.6V340l-48-36s6.6-10.6 14.5-27.5C169.5 258.2 144 220.1 144 176s25.5-82.2 62.5-100.5C198.6 58.6 192 48 192 48zm0 128c0 23.5 12.7 44.1 31.6 55.2c4.9-17.3 8.4-36.2 8.4-55.2s-3.5-37.9-8.4-55.2C204.7 131.9 192 152.5 192 176zm88 0c0 18.9 3.5 37.9 8.4 55.2C307.3 220.1 320 199.5 320 176s-12.7-44.1-31.6-55.2c-4.9 17.3-8.4 36.2-8.4 55.2zM40 224c0 34.1 20.8 73 47.6 107.4c11 14.1 22 26.2 31 35.5l32.8-17.8C103.1 311.8 56 261 56 180.6c0-6.2 .2-12.5 .6-18.9C46.5 179.5 40 200.2 40 224zm432 0c0-23.8-6.5-44.5-16.6-62.3c.4 6.4 .6 12.7 .6 18.9c0 80.4-47.1 131.2-95.4 168.5l32.8 17.8c9-9.3 20-21.4 31-35.5C451.2 297 472 258.1 472 224z'
      
    ]
  };

  

  
  

  var faOlive = {
    prefix: 'fasr',
    iconName: 'olive',
    icon: [
      448,
      512,
      [],
      'e316',
      
      'M160 432C98.1 432 48 381.9 48 320c0-79.2 37-138.4 85.9-179.1C184.3 99 243.7 80 280 80c13.6 0 31.8 7.5 50.4 19.9c8.5 5.7 15.7 11.4 20.8 15.8c2.5 2.1 4.4 3.9 5.6 5c.6 .6 1 1 1.2 1.2l.1 .1 .1 .1c.2 .2 .6 .6 1.2 1.2c1.1 1.2 2.9 3.1 5 5.6c4.3 5 10.1 12.2 15.8 20.8C392.5 168.2 400 186.4 400 200c0 36.3-19 95.7-60.9 146.1C298.4 395 239.2 432 160 432zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM271.1 208.9c30.3 30.3 87.8 21.9 87.8 21.9s8.4-57.5-21.9-87.8s-87.8-21.9-87.8-21.9s-8.4 57.5 21.9 87.8z'
      
    ]
  };

  

  
  

  var faHoneyPot = {
    prefix: 'fasr',
    iconName: 'honey-pot',
    icon: [
      448,
      512,
      [127855],
      'e418',
      
      'M448 224c0 176-128 256-128 256H128s-128-80-128-256C0 166.7 25.1 115.2 65 80H56 32V32H56h72 48 16 64H392h24V80H392h-9c39.9 35.2 65 86.7 65 144zM48 224H400c0-79.5-64.5-144-144-144H192c-5.4 0-10.7 .3-16 .9V136v24H128V136 95c-47.4 23.6-80 72.5-80 129zM78.6 352c7.4 14 15.5 26.3 23.6 36.9c13.6 17.8 27.1 30.9 37 39.3c1.6 1.4 3.1 2.6 4.5 3.7H304.3c1.4-1.1 2.9-2.4 4.5-3.7c9.9-8.5 23.4-21.5 37-39.3c8.1-10.6 16.2-22.9 23.6-36.9H78.6z'
      
    ]
  };

  

  
  

  var faCoins = {
    prefix: 'fasr',
    iconName: 'coins',
    icon: [
      512,
      512,
      [],
      'f51e',
      
      'M176 88v0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c.4 .3 .8 .7 1.2 1c-18.7 .4-36.9 1.7-54.4 4.1V88c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C226.4 7.5 271.5 0 320 0s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S512 70 512 88V192 296c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9c-9.6 3.7-20.1 6.9-31.3 9.6V323.6c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5v0V252.4c-5.3 2.6-10.9 5-16.7 7.2c-9.6 3.7-20.1 6.9-31.3 9.6V219.6c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5v0 0V148.4c-5.3 2.6-10.9 5-16.7 7.2c-13.7 5.2-29.4 9.6-46.3 12.9c-5.1-7.5-11-13.9-16.8-19.1c-10.1-9.1-21.8-16.5-34-22.6c31.7-2.3 59.3-8.2 80-16.1c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5v0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7C403.2 54.9 364.2 48 320 48s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5l0 0zM48 216v0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5v0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7c-27-10.3-66-17.2-110.2-17.2s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5l0 0zM0 216c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C98.4 135.5 143.5 128 192 128s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S384 198 384 216V320 424c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9C285.6 504.5 240.5 512 192 512s-93.6-7.5-127.3-20.3c-16.8-6.4-32-14.6-43.5-24.9S0 442 0 424V320 216zM336 320V276.4c-5.3 2.6-10.9 5-16.7 7.2C285.6 296.5 240.5 304 192 304s-93.6-7.5-127.3-20.3c-5.8-2.2-11.4-4.6-16.7-7.2V320v0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5v0 0zM64.7 387.7c-5.8-2.2-11.4-4.6-16.7-7.2V424l0 0c0 0 0 .5 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5v0V380.4c-5.3 2.6-10.9 5-16.7 7.2C285.6 400.5 240.5 408 192 408s-93.6-7.5-127.3-20.3z'
      
    ]
  };

  

  
  

  var faMountainCity = {
    prefix: 'fasr',
    iconName: 'mountain-city',
    icon: [
      640,
      512,
      [],
      'e52e',
      
      'M312 0H288V24 144.4l48 76.8V48H464V216v24h24 56 48V480v24h48V480 216 192H616 592V120 96H544v24 72H512V24 0H488 312zM432 336V272H368v.4L407.7 336H432zM368 80v64h64V80H368zm64 96H368v64h64V176zm128 96H496v64h64V272zm-64 96v64h64V368H496zM480 512l-30-48L268.3 173.3 240 128l-28.3 45.3L30 464 0 512H56.6 423.4 480zm-86.6-48H86.6l60.8-97.3L173.3 399l18.3 22.9 18.8-22.4L250.2 352h73.2l70 112zM240 218.6L293.4 304H239 227.8l-7.2 8.6-28.2 33.6-18.1-22.6 65.6-105z'
      
    ]
  };

  

  
  

  var faFluxCapacitor = {
    prefix: 'fasr',
    iconName: 'flux-capacitor',
    icon: [
      448,
      512,
      [],
      'f8ba',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM283.3 253.3c6.6 1.8 13.6 2.7 20.7 2.7c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7l-49-49L87.4 176 144 119.4l28.3 28.3L224 199.4l51.7-51.7L304 119.4 360.6 176l-28.3 28.3-49 49zM180.4 268.9c-21.9 14.3-36.4 39-36.4 67.1c0 44.2 35.8 80 80 80s80-35.8 80-80c0-28.1-14.5-52.8-36.4-67.1l-3.6 3.6V336v40H184V336 272.6l-3.6-3.6zM155.3 164.7L144 153.4 121.4 176l11.3 11.3L208 262.6V336v16h32V336 262.6l75.3-75.3L326.6 176 304 153.4l-11.3 11.3L224 233.4l-68.7-68.7z'
      
    ]
  };

  

  
  

  var faBatteryHalf = {
    prefix: 'fasr',
    iconName: 'battery-half',
    icon: [
      576,
      512,
      ["battery-3"],
      'f242',
      
      'M496 144V368H48V144H496zM48 96H0v48V368v48H48 496h48V368 320h32V192H544V144 96H496 48zm240 96H96V320H288V192z'
      
    ]
  };

  
    var faBattery3 = faBatteryHalf;
  

  
  

  var faBoltAuto = {
    prefix: 'fasr',
    iconName: 'bolt-auto',
    icon: [
      576,
      512,
      [],
      'e0b6',
      
      'M333.5 73.8l-22 87.8-11.7 46.9 47.9 6.4L416 224v48L156.9 466.3 96 512l18.5-73.8 22-87.8 11.7-46.9-47.9-6.4L32 288V240L291.1 45.7 352 0 333.5 73.8zm-40 182.2L240.3 249l13-52.1 19.3-77.4L100.4 248.7l54.1 7.2 53.3 7.1-13 52.1-19.3 77.4L347.6 263.3l-54.1-7.2zM479.8 288l6.2 14.6L575.6 512H523.4l-17.1-40H421.7l-17.1 40H352.4l89.5-209.4 6.2-14.6h31.7zm5.9 136L464 373.1 442.2 424h43.5z'
      
    ]
  };

  

  
  

  var faIndustryWindows = {
    prefix: 'fasr',
    iconName: 'industry-windows',
    icon: [
      576,
      512,
      [127981,"industry-alt"],
      'f3b3',
      
      'M192 80v43.3V176l48-21.8 80-36.4L368 96v27.3 25.5V176l48-21.8 80-36.4L544 96v52.7V432v48H496 80 32V432 80 32H80h64 48V80zm19.9 139.7L144 250.5V176 80H80V432H496V170.5L387.9 219.7 320 250.5V176v-5.5L211.9 219.7zM208 296v80H128V296h80zm120 0v80H248V296h80zm40 0h80v80H368V296z'
      
    ]
  };

  
    var faIndustryAlt = faIndustryWindows;
  

  
  

  var faCarMirrors = {
    prefix: 'fasr',
    iconName: 'car-mirrors',
    icon: [
      576,
      512,
      [],
      'e343',
      
      'M152 32H134.7l-5.5 16.4L86.7 176H80 32 0v48H32V352v48 80H80V400H496v80h48V400 352 224h32V176H544 496h-6.7L446.8 48.4 441.3 32H424 152zM480 224h16V352H80V224H96 480zm-41.3-48H137.3l32-96H406.7l32 96zM176 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faRacquet = {
    prefix: 'fasr',
    iconName: 'racquet',
    icon: [
      512,
      512,
      [],
      'f45a',
      
      'M349 48c31.9 0 61.1 10.9 82.6 32.4S464 131.2 464 163c0 40.6-17.7 84.9-52.9 120.1c-64 64-154.5 68.7-202.7 20.5C186.9 282.1 176 252.8 176 221c0-40.6 17.7-84.9 52.9-120.1S308.4 48 349 48zm0-48c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 35 9.9 69.5 30.8 98.3L127 351l-23-23L70.1 361.9 33.9 398.1 0 432l33.9 33.9 12.1 12.1L80 512l33.9-33.9 36.1-36.1L184 408l-23-23 31.7-31.7c73.6 54 182.1 34.1 252.3-36.2c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM80 444.1L67.9 432 104 395.9 116.1 408 80 444.1z'
      
    ]
  };

  

  
  

  var faPiggyBank = {
    prefix: 'fasr',
    iconName: 'piggy-bank',
    icon: [
      576,
      512,
      [],
      'f4d3',
      
      'M209.9 96.5c-17.3 1.3-34 4.8-49.8 10.4C162.8 47.4 211.9 0 272 0c52 0 95.6 35.4 108.3 83.4c-6 3.8-11.7 8-17 12.6H334c-7.1-27.6-32.2-48-62-48c-30 0-55.2 20.6-62.1 48.5zM376.4 176H224c-61.9 0-112 50.1-112 112c0 36.6 17.5 69.1 44.8 89.6L176 392v24 48h48V448 400h48 48 48v48 16h48V426.6 398.9L440 385c13.1-7.6 24.6-17.8 33.7-29.9L488 336h24 16V272H499.3l-12.6-28.8c-6.1-14.1-15.1-26.7-26.2-37.1l-20.6-19.3 6.9-27.4 3.9-15.4H448c-14.2 0-26.9 6.1-35.8 16l-14.3 16H376.4zM448 96h14.5H512l-12 48-6.8 27.1c15.8 14.8 28.7 32.8 37.5 52.9H576v48 64 48H528 512c-12.9 17.2-29.3 31.8-48 42.6V464v48H416 368 320V496 464 448H272v16 32 16H224 176 128V464 416c-37-27.8-61.6-71.3-63.8-120.6C28 290.9 0 260 0 222.6c0-27.8 15.7-53.2 40.6-65.7l4.7-2.3 21.5 42.9-4.7 2.3C53.4 204.1 48 212.9 48 222.6c0 12.6 9.1 23 21.1 25.1C87 178.8 149.6 128 224 128H376.4C394 108.4 419.6 96 448 96zM424 240a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCarBump = {
    prefix: 'fasr',
    iconName: 'car-bump',
    icon: [
      640,
      512,
      [],
      'f5e0',
      
      'M69.5 79.4L85.9 75 338.7 7.3l16-4.3 9.7 13.4 73.1 100.8 2.5-.7 46.4-12.4 12.4 46.4L529.8 266l12.4 46.4 0 0 19.9 74.4-44.6 12-19.9-74.4-1.7 .5L112.6 427.4l-1.7 .5 19.9 74.4-44.6 12L66.2 439.8 60 416.5l-6.2-23.1L22.9 278 10.4 231.6l46.4-12.4 1.7-.5L68.2 96.3l1.3-16.9zM335.2 57.9L114.7 117l-7 88.6 280.1-75.1L335.2 57.9zM69.2 265.6l30.9 115.5L483.4 278.4 452.4 162.9 69.2 265.6zm43.5 50.2a30.8 30.8 0 1 1 59.5-15.9 30.8 30.8 0 1 1 -59.5 15.9zM402.2 206.4a30.8 30.8 0 1 1 15.9 59.5 30.8 30.8 0 1 1 -15.9-59.5zM510.9 416c56.4 0 103.1 41.7 110.9 96H400c7.8-54.3 54.4-96 110.9-96z'
      
    ]
  };

  

  
  

  var faSushiRoll = {
    prefix: 'fasr',
    iconName: 'sushi-roll',
    icon: [
      448,
      512,
      ["maki-roll","makizushi"],
      'e48b',
      
      'M400 207.7c-13.2 11.2-29 19.7-45 26.1C319 248.2 272.7 256 224 256s-95-7.8-131-22.2c-16-6.4-31.9-14.9-45-26.1V355.6c.5 .8 1.1 1.7 1.7 2.6c5.1 7.4 13.7 18 26.8 28.7C101.9 407.9 147.1 432 224 432s122.1-24.1 147.5-45.1c13.1-10.8 21.7-21.3 26.8-28.7c.6-.9 1.2-1.8 1.8-2.6V207.7zM64 144c0 11.6 7.7 22.5 21.2 31.9l50.3-46.6 3-2.8 3.9-1.4 75.3-26.5-8.4-18.3C127.9 83.2 64 110.6 64 144zm60.5 50.1c27.3 8.7 61.9 13.9 99.5 13.9c39.9 0 76.3-5.8 104.3-15.5l-73.7-27.6-7.7-2.9-3.4-7.5-8.9-19.4-74.9 26.4-35.2 32.6zM384 144c0-31.3-56.1-57.3-130.2-62.9l22.5 49.3 97.2 36.4C380.3 159.7 384 152 384 144zM224 32c123.7 0 224 50.1 224 112V368s-48 112-224 112S0 368 0 368V144C0 82.1 100.3 32 224 32z'
      
    ]
  };

  
    var faMakiRoll = faSushiRoll;
  
    var faMakizushi = faSushiRoll;
  

  
  

  var faFaceHeadBandage = {
    prefix: 'fasr',
    iconName: 'face-head-bandage',
    icon: [
      576,
      512,
      [],
      'e37a',
      
      'M71.3 354c6.6-9.7 13.4-19.2 20.6-28.4C120.5 406.2 197.5 464 288 464c114.9 0 208-93.1 208-208c0-13.2-1.2-26.2-3.6-38.7c11.9 3 23.7 6.3 35.4 9.8l15 4.5c.8 8 1.1 16.2 1.1 24.4c0 141.4-114.6 256-256 256c-99.5 0-185.8-56.8-228.2-139.8c2.5-3.8 4.8-7.5 6.7-10.7c1.9-3.1 3.5-5.7 4.7-7.5zM218.5 209.6c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32c13.5-10.8 27.6-20.9 42.1-30.4zM368.1 12.8c-45.1 9.1-88.5 23-129.6 41.1c-13.9 3.4-27.2 8.2-39.8 14.2c-33.5 3.1-66.5 7.9-98.9 14.3C146.6 31.8 213.6 0 288 0c28 0 54.9 4.5 80.1 12.8zm-.3 382.7C352.2 381.2 328.4 368 296 368c-12.3 0-23.2 1.9-32.8 4.9l-22.9 7.2-14.4-45.8 22.9-7.2c14.2-4.5 30-7.1 47.2-7.1c46.5 0 81.4 19.3 104.2 39.9l17.8 16.2-32.3 35.5-17.8-16.1zM336.4 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c20.8 12.6 39.7 28 56.1 45.7C419.3 71.1 360.6 64.9 300.6 64.1zM406 103.4c34 4.3 67.3 10.5 100.1 18.3c14.1 22.8 24.6 47.9 31 74.7C458.2 172.7 374.6 160 288 160c-17.1 0-34.1 .5-51 1.5c-47.8 2.8-94.6 9.4-140 19.7c-19.6 4.4-39 9.5-58.1 15.3c6.4-26.8 17-51.9 31-74.7c48.4-11.6 98.2-19.5 149.3-23.2C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1c-51.6 37.5-96.5 83.8-132.2 136.7C36.5 310.9 32 284 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5z'
      
    ]
  };

  

  
  

  var faCircleLocationArrow = {
    prefix: 'fasr',
    iconName: 'circle-location-arrow',
    icon: [
      512,
      512,
      ["location-circle"],
      'f602',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm233.4 22.6L86.3 244.7 369.1 142.9 267.3 425.7 233.4 278.6z'
      
    ]
  };

  
    var faLocationCircle = faCircleLocationArrow;
  

  
  

  var faFolderHeart = {
    prefix: 'fasr',
    iconName: 'folder-heart',
    icon: [
      512,
      512,
      [],
      'e189',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zM144 251.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L256 384.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z'
      
    ]
  };

  

  
  

  var faPlaneUp = {
    prefix: 'fasr',
    iconName: 'plane-up',
    icon: [
      512,
      512,
      [],
      'e22d',
      
      'M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106v51.5l163.9 93.7 12.1 6.9V272v80 31.8l-30.6-8.7L336 333.5V356l54.4 40.8L400 404v12 72 24H376 360h-3.6l-3.4-1.1L256 481.1l-96.9 29.8-3.4 1.1H152 136 112V488 416 404l9.6-7.2L176 356l0-22.5L30.6 375.1 0 383.8V352 272 258.1l12.1-6.9L176 157.5V106c0-20.3 8.1-45.1 20-64.6c6.1-10 13.8-19.9 23.3-27.5zM237 66.2c-8.5 14-13 30.2-13 39.7v65.5 13.9l-12.1 6.9L48 285.9v34.3l145.4-41.5 30.6-8.7v31.8l0 66.3v12l-9.6 7.2L160 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2L352 460.4V428l-54.4-40.8L288 380V368 301.7 269.9l30.6 8.7L464 320.2V285.9L300.1 192.3 288 185.4V171.4 106c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8 .2-6.7 3.3c-3.9 3.1-8.2 8.1-12.3 14.9z'
      
    ]
  };

  

  
  

  var faMobileScreen = {
    prefix: 'fasr',
    iconName: 'mobile-screen',
    icon: [
      384,
      512,
      ["mobile-android-alt"],
      'f3cf',
      
      'M64 464H320V368H64v96zm0-144H320V48H64V320zM16 0H64 320h48V48 464v48H320 64 16V464 48 0zM160 400h64 16v32H224 160 144V400h16z'
      
    ]
  };

  
    var faMobileAndroidAlt = faMobileScreen;
  

  
  

  var faBellSchool = {
    prefix: 'fasr',
    iconName: 'bell-school',
    icon: [
      512,
      512,
      [],
      'f5d5',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM352 358.1c39.4-37.9 64-91.1 64-150.1C416 93.1 322.9 0 208 0S0 93.1 0 208c0 59 24.6 112.2 64 150.1V488v24H88 272h56 24H464h24V488 441.6c14.3-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6V464H352V358.1zM304 464H272 112V392.6c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4V464zM208 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faTemperatureThreeQuarters = {
    prefix: 'fasr',
    iconName: 'temperature-three-quarters',
    icon: [
      320,
      512,
      ["temperature-3","thermometer-3","thermometer-three-quarters"],
      'f2c8',
      
      'M96 294.5L85.3 307.7C72 324.2 64 345.1 64 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L224 294.5v-17V48H96V277.5v17zM224 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5V48 0H96 224zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V152 136h32v16V322.8c18.6 6.6 32 24.4 32 45.3z'
      
    ]
  };

  
    var faTemperature3 = faTemperatureThreeQuarters;
  
    var faThermometer3 = faTemperatureThreeQuarters;
  
    var faThermometerThreeQuarters = faTemperatureThreeQuarters;
  

  
  

  var faBoxingGlove = {
    prefix: 'fasr',
    iconName: 'boxing-glove',
    icon: [
      448,
      512,
      [129354,"glove-boxing"],
      'f438',
      
      'M0 0H24 368h24V24 128h32 24v24V288v9.9l-7 7-89 89V488v24H328 56 32V488 392.4L5.3 359 0 352.4V344 24 0zM392 176H368 344 312 272v80h40 24v48H312 248 224V280 232H128h-9.9l-7-7L79 193 113 159l25 25H224V152 128h24 64 32V48H48V335.6L74.7 369l5.3 6.6V384v80H304V384v-9.9l7-7 89-89V176h-8zM152.9 346.7L192 372.8l39.1-26.1 13.3-8.9 8.9 13.3 8.9 13.3-13.3 8.9-28 18.7 28 18.7 13.3 8.9-8.9 13.3-8.9 13.3-13.3-8.9L192 411.2l-39.1 26.1-13.3 8.9-8.9-13.3-8.9-13.3 13.3-8.9 28-18.7-28-18.7-13.3-8.9 8.9-13.3 8.9-13.3 13.3 8.9z'
      
    ]
  };

  
    var faGloveBoxing = faBoxingGlove;
  

  
  

  var faHouseChimneyMedical = {
    prefix: 'fasr',
    iconName: 'house-chimney-medical',
    icon: [
      576,
      512,
      ["clinic-medical"],
      'f7f2',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 488h24V488 253.5l24.5 20.8 31.1-36.6L512 190.6V88 64H464V88v61.9L303.5 13.7zM464 216v24l0 224H112V212.8L288 63.5 464 212.8l0 3.2zM256 192v64H192v64h64v64h64V320h64V256H320V192H256z'
      
    ]
  };

  
    var faClinicMedical = faHouseChimneyMedical;
  

  
  

  var faCards = {
    prefix: 'fasr',
    iconName: 'cards',
    icon: [
      640,
      512,
      [],
      'e3ed',
      
      'M228.5 446.4l170.9-98.6L236.4 65.6 65.6 164.2 228.5 446.4zm24 41.6l-41.6 24-24-41.6L0 146.7 212.4 24 254 0l24 41.6L440.9 323.8l24 41.6-41.6 24L252.5 488zm67.5-2l160.9-92.9 27.7-16-16-27.7L327.9 64H640V512H320V486zM473.9 187.6L528 243.4l54-55.8c14-14.5 13.2-38.5-2.2-51.9c-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2c-15.7 13.5-16.5 37.5-2.5 51.9zM159.5 279.7l27.2-101.6 101.6 27.2c21.4 5.7 34.2 27.8 28.4 49.2S289 288.8 267.5 283l-8.2-2.2L274 306.2l19.9-11.5 11.5 19.9-59.7 34.5-11.5-19.9 19.9-11.5-14.7-25.4-2.2 8.2C231.5 322 209.4 334.7 188 329s-34.2-27.8-28.4-49.2z'
      
    ]
  };

  

  
  

  var faLocationDotSlash = {
    prefix: 'fasr',
    iconName: 'location-dot-slash',
    icon: [
      640,
      512,
      ["map-marker-alt-slash"],
      'f605',
      
      'M457.5 332.4L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L153.5 96.4C186.6 38.8 248.8 0 320 0C426 0 512 86 512 192c0 39.4-23.7 90.6-54.5 140.4zM191.9 126.2l52.2 40.5C254.7 134.9 284.7 112 320 112c44.2 0 80 35.8 80 80c0 28.2-14.6 53-36.7 67.3l56.1 43.5c7.2-11.9 13.9-23.8 19.9-35.4C456.3 234 464 208.3 464 192c0-79.5-64.5-144-144-144c-55.8 0-104.2 31.8-128.1 78.2zm125.9 97.7c.7 .1 1.5 .1 2.2 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 3.5 .6 6.9 1.6 10.1l28.1 21.8zm84.3 188.9c-18.4 24.3-36.1 46-50.3 62.8C332.8 498.1 320 512 320 512s-12.8-13.9-31.8-36.4c-53.5-63.4-156.1-195.2-160.1-278.7l62.6 49.3c2.9 6.7 6.2 13.7 10 21.1c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c13-15.6 28.5-34.7 44.4-55.8l37.7 29.7z'
      
    ]
  };

  
    var faMapMarkerAltSlash = faLocationDotSlash;
  

  
  

  var faCaretDown = {
    prefix: 'fasr',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M272 192l48 0 0 48L160 384 0 240l0-48 48 0 224 0zM71.8 240L160 319.4 248.2 240 71.8 240z'
      
    ]
  };

  

  
  

  var faBallot = {
    prefix: 'fasr',
    iconName: 'ballot',
    icon: [
      448,
      512,
      [],
      'f732',
      
      'M400 48V464H48V48H400zM48 0H0V48 464v48H48 400h48V464 48 0H400 48zM80 96v64h64V96H80zm64 128H80v64h64V224zM80 352v64h64V352H80zM200 104H176v48h24H344h24V104H344 200zm0 128H176v48h24H344h24V232H344 200zm0 128H176v48h24H344h24V360H344 200z'
      
    ]
  };

  

  
  

  var faUsbDrive = {
    prefix: 'fasr',
    iconName: 'usb-drive',
    icon: [
      640,
      512,
      [],
      'f8e9',
      
      'M48 144V368H400V144H48zM0 96H48 400h48v48V368v48H400 48 0V368 144 96zm640 32V384H480V128H640zm-56 56H536v48h48V184zm-48 96v48h48V280H536z'
      
    ]
  };

  

  
  

  var faArrowsFromDottedLine = {
    prefix: 'fasr',
    iconName: 'arrows-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a3',
      
      'M241 18.2l-17-17-17 17-64 64-17 17L160 133.1l17-17 23-23V168v24h48V168 93.1l23 23 17 17 33.9-33.9-17-17-64-64zM248 344V320H200v24 74.9l-23-23-17-17-33.9 33.9 17 17 64 64 17 17 17-17 64-64 17-17L288 378.9l-17 17-23 23V344zM64 224H0v64H64V224zm96 0H96v64h64V224zm32 64h64V224H192v64zm160-64H288v64h64V224zm32 0v64h64V224H384z'
      
    ]
  };

  

  
  

  var faKeyboard = {
    prefix: 'fasr',
    iconName: 'keyboard',
    icon: [
      576,
      512,
      [9000],
      'f11c',
      
      'M48 112V400H528V112H48zM0 64H48 528h48v48V400v48H528 48 0V400 112 64zM416 320v48H160V320H416zM104 232h48v48H104V232zm48-80v48H104V152h48zm32 80h48v48H184V232zm48-80v48H184V152h48zm32 80h48v48H264V232zm48-80v48H264V152h48zm32 80h48v48H344V232zm48-80v48H344V152h48zm32 80h48v48H424V232zm48-80v48H424V152h48z'
      
    ]
  };

  

  
  

  var faTimeline = {
    prefix: 'fasr',
    iconName: 'timeline',
    icon: [
      640,
      512,
      [],
      'e29c',
      
      'M160 64v64h-8H104 96V64h64zm-8 112h8 48V128 64 16H160 96 48V64v64 48H96h8v56H24 0v48H24 296v56h-8H240v48 64 48h48 64 48V448 384 336H352h-8V280H616h24V232H616 536V176h8 48V128 64 16H544 480 432V64v64 48h48 8v56H152V176zM344 384h8v64H288V384h8 48zM480 64h64v64H480V64z'
      
    ]
  };

  

  
  

  var faS = {
    prefix: 'fasr',
    iconName: 's',
    icon: [
      320,
      512,
      [115],
      '53',
      
      'M91.2 90.6c-24 10.1-37.9 26.2-41.8 48c-2.8 16.1-1 27.4 2.8 35.7c3.8 8.5 10.6 16.1 21.1 23.3c22.1 15.1 54.9 24.6 93.2 35.3c.8 .2 1.6 .4 2.4 .7c35.3 9.9 75.6 21.2 104.9 41.2c15.6 10.6 29.3 24.5 37.7 43.1c8.5 18.7 10.6 40 6.4 63.9c-7.2 40.8-34.4 68.8-70.5 83.9c-35.3 14.8-79.6 17.8-125.7 10.7l-.1 0c-24.5-3.9-64.3-17.2-90.9-26.2c-5.3-1.8-10-3.4-14-4.7L-6.3 438 8.6 392.4l22.8 7.4c4.9 1.6 10.5 3.5 16.3 5.4c26.9 9 61.2 20.4 81.3 23.6c40.4 6.2 75.1 2.9 99.8-7.5c24-10.1 37.9-26.2 41.8-48c2.8-16.1 1-27.4-2.8-35.7c-3.8-8.5-10.6-16.1-21.1-23.3c-22.1-15.1-54.9-24.6-93.2-35.3c-.8-.2-1.6-.4-2.4-.7c-35.3-9.9-75.6-21.2-104.9-41.2c-15.6-10.6-29.3-24.5-37.7-43.1c-8.5-18.7-10.6-40-6.4-63.9l23.6 4.2L2.1 130.3C9.3 89.5 36.5 61.5 72.6 46.4c35.3-14.8 79.6-17.8 125.7-10.7c13.7 2.1 55.1 9.9 69.7 13.8l23.2 6.1-12.1 46.4-23.2-6.1c-12.4-3.2-52-10.8-64.9-12.8l3.6-23.7L191 83.1c-40.4-6.2-75.2-2.9-99.9 7.5z'
      
    ]
  };

  

  
  

  var faOverline = {
    prefix: 'fasr',
    iconName: 'overline',
    icon: [
      448,
      512,
      [],
      'f876',
      
      'M24 32H0V80H24 424h24V32H424 24zm200 80c-97.2 0-176 78.8-176 176v16c0 97.2 78.8 176 176 176s176-78.8 176-176V288c0-97.2-78.8-176-176-176zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V288z'
      
    ]
  };

  

  
  

  var faSquareUpLeft = {
    prefix: 'fasr',
    iconName: 'square-up-left',
    icon: [
      448,
      512,
      [],
      'e282',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM128 320V160H288l24 24-52 52 76 76-56 56-76-76-52 52-24-24z'
      
    ]
  };

  

  
  

  var faBaseballBatBall = {
    prefix: 'fasr',
    iconName: 'baseball-bat-ball',
    icon: [
      512,
      512,
      [],
      'f432',
      
      'M390.8 .1l16.6 16.6 88 88 16.6 16.6-16.1 17L337.4 304.5 335 307l-3 1.7L182.7 395.2l-54.2 54.2c-.3-.3-.6-.7-1-1l-64-64c-.3-.3-.7-.6-1-1l54.2-54.2L203.2 180l1.7-3 2.5-2.4L373.9 16.2l17-16.1zM305 269L444.9 122 390 67.1 243 207 171.9 329.9l10.2 10.2L305 269zM464 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM50.9 401l60.2 60.2 17 17L94.1 512l-17-17L17 434.9l-17-17L33.9 384l17 17z'
      
    ]
  };

  

  
  

  var faPenNibSlash = {
    prefix: 'fasr',
    iconName: 'pen-nib-slash',
    icon: [
      640,
      512,
      [],
      'e4a1',
      
      'M446.7 324L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L212.8 142.4 352 96l62.1-62.1L448 0l33.9 33.9 60.1 60.1L576 128l-33.9 33.9L480 224 446.7 324zM258.4 177.8l148.1 115 28-84 3.6-10.7 0 0-60.1-60.1 0 0-10.8 3.6L258.4 177.8zM409 418.2L112 512 64 464l80.3-254.3 40.3 31.8L125.9 427.5 228.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-9.4 2.7-18.2 7.4-25.7l75 59.1c-8.7 9-20.9 14.6-34.4 14.6c-7.4 0-14.4-1.7-20.7-4.7L148.5 450.1l214.9-67.9L409 418.2z'
      
    ]
  };

  

  
  

  var faListRadio = {
    prefix: 'fasr',
    iconName: 'list-radio',
    icon: [
      512,
      512,
      [],
      'e1d0',
      
      'M64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM184 72H160v48h24H488h24V72H488 184zm0 160H160v48h24H488h24V232H488 184zm0 160H160v48h24H488h24V392H488 184zM64 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faLampStreet = {
    prefix: 'fasr',
    iconName: 'lamp-street',
    icon: [
      512,
      512,
      [],
      'e1c5',
      
      'M48 172c0-68.5 55.5-124 124-124c65 0 118.3 50 123.6 113.5C217.1 171.5 153.4 228.9 134 304c-3.9 15.3-6 31.4-6 48h48H464h48c0-16.6-2.1-32.7-6-48c-19.4-75.4-83.4-132.9-162.3-142.6C338.2 71.4 263.4 0 172 0C77 0 0 77 0 172V512H48V172zm272 36c62.7 0 116 40.1 135.8 96H184.2c19.8-55.9 73.1-96 135.8-96zm0 240c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faCloudSleet = {
    prefix: 'fasr',
    iconName: 'cloud-sleet',
    icon: [
      512,
      512,
      [],
      'f741',
      
      'M368 128v48h48c26.5 0 48 21.5 48 48v48H416 96 48V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 320H48 96 416h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48 48zm216 32H168v24 16H152 128v48h24 16v16 24h48V456 440h16 24V392H232 216V376 352zm256 0H424v24 16H408 384v48h24 16v16 24h48V456 440h16 24V392H488 472V376 352zm-352 0H72L0 512H48l72-160zm256 0H328L256 512h48l72-160z'
      
    ]
  };

  

  
  

  var faFaucet = {
    prefix: 'fasr',
    iconName: 'faucet',
    icon: [
      512,
      512,
      [],
      'e005',
      
      'M288 192H248V146.4L384 160V96L248 109.6V64H200v45.6L64 96v64l136-13.6V192H168h-9.9l-7 7-25 25H24 0v48H24 136h9.9l7-7 25-25H278.1l25 25 7 7H320h40c57.4 0 104 46.6 104 104v24H400v-8c0-30.9-25.1-56-56-56H311.7 298.5l-7.1 11.1C277.2 369.3 252.3 384 224 384s-53.2-14.7-67.4-36.9L149.5 336H136.3 24 0v48H24 124.1c23.4 29.2 59.5 48 99.9 48s76.5-18.8 99.9-48H344c4.4 0 8 3.6 8 8v32 24h24H488h24V424 376c0-83.9-68.1-152-152-152H329.9l-25-25-7-7H288z'
      
    ]
  };

  

  
  

  var faArrowsMaximize = {
    prefix: 'fasr',
    iconName: 'arrows-maximize',
    icon: [
      512,
      512,
      ["expand-arrows"],
      'f31d',
      
      'M328 32H304V80h24 70.1L256 222.1 113.9 80H184h24V32H184 56 32V56 184v24H80V184 113.9L222.1 256 80 398.1V328 304H32v24V456v24H56 184h24V432H184 113.9L256 289.9 398.1 432H328 304v48h24H456h24V456 328 304H432v24 70.1L289.9 256 432 113.9V184v24h48V184 56 32H456 328z'
      
    ]
  };

  
    var faExpandArrows = faArrowsMaximize;
  

  
  

  var faCarBolt = {
    prefix: 'fasr',
    iconName: 'car-bolt',
    icon: [
      512,
      512,
      [],
      'e341',
      
      'M120 32H103L97.3 48.1 52.6 176H48 0v48V352v48 80H48V400H464v80h48V400 352 224 176H464h-4.6L414.7 48.1 409 32H392 120zM408.6 176H384v48h80V352H48V224h80V176H103.4L137 80H375l33.6 96zM112 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 224h88l-24 96L352 192H264l24-96L160 224z'
      
    ]
  };

  

  
  

  var faPallet = {
    prefix: 'fasr',
    iconName: 'pallet',
    icon: [
      640,
      512,
      [],
      'f482',
      
      'M24 320H0v48H24 64v96H24 0v48H24 64 88h24H296h24 24H528h24 24 40 24V464H616 576V368h40 24V320H616 576 552 528 344 320 296 112 88 64 24zm88 48H296v96H112V368zm232 0H528v96H344V368z'
      
    ]
  };

  

  
  

  var faBackwardStep = {
    prefix: 'fasr',
    iconName: 'backward-step',
    icon: [
      320,
      512,
      ["step-backward"],
      'f048',
      
      'M80 88V64H32V88 232v48V424v24H80V424 309.6L256 418.4 304 448V391.6 120.4 64L256 93.6 80 202.4V88zm4.5 168L256 150.1V361.9L84.5 256z'
      
    ]
  };

  
    var faStepBackward = faBackwardStep;
  

  
  

  var faTruckTow = {
    prefix: 'fasr',
    iconName: 'truck-tow',
    icon: [
      640,
      512,
      [],
      'e2b8',
      
      'M64 32V16 0H80h32 5.7H160L373.3 240H384V120 96h24H512h11l7.2 8.3 104 120L640 231v9V392v24H616 576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H24 0V392 264 240H24 184L96 64v96c0 20.9-13.4 38.7-32 45.3V208H48c-26.5 0-48-21.5-48-48V144 128H32v16 16c0 8.8 7.2 16 16 16s16-7.2 16-16V32zM243.2 368H396.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H592V288H432 416 384 351.8 208 48v80H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48zM145.8 56.3L237.7 240h71.4L145.8 56.3zM584.2 240L501 144H432v96H584.2zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faInputNumeric = {
    prefix: 'fasr',
    iconName: 'input-numeric',
    icon: [
      640,
      512,
      [],
      'e1bd',
      
      'M592 112V400H48V112H592zM48 64H0v48V400v48H48 592h48V400 112 64H592 48zm56 96v48h24 8v96H120 96v48h24 80 24V304H200 184V184 160H160 128 104zm213.4 51.8c5.9 6.7 5.7 16.7-.3 23.3L248 309.9V352h16 88 24V304H352 318.8l33.6-36.4c22.7-24.6 23.2-62.3 1.2-87.4c-26.2-30-73-29.7-98.9 .5l-16.9 19.7 36.4 31.2 16.9-19.7c6.9-8.1 19.3-8.1 26.3-.1z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fasr',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256v12.8l10.7 7.1 96 64 20 13.3 26.6-39.9-20-13.3L280 243.2V120 96H232v24z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faDash = {
    prefix: 'fasr',
    iconName: 'dash',
    icon: [
      512,
      512,
      ["minus-large"],
      'e404',
      
      'M0 232H24 488h24v48H488 24 0V232z'
      
    ]
  };

  
    var faMinusLarge = faDash;
  

  
  

  var faRaindrops = {
    prefix: 'fasr',
    iconName: 'raindrops',
    icon: [
      448,
      512,
      [],
      'f75c',
      
      'M105.5 122.8L160 32l54.5 90.8c6.2 10.4 9.5 22.3 9.5 34.4V160c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.8c0-12.1 3.3-24 9.5-34.4zm-96 192L64 224l54.5 90.8c6.2 10.4 9.5 22.3 9.5 34.4V352c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.8c0-12.1 3.3-24 9.5-34.4zm244-4.2c-8.8 12.9-13.5 28.2-13.5 43.8c0 42.9 34.8 77.7 77.7 77.7h4.7c42.9 0 77.7-34.8 77.7-77.7c0-15.6-4.7-30.9-13.5-43.8L320 213.2l-66.5 97.4zm-39.6-27.1l77.1-112.9L320 128l29.1 42.6 77.1 112.9c14.2 20.9 21.9 45.6 21.9 70.8C448 423.7 391.7 480 322.3 480h-4.7C248.3 480 192 423.7 192 354.3c0-25.3 7.6-50 21.9-70.8z'
      
    ]
  };

  

  
  

  var faArrowDownArrowUp = {
    prefix: 'fasr',
    iconName: 'arrow-down-arrow-up',
    icon: [
      576,
      512,
      ["sort-alt"],
      'f883',
      
      'M111 461.8l-96-96-17-17L32 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17-17-17zM367 50.2l17-17 17 17 96 96 17 17L480 197.1l-17-17-55-55V456v24H360V456 125.1l-55 55-17 17-33.9-33.9 17-17 96-96z'
      
    ]
  };

  
    var faSortAlt = faArrowDownArrowUp;
  

  
  

  var faLightSwitchOn = {
    prefix: 'fasr',
    iconName: 'light-switch-on',
    icon: [
      384,
      512,
      [],
      'e019',
      
      'M168 48V64h48V48H336V464H216V448H168v16H48V48H168zM48 0H0V48 464v48H48 336h48V464 48 0H336 48zM240 256V368H144V256h96zM144 96H96v48V368v48h48 96 48V368 144 96H240 144z'
      
    ]
  };

  

  
  

  var faSquareRootVariable = {
    prefix: 'fasr',
    iconName: 'square-root-variable',
    icon: [
      576,
      512,
      ["square-root-alt"],
      'f698',
      
      'M301.8 32H320 552h24V80H552 338.2L231.1 462.5 226.2 480H193.7l-6.8-12.6L81.7 272H24 0V224H24 96h14.3l6.8 12.6 83.8 155.6 96-342.7L301.8 32zM391 265L425 231l55 55 55-55L569 265l-55 55 55 55L535 409l-55-55-55 55L391 375l55-55-55-55z'
      
    ]
  };

  
    var faSquareRootAlt = faSquareRootVariable;
  

  
  

  var faArrowUpFromDottedLine = {
    prefix: 'fasr',
    iconName: 'arrow-up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e09b',
      
      'M241.3 50.5L224 32.6 206.7 50.5 78.7 183.3 62.1 200.6l34.6 33.3 16.7-17.3 86.7-90V328v24h48V328 126.7l86.7 90 16.7 17.3 34.6-33.3-16.7-17.3L241.3 50.5zM64 416H0v64H64V416zm96 0H96v64h64V416zm32 64h64V416H192v64zm160-64H288v64h64V416zm32 0v64h64V416H384z'
      
    ]
  };

  

  
  

  var faU = {
    prefix: 'fasr',
    iconName: 'u',
    icon: [
      384,
      512,
      [117],
      '55',
      
      'M48 32V56 288c0 79.5 64.5 144 144 144s144-64.5 144-144V56 32h48V56 288c0 106-86 192-192 192S0 394 0 288V56 32H48z'
      
    ]
  };

  

  
  

  var faArrowTurnUp = {
    prefix: 'fasr',
    iconName: 'arrow-turn-up',
    icon: [
      384,
      512,
      ["level-up"],
      'f148',
      
      'M24 464L0 464l0 48 24 0 168 0 24 0 0-24 0-394.9 79 79 17 17 33.9-33.9-17-17L216 25.3l0-1.3-1.3 0L209 18.2l-17-17-17 17L169.3 24 168 24l0 1.3L55 138.2l-17 17L72 189.1l17-17 79-79L168 464 24 464z'
      
    ]
  };

  
    var faLevelUp = faArrowTurnUp;
  

  
  

  var faMobileSignalOut = {
    prefix: 'fasr',
    iconName: 'mobile-signal-out',
    icon: [
      512,
      512,
      [],
      'e1f0',
      
      'M48 48H224V0H48 0V48 464v48H48 304h48V464 288H304V464H48V48zm96 352H128v32h16 64 16V400H208 144zM256 48c114.9 0 208 93.1 208 208h48C512 114.6 397.4 0 256 0V48zm32 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0h48c0-88.4-71.6-160-160-160v48c61.9 0 112 50.1 112 112z'
      
    ]
  };

  

  
  

  var faGripVertical = {
    prefix: 'fasr',
    iconName: 'grip-vertical',
    icon: [
      320,
      512,
      [],
      'f58e',
      
      'M40 440l0-48 48 0 0 48-48 0zM0 480l40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0L0 352l0 40 0 48 0 40zm232-40l0-48 48 0 0 48-48 0zm-40 40l40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48 0 40zM40 232l48 0 0 48-48 0 0-48zM0 280l0 40 40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0L0 192l0 40 0 48zm232 0l0-48 48 0 0 48-48 0zm-40 40l40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48 0 40zM40 72l48 0 0 48-48 0 0-48zM0 120l0 40 40 0 48 0 40 0 0-40 0-48 0-40L88 32 40 32 0 32 0 72l0 48zm232 0l0-48 48 0 0 48-48 0zm-40 40l40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48 0 40z'
      
    ]
  };

  

  
  

  var faSquareD = {
    prefix: 'fasr',
    iconName: 'square-d',
    icon: [
      448,
      512,
      [],
      'e268',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm152 96h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H152 128V360 152 128h24zm24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H176V336z'
      
    ]
  };

  

  
  

  var faAxe = {
    prefix: 'fasr',
    iconName: 'axe',
    icon: [
      640,
      512,
      [129683],
      'f6b2',
      
      'M0 448l64 64L313.4 262.6l-64-64L0 448zM400 48L385.9 33.9 352 0 318.1 33.9 257.9 94.1 224 128l33.9 33.9L384 288v80 48h32c5.4 0 10.7-.2 16-.6C543 407.6 631.6 319 639.4 208c.4-5.3 .6-10.6 .6-16V160H592 512l-48-48 48-48L448 0 400 48zM512 208h79.3c-7.6 84.4-74.8 151.7-159.3 159.3V288 268.1l-14.1-14.1L291.9 128 352 67.9 478.1 193.9 492.1 208H512z'
      
    ]
  };

  

  
  

  var faChessClock = {
    prefix: 'fasr',
    iconName: 'chess-clock',
    icon: [
      640,
      512,
      [],
      'f43d',
      
      'M256 32H96V80h56v32H48 0v48V432v48H48 592h48V432 160 112H592 544V80H384v32H200V80h56V32zM592 160V432H48V160H592zM200 400a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM184 240V224h32v16 48 16H184V288 240zM513.5 369.5A104 104 0 1 0 366.5 222.5 104 104 0 1 0 513.5 369.5zM502.2 256.4l-11.3 11.3L457 301.7 445.7 313 423 290.3 434.3 279l33.9-33.9 11.3-11.3 22.6 22.6z'
      
    ]
  };

  

  
  

  var faPeapod = {
    prefix: 'fasr',
    iconName: 'peapod',
    icon: [
      512,
      512,
      [],
      'e31c',
      
      'M416 48C212.8 48 48 212.8 48 416v48H96c203.2 0 368-164.8 368-368V48H416zm0-48h48 48V48 96c0 229.8-186.2 416-416 416H48 0V464 416C0 186.2 186.2 0 416 0zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z'
      
    ]
  };

  

  
  

  var faShareAll = {
    prefix: 'fasr',
    iconName: 'share-all',
    icon: [
      576,
      512,
      [],
      'f367',
      
      'M469.6 184.4L352 76.6V32h32L576 208 384 384H352V339.4L469.6 231.6 495.4 208l-25.7-23.6zM128 480s-41.8-15.7-77.7-53C23.5 399 0 358.8 0 304c0-97.2 78.8-176 176-176h48V80 67.8v-.9V32h32l16 14.7L412.5 175.4 448 208l-35.5 32.6L272 369.3 256 384H224V349.1v-.9V336 288H208c-11.1 0-21.9 1.6-32 4.6C129.7 306.4 96 349.3 96 400c0 1.4 0 2.9 .1 4.3C97.9 449.9 128 480 128 480zM48 304c0 17 3.1 32 8.2 45.4C77.4 285.8 137.3 240 208 240h16 48v48 16.2L377 208 272 111.8V128v48H224 176c-70.7 0-128 57.3-128 128z'
      
    ]
  };

  

  
  

  var faDisplayMedical = {
    prefix: 'fasr',
    iconName: 'display-medical',
    icon: [
      576,
      512,
      ["desktop-medical"],
      'e166',
      
      'M528 48H48V368H528V48zM48 416H0V368 48 0H48 528h48V48 368v48H528 364.3l8 48H424h24v48H424 352 224 152 128V464h24 51.7l8-48H48zm212.3 0l-8 48h71.3l-8-48H260.3zM256 112h64v64h64v64H320v64H256V240H192V176h64V112z'
      
    ]
  };

  
    var faDesktopMedical = faDisplayMedical;
  

  
  

  var faFolderMusic = {
    prefix: 'fasr',
    iconName: 'folder-music',
    icon: [
      512,
      512,
      [],
      'e18d',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm80 48v32V352c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V247.1l-96 36V384c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V272 240 228.9l10.4-3.9 128-48 21.6-8.1V192z'
      
    ]
  };

  

  
  

  var faHexagonVerticalNftSlanted = {
    prefix: 'fasr',
    iconName: 'hexagon-vertical-nft-slanted',
    icon: [
      448,
      512,
      [],
      'e506',
      
      'M224 456.7L400 356.1V155.9L224 55.3 48 155.9V356.1L224 456.7zM0 128L224 0 448 128V384L224 512 0 384V128zM192 92l31.8-18.2L272 101.4v36.9l-48-27.5V240h32 16v32H256 224V432v6.3L192 420V256 92zM320 383.4V165.8L296 152V115.1l47.9 27.4 0 0L384 165.4v36.8L352 184V365.1l-32 18.3zM160 384v17.7L127.2 383 96 266.1V360v5.1L64 346.9V165.1l33.1-18.9L128 261.9V128.6l32-18.3V112 381.9 384z'
      
    ]
  };

  

  
  

  var faTabletScreen = {
    prefix: 'fasr',
    iconName: 'tablet-screen',
    icon: [
      448,
      512,
      ["tablet-android-alt"],
      'f3fc',
      
      'M48 464H400V368H48v96zm0-144H400V48H48V320zM0 0H48 400h48V48 464v48H400 48 0V464 48 0zM192 400h64 16v32H256 192 176V400h16z'
      
    ]
  };

  
    var faTabletAndroidAlt = faTabletScreen;
  

  
  

  var faToiletPaperBlank = {
    prefix: 'fasr',
    iconName: 'toilet-paper-blank',
    icon: [
      640,
      512,
      ["toilet-paper-alt"],
      'f71f',
      
      'M8 512H60 381.3l8.2-19.7c19-45.8 29.6-96.3 35.4-147.5c0-.2 0-.4 .1-.5c5.9-51.4 6.9-103.4 6.9-152.2c0-76 26.2-138.3 59.4-143.6c1.5-.2 3.1-.4 4.6-.4c35.3 0 64 64.5 64 144s-28.7 144-64 144c-13.2 0-25.5-9-35.7-24.5c-1.5 20-3.6 40.1-6.5 60.2C465.5 379 479.7 384 496 384c24.5 0 44.1-11.4 58-24.5c13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5C540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8 .1l0-.1H160C107 0 64 86 64 192c0 88.5-3.8 187.7-36.1 272c-.5 1.3-1 2.5-1.5 3.8L8 512zM419 48c-4.7 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 93.9-4.4 191.6-34.9 272H78.9C109 374.7 112 275 112 192c0-47.2 9.7-87.5 23.1-114.3c6.7-13.4 13.4-21.6 18.6-26c2.5-2.1 4.3-3 5.2-3.4c.5-.2 .8-.3 .9-.3s.2 0 .3 0H419zm77 192c13.3 0 24-21.5 24-48s-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48z'
      
    ]
  };

  
    var faToiletPaperAlt = faToiletPaperBlank;
  

  
  

  var faFolderXmark = {
    prefix: 'fasr',
    iconName: 'folder-xmark',
    icon: [
      512,
      512,
      ["folder-times"],
      'f65f',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm81.9 80l-17 17-47 47 47 47 17 17L320 385.9l-17-17-47-47-47 47-17 17L158.1 352l17-17 47-47-47-47-17-17L192 190.1l17 17 47 47 47-47 17-17L353.9 224z'
      
    ]
  };

  
    var faFolderTimes = faFolderXmark;
  

  
  

  var faFilmCanister = {
    prefix: 'fasr',
    iconName: 'film-canister',
    icon: [
      576,
      512,
      ["film-cannister"],
      'f8b7',
      
      'M96 0H256V32h40 32 24V80H328h-8V464h8 24v48H328 296 56 24 0V464H24h8V80H24 0V32H24 56 96V0zM80 80V464H272V80H80zm496 48V320H512v96H352V128H576zM392 168v48h48V168H392zm144 0H488v48h48V168zM392 328v48h48V328H392z'
      
    ]
  };

  
    var faFilmCannister = faFilmCanister;
  

  
  

  var faSplit = {
    prefix: 'fasr',
    iconName: 'split',
    icon: [
      512,
      512,
      [],
      'e254',
      
      'M412.8 30.1l17 17 57 57H488v1.3l5.8 5.8 17 17-17 17-5.8 5.8V152h-1.3l-57 57-17 17L378.9 192l17-17 23-23H329.9l-104 104 104 104h88.9l-23-23-17-17 33.9-33.9 17 17 57 57H488v1.3l5.8 5.8 17 17-17 17-5.8 5.8V408h-1.3l-57 57-17 17L378.9 448l17-17 23-23H320h-9.9l-7-7-121-121H24 0V232H24 182.1L303 111l7-7H320h98.9l-23-23-17-17 33.9-33.9z'
      
    ]
  };

  

  
  

  var faWaveformLines = {
    prefix: 'fasr',
    iconName: 'waveform-lines',
    icon: [
      640,
      512,
      ["waveform-path"],
      'f8f2',
      
      'M344 0V24 488v24H296V488 24 0h48zM544 64V88 424v24H496V424 88 64h48zM240 96v24V392v24H192V392 120 96h48zm208 32v24V360v24H400V360 152 128h48zM144 192v24 80 24H96V296 216 192h48zM48 224v24 16 24H0V264 248 224H48zm592 0v24 16 24H592V264 248 224h48z'
      
    ]
  };

  
    var faWaveformPath = faWaveformLines;
  

  
  

  var faWaterArrowUp = {
    prefix: 'fasr',
    iconName: 'water-arrow-up',
    icon: [
      576,
      512,
      ["water-rise"],
      'f775',
      
      'M312 256V232 89.5L359.9 133l17.8 16.1 32.3-35.5L392.1 97.4l-88-80L288 2.8 271.9 17.4l-88 80-17.8 16.1 32.3 35.5L216.1 133 264 89.5V232v24h48zM96 478.2c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V464c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6 0 0c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4 0 0c-13 11.6-24.8 22.2-40.2 30.9C39.4 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1c6.5-3.7 12.2-7.4 16.9-10.7zM79 360.9c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V336c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4c-13 11.6-24.8 22.2-40.2 30.9C39.4 328.2 19.7 336 0 336v48c31.5 0 59.7-12.2 79-23.1z'
      
    ]
  };

  
    var faWaterRise = faWaterArrowUp;
  

  
  

  var faPlaceOfWorship = {
    prefix: 'fasr',
    iconName: 'place-of-worship',
    icon: [
      640,
      512,
      [],
      'f67f',
      
      'M320 .1l17.5 18.7 72 76.8 6.5 6.9V112v73.5l53 34.3 11 7.1V240 464H592V357.1l-80-51.8V248.1l117 75.7 11 7.1V344 488v24H616 384v0H224v0H24 0V488 344 330.9l11-7.1 117-75.7v57.2L48 357.1V464H160V240 226.9l11-7.1 53-34.3V112v-9.5l6.5-6.9 72-76.8L320 .1zM272 121.5v77.1 13.1l-11 7.1-53 34.3V464h64V368c0-26.5 21.5-48 48-48s48 21.5 48 48v96h64V253.1l-53-34.3-11-7.1V198.6 121.5L320 70.3l-48 51.2z'
      
    ]
  };

  

  
  

  var faPersonSkiJumping = {
    prefix: 'fasr',
    iconName: 'person-ski-jumping',
    icon: [
      512,
      512,
      ["ski-jump"],
      'f7c7',
      
      'M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM112 96h24H309.6h9.9l7 7 16 16 18.2 18.2-19.4 16.9L202.4 275 171.1 384.4 464 233.4V192 168h48v24 56 14.6l-13 6.7L50.5 500.7l-21.3 11L7.1 469l21.3-11 92.4-47.7-6.6-1.9 6.6-23.1 45.7-159.8c2.7-9.4 7.8-18 14.9-24.9c11.1-10.7 36.2-34.6 60.8-56.8H136 112V96z'
      
    ]
  };

  
    var faSkiJump = faPersonSkiJumping;
  

  
  

  var faPlugCirclePlus = {
    prefix: 'fasr',
    iconName: 'plug-circle-plus',
    icon: [
      576,
      512,
      [],
      'e55f',
      
      'M120 24V0H72V24v88h48V24zm192 0V0H264V24v88h48V24zM24 144H0v48H24h8v64c0 80.2 59 146.6 136 158.2V512h48V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8 24V144H360h-8H304 80 32 24zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48 16v32H496 448v48 16H416V432 384H368 352V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faCircle7 = {
    prefix: 'fasr',
    iconName: 'circle-7',
    icon: [
      512,
      512,
      [],
      'e0f4',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72-384H184 160v48h24H290.2L196.3 375.8l-3.9 8.2h53L349.7 162.2l2.3-4.9V128H328z'
      
    ]
  };

  

  
  

  var faScannerTouchscreen = {
    prefix: 'fasr',
    iconName: 'scanner-touchscreen',
    icon: [
      512,
      512,
      [],
      'f48a',
      
      'M128 0V64h48V0H128zM304 0V64h48V0H304zM256 0H224V64h32V0zM384 0V288h32V0H384zM512 0H464V288h48V0zM48 144H304V464H48V144zm0-48H0v48V464v48H48 304h48V464 144 96H304 48zM272 432V176H80V432H272z'
      
    ]
  };

  

  
  

  var faWaterArrowDown = {
    prefix: 'fasr',
    iconName: 'water-arrow-down',
    icon: [
      576,
      512,
      ["water-lower"],
      'f774',
      
      'M312 0V24 161.7l47.9-43.5 17.8-16.1 32.3 35.5-17.8 16.1-88 80L288 248.4l-16.1-14.7-88-80-17.8-16.1 32.3-35.5 17.8 16.1L264 161.7 264 24V0h48zM96 478.2c-4.7 3.3-10.4 7-16.9 10.7C59.7 499.8 31.5 512 0 512V464c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l0 0 .4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l0 0 .7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.8 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7zM79 360.9C59.7 371.8 31.5 384 0 384V336c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.8 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  
    var faWaterLower = faWaterArrowDown;
  

  
  

  var faFaceSwear = {
    prefix: 'fasr',
    iconName: 'face-swear',
    icon: [
      640,
      512,
      [],
      'e399',
      
      'M320 48c114.9 0 208 93.1 208 208h48C576 114.6 461.4 0 320 0S64 114.6 64 256h48c0-114.9 93.1-208 208-208zM240.4 224c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32zM0 512H640V288H0V512zM400 384H384v32h16 16v32H400 384v16 16H352V464 448H320v16 16H288V464 448H272 256V416h16 16V384H272 256V352h16 16V336 320h32v16 16h32V336 320h32v16 16h16 16v32H400zm-80 0v32h32V384H320zm262.6-41.7l-10.4 12.1-96 112-10.4 12.1-24.3-20.8 10.4-12.1 96-112 10.4-12.1 24.3 20.8zM448 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 320v16 64 16H192V400 336 320h32zM192 448h32v32H192V448zM96.4 335.5V320h32v15.3c5.3 .9 10.4 2 15.1 3.2l15.5 3.9-7.7 31.1-15.5-3.9c-8.4-2.1-16.4-3.6-23.7-3.7c-5.5-.1-12 1.1-16.3 3.5c-2 1.1-3 2.1-3.3 2.6c-.2 .3-.5 .9-.5 2.4c0 .3 0 .3 .1 .4l0 0c.3 .4 1.2 1.3 3.5 2.5c4.9 2.7 11.9 4.6 21.4 7.3l.2 .1c8.4 2.4 19.3 5.4 28 10.6c9.6 5.6 18.9 15.2 19.3 30.6c.5 17.3-9.2 28.8-20.5 34.9c-5 2.7-10.5 4.5-15.8 5.6V480h-32V465.7c-7.5-1.6-14.5-3.8-20.6-5.8l0 0 0 0c-1.6-.5-3.1-1-4.5-1.4L56 453.7l9.5-30.6 15.3 4.8c1.8 .6 3.6 1.1 5.3 1.7l0 0c10.4 3.3 18.4 5.8 26.8 6.1c6 .2 12.1-1 16.1-3.1c1.8-1 2.7-1.9 3.1-2.5c.3-.5 .8-1.4 .7-3.3l0-.1c0-.6 0-1.7-3.6-3.8c-4.6-2.7-11.3-4.8-20.7-7.4l-1.6-.5 0 0c-8-2.3-18.1-5.1-26.3-9.5c-9.2-5-19.4-13.8-20.4-29.1C59 358.5 69.7 347 80.8 341.1c5-2.7 10.4-4.5 15.6-5.6z'
      
    ]
  };

  

  
  

  var faRadioTuner = {
    prefix: 'fasr',
    iconName: 'radio-tuner',
    icon: [
      512,
      512,
      ["radio-alt"],
      'f8d8',
      
      'M485.7 55.3L509 49.6 497.6 3 474.3 8.7l-456 112L0 125.2V128v16 32V304v24V464v48H48 464h48V464 176 128H464 189.8l296-72.7zM48 272H464V464H48V328 304 272zM368 432a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM80 320v32H96 224h16V320H224 96 80zm16 64v32h16 96 16V384H208 112 96z'
      
    ]
  };

  
    var faRadioAlt = faRadioTuner;
  

  
  

  var faFaceSmilePlus = {
    prefix: 'fasr',
    iconName: 'face-smile-plus',
    icon: [
      640,
      512,
      ["smile-plus"],
      'f5b9',
      
      'M568 0V24 72h48 24v48H616 568v48 24H520V168 120H472 448V72h24 48V24 0h48zM400 288A176 176 0 1 0 48 288a176 176 0 1 0 352 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 368c31.1 0 58.9-13.6 78-35.2l36 31.8C310.2 396.1 269.4 416 224 416s-86.2-19.9-114-51.5l36-31.8c19.1 21.6 46.9 35.2 78 35.2z'
      
    ]
  };

  
    var faSmilePlus = faFaceSmilePlus;
  

  
  

  var faMoped = {
    prefix: 'fasr',
    iconName: 'moped',
    icon: [
      640,
      512,
      [],
      'e3b9',
      
      'M328 32h24 64 17.1l5.6 16.1 15.6 44.8L512 64h32v96H512l-41.7-20.8L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8l-33.6 34.2C570.2 284.2 542.6 272 512 272c-52.7 0-97 36.5-108.9 85.6c-2 8.4-3.1 17.3-3.1 26.4H368 352 256c0 53-43 96-96 96s-96-43-96-96H48 0V336 320c0-70.7 57.3-128 128-128h80 48v48 48 48h48 32 23.3c14.5-46 49.1-83.1 93.6-100.7L398.9 80H352 328V32zm-72 80v48H96V112H256zM208 336V240H128c-44.2 0-80 35.8-80 80v16H208zm-48 96c26.5 0 48-21.5 48-48H112c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faTemperatureSnow = {
    prefix: 'fasr',
    iconName: 'temperature-snow',
    icon: [
      576,
      512,
      ["temperature-frigid"],
      'f768',
      
      'M357.3 307.7L368 294.5v-17V48H496V277.5v17l10.7 13.2C520 324.2 528 345.1 528 368c0 53-43 96-96 96s-96-43-96-96c0-22.9 8-43.8 21.3-60.3zM544 0H496 368 320V48 277.5c-20 24.7-32 56.2-32 90.5c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5V48 0zM432 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272 256H416v16 50.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM288 96.9l-22.6-6.1-4.1 15.5-12.9 48.2L200 182.4V126.6l35.3-35.3L246.6 80 224 57.4 212.7 68.7 200 81.4V56 32H152V56 81.4L139.3 68.7 128 57.4 105.4 80l11.3 11.3L152 126.6v55.8l-48.3-27.9L90.7 106.3 86.6 90.8 55.7 99.1l4.1 15.5 4.6 17.3-15-8.7-20.8-12-24 41.6 20.8 12 15 8.7-17.3 4.6L7.7 182.3 16 213.2 31.4 209l48.2-12.9L128 224 79.7 251.9 31.4 239 16 234.8 7.7 265.7l15.5 4.1 17.3 4.6-15 8.7-20.8 12 24 41.6 20.8-12 15-8.7-4.6 17.3-4.1 15.5 30.9 8.3 4.1-15.5 12.9-48.2L152 265.6v55.8l-35.3 35.3L105.4 368 128 390.6l11.3-11.3L152 366.6V392v24h48V392 366.6l12.7 12.7L224 390.6 246.6 368l-11.3-11.3L200 321.4V265.6l48.3 27.9 10.9 40.7c4.8-24.7 14.8-47.6 28.8-67.4V247.7l-15.7 4.2L224 224l48.3-27.9 15.7 4.2V131.6l-.5 .3 .5-1.8V96.9z'
      
    ]
  };

  
    var faTemperatureFrigid = faTemperatureSnow;
  

  
  

  var faTabletRugged = {
    prefix: 'fasr',
    iconName: 'tablet-rugged',
    icon: [
      448,
      512,
      [],
      'f48f',
      
      'M368 48V464H80V48H368zM80 0H32V48L0 64v96l32 16v16L0 208v96l32 16v16L0 352v96l32 16v48H80 368h48V464l32-16V352l-32-16V320l32-16V208l-32-16V176l32-16V64L416 48V0H368 80z'
      
    ]
  };

  

  
  

  var faDistributeSpacingHorizontal = {
    prefix: 'fasr',
    iconName: 'distribute-spacing-horizontal',
    icon: [
      512,
      512,
      [],
      'e365',
      
      'M480 0L432 0l0 512 48 0L480 0zM304 368l-96 0 0-224 96 0 0 224zm48-224l0-48-48 0-96 0-48 0 0 48 0 224 0 48 48 0 96 0 48 0 0-48 0-224zM80 512L80 0 32 0l0 512 48 0z'
      
    ]
  };

  

  
  

  var faEyeDropperFull = {
    prefix: 'fasr',
    iconName: 'eye-dropper-full',
    icon: [
      512,
      512,
      [],
      'e172',
      
      'M233 135L338.2 29.8c19.1-19.1 45-29.8 72-29.8C466.4 0 512 45.6 512 101.8c0 27-10.7 52.9-29.8 72L377 279l8 8 17 17L368 337.9l-17-17L191 161l-17-17L208 110.1l17 17 8 8zM343 245.1L448.2 139.9c10.1-10.1 15.8-23.8 15.8-38.1C464 72.1 439.9 48 410.2 48c-14.3 0-28 5.7-38.1 15.8L266.9 169 343 245.1zM180.4 195.6l136 136L168 480H80L40 512 0 472l32-40V344L180.4 195.6z'
      
    ]
  };

  

  
  

  var faVials = {
    prefix: 'fasr',
    iconName: 'vials',
    icon: [
      512,
      512,
      [],
      'f493',
      
      'M0 32H24 56 168h32 24V80H200h-8V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V80H24 0V32zM80 80V256h64V80H80zM288 32h24 32H456h32 24V80H488h-8V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V80h-8H288V32zm80 48V256h64V80H368z'
      
    ]
  };

  

  
  

  var faShieldPlus = {
    prefix: 'fasr',
    iconName: 'shield-plus',
    icon: [
      512,
      512,
      [],
      'e24a',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM232 368h48V344 280h64 24V232H344 280V168l0-24H232v24 64H168 144v48h24 64v64 24z'
      
    ]
  };

  

  
  

  var faBookFont = {
    prefix: 'fasr',
    iconName: 'book-font',
    icon: [
      448,
      512,
      [],
      'e0bf',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zM255.3 80l6.4 13.9L359.2 304H306.3L284 256h-4H200h-4l-22.3 48H120.8L218.2 93.9 224.7 80h30.7zm6.4 128L240 161.1 218.2 208h43.5z'
      
    ]
  };

  

  
  

  var faCartShopping = {
    prefix: 'fasr',
    iconName: 'cart-shopping',
    icon: [
      576,
      512,
      [128722,"shopping-cart"],
      'f07a',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 488h24V336H488 179.9l-9.1-48H496L561 80l15-48H525.7 122l-2.4-12.5L115.9 0H96 24zM161.6 240L131.1 80H510.7l-50 160H161.6zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faShoppingCart = faCartShopping;
  

  
  

  var faCarGarage = {
    prefix: 'fasr',
    iconName: 'car-garage',
    icon: [
      640,
      512,
      [],
      'f5e2',
      
      'M331 10.7l280 144 21.3 11-22 42.7-21.3-11L320 59 51 197.3l-21.3 11-22-42.7 21.3-11 280-144L320 5l11 5.6zM199.1 160H216 424h16.9l5.7 15.9L480.9 272H528v48 80 16 32 64H480l0-64H160v64H112V448 416 400 320 272h47.1l34.3-96.1 5.7-15.9zm208 48H232.9l-22.9 64H429.9l-22.9-64zM480 320H160v80H480V320zM208 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faPersonMilitaryRifle = {
    prefix: 'fasr',
    iconName: 'person-military-rifle',
    icon: [
      512,
      512,
      [],
      'e54b',
      
      'M160 16V64H352V0L160 16zM437.9 40L424 32 408 59.7l13.9 8L331.6 224H304 208 168h-8-5.9l-6.9 12.1L46.4 412.1 34.4 432.9l41.7 23.9L88 435.9l72-125.7V464v48h48 96 48V464 310.3l72 125.7 11.9 20.8 41.7-23.9-11.9-20.8L391.9 283.3l53.4-92.5L416 173.9 479.4 64l-13.9-8L437.9 40zM304 272V403.6L228.8 272H304zM208 464V332.4L283.2 464H208zM176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H283.7c2.7 4.7 4.3 10.2 4.3 16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H177.6c-1 5.2-1.6 10.5-1.6 16z'
      
    ]
  };

  

  
  

  var faFlagSwallowtail = {
    prefix: 'fasr',
    iconName: 'flag-swallowtail',
    icon: [
      448,
      512,
      ["flag-alt"],
      'f74c',
      
      'M48 24V0H0V24v8V80 304v48V488v24H48V488 352H392h56l-28.8-48L352 192 419.2 80 448 32H392 48V24zm0 56H363.2l-52.4 87.3L296 192l14.8 24.7L363.2 304H48V80z'
      
    ]
  };

  
    var faFlagAlt = faFlagSwallowtail;
  

  
  

  var faStarOfDavid = {
    prefix: 'fasr',
    iconName: 'star-of-david',
    icon: [
      512,
      512,
      [10017],
      'f69a',
      
      'M16 400H64h99.3L232 512h48l68.7-112H448h48V352l-58.9-96L496 160V112H448 348.7L280 0H232L163.3 112H64 16v48l58.9 96L16 352v48zm87.1-98.1L133.8 352H72.3l30.8-50.1zM190.1 352l-58.9-96 58.9-96H321.9l58.9 96-58.9 96H190.1zm29.5 48h72.8L256 459.3 219.6 400zm158.6-48l30.7-50.1L439.7 352H378.2zm30.7-141.9L378.2 160h61.5l-30.8 50.1zM292.4 112H219.6L256 52.7 292.4 112zM133.8 160l-30.8 50.1L72.3 160h61.5z'
      
    ]
  };

  

  
  

  var faMosquito = {
    prefix: 'fasr',
    iconName: 'mosquito',
    icon: [
      640,
      512,
      [],
      'e52b',
      
      'M288 266l0 .2-67 87-5 6.5 0 8.2 0 53.5-40.4 37.9-17.5 16.4 32.9 35 17.5-16.4 48-45.1 7.6-7.1 0-10.4 0-55.7 24-31.2 0 62.9 0 32 64 0 0-32 0-63L376 376l0 55.7 0 10.4 7.6 7.1 48 45.1 17.5 16.4 32.9-35-17.5-16.4L424 421.4l0-53.5 0-8.2-5-6.5-67-87 0-.2L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9L449 161.1l13-13-9.1-15.9L429.5 91.4l36.3-40.1 16.1-17.8L446.3 1.3 430.2 19.1l-48 53L370.5 85l8.6 15.1 22.9 40L352 190.3l0-38.1 0-32-24 0 0-56.2 0-8-16 0 0 8 0 56.2-24 0 0 32 0 38.1-50.1-50.1 22.9-40L269.5 85 257.8 72.1l-48-53L193.7 1.3 158.1 33.5l16.1 17.8 36.3 40.1-23.3 40.8-9.1 15.9 13 13 41.3 41.4-153 23.9C34 232.4 0 272.8 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266zM119.9 354.6c-13.6 14.2-30.4 16-44.9 9.7c-14.8-6.4-27-21.4-27-43.7c0-25.5 17.8-44 37.6-46.6c.4-.1 .8-.1 1.2-.2l146.6-23L122.3 352.3c-.8 .7-1.6 1.5-2.4 2.3zM406.6 250.9l146.6 22.9c.4 .1 .8 .1 1.2 .2c19.7 2.6 37.6 21.1 37.6 46.6c0 22.3-12.2 37.3-27 43.7c-14.5 6.3-31.3 4.5-44.9-9.7c-.8-.8-1.6-1.6-2.4-2.3L406.6 250.9z'
      
    ]
  };

  

  
  

  var faDuck = {
    prefix: 'fasr',
    iconName: 'duck',
    icon: [
      512,
      512,
      [129414],
      'f6d8',
      
      'M250.8 272.4L104.3 325.2l-17.8 6.4-17.4-7.4-18.3-7.9C63.9 382.3 122.1 432 192 432H312c44.2 0 80-35.8 80-80V339.2c0-22.4-9.2-42.8-24.4-57.5L352 266.6V224.4l19.8-15.2C389 195.9 400 175.3 400 152c0-39.8-32.2-72-72-72s-72 32.2-72 72c0 17.1 5.9 32.8 15.9 45.1l16.1 20V259l-37.2 13.4zM32 256l16 6.9L88 280l99.5-35.8 47-16.9c-10.1-12.5-17.7-27.1-22.1-43C209.5 174 208 163.2 208 152c0-66.3 53.7-120 120-120c60.8 0 111 45.2 118.9 103.9l1.1 .1 64-8v8c0 52.5-42.2 95.2-94.5 96c-5 5.6-10.5 10.7-16.4 15.3c9 8.7 16.8 18.8 22.9 29.8c10.3 18.5 16.1 39.7 16.1 62.2V352c0 70.7-57.3 128-128 128H192C91.3 480 8.8 402.6 .7 304c-.4-5.3-.7-10.6-.7-16V256H32zM344 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM231.5 353.7c22.7-5.7 38.1-24 40.8-44l47.6 6.3c-5.3 39.8-35.2 73.9-76.7 84.2c-34.1 8.5-68.6-.8-92.8-22.3l31.9-35.9c12.5 11.1 30.7 16.2 49.3 11.6z'
      
    ]
  };

  

  
  

  var faMosque = {
    prefix: 'fasr',
    iconName: 'mosque',
    icon: [
      640,
      512,
      [128332],
      'f678',
      
      'M400 0l19.2 25.6c17.9 23.8 39.8 40.5 66.4 56.3c12.8 7.6 26.4 14.9 41.2 22.8l2 1.1c15.4 8.2 31.9 17.1 48.9 27.3c30.1 18 46.2 50.7 46.2 84c0 20.2-5.8 39-15.9 54.9H616h24v24V488v24H616 448 352 240 184 160 24 0V488 176 148.7C0 104.3 20.5 62.3 55.6 35l25.7-20L96 3.6l14.7 11.5 25.7 20c26.8 20.8 45.1 50.2 52.2 82.7c-22.6 19.6-36.9 46.1-42.3 74.3H144 48V464H160V296 272h24 7.9c-10-15.9-15.9-34.7-15.9-54.9c0-33.3 16.1-66 46.2-84c17-10.2 33.5-19 48.9-27.3l2-1.1 0 0 0 0 0 0c14.8-7.9 28.3-15.2 41.2-22.8c26.6-15.8 48.5-32.5 66.4-56.3L400 0zM208 464h32 16V408c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48V414c0-19 8.4-37 23-49.2L400 344l25 20.8C439.6 377 448 395 448 414v50h48V408c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48V320H521.1 400 278.9 208V464zM48.1 144h95.8c-1.4-27.9-14.8-53.9-36.9-71.1L96 64.4 85.1 72.9C62.9 90.1 49.5 116.1 48.1 144zM576 217.1c0-18.2-8.8-34.3-22.8-42.8c-16-9.5-31.5-17.9-47-26.2l-2.4-1.3 0 0c-14.5-7.7-29-15.5-42.8-23.7c-21.6-12.9-42.4-27.4-61.1-46.4c-18.7 19-39.4 33.5-61.1 46.4c-13.8 8.2-28.3 16-42.8 23.7l0 0-2.4 1.3c-15.4 8.2-31 16.6-47 26.2c-14.1 8.4-22.8 24.5-22.8 42.8c0 30.3 24.6 54.9 54.9 54.9H400 521.1c30.3 0 54.9-24.6 54.9-54.9z'
      
    ]
  };

  

  
  

  var faBookHeart = {
    prefix: 'fasr',
    iconName: 'book-heart',
    icon: [
      448,
      512,
      [],
      'f499',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zm80-187.5c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L240 304.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z'
      
    ]
  };

  

  
  

  var faDropletSlash = {
    prefix: 'fasr',
    iconName: 'droplet-slash',
    icon: [
      640,
      512,
      ["tint-slash"],
      'f5c7',
      
      'M505.5 369.7l115.4 89.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L209.9 140.2c27.8-40.3 57.2-77.4 78.6-103.3C307.3 14.1 320 0 320 0s12.7 14.1 31.5 36.9C405.9 102.8 512 241.2 512 320c0 17.2-2.3 33.8-6.5 49.7zm-257.6-200L463 336.7c.6-5.5 1-11.1 1-16.7c0-14.5-7.4-39.2-24.7-72.8c-16.5-32-39-66.6-62.3-99c-20.2-28.1-40.5-53.9-57-74.1c-16.5 20.2-36.8 46-57 74.1c-5.1 7.1-10.1 14.2-15.1 21.4zM456.1 455.4C421.4 490.4 373.2 512 320 512c-106 0-192-86-192-192c0-27.4 12.8-61.9 31.8-98.1l38.4 30.3C182.7 283.2 176 306.2 176 320c0 79.5 64.5 144 144 144c37.9 0 72.4-14.6 98.1-38.6l38 30zM328 368v48c-57.4 0-104-46.6-104-104h48c0 30.9 25.1 56 56 56z'
      
    ]
  };

  
    var faTintSlash = faDropletSlash;
  

  
  

  var faGear = {
    prefix: 'fasr',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M328 0l14.6 66.8c11.9 5.5 23.3 12 33.8 19.6l65.2-20.8 72 124.7-50.6 46.1c.6 6.4 .9 12.9 .9 19.5s-.3 13.1-.9 19.5l50.6 46.1-72 124.7-65.2-20.8c-10.6 7.5-21.9 14.1-33.8 19.6L328 512H184l-14.6-66.8c-11.9-5.5-23.3-12-33.8-19.6L70.3 446.4l-72-124.7 50.6-46.1c-.6-6.4-.9-12.9-.9-19.5s.3-13.1 .9-19.5L-1.7 190.4l72-124.7 65.2 20.8c10.6-7.5 21.9-14.1 33.8-19.6L184 0H328zm63 132.2l-22.9 7.3-19.5-13.9c-8.2-5.8-16.9-10.9-26-15.1l-21.8-10-5.1-23.4L289.4 48H222.6l-6.4 29.1-5.1 23.4-21.8 10c-9.2 4.2-17.9 9.3-26 15.1l-19.5 13.9L121 132.2l-28.4-9L59.2 180.9l22 20.1 17.7 16.1-2.2 23.8c-.5 5-.7 10-.7 15.1s.2 10.1 .7 15.1l2.2 23.8L81.2 311l-22 20.1 33.4 57.8 28.4-9 22.9-7.3 19.5 13.9c8.2 5.8 16.9 10.9 26 15.1l21.8 10 5.1 23.4 6.4 29.1h66.7l6.4-29.1 5.1-23.4 21.8-10c9.2-4.2 17.9-9.3 26-15.1l19.5-13.9 22.9 7.3 28.4 9 33.4-57.8L430.8 311l-17.7-16.1 2.2-23.8c.5-5 .7-10 .7-15.1s-.2-10.1-.7-15.1l-2.2-23.8L430.8 201l22.1-20.1-33.4-57.8-28.4 9zM304 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faCameraSecurity = {
    prefix: 'fasr',
    iconName: 'camera-security',
    icon: [
      448,
      512,
      ["camera-home"],
      'f8fe',
      
      'M400 48V368H320 128 48V48H400zM346.7 416H400h48V368 48 0H400 48 0V48 368v48H48h53.3L74.7 464 48 512h54.9H345.1 400l-26.7-48-26.7-48zm-54.9 0l26.7 48H129.6l26.7-48H291.8zM336 208a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM224 144a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  
    var faCameraHome = faCameraSecurity;
  

  
  

  var faUserDoctorHairLong = {
    prefix: 'fasr',
    iconName: 'user-doctor-hair-long',
    icon: [
      448,
      512,
      [],
      'e459',
      
      'M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16 48L48 240v32H224 400V240l-48-48V144 128C352 57.3 294.7 0 224 0zM99.5 352H136v50.3c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V352H280v50c-27.6 7.1-48 32.2-48 62v32 16h16 24 16V480H272h-8V464c0-17.7 14.3-32 32-32s32 14.3 32 32v16h-8H304v32h16 24 16V496 464c0-29.8-20.4-54.9-48-62V352h36.5l49.2 160H448L384 304H64L0 512H50.2L99.5 352zM128 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faFileCertificate = {
    prefix: 'fasr',
    iconName: 'file-certificate',
    icon: [
      512,
      512,
      ["file-award"],
      'f5f3',
      
      'M224 464H464V160H352V48H176v70.2l-1.9-2.4L151.6 125 128 134.7V48 0h48H384L512 128V464v48H464 224v0V464zM92.3 154.6l5.6 2.3L128 169.3 158.1 157l5.6-2.3 3.7 4.8 19.9 25.7 32.2 4.4 6 .8 .8 6 4.4 32.2 25.7 19.9 4.8 3.7-2.3 5.6L246.7 288 259 318.1l2.3 5.6-4.8 3.7-25.7 19.9-4.4 32.2-.8 6-6 .8L192 390.2V512l-64-40L64 512V390.2l-27.6-3.8-6-.8-.8-6-4.4-32.2L-.5 327.4l-4.8-3.7 2.3-5.6L9.3 288-3 257.9l-2.3-5.6 4.8-3.7 25.7-19.9 4.4-32.2 .8-6 6-.8 32.2-4.4 19.9-25.7 3.7-4.8zM192 288A64 64 0 1 0 64 288a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faFileAward = faFileCertificate;
  

  
  

  var faMessageXmark = {
    prefix: 'fasr',
    iconName: 'message-xmark',
    icon: [
      512,
      512,
      ["comment-alt-times","message-times"],
      'f4ab',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM353.9 144L320 110.1l-17 17-47 47-47-47-17-17L158.1 144l17 17 47 47-47 47-17 17L192 305.9l17-17 47-47 47 47 17 17L353.9 272l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faCommentAltTimes = faMessageXmark;
  
    var faMessageTimes = faMessageXmark;
  

  
  

  var faHousePersonReturn = {
    prefix: 'fasr',
    iconName: 'house-person-return',
    icon: [
      640,
      512,
      ["house-person-arrive","house-return"],
      'e011',
      
      'M384 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM557.4 201.5l20.5 47.9 9.5 22.1 44.1-18.9-9.5-22.1-24-56-3.5-8.1-7.9-3.9-80-40-8.2-4.1-8.8 2.4-88 24-13.2 3.6-3.6 13.2-22.3 81.9L327 279 361 313l40-40 4.5-4.5 1.7-6.1 6.4-23.4 25.7 82.3-54.4 44.2-6.2 5-1.9 7.8-24 96-5.8 23.3 46.6 11.6 5.8-23.3 22.1-88.2 104.6-85c18.1-14.7 25.2-39.1 17.8-61.2l-22.7-68 36.3 18.2zm-59.2 65.1c1.1 3.2 0 6.6-2.5 8.7l-16.3 13.3L446.9 184.8c-.2-.8-.5-1.6-.9-2.3l22.1-6 30 90.1zm66.2 135.9l-24.1-60.4-39 31.7 20.4 51.1 1.8 4.6L527 433l60.8 60.8 17 17 33.9-33.9-17-17-57.3-57.3zM384.6 116.9L255 13.3l-15-12-15 12L25 173.3l-18.7 15 30 37.5 18.7-15 9-7.2V392v24H88 336.5l12-48H112V165.1L240 62.7l115.7 92.5 9-32.9 20-5.4zM160 192v96h96V192H160z'
      
    ]
  };

  
    var faHousePersonArrive = faHousePersonReturn;
  
    var faHouseReturn = faHousePersonReturn;
  

  
  

  var faCartCircleArrowDown = {
    prefix: 'fasr',
    iconName: 'cart-circle-arrow-down',
    icon: [
      640,
      512,
      [],
      'e3ef',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H510.7L475.3 193.2c6.8-.8 13.7-1.2 20.7-1.2c10 0 19.7 .8 29.2 2.4L561 80l15-48H525.7 122l-2.4-12.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-136l-11.3 11.3-56 56L496 454.6l-11.3-11.3-56-56L417.4 376 440 353.4l11.3 11.3L480 393.4V304 288h32v16 89.4l28.7-28.7L552 353.4 574.6 376z'
      
    ]
  };

  

  
  

  var faFaceSmileHalo = {
    prefix: 'fasr',
    iconName: 'face-smile-halo',
    icon: [
      512,
      512,
      [],
      'e38f',
      
      'M512 80C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zm-64 0c0 17.7-86 32-192 32S64 97.7 64 80s86-32 192-32s192 14.3 192 32zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-14 5.8-29.6 11.1-46.4 15.6c17.8 29.1 28 63.3 28 99.9c0 106-86 192-192 192S64 378 64 272c0-36.6 10.2-70.8 28-99.9c-16.9-4.6-32.4-9.8-46.4-15.6zM176 208c-28 0-56 40-56 80c0 0 28-32 56-32s56 32 56 32c0-40-28-80-56-80zm80 208c61.9 0 112-36.8 132-66.7L348 322.7C336 340.8 300.1 368 256 368s-80-27.2-92-45.3L124 349.3c19.9 29.9 70 66.7 132 66.7zm24-128s28-32 56-32s56 32 56 32c0-40-28-80-56-80s-56 40-56 80z'
      
    ]
  };

  

  
  

  var faCircleBolt = {
    prefix: 'fasr',
    iconName: 'circle-bolt',
    icon: [
      512,
      512,
      [],
      'e0fe',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm232 16H144V248L320 112 280 240h88v24L192 400l40-128z'
      
    ]
  };

  

  
  

  var faPresentationScreen = {
    prefix: 'fasr',
    iconName: 'presentation-screen',
    icon: [
      576,
      512,
      ["presentation"],
      'f685',
      
      'M24 0H0V48H24 552h24V0H552 24zm8 80V328v24H56 264v46.1l-61.8 61.8-17 17 33.9 33.9 17-17L288 441.9l51.8 51.8 17 17 33.9-33.9-17-17L312 398.1V352H520h24V328 80H496V304H288 80V80H32z'
      
    ]
  };

  
    var faPresentation = faPresentationScreen;
  

  
  

  var faHandsAslInterpreting = {
    prefix: 'fasr',
    iconName: 'hands-asl-interpreting',
    icon: [
      640,
      512,
      ["american-sign-language-interpreting","asl-interpreting","hands-american-sign-language-interpreting"],
      'f2a3',
      
      'M221.3 1.1l16.5 17.4 55.1 58 8.7 9.2 6-1.9 7.2 22.9 11.4 36C354 109.1 394.9 96 432 96h.1 54c85 0 154 68.9 154 154c0 15.9-2.5 31.8-7.3 46.9L573 483.5l-7.3 22.9L542.8 499l-76.2-24.4-7.3-2.3-23.2 22.1-17.4 16.5-16.5-17.4-55.1-58-8.7-9.2-6 1.9-7.2-22.9-11.4-36C286 402.9 245.1 416 208 416h-.1H154C68.9 416 0 347.1 0 262c0-15.9 2.5-31.8 7.3-46.9L67 28.5 74.4 5.6 97.2 13l76.2 24.4 7.3 2.3 23.2-22.1L221.3 1.1zM135.9 75.7L105.4 66 53 229.7c-3.3 10.4-5 21.3-5 32.3c0 58.5 47.4 106 106 106h54 .1c30.8 0 60.2-12.3 76.2-40l8-13.9-23.1-13.4-4.6-2.6-8 13.8c-8.7 15.1-25.6 24-48.5 24h0l0 0C177 336 152 310.9 152 280c0-30.9 25.1-56 56-56c22.9 0 39.8 9 48.5 24l8 13.8 4.6-2.6 23.1-13.4-8-13.8c-3.6-6.2-7.8-11.6-12.4-16.1l-28.3-28 38-12 4.5-1.4L276.3 144l-34.6 10.9-99.1 31.3L218 114.6l23.7-22.5-22-23.2-49.1 46.7-68 64.6 28.6-89.3 4.8-15.1zM504.1 436.3l30.5 9.8L587 282.3c3.3-10.4 5-21.3 5-32.3c0-58.5-47.4-106-106-106h-54H432c-30.8 0-60.2 12.3-76.2 40l-8 13.8 23.1 13.4 4.6 2.6 8-13.8c8.7-15.1 25.6-24 48.5-24h0l0 0c30.9 0 55.9 25.1 55.9 56c0 30.9-25.1 56-56 56c-22.9 0-39.8-9-48.5-24l-8-13.8-4.6 2.6-23.1 13.4 8 13.8c3.6 6.2 7.8 11.6 12.4 16.1l28.3 28-38 12-4.5 1.4 9.6 30.5 34.6-10.9 99.1-31.3L422 397.4l-23.7 22.5 22 23.2 49.1-46.7 68-64.6-28.6 89.3-4.8 15.1zM224 280a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm208-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  
    var faAslInterpreting = faHandsAslInterpreting;
  
    var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  

  
  

  var faChartUser = {
    prefix: 'fasr',
    iconName: 'chart-user',
    icon: [
      640,
      512,
      ["user-chart"],
      'f6a3',
      
      'M208 48H592V368H310.2l14.4 48H592h48V368 48 0H592 208 160V48 96c17 0 33.2 3.3 48 9.3V48zM512 240l16-16V112H416l-16 16 39 39-55 55-47-47-17-17L286.1 192l17 17 64 64 17 17 17-17 72-72 39 39zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM83.7 400H236.3l19.2 64H64.5l19.2-64zM272 352H48L14.4 464 0 512H50.1 269.9 320l-14.4-48L272 352z'
      
    ]
  };

  
    var faUserChart = faChartUser;
  

  
  

  var faBookCircleArrowRight = {
    prefix: 'fasr',
    iconName: 'book-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0bc',
      
      'M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H394.8c-18.3-12.9-34.1-29.2-46.3-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H322.9c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H400V220.5c14.6-9.5 30.8-17 48-21.8V24 0H424 88zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 289.4l11.3 11.3 56 56L582.6 368l-11.3 11.3-56 56L504 446.6 481.4 424l11.3-11.3L521.4 384H432 416V352h16 89.4l-28.7-28.7L481.4 312 504 289.4z'
      
    ]
  };

  

  
  

  var faVolumeOff = {
    prefix: 'fasr',
    iconName: 'volume-off',
    icon: [
      320,
      512,
      [],
      'f026',
      
      'M146.2 304l13.6 12.1L272 415.8V96.2L159.9 195.9 146.2 208H128 48v96h80 18.2zM48 352H0V304 208 160H48h80L272 32h48V80 432v48H272L128 352H48z'
      
    ]
  };

  

  
  

  var faFlaskRoundPoison = {
    prefix: 'fasr',
    iconName: 'flask-round-poison',
    icon: [
      448,
      512,
      ["flask-poison"],
      'f6e0',
      
      'M176 196.5V167.4 48h96V167.4v29.1L297.8 210c51.3 26.7 86.2 80.3 86.2 142c0 43.6-17.4 83.1-45.7 112H109.7C81.4 435.1 64 395.6 64 352c0-61.7 34.9-115.3 86.2-142L176 196.5zm144-29.1V48h8 24V0H328h-8H272 176 128h-8H96V48h24 8V167.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160H356.9c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6zM312 328c0-39.8-39.4-72-88-72s-88 32.2-88 72c0 22.4 12.5 42.3 32 55.5V416H280V383.5c19.5-13.2 32-33.2 32-55.5zM192 312a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faFlaskPoison = faFlaskRoundPoison;
  

  
  

  var faFrancSign = {
    prefix: 'fasr',
    iconName: 'franc-sign',
    icon: [
      320,
      512,
      [],
      'e18f',
      
      'M72 32H48V56 192v48 80H0v48H48v88 24H96V456 368H224V320H96V240H288V192H96V80H296h24V32H296 72z'
      
    ]
  };

  

  
  

  var faArrowDownLeft = {
    prefix: 'fasr',
    iconName: 'arrow-down-left',
    icon: [
      384,
      512,
      [],
      'e091',
      
      'M56 416H32V392 152 128H80v24V334.1L303 111l17-17L353.9 128l-17 17-223 223H296h24v48H296 56z'
      
    ]
  };

  

  
  

  var faStreetView = {
    prefix: 'fasr',
    iconName: 'street-view',
    icon: [
      512,
      512,
      [],
      'f21d',
      
      'M256 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-96a72 72 0 1 1 0 144A72 72 0 1 1 256 0zM223.4 280l4.7 42.7L235 384H277l6.8-61.3 4.7-42.7H320V240c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v40h31.4zm108.1 48L320 432H192L180.4 328H144V280 240c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80v40 48H331.6zM55.3 419.2c-3.6 2.4-3.6 7.2 0 9.6c8.8 5.7 23.1 11.8 43 17.3C137.7 457 193.5 464 256 464s118.3-7 157.7-17.9c19.9-5.5 34.2-11.6 43-17.3c3.6-2.4 3.6-7.2 0-9.6c-2.1-1.4-4.8-2.9-7.9-4.5c-15.3-7.7-38.8-14.9-69-20.5l8.6-47.2c32.4 5.9 60.9 14.2 82 24.8c10.5 5.3 20.3 11.7 27.8 19.6c7.6 8.1 14 19.1 14 32.6c0 21.4-15.5 36.1-29.1 45c-14.7 9.6-34.3 17.3-56.4 23.4C381.8 504.7 321.6 512 256 512s-125.8-7.3-170.4-19.6c-22.1-6.1-41.8-13.8-56.4-23.4C15.5 460.1 0 445.4 0 424c0-13.5 6.4-24.5 14-32.6c7.5-7.9 17.3-14.3 27.8-19.6c21-10.6 49.5-18.9 82-24.8l8.6 47.2c-30.2 5.5-53.7 12.8-69 20.5c-3.2 1.6-5.8 3.1-7.9 4.5z'
      
    ]
  };

  

  
  

  var faFontCase = {
    prefix: 'fasr',
    iconName: 'font-case',
    icon: [
      640,
      512,
      [],
      'f866',
      
      'M153.4 48L159 32h34l5.6 16 152 432H299.8L260.4 368H91.6L52.2 480H1.3L153.4 48zM108.5 320h135L176 128.3 108.5 320zM640 184V456v24H592V456v-8.8c-22.1 20.4-51.6 32.8-84 32.8c-68.5 0-124-55.5-124-124V284c0-68.5 55.5-124 124-124c32.4 0 61.9 12.4 84 32.8V184 160h48v24zM508 208c-42 0-76 34-76 76v72c0 42 34 76 76 76s76-34 76-76V284c0-42-34-76-76-76z'
      
    ]
  };

  

  
  

  var faPlugCircleCheck = {
    prefix: 'fasr',
    iconName: 'plug-circle-check',
    icon: [
      576,
      512,
      [],
      'e55c',
      
      'M120 24V0H72V24v88h48V24zm192 0V0H264V24v88h48V24zM24 144H0v48H24h8v64c0 80.2 59 146.6 136 158.2V512h48V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8 24V144H360h-8H304 80 32 24zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336z'
      
    ]
  };

  

  
  

  var faArrowLeftLong = {
    prefix: 'fasr',
    iconName: 'arrow-left-long',
    icon: [
      512,
      512,
      ["long-arrow-left"],
      'f177',
      
      'M17 239L0 256l17 17L153 409l17 17L203.9 392l-17-17-95-95L488 280l24 0 0-48-24 0L91.9 232l95-95 17-17L169.9 86.1l-17 17L17 239z'
      
    ]
  };

  
    var faLongArrowLeft = faArrowLeftLong;
  

  
  

  var faTrashSlash = {
    prefix: 'fasr',
    iconName: 'trash-slash',
    icon: [
      640,
      512,
      [],
      'e2b3',
      
      'M243.2 0H256 384h12.8L404 10.7 450.2 80h13.7H512h32v48H508.4L491.4 358.7 620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 84 65.2h43.8 13.7L236 10.7 243.2 0zm-49 128L445.8 323.4 460.3 128H194.2zm243 312.4l45.5 35.8L480 512H160L137.2 204.1l51.1 40.3L204.6 464H435.4l1.7-23.6zM247.5 80h145L371.2 48H268.8L247.5 80z'
      
    ]
  };

  

  
  

  var faChess = {
    prefix: 'fasr',
    iconName: 'chess',
    icon: [
      512,
      512,
      [],
      'f439',
      
      'M144 0V16 32h16 16V64H160 144V96h40 48v24l-8 24-21.3 64H224v48H200h-5.8l13.1 96H158.8l-13.1-96H110.3L97.2 352H48.7l13.1-96H56 32V208H53.3L32 144l-8-24V96H72h40V64H96 80V32H96h16V16 0h32zM103.9 208h48.1l21.3-64H82.6l21.3 64zM71.5 432L53.8 464H202.2l-17.8-32H71.5zm141.2-48L256 461.9 299.3 384H468.7L512 461.9V464v48H464 304 256 208 48 0V464v-2.1L43.3 384H212.7zM280 160H488h24v24 72 8.7l-5.6 6.7L472 312.7V328v24H424V328 304v-8.7l5.6-6.7L464 247.3V208H432v16 16H400V224 208H368v16 16H336V224 208H304v39.3l34.4 41.3 5.6 6.7V304v24 24H296V328 312.7l-34.4-41.3-5.6-6.7V256 184 160h24zm29.8 304H458.2l-17.8-32H327.5l-17.8 32z'
      
    ]
  };

  

  
  

  var faGif = {
    prefix: 'fasr',
    iconName: 'gif',
    icon: [
      576,
      512,
      [],
      'e190',
      
      'M528 80V432H48V80H528zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM320 160H272v24V328v24h48V328 184 160zm32 0v24 80 64 24h48V328 288h40 24V240H440 400V208h64 24V160H464 376 352zM128 256c0-26.5 21.5-48 48-48c12.3 0 23.5 4.6 32 12.2l32-35.8c-17-15.2-39.4-24.5-64-24.5c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8l11.2-7.1V315.9 280 256H192v24 21.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faRightToLine = {
    prefix: 'fasr',
    iconName: 'right-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-right"],
      'f34c',
      
      'M128 288l48 0 0 48 0 28.1L284.1 256 176 147.9l0 28.1 0 48-48 0-80 0 0 64 80 0zm190.1 1.9L192 416l-16 0-48 0 0-32 0-16 0-32-48 0-32 0L0 336l0-48 0-64 0-48 48 0 32 0 48 0 0-32 0-16 0-32 48 0 16 0L318.1 222.1 352 256l-33.9 33.9zM400 88l0-24 48 0 0 24 0 336 0 24-48 0 0-24 0-336z'
      
    ]
  };

  
    var faArrowAltToRight = faRightToLine;
  

  
  

  var faFireFlame = {
    prefix: 'fasr',
    iconName: 'fire-flame',
    icon: [
      384,
      512,
      ["flame"],
      'f6df',
      
      'M180.9 9.7L192 0l11.1 9.7c76.7 67.1 135.2 152.5 170 248.3c7.2 19.9 10.9 41.1 10.9 62.2C384 425.4 297.2 512 192 512S0 425.4 0 320.2C0 299 3.7 277.8 10.9 258c34.8-95.8 93.3-181.2 170-248.3zM56 274.4c-5.3 14.5-8 30.2-8 45.8C48 398.8 113.3 464 192 464s144-65.2 144-143.8c0-15.6-2.7-31.2-8-45.8C299.1 195 252.6 123.3 192 64.7C131.4 123.3 84.9 195 56 274.4zM205.7 160v14.4c0 11.3 4.4 22.2 12.3 30.2l40.3 41.1c19 19.4 29.6 45.5 29.6 72.6V320c0 53-43 96-96 96s-96-43-96-96v-4.6c0-22.3 10.3-43.4 27.9-57.1L137.1 248v50.3c0 20.8 16.9 37.7 37.7 37.7s37.7-16.9 37.7-37.7v-1.5c0-10.2-3.9-19.9-11-27.3l-14.2-14.7c-10.2-10.6-16-24.8-16-39.6c0-17 7.6-33 20.6-43.9L205.7 160z'
      
    ]
  };

  
    var faFlame = faFireFlame;
  

  
  

  var faMinus = {
    prefix: 'fasr',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M432 280H408L40 280H16l0-48 24 0 368 0 24 0v48z'
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faCircle5 = {
    prefix: 'fasr',
    iconName: 'circle-5',
    icon: [
      512,
      512,
      [],
      'e0f2',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128H186.1l-2 21.8-8 88L174 261.1l23.2 2.8 79.1 9.5c15.8 1.9 27.7 15.3 27.7 31.2c0 17.4-14.1 31.5-31.5 31.5h-33c-12.1 0-23.2-6.7-29-17.3l-5.4-10-42.3 22.7 5.4 10c14.1 26.2 41.5 42.6 71.2 42.6h33c43.9 0 79.5-35.6 79.5-79.5c0-40.2-30.1-74.1-70-78.9l-56-6.7 3.9-42.9H312h24V128H312 208z'
      
    ]
  };

  

  
  

  var faCircleSterling = {
    prefix: 'fasr',
    iconName: 'circle-sterling',
    icon: [
      512,
      512,
      [],
      'e5cf',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm261.5-96c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H272h16v32H272 231.7l.3 41.2 0 5.9-2.7 5.3-6 11.6H328h24v48H328 184 144.7l18-35L184 291.6l-.3-35.6H176 160V224h16 7.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1 22.3 8.9-17.8 44.6-22.3-8.9-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z'
      
    ]
  };

  

  
  

  var faBracketRoundRight = {
    prefix: 'fasr',
    iconName: 'bracket-round-right',
    icon: [
      192,
      512,
      [],
      '29',
      
      'M23.1 64.3L43.7 76.6C76.7 96.3 144 160.7 144 256s-67.3 159.7-100.3 179.4L23.1 447.7l24.6 41.2 20.6-12.3C110 451.8 192 374.1 192 256S110 60.2 68.3 35.4L47.7 23.1 23.1 64.3z'
      
    ]
  };

  

  
  

  var faVirusSlash = {
    prefix: 'fasr',
    iconName: 'virus-slash',
    icon: [
      640,
      512,
      [],
      'e075',
      
      'M476.4 347.1c-1.4-29.7 21.2-59.1 56-59.1H576V224H532.5c-49.9 0-74.9-60.3-39.6-95.6l30.8-30.8L478.4 52.4 447.6 83.1C412.3 118.4 352 93.4 352 43.5V0H288V43.5c0 49.9-60.3 74.9-95.6 39.6L161.6 52.4 133.3 80.7 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L476.4 347.1zM218.6 147c39.4 4.9 79.8-13.6 101.4-47.4c11.6 18.2 28.6 31.9 48 40c19.5 8.1 41.4 10.5 62.6 5.8c-9.3 42.2 9.4 87.3 45.8 110.6c-21 13.5-36.2 34.2-43.4 57.4L218.6 147zM402 412.7l-44.6-35.1c-14.9 8.2-27.9 20.1-37.4 34.8c-23.3-36.4-68.4-55.1-110.6-45.8c9.3-42.2-9.4-87.3-45.8-110.6c7.1-4.6 13.6-9.9 19.2-16l-38.1-30c-9.5 8.5-22.2 14-37.2 14H64v64h43.5c49.9 0 74.9 60.3 39.6 95.6l-30.8 30.8 45.3 45.3 30.8-30.8c35.3-35.2 95.6-10.3 95.6 39.6V512h64V468.5c0-31.2 23.6-52.7 50-55.7z'
      
    ]
  };

  

  
  

  var faDna = {
    prefix: 'fasr',
    iconName: 'dna',
    icon: [
      448,
      512,
      [129516],
      'f471',
      
      'M416 24V0H368V24c0 2.7-.1 5.4-.2 8H80.2c-.2-2.6-.2-5.3-.2-8V0H32V24c0 55.6 24.5 101.9 58.1 141.9c27.2 32.4 61.5 62 95.8 90.1c-34.3 28.1-68.6 57.7-95.8 90.1C56.5 386.1 32 432.4 32 488v24H80V488c0-2.7 .1-5.4 .2-8H367.8c.2 2.6 .2 5.3 .2 8v24h48V488c0-55.6-24.5-101.9-58.1-141.9c-20.6-24.5-45.2-47.3-70.8-69.2c-8.7 7.1-17.3 14.1-25.7 20.9l0 0-2.2 1.8c-3.4 2.7-6.7 5.5-10.1 8.1c11.2 9.4 22.1 18.8 32.3 28.3h-115c22-20.4 46.7-40.4 72.2-61c.3-.2 .5-.4 .8-.6l.7-.6c41.3-33.4 84.7-68.6 117.7-107.9C391.5 125.9 416 79.6 416 24zM121.1 384H326.9c12.4 15.7 22.4 31.6 29.4 48H91.7c7-16.4 17-32.3 29.4-48zM91.7 80H356.3c-7 16.4-17 32.3-29.4 48H121.1c-12.4-15.7-22.4-31.6-29.4-48zm189.8 96c-17.8 16.4-37.2 32.6-57.5 49.1c-20.3-16.5-39.7-32.7-57.5-49.1h115z'
      
    ]
  };

  

  
  

  var faTurnLeftUp = {
    prefix: 'fasr',
    iconName: 'turn-left-up',
    icon: [
      384,
      512,
      [],
      'e638',
      
      'M264 320l0 48 48 0 24 0 48 0 0 48 0 48 0 48-48 0-168 0-48 0 0-48 0-208 0-48-40 0-8 0-40 0 0-48L158.1 33.9 192 0l33.9 33.9L352 160l0 48-40 0-8 0-40 0 0 48 0 64zm20.1-160L192 67.9 99.9 160l20.1 0 48 0 0 48 0 256 168 0 0-48-72 0-48 0 0-48 0-160 0-48 48 0 20.1 0z'
      
    ]
  };

  

  
  

  var faCloudBoltMoon = {
    prefix: 'fasr',
    iconName: 'cloud-bolt-moon',
    icon: [
      576,
      512,
      ["thunderstorm-moon"],
      'f76d',
      
      'M572.7 178.3c-12.1 5.6-25.6 8.7-39.9 8.7c-52.8 0-95.6-43-95.6-96c0-37.8 21.7-70.5 53.4-86.1C479.4 1.7 467.7 0 455.5 0c-49.8 0-92.9 28.7-113.9 70.5c41.7 14.9 72.1 53.9 74.2 100.2c32.7 15.5 56.7 46.3 62.7 83.2c42.5-7.8 77.7-36.7 94.2-75.6zM128.6 160c0-26.5 21.5-48 48-48s48 21.5 48 48v8h49c3.5-13.8 16.1-24 31-24c17.7 0 32 14.3 32 32v40 24h24H368c17.7 0 32 14.3 32 32v32H368h-7.4H352V320v32h8.6 24V352H424h24V328 272c0-38.5-27.2-70.7-63.4-78.3V176c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C242 82.6 211.4 64 176.6 64c-53 0-96 43-96 96v1.2C34.9 168.6 0 208.2 0 256v72 24H24 48.8l0 0H64v-7.7L117.1 304h-4.7l0 0H80.6 48V256c0-26.5 21.5-48 48-48h8.6 24V184 160zM144 512L320 376V352H232l40-128L96 360v24h88L144 512z'
      
    ]
  };

  
    var faThunderstormMoon = faCloudBoltMoon;
  

  
  

  var faCircleUpRight = {
    prefix: 'fasr',
    iconName: 'circle-up-right',
    icon: [
      512,
      512,
      [],
      'e129',
      
      'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 320l-24 24-52-52-76 76-56-56 76-76-52-52 24-24H352V320z'
      
    ]
  };

  

  
  

  var faKeyboardDown = {
    prefix: 'fasr',
    iconName: 'keyboard-down',
    icon: [
      576,
      512,
      [],
      'e1c2',
      
      'M48 48V256H528V48H48zM0 0H48 528h48V48 256v48H528 48 0V256 48 0zM209 359l79 79 79-79 17-17L417.9 376l-17 17-96 96-17 17-17-17-96-96-17-17L192 342.1l17 17zM160 176H416v48H160V176zm-8-88v48H104V88h48zm32 0h48v48H184V88zm128 0v48H264V88h48zm32 0h48v48H344V88zm128 0v48H424V88h48z'
      
    ]
  };

  

  
  

  var faLeftLong = {
    prefix: 'fasr',
    iconName: 'left-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-left"],
      'f30a',
      
      'M160 224l48 0 256 0 0 64-256 0-48 0 0 48 0 12.1L67.9 256 160 163.9l0 12.1 0 48zM33.9 222.1L0 256l33.9 33.9L160 416l48 0 0-32 0-16 0-32 48 0 208 0 48 0 0-48 0-64 0-48-48 0-208 0-48 0 0-32 0-16 0-32-48 0L33.9 222.1z'
      
    ]
  };

  
    var faLongArrowAltLeft = faLeftLong;
  

  
  

  var faMoneyBill1 = {
    prefix: 'fasr',
    iconName: 'money-bill-1',
    icon: [
      576,
      512,
      ["money-bill-alt"],
      'f3d1',
      
      'M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 64H48 528h48v48V400v48H528 48 0V400 112 64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-64v32h16v64h-8H248v32h16 8 32 8 16V288H312h-8V208 192H288 272 256z'
      
    ]
  };

  
    var faMoneyBillAlt = faMoneyBill1;
  

  
  

  var faCropSimple = {
    prefix: 'fasr',
    iconName: 'crop-simple',
    icon: [
      512,
      512,
      ["crop-alt"],
      'f565',
      
      'M128 24V0H80V24 80H24 0v48H24 80V408v24h24H328h24V384H328 128V24zM384 488v24h48V488 432h56 24V384H488 432l0-280V80H408L160 80v48l224 0 0 360z'
      
    ]
  };

  
    var faCropAlt = faCropSimple;
  

  
  

  var faIndianRupeeSign = {
    prefix: 'fasr',
    iconName: 'indian-rupee-sign',
    icon: [
      320,
      512,
      ["indian-rupee","inr"],
      'e1bc',
      
      'M0 32H24 80h24H296h24V80H296 211.3c17.7 19.8 30.1 44.6 34.7 72h50 24v48H296 246c-11.4 68.1-70.7 120-142 120H95.6L268.7 427.6l20.4 12.7-25.3 40.8-20.4-12.7L11.3 324.1 0 317.1V303.7 296 272H24h80c44.7 0 82.3-30.6 93-72H24 0V152H24 197c-10.7-41.4-48.2-72-93-72H80 24 0V32z'
      
    ]
  };

  
    var faIndianRupee = faIndianRupeeSign;
  
    var faInr = faIndianRupeeSign;
  

  
  

  var faListTimeline = {
    prefix: 'fasr',
    iconName: 'list-timeline',
    icon: [
      512,
      512,
      [],
      'e1d1',
      
      'M144 96l33.9-33.9L208 32H400h48V80v32 48H400 208l-30.1-30.1L144 96zm256 16V80H227.9l-16 16 16 16H400zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0l33.9-33.9L208 352H400h48v48 32 48H400 208l-30.1-30.1L144 416zm256 16V400H227.9l-16 16 16 16H400zM177.9 289.9L144 256l33.9-33.9L208 192H464h48v48 32 48H464 208l-30.1-30.1zM227.9 272H464V240H227.9l-16 16 16 16z'
      
    ]
  };

  

  
  

  var faMoneyBillsSimple = {
    prefix: 'fasr',
    iconName: 'money-bills-simple',
    icon: [
      640,
      512,
      ["money-bills-alt"],
      'e1f4',
      
      'M592 80V336H144V80H592zM144 32H96V80 336v48h48H592h48V336 80 32H592 144zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120V96H0v24V456v24H24 520h24V432H520 48V120z'
      
    ]
  };

  
    var faMoneyBillsAlt = faMoneyBillsSimple;
  

  
  

  var faBadgeDollar = {
    prefix: 'fasr',
    iconName: 'badge-dollar',
    icon: [
      512,
      512,
      [],
      'f645',
      
      'M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5L321 99.1l19-5.8c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1l-5.8 19 17.5 9.3c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7L412.9 321l5.8 19c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7l-19-5.8-9.3 17.5c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5L191 412.9l-19 5.8c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340l5.8-19-17.5-9.3C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7L99.1 191l-5.8-19c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2l19 5.8 9.3-17.5zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zm20.9 149.3v-20h-40v20 8.5c-6.7 1.3-13.1 3.2-19.1 5.9c-16.1 7.3-29.9 20.8-33.3 40.2c-1.9 10.9-.9 21.4 3.6 30.9c4.4 9.3 11.3 15.9 18.5 20.8c12.6 8.5 29.3 13.6 42.4 17.5l2.3 .7c15.4 4.6 26.3 8.3 33.2 13.3c3 2.2 4.3 4 4.9 5.4c.6 1.3 1.2 3.9 .4 8.7c-.8 4.7-3.5 8.6-10.2 11.4c-7.3 3.1-18.7 4.5-33.2 2.3c-6.9-1.1-19-5.3-29.6-8.9l0 0 0 0 0 0c-2.4-.8-4.7-1.6-6.9-2.3l-19-6.3-12.6 38 19 6.3c1.4 .5 3.1 1 5 1.7l0 0 0 0 0 0c9.3 3.2 24 8.2 34.6 10.4v8.9 20h40v-20-8c6.5-1.1 12.7-2.8 18.5-5.3c16.9-7.2 30.3-21.1 33.8-41.4c1.9-11.2 1.1-21.8-3.1-31.4c-4.2-9.6-10.9-16.6-18.1-21.8c-13.2-9.6-30.8-14.9-44.4-19l-.8-.2c-15.6-4.7-26.7-8.2-33.8-13c-3.1-2.1-4.3-3.7-4.8-4.8c-.4-.9-1.1-2.8-.3-6.9c.5-3.1 2.9-7.2 10.4-10.6c7.6-3.4 19.1-5.2 33.1-3c4.9 .8 20 3.7 24.3 4.9l19.3 5.1 10.3-38.7L302 163.3c-5.3-1.4-18-3.9-25.1-5.2v-8.8z'
      
    ]
  };

  

  
  

  var faBallPile = {
    prefix: 'fasr',
    iconName: 'ball-pile',
    icon: [
      640,
      512,
      [],
      'f77e',
      
      'M368 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 0c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C405.1 365.1 416 389.3 416 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C213.1 365.1 224 389.3 224 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C138.9 306.9 128 282.7 128 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C234.9 146.9 224 122.7 224 96c0-53 43-96 96-96s96 43 96 96zm-96 96c-9.9 0-19.5-1.5-28.6-4.3C309.1 205.1 320 229.3 320 256c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zm0 64c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C330.9 306.9 320 282.7 320 256zM176 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM368 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM560 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faFaceSmileUpsideDown = {
    prefix: 'fasr',
    iconName: 'face-smile-upside-down',
    icon: [
      512,
      512,
      [],
      'e395',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM124 178.7L164 205.3C176 187.2 211.9 160 256 160s80 27.2 92 45.3L388 178.7C368 148.8 317.9 112 256 112s-112 36.8-132 66.7zM208.4 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faChartGantt = {
    prefix: 'fasr',
    iconName: 'chart-gantt',
    icon: [
      512,
      512,
      [],
      'e0e4',
      
      'M48 32V56 432H488h24v48H488 24 0V456 56 32H48zm80 80l24 0 112 0 24 0v48l-24 0-112 0-24 0 0-48zm88 96H360h24v48H360 216 192V208h24zm160 96h80 24v48H456 376 352V304h24z'
      
    ]
  };

  

  
  

  var faTrainSubway = {
    prefix: 'fasr',
    iconName: 'train-subway',
    icon: [
      448,
      512,
      ["subway"],
      'f239',
      
      'M48 48V208H200l0-160H48zM248 208H400V48H248l0 160zM48 256V400H400V256H48zM0 0H48 400h48V48 400v48H400 385.9l47 47 17 17H382.1l-64-64H129.9l-64 64H-1.9l17-17 47-47H48 0V400 48 0zM96 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faSubway = faTrainSubway;
  

  
  

  var faGameConsoleHandheldCrank = {
    prefix: 'fasr',
    iconName: 'game-console-handheld-crank',
    icon: [
      640,
      512,
      [],
      'e5b9',
      
      'M80 80V432H432V80H80zM32 32H80 432h48V80 272h32V200 168 144h24 48 24v24 32 24H584 560v72 24H536 480V432v48H432 80 32V432 80 32zm352 96V256H128V128H384zM192 288v16 16h16 16v32H208 192v16 16H160V368 352H144 128V320h16 16V304 288h32zm104 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faSportsball = {
    prefix: 'fasr',
    iconName: 'sportsball',
    icon: [
      512,
      512,
      [],
      'e44b',
      
      'M26.8 249.3C35 216.1 47.7 183.5 66 153.6c6.7-10.9 14.1-21.4 22.2-31.4l0 0c10-12.2 21.1-23.7 33.5-34.4l0 0c24.1-20.7 53-38 87.1-50.7c12.8-4.7 26.2-8.8 40.3-12.1c0 0 0 0 0 0c15-3.5 30.9-6.3 47.5-8.1c0 0 0 0 0 0c46.4-5.2 99-3.6 158.6 5.9l0 0c2.1 .3 4.2 .7 6.2 1l0 0 12.4 2.1 0 0 9.2 1.5 4.4 21.5c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3l0 0-12.4-2.1-9.2-1.5-2-9.7 0 0-2.4-11.8c-.5-2.6-1.1-5.2-1.6-7.9l0 0c-8.6-45.4-12.3-101.5-4.9-158.4c0 0 0 0 0 0c2-15.8 5-31.7 8.8-47.4c0 0 0 0 0 0zM65.2 306c-4.5 36.8-3.9 73.6-.1 107l69.8-69.8c-20.5-16.4-44-29.1-69.7-37.2zM99.4 446.5c39.9 4.3 75.4 4.5 106.9 1.3c-8.1-26-20.9-49.9-37.5-70.6L99.4 446.5zM254 439.7c11.5-2.8 22.3-6.1 32.4-9.9c27.3-10.1 50.3-23.7 69.7-39.8L256 289.9l-53.1 53.1c23.3 27.9 40.9 60.7 51.1 96.7zm135.6-84.1c5.6-7.2 10.8-14.6 15.5-22.3c15.1-24.6 25.8-51.8 33-79.8c-35.3-10.3-67.5-27.7-94.9-50.6L289.9 256l99.6 99.6zM446.8 206c4.5-36.8 3.9-73.6 .1-107l-69.8 69.8c20.5 16.4 44.1 29.1 69.7 37.2zM412.6 65.5c-39.9-4.3-75.4-4.5-106.9-1.3c8.1 26 20.9 49.9 37.5 70.6l69.3-69.3zM258 72.3c-11.5 2.8-22.2 6.1-32.4 9.9c-27.3 10.1-50.3 23.7-69.7 39.8L256 222.1l53.1-53.1C285.8 141 268.2 108.2 258 72.3zM122.4 156.4c-5.6 7.2-10.8 14.6-15.5 22.3c-15.1 24.6-25.8 51.8-33 79.8c35.3 10.3 67.5 27.7 94.9 50.6L222.1 256l-99.6-99.6z'
      
    ]
  };

  

  
  

  var faSignalBarsFair = {
    prefix: 'fasr',
    iconName: 'signal-bars-fair',
    icon: [
      640,
      512,
      ["signal-alt-2"],
      'f692',
      
      'M224 304V464h32V304H224zm-48-48h48 32 48v48V464v48H256 224 176V464 304 256zM64 432v32H96V432H64zM16 384H64 96h48v48 32 48H96 64 16V464 432 384z'
      
    ]
  };

  
    var faSignalAlt2 = faSignalBarsFair;
  

  
  

  var faDistributeSpacingVertical = {
    prefix: 'fasr',
    iconName: 'distribute-spacing-vertical',
    icon: [
      512,
      512,
      [],
      'e366',
      
      'M0 32V80H512V32H0zM368 208v96H144V208H368zM144 160H96v48 96 48h48H368h48V304 208 160H368 144zM512 432H0v48H512V432z'
      
    ]
  };

  

  
  

  var faCircleLeft = {
    prefix: 'fasr',
    iconName: 'circle-left',
    icon: [
      512,
      512,
      [61840,"arrow-alt-circle-left"],
      'f359',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM224 368h32V304H384V208l-128 0V144H224L128 256l96 112z'
      
    ]
  };

  
    var faArrowAltCircleLeft = faCircleLeft;
  

  
  

  var faCowbellCirclePlus = {
    prefix: 'fasr',
    iconName: 'cowbell-circle-plus',
    icon: [
      576,
      512,
      ["cowbell-more"],
      'f8b4',
      
      'M128 0h24H296h24V24 96h64l19.7 98.3c-16.2 2.6-31.7 7.5-46.1 14.2L344.6 144H103.4L58.6 368H256c0 16.6 2.3 32.7 6.6 48H49 0l9.6-48L64 96h64V24 0zM285.5 465.6C277.9 492.4 253.2 512 224 512c-35.3 0-64-28.7-64-64H275.2c3.1 6.1 6.6 12 10.3 17.6zM272 48H176V96h96V48zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  
    var faCowbellMore = faCowbellCirclePlus;
  

  
  

  var faPlaneArrival = {
    prefix: 'fasr',
    iconName: 'plane-arrival',
    icon: [
      640,
      512,
      [128748],
      'f5af',
      
      'M184 0H151.7L161 30.9l37.6 125.2-60.8-16.2L110.3 71.1l-4.6-11.4-11.9-3-64-16L0 33.3V64 192v11.3l8.7 7.2 112.7 93.4 4.1 3.4 5.1 1.4 324.5 86.3c36.1 9.6 74.2 8.5 109.6-3.2c40.2-13.3 51.3-64.8 20.2-93.5l-31.8-29.3c-18.1-16.7-40-28.8-63.8-35.1L386 206.1 276.9 12.2 270 0H256 184zm72.9 183.5L216.3 48H242L349.1 238.4l5 8.8 9.8 2.6 113 30.1c16.3 4.3 31.3 12.6 43.7 24l31.8 29.3c4.2 3.9 2.7 10.9-2.7 12.7c-26.6 8.8-55.2 9.6-82.2 2.4L148 263.5 48 180.7v-86l22.3 5.6 27.4 68.6 4.5 11.2 11.6 3.1 113.9 30.4 41.5 11.1-12.3-41.2zM24 464H0v48H24 616h24V464H616 24zm168-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faPersonFromPortal = {
    prefix: 'fasr',
    iconName: 'person-from-portal',
    icon: [
      512,
      512,
      ["portal-exit"],
      'e023',
      
      'M72.2 436C58.7 404.6 48 348.4 48 256s10.7-148.6 24.2-180C84.6 47.3 94.6 47.9 95.9 48l.1 0 .1 0c1.3-.1 11.3-.7 23.7 28c13.5 31.4 24.2 87.7 24.2 180c0 45.7-2.6 82.6-6.9 112H120 96v48h24 7s0 0 0 0h49.7s0 0 0 0H216h16.6l5.9-15.5 18-47.9-4.9-2.8c-14.1-8-25.4-19.3-33-32.6L199.4 368H185.6c4.2-31.3 6.4-68.4 6.4-112c0-21.1-.5-40.7-1.6-58.8L240 160h33.4l-31.8 95.4c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L311.4 512h50.3l45.3-144.8 5.8-18.5-16.9-9.5-43.4-24.4 28.1-84.4 12.5 40.8 5.2 16.9H416h72 24V240H488 433.7l-26.8-87.1-3.9-12.6-12.7-3.5-88-24-3.1-.8H296 232h-8l-6.4 4.8-32.4 24.3C171 38.7 136.4 0 96 0C43 0 0 66.6 0 256S43 512 96 512c28 0 53.2-18.6 70.7-64H113.9c-9.5 16.5-16.7 16.1-17.8 16l-.1 0-.1 0c-1.3 .1-11.3 .7-23.7-28zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-46.6 71.8l27 7.4L309.8 290.7l-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5l34.2-102.7z'
      
    ]
  };

  
    var faPortalExit = faPersonFromPortal;
  

  
  

  var faCalendarPlus = {
    prefix: 'fasr',
    iconName: 'calendar-plus',
    icon: [
      448,
      512,
      [],
      'f271',
      
      'M152 24V0H104V24 64H0v80 48V464v48H48 400h48V464 192 144 64H344V24 0H296V24 64H152V24zM48 192H400V464H48V192zm200 40H200v24 48H152 128v48h24 48v48 24h48V400 352h48 24V304H296 248V256 232z'
      
    ]
  };

  

  
  

  var faPersonSkiingNordic = {
    prefix: 'fasr',
    iconName: 'person-skiing-nordic',
    icon: [
      576,
      512,
      ["skiing-nordic"],
      'f7ca',
      
      'M384 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM200 112h-8l-6.4 4.8-64 48-19.2 14.4 19.2 25.6L67 464H24 0v48H24 279.4l0 0h50.3l0 0H552h24V488 432 408H528v24 32H434.6l27.1-176H480V240H456 401.7l-26.8-87.1-3.9-12.6-12.7-3.5-88-24-3.1-.8H264 200zM429.4 288L402.3 464H344.6l30.3-96.8 5.8-18.5-16.9-9.5-43.4-24.4 28.1-84.4 12.5 40.8 5.2 16.9H384h45.3zM99.7 464l55.7-264.6L208 160h33.4l-31.8 95.4c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L294.4 464H190.7l36.8-109.8-8-4.5c-13.1-7.4-23.6-17.6-31.2-29.6L140.1 464H99.7zM255.1 270.5l34.2-102.7 27 7.4L277.8 290.7l-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5z'
      
    ]
  };

  
    var faSkiingNordic = faPersonSkiingNordic;
  

  
  

  var faArrowDownRight = {
    prefix: 'fasr',
    iconName: 'arrow-down-right',
    icon: [
      384,
      512,
      [],
      'e093',
      
      'M328 416h24V392 152 128H304v24V334.1L81 111l-17-17L30.1 128l17 17 223 223H88 64v48H88 328z'
      
    ]
  };

  

  
  

  var faGrate = {
    prefix: 'fasr',
    iconName: 'grate',
    icon: [
      448,
      512,
      [],
      'e193',
      
      'M24 32H0V56 256 456v24H24 128h96 96H424h24V456 256 56 32H424 320 224 128 24zm80 48V232H48V80h56zM48 280h56V432H48V280zM152 432V280h48V432H152zm96 0V280h48V432H248zm96 0V280h56V432H344zm56-200H344V80h56V232zM296 80V232H248V80h48zm-96 0V232H152V80h48z'
      
    ]
  };

  

  
  

  var faTrafficCone = {
    prefix: 'fasr',
    iconName: 'traffic-cone',
    icon: [
      512,
      512,
      [],
      'f636',
      
      'M223.9 0H240h32 16.1l6.1 15L476.9 464H488h24v48H488 24 0V464H24 35.1L217.8 15l6.1-15zM386 368H126L86.9 464H425.1l-39-96zm-19.5-48L320.9 208H191.1L145.5 320h221zM210.6 160h90.8L256 48.4 210.6 160z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleCheck = {
    prefix: 'fasr',
    iconName: 'house-medical-circle-check',
    icon: [
      640,
      512,
      [],
      'e511',
      
      'M288 .5l15.5 13.2L514.8 193c-6.2-.7-12.5-1-18.8-1c-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8V464H348.5c12.3 18.8 28 35.1 46.3 48H88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm32 112a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faAlarmExclamation = {
    prefix: 'fasr',
    iconName: 'alarm-exclamation',
    icon: [
      512,
      512,
      [],
      'f843',
      
      'M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L423 489l17 17L473.9 472l-17-17-26.5-26.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L55 455l-17 17L72 505.9l17-17 26.5-26.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 160H232v24V296v24h48V296 184 160zM232 408h48V360H232v48z'
      
    ]
  };

  

  
  

  var faTarpDroplet = {
    prefix: 'fasr',
    iconName: 'tarp-droplet',
    icon: [
      576,
      512,
      [],
      'e57c',
      
      'M288 160c-35.3 0-64-26.9-64-60S288-8 288-8s64 74.9 64 108s-28.7 60-64 60zM48 128H197.5c7 19.8 20.3 36.6 37.5 48H48l0 288 368 0V352H528V176l-186.9 0c17.2-11.4 30.5-28.2 37.5-48H528h48v48V384L448 512H48 0V464 176 128H48zm64 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faRectangleList = {
    prefix: 'fasr',
    iconName: 'rectangle-list',
    icon: [
      576,
      512,
      ["list-alt"],
      'f022',
      
      'M48 80V432H528V80H48zM0 32H48 528h48V80 432v48H528 48 0V432 80 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104-24h24H448h24v48H448 224 200V136zm0 96h24H448h24v48H448 224 200V232zm0 96h24H448h24v48H448 224 200V328zm-72-40a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  
    var faListAlt = faRectangleList;
  

  
  

  var faDumbbell = {
    prefix: 'fasr',
    iconName: 'dumbbell',
    icon: [
      640,
      512,
      [],
      'f44b',
      
      'M128 32h24 80 24V56 232H384V56 32h24 80 24V56v48h56 24v24V232h24 24v48H616 592V384v24H568 512v48 24H488 408 384V456 280H256V456v24H232 152 128V456 408H72 48V384 280H24 0V232H24 48V128 104H72h56V56 32zm48 72v24V384v24 24h32V80H176v24zm-48 48H96V360h32V152zM464 384V128 104 80H432V432h32V408 384zm80-24V152H512V360h32z'
      
    ]
  };

  

  
  

  var faFaceGrinSquintTears = {
    prefix: 'fasr',
    iconName: 'face-grin-squint-tears',
    icon: [
      512,
      512,
      [129315,"grin-squint-tears"],
      'f586',
      
      'M442.3 98.6c-.4 .1-.8 .2-1.3 .2c-13.2 2.4-25.4 4.1-33.1 5.1c1-7.2 2.6-18.6 4.9-30.9c.1-.7 .3-1.4 .4-2.1c.8-4.4 1.7-8.9 2.7-13.3c.1-.4 .2-.9 .3-1.3c4.1-18.5 9.6-36.2 16.6-43.1c17.9-17.9 47.1-17.6 65.3 .7s18.6 47.6 .7 65.6c-6.9 6.9-24.5 12.4-43 16.4m0 0c-4.5 1-9 1.9-13.5 2.7zM403.1 403.1c73.3-73.3 80.5-187.8 21.4-269.1c10.8-1.6 24.8-3.9 38.5-6.9c4.1-.9 8.3-1.9 12.5-3c59.2 98.4 46.4 228-38.5 312.9c-84.9 84.9-214.7 97.7-313.2 38.3c1.1-4.1 2.1-8.2 3-12.2c3.1-13.7 5.4-27.8 7.1-38.6c81.3 59.1 195.8 52 269.1-21.4zM75 75C159.9-10 289.7-22.7 388.1 36.7c-1.1 4.1-2.1 8.2-3 12.2c-3.1 13.7-5.4 27.8-7.1 38.6c-81.3-59.1-195.8-52-269.1 21.4C35.6 182.2 28.5 296.7 87.5 378c-10.8 1.6-24.8 3.9-38.5 6.9c-4.1 .9-8.3 1.9-12.5 3C-22.7 289.5-9.9 159.9 75 75zM98.7 441.1c-.9 4.8-1.9 9.7-3 14.6c-4.1 18.5-9.6 36.2-16.6 43.1c-17.9 17.9-47.1 17.6-65.3-.7s-18.6-47.6-.7-65.6c8-8 30.1-14 51.4-18.1c2.1-.4 4.2-.8 6.3-1.2c13.2-2.4 25.5-4.1 33.1-5.1c-1.1 7.6-2.8 19.9-5.3 33.1zM300.4 300.5c35.6-35.6 62.6-74.8 79.9-113.1c32.5 52.1 24.7 123.3-22.6 170.5s-118.4 55.1-170.5 22.6c38.3-17.3 77.5-44.3 113.1-79.9zM75 278.6l129.3-38.8L165.5 369.1l-12.9-77.6L75 278.6zm164.9-74.3L278.6 75l12.9 77.6 77.6 12.9L239.8 204.3z'
      
    ]
  };

  
    var faGrinSquintTears = faFaceGrinSquintTears;
  

  
  

  var faReel = {
    prefix: 'fasr',
    iconName: 'reel',
    icon: [
      448,
      512,
      [],
      'e238',
      
      'M24 0H0V48H24 64V72v40h40H344h40V72 48h40 24V0H424 384 344 104 64 24zm80 72V48H344V72H104zM24 464H0v48H24 64h40H344h40 40 24V464H424 384V440 400H344 104 64v40 24H24zm320 0H104V440H344v24zM64 176H384V144H64v32zm0 64H432h16V208H432 64v32zm0 64H384V272H64v32zm0 64H384V336H64v32z'
      
    ]
  };

  

  
  

  var faHardDrive = {
    prefix: 'fasr',
    iconName: 'hard-drive',
    icon: [
      512,
      512,
      [128436,"hdd"],
      'f0a0',
      
      'M48 80V256H464V80H48zm0 224V432H464V304H48zM0 256V80 32H48 464h48V80 256v48V432v48H464 48 0V432 304 256zM280 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faHdd = faHardDrive;
  

  
  

  var faTvMusic = {
    prefix: 'fasr',
    iconName: 'tv-music',
    icon: [
      640,
      512,
      [],
      'f8e6',
      
      'M592 48V368H48V48H592zM48 0H0V48 368v48H48 592h48V368 48 0H592 48zM96 464v48h24H520h24V464H520 120 96zM416 96V72.9L394.4 81l-128 48L256 132.9V144v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V128 96z'
      
    ]
  };

  

  
  

  var faArrowRotateLeft = {
    prefix: 'fasr',
    iconName: 'arrow-rotate-left',
    icon: [
      512,
      512,
      [8634,"arrow-left-rotate","arrow-rotate-back","arrow-rotate-backward","undo"],
      'f0e2',
      
      'M40 224H16V200 56 32H64V56v80.1l20-23.5C125 63.4 186.9 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-50.4 0-97-16.7-134.4-44.8l28.8-38.4C179.8 418.9 216.3 432 256 432c97.2 0 176-78.8 176-176s-78.8-176-176-176c-54.3 0-102.9 24.6-135.2 63.4l-.1 .2 0 0L93.1 176H184h24v48H184 40z'
      
    ]
  };

  
    var faArrowLeftRotate = faArrowRotateLeft;
  
    var faArrowRotateBack = faArrowRotateLeft;
  
    var faArrowRotateBackward = faArrowRotateLeft;
  
    var faUndo = faArrowRotateLeft;
  

  
  

  var faCookie = {
    prefix: 'fasr',
    iconName: 'cookie',
    icon: [
      512,
      512,
      [127850],
      'f563',
      
      'M118 121.7L66 229.1 86.6 346.8 172 429.7l117.3 16.6 104.7-56L446 282.9 425.4 165.2 340 82.3 222.7 65.7 118 121.7zM213.9 16L362.2 37 470 141.6l26 148.3L430.3 425.3 298.1 496 149.8 475 42 370.4 16 222.1 81.7 86.7 213.9 16zM320 160l-32-32 32-32 32 32-32 32zM128 192l32-32 32 32-32 32-32-32zm160 96l-32-32 32-32 32 32-32 32zm-96 96l-32-32 32-32 32 32-32 32zm128-32l32-32 32 32-32 32-32-32z'
      
    ]
  };

  

  
  

  var faOctagonDivide = {
    prefix: 'fasr',
    iconName: 'octagon-divide',
    icon: [
      512,
      512,
      [],
      'e203',
      
      'M48 332.1V179.9L179.9 48H332.1L464 179.9V332.1L332.1 464H179.9L48 332.1zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM288 128H224v64h64V128zM168 232H144v48h24H344h24V232H344 168zm56 88v64h64V320H224z'
      
    ]
  };

  

  
  

  var faCommentArrowUpRight = {
    prefix: 'fasr',
    iconName: 'comment-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e145',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM200 152H176v48h24 54.1l-87 87-17 17L184 337.9l17-17 87-87V288v24h48V288 176 152H312 200z'
      
    ]
  };

  

  
  

  var faOctagon = {
    prefix: 'fasr',
    iconName: 'octagon',
    icon: [
      512,
      512,
      [128721],
      'f306',
      
      'M179.9 464H332.1L464 332.1V179.9L332.1 48H179.9L48 179.9V332.1L179.9 464zM0 160L160 0H352L512 160V352L352 512H160L0 352V160z'
      
    ]
  };

  

  
  

  var faBorderBottomRight = {
    prefix: 'fasr',
    iconName: 'border-bottom-right',
    icon: [
      448,
      512,
      ["border-style-alt"],
      'f854',
      
      'M448 56l0-24-48 0 0 24 0 376L24 432 0 432l0 48 24 0 400 0 24 0 0-24 0-400zM352 96l0-64-64 0 0 64 64 0zM160 96l0-64L96 32l0 64 64 0zm96-64l-64 0 0 64 64 0 0-64zM64 96l0-64L0 32 0 96l64 0zm0 128L0 224l0 64 64 0 0-64zm0-32l0-64L0 128l0 64 64 0zm0 128L0 320l0 64 64 0 0-64z'
      
    ]
  };

  
    var faBorderStyleAlt = faBorderBottomRight;
  

  
  

  var faCarBuilding = {
    prefix: 'fasr',
    iconName: 'car-building',
    icon: [
      640,
      512,
      [],
      'f859',
      
      'M48 48H304v80l48 0V48 0H304 48 0V48 432v48H48 192l0-48H48V48zM256 192H192v47.7l56.7 .4 1.8 0 5.5-15.9V192zM160 96H96v64h64V96zm32 0v64h64V96H192zm-32 96H96v64h64V192zm0 96H96v64h64V288zM311.1 160l-5.7 15.9L271.1 272H224v48 80 16 32 64h48V448H592v64h48V448 416 400 320 272H592.9l-34.3-96.1L552.9 160H536 328 311.1zM576.6 320H592v80H272V320h15.4c.4 0 .7 0 1.1 0H575.4c.4 0 .7 0 1.1 0zM519.1 208l22.9 64H322.1l22.9-64H519.1zM336 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faMessageMusic = {
    prefix: 'fasr',
    iconName: 'message-music',
    icon: [
      512,
      512,
      ["comment-alt-music"],
      'f8af',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM352 96V72.9L330.4 81l-128 48L192 132.9V144v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V128 96z'
      
    ]
  };

  
    var faCommentAltMusic = faMessageMusic;
  

  
  

  var faCameraViewfinder = {
    prefix: 'fasr',
    iconName: 'camera-viewfinder',
    icon: [
      512,
      512,
      ["screenshot"],
      'e0da',
      
      'M0 0V24 136v24H48V136 48h88 24V0H136 24 0zM200 96H184.2l-6.2 14.5L170.5 128H120 96v24V360v24h24H392h24V360 152 128H392 341.5l-7.5-17.5L327.8 96H312 200zm8.3 65.5l7.5-17.5h80.3l7.5 17.5 6.2 14.5h15.8H368V336H144V176h42.3 15.8l6.2-14.5zM256 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM488 0H376 352V48h24 88v88 24h48V136 24 0H488zM0 512H24 136h24V464H136 48V376 352H0v24V488v24zm488 0h24V488 376 352H464v24 88H376 352v48h24H488z'
      
    ]
  };

  
    var faScreenshot = faCameraViewfinder;
  

  
  

  var faMoneyBillWheat = {
    prefix: 'fasr',
    iconName: 'money-bill-wheat',
    icon: [
      512,
      512,
      [],
      'e52a',
      
      'M176 0H160V16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80zM56 16H32V64H56h48 24V16H104 56zM24 88H0v48H24 136h24V88H136 24zm8 72v48H56h48 24V160H104 56 32zM272 0V16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80H272zM400 0H384V16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80zm80 128H464c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80V128zm-128 0c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80V128H352zm-96 0H240c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80V128zM48 359.5c28.9-3.6 51.9-26.6 55.5-55.5h305c3.6 29 26.6 51.9 55.5 55.5v49c-29 3.6-51.9 26.6-55.5 55.5h-305c-3.6-29-26.6-51.9-55.5-55.5v-49zM48 256H0v48V464v48H48 464h48V464 304 256H464 48zM256 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faPlusLarge = {
    prefix: 'fasr',
    iconName: 'plus-large',
    icon: [
      512,
      512,
      [],
      'e59e',
      
      'M488 232l24 0 0 48-24 0-208 0V488l0 24H232l0-24 0-208L24 280 0 280V232l24 0 208 0 0-208 0-24 48 0V24l0 208 208 0z'
      
    ]
  };

  

  
  

  var faBellSchoolSlash = {
    prefix: 'fasr',
    iconName: 'bell-school-slash',
    icon: [
      640,
      512,
      [],
      'f5d6',
      
      'M552 512H528l-60.9-48H416V423.8l-85-67C312.7 364 292.8 368 272 368c-88.4 0-160-71.6-160-160c0-7.6 .5-15.2 1.6-22.5l-42-33.1C66.6 170.1 64 188.7 64 208c0 59 24.6 112.2 64 150.1V488v24h24H336h56 24H528h24v0zm19.3-91.2c3-6.3 4.7-13.3 4.7-20.8c0-26.5-21.5-48-48-48c-11.7 0-22.5 4.2-30.8 11.2L445.4 323C467.2 290 480 250.5 480 208C480 93.1 386.9 0 272 0C210.8 0 155.7 26.5 117.7 68.6L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-49.6-38.5zM155.7 98.1C184.9 67.3 226.2 48 272 48c88.4 0 160 71.6 160 160c0 31.4-9.1 60.7-24.7 85.4l-51-39.6c7.4-13.6 11.7-29.3 11.7-45.9c0-53-43-96-96-96c-25.2 0-48.2 9.7-65.3 25.7l-51-39.6zM317.4 223.6l-71.8-55.7c7.6-5 16.6-7.9 26.4-7.9c26.5 0 48 21.5 48 48c0 5.5-.9 10.7-2.6 15.6zM336 464H176V392.6c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4V464H336z'
      
    ]
  };

  

  
  

  var faBowlingBallPin = {
    prefix: 'fasr',
    iconName: 'bowling-ball-pin',
    icon: [
      576,
      512,
      [],
      'e0c3',
      
      'M436 228.8l5.4-20.8h45.3l40.9 159.2L499.9 464H428.1l-11.7-40.9c-10 17.5-22.2 33.7-36.2 48L391.9 512H536.1l41.2-144.1L528 176c1.6-7.1 3.3-13.6 4.8-19.9l0 0 0 0C538.9 131.2 544 110.8 544 82V80c0-44.2-35.8-80-80-80s-80 35.8-80 80v2c0 27.6 4.6 47.5 10.4 70.8c18.2 22.4 32.4 48.1 41.6 76zm50.7-86.5c-1.3 5.4-2.7 11.2-4.3 17.7H445.6c-1.5-6.5-3-12.4-4.3-17.7c-5.8-23.6-9.3-37.7-9.3-60.3V80c0-17.7 14.3-32 32-32s32 14.3 32 32v2c0 22.6-3.5 36.8-9.3 60.3l0 0 0 0zM208 144a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm16-316a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zm0 88a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM124 272a28 28 0 1 0 0-56 28 28 0 1 0 0 56z'
      
    ]
  };

  

  
  

  var faArrowDownAZ = {
    prefix: 'fasr',
    iconName: 'arrow-down-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-asc","sort-alpha-down"],
      'f15d',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM328 288h24H480h24v24 8 9.9l-7 7-95 95H480h24v48H480 352 328V456v-8-9.9l7-7 95-95H352 328V288zM400.6 32h30.8l6.4 14 89.3 194H474.2l-14.8-32.2c-1.1 .2-2.2 .2-3.4 .2H372.5l-14.7 32H304.9L394.2 46l6.4-14zM416 113.4L394.6 160h42.8L416 113.4z'
      
    ]
  };

  
    var faSortAlphaAsc = faArrowDownAZ;
  
    var faSortAlphaDown = faArrowDownAZ;
  

  
  

  var faCheckDouble = {
    prefix: 'fasr',
    iconName: 'check-double',
    icon: [
      448,
      512,
      [],
      'f560',
      
      'M337 81l17-17L320 30.1 303 47l-143 143L97 127l-17-17L46.1 144l17 17 80 80 17 17 17-17L337 81zm94 130L448 194l-33.9-34-17 16.9L160.6 412.3 50.8 303.1l-17-16.9L0 320.2l17 16.9L143.7 463.2l16.9 16.9 16.9-16.9L431 211z'
      
    ]
  };

  

  
  

  var faPeopleDressSimple = {
    prefix: 'fasr',
    iconName: 'people-dress-simple',
    icon: [
      512,
      512,
      [],
      'e218',
      
      'M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM100.2 208h55.6l36.6 128H63.6l36.6-128zM192 160H64L13.7 336 0 384H49.9 64V488v24h48V488 384h32V488v24h48V488 384h14.1H256h49.9H320V488v24h48V488 384h32V488v24h48V488 384h14.1H512l-13.7-48L448 160H320L269.7 336 256 384l-13.7-48L192 160zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM356.2 208h55.6l36.6 128H319.6l36.6-128z'
      
    ]
  };

  

  
  

  var faVestPatches = {
    prefix: 'fasr',
    iconName: 'vest-patches',
    icon: [
      448,
      512,
      [],
      'e086',
      
      'M178.4 81.1l28.9 95.4-25.1 82.8L118.2 48H96v80 72 6.6l-3.4 5.7L48 286.6V464H176v24 24H24 0V488 280v-6.6l3.4-5.7L48 193.4V128 24 0H72h64 7 10.8 5.1l6 14.2 .1 .1c.2 .4 .7 1.2 1.4 2.3c1.5 2.2 4.1 5.4 8.3 8.8C182.6 31.9 197.5 40 224 40s41.4-8.1 49.3-14.6c4.1-3.4 6.8-6.6 8.3-8.8c.7-1.1 1.2-1.9 1.4-2.3l.1-.1 6-14.2h5.1H305h7 64 24V24 128v65.4l44.6 74.3 3.4 5.7V280 488v24H424 232 208V488 288v-3.6l1-3.4 60.6-200C256.9 85.3 241.8 88 224 88s-32.9-2.7-45.6-6.9zM329.8 48L256 291.6V464H400V286.6l-44.6-74.3-3.4-5.7V200 128 48H329.8zM288 288v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H288V288zM107.3 260.7L120 273.4l12.7-12.7L144 249.4 166.6 272l-11.3 11.3L142.6 296l12.7 12.7L166.6 320 144 342.6l-11.3-11.3L120 318.6l-12.7 12.7L96 342.6 73.4 320l11.3-11.3L97.4 296 84.7 283.3 73.4 272 96 249.4l11.3 11.3zM72 400a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'
      
    ]
  };

  

  
  

  var faLaptopBinary = {
    prefix: 'fasr',
    iconName: 'laptop-binary',
    icon: [
      640,
      512,
      [],
      'e5e7',
      
      'M112 80H528V320h48V80 32H528 112 64V80 320h48V80zM51.9 400H588.1l-32 32H83.9l-32-32zM640 416V400 352H592 48 0v48 16l64 64H576l64-64zM176 128H160v16 80 16h16 64 16V224 144 128H240 176zm16 80V160h32v48H192zm112-80H288v32h16v64 16h32V224 144 128H320 304zm80 0v16 80 16h16 64 16V224 144 128H464 400 384zm32 32h32v48H416V160zM192 272H176v32h16v16h32V288 272H208 192zm256 0H432 416 400v32h16v16h32V288 272zm-80 16V272H352 288 272v16 32h32V304h32v16h32V288z'
      
    ]
  };

  

  
  

  var faTent = {
    prefix: 'fasr',
    iconName: 'tent',
    icon: [
      576,
      512,
      [],
      'e57d',
      
      'M48.2 512H0l4.4-48L32 160 288 0l23.3 16h.7v.5L544 176l27.4 288 4.6 48H527.8 440 264 48.2zm365.4-48H523.2L498.3 202.9 312 74.7V279.3L413.6 464zM264 71.6L77.6 188.1 52.6 464H264V328 192 71.6z'
      
    ]
  };

  

  
  

  var faAlien = {
    prefix: 'fasr',
    iconName: 'alien',
    icon: [
      448,
      512,
      [128125],
      'f8f5',
      
      'M224 48C126.8 48 48 126.8 48 224c0 67.2 43.3 127.2 96 174.2c25.5 22.8 51.2 40.7 70.6 53c3.3 2.1 6.5 4 9.4 5.8c2.9-1.8 6-3.7 9.4-5.8c19.4-12.3 45.1-30.2 70.6-53c52.7-47 96-106.9 96-174.2c0-97.2-78.8-176-176-176zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 176-224 288-224 288S0 400 0 224zm240 80c0-44.2 35.8-80 80-80h48v16c0 44.2-35.8 80-80 80H240V304zM128 224c44.2 0 80 35.8 80 80v16H160c-44.2 0-80-35.8-80-80V224h48z'
      
    ]
  };

  

  
  

  var faPersonCane = {
    prefix: 'fasr',
    iconName: 'person-cane',
    icon: [
      448,
      512,
      [],
      'e53c',
      
      'M224 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-91.1 32h-14L112 140.2l-76.9 136 41.8 23.6L128 209.5V488v24h48V488 352h32V488v24h48V488 214.2l61.6 73.3 15.4 18.4 36.7-30.9-15.4-18.4-100.9-120-7.2-8.6H235.1 132.9zM208 176V304H176V176h32zM360 368c4.4 0 8 3.6 8 8V488v24h48V488 376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8 24h48V384v-8c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCloudRainbow = {
    prefix: 'fasr',
    iconName: 'cloud-rainbow',
    icon: [
      576,
      512,
      [],
      'f73e',
      
      'M317.5 192C371.1 105.6 466.8 48 576 48V0C440.1 0 322.3 77 263.6 189.7c4.2 3.2 8.2 6.6 11.9 10.2c13.1-4.9 27.2-7.6 41.9-7.9zM409 228c37.9-51 98.6-84 167-84V96c-85.2 0-160.7 41.6-207.2 105.6c15.1 6.2 28.7 15.2 40.2 26.4zm35.8 63.2c10.8 2.5 21.1 6.3 30.7 11.4C493.7 265.5 531.9 240 576 240V192c-58.7 0-110 31.6-137.8 78.7c2.7 6.6 5 13.4 6.6 20.5zM368 320v48h48c26.5 0 48 21.5 48 48v48H416 96 48V416c0-20.8 13.3-38.7 32-45.3l32-11.3V325.5 304c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 512H48 96 416h48 48V464 416c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 210.8 213.9 192 176 192c-61.9 0-112 50.1-112 112v21.5C26.7 338.6 0 374.2 0 416v48 48z'
      
    ]
  };

  

  
  

  var faCrosshairs = {
    prefix: 'fasr',
    iconName: 'crosshairs',
    icon: [
      512,
      512,
      [],
      'f05b',
      
      'M280 0V24 41.3C380.1 52.4 459.6 131.9 470.7 232H488h24v48H488 470.7C459.6 380.1 380.1 459.6 280 470.7V488v24H232V488 470.7C131.9 459.6 52.4 380.1 41.3 280H24 0V232H24 41.3C52.4 131.9 131.9 52.4 232 41.3V24 0h48zM89.7 280c10.5 73.6 68.7 131.8 142.3 142.3V392 368h48v24 30.3c73.6-10.5 131.8-68.7 142.3-142.3H392 368V232h24 30.3C411.8 158.4 353.6 100.2 280 89.7V120v24H232V120 89.7C158.4 100.2 100.2 158.4 89.7 232H120h24v48H120 89.7zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faMusicMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'music-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e662',
      
      'M496 208c0 83-63.1 151.2-144 159.2v24.6c0 1.3 0 2.5-.1 3.8c.1 1.4 .1 2.8 .1 4.2c0 5.5-.6 10.7-1.8 15.7c43.3-2.9 82.9-19.1 114.9-44.5l124 124 17 17L640 478.1l-17-17-124-124C527.2 301.7 544 256.8 544 208C544 93.1 450.9 0 336 0C230.5 0 143.4 78.5 129.8 180.2l52.7-17.6C202.1 96.4 263.4 48 336 48c88.4 0 160 71.6 160 160zM320 152l-31.6 10.5-192 64L80 232v17.3 48V417.6c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48c32.5 0 59.3-18.1 63.4-41.6c.4-1.7 .6-3.4 .6-5.2v-1.2V314.6l144-48v87c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.3-.1-2.5-.2-3.7c.1-1 .2-2 .2-3v-160-48V152z'
      
    ]
  };

  

  
  

  var faTruck = {
    prefix: 'fasr',
    iconName: 'truck',
    icon: [
      640,
      512,
      [9951,128666],
      'f0d1',
      
      'M368 48V368H320 243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H48V48H368zm16 368c0 53 43 96 96 96s96-43 96-96h40 24V368H616h-8V232v-9.9l-7-7L489 103l-7-7H472 416V48 0H368 48 0V48 368v48H48 64c0 53 43 96 96 96s96-43 96-96h64 48 8 8zm78.1-272l96 96H416V144h46.1zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faLandmark = {
    prefix: 'fasr',
    iconName: 'landmark',
    icon: [
      512,
      512,
      [127963],
      'f66f',
      
      'M0 192H48 464h48V144L256 0 0 144v48zM256 55.1L414.1 144H97.9L256 55.1zM112 224H64V384H56 32v48H56 456h24V384H456h-8V224H400V384H336V224H288V384H224V224H176V384H112V224zM0 464v48H24 488h24V464H488 24 0z'
      
    ]
  };

  

  
  

  var faHouseWindow = {
    prefix: 'fasr',
    iconName: 'house-window',
    icon: [
      576,
      512,
      [],
      'e3b3',
      
      'M288 .5l15.5 13.2 264 224-31.1 36.6L512 253.5V488v24H488 88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zm0 62.9L112 212.8V464H464V212.8L288 63.5zM256 288h64V224H256v64zM208 176h48 64 48v48 64 48H320 256 208V288 224 176z'
      
    ]
  };

  

  
  

  var faHoseReel = {
    prefix: 'fasr',
    iconName: 'hose-reel',
    icon: [
      640,
      512,
      [],
      'e41a',
      
      'M320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208c45.6 0 87.7-14.6 122-39.5l28.2 38.9C428 494 376.1 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0S576 114.6 576 256v96h16 24v48H592h-2.3l-11.4 80H592v32H576 528 512V480h13.7l-11.4-80H512 488V352h24 16V256c0-114.9-93.1-208-208-208zM208 256a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM320 416a160 160 0 1 1 0-320 160 160 0 1 1 0 320zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faFamilyPants = {
    prefix: 'fasr',
    iconName: 'family-pants',
    icon: [
      512,
      512,
      [],
      'e302',
      
      'M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM78 208l-4 96h38 32v48H112V488v24H64V488 352H24l2-48 6-144H177.6c-1 5.2-1.6 10.5-1.6 16c0 11.4 2.4 22.2 6.7 32H178 128 78zm258-32c0-5.5-.6-10.8-1.6-16H480l6 144 2 48H448V488v24H400V488 352H368V304h32 38l-4-96H384 334h-4.7c4.3-9.8 6.7-20.6 6.7-32zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm-64 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 368h64V304H224v64zm112 48H304v96H208V416H176V368 304 256h48 64 48v48 64 48z'
      
    ]
  };

  

  
  

  var faPlateUtensils = {
    prefix: 'fasr',
    iconName: 'plate-utensils',
    icon: [
      640,
      512,
      [58713],
      'e43b',
      
      'M48 16V40 168c0 4.4 3.6 8 8 8h8V40 16h48V40 176h8c4.4 0 8-3.6 8-8V40 16h48V40 168c0 30.9-25.1 56-56 56h-8V472v24H64V472 224H56c-30.9 0-56-25.1-56-56V40 16H48zm592 0V64.8 192v24 56 48V472v24H592V472 320H560 512V272 160c0-74.8 43.7-111.3 80-128.8C617.9 18.8 640 16 640 16zM592 192V87.3c-17.2 13.6-32 35.1-32 72.7V272h32V216 192zM336 32c60.2 0 114.9 23.8 155.2 62.4c-6.5 17.4-10.6 37.4-11.1 60.4C448.2 109.6 395.6 80 336 80c-50.4 0-95.9 21.2-128 55.2V72.2C244.3 46.8 288.4 32 336 32zm0 400c61.8 0 116.1-31.8 147.5-80H512h26.4c-36 75.7-113.1 128-202.4 128c-81.5 0-152.8-43.5-192-108.6V252.7c5.7-1.6 11.1-3.8 16.3-6.4c-.2 3.2-.3 6.5-.3 9.7c0 97.2 78.8 176 176 176zm80-176a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-208 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z'
      
    ]
  };

  

  
  

  var faPrescriptionBottleMedical = {
    prefix: 'fasr',
    iconName: 'prescription-bottle-medical',
    icon: [
      384,
      512,
      ["prescription-bottle-alt"],
      'f486',
      
      'M336 48V80H48V48H336zM48 0H0V48 80v48H48 336h48V80 48 0H336 48zM32 160V464v48H80 304h48V464 160H304V464H80V160H32zm133.3 64v53.3H112v53.3h53.3V384h53.3V330.7H272V277.3l-53.3 0V224H165.3z'
      
    ]
  };

  
    var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
  

  
  

  var faBraille = {
    prefix: 'fasr',
    iconName: 'braille',
    icon: [
      640,
      512,
      [],
      'f2a1',
      
      'M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM88 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCalendarClock = {
    prefix: 'fasr',
    iconName: 'calendar-clock',
    icon: [
      576,
      512,
      ["calendar-time"],
      'e0d2',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48H432 400 288 48V464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 192 144 64H104V24 0h48zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80H416v16 64 16h16 48 16V352H480 448V304 288z'
      
    ]
  };

  
    var faCalendarTime = faCalendarClock;
  

  
  

  var faClockDesk = {
    prefix: 'fasr',
    iconName: 'clock-desk',
    icon: [
      448,
      512,
      [],
      'e134',
      
      'M400 224A176 176 0 1 0 48 224a176 176 0 1 0 352 0zM224 0C347.7 0 448 100.3 448 224V512H0V224C0 100.3 100.3 0 224 0zm24 96v24 94.1l41 41 17 17L272 305.9l-17-17-48-48-7-7V224 120 96h48z'
      
    ]
  };

  

  
  

  var faCalendarCheck = {
    prefix: 'fasr',
    iconName: 'calendar-check',
    icon: [
      448,
      512,
      [],
      'f274',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zM329 297L217 409l-17 17-17-17-64-64-17-17L136 294.1l17 17 47 47 95-95 17-17L345.9 280l-17 17z'
      
    ]
  };

  

  
  

  var faPlaneProp = {
    prefix: 'fasr',
    iconName: 'plane-prop',
    icon: [
      576,
      512,
      [],
      'e22b',
      
      'M264-8H243l-2.8 20.8L233.4 64H192v64h32.9l-7.1 53.1-76.6 7.5-5.4-39.8L133 128H112 60.6h-21l-2.8 20.8-8 58.7C11.5 217 0 235.3 0 256s11.5 39 28.8 48.5l8 58.7L39.6 384h21H112h21l2.8-20.8 5.4-39.8 76.6 7.5 7.1 53.1H192v64h41.4l6.8 51.2L243 520h21 56 21l2.8-20.8 6.8-51.2H368v16 16h32V464 432h16V400H400V368 352H368v16 16h-8.9l6.4-48 100.6 0c20.4 0 46.1-6.9 67-18.5c19.5-10.8 44-30.9 44-61.5c0-30.2-24.7-50.4-43.9-61.1c-20.8-11.6-46.5-18.9-67.1-18.9H365.5l-6.4-48H368v16 16h32V144 112h16V80H400V48 32H368V48 64H350.6l-6.8-51.2L341-8H320 264zm53.1 184H270.9h-1.2l-1.2 .1-1.7 .2L285 40h14l18.1 136zm0 160L299 472H285L266.8 335.7l1.7 .2 1.2 .1h1.2 46.3zM74.4 228.3L81.5 176H91l5.7 41.9 3.1 22.9 23-2.3L272 224H466.2c11.1 0 28.9 4.5 43.7 12.8c16.3 9.1 19.3 17 19.3 19.2c0 2.8-3.1 10.6-19.2 19.5c-14.7 8.1-32.5 12.5-43.8 12.5L272 288 122.8 273.4l-23-2.3-3.1 22.9L91 336H81.5l-7.1-52.3L72 266.3l-17.3-3-.7-.1c-3.5-.6-6-3.6-6-7.1s2.5-6.5 6-7.1l.7-.1 17.3-3 2.4-17.4z'
      
    ]
  };

  

  
  

  var faNfcSignal = {
    prefix: 'fasr',
    iconName: 'nfc-signal',
    icon: [
      512,
      512,
      [],
      'e1fb',
      
      'M400 80H48V432H235.3c-4.5 15.5-7.7 31.5-9.5 48H48 0V432 80 32H48 400h48V80 231.1c-16.6 3.8-32.6 9-48 15.5V80zm-32 56V262.5c-17.2 10-33.3 21.6-48 34.8V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V136 112h24H344h24v24zM246.6 400H104 80V376 136 112h24 32 24v48H136h-8V352H272.5c-10.1 15.1-18.8 31.1-25.9 48zM512 304c-114.9 0-208 93.1-208 208H256c0-141.4 114.6-256 256-256v48zM480 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 64H352c0-88.4 71.6-160 160-160v48c-61.9 0-112 50.1-112 112z'
      
    ]
  };

  

  
  

  var faStarSharpHalfStroke = {
    prefix: 'fasr',
    iconName: 'star-sharp-half-stroke',
    icon: [
      576,
      512,
      ["star-sharp-half-alt"],
      'e28d',
      
      'M313.3 77.7l38.3 117.9h124 81.7l-66.1 48L390.9 316.4l38.3 117.9L454.4 512l-66.1-48L288.1 391.1 187.8 464l-66.1 48 25.2-77.7 38.3-117.9L84.9 243.6l-66.1-48h81.7 124L262.8 77.7 288.1 0l25.2 77.7zm38.3 165.9H316.7l-10.8-33.2-17.9-55.1-.1 .2V331.8l.1 0 28.2 20.5 46.8 34-17.9-55.1-10.8-33.2 28.2-20.5 46.8-34H351.6z'
      
    ]
  };

  
    var faStarSharpHalfAlt = faStarSharpHalfStroke;
  

  
  

  var faWater = {
    prefix: 'fasr',
    iconName: 'water',
    icon: [
      576,
      512,
      [],
      'f773',
      
      'M96 126.2c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V112c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4 0 0c-13 11.6-24.8 22.2-40.2 30.9C39.4 104.2 19.7 112 0 112v48c31.5 0 59.7-12.2 79-23.1c6.5-3.7 12.2-7.4 16.9-10.7zm0 288c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V400c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6 0 0c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4 0 0c-13 11.6-24.8 22.2-40.2 30.9C39.4 392.2 19.7 400 0 400v48c31.5 0 59.7-12.2 79-23.1c6.5-3.7 12.2-7.4 16.9-10.7zM79 280.9c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V256c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4c-13 11.6-24.8 22.2-40.2 30.9C39.4 248.2 19.7 256 0 256v48c31.5 0 59.7-12.2 79-23.1z'
      
    ]
  };

  

  
  

  var faWaveform = {
    prefix: 'fasr',
    iconName: 'waveform',
    icon: [
      640,
      512,
      [],
      'f8f1',
      
      'M429 64h38.5l4.3 28.4L500.2 282l20.4-95 5.8-27h30.4l9.5 22.8L600 264h8 24v48H608 584 568l-6.2-14.8-10.5-25.1L519.5 421l-5.8 27H476.5l-4.3-28.4L446.8 249.5 407.7 483.9 403 512H364.3l-4.1-28.6L320 201.7 279.8 483.4 275.7 512H237l-4.7-28.1L193.2 249.5 167.7 419.6 163.5 448H126.3l-5.8-27L88.6 272.1 78.2 297.2 72 312H56 32 8V264H32h8l33.8-81.2L83.3 160h30.4l5.8 27 20.4 95L168.3 92.4 172.5 64H211l4.7 28.1 38.5 231L296.2 28.6 300.3 0h39.3l4.1 28.6 42.1 294.5 38.5-231L429 64z'
      
    ]
  };

  

  
  

  var faTricycleAdult = {
    prefix: 'fasr',
    iconName: 'tricycle-adult',
    icon: [
      640,
      512,
      [],
      'e5c4',
      
      'M288 64h24 56 12.8L388 74.7 512.4 261.3c9.9-3.4 20.5-5.3 31.6-5.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-24.6 9.3-47 24.5-64L460 269.3l-48 72L404.8 352H392 352h-2.7l-2.6-.6L287 338c.7 4.6 1 9.3 1 14c0 53-43 96-96 96c-17.5 0-33.9-4.7-48-12.8c.6-.4 1.3-.8 1.9-1.1c-14.5 8.9-31.6 14-49.9 14c-53 0-96-43-96-96c0-28.4 12.3-53.9 31.9-71.4l-5.1-1.2L3.3 274.1l10.5-46.8 23.4 5.3L354.7 304h24.5l52-78-76-114H312 288V64zM184.6 314.9c4.8 11.4 7.4 23.9 7.4 37.1c0 16.9-4.3 32.7-12 46.5c3.8 1 7.8 1.5 12 1.5c26.5 0 48-21.5 48-48c0-9.7-2.9-18.8-7.9-26.4l-47.5-10.7zM71.5 89.8l7.3 22.9 19.7 61.4 98.1 19.1 23.6 4.6L211 244.9l-23.6-4.6-112-21.9-13.9-2.7-4.3-13.5-24-74.9-7.3-22.9L71.5 89.8zM144 352a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm448 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faFileEps = {
    prefix: 'fasr',
    iconName: 'file-eps',
    icon: [
      512,
      512,
      [],
      'e644',
      
      'M48 464H96v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zM160 352h16 64 16v32H240 192v32h32 16v32H224 192v32h48 16v32H240 176 160V496 432 368 352zm144 0h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H320v32 16H288V496 448 368 352h16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H320v48h16zm117.7-80H480h16v32H480 453.7c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7H424 408V480h16 34.3c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7c0-25.2 20.4-45.7 45.7-45.7z'
      
    ]
  };

  

  
  

  var faHandHoldingDroplet = {
    prefix: 'fasr',
    iconName: 'hand-holding-droplet',
    icon: [
      576,
      512,
      ["hand-holding-water"],
      'f4c1',
      
      'M288 0l76.8 102.4C377.3 119 384 139.2 384 160c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L288 0zM160.7 304H168 384h24v24 46.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H424 24 0V464H24 416.6l91.7-62.8-15-24-80.4 51L407 432h-7H368 320 296 256 232V384h24 40 24 40V352H175.3l-90 60-6 4H72 24 0V368H24 64.7l90-60 6-4z'
      
    ]
  };

  
    var faHandHoldingWater = faHandHoldingDroplet;
  

  
  

  var faSquare4 = {
    prefix: 'fasr',
    iconName: 'square-4',
    icon: [
      448,
      512,
      [],
      'e259',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM288 192H240v24 56H175.6l40-144H165.8L120.9 289.6 112.4 320H144h96v40 24h48V360 320h8 24V272H296h-8V216 192z'
      
    ]
  };

  

  
  

  var faBuoyMooring = {
    prefix: 'fasr',
    iconName: 'buoy-mooring',
    icon: [
      576,
      512,
      [],
      'e5b6',
      
      'M264 0h48V64h48 19.8l3.8 19.4 60.5 310.2c-6.5 4.4-12.6 8-19.4 11.1c-8.2 3.8-17.1 6.9-25.7 8.7L383.9 336H192.1L177 413.3c-8.6-1.8-17.4-4.9-25.7-8.7c-6.8-3.1-12.9-6.7-19.4-11.1L192.4 83.4 196.2 64H216h48V0zM201.4 288H374.6L340.2 112H235.8L201.4 288zM79 488.9C59.7 499.8 31.5 512 0 512V464c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  

  
  

  var faArrowDown19 = {
    prefix: 'fasr',
    iconName: 'arrow-down-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-asc","sort-numeric-down"],
      'f162',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM360 32h24 48 24V56 176h24 24v48H480 432 384 360V176h24 24V80H384 360V32zm24 312a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm128 0c0 20.6-6.4 40.7-18.4 57.5L437.5 480h-59l10-13.9 24.8-34.7C369.7 426.1 336 389 336 344c0-48.6 39.4-88 88-88s88 39.4 88 88z'
      
    ]
  };

  
    var faSortNumericAsc = faArrowDown19;
  
    var faSortNumericDown = faArrowDown19;
  

  
  

  var faSleigh = {
    prefix: 'fasr',
    iconName: 'sleigh',
    icon: [
      640,
      512,
      [],
      'f7cc',
      
      'M24 32H0V80H24h8V256c0 62.5 44.8 114.5 104 125.8V432H56 32v48H56 616h24V456 384 360H592v24 48H440V383.8C507 379.6 560 324 560 256V144h24 24V96H584 560 536 512 464 416v48 32 48h-6.6c-14 0-27.8-1.3-41.4-3.7c-64.2-11.6-121.3-49.7-156.6-106C182.5 67.9 133.7 38.1 80 32.8c-2.7-.3-5.3-.5-8-.6V32H63 48 32 24zM392 432H184V384H392v48zm40-96H392 184 160c-44.2 0-80-35.8-80-80V81.1c37.2 5 70.5 26.3 90.7 58.6C222.2 222 312.3 272 409.4 272H416h48V224 144h48V256c0 44.2-35.8 80-80 80z'
      
    ]
  };

  

  
  

  var faCarOn = {
    prefix: 'fasr',
    iconName: 'car-on',
    icon: [
      512,
      512,
      [],
      'e4dd',
      
      'M280 24v80 24H232V104 24 0h48V24zM135.1 160H152 360h16.9l5.7 15.9L416.9 272H464v48 80 16 32 64H416V448H96v64H48V448 416 400 320 272H95.1l34.3-96.1 5.7-15.9zm208 48H168.9l-22.9 64H365.9l-22.9-64zM416 320H96v80H416V320zM144 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 22.1L73 39l48 48 17 17L104 137.9 87 121 39 73l-17-17L56 22.1zM439 39l17-17L489.9 56 473 73l-48 48-17 17L374.1 104l17-17 48-48z'
      
    ]
  };

  

  
  

  var faMeteor = {
    prefix: 'fasr',
    iconName: 'meteor',
    icon: [
      512,
      512,
      [9732],
      'f753',
      
      'M304 16L253.6 45.2 101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3l88.2-152.3L496 208l-7.5 .6L438 212.5l-1.9 .1 17.7-49.5L491.1 58.4 512 0 453.6 20.9 348.9 58.3 299.4 75.9l.1-1.9 3.9-50.5L304 16zM125.3 174.9l123.8-71.7L245.9 146l69.7-24.9L432.7 79.3 390.9 196.5 366 266.1l42.8-3.3L337.1 386.7C309.4 434.5 258.3 464 203 464c-85.6 0-155-69.4-155-155c0-55.3 29.5-106.4 77.3-134.1zM200 424a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faCartArrowUp = {
    prefix: 'fasr',
    iconName: 'cart-arrow-up',
    icon: [
      576,
      512,
      [],
      'e3ee',
      
      'M0 0H24 96h19.9l3.7 19.5 42 220.5H462.2l63-208h50.2L503 271l-5.2 17H480 170.7l9.1 48H488h24v48H488 160 140.1l-3.7-19.5L76.1 48H24 0V0zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM296 184V97.9l-23 23-17 17L222.1 104l17-17 64-64 17-17 17 17 64 64 17 17L384 137.9l-17-17-23-23V184v24H296V184z'
      
    ]
  };

  

  
  

  var faSquareVirus = {
    prefix: 'fasr',
    iconName: 'square-virus',
    icon: [
      448,
      512,
      [],
      'e578',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM248 378.2v.2 24H224 200l0-23.8 0-.2c0-23.8-28.8-35.7-45.6-18.9l-.1 .1-16.8 16.8-33.9-33.9 17-17 .2-.2c16.6-16.8 4.7-45.4-19-45.4l0 0-24 0V256v0 0V232h24l0 0c23.7 0 35.6-28.6 19-45.4l-.2-.2-17-17 33.9-33.9 16.8 16.8 .1 .1c16.8 16.8 45.6 4.9 45.6-18.9l0-.2V109.6h24 0 24v24 .2c.2 23.6 28.6 35.4 45.4 18.8l.1-.1 17-17 16.8 16.8 .1 .1 .1 .1 16.8 16.8-16.8 16.8-.1 .1c-16.8 16.8-4.9 45.6 18.9 45.6l0 0h24v24 24l-24 0 0 0c-23.8 0-35.7 28.8-18.9 45.6l.1 .1 16.8 16.8-16.8 16.8-.1 .1-.1 .1-16.8 16.8-17-17-.2-.2c-16.8-16.6-45.3-4.7-45.4 18.9zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCamera = {
    prefix: 'fasr',
    iconName: 'camera',
    icon: [
      512,
      512,
      [62258,"camera-alt"],
      'f030',
      
      'M352 32l21.3 64H464h48v48V432v48H464 48 0V432 144 96H48h90.7L160 32H352zm21.3 112H338.7l-10.9-32.8L317.4 80H194.6l-10.4 31.2L173.3 144H138.7 48V432H464V144H373.3zM256 176a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm64 112a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faCameraAlt = faCamera;
  

  
  

  var faCameraPolaroid = {
    prefix: 'fasr',
    iconName: 'camera-polaroid',
    icon: [
      576,
      512,
      [],
      'f8aa',
      
      'M464 270.5V256 80H112V256v14.5l-8.1 12.1L68.4 336H507.6l-35.6-53.4L464 270.5zM528 384H48v48H528V384zm48-32v80 48H528 48 0V432 352l64-96V80 32h48H464h48V80 256l64 96zM432 112v48H384V112h48zM288 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm32 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCloudMeatball = {
    prefix: 'fasr',
    iconName: 'cloud-meatball',
    icon: [
      512,
      512,
      [],
      'f73b',
      
      'M266.3 48.1C246 18.9 213.1 0 176 0C114.1 0 64 52.7 64 117.6v22.5C26.7 154 0 191.3 0 235.2V288v48H48 96h37.6l-2.9-14.4 12.1-12.1L164.4 288H96 48V235.2c0-24.4 14.7-43.4 32.7-50.1L112 173.5V140.1 117.6C112 76.9 142.8 48 176 48c20.6 0 39.6 10.6 51.8 28.7l27 40.2 40-27.4c7.5-5.1 16.1-7.9 25.3-7.9c24.3 0 48 21.4 48 52.8v48h48c24.3 0 48 21.4 48 52.8V288H416 347.6l21.5 21.5 12.1 12.1L378.4 336H416h48 48V288 235.2c0-55.7-43-100.8-96-100.8c0-55.7-43-100.8-96-100.8c-18.7 0-36.1 5.6-50.9 15.3c-.5 .3-1 .7-1.5 1c-.4-.6-.8-1.2-1.3-1.8zM172.1 434.7l-6.6 33.1 22.6 22.6 33.1-6.6L240 512h32l18.7-28.1 33.1 6.6 22.6-22.6-6.6-33.1L368 416V384l-28.1-18.7 6.6-33.1-22.6-22.6-33.1 6.6L272 288H240l-18.7 28.1-33.1-6.6-22.6 22.6 6.6 33.1L144 384v32l28.1 18.7zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faMessageHeart = {
    prefix: 'fasr',
    iconName: 'message-heart',
    icon: [
      512,
      512,
      [],
      'e5c9',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM144 171.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 304.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2z'
      
    ]
  };

  

  
  

  var faHammerCrash = {
    prefix: 'fasr',
    iconName: 'hammer-crash',
    icon: [
      640,
      512,
      [],
      'e414',
      
      'M283.9 344.9l3-21.7 47.4 23.7 13.1-26.2 21.1-8 29.9-11.4 22 23.2 24.6 25.9 10.9-34 9.8-30.4 31.8-2.7 35.5-3.1-19.8-29.7L495.4 224l17.7-26.6 19.8-29.7-35.5-3.1-31.8-2.7-9.8-30.4-5.4-16.7 .5-1.1-1-.5-5-15.7-8.5 8.9L391.5 84l36.6-38.6L465.8 5.6l16.7 52.1 18.9 59.1 61.8 5.3 54.6 4.7-30.3 45.6L553.1 224l34.4 51.6 30.3 45.6-54.6 4.7-61.8 5.3-18.9 59.1-16.7 52.1-37.7-39.7-42.7-45-58 22-51.2 19.4 7.6-54.2zM64.4 122.5L298.5 239.6l45.1-90.1L172.7 64h-79L64.4 122.5zM42.9 165.5L0 144l21.5-42.9L64 16H184l181.1 90.5L408 128l-21.5 42.9-45.1 90.1L320 304l-42.9-21.5-89.2-44.6L64.5 484.7 21.5 463.3 144.9 216.5l-102-51z'
      
    ]
  };

  

  
  

  var faFishingRod = {
    prefix: 'fasr',
    iconName: 'fishing-rod',
    icon: [
      448,
      512,
      [],
      'e3a8',
      
      'M284.6 0H288h64 24V24 136v24H328V136 48H291.4L88 106.1V288h40v48V464v48H80 48 0V464 336 288H40V88 69.9l17.4-5 224-64 3.2-.9zM80 336H48V464H80V336zm176 8c0-76.8 64-136 96-152c32 16 96 75.2 96 152c0 32-16 80-64 112l32 40v16H288V496l32-40c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCircleInfo = {
    prefix: 'fasr',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336H192v48h24 80 24V336H296h-8V248 224H264 216 192v48h24 24v64H216zm72-144V128H224v64h64z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faSlashBack = {
    prefix: 'fasr',
    iconName: 'slash-back',
    icon: [
      320,
      512,
      [],
      '5c',
      
      'M9 0H62.3L311 512H257.7L9 0z'
      
    ]
  };

  

  
  

  var faUserDoctor = {
    prefix: 'fasr',
    iconName: 'user-doctor',
    icon: [
      448,
      512,
      ["user-md"],
      'f0f0',
      
      'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM99.5 352L50.2 512H0L64 304H384l64 208H397.8L348.5 352H312v50c27.6 7.1 48 32.2 48 62v32 16H344 320 304V480h16 8V464c0-17.7-14.3-32-32-32s-32 14.3-32 32v16h8 16v32H272 248 232V496 464c0-29.8 20.4-54.9 48-62V352H168v50.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V352H99.5zM176 456a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faUserMd = faUserDoctor;
  

  
  

  var faMeterBolt = {
    prefix: 'fasr',
    iconName: 'meter-bolt',
    icon: [
      640,
      512,
      [],
      'e1e9',
      
      'M464 256c0 9.9-.7 19.6-2 29.1l49.9-37.9C507.2 109.9 394.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c80.8 0 152.9-37.5 199.9-96H388.9c-36 30-82.4 48-132.9 48C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208zM192 152V128H144v24 48 24h48V200 152zm88 0V128H232v24 48 24h48V200 152zm88 0V128H320v24 48 24h48V200 152zM504 384L464 512 640 376V352H552l40-128L416 360v24h88z'
      
    ]
  };

  

  
  

  var faHouseChimneyBlank = {
    prefix: 'fasr',
    iconName: 'house-chimney-blank',
    icon: [
      576,
      512,
      [],
      'e3b0',
      
      'M288 .5l15.5 13.2L464 149.9V88 64h48V88v96 6.6l55.5 47.1-31.1 36.6L512 253.5V488v24H488 88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zm0 63L112 212.8V464H464V212.8L288 63.5z'
      
    ]
  };

  

  
  

  var faHouseHeart = {
    prefix: 'fasr',
    iconName: 'house-heart',
    icon: [
      576,
      512,
      ["home-heart"],
      'f4c9',
      
      'M288 .5l15.5 13.2 264 224-31.1 36.6L512 253.5V488v24H488 88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zm0 62.9L112 212.8V464H464V212.8L288 63.5zM176 267.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L288 400.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z'
      
    ]
  };

  
    var faHomeHeart = faHouseHeart;
  

  
  

  var faFileXmark = {
    prefix: 'fasr',
    iconName: 'file-xmark',
    icon: [
      384,
      512,
      ["file-times"],
      'f317',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zm33.9 256L256 222.1l-17 17-47 47-47-47-17-17L94.1 256l17 17 47 47-47 47-17 17L128 417.9l17-17 47-47 47 47 17 17L289.9 384l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faFileTimes = faFileXmark;
  

  
  

  var faMountain = {
    prefix: 'fasr',
    iconName: 'mountain',
    icon: [
      512,
      512,
      [127956],
      'f6fc',
      
      'M48 432v-9.2L154.5 266.3l34.5 44.4 19.3 24.8 18.9-25.1L268 256h82.4L464 422.8V432H48zM317.8 208H256 244l-7.2 9.6-29.1 38.9-24.7-31.8L256 117.3 317.8 208zM256 32L227 74.6 0 408v24 48H48 464h48V432 408L285 74.6 256 32z'
      
    ]
  };

  

  
  

  var faHourglass = {
    prefix: 'fasr',
    iconName: 'hourglass',
    icon: [
      384,
      512,
      [9203,62032,"hourglass-empty"],
      'f254',
      
      'M24 0H0V48H24h8v72 9.9l7 7 119 119L39 375l-7 7V392v72H24 0v48H24 360h24V464H360h-8V392v-9.9l-7-7-119-119L345 137l7-7V120 48h8 24V0H360 24zM304 48v62.1l-112 112L80 110.1V48H304zM192 289.9l112 112V464H80V401.9l112-112z'
      
    ]
  };

  
    var faHourglassEmpty = faHourglass;
  

  
  

  var faNfcTrash = {
    prefix: 'fasr',
    iconName: 'nfc-trash',
    icon: [
      640,
      512,
      [],
      'e1fd',
      
      'M400 80H48V432H378.2l3.4 48H48 0V432 80 32H48 400h48V80v80H434.3l-16 32H400V80zM352 192v96h15.9l.1 1.1V376v24H344 104 80V376 136 112h24 32 24v48H136h-8V352H320V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V136 112h24H344h24v24 56H352zm102.1 0H464h96 9.9l4.4 8.8L585.9 224H624h16v32H624 576 448 400 384V224h16 38.1l11.6-23.2 4.4-8.8zM608 512H416L400 288H624L608 512z'
      
    ]
  };

  

  
  

  var faTruckFieldUn = {
    prefix: 'fasr',
    iconName: 'truck-field-un',
    icon: [
      640,
      512,
      [],
      'e58e',
      
      'M64 80v48V288v48H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H352V224 104 80H64zM16 336V288H0V128H16V80 32H64 352h48V80h56 15.2l6.5 13.8L539 224h69V336h8 24v48H616h-8H576c0 53-43 96-96 96s-96-43-96-96H352 256c0 53-43 96-96 96s-96-43-96-96H24 16 0V336H16zm96 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM400 224h85.9l-45.2-96H400v96zm80 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144 128h32v16 64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144 128h32v16zm112-16h8 9.9l4.4 8.8L288 188.2V144 128h32v16 96 16H304h-8-9.9l-4.4-8.8L256 195.8V240v16H224V240 144 128h16z'
      
    ]
  };

  

  
  

  var faPuzzlePieceSimple = {
    prefix: 'fasr',
    iconName: 'puzzle-piece-simple',
    icon: [
      640,
      512,
      ["puzzle-piece-alt"],
      'e231',
      
      'M112 64h24H280h24V88v14.4 10.9l-8.2 7.2c-5.4 4.7-7.8 10.3-7.8 15.5c0 9.9 10.7 24 32 24s32-14.1 32-24c0-5.3-2.4-10.8-7.8-15.5l-8.2-7.2V102.4 88 64h24H504h24V88v94.6c10.9-8.9 24.5-14.6 40-14.6c22.5 0 41 12.2 53.1 28.3S640 233.6 640 256s-6.8 43.5-18.9 59.7S590.5 344 568 344c-15.5 0-29.1-5.8-40-14.6V424v24H504 360 336V424 409.6 398.7l8.2-7.2c5.4-4.7 7.8-10.3 7.8-15.5c0-9.9-10.7-24-32-24s-32 14.1-32 24c0 5.3 2.4 10.8 7.8 15.5l8.2 7.2v10.9V424v24H280 136 112V424 329.4C101.1 338.2 87.5 344 72 344c-22.5 0-41-12.2-53.1-28.3S0 278.4 0 256s6.8-43.5 18.9-59.7S49.5 168 72 168c15.5 0 29.1 5.8 40 14.6V88 64zm48 48V216v24H136 109.5 95.9l-7-11.6C83.2 218.8 76.5 216 72 216c-4 0-9.5 2.1-14.7 9.1S48 243 48 256s4 23.8 9.3 30.9s10.7 9.1 14.7 9.1c4.5 0 11.2-2.8 16.9-12.4l7-11.6h13.6H136h24v24V400h84.5c-2.9-7.4-4.5-15.5-4.5-24c0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24H480V296 272h24 26.5 13.6l7 11.6c5.8 9.6 12.4 12.4 16.9 12.4c4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9s-4-23.8-9.3-30.9s-10.7-9.1-14.7-9.1c-4.5 0-11.2 2.8-16.9 12.4l-7 11.6H530.5 504 480V216 112H395.5c2.9 7.4 4.5 15.5 4.5 24c0 43.1-39.4 72-80 72s-80-28.9-80-72c0-8.5 1.6-16.6 4.5-24H160z'
      
    ]
  };

  
    var faPuzzlePieceAlt = faPuzzlePieceSimple;
  

  
  

  var faTreeDeciduous = {
    prefix: 'fasr',
    iconName: 'tree-deciduous',
    icon: [
      512,
      512,
      [127795,"tree-alt"],
      'f400',
      
      'M185.9 103.6l-5.5 23.5L157 121.5c-4.1-1-8.5-1.5-13-1.5c-30.9 0-56 25.1-56 56c0 5.4 .8 10.6 2.2 15.4l5.8 20.1L76.7 220c-17 7.4-28.7 24.4-28.7 44v72H232V320 256 152 128h48v24V256v64 16H464V264c0-19.6-11.8-36.5-28.7-44l-19.2-8.4 5.8-20.1c1.4-4.9 2.2-10.1 2.2-15.4c0-30.9-25.1-56-56-56c-4.5 0-8.8 .5-13 1.5l-23.4 5.5-5.5-23.5C318.7 71.7 290.1 48 256 48s-62.7 23.7-70.1 55.6zM232 384H24 0V360 264c0-32.3 16-60.9 40.4-78.3c-.3-3.2-.4-6.4-.4-9.7C40 118.6 86.6 72 144 72c.7 0 1.3 0 2 0C164.5 29.6 206.8 0 256 0s91.5 29.6 110 72c.7 0 1.3 0 2 0c57.4 0 104 46.6 104 104c0 3.3-.2 6.5-.4 9.7C496 203.1 512 231.7 512 264v96 24H488 280V488v24H232V488 384z'
      
    ]
  };

  
    var faTreeAlt = faTreeDeciduous;
  

  
  

  var faIndent = {
    prefix: 'fasr',
    iconName: 'indent',
    icon: [
      448,
      512,
      [],
      'f03c',
      
      'M0 40V88H24 424h24V40H424 24 0zM192 168v48h24H424h24V168H424 216 192zm24 128H192v48h24H424h24V296H424 216zM0 424v48H24 424h24V424H424 24 0zm0-72l128-96L0 160V352z'
      
    ]
  };

  

  
  

  var faCommentMusic = {
    prefix: 'fasr',
    iconName: 'comment-music',
    icon: [
      512,
      512,
      [],
      'f8b0',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM352 128V104.9L330.4 113l-128 48L192 164.9V176v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V219.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V160 128z'
      
    ]
  };

  

  
  

  var faRugbyBall = {
    prefix: 'fasr',
    iconName: 'rugby-ball',
    icon: [
      512,
      512,
      [],
      'e3c6',
      
      'M496 80L432 16H336C159.3 16 16 159.3 16 336v96l64 64h96c176.7 0 320-143.3 320-320V80zM343.7 64L235.3 116.4 116.4 235.3 64 343.7c0-67.1 20.4-131.3 64-183c9.8-11.6 20.5-22.3 32-32.1C211.8 84.6 276.3 64 343.7 64zM86.2 434.3l-8.6-8.6 78.4-162.3L263.5 156.1 425.8 77.7l8.6 8.6L355.9 248.5 248.5 355.9 86.2 434.3zM168.3 448l108.4-52.4L395.6 276.7 448 168.3c0 67.4-20.6 131.9-64.6 183.7c-9.6 11.3-20.1 21.8-31.4 31.4c-51.8 44-116.3 64.6-183.7 64.6z'
      
    ]
  };

  

  
  

  var faMessageMedical = {
    prefix: 'fasr',
    iconName: 'message-medical',
    icon: [
      512,
      512,
      ["comment-alt-medical"],
      'f7f4',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM224 112v64H160v64h64v64h64V240h64V176H288V112H224z'
      
    ]
  };

  
    var faCommentAltMedical = faMessageMedical;
  

  
  

  var faReflectHorizontal = {
    prefix: 'fasr',
    iconName: 'reflect-horizontal',
    icon: [
      512,
      512,
      [],
      'e664',
      
      'M280 0l0 24 0 464 0 24-48 0 0-24 0-464 0-24 48 0zM158.1 222.1L192 256l-33.9 33.9L48 400 32 416 0 416l0-32 0-3.9L0 368 0 144l0-12.1L0 128 0 96l32 0 16 16L158.1 222.1zM48 332.1L124.1 256 48 179.9l0 152.2zM320 256l33.9-33.9L464 112l16-16 32 0 0 32 0 3.9 0 12.1 0 224 0 12.1 0 3.9 0 32-32 0-16-16L353.9 289.9 320 256zm67.9 0L464 332.1l0-152.2L387.9 256z'
      
    ]
  };

  

  
  

  var faParachuteBox = {
    prefix: 'fasr',
    iconName: 'parachute-box',
    icon: [
      512,
      512,
      [],
      'f4cd',
      
      'M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H232V320H208 197.6L96.3 188.9c-.2-4.3-.3-8.6-.3-12.9c0-64 22.2-121.2 57.1-159.3C50.3 53.5 8.3 142.1 0 192H38L160 349.8V368v96 48h48 96 48V464 368 349.8L474 192h38c-8.3-49.9-50.3-138.5-153.1-175.3C393.8 54.8 416 112.1 416 176c0 4.3-.1 8.6-.3 12.9L314.4 320H304 280V192H383.5zM208 368h96v96H208V368z'
      
    ]
  };

  

  
  

  var faCircleNodes = {
    prefix: 'fasr',
    iconName: 'circle-nodes',
    icon: [
      512,
      512,
      [],
      'e4e2',
      
      'M368 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-29.9 50.6c6.8 8.3 15.2 15.2 24.7 20.2L326 352.6c-11.5 1.4-22.2 5.3-31.7 11.1L153.3 240.2c4.3-9.9 6.7-20.7 6.7-32.2c0-2-.1-4.1-.2-6.1l178.3-71.3zM410 159.4c39.5-4.9 70-38.6 70-79.4c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 2 .1 4.1 .2 6.1L141.9 157.4C127.3 139.4 105 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c15.3 0 29.5-4.3 41.6-11.7L262.7 399.8c-4.3 9.9-6.7 20.7-6.7 32.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-30.7-17.3-57.4-42.7-70.8L410 159.4zM304 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faCircleWifiCircleWifi = {
    prefix: 'fasr',
    iconName: 'circle-wifi-circle-wifi',
    icon: [
      640,
      512,
      ["circle-wifi-group"],
      'e67e',
      
      'M256 48c94.3 0 173.9 62.7 199.4 148.7c13-3.1 26.6-4.7 40.6-4.7c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25c-11-12-20.4-25.5-27.7-40.1c-25.3 11-53.3 17.1-82.6 17.1C141.1 464 48 370.9 48 256S141.1 48 256 48zm0 96c-70.3 0-133.6 30.3-177.5 78.5l34 34C147.6 216.9 198.9 192 256 192c46.8 0 89.7 16.7 123 44.5c12.3-11 26.2-20.3 41.3-27.5C377.4 168.7 319.6 144 256 144zm0 96c-43.7 0-82.5 20.6-107.4 52.6l34.4 34.4C198.7 303.5 225.6 288 256 288c28.5 0 53.8 13.6 69.9 34.6c4.6-17.1 11.6-33.2 20.8-47.9C322.7 253.1 290.9 240 256 240zm32 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-31.5-20.4l-25.6 19.2C564.3 338.6 532.3 320 496 320s-68.3 18.6-86.9 46.8l-25.6-19.2c24.5-36 65.7-59.6 112.5-59.6s88.1 23.6 112.5 59.6zM496 352c26.2 0 49.4 12.6 64 32l-25.6 19.2C525.6 391.5 511.7 384 496 384s-29.6 7.5-38.4 19.2L432 384c14.6-19.4 37.8-32 64-32zm0 60a20 20 0 1 1 0 40 20 20 0 1 1 0-40z'
      
    ]
  };

  
    var faCircleWifiGroup = faCircleWifiCircleWifi;
  

  
  

  var faArrowTurnDownLeft = {
    prefix: 'fasr',
    iconName: 'arrow-turn-down-left',
    icon: [
      512,
      512,
      [],
      'e2e1',
      
      'M464 56V32h48V56 288v24H488 93.1l79 79 17 17-33.9 33.9-17-17L18.2 305l-17-17 17-17 120-120 17-17L189.1 168l-17 17-79 79H464V56z'
      
    ]
  };

  

  
  

  var faBorderNone = {
    prefix: 'fasr',
    iconName: 'border-none',
    icon: [
      448,
      512,
      [],
      'f850',
      
      'M0 416l0 64 64 0 0-64L0 416zm96 64l64 0 0-64-64 0 0 64zM96 96l64 0 0-64L96 32l0 64zm0 128l0 64 64 0 0-64-64 0zM288 480l64 0 0-64-64 0 0 64zm0-448l0 64 64 0 0-64-64 0zm0 256l64 0 0-64-64 0 0 64zM192 416l0 64 64 0 0-64-64 0zm0-320l64 0 0-64-64 0 0 64zm0 128l0 64 64 0 0-64-64 0zM384 480l64 0 0-64-64 0 0 64zm0-384l64 0 0-64-64 0 0 64zM0 32L0 96l64 0 0-64L0 32zM384 288l64 0 0-64-64 0 0 64zM0 224l0 64 64 0 0-64L0 224zM192 384l64 0 0-64-64 0 0 64zm192-64l0 64 64 0 0-64-64 0zM0 384l64 0 0-64L0 320l0 64zM384 128l0 64 64 0 0-64-64 0zM0 192l64 0 0-64L0 128l0 64zm192-64l0 64 64 0 0-64-64 0z'
      
    ]
  };

  

  
  

  var faCircleSmall = {
    prefix: 'fasr',
    iconName: 'circle-small',
    icon: [
      320,
      512,
      [],
      'e122',
      
      'M160 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faBottleBaby = {
    prefix: 'fasr',
    iconName: 'bottle-baby',
    icon: [
      512,
      512,
      [],
      'e673',
      
      'M192 96l0-32 32-16 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 32 16 0 32 32 0 0 48 21.8 21.8c27 27 42.2 63.6 42.2 101.8L416 464l0 48-48 0-224 0-48 0 0-48 0-196.4c0-38.2 15.2-74.8 42.2-101.8L160 144l0-48 32 0zM368 464l0-196.4c0-25.5-10.1-49.9-28.1-67.9l-7.8-7.8-152.2 0-7.8 7.8c-18 18-28.1 42.4-28.1 67.9l0 4.4 112 0 0 48-112 0 0 48 112 0 0 48-112 0 0 48 224 0z'
      
    ]
  };

  

  
  

  var faLitecoinSign = {
    prefix: 'fasr',
    iconName: 'litecoin-sign',
    icon: [
      384,
      512,
      [],
      'e1d3',
      
      'M112 56V32H64V56 220.5L17.8 232.8-5.4 239 7 285.4l23.2-6.2 33.8-9V456v24H88 360h24V432H360 112V257.4l158.2-42.2 23.2-6.2L281 162.6l-23.2 6.2L112 207.7V56z'
      
    ]
  };

  

  
  

  var faH6 = {
    prefix: 'fasr',
    iconName: 'h6',
    icon: [
      640,
      512,
      [],
      'e413',
      
      'M48 88V64H0V88 248 424v24H48V424 272H272V424v24h48V424 248 88 64H272V88 224H48V88zM387.2 195.5C364.4 224 352 259.5 352 296h.2c-.1 2.6-.2 5.3-.2 8c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-6.8 0-13.4 .5-20 1.4L553.9 64H492.5L387.2 195.5zM400 304a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faCircleY = {
    prefix: 'fasr',
    iconName: 'circle-y',
    icon: [
      512,
      512,
      [],
      'e12f',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 295.9V376v24h48V376 295.9L391.4 144H331.8L256 247.4 180.2 144H120.6L232 295.9z'
      
    ]
  };

  

  
  

  var faAppleCore = {
    prefix: 'fasr',
    iconName: 'apple-core',
    icon: [
      384,
      512,
      [],
      'e08f',
      
      'M176 96V80c0-44.2 35.8-80 80-80h16 16V16 32c0 44.2-35.8 80-80 80H192 176V96zM80 128l112 32 112-32c6.7 0 13 .6 19.1 1.9c18.4 3.7 33.9 12.7 46.7 25.4c-13.7 8.7-26.1 19.2-36.9 31.2C305 217.7 288 258.9 288 304c0 53.7 24.1 101.8 62 134.1c4.8 4.1 9.7 7.9 14.9 11.4c-10.3 13.5-21.8 25.2-34.1 34.7C307.7 502 281.8 512 256 512l-64-16-64 16c-25.8 0-51.7-10-74.8-27.9c-12.2-9.5-23.7-21.1-34.1-34.7c5.2-3.5 10.2-7.3 14.9-11.4C71.9 405.8 96 357.7 96 304c0-45.1-17-86.3-44.9-117.5c-10.8-12-23.2-22.6-36.9-31.2c12.8-12.7 28.4-21.7 46.7-25.4C67 128.6 73.3 128 80 128zm125.2 78.2L192 209.9l-13.2-3.8-67.9-19.4C131.9 220.8 144 261 144 304c0 56.2-20.7 107.6-54.9 146.9c12 7.8 23.6 11.9 33.9 12.9l57.3-14.3 11.6-2.9 11.6 2.9 57.3 14.3c10.3-1 22-5 33.9-12.9C260.7 411.6 240 360.2 240 304c0-43 12.1-83.2 33.1-117.3l-67.9 19.4z'
      
    ]
  };

  

  
  

  var faArrowUp91 = {
    prefix: 'fasr',
    iconName: 'arrow-up-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-up-alt"],
      'f887',
      
      'M464 120a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm48 0c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 45 33.7 82.1 77.3 87.4l-24.8 34.7-10 13.9h59l56.1-78.5c12-16.8 18.4-36.9 18.4-57.5zM160 33.3l-17 17-96 96-17 17L64 197.1l17-17 55-55V456v24h48V456 125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM360 288v48h24 24v96H384 360v48h24 48 48 24V432H480 456V312 288H432 384 360z'
      
    ]
  };

  
    var faSortNumericUpAlt = faArrowUp91;
  

  
  

  var faPersonPinball = {
    prefix: 'fasr',
    iconName: 'person-pinball',
    icon: [
      640,
      512,
      [],
      'e21d',
      
      'M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM24 128H0v24V274c0 15.6 6.5 30.4 17.9 41L112 402.5V488v24h48V488 392 381.5l-7.7-7.1-32.3-30v-88l11.2 19.5 6.9 12.1H152h40v88V488v24h48V488 400H592v88 24h48V488 376 228.8 208 179.3 24 0H616 504 480V24 72v4.5l1.6 4.2 46.2 118.8L256 248.4V240H232 165.9l-57.1-99.9L101.9 128H88 24zm48 48V299.8L50.6 279.9c-1.6-1.5-2.6-3.6-2.6-5.9V176H72zM592 352H240V300.1l32.1-5.8c0 .6-.1 1.1-.1 1.7c0 13.3 10.7 24 24 24s24-10.7 24-24c0-3.5-.8-6.9-2.2-9.9L592 236.7V352zM48 386.7L0 342.1 0 488l0 24 48 0 0-24 0-101.3zM528 67.5V48h64V187.2l-16.5 2.4L528 67.5z'
      
    ]
  };

  

  
  

  var faLungs = {
    prefix: 'fasr',
    iconName: 'lungs',
    icon: [
      640,
      512,
      [129729],
      'f604',
      
      'M344 195.6l40 28.6V184.7 176 144 96h48 56c26.9 35.8 51.5 73.2 73.8 112.1C597.7 271.1 640 348.4 640 423c0 49.1-39.8 89-89 89c-38.2 0-78.8-12.6-117.7-24.7C416.5 482.1 399.9 477 384 473V322.5l48 34.3v79.9c6.1 1.8 12.1 3.7 18.1 5.6c10.7 3.3 21 6.5 29.9 9c27.3 7.8 50.6 12.7 71.1 12.7c22.6 0 41-18.3 41-41c0-59.7-34.7-126-71.9-191.1c-17.3-30.3-36.1-59.6-56.4-87.9H432v32 43.2 39.3l69.9 50 19.5 13.9-27.9 39.1-19.5-13.9-42.1-30-48-34.3-64-45.7-64 45.7-48 34.3-42.1 30-19.5 13.9-27.9-39.1 19.5-13.9 69.9-50V219.2 176 144H176.3c-20.3 28.4-39.1 57.7-56.4 87.9C82.7 297 48 363.3 48 423c0 22.6 18.3 41 41 41c20.5 0 43.8-4.9 71.1-12.7c8.9-2.6 19.1-5.7 29.9-9c5.9-1.8 12-3.7 18.1-5.6V356.8l48-34.3V473c-15.9 4-32.4 9.1-49.3 14.3C167.8 499.4 127.2 512 89 512c-49.1 0-89-39.8-89-89c0-74.6 42.3-152 78.2-214.9C100.5 169.2 125.1 131.8 152 96h56 48v48 32 8.7 39.5l40-28.6V24 0h48V24 195.6z'
      
    ]
  };

  

  
  

  var faRibbon = {
    prefix: 'fasr',
    iconName: 'ribbon',
    icon: [
      448,
      512,
      [127895],
      'f4d6',
      
      'M352 142.9l-11.8-17.2-16.5 18.4-45.9 51-32.3-35.9L288 112 224 48l-64 64L415.7 396.1 448 432l-39.3 28.1L336 512 48 192V128L136 0h40 48 48 40l88 128v64l-62.5 69.4-32.3-35.9 46.8-52V142.9zM142.8 345.1l-71.1 79L105 448l65.2-72.4 32.3 35.9L112 512 39.3 460.1 0 432l32.3-35.9 78.2-86.8 32.3 35.9zM96 142.9v30.7L343 448l33.4-23.8L124.3 144.1l-16.5-18.4L96 142.9z'
      
    ]
  };

  

  
  

  var faLockA = {
    prefix: 'fasr',
    iconName: 'lock-a',
    icon: [
      448,
      512,
      [],
      'e422',
      
      'M224 48c44.2 0 80 35.8 80 80v32H144V128c0-44.2 35.8-80 80-80zM96 128v32H48 0v48V464v48H48 400h48V464 208 160H400 352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM48 208H96h48H304h48 48V464H48V208zM283.1 440H336L250.4 254.6l-1.8-3.8L240 232H208l-8.7 18.8-1.8 3.8L112 440h52.9l18.5-40h81.3l18.5 40zM224 311.9L242.5 352h-37L224 311.9z'
      
    ]
  };

  

  
  

  var faArrowRightToCity = {
    prefix: 'fasr',
    iconName: 'arrow-right-to-city',
    icon: [
      640,
      512,
      [],
      'e4b3',
      
      'M312 0H288V24 488v24h48V488 48H464V216v24h24 56 48V488v24h48V488 216 192H616 592V120 96H544v24 72H512V24 0H488 312zm56 80v64h64V80H368zm64 96H368v64h64V176zm-64 96v64h64V272H368zm192 0H496v64h64V272zm-64 96v64h64V368H496zM144.1 158.2l-17.8-16.1L94.1 177.6l17.8 16.1L153.9 232H24 0v48H24 153.9l-42.1 38.2L94.1 334.4l32.3 35.5 17.8-16.1 88-80L251.7 256l-19.5-17.8-88-80z'
      
    ]
  };

  

  
  

  var faChartLineDown = {
    prefix: 'fasr',
    iconName: 'chart-line-down',
    icon: [
      512,
      512,
      [128201],
      'f64d',
      
      'M48 56V32H0V56 456v24H24 488h24V432H488 48V56zM344 320H456h24V296 184 160H432v24 54.1L321 127l-17-17-17 17-79 79-63-63-17-17L94.1 160l17 17 80 80 17 17 17-17 79-79L398.1 272H344 320v48h24z'
      
    ]
  };

  

  
  

  var faPaperclip = {
    prefix: 'fasr',
    iconName: 'paperclip',
    icon: [
      448,
      512,
      [128206],
      'f0c6',
      
      'M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271l17-17L449.9 288l-17 17L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.2-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127l17-17L321.9 144l-17 17L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z'
      
    ]
  };

  

  
  

  var faBinRecycle = {
    prefix: 'fasr',
    iconName: 'bin-recycle',
    icon: [
      576,
      512,
      [],
      'e5f7',
      
      'M0 32H32 80.1 495.9 544h32V80H540.6L512 480H64L35.4 80H0V32zM83.6 80l25.1 352H467.3L492.4 80H83.6zM288 176c-2.2 0-4.3 1.1-5.5 2.9l-33.8 48.3-40.8-25.5 35.2-50.3c10.2-14.6 27-23.3 44.8-23.3s34.6 8.7 44.8 23.3l35.2 50.3-40.8 25.5-33.8-48.3c-1.3-1.8-3.3-2.9-5.5-2.9zM180.4 241l40.8 25.5-36 51.4c-.8 1.1-1.2 2.4-1.2 3.7c0 3.5 2.9 6.4 6.4 6.4H264v48H190.4c-30.1 0-54.4-24.4-54.4-54.4c0-11.2 3.4-22.1 9.8-31.2L180.4 241zM312 376V328h73.6c3.5 0 6.4-2.9 6.4-6.4c0-1.3-.4-2.6-1.2-3.7l-36-51.4L395.6 241l34.5 49.3c6.4 9.1 9.8 20 9.8 31.2c0 30.1-24.4 54.4-54.4 54.4H312z'
      
    ]
  };

  

  
  

  var faAnglesUp = {
    prefix: 'fasr',
    iconName: 'angles-up',
    icon: [
      448,
      512,
      ["angle-double-up"],
      'f102',
      
      'M241 47l-17-17L207 47 47 207l-17 17L64 257.9l17-17 143-143L367 241l17 17L417.9 224l-17-17L241 47zm0 192l-17-17-17 17L47 399l-17 17L64 449.9l17-17 143-143L367 433l17 17L417.9 416l-17-17L241 239z'
      
    ]
  };

  
    var faAngleDoubleUp = faAnglesUp;
  

  
  

  var faFaceTissue = {
    prefix: 'fasr',
    iconName: 'face-tissue',
    icon: [
      512,
      512,
      [],
      'e39c',
      
      'M464 256c0 114.9-93.1 208-208 208c-13 0-25.6-1.2-37.9-3.4l-8.7 47.2c15.1 2.8 30.7 4.2 46.7 4.2c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 15.9 1.5 31.5 4.2 46.7l47.2-8.7C49.2 281.6 48 269 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208zM241 386.7l15 12 15-12 26.3-21L330.7 388l16.4 10.9L361 385l24-24 17-17L368 310.1l-17 17-10.1 10.1L309.3 316l-14.6-9.7-13.7 11-25 20-13.1-10.5-9.9 53.5 8.1 6.5zM112 128l45.7 64L112 256l118.9-64L112 128zm169.1 64L400 256l-45.7-64L400 128 281.1 192zM216 296L0 336l64 48L32 480l96-32 48 64 40-216z'
      
    ]
  };

  

  
  

  var faDollyEmpty = {
    prefix: 'fasr',
    iconName: 'dolly-empty',
    icon: [
      576,
      512,
      [],
      'f473',
      
      'M0 0H24 128c10.4 0 19.6 6.7 22.8 16.6L250 320.2c2-.1 4-.2 6-.2c33.2 0 62.5 16.9 79.8 42.5L544 289.4l22.6-8 15.9 45.3-22.6 8L351.7 407.8c.2 2.7 .3 5.4 .3 8.2c0 53-43 96-96 96s-96-43-96-96c0-34 17.7-63.9 44.3-80.9L110.6 48H24 0V0zM304 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faEnvelope = {
    prefix: 'fasr',
    iconName: 'envelope',
    icon: [
      512,
      512,
      [9993,61443,128386],
      'f0e0',
      
      'M48 150.8l208 143 208-143V112H48v38.8zM464 209L256 352 48 209V400H464V209zM0 400V176 112 64H48 464h48v48 64V400v48H464 48 0V400z'
      
    ]
  };

  

  
  

  var faTruckLadder = {
    prefix: 'fasr',
    iconName: 'truck-ladder',
    icon: [
      640,
      512,
      [],
      'e657',
      
      'M0 0V48H32v96H0v48H352V144H320V48h32V0H0zM272 144H240V48h32v96zM160 48h32v96H160V48zm-48 96H80V48h32v96zM408 96H384v24V224H24 0v24V392v24H24 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h40 24V392 240v-8.4l-5.3-6.6-96-120-7.2-9H520 408zM76.8 368H48V272H384h48H592v96H563.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48zM432 224V144h76.5l64 80H432zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faHeadSide = {
    prefix: 'fasr',
    iconName: 'head-side',
    icon: [
      512,
      512,
      [],
      'f6e9',
      
      'M112 361.7v19.6V448v16 48H96 64V480 464 381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1V264v24 16 32H496 480 464 448v48 16 16 32H416 400 368 320v16 16 16 16H288 272V464 448 400h48 80V336 288h48 16V270.1l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48H224C126.8 48 48 127 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM336 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faCakeCandles = {
    prefix: 'fasr',
    iconName: 'cake-candles',
    icon: [
      448,
      512,
      [127874,"birthday-cake","cake"],
      'f1fd',
      
      'M63.9 44.9C58.8 52.1 56 60.8 56 69.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.6c0-8.8-2.8-17.5-7.9-24.6L96 0 63.9 44.9zM120 168V144H72v24 56H48 0v48V464v48H48 400h48V464 272 224H400 376V168 144H328v24 56H248V168 144H200v24 56H120V168zM48 340.3V272H400v68.3l-37.7-17.9-10.6-5-10.5 5.2L288 349.2l-53.3-26.6L224 317.2l-10.7 5.4L160 349.2l-53.3-26.6-10.5-5.2-10.6 5L48 340.3zm0 53.2l47.7-22.7 53.5 26.8 10.7 5.4 10.7-5.4L224 370.8l53.3 26.6 10.7 5.4 10.7-5.4 53.5-26.8L400 393.4V464H48V393.4zM224 0L191.9 44.9c-5.1 7.2-7.9 15.8-7.9 24.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.6c0-8.8-2.8-17.5-7.9-24.6L224 0zm95.9 44.9c-5.1 7.2-7.9 15.8-7.9 24.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.6c0-8.8-2.8-17.5-7.9-24.6L352 0 319.9 44.9z'
      
    ]
  };

  
    var faBirthdayCake = faCakeCandles;
  
    var faCake = faCakeCandles;
  

  
  

  var faSquare1 = {
    prefix: 'fasr',
    iconName: 'square-1',
    icon: [
      448,
      512,
      [],
      'e256',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zm96 304v48h24 56 56 24V336H280 248V152 128H224h-8-6.2l-5.4 3L144 164.5v54.9l11.7-6.5L200 188.3V336H168 144z'
      
    ]
  };

  

  
  

  var faComment = {
    prefix: 'fasr',
    iconName: 'comment',
    icon: [
      512,
      512,
      [61669,128489],
      'f075',
      
      'M112.7 358.8l-10.8 28.9-7 18.5 57.6-17.3 13.9-4.2 13.9 4.2c23.3 7.1 48.8 11 75.7 11c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 35.1 15 68.9 42.9 96.9l21.8 21.9zm-39 103.9L16 480l21.2-56.5 19.8-52.7C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L73.8 462.7z'
      
    ]
  };

  

  
  

  var faEllipsisStrokeVertical = {
    prefix: 'fasr',
    iconName: 'ellipsis-stroke-vertical',
    icon: [
      192,
      512,
      ["ellipsis-v-alt"],
      'f39c',
      
      'M120 72l0 48-48 0 0-48 48 0zM72 32L32 32l0 40 0 48 0 40H72h48l40 0V120 72 32l-40 0L72 32zm48 200l0 48H72l0-48h48zM72 192H32l0 40 0 48 0 40H72h48 40V280l0-48V192l-40 0H72zm0 200h48l0 48H72V392zM32 352l0 40 0 48 0 40H72h48 40V440 392 352H120 72 32z'
      
    ]
  };

  
    var faEllipsisVAlt = faEllipsisStrokeVertical;
  

  
  

  var faBracketsCurly = {
    prefix: 'fasr',
    iconName: 'brackets-curly',
    icon: [
      576,
      512,
      [],
      'f7ea',
      
      'M64 32H88 200h24V80H200 112V192v9.9l-7 7-47 47 47 47 7 7V320 432h88 24v48H200 88 64V456 329.9L7 273l-7-7V246.1l7-7 57-57V56 32zm448 0V56 182.1l57 57 7 7v19.9l-7 7-57 57V456v24H488 376 352V432h24 88V320v-9.9l7-7 47-47-47-47-7-7V192 80H376 352V32h24H488h24z'
      
    ]
  };

  

  
  

  var faCircleYen = {
    prefix: 'fasr',
    iconName: 'circle-yen',
    icon: [
      512,
      512,
      [],
      'e5d0',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM137.5 144h61L256 217.2 313.5 144h61l-11.7 14.8L286.5 256H320h16v32H320 280v32h40 16v32H320 280v25 24H232V377 352H192 176V320h16 40V288H192 176V256h16 33.5l-76.3-97.2L137.5 144z'
      
    ]
  };

  

  
  

  var faCoffeeBean = {
    prefix: 'fasr',
    iconName: 'coffee-bean',
    icon: [
      448,
      512,
      [],
      'e13e',
      
      'M380.3 125.1l-38.8 77.6-2.9 5.7-5.3 3.5L146.2 336.7l-44.3 80.5c22 11.1 49.7 15.2 81.3 10.7c45.5-6.5 96.1-30.9 138.9-73.8s67.3-93.4 73.8-138.9c5.1-36-1-66.9-15.7-90.1zM343.5 91.2c-22.3-11.8-50.7-16.4-83.4-11.7c-45.5 6.5-96.1 30.9-138.9 73.8S54 246.7 47.5 292.2c-5.3 37.4 1.4 69.3 17.4 92.8L107 308.4l2.8-5.1 4.9-3.3L301.4 175.6l42.2-84.3zm57.4-16.7c74.2 74.2 54.2 214.6-44.8 313.6s-239.4 119-313.6 44.8s-54.2-214.6 44.8-313.6s239.4-119 313.6-44.8z'
      
    ]
  };

  

  
  

  var faInboxes = {
    prefix: 'fasr',
    iconName: 'inboxes',
    icon: [
      512,
      512,
      [],
      'e1bb',
      
      'M62.5 96H160l32 64H320l32-64h97.5l-40-48h-307l-40 48zM512 96v48 96 48H464 48 0V240 144 96L80 0H432l80 96zm-48 48H381.7l-18.7 37.5L349.7 208H320 192 162.3l-13.3-26.5L130.3 144H48v96H464V144zM192 384H320l32-64H464h48v48 96 48H464 48 0V464 368 320H48 160l32 64zm189.7-16l-18.7 37.5L349.7 432H320 192 162.3l-13.3-26.5L130.3 368H48v96H464V368H381.7z'
      
    ]
  };

  

  
  

  var faBookSection = {
    prefix: 'fasr',
    iconName: 'book-section',
    icon: [
      448,
      512,
      ["book-law"],
      'e0c1',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zM231.7 248l-7-1.8c-20.7-5.5-63.7-17-55.7-58.8c2-10.5 7.5-19.2 15.6-25.8c-11.5-8.8-19.4-21.7-15.6-41.7c5.7-29.8 37.9-45 82-38.7c7.8 1.1 16.8 3.3 28.3 6.9l-8.9 28.6c-9.9-3.1-17.5-4.9-23.6-5.8c-26.1-3.8-46 2.3-48.4 14.7c-1.7 8.7-.2 15.1 34 24.1l6.8 1.8 0 0c28.2 7.3 70.9 18.3 62.8 60.6c-2 10.5-7.5 19.2-15.6 25.9c11.8 8.9 19.4 21.7 15.6 41.6c-4.8 25.3-28.9 40.2-63.1 40.2c-6 0-12.3-.5-18.9-1.4c-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8 9.1-28.6 5.5 1.8c10.1 3.3 21.5 7 31 8.3c26.3 3.7 46.1-2.3 48.4-14.7c2.3-11.9-5.4-16.8-40.9-26zm0-67.5s-8.8-2.3-9.7-2.6c-8.1 1.1-21.6 4.5-23.6 15.1c-1.7 8.7-.2 15.1 34 24.1c0 0 13.2 3.5 16.6 4.4c8.2-1.1 21.6-4.5 23.6-15c2.3-11.9-5.4-16.8-40.9-26z'
      
    ]
  };

  
    var faBookLaw = faBookSection;
  

  
  

  var faStretcher = {
    prefix: 'fasr',
    iconName: 'stretcher',
    icon: [
      640,
      512,
      [],
      'f825',
      
      'M52.8 79.7L36.5 62.1 1.3 94.7l16.3 17.6 140.8 152 7.1 7.7H176 616h24V224H616 186.5L52.8 79.7zM241.2 304l86 62.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24.1 3.5-33.9 9.7l-37.3-27.1 86-62.5H413.2L368 336.9 322.8 304H241.2zM240 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faTag = {
    prefix: 'fasr',
    iconName: 'tag',
    icon: [
      448,
      512,
      [127991],
      'f02b',
      
      'M224 412.1L48 236.1V80H204.1l176 176L224 412.1zM414.1 222.1L224 32H48 0V80 256L190.1 446.1 224 480l33.9-33.9L414.1 289.9 448 256l-33.9-33.9zM112 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faSteeringWheel = {
    prefix: 'fasr',
    iconName: 'steering-wheel',
    icon: [
      512,
      512,
      [],
      'f622',
      
      'M232 369.1v93.5C133.7 451.3 56.2 371.4 48.6 272H156.4L232 369.1zm48 0L355.6 272H463.4c-7.6 99.4-85 179.3-183.4 190.6V369.1zM352 224l-16-32H176l-16 32H50.4C65.8 124.3 152 48 256 48s190.2 76.3 205.6 176H352zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faPlaneLock = {
    prefix: 'fasr',
    iconName: 'plane-lock',
    icon: [
      640,
      512,
      [],
      'e558',
      
      'M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106v51.5l96.7 55.3c-8.5 13.7-14.1 29.3-16 46.1L300.1 192.3 288 185.4V171.4 106c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8 .2-6.7 3.3c-3.9 3.1-8.2 8.1-12.3 14.9c-8.5 14-13 30.2-13 39.7v65.5 13.9l-12.1 6.9L48 285.9v34.3l145.4-41.5 30.6-8.7v31.8l0 66.3v12l-9.6 7.2L160 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2L352 460.4V428l-54.4-40.8L288 380V368 301.7 269.9l30.6 8.7L384 297.3l0 49.9-48-13.7V356l48 36 0 120h-8H360h-3.6l-3.4-1.1L256 481.1l-96.9 29.8-3.4 1.1H152 136 112V488 416 404l9.6-7.2L176 356l0-22.5L30.6 375.1 0 383.8V352 272 258.1l12.1-6.9L176 157.5V106c0-20.3 8.1-45.1 20-64.6c6.1-10 13.8-19.9 23.3-27.5zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H416V320h32V272z'
      
    ]
  };

  

  
  

  var faTruckFire = {
    prefix: 'fasr',
    iconName: 'truck-fire',
    icon: [
      640,
      512,
      [],
      'e65a',
      
      'M640 0H0V48H32V96H0v48V368v48H48 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h16 48V368 144 96H592 544c0-17.7-14.3-32-32-32s-32 14.3-32 32H384V48H640V0zM336 48V96H280V48h56zm0 96h48v80H48V144H336zM48 368V272H408h24V248 144H592V368H563.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H48zM232 48V96H184V48h48zm-96 0V96H80V48h56zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm80-192H464v96h96V176z'
      
    ]
  };

  

  
  

  var faSatellite = {
    prefix: 'fasr',
    iconName: 'satellite',
    icon: [
      512,
      512,
      [128752],
      'f7bf',
      
      'M401.9 398.1L368 432l-33.9-33.9-35.5-35.5c6 36.5 .8 74.5-15.6 108.6c-7 14.5-16 28.2-27 40.9l-34-34-77-77L81 465 47 431l64-64L34 290 0 256c12.6-11 26.4-20.1 40.9-27c34.1-16.4 72.1-21.5 108.6-15.6l-35.5-35.5L80 144l33.9-33.9 76.1-76.1L224 0l33.9 33.9L304 80l30.1-30.1L368 16l33.9 33.9 60.1 60.1L496 144l-33.9 33.9L432 208l46.1 46.1L512 288l-33.9 33.9-76.1 76.1zm-3.9-156.1l-76.1 76.1L368 364.1 444.1 288l-46.1-46.1zm-128-128L224 67.9 147.9 144l46.1 46.1 76.1-76.1zM368 83.9L214.4 237.5c12 7.3 23.3 16.2 33.6 26.5s19.2 21.6 26.5 33.6L428.1 144 368 83.9zM246.2 434.3c15.4-46.6 4.4-99.8-32.2-136.4s-89.8-47.6-136.4-32.2L246.2 434.3z'
      
    ]
  };

  

  
  

  var faChessClockFlip = {
    prefix: 'fasr',
    iconName: 'chess-clock-flip',
    icon: [
      640,
      512,
      ["chess-clock-alt"],
      'f43e',
      
      'M384 32H544V80H488v32H592h48v48V432v48H592 48 0V432 160 112H48 96V80H256v32H440V80H384V32zM48 160V432H592V160H48zm392 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm16 48V224H424v16 48 16h32V288 240zM126.5 222.5A104 104 0 1 1 273.5 369.5 104 104 0 1 1 126.5 222.5zm135.8 33.9l-22.6-22.6-11.3 11.3L194.3 279 183 290.3 205.7 313 217 301.7l33.9-33.9 11.3-11.3z'
      
    ]
  };

  
    var faChessClockAlt = faChessClockFlip;
  

  
  

  var faFilePlusMinus = {
    prefix: 'fasr',
    iconName: 'file-plus-minus',
    icon: [
      384,
      512,
      [],
      'e177',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM216 200V176H168v24 40H128 104v48h24 40v40 24h48V328 288h40 24V240H256 216V200zM128 384H104v48h24H256h24V384H256 128z'
      
    ]
  };

  

  
  

  var faUserVisor = {
    prefix: 'fasr',
    iconName: 'user-visor',
    icon: [
      448,
      512,
      [],
      'e04c',
      
      'M224 208c26.2 0 49.4-12.6 64-32H160c14.6 19.4 37.8 32 64 32zm0 48c-53.7 0-99.7-33.1-118.7-80H80V48h44.1C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48H368V176H342.7c-19 46.9-65 80-118.7 80zM128 96v32h16H304h16V96H304 144 128zM65 464H383L348.5 352H99.5L65 464zM64 304H384l49.2 160L448 512H397.8 50.2 0l14.8-48L64 304zM286.7 448l-6.7-6.7L313.3 368l33.3 73.3L340 448l-20-20-33.3 20z'
      
    ]
  };

  

  
  

  var faLiraSign = {
    prefix: 'fasr',
    iconName: 'lira-sign',
    icon: [
      320,
      512,
      [8356],
      'f195',
      
      'M96 158c0-43.1 34.9-78 78-78c9.1 0 18.1 1.6 26.7 4.7l71.1 25.9 22.6 8.2 16.4-45.1-22.6-8.2L217.1 39.6c-13.8-5-28.4-7.6-43.1-7.6C104.4 32 48 88.4 48 158v34H0v48H48v48H0v48H43L1.7 439.1 0 443.4V448v8 24H24 296h24V432H296 56.2l38-95.1 .4-.9H256V288H96V240H256V192H96V158z'
      
    ]
  };

  

  
  

  var faChild = {
    prefix: 'fasr',
    iconName: 'child',
    icon: [
      320,
      512,
      [],
      'f1ae',
      
      'M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-96a72 72 0 1 1 0 144A72 72 0 1 1 160 0zM88.9 160h13.6H216h13.4l7 11.4 68.8 112 12.6 20.4L276.9 329l-12.6-20.4L240 268.9V488v24H192V488 384H128V488v24H80V488 268L55.8 308.4 43.4 328.9 2.3 304.2l12.4-20.6 67.3-112 7-11.6zM128 336h64V208H128V336z'
      
    ]
  };

  

  
  

  var faWashingMachine = {
    prefix: 'fasr',
    iconName: 'washing-machine',
    icon: [
      448,
      512,
      ["washer"],
      'f898',
      
      'M48 48V464H400V48H48zM0 0H48 400h48V48 464v48H400 48 0V464 48 0zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM144 256c32 0 56 16 80 32s48 32 80 32c3.6 0 7.1-.1 10.6-.3c3.5-9.9 5.4-20.6 5.4-31.7c0-53-43-96-96-96c-42 0-77.6 26.9-90.7 64.4c3.6-.3 7.2-.4 10.7-.4zm80-112a144 144 0 1 1 0 288 144 144 0 1 1 0-288z'
      
    ]
  };

  
    var faWasher = faWashingMachine;
  

  
  

  var faBookSparkles = {
    prefix: 'fasr',
    iconName: 'book-sparkles',
    icon: [
      448,
      512,
      ["book-spells"],
      'f6b8',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM48 432c0 17.7 14.3 32 32 32H368V400H80c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zM160 112l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16zM264 216l24-56 24 56 56 24-56 24-24 56-24-56-56-24 56-24z'
      
    ]
  };

  
    var faBookSpells = faBookSparkles;
  

  
  

  var faSquareArrowDownRight = {
    prefix: 'fasr',
    iconName: 'square-arrow-down-right',
    icon: [
      448,
      512,
      [],
      'e262',
      
      'M400 432V80H48V432H400zm48 48H400 48 0V432 80 32H48 400h48V80 432v48zM312 368H160 136V320h24 94.1L119 185l-17-17L136 134.1l17 17 135 135V184 160h48v24V344v24H312z'
      
    ]
  };

  

  
  

  var faFilmSlash = {
    prefix: 'fasr',
    iconName: 'film-slash',
    icon: [
      640,
      512,
      [],
      'e179',
      
      'M29.4 .1l19 14.7L70.5 32H112 528h48V80 424.4l44.9 34.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1zM176 113.9V80H132.4L176 113.9zM328.2 232H416V192 80H224v71.1L328.2 232zM528 387.2V344H472.4L528 387.2zM416 423.8L487.4 480H112 64V432 146.4L152.3 216H112v80h64V234.7L233.5 280H224v40V432H416v-8.2zM176 344H112v88h64V344zM464 80v88h64V80H464zm64 136H464v80h64V216z'
      
    ]
  };

  

  
  

  var faBusSchool = {
    prefix: 'fasr',
    iconName: 'bus-school',
    icon: [
      512,
      512,
      [],
      'f5dd',
      
      'M96 96h80V80l160 0V96h80V94c-11.6-14.2-51.7-46-160-46c-55.9 0-95.6 9.9-122 21.5c-21.1 9.2-32.7 19-38 24.8V96zm0 48v80H232V144H96zm320 80V144H280v80H416zM464 86.6V128h48V256H496V424v24H472 448v40 24H400V488 448H112v40 24H64V488 448H40 16V424 256H0V128H48V86.6 80.4l3.1-5.5c9.4-16.7 31.2-35.2 63.7-49.4C148 10.9 194.5 0 256 0C386.6 0 443.3 43.4 460.9 74.9l3.1 5.5v6.3zM64 400h48H400h48V272H416 96 64V400zm48-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faClipboardUser = {
    prefix: 'fasr',
    iconName: 'clipboard-user',
    icon: [
      384,
      512,
      [],
      'f7f3',
      
      'M336 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H80 48 0v48V464v48H48 336h48V464 112 64H336zM80 112v48H192 304V112h32V464H298.7L272 384H112L85.3 464H48V112H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faFaceFearful = {
    prefix: 'fasr',
    iconName: 'face-fearful',
    icon: [
      512,
      512,
      [],
      'e375',
      
      'M464 256c0-43.5-13.3-83.9-36.2-117.2l-11.1 11.8-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9H320V80h16c5.8 0 11.6 .4 17.2 1.1c8 1.1 15.7 2.8 23.2 5.2C342.4 62.2 300.9 48 256 48s-86.4 14.2-120.4 38.4c7.5-2.4 15.2-4.2 23.2-5.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H176c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8L95.2 150.6 84.2 138.8C61.3 172.1 48 212.5 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 64c44.2 0 80 35.8 80 80v16H176V400c0-44.2 35.8-80 80-80zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48A80 80 0 1 1 80 224a80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  

  
  

  var faLocationExclamation = {
    prefix: 'fasr',
    iconName: 'location-exclamation',
    icon: [
      384,
      512,
      ["map-marker-exclamation"],
      'f608',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zM216 96v24V232v24H168V232 120 96h48zM168 336V288h48v48H168z'
      
    ]
  };

  
    var faMapMarkerExclamation = faLocationExclamation;
  

  
  

  var faTableRows = {
    prefix: 'fasr',
    iconName: 'table-rows',
    icon: [
      512,
      512,
      ["rows"],
      'e292',
      
      'M464 432l-336 0 0-152 336 0 0 152zm0-200l-336 0 0-152 336 0 0 152zM0 432l0 48 48 0 416 0 48 0 0-48 0-352 0-48-48 0L48 32 0 32 0 80 0 432z'
      
    ]
  };

  
    var faRows = faTableRows;
  

  
  

  var faHatCowboySide = {
    prefix: 'fasr',
    iconName: 'hat-cowboy-side',
    icon: [
      640,
      512,
      [],
      'f8c1',
      
      'M202.9 121.5l-9.6 71.9c31.6 4 61.6 16.8 86.5 37L311.3 256H442.2L409.7 87 202.9 121.5zM560 400c17.7 0 32-14.3 32-32c0-35.1-28.4-66.8-65.6-92.2c-12.3-8.4-24.7-15.5-35.6-21.2l28 145.4H560zM448 32l31.6 164.4 .1 0c4.5 1.9 10.8 4.6 18.3 8.1c15 7.1 35.2 17.7 55.5 31.6C592.4 262.8 640 307.1 640 368c0 44.2-35.8 80-80 80H480 464 24 0V424 363.6C0 277.9 62.8 207 144.8 194.1L160 80 448 32zM48 363.6V400H412.4L249.5 267.7c-22-17.9-49.6-27.7-77.9-27.7C103.3 240 48 295.3 48 363.6z'
      
    ]
  };

  

  
  

  var faDiscDrive = {
    prefix: 'fasr',
    iconName: 'disc-drive',
    icon: [
      512,
      512,
      [],
      'f8b5',
      
      'M56 32H32V56 432H24 0v48H24 56 456h32 24V432H488h-8V56 32H456 56zM432 80V432H80V80H432zM400 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-176 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faPhoneVolume = {
    prefix: 'fasr',
    iconName: 'phone-volume',
    icon: [
      512,
      512,
      ["volume-control-phone"],
      'f2a0',
      
      'M272.4 369.2l31.9 18.4 26-26 33.2-33.2L457.7 366l-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM256 48c114.9 0 208 93.1 208 208h48C512 114.6 397.4 0 256 0V48zm32 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0h48c0-88.4-71.6-160-160-160v48c61.9 0 112 50.1 112 112z'
      
    ]
  };

  
    var faVolumeControlPhone = faPhoneVolume;
  

  
  

  var faSealQuestion = {
    prefix: 'fasr',
    iconName: 'seal-question',
    icon: [
      512,
      512,
      [],
      'e243',
      
      'M289.9 33.9l33 33 66 0 48 0 0 48 0 66 41 41L512 256l-33.9 33.9-41 41 0 66 0 48-48 0-66 0-33 33L256 512l-33.9-33.9-33-33-66 0-48 0 0-48 0-66-41-41L0 256l33.9-33.9 41-41 0-66 0-48 48 0 66 0 33-33L256 0l33.9 33.9zm33 81l-19.9 0L289 100.9l-33-33-33 33L208.9 115 189 115l-66 0 0 66 0 19.9L108.9 215l-41 41 41 41L123 311.1l0 19.9 0 66 66 0 19.9 0L223 411.1l33 33 33-33L303.1 397l19.9 0 66 0 0-66 0-19.9L403.1 297l41-41-41-41L389 200.9l0-19.9 0-66-66 0zM168 184c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1l0 24-4.7 0c-5.2 12.8-14.6 23.7-27 30.8L280 264.4l0 7.6 0 24-48 0 0-24 0-21.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L224 176c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 152l48 0 0 48-48 0 0-48z'
      
    ]
  };

  

  
  

  var faSolarSystem = {
    prefix: 'fasr',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M464 256c0 42.1-12.5 81.3-34 114.1c-4.4-1.3-9.1-2.1-14-2.1c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c14.2 9 25.3 22.3 31.6 38C196.5 54.6 225.5 48 256 48c114.9 0 208 93.1 208 208zM256 464C141.1 464 48 370.9 48 256c0-42.1 12.5-81.3 34-114.1c4.4 1.3 9.1 2.1 14 2.1c26.5 0 48-21.5 48-48s-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-14.1-9.1-25.1-22.4-31.3-38.2c-26.1 11.8-55 18.3-85.5 18.3zm96-264c.3 0 .7 0 1 0c9.5 16.5 15 35.6 15 56c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c20.4 0 39.5 5.5 56 15c0 .3 0 .7 0 1c0 22.1 17.9 40 40 40zm64 56c0-31.8-9.3-61.3-25.2-86.2c.8-3.1 1.2-6.4 1.2-9.8c0-22.1-17.9-40-40-40c-3.4 0-6.6 .4-9.8 1.2C317.3 105.2 287.8 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160zM256 336l33.9-33.9 12.1-12.1L336 256l-33.9-33.9-12.1-12.1L256 176l-33.9 33.9-12.1 12.1L176 256l33.9 33.9 12.1 12.1L256 336zm0-67.9L243.9 256 256 243.9 268.1 256 256 268.1z'
      
    ]
  };

  

  
  

  var faBookTanakh = {
    prefix: 'fasr',
    iconName: 'book-tanakh',
    icon: [
      448,
      512,
      ["tanakh"],
      'f827',
      
      'M448 88c0-48.6-39.4-88-88-88H24 0V24 376v24H24h8v64H24 0v48H24 368c44.2 0 80-35.8 80-80c0-2.7-.1-5.4-.4-8h.4V88zM368 400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80V400H368zm32-41.3c-9.8-4.3-20.6-6.7-32-6.7H48V48H360c22.1 0 40 17.9 40 40V358.7zM216 56L202.1 80l-27.7 48H119 91.3l13.9 24 27.7 48-27.7 48L91.3 272H119h55.4l27.7 48L216 344l13.9-24 27.7-48H313h27.7l-13.9-24-27.7-48 27.7-48 13.9-24H313 257.6L229.9 80 216 56zM146.7 176l-13.9-24h27.7l-13.9 24zm41.6-24h55.4l27.7 48-27.7 48H188.3l-27.7-48 27.7-48zm-55.4 96l13.9-24 13.9 24H132.9zM216 296l-13.9-24h27.7L216 296zm83.1-48H271.4l13.9-24 13.9 24zm0-96l-13.9 24-13.9-24h27.7zm-97-24L216 104l13.9 24H202.1z'
      
    ]
  };

  
    var faTanakh = faBookTanakh;
  

  
  

  var faTableCellsLarge = {
    prefix: 'fasr',
    iconName: 'table-cells-large',
    icon: [
      512,
      512,
      ["th-large"],
      'f009',
      
      'M280 80V232H464V80H280zm-48 0H48V232H232V80zM48 280V432H232V280H48zM280 432H464V280H280V432zM0 32H48 464h48V80 432v48H464 48 0V432 80 32z'
      
    ]
  };

  
    var faThLarge = faTableCellsLarge;
  

  
  

  var faCloudDrizzle = {
    prefix: 'fasr',
    iconName: 'cloud-drizzle',
    icon: [
      512,
      512,
      [],
      'f738',
      
      'M368 128v48h48c26.5 0 48 21.5 48 48v48H416 96 48V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 320H48 96 416h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48 48zm88 56V352H40v24 48 24H88V424 376zm96 64V416H136v24 48 24h48V488 440zm192-24H328v24 48 24h48V488 440 416zm-96-40V352H232v24 48 24h48V424 376zm192-24H424v24 48 24h48V424 376 352z'
      
    ]
  };

  

  
  

  var faPeoplePantsSimple = {
    prefix: 'fasr',
    iconName: 'people-pants-simple',
    icon: [
      512,
      512,
      [],
      'e21a',
      
      'M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM78 208H178l4 96H144 112 74l4-96zM24 352H64V488v24h48V488 352h32V488v24h48V488 352h40l-2-48-6-144H32L26 304l-2 48zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM334 208H434l4 96H400 368 330l4-96zM280 352h40V488v24h48V488 352h32V488v24h48V488 352h40l-2-48-6-144H288l-6 144-2 48z'
      
    ]
  };

  

  
  

  var faFlowerTulip = {
    prefix: 'fasr',
    iconName: 'flower-tulip',
    icon: [
      512,
      512,
      [127799],
      'f801',
      
      'M282.5 110L256 76.8 229.5 110 202 144.3l-36.6-24.4L144 105.7V160c0 44.2 35.8 80 80 80h8 48 8c44.2 0 80-35.8 80-80V105.7l-21.4 14.2L310 144.3 282.5 110zM232 288h-8c-70.7 0-128-57.3-128-128V73.7 16l48 32 48 32 33.3-41.6L256 0l30.7 38.4L320 80l48-32 48-32V73.7 160c0 70.7-57.3 128-128 128h-8v85.4c41-52 104.6-85.4 176-85.4h8 48c0 16.5-1.8 32.5-5.2 48C484.9 436.6 395.2 512 288 512h-8H232h-8C116.8 512 27.1 436.6 5.2 336C1.8 320.5 0 304.5 0 288H48h8c71.4 0 135 33.4 176 85.4V288zM56 336H54.6C75.5 409.9 143.4 464 224 464h1.4C204.5 390.1 136.6 336 56 336zm400 0c-80.6 0-148.5 54.1-169.4 128H288c80.6 0 148.5-54.1 169.4-128H456z'
      
    ]
  };

  

  
  

  var faBusinessTime = {
    prefix: 'fasr',
    iconName: 'business-time',
    icon: [
      640,
      512,
      ["briefcase-clock"],
      'f64a',
      
      'M152 0H128V24 96H48 0v48V280 432v48H48 360.2c-11.8-14.3-21.4-30.5-28.2-48H48V304H192v48H320.7c3.3-36.3 17.6-69.4 39.5-96H352 192 48V144H152 360 464v50.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7V144 96H464 384V24 0H360 152zM336 96H176V48H336V96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 288v16 48h32 16v32H544 496 480V368 304 288h32z'
      
    ]
  };

  
    var faBriefcaseClock = faBusinessTime;
  

  
  

  var faCommentDollar = {
    prefix: 'fasr',
    iconName: 'comment-dollar',
    icon: [
      512,
      512,
      [],
      'f651',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM276 144V124H236v20 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5l0 0c7.9 2.7 20.3 7 29.9 9.1V336v20h40V336v-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l0 0 0 0-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V144z'
      
    ]
  };

  

  
  

  var faPersonDress = {
    prefix: 'fasr',
    iconName: 'person-dress',
    icon: [
      320,
      512,
      ["female"],
      'f182',
      
      'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM94.8 128h14.1H128h64 19.1 14.1l6.9 12.4 75.3 136 11.6 21-42 23.3-11.6-21L220 217.7 257 336l15 48H224V488v24H176V488 384H144V488v24H96V488 384H48l15-48 37-118.3L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128zM206.7 336L160 186.5 113.3 336h93.4z'
      
    ]
  };

  
    var faFemale = faPersonDress;
  

  
  

  var faDreidel = {
    prefix: 'fasr',
    iconName: 'dreidel',
    icon: [
      448,
      512,
      [],
      'f792',
      
      'M446.7 67.2l-17 17L327.6 186.3l67.7 67.7 11.3 11.3L429.3 288l-22.6 22.6-11.3 11.3L246.6 470.6l-9.4 9.4H224 48 32 0V448 432 256 242.7l9.4-9.4L158.1 84.7l11.3-11.3L192 50.7l22.6 22.6 11.3 11.3 67.7 67.7L395.8 50.2l17-17 33.9 33.9zM48 262.6V432H217.4l58.3-58.3L106.3 204.3 48 262.6zm92.3-92.3L309.7 339.7 361.4 288 192 118.6l-51.7 51.7z'
      
    ]
  };

  

  
  

  var faOtter = {
    prefix: 'fasr',
    iconName: 'otter',
    icon: [
      640,
      512,
      [129446],
      'f700',
      
      'M131.6 182.7l-3.6-2.4V176 152v-8h8 48 8v8 24 4.3l-3.6 2.4-7.5 5 7.9 5.9L208 208h32 16V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v64h48l19.2-14.4 7.9-5.9-7.5-5zm118 73.3H192l-32-24-32 24H92.1c9.9 28 36.6 48 67.9 48h64 24v32H352v-9.9l7-7 15-15H328c-34.2 0-63.8-19.5-78.4-48zM416 256V200 176h24 72 22.1c-6.4-31-28.9-57-59.8-67.3l-17.9-6 12.5-46.3 16.2 3.4C575.4 78.9 640 158.5 640 250.8c0 120.3-92.6 218.9-210.4 228.5c-4.5 .5-9 .8-13.6 .8h-5.2H384 257.6C133.5 480 32.9 379.9 32 256H16V208 144H0V96H24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296h24v48H304v32h56 24v48H360 312v28.7c4.9 2.1 10.3 3.3 16 3.3h88zM99.7 335.8l.1 .2h.3l-.4-.2zM410.8 432c4.7 0 9.4-.2 14.1-.5c35.6-4.4 63.1-34.7 63.1-71.5V304 256 224H464v48 9.9l-7 7-57 57V360v24H376 136.2c31.8 29.8 74.5 48 121.4 48H384h26.8zM536 360c0 8.2-.8 16.3-2.4 24c35.9-33.1 58.4-80.6 58.4-133.3c0-16.7-2.8-32.8-8-47.9V208c0 35.5-19.3 66.6-48 83.2V360zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faUserSecret = {
    prefix: 'fasr',
    iconName: 'user-secret',
    icon: [
      448,
      512,
      [128373],
      'f21b',
      
      'M121.1 87.5L160 0l64 32L288 0l38.9 87.5C380.5 96 416 111 416 128c0 13.4-22.1 25.6-57.7 34.3c1.1 7.1 1.7 14.3 1.7 21.7c0 13.9-2.1 27.4-6 40h10.9H416l-17.5 48-5.8 16-17.5 48H416l2.9 15.9L439.3 464l8.7 48H399.2 280 168 48.8 0l8.7-48L29.1 351.9 32 336H72.7L55.3 288l-5.8-16L32 224H83.1 94c-3.9-12.6-6-26.1-6-40c0-7.4 .6-14.6 1.7-21.7C54.1 153.6 32 141.4 32 128c0-17 35.5-32 89.1-40.5zM268 464H390.5l-14.5-80h-.7H306.7l23.4-64.4L347.5 272H327.7c-16.9 19.9-39.5 34.9-65.2 42.5L240 352l28 112zM185.5 314.5c-25.7-7.6-48.3-22.6-65.2-42.5H100.5l17.3 47.6L141.3 384H72.7h-.7L57.5 464H180l28-112-22.5-37.5zM224 272c34.2 0 63.8-19.5 78.4-48H240l-8-32H216l-8 32H145.6c14.6 28.5 44.2 48 78.4 48z'
      
    ]
  };

  

  
  

  var faRv = {
    prefix: 'fasr',
    iconName: 'rv',
    icon: [
      640,
      512,
      [],
      'f7be',
      
      'M224 0H384V32H584h24V56 184v24H584 573.4l57.4 45.1 9.2 7.2V272 392v24H616 574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H408 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-6.8 .8-13.4 2.4-19.6L95 409 7 321l-7-7V304 56 32H24 224V0zM432 256H556.8l-61.1-48H432v48zM384 368V256 184 160h24 16 80 8.3H560V80H48V294.1L121.9 368H128c13.4-10 30-16 48-16s34.6 6 48 16H384zM208 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 128V256H96V128H288z'
      
    ]
  };

  

  
  

  var faClockElevenThirty = {
    prefix: 'fasr',
    iconName: 'clock-eleven-thirty',
    icon: [
      512,
      512,
      [],
      'e348',
      
      'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V263.3l-60-90-13.3-20 39.9-26.6 13.3 20 64 96 4 6V256 392v24H232V392z'
      
    ]
  };

  

  
  

  var faExpandWide = {
    prefix: 'fasr',
    iconName: 'expand-wide',
    icon: [
      512,
      512,
      [],
      'f320',
      
      'M136 64h24v48H136 48v88 24H0V200 88 64H24 136zM0 312V288H48v24 88h88 24v48H136 24 0V424 312zM488 64h24V88 200v24H464V200 112H376 352V64h24H488zM464 312V288h48v24V424v24H488 376 352V400h24 88V312z'
      
    ]
  };

  

  
  

  var faBriefcaseArrowRight = {
    prefix: 'fasr',
    iconName: 'briefcase-arrow-right',
    icon: [
      512,
      512,
      [],
      'e2f2',
      
      'M128 0h24H360h24V24 96h80 48v48V432v48H464 48 0V432 144 96H48h80V24 0zM336 48H176V96H336V48zM48 144V432H464V144H360 152 48zm257 55l72 72 17 17-17 17-72 72-17 17L254.1 360l17-17 31-31H152 128V264h24H302.1l-31-31-17-17L288 182.1l17 17z'
      
    ]
  };

  

  
  

  var faSuitcaseMedical = {
    prefix: 'fasr',
    iconName: 'suitcase-medical',
    icon: [
      512,
      512,
      ["medkit"],
      'f0fa',
      
      'M128 0h24H360h24V24 96h80 48v48V432v48H464 48 0V432 144 96H48h80V24 0zM336 48H176V96H336V48zm24 96H152h-8V432H368V144h-8zM96 144H48V432H96V144zM416 432h48V144H416V432zM229.3 208h53.3v53.3l53.3 0v53.3H282.7V368H229.3V314.7H176V261.3h53.3V208z'
      
    ]
  };

  
    var faMedkit = faSuitcaseMedical;
  

  
  

  var faO = {
    prefix: 'fasr',
    iconName: 'o',
    icon: [
      448,
      512,
      [111],
      '4f',
      
      'M224 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z'
      
    ]
  };

  

  
  

  var faBookBible = {
    prefix: 'fasr',
    iconName: 'book-bible',
    icon: [
      448,
      512,
      ["bible"],
      'f647',
      
      'M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H424h24V464H424h-8V400h8 24V376 24 0H424 88zM368 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H368zM80 352c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H400V352H80zM208 80v64H144v64h64V320h64V208h64V144H272V80H208z'
      
    ]
  };

  
    var faBible = faBookBible;
  

  
  

  var faMessagesQuestion = {
    prefix: 'fasr',
    iconName: 'messages-question',
    icon: [
      640,
      512,
      [],
      'e1e7',
      
      'M144 360L96 384V368 330.3 320H48 0V272 48 0H48 368h48V48 272v48H368 224l-80 40zm0-53.7l58.5-29.3 10.1-5.1H224 368V48H48V272H96h48v34.3zM256 352h48v48H416h11.3l10.1 5.1L496 434.3V400h48 48V176H448V128H592h48v48V400v48H592 544v10.3V496v16l-48-24-80-40H304 256V400 352zM146.7 109c0-21.4 17.3-38.7 38.7-38.7h40.3c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 165.4v5.9 16H192v-16V156.1v-9.3l8-4.6 31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7H185.3c-3.7 0-6.7 3-6.7 6.7l0 4.6-32 0 0-4.6zM191 216.7h34v34H191v-34z'
      
    ]
  };

  

  
  

  var faGamepadModern = {
    prefix: 'fasr',
    iconName: 'gamepad-modern',
    icon: [
      640,
      512,
      [63676,127918,"gamepad-alt"],
      'e5a2',
      
      'M591.7 480H440l-16-96H216l-16 96H48.3 0l5.4-48L42.8 96 160 32H320 480L597.2 96l37.5 336 5.4 48H591.7zm-423-103.9l6.7-40.1H216 424h40.7l6.7 40.1 9.3 55.9H586.4L552.3 126.2 467.7 80H320 172.3L87.7 126.2 53.6 432H159.3l9.3-55.9zM232 168v32h32 24v48H264 232v32 24H184V280 248H152 128V200h24 32V168 144h48v24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  
    var faGamepadAlt = faGamepadModern;
  

  
  

  var faCurlingStone = {
    prefix: 'fasr',
    iconName: 'curling-stone',
    icon: [
      576,
      512,
      [129356,"curling"],
      'f44a',
      
      'M176 32h24H392h24V80H392 224v64H480v64h32l64 64v40 8 96l-64 64H64L0 416V320v-8V272l64-64H96V144h80V56 32zM48 312v8H528v-8V291.9L492.1 256H83.9L48 291.9V312zm0 56v28.1L83.9 432H492.1L528 396.1V368H48z'
      
    ]
  };

  
    var faCurling = faCurlingStone;
  

  
  

  var faTankWater = {
    prefix: 'fasr',
    iconName: 'tank-water',
    icon: [
      448,
      512,
      [],
      'e452',
      
      'M206.4 32H48 0V80 432v48H48 400h48V432 80 32H400 241.6L251 46.8 272.1 80H400V302.4c-14.2-2.7-27.8-8.7-39.4-15.3c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-11.6 6.6-25.2 12.5-39.3 15.3V80H175.9L197 46.8 206.4 32zM48 351c25-3.1 47.1-13 63-22.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c16 9.1 38.1 19 63.1 22.1v81H48V351zM213.8 80l-37.1 58.3c-5.7 8.9-8.7 19.3-8.7 29.9c0 30.8 25.2 55.8 56 55.8s56-25 56-55.8c0-10.6-3-21-8.7-29.9L234.2 80 224 64 213.8 80z'
      
    ]
  };

  

  
  

  var faImageLandscape = {
    prefix: 'fasr',
    iconName: 'image-landscape',
    icon: [
      576,
      512,
      ["landscape"],
      'e1b5',
      
      'M48 112V400H83.8l80.8-110.2L184 263.4l19.4 26.4L232.8 330l83.1-127.1L336 172.1l20.1 30.7L485 400h43V112H48zm.6 336H48 0V400 112 64H48 528h48v48V400v48H528 516.4 472 319.4 272 200 155.6 96 48.6zM160 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faLandscape = faImageLandscape;
  

  
  

  var faArrowUpToDottedLine = {
    prefix: 'fasr',
    iconName: 'arrow-up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a1',
      
      'M64 96V32H0V96H64zm96 0V32H96V96h64zm32 0h64V32H192V96zm160 0V32H288V96h64zm32 0h64V32H384V96zM241.5 151.6L224 133l-17.5 18.6-128 136L62.1 305l35 32.9 16.4-17.5L200 228.5V312 440v24h48V440 312 228.5l86.5 91.9L351 337.9l35-32.9-16.4-17.5-128-136z'
      
    ]
  };

  

  
  

  var faSiren = {
    prefix: 'fasr',
    iconName: 'siren',
    icon: [
      448,
      512,
      [],
      'e02d',
      
      'M345.6 304H394L368 96H80L54 304h48.4l20-160H325.6l20 160zm-165.5 0l11.8-94 2.2-18H161.9l-1.8 14-12.2 98h32.2zM48 384H400v48H48V384zM0 336v48 48 48H48 400h48V432 384 336H400 48 0z'
      
    ]
  };

  

  
  

  var faFilePdf = {
    prefix: 'fasr',
    iconName: 'file-pdf',
    icon: [
      512,
      512,
      [],
      'f1c1',
      
      'M112 464l-64 0L48 48l176 0 0 112 112 0 0 144 48 0 0-176L256 0 48 0 0 0 0 48 0 464l0 48 48 0 64 0 0-48zm64-112l-16 0 0 16 0 80 0 64 32 0 0-48 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80l-16 0 0 16 0 128 0 16 16 0 32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm32 128l-16 0 0-96 16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16zm80-128l0 16 0 64 0 64 0 16 32 0 0-16 0-48 32 0 16 0 0-32-16 0-32 0 0-32 32 0 16 0 0-32-16 0-48 0-16 0z'
      
    ]
  };

  

  
  

  var faBagShoppingMinus = {
    prefix: 'fasr',
    iconName: 'bag-shopping-minus',
    icon: [
      448,
      512,
      [],
      'e650',
      
      'M224 48c35.3 0 64 28.7 64 64v48H160V112c0-35.3 28.7-64 64-64zM112 112v48H48 0v48V464v48H48 400h48V464 208 160H400 336V112c0-53.6-37.7-98.4-88-109.4V0H224C162.1 0 112 50.1 112 112zM48 208h64 48H288h48 64V464H48V208zm96 104H120v48h24H304h24V312H304 144z'
      
    ]
  };

  

  
  

  var faTableCells = {
    prefix: 'fasr',
    iconName: 'table-cells',
    icon: [
      512,
      512,
      ["th"],
      'f00a',
      
      'M360 80v88H464V80H360zm-48 0H200v88H312V80zM152 80H48v88H152V80zM48 216v80H152V216H48zm0 128v88H152V344H48zm152 88H312V344H200v88zm160 0H464V344H360v88zM464 296V216H360v80H464zM0 32H48 464h48V80 432v48H464 48 0V432 80 32zM200 296H312V216H200v80z'
      
    ]
  };

  
    var faTh = faTableCells;
  

  
  

  var faCircleSort = {
    prefix: 'fasr',
    iconName: 'circle-sort',
    icon: [
      512,
      512,
      ["sort-circle"],
      'e030',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-64L256 96l112 96v32H144V192zM256 416L144 320V288H368v32L256 416z'
      
    ]
  };

  
    var faSortCircle = faCircleSort;
  

  
  

  var faUpRightFromSquare = {
    prefix: 'fasr',
    iconName: 'up-right-from-square',
    icon: [
      512,
      512,
      ["external-link-alt"],
      'f35d',
      
      'M321.9 81.9L288 48l33.9-33.9L336 0H464h48V48 176l-14.1 14.1L464 224l-33.9-33.9L393 153 241 305l-17 17L190.1 288l17-17L359 119 321.9 81.9zM464 156.1V48H355.9L464 156.1zM0 32H24 200h24V80H200 48V464H432V312 288h48v24V488v24H456 24 0V488 56 32z'
      
    ]
  };

  
    var faExternalLinkAlt = faUpRightFromSquare;
  

  
  

  var faCherries = {
    prefix: 'fasr',
    iconName: 'cherries',
    icon: [
      640,
      512,
      [],
      'e0ec',
      
      'M288 40l12.5-20.5L269.1 .3l-4.9 36.5s0 0 0 0l0 0 0 0 0 0 0 .1-.1 .8c-.1 .7-.3 1.9-.6 3.5c-.6 3.1-1.5 7.9-2.9 13.9c-2.8 12.2-7.5 29.7-15.2 50.7c-13.9 38.3-37.3 87.6-76 136.4C152.3 233.5 126.6 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.2 0-38.2 4.1-53.1 9.5c26.5-40.4 44.1-79.4 55.7-111.2c5.7-15.6 9.9-29.6 13.1-41.3c11.9 9.5 26.3 22.2 41 37.6c29.1 30.7 58.2 71.2 72.2 119.6c-12-5.3-27-10.3-44.1-12.7c16.3 14.8 30.1 35.3 37.4 63c1.8 1 3.3 2 4.6 2.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3L448 317.5l29.7-23.7 .4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4c.1 0 .2 0 .4 0c.1 0 .2 0 .3 0c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-12.3 0-36.6-3.4-61.7-13.4c-9.2 14.8-20.2 27.5-32.3 38.2C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.3 10.6-76.3 19.6c-14.3-67.2-52.9-120.9-88.3-158.2C359.3 64.4 339.8 48 325.3 36.9c-7.3-5.6-13.3-9.8-17.6-12.7c-2.2-1.5-3.9-2.6-5.1-3.4c-.6-.4-1.1-.7-1.4-.9l-.4-.3-.1-.1 0 0 0 0s0 0-12.5 20.5zm-.6 232c.2 0 .4 0 .7 .1c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-16.7 0-55.6-6.3-88.7-26.8C72.7 418.3 48 388.4 48 336c0-39.1 15.1-51.2 24.2-56.5c6.1-3.6 12.7-5.6 18-6.6c2.6-.5 4.6-.7 5.7-.8c.3 0 .6 0 .7-.1c18.7 .1 35.4 5.5 48 11.4c6.2 2.9 11.1 5.8 14.2 7.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3L192 317.5l29.7-23.7 .4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4z'
      
    ]
  };

  

  
  

  var faFileVideo = {
    prefix: 'fasr',
    iconName: 'file-video',
    icon: [
      384,
      512,
      [],
      'f1c8',
      
      'M336 464V160H224V48H48V464H336zM48 0H256L384 128V464v48H336 48 0V464 48 0H48zM80 256H240v48l64-32V400l-64-32v48H80V256z'
      
    ]
  };

  

  
  

  var faUsersViewfinder = {
    prefix: 'fasr',
    iconName: 'users-viewfinder',
    icon: [
      640,
      512,
      [],
      'e595',
      
      'M0 0V24 136v24H48V136 48h88 24V0H136 24 0zM640 0H616 504 480V48h24 88v88 24h48V136 24 0zM24 512H136h24V464H136 48V376 352H0v24V488v24H24zm616 0V488 376 352H592v24 88H504 480v48h24H616h24zM260.1 288H224l-20 80-12 48h49.5 157H448l-12-48-20-80H379.9 320 260.1zm14.6-48a72 72 0 1 0 90.5-112.1A72 72 0 1 0 274.7 240zm-13.3 96h117l8 32h-133l8-32zM320 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 96H441l6.1 24.2L461 336h83l-24-80zm-400 0L96 336h83L193 280.2 199 256H120zm55.8-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faGalaxy = {
    prefix: 'fasr',
    iconName: 'galaxy',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M160 184c0-63.9 44.1-117.6 103.6-132.1C237.3 82 221 119.6 217 159.4l-5.1 49.9 42-27.3C275.2 168 300.6 160 328 160c63.9 0 117.6 44.1 132.1 103.6C430 237.3 392.4 221 352.6 217l-49.9-5.1 27.3 42C344 275.2 352 300.6 352 328c0 63.9-44.1 117.6-103.6 132.1C274.7 430 291 392.4 295 352.6l5.1-49.9-42 27.3C236.7 344 211.4 352 184 352c-63.9 0-117.6-44.1-132.1-103.6C82 274.7 119.6 291 159.4 295l49.9 5.1-27.3-42C168 236.8 160 211.4 160 184zM296 0C194.4 0 112 82.4 112 184c0 17.7 2.5 34.9 7.2 51.2c-18-8.1-34.3-19.9-47.9-34.8L41.8 167.9 0 121.9V184v32C0 317.6 82.4 400 184 400c17.7 0 34.9-2.5 51.2-7.2c-8.1 18-19.9 34.3-34.8 47.9l-32.6 29.6L121.9 512H184h32c101.6 0 184-82.4 184-184c0-17.7-2.5-34.9-7.2-51.2c18 8.1 34.3 19.9 47.9 34.8l29.6 32.6L512 390.1V328 296c0-101.6-82.4-184-184-184c-17.7 0-34.9 2.5-51.2 7.2c8.1-18 19.9-34.3 34.8-47.9l32.6-29.6L390.1 0H328 296zM256 296l40-40-40-40-40 40 40 40z'
      
    ]
  };

  

  
  

  var faJ = {
    prefix: 'fasr',
    iconName: 'j',
    icon: [
      320,
      512,
      [106],
      '4a',
      
      'M320 32V56 320c0 88.4-71.6 160-160 160S0 408.4 0 320V280 256H48v24 40c0 61.9 50.1 112 112 112s112-50.1 112-112V56 32h48z'
      
    ]
  };

  

  
  

  var faHighDefinition = {
    prefix: 'fasr',
    iconName: 'high-definition',
    icon: [
      576,
      512,
      ["rectangle-hd"],
      'e1ae',
      
      'M528 80V432H48V80H528zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM304 160v24V328v24h24 56c53 0 96-43 96-96s-43-96-96-96H328 304zm80 48c26.5 0 48 21.5 48 48s-21.5 48-48 48H352V208h32zM160 184V160H112v24 72 72 24h48V328 280h64v48 24h48V328 256 184 160H224v24 48H160V184z'
      
    ]
  };

  
    var faRectangleHd = faHighDefinition;
  

  
  

  var faRestroom = {
    prefix: 'fasr',
    iconName: 'restroom',
    icon: [
      640,
      512,
      [],
      'f7bd',
      
      'M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zM59.6 128H76.9 179.1h17.3l5.4 16.5 44.9 136 7.5 22.8-45.6 15.1-7.5-22.8L192 267.7V488v24H144V488 352H112V488v24H64V488 267.6l-9.2 27.9-7.5 22.8L1.7 303.3l7.5-22.8 44.9-136L59.6 128zM112 304h32V176H112V304zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-20.4 80h17.3H480h64 19.1 17.3l5.4 16.5 44.9 136 7.5 22.8-35.8 11.8L609 336l15 48H576V488v24H528V488 384H496V488v24H448V488 384H400l15-48 6.5-20.9-35.8-11.8 7.5-22.8 44.9-136 5.4-16.5zM512 186.5L465.3 336h93.4L512 186.5zM344 24V488v24H296V488 24 0h48V24z'
      
    ]
  };

  

  
  

  var faDiceD6 = {
    prefix: 'fasr',
    iconName: 'dice-d6',
    icon: [
      448,
      512,
      [],
      'f6d1',
      
      'M200 498.3L224 512l24-13.7L448 384V149.4v-28l-24.5-13.3L224 0 24.3 111.4 0 125v27.8V384L200 498.3zM48 356.1V180.8l152 88.9V443L48 356.1zM72.4 139.5L224.3 54.8l151.4 82.1L223.8 228.1 72.4 139.5zM400 178.3V356.1L248 443V269.6l152-91.3z'
      
    ]
  };

  

  
  

  var faAlignLeft = {
    prefix: 'fasr',
    iconName: 'align-left',
    icon: [
      448,
      512,
      [],
      'f036',
      
      'M24 40H0V88H24 264h24V40H264 24zm0 128H0v48H24 424h24V168H424 24zM0 296v48H24 264h24V296H264 24 0zM24 424H0v48H24 424h24V424H424 24z'
      
    ]
  };

  

  
  

  var faTemperatureSun = {
    prefix: 'fasr',
    iconName: 'temperature-sun',
    icon: [
      640,
      512,
      ["temperature-hot"],
      'f76a',
      
      'M104 104L0 121.3 60.7 208 0 294.7 104 312l17.3 104L208 355.3 294.7 416l.8-5c-4.9-16.1-7.5-33.3-7.5-51c0-37.7 11.8-72.6 32-101.2V105.3l-8-1.3L294.7 0 208 60.7 121.3 0 104 104zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM389.3 307.7L400 294.5v-17V48H528V277.5v17l10.7 13.2C552 324.2 560 345.1 560 368c0 53-43 96-96 96s-96-43-96-96c0-22.9 8-43.8 21.3-60.3zM576 0H528 400 352V48 277.5c-20 24.7-32 56.2-32 90.5c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5V48 0zM464 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112 96H448v16V322.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z'
      
    ]
  };

  
    var faTemperatureHot = faTemperatureSun;
  

  
  

  var faCupStrawSwoosh = {
    prefix: 'fasr',
    iconName: 'cup-straw-swoosh',
    icon: [
      384,
      512,
      [],
      'e364',
      
      'M224 0h56 24V48H280 243l-18.8 80h79.6H352h8 24v48H360 348 299.8 212.9 163.6 84.2 36 24 0V128H24h8H80.2h94.7L200.6 18.5 205 0h19zM64 512L38.7 208H86.8L99.7 362.4c15.7-3.1 27.5-7.3 36.9-11.9c19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7c16-8.6 35.4-15.1 59.8-18.9l3-36h48.2L320 512H64zM290 293.5c-14.1 3.1-24.6 7.1-32.9 11.6c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-14.9 7.4-32.6 13.1-54.2 17l4.5 53.5H275.8L290 293.5z'
      
    ]
  };

  

  
  

  var faArrowLeftFromBracket = {
    prefix: 'fasr',
    iconName: 'arrow-left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e668',
      
      'M344 432l-24 0 0 48 24 0 144 0 24 0 0-24 0-400 0-24-24 0L344 32l-24 0 0 48 24 0 120 0 0 352-120 0zM17 239L0 256l17 17L145 401l17 17L195.9 384l-17-17-87-87 234.9 0 24 0 0-48-24 0L91.9 232l87-87 17-17L161.9 94.1l-17 17L17 239z'
      
    ]
  };

  

  
  

  var faRuler = {
    prefix: 'fasr',
    iconName: 'ruler',
    icon: [
      512,
      512,
      [128207],
      'f545',
      
      'M512 160l-33.9-33.9L385.9 33.9 352 0 318.1 33.9 33.9 318.1 0 352l33.9 33.9 92.1 92.1L160 512l33.9-33.9L478.1 193.9 512 160zm-67.9 0L160 444.1 67.9 352l34.7-34.7 30.1 30.1L144 358.6 166.6 336l-11.3-11.3-30.1-30.1 41.4-41.4 30.1 30.1L208 294.6 230.6 272l-11.3-11.3-30.1-30.1 41.4-41.4 30.1 30.1L272 230.6 294.6 208l-11.3-11.3-30.1-30.1 41.4-41.4 30.1 30.1L336 166.6 358.6 144l-11.3-11.3-30.1-30.1L352 67.9 444.1 160z'
      
    ]
  };

  

  
  

  var faPersonCircleXmark = {
    prefix: 'fasr',
    iconName: 'person-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e543',
      
      'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM94.8 128h14.1H211.1h14.1l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6L224 224.9V488v24H176V488 352H144V488v24H96V488 224.9L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128zM144 304h32V176H144V304zm288-80a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faArrowLeft = {
    prefix: 'fasr',
    iconName: 'arrow-left',
    icon: [
      448,
      512,
      [8592],
      'f060',
      
      'M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z'
      
    ]
  };

  

  
  

  var faLeafMaple = {
    prefix: 'fasr',
    iconName: 'leaf-maple',
    icon: [
      512,
      512,
      [127809],
      'f6f6',
      
      'M448 144l16.5-57.6L480 32 425.6 47.5 368 64 354.8 42.8 328 0 295.7 38.8l-7.1 8.5-37.5 45-2.5 3L248 96l-.1-.5L240 48l-18.3 4.6-28.4 7.1L176 64 159.6 44.9 128 8 96.4 44.9 80 64 50.9 61.1 0 56l12.9 49.5L48 240 35.3 252.7 0 288l43.6 24.2 78.5 43.6-104 104-17 17 33.9 33.9 17-17 104-104 43.6 78.5L224 512l35.3-35.3L272 464l134.5 35.1L456 512l-5.1-50.9L448 432l19.1-16.4L504 384l-36.9-31.6L448 336l4.3-17.3 7.1-28.4L464 272l-47.5-7.9-.5-.1 .7-.6 3-2.5 45-37.5 8.5-7.1L512 184l-42.8-26.8L448 144zM191.4 354.5L313.9 232.1l17-17-33.9-33.9-17 17L157.5 320.6 78.9 276.9l3-3 19.4-19.4-6.9-26.6L63.9 110.6l11.4 1.1 24.9 2.5 16.3-19L128 81.8l11.6 13.5 19.3 22.5 28.8-7.2 13.6-3.4L210 160h47.1l27.7-33.3 37.6-45.1 4.9 7.8 19.1 30.6 34.7-9.9 28.9-8.3-8.3 28.9-9.9 34.7 30.6 19.1 7.8 4.9-45.1 37.6L352 254.9V302l52.8 8.8-3.4 13.6-7.2 28.8 22.5 19.3L430.2 384l-13.5 11.6-19 16.3 2.5 24.9 1.1 11.4L284.1 417.6l-26.6-6.9-19.4 19.4-3 3-43.6-78.5z'
      
    ]
  };

  

  
  

  var faRepublican = {
    prefix: 'fasr',
    iconName: 'republican',
    icon: [
      640,
      512,
      [],
      'f75e',
      
      'M152 32C68.1 32 0 100.1 0 184v80V456v24H24h96 24V456 384H304v72 24h24 96 24V456 384h48v24c0 39.8 32.2 72 72 72s72-32.2 72-72V344 320H592v24 64c0 13.3-10.7 24-24 24s-24-10.7-24-24V360 264 184c0-83.9-68.1-152-152-152H152zM496 288v48H424 400v24 72H352V360 336H328 120 96v24 72H48V288H496zm0-48H48V184C48 126.6 94.6 80 152 80H392c57.4 0 104 46.6 104 104v56zM159.6 144l-15.7-32-15.7 32-36.3 4.6 26.5 24.4L111.7 208l32.1-16.9L176 208l-6.7-34.9 26.5-24.4L159.6 144zm112.3-32l-15.7 32-36.3 4.6 26.5 24.4L239.7 208l32.1-16.9L304 208l-6.7-34.9 26.5-24.4L287.6 144l-15.7-32zm143.7 32l-15.7-32-15.7 32-36.3 4.6 26.5 24.4L367.7 208l32.1-16.9L432 208l-6.7-34.9 26.5-24.4L415.6 144z'
      
    ]
  };

  

  
  

  var faHandsClapping = {
    prefix: 'fasr',
    iconName: 'hands-clapping',
    icon: [
      544,
      512,
      [],
      'e1a8',
      
      'M368 16V80 96H336V80 16 0h32V16zm-98.7 7.1l32 48 8.9 13.3-26.6 17.8-8.9-13.3-32-48-8.9-13.3L260.4 9.8l8.9 13.3zM191.4 94.6l17 15.8L288 184.8V168 144h24 80 24v24V329.6C416 430.3 334.3 512 233.6 512c-22.5 0-44.1-2.1-65.9-10.4c-21.8-8.3-42.1-22.1-63.1-43.1L88 441.9 71 425 55 409l-.1-.1L31 385l-17-17 17-17 31-31L31 289l-17-17 17-17 31-31L47 209l-17-17 17-17 48-48 17-17 17 17 15 15 31-31 16.4-16.4zM113 207l88 88 17 17L184 345.9l-17-17-71-71L81.9 272 96 286.1l17 17 40 40 17 17L136 393.9l-17-17-23-23L81.9 368l7 7 16 16 17 17 16.6 16.6c17.4 17.4 32.1 26.8 46.2 32.1c14.2 5.4 29.3 7.2 48.9 7.2C307.8 464 368 403.8 368 329.6V192H336v48 20l-29.8 7.4-10.6-9.9-103-96.2L177.9 176l71 71 17 17L232 297.9l0 0 0 0-17-17-88-88-15-15L97.9 192l15 15zM361.6 512c-4.9 0-9.8-.1-14.7-.3c23.2-14.5 43.5-33.3 59.7-55.4c52.1-18.5 89.4-68.2 89.4-126.7V192H448V168 144h72 24v24V329.6C544 430.3 462.3 512 361.6 512zm82-502.2l26.6 17.8-8.9 13.3-32 48-8.9 13.3L393.8 84.4l8.9-13.3 32-48 8.9-13.3z'
      
    ]
  };

  

  
  

  var faSnowflakes = {
    prefix: 'fasr',
    iconName: 'snowflakes',
    icon: [
      640,
      512,
      [],
      'f7cf',
      
      'M248 24V0H200V24 70.1L183.4 53.4l-17-17L132.5 70.4l17 17L200 137.9v76.5l-66.2-38.2-18.5-69.1-6.2-23.2L62.7 96.3l6.2 23.2L75 142.2l-26-15-20.8-12-24 41.6 20.8 12 26 15-22.7 6.1L5.1 196.1l12.4 46.4 23.2-6.2 69.1-18.5L176 256l-66.2 38.2L40.7 275.7l-23.2-6.2L5.1 315.9l23.2 6.2L51 328.2l-26 15-20.8 12 24 41.6 20.8-12 26-15-6.1 22.7-6.2 23.2 46.4 12.4 6.2-23.2 18.5-69.1L200 297.6v76.5l-50.6 50.6-17 17 33.9 33.9 17-17L200 441.9V488v24h48V488 441.9l16.6 16.6 17 17 33.9-33.9-17-17L248 374.1V297.6l66.2 38.2 18.5 69.1 6.2 23.2 46.4-12.4-6.2-23.2L373 369.8l26 15 20.8 12 24-41.6-20.8-12-26-15 22.7-6.1 23.2-6.2-12.4-46.4-23.2 6.2-69.1 18.5L272 256l66.2-38.2 69.1 18.5 23.2 6.2 12.4-46.4-23.2-6.2L397 183.8l26-15 20.8-12-24-41.6-20.8 12-26 15 6.1-22.7 6.2-23.2L339 83.9l-6.2 23.2-18.5 69.1L248 214.4V137.9l50.6-50.6 17-17L281.6 36.5l-17 17L248 70.1V24zm262 40L482.2 91.8l33.9 33.9L544 97.9l27.8 27.8 33.9-33.9L577.9 64l27.8-27.8L571.8 2.2 544 30.1 516.2 2.2 482.2 36.2 510.1 64zm37.1 129.3l-33.9 33.9 17 17L542.1 256l-11.8 11.8-17 17 33.9 33.9 17-17L576 289.9l11.8 11.8 17 17 33.9-33.9-17-17L609.9 256l11.8-11.8 17-17-33.9-33.9-17 17L576 222.1l-11.8-11.8-17-17z'
      
    ]
  };

  

  
  

  var faCircleAmpersand = {
    prefix: 'fasr',
    iconName: 'circle-ampersand',
    icon: [
      512,
      512,
      [],
      'e0f8',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128v24 36.7c0 18.6 7.2 36.4 20 49.8l7.3 7.7-21.9 16.1c-18.5 13.6-29.4 35.1-29.4 58.1V360v24h24 88 16 12.6l7.2-10.3 10.8-15.6L327.4 384h66.1c-.7-.9-1.4-1.8-2.2-2.6l-60.9-63.6 33.3-48.1 13.7-19.7-39.5-27.3-13.7 19.7-27.7 40.1-28.6-29.9 18-13.2c16.4-12.1 26.2-31.2 26.2-51.6V152 128H288 192 168zm66.4 89.6l-11.7-12.2c-4.3-4.5-6.7-10.4-6.7-16.6V176h48v11.7c0 5.1-2.4 9.9-6.5 12.9l-23.1 16.9zm-5.6 63.6l39.8 41.5L259.4 336H192V320.3c0-7.6 3.6-14.8 9.8-19.4l27-19.8z'
      
    ]
  };

  

  
  

  var faCampfire = {
    prefix: 'fasr',
    iconName: 'campfire',
    icon: [
      512,
      512,
      [],
      'f6ba',
      
      'M228.4 0C189.6 24.2 112 93.1 112 174.5C112 254.9 177.1 320 257.5 320s145.5-65.1 145.5-145.5c0-24.2-17.5-87.3-87.3-145.5L286.5 58.2 228.4 0zm87.3 218.3c0 32.1-26 58.2-58.2 58.2s-58.2-26-58.2-58.2c0-43.6 58.2-87.3 58.2-87.3s58.2 43.6 58.2 87.3zM40.1 297.4l-22.6-8.1L1.3 334.5l22.6 8.1L184.6 400 23.9 457.4 1.3 465.5l16.1 45.2 22.6-8.1L256 425.5l215.9 77.1 22.6 8.1 16.1-45.2-22.6-8.1L327.4 400l160.7-57.4 22.6-8.1-16.1-45.2-22.6 8.1L256 374.5 40.1 297.4z'
      
    ]
  };

  

  
  

  var faHandsHolding = {
    prefix: 'fasr',
    iconName: 'hands-holding',
    icon: [
      640,
      512,
      [],
      'f4c2',
      
      'M120 64h24V88 302.1l47-47 17-17 17 17 95 95 95-95 17-17 17 17 47 47V88 64h24 96 24V88 392v9.9l-7 7-84.8 84.8-17 17-33.9-33.9 17-17L592 382.1V112H544V312v9.9l-7 7-7 7-17 17-40 40c0 0 0 0 0 0l-16 16-17 17L406.1 392l17-17 16-16c0 0 0 0 0 0l23-23L432 305.9l-88 88V488v24H320 296V488 393.9l-88-88L177.9 336l23 23 16 16 1 1 16 16L200 425.9l-16-16-1-1-16-16-40-40-17-17-7-7-7-7V312 112H48V382.1l77.8 77.8 17 17-33.9 33.9-17-17L7 409l-7-7V392 88 64H24h96z'
      
    ]
  };

  

  
  

  var faHeadphones = {
    prefix: 'fasr',
    iconName: 'headphones',
    icon: [
      512,
      512,
      [127911],
      'f025',
      
      'M256 80C152 80 65.8 156.3 50.4 256H80h48v48V432v48H80 48 0V432 368 288C0 146.6 114.6 32 256 32s256 114.6 256 256v80 64 48H464 432 384V432 304 256h48 29.6C446.2 156.3 360 80 256 80zM464 304H432V432h32V368 304zM48 368v64H80V304H48v64z'
      
    ]
  };

  

  
  

  var faTengeSign = {
    prefix: 'fasr',
    iconName: 'tenge-sign',
    icon: [
      384,
      512,
      [8376,"tenge"],
      'f7d7',
      
      'M0 32H384V80H0V32zM216 160H384v48H216V480H168V208H0V160H168h48z'
      
    ]
  };

  
    var faTenge = faTengeSign;
  

  
  

  var faSquare7 = {
    prefix: 'fasr',
    iconName: 'square-7',
    icon: [
      448,
      512,
      [],
      'e25c',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm296 96h24v29.4l-2.3 4.9L213.5 384h-53l3.9-8.2L258.2 176H152 128V128h24H296z'
      
    ]
  };

  

  
  

  var faLampFloor = {
    prefix: 'fasr',
    iconName: 'lamp-floor',
    icon: [
      640,
      512,
      [],
      'e015',
      
      'M177.9 224H128l13.7-48L192 0H448l50.3 176L512 224H462.1 177.9zm270.4-48L411.8 48H228.2L191.6 176H448.4zM216 464h80V256h48V464h80 24v48H424 320 216 192V464h24z'
      
    ]
  };

  

  
  

  var faSunCloud = {
    prefix: 'fasr',
    iconName: 'sun-cloud',
    icon: [
      640,
      512,
      [127780],
      'f763',
      
      'M193.1 23.2L256 57.1l62.9-33.9L362 0l14.1 46.9 20.5 68.4 68.4 20.5L512 150l-23.2 43.1-.8 1.5c-7.7-1.7-15.7-2.6-24-2.6c-11 0-21.6 1.6-31.6 4.5l9.4-17.5-59-17.7-24.8-7.4-7.4-24.8L333 70.2 278.8 99.4 256 111.6 233.2 99.4 179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2L111.6 256 99.4 278.8 70.2 333l59 17.7 24.8 7.4 7.4 24.8 17.7 59 54.2-29.2L256 400.4l22.8 12.3 9.2 5V448h93.2l-5.1 17.1L362 512l-43.1-23.2L256 454.9l-62.9 33.9L150 512l-14.1-46.9-20.5-68.4L46.9 376.1 0 362l23.2-43.1L57.1 256 23.2 193.1 0 150l46.9-14.1 68.4-20.5 20.5-68.4L150 0l43.1 23.2zM256 144c58.8 0 107 45.3 111.6 102.9c-2.2 3.8-4.3 7.7-6.1 11.7c-21.9 5.2-40.8 17.9-54 35.3c7.8-10.6 12.4-23.7 12.4-37.9c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c20.7 0 39.1-9.8 50.8-25.1C295 310.8 288 330.6 288 352v11.4c-10.1 3-20.9 4.6-32 4.6c-61.9 0-112-50.1-112-112s50.1-112 112-112zM384 416H320V352c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72v72H568 384z'
      
    ]
  };

  

  
  

  var faDivide = {
    prefix: 'fasr',
    iconName: 'divide',
    icon: [
      448,
      512,
      [247,10135],
      'f529',
      
      'M256 64v64H192V64h64zM432 280H408 40 16V232H40 408h24v48zM192 384h64v64H192V384z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenDollar = {
    prefix: 'fasr',
    iconName: 'envelope-open-dollar',
    icon: [
      512,
      512,
      [],
      'f657',
      
      'M112 48V215.6L64 183V48 0h48H400h48V48 183l-48 32.6V48H112zM256 410l-27-18.3L48 268.9V464H464V268.9L283 391.7 256 410zM464 210.9l48-32.6v58V464v48H464 48 0V464 236.3v-58l48 32.6L256 352 464 210.9zM276 96v6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2 0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6V288v20H236V288v-6.4c-9.5-2.2-22-6.4-29.9-9.1l0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1l0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1V96 76h40V96z'
      
    ]
  };

  

  
  

  var faCubes = {
    prefix: 'fasr',
    iconName: 'cubes',
    icon: [
      576,
      512,
      [],
      'f1b3',
      
      'M288 4.4l8.1 2.9 136 48.5L448 61.5V78.4 207.5l112.5 42.7 15.5 5.9v16.6V426.8v15.7l-14.3 6.3L433.7 505l-9.4 4.1-9.5-3.9L288 452.7 161.2 505.2l-9.5 3.9-9.4-4.1-128-56.3L0 442.4V426.8 272.6 256.1l15.5-5.9L128 207.5V78.4 61.5l15.9-5.7 136-48.5L288 4.4zM400 117.9l-88 33.7v86.9l88-31.4V117.9zM264 151.7l-88-33.7v89.3l88 31.4V151.7zm48 259.1l88 36.4V353.9l-88-33.7v90.6zm136 35.5l80-35.2V323.2l-80 30.7v92.4zM264 320.2l-88 33.7v93.3l88-36.4V320.2zM48 411.1l80 35.2V353.9L48 323.2v87.9zM288 55.4L214.9 81.5l73.1 28 73.1-28L288 55.4zM152.3 249.7L70.8 280.6 152 311.7l83.9-32.1-83.6-29.8zm352.9 30.9l-81.4-30.9-83.6 29.8L424 311.7l81.2-31.1z'
      
    ]
  };

  

  
  

  var faSquareR = {
    prefix: 'fasr',
    iconName: 'square-r',
    icon: [
      448,
      512,
      [],
      'e27c',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm128 96h24H256c44.2 0 80 35.8 80 80c0 37.8-26.3 69.5-61.6 77.9L337.1 384h-57l-61.3-96H176v72 24H128V360 264 152 128zm48 112h56 24c17.7 0 32-14.3 32-32s-14.3-32-32-32H176v64z'
      
    ]
  };

  

  
  

  var faBillboard = {
    prefix: 'fasr',
    iconName: 'billboard',
    icon: [
      640,
      512,
      [],
      'e5cd',
      
      'M440 24V0H392V24v8H248V24 0H200V24v8H80 32V80 352H0v48H32 80 296v88 24h48V488 400H560h48 32V352H608V80 32H560 440V24zM200 128h-8H168v48h24 32 32 24V128H256h-8V80H392v48h-8H360v48h24 32 32 24V128H448h-8V80H560V352H80V80H200v48z'
      
    ]
  };

  

  
  

  var fa0 = {
    prefix: 'fasr',
    iconName: '0',
    icon: [
      320,
      512,
      [],
      '30',
      
      'M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 80C98.1 80 48 130.1 48 192V320c0 61.9 50.1 112 112 112s112-50.1 112-112V192c0-61.9-50.1-112-112-112z'
      
    ]
  };

  

  
  

  var faShirt = {
    prefix: 'fasr',
    iconName: 'shirt',
    icon: [
      640,
      512,
      [128085,"t-shirt","tshirt"],
      'f553',
      
      'M232.4 24l23.9-2.2L254.3 0H232.4V24zm175.3 0V0H385.7l-2 21.8L407.6 24zm19.9 0L443 5.6 436.3 0h-8.7V24zm8.9 7.4L421.1 49.9v0l15.4-18.4zm144 120L595.8 133v0l-15.4 18.4zm25.2 21l18.1 15.8 16.2-18.5L621 154l-15.4 18.4zm-21.6 24.7l18.1 15.8-18.1-15.8zm-56 64L510 245.3l18.1 15.8zm-20.6 23.5L492.1 303l18 15 15.4-17.6-18.1-15.8zm-24-20L468.2 283l15.4-18.4zM456 241.7l15.4-18.4L432 190.4v51.2h24zM456 488v24h24V488H456zm-272 0H160v24h24V488zm0-246.3h24V190.4l-39.4 32.8L184 241.7zm-27.5 22.9l-15.4-18.4 15.4 18.4zm-24 20l-18.1 15.8L129.9 318l18-15-15.4-18.4zm-20.6-23.5L130 245.3l-18.1 15.8zm-56-64L74 181.3 55.9 197.1zM34.3 172.4L19 154 .1 169.7l16.2 18.5 18.1-15.8zm25.2-21L44.2 133h0l15.4 18.4zm144-120l15.4 18.4v0L203.5 31.4zm8.9-7.4V0h-8.7l-6.7 5.6L212.4 24zM232.4 0H224V48h8.4V0zM320 80c-33.4 0-60.8-25.6-63.7-58.2l-47.8 4.3C213.6 83.3 261.6 128 320 128V80zm63.7-58.2C380.8 54.4 353.4 80 320 80v48c58.4 0 106.4-44.7 111.5-101.8l-47.8-4.3zM416 0h-8.4V48H416V0zm11.6 0H416V48h11.6V0zm24.3 13L443 5.6 412.2 42.4l8.9 7.4L451.8 13zm144 120L451.8 13 421.1 49.9l144 120L595.8 133zM621 154l-25.2-21-30.7 36.9 25.2 21L621 154zm-18.9 58.9l21.6-24.7-36.1-31.6L566 181.3l36.1 31.6zm-56 64l56-64L566 181.3l-56 64 36.1 31.6zm-20.6 23.5l20.6-23.5L510 245.3l-20.6 23.5 36.1 31.6zM468.2 283l24 20 30.7-36.9-24-20L468.2 283zm-27.5-22.9L468.2 283l30.7-36.9-27.5-22.9-30.7 36.9zM432 241.7V488h48V241.7H432zM456 464H184v48H456V464zM208 488V241.7H160V488h48zM171.9 283l27.5-22.9-30.7-36.9-27.5 22.9L171.9 283zm-24 20l24-20-30.7-36.9-24 20L147.9 303zm-54-26.1l20.6 23.5 36.1-31.6L130 245.3 93.9 276.9zm-56-64l56 64L130 245.3l-56-64L37.9 212.9zM16.3 188.2l21.6 24.7L74 181.3 52.4 156.6 16.3 188.2zM44.2 133L19 154l30.7 36.9 25.2-21L44.2 133zm144-120L44.2 133l30.7 36.9 144-120L188.2 13zm8.9-7.4L188.2 13l30.7 36.9 8.9-7.4L197.1 5.6zM224 0H212.4V48H224V0z'
      
    ]
  };

  
    var faTShirt = faShirt;
  
    var faTshirt = faShirt;
  

  
  

  var faClockSix = {
    prefix: 'fasr',
    iconName: 'clock-six',
    icon: [
      512,
      512,
      [],
      'e352',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V360v24H232V360 120 96h48v24z'
      
    ]
  };

  

  
  

  var faHose = {
    prefix: 'fasr',
    iconName: 'hose',
    icon: [
      448,
      512,
      [],
      'e419',
      
      'M288 128h48V104v-2.3l80-11.4V104h32V88 40 24H416V37.7L336 26.3V24 0H288V24v80 24zM8 464v48H32 416h24V464H416 32 8zm24-80H8v48H32 416h24V384H416 32zM8 304v48H32 416h24V304H416 32 8zM56 156c0-37.6 30.4-68 68-68H256V40H124C59.9 40 8 91.9 8 156s51.9 116 116 116H416h24V224H416 124c-37.6 0-68-30.4-68-68z'
      
    ]
  };

  

  
  

  var faPhoneXmark = {
    prefix: 'fasr',
    iconName: 'phone-xmark',
    icon: [
      640,
      512,
      [],
      'e227',
      
      'M336.4 369.2l31.9 18.4 26-26 33.2-33.2L521.7 366l-17.8 97.9C289.4 459.7 116.3 286.6 112.1 72L210 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM576 336L416 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L304 160 240 0 64 32l0 32c0 247.4 200.6 448 448 448h32l32-176zm-6-296L536 6.1 519 23l-47 47L425 23l-17-17L374.1 40l17 17 47 47-47 47-17 17L408 201.9l17-17 47-47 47 47 17 17L569.9 168l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  

  
  

  var faGuitars = {
    prefix: 'fasr',
    iconName: 'guitars',
    icon: [
      512,
      512,
      [],
      'f8bf',
      
      'M152 178V133.7l21.5-42.9 2.5-5.1V80 24 0H152 104 80V24 80v5.7l2.5 5.1L104 133.7V178c-50.3 8.6-88 43.8-88 86c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104c29.3 0 56.3-8 77.8-21.4c-8.4-14.7-13.4-31.7-13.8-49.7c-13.1 12.9-34.3 23.2-64 23.2c-54 0-80-33.9-80-56c0-9.7 3.7-19.8 12.4-29.3c26.2-29 26.4-71.9 7.8-101.2c-3-4.8-4.2-9.2-4.2-13.5c0-9.6 11.2-29.7 40-37.1V312v24h48V312 226.9c28.8 7.4 40 27.5 40 37.1c0 4.2-1.2 8.7-4.2 13.5c-18.6 29.4-18.4 72.2 7.8 101.2c2.1 2.3 3.9 4.7 5.5 7.1c4.7-13.9 10.4-26.2 15.3-36.6l.8-1.6c2.6-5.5 4.9-10.4 6.8-14.8c-2.6-9.9-1.1-21 4.4-29.6c1.2-1.9 2.3-3.8 3.3-5.7c-.4-3.5-1.1-6.4-1.8-8.9c-1-3.3-2.2-6.8-3.6-10.8l-.4-1.2c-3.3-9.7-8-23.4-9.4-38c-.3-2.9-.4-5.9-.4-9V224 209.6c-15.8-15.7-38.2-27.1-64-31.5zm160-66l32 36.6V240c-23.7 0-38.6-8.8-48-19.8c-16-18.8-16-44.2-16-44.2H248v0 48 5.5c0 2 .1 4 .3 6c1 10.8 4.7 21.4 8.2 31.9l0 0c1.4 4 2.7 7.9 3.9 11.8c2.1 6.8 3.6 15.1 3.6 24.8c0 19.2-8.6 37.5-17.8 57.2c-10.7 22.8-22.2 47.3-22.2 77c0 40.8 33 73.8 73.8 73.8H438.2c40.8 0 73.8-33 73.8-73.8c0-29.7-11.5-54.3-22.2-77c-9.2-19.7-17.8-38-17.8-57.2c0-9.8 1.5-18 3.6-24.8c1.2-3.9 2.6-7.9 3.9-11.8l0 0 0 0c2.5-7.3 5-14.6 6.6-22.1c.4-1.8 .7-3.5 1-5.3c.6-3.5 .9-7 .9-10.5V192v0H456s0 19-16 33.1c-9.4 8.3-24.3 14.9-48 14.9V74.1c9.6-6.4 16-17.3 16-29.7V40c0-22.1-17.9-40-40-40H336L312 112zm0 192c0-7.2-.5-14-1.5-20.4c10.4 2.9 21.6 4.4 33.5 4.4h48c12.1 0 23.2-1.3 33.4-3.6c-.9 6.2-1.4 12.7-1.4 19.6c0 30.6 13.4 58.9 22 76.9l0 0 0 0 0 0c.9 1.9 1.7 3.6 2.5 5.3c9.9 21.2 15.5 35.9 15.5 52.1c0 14.2-11.6 25.8-25.8 25.8H297.8c-14.2 0-25.8-11.6-25.8-25.8c0-16.2 5.6-30.9 15.5-52.1c.8-1.6 1.6-3.4 2.5-5.3l0 0 0 0c8.6-18 22-46.2 22-76.9zm8 80v48h24 48 24V384H392 344 320z'
      
    ]
  };

  

  
  

  var faScrollOld = {
    prefix: 'fasr',
    iconName: 'scroll-old',
    icon: [
      576,
      512,
      [],
      'f70f',
      
      'M80 80c-17.7 0-32 14.3-32 32v48H80v48H24 0V184 112C0 67.8 35.8 32 80 32H400c44.2 0 80 35.8 80 80V272H464 448 432 400 384V240h16 32V160H400 384V128h16 32V112c0-17.7-14.3-32-32-32H153.3c4.3 9.8 6.7 20.6 6.7 32V224h48 16v32H208 160V400c0 17.7 14.3 32 32 32s32-14.3 32-32V328 304h24 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .6 .6 .5 .6 .5 .5 .5 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .5 .5 .6 .5 .6 .6 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .7 .6 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 24v24 72c0 44.2-35.8 80-80 80H192c-44.2 0-80-35.8-80-80V112c0-17.7-14.3-32-32-32zM265.3 432H496c17.7 0 32-14.3 32-32V352h-.3H527h-.7-.7-.6-.7-.6-.6-.6-.6-.6-.6-.6-.6-.6H518h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H511h-.6-.6-.6-.6-.6-.6-.6H506h-.6-.6-.6-.6-.6-.6-.6H501h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H490h-.6-.6-.6-.6H487h-.6-.6-.6-.6H484h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H477h-.6-.6-.6-.6H474h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H463h-.6-.6-.6-.6-.6-.6H459h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H450h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H441h-.6-.6-.6-.6-.6-.6-.6-.6H436h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H430h-.6-.5-.6-.6-.5-.6-.5-.5H425h-.6-.5-.5-.5-.5-.5-.5-.5-.5-.5H419h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H413h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H406h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H400v32 16H368V384 352h-.2-.6-.6-.6-.6-.6-.6H364h-.6-.6-.6-.6-.6-.6-.6-.6H359h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H350h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H341h-.6-.6-.6-.6-.6-.6H337h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H326h-.6-.6-.6-.6H323h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H316h-.6-.6-.6-.6H313h-.6-.6-.6-.6H310h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H299h-.6-.6-.6-.6-.6-.6-.6H294h-.6-.6-.6-.6-.6-.6-.6H289h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H282h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.7-.7-.7-.7H273h-.7H272v48c0 11.4-2.4 22.2-6.7 32z'
      
    ]
  };

  

  
  

  var faQuoteRight = {
    prefix: 'fasr',
    iconName: 'quote-right',
    icon: [
      448,
      512,
      [8221,"quote-right-alt"],
      'f10e',
      
      'M448 296c0 66.3-53.7 120-120 120H312 288V368h24 16c39.8 0 72-32.2 72-72v-8H304 256V240 144 96h48 96 48v48 48 48 48 8zm-48-56V192 144H304v96h96zM48 240h96V192 144H48v96zm144-48v48 48 8c0 66.3-53.7 120-120 120H56 32V368H56 72c39.8 0 72-32.2 72-72v-8H48 0V240 144 96H48h96 48v48 48z'
      
    ]
  };

  
    var faQuoteRightAlt = faQuoteRight;
  

  
  

  var faPenClipSlash = {
    prefix: 'fasr',
    iconName: 'pen-clip-slash',
    icon: [
      640,
      512,
      ["pen-alt-slash"],
      'e20f',
      
      'M409.1 294.9L463 241l0 0L497 207l0 0 45.1-45.1L576 128 542.1 94.1 512.4 64.4 512 64l-.4-.4L481.9 33.9 448 0 414.1 33.9 369 79 321 31l-17-17L287 31l-95.2 95.2L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L409.1 294.9zm-179-139L304 81.9l31 31-70 70-34.9-27.1zm73.1 56.8L369 146.9 429.1 207l-58.2 58.2-67.7-52.5zm36.8 151.3l-38-29.9L200.3 435.8l-75.1 15 15-75.1L234.8 281l-38-29.9L96 352 74.2 461 64 512l51-10.2L224 480 340.1 363.9z'
      
    ]
  };

  
    var faPenAltSlash = faPenClipSlash;
  

  
  

  var faPoo = {
    prefix: 'fasr',
    iconName: 'poo',
    icon: [
      512,
      512,
      [128169],
      'f2fe',
      
      'M232 0H187.2L212 37.3l5.7 8.5L232 36.3l-14.3 9.5c4.1 6.1 6.3 13.4 6.3 20.7v8.1c0 16.2-13.1 29.3-29.3 29.3H180h-3.1c-6.1 0-12.1 .8-17.8 2.2C113.9 115.8 80 155.9 80 204c0 2 .1 4.1 .2 6.1C46.9 226.3 24 260.5 24 300c0 12.2 2.2 23.9 6.2 34.7C11.6 353.5 0 379.4 0 408v80 24H24 488h24V488 408c0-28.6-11.6-54.5-30.2-73.3c4-10.8 6.2-22.5 6.2-34.7c0-39.5-22.9-73.7-56.2-89.9c.1-2 .2-4 .2-6.1c0-38-21.2-71-52.3-87.9C363.6 49.5 303.6 0 232 0zm40 66.6c0-3.7-.2-7.3-.7-10.9c33.3 13.6 58 44 63.5 80.7l2.1 14 13.2 4.9C370 162.6 384 181.7 384 204c0 5.2-.8 10.3-2.2 15l-7.4 24.6 25.1 5.7c23.2 5.2 40.5 26 40.5 50.7c0 10.4-3 20-8.2 28.1l-12.9 20 19.9 13.1C454 371.2 464 388.5 464 408v56H48V408c0-19.5 10-36.8 25.3-46.8l19.9-13.1-12.9-20C75 320 72 310.4 72 300c0-24.7 17.3-45.5 40.5-50.7l25.1-5.7L130.2 219c-1.4-4.7-2.2-9.7-2.2-15c0-25.1 17.8-46 41.4-50.9l.6-.1 .6-.2c2-.5 4.1-.8 6.3-.8H180h14.7c42.7 0 77.3-34.6 77.3-77.3V66.6zM192 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c64 0 96-64 96-64H160s32 64 96 64z'
      
    ]
  };

  

  
  

  var faFaceMelting = {
    prefix: 'fasr',
    iconName: 'face-melting',
    icon: [
      640,
      512,
      [129760],
      'e483',
      
      'M528 256c0-114.9-93.1-208-208-208s-208 93.1-208 208c0 33.5 7.9 65 21.9 93c16.7 33.4 12.5 72.2-.1 100.7c-2.1 4.7-4.6 9.5-7.6 14.4H319.9l.1 0h0 0l.1 0h164c-2.7-7.5-4.1-15.6-4.1-24c0-32.6 21.6-60.1 51.3-69c-10.9-20.5-14.2-44.9-9.1-66.1c3.8-15.6 5.8-32 5.8-48.9zm0 184c0 13.3 10.7 24 24 24l0 0h56v48l-56 0H320.1l-.1 0-.1 0H46.6 24L0 512V488 464H24l0 0H46.6c38.9 0 61.8-58.8 44.4-93.6C73.7 336 64 297.1 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 20.7-2.5 40.8-7.1 60.1c-6 24.8 11.1 51.8 36.5 51.9c0 0 0 0 0 0h0H616l24 0v23.9c0 0 0 .1 0 .1s0 .1 0 .1V416H616c0 0 0 0 0 0H605.5h0L552 416c-13.3 0-24 10.7-24 24zM263.8 158.1a32 32 0 1 1 -16.6 61.8 32 32 0 1 1 16.6-61.8zm115.4 64A32 32 0 1 1 441 238.7a32 32 0 1 1 -61.8-16.6zM177.3 300.8l43.2-21c11.3 23.2 33.6 50.1 72.7 60.6s71.9-1.7 93.2-16.1l26.9 39.8c-29.5 19.9-76.5 37.8-132.5 22.8s-87.9-54-103.4-86z'
      
    ]
  };

  

  
  

  var faBookMedical = {
    prefix: 'fasr',
    iconName: 'book-medical',
    icon: [
      448,
      512,
      [],
      'f7e6',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zM208 96h64v64h64v64H272v64H208V224H144V160h64V96z'
      
    ]
  };

  

  
  

  var faArrowDownSmallBig = {
    prefix: 'fasr',
    iconName: 'arrow-down-small-big',
    icon: [
      576,
      512,
      ["sort-size-down-alt"],
      'f88d',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM432 80H368v64h64V80zM368 32h64 48V80v64 48H432 368 320V144 80 32h48zm0 400H496V304H368V432zM320 256h48H496h48v48V432v48H496 368 320V432 304 256z'
      
    ]
  };

  
    var faSortSizeDownAlt = faArrowDownSmallBig;
  

  
  

  var faGaugeSimple = {
    prefix: 'fasr',
    iconName: 'gauge-simple',
    icon: [
      512,
      512,
      ["gauge-simple-med","tachometer-average"],
      'f629',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6V120 96H232v24V301.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56z'
      
    ]
  };

  
    var faGaugeSimpleMed = faGaugeSimple;
  
    var faTachometerAverage = faGaugeSimple;
  

  
  

  var faTrash = {
    prefix: 'fasr',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M147.2 0H160 288h12.8L308 10.7 354.2 80h13.7H416h32v48H412.4L384 512H64L35.6 128H0V80H32 80.1 93.8L140 10.7 147.2 0zm4.4 80h145L275.2 48H172.8L151.5 80zM83.7 128l24.9 336H339.4l24.9-336H83.7z'
      
    ]
  };

  

  
  

  var faHandFingersCrossed = {
    prefix: 'fasr',
    iconName: 'hand-fingers-crossed',
    icon: [
      416,
      512,
      [],
      'e1a3',
      
      'M197.4 10.3L175.6 .2 165.5 21.9 152 50.8l-4.1-8.8L137.7 20.2 116 30.3 43.5 64.1 21.7 74.3 31.9 96 81.4 202.2 63.8 240H56 32v24 56 0 24 0c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168v-8V312 256 184 160H392 336v-8V128H312 257.2l24.2-52 10.1-21.8L269.9 44.1 197.4 10.3zM114.5 84l11 23.6-17.7 37.9L85.5 97.5l29-13.5zM152 240H116.7l82.1-176 29 13.5L152 240zm216-32v48 32H336v-8V208h32zM312 336h56v8c0 66.3-53.7 120-120 120H200c-66.3 0-120-53.7-120-120l0 0 0-24 0 0 0-32H208v32H152 128v48h24 80 24V344 304h32v8 24h24zM256 176h32v8 72H256V176z'
      
    ]
  };

  

  
  

  var faCloudWord = {
    prefix: 'fasr',
    iconName: 'cloud-word',
    icon: [
      640,
      512,
      [],
      'e138',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM144 288H336h16v32H336 144 128V288h16zm112 64v32H240 144 128V352h16 96 16zm256 0v32H496 304 288V352h16H496h16zM384 288h16 96 16v32H496 400 384V288z'
      
    ]
  };

  

  
  

  var faPhoneArrowDownLeft = {
    prefix: 'fasr',
    iconName: 'phone-arrow-down-left',
    icon: [
      512,
      512,
      ["phone-arrow-down","phone-incoming"],
      'e223',
      
      'M272.4 369.2l31.9 18.4 26-26 33.2-33.2L457.7 366l-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM489 57l17-17L472 6.1 455 23l-119 119V88 64H288V88 200v24h24H424h24V176H424 369.9L489 57z'
      
    ]
  };

  
    var faPhoneArrowDown = faPhoneArrowDownLeft;
  
    var faPhoneIncoming = faPhoneArrowDownLeft;
  

  
  

  var faOrnament = {
    prefix: 'fasr',
    iconName: 'ornament',
    icon: [
      384,
      512,
      [],
      'f7b8',
      
      'M224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96h64V64zM128 96V64c0-35.3 28.7-64 64-64s64 28.7 64 64V96h32v57.7c57.4 33.2 96 95.2 96 166.3c0 106-86 192-192 192S0 426 0 320c0-71.1 38.6-133.1 96-166.3V96h32zM84.7 224H299.3C273 194.5 234.6 176 192 176s-81 18.5-107.3 48zM56.2 272c-5.3 15-8.2 31.2-8.2 48s2.9 33 8.2 48H327.8c5.3-15 8.2-31.2 8.2-48s-2.9-33-8.2-48H56.2zM84.7 416c26.4 29.5 64.7 48 107.3 48s81-18.5 107.3-48H84.7z'
      
    ]
  };

  

  
  

  var faFileXml = {
    prefix: 'fasr',
    iconName: 'file-xml',
    icon: [
      512,
      512,
      [],
      'e654',
      
      'M48 464H96v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zM416 352v16V496v16H384V496 421.8l-17.9 33.7-13.9 26.2-14.3-26L320 423v73 16H288V496 368 352l16 0 4 0 9.5 0 4.6 8.3 29.7 54 28.5-53.8 4.5-8.5 9.6 0 5.6 0 16 0zm-224 0v16c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4V352h32v16c0 13.6-4 26.9-11.6 38.2L227.2 432l17.2 25.8C252 469.1 256 482.4 256 496v16H224V496c0-7.3-2.2-14.4-6.2-20.4L208 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4v16H160V496c0-13.6 4-26.9 11.6-38.2L188.8 432l-17.2-25.8C164 394.9 160 381.6 160 368V352h32zM448 512V496 368 352h32v16V480h16 16v32H496 464 448z'
      
    ]
  };

  

  
  

  var faCarSideBolt = {
    prefix: 'fasr',
    iconName: 'car-side-bolt',
    icon: [
      640,
      512,
      [],
      'e344',
      
      'M128 32H111.8l-6 15.1L47.8 192H0v48V352v48H48 65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H592h48V352 240 192H592 523.5L402.7 41l-7.2-9H384 128zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zm135.8-16c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H48V240h80V192H99.4L144.2 80H372.5l89.6 112H432v48H592V352H570.5zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32-112h88l-24 96L384 192H296l24-96L192 224z'
      
    ]
  };

  

  
  

  var faBrightness = {
    prefix: 'fasr',
    iconName: 'brightness',
    icon: [
      512,
      512,
      [],
      'e0c9',
      
      'M232 88v24h48V88 24 0H232V24 88zm24 120a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM0 232v48H24 88h24V232H88 24 0zm424 0H400v48h24 64 24V232H488 424zM232 512h48V488 424 400H232v24 64 24zM92 58L58 92l17 17 45.3 45.3 17 17 33.9-33.9-17-17L108.9 75 92 58zM391.8 357.8l-17-17-33.9 33.9 17 17L403.1 437l17 17L454 420l-17-17-45.3-45.3zM58 420L92 454l17-17 45.3-45.3 17-17-33.9-33.9-17 17L75 403.1 58 420zM357.8 120.2l-17 17 33.9 33.9 17-17L437 108.9l17-17L420 58l-17 17-45.3 45.3z'
      
    ]
  };

  

  
  

  var faBoxCircleCheck = {
    prefix: 'fasr',
    iconName: 'box-circle-check',
    icon: [
      576,
      512,
      [],
      'e0c4',
      
      'M59.6 160L95.2 80H200v80H59.6zM248 160V80H352.8l35.6 80H248zM48 208H358.6c22.3-10.3 47.2-16 73.4-16c5.4 0 10.7 .2 16 .7V176L384 32H64L0 176V432v48H48 296.2c-11.8-14.3-21.4-30.5-28.2-48H48V208zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336z'
      
    ]
  };

  

  
  

  var faShowerDown = {
    prefix: 'fasr',
    iconName: 'shower-down',
    icon: [
      384,
      512,
      ["shower-alt"],
      'e24d',
      
      'M216 0V24v9.8c77 11.6 136 78 136 158.2v16h8 24v48H360 328 56 24 0V208H24h8V192C32 111.8 91 45.4 168 33.8V24 0h48zm88 192c0-61.9-50.1-112-112-112S80 130.1 80 192v16H304V192zM256 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7L256 416zm36.2-79.3L320 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7zM128 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8C110.2 512 96 497.8 96 480.4c0-5.5 1.4-10.9 4.2-15.7L128 416zm36.2-79.3L192 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7zM64 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C96 369.8 81.8 384 64.4 384h-.8C46.2 384 32 369.8 32 352.4c0-5.5 1.4-10.9 4.2-15.7L64 288z'
      
    ]
  };

  
    var faShowerAlt = faShowerDown;
  

  
  

  var faPersonDigging = {
    prefix: 'fasr',
    iconName: 'person-digging',
    icon: [
      576,
      512,
      ["digging"],
      'f85e',
      
      'M304 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 352H288l-16 48-16 48h50.6H528h48V464L477.5 328.6 448 288l-30.1 40.2-17.5 23.3 0 0L308.1 313 254.5 167.7l-3.9-10.5-10.5-3.8-88-32-16.7-6.1-10.7 14.2L63.6 211.2l-22.4-9.3-22.2-9.2L.6 236.9l22.2 9.2 347.9 145L352 416zM109.3 230.2l43.2-57.6 60.8 22.1 34.3 93.1L109.3 230.2zM447.4 368.8L516.6 464H376l14.4-19.2 57-76zm-366-67.7L55.3 290l-6.6 27.6L1.9 512H51.2L88.7 356.4 176 393.5V488v24h48V488 377.6 361.7l-14.6-6.2-128-54.4z'
      
    ]
  };

  
    var faDigging = faPersonDigging;
  

  
  

  var faMouseField = {
    prefix: 'fasr',
    iconName: 'mouse-field',
    icon: [
      512,
      512,
      [],
      'e5a8',
      
      'M393.4 50.8C397.9 49 402.8 48 408 48c22.1 0 40 17.9 40 40c0 8.1-2.4 15.6-6.5 21.9c-10.4-5.3-21.7-9.1-33.6-11.4c-.9-17.4-6.1-33.7-14.5-47.8zm86.2 88.4C489.9 124.8 496 107.1 496 88c0-48.6-39.4-88-88-88c-18.4 0-35.5 5.7-49.6 15.3C342.5 5.6 323.9 0 304 0C246.6 0 200 46.6 200 104v3.2c0 20.8 6.2 40.6 17.2 57.3C143.1 182 88 248.6 88 328v40H72c-39.8 0-72 32.2-72 72s32.2 72 72 72H456h24V464H456 72c-13.3 0-24-10.7-24-24s10.7-24 24-24h40H344h24 24 24V368H392 368 344.2l32-80H488h24V264 224.3c0-32.6-12.2-62.4-32.4-85.1zM292.6 368H136V328c0-66.3 53.7-120 120-120h24l9.5-46.1-7.5-3.2c-20.6-8.8-33.9-29.1-33.9-51.5V104c0-30.9 25.1-56 56-56s56 25.1 56 56v16 22.2l22.2 1.7 8 .6c41.7 3.2 73.9 38 73.9 79.8V240H360 343.8l-6 15.1L292.6 368zM396 216a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  

  
  

  var faCoffeePot = {
    prefix: 'fasr',
    iconName: 'coffee-pot',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M0 32H24h98.4H192h24H428.9 480L462.5 80l-35.2 96.8C478.4 211.3 512 269.7 512 336v8c0 80-72 136-72 136H136s-72-56-72-136v-8c0-65.4 32.7-123.2 82.7-157.9L103.1 80H48V200v24H0V200 56 32zM191.2 160H382.4l29.1-80H216 192 155.6l35.6 80zM112.9 320H463.1c-5.4-48.9-35.3-90.4-77.1-112H190c-41.8 21.6-71.7 63.1-77.1 112zM421.4 432H154.6s0 0 0 0H421.4s0 0 0 0z'
      
    ]
  };

  

  
  

  var faPenFancy = {
    prefix: 'fasr',
    iconName: 'pen-fancy',
    icon: [
      512,
      512,
      [10002,128395],
      'f5ac',
      
      'M64 272l120-48L366.7 34.6 400 0l33.9 33.9 44.1 44.1L512 112l-34.6 33.3L288 328 240 448 32 512 0 480 64 272zm158.8-19.1l36.3 36.3L443.5 111.4 400.6 68.5 222.8 252.9zm-43.3 24.6L103.1 308 68.4 421 112 377.3c0-.4 0-.9 0-1.3c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24c-.4 0-.9 0-1.3 0L91 443.6l113-34.8 30.6-76.4-55-55z'
      
    ]
  };

  

  
  

  var faChartKanban = {
    prefix: 'fasr',
    iconName: 'chart-kanban',
    icon: [
      448,
      512,
      [],
      'e64f',
      
      'M368 432l0-352h32l0 352H368zm-48 48h48 32 48V432l0-352V32H400 368 320V80l0 352v48zM80 368H48L48 80H80l0 288zM48 416H80h48l0-48 0-288 0-48H80 48 0L0 80 0 368l0 48H48zM240 240H208l0-160h32l0 160zm-32 48h32l48 0V240 80 32H240 208l-48 0 0 48 0 160v48h48z'
      
    ]
  };

  

  
  

  var faHatWizard = {
    prefix: 'fasr',
    iconName: 'hat-wizard',
    icon: [
      512,
      512,
      [],
      'f6e8',
      
      'M368 192L410.5 64.4 432 0 371.3 30.4 176 128 48 416h52.5L212.9 163.2 349.8 94.8l-27.4 82.1-5.8 17.3 7.2 16.8L411.8 416H464L368 192zM237.7 416L248 392l56-24-56-24-24-56-24 56-56 24 56 24 10.3 24h27.4zM0 448v64H32 480h32V448H480 32 0zM256 256l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32z'
      
    ]
  };

  

  
  

  var faSquareKanban = {
    prefix: 'fasr',
    iconName: 'square-kanban',
    icon: [
      448,
      512,
      [],
      'e488',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM152 288H104V128h48V288zm144 64V128h48V352H296zm-48-96H200V128h48V256z'
      
    ]
  };

  

  
  

  var faGarageCar = {
    prefix: 'fasr',
    iconName: 'garage-car',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      'M320 6.1l9 3.7 296 120 15 6.1V152 488v24H592V488 168.2L320 57.9 48 168.2V488v24H0V488 152 135.8l15-6.1L311 9.8l9-3.7zM96 192h24H520h24v24V488v24H496V488 240H144V488v24H96V488 216 192zm159.1 80H384h18.1l5 17.4 16 56L425 352h7 24v24V488v24H408V488v-8H232v8 24H184V488 376 352h24 7.1l1.7-6.3 15.1-56 4.8-17.7h18.4zM408 400H232v32H408V400zm-33-48l-9.1-32H273.5l-8.6 32H375z'
      
    ]
  };

  

  
  

  var faTextWidth = {
    prefix: 'fasr',
    iconName: 'text-width',
    icon: [
      448,
      512,
      [],
      'f035',
      
      'M24 32L0 32 0 56l0 56 0 24 48 0 0-24 0-32 152 0 0 160-32 0-24 0 0 48 24 0 112 0 24 0 0-48-24 0-32 0 0-160 152 0 0 32 0 24 48 0 0-24 0-56 0-24-24 0L24 32zM429.8 401l17-17-17-17L369 306.2l-17-17-33.9 33.9 17 17L354.9 360 93.1 360 113 340.2l17-17L96 289.3l-17 17L18.2 367l-17 17 17 17L79 461.8l17 17 33.9-33.9-17-17L93.1 408l261.7 0L335 427.8l-17 17L352 478.7l17-17L429.8 401z'
      
    ]
  };

  

  
  

  var faPersonBooth = {
    prefix: 'fasr',
    iconName: 'person-booth',
    icon: [
      576,
      512,
      [],
      'f756',
      
      'M216 0H192V24 208h48V48h7.6l78.9 200.8L273.1 416.7l-10 31.3H296 528v40 24h48V488 448 424 24 0H552 264 228.8 216zM528 400H328.8l46-144.7 2.6-8.1-3.1-7.9L299.2 48H528V400zM192 320V488v24h48V488 320H192zM64 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM0 160v24V288v8.5l0 0V488v24H48V488 355.6l56 68.9V488v24h48V488 416v-8.5l-5.4-6.6L120 368.1V262.4L133.3 279l7.2 9H152h64 24V240H216 163.5l-56.8-71-7.2-9H88 24 0zM72 309L48 279.5V264 240h0V208H72V309z'
      
    ]
  };

  

  
  

  var faBanBug = {
    prefix: 'fasr',
    iconName: 'ban-bug',
    icon: [
      512,
      512,
      ["debug"],
      'f7f9',
      
      'M256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1L385.1 419.1C349.7 447.2 304.8 464 256 464zm80-161.9v-4.1l28.9 5.8 15.7 3.1 6.3-31.4-15.7-3.1-35.1-7V246.7l35.1-7 15.7-3.1-6.3-31.4-15.7 3.1L336 214.1V183.5l16.2-9.7 13.7-8.2L349.5 138l-13.7 8.2-18.4 11.1L288 128H224l-31 31L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L336 302.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3l-15.7 3.1 6.3 31.4 15.7-3.1 28.9-5.8v30.6l-16.2 9.7L146 346.5 162.5 374l13.7-8.2 18.4-11.1L224 384h64l2.7-2.7L175 265.5l-34.1 6.8z'
      
    ]
  };

  
    var faDebug = faBanBug;
  

  
  

  var faBridgeWater = {
    prefix: 'fasr',
    iconName: 'bridge-water',
    icon: [
      576,
      512,
      [],
      'e4ce',
      
      'M576 208V160 112 64H528 48 0v48 48 48c44.2 0 80 35.8 80 80v59.5L96 336l18.6 13.4 1.1 .8 0 0 0 0c4.4 3.2 8.5 6.1 12.3 8.7V288c0-53.7-33.1-99.7-80-118.7V112H528v57.3c-46.9 19-80 65-80 118.7v70.9c3.8-2.6 7.8-5.5 12.3-8.7l0 0L480 336l16 11.5V288c0-44.2 35.8-80 80-80zM352 272V376.3c10.7 4 21.8 6.7 32 6.7c5.2 0 10.5-.7 16-1.9V272c0-61.9-50.1-112-112-112s-112 50.1-112 112V381.1c5.5 1.2 10.8 1.9 16 1.9c10.2 0 21.3-2.7 32-6.7V272c0-35.3 28.7-64 64-64s64 28.7 64 64zM79 456.9c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V432c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4c-13 11.6-24.8 22.2-40.2 30.9C39.4 424.2 19.7 432 0 432v48c31.5 0 59.7-12.2 79-23.1z'
      
    ]
  };

  

  
  

  var faVentDamper = {
    prefix: 'fasr',
    iconName: 'vent-damper',
    icon: [
      640,
      512,
      [],
      'e465',
      
      'M528 112V400H112V112H528zM112 64H64v48 48H0V352H64v48 48h48H528h48V400 352h64V160H576V112 64H528 112zm72 80H160v48h24H456h24V144H456 184zm0 88H160v48h24H456h24V232H456 184zm0 88H160v48h24H456h24V320H456 184z'
      
    ]
  };

  

  
  

  var faMosquitoNet = {
    prefix: 'fasr',
    iconName: 'mosquito-net',
    icon: [
      640,
      512,
      [],
      'e52c',
      
      'M256 242.2v23.1l-59.3 59.3-4.7 4.7V336v44.2l-30.3 60.6-7.2 14.3 28.6 14.3 7.2-14.3 32-64 1.7-3.4V384l0-41.4 32-32v50l0 32h64v-32-50l32 32V336 297.4l-32-32V242.2l32 27.9V256h32V224h80 16 64 3c-11.7-9.9-26.3-16.5-42.4-18.5L344.7 181.6l49.6-41.3 8.4-7-3.5-10.4L385.4 81.6 414 30.2l7.8-14L393.8 .6l-7.8 14L354 72.2l-3.4 6.2 2.2 6.7 12.5 37.6L320 160.5V137.9v-32H296.2V63.7 55.5l-16.3 0v8.2 42.2l-23.8 0v32 22.6l-45.4-37.8 12.5-37.6 2.2-6.7L222 72.2 190 14.6l-7.8-14-28 15.5 7.8 14 28.6 51.4-13.8 41.3-3.5 10.4 8.4 7 49.6 41.3L71.4 205.5C30.6 210.6 0 245.2 0 286.3c0 72.6 87.8 109 139.2 57.6L256 242.2zM105.2 310C84.1 331.2 48 316.2 48 286.3c0-16.9 12.6-31.1 29.4-33.2c.4 0 .8-.1 1.1-.2l111.2-16.6-82 71.4c-.8 .7-1.6 1.5-2.4 2.3zM528 256H496v16 16H448V272 256H416v16 16H400 384v32h16 16v48H400 384v32h16 16v48H400 384v32h16 16v16 16h32V496 480h48v16 16h32V496 480h48v16 16h32V496 480h16 16V448H624 608V400h16 16V368H624 608V320h16 16V288H624 608V272 256H576v16 16H528V272 256zm0 64h48v48H528V320zm0 80h48v48H528V400zm-80-80h48v48H448V320zm0 80h48v48H448V400z'
      
    ]
  };

  

  
  

  var faRocketLaunch = {
    prefix: 'fasr',
    iconName: 'rocket-launch',
    icon: [
      512,
      512,
      [128640],
      'e027',
      
      'M197.9 253.9c32.2-113.5 86.9-164.1 137-186.9c43.8-20 90.1-21.4 126.8-16.6c4.8 36.6 3.4 82.9-16.6 126.8c-22.8 50-73.4 104.8-186.9 137c-6.4-12.9-14.8-24.7-25.2-35s-22.2-18.8-35-25.2zM44.4 287.7c1.2 .2 2.4 .3 3.6 .3h90.7c22.6 0 44.3 9 60.3 25s25 37.7 25 60.3l0 82.7c0 .1 0 .1 0 .2V512l160-80 0-119.9C527.5 223 520.4 80.2 502.7 9.3C431.8-8.4 289-15.5 199.9 128l-64.4 0c-.1 0-.2 0-.3 0L80 128 0 287.6l44.4 .1zM.5 511.5s116.5 8 166-41.5c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C-7.5 395 .5 511.5 .5 511.5zm64.1-64.1s-2.7-38.7 13.8-55.2c11.4-11.4 30-11.4 41.4 0s11.4 30 0 41.4c-16.5 16.5-55.2 13.8-55.2 13.8zM408 144a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngine = {
    prefix: 'fasr',
    iconName: 'starfighter-twin-ion-engine',
    icon: [
      576,
      512,
      ["starfighter-alt"],
      'e038',
      
      'M48 32V56 193.7l105.8-24.9C182.4 125 231.8 96 288 96s105.6 29 134.2 72.8L528 193.7V56 32h48V56 205v19 64 19V456v24H528V456 318.3L422.2 343.2C393.6 387 344.2 416 288 416s-105.6-29-134.2-72.8L48 318.3V456v24H0V456 307 288 224 205 56 32H48zM444.7 288.6L528 269V243l-83.3-19.6c2.2 10.5 3.3 21.4 3.3 32.6s-1.1 22.1-3.3 32.6zM48 269l83.3 19.6c-2.2-10.5-3.3-21.4-3.3-32.6s1.1-22.1 3.3-32.6L48 243v26zm224 97.9V334.4c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2zm-73.7-43.8l23-23c-5.6-8.4-9.6-17.9-11.7-28.1H177.1c2.7 19 10.2 36.4 21.2 51.1zM177.1 240h32.5c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1zm43.8-73.7l23 23c8.4-5.6 17.9-9.6 28.1-11.7V145.1c-19 2.7-36.4 10.2-51.1 21.2zM355.1 345.7l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7v32.5c19-2.7 36.4-10.2 51.1-21.2zm22.6-22.6c11-14.7 18.4-32.1 21.2-51.1H366.4c-2.1 10.2-6.1 19.7-11.7 28.1l23 23zm-23-111.2c5.6 8.4 9.6 17.9 11.7 28.1h32.5c-2.7-19-10.2-36.4-21.2-51.1l-23 23zm.3-45.6c-14.7-11-32.1-18.4-51.1-21.2v32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23zM310.6 278.6c5.8-5.8 9.4-13.8 9.4-22.6c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.3-9.2h-.5c-8.7 .1-16.5 3.6-22.3 9.2l-.3 .3c-5.7 5.8-9.2 13.7-9.2 22.5c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4z'
      
    ]
  };

  
    var faStarfighterAlt = faStarfighterTwinIonEngine;
  

  
  

  var faDiceSix = {
    prefix: 'fasr',
    iconName: 'dice-six',
    icon: [
      448,
      512,
      [9861],
      'f526',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngineAdvanced = {
    prefix: 'fasr',
    iconName: 'starfighter-twin-ion-engine-advanced',
    icon: [
      640,
      512,
      ["starfighter-alt-advanced"],
      'e28e',
      
      'M6.5 127.6l112-120 35.1 32.8L48 153.5V195l137.9-26.3C214.4 124.9 263.8 96 320 96s105.6 28.9 134.1 72.7L592 195V153.5L486.5 40.4 521.5 7.6l112 120 6.5 6.9V144v60.1V224v64 19.9V368v9.5l-6.5 6.9-112 120-35.1-32.7L592 358.5V317L454.1 343.3C425.6 387.1 376.2 416 320 416s-105.6-28.9-134.1-72.7L48 317v41.5L153.5 471.6l-35.1 32.7-112-120L0 377.5V368 307.9 288 224 204.1 144v-9.5l6.5-6.9zM48 268.1l115.7 22c-2.4-11-3.7-22.4-3.7-34.2s1.3-23.2 3.7-34.2L48 243.9v24.3zm428.3-46.3c2.4 11 3.7 22.4 3.7 34.2s-1.3 23.2-3.7 34.2l115.7-22V243.9l-115.7-22zM304 334.4c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2V334.4zm-50.7-34.3c-5.6-8.4-9.6-17.9-11.7-28.1H209.1c2.7 19 10.2 36.4 21.2 51.1l23-23zM241.6 240c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1h32.5zm34.3-50.7c8.4-5.6 17.9-9.6 28.1-11.7V145.1c-19 2.7-36.4 10.2-51.1 21.2l23 23zM336 366.9c19-2.7 36.4-10.2 51.1-21.2l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7v32.5zM430.9 272H398.4c-2.1 10.2-6.1 19.7-11.7 28.1l23 23c11-14.7 18.4-32.1 21.2-51.1zm-32.5-32h32.5c-2.7-19-10.2-36.4-21.2-51.1l-23 23c5.6 8.4 9.6 17.9 11.7 28.1zM336 145.1v32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23c-14.7-11-32.1-18.4-51.1-21.2zM352 256c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.2-9.2h-.5c-8.7 .1-16.5 3.6-22.2 9.2l-.3 .3c-5.7 5.8-9.2 13.7-9.2 22.5c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4s9.4-13.8 9.4-22.6z'
      
    ]
  };

  
    var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
  

  
  

  var faShieldVirus = {
    prefix: 'fasr',
    iconName: 'shield-virus',
    icon: [
      512,
      512,
      [],
      'e06c',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zm-149 13.9l-11.3 11.3C311.9 161.5 272 145 272 112V96H256 240v16c0 33-39.9 49.5-63.2 26.2l-11.3-11.3-11.3 11.3 0 0-11.3 11.3 11.3 11.3C177.5 184.1 161 224 128 224H112v16 16h16c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 11.3 11.3 0 0 11.3 11.3 11.3-11.3C200.1 318.5 240 335 240 368v16h16 16V368c0-33 39.9-49.5 63.2-26.2l11.3 11.3 11.3-11.3 11.3-11.3-11.3-11.3C334.5 295.9 351 256 384 256h16V240 224H384c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-11.3-11.3-11.3-11.3zM232 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faConveyorBeltBoxes = {
    prefix: 'fasr',
    iconName: 'conveyor-belt-boxes',
    icon: [
      640,
      512,
      ["conveyor-belt-alt"],
      'f46f',
      
      'M304 48V208H144V48H304zM144 0H96V48 208v48h48H304h48V208 48 0H304 144zM528 112v96H432V112h96zM432 64H384v48 96 48h48 96 48V208 112 64H528 432zm96 272c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64H528zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H112zm48 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faConveyorBeltAlt = faConveyorBeltBoxes;
  

  
  

  var faLaptopMobile = {
    prefix: 'fasr',
    iconName: 'laptop-mobile',
    icon: [
      640,
      512,
      ["phone-laptop"],
      'f87a',
      
      'M112 48H464V96h48V48 0H464 112 64V48 320H0v32l32 32H352V320H112V48zm272 80v48V464v48h48H592h48V464 176 128H592 432 384zm48 48H592V464H432V176z'
      
    ]
  };

  
    var faPhoneLaptop = faLaptopMobile;
  

  
  

  var faDoorClosed = {
    prefix: 'fasr',
    iconName: 'door-closed',
    icon: [
      576,
      512,
      [128682],
      'f52a',
      
      'M432 48V464H144V48H432zm48 416V48 0H432 144 96V48 464H24 0v48H24 96h48H432h48 72 24V464H552 480zM368 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faDialLow = {
    prefix: 'fasr',
    iconName: 'dial-low',
    icon: [
      576,
      512,
      [],
      'e15d',
      
      'M320 0H256V64h64V0zM128 64H64v64h64V64zm384 0H448v64h64V64zm0 192v64h64V256H512zm0 192H448v64h64V448zM64 448v64h64V448H64zM0 256v64H64V256H0zM288 400c-53.6 0-98.4-37.7-109.4-88H288h24V264H288 178.6c11-50.3 55.8-88 109.4-88c61.9 0 112 50.1 112 112s-50.1 112-112 112zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0z'
      
    ]
  };

  

  
  

  var faOctagonExclamation = {
    prefix: 'fasr',
    iconName: 'octagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e204',
      
      'M48 332.1V179.9L179.9 48H332.1L464 179.9V332.1L332.1 464H179.9L48 332.1zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM280 128H232v24V264v24h48V264 152 128zM232 320v48h48V320H232z'
      
    ]
  };

  

  
  

  var faArrowUp19 = {
    prefix: 'fasr',
    iconName: 'arrow-up-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-up"],
      'f163',
      
      'M360 32V80h24 24v96H384 360v48h24 48 48 24V176H480 456V56 32H432 384 360zM160 33.3l-17 17-96 96-17 17L64 197.1l17-17 55-55V456v24h48V456 125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM464 344a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm48 0c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 45 33.7 82.1 77.3 87.4l-24.8 34.7-10 13.9h59l56.1-78.5c12-16.8 18.4-36.9 18.4-57.5z'
      
    ]
  };

  
    var faSortNumericUp = faArrowUp19;
  

  
  

  var faPipeCircleCheck = {
    prefix: 'fasr',
    iconName: 'pipe-circle-check',
    icon: [
      640,
      512,
      [],
      'e436',
      
      'M48 96v24 8H320 464v-8V96h48v24 32 40.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9V176H320 48V336H322.9c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16H48v8 24H0V392 360 152 120 96H48zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faUserGear = {
    prefix: 'fasr',
    iconName: 'user-gear',
    icon: [
      640,
      512,
      ["user-cog"],
      'f4fe',
      
      'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM65 464H342.8l24.1 41.7L404 484.3V512h-6.2H50.2 0l14.8-48L64 304H305.4l-15.5 26.9L326 351.7l-.5 .3H99.5L65 464zM436 206.4h88.1v42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8V497H436V454.8c-8-3.4-15.6-7.7-22.5-12.9l-34.9 20.1-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9V206.4zm92.1 145.3a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z'
      
    ]
  };

  
    var faUserCog = faUserGear;
  

  
  

  var faPuzzle = {
    prefix: 'fasr',
    iconName: 'puzzle',
    icon: [
      512,
      512,
      [],
      'e443',
      
      'M512 0V208H432v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V208l-64 0V144h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304V0H512zM0 240V64H224v80h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v80H160V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H48V464H224V416H208c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V288h80v32c0 17.7 14.3 32 32 32s32-14.3 32-32V288h80V512H256 224 24 0V488 288 240z'
      
    ]
  };

  

  
  

  var faSquareHeart = {
    prefix: 'fasr',
    iconName: 'square-heart',
    icon: [
      448,
      512,
      [128159,"heart-square"],
      'f4c8',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM115.3 271.2c-13.4-13.4-20.9-31.5-20.9-50.4v-3.2c0-37.6 30.5-68.1 68.1-68.1c20.7 0 40.2 9.4 53.2 25.6l8.4 10.4 8.4-10.4c12.9-16.1 32.5-25.6 53.2-25.6c37.6 0 68.1 30.5 68.1 68.1v3.2c0 18.9-7.5 37-20.9 50.4l-22.3 22.3 0 0L224 379.9l0 0 0 0-86.4-86.4 0 0-22.3-22.3z'
      
    ]
  };

  
    var faHeartSquare = faSquareHeart;
  

  
  

  var faSquare5 = {
    prefix: 'fasr',
    iconName: 'square-5',
    icon: [
      448,
      512,
      [],
      'e25a',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm176 96H280h24v48H280 197.9L194 218.9l56 6.7c39.9 4.8 70 38.7 70 78.9c0 43.9-35.6 79.5-79.5 79.5h-33c-29.8 0-57.1-16.4-71.2-42.6l-5.4-10 42.3-22.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3h33c17.4 0 31.5-14.1 31.5-31.5c0-15.9-11.9-29.3-27.7-31.2l-79.1-9.5L142 261.1l2.1-23.2 8-88 2-21.8H176z'
      
    ]
  };

  

  
  

  var faHouseBlank = {
    prefix: 'fasr',
    iconName: 'house-blank',
    icon: [
      576,
      512,
      ["home-blank"],
      'e487',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 488h24V488 253.5l24.5 20.8 31.1-36.6-264-224zM464 212.8V464H112V212.8L288 63.5 464 212.8z'
      
    ]
  };

  
    var faHomeBlank = faHouseBlank;
  

  
  

  var faLightbulbSlash = {
    prefix: 'fasr',
    iconName: 'lightbulb-slash',
    icon: [
      640,
      512,
      [],
      'f673',
      
      'M425.2 248.9C439.6 228.3 448 203.2 448 176c0-70.7-57.3-128-128-128c-55.3 0-102.5 35.1-120.3 84.2l41.2 32c5.7-38.6 39-68.2 79.1-68.2v32c-26.5 0-48 21.5-48 48H256L398.2 286.4c4.9-6.9 9.7-13.5 14.2-19.7l0 0 0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zm11 66.9L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 112 86.9C188.4 41.7 249.3 0 320 0c97.2 0 176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0 0 0 0 0c-4.4 6-8.8 12-13.1 18.1zM400 424.9V512H240V416H388.7l11.3 8.9zM152.4 229.8l108.5 85.5c2.3 3.7 4.4 7.5 6.5 11.2c10.4 19 15.7 38.8 18.3 57.5H237c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4c-9.8-14.1-17.6-29.8-23-46.6z'
      
    ]
  };

  

  
  

  var faBooksMedical = {
    prefix: 'fasr',
    iconName: 'books-medical',
    icon: [
      576,
      512,
      [],
      'f7e8',
      
      'M112 416v48h64V416H112zm64 96H112 64V464 416 392v-8H176V368 320h48v48h64V144H224v48H176V144 128H64v-8V96 48 0h48 64 48 64 48V30.1l11.2-3 54.9-14.7L448.4 0l12.4 46.4 11 41.2 6.2 23.2 6.2 23.2 54.8 204.6 6.2 23.2 6.2 23.2 11 41.2L575 472.4l-46.4 12.4-54.9 14.7L427.4 512 415 465.6l-11-41.2-6.2-23.2-6.2-23.2L336.7 173.5l-.7-2.5V368v24 24 48 48H288 224 176zm48-48h64V416H224v48zM176 48H112V96h64V48zm48 48h64V48H224V96zM461.3 453.2l54.9-14.7-11-41.2L450.3 412l11 41.2zm-23.5-87.5L492.8 351 438 146.3 383 161l54.8 204.6zm-67.3-251L425.5 100l-11-41.2L359.6 73.5l11 41.2zM64 160h64v64h64v64H128v64H64V288H0V224H64V160z'
      
    ]
  };

  

  
  

  var faKeyboardBrightness = {
    prefix: 'fasr',
    iconName: 'keyboard-brightness',
    icon: [
      640,
      512,
      [],
      'e1c0',
      
      'M129 167l-17-17L78.1 184l17 17 80 80 17 17L225.9 264l-17-17-80-80zm167 33v24h48V200 88 64H296V88 200zm135 47l-17 17L448 297.9l17-17 80-80 17-17L528 150.1l-17 17-80 80zM0 368v48H24h80 24V368H104 24 0zm216 0H192v48h24H424h24V368H424 216zm320 0H512v48h24 80 24V368H616 536z'
      
    ]
  };

  

  
  

  var faHeadSideVirus = {
    prefix: 'fasr',
    iconName: 'head-side-virus',
    icon: [
      512,
      512,
      [],
      'e064',
      
      'M112 361.7v19.6V448v16 48H96 64V480 464 381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1V264v24 16 32H496 480 464 448v48 16 16 32H416 400 368 320v16 16 16 16H288 272V464 448 400h48 80V336 288h48 16V270.1l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48H224C126.8 48 48 127 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM314.5 110.9l11.3 11.3 11.3 11.3-11.3 11.3C302.5 168.1 319 208 352 208h16v16 16H352c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3C279.9 302.5 240 319 240 352v16H224 208V352c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-11.3-11.3 0 0-11.3-11.3 11.3-11.3C145.5 279.9 129 240 96 240H80V224 208H96c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 11.3-11.3 0 0 11.3-11.3 11.3 11.3C168.1 145.5 208 129 208 96V80h16 16V96c0 33 39.9 49.5 63.2 26.2l11.3-11.3zM200 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faRectangleCode = {
    prefix: 'fasr',
    iconName: 'rectangle-code',
    icon: [
      512,
      512,
      [],
      'e322',
      
      'M464 80V432H48V80H464zM48 32H0V80 432v48H48 464h48V432 80 32H464 48zM270.1 192l17 17 47 47-47 47-17 17L304 353.9l17-17 64-64 17-17-17-17-64-64-17-17L270.1 192zM225 209l17-17L208 158.1l-17 17-64 64-17 17 17 17 64 64 17 17L241.9 320l-17-17-47-47 47-47z'
      
    ]
  };

  

  
  

  var faTrafficLightSlow = {
    prefix: 'fasr',
    iconName: 'traffic-light-slow',
    icon: [
      320,
      512,
      [],
      'f639',
      
      'M48 48V352c0 61.9 50.1 112 112 112s112-50.1 112-112V48H48zM0 0H48 272h48V48 352c0 88.4-71.6 160-160 160S0 440.4 0 352V48 0zM144 376a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-120a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM144 136a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faKiwiFruit = {
    prefix: 'fasr',
    iconName: 'kiwi-fruit',
    icon: [
      448,
      512,
      [],
      'e30c',
      
      'M399.8 265.3C358.7 298.6 295.3 320 224 320s-134.7-21.4-175.8-54.7C53.1 358.2 129.9 432 224 432s170.9-73.8 175.8-166.7zM448 176v80c0 123.7-100.3 224-224 224S0 379.7 0 256V176C0 96.5 100.3 32 224 32s224 64.5 224 144zM224 64H208V80v24 16h16 16V104 80 64H224zM64 176v16H80h32 16V176 160H112 80 64v16zm256 0v16h16 32 16V176 160H368 336 320v16zm-96 56H208v16 24 16h16 16V272 248 232H224zM139.3 92.7L128 81.4 105.4 104l11.3 11.3 8 8L136 134.6 158.6 112l-11.3-11.3-8-8zm192 22.6L342.6 104 320 81.4 308.7 92.7l-8 8L289.4 112 312 134.6l11.3-11.3 8-8zm-184 136L158.6 240 136 217.4l-11.3 11.3-8 8L105.4 248 128 270.6l11.3-11.3 8-8zm176-22.6L312 217.4 289.4 240l11.3 11.3 8 8L320 270.6 342.6 248l-11.3-11.3-8-8zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24s25.1 24 56 24s56-10.7 56-24z'
      
    ]
  };

  

  
  

  var faPawClaws = {
    prefix: 'fasr',
    iconName: 'paw-claws',
    icon: [
      512,
      512,
      [],
      'f702',
      
      'M320 0l53.1 58.4c17.3 19 26.9 43.9 26.9 69.6h0c.2 11.3-1.5 23.2-5.5 35.1c-14.3 42.9-52.1 69.1-84.4 58.5s-46.9-53.9-32.6-96.8c8.2-24.7 24.2-43.8 42.5-53.6V0zM226.5 124.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.5-35.1h0c0-25.7 9.6-50.6 26.9-69.6L184 0V71.2c18.3 9.8 34.3 28.9 42.5 53.6zM100.4 230.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3C3.7 267.8-.1 253.3 0 240H0v-3.2c0-13.5 4.3-26.7 12.2-37.6L64 128v68.8c13.9 6.1 27.1 17.8 36.4 33.7zM256 414.5l11.6 2.9 125.3 31.3c-10.1-42.6-29.8-74.7-51.7-97.7C307.8 316 271.6 304 256 304s-51.8 12-85.2 47.1c-21.9 23-41.6 55.1-51.7 97.7l125.3-31.3 11.6-2.9zM112.2 499.9L64 512c0-17.8 1.3-34.6 3.7-50.4C89.2 320.7 198.5 256 256 256s166.8 64.7 188.3 205.6c2.4 15.8 3.7 32.6 3.7 50.4l-48.2-12.1L256 464 112.2 499.9zM421.8 314.7c-24.5-14-29.1-51.7-10.2-84.1c9.3-15.9 22.4-27.6 36.4-33.7V128l51.8 71.2c8 10.9 12.2 24.1 12.2 37.6V240h0c.1 13.3-3.7 27.8-11.6 41.4c-18.9 32.4-54 47.3-78.5 33.3z'
      
    ]
  };

  

  
  

  var faBorderInner = {
    prefix: 'fasr',
    iconName: 'border-inner',
    icon: [
      448,
      512,
      [],
      'f84e',
      
      'M384 480l0-64 64 0 0 64-64 0zm0-96l0-64 64 0 0 64-64 0zM0 384l0-64 64 0 0 64L0 384zM448 192l-64 0 0-64 64 0 0 64zM0 192l0-64 64 0 0 64L0 192zM448 96l-64 0 0-64 64 0 0 64zM64 96L0 96 0 32l64 0 0 64zM0 480l0-64 64 0 0 64L0 480zM352 96l-64 0 0-64 64 0 0 64zM288 480l0-64 64 0 0 64-64 0zM160 96L96 96l0-64 64 0 0 64zM96 480l0-64 64 0 0 64-64 0zm104 0l0-24 0-176L24 280 0 280l0-48 24 0 176 0 0-176 0-24 48 0 0 24 0 176 176 0 24 0 0 48-24 0-176 0 0 176 0 24-48 0z'
      
    ]
  };

  

  
  

  var faToothbrush = {
    prefix: 'fasr',
    iconName: 'toothbrush',
    icon: [
      576,
      512,
      [129701],
      'f635',
      
      'M48 160c0-8.8 7.2-16 16-16H288c16.6 0 33.4-3.7 48.3-13.4c15-9.8 24.3-23.1 29.8-35.8c1-2.2 1.8-4.5 2.6-6.7c4.9 2.1 9.4 4.5 13.2 7.2c12 8.3 18 18.5 18 32.8c0 26.5-21.5 48-48 48H64 48V160zM376 39.5c-15.4-5-31.9-7.5-48-7.5c0 30.8-2.3 64-40 64H64C28.7 96 0 124.7 0 160v16 48H48 64 352c53 0 96-43 96-96c0-46.4-32.5-75.7-72-88.5zM80 280V256H32v24V432H24 0v48H24 56h80 80 80 80H552h24V432H552 400V280 256H352v24V432H320V280 256H272v24V432H240V280 256H192v24V432H160V280 256H112v24V432H80V280z'
      
    ]
  };

  

  
  

  var faCalendarCirclePlus = {
    prefix: 'fasr',
    iconName: 'calendar-circle-plus',
    icon: [
      576,
      512,
      [],
      'e470',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48H432 400 352 48V464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 192 144 64H104V24 0h48zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  

  
  

  var faRampLoading = {
    prefix: 'fasr',
    iconName: 'ramp-loading',
    icon: [
      448,
      512,
      [],
      'f4d4',
      
      'M80 48H368V312.4l48 88V48 0H368 80 32V48 400.4l48-88V48zm64 240H129.8l-6.8 12.5-96 176L7.6 512H48 400h40.4l-19.4-35.5-96-176L318.2 288H304 144zM88.4 464l69.8-128H289.8l69.8 128H88.4z'
      
    ]
  };

  

  
  

  var faNarwhal = {
    prefix: 'fasr',
    iconName: 'narwhal',
    icon: [
      640,
      512,
      [],
      'f6fe',
      
      'M587.4 210.5C619.9 242.4 640 286.9 640 336c0 97.2-78.8 176-176 176H232c-54.1 0-102-26.9-130.9-68c-15.4-21.9-25.5-47.9-28.3-76c-.5-5.3-.8-10.6-.8-16V272 260L0 224V96l96 48 96-48V224l-72 36v12 34.9V352v16l1-.8 47-37L323.2 207.9c39.4-31 88-47.9 138.2-47.9H464c16.6 0 32.6 2.3 47.9 6.6L640 0 587.4 210.5zM232 464H464c70.7 0 128-57.3 128-128s-57.3-128-128-128h-2.6c-39.4 0-77.6 13.2-108.5 37.6L149.7 405.7l-10.8 8.5C159 444.2 193.2 464 232 464zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faTableLayout = {
    prefix: 'fasr',
    iconName: 'table-layout',
    icon: [
      512,
      512,
      [],
      'e290',
      
      'M464 80v80H48V80H464zM48 432V208h96V432H48zm144 0V208H464V432H192zM48 32H0V80 432v48H48 464h48V432 80 32H464 48z'
      
    ]
  };

  

  
  

  var faChildReaching = {
    prefix: 'fasr',
    iconName: 'child-reaching',
    icon: [
      384,
      512,
      [],
      'e59d',
      
      'M192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 192 0a72 72 0 1 0 0 144zM96.5 224h14H112V488v24h48V488 384h64V488v24h48V488 224h13.8l6.9-11.9 56-96 12.1-20.7L319.4 71.2 307.3 91.9 258.2 176H124.5L76.9 92.2 65 71.3 23.3 95l11.8 20.9 54.5 96L96.5 224zM224 336H160V224h64V336z'
      
    ]
  };

  

  
  

  var faCalendarXmark = {
    prefix: 'fasr',
    iconName: 'calendar-xmark',
    icon: [
      448,
      512,
      ["calendar-times"],
      'f273',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zm-95 89l-47 47 47 47 17 17L288 425.9l-17-17-47-47-47 47-17 17L126.1 392l17-17 47-47-47-47-17-17L160 230.1l17 17 47 47 47-47 17-17L321.9 264l-17 17z'
      
    ]
  };

  
    var faCalendarTimes = faCalendarXmark;
  

  
  

  var faComputerMouseScrollwheel = {
    prefix: 'fasr',
    iconName: 'computer-mouse-scrollwheel',
    icon: [
      384,
      512,
      ["mouse-alt"],
      'f8cd',
      
      'M224 464c61.9 0 112-50.1 112-112V48H48V352c0 61.9 50.1 112 112 112h64zM0 0H48 336h48V48 352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V48 0zM224 96v96H160V96h64z'
      
    ]
  };

  
    var faMouseAlt = faComputerMouseScrollwheel;
  

  
  

  var faPhone = {
    prefix: 'fasr',
    iconName: 'phone',
    icon: [
      512,
      512,
      [128222,128379],
      'f095',
      
      'M304.3 387.5l-31.9-18.4c-53.8-31-98.6-75.8-129.6-129.6l-18.4-31.9 26-26 33.2-33.2L146 54.2 48.1 72c4.2 214.5 177.4 387.6 391.9 391.9L457.7 366l-94.2-37.7-33.2 33.2-26 26zM352 272l160 64L480 512H448C200.6 512 0 311.4 0 64L0 32 176 0l64 160-55.6 55.6c26.8 46.5 65.5 85.2 112 112L352 272z'
      
    ]
  };

  

  
  

  var faFaceGrinTears = {
    prefix: 'fasr',
    iconName: 'face-grin-tears',
    icon: [
      640,
      512,
      [128514,"grin-tears"],
      'f588',
      
      'M517.7 320.9c1.2 4 2.4 8 3.8 11.8c3 8.2 8 20 16.6 28.7c3.4 3.4 7.1 6.5 10.9 9.1C507 454.4 420.2 512 320 512s-187-57.6-229.1-141.5c3.8-2.6 7.5-5.7 10.9-9.1c8.7-8.7 13.7-20.5 16.6-28.7c1.4-3.8 2.7-7.8 3.8-11.8C149.6 404 227.8 464 320 464s170.4-60 197.7-143.1zM523.8 214C504.3 119.3 420.5 48 320 48s-184.3 71.3-203.8 166l-16.6 2.3-.1 0c-7.4 1-19.7 2.7-33.2 5.1C83.2 96.4 190.3 0 320 0S556.8 96.4 573.7 221.5c-13.5-2.4-25.8-4.1-33.2-5.1l-.1 0L523.8 214zM576 254.5c21.1 4.2 42.9 10.1 50.8 18c17.9 18 17.5 47.3-.7 65.6c-17.8 17.9-46.2 18.6-64.2 1.8c-.4-.4-.7-.7-1.1-1.1c-8.7-8.8-15.2-34.6-19.5-57.7c-2.5-13.2-4.2-25.4-5.3-33.1c7.6 1.1 19.9 2.8 33.1 5.1c2.3 .4 4.6 .9 6.9 1.3zM98.7 281.1c-4.3 23.1-10.8 48.9-19.5 57.7c-.4 .4-.7 .7-1.1 1.1c-17.9 16.8-46.4 16.1-64.2-1.8c-18.2-18.3-18.6-47.6-.7-65.6c7.9-7.9 29.7-13.9 50.8-18c2.3-.5 4.6-.9 6.9-1.3c13.2-2.4 25.5-4.1 33.1-5.1c-1.1 7.6-2.8 19.9-5.3 33.1zm221.2 37.8c50.3 0 97.2-8.6 136.5-23.5C442.6 355.2 386.7 400 319.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM240 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z'
      
    ]
  };

  
    var faGrinTears = faFaceGrinTears;
  

  
  

  var faSpinnerThird = {
    prefix: 'fasr',
    iconName: 'spinner-third',
    icon: [
      512,
      512,
      [],
      'f3f4',
      
      'M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0V48c114.9 0 208 93.1 208 208c0 37.9-10.1 73.4-27.8 104l41.6 24z'
      
    ]
  };

  

  
  

  var faLungsVirus = {
    prefix: 'fasr',
    iconName: 'lungs-virus',
    icon: [
      640,
      512,
      [],
      'e067',
      
      'M344 24V144H296V24 0h48V24zM256 144v44.1l-26.5-26.5L208 183.1V144H176.3c-20.3 28.4-39.1 57.7-56.4 87.9C82.7 297 48 363.3 48 423c0 22.6 18.3 41 41 41c20.5 0 43.8-4.9 71.1-12.7c8.9-2.6 19.1-5.7 29.9-9l2.6-.8L231 479.9c-8 2.4-16.1 4.9-24.3 7.4l0 0C167.8 499.4 127.2 512 89 512c-49.1 0-89-39.8-89-89c0-74.6 42.3-152 78.2-214.9C100.5 169.2 125.1 131.8 152 96h56 48v48zM433.3 487.3c-8.2-2.5-16.3-5.1-24.3-7.4l38.5-38.4 2.6 .8c10.7 3.3 21 6.5 29.9 9c27.3 7.8 50.6 12.7 71.1 12.7c22.6 0 41-18.3 41-41c0-59.7-34.7-126-71.9-191.1c-17.3-30.3-36.1-59.6-56.4-87.9H432v39.1l-21.5-21.5L384 188.1V144 96h48 56c26.9 35.8 51.5 73.2 73.8 112.1C597.7 271.1 640 348.4 640 423c0 49.1-39.8 89-89 89c-38.2 0-78.8-12.6-117.7-24.7zM410.5 206.9l11.3 11.3 11.3 11.3-11.3 11.3C398.5 264.1 415 304 448 304h16v16 16H448c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3C375.9 398.5 336 415 336 448v16H320 304V448c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-11.3-11.3 0 0-11.3-11.3 11.3-11.3C241.5 375.9 225 336 192 336H176V320 304h16c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 11.3-11.3 0 0 11.3-11.3 11.3 11.3C264.1 241.5 304 225 304 192V176h16 16v16c0 33 39.9 49.5 63.2 26.2l11.3-11.3zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faUsersBetweenLines = {
    prefix: 'fasr',
    iconName: 'users-between-lines',
    icon: [
      640,
      512,
      [],
      'e591',
      
      'M0 0H24 616h24V48H616 24 0V0zM0 464H24 616h24v48H616 24 0V464zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 256H203.4l-7.8 20.8L167.4 352H32l32-96zm411.8 96l-28.2-75.2L439.8 256H576l32 96H475.8zm-58.2-64l24 64 6 16 18 48H414.3 228.9 177.6l18-48 6-16L224 292.3l1.6-4.3H416h1.6zm17.6-128a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM246.9 368H396.3l-12-32H258.9l-12 32z'
      
    ]
  };

  

  
  

  var faChildDress = {
    prefix: 'fasr',
    iconName: 'child-dress',
    icon: [
      320,
      512,
      [],
      'e59c',
      
      'M136 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm96 0A72 72 0 1 0 88 72a72 72 0 1 0 144 0zM116.9 160H105.5l-7.2 8.8L.6 288.8l37.2 30.3 47.1-57.9L49.2 368.4 38.7 400H72 96v88 24h48V488 400h32v88 24h48V488 400h24 33.3l-10.5-31.6L235.1 261.3l47.1 57.9 37.2-30.3-97.7-120-7.2-8.8H203.1h-1.8H184 136 118.7h-1.8zM105.3 352l48-144h13.4l48 144H105.3z'
      
    ]
  };

  

  
  

  var faCardClub = {
    prefix: 'fasr',
    iconName: 'card-club',
    icon: [
      384,
      512,
      [],
      'e3e9',
      
      'M48 48V464H336V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM256 192c0 5.6-.7 11.1-2.1 16.3c28.2 2.9 50.1 26.8 50.1 55.7c0 30.9-25.1 56-56 56c-15.7 0-29.8-6.4-40-16.8V336h16 16v32H224 208 176 160 144V336h16 16V303.2c-10.2 10.4-24.3 16.8-40 16.8c-30.9 0-56-25.1-56-56c0-28.9 21.9-52.7 50.1-55.7c-1.4-5.2-2.1-10.7-2.1-16.3c0-35.3 28.7-64 64-64s64 28.7 64 64z'
      
    ]
  };

  

  
  

  var faRulerTriangle = {
    prefix: 'fasr',
    iconName: 'ruler-triangle',
    icon: [
      512,
      512,
      [128208],
      'f61c',
      
      'M48 464V67.9l66.7 66.7-14.1 14.1L89.4 160 112 182.6l11.3-11.3 14.1-14.1 57.4 57.4-14.1 14.1L169.4 240 192 262.6l11.3-11.3 14.1-14.1 57.4 57.4-14.1 14.1L249.4 320 272 342.6l11.3-11.3 14.1-14.1 57.4 57.4-14.1 14.1L329.4 400 352 422.6l11.3-11.3 14.1-14.1L444.1 464H48zM0 0V48 464v48H48 464h48V464L48 0H0zM128 256V384H256L128 256z'
      
    ]
  };

  

  
  

  var faHousePersonLeave = {
    prefix: 'fasr',
    iconName: 'house-person-leave',
    icon: [
      640,
      512,
      ["house-leave","house-person-depart"],
      'e00f',
      
      'M480 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM402.6 201.5l-20.5 47.9-9.5 22.1-44.1-18.9 9.5-22.1 24-56 3.5-8.1 7.9-3.9 80-40 8.2-4.1 8.8 2.4 88 24 13.2 3.6 3.6 13.2 22.3 81.9L633 279 599 313l-40-40-4.5-4.5-1.7-6.1-6.4-23.4-25.7 82.3 54.4 44.2 6.2 5 1.9 7.8 24 96 5.8 23.3-46.6 11.6-5.8-23.3-22.1-88.2L434 312.6c-18.1-14.7-25.2-39.1-17.8-61.2l22.7-68-36.3 18.2zm59.2 65.1c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3 32.4-103.8c.2-.8 .5-1.6 .9-2.3l-22.1-6-30 90.1zM395.5 402.5l24.1-60.4 39 31.7-20.4 51.1-1.8 4.6L433 433l-60.8 60.8-17 17-33.9-33.9 17-17 57.3-57.3zM255 13.3L387.8 119.5l-47.2 23.6 0 .1L240 62.7 112 165.1V368H352h16 6.9l-6.6 16.5L336.8 416H88 64V392 203.5l-9 7.2-18.7 15-30-37.5 18.7-15 200-160 15-12 15 12zM160 192h96v96H160V192z'
      
    ]
  };

  
    var faHouseLeave = faHousePersonLeave;
  
    var faHousePersonDepart = faHousePersonLeave;
  

  
  

  var faLeftFromBracket = {
    prefix: 'fasr',
    iconName: 'left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e66c',
      
      'M224 224l-48 0 0-48 0-28.1L67.9 256 176 364.1l0-28.1 0-48 48 0 80 0 0-64-80 0zM33.9 222.1L160 96l16 0 48 0 0 32 0 16 0 32 48 0 32 0 48 0 0 48 0 64 0 48-48 0-32 0-48 0 0 32 0 16 0 32-48 0-16 0L33.9 289.9 0 256l33.9-33.9zM344 432l120 0 0-352L344 80l-24 0 0-48 24 0 144 0 24 0 0 24 0 400 0 24-24 0-144 0-24 0 0-48 24 0z'
      
    ]
  };

  

  
  

  var faMarsDouble = {
    prefix: 'fasr',
    iconName: 'mars-double',
    icon: [
      640,
      512,
      [9891],
      'f227',
      
      'M288 32h24H424h24V56 168v24H400V168 113.9l-83.7 83.7C338.7 227.2 352 264.1 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L366.1 80H312 288V32zM176 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm128 36c14.3-11.2 27.1-24.2 38-38.6c8.4 1.7 17.1 2.6 26 2.6c70.7 0 128-57.3 128-128c0-22.5-5.8-43.6-16-62l0-50V168v-9.9L558.1 80H504 480V56 32h24H616h24V56 168v24H592V168 113.9l-83.7 83.7C530.7 227.2 544 264.1 544 304c0 97.2-78.8 176-176 176c-22.6 0-44.2-4.3-64-12z'
      
    ]
  };

  

  
  

  var faLocationCrosshairs = {
    prefix: 'fasr',
    iconName: 'location-crosshairs',
    icon: [
      512,
      512,
      ["location"],
      'f601',
      
      'M280 0V24 65.5C366.8 76.3 435.7 145.2 446.5 232H488h24v48H488 446.5C435.7 366.8 366.8 435.7 280 446.5V488v24H232V488 446.5C145.2 435.7 76.3 366.8 65.5 280H24 0V232H24 65.5C76.3 145.2 145.2 76.3 232 65.5V24 0h48zM112 256a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm192 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faLocation = faLocationCrosshairs;
  

  
  

  var faChessQueenPiece = {
    prefix: 'fasr',
    iconName: 'chess-queen-piece',
    icon: [
      256,
      512,
      ["chess-queen-alt"],
      'f446',
      
      'M128 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 208H16v48H40 54.7l-4 96h48l4-96h50.6l4 96h48l-4-96H216h24V208H216h-8.9L240 133.6l14.1-31.8 1.9-4.4L232 80.7c-1.4 1.5-2.9 2.9-4.4 4.1c-7.3 6-15.3 9.3-22.5 9.1c-3.6-.1-7-1-10-2.9C188.5 87 184 78.2 184 64H152c0 11.4-5.9 18.8-13.6 22.1c-6.5 2.8-14.2 2.8-20.7 0C109.9 82.8 104 75.4 104 64H72c0 14.2-4.5 23-11 27.1C58 93 54.6 93.9 51 94c-7.2 .1-15.3-3.1-22.5-9.1c-1.5-1.3-3-2.6-4.4-4.1L0 97.4l1.9 4.4L16 133.6 48.9 208H40zm116.1-3.4l-1.5 3.4H101.4l-1.5-3.4-29-65.6c8-2.5 15.4-6.4 21.9-11.6c11.3 6.2 23.7 8.9 35.3 8.9s24-2.7 35.3-8.9c6.5 5.2 13.8 9.1 21.9 11.6l-29 65.6zM53.8 464l17.8-32H184.5l17.8 32H53.8zM256 461.9L212.7 384H43.3L0 461.9V464v48H48 208h48V464v-2.1z'
      
    ]
  };

  
    var faChessQueenAlt = faChessQueenPiece;
  

  
  

  var faBiohazard = {
    prefix: 'fasr',
    iconName: 'biohazard',
    icon: [
      576,
      512,
      [9763],
      'f780',
      
      'M167.2 3.2C138 33.4 120 74.6 120 120c0 26.1 6 50.8 16.6 72.9c-22.4 2.3-44.6 9-65.3 20.6c-33.7 18.8-58 47.3-71.3 79.7c57.1-48 153.9-53.7 204.4 30.8s-2.9 162.6-74.6 186.3c35.7 5.1 73.5-.9 107.2-19.7c20.6-11.5 37.7-26.6 50.9-44c13.2 17.4 30.3 32.6 50.9 44c33.7 18.8 71.5 24.8 107.2 19.7C374.5 486.6 321 408.6 371.6 324s147.4-78.8 204.4-30.8c-13.3-32.4-37.6-60.9-71.3-79.7c-20.7-11.5-43-18.3-65.3-20.6C450 170.8 456 146.1 456 120c0-45.4-18-86.6-47.2-116.8C433.9 77.9 393.6 176 288 176S142.1 77.9 167.2 3.2zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM288 64c-32.2 0-62.6 7.3-89.8 20.3c2.1 5.9 4.8 11.6 7.9 16.9c5.1 8.6 11.7 16.5 20 23.1c19-8 40-12.4 61.9-12.4s42.9 4.4 61.9 12.4c8.3-6.6 14.9-14.5 20-23.1c3.2-5.3 5.8-11 7.9-16.9C350.6 71.3 320.2 64 288 64zM191.8 399.9c-32.3-24.3-55.1-60.6-61.8-102.3c-9.2-3.9-18.6-6-28.1-6.8c-7-.6-14.1-.4-21.1 .5c5.9 63.9 40.7 119.5 91.2 153.5c4.8-5.8 8.9-12.1 12.1-18.7c3.9-8 6.6-16.8 7.7-26.2zM495.1 291.3c-7-.9-14.1-1-21.1-.5c-9.4 .8-18.9 3-28.1 6.8c-6.7 41.7-29.5 77.9-61.8 102.3c1.1 9.4 3.8 18.1 7.7 26.2c3.2 6.6 7.3 12.9 12.1 18.7c50.5-34 85.3-89.5 91.2-153.5z'
      
    ]
  };

  

  
  

  var faWebAwesome = {
    prefix: 'fasr',
    iconName: 'web-awesome',
    icon: [
      640,
      512,
      [],
      'e682',
      
      'M372.2 52c0 20.9-12.4 39-30.2 47.2L448 192l102.2-20.4 2.2-.4c-5.3-7.7-8.4-17.1-8.4-27.1c0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48l-9.8 21.8L464 480l-288 0L56.2 213.8 46.4 192C20.6 191.1 0 170 0 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1l2.2 .4L192 192 298.1 99.1c-17.7-8.3-30-26.3-30-47.1c0-28.7 23.3-52 52-52s52 23.3 52 52zm44.2 176.1L320 143.8l-96.4 84.3-17.8 15.6-23.2-4.6L114 225.4 207 432 433 432l93-206.6-68.5 13.7-23.2 4.6-17.8-15.6z'
      
    ]
  };

  

  
  

  var faBalloon = {
    prefix: 'fasr',
    iconName: 'balloon',
    icon: [
      384,
      512,
      [],
      'e2e3',
      
      'M196.6 392.6l1-.7c.9-.7 2.4-1.8 4.3-3.2c3.9-2.9 9.5-7.3 16.4-13c13.8-11.5 32.1-28 50.2-47.9C306.6 285.8 336 237.3 336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 45.3 29.4 93.8 67.5 135.7c18.1 19.9 36.4 36.4 50.2 47.9c6.9 5.7 12.5 10.1 16.4 13c1.9 1.5 3.4 2.5 4.3 3.2l1 .7 .1 .1 0 0 0 0 0 0s0 0 0 0l4.4 3.1 4.4-3.1s0 0 0 0l0 0 0 0 0 0 .1-.1zM384 192c0 128-160 240-160 240l12.8 32L256 512H204.3 179.7 128l19.2-48L160 432S0 320 0 192C0 86 86 0 192 0S384 86 384 192zm-256 8v8H80v-8c0-66.3 53.7-120 120-120h8v48h-8c-39.8 0-72 32.2-72 72z'
      
    ]
  };

  

  
  

  var faSensorOn = {
    prefix: 'fasr',
    iconName: 'sensor-on',
    icon: [
      640,
      512,
      [],
      'e02b',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zm96 96H96v24V264v24h48V264 152 128zm96 0H192v24V264v24h48V264 152 128zm357.3-20l20-13.3L590.7 54.7 570.7 68l-48 32-20 13.3 26.6 39.9 20-13.3 48-32zM536 232H512v48h24 80 24V232H616 536zm13.3 140l-20-13.3-26.6 39.9 20 13.3 48 32 20 13.3 26.6-39.9-20-13.3-48-32z'
      
    ]
  };

  

  
  

  var faMessagesDollar = {
    prefix: 'fasr',
    iconName: 'messages-dollar',
    icon: [
      640,
      512,
      ["comments-alt-dollar"],
      'f652',
      
      'M144 360L96 384V368 330.3 320H48 0V272 48 0H48 368h48V48 272v48H368 224l-80 40zm0-53.7l58.5-29.3 10.1-5.1H224 368V48H48V272H96h48v34.3zM256 352h48v48H416h11.3l10.1 5.1L496 434.3V400h48 48V176H448V128H592h48v48V400v48H592 544v10.3V496v16l-48-24-80-40H304 256V400 352zM185.8 128.8c-.4 2.4 0 3.3 .1 3.4c.1 .3 .7 1.2 2.8 2.6c4.9 3.2 12.7 5.6 24 8.9l.6 .2c9.7 2.8 22.6 6.6 32.3 13.5c5.3 3.8 10.4 8.9 13.6 16.1c3.2 7.2 3.9 15.2 2.4 23.4c-2.7 15.1-13 25.2-25.5 30.4c-3.9 1.6-8 2.8-12.2 3.5v3.9 16H192v-16-4.5c-7.6-1.7-17.5-5-23.8-7.1l0 0 0 0 0 0c-1.4-.5-2.6-.9-3.6-1.2L149.4 217l9.9-30.4 15.2 4.9c1.6 .5 3.3 1.1 5.1 1.7l0 0 0 0 0 0c7.6 2.5 16.2 5.4 21.1 6.1c10.3 1.6 18.3 .6 23.3-1.5c4.5-1.9 5.8-4.1 6.2-6.5c.5-3 .1-4.3-.1-4.7c-.2-.6-.9-1.6-2.9-3c-4.7-3.3-12.3-5.8-23.5-9.1l-1.7-.5c-9.4-2.7-21.6-6.3-30.8-12.4c-5.3-3.5-10.6-8.4-13.9-15.3c-3.5-7.1-4.2-15-2.8-23c2.6-14.6 13.2-24.4 25-29.6c4-1.7 8.2-3.1 12.6-4V85.3v-16h32v16 4.4c5.3 .9 13.3 2.5 16.8 3.4l15.5 4-8 31-15.5-4c-3.1-.8-13.9-2.9-17.4-3.4c-9.9-1.5-17.9-.3-23.1 2c-5.2 2.3-6.2 4.8-6.4 6z'
      
    ]
  };

  
    var faCommentsAltDollar = faMessagesDollar;
  

  
  

  var faArrowRotateRight = {
    prefix: 'fasr',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635,"arrow-right-rotate","arrow-rotate-forward","redo"],
      'f01e',
      
      'M472 224h24V200 56 32H448V56v80.1l-20-23.5C387 63.4 325.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8l-28.8-38.4C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2 0 0L418.9 176H328 304v48h24H472z'
      
    ]
  };

  
    var faArrowRightRotate = faArrowRotateRight;
  
    var faArrowRotateForward = faArrowRotateRight;
  
    var faRedo = faArrowRotateRight;
  

  
  

  var faUserMusic = {
    prefix: 'fasr',
    iconName: 'user-music',
    icon: [
      640,
      512,
      [],
      'f8eb',
      
      'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H288v0c0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c36.3 0 70.1 10.9 98.3 29.5v51.6c-3.2 .4-6.5 1-9.6 1.7C335.1 365.2 304 352 269.7 352H178.3c-65.7 0-120.1 48.7-129 112zM630 164.5c6.3 4.5 10 11.8 10 19.5v48V392c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V265.3l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V296 248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z'
      
    ]
  };

  

  
  

  var faFacePensive = {
    prefix: 'fasr',
    iconName: 'face-pensive',
    icon: [
      512,
      512,
      [],
      'e384',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 368h96 24v48H304 208 184V368h24zm183.5-98.3l32.2 23.8c-36 48.7-108.2 48.7-144.2 0l32.2-23.8c20 27.1 59.8 27.1 79.8 0zm-271.8 0c20 27.1 59.8 27.1 79.8 0l32.2 23.8c-36 48.7-108.2 48.7-144.2 0l32.2-23.8zM74.5 200.8l14.3-7.2 22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18 10-12.5 25 20-10 12.5-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4-14.3 7.2L74.5 200.8zm348.6-7.2l14.3 7.2-14.3 28.6-14.3-7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18-10-12.5 25-20 10 12.5 14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z'
      
    ]
  };

  

  
  

  var faHandsPraying = {
    prefix: 'fasr',
    iconName: 'hands-praying',
    icon: [
      640,
      512,
      ["praying-hands"],
      'f684',
      
      'M241.7 7.8l19 11.9 59.3 37 59.3-37 19-11.9 13.2 18.1 128 176 4.6 6.3V216v85.7l70.3 19.2 23.2 6.3-12.6 46.3-23.2-6.3-88-24L496 338.3V320 223.8L385.7 72.2 361.1 87.6l67.3 107.6 3.6 5.8V208v88 24H384V296 216H344V389.3l269.8 67.5 23.3 5.8-11.6 46.6-23.3-5.8L320 432.7 37.8 503.3l-23.3 5.8L2.9 462.5l23.3-5.8L296 389.3V216H256v80 24H208V296 208v-6.9l3.6-5.8L278.9 87.6 254.3 72.2 144 223.8V320v18.3l-17.7 4.8-88 24-23.2 6.3L2.5 327.2l23.2-6.3L96 301.7V216v-7.8l4.6-6.3 128-176L241.7 7.8zM296 168h24 0 24 10.7L320 112.5 285.3 168H296z'
      
    ]
  };

  
    var faPrayingHands = faHandsPraying;
  

  
  

  var faHandScissors = {
    prefix: 'fasr',
    iconName: 'hand-scissors',
    icon: [
      512,
      512,
      [],
      'f257',
      
      'M.3 195.6l23.4 5.2L65.2 210l-38.4 1.3-24 .8 .8 24 2.8 80 .8 24 24-.8L192 333.6V376v24h24 8l0 40v24h24 40 96 8c66.3 0 120-53.7 120-120V218.6c0-26.9-7.1-53.3-20.7-76.6l-19.8 11.5L491.3 142l-1.5-2.6C462.5 92.7 412.5 64 358.5 64H320 309.4l-7.1 7.9-45.1 49.6L51.4 75.8 28 70.6 22.8 94 5.5 172.1 .3 195.6zM240 352V308.8 283.9l-24.8 .9L53.6 290.4l-1.1-32 197.7-6.9 13.8-.5V204.9l-9.7-2.1L57.5 159.1l6.9-31.2 195.9 43.4 2.4 .5 85.6 19.7 15.6 3.6 7.2-31.2-15.6-3.6-57-13.2 32-35.2h27.9c37 0 71.2 19.6 89.8 51.6L469 151.5l-20.7 12.1 1.5 2.6c9.3 15.9 14.2 34 14.2 52.4V344c0 39.8-32.2 72-72 72h-8H288 272V376 352H248h-8z'
      
    ]
  };

  

  
  

  var faDrumSteelpan = {
    prefix: 'fasr',
    iconName: 'drum-steelpan',
    icon: [
      576,
      512,
      [],
      'f56a',
      
      'M528 160c0-9.9-8-29.9-55-49.8c-19.3-8.2-42.6-15-69-20l-11.1 66.5 31.2 68.7c18.2-4.4 34.6-9.7 48.9-15.7c47.1-19.9 55-39.9 55-49.8zm48 0V352c0 24.3-11.3 44.9-28.1 61c-16.5 15.8-39.1 28.3-64.8 37.8C431.7 470.1 362.6 480 288 480s-143.7-9.9-195.1-29.1c-25.6-9.6-48.2-22-64.8-37.8C11.3 396.9 0 376.3 0 352V160C0 80 128.9 32 288 32s288 48 288 128zm-48 74.9C476.4 269 388.2 288 288 288s-188.4-19-240-53.1V352c0 8.2 3.5 16.9 13.3 26.3c10.2 9.7 26.2 19.3 48.4 27.6C153.9 422.4 216.8 432 288 432s134.1-9.6 178.3-26.1c22.1-8.3 38.2-17.8 48.4-27.6c9.9-9.4 13.3-18.2 13.3-26.3V234.9zM48 160c0 9.9 8 29.9 55 49.8c14.3 6 30.7 11.3 48.9 15.7l31.2-68.7L172 90.2c-26.4 5.1-49.7 11.9-69 20C56 130.1 48 150.1 48 160zM356.4 83.3C334.9 81.2 312 80 288 80s-46.9 1.2-68.4 3.3l6.8 41L288 150l61.6-25.7 6.8-41zm19 151.1l-26.3-57.9-51.9 21.6L288 202l-9.2-3.8-51.9-21.6-26.3 57.9c26.9 3.6 56.3 5.6 87.5 5.6s60.6-2 87.5-5.6z'
      
    ]
  };

  

  
  

  var faHandPointer = {
    prefix: 'fasr',
    iconName: 'hand-pointer',
    icon: [
      448,
      512,
      [],
      'f25a',
      
      'M136 0H112V24 260.6L95.1 235.2l-13.3-20-20 13.3L10.7 262.6 0 269.7v12.8 33.5 7.3l4 6 6.7 10.1L78.2 440.8c29.7 44.5 79.6 71.2 133.1 71.2h.7 0l.1 0h0H328c66.3 0 120-53.7 120-120V376 288 240 216H424 384V192H360 312v-8V160H288 240V24 0H216 136zM264 240h24 48v24h24 40v24 88 16c0 39.8-32.2 72-72 72H212.3h0l-.1 0h0-.7c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9l-2.7-4V295.4l20.4-13.6 8.9 13.3 24.4 36.5L117.9 356l20.7-20.7L153 321l7-7V304 48h32V184v24h24 48v8 24zm-40 64V288H192v16 96 16h32V400 304zm64-16H256v16 96 16h32V400 304 288zm64 16V288H320v16 96 16h32V400 304z'
      
    ]
  };

  

  
  

  var faBacterium = {
    prefix: 'fasr',
    iconName: 'bacterium',
    icon: [
      512,
      512,
      [],
      'e05a',
      
      'M422.3 40.9l8.9-22.3L386.6 .8l-8.9 22.3-3.6 9.1c-10.3-.6-20.8 .3-31.3 2.7c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7L292.6 8.5 248.5 27.4l9.5 22.1 4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7l-13.3-20L142.7 89.3l13.3 20 7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3l-18.7-15-30 37.5 18.7 15 15 12c-2.1 3.2-4.1 6.5-6 9.7c-8.6 14.3-16.5 29.5-23.3 45.2l-9.8-3.9-22.3-8.9L8.8 293.4l22.3 8.9 11.4 4.5c-4.8 16.8-8.2 34-10 51c-.5 5-.6 10-.4 14.9l-14.7 4.2-23.1 6.6L7.5 429.7l23.1-6.6 13.8-3.9c10.4 20.2 26.8 37 47 47.8l-1.7 4.2-8.9 22.3 44.6 17.8 8.9-22.3 3.6-9.1c24.3 1.3 47.3-5.2 66.5-17.5L215 473l17 17L265.9 456l-17-17-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3c.6-3.9 1.4-7.7 2.5-11.5l12.7 5.5 22.1 9.5 18.9-44.1-22.1-9.5-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5 6.6 23.1 46.2-13.2-6.6-23.1L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249l17 17L489.9 232l-17-17-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2 23.1-6.6L504.5 82.3l-23.1 6.6-13.7 3.9c-10.6-20.7-27.2-37.2-47.1-47.7l1.7-4.2zm-214.4 332c-.1 .7-.2 1.4-.3 2.1c-3.8 34.6-34.6 59.9-69.4 56.8c-35.1-3.2-61-34.2-58-69.2c4.4-41 20.4-84 42.9-121.4c38-63.4 107.9-131.1 230.5-159.4c34.4-7.9 68.8 13.5 76.8 48s-13.5 68.8-48 76.8C297 226.1 254.9 270.3 232.9 306.9c-10.8 18-21.1 40.8-25 66zM192 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faGridDividers = {
    prefix: 'fasr',
    iconName: 'grid-dividers',
    icon: [
      512,
      512,
      [],
      'e3ad',
      
      'M0 0H512V48H0V0zM80 144v32h32V144H80zM32 96H80h32 48v48 32 48H112 80 32V176 144 96zM80 432v32h32V432H80zM32 384H80h32 48v48 32 48H112 80 32V464 432 384zM272 144H240v32h32V144zM240 96h32 48v48 32 48H272 240 192V176 144 96h48zm0 336v32h32V432H240zm-48-48h48 32 48v48 32 48H272 240 192V464 432 384zM432 144H400v32h32V144zM400 96h32 48v48 32 48H432 400 352V176 144 96h48zm0 336v32h32V432H400zm-48-48h48 32 48v48 32 48H432 400 352V464 432 384zm160-96v48H0V288H512z'
      
    ]
  };

  

  
  

  var faHandHoldingDollar = {
    prefix: 'fasr',
    iconName: 'hand-holding-dollar',
    icon: [
      576,
      512,
      ["hand-holding-usd"],
      'f4c0',
      
      'M312 32v2.9c6.4 1.2 14.3 2.8 18.2 3.9L353.4 45 341 91.4l-23.2-6.2c-3.7-1-17-3.6-21.3-4.3c-11.6-1.8-20.8-.3-26.4 2.3c-5.5 2.5-5.9 4.8-5.9 5.1l0 0c-.3 1.5-.2 2.3-.2 2.7c.2 .2 .7 .9 2.2 1.9c5.5 3.7 14.4 6.6 28.8 10.9l1 .3c12 3.6 28.7 8.7 41.4 17.9c7.1 5.2 14 12.3 18.2 22.1c4.3 9.9 5.1 20.7 3.2 31.7c-3.6 20.6-17.3 34.5-34 41.7c-4.2 1.8-8.5 3.2-13 4.2V224v24H264l0-24v-3.2c-9.3-2.4-20.3-6.1-27.3-8.5l0 0 0 0c-1.7-.6-3.1-1.1-4.2-1.4l-22.8-7.6 15.2-45.5 22.8 7.6c2.1 .7 4.3 1.5 6.6 2.2l0 0c9.5 3.2 19.7 6.7 25.4 7.6c12.3 1.9 21.4 .6 26.6-1.6c4.4-1.9 5.3-3.8 5.6-5.8c.3-1.8 .3-2.9 .2-3.5c-.1-.6-.2-.8-.2-.9l0 0c0-.1-.4-.9-2.4-2.4c-5.2-3.8-14-6.8-28.1-11.1l-2.3-.7c-11.6-3.5-27.5-8.2-39.6-16.5c-7-4.8-14.1-11.5-18.7-21.1c-4.6-9.8-5.6-20.5-3.7-31.4c3.5-20 17.6-33.5 33.4-40.7c4.3-2 8.9-3.5 13.6-4.7V32 8h48V32zM264.1 91.1c0 0 0 0 0 0s0 0 0-.1c0 0 0 .1 0 .1zM160.7 304H168 384h24v24 46.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H424 24 0V464H24 416.6l91.7-62.8-15-24-80.4 51L407 432h-7H368 320 296 256 232V384h24 40 24 40V352H175.3l-90 60-6 4H72 24 0V368H24 64.7l90-60 6-4z'
      
    ]
  };

  
    var faHandHoldingUsd = faHandHoldingDollar;
  

  
  

  var faCircleEllipsisVertical = {
    prefix: 'fasr',
    iconName: 'circle-ellipsis-vertical',
    icon: [
      512,
      512,
      [],
      'e10b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224 64h64v64H224V320zm0-192h64v64H224V128zm0 160V224h64v64H224z'
      
    ]
  };

  

  
  

  var faFaceGrinSquint = {
    prefix: 'fasr',
    iconName: 'face-grin-squint',
    icon: [
      512,
      512,
      [128518,"grin-squint"],
      'f585',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM112 144l118.9 64L112 272l45.7-64L112 144zm169.1 64L400 144l-45.7 64L400 272 281.1 208z'
      
    ]
  };

  
    var faGrinSquint = faFaceGrinSquint;
  

  
  

  var faSquareLeft = {
    prefix: 'fasr',
    iconName: 'square-left',
    icon: [
      448,
      512,
      [11013,"arrow-alt-square-left"],
      'f351',
      
      'M48 432H400V80L48 80l0 352zM0 480V432 80 32H48 400h48V80 432v48H400 48 0zM192 368L96 256l96-112h32v64H352v96H224v64H192z'
      
    ]
  };

  
    var faArrowAltSquareLeft = faSquareLeft;
  

  
  

  var faDiamond = {
    prefix: 'fasr',
    iconName: 'diamond',
    icon: [
      512,
      512,
      [9830],
      'f219',
      
      'M0 256l33.9 33.9L222.1 478.1 256 512l33.9-33.9L478.1 289.9 512 256l-33.9-33.9L289.9 33.9 256 0 222.1 33.9 33.9 222.1 0 256zM256 444.1L67.9 256 256 67.9 444.1 256 256 444.1z'
      
    ]
  };

  

  
  

  var faUserNurseHairLong = {
    prefix: 'fasr',
    iconName: 'user-nurse-hair-long',
    icon: [
      448,
      512,
      [],
      'e45e',
      
      'M96 48v80h.3c-.2 2.6-.3 5.3-.3 8v24 16 0 48L48 272v32H224 400V272l-48-48V176 160 136c0-2.7-.1-5.4-.3-8h.3V48L224 0 96 48zm48 128h64l32-32 16 16h48v16c0 44.2-35.8 80-80 80s-80-35.8-80-80zM208 40h32V64h24V96H240v24H208V96H184V64h24V40zM189 456.9l6.7 7.1H68.5l29.1-80h22.8L189 456.9zM379.5 464H252.3l6.7-7.1L327.6 384h22.8l29.1 80zM384 336H306.8L257 389l-33 35-33-35-49.9-53H64L17.5 464 0 512H51.1 396.9 448l-17.5-48L384 336z'
      
    ]
  };

  

  
  

  var faAlbumCirclePlus = {
    prefix: 'fasr',
    iconName: 'album-circle-plus',
    icon: [
      576,
      512,
      [],
      'e48c',
      
      'M48 80H400V194.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7V80 32H400 48 0V80 432v48H48 296.2c-11.8-14.3-21.4-30.5-28.2-48H48V80zm176 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c-1.4-9.1-2.2-18.4-2.2-27.9c0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48 16v32H496 448v48 16H416V432 384H368 352V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faScarf = {
    prefix: 'fasr',
    iconName: 'scarf',
    icon: [
      512,
      512,
      [129507],
      'f7c1',
      
      'M408.6 222.1l7.4-7.4V123.3L336.7 0H175.3L96 123.3v91.3L254.1 372.7l22.6 22.6L288 406.6 388.7 507.3l22.6-22.6L310.6 384l11.3-11.3L336 358.6 436.7 459.3l22.6-22.6L358.6 336l14.1-14.1L384 310.6 484.7 411.3l22.6-22.6L406.6 288l-11.3-11.3L374.6 256l33.9-33.9zM338.7 288L288 338.7l-144-144V137.4L201.5 48H310.5L368 137.4v57.3l-27.3 27.3-50.7-50.7L304 157.3V128H208v29.3L306.7 256h0l0 0 32 32zM4.7 388.7l22.6 22.6 112-112-22.6-22.6-112 112zm48 48l22.6 22.6 112-112-22.6-22.6-112 112zm48 48l22.6 22.6 112-112-22.6-22.6-112 112z'
      
    ]
  };

  

  
  

  var faPlantWilt = {
    prefix: 'fasr',
    iconName: 'plant-wilt',
    icon: [
      512,
      512,
      [],
      'e5aa',
      
      'M280 112c0-35.3 28.7-64 64-64s64 28.7 64 64v18.7c-33.9 8-56 33.6-56 72.4c0 29.3 35.8 79.4 80 116.9c44.2-37.5 80-88 80-116.9c0-38.8-22.1-64.4-56-72.4V112C456 50.1 405.9 0 344 0S232 50.1 232 112v36.1c-18.1-12.7-40.2-20.1-64-20.1c-61.9 0-112 50.1-112 112v18.7c-33.9 8-56 33.6-56 72.4C0 360.4 35.8 410.5 80 448c44.2-37.5 80-88 80-116.9c0-38.8-22.1-64.4-56-72.4V240c0-35.3 28.7-64 64-64s64 28.7 64 64v32V488v24h48V488 272 240 112zM54.7 311.3c3.2-2.9 9.9-6.7 22.3-7.2c1 .1 2 .2 3.1 .2s2.1-.1 3.1-.2c12.3 .5 19.1 4.3 22.3 7.2c2.9 2.6 6.7 7.9 6.7 19.8c0-.2 0-.1-.2 .4c-.7 2.2-3.6 11.4-14.7 27.5c-4.9 7.1-10.7 14.5-17.1 21.8c-6.4-7.3-12.2-14.7-17.1-21.7c-11.4-16.4-14.1-25.7-14.7-27.7c-.1-.4-.1-.5-.1-.3c0-11.9 3.8-17.1 6.7-19.8zM464 203.1c0-.2 0-.1-.2 .4c-.7 2.2-3.6 11.4-14.7 27.5c-4.9 7.1-10.7 14.5-17.1 21.8c-6.4-7.3-12.2-14.7-17.1-21.7c-11.4-16.4-14.1-25.7-14.7-27.7c-.1-.4-.1-.5-.1-.3c0-11.9 3.8-17.1 6.7-19.8c3.5-3.1 11-7.3 25.3-7.3s21.9 4.1 25.3 7.3c2.9 2.6 6.7 7.9 6.7 19.8z'
      
    ]
  };

  

  
  

  var faCommentDots = {
    prefix: 'fasr',
    iconName: 'comment-dots',
    icon: [
      512,
      512,
      [62075,128172,"commenting"],
      'f4ad',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faCommenting = faCommentDots;
  

  
  

  var faCalendarArrowUp = {
    prefix: 'fasr',
    iconName: 'calendar-arrow-up',
    icon: [
      448,
      512,
      ["calendar-upload"],
      'e0d1',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zM248 408v24H200V408 305.9l-39 39-17 17L110.1 328l17-17 80-80 17-17 17 17 80 80 17 17L304 361.9l-17-17-39-39V408z'
      
    ]
  };

  
    var faCalendarUpload = faCalendarArrowUp;
  

  
  

  var faSortUp = {
    prefix: 'fasr',
    iconName: 'sort-up',
    icon: [
      320,
      512,
      ["sort-asc"],
      'f0de',
      
      'M48 224H0V176L160 32 320 176v48H272 48zm200.2-48L160 96.6 71.8 176H248.2z'
      
    ]
  };

  
    var faSortAsc = faSortUp;
  

  
  

  var faSquareL = {
    prefix: 'fasr',
    iconName: 'square-l',
    icon: [
      448,
      512,
      [],
      'e275',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM176 152V336H296h24v48H296 152 128V360 152 128h48v24z'
      
    ]
  };

  

  
  

  var faTennisBall = {
    prefix: 'fasr',
    iconName: 'tennis-ball',
    icon: [
      512,
      512,
      [127934],
      'f45e',
      
      'M248 463.8c0-55.2 21.1-110.4 63.3-152.6s97.4-63.2 152.6-63.3C459.7 139.5 372.5 52.3 264 48.2c0 55.2-21.1 110.4-63.3 152.6S103.4 264 48.2 264C52.3 372.5 139.5 459.7 248 463.8zm48-3.7C378.8 444 444 378.8 460.2 296c-41.7 1-83.1 17.3-114.9 49.2S297 418.4 296 460.2zM51.9 216c41.7-1 83.1-17.3 114.9-49.2S215 93.6 216 51.9C133.2 68 68 133.2 51.9 216zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faFaceTongueMoney = {
    prefix: 'fasr',
    iconName: 'face-tongue-money',
    icon: [
      512,
      512,
      [],
      'e39d',
      
      'M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4c34.9-26.2 58.7-66.3 63.2-112H352 320 192 160 96.8c4.5 45.8 28.4 85.8 63.2 112c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zm-44.4 16C292.2 471.7 275.1 480 256 480s-36.2-8.3-47.9-21.5c-5.7-6.4-10.2-14-12.9-22.4c-2.1-6.3-3.2-13-3.2-20V336H320v80c0 7-1.1 13.7-3.2 20c-2.8 8.4-7.2 16-12.9 22.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM146.9 135.2c-10.4 6-19.7 17.1-18.7 33.8c.9 14.3 9.9 23 18.6 28c7.4 4.3 16.6 7 23.6 9.1l1.5 .4c8.3 2.5 13.9 4.4 17.6 6.7c2.6 1.7 2.6 2.4 2.6 3l0 .1c.1 1.9-.4 2.7-.6 3c-.3 .4-.8 1.1-2.2 1.9c-3 1.7-7.9 2.8-12.7 2.6c-7-.2-13.5-2.4-22.7-5.6c-1.5-.5-3.1-1-4.7-1.6l-15.2-5.1-10.1 30.4 15.2 5.1c1.2 .4 2.5 .9 3.9 1.3c5.1 1.8 11.1 3.8 17.6 5.3l0 18.2h32V254.2c4.4-1.1 8.8-2.8 12.9-5.2c10.7-6.2 19.1-17.4 18.6-33.5c-.4-14.4-8.6-23.7-17.6-29.4c-8-5-17.8-8-25.1-10.2l-.3-.1c-8.5-2.6-14.3-4.4-18.3-6.7c-1.8-1-2.4-1.7-2.6-1.9l0 0c0 0 0-.1 0-.2c-.1-1.4 .2-1.9 .3-2.1c.2-.4 .8-1.1 2.4-2c3.4-1.9 8.6-3 13-2.9c6.1 .1 12.8 1.4 20.1 3.4l15.5 4.1 8.2-30.9-15.5-4.1c-3.6-1-7.6-1.9-11.7-2.7V112h-32v17.8c-4.6 1.1-9.2 2.8-13.6 5.3zM320 129.9c-4.4 1.1-9 2.8-13.1 5.2c-10.4 6-19.7 17.1-18.7 33.8c.9 14.3 9.9 23 18.6 28c7.4 4.3 16.6 7 23.6 9.1l1.5 .4c8.3 2.5 13.9 4.4 17.6 6.7c2.6 1.7 2.6 2.4 2.6 3l0 .1c.1 1.9-.4 2.7-.6 3c-.3 .4-.8 1.1-2.2 1.9c-3 1.7-7.9 2.8-12.7 2.6c-7-.2-13.5-2.4-22.7-5.6c-1.5-.5-3.1-1-4.7-1.6l-15.2-5.1-10.1 30.4 15.2 5.1c1.2 .4 2.5 .9 3.9 1.3c5 1.7 10.8 3.7 17.1 5.2V272h32V254.3c4.5-1.1 9.1-2.8 13.3-5.3c10.6-6.2 19.1-17.4 18.6-33.5c-.4-14.4-8.6-23.7-17.5-29.4c-8-5-17.8-8-25.1-10.2l-.3-.1c-8.5-2.6-14.3-4.4-18.3-6.7c-1.8-1-2.4-1.7-2.6-1.9l0 0c0 0 0-.1 0-.2c-.1-1.4 .2-1.9 .3-2.1c.2-.4 .8-1.1 2.4-2c3.4-1.9 8.6-3 13-2.9c6.1 .1 12.8 1.4 20.1 3.4l15.5 4.1 8.2-30.9-15.5-4.1c-3.8-1-7.8-2-12.1-2.8V112H320v17.9zM268.7 359.6V344h-24v15.8c-3.2 .8-6.5 1.9-9.6 3.6c-7.7 4.1-15.2 12.1-14.4 24.7c.7 10.8 7.9 17 14.2 20.4c5.5 3 12.4 4.9 17.7 6.4l1.1 .3c6.2 1.8 10.5 3.1 13.4 4.8c1.1 .7 1.6 1.1 1.7 1.3l0 .1c0 1-.2 1.3-.2 1.4c-.1 .2-.5 .6-1.5 1.2c-2.3 1.3-6.1 2-9.9 1.9c-5.4-.2-10.4-1.8-17.3-3.9l0 0c-1.1-.4-2.3-.7-3.5-1.1l-11.5-3.6-7.1 22.9 11.5 3.6c.9 .3 1.9 .6 3 .9l0 0c3.7 1.2 8 2.6 12.7 3.6v17h24V448.7c3.3-.8 6.6-1.9 9.7-3.6c7.9-4.3 14.7-12.3 14.3-24.4c-.3-10.8-6.9-17.5-13.5-21.4c-5.9-3.5-13.3-5.6-18.8-7.1l0 0-.2-.1c-6.4-1.8-10.8-3.1-13.9-4.7c-.9-.5-1.4-.9-1.7-1.1c0-.2 0-.3 0-.3s0 0 0-.1c.1-.1 .5-.6 1.7-1.3c2.6-1.4 6.7-2.2 10.1-2.1c4.7 .1 9.8 1 15.3 2.4l11.6 2.9 5.8-23.3-11.6-2.9c-2.8-.7-5.8-1.4-8.9-1.9z'
      
    ]
  };

  

  
  

  var faUserPoliceTie = {
    prefix: 'fasr',
    iconName: 'user-police-tie',
    icon: [
      448,
      512,
      [],
      'e334',
      
      'M80 99.2L48 80V48L224 0 400 48V80L368 99.2V128c-16 10.7-67.2 32-144 32s-128-21.3-144-32V99.2zM227 48.6l-3-1.2-3 1.2L189 61.4l-5 2v5.4c0 17.2 7 46.1 36.9 58.6l3.1 1.3 3.1-1.3C257 114.9 264 86 264 68.8V63.4l-5-2L227 48.6zM96 192c0-7.9 .7-15.7 2.1-23.2c14 5.4 28.5 9.9 43.3 13.4c-.4 3.2-.6 6.5-.6 9.8c0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8c14.8-3.6 29.3-8.1 43.3-13.4c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128zM208 416l-32-64h96l-32 64 12.2 48.9 .6-.9L320 352h80l33.6 112L448 512H397.9 280 256 224 192 168 50.1 0l14.4-48L48 352h80l67.2 112 .6 .9L208 416zm175.5 48l-19.2-64H347.2l-38.4 64h74.7zM100.8 400H83.7L64.5 464h74.7l-38.4-64z'
      
    ]
  };

  

  
  

  var faFileUser = {
    prefix: 'fasr',
    iconName: 'file-user',
    icon: [
      384,
      512,
      [],
      'f65c',
      
      'M298.7 464L272 384H112L85.3 464H48V48H224V160H336V464H298.7zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zm0 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faScaleUnbalanced = {
    prefix: 'fasr',
    iconName: 'scale-unbalanced',
    icon: [
      640,
      512,
      ["balance-scale-left"],
      'f515',
      
      'M240 80c0 2.8 .1 5.5 .4 8.3L112.7 129.1l-22.9 7.3 14.6 45.7 22.9-7.3 132.3-42.3c9.6 11 22.1 19.4 36.4 23.8V488v24h24H520h24V464H520 344V156.3c30.1-9.5 52.5-36.2 55.6-68.6L527.3 46.9 512.7 1.1 389.6 40.5C375.8 16.3 349.8 0 320 0c-44.2 0-80 35.8-80 80zM97.5 224l-6.7 12.9-88 168L0 410.1V416v32 9.9l7 7 40 40 7 7H64 192h9.9l7-7 40-40 7-7V448l0-32v-5.9l-2.7-5.2-88-168L158.5 224H144 112 97.5zm29 48h3l75.4 144H51.1l75.4-144zM496 96H481.5l-6.7 12.9-88 168-2.7 5.2V288v32 9.9l7 7 40 40 7 7H448 576h9.9l7-7 40-40 7-7V320 288v-5.9l-2.7-5.2-88-168L542.5 96H528 496zM435.1 288l75.4-144h3l75.4 144H435.1zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faBalanceScaleLeft = faScaleUnbalanced;
  

  
  

  var faFaceKissClosedEyes = {
    prefix: 'fasr',
    iconName: 'face-kiss-closed-eyes',
    icon: [
      512,
      512,
      [],
      'e37d',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432l-3.9-15 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0 0 0V345l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0 0 0 3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-89.1-63.4c-20-27.1-59.8-27.1-79.8 0l-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8zm80.2 0l-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0z'
      
    ]
  };

  

  
  

  var faVihara = {
    prefix: 'fasr',
    iconName: 'vihara',
    icon: [
      640,
      512,
      [],
      'f6a7',
      
      'M333.8 12.3L320 2.7l-13.8 9.6C258.9 45.5 197.5 64.5 137.7 80.8L128 83.5v49.8l22.3-6.1c3.2-.9 6.4-1.8 9.7-2.7v49.8c-31.3 29-70.1 48.9-112.1 57.3l-4.6 .9L32 234.7l0 49V288H56 96v40 8.6c-22.8 28.7-53.9 49.7-89.1 60.3L0 398.9V448H64l0 0v40l0 24 0 0h48V488 448H296v40 24h48V488 448H528v40 24h48l0 0 0-24V448l0 0h64V398.9l-6.9-2.1c-35.2-10.6-66.3-31.6-89.1-60.3V328 288h40 24v-6.2V233.1l-3.7-.7-9.9-1.8c-42.7-7.8-82.3-27.4-114.4-56.5V124.5c3.3 .9 6.5 1.8 9.7 2.7l22.3 6.1V83.5l-9.7-2.6C442.5 64.5 381.1 45.5 333.8 12.3zM496 288v32H344 320 296 144V288H296h24 24H496zM432.1 110.3c0 .6-.1 1.1-.1 1.7v48H344 320 296 208V112c0-.6 0-1.2-.1-1.7C246.2 97.9 285.4 82.4 320 60.8c34.6 21.6 73.8 37.2 112.1 49.5zM487.9 240H344 320 296 153.1c14.6-9.3 28.4-20 41.1-32H296h24 24H445.9c13 12 27.1 22.7 42 32zm19.8 128c9.5 11.7 20.1 22.4 31.6 32H344 320 296 100.7c11.5-9.6 22.1-20.3 31.6-32H296h24 24H507.7z'
      
    ]
  };

  

  
  

  var faFloppyDisk = {
    prefix: 'fasr',
    iconName: 'floppy-disk',
    icon: [
      448,
      512,
      [128190,128426,"save"],
      'f0c7',
      
      'M48 480H0V432 80 32H48 336L448 144V432v48H400 48zm352-48V163.9l-80-80V184v24H296 104 80V184 80H48V432H400zM128 80v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  
    var faSave = faFloppyDisk;
  

  
  

  var faShop = {
    prefix: 'fasr',
    iconName: 'shop',
    icon: [
      640,
      512,
      ["store-alt"],
      'f54f',
      
      'M515.5 48l69.8 128H54.7L124.5 48h391zM96 0L0 176v48H48 64V488v24H88 360h24V488 224H528V488v24h48V488 224h16 48V176L544 0H96zM336 224v96H112V224H336zM112 464V368H336v96H112z'
      
    ]
  };

  
    var faStoreAlt = faShop;
  

  
  

  var faPrescription = {
    prefix: 'fasr',
    iconName: 'prescription',
    icon: [
      448,
      512,
      [],
      'f5b1',
      
      'M24 0H0V24 200v96 24H48V296 224h78.1l128 128L146.2 459.8l-17 17 33.9 33.9 17-17L288 385.9 395.8 493.8l17 17 33.9-33.9-17-17L321.9 352 429.8 244.2l17-17-33.9-33.9-17 17L288 318.1l-95.3-95.3C246.6 214.7 288 168.2 288 112C288 50.1 237.9 0 176 0H24zM176 176H48V48H176c35.3 0 64 28.7 64 64s-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faWalker = {
    prefix: 'fasr',
    iconName: 'walker',
    icon: [
      448,
      512,
      [],
      'f831',
      
      'M116.9 0H136 384h24V24 388.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V224H115L55.4 485.3l-5.3 23.4L3.3 498.1l5.3-23.4 104-456L116.9 0zM126 176H360V48H155.1L126 176zM384 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faScreencast = {
    prefix: 'fasr',
    iconName: 'screencast',
    icon: [
      576,
      512,
      [],
      'e23e',
      
      'M528 80H48V196c-15.6-2.6-31.6-4-48-4V80 32H48 528h48V80 432v48H528 288c0-16.4-1.4-32.4-4-48H528V80zM0 272V224c141.4 0 256 114.6 256 256H208c0-114.9-93.1-208-208-208zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 64c0-61.9-50.1-112-112-112V320c88.4 0 160 71.6 160 160H112z'
      
    ]
  };

  

  
  

  var faDiploma = {
    prefix: 'fasr',
    iconName: 'diploma',
    icon: [
      640,
      512,
      ["scroll-ribbon"],
      'f5ea',
      
      'M208 144V113l0-.5c.3-18 14.9-32.5 33-32.5c9.5 0 18.6 4.1 24.8 11.3L312 144H240 208zm120 0l46.1-52.7C380.4 84.1 389.5 80 399 80h1c17.7 0 32 14.3 32 32l0 .5 0 .5v31H400 328zm152 48H592v84.7l-42.7 85.5L384 331.2V192h48 48zM384 380l192 36 64-128V192 144H592 480V113c0-44.7-36.3-81-81-81c-23.4 0-45.6 10.1-61 27.7L320 80.3 302 59.7C286.6 42.1 264.4 32 241 32c-44.7 0-81 36.3-81 81v31H48 0v48 96L64 416l192-36V480l64-40 64 40V380zM256 331.2l-165.3 31L48 276.7V192H160h48 48V331.2z'
      
    ]
  };

  
    var faScrollRibbon = faDiploma;
  

  
  

  var faShirtTankTop = {
    prefix: 'fasr',
    iconName: 'shirt-tank-top',
    icon: [
      384,
      512,
      [],
      'e3c9',
      
      'M112 72c0 44.2 35.8 80 80 80s80-35.8 80-80V24 0h48V24 72v50.3l61.5 122.9 2.5 5.1V256 488v24H360 24 0V488 256v-5.7l2.5-5.1L64 122.3V72 24 0h48V24 72zm173.1 87.9C261.8 184.6 228.7 200 192 200s-69.8-15.4-93.1-40.1L48 261.7V464H336V261.7L285.1 159.9z'
      
    ]
  };

  

  
  

  var faChessBishopPiece = {
    prefix: 'fasr',
    iconName: 'chess-bishop-piece',
    icon: [
      256,
      512,
      ["chess-bishop-alt"],
      'f43b',
      
      'M64 32H88h80 24V80H171.2c6.1 6.4 13.1 14.3 20 23.6C210.8 129.8 232 168.8 232 216c0 15.8-3.7 29-9.2 40H224v48H205.7l4.8 48H162.3l-4.8-48h-59l-4.8 48H45.5l4.8-48H32V256h1.2c-5.5-11-9.2-24.2-9.2-40c0-47.2 21.2-86.2 40.8-112.4c7-9.3 13.9-17.2 20-23.6H64V32zm93.3 224l7.5-5.1c9.6-6.5 19.2-16.9 19.2-34.9c0-13.8-2.6-26.9-6.9-39.2L161 193l-17 17L110.1 176l17-17 26.1-26.1c-.1-.2-.2-.3-.4-.5c-8.1-10.8-16.2-19.3-22.2-25.1c-.9-.9-1.8-1.7-2.6-2.5c-.8 .8-1.7 1.6-2.6 2.5c-6 5.8-14.1 14.4-22.2 25.1C86.8 154.2 72 183.2 72 216c0 18.1 9.6 28.5 19.2 34.9l7.5 5.1h58.7zM71.5 432L53.8 464H202.2l-17.8-32H71.5zm141.2-48L256 461.9V464v48H208 48 0V464v-2.1L43.3 384H212.7z'
      
    ]
  };

  
    var faChessBishopAlt = faChessBishopPiece;
  

  
  

  var faFaceFrown = {
    prefix: 'fasr',
    iconName: 'face-frown',
    icon: [
      512,
      512,
      [9785,"frown"],
      'f119',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1l-45.2-16.3C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9l-45.2 16.3C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faFrown = faFaceFrown;
  

  
  

  var faDryer = {
    prefix: 'fasr',
    iconName: 'dryer',
    icon: [
      448,
      512,
      [],
      'f861',
      
      'M400 48V464H48V48H400zM48 0H0V48 464v48H48 400h48V464 48 0H400 48zm80 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 256c-44.7 0-82.3-30.6-93-72h53 24V264H184 131c10.7-41.4 48.2-72 93-72c53 0 96 43 96 96s-43 96-96 96zm0 48a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  

  
  

  var faWindowMaximize = {
    prefix: 'fasr',
    iconName: 'window-maximize',
    icon: [
      512,
      512,
      [128470],
      'f2d0',
      
      'M464 432l0-208H48l0 208 416 0zm48-208V432v48H464L48 480H0l0-48V224 80 32H48 464h48V80l0 144z'
      
    ]
  };

  

  
  

  var faHouseChimney = {
    prefix: 'fasr',
    iconName: 'house-chimney',
    icon: [
      576,
      512,
      [63499,"home-lg"],
      'e3af',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 488h24V488 253.5l24.5 20.8 31.1-36.6L512 190.6V184 88 64H464V88v61.9L303.5 13.7zM464 212.8V464H384V296 272H360 216 192v24V464H112V212.8L288 63.5 464 212.8zM336 320V464H240V320h96z'
      
    ]
  };

  
    var faHomeLg = faHouseChimney;
  

  
  

  var faArrowUpLeftFromCircle = {
    prefix: 'fasr',
    iconName: 'arrow-up-left-from-circle',
    icon: [
      512,
      512,
      [],
      'e09e',
      
      'M24 0H0V24 184v24H48V184 81.9L295 329l17 17L345.9 312l-17-17L81.9 48H184h24V0H184 24zM288 112c97.2 0 176 78.8 176 176s-78.8 176-176 176s-176-78.8-176-176H64c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64v48z'
      
    ]
  };

  

  
  

  var faHeartCircleXmark = {
    prefix: 'fasr',
    iconName: 'heart-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e501',
      
      'M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1l4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-14.4-6.6-29.8-11.4-45.9-14c2.7-8.5 4.1-17.4 4.1-26.4c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faBus = {
    prefix: 'fasr',
    iconName: 'bus',
    icon: [
      576,
      512,
      [128653],
      'f207',
      
      'M112 272H464V400H432 364.2 144 112V272zm0-48V144H264v80H112zm352 0H312V144H464v80zM368 96V80L208 80V96H115.5c6.9-6.7 19.2-15.8 39-24.5C183.5 58.8 227 48 288 48c111.7 0 157.4 31 173.1 48H368zM88 448h8v40 24h48V488 448H364.2 432v40 24h48V488 448h8 24V424 256h32V128H512V92.1 85.8l-3.1-5.5C490.3 47 429.6 0 288 0C221.4 0 171.2 11.9 135.3 27.5C100.2 42.9 76.9 62.7 67.1 80.4L64 85.8v6.3V128H32V256H64V424v24H88zm88-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faPump = {
    prefix: 'fasr',
    iconName: 'pump',
    icon: [
      640,
      512,
      [],
      'e442',
      
      'M88 0H64V48H88h8V208H48v-8V176H0v24 32V376v32 24H48V408v-8H320V352H48V256h72 24V232 48h96V232v24h24 56V208H288V48h8 24V0H296 264 120 88zM400 185.7L462.5 144H592V464H462.5L400 422.3V185.7zM448 96l-96 64V448l96 64H592h48V464 144 96H592 448zm0 112v32h16 80 16V208H544 464 448zm0 80v32h16 80 16V288H544 464 448zm0 80v32h16 80 16V368H544 464 448z'
      
    ]
  };

  

  
  

  var faSignal = {
    prefix: 'fasr',
    iconName: 'signal',
    icon: [
      640,
      512,
      [128246,"signal-5","signal-perfect"],
      'f012',
      
      'M600 0V24 488v24H552V488 24 0h48zM472 96v24V488v24H424V488 120 96h48zM344 192v24V488v24H296V488 216 192h48zM216 288v24V488v24H168V488 312 288h48zM88 384v24 80 24H40V488 408 384H88z'
      
    ]
  };

  
    var faSignal5 = faSignal;
  
    var faSignalPerfect = faSignal;
  

  
  

  var faFileCode = {
    prefix: 'fasr',
    iconName: 'file-code',
    icon: [
      384,
      512,
      [],
      'f1c9',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM161 289l17-17L144 238.1l-17 17L79 303l-17 17 17 17 48 48 17 17L177.9 368l-17-17-31-31 31-31zM257 255l-17-17L206.1 272l17 17 31 31-31 31-17 17L240 401.9l17-17 48-48 17-17-17-17-48-48z'
      
    ]
  };

  

  
  

  var faToiletPaperBlankUnder = {
    prefix: 'fasr',
    iconName: 'toilet-paper-blank-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse-alt"],
      'e29f',
      
      'M71 84.3C85.4 56.9 101.1 48 112 48H324.7c-3 4.5-5.7 9.3-8.2 14.1C298.5 96.6 288 142.5 288 192s10.5 95.4 28.5 129.9c2.5 4.8 5.3 9.5 8.2 14.1H112c-10.9 0-26.6-8.9-41-36.3C57.2 273.3 48 235.3 48 192s9.2-81.3 23-107.7zM400 48c10.9 0 26.6 8.9 41 36.3c13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3s-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C373.4 56.9 389.1 48 400 48zm64 303.1V464H208V416H160v72 24h24H488h24V488 192c0-49.5-10.5-95.4-28.5-129.9C466 28.7 437.7 0 400 0H112C74.3 0 46 28.7 28.5 62.1C10.5 96.6 0 142.5 0 192s10.5 95.4 28.5 129.9C46 355.3 74.3 384 112 384H400c25.9 0 47.4-13.6 64-32.9zM424 192c0-26.5-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48s24-21.5 24-48z'
      
    ]
  };

  
    var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
  

  
  

  var faFloppyDisks = {
    prefix: 'fasr',
    iconName: 'floppy-disks',
    icon: [
      512,
      512,
      [],
      'e183',
      
      'M96 416h48H464h48V368 112L400 0H224 176 144 96V48 368v48zM176 48v72 24h24H360h24V120 51.9l80 80V368H144V48h32zm160 0V96H224V48H336zM48 120V96H0v24V488v24H24 392h24V464H392 48V120zM368 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faTowerObservation = {
    prefix: 'fasr',
    iconName: 'tower-observation',
    icon: [
      512,
      512,
      [],
      'e586',
      
      'M256 .8l10 4.6L434 82.2l21.8 10-20 43.7L416 126.7V232v24H392 371l34.7 208H488h24v48H488 24 0V464H24h82.3L141 256H120 96V232 126.7l-19.8 9.1-20-43.7L78 82.2 246 5.4 256 .8zm0 52.8L144 104.8V128H368V104.8L256 53.6zM144 176v32H368V176H144zM330.8 464L256 400.7 181.2 464H330.8zM185.9 278.5L256 337.8l70.1-59.3L322.3 256H189.7l-3.7 22.5zm-9.2 55.1l-13.8 83 55.9-47.3-42.1-35.6zm116.4 35.6l55.9 47.3-13.8-83-42.1 35.6z'
      
    ]
  };

  

  
  

  var faPen = {
    prefix: 'fasr',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      'M0 512l10.2-51L32 352 350.1 33.9 384 0l33.9 33.9 60.1 60.1L512 128l-33.9 33.9L160 480 51 501.8 0 512zm136.3-76.2L382.1 190.1l-60.1-60.1L76.2 375.7l-15 75.1 75.1-15z'
      
    ]
  };

  

  
  

  var faUserSlash = {
    prefix: 'fasr',
    iconName: 'user-slash',
    icon: [
      640,
      512,
      [],
      'f506',
      
      'M320 208c-10.8 0-21.1-2.1-30.5-6l-33.5-26c-10-13.4-15.9-30-15.9-47.9c0-44.2 35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM192 126.3L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L353.4 251.6C407.9 236.9 448 187.1 448 128C448 57.3 390.7 0 320 0C249.9 0 192.9 56.4 192 126.3zM264 304H160L110.8 464 96 512h50.2H493.8 544l-16 0-60.9-48H161l34.5-112H324.9L264 304z'
      
    ]
  };

  

  
  

  var faManhole = {
    prefix: 'fasr',
    iconName: 'manhole',
    icon: [
      512,
      512,
      [],
      'e1d6',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 128c16.6 0 30.3-12.6 31.8-28.8C361 113.9 416 178.5 416 256s-55 142.1-128.2 156.8C286.3 396.6 272.6 384 256 384s-30.3 12.6-31.8 28.8C151 398.1 96 333.5 96 256s55-142.1 128.2-156.8c1.6 16.2 15.2 28.8 31.8 28.8zm-80 48v32h32V176H176zm0 64v32h32V240H176zm32 64H176v32h32V304zm64-128H240v32h32V176zm-32 64v32h32V240H240zm32 64H240v32h32V304zm64-128H304v32h32V176zm-32 64v32h32V240H304zm32 64H304v32h32V304z'
      
    ]
  };

  

  
  

  var faHexagon = {
    prefix: 'fasr',
    iconName: 'hexagon',
    icon: [
      512,
      512,
      [11043],
      'f312',
      
      'M155.9 432l200.3 0L456.7 256 356.1 80 155.9 80 55.3 256 155.9 432zM0 256L128 32l256 0L512 256 384 480l-256 0L0 256z'
      
    ]
  };

  

  
  

  var faFileShield = {
    prefix: 'fasr',
    iconName: 'file-shield',
    icon: [
      576,
      512,
      [],
      'e4f0',
      
      'M48 464H312.6c13.9 18 30.4 34.3 49.5 48H336 48 0V464 48 0H48 256L384 128v80.3l-48 18.6V160H224V48H48V464zM527.3 312.4L432 275.5V460.4c56.5-26.3 90.2-87 95.3-148zM432 512c-96-32-144-130.1-144-216V279.7L432 224l144 55.8V296c0 85.9-48 184-144 216z'
      
    ]
  };

  

  
  

  var faPersonMilitaryToPerson = {
    prefix: 'fasr',
    iconName: 'person-military-to-person',
    icon: [
      512,
      512,
      [],
      'e54c',
      
      'M56 14.1v32H200V0L56 14.1zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-5.5-.7-10.9-2-16H66c-1.3 5.1-2 10.5-2 16zM345.8 272l6-32h64.3l6 32H345.8zM312 192l-15 80-9 48h48.8 94.3H480l-9-48-15-80H312zM58.7 213.1L32 320H197.8L58.7 213.1zm159 81.9L192 192H83.8L217.8 295zM272 432l96 80h16V456l104 0h24V408H488l-104 0V352H368l-96 80zM128 352v56L24 408H0l0 48H24l104 0v56h16l96-80-96-80H128z'
      
    ]
  };

  

  
  

  var faAudioDescription = {
    prefix: 'fasr',
    iconName: 'audio-description',
    icon: [
      576,
      512,
      [],
      'f29e',
      
      'M48 80V432H528V80H48zM0 32H48 528h48V80 432v48H528 48 0V432 80 32zM328 160h56c53 0 96 43 96 96s-43 96-96 96H328 304V328 184 160h24zm24 144h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96zM173.9 287.8h36.3L192 245.2l-18.1 42.6zm-17 40L146.5 352H94.4l75.6-177.4 6.2-14.6h31.7l6.2 14.6L289.6 352H237.5l-10.3-24.2H156.8z'
      
    ]
  };

  

  
  

  var faArrowsMinimize = {
    prefix: 'fasr',
    iconName: 'arrows-minimize',
    icon: [
      512,
      512,
      ["compress-arrows"],
      'e0a5',
      
      'M48 14.1L65 31l111 111V56 32h48V56 200v24H200 56 32V176H56h86.1L31 65l-17-17L48 14.1zM497.9 48L481 65l-111 111H456h24v48H456 312 288V200 56 32h48V56v86.1L447 31l17-17L497.9 48zM32 288H56 200h24v24V456v24H176V456 369.9L65 481l-17 17L14.1 464l17-17 111-111H56 32V288zm256 0h24H456h24v48H456 369.9L481 447l17 17L464 497.9l-17-17-111-111V456v24H288V456 312 288z'
      
    ]
  };

  
    var faCompressArrows = faArrowsMinimize;
  

  
  

  var faBootHeeled = {
    prefix: 'fasr',
    iconName: 'boot-heeled',
    icon: [
      512,
      512,
      [],
      'e33f',
      
      'M272 48V288l208 96v80h8 24v48H488h-8H432 344 320 272l-96-32-48-16v16 32h-7.8H80 48 0V464 384L24 256 0 64V48 0H48 224h48V48zM143.2 418.5L279.8 464H320h24 88V414.7L251.9 331.6 224 318.7V288 48H144V232v24H96V232 48H48V61L71.6 250l.9 7.4-1.4 7.4L48 388.5V416h79.8c5.2 0 10.3 .8 15.4 2.5z'
      
    ]
  };

  

  
  

  var faTicketAirline = {
    prefix: 'fasr',
    iconName: 'ticket-airline',
    icon: [
      640,
      512,
      ["ticket-perforated-plane","ticket-plane"],
      'e29a',
      
      'M0 112V64H48 592h48v48 48 48H616c-26.5 0-48 21.5-48 48s21.5 48 48 48h24v48 48 48H592 48 0V400 112zM48 400H592V349c-41.4-10.7-72-48.2-72-93s30.6-82.3 72-93V112H48V400zM432 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM186.7 224L160 144h56l46.7 80h40.3c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288H262.7L216 368H160l26.7-80H144l-24 32H88l16-64L88 192h32l24 32h42.7z'
      
    ]
  };

  
    var faTicketPerforatedPlane = faTicketAirline;
  
    var faTicketPlane = faTicketAirline;
  

  
  

  var faHeat = {
    prefix: 'fasr',
    iconName: 'heat',
    icon: [
      448,
      512,
      [],
      'e00c',
      
      'M200 32V56v88c0 36.4 11.8 71.7 33.6 100.8l19.2 25.6c28 37.4 43.2 82.9 43.2 129.6v56 24H248V456 400c0-36.3-11.8-71.7-33.6-100.8l-19.2-25.6C167.2 236.2 152 190.7 152 144V56 32h48zM48 96v24 37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456v24H96V456 418.1c0-33.2-9.8-65.6-28.2-93.2L36.3 277.7C12.6 242.2 0 200.5 0 157.9V120 96H48zm304 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456v24H400V456 418.1c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.3C316.6 242.2 304 200.5 304 157.9V120 96h48v24z'
      
    ]
  };

  

  
  

  var faFaceSadCry = {
    prefix: 'fasr',
    iconName: 'face-sad-cry',
    icon: [
      512,
      512,
      [128557,"sad-cry"],
      'f5b3',
      
      'M400 406.1V288 264H352v24V440.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V288 264H112v24V406.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zm0 61.6C467.6 421.6 512 344 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 88 44.4 165.6 112 211.7V472h6.5c39.7 25.3 86.9 40 137.5 40s97.8-14.7 137.5-40H400v-4.3zM199.5 234.3l32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8c20-27.1 59.8-27.1 79.8 0zm112.2 0c20-27.1 59.8-27.1 79.8 0l32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48V320c0-26.5-21.5-48-48-48s-48 21.5-48 48z'
      
    ]
  };

  
    var faSadCry = faFaceSadCry;
  

  
  

  var faEye = {
    prefix: 'fasr',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M129.1 361.4C93.6 327.2 67.7 286.9 52.5 256c15.1-30.9 41-71.2 76.6-105.4C171.8 109.5 224.9 80 288 80s116.2 29.5 158.9 70.6c35.6 34.3 61.5 74.5 76.6 105.4c-15.1 30.9-41 71.2-76.6 105.4C404.2 402.5 351.1 432 288 432s-116.2-29.5-158.9-70.6zM288 480c158.4 0 258-149.3 288-224C546 181.3 446.4 32 288 32S30 181.3 0 256c30 74.7 129.6 224 288 224zm0-144c-44.2 0-80-35.8-80-80c0-5.4 .5-10.6 1.5-15.7L288 256l-15.7-78.5c5.1-1 10.3-1.5 15.7-1.5c44.2 0 80 35.8 80 80s-35.8 80-80 80zM160 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-8.6 0-17 .8-25.1 2.5c-50.3 10-90 49.5-100.3 99.7l-.1 .7c-1.6 8.1-2.5 16.5-2.5 25.1z'
      
    ]
  };

  

  
  

  var faBusSimple = {
    prefix: 'fasr',
    iconName: 'bus-simple',
    icon: [
      448,
      512,
      ["bus-alt"],
      'f55e',
      
      'M48 272H400V400H368 300.2 80 48V272zm0-48V144H400v80H48zM51.5 96c6.9-6.7 19.2-15.8 39-24.5C119.5 58.8 163 48 224 48c111.7 0 157.4 31 173.1 48H51.5zM24 448h8v40 24H80V488 448H300.2 368v40 24h48V488 448h8 24V424 92.1 85.8l-3.1-5.5C426.3 47 365.6 0 224 0C157.4 0 107.2 11.9 71.3 27.5C36.2 42.9 12.9 62.7 3.1 80.4L0 85.8v6.3V424v24H24zm88-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faBusAlt = faBusSimple;
  

  
  

  var faChestnut = {
    prefix: 'fasr',
    iconName: 'chestnut',
    icon: [
      448,
      512,
      [127792],
      'e3f6',
      
      'M48 384v12.1L83.9 432H364.1L400 396.1V384H48zm351.4-48c-5.2-68.4-43.7-119.9-90-162.8c-19.9-18.4-39.7-33.9-58.6-48.7l0 0c-5-3.9-10-7.8-14.9-11.7c-4-3.2-8-6.4-11.9-9.6c-3.9 3.3-8 6.5-11.9 9.6c-4.9 3.9-9.8 7.7-14.9 11.7l0 0 0 0c-18.8 14.7-38.7 30.2-58.6 48.7c-46.3 42.8-84.8 94.3-90 162.8H399.4zM168.4 86.2c7.7-6 15-11.7 21.6-17.1C207.7 54.6 220.5 42.5 224 32c3.5 10.5 16.3 22.6 34.1 37.1c6.6 5.3 13.8 11 21.6 17.1C346.3 138.2 448 217.7 448 352v32 32l-64 64H64L0 416V384 352C0 217.7 101.7 138.2 168.4 86.2l0 0z'
      
    ]
  };

  

  
  

  var faTape = {
    prefix: 'fasr',
    iconName: 'tape',
    icon: [
      576,
      512,
      [],
      'f4db',
      
      'M224 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zM362.6 432c52-41 85.4-104.6 85.4-176C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H552h24V432H552 362.6zM224 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faBasketShopping = {
    prefix: 'fasr',
    iconName: 'basket-shopping',
    icon: [
      576,
      512,
      ["shopping-basket"],
      'f291',
      
      'M256.4 29.8L245.3 51.1 171.8 192H404.2L330.7 51.1 319.6 29.8 362.2 7.6l11.1 21.3L458.4 192h36.1H544h32v48H532L464 512H112L44 240H0V192H32 81.5h36.1L202.7 28.9 213.8 7.6l42.6 22.2zM93.5 240l56 224h277l56-224H93.5zM224 312v80 24H176V392 312 288h48v24zm88-24v24 80 24H264V392 312 288h48zm88 24v80 24H352V392 312 288h48v24z'
      
    ]
  };

  
    var faShoppingBasket = faBasketShopping;
  

  
  

  var faHouseMedicalFlag = {
    prefix: 'fasr',
    iconName: 'house-medical-flag',
    icon: [
      640,
      512,
      [],
      'e514',
      
      'M496 24V0H448V24v8V192 512h48V192H640V32H496V24zM416 133L286.3 36.7 272 26.1 257.7 36.7 19.4 213.5 .2 227.8l28.6 38.5L48 252.1l16-11.9V488v24H88 416V464l-304 0V218.4 204.6L272 85.9 416 192.7V133zM240 192v64H176v64h64v64h64V320h64V256H304V192H240z'
      
    ]
  };

  

  
  

  var faMobileButton = {
    prefix: 'fasr',
    iconName: 'mobile-button',
    icon: [
      384,
      512,
      [],
      'f10b',
      
      'M64 48V464H320V48H64zM16 0H64 320h48V48 464v48H320 64 16V464 48 0zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faTerminal = {
    prefix: 'fasr',
    iconName: 'terminal',
    icon: [
      576,
      512,
      [],
      'f120',
      
      'M14.3 80.2L-1.9 62.5 33.5 30.1 49.7 47.8l176 192L240.6 256l-14.9 16.2-176 192L33.5 481.9-1.9 449.5l16.2-17.7L175.4 256 14.3 80.2zM248 432H552h24v48H552 248 224V432h24z'
      
    ]
  };

  

  
  

  var faCircleSortUp = {
    prefix: 'fasr',
    iconName: 'circle-sort-up',
    icon: [
      512,
      512,
      ["sort-circle-up"],
      'e032',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-64L256 96l112 96v32H144V192zm0 96h32H336h32v32L256 416 144 320V288zm112 85.9L318.8 320H193.2L256 373.9z'
      
    ]
  };

  
    var faSortCircleUp = faCircleSortUp;
  

  
  

  var faBanSmoking = {
    prefix: 'fasr',
    iconName: 'ban-smoking',
    icon: [
      512,
      512,
      [128685,"smoking-ban"],
      'f54d',
      
      'M92.9 126.9L385.1 419.1C349.7 447.2 304.8 464 256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1zm165 97.1L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L353.9 320H400h16V304 240 224H400 257.9zm32 32H384v32H321.9l-32-32zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM288 96H256v16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v16h32V176c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16V96zM112 224H96v16 64 16h16H240.8l-96-96H112z'
      
    ]
  };

  
    var faSmokingBan = faBanSmoking;
  

  
  

  var faCartFlatbed = {
    prefix: 'fasr',
    iconName: 'cart-flatbed',
    icon: [
      640,
      512,
      ["dolly-flatbed"],
      'f474',
      
      'M24 0H0V48H24 80V440v24h24 56c0 26.5 21.5 48 48 48s48-21.5 48-48H448c0 26.5 21.5 48 48 48s48-21.5 48-48h72 24V416H616 496 208 128V24 0H104 24zM560 80V304H240V80h96V192l64-48 64 48V80h96zm0-48H464 336 240 192V80 304v48h48H560h48V304 80 32H560z'
      
    ]
  };

  
    var faDollyFlatbed = faCartFlatbed;
  

  
  

  var faCircleR = {
    prefix: 'fasr',
    iconName: 'circle-r',
    icon: [
      512,
      512,
      [],
      'e120',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v24V264v96 24h48V360 288h42.9l61.3 96h57l-62.7-98.1c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80H184 160zm48 112V176h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H264 208z'
      
    ]
  };

  

  
  

  var faArrowUpRight = {
    prefix: 'fasr',
    iconName: 'arrow-up-right',
    icon: [
      384,
      512,
      [],
      'e09f',
      
      'M328 96h24v24V360v24H304V360 177.9L81 401l-17 17L30.1 384l17-17 223-223H88 64V96H88 328z'
      
    ]
  };

  

  
  

  var faDolphin = {
    prefix: 'fasr',
    iconName: 'dolphin',
    icon: [
      512,
      512,
      [],
      'e168',
      
      'M80 160C80 98.1 130.1 48 192 48h30.3c42.2 0 81.9 10.8 116.4 29.8l8.6 4.7 9.4-2.6L420.6 62l-21.2 39.3-8 14.8 11.2 12.6c38.2 42.8 61.4 99.1 61.4 160.9c0 31.3-12.2 59.8-32 81c0-.9 0-1.8 0-2.6v-8c0-48.6-39.4-88-88-88H328 304v24 20.3l-38.3-37.5-7-6.8h-9.8H216 192 56 48v-8V248v-4.5l3.9-2.3 24.4-14.6 16.9-10.1-6.7-18.5C82.3 186 80 173.3 80 160zM384 368c0 22.1-17.9 40-40 40H238.4L216 352H128l32 80-32 80h88l22.4-56H344h1.7C437.5 456 512 381.5 512 289.7c0-68-23.4-130.5-62.6-179.9l35.8-66.4L496 23.2 476.3 11.4l-8-4.8-8.9-5.3-10 2.8L353 31.1C313.7 11.2 269.3 0 222.3 0H192C103.6 0 32 71.6 32 160c0 11.9 1.3 23.6 3.8 34.8L27.2 200l-15.5 9.3L0 216.3v13.6V248v16 32 24H24 56 192h24 23.1l42.1 41.2 7 6.8H298h30 24V344 320.8c18.3 3.7 32 19.8 32 39.2v8zM184 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faArrowsToLine = {
    prefix: 'fasr',
    iconName: 'arrows-to-line',
    icon: [
      448,
      512,
      [],
      'e0a7',
      
      'M224 201.9l17-17 72-72 17-17L296 62.1 279 79l-31 31L248 24V0H200V24l0 86.1L169 79l-17-17L118.1 96l17 17 72 72 17 17zM0 232v48H24 424h24V232H424 24 0zm241 95l-17-17-17 17-72 72-17 17L152 449.9l17-17 31-31V488v24h48V488 401.9l31 31 17 17L329.9 416l-17-17-72-72z'
      
    ]
  };

  

  
  

  var faFaucetDrip = {
    prefix: 'fasr',
    iconName: 'faucet-drip',
    icon: [
      512,
      512,
      [128688],
      'e006',
      
      'M248 128h40 9.9l7 7 25 25H360c83.9 0 152 68.1 152 152v48 24H488 376 352V360 328c0-4.4-3.6-8-8-8H323.9c-23.4 29.2-59.5 48-99.9 48s-76.5-18.8-99.9-48H24 0V272H24 136.3h13.1l7.1 11.1C170.8 305.3 195.7 320 224 320s53.2-14.7 67.4-36.9l7.1-11.1h13.1H344c30.9 0 56 25.1 56 56v8h64V312c0-57.4-46.6-104-104-104H320h-9.9l-7-7-25-25H177.9l-25 25-7 7H136 24 0V160H24 126.1l25-25 7-7H168h32V82.4L64 96V32L200 45.6V0h48V45.6L384 32V96L248 82.4V128zM432 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7L432 416z'
      
    ]
  };

  

  
  

  var faBarsProgress = {
    prefix: 'fasr',
    iconName: 'bars-progress',
    icon: [
      512,
      512,
      ["tasks-alt"],
      'f828',
      
      'M464 112v64H320V112H464zM48 64H0v48 64 48H48 464h48V176 112 64H464 48zM464 336v64H192V336H464zM48 288H0v48 64 48H48 464h48V400 336 288H464 48z'
      
    ]
  };

  
    var faTasksAlt = faBarsProgress;
  

  
  

  var faNfcSymbol = {
    prefix: 'fasr',
    iconName: 'nfc-symbol',
    icon: [
      512,
      512,
      [],
      'e531',
      
      'M141.6 26.4l13 12.1 189.7 176 17.6 16.3-32.6 35.2-17.6-16.3L135.6 86.2C82.7 123.4 48 186.4 48 256C48 331.9 89.3 400 150.3 435.2l-24 41.5C50.6 433 0 349.3 0 256S50.6 79 126.3 35.2l15.3-8.9zM464 256c0-75.9-41.3-143.9-102.3-179.2l24-41.5C461.4 79 512 162.7 512 256s-50.6 177-126.3 220.8l-15.3 8.9-13-12.1-189.7-176-17.6-16.3 32.6-35.2 17.6 16.3L376.4 425.8C429.3 388.6 464 325.6 464 256z'
      
    ]
  };

  

  
  

  var faSquareChevronUp = {
    prefix: 'fasr',
    iconName: 'square-chevron-up',
    icon: [
      448,
      512,
      ["chevron-square-up"],
      'f32c',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM241 167L345 271l17 17L328 321.9l-17-17-87-87-87 87-17 17L86.1 288l17-17L207 167l17-17 17 17z'
      
    ]
  };

  
    var faChevronSquareUp = faSquareChevronUp;
  

  
  

  var faHouseSignal = {
    prefix: 'fasr',
    iconName: 'house-signal',
    icon: [
      576,
      512,
      [],
      'e012',
      
      'M336 1.3l15 12 200 160 18.7 15-30 37.5-18.7-15-9-7.2V392v24H488 271.6c-5.9-16.8-13.4-32.8-22.1-48H464V165.1L336 62.7 208 165.1V312.8c-14.5-15.1-30.6-28.6-48-40.3v-69l-9 7.2-18.7 15-30-37.5 18.7-15 200-160 15-12zM384 192v96H288V192h96zM0 304V256c141.4 0 256 114.6 256 256H208c0-114.9-93.1-208-208-208zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 64c0-61.9-50.1-112-112-112V352c88.4 0 160 71.6 160 160H112z'
      
    ]
  };

  

  
  

  var faFaceRaisedEyebrow = {
    prefix: 'fasr',
    iconName: 'face-raised-eyebrow',
    icon: [
      512,
      512,
      [],
      'e388',
      
      'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 328h24H328h24v48H328 184 160V328zM328.8 141.8l-29.5 29.5L288 182.6 265.4 160l11.3-11.3 29.5-29.5c25-25 66.6-20.9 86.2 8.5l4.9 7.4 8.9 13.3-26.6 17.8-8.9-13.3-4.9-7.4c-8.4-12.6-26.2-14.4-36.9-3.7zM128 144h64 16v32H192 128 112V144h16z'
      
    ]
  };

  

  
  

  var faFaceZipper = {
    prefix: 'fasr',
    iconName: 'face-zipper',
    icon: [
      512,
      512,
      [],
      'e3a5',
      
      'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 32.2-7.3 62.8-20.4 90l42.9 21.5C502.8 333.8 512 296 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c40 0 77.8-9.2 111.5-25.5L346 443.6c-27.2 13.1-57.8 20.4-90 20.4C141.1 464 48 370.9 48 256zm304 82.7V336 320H320v16 32 2.7l9.4-9.4L352 338.7zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 336V320H192v16 32 16h32V368 336zm64-16H256v16 32 16h32V368 336 320zm-128 0H128v16 32 16h32V368 336 320zm352 96L384 352l-32 32 64 128h32l64-64V416zm-63.5 16.5l-16 16L424 457l-17-17 8.5-8.5 16-16L440 407l17 17-8.5 8.5z'
      
    ]
  };

  

  
  

  var faCardDiamond = {
    prefix: 'fasr',
    iconName: 'card-diamond',
    icon: [
      384,
      512,
      [],
      'e3ea',
      
      'M48 48V464H336V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM80 256L192 144 304 256 192 368 80 256z'
      
    ]
  };

  

  
  

  var faSquareParking = {
    prefix: 'fasr',
    iconName: 'square-parking',
    icon: [
      448,
      512,
      [127359,"parking"],
      'f540',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm160 96h88c53 0 96 43 96 96s-43 96-96 96H184v40 24H136V360 320 272 152 128h24zm88 144c26.5 0 48-21.5 48-48s-21.5-48-48-48H184v96h64z'
      
    ]
  };

  
    var faParking = faSquareParking;
  

  
  

  var faUserRobot = {
    prefix: 'fasr',
    iconName: 'user-robot',
    icon: [
      448,
      512,
      [],
      'e04b',
      
      'M240 16V0H208V16 64H112 64v48V272v48h48H336h48V272 112 64H336 240V16zm96 96V272H304V240H272v32H240V240H208v32H176V240H144v32H112V112H336zM83.7 400H364.3l19.2 64H304V432 416H272v16 32H240V432 416H208v16 32H176V432 416H144v16 32H64.5l19.2-64zM160 512h64 64H397.9 448l-14.4-48L400 352H48L14.4 464 0 512H50.1 160zM32 128H0V256H32V128zm416 0H416V256h32V128zM208 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFaceMehBlank = {
    prefix: 'fasr',
    iconName: 'face-meh-blank',
    icon: [
      512,
      512,
      [128566,"meh-blank"],
      'f5a4',
      
      'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faMehBlank = faFaceMehBlank;
  

  
  

  var faForwardFast = {
    prefix: 'fasr',
    iconName: 'forward-fast',
    icon: [
      512,
      512,
      [9197,"fast-forward"],
      'f050',
      
      'M448 64V88 222.1L272 97.9 224 64v58.8 99.4L48 97.9 0 64v58.8V389.2 448l48-33.9L224 289.9v99.4V448l48-33.9L448 289.9V424v24h48V424 256 88 64H448zM272 256V156.6L412.8 256 272 355.4V256zm-83.2 0L48 355.4V156.6L188.8 256z'
      
    ]
  };

  
    var faFastForward = faForwardFast;
  

  
  

  var faWineGlass = {
    prefix: 'fasr',
    iconName: 'wine-glass',
    icon: [
      320,
      512,
      [127863],
      'f4e3',
      
      'M64.2 176H255.8l1.9 21c5.2 57.5-40 107-97.7 107s-102.9-49.5-97.7-107l1.9-21zm4.4-48l7.3-80H244.2l7.3 80H68.6zM32 0L14.5 192.7C7.4 270.1 61.9 337.8 136 350V464H48v48H160 272V464H184V350c74.1-12.2 128.6-80 121.5-157.4L288 0H32z'
      
    ]
  };

  

  
  

  var faTags = {
    prefix: 'fasr',
    iconName: 'tags',
    icon: [
      512,
      512,
      [],
      'f02c',
      
      'M495.2 189.3l7 7v9.9 99.5 9.9l-7 7L337 481 303 447 454.2 295.8V216.2L303 65 337 31 495.2 189.3zM48 236.1l176 176 144-144V243.9L204.1 80H48V236.1zM224 32L416 224v64L257.9 446.1 224 480l-33.9-33.9L0 256V80 32H48 224zM80 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faArrowTurnRight = {
    prefix: 'fasr',
    iconName: 'arrow-turn-right',
    icon: [
      512,
      512,
      [],
      'e635',
      
      'M373.8 361l-17 17L322.9 344l17-17 79-79H48V456v24H0V456 224 200H24 418.9l-79-79-17-17 33.9-33.9 17 17 120 120 17 17-17 17-120 120z'
      
    ]
  };

  

  
  

  var faHeadSideMedical = {
    prefix: 'fasr',
    iconName: 'head-side-medical',
    icon: [
      512,
      512,
      [],
      'f809',
      
      'M112 361.7v19.6V448v16 48H96 64V480 464 381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1V264v24 16 32H496 480 464 448v48 16 16 32H416 400 368 320v16 16 16 16H288 272V464 448 400h48 80V336 288h48 16V270.1l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48H224C126.8 48 48 127 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM192 160V96h64v64h64v64H256v64H192V224H128V160h64z'
      
    ]
  };

  

  
  

  var faFileCircleMinus = {
    prefix: 'fasr',
    iconName: 'file-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ed',
      
      'M48 464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 48 0H48 256L384 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48V464zm240-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16V352H496 368 352v32h16H496h16z'
      
    ]
  };

  

  
  

  var faUserTieHairLong = {
    prefix: 'fasr',
    iconName: 'user-tie-hair-long',
    icon: [
      448,
      512,
      [],
      'e460',
      
      'M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16 48L48 240v32H224 400V240l-48-48V144 128C352 57.3 294.7 0 224 0zM209.1 359.2l-15.9 59.2L144 320H64L16 464 0 512H50.6 168h18.3 75.3H280 397.4 448l-16-48L384 320H304l-49.2 98.4-15.9-59.2L272 304H224 176l33.1 55.2zM381.4 464H285.7l48-96h15.7l32 96zM114.3 368l48 96H66.6l32-96h15.7z'
      
    ]
  };

  

  
  

  var faTeethOpen = {
    prefix: 'fasr',
    iconName: 'teeth-open',
    icon: [
      576,
      512,
      [],
      'f62f',
      
      'M528 48v77.4C512.1 102.8 485.8 88 456 88c-15.2 0-29.5 3.9-42 10.7C397.9 77.6 372.5 64 344 64c-21.3 0-40.8 7.5-56 20.1C272.8 71.5 253.3 64 232 64c-28.5 0-53.9 13.6-70 34.7C149.5 91.9 135.2 88 120 88c-29.8 0-56.1 14.8-72 37.4V48H528zm16 208h32V208 48 0H528 48 0V48 208v48H32 48 80h64 16 32 16 48 16 32 16 48 16 32 16 64 32 16zm-48-48H464 448 432 416V176c0-5.7 1.2-11.1 3.3-16c1.2-2.9 2.8-5.5 4.7-8c2.2-2.9 4.8-5.5 7.7-7.7c6.7-5.2 15.2-8.3 24.3-8.3c16.4 0 30.5 9.9 36.7 24c2.1 4.9 3.3 10.3 3.3 16v32zm-112 0H368 352 336 320 304V160v-8c0-10.9 4.4-20.8 11.4-28c7.3-7.4 17.4-12 28.6-12c15.2 0 28.4 8.5 35.2 21c3.1 5.7 4.8 12.1 4.8 19v8 16 32zm-112 0H256 240 224 208 192V176 160v-8c0-6.9 1.7-13.4 4.8-19c6.8-12.5 20-21 35.2-21c11.2 0 21.3 4.6 28.6 12c7.1 7.2 11.4 17.1 11.4 28v8 48zm-112 0H144 128 112 80V176c0-5.7 1.2-11.1 3.3-16c6.2-14.1 20.3-24 36.7-24c9.2 0 17.6 3.1 24.3 8.3c2.9 2.2 5.5 4.8 7.7 7.7c1.8 2.5 3.4 5.1 4.7 8c2.1 4.9 3.3 10.3 3.3 16v32zM32 288H0v48V464v48H48 528h48V464 336 288H544 528 496 432 416 384 368 320 304 272 256 208 192 160 144 80 48 32zM528 410.6V464H48V410.6C63.9 433.2 90.2 448 120 448c21.3 0 40.8-7.5 56-20.1c15.2 12.6 34.7 20.1 56 20.1s40.8-7.5 56-20.1c15.2 12.6 34.7 20.1 56 20.1s40.8-7.5 56-20.1c15.2 12.6 34.7 20.1 56 20.1c29.8 0 56.1-14.8 72-37.4zM496 336v24c0 9-3 17.3-8 24c-7.3 9.7-18.9 16-32 16c-11.2 0-21.3-4.6-28.6-12c-1.2-1.3-2.4-2.6-3.4-4c-5-6.7-8-15-8-24V336h16 16 16 32zm-112 0v24c0 9-3 17.3-8 24c-1.1 1.4-2.2 2.8-3.4 4c-7.3 7.4-17.4 12-28.6 12s-21.3-4.6-28.6-12c-1.2-1.3-2.4-2.6-3.5-4c-5-6.7-8-15-8-24V336h16 16 16 16 16zm-112 0v24c0 9-3 17.3-8 24c-1.1 1.4-2.2 2.8-3.5 4c-7.3 7.4-17.4 12-28.6 12s-21.3-4.6-28.6-12c-1.2-1.3-2.4-2.6-3.5-4c-5-6.7-8-15-8-24V336h16 16 16 16 16zm-112 0v24c0 9-3 17.3-8 24c-1.1 1.4-2.2 2.8-3.5 4c-7.3 7.4-17.4 12-28.6 12c-13.1 0-24.7-6.3-32-16c-5-6.7-8-15-8-24V336h32 16 16 16z'
      
    ]
  };

  

  
  

  var faCommentMedical = {
    prefix: 'fasr',
    iconName: 'comment-medical',
    icon: [
      512,
      512,
      [],
      'f7f5',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM224 208H160v64h64v64h64V272h64V208H288V144H224v64z'
      
    ]
  };

  

  
  

  var faPanorama = {
    prefix: 'fasr',
    iconName: 'panorama',
    icon: [
      640,
      512,
      [],
      'e209',
      
      'M0 32V80 432v48H48h5.5c84.8-30.3 176.9-40 266.5-40s181.7 9.7 266.5 40H592h48V432 80 32H592h-5.5C501.7 62.3 409.5 72 320 72s-181.7-9.7-266.5-40H48 0zM48 80.9C136.7 110.7 230.9 120 320 120s183.3-9.3 272-39.1V431.1c-21.9-7.4-44.2-13.5-66.7-18.6l-1.7-2.4-136-192L368 190.5l-19.6 27.6L267 333l-31.7-43.2L216 263.4l-19.4 26.4-88 120-3.7 5c-19.2 4.6-38.2 10-57 16.3V80.9zM176 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faClipboardQuestion = {
    prefix: 'fasr',
    iconName: 'clipboard-question',
    icon: [
      384,
      512,
      [],
      'e4e3',
      
      'M336 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H80 48 0v48V464v48H48 336h48V464 112 64H336zM80 112v48H192 304V112h32V464H48V112H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM104 248l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8h56.9c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L168 300.6v13.9V336v24h48V336v-7.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H160c-30.9 0-56 25.1-56 56zm64 200h48V400H168v48z'
      
    ]
  };

  

  
  

  var faCartCircleCheck = {
    prefix: 'fasr',
    iconName: 'cart-circle-check',
    icon: [
      640,
      512,
      [],
      'e3f1',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H510.7L475.3 193.2c6.8-.8 13.7-1.2 20.7-1.2c10 0 19.7 .8 29.2 2.4L561 80l15-48H525.7 122l-2.4-12.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faRoute = {
    prefix: 'fasr',
    iconName: 'route',
    icon: [
      512,
      512,
      [],
      'f4d7',
      
      'M454.1 126.5c-7.3 14.5-17.4 30-28.5 44.7c-3.2 4.3-6.4 8.4-9.6 12.4c-3.2-3.9-6.4-8.1-9.6-12.4c-11-14.7-21.2-30.2-28.5-44.7c-7.6-15.3-9.9-25.4-9.9-30.5c0-26.5 21.5-48 48-48s48 21.5 48 48c0 5.1-2.3 15.3-9.9 30.5zm-6 93.6C476 186.4 512 135.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 34.7 28.3 78.9 54.1 112H264 240v24V360v24h24H464v80H177.8c-2.7 3.8-5.5 7.6-8.2 11.2c-10.7 14.2-21.3 26.9-30 36.8H488h24V488 360 336H488 288V256H416s14.4-14.4 32.1-35.8zm-314 162.4c-7.3 14.5-17.4 30-28.5 44.7c-3.2 4.3-6.4 8.4-9.6 12.4c-3.2-3.9-6.4-8.1-9.6-12.4c-11-14.7-21.2-30.2-28.5-44.7C50.3 367.3 48 357.1 48 352c0-26.5 21.5-48 48-48s48 21.5 48 48c0 5.1-2.3 15.3-9.9 30.5zm3.8 81.5c25.9-33.1 54.1-77.3 54.1-112c0-53-43-96-96-96s-96 43-96 96c0 39.2 36 90.4 63.9 124.2C81.6 497.6 96 512 96 512s4.4-4.4 11.3-11.9c.1-.2 .3-.3 .4-.5c2.9-3.2 6.3-7 10-11.2c.3-.3 .6-.7 .9-1c3-3.5 6.2-7.2 9.5-11.3c3.2-3.8 6.5-7.9 9.8-12.2z'
      
    ]
  };

  

  
  

  var faTruckField = {
    prefix: 'fasr',
    iconName: 'truck-field',
    icon: [
      640,
      512,
      [],
      'e58d',
      
      'M352 80v24V224 336H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64V288 128 80H352zM16 288v48H0v48H16h8H64c0 53 43 96 96 96s96-43 96-96h96 32c0 53 43 96 96 96s96-43 96-96h32 8 24V336H616h-8V224H539L477.7 93.8 471.2 80H456 400V32H352 64 16V80v48H0V288H16zm144 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM485.9 224H400V128h40.8l45.2 96zM528 384a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faBasketShoppingPlus = {
    prefix: 'fasr',
    iconName: 'basket-shopping-plus',
    icon: [
      576,
      512,
      [],
      'e653',
      
      'M256.4 29.8L245.3 51.1 171.8 192H404.2L330.7 51.1 319.6 29.8 362.2 7.6l11.1 21.3L458.4 192h36.1H544h32v48H532L464 512H112L44 240H0V192H32 81.5h36.1L202.7 28.9 213.8 7.6l42.6 22.2zM482.5 240H93.5l56 224h277l56-224zM200 328h24 40V288l0-24h48l0 24v40h40 24v48H352 312v40 24H264V416 376H224 200V328z'
      
    ]
  };

  

  
  

  var faUserCrown = {
    prefix: 'fasr',
    iconName: 'user-crown',
    icon: [
      448,
      512,
      [],
      'f6a4',
      
      'M96 53.7V144c0 70.7 57.3 128 128 128s128-57.3 128-128V53.7 0L304 24l-16 8L224 0 160 32l-16-8L96 0V53.7zM144 128H304v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128zM99.5 352H348.5L383 464H65L99.5 352zM384 304H64L14.8 464 0 512H50.2 397.8 448l-14.8-48L384 304z'
      
    ]
  };

  

  
  

  var faFaceClouds = {
    prefix: 'fasr',
    iconName: 'face-clouds',
    icon: [
      640,
      512,
      [],
      'e47d',
      
      'M128 0c23.7 0 44.4 12.9 55.4 32H224c35.3 0 64 28.7 64 64v64H224 0V96C0 60.7 28.7 32 64 32h8.6C83.6 12.9 104.3 0 128 0zm84.7 192H224h44.1c2.7 4.7 4.3 10.2 4.3 16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16zM307.4 48.4C296.8 29.8 280.1 15.2 260.1 7c19.2-4.6 39.2-7 59.9-7C461.4 0 576 114.6 576 256c0 14.8-1.3 29.3-3.7 43.5c-12.5-10.8-28.3-17.8-45.7-19.2c.9-8 1.4-16.1 1.4-24.3c0-114.9-93.1-208-208-208c-4.2 0-8.4 .1-12.6 .4zM72.1 192h50c-6.5 20.2-10 41.7-10 64c0 81 46.3 151.2 114 185.6c-1.3 7.3-2 14.8-2 22.4v29.4c-93.8-38-160-130-160-237.4c0-22.1 2.8-43.5 8.1-64zM640 512H320 256v-8.1V480 464c0-3.3 .2-6.6 .5-9.9c4.4-43.1 37.3-77.7 79.5-84.8c0-.4 0-.9 0-1.3c0-44.2 35.8-80 80-80c29.3 0 54.9 15.8 68.9 39.3c8.8-9.4 21.3-15.3 35.1-15.3c26.5 0 48 21.5 48 48v11c41.4 10.7 72 48.2 72 93v48zM400.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faAnchorCircleExclamation = {
    prefix: 'fasr',
    iconName: 'anchor-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ab',
      
      'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216 192v48h24 48V464H120V352h72L96 256 0 352H72V488v24H96 288 394.8c-18.3-12.9-34.1-29.2-46.3-48H312V240h48 15.2c2.8-2.7 5.8-5.3 8.8-7.8V192H360 312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64H480V416h32v32zm0-176v16 80 16H480V368 288 272h32z'
      
    ]
  };

  

  
  

  var faFiles = {
    prefix: 'fasr',
    iconName: 'files',
    icon: [
      448,
      512,
      [],
      'e178',
      
      'M144 368H400V128H320V48H144V368zM352 0l96 96V368v48H400 144 96V368 48 0h48H352zM48 96v24V464H328h24v48H328 24 0V488 120 96H48z'
      
    ]
  };

  

  
  

  var faCircleCaretLeft = {
    prefix: 'fasr',
    iconName: 'circle-caret-left',
    icon: [
      512,
      512,
      ["caret-circle-left"],
      'f32e',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 384l32 0 0-256-32 0L144 256 272 384z'
      
    ]
  };

  
    var faCaretCircleLeft = faCircleCaretLeft;
  

  
  

  var faTrashXmark = {
    prefix: 'fasr',
    iconName: 'trash-xmark',
    icon: [
      448,
      512,
      [],
      'e2b4',
      
      'M160 0H147.2L140 10.7 93.8 80H80.1 32 0v48H35.6L64 512H384l28.4-384H448V80H416 367.9 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM108.6 464L83.7 128H364.3L339.4 464H108.6zM316.3 224L288 195.7l-14.1 14.1L224 259.7l-49.9-49.9L160 195.7 131.7 224l14.1 14.1L195.7 288l-49.9 49.9L131.7 352 160 380.3l14.1-14.1L224 316.3l49.9 49.9L288 380.3 316.3 352l-14.1-14.1L252.3 288l49.9-49.9L316.3 224z'
      
    ]
  };

  

  
  

  var faCat = {
    prefix: 'fasr',
    iconName: 'cat',
    icon: [
      576,
      512,
      [128008],
      'f6be',
      
      'M344 0h24 9.9l7 7 41 41h44.1L511 7l7-7H528h24 24V24 160c0 70.7-57.3 128-128 128s-128-57.3-128-128V24 0h24zm24 160c0 44.2 35.8 80 80 80s80-35.8 80-80V57.9L497 89l-7 7H480 416h-9.9l-7-7-31-31V160zm48-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM285 182l4.4-.4c2.2 16.6 7 32.4 13.9 46.9l-14 1.3C188.9 238.9 112 323.1 112 423.9V464H256V400c0-17.7-14.3-32-32-32H192V320h32c39.2 0 71.8 28.2 78.7 65.4l96.2-39.6L432 332.2V368v96h32V319.2c16.9-1.7 33.1-6 48-12.5V488v24H488 408 384V488 403.8l-80 32.9V464h24 24v48H328 88 64V488l0-64 0-.1V184c0-22.1-17.9-40-40-40H0V96H24c48.6 0 88 39.4 88 88v95c40-53.7 101.7-90.5 173-97z'
      
    ]
  };

  

  
  

  var faTruckFront = {
    prefix: 'fasr',
    iconName: 'truck-front',
    icon: [
      512,
      512,
      [],
      'e2b7',
      
      'M48 48V208H68.4l45.8-98.1L120.7 96H136 376h15.3l6.5 13.9L443.6 208H464V48H48zm0 208V400H464V256H48zM0 208V48 0H48 464h48V48 208v48V400v48H480v64H432V448H80v64H32V448H0V400 256 208zm121.4 0H390.6l-29.9-64H151.3l-29.9 64zM96 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faSquareQuarters = {
    prefix: 'fasr',
    iconName: 'square-quarters',
    icon: [
      448,
      512,
      [],
      'e44e',
      
      'M0 32H48 400h48V80 432v48H400 48 0V432 80 32zM48 80L224 256 400 80H48zm0 352H400L224 256 48 432z'
      
    ]
  };

  

  
  

  var faFileDoc = {
    prefix: 'fasr',
    iconName: 'file-doc',
    icon: [
      512,
      512,
      [],
      'e5ed',
      
      'M48 464H96v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176 160V496 368 352h16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8 16H480V400v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8V448h32v16 8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z'
      
    ]
  };

  

  
  

  var faArrowDownFromDottedLine = {
    prefix: 'fasr',
    iconName: 'arrow-down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e090',
      
      'M241.3 461.5L224 479.4l-17.3-17.9L78.7 328.7 62.1 311.4l34.6-33.3 16.7 17.3 86.7 90V184 160h48v24V385.3l86.7-90 16.7-17.3 34.6 33.3-16.7 17.3-128 132.8zM64 96H0V32H64V96zm96 0H96V32h64V96zm32-64h64V96H192V32zM352 96H288V32h64V96zm32 0V32h64V96H384z'
      
    ]
  };

  

  
  

  var faPhoneFlip = {
    prefix: 'fasr',
    iconName: 'phone-flip',
    icon: [
      512,
      512,
      [128381,"phone-alt"],
      'f879',
      
      'M207.7 387.5l31.9-18.4c53.8-31 98.6-75.8 129.6-129.6l18.4-31.9-26-26-33.2-33.2L366 54.2 463.9 72C459.7 286.6 286.6 459.7 72.1 463.9L54.3 366l94.2-37.7 33.2 33.2 26 26zM160 272L0 336 32 512H64c247.4 0 448-200.6 448-448l0-32L336 0 272 160l55.6 55.6c-26.8 46.5-65.5 85.2-112 112L160 272z'
      
    ]
  };

  
    var faPhoneAlt = faPhoneFlip;
  

  
  

  var faBridge = {
    prefix: 'fasr',
    iconName: 'bridge',
    icon: [
      576,
      512,
      [],
      'e4c8',
      
      'M24 32H0V80H24 72v64H24 0v48H24 72h48 80 48H552h24V144H552 504V80h40 24V32H544 24zM456 80v64H376V80h80zM328 80v64H248V80h80zM200 80v64H120V80h80zM24 240H0v48H24c26.5 0 48 21.5 48 48V456v24H96h96 24V456 360c0-39.8 32.2-72 72-72s72 32.2 72 72v96 24h24 96 24V456 336c0-26.5 21.5-48 48-48h24V240H552c-53 0-96 43-96 96v96H408V360c0-66.3-53.7-120-120-120s-120 53.7-120 120v72H120V336c0-53-43-96-96-96z'
      
    ]
  };

  

  
  

  var faHatCowboy = {
    prefix: 'fasr',
    iconName: 'hat-cowboy',
    icon: [
      640,
      512,
      [],
      'f8c0',
      
      'M320 80L260.1 52.4 216 32 202.8 78.8 151.7 260.6c13.9 5 29.2 9.6 46 13.6L247 99.2l52.9 24.4 20.1 9.3 20.1-9.3L393 99.2l49.2 175.1c16.8-4 32.1-8.7 46-13.6L437.2 78.8 424 32 379.9 52.4 320 80zM24 224L0 256s96 192 320 192s320-192 320-192l-24-32s-94.5 96-296 96s-296-96-296-96z'
      
    ]
  };

  

  
  

  var faWarehouseFull = {
    prefix: 'fasr',
    iconName: 'warehouse-full',
    icon: [
      640,
      512,
      ["warehouse-alt"],
      'f495',
      
      'M320 6.1l9 3.7 296 120 15 6.1V152 488v24H592V488 168.2L320 57.9 48 168.2V488v24H0V488 152 135.8l15-6.1L311 9.8l9-3.7zM96 192h24H520h24v24V488v24H496V488 240H144V488v24H96V488 216 192zm224 96v96H176V288H320zM464 416v96H352V416H464zm-288 0H320v96H176V416z'
      
    ]
  };

  
    var faWarehouseAlt = faWarehouseFull;
  

  
  

  var faCodeBranch = {
    prefix: 'fasr',
    iconName: 'code-branch',
    icon: [
      448,
      512,
      [],
      'f126',
      
      'M48 48v64h64V48H48zM0 0H48h64 48V48v64 48H112h-8v96c20.1-15.1 45-24 72-24h96c39.8 0 72-32.2 72-72h-8H288V112 48 0h48 64 48V48v64 48H400h-8c0 66.3-53.7 120-120 120H176c-39.8 0-72 32.2-72 72h8 48v48 64 48H112 48 0V464 400 352H48h8V160H48 0V112 48 0zM112 400H48v64h64V400zM400 48H336v64h64V48z'
      
    ]
  };

  

  
  

  var faObjectSubtract = {
    prefix: 'fasr',
    iconName: 'object-subtract',
    icon: [
      512,
      512,
      [],
      'e49e',
      
      'M48 48l48 0V0H48 0V48 96H48l0-48zm176 0V0H128V48l96 0zM48 128H0v96H48l0-96zm0 128H0v48 48H48 96l0-48H48l0-48zm80 96h32l48 0h16V304l-96 0v48zm32 32l0 80v48h48l256 0h48V464 208l0-48H464l-80 0v48l80 0 0 256-256 0 0-80H160zM352 208l0-48V128H304l0 96h48V208zm0-160V0H304 256V48l48 0V96h48V48zM256 304v48h48 48V304 256H304v48H256z'
      
    ]
  };

  

  
  

  var faHouseWater = {
    prefix: 'fasr',
    iconName: 'house-water',
    icon: [
      576,
      512,
      ["house-flood"],
      'f74f',
      
      'M288 .5l15.5 13.2 264 224-31.1 36.6L512 253.5V390.9c-3.8-2.6-7.8-5.5-12.3-8.7l0 0L480 368l-16 11.5V212.8L288 63.5 112 212.8V379.5L96 368 77.4 381.4l-1.1 .8c-4.4 3.2-8.5 6.1-12.3 8.7V253.5L39.5 274.3 8.5 237.7l264-224L288 .5zM256 224v64h64V224H256zm0-48h64 48v48 64 48H320 256 208V288 224 176h48zM79 488.9C59.7 499.8 31.5 512 0 512V464c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  
    var faHouseFlood = faHouseWater;
  

  
  

  var faPopcorn = {
    prefix: 'fasr',
    iconName: 'popcorn',
    icon: [
      448,
      512,
      [127871],
      'f819',
      
      'M32 156c0 1.3 .1 2.7 .2 4h87.6H328.2h87.6c.1-1.3 .2-2.7 .2-4c0-20.9-14.5-38.3-34-42.9c1.3-4.2 2-8.6 2-13.1c0-24.3-19.7-44-44-44c-1.9 0-3.7 .1-5.6 .3C329.3 37.7 312.3 24 292 24c-8.5 0-16.5 2.4-23.2 6.6C261.8 12.7 244.4 0 224 0s-37.8 12.7-44.8 30.6C172.5 26.4 164.5 24 156 24c-20.3 0-37.3 13.7-42.4 32.3c-1.8-.2-3.7-.3-5.6-.3c-24.3 0-44 19.7-44 44c0 4.6 .7 9 2 13.1c-19.5 4.5-34 22-34 42.9zm85.5 308l-56-224h39.8l46.1 192h32.9L134.2 240H208V416v16h32V416 240h73.8L267.7 432h32.9l46.1-192h39.8l-56 224h-213zM224 192H49.5 0l12 48L80 512H368l68-272 12-48H398.5 224z'
      
    ]
  };

  

  
  

  var faFaceHandOverMouth = {
    prefix: 'fasr',
    iconName: 'face-hand-over-mouth',
    icon: [
      512,
      512,
      [129762],
      'e378',
      
      'M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1v10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 113.1-73.3 209.1-175.1 242.9l52.3-52.3L411.9 424l-15-15c41.3-38 67.1-92.5 67.1-153c0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM302.6 296l-11.3 11.3-56 56 9.4 9.4 72-72L328 289.4 350.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L344 337.4 366.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L344 401.4 366.6 424l-11.3 11.3-48.8 48.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V404 384 354.4v-20h40v20 15l84.7-84.7L280 273.4 302.6 296z'
      
    ]
  };

  

  
  

  var faCircleK = {
    prefix: 'fasr',
    iconName: 'circle-k',
    icon: [
      512,
      512,
      [],
      'e113',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369.1 128H304.6l-82.5 92L208 235.8V152 128H160v24V298.5 360v24h48V360 307.7l29.1-32.5L309.2 384h57.6l-4.8-7.3L270.3 238.3l97.9-109.1 1-1.1z'
      
    ]
  };

  

  
  

  var faArrowRightFromArc = {
    prefix: 'fasr',
    iconName: 'arrow-right-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b1',
      
      'M381.1 134.4L363.5 118l-32.7 35.2 17.6 16.3L415.6 232 184 232l-24 0 0 48 24 0 231.7 0-67.2 62.4-17.6 16.3 32.7 35.2 17.6-16.3 112-104L512 256l-18.9-17.6-112-104zM48 256C48 141.1 141.1 48 256 48l24 0 0-48L256 0C114.6 0 0 114.6 0 256S114.6 512 256 512l24 0 0-48-24 0C141.1 464 48 370.8 48 256z'
      
    ]
  };

  

  
  

  var faTypewriter = {
    prefix: 'fasr',
    iconName: 'typewriter',
    icon: [
      512,
      512,
      [],
      'f8e7',
      
      'M104 0H80V24 160h48V48H342.1L384 89.9V160h48V80 70.1l-7-7L369 7l-7-7H352 104zM0 192v96H32V464v48H80 432h48V464 288h32V192H352l-32 32H192l-32-32H0zm80 96H432V464H80V288zm48 96v48H384V384H128zm40-64H128v40h40V320zm32 0v40h40V320H200zm112 0H272v40h40V320zm32 0v40h40V320H344z'
      
    ]
  };

  

  
  

  var faCanFood = {
    prefix: 'fasr',
    iconName: 'can-food',
    icon: [
      384,
      512,
      [129387],
      'e3e6',
      
      'M320 434.3c-3.4 3-10.2 7.5-21.7 12.2C273.5 456.6 235.9 464 192 464s-81.5-7.4-106.3-17.5c-11.5-4.7-18.3-9.2-21.7-12.2V289.4c13.8 6 30 11 48 14.7V368H272V304.1c18-3.8 34.2-8.8 48-14.7V434.3zm48 5.7V240 72c0-39.8-78.8-72-176-72S16 32.2 16 72V240 440c0 39.8 78.8 72 176 72s176-32.2 176-72zM304 72c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24s112 10.7 112 24zM224 320H160V256h64v64z'
      
    ]
  };

  

  
  

  var faBorderCenterH = {
    prefix: 'fasr',
    iconName: 'border-center-h',
    icon: [
      448,
      512,
      [],
      'f89c',
      
      'M0 480l64 0 0-64L0 416l0 64zm96 0l64 0 0-64-64 0 0 64zM96 96l64 0 0-64L96 32l0 64zM288 416l0 64 64 0 0-64-64 0zm0-320l64 0 0-64-64 0 0 64zM192 416l0 64 64 0 0-64-64 0zm0-320l64 0 0-64-64 0 0 64zM384 416l0 64 64 0 0-64-64 0zm0-384l0 64 64 0 0-64-64 0zM0 96l64 0 0-64L0 32 0 96zM192 320l0 64 64 0 0-64-64 0zm192 64l64 0 0-64-64 0 0 64zM0 320l0 64 64 0 0-64L0 320zM384 192l64 0 0-64-64 0 0 64zM0 128l0 64 64 0 0-64L0 128zm192 64l64 0 0-64-64 0 0 64zM24 232L0 232l0 48 24 0 400 0 24 0 0-48-24 0L24 232z'
      
    ]
  };

  

  
  

  var faBookBookmark = {
    prefix: 'fasr',
    iconName: 'book-bookmark',
    icon: [
      448,
      512,
      [],
      'e0bb',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H400V48H352V240l-80-64-80 64V48H88C65.9 48 48 65.9 48 88V358.7z'
      
    ]
  };

  

  
  

  var faHandshakeSlash = {
    prefix: 'fasr',
    iconName: 'handshake-slash',
    icon: [
      640,
      512,
      [],
      'e060',
      
      'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368H544v16h96V128H608 584 544 505.1L439.9 70.1 433.1 64H424 328h-9.5l-6.9 6.5-86 80.9-31.7-24.8L209.5 112h15.3l48-48H200h-9.5l-6.9 6.5L155.7 96.7 38.8 5.1zM263.8 181.4L337.5 112h77.4l65.2 57.9 6.8 6.1H496h48V320H456 440.6l-99.4-77.9 35.1-32.4 17.6-16.3-32.6-35.3-17.6 16.3-40.9 37.7-39.1-30.7zM96 171.6L40.6 128H32 0V384H96V352h11l45 45 7 7 17 17 38.2 38.2 17 17 17-17 23.3-23.3 21 21 17 17 17-17 58-58-38-29.9-37 37-21-21-17-17-17 17-23.3 23.3-21.3-21.3-17-17-7-7-52-52-7-7h-9.9H96V224 176v-4.4zM256.7 320h-4.4l2 2.2 2.4-2.2zM32 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm560-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faPlaneDeparture = {
    prefix: 'fasr',
    iconName: 'plane-departure',
    icon: [
      640,
      512,
      [128747],
      'f5b0',
      
      'M176 33.4l-8.7-3.1-8.5 3.6-96 40L20 91.6l39.2 24.7L192 199.9 151 221.4l-45.5-19.5-11.9-5.1L82.7 204l-48 32L11.3 251.6l19.1 20.7 96 104 7.1 7.7H144 256h5.9l5.2-2.7L524.5 246.1c45.3-23.8 81.5-61.7 103.1-108c19.6-42-11-90.1-57.4-90.1H519.5c-24.6 0-48.8 6-70.5 17.4L375.1 104 176 33.4zm-52.1 67l44.7-18.6L369 152.8l9.9 3.5 9.3-4.9 83.1-43.5c14.9-7.8 31.4-11.9 48.3-11.9h50.8c11.2 0 18.6 11.6 13.9 21.8c-17.2 36.8-46 67-81.9 85.8L250.1 336H154.5L84.7 260.4l13.8-9.2 44.1 18.9 10.5 4.5 10.1-5.3 88.1-46.2 36.9-19.4-35.3-22.2L124 100.4zM24 464H0v48H24 616h24V464H616 24z'
      
    ]
  };

  

  
  

  var faBuoy = {
    prefix: 'fasr',
    iconName: 'buoy',
    icon: [
      576,
      512,
      [],
      'e5b5',
      
      'M416 0H160V48h36.1L142.2 304H96 48v48 49c8.9-4.9 17.3-10.9 28.3-18.8l1.1-.8L96 368V352H480v16l0 0 19.7 14.2c11 7.9 19.3 13.9 28.3 18.8V352 304H480 433.8L379.9 48H416V0zM330.8 48l11.9 56.6L288 168.5l-54.8-63.9L245.2 48h85.7zM220.8 163.8l35.6 41.5-58.8 68.6 23.2-110.1zM288 242.2L341 304H235l53-61.8zm90.4 31.7l-58.8-68.6 35.6-41.5 23.2 110.1zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V464c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4c-13 11.6-24.8 22.2-40.2 30.9C39.4 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1z'
      
    ]
  };

  

  
  

  var faImageUser = {
    prefix: 'fasr',
    iconName: 'image-user',
    icon: [
      512,
      512,
      [],
      'e1b8',
      
      'M48 80V432H464V80H48zM0 32H48 464h48V80 432v48H464 48 0V432 80 32zM192 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 96l32 96H144l32-96H336z'
      
    ]
  };

  

  
  

  var faTicketsPerforated = {
    prefix: 'fasr',
    iconName: 'tickets-perforated',
    icon: [
      640,
      512,
      [],
      'e63f',
      
      'M592 80v54.2c-24.1 15.7-40 42.9-40 73.8s15.9 58.1 40 73.8V336H144V80H592zm48 40V80 32H592 144 96V80 336v48h48H592h48V336 296 248c-22.1 0-40-17.9-40-40s17.9-40 40-40V120zm-144 8a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM48 120V96H0v24V456v24H24 520h24V432H520 48V120z'
      
    ]
  };

  

  
  

  var faCircleQuestion = {
    prefix: 'fasr',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-72c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4V272v24H232V272 250.5 236.6l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H224c-4.4 0-8 3.6-8 8l0 6.5-48 0V184zm64 152h48v48H232V336z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faFileImage = {
    prefix: 'fasr',
    iconName: 'file-image',
    icon: [
      384,
      512,
      [128443],
      'f1c5',
      
      'M48 48H224V160H336V464H48V48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM80 432h48 64H304V400L216 288l-57.7 73.5L136 336 80 400v32zm48-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faRupeeSign = {
    prefix: 'fasr',
    iconName: 'rupee-sign',
    icon: [
      448,
      512,
      [8360,"rupee"],
      'f156',
      
      'M0 32H24h96c75.1 0 136 60.9 136 136c0 62.4-42 115-99.3 131l57.9 181H164.2L107.9 304H48V480H0V280 56 32zM48 256h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48V256zm264.6 10.4c-1.2 7.9-.2 12.8 1 15.9s3.5 6.2 7.5 9.4c9.2 7.4 23.3 12.5 43.1 19.6l.8 .3c17.4 6.2 40 14.2 56.7 28.5c9 7.7 16.8 17.6 21.5 30.4c4.7 12.7 5.7 26.7 3.5 41.9c-3.9 26.6-19.1 46.5-41 57.6c-21 10.6-46.4 12.3-71.6 7.6l-.2 0 0 0c-9-1.7-20.2-5.7-29.5-9.2c-6.3-2.4-13-5.1-18.5-7.3c-2.7-1.1-5.1-2-7-2.8l-22.3-8.8 17.5-44.7 22.3 8.8c2.6 1 5.3 2.1 8.2 3.3c5.1 2.1 10.7 4.3 16.7 6.6c9.4 3.5 17 6 21.5 6.9c18.1 3.3 32.1 1.2 41.2-3.3c8.1-4.1 13.5-10.7 15.1-21.7c1.3-8.8 .4-14.5-1-18.3c-1.4-3.8-3.8-7.1-7.7-10.5c-9-7.7-22.9-13.1-42.4-20l-2.9-1c-16.8-5.9-38.1-13.5-54.1-26.2c-9-7.2-17.1-16.6-22.1-29s-6.2-26.1-4-40.8c7.8-52.8 62.2-74.5 112.6-65.2c7.1 1.3 28.4 6.1 36.5 8.7l22.9 7.2-14.4 45.8-22.9-7.2c-5.5-1.7-24.7-6.1-30.8-7.3c-36.3-6.7-54.2 10.2-56.4 25z'
      
    ]
  };

  
    var faRupee = faRupeeSign;
  

  
  

  var faDiagramNested = {
    prefix: 'fasr',
    iconName: 'diagram-nested',
    icon: [
      448,
      512,
      [],
      'e157',
      
      'M144 80v96H48V80h96zM48 32H0V80v96 48H48 72V384v24H96 256v24 48h48 96 48V432 336 288H400 304 256v48 24H120V224h24 48V176 80 32H144 48zM400 336v96H304V336h96z'
      
    ]
  };

  

  
  

  var faVectorPolygon = {
    prefix: 'fasr',
    iconName: 'vector-polygon',
    icon: [
      448,
      512,
      [],
      'e2c7',
      
      'M408 72v48H360V72h48zM360 32H320V72H128V32H88 40 0V72v48 40H40V352H0v40 48 40H40 88h40V440H320v40h40 48 40V440 392 352H408 373.6L352 316V280 232 196l21.6-36H408h40V120 72 32H408 360zM298.4 320L320 356v36H128V352H88V160h40V120H320v36l-21.6 36H264 224v40 48 40h40 34.4zM40 392H88v48H40V392zm320 0h48v48H360V392zM40 72H88v48H40V72zM312 232v48H264V232h48z'
      
    ]
  };

  

  
  

  var faBugs = {
    prefix: 'fasr',
    iconName: 'bugs',
    icon: [
      576,
      512,
      [],
      'e4d0',
      
      'M194.2 41.9l-29.7 65.5c10.2 7.1 18.2 17 22.9 28.6h15.4l2.3-18.9 2.9-23.8L255.5 99l-2.9 23.8-4.8 40L245.3 184H224 192v23.3l37.8 9.5 16.1 4 1.9 16.5 6.4 56 2.7 23.8-47.7 5.4-2.7-23.8L202 259.3l-17.9-4.5C173.3 274.6 152.2 288 128 288s-45.3-13.4-56.1-33.2L54 259.3l-4.5 39.5-2.7 23.8L-1 317.1l2.7-23.8 6.4-56L10 220.8l16.1-4L64 207.3V184H32 10.5L8.2 162.7l-4.5-40L1 98.8l47.7-5.3 2.7 23.9L53.5 136H68.7c4.7-11.6 12.7-21.5 22.9-28.6L61.8 41.9 51.9 20.1 95.6 .2l9.9 21.9L128 71.7l22.5-49.6L160.4 .2l43.7 19.8-9.9 21.9zM553.6 239.5l-65.6 47c5.3 11.2 7.2 23.8 5.5 36.2l14.7 8.5 13.9-15.9 15.8-18L574 329l-15.8 18-26.9 30.6-13 14.8-17-9.8-27.7-16-11.6 20.1 28 27.1L501 424.5 495.8 439 478.6 488l-8 22.6-45.3-15.9 8-22.6 12.1-34.4-14.2-13.7c-19.3 11.7-44.3 12.8-65.2 .7s-32.5-34.3-32-56.8l-18.2-5.2-25 31.8-14.8 18.9-37.8-29.6 14.8-18.9 34.9-44.5 10-12.7 15.5 4.4L351 322.7l11.6-20.1-27.7-16-17-9.8 6.3-18.6 13.1-38.6 7.7-22.7 45.5 15.4-7.7 22.7-6.8 20 14.7 8.5c9.9-7.7 21.8-12.3 34.1-13.3l7.8-80.3 2.3-23.9 47.8 4.7-2.3 23.9-6.1 62.9 51.4-36.8 19.5-14 27.9 39-19.5 14zM144 224V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16zM411.9 377.2l32-55.4c4.4-7.7 1.8-17.4-5.9-21.9s-17.4-1.8-21.9 5.9l-32 55.4c-4.4 7.7-1.8 17.4 5.9 21.9s17.4 1.8 21.9-5.9z'
      
    ]
  };

  

  
  

  var faWrench = {
    prefix: 'fasr',
    iconName: 'wrench',
    icon: [
      512,
      512,
      [128295],
      'f0ad',
      
      'M322.3 268l-26.9-7.4-19.7 19.7L112 444.1 67.9 400 231.6 236.3l19.7-19.7L244 189.7c-2.6-9.4-4-19.3-4-29.7c0-60.5 48-109.9 108-111.9l-30 30L304 92.1V112v48 48h48 48 19.9l14.1-14.1 30-30c-2.1 60-51.4 108-111.9 108c-10.3 0-20.3-1.4-29.7-4zM112 512l33.9-33.9L309.7 314.3c13.5 3.7 27.7 5.7 42.3 5.7c88.4 0 160-71.6 160-160c0-13.5-1.7-26.7-4.9-39.3c-4.3-17-11.3-33-20.6-47.3l-35.1 35.1L400 160H352V112l51.5-51.5 35.1-35.1c-14.4-9.3-30.3-16.3-47.3-20.6C378.7 1.7 365.5 0 352 0C263.6 0 192 71.6 192 160c0 14.7 2 28.9 5.7 42.3L33.9 366.1 0 400l33.9 33.9 44.1 44.1L112 512zm8-97.4L142.6 392 120 369.4 97.4 392 120 414.6z'
      
    ]
  };

  

  
  

  var faArrowTurnLeft = {
    prefix: 'fasr',
    iconName: 'arrow-turn-left',
    icon: [
      512,
      512,
      [],
      'e632',
      
      'M464 488v24h48V488 256 232H488 93.1l79-79 17-17-33.9-33.9-17 17L18.2 239l-17 17 17 17 120 120 17 17L189.1 376l-17-17-79-79H464V488z'
      
    ]
  };

  

  
  

  var faTransporter6 = {
    prefix: 'fasr',
    iconName: 'transporter-6',
    icon: [
      512,
      512,
      [],
      'e2a7',
      
      'M48 0L64 32 96 48 64 64 48 96 32 64 0 48 32 32 48 0zM464 352l16 32 32 16-32 16-16 32-16-32-32-16 32-16 16-32zM96 464h24H392h24v48H392 120 96V464zM224 0h64 16V32H288 224 208V0h16zM112 256H400h16v32H400 112 96V256h16z'
      
    ]
  };

  

  
  

  var faUtilityPole = {
    prefix: 'fasr',
    iconName: 'utility-pole',
    icon: [
      512,
      512,
      [],
      'e2c3',
      
      'M280 24V0H232V24 80H128V56 32H80V56 80H64.2c-.2 0-.3 0-.5 0H48V56 32H0V56v48 24H24 80h3.2L232 227.2V296 488v24h48V488 296 227.2L428.8 128H432h56 24V104 56 32H464V56 80H448.2c-.2 0-.3 0-.5 0H432V56 32H384V56 80H280V24zm91.2 104L280 188.8V128h91.2zM232 188.8L140.8 128H232v60.8z'
      
    ]
  };

  

  
  

  var faBurger = {
    prefix: 'fasr',
    iconName: 'burger',
    icon: [
      512,
      512,
      ["hamburger"],
      'f805',
      
      'M32 224V192s0-6.1 1.7-16C40.6 135.5 75.9 32 256 32s215.4 103.5 222.3 144c1.7 9.9 1.7 16 1.7 16v32H432 80 32zm67.3-84.5c-9.1 13-14 26.2-16.6 36.5H429.3c-2.6-10.3-7.5-23.4-16.6-36.5c-8.4-12-22-26.2-44.8-37.7c.1 .7 .2 1.5 .2 2.2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.1 2.4-9.6 6.1-12.6c-19.2-6-42.8-10.2-72.1-11.2c1.3 2.3 2 4.9 2 7.8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.5 2-7.8c-29.3 1-52.9 5.2-72.1 11.2c3.7 2.9 6.1 7.5 6.1 12.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 .1-1.5 .1-2.2c-22.8 11.5-36.4 25.7-44.8 37.7zM80 432H432V400H80v32zM32 352H80 432h48v48 32 48H432 80 32V432 400 352zm464-96v64H16V256H496z'
      
    ]
  };

  
    var faHamburger = faBurger;
  

  
  

  var faStaff = {
    prefix: 'fasr',
    iconName: 'staff',
    icon: [
      512,
      512,
      [],
      'f71b',
      
      'M282.2 0h9.9H312 440h48 24V24 72 232v36.2 18.1l-17.4 5-34.8 9.9L446.5 305l-24.8 44-43.4-24.5L253.7 360.1l-98.8 98.8L121 492.9l-17 17-17-17L19.1 425l-17-17 17-17 33.9-33.9L96 314.2V272h42.2l26.9-26.9 8.8-8.8 4.4-4.4 6-1.7 12-3.4L368 177.7V144H341.8L321 164.9l-17 17-17-17L219.1 97l-17-17 17-17 33.9-33.9 8-8L275.1 7l7-7zm19.9 48l-7 7-8 8-17 17L304 113.9 314.9 103l7-7h9.9H392h24v24 75.8 18.1l-17.4 5L209.4 272.9l-6 1.7L199 279 87 391l-17 17L104 441.9l17-17L224.2 321.8l4.4-4.4 6-1.7 212-60.6 17.4-5V232 72 48H440 312h-9.9z'
      
    ]
  };

  

  
  

  var faChartRadar = {
    prefix: 'fasr',
    iconName: 'chart-radar',
    icon: [
      512,
      512,
      [],
      'e0e7',
      
      'M155.9 432H356.1L456.7 256 356.1 80H155.9L55.3 256 155.9 432zM0 256L128 32H384L512 256 384 480H128L0 256zm290.2-75.2l40.2 100.6c17.1 4.6 29.6 20.1 29.6 38.6c0 22.1-17.9 40-40 40c-15.9 0-29.7-9.3-36.1-22.7l-97.2-19.4c-7.1 6.3-16.4 10.2-26.7 10.2c-22.1 0-40-17.9-40-40s17.9-40 40-40l57.6-76.8c-1-3.6-1.6-7.3-1.6-11.2c0-22.1 17.9-40 40-40s40 17.9 40 40c0 7.6-2.1 14.7-5.8 20.8zM202 271.9l79.2 15.8-31.7-79.2L202 271.9z'
      
    ]
  };

  

  
  

  var faLockHashtag = {
    prefix: 'fasr',
    iconName: 'lock-hashtag',
    icon: [
      448,
      512,
      [],
      'e423',
      
      'M144 128v32H304V128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 160V128C96 57.3 153.3 0 224 0s128 57.3 128 128v32h48 48v48V464v48H400 48 0V464 208 160H48 96zm0 48H48V464H400V208H352 304 144 96zm112 16v24 24h32V248 224h48v24 24h24 24v48H312 288v32h24 24v48H312 288v24 24H240V424 400H208v24 24H160V424 400H136 112V352h24 24V320H136 112V272h24 24V248 224h48zm0 128h32V320H208v32z'
      
    ]
  };

  

  
  

  var faTurnDownLeft = {
    prefix: 'fasr',
    iconName: 'turn-down-left',
    icon: [
      512,
      512,
      [],
      'e331',
      
      'M160 264l48 0 160 0 48 0 0-48 0-136 48 0 0 232-256 0-48 0 0 48 0 20.1L67.9 288 160 195.9l0 20.1 0 48zM33.9 254.1L0 288l33.9 33.9L160 448l48 0 0-40 0-8 0-40 48 0 208 0 48 0 0-48 0-232 0-48-48 0-48 0-48 0 0 48 0 88 0 48-48 0-64 0-48 0 0-40 0-8 0-40-48 0L33.9 254.1z'
      
    ]
  };

  

  
  

  var faFileAudio = {
    prefix: 'fasr',
    iconName: 'file-audio',
    icon: [
      384,
      512,
      [],
      'f1c7',
      
      'M48 48H224V160H336V464H48V48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM226.5 393.7L258.3 430c23.4-24.4 37.7-57.5 37.7-94s-14.4-69.6-37.7-94l-31.8 36.3C239.9 293.8 248 313.9 248 336s-8.1 42.2-21.5 57.7zM96 376h40l40 40h16V256H176l-40 40H96v80z'
      
    ]
  };

  

  
  

  var faPool8Ball = {
    prefix: 'fasr',
    iconName: 'pool-8-ball',
    icon: [
      512,
      512,
      [],
      'e3c5',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm120-56a136 136 0 1 1 272 0 136 136 0 1 1 -272 0zm173.3-25.8C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2C207.2 184.5 200 199.4 200 216c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faTruckClock = {
    prefix: 'fasr',
    iconName: 'truck-clock',
    icon: [
      640,
      512,
      ["shipping-timed"],
      'f48c',
      
      'M48 48V368H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h48V48H48zM480 512c-53 0-96-43-96-96h-8-8H320 256c0 53-43 96-96 96s-96-43-96-96H48 0V368 48 0H48 368h48V48 96h56 9.9l7 7L601 215l7 7V232 368h8 24v48H616 576c0 53-43 96-96 96zM416 240H558.1l-96-96H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 192a112 112 0 1 1 224 0A112 112 0 1 1 96 192zm128-64H192v16 48 16h16 32 16V176H240 224V144 128z'
      
    ]
  };

  
    var faShippingTimed = faTruckClock;
  

  
  

  var faCartCirclePlus = {
    prefix: 'fasr',
    iconName: 'cart-circle-plus',
    icon: [
      640,
      512,
      [],
      'e3f3',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H510.7L475.3 193.2c6.8-.8 13.7-1.2 20.7-1.2c10 0 19.7 .8 29.2 2.4L561 80l15-48H525.7 122l-2.4-12.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm208 16H512v48 16H480V432 384H432l-16 0V352l16 0h48V304 288h32v16 48h48 16v32H560z'
      
    ]
  };

  

  
  

  var faClipboardCheck = {
    prefix: 'fasr',
    iconName: 'clipboard-check',
    icon: [
      384,
      512,
      [],
      'f46c',
      
      'M336 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H80 48 0v48V464v48H48 336h48V464 112 64H336zM80 112v48H192 304V112h32V464H48V112H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM289 267.6l17-17L272 216.7l-17 17-89.7 89.7L129 287l-17-17L78.1 304l17 17 53.3 53.3 17 17 17-17L289 267.6z'
      
    ]
  };

  

  
  

  var faFlatbreadStuffed = {
    prefix: 'fasr',
    iconName: 'flatbread-stuffed',
    icon: [
      576,
      512,
      [129369],
      'e40c',
      
      'M346.6 53.2L255.9 3.4 185.1 78.8 83.6 98.9 77.8 202.2 13 282.9 75 365.7l.5 25.5L133.8 333c-13.7-19.5-21.8-43.3-21.8-69c0-66.3 53.7-120 120-120c25.7 0 49.5 8.1 69 21.8L422.5 44.2l-75.9 9zM232 176c-48.6 0-88 39.4-88 88c0 16.8 4.7 32.5 12.9 45.9l121-121C264.5 180.7 248.8 176 232 176zm228.7-56.8c55.6 86.7 45.5 203.4-30.3 279.2s-192.5 85.9-279.2 30.3L460.7 119.2zM79.7 432.3c11.6 11.6 23.9 21.9 36.9 31c106.1 74 253.1 63.7 347.7-31s105-241.7 31-347.7c-9.1-13-19.4-25.3-31-36.9L430.4 81.6 113.6 398.4 79.7 432.3zM296 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faOctagonCheck = {
    prefix: 'fasr',
    iconName: 'octagon-check',
    icon: [
      512,
      512,
      [],
      'e426',
      
      'M48 332.1V179.9L179.9 48H332.1L464 179.9V332.1L332.1 464H179.9L48 332.1zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z'
      
    ]
  };

  

  
  

  var faWallet = {
    prefix: 'fasr',
    iconName: 'wallet',
    icon: [
      512,
      512,
      [],
      'f555',
      
      'M24 32H0V56 456v24H24 488h24V456 152 128H488 120 96v48h24H464V432H48V80H456h24V32H456 24zM384 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fasr',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      'M40 6.1L6.1 40 23 57l56 56 17 17L129.9 96 113 79 57 23 40 6.1zm560 0L583 23 527 79l-17 17L544 129.9l17-17 56-56 17-17L600 6.1zM57 489l56-56 17-17L96 382.1 79 399 23 455l-17 17L40 505.9l17-17zm543 17L633.9 472l-17-17-56-56-17-17L510.1 416l17 17 56 56 17 17zM260.1 288H224l-20 80-12 48h49.5 157H448l-12-48-20-80H379.9 320 260.1zm1.4 48h117l8 32h-133l8-32zm13.3-96a72 72 0 1 0 90.5-112.1A72 72 0 1 0 274.7 240zM320 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 96H441l6.1 24.2L461 336h83l-24-80zm-400 0L96 336h83L193 280.2 199 256H120zm55.8-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faVolumeHigh = {
    prefix: 'fasr',
    iconName: 'volume-high',
    icon: [
      640,
      512,
      [128266,"volume-up"],
      'f028',
      
      'M592 256c0 78.5-37.7 148.2-96 192l28.8 38.4C594.7 433.9 640 350.3 640 256.1l0-.1 0-.1c0-94.2-45.3-177.8-115.2-230.3L496 64c58.3 43.8 96 113.5 96 192zM438.4 371.2l28.8 38.4c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2s-22.6 88.9-57.6 115.2zM400 256c0 15.7-7.5 29.6-19.2 38.4l28.8 38.4C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4zM159.9 316.1L146.2 304H128 48V208h80 18.2l13.6-12.1L272 96.2V415.8L159.9 316.1zM0 352H48h80L272 480h48V432 80 32H272L128 160H48 0v48 96 48z'
      
    ]
  };

  
    var faVolumeUp = faVolumeHigh;
  

  
  

  var faCloudSlash = {
    prefix: 'fasr',
    iconName: 'cloud-slash',
    icon: [
      640,
      512,
      [],
      'e137',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-.3-.2h.4V432 352c0-59.6-40.8-109.8-96-124V208c0-70.7-57.3-128-128-128c-13.9 0-27.3 2.2-39.9 6.3C346.8 53 303.9 32 256 32c-46.8 0-89 20.1-118.2 52.2L48.4 14.8zm127.5 99C196.2 92.9 224.6 80 256 80c33.5 0 63.5 14.6 84.1 38L361 141.8l30.1-9.8c7.8-2.5 16.1-3.9 24.9-3.9c44.2 0 80 35.8 80 80v20 37.2l36 9.3c34.5 8.9 60 40.3 60 77.5v80h-6.2L175.9 113.8zM144 234.1V209.5L97.2 172.6c-.8 6.4-1.2 12.9-1.2 19.4v8.2C40.1 220 0 273.3 0 336v96 48H48h96H487.4l-60.9-48H144 48V336c0-41.7 26.6-77.3 64-90.6l32-11.3z'
      
    ]
  };

  

  
  

  var faInboxOut = {
    prefix: 'fasr',
    iconName: 'inbox-out',
    icon: [
      512,
      512,
      [128228,"inbox-arrow-up"],
      'f311',
      
      'M280 288v24H232V288 93.1l-63 63-17 17-33.9-33.9 17-17 104-104 17-17 17 17 104 104 17 17L360 173.1l-17-17-63-63V288zM160 320l32 64H320l32-64H464h48v48 96 48H464 48 0V464 368 320H48 160zm202.9 85.5L349.7 432H320 192 162.3l-13.3-26.5L130.3 368H48v96H464V368H381.7l-18.7 37.5z'
      
    ]
  };

  
    var faInboxArrowUp = faInboxOut;
  

  
  

  var faClockOneThirty = {
    prefix: 'fasr',
    iconName: 'clock-one-thirty',
    icon: [
      512,
      512,
      [],
      'e34f',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V263.3l60-90 13.3-20-39.9-26.6-13.3 20-64 96-4 6V256 392v24h48V392z'
      
    ]
  };

  

  
  

  var faMobileScreenButton = {
    prefix: 'fasr',
    iconName: 'mobile-screen-button',
    icon: [
      384,
      512,
      ["mobile-alt"],
      'f3cd',
      
      'M64 464H320V368H64v96zm0-144H320V48H64V320zM16 0H64 320h48V48 464v48H320 64 16V464 48 0zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faMobileAlt = faMobileScreenButton;
  

  
  

  var faSlider = {
    prefix: 'fasr',
    iconName: 'slider',
    icon: [
      512,
      512,
      [],
      'e252',
      
      'M368 144V368H304V144h64zM304 96H256v48V368v48h48 64 48V368 280h72 24V232H488 416V144 96H368 304zM0 280H24 224V232H24 0v48z'
      
    ]
  };

  

  
  

  var faCircleUp = {
    prefix: 'fasr',
    iconName: 'circle-up',
    icon: [
      512,
      512,
      [61467,"arrow-alt-circle-up"],
      'f35b',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 224v32h64V384h96V256h64V224L256 128 144 224z'
      
    ]
  };

  
    var faArrowAltCircleUp = faCircleUp;
  

  
  

  var faBadgeCheck = {
    prefix: 'fasr',
    iconName: 'badge-check',
    icon: [
      512,
      512,
      [],
      'f336',
      
      'M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5L321 99.1l19-5.8c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1l-5.8 19 17.5 9.3c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7L412.9 321l5.8 19c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7l-19-5.8-9.3 17.5c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5L191 412.9l-19 5.8c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340l5.8-19-17.5-9.3C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7L99.1 191l-5.8-19c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2l19 5.8 9.3-17.5zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z'
      
    ]
  };

  

  
  

  var faSatelliteDish = {
    prefix: 'fasr',
    iconName: 'satellite-dish',
    icon: [
      512,
      512,
      [128225],
      'f7c0',
      
      'M192 0V48c150.2 0 272 121.8 272 272h48C512 143.3 368.7 0 192 0zm0 104v48c92.8 0 168 75.2 168 168h48c0-119.3-96.7-216-216-216zm17 233l56-56L231 247l-56 56L80 208 45.8 173.8c-10.3 12.8-19.1 26.8-26.1 41.8C7.1 242.4 0 272.4 0 304C0 418.9 93.1 512 208 512c31.6 0 61.6-7.1 88.4-19.7c15-7.1 29-15.8 41.8-26.1L304 432l-95-95zM48 304c0-18.1 3-35.4 8.5-51.6L259.6 455.5C243.4 461 226.1 464 208 464c-88.4 0-160-71.6-160-160z'
      
    ]
  };

  

  
  

  var faForkKnife = {
    prefix: 'fasr',
    iconName: 'fork-knife',
    icon: [
      576,
      512,
      ["utensils-alt"],
      'f2e6',
      
      'M57.3 7.3L232 188.5c.1 21.7 5.1 42.8 14.4 61.9l-10.9 10.9L48 66.9V83.6c0 52.8 20.9 103.5 58.2 141l82.8 83.2L155 341.8 72.1 258.5C25.9 212 0 149.1 0 83.6V24 0H24 40 50.2l7.1 7.3zM454.7 488.7L313.3 341.9l12.3-12.3c17.4 8.5 36.6 13.4 56.2 14.2L489.3 455.3l16.7 17.3-34.6 33.3-16.7-17.3zm87-386.9L576 136l0 0L479.2 265.1c-3.3 4.4-7 8.6-10.9 12.6l-1.9 1.9c-20.8 20.8-49 32.5-78.4 32.5c-24.5 0-48.1-8.1-67.3-22.8L116.2 493.8l-17 17L65.3 476.8l17-17L286.8 255.3C272.1 236.1 264 212.5 264 188c0-29.4 11.7-57.6 32.5-78.4l1.9-1.9c3.9-3.9 8.1-7.6 12.6-10.9L440 0l34.3 34.3L339.7 135.2c-2.6 2-5.1 4.1-7.4 6.4l-1.9 1.9C318.6 155.3 312 171.3 312 188c0 16.4 6.4 32.2 17.9 44L344 246.1c11.8 11.5 27.5 17.9 44 17.9c16.7 0 32.7-6.6 44.5-18.4l1.9-1.9c2.3-2.3 4.5-4.8 6.4-7.4L541.7 101.7zM525 85l-4 4L405 205l-17 17L354.1 188l17-17L487 55l4-4L525 85z'
      
    ]
  };

  
    var faUtensilsAlt = faForkKnife;
  

  
  

  var faBasketball = {
    prefix: 'fasr',
    iconName: 'basketball',
    icon: [
      512,
      512,
      [127936,"basketball-ball"],
      'f434',
      
      'M304 458.4c0-.8 0-1.6 0-2.4c0-33.3 10.7-64.1 28.9-89.2l52.2 52.2c-23.5 18.6-51 32.2-81.1 39.4zM256.2 464c-.1 0-.1 0-.2 0c-48.8 0-93.7-16.8-129.1-44.9L256 289.9l42.6 42.6C271.9 366.6 256 409.4 256 456c0 2.7 .1 5.3 .2 8zm76.4-165.4L289.9 256 419.1 126.9C447.2 162.3 464 207.2 464 256c0 .1 0 .1 0 .2c-2.7-.1-5.3-.2-8-.2c-46.6 0-89.4 15.9-123.4 42.6zM458.4 304c-7.1 30.1-20.8 57.7-39.4 81.1l-52.2-52.2c25-18.2 55.9-28.9 89.2-28.9c.8 0 1.6 0 2.4 0zM256 222.1l-42.6-42.6C240.1 145.4 256 102.6 256 56c0-2.7-.1-5.3-.2-8c.1 0 .1 0 .2 0c48.8 0 93.7 16.8 129.1 44.9L256 222.1zm-76.9-76.9L126.9 92.9c23.5-18.6 51-32.2 81.1-39.4c0 .8 0 1.6 0 2.4c0 33.3-10.7 64.1-28.9 89.2zm-33.9 33.9C120.1 197.3 89.3 208 56 208c-.8 0-1.6 0-2.4 0c7.1-30.1 20.8-57.7 39.4-81.1l52.2 52.2zM48 255.8c2.7 .1 5.3 .2 8 .2c46.6 0 89.4-15.9 123.4-42.6L222.1 256 92.9 385.1C64.8 349.7 48 304.8 48 256c0-.1 0-.1 0-.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faBasketballBall = faBasketball;
  

  
  

  var faTrademark = {
    prefix: 'fasr',
    iconName: 'trademark',
    icon: [
      640,
      512,
      [8482],
      'f25c',
      
      'M0 96H24 232h24v48H232 152V392v24H104V392 144H24 0V96zm288 24V96h36.2l7.2 9.8L464 287.3 596.6 105.8l7.2-9.8H640v24V392v24H592V392 193.5L483.4 342.2 464 368.7l-19.4-26.5L336 193.5V392v24H288V392 120z'
      
    ]
  };

  

  
  

  var faCircleDashed = {
    prefix: 'fasr',
    iconName: 'circle-dashed',
    icon: [
      512,
      512,
      [],
      'e105',
      
      'M1.1 232H49.4c4.5-39.5 20.1-75.6 43.6-105.1L58.8 92.7C26.9 131.3 6 179.3 1.1 232zM126.9 92.9c29.6-23.4 65.7-39 105.1-43.6V1.1C179.3 6 131.3 26.9 92.7 58.8l34.1 34.1zM280 462.6v48.3c52.7-4.9 100.7-25.8 139.3-57.7l-34.1-34.1c-29.6 23.4-65.7 39-105.1 43.6zm139.1-77.5l34.1 34.1c31.9-38.5 52.8-86.6 57.7-139.3H462.6c-4.5 39.5-20.1 75.6-43.6 105.1zM92.7 453.2c38.5 31.9 86.6 52.8 139.3 57.7V462.6c-39.5-4.5-75.6-20.1-105.1-43.6L92.7 453.2zM58.8 419.3l34.1-34.1c-23.4-29.6-39-65.7-43.6-105.1H1.1C6 332.7 26.9 380.7 58.8 419.3zM419.3 58.8C380.7 26.9 332.7 6 280 1.1V49.4c39.5 4.5 75.6 20.1 105.1 43.6l34.1-34.1zm-.2 68.1c23.4 29.6 39 65.7 43.6 105.1h48.3c-4.9-52.7-25.8-100.7-57.7-139.3l-34.1 34.1z'
      
    ]
  };

  

  
  

  var faPlaneSlash = {
    prefix: 'fasr',
    iconName: 'plane-slash',
    icon: [
      640,
      512,
      [],
      'e069',
      
      'M462.1 336H502c20.2 0 44.9-7.8 64.5-19.6C585 305.4 608 285.1 608 256c0-14.7-6.3-27.2-13.9-36.7c-7.6-9.5-17.4-17.3-27.5-23.3c-19.6-11.9-44.3-20-64.6-20l-99.5 0L308.8 12.1 301.9 0H288 208 176.2l8.7 30.6L218 146.5 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L462.1 336zM282.2 196.3l-.8-2.9L239.8 48h34.3l93.7 163.9 6.9 12.1h13.9L502 224c9.6 0 25.8 4.6 39.7 13c6.7 4.1 11.8 8.4 14.9 12.3c3.1 3.9 3.3 6.1 3.3 6.7c0 2.4-3 10.1-18.1 19.2C528 283.6 511.8 288 502 288H400.3L282.2 196.3zm89.9 192.9l-38.1-30L274.1 464H239.8l41.5-145.4 .2-.7L243.7 288 184 288H172l-7.2 9.6L124 352H97.3l29.5-88.4 2.5-7.6-2.5-7.6L103 177.2 34.4 123.1l6.8 20.5L78.7 256 41.2 368.4 30.7 400H64h72 12l7.2-9.6L196 336l30.5 0L184.9 481.4 176.2 512H208l80 0h13.9l6.9-12.1 63.3-110.7z'
      
    ]
  };

  

  
  

  var faInterrobang = {
    prefix: 'fasr',
    iconName: 'interrobang',
    icon: [
      320,
      512,
      [8253],
      'e5ba',
      
      'M64 160c0-44.2 35.8-80 80-80h32c44.2 0 80 35.8 80 80v7.4c0 22.9-10.9 44.5-29.4 58.1L184 256.6V168 144H136v24V291.8 304v24 16 8 16h48V352v-8V328 316.2l71-52c30.8-22.6 49-58.5 49-96.8V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160v16H64V160zm64 256v64h64V416H128z'
      
    ]
  };

  

  
  

  var faUserAstronaut = {
    prefix: 'fasr',
    iconName: 'user-astronaut',
    icon: [
      448,
      512,
      [],
      'f4fb',
      
      'M80 192a144 144 0 1 1 288 0A144 144 0 1 1 80 192zm325.1-64C378.7 53.4 307.6 0 224 0S69.3 53.4 42.9 128H16V256H42.9C49 273.3 57.5 289.4 68 304H48L11.1 464 0 512H49.3 112h48V464 448h32v16 48H336h62.7H448l-11.1-48L400 304H380c10.5-14.6 19-30.7 25.1-48H432V128H405.1zM336 416H112v48H60.3L86.2 352h31.6c30.4 20.2 66.9 32 106.2 32s75.8-11.8 106.2-32h31.6l25.8 112H336V416zM240 288c53 0 96-43 96-96V160l-32-32H144l-32 32v32c0 53 43 96 96 96h32zM192 160l16 32 32 16-32 16-16 32-16-32-32-16 32-16 16-32zm64 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faRecycle = {
    prefix: 'fasr',
    iconName: 'recycle',
    icon: [
      512,
      512,
      [9842,9850,9851],
      'f1b8',
      
      'M229.4 48l53.1 0 73.3 117.3-36.3-12-22.8-7.6-15.1 45.6 22.8 7.6 91.4 30.4 25.6 8.5 5.4-26.4 19.4-94.4 4.8-23.5-47-9.7-4.8 23.5-5.8 27.9L309.1 0 202.8 0 144.1 93.9l41.2 24.7L229.4 48zM460.7 242.5l-41.2 24.7 41.3 66L424.3 392l-134.6 0 21.9-18.5 18.3-15.5-31-36.7-18.3 15.5-72 60.8L186.8 416l21.7 18.3 72 60.8 18.3 15.5 31-36.7-18.3-15.5L289.6 440 451 440l66.4-106.9-56.6-90.6zm-466 90.6L61 440l99 0V392l-72.3 0L51.2 333.2l68.7-109.9 7.4 36 4.8 23.5 47-9.7-4.8-23.5-19.4-94.4-5.4-26.4-25.6 8.5L32.4 167.6 9.7 175.1l15.1 45.6 22.8-7.6 27.9-9.2L-5.3 333.1z'
      
    ]
  };

  

  
  

  var faBackwardFast = {
    prefix: 'fasr',
    iconName: 'backward-fast',
    icon: [
      512,
      512,
      [9198,"fast-backward"],
      'f049',
      
      'M64 64V88 222.1L240 97.9 288 64v58.8 99.4L464 97.9 512 64v58.8V389.2 448l-48-33.9L288 289.9v99.4V448l-48-33.9L64 289.9V424v24H16V424 256 88 64H64zM240 256V156.6L99.2 256 240 355.4V256zm83.2 0L464 355.4V156.6L323.2 256z'
      
    ]
  };

  
    var faFastBackward = faBackwardFast;
  

  
  

  var faSword = {
    prefix: 'fasr',
    iconName: 'sword',
    icon: [
      512,
      512,
      [128481],
      'f71c',
      
      'M200.6 283.3l-33.9-33.9L400 16l62.5-8.9L512 0l-7.1 49.5L496 112 262.6 345.4l-33.9-33.9L450.7 89.4l4.7-32.8-32.8 4.7L200.6 283.3zM0 416l32-32 32 16 56-56L64 256l32-32L288 416l-32 32-88-56-56 56 16 32L96 512 0 416z'
      
    ]
  };

  

  
  

  var faCartCircleExclamation = {
    prefix: 'fasr',
    iconName: 'cart-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e3f2',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H510.7L475.3 193.2c6.8-.8 13.7-1.2 20.7-1.2c10 0 19.7 .8 29.2 2.4L561 80l15-48H525.7 122l-2.4-12.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64H480V416h32v32zm0-176v16 80 16H480V368 288 272h32z'
      
    ]
  };

  

  
  

  var faLeftToBracket = {
    prefix: 'fasr',
    iconName: 'left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e66d',
      
      'M384 224l-48 0 0-48 0-28.1L227.9 256 336 364.1l0-28.1 0-48 48 0 80 0 0-64-80 0zm-190.1-1.9L320 96l16 0 48 0 0 32 0 16 0 32 48 0 32 0 48 0 0 48 0 64 0 48-48 0-32 0-48 0 0 32 0 16 0 32-48 0-16 0L193.9 289.9 160 256l33.9-33.9zM168 432l24 0 0 48-24 0L24 480 0 480l0-24L0 56 0 32l24 0 144 0 24 0 0 48-24 0L48 80l0 352 120 0z'
      
    ]
  };

  

  
  

  var faCircle = {
    prefix: 'fasr',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faSquarePollHorizontal = {
    prefix: 'fasr',
    iconName: 'square-poll-horizontal',
    icon: [
      448,
      512,
      ["poll-h"],
      'f682',
      
      'M48 80l0 352 352 0 0-352L48 80zM0 32l48 0 352 0 48 0 0 48 0 352 0 48-48 0L48 480 0 480l0-48L0 80 0 32zM256 184L96 184l0-48 160 0 0 48zm96 48l0 48L96 280l0-48 256 0zM192 376l-96 0 0-48 96 0 0 48z'
      
    ]
  };

  
    var faPollH = faSquarePollHorizontal;
  

  
  

  var faHouseFloodWaterCircleArrowRight = {
    prefix: 'fasr',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e50f',
      
      'M0 144a144 144 0 1 1 288 0A144 144 0 1 1 0 144zM152 65.4L129.4 88l11.3 11.3L169.4 128H80 64v32H80h89.4l-28.7 28.7L129.4 200 152 222.6l11.3-11.3 56-56L230.6 144l-11.3-11.3-56-56L152 65.4zM316.7 110c-3.3-16.7-8.9-32.6-16.5-47.2L370 12.5 384 2.4l14 10.1 188.8 136 19.5 14-28.1 38.9L560 188.4V273c-8.9-4.9-17.3-10.9-28.3-18.8L512 240l0 0V153.8L384 61.6 316.7 110zM111 376.9C91.7 387.8 63.5 400 32 400V352c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l0 0 .4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l0 0 .7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7zM128 478.2c-4.7 3.3-10.4 7-16.9 10.7C91.7 499.8 63.5 512 32 512V464c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l0 0 .4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l0 0 .7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7z'
      
    ]
  };

  

  
  

  var faMoneyBillTrendUp = {
    prefix: 'fasr',
    iconName: 'money-bill-trend-up',
    icon: [
      512,
      512,
      [],
      'e529',
      
      'M320 0V48h24 54.1L286.7 159.3 191.6 77.8 175.9 64.3 160.3 77.9l-120 104 31.4 36.3 104.4-90.5 96.3 82.5 16.9 14.5L305 209l127-127V136v24h48V136 24 0H456 344 320zM103.5 304h305c3.6 29 26.6 51.9 55.5 55.5v49c-29 3.6-51.9 26.6-55.5 55.5h-305c-3.6-29-26.6-51.9-55.5-55.5v-49c28.9-3.6 51.9-26.6 55.5-55.5zM48 256H0v48V464v48H48 464h48V464 304 256H464 48zM256 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faMoneyBillTransfer = {
    prefix: 'fasr',
    iconName: 'money-bill-transfer',
    icon: [
      640,
      512,
      [],
      'e528',
      
      'M512 176V112l-18.5 0 0 0H160v16c0 35.3-28.7 64-64 64H80v93.5L50.7 314.7 32 333.5V112 64H80 383.6l.4 0 128 0V0h24L640 88 536 176H512zm48 144V226.5l29.3-29.3L608 178.5V400v48H560 146.5l0 0L128 448l0 64H104L0 424l104-88h24l0 64 128 0 .4 0H480V384c0-35.3 28.7-64 64-64h16zM320 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faElevator = {
    prefix: 'fasr',
    iconName: 'elevator',
    icon: [
      512,
      512,
      [],
      'e16d',
      
      'M64 80V96H224V80L144 0 64 80zm400 96V464H48V176H464zM48 128H0v48V464v48H48 464h48V464 176 128H464 48zM368 96l80-80V0H288V16l80 80zM216 352H104L80 432H240l-24-80zm216 80l-24-80H296l-24 80H432zM208 272a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faTally3 = {
    prefix: 'fasr',
    iconName: 'tally-3',
    icon: [
      640,
      512,
      [],
      'e296',
      
      'M152 40V64 448v24H104V448 64 40h48zm128 0V64 448v24H232V448 64 40h48zM408 64V448v24H360V448 64 40h48V64z'
      
    ]
  };

  

  
  

  var faHouseChimneyHeart = {
    prefix: 'fasr',
    iconName: 'house-chimney-heart',
    icon: [
      576,
      512,
      [],
      'e1b2',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 488h24V488 253.5l24.5 20.8 31.1-36.6L512 190.6V88 64H464V88v61.9L303.5 13.7zM464 212.8l0 3.2v24l0 224H112V212.8L288 63.5 464 212.8zM235.2 208c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L288 400.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4z'
      
    ]
  };

  

  
  

  var faTableTree = {
    prefix: 'fasr',
    iconName: 'table-tree',
    icon: [
      512,
      512,
      [],
      'e293',
      
      'M48 160V432H464V160H128v80h48 16v32H176 128v64H240h16v32H240 112 96V352 272 256 160H48zM0 32H48 464h48V80 432v48H464 48 0V432 80 32zM224 224H416v64H224V224zm192 96v64H288V320H416z'
      
    ]
  };

  

  
  

  var faLockOpen = {
    prefix: 'fasr',
    iconName: 'lock-open',
    icon: [
      576,
      512,
      [],
      'f3c1',
      
      'M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80v72 24h48V200 128C560 57.3 502.7 0 432 0S304 57.3 304 128v64H48 0v48V464v48H48 400h48V464 240 192H400 352V128zM48 240H400V464H48V240z'
      
    ]
  };

  

  
  

  var faSolarPanel = {
    prefix: 'fasr',
    iconName: 'solar-panel',
    icon: [
      640,
      512,
      [],
      'f5ba',
      
      'M68.5 0H88 552h19.5l4 19.1 64 304 .5 2.4V328v32 24H616 344v80h80 24v48H424 216 192V464h24 80V384H24 0V360 328v-2.5l.5-2.4 64-304L68.5 0zm5.3 208L48 330.5V336H185.5l12.8-128H73.8zm10.1-48H203.1L214.3 48H107.5L83.9 160zm162.6 48L233.7 336H406.3L393.5 208h-147zm142.2-48L377.5 48h-115L251.3 160H388.7zm53 48l12.8 128H592v-5.5L566.2 208H441.7zm114.4-48L532.5 48H425.7l11.2 112H556.1z'
      
    ]
  };

  

  
  

  var faShieldDog = {
    prefix: 'fasr',
    iconName: 'shield-dog',
    icon: [
      512,
      512,
      [],
      'e573',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM160.9 270.2L144 304l128 64V304h48c44.2 0 80-35.8 80-80V176H320l-16-32H240v64c0 35.3-28.7 64-64 64c-5.2 0-10.3-.6-15.1-1.8zM144 144v64c0 17.7 14.3 32 32 32s32-14.3 32-32V176 144h-8H144zm112 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faShutters = {
    prefix: 'fasr',
    iconName: 'shutters',
    icon: [
      512,
      512,
      [],
      'e449',
      
      'M24 32H0V80H24 488h24V32H488 24zm-8 96L8 176 0 224H48.7 463.3 512l-8-48-8-48H447.3l8 48H56.7l8-48H16zM8 304L0 352H48.7 463.3 512l-8-48-8-48H447.3l8 48H56.7l8-48H16L8 304zM8 432L0 480H48.7 463.3 512l-8-48-8-48H447.3l8 48H56.7l8-48H16L8 432z'
      
    ]
  };

  

  
  

  var faBitcoinSign = {
    prefix: 'fasr',
    iconName: 'bitcoin-sign',
    icon: [
      320,
      512,
      [],
      'e0b4',
      
      'M64 0h48V64h32V0h48V64.7c54 6 96 51.8 96 107.3c0 27.5-10.3 52.6-27.2 71.6C295.9 261.5 320 297.9 320 340c0 59.6-48.4 108-108 108H192v64H144V448H112v64H64V448H48 0V400 280 232 112 64H48 64V0zM48 112V232H180c33.1 0 60-26.9 60-60s-26.9-60-60-60H48zM180 280H48V400H212c33.1 0 60-26.9 60-60s-26.9-60-60-60H180z'
      
    ]
  };

  

  
  

  var faArrowDownTriangleSquare = {
    prefix: 'fasr',
    iconName: 'arrow-down-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-down"],
      'f888',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM296 224l30-48 61.7-98.7L416 32l28.3 45.3L506 176l30 48H479.4 352.6 296zm86.6-48h66.8L416 122.6 382.6 176zM368 432h96V336H368v96zM320 288h48 96 48v48 96 48H464 368 320V432 336 288z'
      
    ]
  };

  
    var faSortShapesDown = faArrowDownTriangleSquare;
  

  
  

  var faCube = {
    prefix: 'fasr',
    iconName: 'cube',
    icon: [
      512,
      512,
      [],
      'f1b2',
      
      'M256 6.3l8.5 3.2 232 88 15.5 5.9V120 384v16l-14.8 6.1-232 96L256 506l-9.2-3.8-232-96L0 400V384 120 103.4l15.5-5.9 232-88L256 6.3zM48 368l184 76.1V240.4L48 168.1V368zm232 76.1L464 368V168.1L280 240.4V444.1zM256 57.7l-182 69 182 71.5 182-71.5-182-69z'
      
    ]
  };

  

  
  

  var faHandsHoldingDollar = {
    prefix: 'fasr',
    iconName: 'hands-holding-dollar',
    icon: [
      640,
      512,
      ["hands-usd"],
      'f4c5',
      
      'M344 34.9V8H296V34.8c-4.7 1.2-9.3 2.7-13.6 4.7c-15.8 7.2-30 20.7-33.4 40.7c-1.9 10.9-.9 21.6 3.7 31.4c4.5 9.6 11.6 16.3 18.7 21.1c12.1 8.2 28 13 39.6 16.5l2.3 .7c14.1 4.3 22.8 7.3 28.1 11.1s2.2 10.3-3.2 12.6c-5.2 2.2-14.3 3.5-26.6 1.6c-5.7-.9-15.9-4.4-25.4-7.6c-2.3-.8-4.5-1.5-6.6-2.2l-22.8-7.6-15.2 45.5 22.8 7.6c1.1 .4 2.6 .9 4.2 1.4c7 2.4 18 6.2 27.3 8.5V248h48V221.8c4.5-1 8.9-2.4 13-4.2c16.7-7.2 30.4-21.1 34-41.7c1.9-11 1.1-21.8-3.2-31.7c-4.3-9.8-11.1-16.9-18.2-22.1c-12.7-9.2-29.4-14.3-41.4-17.9l-1-.3c-14.4-4.3-23.3-7.2-28.8-10.9c-5-3.4-.4-7.8 3.8-9.7c5.6-2.5 14.7-4.1 26.4-2.3c4.3 .7 17.6 3.3 21.3 4.3L373 91.4 385.4 45l-23.2-6.2c-3.9-1-11.8-2.6-18.2-3.9zM144 64H120 24 0V88 392v9.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112H96V312v9.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16L233.9 392l-16-16-1-1-16-16-23-23L208 305.9l88 88V488v24h24 24V488 393.9l88-88L462.1 336l-23 23 0 0-16 16-17 17L440 425.9l17-17 16-16 0 0 40-40 17-17 7-7 7-7V312 112h48V382.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V392 88 64H616 520 496V88 302.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88 64z'
      
    ]
  };

  
    var faHandsUsd = faHandsHoldingDollar;
  

  
  

  var faToiletPaperXmark = {
    prefix: 'fasr',
    iconName: 'toilet-paper-xmark',
    icon: [
      512,
      512,
      [],
      'e5b3',
      
      'M48 192c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3H324.7c-3-4.5-5.7-9.3-8.2-14.1C298.5 287.4 288 241.5 288 192s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H112c-10.9 0-26.6 8.9-41 36.3C57.2 110.7 48 148.7 48 192zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 464V351.1c-16.6 19.3-38.1 32.9-64 32.9H112c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0H400c37.7 0 66 28.7 83.5 62.1C501.5 96.6 512 142.5 512 192V488v24H488 184 160V488 416h48v48H464zM400 240c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48zM246.6 144l-11.3 11.3L198.6 192l36.7 36.7L246.6 240 224 262.6l-11.3-11.3L176 214.6l-36.7 36.7L128 262.6 105.4 240l11.3-11.3L153.4 192l-36.7-36.7L105.4 144 128 121.4l11.3 11.3L176 169.4l36.7-36.7L224 121.4 246.6 144z'
      
    ]
  };

  

  
  

  var faWifiSlash = {
    prefix: 'fasr',
    iconName: 'wifi-slash',
    icon: [
      640,
      512,
      [],
      'f6ac',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L364.1 259.9c47.4 8.5 90 30.4 124 61.7l32.5-35.3C467.9 237.7 397.4 208 320 208c-7.3 0-14.6 .3-21.7 .8L168.3 107.9C215.4 89.9 266.6 80 320 80c110.4 0 210.9 42.2 286.3 111.3l32.4-35.4C554.8 79 442.9 32 320 32c-69.6 0-135.7 15.1-195.2 42.1L48.4 14.8zM226.3 274.3L184 241c-23.6 12.2-45.3 27.5-64.7 45.4l32.5 35.3c21.6-19.9 46.8-36.1 74.4-47.3zM76.9 156.6L37.7 125.7C25 135.2 12.9 145.2 1.2 155.9l32.4 35.4c13.6-12.5 28.1-24.1 43.2-34.7zM376 424a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faSquareInfo = {
    prefix: 'fasr',
    iconName: 'square-info',
    icon: [
      448,
      512,
      [8505,"info-square"],
      'f30f',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM184 336h24V272H184 160V224h24 48 24v24 88h8 24v48H264 184 160V336h24zm72-208v64H192V128h64z'
      
    ]
  };

  
    var faInfoSquare = faSquareInfo;
  

  
  

  var faTemperatureQuarter = {
    prefix: 'fasr',
    iconName: 'temperature-quarter',
    icon: [
      320,
      512,
      ["temperature-1","thermometer-1","thermometer-quarter"],
      'f2ca',
      
      'M96 294.5L85.3 307.7C72 324.2 64 345.1 64 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L224 294.5v-17V48H96V277.5v17zM224 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5V48 0H96 224zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272 256h32v16 50.8c18.6 6.6 32 24.4 32 45.3z'
      
    ]
  };

  
    var faTemperature1 = faTemperatureQuarter;
  
    var faThermometer1 = faTemperatureQuarter;
  
    var faThermometerQuarter = faTemperatureQuarter;
  

  
  

  var faR = {
    prefix: 'fasr',
    iconName: 'r',
    icon: [
      320,
      512,
      [114],
      '52',
      
      'M24 32H0V56 280 456v24H48V456 304H157.6L263.6 480h56L211.9 301.1C273.6 288.3 320 233.5 320 168c0-75.1-60.9-136-136-136H24zM176 256H48V80H184c48.6 0 88 39.4 88 88s-39.4 88-88 88h-8z'
      
    ]
  };

  

  
  

  var faLockKeyhole = {
    prefix: 'fasr',
    iconName: 'lock-keyhole',
    icon: [
      448,
      512,
      ["lock-alt"],
      'f30d',
      
      'M224 48c44.2 0 80 35.8 80 80v64H144V128c0-44.2 35.8-80 80-80zM96 128v64H48 0v48V464v48H48 400h48V464 240 192H400 352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM48 240H400V464H48V240zm200 80V296H200v24 64 24h48V384 320z'
      
    ]
  };

  
    var faLockAlt = faLockKeyhole;
  

  
  

  var faDiamondHalf = {
    prefix: 'fasr',
    iconName: 'diamond-half',
    icon: [
      512,
      512,
      [],
      'e5b7',
      
      'M222.1 33.9L256 0V48 67.9 444.1 464v48l-33.9-33.9L208 464 33.9 289.9 0 256l33.9-33.9L208 48l14.1-14.1zM208 115.9L67.9 256 208 396.1V115.9z'
      
    ]
  };

  

  
  

  var faKitchenSet = {
    prefix: 'fasr',
    iconName: 'kitchen-set',
    icon: [
      576,
      512,
      [],
      'e51a',
      
      'M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm46 24c-11.4 68.1-70.7 120-142 120C64.5 288 0 223.5 0 144S64.5 0 144 0c71.4 0 130.6 51.9 142 120h66V80h48 96 48v48 32 48H496 400 352V168H286zM80 144a64 64 0 1 1 128 0A64 64 0 1 1 80 144zM376 272V240h48v32h40 48 32v48H512V464v48H464 336 288V464 320H256V272h32 48 40zm88 192V320H336V464H464zM160 320h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H160v32H32V320h96 32zm0 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32zM0 464H224v48H0V464zM400 128v32h96V128H400z'
      
    ]
  };

  

  
  

  var faAppleWhole = {
    prefix: 'fasr',
    iconName: 'apple-whole',
    icon: [
      448,
      512,
      [127822,127823,"apple-alt"],
      'f5d1',
      
      'M208 96V80c0-44.2 35.8-80 80-80h16 16V16 32c0 44.2-35.8 80-80 80H224 208V96zm-96 32l112 32 112-32c76.3 0 112 83.7 112 160c0 128-80 224-160 224l-64-16-64 16C80 512 0 416 0 288c0-76.3 35.7-160 112-160zm125.2 78.2L224 209.9l-13.2-3.8L106.4 176.3c-14.8 1.7-27.2 10.2-37.9 28C55.6 225.5 48 256.3 48 288c0 54.2 17 100 40.4 131.2c22.1 29.5 46.9 42.7 66.7 44.6l57.3-14.3 11.6-2.9 11.6 2.9 57.3 14.3c19.7-1.9 44.5-15.1 66.7-44.6C383 388 400 342.2 400 288c0-31.7-7.6-62.5-20.4-83.7c-10.7-17.7-23.1-26.3-37.9-28L237.2 206.2z'
      
    ]
  };

  
    var faAppleAlt = faAppleWhole;
  

  
  

  var faCircleEuro = {
    prefix: 'fasr',
    iconName: 'circle-euro',
    icon: [
      512,
      512,
      [],
      'e5ce',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144 16c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8H112V208h40.7c19.2-46.9 65.4-80 119.2-80H313h24v48H313 271.9c-26.3 0-49.6 12.6-64.4 32H304v32H192.9c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2H304v32H206.4c14.7 20.3 38.5 33.5 65.5 33.5H313h24v48H313 271.9c-54.4 0-101-33.8-119.8-81.5H112V272h32z'
      
    ]
  };

  

  
  

  var faToiletPaperSlash = {
    prefix: 'fasr',
    iconName: 'toilet-paper-slash',
    icon: [
      640,
      512,
      [],
      'e072',
      
      'M519.3 380.4l101.6 78.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L94.9 50.9C112 19.3 134.9 0 160 0H492.2l0 .1c1.3-.1 2.5-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-9.1 8.7-20.8 16.6-34.7 21zM462.1 336H496c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 37.9-.7 77.8-3.7 117.8L462.1 336zm-79.8-61.9c1.3-27.3 1.6-54.9 1.6-82.1c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48H160c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26c-.5 1-1 2.1-1.5 3.2L382.4 274.1zM64 192c0-15 .9-29.6 2.5-43.6l45.6 35.9c-.1 2.5-.1 5.1-.1 7.7c0 83-3 182.7-33.1 272H349.1c9.1-24.1 15.9-49.8 21-76.4l42.1 33.1c-5.8 24.7-13.1 48.7-22.6 71.5L381.3 512H60 8l18.4-44.2c.5-1.3 1-2.5 1.5-3.8C60.2 379.7 64 280.5 64 192zm432 48c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48z'
      
    ]
  };

  

  
  

  var faRabbit = {
    prefix: 'fasr',
    iconName: 'rabbit',
    icon: [
      512,
      512,
      [128007],
      'f708',
      
      'M224 0L203.2 0l-2.9 20.6L196.5 47c-7.8 54.3 8.4 108.9 43.5 150.1v20.6c-66.8 20.7-119.8 73-141.4 139.4C90.3 353.8 81.4 352 72 352c-39.8 0-72 32.2-72 72s32.2 72 72 72c5.5 0 10.9-.6 16-1.8V512h24 96l96 0h40 16.6l0 0h13.6 93.3 42.4L488 475.7l-17.1-28.6L385 304h63 24V280 191.1 179.7l-8.8-7.2L404 124.3c-6.1-4.9-12.5-9.3-19.3-13c10.8-26.9 14.5-56.5 10.3-86L391.4 0l-40 0L340.3 11c-5.8 5.7-11.1 11.9-15.8 18.3c14.7 21.4 25.1 45.4 30.7 70.4c-8.4-2.1-17-3.4-25.7-3.7c-8.2-29.3-23.8-56.6-46.2-78.8L272.9 7l-7-7L256 0 224 0zM88.7 406.7c-.4 5.7-.7 11.4-.7 17.3v17.9c-4.2 3.8-9.9 6.1-16 6.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.5 0 12.4 2.6 16.7 6.7zm231.3 31V464H304l-96 0H136V424c0-80.8 57-148.2 133-164.3l19-4V236.2 187.9v-9.6l-6.6-6.9C251.8 140.1 237.8 96.8 244 53.8l.8-5.8 1.3 0 3.4 3.4 3.3-3.4-3.3 3.4c20.4 20.2 33.2 46.2 37.2 73.7l3.8 25.9 25.5-6c2.7-.6 5.5-1 8.5-1c17.9 0 35.3 6.2 49.3 17.5l50.3 41V256H360 336v24 28.9 6.6l3.4 5.7L425.1 464H387.7l-19.2-32-4-6.6-17.8-29.7-12.2-20.4L320 351.1l-.9-1.4-21.7 20.6-21.5 20.4L232.2 432h60.2H304h16v5.7zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faValueAbsolute = {
    prefix: 'fasr',
    iconName: 'value-absolute',
    icon: [
      512,
      512,
      [],
      'f6a6',
      
      'M48 32V56 456v24H0V456 56 32H48zM335 143l17-17L385.9 160l-17 17-79 79 79 79 17 17L352 385.9l-17-17-79-79-79 79-17 17L126.1 352l17-17 79-79-79-79-17-17L160 126.1l17 17 79 79 79-79zM512 56V456v24H464V456 56 32h48V56z'
      
    ]
  };

  

  
  

  var faAngel = {
    prefix: 'fasr',
    iconName: 'angel',
    icon: [
      576,
      512,
      [],
      'f779',
      
      'M384 64.2c0-.1 0-.1 0-.2s0-.1 0-.2s-.1-.3-.2-.6c-.3-.6-.9-1.8-2.3-3.5c-2.9-3.5-8.4-7.9-17.3-12.4C346.4 38.4 319.5 32 288 32s-58.4 6.4-76.2 15.4c-8.9 4.5-14.4 8.9-17.3 12.4c-1.4 1.7-2 2.8-2.3 3.5c-.1 .3-.2 .5-.2 .6s0 .1 0 .2s0 .1 0 .2s.1 .3 .2 .6c.3 .6 .9 1.8 2.3 3.5c1.4 1.7 3.4 3.6 6.2 5.6c-6.7 8.3-12.2 17.6-16.3 27.7C169 91 160 78 160 64c0-35.3 57.3-64 128-64s128 28.7 128 64c0 14-9 27-24.3 37.5c-4.1-10-9.6-19.3-16.3-27.7c2.7-2 4.8-4 6.2-5.6c1.4-1.7 2-2.8 2.3-3.5c.1-.3 .2-.5 .2-.6zM288 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM87.9 325.4l14.9 22.4L91.6 372.1 49.2 464H120l89.4-178.7L132.1 208H48v57.5l39.9 59.9zM248 256h80l96-96H528h48v48 72l-48 72 48 104v8 48H528 480 426.3 149.7 96 48 0V464v-8L48 352 0 280V208 160H48 152l96 96zm118.6 29.3L456 464h70.8l-42.4-91.9-11.3-24.4 14.9-22.4L528 265.5V208H443.9l-77.3 77.3zM402.3 464l-80-160H253.7l-80 160H402.3z'
      
    ]
  };

  

  
  

  var faFolders = {
    prefix: 'fasr',
    iconName: 'folders',
    icon: [
      576,
      512,
      [],
      'f660',
      
      'M304 32H144 96V80 336v48h48H528h48V336 144 96H528 368L304 32zm64 112H528V336H144V80H284.1l49.9 49.9L348.1 144H368zM48 120V96H0v24V456v24H24 456h24V432H456 48V120z'
      
    ]
  };

  

  
  

  var faGaugeCirclePlus = {
    prefix: 'fasr',
    iconName: 'gauge-circle-plus',
    icon: [
      640,
      512,
      [],
      'e498',
      
      'M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6V120 96h48v24V301.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80V288H480v16 48H432 416v32l16 0h48v48 16h32V432 384h48 16V352H560 512V304z'
      
    ]
  };

  

  
  

  var faCirclePause = {
    prefix: 'fasr',
    iconName: 'circle-pause',
    icon: [
      512,
      512,
      [62092,"pause-circle"],
      'f28b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328v24H176V328 184 160h48v24zm112 0V328v24H288V328 184 160h48v24z'
      
    ]
  };

  
    var faPauseCircle = faCirclePause;
  

  
  

  var faBottleWater = {
    prefix: 'fasr',
    iconName: 'bottle-water',
    icon: [
      320,
      512,
      [],
      'e4c5',
      
      'M224 0L96 0l0 83.4c-7.6 2.1-14.9 5-21.8 8.9L68 95.7c-27.1 15.1-44 43.7-44 74.8c0 15.9 4.3 30.8 11.9 43.5C28.4 226.2 24 240.6 24 256c0 18 6 34.6 16 48c-10 13.4-16 30-16 48c0 18.1 6 34.8 16.2 48.3C29.9 416.4 24 435.5 24 456l0 8 0 48 48 0 176 0 48 0 0-48 0-8c0-20.5-5.9-39.6-16.2-55.7C290 386.8 296 370.1 296 352c0-18-6-34.6-16-48c10-13.4 16-30 16-48c0-15.4-4.4-29.8-11.9-42c7.6-12.8 11.9-27.6 11.9-43.5c0-31.1-16.8-59.7-44-74.8l-6.2-3.4c-6.9-3.8-14.3-6.8-21.8-8.9L224 0zM76.7 239.2c9.4-15.2 9.6-34.3 .5-49.7c-3.3-5.5-5.2-12-5.2-19.1c0-13.6 7.4-26.2 19.3-32.8l6.2-3.4c7.4-4.1 15.6-6.2 24.1-6.2l76.9 0c8.4 0 16.7 2.1 24.1 6.2l6.2 3.4c11.9 6.6 19.3 19.2 19.3 32.8c0 7.1-1.9 13.5-5.2 19.1c-9.1 15.4-8.9 34.5 .5 49.7c3 4.8 4.7 10.5 4.7 16.8c0 7.3-2.4 13.8-6.4 19.2c-12.8 17.1-12.8 40.6 0 57.7c4 5.3 6.4 11.9 6.4 19.2c0 7.3-2.4 13.9-6.5 19.3c-12.1 16-13 37.8-2.2 54.7c5.5 8.6 8.7 18.9 8.7 30l0 8L72 464l0-8c0-11.1 3.2-21.3 8.7-30c10.8-16.9 9.9-38.8-2.2-54.7c-4.1-5.4-6.5-12-6.5-19.3c0-7.3 2.4-13.8 6.4-19.2c12.8-17.1 12.8-40.6 0-57.7c-4-5.3-6.4-11.9-6.4-19.2c0-6.2 1.7-11.9 4.7-16.8zM208 208l-96 0 0 48 96 0 0-48zM112 336l0 48 96 0 0-48-96 0z'
      
    ]
  };

  

  
  

  var faFaceSurprise = {
    prefix: 'fasr',
    iconName: 'face-surprise',
    icon: [
      512,
      512,
      [128558,"surprise"],
      'f5c2',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  
    var faSurprise = faFaceSurprise;
  

  
  

  var faArrowRightToArc = {
    prefix: 'fasr',
    iconName: 'arrow-right-to-arc',
    icon: [
      512,
      512,
      [],
      'e4b2',
      
      'M232.3 134.4l112 104L363.3 256l-18.9 17.6-112 104-17.6 16.3-32.7-35.2 17.6-16.3L266.9 280 24 280 0 280l0-48 24 0 242.9 0-67.2-62.4-17.6-16.3 32.7-35.2 17.6 16.3zM464 256c0-114.9-93.1-208-208-208l-24 0 0-48 24 0C397.4 0 512 114.6 512 256s-114.6 256-256 256l-24 0 0-48 24 0c114.9 0 208-93.1 208-208z'
      
    ]
  };

  

  
  

  var faUserShakespeare = {
    prefix: 'fasr',
    iconName: 'user-shakespeare',
    icon: [
      448,
      512,
      [],
      'e2c2',
      
      'M224 48c-44.2 0-80 35.8-80 80v32c0 40.1 29.5 73.3 68 79.1V224 212h24v12 15.1c38.5-5.8 68-39 68-79.1V128c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v32 8l32 40v64H286c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16H64V208l32-40v-8V128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 31l8.5 8.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4h12v24H256c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204H180V180h12c2.1 0 12.9-1.9 23.5-12.5L224 159zm16 257c0 8.8-7.2 16-16 16s-16-7.2-16-16H144L96 448V390.3 375.8L66.6 464H208c0-8.8 7.2-16 16-16s16 7.2 16 16H381.4L352 375.8v14.5V448l-48-32H240zm64-56l-8-8H152l-8 8v8H304v-8zM112 320l16-16H320l16 16h48l48 144 16 48H397.4 50.6 0l16-48L64 320h48z'
      
    ]
  };

  

  
  

  var faMartiniGlassCitrus = {
    prefix: 'fasr',
    iconName: 'martini-glass-citrus',
    icon: [
      576,
      512,
      ["cocktail"],
      'f561',
      
      'M528 144c0-53-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-28.2 0-54.5-8.1-76.7-22.1l35.3-35.3c12.5 6 26.6 9.4 41.4 9.4c53 0 96-43 96-96zM32 128h3.9H48 368h12.1H384h32v32l-16 16L241.9 334.1 232 344V464h88v48H232 208 96V464h88V344l-9.9-9.9L16 176 0 160V128H32zm51.9 48L208 300.1 332.1 176H83.9z'
      
    ]
  };

  
    var faCocktail = faMartiniGlassCitrus;
  

  
  

  var faBracketsRound = {
    prefix: 'fasr',
    iconName: 'brackets-round',
    icon: [
      512,
      512,
      ["parentheses"],
      'e0c5',
      
      'M123.7 35.4C82 60.2 0 138 0 256s82 195.8 123.7 220.6l24.6-41.2C115.3 415.7 48 351.3 48 256s67.3-159.7 100.3-179.4L123.7 35.4zm264.6 0L363.7 76.6C396.7 96.3 464 160.7 464 256s-67.3 159.7-100.3 179.4l24.6 41.2C430 451.8 512 374.1 512 256S430 60.2 388.3 35.4z'
      
    ]
  };

  
    var faParentheses = faBracketsRound;
  

  
  

  var faArrowLeftLongToLine = {
    prefix: 'fasr',
    iconName: 'arrow-left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d4',
      
      'M0 88V424v24H48V424 88 64H0V88zM128 256l17 17L281 409l17 17L331.9 392l-17-17-95-95L616 280h24V232H616l-396.1 0 95-95 17-17L297.9 86.1l-17 17L145 239l-17 17z'
      
    ]
  };

  

  
  

  var faPawSimple = {
    prefix: 'fasr',
    iconName: 'paw-simple',
    icon: [
      448,
      512,
      ["paw-alt"],
      'f701',
      
      'M192 80A48 48 0 1 0 96 80a48 48 0 1 0 96 0zM139.5 324.5l10.1-18.2L204.2 208h39.5l54.6 98.3 10.1 18.2 20.2 5c22.6 5.7 39.3 26.2 39.3 50.5c0 28.7-23.3 52-52 52c-12.9 0-24.7-4.7-33.8-12.5L268.7 408H251 197 179.3l-13.5 11.5c-9.1 7.8-20.8 12.5-33.8 12.5c-28.7 0-52-23.3-52-52c0-24.3 16.7-44.8 39.3-50.5l20.2-5zM176 160L107.7 283C64.2 293.8 32 333.2 32 380c0 55.2 44.8 100 100 100c24.8 0 47.5-9 65-24h54c17.5 15 40.2 24 65 24c55.2 0 100-44.8 100-100c0-46.8-32.2-86.2-75.7-97L272 160H176zm128-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faPawAlt = faPawSimple;
  

  
  

  var faHouseCrack = {
    prefix: 'fasr',
    iconName: 'house-crack',
    icon: [
      576,
      512,
      [],
      'e3b1',
      
      'M288 .5l15.5 13.2 264 224-31.1 36.6L512 253.5V488v24H488 88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zm0 62.9L112 212.8V464H220.8L192 416l96-80L224 224 384 336l-96 80 28.8 48H464V212.8L288 63.5z'
      
    ]
  };

  

  
  

  var faLeftToLine = {
    prefix: 'fasr',
    iconName: 'left-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-left"],
      'f34b',
      
      'M320 288l-48 0 0 48 0 28.1L163.9 256 272 147.9l0 28.1 0 48 48 0 80 0 0 64-80 0zm-190.1 1.9L256 416l16 0 48 0 0-32 0-16 0-32 48 0 32 0 48 0 0-48 0-64 0-48-48 0-32 0-48 0 0-32 0-16 0-32-48 0-16 0L129.9 222.1 96 256l33.9 33.9zM48 88l0-24L0 64 0 88 0 424l0 24 48 0 0-24L48 88z'
      
    ]
  };

  
    var faArrowAltToLeft = faLeftToLine;
  

  
  

  var faHexagonMinus = {
    prefix: 'fasr',
    iconName: 'hexagon-minus',
    icon: [
      512,
      512,
      ["minus-hexagon"],
      'f307',
      
      'M55.3 256L155.9 80H356.1L456.7 256 356.1 432H155.9L55.3 256zM128 32L0 256 128 480H384L512 256 384 32H128zm56 200H160v48h24H328h24V232H328 184z'
      
    ]
  };

  
    var faMinusHexagon = faHexagonMinus;
  

  
  

  var faDumpsterFire = {
    prefix: 'fasr',
    iconName: 'dumpster-fire',
    icon: [
      640,
      512,
      [],
      'f794',
      
      'M32 32L0 160H114.9L140.5 32H32zM272 160V32H173.1L147.5 160H272zm32 0h56.5c19.7-21.2 40.4-38.5 57.8-50.8L402.9 32H304V160zm260.5-24.7c2.3 1.9 4.6 3.8 6.8 5.8L544 32H435.5l11.7 58.6 5.4-3.4L512 146.6l30-30 22.5 18.7zM80.4 192H32l4 32H24 0v48H24 42L64 448v8 24h48V456v-8H337c-12.8-14.2-23.5-30.4-31.5-48H106.4l-20-160H306c7.8-17.4 17.6-33.5 28.1-48H80.4zM448 128c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z'
      
    ]
  };

  

  
  

  var faCircleArrowDownLeft = {
    prefix: 'fasr',
    iconName: 'circle-arrow-down-left',
    icon: [
      512,
      512,
      [],
      'e0f9',
      
      'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM168 368H144V344 184 160h48v24V286.1L327 151l17-17L377.9 168l-17 17-135 135H320h24v48H320 168z'
      
    ]
  };

  

  
  

  var faHouseUser = {
    prefix: 'fasr',
    iconName: 'house-user',
    icon: [
      576,
      512,
      ["home-user"],
      'e1b0',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 488h24V488 253.5l24.5 20.8 31.1-36.6-264-224zM464 212.8V464H112V212.8L288 63.5 464 212.8zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm16 96H208l-32 96H400l-32-96z'
      
    ]
  };

  
    var faHomeUser = faHouseUser;
  

  
  

  var faMarsAndVenus = {
    prefix: 'fasr',
    iconName: 'mars-and-venus',
    icon: [
      512,
      512,
      [9893],
      'f224',
      
      'M376 0H352V48h24 38.1L371.2 90.9C340.3 64.2 300 48 256 48C158.8 48 80 126.8 80 224c0 89.1 66.2 162.7 152 174.4V416H208 184v48h24 24v24 24h48V488 464h24 24V416H304 280V398.4c85.8-11.7 152-85.3 152-174.4c0-35.8-10.7-69.2-29.1-97L448 81.9V120v24h48V120 24 0H472 376zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z'
      
    ]
  };

  

  
  

  var faFileChartPie = {
    prefix: 'fasr',
    iconName: 'file-chart-pie',
    icon: [
      384,
      512,
      [],
      'f65a',
      
      'M336 464V160H224V48H48V464H336zM48 0H256L384 128V464v48H336 48 0V464 48 0H48zM176 238.7V336h96.2c-.1 7.8-1.2 15.7-3.3 23.6c-13.7 51.2-66.4 81.6-117.6 67.9s-81.6-66.4-67.9-117.6C95 267 133.7 238.8 176 238.7zM208 208c53 0 96 43 96 96H208V208z'
      
    ]
  };

  

  
  

  var faHeart = {
    prefix: 'fasr',
    iconName: 'heart',
    icon: [
      512,
      512,
      [9829,10084,61578,128153,128154,128155,128156,128420,129293,129294,129505],
      'f004',
      
      'M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1 414.1 254.1l24.2-24.2c16.5-16.5 25.7-38.8 25.7-62.1c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zm33.9 282.2L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c0 0 0 0 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 289.9 446.1z'
      
    ]
  };

  

  
  

  var faFaceNauseated = {
    prefix: 'fasr',
    iconName: 'face-nauseated',
    icon: [
      512,
      512,
      [],
      'e381',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm335.6-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-19.7-77.3c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-5.3-31.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4 22.6 22.6-7.4 7.4zm128.7-7.4l22.6-22.6 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4-5.3 31.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM148 308.8l24-41.5C189 277 202 293 208 312h96.2c6.1-18.8 19-34.5 35.8-44.2l24 41.5c-9.4 5.5-15.7 15.6-15.7 27.2s6.3 21.8 15.7 27.2l-24 41.5c-17.1-9.9-30.2-26-36.2-45.3H208c-6 19-19.1 35-36 44.8l-24-41.5c9.5-5.5 15.7-15.6 15.7-27.2s-6.3-21.8-15.7-27.2z'
      
    ]
  };

  

  
  

  var faBookCircleArrowUp = {
    prefix: 'fasr',
    iconName: 'book-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e0bd',
      
      'M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H394.8c-18.3-12.9-34.1-29.2-46.3-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H322.9c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H400V220.5c14.6-9.5 30.8-17 48-21.8V24 0H424 88zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM417.4 360l11.3-11.3 56-56L496 281.4l11.3 11.3 56 56L574.6 360 552 382.6l-11.3-11.3L512 342.6V432v16H480V432 342.6l-28.7 28.7L440 382.6 417.4 360z'
      
    ]
  };

  

  
  

  var faShirtRunning = {
    prefix: 'fasr',
    iconName: 'shirt-running',
    icon: [
      384,
      512,
      [],
      'e3c8',
      
      'M192 152c-44.2 0-80-35.8-80-80V24 0H64V24 72v50.3L2.5 245.3 0 250.3V256 488v24H24 360h24V488 256v-5.7l-2.5-5.1L320 122.3V72 24 0H272V24 72c0 44.2-35.8 80-80 80zm0 48c36.7 0 69.8-15.4 93.1-40.1l22 43.9c-.4 .2-.7 .5-1.1 .8L48 390.8V261.7L98.9 159.9C122.2 184.6 155.3 200 192 200zM48 450L328.8 247.3l7.2 14.4V464H48V450z'
      
    ]
  };

  

  
  

  var faSignPostsWrench = {
    prefix: 'fasr',
    iconName: 'sign-posts-wrench',
    icon: [
      640,
      512,
      [],
      'e626',
      
      'M64 32L64 0h48l0 32H464l0-32h48l0 32h16 48V80 192H528V80H48V368H359.3c5.5 17.5 13.9 33.7 24.7 48H112l0 96H64l0-96H48 0V368 80 32H48 64zM427.3 224H464v96l48 48 48-48V224l36.7 0c26.6 23.5 43.3 57.8 43.3 96c0 40.4-18.7 76.5-48 99.9V512H432V419.9c-29.3-23.5-48-59.5-48-99.9c0-38.2 16.8-72.5 43.3-96z'
      
    ]
  };

  

  
  

  var faGridRound4 = {
    prefix: 'fasr',
    iconName: 'grid-round-4',
    icon: [
      448,
      512,
      [],
      'e5dd',
      
      'M44.8 64a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zM44.8 183.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM57.6 315.7a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM177.1 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm57.6 119.5a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM296.5 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm57.6 119.5a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM416 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM416 315.7a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z'
      
    ]
  };

  

  
  

  var faFaceThermometer = {
    prefix: 'fasr',
    iconName: 'face-thermometer',
    icon: [
      576,
      512,
      [],
      'e39a',
      
      'M288 48C173.1 48 80 141.1 80 256s93.1 208 208 208c65.9 0 124.7-30.7 162.8-78.5c1.5-1.3 3-2.6 4.4-4L540 301.1C518.8 421 414 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c97 0 181.4 54 224.8 133.5c-16.5-.3-33.1 4.4-47.3 14.1C429 87.8 363.1 48 288 48zM546.8 180.1c19.8 19.8 19.4 52.1-.9 71.4L425.1 366.6c1 1.4 2 2.7 2.9 4.1l-24 16-1 .9-.2-.2L388 397.3C376 379.2 340.1 352 296 352s-80 27.2-92 45.3L164 370.7c19.9-29.9 70-66.7 132-66.7c15.6 0 30.5 2.3 44.4 6.3L477 179.4c19.6-18.8 50.6-18.4 69.8 .7zM402.9 343.5l26.5-25.2-5.8-5.8L415 304l17-17 8.5 8.5 6.3 6.3 15.4-14.7-6.6-6.6L447 272l17-17 8.5 8.5 7 7 15.4-14.7-7.4-7.4L479 240l17-17 8.5 8.5 7.8 7.8 11.5-11c7.3-6.9 7.4-18.5 .3-25.6c-6.9-6.9-18-7-25-.3l-126.2 121c11.3 5.9 21.3 12.8 30 20.1zM208.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faPlugCircleBolt = {
    prefix: 'fasr',
    iconName: 'plug-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e55b',
      
      'M120 24V0H72V24v88h48V24zm192 0V0H264V24v88h48V24zM24 144H0v48H24h8v64c0 80.2 59 146.6 136 158.2V512h48V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8 24V144H360h-8H304 80 32 24zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm24-224l-10.7 64H512L408 448l10.7-64H352l104-96z'
      
    ]
  };

  

  
  

  var faTrophyStar = {
    prefix: 'fasr',
    iconName: 'trophy-star',
    icon: [
      576,
      512,
      ["trophy-alt"],
      'f2eb',
      
      'M325.1 372.3c-4.7 2.5-9.1 4.5-13.1 6.1V464h80 24v48H392 288 184 160V464h24 80V378.4c-4-1.6-8.4-3.6-13.1-6.1c-33.8-6-95.5-22-149.5-63.7C45.9 265.7 0 196.5 0 88V64H24 129.6c-.3-5.2-.5-10.6-.7-16c-.6-15.3-.9-31.3-.9-48h48H400h48c0 16.7-.3 32.7-.9 48c-.2 5.4-.4 10.8-.7 16H552h24V88c0 108.5-45.9 177.7-101.4 220.6c-53.9 41.7-115.7 57.6-149.5 63.7zm65.7-69.7c18.1-8 36.8-18.4 54.4-32c40.6-31.3 75.9-80.2 81.9-158.6H442.7c-9.1 90.1-29.2 150.3-51.9 190.6zM133.2 112H48.9c6 78.4 41.3 127.3 81.9 158.6c17.5 13.6 36.3 24 54.4 32c-22.7-40.3-42.8-100.5-51.9-190.6zM244.9 305.3c14.7 17.7 28.1 25 36 28.2c3.1 1.2 5.6 1.9 7.2 2.3c1.6-.3 4.1-1 7.2-2.3c7.9-3.1 21.2-10.5 36-28.2c27.1-32.6 61.9-104.2 68-257.3H176.9c6.1 153.1 40.8 224.7 68 257.3zm66.6-169.6l52.6 7.6-38 37.1 9 52.4L288 208l-47 24.7 9-52.4-38-37.1 52.6-7.6L288 88l23.5 47.6z'
      
    ]
  };

  
    var faTrophyAlt = faTrophyStar;
  

  
  

  var faCircleThreeQuarters = {
    prefix: 'fasr',
    iconName: 'circle-three-quarters',
    icon: [
      512,
      512,
      [],
      'e125',
      
      'M208 304V256 53.6C116.3 75.2 48 157.6 48 256c0 114.9 93.1 208 208 208c98.4 0 180.8-68.3 202.4-160H256 208zm299.5 0C485 422.4 381 512 256 512C114.6 512 0 397.4 0 256C0 131 89.6 27 208 4.5C223.5 1.5 239.6 0 256 0V48 208v48h48H464h48c0 16.4-1.5 32.5-4.5 48z'
      
    ]
  };

  

  
  

  var faArrowsToEye = {
    prefix: 'fasr',
    iconName: 'arrows-to-eye',
    icon: [
      640,
      512,
      [],
      'e4bf',
      
      'M52.2 18.2l-17-17L1.3 35.2l17 17L78.1 112H40 16v48H40h96 24V136 40 16H112V40 78.1L52.2 18.2zM224.6 310.8c-19-17.6-33.5-37.9-43.1-54.8c9.6-16.9 24.1-37.2 43.1-54.8C250.9 176.7 282.7 160 320 160s69.1 16.7 95.4 41.2c19 17.6 33.5 37.9 43.1 54.8c-9.6 16.9-24.1 37.2-43.1 54.8C389.1 335.3 357.3 352 320 352s-69.1-16.7-95.4-41.2zM320 400c105.6 0 172-96 192-144c-20-48-86.4-144-192-144s-172 96-192 144c20 48 86.4 144 192 144zM604.8 1.3l-17 17L528 78.1V40 16H480V40v96 24h24 96 24V112H600 561.9l59.8-59.8 17-17L604.8 1.3zM52.2 493.8L112 433.9V472v24h48V472 376 352H136 40 16v48H40 78.1L18.2 459.8l-17 17 33.9 33.9 17-17zm552.6 17l33.9-33.9-17-17L561.9 400H600h24V352H600 504 480v24 96 24h48V472 433.9l59.8 59.8 17 17zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faScrewdriverWrench = {
    prefix: 'fasr',
    iconName: 'screwdriver-wrench',
    icon: [
      512,
      512,
      ["tools"],
      'f7d9',
      
      'M33.9 366.1L160.4 239.6l33.9 33.9L67.9 400 112 444.1l95.4-95.4 17.9 17.9 16 16-95.4 95.4L112 512 78.1 478.1 33.9 433.9 0 400l33.9-33.9zM224 144.8V96 80l-7.3-5.5C245.1 29.7 295.1 0 352 0c13.5 0 26.7 1.7 39.3 4.9c17 4.3 33 11.3 47.3 20.6L403.5 60.5 352 112v48h48l51.5-51.5 35.1-35.1c9.3 14.4 16.3 30.3 20.6 47.3c3.2 12.6 4.9 25.7 4.9 39.3c0 57.2-30 107.3-75.1 135.6l-35.2-35.2c35.8-17.8 60.8-54.1 62.3-96.5l-30 30L419.9 208H400 352 304V160 112 92.1l14.1-14.1 30-30C288 50.1 240 99.5 240 160l0 .8-16-16zM287 321l-129-129H96L0 64 64 0 192 96v62.1L321 287l31-31L512 416l-96 96L256 352l31-31z'
      
    ]
  };

  
    var faTools = faScrewdriverWrench;
  

  
  

  var faHandHorns = {
    prefix: 'fasr',
    iconName: 'hand-horns',
    icon: [
      384,
      512,
      [],
      'e1a9',
      
      'M16 0H40h80 24V24 144h56 24v24 8h32V88 64h24 80 24V88 256v32 56c0 92.8-75.2 168-168 168H168C75.2 512 0 436.8 0 344c0 0 0 0 0 0V320v0V264 240H16V24 0zM48 320v0 24s0 0 0 0c0 66.3 53.7 120 120 120h48c66.3 0 120-53.7 120-120V288 256 112H304v64 24 56 88 24H280 224 200 176 120 96V320h24 56V288H120 48v32zM176 200v-8H144v48h32V200zM96 168V144 48H64V240H96V168zm160 56H224v40 56h32V256 224z'
      
    ]
  };

  

  
  

  var faFaceSleepy = {
    prefix: 'fasr',
    iconName: 'face-sleepy',
    icon: [
      512,
      512,
      [],
      'e38e',
      
      'M256 464c47 0 90.4-15.6 125.2-41.9c2.7 14.8 2.8 29.6 2.8 41.9c0 4.5 .4 8.9 1.1 13.1C347.2 499.3 303.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 37-7.8 72.1-22 103.9c-7.4-6.2-15.1-11.8-22.7-16.7c-5.8-3.8-11.8-7.3-17.9-10.6C458.8 308.9 464 283 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208zm-91-45c4.1-39.8 43.1-71 90.6-71s86.5 31.2 90.6 71c-25.4-14.5-56.8-23-90.6-23s-65.2 8.5-90.6 23zM311.7 245.7c20 27.1 59.8 27.1 79.8 0l32.2 23.8c-36 48.7-108.2 48.7-144.2 0l32.2-23.8zm-112.2 0l32.2 23.8c-36 48.7-108.2 48.7-144.2 0l32.2-23.8c20 27.1 59.8 27.1 79.8 0zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-21.7 0-61.1-20-92.1l20-20c47 20.3 96 59.2 96 112.1z'
      
    ]
  };

  

  
  

  var faTarp = {
    prefix: 'fasr',
    iconName: 'tarp',
    icon: [
      576,
      512,
      [],
      'e57b',
      
      'M48 112l480 0V288H416V400L48 400l0-288zM576 320V112 64H528 48 0v48V400v48H48l400 0L576 320zM112 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faHammerBrush = {
    prefix: 'fasr',
    iconName: 'hammer-brush',
    icon: [
      640,
      512,
      [],
      'e620',
      
      'M136 0C60.9 0 0 60.9 0 136v32 36.4l33.5-14.3 41.1-17.6L87 185l7 7H104h13.8L96 512H224L202.2 192H248h24V168v-8h32v32h48V160h0V136 56 32h0V0H304V32H272V24 0H248 136zM304 112H248 224v24 8H113.9L97 127 85.5 115.5l-14.9 6.4-22.4 9.6C50.4 85 88.9 48 136 48h88v8V80h24 56v32zm96 208H592V464H480V416 400H448v16 48H400V320zm48-128l-96 64V464v48h48H592h48V464 256l-96-64V0H448V192zM480 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faClockNine = {
    prefix: 'fasr',
    iconName: 'clock-nine',
    icon: [
      512,
      512,
      [],
      'e34c',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V256v24H256 152 128V232h24 80V120 96h48v24z'
      
    ]
  };

  

  
  

  var faHandsHoldingHeart = {
    prefix: 'fasr',
    iconName: 'hands-holding-heart',
    icon: [
      640,
      512,
      ["hands-heart"],
      'f4c3',
      
      'M199.2 135.1L224 159.9l96 96 96-96 24.8-24.8c14.9-14.9 23.2-35 23.2-56V75.6C464 33.8 430.1-.1 388.4-.1c-23 0-44.7 10.4-59.1 28.4L320 39.9l-9.3-11.6C296.4 10.4 274.6-.1 251.6-.1C209.9-.1 176 33.8 176 75.6v3.6c0 21 8.3 41.1 23.2 56zM144 64H120 24 0V88 392v9.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112H96V312v9.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16L233.9 392l-16-16-1-1-16-16-23-23L208 305.9l88 88V488v24h24 24V488 393.9l88-88L462.1 336l-23 23 0 0-16 16-17 17L440 425.9l17-17 16-16 0 0 40-40 17-17 7-7 7-7V312 112h48V382.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V392 88 64H616 520 496V88 302.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88 64z'
      
    ]
  };

  
    var faHandsHeart = faHandsHoldingHeart;
  

  
  

  var faBasketShoppingSimple = {
    prefix: 'fasr',
    iconName: 'basket-shopping-simple',
    icon: [
      576,
      512,
      ["shopping-basket-alt"],
      'e0af',
      
      'M256.4 29.8L245.3 51.1 171.8 192H404.2L330.7 51.1 319.6 29.8 362.2 7.6l11.1 21.3L458.4 192h36.1H544h32v48H532L464 512H112L44 240H0V192H32 81.5h36.1L202.7 28.9 213.8 7.6l42.6 22.2zM482.5 240H93.5l56 224h277l56-224zM144 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faShoppingBasketAlt = faBasketShoppingSimple;
  

  
  

  var faH = {
    prefix: 'fasr',
    iconName: 'h',
    icon: [
      384,
      512,
      [104],
      '48',
      
      'M336 256l0 200v24h48V456l0-232V56 32H336V56 208L48 208 48 56V32H0V56 456v24H48V456l0-200 288 0z'
      
    ]
  };

  

  
  

  var faLeftFromLine = {
    prefix: 'fasr',
    iconName: 'left-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-right"],
      'f348',
      
      'M224 288l-48 0 0 48 0 28.1L67.9 256 176 147.9l0 28.1 0 48 48 0 80 0 0 64-80 0zM33.9 289.9L160 416l16 0 48 0 0-32 0-16 0-32 48 0 32 0 48 0 0-48 0-64 0-48-48 0-32 0-48 0 0-32 0-16 0-32-48 0-16 0L33.9 222.1 0 256l33.9 33.9zM400 88l0 336 0 24 48 0 0-24 0-336 0-24-48 0 0 24z'
      
    ]
  };

  
    var faArrowAltFromRight = faLeftFromLine;
  

  
  

  var faCupStraw = {
    prefix: 'fasr',
    iconName: 'cup-straw',
    icon: [
      384,
      512,
      [129380],
      'e363',
      
      'M205 0l-4.4 18.5L174.9 128H80.2 32 24 0v48H24 36 84.2h79.4 49.3 86.9H348h12 24V128H360h-8H303.8 224.2L243 48h37 24V0H280 224 205zM38.7 208L64 512H320l25.3-304H297.2L275.8 464H108.2L86.8 208H38.7z'
      
    ]
  };

  

  
  

  var faMessageSmile = {
    prefix: 'fasr',
    iconName: 'message-smile',
    icon: [
      512,
      512,
      ["comment-alt-smile"],
      'f4aa',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM168.4 222.1l-35.8 32 16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32l-16-17.9z'
      
    ]
  };

  
    var faCommentAltSmile = faMessageSmile;
  

  
  

  var faSpaceStationMoon = {
    prefix: 'fasr',
    iconName: 'space-station-moon',
    icon: [
      512,
      512,
      [],
      'e033',
      
      'M256 48c-16.5 0-32.5 1.9-47.8 5.5C245.4 66.8 272 102.3 272 144c0 53-43 96-96 96c-52.7 0-95.4-42.4-96-94.9C59.7 177.2 48 215.2 48 256c0 12.8 1.1 25.2 3.3 37.4c.5 .2 1 .3 1.5 .5C87.7 306.5 147.6 328 256 328s168.3-21.5 203.2-34.1l0 0c.5-.2 1-.4 1.5-.5c2.2-12.1 3.3-24.6 3.3-37.4c0-114.9-93.1-208-208-208zM441.3 350.7C402.1 362.7 343 376 256 376s-146.1-13.3-185.3-25.3C105.2 417.9 175.2 464 256 464s150.8-46.1 185.3-113.3zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM176 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faMelonSlice = {
    prefix: 'fasr',
    iconName: 'melon-slice',
    icon: [
      512,
      512,
      [],
      'e311',
      
      'M368.7 63.3L336 96s0 0 0 0l-1.2 1.2c.3 .3 .7 .7 1 1C334.6 113.6 324.6 203.4 264 264s-150.4 70.6-165.7 71.8c-.4-.3-.7-.7-1-1L96 336s0 0 0 0L63.3 368.7 35.2 396.8l-34 34c11.8 11 24.5 21 37.9 30C87.4 493.1 145.5 512 208 512c167.9 0 304-136.1 304-304c0-62.5-18.9-120.6-51.2-168.9c-9-13.4-19-26.1-30-37.9l-34 34L368.7 63.3zm5.1 95c6.6 18 10.2 37.5 10.2 57.8c0 92.8-75.2 168-168 168c-20.3 0-39.7-3.6-57.8-10.2c3.3-.8 6.7-1.8 10.1-2.8c38-10.9 88.5-32 129.6-73.1s62.2-91.6 73.1-129.6c1-3.4 1.9-6.8 2.8-10.1zM101 398.9c33.3 21 72.7 33.1 115 33.1c119.3 0 216-96.7 216-216c0-42.3-12.1-81.7-33.1-115l27.2-27.2c24.1 39 37.9 85 37.9 134.2c0 141.4-114.6 256-256 256c-49.2 0-95.2-13.9-134.2-37.9L101 398.9z'
      
    ]
  };

  

  
  

  var faPersonCircleQuestion = {
    prefix: 'fasr',
    iconName: 'person-circle-question',
    icon: [
      576,
      512,
      [],
      'e542',
      
      'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM94.8 128h14.1H211.1h14.1l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6L224 224.9V488v24H176V488 352H144V488v24H96V488 224.9L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128zM144 304h32V176H144V304zm288-80a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-22.4 56c-23 0-41.6 18.6-41.6 41.6V328l32 0v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8-8.6 4.5v9.7V376v16h32V378.9l23.5-12.3c10.2-5.4 17.8-14.2 21.7-24.6H496v-16c0-25.4-20.6-45.9-45.9-45.9H409.6zM448 416H416v32h32V416z'
      
    ]
  };

  

  
  

  var faCashRegister = {
    prefix: 'fasr',
    iconName: 'cash-register',
    icon: [
      512,
      512,
      [],
      'f788',
      
      'M32 0H320V128H208v32H480l32 224v80 48H464 48 0V464 384L32 160H144V128H32V0zM80 48V80H96 256h16V48H256 96 80zM464 464V432H48v32H464zM438.4 208H73.6L48.5 384h415L438.4 208zM136 232v48H88V232h48zm96 0v48H184V232h48zm-48 80v48H136V312h48zm96-80h48v48H280V232zm0 128H232V312h48v48zm96-128h48v48H376V232zm0 80v48H328V312h48z'
      
    ]
  };

  

  
  

  var faOctagonPlus = {
    prefix: 'fasr',
    iconName: 'octagon-plus',
    icon: [
      512,
      512,
      ["plus-octagon"],
      'f301',
      
      'M48 332.1V179.9L179.9 48H332.1L464 179.9V332.1L332.1 464H179.9L48 332.1zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zm72 368h48V344 280h64 24V232H344 280V168 144H232v24 64H168 144v48h24 64v64 24z'
      
    ]
  };

  
    var faPlusOctagon = faOctagonPlus;
  

  
  

  var faSignsPost = {
    prefix: 'fasr',
    iconName: 'signs-post',
    icon: [
      512,
      512,
      ["map-signs"],
      'f277',
      
      'M232 0h48V32H448l64 80-64 80H280v32H432h48v48 64 48H432 280V512H232V384H64L0 304l64-80H232V192H80 32V144 80 32H80 232V0zM424.9 80H80v64H424.9l25.6-32L424.9 80zM87.1 272L61.5 304l25.6 32H432V272H87.1z'
      
    ]
  };

  
    var faMapSigns = faSignsPost;
  

  
  

  var faArrowRight = {
    prefix: 'fasr',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      'M429.8 273l17-17-17-17L276.2 85.4l-17-17-33.9 33.9 17 17L354.9 232 24 232 0 232l0 48 24 0 330.8 0L242.2 392.6l-17 17 33.9 33.9 17-17L429.8 273z'
      
    ]
  };

  

  
  

  var faSignatureLock = {
    prefix: 'fasr',
    iconName: 'signature-lock',
    icon: [
      640,
      512,
      [],
      'e3ca',
      
      'M128 80c-26.5 0-48 21.5-48 48v40 24H32V168 128c0-53 43-96 96-96s96 43 96 96v7.9c0 22.2-1.4 44.4-4.1 66.4l133-41.2 45.8-14.2-16.1 45.2L354.1 272H384v16l0 32H320 285.9l11.5-32.1 23.9-66.8L210.5 255.4l-1 4.7c-12.5 56.2-34 110.1-63.6 159.5l-29.3 48.8-7 11.7H96 24 0V456 288 270.3l16.9-5.2L169 218c4.6-27.1 7-54.6 7-82.1V128c0-26.5-21.5-48-48-48zM384 368l0 48H184.8c8.5-15.6 16.3-31.7 23.3-48H384zM157.1 271.9L48 305.7V432H82.4l22.3-37.1c23.1-38.4 40.7-79.8 52.4-123zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H416V320h32V272z'
      
    ]
  };

  

  
  

  var faTickets = {
    prefix: 'fasr',
    iconName: 'tickets',
    icon: [
      640,
      512,
      [],
      'e658',
      
      'M96 80V32h48H592h48V80v40 48c-22.1 0-40 17.9-40 40s17.9 40 40 40v48 40 48H592 144 96V336 296 248c22.1 0 40-17.9 40-40s-17.9-40-40-40V120 80zm48 54.2c24.1 15.7 40 42.9 40 73.8s-15.9 58.1-40 73.8V336H592V281.8c-24.1-15.7-40-42.9-40-73.8s15.9-58.1 40-73.8V80H144v54.2zM48 96v24V432H520h24v48H520 24 0V456 120 96H48zm224 80v64H464V176H272zm-48-48h48H464h48v48 64 48H464 272 224V240 176 128z'
      
    ]
  };

  

  
  

  var faMaskVentilator = {
    prefix: 'fasr',
    iconName: 'mask-ventilator',
    icon: [
      640,
      512,
      [],
      'e524',
      
      'M200.7 374.4c-.5-4.3-.7-8.7-.7-13.1c0-27 9.6-57.1 22.4-83.6C235.3 251 252.8 225.3 271 207l7-7H288h64 9.9l7 7c18.3 18.3 35.7 44 48.6 70.7c12.8 26.5 22.4 56.6 22.4 83.6c0 4.3-.2 8.5-.6 12.7C455 352.8 464 327.4 464 300.8c0-41.1-20.6-104.8-55.4-155.2L359.9 80H280L231 145.6c-34.6 50.3-55 114-55 155.2c0 26.7 8.9 52.3 24.7 73.6zM248 361.3c0 21.8 9.2 41.2 24 54.5v58.6c-45.3-10.8-84-36.5-109.8-71.1l-144.1-36L0 362.7V344 152 128H24 185.1c2.3-3.5 4.6-7 6.9-10.4L256 32H384l63.6 85.6c2.4 3.4 4.7 6.9 6.9 10.4H616h24v24V344v18.7l-18.2 4.5L477.5 403.4c-26 34.6-64.7 60.2-109.5 71V415.7c14.7-13.3 24-32.6 24-54.3c0-16.9-6.4-39.5-17.6-62.7c-9.3-19.3-21.1-37.2-32.8-50.6H298.4c-11.7 13.4-23.5 31.3-32.8 50.6c-11.2 23.2-17.6 45.8-17.6 62.7zm257.6-14.5L592 325.3V176H480.7c19.8 43.2 31.3 88.7 31.3 124.8c0 16-2.2 31.4-6.4 46.1zM159.1 176H48V325.3l86.3 21.6c-4.1-14.7-6.3-30.1-6.3-46c0-36.1 11.4-81.6 31.1-124.8zM296 304h48V512H296V304z'
      
    ]
  };

  

  
  

  var faSendBack = {
    prefix: 'fasr',
    iconName: 'send-back',
    icon: [
      640,
      512,
      [],
      'f87e',
      
      'M208 48V208H48V48H208zM48 0H0V48 208v48H48 208h48V208 48 0H208 48zM592 304V464H432V304H592zM432 256H384v48V464v48h48H592h48V464 304 256H592 432zM160 288V416H352V256 224h32 96V96H288V256v32H256 160z'
      
    ]
  };

  

  
  

  var faCalendarArrowDown = {
    prefix: 'fasr',
    iconName: 'calendar-arrow-down',
    icon: [
      448,
      512,
      ["calendar-download"],
      'e0d0',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zM248 248V350.1l39-39 17-17L337.9 328l-17 17-80 80-17 17-17-17-80-80-17-17L144 294.1l17 17 39 39V248 224h48v24z'
      
    ]
  };

  
    var faCalendarDownload = faCalendarArrowDown;
  

  
  

  var faChartLine = {
    prefix: 'fasr',
    iconName: 'chart-line',
    icon: [
      512,
      512,
      ["line-chart"],
      'f201',
      
      'M48 56V32H0V56 456v24H24 488h24V432H488 48V56zM473 169l17-17L456 118.1l-17 17-119 119-79-79-17-17-17 17-96 96-17 17L128 321.9l17-17 79-79 79 79 17 17 17-17L473 169z'
      
    ]
  };

  
    var faLineChart = faChartLine;
  

  
  

  var faFrenchFries = {
    prefix: 'fasr',
    iconName: 'french-fries',
    icon: [
      384,
      512,
      [127839],
      'f803',
      
      'M97.4 221.4L64 32 112 0l16 90.7V272H117.7L97.4 221.4zM59.7 192H18.7L0 80 41.8 90.5 59.7 192zm305.6 0H325.8L342.7 90.3 384 80 365.3 192zm-75.6 21.4L266.3 272H256V48l64-16L289.8 213.4zM224 272H160V0l64 32V240v32zM64 224l32 80H288l32-80h14.8H384l-10.7 48L320 512H64L10.7 272 0 224H49.2 64zM288 352H96 77.6l24.9 112h179l24.9-112H288z'
      
    ]
  };

  

  
  

  var faObjectGroup = {
    prefix: 'fasr',
    iconName: 'object-group',
    icon: [
      576,
      512,
      [],
      'f247',
      
      'M32 128H48V384H32v64 32H64h64V464H448v16h64 32V448 384H528V128h16V64 32H512 448V48H128V32H64 32V64v64zM96 416V96H480V416H96zm32-288V288H320V128H128zM256 320v64H448V224H352v64 32H320 256z'
      
    ]
  };

  

  
  

  var faRingsWedding = {
    prefix: 'fasr',
    iconName: 'rings-wedding',
    icon: [
      512,
      512,
      [],
      'f81b',
      
      'M172.5 88L152 50.5l1.7-2.5h44.6l1.7 2.5L179.5 88h-7zM96 48l30.1 55.2C53.2 124.7 0 192.1 0 272c0 97.2 78.8 176 176 176c7.8 0 15.5-.5 23-1.5c32.3 39.9 81.6 65.5 137 65.5c97.2 0 176-78.8 176-176c0-91.9-70.4-167.3-160.3-175.3c10.4 16.5 18.6 34.5 24.2 53.6C427.1 231.1 464 279.2 464 336c0 70.7-57.3 128-128 128c-32.8 0-62.7-12.3-85.3-32.6c0 0 0 0 0 0c-12.3-11-22.5-24.4-29.8-39.5c0 0 0 0 0 0C212.6 375 208 356.1 208 336c0-54.9 34.6-101.8 83.2-119.9C299.4 233 304 251.9 304 272c0 43.5-21.7 81.9-54.8 105c7 14.8 17.7 27.5 30.8 37c43.7-32 72-83.7 72-142c0-79.9-53.2-147.3-126.1-168.8L256 48 224 0H128L96 48zM261.3 176.6C201.5 204.7 160 265.5 160 336c0 22.6 4.2 44.1 12 63.9C103.1 397.8 48 341.3 48 272c0-70.7 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6z'
      
    ]
  };

  

  
  

  var faBreadLoaf = {
    prefix: 'fasr',
    iconName: 'bread-loaf',
    icon: [
      640,
      512,
      [127838],
      'f7eb',
      
      'M112 208H64c-8.8 0-16-7.2-16-16c0-36.7 23.6-63.9 68.1-84.4C160.5 87.1 213.4 80 240 80s79.5 7.1 123.9 27.6C408.4 128.1 432 155.3 432 192c0 8.8-7.2 16-16 16H368v48V432H320 112V256 208zm304 48H528V432H416V304 256zm152-48l-40 0-50 0c1.3-5.1 2-10.5 2-16c0-51.1-28-86.9-65.8-111.5c28.7 2 72.2 9.7 109.7 27C568.4 128.1 592 155.3 592 192c0 8.8-7.2 16-16 16l-8 0zM112 480H320h48 48H528h48V432 304 256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v48V432v48h48z'
      
    ]
  };

  

  
  

  var faFaceRollingEyes = {
    prefix: 'fasr',
    iconName: 'face-rolling-eyes',
    icon: [
      512,
      512,
      [128580,"meh-rolling-eyes"],
      'f5a5',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 352v48h24H320h24V352H320 192 168zm-8-80c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  
    var faMehRollingEyes = faFaceRollingEyes;
  

  
  

  var faHexagonVerticalNft = {
    prefix: 'fasr',
    iconName: 'hexagon-vertical-nft',
    icon: [
      448,
      512,
      [],
      'e505',
      
      'M400 356.1V155.9L224 55.3 48 155.9V356.1L224 456.7 400 356.1zM0 128L224 0 448 128V384L224 512 0 384V128zm80 32h8H99.9l3.4 11.4L128 253.7V176 160h32v16V336v16H144h-8H124.1l-3.4-11.4L96 258.3V336v16H64V336 176 160H80zm128 0h48 16v32H256 224v48h32 16v32H256 224v64 16H192V336 256 176 160h16zm96 0h32 32 16v32H368 352V336v16H320V336 192H304 288V160h16z'
      
    ]
  };

  

  
  

  var faUserCowboy = {
    prefix: 'fasr',
    iconName: 'user-cowboy',
    icon: [
      448,
      512,
      [],
      'f8ea',
      
      'M364.2 105.1c-7.7 3-16.2 5.9-25.6 8.6L288 0 224 32 160 0 109.5 113.7c-9.4-2.7-17.9-5.6-25.6-8.6c-32.4-12.7-49.4-27.2-55-34.7L.8 85.1c9.3 27.9 35 62.4 72.5 89.9c7.4 5.4 15.4 10.6 23.8 15.5C96.4 196.1 96 202 96 208c0 70.7 57.3 128 128 128s128-57.3 128-128c0-6-.4-11.9-1.2-17.6c8.4-4.8 16.4-10 23.8-15.5c37.6-27.4 63.2-62 72.5-89.9l-28-14.7c-5.6 7.5-22.7 22-55 34.7zM303.9 211.3C302.2 253.9 267.1 288 224 288s-78.2-34.1-79.9-76.7c24.2 8 50.9 12.7 79.9 12.7s55.8-4.8 79.9-12.7zM66.6 464l16-48H365.4l16 48H66.6zM48 368L16 464 0 512H50.6 397.4 448l-16-48-32-96H48z'
      
    ]
  };

  

  
  

  var faSeal = {
    prefix: 'fasr',
    iconName: 'seal',
    icon: [
      512,
      512,
      [],
      'e241',
      
      'M331 75l-41-41L256 0 222.1 33.9 181 75H123 75v48 58l-41 41L0 256l33.9 33.9 41 41v58 48h48 58l41 41L256 512l33.9-33.9 41-41h58 48V389 331l41-41L512 256l-33.9-33.9-41-41V123 75H389 331zm58 48v58 19.9L403.1 215l41 41-41 41L389 311.1V331v58H331 311.1L297 403.1l-41 41-41-41L200.9 389H181 123V331 311.1L108.9 297l-41-41 41-41L123 200.9V181 123h58 19.9L215 108.9l41-41 41 41L311.1 123H331h58z'
      
    ]
  };

  

  
  

  var faPlaneCircleCheck = {
    prefix: 'fasr',
    iconName: 'plane-circle-check',
    icon: [
      640,
      512,
      [],
      'e555',
      
      'M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106v51.5l91 52c-16.1 7.9-30.9 18.1-43.8 30.3l-83.1-47.5L288 185.4V171.4 106c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8 .2-6.7 3.3c-3.9 3.1-8.2 8.1-12.3 14.9c-8.5 14-13 30.2-13 39.7v65.5 13.9l-12.1 6.9L48 285.9v34.3l145.4-41.5 30.6-8.7v31.8l0 66.3v12l-9.6 7.2L160 428v32.4l88.9-27.4 7.1-2.2 7.1 2.2 91.8 28.3c12.5 19.9 29 37.2 48.2 50.7H384 360h-3.6l-3.4-1.1L256 481.1l-96.9 29.8-3.4 1.1H152 136 112V488 416 404l9.6-7.2L176 356l0-22.5L30.6 375.1 0 383.8V352 272 258.1l12.1-6.9L176 157.5V106c0-20.3 8.1-45.1 20-64.6c6.1-10 13.8-19.9 23.3-27.5zm99.3 264.8l29 8.3c-12.5 24.2-19.6 51.7-19.6 80.8c0 16.3 2.2 32 6.3 47l-36.7-27.6L288 380V368 301.7 269.9l30.6 8.7zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faCircleRight = {
    prefix: 'fasr',
    iconName: 'circle-right',
    icon: [
      512,
      512,
      [61838,"arrow-alt-circle-right"],
      'f35a',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM288 144H256v64l-128 0 0 96H256v64h32l96-112L288 144z'
      
    ]
  };

  
    var faArrowAltCircleRight = faCircleRight;
  

  
  

  var faEject = {
    prefix: 'fasr',
    iconName: 'eject',
    icon: [
      448,
      512,
      [9167],
      'f052',
      
      'M224 134.3L65.7 304H382.3L224 134.3zM0 304L191.2 99.2 224 64l32.8 35.2L448 304v48H400 48 0V304zm24 96H424h24v48H424 24 0V400H24z'
      
    ]
  };

  

  
  

  var faStarship = {
    prefix: 'fasr',
    iconName: 'starship',
    icon: [
      640,
      512,
      [],
      'e039',
      
      'M0 32H24 232h24V56v80 24H232 164.8l37.7 26.1 70.1-8.4C302.6 110.7 369.9 64 448 64c106 0 192 86 192 192s-86 192-192 192c-78.1 0-145.4-46.7-175.3-113.7l-70.1-8.4L164.8 352H232h24v24 80 24H232 24 0V456 376 352H24 80.5l50.1-34.7-45.5-5.5L64 309.3V288 224 202.7l21.1-2.5 45.5-5.5L80.5 160H24 0V136 56 32zM48 80v32H208V80H48zm64 165.3v21.4l146.1 17.5c-1.4-9.2-2.1-18.6-2.1-28.2s.7-19 2.1-28.2L112 245.3zM48 432H208V400H48v32zm400-32a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm32-144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faSimCards = {
    prefix: 'fasr',
    iconName: 'sim-cards',
    icon: [
      448,
      512,
      [],
      'e251',
      
      'M144 368H400V131.9L316.1 48H144V368zM448 112V368v48H400 144 96V368 48 0h48H336L448 112zM48 96v24V464H360h24v48H360 24 0V488 120 96H48zm128 80h96v64H256 176V176zm0 160V272h64v64H176zm192 0H272V272h16 80v64zm0-160v64H304V176h64z'
      
    ]
  };

  

  
  

  var faCommentCode = {
    prefix: 'fasr',
    iconName: 'comment-code',
    icon: [
      512,
      512,
      [],
      'e147',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM217 193l17-17L200 142.1l-17 17-64 64-17 17 17 17 64 64 17 17L233.9 304l-17-17-47-47 47-47zM329 159l-17-17L278.1 176l17 17 47 47-47 47-17 17L312 337.9l17-17 64-64 17-17-17-17-64-64z'
      
    ]
  };

  

  
  

  var faHelmetSafety = {
    prefix: 'fasr',
    iconName: 'helmet-safety',
    icon: [
      576,
      512,
      ["hard-hat","hat-hard"],
      'f807',
      
      'M208 32V56 296v24h48V296 80h64V296v24h48V296 56 32H344 232 208zM0 384v24s80 72 288 72s288-72 288-72V384H0zm32-96v64H80V288c0-68.4 39-127.7 96-156.8V78.7C91.8 110.9 32 192.5 32 288zm464-2.2l0 66.2h48l0-64 0-2.4c-1-94.5-60.5-174.9-144-206.9v52.5c56.4 28.8 95.2 87.2 96 154.6z'
      
    ]
  };

  
    var faHardHat = faHelmetSafety;
  
    var faHatHard = faHelmetSafety;
  

  
  

  var faToiletPaper = {
    prefix: 'fasr',
    iconName: 'toilet-paper',
    icon: [
      640,
      512,
      [129531],
      'f71e',
      
      'M60 512H8l18.4-44.2c.5-1.3 1-2.5 1.5-3.8C60.2 379.7 64 280.5 64 192C64 86 107 0 160 0H492.2l0 .1c1.3-.1 2.6-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-13.9 13.2-33.5 24.5-58 24.5c-16.3 0-30.5-5-42.2-12.3c2.9-20.1 5-40.2 6.5-60.2C470.5 327 482.8 336 496 336c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 48.8-1.1 100.8-6.9 152.2l-.1 .5c-5.9 51.2-16.5 101.7-35.4 147.5L381.3 512H60zM160 48c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26C121.7 104.5 112 144.8 112 192c0 83-3 182.7-33.1 272H349.1C379.6 383.6 384 285.9 384 192c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48H160zM520 192c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48zm-344 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faKaaba = {
    prefix: 'fasr',
    iconName: 'kaaba',
    icon: [
      576,
      512,
      [128331],
      'f66b',
      
      'M288 224l240-80v47.1l-240 80-240-80V144l240 80zm-240 .9l234.9 78.3 5.1 1.7 5.1-1.7L528 224.9v38.3l-16 5.3v33.7l16-5.3v84.5l-240 80-240-80V296.9l16 5.3V268.5l-16-5.3V224.9zm240-51.5L103.8 112 288 50.6 472.2 112 288 173.4zM576 416V128 96l-12-4-15.9-5.3L288 0 27.9 86.7 12 92 0 96v32V416l288 96 288-96zM96 279.1v33.7l96 32V311.1l-96-32zm186.9 96l5.1 1.7 5.1-1.7L352 355.5V321.8l-64 21.3-64-21.3v33.7l58.9 19.6zM384 344.9l96-32V279.1l-96 32v33.7z'
      
    ]
  };

  

  
  

  var faSquareList = {
    prefix: 'fasr',
    iconName: 'square-list',
    icon: [
      448,
      512,
      [],
      'e489',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104-24h24 96 24v48H320 224 200V136zm0 96h24 96 24v48H320 224 200V232zm0 96h24 96 24v48H320 224 200V328zm-72-40a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faLocationPin = {
    prefix: 'fasr',
    iconName: 'location-pin',
    icon: [
      384,
      512,
      ["map-marker"],
      'f041',
      
      'M311.3 267.4c-16.4 32.2-38.8 66.4-62.1 98.3c-20.3 27.9-40.7 53.3-57.2 73.1c-16.5-19.8-36.9-45.2-57.2-73.1c-23.2-31.9-45.6-66.2-62.1-98.3C55.7 234 48 208.3 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 16.3-7.7 42-24.7 75.4zM223.8 475.6C278.4 411 384 275.1 384 192C384 86 298 0 192 0S0 86 0 192c0 83.1 105.6 219 160.2 283.6C179.2 498.1 192 512 192 512s12.8-13.9 31.8-36.4z'
      
    ]
  };

  
    var faMapMarker = faLocationPin;
  

  
  

  var faTelescope = {
    prefix: 'fasr',
    iconName: 'telescope',
    icon: [
      576,
      512,
      [128301],
      'e03e',
      
      'M458.5 232.4l-80-138.6 48.9-28.2 80 138.6-48.9 28.2zM573 221.7l-24-41.6L469 41.6 445 0 403.4 24 354.5 52.2l-41.6 24 14 24.2L36.7 284.9l19.2 33.3L0 350.5l49.9 86.4 55.9-32.3 16.3 28.2 116-62.7L180.3 512h51.8l53.1-130.2c6 1.5 12.3 2.2 18.8 2.2s12.8-.8 18.8-2.2L375.9 512h51.8L364.3 356.5C376.6 342.5 384 324.1 384 304c0-4.2-.3-8.2-.9-12.2l41.4-22.4 16.5 28.5 41.6-24 48.9-28.2 41.6-24zM140.4 368.4l-39.1-67.7L350.9 142.1l49.5 85.7-38.6 20.9C347.2 233.5 326.7 224 304 224c-44.2 0-80 35.8-80 80c0 6.2 .7 12.3 2.1 18.1l-85.7 46.3zM304 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faObjectExclude = {
    prefix: 'fasr',
    iconName: 'object-exclude',
    icon: [
      512,
      512,
      [],
      'e49c',
      
      'M48 48H304v80h48V48 0H304 48 0V48 304v48H48h80V304H48V48zM160 384v80 48h48H464h48V464 208 160H464 384v48h80V464H208V384H160zm96-32h48 48V304 288H304v16H256v48zm96-144V160H304 288v48h16v48h48V208zM224 352l0-48H208V256H160v48 48h48 16zM160 208v16l48 0V208h48V160H208 160v48z'
      
    ]
  };

  

  
  

  var faPoop = {
    prefix: 'fasr',
    iconName: 'poop',
    icon: [
      512,
      512,
      [],
      'f619',
      
      'M187.2 0H232c71.6 0 131.6 49.5 147.7 116.1C410.8 133 432 166 432 204c0 2-.1 4.1-.2 6.1C465.1 226.3 488 260.5 488 300c0 12.2-2.2 23.9-6.2 34.7C500.4 353.5 512 379.4 512 408v80 24H488 24 0V488 408c0-28.6 11.6-54.5 30.2-73.3c-4-10.8-6.2-22.5-6.2-34.7c0-39.5 22.9-73.7 56.2-89.9c-.1-2-.2-4-.2-6.1c0-48.1 33.9-88.2 79.1-97.8c5.7-1.4 11.7-2.2 17.8-2.2H180h14.7c16.2 0 29.3-13.1 29.3-29.3V66.6c0-7.4-2.2-14.6-6.3-20.7L232 36.3l-14.3 9.5L212 37.3 187.2 0zm84.1 55.7c.5 3.6 .7 7.2 .7 10.9v8.1c0 42.7-34.6 77.3-77.3 77.3H180h-3.1c-2.2 0-4.3 .3-6.3 .8l-.6 .2-.6 .1C145.8 158 128 178.9 128 204c0 5.2 .8 10.3 2.2 15l7.4 24.6-25.1 5.7C89.3 254.5 72 275.3 72 300c0 10.4 3 20 8.2 28.1l12.9 20L73.3 361.2C58 371.2 48 388.5 48 408v56H464V408c0-19.5-10-36.8-25.3-46.8l-19.9-13.1 12.9-20C437 320 440 310.4 440 300c0-24.7-17.3-45.5-40.5-50.7l-25.1-5.7 7.4-24.6c1.4-4.7 2.2-9.7 2.2-15c0-22.3-14-41.4-33.8-48.7l-13.2-4.9-2.1-14c-5.5-36.7-30.2-67.1-63.5-80.7z'
      
    ]
  };

  

  
  

  var faHandPointRibbon = {
    prefix: 'fasr',
    iconName: 'hand-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a6',
      
      'M48 0H72h80 24V24 80h16v64h40 24v24 8h56 24v16h56 24v24 40 88 0l0 .1C415.9 436.9 340.7 512 248 512H200c-92.8 0-168-75.2-168-168v0V320v0V264 240H48V176H0l43.6-48L0 80H48V24 0zM96 176v64h32V176H96zm32-96V48H96V80h32zM368 240H336v96h32V256 240zM312 384H288V368H256 232 208 152 128V320h24 56V288H152 80v32 0 24 0c0 66.3 53.7 120 120 120h48c52.2 0 96.7-33.4 113.2-80H312zM176 192v48h32V200v-8H176zm112 32H256v40 56h32V224z'
      
    ]
  };

  

  
  

  var faAlien8bit = {
    prefix: 'fasr',
    iconName: 'alien-8bit',
    icon: [
      640,
      512,
      [128126,"alien-monster"],
      'f8f6',
      
      'M176 32V56h24 24V80v48H416V80 56h24 24V32h48V56 80v24H488 464v48 8h24 24v24 56h8 40V152 128h48v24V264v24H584 544v72 24H520 480v72 24H456 376 352V432h24 56V384H208v48h56 24v48H264 184 160V456 384H120 96V360 288H56 32V264 152 128H80v24 88h40 8V184 160h24 24v-8V104H152 128V80 56 32h48zm48 144v8 24H200 176v56 24H152h-8v48h40H456h40V288h-8H464V264 208H440 416V184v-8H224zm0 48h64v80H224V224zm192 0v80H352V224h64z'
      
    ]
  };

  
    var faAlienMonster = faAlien8bit;
  

  
  

  var faCircleArrowDownRight = {
    prefix: 'fasr',
    iconName: 'circle-arrow-down-right',
    icon: [
      512,
      512,
      [],
      'e0fa',
      
      'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm88 368h24V344 184 160H320v24V286.1L185 151l-17-17L134.1 168l17 17 135 135H192 168v48h24H344z'
      
    ]
  };

  

  
  

  var faFaceDisguise = {
    prefix: 'fasr',
    iconName: 'face-disguise',
    icon: [
      512,
      512,
      [],
      'e370',
      
      'M464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-16.5 1.9-32.6 5.6-48H72c0 49.4 37.4 90.1 85.4 95.4l-4.5 2.3-8.8 4.4V320v32 9.9l8.8 4.4 14.3 7.1L147.5 398l-10 12.5 25 20 10-12.5 23.9-29.9 7.3 3.6-10.5 26.3-5.9 14.9 29.7 11.9 5.9-14.9 9.5-23.9 7.6 3.8V432v16h32V432 409.9l7.6-3.8 9.5 23.9 5.9 14.9 29.7-11.9-5.9-14.9-10.5-26.3 7.3-3.6L339.5 418l10 12.5 25-20-10-12.5-19.6-24.5 14.3-7.1 8.8-4.4V352 320v-9.9l-8.8-4.4-4.5-2.3c48-5.3 85.4-46 85.4-95.4h18.4c3.6 15.4 5.6 31.5 5.6 48zM230.7 220.8l-29.6 42.3-.2-.4c-2.9 1.8-5.4 3.2-6.8 3.8c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 4.4-.4 8.7-1.3 12.8zM280 208c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-1.4-.6-3.9-2-6.8-3.8l-.2 .4-29.6-42.3c-.8-4.1-1.3-8.4-1.3-12.8zm219.3-32C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176H0v32H4.5C1.5 223.5 0 239.6 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-16.4-1.5-32.5-4.5-48H512V176H499.3zM63.9 176c6.2-14.8 14-28.7 23.2-41.5l5.6 13.9C86.2 156.6 81 165.9 77.5 176H63.9zm384.1 0H434.5c-3.6-10.1-8.8-19.4-15.3-27.6l5.6-13.9c9.2 12.8 17 26.7 23.2 41.5zM132.6 118.8l-6.3-15.7-2.9-7.3C159.4 65.9 205.6 48 256 48s96.6 17.9 132.6 47.8l-2.9 7.3-6.3 15.7c-1.1-.5-2.3-.9-3.4-1.3V112 88H328v24 1.3c-1.4 .2-2.8 .5-4.1 .8l-9.2-18.3-42.9 21.5 9.2 18.3c-10.6 9.3-19.2 20.9-25 34c-5.7-13.1-14.3-24.7-25-34l9.2-18.3L197.3 95.8l-9.2 18.3c-1.4-.3-2.7-.6-4.1-.8V112 88H136v24 5.5c-1.2 .4-2.3 .8-3.4 1.3zM256 240.5l50.9 72.7 2.3 3.3 3.6 1.8L336 329.9v12.2l-80 40-80-40V329.9l23.2-11.6 3.6-1.8 2.3-3.3L256 240.5zm-88-.5a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faObjectUngroup = {
    prefix: 'fasr',
    iconName: 'object-ungroup',
    icon: [
      640,
      512,
      [],
      'f248',
      
      'M48 48V80H80V48H48zM0 0H48 80h48V40H320V0h48 32 48V48 80v48H408v96h40v48 32 48H400 368 320V312H128v40H80 48 0V304 272 224H40V128H0V80 48 0zM88 128v96h40v40H320V224h40V128H320V88H128v40H88zM80 272H48v32H80V272zM400 48H368V80h32V48zM368 272v32h32V272H368zM592 432H560v32h32V432zm-40-48V288H512V248H480V200h32V160h48 32 48v48 32 48H600v96h40v48 32 48H592 560 512V472H320v40H272 240 192V464 432 384h40V352h48v32h40v40H512V384h40zm8-176v32h32V208H560zM272 432H240v32h32V432z'
      
    ]
  };

  

  
  

  var faFaceGrinBeam = {
    prefix: 'fasr',
    iconName: 'face-grin-beam',
    icon: [
      512,
      512,
      [128516,"grin-beam"],
      'f582',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z'
      
    ]
  };

  
    var faGrinBeam = faFaceGrinBeam;
  

  
  

  var faBuildingFlag = {
    prefix: 'fasr',
    iconName: 'building-flag',
    icon: [
      640,
      512,
      [],
      'e4d5',
      
      'M48 48V464h96V352h96V464h96V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM88 88h80v80H88V88zm208 0v80H216V88h80zM88 216h80v80H88V216zm208 0v80H216V216h80zM480 0V32H640V192H480V512H416V32 0h64z'
      
    ]
  };

  

  
  

  var faCircleQ = {
    prefix: 'fasr',
    iconName: 'circle-q',
    icon: [
      512,
      512,
      [],
      'e11e',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-336c44.2 0 80 35.8 80 80c0 12.7-3 24.7-8.2 35.3L299.5 256H238.1l56.2 70.3c-11.4 6.2-24.4 9.7-38.3 9.7c-44.2 0-80-35.8-80-80s35.8-80 80-80zm0 208c25.2 0 48.7-7.3 68.6-19.9L340.5 384h61.5l-42.3-52.9C375 310 384 284.1 384 256c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faFishFins = {
    prefix: 'fasr',
    iconName: 'fish-fins',
    icon: [
      576,
      512,
      [],
      'e4f2',
      
      'M272 32l73.4 64.2C499.1 102.2 576 256 576 256s-76.9 153.8-230.6 159.8L272 480l-48-32V387.4c-27.5-14.8-50.5-33.7-69.1-52.5L32 384 0 352l48-96L0 160l32-32 118.7 53.4c19.3-20.2 43.7-40.8 73.3-56.8V64l48-32zM484.3 300.3c15.7-16 27.7-31.9 36.1-44.3c-8.3-12.3-20.4-28.3-36.1-44.3c-33.6-34.2-80.4-65.5-140.8-67.9l-16.8-.7L314 132.1l-42.3-37v29.6 28.5l-25 13.5c-24.2 13-44.7 30.3-61.5 47.8l-23.3 24.3-30.7-13.8L72.6 198.5l18.1 36.1L101.3 256 90.6 277.3 70.7 317.2l66.4-26.6 29.3-11.7 22.2 22.5c16.1 16.3 35.5 32 57.9 44.1l25 13.5v28.5 29.6l42.3-37 12.7-11.1 16.8-.7c60.4-2.4 107.3-33.7 140.8-67.9zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm117.4 10.6l0 0 0 0c0 0 0 0 0 .1zm0 42.8c0 .1 0 .1 0 .1l0 0 0 0z'
      
    ]
  };

  

  
  

  var faFileContract = {
    prefix: 'fasr',
    iconName: 'file-contract',
    icon: [
      384,
      512,
      [],
      'f56c',
      
      'M48 48H224V160H336V464H48V48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM96 96H80v32H96h80 16V96H176 96zm0 64H80v32H96h80 16V160H176 96zm56 144H140.1l-3.4 11.4L116.1 384H96 80v32H96h32 11.9l3.4-11.4L160 349l16.7 55.6 3.4 11.4H192h8 9.9l4.4-8.8L225.9 384h4.2l11.6 23.2 4.4 8.8H256h32 16V384H288 265.9l-11.6-23.2-4.4-8.8H240 216h-9.9l-4.4 8.8-3 5.9-15.4-51.4L179.9 304H168 152z'
      
    ]
  };

  

  
  

  var faFileExcel = {
    prefix: 'fasr',
    iconName: 'file-excel',
    icon: [
      384,
      512,
      [],
      'f1c3',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM97.9 224L163 320 97.9 416h58L192 362.7 228.1 416h58L221 320l65.1-96h-58L192 277.3 155.9 224h-58z'
      
    ]
  };

  

  
  

  var faFileXls = {
    prefix: 'fasr',
    iconName: 'file-xls',
    icon: [
      512,
      512,
      [],
      'e64d',
      
      'M48 464h80v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zm176-96c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4V352h32v16c0 13.6-4 26.9-11.6 38.2L259.2 432l17.2 25.8C284 469.1 288 482.4 288 496v16H256V496c0-7.3-2.2-14.4-6.2-20.4L240 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4v16H192V496c0-13.6 4-26.9 11.6-38.2L220.8 432l-17.2-25.8C196 394.9 192 381.6 192 368V352h32v16zm96 144V496 368 352h32v16V480h24 16v32H376 336 320zm88-114.3c0-25.2 20.4-45.7 45.7-45.7H480h16v32H480 453.7c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7H432 416V480h16 26.3c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7z'
      
    ]
  };

  

  
  

  var faSackXmark = {
    prefix: 'fasr',
    iconName: 'sack-xmark',
    icon: [
      512,
      512,
      [],
      'e56a',
      
      'M382.9 48L360.2 80.9 333 120.4c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416v48 48H464 48 0V464 416C0 274.8 89.4 185.5 150.8 139.9c10.4-7.7 20-14.2 28.2-19.4L151.8 80.9 129.1 48 96 0h58.3H357.7 416L382.9 48zM464 416c0-139-102.9-220.6-156.9-255.2L293.3 152H218.7l-13.8 8.8C150.9 195.4 48 277 48 416v48H464V416zM286 104l7.5-10.8L324.6 48H187.4l31.1 45.2L226 104h60zM209 239l47 47 47-47 17-17L353.9 256l-17 17-47 47 47 47 17 17L320 417.9l-17-17-47-47-47 47-17 17L158.1 384l17-17 47-47-47-47-17-17L192 222.1l17 17z'
      
    ]
  };

  

  
  

  var faClockEight = {
    prefix: 'fasr',
    iconName: 'clock-eight',
    icon: [
      512,
      512,
      [],
      'e345',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V256v12.8L269.3 276l-96 64-20 13.3-26.6-39.9 20-13.3L232 243.2V120 96h48v24z'
      
    ]
  };

  

  
  

  var faBoltLightning = {
    prefix: 'fasr',
    iconName: 'bolt-lightning',
    icon: [
      384,
      512,
      [],
      'e0b7',
      
      'M234.7 96l10.7-48L256 0H206.8 32L5.3 240 0 288H48.3h78.6H176l-10.3 48-16.3 76L128 512l65.8-78.2L384 208V192 144H336 273.2 224l10.7-48zm100.1 96L215.3 333.9l7.7-35.8L235.4 240H176 53.6L75 48H196.2l-19 85.6-13 58.4H224 334.7z'
      
    ]
  };

  

  
  

  var faChartPie = {
    prefix: 'fasr',
    iconName: 'chart-pie',
    icon: [
      576,
      512,
      ["pie-chart"],
      'f200',
      
      'M541.7 192c.8 5.3 1.3 10.6 1.7 16c.4 5.3 .6 10.6 .6 16s-.2 10.7-.6 16H352 304V192 .6c5.3-.4 10.6-.6 16-.6s10.7 .2 16 .6c5.4 .4 10.7 1 16 1.7c98.1 14 175.7 91.6 189.7 189.7zM352 50.9V192H493.1C480 120.5 423.5 64 352 50.9zm-144 257V288 90.9C133.4 117.3 80 188.4 80 272c0 106 86 192 192 192c27.2 0 53-5.6 76.4-15.8L222.1 321.9 208 307.9zM390.8 422.8L425 457c-12.5 10.4-26.2 19.5-40.7 27.2C350.8 501.9 312.6 512 272 512C139.5 512 32 404.6 32 272C32 161.6 106.5 68.6 208 40.6c15.4-4.3 31.5-7 48-8.1V80.7 288L390.8 422.8zM320 288H575.5C571 355.9 538.3 416.1 489 457L320 288z'
      
    ]
  };

  
    var faPieChart = faChartPie;
  

  
  

  var faPersonCirclePlus = {
    prefix: 'fasr',
    iconName: 'person-circle-plus',
    icon: [
      576,
      512,
      [],
      'e541',
      
      'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM94.8 128h14.1H211.1h14.1l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6L224 224.9V488v24H176V488 352H144V488v24H96V488 224.9L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128zM144 304h32V176H144V304zm288-80a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  

  
  

  var faTaxi = {
    prefix: 'fasr',
    iconName: 'taxi',
    icon: [
      512,
      512,
      [128662,"cab"],
      'f1ba',
      
      'M352 0H160V64H120 102.7L97.2 80.4 54.7 208H48 0v48V384v48 80H48V432H464v80h48V432 384 256 208H464h-6.7L414.8 80.4 409.3 64H392 352V0zm22.7 112l32 96H105.3l32-96H374.7zM48 256H464V384H48V256zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faCab = faTaxi;
  

  
  

  var faRoad = {
    prefix: 'fasr',
    iconName: 'road',
    icon: [
      576,
      512,
      [128739],
      'f018',
      
      'M63.6 432H264V408 384h48v24 24H512.4L411.8 80H312v24 24H264V104 80H164.2L63.6 432zM312 32H448L562.3 432 576 480H526.1 49.9 0l13.7-48L128 32H264h48zm0 184v80 24H264V296 216 192h48v24z'
      
    ]
  };

  

  
  

  var faBedBunk = {
    prefix: 'fasr',
    iconName: 'bed-bunk',
    icon: [
      576,
      512,
      [],
      'f8f8',
      
      'M48 0V24 160H256V24 0h24H456c66.3 0 120 53.7 120 120v64 96V439.7 488v24H528V488 463.7H280 48V488v24H0V488 439.7 184 24 0H48zM256 415.7V280 256h24H528V208H280 48V415.7H256zM528 160V120c0-39.8-32.2-72-72-72H304V160H528zm0 144H304V415.7H528V304zM96 328a56 56 0 1 1 112 0A56 56 0 1 1 96 328zM152 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112z'
      
    ]
  };

  

  
  

  var faLeaf = {
    prefix: 'fasr',
    iconName: 'leaf',
    icon: [
      512,
      512,
      [],
      'f06c',
      
      'M272 144c-57.6 0-106.3 38.1-122.4 90.4c20.9-6.7 43.2-10.4 66.4-10.4H320v48H216c-25.4 0-49.5 5.6-71 15.7C152.7 351 206.6 400 271.9 400h.1l.8 0 .1 0C370.2 399.5 464 299.7 464 156.6c0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144H320v0H272zM96.4 260.1C102.5 168.5 178.8 96 272 96l48 0h56c28.7 0 54.8-10.8 74.6-28.5c14.9-13.3 26.2-30.5 32.3-50.1c8.8 19.7 15.9 40.8 20.8 63c5.4 24.3 8.3 49.8 8.3 76.2C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440v16 24H0V456 440c0-75.1 38.3-141.2 96.4-179.9z'
      
    ]
  };

  

  
  

  var faF = {
    prefix: 'fasr',
    iconName: 'f',
    icon: [
      320,
      512,
      [102],
      '46',
      
      'M24 32H0V56 248 456v24H48V456 272H232h24V224H232 48V80H296h24V32H296 24z'
      
    ]
  };

  

  
  

  var faCloudPlus = {
    prefix: 'fasr',
    iconName: 'cloud-plus',
    icon: [
      640,
      512,
      [],
      'e35e',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM296 400V376 312H232 208V264h24 64V200 176h48v24 64h64 24v48H408 344v64 24H296z'
      
    ]
  };

  

  
  

  var faAustralSign = {
    prefix: 'fasr',
    iconName: 'austral-sign',
    icon: [
      448,
      512,
      [],
      'e0a9',
      
      'M199.7 32H216h16 16.3l6 15.2L324.4 224H424h24v48H424 343.4l19 48H424h24v48H424 381.4l40.9 103.2 3.5 8.8H374.2L329.8 368H118.2L73.8 480H22.2l3.5-8.8L66.6 368H24 0V320H24 85.6l19-48H24 0V224H24h99.6L193.7 47.2l6-15.2zM224 101L175.2 224h97.5L224 101zM137.2 320H310.8l-19-48H156.2l-19 48z'
      
    ]
  };

  

  
  

  var faChessKnightPiece = {
    prefix: 'fasr',
    iconName: 'chess-knight-piece',
    icon: [
      320,
      512,
      ["chess-knight-alt"],
      'f442',
      
      'M53.9 112l94.8 0C216.8 112 272 167.2 272 235.3c0 11.3-1.6 22.5-4.6 33.4L244 352h49.9l19.8-70.3c4.3-15.1 6.4-30.7 6.4-46.4C320 140.7 243.3 64 148.7 64L24.4 64 .4 64V88v26.7 9l5.9 6.8 3.9 4.4-2.8 2.8-7 7 0 9.9L0 255.6 0 265 6.4 272l25.5 27.5 .1 12.7 .3 39.8h48l-.2-25.7 91.3-49.1 21.1-11.4-22.8-42.3-21.1 11.4L74.5 274.8 48.1 246.3l.3-81.6L60 153l15.9-15.9L61.1 120.2 53.9 112zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM69.2 432H250.8l16.6 32H52.7l16.6-32zM320 464v-2.7L280 384H40L0 461.3V464v48H48 272h48V464z'
      
    ]
  };

  
    var faChessKnightAlt = faChessKnightPiece;
  

  
  

  var faPie = {
    prefix: 'fasr',
    iconName: 'pie',
    icon: [
      576,
      512,
      [129383],
      'f705',
      
      'M544 240H531.3C497.7 137.8 401.4 64 288 64S78.3 137.8 44.7 240H32 0v64H32h9.2l63.9-30.4 6-2.9 6.3 2.3L200 303l82.5-30 5.5-2 5.5 2L376 303l82.5-30 6.3-2.3 6.1 2.9L534.8 304H544h32V240H544zM96 448H480l38.7-116.2L475.1 311l-29.7 89H130.6l-29.7-89L57.3 331.8 96 448zM206.3 151.2l-16 32-7.2 14.3-28.6-14.3 7.2-14.3 16-32 7.2-14.3 28.6 14.3-7.2 14.3zm192-14.3l16 32 7.2 14.3-28.6 14.3-7.2-14.3-16-32-7.2-14.3 28.6-14.3 7.2 14.3zM304 144v32 16H272V176 144 128h32v16z'
      
    ]
  };

  

  
  

  var faSquareEllipsis = {
    prefix: 'fasr',
    iconName: 'square-ellipsis',
    icon: [
      448,
      512,
      [],
      'e26e',
      
      'M48 432l352 0 0-352L48 80l0 352zM0 480l0-48L0 80 0 32l48 0 352 0 48 0 0 48 0 352 0 48-48 0L48 480 0 480zM160 224l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z'
      
    ]
  };

  

  
  

  var faVirusCovid = {
    prefix: 'fasr',
    iconName: 'virus-covid',
    icon: [
      512,
      512,
      [],
      'e4a8',
      
      'M216 0H192V48h24 16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L125.9 92l11.3-11.3 17-17L120.2 29.7l-17 17L46.7 103.3l-17 17 33.9 33.9 17-17L92 125.9l23.8 23.8C97.9 173.2 85.8 201.3 81.6 232H48V216 192H0v24 80 24H48l0-24V280H81.6c4.2 30.7 16.3 58.8 34.1 82.3L92 386.1 80.6 374.8l-17-17L29.7 391.8l17 17 56.6 56.6 17 17 33.9-33.9-17-17L125.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H216 192v48h24 80 24V464H296 280V430.4c30.7-4.2 58.8-16.3 82.3-34.1L386.1 420l-11.3 11.3-17 17 33.9 33.9 17-17 56.6-56.6 17-17-33.9-33.9-17 17L420 386.1l-23.8-23.8c17.9-23.5 29.9-51.7 34.1-82.3H464v16 24h48V296 216 192H464v24 16H430.4c-4.2-30.7-16.3-58.8-34.1-82.3L420 125.9l11.3 11.3 17 17 33.9-33.9-17-17L408.7 46.7l-17-17L357.8 63.7l17 17L386.1 92l-23.8 23.8C338.8 97.9 310.7 85.8 280 81.6V48h16 24V0H296 216zm40 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faImagePolaroidUser = {
    prefix: 'fasr',
    iconName: 'image-polaroid-user',
    icon: [
      448,
      512,
      [],
      'e1b6',
      
      'M48 432V368H400v64H48zM322 320l-18-48H144l-18 48H48V80H400V320H322zm126 24V320 80 32H400 48 0V80 320v24 24 64 48H48 400h48V432 368 344zM288 176a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faWonSign = {
    prefix: 'fasr',
    iconName: 'won-sign',
    icon: [
      512,
      512,
      [8361,"krw","won"],
      'f159',
      
      'M68.2 240L11.5 32H61.2L118 240h67.1L228.6 50.6 232.9 32H252h8 19.1l4.3 18.6L326.9 240H394L450.8 32h49.8L443.8 240H488h24v48H488 430.7L383.2 462.3 378.3 480H360h-8H332.9l-4.3-18.6L288.7 288H223.3L183.4 461.4 179.1 480H160h-8H133.7l-4.8-17.7L81.3 288H24 0V240H24 68.2zm62.8 48l23.3 85.4L174 288h-43zm103.2-48h43.4L256 145.7 234.3 240zM338 288l19.7 85.4L380.9 288H338z'
      
    ]
  };

  
    var faKrw = faWonSign;
  
    var faWon = faWonSign;
  

  
  

  var faImagesUser = {
    prefix: 'fasr',
    iconName: 'images-user',
    icon: [
      576,
      512,
      [],
      'e1b9',
      
      'M528 80H144V336h88l24-64H416l24 64h88V80zM144 32H528h48V80 336v48H528 144 96V336 80 32h48zM48 96v24V432H456h24v48H456 24 0V456 120 96H48zm224 80a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCubesStacked = {
    prefix: 'fasr',
    iconName: 'cubes-stacked',
    icon: [
      448,
      512,
      [],
      'e4e6',
      
      'M272 80H240v32h32V80zM240 32h32 48V80v32 48H272 240 192V112 80 32h48zM120.5 240.5l16 27.7 27.7-16-16-27.7-27.7 16zM55 223l41.6-24 27.7-16 41.6-24 24 41.6 16 27.7 24 41.6-41.6 24-27.7 16-41.6 24L95 292.2 79 264.5 55 223zm281 17H304v32h32V240zm-80-48h48 32 48v48 32 48H336 304 256V272 240 192zM368 432h32V400H368v32zm-48-80h48 32 48v48 32 48H400 368 320V432 400 352zm-80 48H208v32h32V400zm-32-48h32 48v48 32 48H240 208 160V432 400 352h48zM48 400v32H80V400H48zM0 352H48 80h48v48 32 48H80 48 0V432 400 352z'
      
    ]
  };

  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fasr',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      'M328 0H304V48h24H430.1L207 271l-17 17L224 321.9l17-17 223-223V184v24h48V184 24 0H488 328zM24 32H0V56 488v24H24 456h24V488 312 288H432v24V464H48V80H200h24V32H200 24z'
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faMagnifyingGlassChart = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-chart',
    icon: [
      512,
      512,
      [],
      'e522',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM104 216v48 24h48V264l0-48V192H104l0 24zm80-96V264v24h48V264 120 96l-48 0v24zm80 64v80 24h48V264 184 160l-48 0v24z'
      
    ]
  };

  

  
  

  var faMobileNotch = {
    prefix: 'fasr',
    iconName: 'mobile-notch',
    icon: [
      384,
      512,
      ["mobile-iphone"],
      'e1ee',
      
      'M256 48V80H128V48H64V464H320V48H256zM16 0H64 320h48V48 464v48H320 64 16V464 48 0z'
      
    ]
  };

  
    var faMobileIphone = faMobileNotch;
  

  
  

  var faClothesHanger = {
    prefix: 'fasr',
    iconName: 'clothes-hanger',
    icon: [
      640,
      512,
      [],
      'e136',
      
      'M211.4 91.3C221 38.4 267 0 320.8 0C382.2 0 432 49.8 432 111.2v2.9c0 36.5-17.5 70.8-47 92.3l-23.2 16.9L629.4 404.1l10.6 7.1V424v64 24H616 24 0V488 424 411.3l10.6-7.1L306.2 204.3l50.6-36.8c17.1-12.4 27.2-32.3 27.2-53.5v-2.9C384 76.3 355.7 48 320.8 48c-30.6 0-56.7 21.8-62.2 51.9l-3 16.4-4.3 23.6-47.2-8.6 4.3-23.6 3-16.4zM320 253L48 436.7V464H592V436.7L320 253z'
      
    ]
  };

  

  
  

  var faBuildingCircleExclamation = {
    prefix: 'fasr',
    iconName: 'building-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4d3',
      
      'M48 48H336V294.6c11.1-24.3 27.7-45.5 48-62.3V48 0H336 48 0V48 464v48H48 336h48v-8.2c-20.3-16.8-36.9-38.1-48-62.3V464H240V352H144V464H48V48zM88 88v80h80V88H88zm208 0H216v80h80V88zM88 216v80h80V216H88zm208 0H216v80h80V216zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64H480V416h32v32zm0-176v16 80 16H480V368 288 272h32z'
      
    ]
  };

  

  
  

  var faMoonStars = {
    prefix: 'fasr',
    iconName: 'moon-stars',
    icon: [
      512,
      512,
      [],
      'f755',
      
      'M320 64l48 16L320 96l-16 48L288 96 240 80l48-16 16-48 16 48zM440 200l72 24-72 24-24 72-24-72-72-24 72-24 24-72 24 72zM192 128c21 0 41.2 3.4 60.2 9.6c-21.5 8.3-40.5 21.6-55.6 38.5C173.8 201.5 160 235.2 160 272c0 78 62 141.5 139.4 143.9c1.5 0 3.1 .1 4.6 .1c22 0 42.9-4.9 61.6-13.8c-11.1 23.4-26.8 44.1-45.8 61.1C285.8 493.6 241 512 192 512C86 512 0 426 0 320C0 219.2 77.6 136.6 176.3 128.6c5.2-.4 10.4-.6 15.7-.6zM48 320c0 79.5 64.5 144 144 144c18.3 0 35.8-3.4 51.8-9.6C167.3 429.1 112 357 112 272c0-29.4 6.6-57.3 18.4-82.2C81.7 212.9 48 262.5 48 320z'
      
    ]
  };

  

  
  

  var faWhiskeyGlass = {
    prefix: 'fasr',
    iconName: 'whiskey-glass',
    icon: [
      512,
      512,
      [129347,"glass-whiskey"],
      'f7a0',
      
      'M91.9 336H420.1l-13.7 96H105.6L91.9 336zM41 318.8L64 480H448l23-161.2c.6-2.1 1-4.4 1-6.8L505.1 80 512 32H463.5 48.5 0L6.9 80 40 312c0 2.3 .3 4.6 1 6.8zM85.1 288L55.3 80H456.7L426.9 288H85.1z'
      
    ]
  };

  
    var faGlassWhiskey = faWhiskeyGlass;
  

  
  

  var faCode = {
    prefix: 'fasr',
    iconName: 'code',
    icon: [
      640,
      512,
      [],
      'f121',
      
      'M376.5 1.8l-7.3 22.8-144 448-7.3 22.8 45.7 14.7 7.3-22.8 144-448 7.3-22.8L376.5 1.8zm61.6 135.3l17.5 16.4L564.9 256 455.6 358.5l-17.5 16.4 32.8 35 17.5-16.4 128-120L635.1 256l-18.7-17.5-128-120-17.5-16.4-32.8 35zm-269-35l-17.5 16.4-128 120L4.9 256l18.7 17.5 128 120 17.5 16.4 32.8-35-17.5-16.4L75.1 256 184.4 153.5l17.5-16.4-32.8-35z'
      
    ]
  };

  

  
  

  var faFileExclamation = {
    prefix: 'fasr',
    iconName: 'file-exclamation',
    icon: [
      384,
      512,
      [],
      'f31a',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM216 192H168v24V328v24h48V328 216 192zM168 384v48h48V384H168z'
      
    ]
  };

  

  
  

  var faStarHalfStroke = {
    prefix: 'fasr',
    iconName: 'star-half-stroke',
    icon: [
      576,
      512,
      ["star-half-alt"],
      'f5c0',
      
      'M315.2 51.4L374.6 164l125.4 21.7 57.3 9.9-40.5 41.7L428 328.5l18.1 125.9 8.3 57.6-52.2-25.7L288.1 430.2 173.9 486.3 121.7 512l8.3-57.6 18.1-125.9L59.4 237.3 18.9 195.6l57.3-9.9L201.6 164 260.9 51.4 288.1 0l27.1 51.4zm-27.1 51.4V376.7l21.2 10.4L394 428.8l-13.4-93.4L377.2 312l16.4-16.9 65.8-67.7-93-16.1-23.3-4-11-20.9-44.1-83.5z'
      
    ]
  };

  
    var faStarHalfAlt = faStarHalfStroke;
  

  
  

  var faMoneyCheck = {
    prefix: 'fasr',
    iconName: 'money-check',
    icon: [
      576,
      512,
      [],
      'f53c',
      
      'M48 112V400H528V112H48zM0 64H48 528h48v48V400v48H528 48 0V400 112 64zM288 208v48H96V208H288zm192 96v48H96V304H480zm0-144v96H352V160H480z'
      
    ]
  };

  

  
  

  var faPuzzlePiece = {
    prefix: 'fasr',
    iconName: 'puzzle-piece',
    icon: [
      512,
      512,
      [129513],
      'f12e',
      
      'M201.1 57.3C194.1 62.5 192 68 192 72c0 4.5 2.8 11.2 12.4 16.9l11.6 7v13.6V120v24H192 48v60.5c7.4-2.9 15.5-4.5 24-4.5c43.1 0 72 39.4 72 80s-28.9 80-72 80c-8.5 0-16.6-1.6-24-4.5V464H156.5c-2.9-7.4-4.5-15.5-4.5-24c0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24H368V320 296h24 10.5 13.6l7 11.6c5.8 9.6 12.4 12.4 16.9 12.4c4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9s-4-23.8-9.3-30.9s-10.7-9.1-14.7-9.1c-4.5 0-11.2 2.8-16.9 12.4l-7 11.6H402.5 392 368V240 144H272 248V120 109.5 95.9l11.6-7C269.2 83.2 272 76.5 272 72c0-4-2.1-9.5-9.1-14.7S245 48 232 48s-23.8 4-30.9 9.3zM172.3 18.9C188.5 6.8 209.6 0 232 0s43.5 6.8 59.7 18.9S320 49.5 320 72c0 8.6-1.8 16.7-4.9 24H392h24v24 76.9c7.3-3.1 15.4-4.9 24-4.9c22.5 0 41 12.2 53.1 28.3S512 257.6 512 280s-6.8 43.5-18.9 59.7S462.5 368 440 368c-8.6 0-16.7-1.8-24-4.9V488v24H392 272 248V488 473.6 462.7l8.2-7.2c5.4-4.7 7.8-10.3 7.8-15.5c0-9.9-10.7-24-32-24s-32 14.1-32 24c0 5.3 2.4 10.8 7.8 15.5l8.2 7.2v10.9V488v24H192 24 0V488 320 296H24 38.4 49.3l7.2 8.2c4.7 5.4 10.3 7.8 15.5 7.8c9.9 0 24-10.7 24-32s-14.1-32-24-32c-5.3 0-10.8 2.4-15.5 7.8L49.3 264H38.4 24 0V240 120 96H24 148.9c-3.1-7.3-4.9-15.4-4.9-24c0-22.5 12.2-41 28.3-53.1z'
      
    ]
  };

  

  
  

  var faTrainTrack = {
    prefix: 'fasr',
    iconName: 'train-track',
    icon: [
      576,
      512,
      [],
      'e453',
      
      'M392.9 32h-51l23 64H211.1l23-64h-51l-23 64H112 88v48h24 30.8L114 224H72 48v48H72 96.7L67.9 352H32 8v48H32 50.7L21.9 480h51l28.8-80H474.3l28.8 80h51l-28.8-80H544h24V352H544 508.1l-28.8-80H504h24V224H504 462l-28.8-80H464h24V96H464 415.9l-23-64zM382.2 144L411 224H165l28.8-80H382.2zm46.1 128l28.8 80H118.9l28.8-80H428.3z'
      
    ]
  };

  

  
  

  var faArrowUpSmallBig = {
    prefix: 'fasr',
    iconName: 'arrow-up-small-big',
    icon: [
      576,
      512,
      ["sort-size-up-alt"],
      'f88f',
      
      'M432 80v64H368V80h64zM368 32H320V80v64 48h48 64 48V144 80 32H432 368zM160 33.3l-17 17-96 96-17 17L64 197.1l17-17 55-55V456v24h48V456 125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM368 432V304H496V432H368zM320 256v48V432v48h48H496h48V432 304 256H496 368 320z'
      
    ]
  };

  
    var faSortSizeUpAlt = faArrowUpSmallBig;
  

  
  

  var faHandHoldingHeart = {
    prefix: 'fasr',
    iconName: 'hand-holding-heart',
    icon: [
      576,
      512,
      [],
      'f4be',
      
      'M167.2 135.1c-14.9-14.9-23.2-35-23.2-56V75.6C144 33.8 177.9-.1 219.6-.1c23 0 44.7 10.4 59.1 28.4L288 39.9l9.3-11.6C311.6 10.4 333.4-.1 356.4-.1C398.1-.1 432 33.8 432 75.6v3.6c0 21-8.3 41.1-23.2 56L384 159.9l-96 96-96-96-24.8-24.8zM160.7 304H168 384h24v24 46.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H424 24 0V464H24 416.6l91.7-62.8-15-24-80.4 51L407 432h-7H368 320 296 256 232V384h24 40 24 40V352H175.3l-90 60-6 4H72 24 0V368H24 64.7l90-60 6-4z'
      
    ]
  };

  

  
  

  var faHouseChimneyUser = {
    prefix: 'fasr',
    iconName: 'house-chimney-user',
    icon: [
      576,
      512,
      [],
      'e065',
      
      'M288 .5l15.5 13.2L464 149.9V88 64h48V88v96 6.6l55.5 47.1-31.1 36.6L512 253.5V488v24H488 88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zm0 63L112 212.8V464H464V212.8L288 63.5zm0 96.5a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM208 320H368l32 96H176l32-96z'
      
    ]
  };

  

  
  

  var faDryerHeat = {
    prefix: 'fasr',
    iconName: 'dryer-heat',
    icon: [
      448,
      512,
      ["dryer-alt"],
      'f862',
      
      'M48 48V464H400V48H48zM0 0H48 400h48V48 464v48H400 48 0V464 48 0zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM80 288a144 144 0 1 1 288 0A144 144 0 1 1 80 288zm120-70.6l-12.7-12.7-22.6 22.6L177.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7 22.6-22.6L190.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6zm80 0l-12.7-12.7-22.6 22.6L257.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7 22.6-22.6L270.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6z'
      
    ]
  };

  
    var faDryerAlt = faDryerHeat;
  

  
  

  var faUpDownLeftRight = {
    prefix: 'fasr',
    iconName: 'up-down-left-right',
    icon: [
      512,
      512,
      ["arrows-alt"],
      'f0b2',
      
      'M160 144V96l62.1-62.1L256 0l33.9 33.9L352 96v48l-48 0H280v88h88V208 160h48l62.1 62.1L512 256l-33.9 33.9L416 352H368V304 280H280v88h24 48v48l-62.1 62.1L256 512l-33.9-33.9L160 416V368h48 24V280H144v24 48H96L33.9 289.9 0 256l33.9-33.9L96 160h48v48 24h88V144H208 160zM284.1 96L256 67.9 227.9 96l56.2 0zM67.9 256L96 284.1V227.9L67.9 256zM284.1 416H227.9L256 444.1 284.1 416zm160-160L416 227.9v56.2L444.1 256z'
      
    ]
  };

  
    var faArrowsAlt = faUpDownLeftRight;
  

  
  

  var faToggleLargeOn = {
    prefix: 'fasr',
    iconName: 'toggle-large-on',
    icon: [
      576,
      512,
      [],
      'e5b1',
      
      'M576 64H0V448H576V64zm-48 48V400H240V112H528z'
      
    ]
  };

  

  
  

  var faFileSignature = {
    prefix: 'fasr',
    iconName: 'file-signature',
    icon: [
      576,
      512,
      [],
      'f573',
      
      'M336 435.3V464H48V48H224V160H336v84.4l48-48V128L256 0H48 0V48 464v48H48 336h48V464 427l-1.7 1.7L336 435.3zM152 304H140.1l-3.4 11.4L116.1 384H96 80v32H96h32 11.9l3.4-11.4L160 349l16.7 55.6 3.4 11.4H192h8 9.9l4.4-8.8L225.9 384h12.2l11.6 23.2 4.4 8.8H264h16 1.6H288l.1-.1L370.9 404 512.1 262.7l-71-71L299.9 333l-7.3 51h-11H280h-6.1l-11.6-23.2-4.4-8.8H248 216h-9.9l-4.4 8.8-3 5.9-15.4-51.4L179.9 304H168 152zM576 198.8l-71-71-41.3 41.3 71 71L576 198.8z'
      
    ]
  };

  

  
  

  var faQuestion = {
    prefix: 'fasr',
    iconName: 'question',
    icon: [
      320,
      512,
      [10067,10068,61736],
      '3f',
      
      'M144 80c-44.2 0-80 35.8-80 80v16H16V160C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v7.4c0 38.2-18.2 74.2-49 96.8l-71 52V328v24H136V328 304 291.8l9.8-7.2 80.8-59.2c18.5-13.6 29.4-35.1 29.4-58.1V160c0-44.2-35.8-80-80-80H144zm48 336v64H128V416h64z'
      
    ]
  };

  

  
  

  var faUserNurseHair = {
    prefix: 'fasr',
    iconName: 'user-nurse-hair',
    icon: [
      448,
      512,
      [],
      'e45d',
      
      'M96 48L224 0 352 48v80h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128v0V136c0-2.7 .1-5.4 .3-8H96V48zm48 128c0 44.2 35.8 80 80 80s80-35.8 80-80V160H256l-16-16-32 32H144zM208 40V64H184V96h24v24h32V96h24V64H240V40H208zM189 456.9L105.4 368H98.6l-32 96H195.7l-6.7-7.1zM381.4 464l-32-96h-6.8L259 456.9l-6.7 7.1H381.4zM321.9 320H384l48 144 16 48H397.4 50.6 0l16-48L64 320h62.1L191 389l33 35 33-35 64.9-69z'
      
    ]
  };

  

  
  

  var faClipboardPrescription = {
    prefix: 'fasr',
    iconName: 'clipboard-prescription',
    icon: [
      384,
      512,
      [],
      'f5e8',
      
      'M336 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H80 48 0v48V464v48H48 336h48V464 112 64H336zM80 112v48H192 304V112h32V464H48V112H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM104 204H84v20 80 64 20h40V368 324h35.7l52 52-25.9 25.9L171.7 416 200 444.3l14.1-14.1L240 404.3l25.9 25.9L280 444.3 308.3 416l-14.1-14.1L268.3 376l25.9-25.9L308.3 336 280 307.7l-14.1 14.1L240 347.7l-32.6-32.6C224.6 304.6 236 285.6 236 264c0-33.1-26.9-60-60-60H104zm72 80h-8H124V244h52c11 0 20 9 20 20s-9 20-20 20z'
      
    ]
  };

  

  
  

  var faCirclePhone = {
    prefix: 'fasr',
    iconName: 'circle-phone',
    icon: [
      512,
      512,
      ["phone-circle"],
      'e11b',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 128l-72 16 0 16c0 123.7 100.3 224 224 224h16l16-72-72-40-33.5 41.9c-34.2-18.1-62.3-46.2-80.4-80.4L240 200l-40-72z'
      
    ]
  };

  
    var faPhoneCircle = faCirclePhone;
  

  
  

  var faSquareG = {
    prefix: 'fasr',
    iconName: 'square-g',
    icon: [
      448,
      512,
      [],
      'e271',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM144 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H248 224V232h24 80 24v24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l-32 35.8C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fasr',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'f0b0',
      
      'M224 286.4V304v56.9l64 51.2V304 286.4L299.4 273 462.7 80H49.3L212.6 273 224 286.4zM0 80V32H48 464h48V80 96L336 304V450.5 512l-48-38.4L176 384V304L0 96V80z'
      
    ]
  };

  

  
  

  var faDownToLine = {
    prefix: 'fasr',
    iconName: 'down-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-bottom"],
      'f34a',
      
      'M224 160l0 48 48 0 28.1 0L192 316.1 83.9 208l28.1 0 48 0 0-48 0-80 64 0 0 80zm1.9 190.1L352 224l0-16 0-48-32 0-16 0-32 0 0-48 0-32 0-48-48 0-64 0-48 0 0 48 0 32 0 48-32 0-16 0-32 0 0 48 0 16L158.1 350.1 192 384l33.9-33.9zM24 432L0 432l0 48 24 0 336 0 24 0 0-48-24 0L24 432z'
      
    ]
  };

  
    var faArrowAltToBottom = faDownToLine;
  

  
  

  var faRouteHighway = {
    prefix: 'fasr',
    iconName: 'route-highway',
    icon: [
      448,
      512,
      [],
      'f61a',
      
      'M236.3 11.4L224 4l-12.3 7.4-8 4.8c-38.3 23-85.5 25.7-126.2 7.2L65.9 18.2 46 9.1l-10.9 19-32 56L-3.2 95.2l5.7 11.5 16.2 32.5c8.7 17.4 13.2 36.6 13.2 56c0 15.9-3 31.7-9 46.5L8.7 277.7C2.9 292 0 307.3 0 322.7c0 46.7 26.8 89.2 68.8 109.4l144.8 69.5 10.4 5 10.4-5 144.8-69.5c42.1-20.2 68.8-62.7 68.8-109.4c0-15.4-2.9-30.7-8.7-45.1L425 241.8c-5.9-14.8-9-30.6-9-46.5c0-19.5 4.5-38.6 13.2-56l16.2-32.5 5.7-11.5-6.4-11.2-32-56L402 9.1l-19.9 9.1-11.5 5.2c-40.7 18.5-87.9 15.8-126.2-7.2l-8-4.8zM80 192H368c0 1.1 0 2.2 0 3.2c0 22 4.2 43.9 12.4 64.4l14.4 35.9c3.5 8.7 5.2 17.9 5.2 27.2c0 28.2-16.2 53.9-41.6 66.1L224 453.4 89.6 388.9C64.2 376.7 48 351 48 322.7c0-9.3 1.8-18.6 5.2-27.2l14.4-35.9C75.8 239.1 80 217.3 80 195.2c0-1.1 0-2.2 0-3.2z'
      
    ]
  };

  

  
  

  var faMemoCircleCheck = {
    prefix: 'fasr',
    iconName: 'memo-circle-check',
    icon: [
      576,
      512,
      [],
      'e1d9',
      
      'M48 48H336V220.5c14.6-9.5 30.8-17 48-21.8V48 0H336 48 0V48 464v48H48 330.8c-18.3-12.9-34.1-29.2-46.3-48H48V48zM288 224H264 120 96v48h24H264h20.5c1.1-1.8 2.3-3.5 3.5-5.2V224zM120 128H96v48h24H264h24V128H264 120zm0 192H96v48h24 48 24V320H168 120zm456 48a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336z'
      
    ]
  };

  

  
  

  var faPodium = {
    prefix: 'fasr',
    iconName: 'podium',
    icon: [
      448,
      512,
      [],
      'f680',
      
      'M176 0H288c26.5 0 48 21.5 48 48s-21.5 48-48 48H176V72h-8c-22.1 0-40 17.9-40 40v32H424h24v48H424 24 0V144H24 80V112c0-48.6 39.4-88 88-88h8V0zM80 512L47.3 224H95.6l27.3 240H325.1l27.3-240h48.3L368 512H80z'
      
    ]
  };

  

  
  

  var faDagger = {
    prefix: 'fasr',
    iconName: 'dagger',
    icon: [
      384,
      512,
      [],
      'f6cb',
      
      'M216 0V24 128h8 48 40 24 48v48c0 26.5-21.5 48-48 48s-48-21.5-48-48H272 224 192 160 112 96c0 26.5-21.5 48-48 48s-48-21.5-48-48V128H48 72h40 48 8V24 0h48zM160 398.6L192 437l32-38.4V208h48V416l-48.8 58.5L192 512l-31.2-37.5L112 416V208h48V398.6z'
      
    ]
  };

  

  
  

  var faFaceKissWinkHeart = {
    prefix: 'fasr',
    iconName: 'face-kiss-wink-heart',
    icon: [
      512,
      512,
      [128536,"kiss-wink-heart"],
      'f598',
      
      'M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c33.5 0 65.6-6.4 94.9-18.2l-1.5-5.9-10.5-41.1zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272l-3.9 15 0 0 0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0V359l0 0 0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 3.9 15c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm199.2-5.7l32.2-23.8c-36-48.7-108.2-48.7-144.2 0l32.2 23.8c20-27.1 59.8-27.1 79.8 0zm58.4 118c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l27 105.1 100.7-28.2c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z'
      
    ]
  };

  
    var faKissWinkHeart = faFaceKissWinkHeart;
  

  
  

  var faWheatAwnSlash = {
    prefix: 'fasr',
    iconName: 'wheat-awn-slash',
    icon: [
      640,
      512,
      [],
      'e338',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L440.1 318.9c19-3.2 37.2-12.1 51.8-26.8l10.2-10.2L536 248l-29.5-29.5c-1.5-1.5-3-2.9-4.5-4.3c-1.8-1.6-3.6-3.2-5.5-4.7L553 153l17-17L536 102.1l-17 17-64 64-3.1 3.1c-7.7-2.3-15.6-3.8-23.6-4.5L557.8 52.2l17-17L540.8 1.3l-17 17L394.4 147.7c-.8-8-2.3-15.9-4.5-23.6L393 121l64-64 17-17L440 6.1 423 23 366.5 79.5c-1.5-1.9-3.1-3.7-4.7-5.5c-1.1-1.2-2.3-2.5-3.5-3.7l-.9-.9L328 40 295.2 72.8l-.9 .9-.3 .3c-16.9 17.4-27 38.9-30.4 61.2L248 120l-29 27.2L48.4 14.8zM384.8 399.2L151.6 215.4l-13.2 12.4C92.2 271.1 91.1 344 135.8 388.7l8.7 8.7 0 0L82.2 459.8l-17 17 33.9 33.9 17-17 62.4-62.4 8.8 8.8c44.7 44.7 117.5 43.6 160.8-2.5L376 408l0 0 8.8-8.8zM169.8 354.7c-24.4-24.4-24.9-63.3-2.1-88.4c24.3 26.6 27.4 65.7 9.2 95.5l-7.1-7.1zm139.8 53.5c-25 22.9-64 22.3-88.4-2L214 399c29.9-18.2 69-15.1 95.6 9.3zm25-205.5l-5.5-5.5c-24.6-24.6-25-64.1-1.3-89.2c23 26.9 25.3 65.5 6.8 94.7zm133.3 45.4l-10 10c-18.7 18.7-49.1 18.7-67.9 0l-16.8-16.8c29.2-18.5 67.8-16.2 94.7 6.8z'
      
    ]
  };

  

  
  

  var faLanguage = {
    prefix: 'fasr',
    iconName: 'language',
    icon: [
      640,
      512,
      [],
      'f1ab',
      
      'M272 64H0V448H272h32 16H592h48V400 112 64H592 320 304 272zm320 48V400H320V112H592zM144.9 160h30.3l3.4 8.6 47.8 119.6c.1 .3 .2 .6 .3 .9l23.8 59.6 1.4 3.4H208.9l-14.4-36H125.5l-14.4 36H68.1l1.4-3.4L93.3 289c.1-.3 .2-.6 .4-.9l47.8-119.6 3.4-8.6zM160 229.9L141.5 276h36.9L160 229.9zM476 164H436v20 4H384 364v40h20 72 34l-21.6 51.7c-2.6-2.3-5.2-4.8-7.7-7.3l-14.6-14.6L432 243.7 403.7 272l14.1 14.1 14.4 14.4L409 309.3l-18.7 7 14 37.5 18.7-7 45.3-17c2.1 1.4 4.3 2.8 6.5 4.1l18.9 11.3 17.2 10.3 20.6-34.3-17.1-10.3-12.4-7.4L533.3 228H536h20V188H536 520 476v-4V164z'
      
    ]
  };

  

  
  

  var faBreadSlice = {
    prefix: 'fasr',
    iconName: 'bread-slice',
    icon: [
      512,
      512,
      [],
      'f7ec',
      
      'M112 208v48V432H400V256 208h48c8.8 0 16-7.2 16-16c0-34.5-24.6-62.3-74.9-83.9C340.2 87.2 282.8 80 256 80s-84.2 7.2-133.1 28.1C72.6 129.7 48 157.5 48 192c0 8.8 7.2 16 16 16h48zM448 432v48H400 112 64V432 304 256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64v48V432z'
      
    ]
  };

  

  
  

  var faVectorSquare = {
    prefix: 'fasr',
    iconName: 'vector-square',
    icon: [
      448,
      512,
      [],
      'f5cb',
      
      'M408 72v48H360V72h48zM360 32H320V72H128V32H88 40 0V72v48 40H40V352H0v40 48 40H40 88h40V440H320v40h40 48 40V440 392 352H408V160h40V120 72 32H408 360zM88 352V160h40V120H320v40h40V352H320v40H128V352H88zM40 392H88v48H40V392zm320 0h48v48H360V392zM40 72H88v48H40V72z'
      
    ]
  };

  

  
  

  var faMoneyCheckDollar = {
    prefix: 'fasr',
    iconName: 'money-check-dollar',
    icon: [
      576,
      512,
      ["money-check-alt"],
      'f53d',
      
      'M48 112V400H528V112H48zM0 64H48 528h48v48V400v48H528 48 0V400 112 64zM480 272v48H256V272H480zM256 176H480v48H256V176zm-76-16v6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2 0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6V352v20H140V352v-6.4c-9.5-2.2-22-6.4-29.9-9.1l0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1l0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1v-6V140h40v20z'
      
    ]
  };

  
    var faMoneyCheckAlt = faMoneyCheckDollar;
  

  
  

  var faDiceD4 = {
    prefix: 'fasr',
    iconName: 'dice-d4',
    icon: [
      512,
      512,
      [],
      'f6d0',
      
      'M225.3 38.4L30 282.5 0 320l38.4 28.8L232 494l24 18 24-18L473.6 348.8 512 320l-30-37.5L286.7 38.4 280 30 256 0 232 30l-6.7 8.4zm6.7 68.4V434L68.4 311.3 232 106.8zM280 434V106.8L443.6 311.3 280 434z'
      
    ]
  };

  

  
  

  var faPersonDressBurst = {
    prefix: 'fasr',
    iconName: 'person-dress-burst',
    icon: [
      640,
      512,
      [],
      'e544',
      
      'M222.7 79L203.9 47.1 176 0 148.1 47.1 129.3 79 92.6 73.8 38.4 66.3l19.4 51.2L71 152 44.1 177.5 4.4 215.2l52.1 16.7 35.2 11.3L95 280l4.7 54.6 45.6-30.3L176 283.7l30.8 20.5 45.6 30.3L257 280l3.2-36.9 35.2-11.3 18.1-5.8 15.9-28.2-21.6-20.4L281 152l13.1-34.6 19.4-51.2-54.2 7.6L222.7 79zM239.9 125l-3.8 10-11.4 29.9 23.2 22 7.7 7.3-10.1 3.3-30.4 9.8-2.7 31.9-.9 10.6-8.9-5.9L176 226l-26.6 17.7-8.9 5.9-.9-10.6-2.7-31.9-30.4-9.8-10.1-3.3 7.7-7.3 23.2-22L115.9 135l-3.8-10 10.6 1.5 31.7 4.4 16.3-27.5 5.4-9.2 5.4 9.2 16.3 27.5 31.7-4.4 10.6-1.5zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H414.8l-6.9 12.4-75.3 136-11.6 21 42 23.3 11.6-21L420 217.7 383 336l-15 48h48V488v24h48V488 384h32V488v24h48V488 384h48l-15-48L540 217.7l45.4 81.9 11.6 21 42-23.3-11.6-21-75.3-136L545.2 128H531.1 512 448 428.9zM480 186.5L526.7 336H433.3L480 186.5z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fasr',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M288 0H160V128h79.8L261 181.1c-34.9 21.3-60 57.1-67 98.9H128V240H0V368H128V328h66c11.4 68.1 70.7 120 142 120c43.8 0 83-19.5 109.4-50.4l66.6 40V512H640V384H516l-45.8-27.5c6.4-16.3 9.9-34 9.9-52.5c0-23.2-5.5-45.2-15.3-64.6L529.3 192H640V64H512v81.2l-75.7 55.5C410.4 175.5 375 160 336 160c-10.5 0-20.6 1.1-30.5 3.2L288 119.4V0zm48 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faWifiExclamation = {
    prefix: 'fasr',
    iconName: 'wifi-exclamation',
    icon: [
      640,
      512,
      [],
      'e2cf',
      
      'M344 56V32H296V56 312v24h48V312 56zM1.2 155.9l32.4 35.4C96.1 134 175.8 95.3 264 83.7V56 35.3C163.3 47.2 72.3 90.8 1.2 155.9zM119.4 286.4l32.5 35.3C183 293 221.4 272.2 264 262.3V213.3c-55.2 10.6-104.9 36.5-144.6 73.1zM376 213.3v49.1c42.6 9.8 81 30.6 112.1 59.3l32.5-35.3c-39.7-36.6-89.4-62.5-144.6-73.1zM264 424a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM376 56V83.7C464.2 95.3 543.9 134 606.3 191.3l32.4-35.4C567.7 90.8 476.7 47.2 376 35.3V56z'
      
    ]
  };

  

  
  

  var faKidneys = {
    prefix: 'fasr',
    iconName: 'kidneys',
    icon: [
      640,
      512,
      [],
      'f5fb',
      
      'M167.4 186.6l14-15.7 39.2-44.1c7.4-8.3 11.4-18.9 11.4-30c0-14.9-7.7-29.3-23.5-39.9c-6-4-21.8-9.5-44-8.9c-33.2 .9-61.1 20-82.8 54.7C59.7 138 48 184.2 48 224c0 28.9 6.4 59.7 19.3 81.5c11.6 19.6 26.8 30.5 51 30.5c35.1 0 60.9-30.8 58.4-55.7l-7.3-72.7-2.1-20.9zM118.3 384C29.8 384 0 293 0 224C0 128.4 55 3 163.2 0c28.9-.8 55.4 5.9 71.9 16.9C262.2 35 280 63.5 280 96.7c0 22.8-8.4 44.8-23.5 61.9l-31.2 35.1 65.5 32.8 13.3 6.6V248 488v24H256V488 262.8l-34.5-17.2 3 29.9C230.3 333.6 176.7 384 118.3 384zM418.5 245.6L384 262.8V488v24H336V488 248 233.2l13.3-6.6 65.5-32.8-31.2-35.1C368.4 141.6 360 119.6 360 96.7c0-33.3 17.8-61.7 44.9-79.8C421.5 5.9 448-.8 476.8 0C585 3 640 128.4 640 224c0 69-29.8 160-118.3 160c-58.4 0-112-50.4-106.2-108.5l3-29.9zm40.2-74.7l14 15.7-2.1 20.9-7.3 72.7c-2.5 25 23.3 55.7 58.4 55.7c24.2 0 39.4-10.9 51-30.5C585.6 283.7 592 252.9 592 224c0-39.8-11.7-86-33.7-121.3C536.6 68 508.7 48.9 475.5 48c-22.1-.6-38 4.9-44 8.9C415.7 67.5 408 81.9 408 96.7c0 11.1 4.1 21.7 11.4 30l39.2 44.1z'
      
    ]
  };

  

  
  

  var faFaceParty = {
    prefix: 'fasr',
    iconName: 'face-party',
    icon: [
      640,
      512,
      [],
      'e383',
      
      'M35 93.5C49.7 67.8 67.7 44.3 88.5 23.6l45.8 12.2C99.7 65.1 72.1 102.3 54.3 144.7L35 93.5zM20.9 55.6L0 0 53.3 14.2C41.5 27.2 30.7 41 20.9 55.6zM320 464c59 0 112.2-24.6 150.1-64h61.6C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176H528 512.1C480.7 100.8 406.5 48 320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208zM196.8 237.6l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0zm160 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0zM416 316c0 6.9-3.1 13.2-7.3 18.3c-.5 .6-1 1.1-1.5 1.7H608V240H544v32h32 16v32H576 528 512V288 224 208h16 96 16v16V352v16H624 407.2c.5 .6 1 1.1 1.5 1.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C378.7 427.1 361.4 432 344 432l-3.9-15 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0 0 0V345l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0 0 0 3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zm-32.8 36c.3 .1 .5 .2 .8 .3v-.7c-.3 .1-.5 .2-.8 .3z'
      
    ]
  };

  

  
  

  var faSparkle = {
    prefix: 'fasr',
    iconName: 'sparkle',
    icon: [
      448,
      512,
      [],
      'e5d6',
      
      'M298.7 330.7l95.7-47.8L448 256l-53.7-26.8-95.7-47.8L250.8 85.7 224 32 197.2 85.7l-47.8 95.7L53.7 229.2 0 256l53.7 26.8 95.7 47.8 47.8 95.7L224 480l26.8-53.7 47.8-95.7zm-74.7 42l-31.7-63.5-7.2-14.3-14.3-7.2L107.3 256l63.5-31.7 14.3-7.2 7.2-14.3L224 139.3l31.7 63.5 7.2 14.3 14.3 7.2L340.7 256l-63.5 31.7-14.3 7.2-7.2 14.3L224 372.7z'
      
    ]
  };

  

  
  

  var faChartWaterfall = {
    prefix: 'fasr',
    iconName: 'chart-waterfall',
    icon: [
      512,
      512,
      [],
      'e0eb',
      
      'M48 32V56 432H488h24v48H488 24 0V456 56 32H48zM192 224v24 80 24H144V328 248 224h48zm96-72v80 24H240V232 152 128h48v24zm96-88V88v80 24H336V168 88 64h48zm96 24V328v24H432V328 88 64h48V88z'
      
    ]
  };

  

  
  

  var faListOl = {
    prefix: 'fasr',
    iconName: 'list-ol',
    icon: [
      512,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      'M56 32H80h24V56 176h8 24v48H112h-8H56 48 24V176H48h8V80H32V32H56zM192 72h24H488h24v48H488 216 192V72zm0 160h24H488h24v48H488 216 192V232zm0 160h24H488h24v48H488 216 192V392zM8 352c0-35.3 28.7-64 64-64H89.2c34.7 0 62.8 28.1 62.8 62.8c0 17.7-7.5 34.6-20.5 46.5L93.4 432H128h24v48H128 32 8V456v-.6V444.8l7.8-7.1 83.3-75.9c3.1-2.8 4.8-6.8 4.8-11c0-8.2-6.6-14.8-14.8-14.8H72c-8.8 0-16 7.2-16 16H8z'
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faSort = {
    prefix: 'fasr',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      'M0 224H48 272h48V176L160 32 0 176v48zM160 96.6L248.2 176H71.8L160 96.6zM0 288v48L160 480 320 336V288H272 48 0zM160 415.4L71.8 336H248.2L160 415.4z'
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faLocust = {
    prefix: 'fasr',
    iconName: 'locust',
    icon: [
      576,
      512,
      [],
      'e520',
      
      'M312 32H288V80h24 48c84.6 0 154.7 62.6 166.3 144H434.6l-45.5-83.5-18-33.1-22.4 30.3-35 47.5-29.4-46.2L265 108.8l-20.6 29.4L184.2 224H80 32v48 67.2l54 24.7L4.5 480H63.1l67.2-95.8 28.7 13.1-51.2 78.1-3 4.6h57.4l41.9-64h71l-32.1 56.1-4.5 7.9h55.3l36.6-64H441.2l32 64h53.7l-1.4-2.7-31.2-62.3c46.2-6.9 81.6-46.6 81.7-94.7l0-.2V248c0-119.3-96.7-216-216-216H312zm-7.6 336l-1.3-.7-.4 .7H210.5l-52-23.8L209.1 272H311.9l.7 1.1 1.8-1.1h91.7l.3 .6 1-.6H528v48c0 26.5-21.5 48-48 48H304.4zM114 323.9L80 308.4V272h70.5L114 323.9zM242.8 224L263 195.2 281.4 224H242.8zm102 0L365 196.6l15 27.4H344.8zM496 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faFilterCircleXmark = {
    prefix: 'fasr',
    iconName: 'filter-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e17b',
      
      'M224 254.4V272v56.9l32.5 26c-.3 4.3-.5 8.7-.5 13.1c0 19.2 3.1 37.7 8.8 55L176 352V272L0 64V48 0H48 496h48V48 64L435.7 192c-1.2 0-2.4 0-3.7 0c-25.8 0-50.2 5.5-72.3 15.5L494.7 48H49.3L212.6 241 224 254.4zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faToiletPaperCheck = {
    prefix: 'fasr',
    iconName: 'toilet-paper-check',
    icon: [
      640,
      512,
      [],
      'e5b2',
      
      'M60 512H8l18.4-44.2c.5-1.3 1-2.5 1.5-3.8C60.2 379.7 64 280.5 64 192C64 86 107 0 160 0H492.2l0 .1c1.3-.1 2.6-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-13.9 13.2-33.5 24.5-58 24.5c-16.3 0-30.5-5-42.2-12.3c2.9-20.1 5-40.2 6.5-60.2C470.5 327 482.8 336 496 336c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 48.8-1.1 100.8-6.9 152.2l-.1 .5c-5.9 51.2-16.5 101.7-35.4 147.5L381.3 512H60zM160 48c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26C121.7 104.5 112 144.8 112 192c0 83-3 182.7-33.1 272H349.1C379.6 383.6 384 285.9 384 192c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48H160zM520 192c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48zm-204.7-4.7l-72 72L232 270.6l-11.3-11.3-40-40L169.4 208 192 185.4l11.3 11.3L232 225.4l60.7-60.7L304 153.4 326.6 176l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faCircleI = {
    prefix: 'fasr',
    iconName: 'circle-i',
    icon: [
      512,
      512,
      [],
      'e111',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H160v48h24 48V336H184 160v48h24 48 48 48 24V336H328 280V176h48 24V128H328 256 184z'
      
    ]
  };

  

  
  

  var faUserGroupCrown = {
    prefix: 'fasr',
    iconName: 'user-group-crown',
    icon: [
      640,
      512,
      ["users-crown"],
      'f6a5',
      
      'M96 0l48 24 16 8L224 0l64 32 16-8L352 0V53.7 144c0 70.7-57.3 128-128 128s-128-57.3-128-128V53.7 0zm48 144c0 44.2 35.8 80 80 80s80-35.8 80-80V128H144v16zM65 464H383L348.5 352H99.5L65 464zM64 304H384l49.2 160L448 512H397.8 50.2 0l14.8-48L64 304zM640 512H481.5l-2.9-9.4L422.4 320H576l64 192zM432 256c-27.7 0-53-10.1-72.6-26.7C375 204.6 384 175.4 384 144V53.7 42.8C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z'
      
    ]
  };

  
    var faUsersCrown = faUserGroupCrown;
  

  
  

  var faCircleArrowRight = {
    prefix: 'fasr',
    iconName: 'circle-arrow-right',
    icon: [
      512,
      512,
      ["arrow-circle-right"],
      'f0a9',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm377 17l17-17-17-17-88-88-17-17L238.1 168l17 17 47 47L152 232l-24 0 0 48 24 0 150.1 0-47 47-17 17L272 377.9l17-17 88-88z'
      
    ]
  };

  
    var faArrowCircleRight = faCircleArrowRight;
  

  
  

  var faBreadSliceButter = {
    prefix: 'fasr',
    iconName: 'bread-slice-butter',
    icon: [
      512,
      512,
      [],
      'e3e1',
      
      'M112 256V208H64c-8.8 0-16-7.2-16-16c0-34.5 24.6-62.3 74.9-83.9C171.8 87.2 229.2 80 256 80s84.2 7.2 133.1 28.1C439.4 129.7 464 157.5 464 192c0 8.8-7.2 16-16 16H400v48V432H112V256zM448 480V432 304 256c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v48V432v48h48H400h48zM256 376l88-88-88-88-88 88 88 88z'
      
    ]
  };

  

  
  

  var faMoonCloud = {
    prefix: 'fasr',
    iconName: 'moon-cloud',
    icon: [
      640,
      512,
      [],
      'f754',
      
      'M543.6 41.2c-20.2-6-41.5-9.2-63.6-9.2c-10.6 0-21 .7-31.1 2.1C345 48.6 263.9 134.3 256.5 240.3c17.4 1.4 33.6 7.1 47.5 16l0-.3c0-61.1 31.1-114.9 78.4-146.5c-19.6 34.8-30.7 74.9-30.7 117.7c0 86.2 45.4 161.9 113.6 204.2c-44.5-3.7-84.3-24-113.2-54.6v63c36.3 25.3 80.4 40.2 128 40.2c28.3 0 55.3-5.2 80.2-14.8c10.7-4.1 21.1-9 31-14.7c17.9-10.3 34.3-22.9 48.6-37.6c-15.5 4.1-31.8 6.2-48.6 6.2c-12.6 0-25-1.2-36.9-3.6c-88.1-17.3-154.6-95.1-154.6-188.4c0-58.9 26.4-111.6 68.1-146.8c4-3.4 8.1-6.6 12.3-9.6c18.9-13.6 40.4-23.7 63.6-29.7zM64 416H248h72V352h-.4c.3-2.6 .4-5.3 .4-8c0-39.8-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64v64H64z'
      
    ]
  };

  

  
  

  var faArrowTurnDownRight = {
    prefix: 'fasr',
    iconName: 'arrow-turn-down-right',
    icon: [
      512,
      512,
      [],
      'e3d6',
      
      'M48 56V32H0V56 288v24H24 418.9l-79 79-17 17 33.9 33.9 17-17 120-120 17-17-17-17-120-120-17-17L322.9 168l17 17 79 79H48V56z'
      
    ]
  };

  

  
  

  var faGuitarElectric = {
    prefix: 'fasr',
    iconName: 'guitar-electric',
    icon: [
      512,
      512,
      [127928],
      'f8be',
      
      'M352 126.1V64L448 0l39.2 31.4c21.7 17.4 23.5 49.8 3.8 69.5c-14.5 14.5-36.6 17.7-54.5 8.5L308.2 237.8c13.5 9.4 24.9 10.7 32.7 10.3c5.5-.3 10-1.6 13-2.8c1.5-.6 2.6-1.1 3.2-1.4l.4-.2 16-10.1L387 247.2l15.8 15.8 17 17-17 17-28.8 28.8c-12.3 12.3-27.1 19.6-38.2 25.1l-1.2 .6c-12.4 6.2-20.6 10.5-26.9 16.8c-10.7 10.7-15 24.8-20.8 46.4l-.5 1.9c-5.2 19.4-12.2 45.4-32.7 66c-19.1 19.1-44.1 29-69.1 29.7c-26.8 .7-53.9-9.2-74.4-29.7l-.1-.1 0 0L29.7 401l0 0c-39.6-39.6-39.6-103.9 0-143.5c20.4-20.4 46.2-27.4 65.4-32.6l1.8-.5c21.4-5.8 35.4-10.2 46-20.8c6.3-6.3 10.6-14.5 16.8-26.9l.6-1.2c5.5-11.1 12.9-25.9 25.1-38.2l40.7-40.7 17-17 17 17 15.8 15.8 14.4 14.4-11.7 16.4-.1 .1c-.1 .2-.4 .6-.7 1.1c-.7 1.1-1.7 2.8-2.8 5.1c-2.3 4.6-4.9 11-6.3 18.3c-2.1 10.6-1.9 23 5.8 35.8L352 126.1zm-160 128l17 17 32 32 17 17L224 353.9l-17-17-32-32-17-17L192 254.1zm-64 64l17 17 32 32 17 17L160 417.9l-17-17-32-32-17-17L128 318.1zm91.5-146.9c-6.2 6.2-10.5 14.4-16.7 26.8l-.5 1.1c-5.5 11.1-12.9 26-25.3 38.4c-20.4 20.4-46.3 27.5-65.6 32.7l-1.8 .5c-21.4 5.8-35.4 10.1-46 20.7c-20.9 20.9-20.9 54.8 0 75.6l.1 .1 0 0 80.4 81.2 0 0c10.8 10.8 25 16 39.2 15.6c13.2-.3 26.3-5.6 36.4-15.6c10.7-10.7 15-24.7 20.7-46.3l.5-1.8c5.2-19.4 12.2-45.5 32.7-66.1c12.4-12.4 27.2-19.8 38.4-25.3l1.1-.5c9.3-4.6 16.2-8.2 21.7-12.3c-22-.8-47.9-9.6-73.1-34.8L250 249.3c-25.9-25.9-32-54.6-30.1-78.5l-.4 .4z'
      
    ]
  };

  

  
  

  var faRectangleAd = {
    prefix: 'fasr',
    iconName: 'rectangle-ad',
    icon: [
      576,
      512,
      ["ad"],
      'f641',
      
      'M48 80V432H528V80H48zM0 32H48 528h48V80 432v48H528 48 0V432 80 32zM192.3 160H208h4 16.1l6.1 14.8L307.4 352H255.4l-9.9-24H171.6l-10.4 24H108.8L186 174.4l6.3-14.4zm.2 120h33.3l-16.2-39.2L192.4 280zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184 160h48v24 96 48 24H416v-4.1c-7.5 2.7-15.6 4.1-24 4.1c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z'
      
    ]
  };

  
    var faAd = faRectangleAd;
  

  
  

  var faNewspaper = {
    prefix: 'fasr',
    iconName: 'newspaper',
    icon: [
      512,
      512,
      [128240],
      'f1ea',
      
      'M96 32h24H488h24V56 456v24H488 144 120 72 48 24 0V456 112 88H48v24V432H72 96V56 32zm48 400H464V80H144V432zm32-320H320V240H176V112zm200 0h32 24v48H408 376 352V112h24zm0 80h32 24v48H408 376 352V192h24zM200 272H408h24v48H408 200 176V272h24zm0 80H408h24v48H408 200 176V352h24z'
      
    ]
  };

  

  
  

  var faStomach = {
    prefix: 'fasr',
    iconName: 'stomach',
    icon: [
      512,
      512,
      [],
      'f623',
      
      'M184 24V0H136V24 192v24h24 96.2c-.2 2.6-.2 5.3-.2 8v64c0 39.8-32.2 72-72 72H24 0v8 16 8 96 24H24 48V488 416h64c9.6 0 19 3.5 30.6 11.1c8.8 5.7 17.1 12.6 26.9 20.7c4.2 3.4 8.6 7.1 13.5 11C214.6 484 255.9 512 320 512c106 0 192-86 192-192V224c0-70.7-57.3-128-128-128c-50.6 0-94.4 29.4-115.1 72H184V24zm18 388.3c-2-1.6-4-3.3-6-4.9c46.2-4.6 84.6-35.4 100.4-77.3c12.2-6.9 22.6-8 32.7-6.6c12.4 1.7 24.9 7.1 41.1 14.4l1.2 .6c14.8 6.6 33.1 14.8 53 17.6c11.5 1.6 23.3 1.3 35.4-1.5C444.4 417.4 387.6 464 320 464c-47.9 0-78.6-20-107-42.7c-3.5-2.8-7.2-5.8-10.9-8.9l0 0 0 0 0 0zM464 301.6c-12.4 7.1-22.9 8.2-33.1 6.8c-12.4-1.7-24.9-7.1-41.1-14.4l-1.2-.6c-14.8-6.6-33.1-14.8-53-17.6c-10.3-1.4-20.8-1.4-31.6 .7V224c0-44.2 35.8-80 80-80s80 35.8 80 80v77.6z'
      
    ]
  };

  

  
  

  var faSnowflake = {
    prefix: 'fasr',
    iconName: 'snowflake',
    icon: [
      448,
      512,
      [10052,10054],
      'f2dc',
      
      'M248 24V0H200V24 70.1L183.4 53.4l-17-17L132.5 70.4l17 17L200 137.9v76.5l-66.2-38.2-18.5-69.1L109 83.9 62.7 96.3l6.2 23.2L75 142.2l-26-15-20.8-12-24 41.6 20.8 12 26 15-22.7 6.1L5.1 196.1l12.4 46.4 23.2-6.2 69.1-18.5L176 256l-66.2 38.2L40.7 275.7l-23.2-6.2L5.1 315.9l23.2 6.2L51 328.2l-26 15-20.8 12 24 41.6 20.8-12 26-15-6.1 22.7-6.2 23.2L109 428.1l6.2-23.2 18.5-69.1L200 297.6v76.5l-50.6 50.6-17 17 33.9 33.9 17-17L200 441.9V488v24h48V488 441.9l16.6 16.6 17 17 33.9-33.9-17-17L248 374.1V297.6l66.2 38.2 18.5 69.1 6.2 23.2 46.4-12.4-6.2-23.2L373 369.8l26 15 20.8 12 24-41.6-20.8-12-26-15 22.7-6.1 23.2-6.2-12.4-46.4-23.2 6.2-69.1 18.5L272 256l66.2-38.2 69.1 18.5 23.2 6.2 12.4-46.4-23.2-6.2L397 183.8l26-15 20.8-12-24-41.6-20.8 12-26 15 6.1-22.7 6.2-23.2L339 83.9l-6.2 23.2-18.5 69.1L248 214.4V137.9l50.6-50.6 17-17L281.6 36.5l-17 17L248 70.1V24z'
      
    ]
  };

  

  
  

  var faBroomWide = {
    prefix: 'fasr',
    iconName: 'broom-wide',
    icon: [
      512,
      512,
      [],
      'e5d1',
      
      'M336 144L480 0l32 32L368 176l48 48L265.7 469.9 240 512l-34.9-34.9L34.9 306.9 0 272l42.1-25.7L288 96l48 48zM77 281.2L102.9 307 160 288l-19 57.1L230.8 435l89.6-146.6-96.8-96.8L77 281.2z'
      
    ]
  };

  

  
  

  var faP = {
    prefix: 'fasr',
    iconName: 'p',
    icon: [
      320,
      512,
      [112],
      '50',
      
      'M48 288H168c57.4 0 104-46.6 104-104s-46.6-104-104-104H48V288zm0 48V456v24H0V456 312 56 32H24 48 168c83.9 0 152 68.1 152 152s-68.1 152-152 152H48z'
      
    ]
  };

  

  
  

  var faTrashCanClock = {
    prefix: 'fasr',
    iconName: 'trash-can-clock',
    icon: [
      576,
      512,
      [],
      'e2aa',
      
      'M160 0H147.2L140 10.7 93.8 80H80 32 0v48H32V464v48H80 330.8c-18.3-12.9-34.1-29.2-46.3-48H80V128H368v76c15.1-5.9 31.2-9.8 48-11.3V128h32V80H416 368 354.2L308 10.7 300.8 0H288 160zM288 266.8c9.1-12.9 19.9-24.5 32-34.6V192 176H288v16 74.8zM296.5 80h-145l21.3-32H275.2l21.3 32zM160 192V176H128v16V400v16h32V400 192zm80 0V176H208v16V400v16h32V400 192zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 288v16 48h32 16v32H480 432 416V368 304 288h32z'
      
    ]
  };

  

  
  

  var faSausage = {
    prefix: 'fasr',
    iconName: 'sausage',
    icon: [
      512,
      512,
      [],
      'f820',
      
      'M384.7 69.2C347.1 82.2 320 117.9 320 160c0 88.4-71.6 160-160 160c-42.1 0-77.8 27.1-90.8 64.7L0 360V472l69.2-24.7c13 37.7 48.7 64.7 90.8 64.7c194.4 0 352-157.6 352-352c0-42.1-27.1-77.8-64.7-90.8L472 0H360l24.7 69.2zM416 112c26.5 0 48 21.5 48 48c0 167.9-136.1 304-304 304c-26.5 0-48-21.5-48-48s21.5-48 48-48c114.9 0 208-93.1 208-208c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faFeatherPointed = {
    prefix: 'fasr',
    iconName: 'feather-pointed',
    icon: [
      512,
      512,
      ["feather-alt"],
      'f56b',
      
      'M171.3 165.6c36.7-36.7 99.8-65.2 169.4-85.2c41-11.8 81.7-20 116.2-25.3c-5.4 34.5-13.5 75.3-25.3 116.2c-3.6 12.5-7.5 24.8-11.6 36.8H337.9l7.9-7.9 17-17-33.9-33.9-17 17L123.5 354.5c-12.3-21.8-15.4-48.9-9.8-79.4c7.5-41 30.2-82.1 57.6-109.6zM122.7 423.3c78 54.7 194.8 14.3 257.7-48.6c76.4-76.4 112.4-229.2 126.1-325.9c2.6-18.6 4.4-35.2 5.5-48.7c-13.5 1.1-30.1 2.9-48.7 5.5C366.6 19.2 213.8 55.2 137.4 131.6C74.5 194.5 34 311.4 88.7 389.3L18.2 459.8l-17 17 33.9 33.9 17-17 70.5-70.5zm34.8-34.8L193.9 352H334c-26.6 22.2-61.9 39.8-97.1 46.3c-30.6 5.6-57.6 2.5-79.4-9.8zM375.4 304H241.9l48-48H401.1c-7.9 17.4-16.4 33.6-25.7 48z'
      
    ]
  };

  
    var faFeatherAlt = faFeatherPointed;
  

  
  

  var faMace = {
    prefix: 'fasr',
    iconName: 'mace',
    icon: [
      512,
      512,
      [],
      'f6f8',
      
      'M417.9 183.7C404.7 141 371 107.3 328.3 94.1L288 0 247.7 94.1c-42.7 13.2-76.4 46.9-89.6 89.6L64 224l94.1 40.3c4.2 13.5 10.4 26.1 18.3 37.4L18.2 459.8l-17 17 33.9 33.9 17-17L210.3 335.6c11.3 7.9 23.9 14.1 37.4 18.3L288 448l40.3-94.1c42.7-13.2 76.4-46.9 89.6-89.6L512 224l-94.1-40.3zM288 136a88 88 0 1 1 0 176 88 88 0 1 1 0-176zm32 88a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faTemperatureArrowDown = {
    prefix: 'fasr',
    iconName: 'temperature-arrow-down',
    icon: [
      576,
      512,
      ["temperature-down"],
      'e03f',
      
      'M112 294.5l-10.7 13.2C88 324.2 80 345.1 80 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L240 294.5v-17V48H112V277.5v17zM240 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S32 447.5 32 368c0-34.3 12-65.8 32-90.5V48 0h48H240zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272 256h32v16 50.7c18.6 6.6 32 24.4 32 45.3zM448 491.9l-17.8-19.8-72-80-16.1-17.8 35.7-32.1 16.1 17.8L424 393.5 424 56V32l48 0V56l0 337.5 30.2-33.5 16.1-17.8 35.7 32.1-16.1 17.8-72 80L448 491.9z'
      
    ]
  };

  
    var faTemperatureDown = faTemperatureArrowDown;
  

  
  

  var faBookmarkSlash = {
    prefix: 'fasr',
    iconName: 'bookmark-slash',
    icon: [
      640,
      512,
      [],
      'e0c2',
      
      'M512 374.7l108.9 84.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L128 76.6V48 0h48H464h48V48 374.7zM176 113.9L464 337.5V48H176v65.9zM512 499.4V512l-48-28L320 400 176 484l-48 28V456.4 196.8l48 37.8V428.4l119.8-69.9L317.3 346 512 499.4z'
      
    ]
  };

  

  
  

  var faA = {
    prefix: 'fasr',
    iconName: 'a',
    icon: [
      384,
      512,
      [97],
      '41',
      
      'M175.5 32h33l5.9 15.4L380.7 480H329.3l-36.9-96H91.6L54.7 480H3.3L169.6 47.4 175.5 32zM192 122.9L110.1 336H273.9L192 122.9z'
      
    ]
  };

  

  
  

  var faRoadLock = {
    prefix: 'fasr',
    iconName: 'road-lock',
    icon: [
      640,
      512,
      [],
      'e567',
      
      'M95.6 432L196.2 80H296v24 24h48V104 80h99.8l27.3 95.5c13.6-8.1 29.1-13.3 45.6-15L480 32H344 296 160L45.7 432 32 480H81.9 384l0-48H344V408 384H296v24 24H95.6zM344 216V192H296v24 80 24h48V296 216zm184 24c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48H416V512H640V320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faInputPipe = {
    prefix: 'fasr',
    iconName: 'input-pipe',
    icon: [
      640,
      512,
      [],
      'e1be',
      
      'M48 112V400H592V112H48zM0 64H48 592h48v48V400v48H592 48 0V400 112 64zM144 184V328v24H96V328 184 160h48v24z'
      
    ]
  };

  

  
  

  var faDeer = {
    prefix: 'fasr',
    iconName: 'deer',
    icon: [
      512,
      512,
      [129420],
      'f78e',
      
      'M256 16V0H224V16 40c0 30.9 25.1 56 56 56h8 8 20.6l-.3 .9L256 112v32h46.2L295 168H104c-28.5 0-54.2 12.5-71.8 32.2C12.5 217.8 0 243.5 0 272v48 16H32V321.9l8 8v18.2L25.2 392.4l-2.6 7.9 2.9 7.9 32 88L63.2 512H80h80 34.3l-11.7-32.2L156.4 408 183 386.7l9-7.2V369.3l16.4 5.5 3.7 1.2H216h48V488v24h24 80 24V488 311.8c0-2.6 .4-5.1 1.2-7.6L409.3 256H496h24V232 168 157.4l-7.9-7.1-68-61.8C460.8 78.7 472 60.7 472 40V16 0H440V16 40c0 13.3-10.7 24-24 24h-8H346.6c3.5-7.3 5.4-15.4 5.4-24V16 0H320V16 40c0 13.3-10.7 24-24 24h-8-8c-13.3 0-24-10.7-24-24V16zM144 356.5l-31 24.8L99.6 392l5.9 16.2L125.7 464H96.8L73.4 399.7l13.4-40.1 1.2-3.7V352 320v-9.9l-7-7-25-25V264c0-26.5 21.5-48 48-48H312.9h17.9l5.1-17.1 26-86.9h36.8L472 178.6V208H392 374.7l-5.5 16.4L347.7 289c-2.4 7.3-3.7 15-3.7 22.8V464H312V352 328H288 219.9l-44.3-14.8L144 302.7V336v20.5zM416 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faPersonSkiing = {
    prefix: 'fasr',
    iconName: 'person-skiing',
    icon: [
      512,
      512,
      [9975,"skiing"],
      'f7c9',
      
      'M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM13.8 247.6l21.3 11.1L239.8 365l49.6-74.5-84.7-90c-9.2-9.7-14.1-21.6-15-33.7l89.6 42.9 58.2 61.8 13.1 13.9L340 301.3l-57.3 86 133.5 69.3 37.1-18.5 21.5-10.7 21.5 42.9L474.7 481l-48 24-10.9 5.5-10.9-5.6L12.9 301.3-8.4 290.2l22.1-42.6zm326.6-192l9.8 22.9 42.8 100.5 65.4 31.3L480 220.7 459.3 264l-21.7-10.4-42.4-20.3-.1 .3-14.4-6.9-229.1-110-9.2 18.4-7.2 14.3-28.6-14.3 7.2-14.3 9-18-17.6-8.4L90.7 87.5l13.8-28.8 14.4 6.9L137 74.2l8.7-17.4 7.2-14.3 28.6 14.3-7.2 14.3-8.5 16.9 52.4 25.2c1.1-.6 2.2-1.2 3.4-1.7l96.1-45.2 22.5-10.6zM273.9 140L337 170.2l-21.3-49.9L273.9 140z'
      
    ]
  };

  
    var faSkiing = faPersonSkiing;
  

  
  

  var faZ = {
    prefix: 'fasr',
    iconName: 'z',
    icon: [
      384,
      512,
      [122],
      '5a',
      
      'M384 32H360 24 0V80H24 308.5L5.6 440.6 0 447.3V480H24 360h24V432H360 75.5L378.4 71.4l5.6-6.7V32z'
      
    ]
  };

  

  
  

  var faPinball = {
    prefix: 'fasr',
    iconName: 'pinball',
    icon: [
      448,
      512,
      [],
      'e229',
      
      'M352 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM81.1 333.6l.1 0L312 408 126.8 251.2c-20.3-17-50.5-14.3-67.6 6s-14.4 50.6 6 67.7c4.5 3.8 9.8 6.8 15.9 8.8zM66.3 379.3c-12.1-3.9-22.8-10-32-17.7c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3-29.6 55.7L66.3 379.3zM96 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faFaceConfused = {
    prefix: 'fasr',
    iconName: 'face-confused',
    icon: [
      512,
      512,
      [],
      'e36d',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM203.2 385.6l-12.8 9.6-19.2 14.4-28.8-38.4 19.2-14.4 12.8-9.6c37.4-28 82.9-43.2 129.6-43.2h40 24v48H344 304c-36.4 0-71.7 11.8-100.8 33.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faDemocrat = {
    prefix: 'fasr',
    iconName: 'democrat',
    icon: [
      640,
      512,
      [],
      'f747',
      
      'M112 0s-16 12.1-16 32c0 11.8 4.4 21.5 9.9 28.9L13.8 168.4 .8 183.5 13.3 199l64 80 12.7 15.8 17.7-9.8L157 257.5l35 75.7V488v24h24 96 24V488 432h96v56 24h24 96 24V488 328 205.4l32.1 28.5 31.9-35.9-72-64-6.8-6.1H552 288.3L209.9 66.1c7.3-8 14.1-19.3 14.1-34.1c0-19.9-16-32-16-32L160 45.7 112 0zM240 464V352H528V464H480V408 384H456 312 288v24 56H240zM528 176V304H231.4l-41.6-90.1L179 190.5 156.3 203l-54.3 30.2L63.2 184.5l76.1-88.8 29.8-.7 96 75.8 6.5 5.2H280 528zM386 229.4L375.5 208 365 229.4l-24.2 3.1 17.7 16.3L354 272l21.4-11.3L396.9 272l-4.4-23.3 17.7-16.3L386 229.4zM279.5 208L269 229.4l-24.2 3.1 17.7 16.3L258 272l21.4-11.3L300.9 272l-4.4-23.3 17.7-16.3L290 229.4 279.5 208zM474 229.4L463.5 208 453 229.4l-24.2 3.1 17.7 16.3L442 272l21.4-11.3L484.9 272l-4.4-23.3 17.7-16.3L474 229.4z'
      
    ]
  };

  

  
  

  var faLinkSimpleSlash = {
    prefix: 'fasr',
    iconName: 'link-simple-slash',
    icon: [
      640,
      512,
      [],
      'e1ce',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-87.5-68C578.2 363 608 313 608 256c0-88.4-71.6-160-160-160H376 352v48h24 72c61.9 0 112 50.1 112 112c0 46.3-28.1 86-68.1 103.1L390 280h34 24V232H424 328.2L214.8 144H264h24V96H264 192c-11.8 0-23.2 1.3-34.3 3.7L48.4 14.8zM70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h72 24V368H264 192c-61.9 0-112-50.1-112-112c0-28.6 10.7-54.8 28.4-74.6L70.7 151.7z'
      
    ]
  };

  

  
  

  var faPickaxe = {
    prefix: 'fasr',
    iconName: 'pickaxe',
    icon: [
      512,
      512,
      [],
      'e5bf',
      
      'M332.7 179.3c50 50 88.1 107.3 117.6 169.9c1.5 3.2 3 6.4 4.4 9.6c7.9 17.5 15.2 35.3 21.9 53.5L492.2 374c3.7-9.1 6.9-18.4 9.5-27.8c22.6-80.8 6.1-169.5-43.8-236.9L480 88 424 32 402.7 54.1s0 0 0 0C335.3 4.2 246.6-12.3 165.8 10.3c-9.4 2.6-18.7 5.8-27.8 9.5L99.6 35.3c18.2 6.7 36.1 14 53.5 21.9c3.2 1.5 6.4 2.9 9.6 4.4c62.6 29.5 119.9 67.6 169.9 117.6zm33.9-33.9c-38.6-38.6-81-70.5-126.3-97c58.3 .4 116.2 23.3 158.3 65.5c41.9 42.1 64.6 99.7 65 157.7c-26.5-45.2-58.4-87.6-97-126.3zm-32.1 82.8c-7.7-8.8-15.8-17.6-24.5-26.2s-17.4-16.8-26.2-24.5L0 472l40 40L334.6 228.2z'
      
    ]
  };

  

  
  

  var faTicketsSimple = {
    prefix: 'fasr',
    iconName: 'tickets-simple',
    icon: [
      640,
      512,
      [],
      'e659',
      
      'M96 32V80v40 48c22.1 0 40 17.9 40 40s-17.9 40-40 40v48 40 48h48H592h48V336 296 248c-22.1 0-40-17.9-40-40s17.9-40 40-40V120 80 32H592 144 96zm88 176c0-30.9-15.9-58.1-40-73.8V80H592v54.2c-24.1 15.7-40 42.9-40 73.8s15.9 58.1 40 73.8V336H144V281.8c24.1-15.7 40-42.9 40-73.8zM48 120V96H0v24V456v24H24 520h24V432H520 48V120z'
      
    ]
  };

  

  
  

  var faCommentsDollar = {
    prefix: 'fasr',
    iconName: 'comments-dollar',
    icon: [
      640,
      512,
      [],
      'f653',
      
      'M96.7 271.5l-11 27.4-7.1 17.6 70-16.2 10.1-2.3 10.2 2.1c12.4 2.5 25.5 3.9 39 3.9c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 26.5 10.2 51.8 29.2 73.4l19.5 22.2zM57 370.9L0 384l21.7-54.3 19.4-48.6C15.3 251.8 0 215.4 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-16.7 0-32.9-1.7-48.5-4.8L57 370.9zm188.2 10.6c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.5 0 26.6-1.3 39-3.9l10.2-2.1 10.1 2.3 70.1 16.2-7.1-17.6-11-27.4 19.5-22.2c19-21.5 29.2-46.9 29.2-73.4c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 39.4-15.3 75.8-41.2 105.1l19.4 48.6L640 512l-57-13.1L480.5 475.2c-15.6 3.1-31.8 4.8-48.5 4.8c-82 0-153-40.2-186.8-98.5zM224 90.7v7c5.8 1 16.2 3 20.5 4.2l15.5 4.1-8.1 30.9-15.5-4.1c-3.6-.9-15.8-3.3-19.8-3.9c-11.3-1.8-20.8-.3-27 2.5c-6.2 2.8-8.1 6.1-8.5 8.5c-.6 3.3 0 4.8 .3 5.4c.4 .8 1.3 2.1 3.9 3.9c5.8 3.9 14.9 6.7 27.5 10.4l.6 .2c11 3.3 25.2 7.5 35.9 15.2c5.8 4.2 11.2 9.8 14.6 17.4c3.4 7.8 4.1 16.3 2.6 25.3c-2.9 16.3-13.8 27.3-27.4 33.1c-4.7 2-9.8 3.4-15.1 4.2v6.4 16H192v-16-7.1c-8.6-1.7-20.5-5.8-28.1-8.4l0 0 0 0c-1.6-.5-2.9-1-4.1-1.4l-15.2-5 10-30.4 15.2 5c1.8 .6 3.7 1.2 5.6 1.9l0 0c8.6 2.9 18.5 6.2 24.1 7.1c11.8 1.8 21.1 .7 27.1-1.8c5.5-2.3 7.6-5.4 8.3-9.1c.7-3.8 .1-5.8-.3-6.8c-.5-1.1-1.5-2.6-4-4.3c-5.6-4-14.5-7-27-10.7l-1.9-.6c-10.6-3.2-24.1-7.2-34.3-14c-5.8-3.9-11.4-9.2-14.9-16.6c-3.6-7.6-4.5-16-2.9-24.8c2.7-15.6 13.9-26.4 26.9-32.2c4.8-2.1 10-3.7 15.5-4.7V90.7v-16h32v16z'
      
    ]
  };

  

  
  

  var faFaceHushed = {
    prefix: 'fasr',
    iconName: 'face-hushed',
    icon: [
      512,
      512,
      [],
      'e37b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H192c-4.4 0-8.8 .3-13 .9zm141-.9H304V128h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faPersonSnowmobiling = {
    prefix: 'fasr',
    iconName: 'person-snowmobiling',
    icon: [
      640,
      512,
      ["snowmobile"],
      'f7d1',
      
      'M240 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM360.2 63.1l12.3 20.6 46.8 78.1L576 240v96l-84 56 54 72h4.1l33-33 17-17L633.9 448l-17 17-40 40-7 7H560 440 416V464h24 46l-48-64H313.3c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64l8-16 40-80H288l24-32H280 268l-7.2-9.6L220 176H191.6l-25.7 57.7-43.9-19.5 32-72 6.3-14.3H176h56 12l7.2 9.6L292 192h56l18.7-24.9-35.3-58.8L319.1 87.8l41.2-24.7zm38.2 141.8l-.3 .2-71.8 95.7L312 320H288 109.7l-16 32H240 465.5L528 310.3V269.7L398.5 204.9zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H240c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z'
      
    ]
  };

  
    var faSnowmobile = faPersonSnowmobiling;
  

  
  

  var faChurch = {
    prefix: 'fasr',
    iconName: 'church',
    icon: [
      640,
      512,
      [9962],
      'f51d',
      
      'M344 24V0H296V24 48H264 240V96h24 32v26.9L171 203.9l-11 7.1V224 464H48V357.1l80-51.8V248.1L11 323.9 0 330.9V344 488v24H24 192v0H448h8 24H616h24V488 344 330.9l-11-7.1L512 248.1v57.2l80 51.8V464H480V224 210.9l-11-7.1L344 122.9V96h32 24V48H376 344V24zM208 237.1l112-72.5 112 72.5V464H368V368c0-26.5-21.5-48-48-48s-48 21.5-48 48v96H208V237.1z'
      
    ]
  };

  

  
  

  var faTableCellsColumnLock = {
    prefix: 'fasr',
    iconName: 'table-cells-column-lock',
    icon: [
      640,
      512,
      [],
      'e678',
      
      'M464 80L360 80l0 88 104 0 0-88zM200 80l0 88 112 0 0-88L200 80zM312 432l0-88-112 0 0 88 112 0zm72-136l0 48-24 0 0 88 24 0 0 48L48 480 0 480l0-48L0 80 0 32l48 0 416 0 48 0 0 48 0 81.1c-34.7 5-64.2 25.8-81 54.9l-71 0 0 80 24 0zm-184 0l112 0 0-80-112 0 0 80zm328-56c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z'
      
    ]
  };

  

  
  

  var faCalendarLinesPen = {
    prefix: 'fasr',
    iconName: 'calendar-lines-pen',
    icon: [
      576,
      512,
      [],
      'e472',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48H400 384 48V464H260.3l-6.9 48H48 0V464 192 144 64H104V24 0h48zM320 256v48H96V256H320zM96 352H256v48H96V352zM505 223.8l71 71-41.3 41.3-71-71L505 223.8zm-63.9 63.9l71 71L370.9 500 288 511.9 299.9 429 441.1 287.8z'
      
    ]
  };

  

  
  

  var faGlassCitrus = {
    prefix: 'fasr',
    iconName: 'glass-citrus',
    icon: [
      512,
      512,
      [],
      'f869',
      
      'M372.5 239.9c50.9-2.4 91.5-44.4 91.5-95.9c0-53-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144s-64.5 144-144 144l-.5 0 5-48.1zM61.6 256H290.4l8.3-80H53.3l8.3 80zm5 48L83.3 464H268.7l16.7-160H66.6zM312 512H40L5 176 0 128H48.3 303.7 352l-5 48L312 512z'
      
    ]
  };

  

  
  

  var faItalic = {
    prefix: 'fasr',
    iconName: 'italic',
    icon: [
      384,
      512,
      [],
      'f033',
      
      'M128 32h24H360h24V80H360 291.3L144.7 432H232h24v48H232 24 0V432H24 92.7L239.3 80H152 128V32z'
      
    ]
  };

  

  
  

  var faCediSign = {
    prefix: 'fasr',
    iconName: 'cedi-sign',
    icon: [
      384,
      512,
      [],
      'e0df',
      
      'M240 0V24 72.5C277.9 75 313 88 341.9 108.4l-27.7 39.2c-20.9-14.8-46.3-24.5-74.1-27V391.4c27.8-2.5 53.2-12.2 74.1-27l27.7 39.2C313 424 277.9 437 240 439.5v.5 48 24H192V488 440v-2.8C102 422 32 347.7 32 256s70-166 160-181.2V24 0h48zM80 256c0 63.2 47 117.9 112 132.3V123.7C127 138.1 80 192.8 80 256z'
      
    ]
  };

  

  
  

  var faCouch = {
    prefix: 'fasr',
    iconName: 'couch',
    icon: [
      640,
      512,
      [],
      'f4b8',
      
      'M528 80H112V192H64V80 32h48H528h48V80 192H528V80zM48 272V432H96V272H48zM0 224H48 96h48v48 16H496V272 224h48 48 48v48V432v48H592 544 496V448H144v32H96 48 0V432 272 224zM144 400H496V336H144v64zM592 272H544V432h48V272z'
      
    ]
  };

  

  
  

  var faMartiniGlassEmpty = {
    prefix: 'fasr',
    iconName: 'martini-glass-empty',
    icon: [
      512,
      512,
      ["glass-martini"],
      'f000',
      
      'M0 0V48L222.1 270.1 232 280V464H152 128v48h24H256 360h24V464H360 280V280l9.9-9.9L512 48V0H464 48 0zM444.1 48L256 236.1 67.9 48H444.1z'
      
    ]
  };

  
    var faGlassMartini = faMartiniGlassEmpty;
  

  
  

  var faMemo = {
    prefix: 'fasr',
    iconName: 'memo',
    icon: [
      384,
      512,
      [],
      'e1d8',
      
      'M48 48V464H336V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM120 128H264h24v48H264 120 96V128h24zm0 96H264h24v48H264 120 96V224h24zm0 96h48 24v48H168 120 96V320h24z'
      
    ]
  };

  

  
  

  var faSquare = {
    prefix: 'fasr',
    iconName: 'square',
    icon: [
      448,
      512,
      [9632,9723,9724,61590],
      'f0c8',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48z'
      
    ]
  };

  

  
  

  var faCommentCheck = {
    prefix: 'fasr',
    iconName: 'comment-check',
    icon: [
      512,
      512,
      [],
      'f4ac',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM369 193l17-17L352 142.1l-17 17-111 111-47-47-17-17L126.1 240l17 17 64 64 17 17 17-17L369 193z'
      
    ]
  };

  

  
  

  var faHeartHalf = {
    prefix: 'fasr',
    iconName: 'heart-half',
    icon: [
      512,
      512,
      [],
      'e1ab',
      
      'M256 480V412.1 96L231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L208 432l48 48zM208 364.1L73.7 229.8C57.2 213.4 48 191 48 167.8C48 119.3 87.3 80 135.8 80c23.3 0 45.6 9.2 62.1 25.7L208 115.9V364.1z'
      
    ]
  };

  

  
  

  var faTicketPerforated = {
    prefix: 'fasr',
    iconName: 'ticket-perforated',
    icon: [
      640,
      512,
      [],
      'e63e',
      
      'M0 64v48V400v48H48 592h48V400 352 304H616c-26.5 0-48-21.5-48-48s21.5-48 48-48h24V160 112 64H592 48 0zM592 400H48V112H592v51c-41.4 10.7-72 48.2-72 93s30.6 82.3 72 93v51zM448 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFileZipper = {
    prefix: 'fasr',
    iconName: 'file-zipper',
    icon: [
      384,
      512,
      ["file-archive"],
      'f1c6',
      
      'M48 464V48h64V64h16 32 16V48h48V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM112 96v32h16 32 16V96H160 128 112zm0 64v32h16 32 16V160H160 128 112zM80 416H208V344L176 224H112L80 344v72zm48-80h32 16v32H160 128 112V336h16z'
      
    ]
  };

  
    var faFileArchive = faFileZipper;
  

  
  

  var faHouseChimneyCrack = {
    prefix: 'fasr',
    iconName: 'house-chimney-crack',
    icon: [
      576,
      512,
      ["house-damage"],
      'f6f1',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 488h24V488 253.5l24.5 20.8 31.1-36.6L512 190.6V88 64H464V88v61.9L303.5 13.7zM464 216v24l0 224H316.8L288 416l96-80L224 224l64 112-96 80 28.8 48H112V212.8L288 63.5 464 212.8l0 3.2z'
      
    ]
  };

  
    var faHouseDamage = faHouseChimneyCrack;
  

  
  

  var faHeartCircleCheck = {
    prefix: 'fasr',
    iconName: 'heart-circle-check',
    icon: [
      576,
      512,
      [],
      'e4fd',
      
      'M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1l4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-14.4-6.6-29.8-11.4-45.9-14c2.7-8.5 4.1-17.4 4.1-26.4c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z'
      
    ]
  };

  

  
  

  var faArchway = {
    prefix: 'fasr',
    iconName: 'archway',
    icon: [
      512,
      512,
      [],
      'f557',
      
      'M0 32H24h8H80 432h48 24V80H480V432h8 24v48H488h-8H432h-8H400 384 336V432 336c0-44.2-35.8-80-80-80s-80 35.8-80 80v96 48H128 112 88 80 32 24 0V432H24h8V80H24 0V32zM80 80v32H432V80H80zm0 80V432h8 24 16V336c0-70.7 57.3-128 128-128s128 57.3 128 128v96h16 24 8V160H80z'
      
    ]
  };

  

  
  

  var faClockTwoThirty = {
    prefix: 'fasr',
    iconName: 'clock-two-thirty',
    icon: [
      512,
      512,
      [],
      'e35b',
      
      'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V256 243.2l10.7-7.1 96-64 20-13.3 26.6 39.9-20 13.3L280 268.8V392v24H232V392z'
      
    ]
  };

  

  
  

  var faHashtagLock = {
    prefix: 'fasr',
    iconName: 'hashtag-lock',
    icon: [
      576,
      512,
      [],
      'e415',
      
      'M447.5 136H424 352.5L373.3 32h-49L303.5 136h-111L213.3 32h-49L143.5 136H56 48.5l-9.6 48H56h77.9L105.1 328 24 328l-13.9 0L.5 376 24 376l71.5 0L74.7 480h49l20.8-104 111 0L234.7 480h49l59.2-296h51.8c13.7-10.8 29.9-18.4 47.6-21.9l5.2-26.1zM182.9 184h111L265.1 328l-111 0 28.8-144zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48H352V512H576V320H544V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faBorderOuter = {
    prefix: 'fasr',
    iconName: 'border-outer',
    icon: [
      448,
      512,
      [],
      'f851',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm256 96v64H192V128h64zM96 224h64v64H96V224zm160 0v64H192V224h64zm32 0h64v64H288V224zm-32 96v64H192V320h64z'
      
    ]
  };

  

  
  

  var faArrowsToDot = {
    prefix: 'fasr',
    iconName: 'arrows-to-dot',
    icon: [
      512,
      512,
      [],
      'e4be',
      
      'M280 24V0H232V24l0 86.1L201 79l-17-17L150.1 96l17 17 72 72 17 17 17-17 72-72 17-17L328 62.1 311 79l-31 31L280 24zM416 361.9L449.9 328l-17-17-31-31H488h24V232H488 401.9l31-31 17-17L416 150.1l-17 17-72 72-17 17 17 17 72 72 17 17zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM113 167l-17-17L62.1 184l17 17 31 31L24 232H0v48H24h86.1L79 311l-17 17L96 361.9l17-17 72-72 17-17-17-17-72-72zm37.1 249L184 449.9l17-17 31-31 0 86.1v24h48V488 401.9l31 31 17 17L361.9 416l-17-17-72-72-17-17-17 17-72 72-17 17z'
      
    ]
  };

  

  
  

  var faRestroomSimple = {
    prefix: 'fasr',
    iconName: 'restroom-simple',
    icon: [
      640,
      512,
      [],
      'e23a',
      
      'M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM74 304l4-96H178l4 96H144 112 74zM64 352V488v24h48V488 352h32V488v24h48V488 352h40l-2-48-6-144H32L26 304l-2 48H64zM344 0H296V24 488v24h48V488 24 0zM576 64A64 64 0 1 0 448 64a64 64 0 1 0 128 0zM484.2 208h55.6l36.6 128H447.6l36.6-128zM576 160H448L397.7 336 384 384h49.9H448V488v24h48V488 384h32V488v24h48V488 384h14.1H640l-13.7-48L576 160z'
      
    ]
  };

  

  
  

  var faLayerGroup = {
    prefix: 'fasr',
    iconName: 'layer-group',
    icon: [
      576,
      512,
      [],
      'f5fd',
      
      'M288 203.5L118.2 128 288 52.5 457.8 128 288 203.5zM516.9 101.7L288 0 59.1 101.7 0 128l59.1 26.3L288 256 516.9 154.3 576 128l-59.1-26.3zm-353.2 134l-59.1-26.3L59.1 229.7 0 256l59.1 26.3L288 384 516.9 282.3 576 256l-59.1-26.3-45.5-20.2-59.1 26.3L457.8 256 288 331.5 118.2 256l45.5-20.2zM104.6 337.5L59.1 357.7 0 384l59.1 26.3L288 512 516.9 410.3 576 384l-59.1-26.3-45.5-20.2-59.1 26.3L457.8 384 288 459.5 118.2 384l45.5-20.2-59.1-26.3z'
      
    ]
  };

  

  
  

  var faEnvelopeCircleCheck = {
    prefix: 'fasr',
    iconName: 'envelope-circle-check',
    icon: [
      640,
      512,
      [],
      'e4e8',
      
      'M48 150.8l208 143 108.2-74.4c-21.3 24-36.1 53.9-41.7 86.9L256 352 48 209V400H332c6.9 17.5 16.4 33.7 28.2 48H48 0V400 176 112 64H48 464h48v48 48.7c-5.3-.5-10.6-.7-16-.7c-21.6 0-42.4 3.9-61.5 11.1L464 150.8V112H48v38.8zM352 336a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 281.4l-11.3 11.3L480 353.4l-28.7-28.7L440 313.4 417.4 336l11.3 11.3 40 40L480 398.6l11.3-11.3 72-72L574.6 304z'
      
    ]
  };

  

  
  

  var faWave = {
    prefix: 'fasr',
    iconName: 'wave',
    icon: [
      576,
      512,
      [],
      'e65b',
      
      'M304 80c-83.9 0-152 68.1-152 152c0 66.3-53.7 120-120 120H8V304H32c39.8 0 72-32.2 72-72c0-110.5 89.5-200 200-200c67.7 0 127.5 33.6 163.6 85l-29.9 35.5C426.3 147 413.5 144 400 144c-48.6 0-88 39.4-88 88c0 39.8 32.2 72 72 72v0c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.8-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.5 23.1-79 23.1v0c-66.3 0-120-53.7-120-120c0-66.9 48.3-122.6 112-133.9C354.6 86.6 330.1 80 304 80zM96 446.2c-4.7 3.3-10.4 7-16.9 10.7C59.7 467.8 31.5 480 0 480V432c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l0 0 .4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l0 0 .7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.8 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7z'
      
    ]
  };

  

  
  

  var faCommentMiddleTop = {
    prefix: 'fasr',
    iconName: 'comment-middle-top',
    icon: [
      512,
      512,
      [],
      'e14a',
      
      'M290.2 145.4L279.4 128 256 90.6 232.6 128l-10.8 17.3-20 4.2C106.3 169.6 48 236.6 48 304c0 79.5 83.3 160 208 160s208-80.5 208-160c0-67.4-58.3-134.4-153.7-154.4l-20-4.2zM227.7 45.3L256 0l28.3 45.3 35.8 57.3C430.5 125.7 512 207.1 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-96.9 81.5-178.3 191.9-201.4l35.8-57.3z'
      
    ]
  };

  

  
  

  var faGridRound2 = {
    prefix: 'fasr',
    iconName: 'grid-round-2',
    icon: [
      512,
      512,
      [],
      'e5db',
      
      'M128 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM336 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z'
      
    ]
  };

  

  
  

  var faVirus = {
    prefix: 'fasr',
    iconName: 'virus',
    icon: [
      512,
      512,
      [],
      'e074',
      
      'M224 468.5c0-49.9-60.3-74.9-95.6-39.6L97.6 459.6 52.4 414.4l30.8-30.8C118.4 348.3 93.4 288 43.5 288H0V224H43.5c49.9 0 74.8-60.3 39.6-95.6L52.4 97.6 97.6 52.4l30.8 30.8C163.7 118.4 224 93.4 224 43.5V0h64V43.5c0 49.9 60.3 74.8 95.6 39.6l30.8-30.8 45.3 45.3-30.8 30.8c-35.3 35.3-10.3 95.6 39.6 95.6H512v64H468.5c-49.9 0-74.9 60.3-39.6 95.6l30.8 30.8-45.3 45.3-30.8-30.8c-35.3-35.3-95.6-10.3-95.6 39.6V512H224V468.5zm32-56c23.3-36.4 68.4-55.1 110.6-45.8c-9.3-42.2 9.4-87.3 45.8-110.6c-36.4-23.3-55.1-68.4-45.8-110.6c-21.2 4.7-43.1 2.3-62.6-5.8c-19.4-8.1-36.4-21.8-48-40c-23.3 36.4-68.4 55.1-110.6 45.8c9.3 42.2-9.4 87.3-45.8 110.6c36.4 23.3 55.1 68.4 45.8 110.6c42.2-9.3 87.3 9.4 110.6 45.8zM192 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm88 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faBookAtlas = {
    prefix: 'fasr',
    iconName: 'book-atlas',
    icon: [
      448,
      512,
      ["atlas"],
      'f558',
      
      'M0 88C0 39.4 39.4 0 88 0H424h24V24 376v24H424h-8v64h8 24v48H424 80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H400V48H88C65.9 48 48 65.9 48 88V358.7zM176.5 216h-31c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8h31zM112 200a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 123.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 216H208.6c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z'
      
    ]
  };

  
    var faAtlas = faBookAtlas;
  

  
  

  var faTruckPlow = {
    prefix: 'fasr',
    iconName: 'truck-plow',
    icon: [
      640,
      512,
      [],
      'f7de',
      
      'M128 32h24H288h13.5l7 11.5 88 144c.9 1.5 1.6 3 2.2 4.5H432h48v48 96h32V208v-8.4l5.3-6.6 64-80 15-18.7 37.5 30-15 18.7L560 216.4V359.6L618.7 433l15 18.7-37.5 30-15-18.7-63.2-79H480 464c0 53-43 96-96 96s-96-43-96-96H224c0 53-43 96-96 96s-96-43-96-96H0V336 240 192H48h80V56 32zm48 160H343L274.5 80H176V192zm35.2 144h73.7c16.6-28.7 47.6-48 83.2-48c24.6 0 47 9.2 64 24.4V240H48v90.9C65.2 305 94.6 288 128 288c35.5 0 66.6 19.3 83.2 48zM176 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm192 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faShieldHalved = {
    prefix: 'fasr',
    iconName: 'shield-halved',
    icon: [
      512,
      512,
      ["shield-alt"],
      'f3ed',
      
      'M232 60.8V447.4c-66.9-37.8-108.8-94.3-134.1-152.6C71 232.9 63.1 169.5 64.1 126L232 60.8zm48 386.5V60.8L448 126c1 43.5-6.9 106.9-33.8 168.8C388.8 353.1 346.9 409.5 280 447.3zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9z'
      
    ]
  };

  
    var faShieldAlt = faShieldHalved;
  

  
  

  var faFaceConfounded = {
    prefix: 'fasr',
    iconName: 'face-confounded',
    icon: [
      512,
      512,
      [],
      'e36c',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm231 77.3l25 20 25-20 13.7-11 14.6 9.7 31.6 21.1L351 343l17-17L401.9 360l-17 17-24 24-13.9 13.9L330.7 404l-33.4-22.3-26.3 21-15 12-15-12-26.3-21L181.3 404l-16.4 10.9L151 401l-24-24-17-17L144 326.1l17 17 10.1 10.1L202.7 332l14.6-9.7 13.7 11zM112 176l118.9 64L112 304l45.7-64L112 176zm169.1 64L400 176l-45.7 64L400 304 281.1 240z'
      
    ]
  };

  

  
  

  var faPalletBox = {
    prefix: 'fasr',
    iconName: 'pallet-box',
    icon: [
      640,
      512,
      [],
      'e208',
      
      'M464 48H384v96L320 96l-64 48V48H176V240H464V48zm0-48h48V48 240v48H464 176 128V240 48 0h48 80H384h80zM0 320H24 64 88h24H296h24 24H528h24 24 40 24v48H616 576v96h40 24v48H616 576 552 528 344 320 296 112 88 64 24 0V464H24 64V368H24 0V320zM112 464H296V368H112v96zm232 0H528V368H344v96z'
      
    ]
  };

  

  
  

  var faGreaterThanEqual = {
    prefix: 'fasr',
    iconName: 'greater-than-equal',
    icon: [
      448,
      512,
      [],
      'f532',
      
      'M400.4 169.5L32 32.3V83.5L323.2 192 32 300.5v51.2L400.4 214.5l15.6-5.8V175.3l-15.6-5.8zM424 432H24 0v48H24 424h24V432H424z'
      
    ]
  };

  

  
  

  var faSquareArrowUp = {
    prefix: 'fasr',
    iconName: 'square-arrow-up',
    icon: [
      448,
      512,
      ["arrow-square-up"],
      'f33c',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM241 135l88 88 17 17L312 273.9l-17-17-47-47V360v24H200V360 209.9l-47 47-17 17L102.1 240l17-17 88-88 17-17 17 17z'
      
    ]
  };

  
    var faArrowSquareUp = faSquareArrowUp;
  

  
  

  var faBurgerSoda = {
    prefix: 'fasr',
    iconName: 'burger-soda',
    icon: [
      640,
      512,
      [],
      'f858',
      
      'M224 0H205l-4.4 18.5L174.9 128H80.2 32 24 0v48H24 36 84.2h79.4 49.3 86.9H348h12 6.8c5.5-2 11.2-3.9 17.2-5.6V128H360h-8H303.8 224.2L243 48h37 24V0H280 224zm32 464H108.2L86.8 208H38.7L64 512H256V464zm80-162.9c.7-1.3 1.6-3.1 2.8-5.1c3.5-5.8 9.3-13.8 18.5-22c3.1-2.8 6.7-5.7 10.8-8.5c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.7-5.7 33-10 55.7-11.3c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.7 1.3 41 5.6 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c4.1 2.8 7.7 5.7 10.8 8.5c9.2 8.2 15 16.2 18.5 22c1.2 2 2.1 3.7 2.8 5.1v35H336v-35zm0 115H592v48H336v-48zm-48-40v8 8 96 24h24H616h24v-24-96-8-8-8-8-64-4l-1.3-3.8L616 296.1c22.7-7.8 22.7-7.8 22.7-7.8l0 0 0-.1-.1-.2-.2-.4c-.1-.3-.3-.7-.5-1.2c-.4-.9-.9-2.2-1.6-3.6c-1.3-3-3.3-6.9-6.1-11.5c-5.6-9.2-14.4-21.2-27.6-33c-27-24.1-70.7-46.1-138.7-46.1s-111.7 22-138.7 46.1c-13.3 11.8-22.1 23.8-27.6 33c-2.8 4.6-4.8 8.6-6.1 11.5c-.7 1.5-1.2 2.7-1.6 3.6c-.2 .5-.3 .9-.5 1.2l-.2 .4-.1 .2 0 .1 0 0c0 0 0 0 22.7 7.8l-22.7-7.8-1.3 3.8v4 64 8 8z'
      
    ]
  };

  

  
  

  var faCabinetFiling = {
    prefix: 'fasr',
    iconName: 'cabinet-filing',
    icon: [
      448,
      512,
      [128452],
      'f64b',
      
      'M400 232V48H48V232H400zM0 464V280 256 232 48 0H48 400h48V48 232v24 24V464v48H400 48 0V464zM48 280V464H400V280H48zM136 96H312h24v24 32 24H288V152v-8H160v8 24H112V152 120 96h24zm0 240H312h24v24 32 24H288V392v-8H160v8 24H112V392 360 336h24z'
      
    ]
  };

  

  
  

  var faListDropdown = {
    prefix: 'fasr',
    iconName: 'list-dropdown',
    icon: [
      512,
      512,
      [],
      'e1cf',
      
      'M48 192V432H464V192H48zM0 32H48 464h48V80 432v48H464 48 0V432 80 32zM352 96l48 48 48-48H352zM128 232H384h24v48H384 128 104V232h24zm0 96H384h24v48H384 128 104V328h24z'
      
    ]
  };

  

  
  

  var faWatchCalculator = {
    prefix: 'fasr',
    iconName: 'watch-calculator',
    icon: [
      384,
      512,
      [],
      'f8f0',
      
      'M320 0H64V64H48 0v48V400v48H48 64v64H320V448h16 48V400 112 64H336 320V0zm16 112V400H48V112H336zm-40 48H88v64H296V160zM88 248v48h48V248H88zm128 0H168v48h48V248zm32 0v48h48V248H248zM136 312H88v48h48V312zm32 0v48h48V312H168zm128 0H248v48h48V312z'
      
    ]
  };

  

  
  

  var faWatchApple = {
    prefix: 'fasr',
    iconName: 'watch-apple',
    icon: [
      384,
      512,
      [],
      'e2cb',
      
      'M320 0H64V64H48 0v48V400v48H48 64v64H320V448h16 48V400 112 64H336 320V0zm16 112V400H48V112H336zM192 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-8 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCruzeiroSign = {
    prefix: 'fasr',
    iconName: 'cruzeiro-sign',
    icon: [
      448,
      512,
      [],
      'e152',
      
      'M80 256c0-97 79.3-176 177.6-176c45.6 0 87 17 118.5 44.9L407.9 89C368 53.5 315.3 32 257.6 32C133.2 32 32 132.1 32 256s101.2 224 225.6 224c57.7 0 110.4-21.5 150.3-57l-31.9-35.9C344.6 415 303.2 432 257.6 432c-5.9 0-11.8-.3-17.6-.9V320v-1.8c0-21.1 17.1-38.2 38.2-38.2c10.1 0 19.9 4 27 11.2L311 297 345 263l-5.8-5.8c-16.2-16.2-38.1-25.3-61-25.3c-13.7 0-26.7 3.2-38.2 8.9V224H192v94.2V320v99.6C126.3 393.7 80 330.1 80 256z'
      
    ]
  };

  

  
  

  var faShelvesEmpty = {
    prefix: 'fasr',
    iconName: 'shelves-empty',
    icon: [
      640,
      512,
      [],
      'e246',
      
      'M48 24V0H0V24 160v24 24V416v24 24 24 24H48V488 464H592v24 24h48V488 464 440 416 208 184 160 24 0H592V24 160H48V24zm0 184H592V416H48V208z'
      
    ]
  };

  

  
  

  var faGarageOpen = {
    prefix: 'fasr',
    iconName: 'garage-open',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M320 6.1l9 3.7 296 120 15 6.1V152 488v24H592V488 168.2L320 57.9 48 168.2V488v24H0V488 152 135.8l15-6.1L311 9.8l9-3.7zM96 192h24H520h24v24V488v24H496V488 320H144V488v24H96V488 216 192zm48 80H496V240H144v32zm64 80H432h24v24V488v24H408V488v-8H232v8 24H184V488 376 352h24zm200 80V400H232v32H408z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassArrowsRotate = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e65e',
      
      'M208 368c83 0 151.2-63.1 159.2-144h48.2c-3.2 42.6-19.3 81.6-44.3 113.1l124 124 17 17L478.1 512l-17-17-124-124C301.7 399.2 256.8 416 208 416c-53.4 0-102-20.1-138.9-53.1L24 408 0 384V256H128l24 24-48.9 48.9C131.2 353.2 167.9 368 208 368zM312.9 87.1C284.8 62.8 248.1 48 208 48C125 48 56.8 111.1 48.8 192H.6C8.8 84.6 98.5 0 208 0c53.4 0 102 20.1 138.9 53.1L392 8l24 24V160H288l-24-24 48.9-48.9z'
      
    ]
  };

  

  
  

  var faFireExtinguisher = {
    prefix: 'fasr',
    iconName: 'fire-extinguisher',
    icon: [
      512,
      512,
      [129519],
      'f134',
      
      'M200 0V24 56h88V32L512 0V160L288 128V104H200v26.6c50.3 11 88 55.8 88 109.4V464v48H240 112 64V464 240c0-53.6 37.7-98.4 88-109.4V104.9c-46.9 5.5-86.5 34.8-106.3 75.6l-43.1-21C30.1 102.8 86.1 62.4 152 56.7V24 0h48zM112 464H240V416H112v48zm0-224V368H240V240c0-35.3-28.7-64-64-64s-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faArrowsToDottedLine = {
    prefix: 'fasr',
    iconName: 'arrows-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a6',
      
      'M224 201.9l17-17 72-72 17-17L296 62.1 279 79l-31 31L248 24V0L200 0V24l0 86.1L169 79l-17-17L118.1 96l17 17 72 72 17 17zM0 224v64H64V224H0zm96 0v64h64V224H96zm96 0v64h64V224H192zm96 0v64h64V224H288zm160 0H384v64h64V224zM241 327l-17-17-17 17-72 72-17 17L152 449.9l17-17 31-31V488v24h48V488 401.9l31 31 17 17L329.9 416l-17-17-72-72z'
      
    ]
  };

  

  
  

  var faCircleBookOpen = {
    prefix: 'fasr',
    iconName: 'circle-book-open',
    icon: [
      512,
      512,
      ["book-circle"],
      'e0ff',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c27.8 0 56 16 56 16V176s-28.2-16-56-16s-56 16-56 16V352s28.2-16 56-16zm144 0c27.8 0 56 16 56 16V176s-28.2-16-56-16s-56 16-56 16V352s28.2-16 56-16z'
      
    ]
  };

  
    var faBookCircle = faCircleBookOpen;
  

  
  

  var faArrowsRotate = {
    prefix: 'fasr',
    iconName: 'arrows-rotate',
    icon: [
      512,
      512,
      [128472,"refresh","sync"],
      'f021',
      
      'M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9L414.1 176H360 336v48h24H472h24V200 88 64H448V88v54.1L395.9 89.9C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3L94 187.1zM64 369.9l52.1 52.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9l-44.1-18.9C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L97.9 336H152h24V288H152 40 16v24V424v24H64V424 369.9z'
      
    ]
  };

  
    var faRefresh = faArrowsRotate;
  
    var faSync = faArrowsRotate;
  

  
  

  var faBorderTop = {
    prefix: 'fasr',
    iconName: 'border-top',
    icon: [
      448,
      512,
      [],
      'f855',
      
      'M0 32H448V80H0V32zm0 96H64v64H0V128zm448 0v64H384V128h64zm-256 0h64v64H192V128zM64 320v64H0V320H64zm320 0h64v64H384V320zm-128 0v64H192V320h64zM0 224H64v64H0V224zm448 0v64H384V224h64zm-256 0h64v64H192V224zM64 416v64H0V416H64zm320 0h64v64H384V416zm-128 0v64H192V416h64zM96 224h64v64H96V224zm64 192v64H96V416h64zm128 0h64v64H288V416zm64-192v64H288V224h64z'
      
    ]
  };

  

  
  

  var faMugTea = {
    prefix: 'fasr',
    iconName: 'mug-tea',
    icon: [
      576,
      512,
      [],
      'f875',
      
      'M152 112v24l-40 40V288H224V176l-40-40V112H368V400H80V112h72zM80 64H32v48V400v48H80 368h48V400 320h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H416 384 368 80zM448 272H416V112h32c44.2 0 80 35.8 80 80s-35.8 80-80 80z'
      
    ]
  };

  

  
  

  var faBurgerFries = {
    prefix: 'fasr',
    iconName: 'burger-fries',
    icon: [
      640,
      512,
      [],
      'e0cd',
      
      'M97.4 221.4L117.7 272H128V90.7L112 0 64 32 97.4 221.4zM59.7 192L41.8 90.5 0 80 18.7 192H59.7zm308.3-16.5L384 80 342.7 90.3 325.8 192h7.3c10.4-6.1 22-11.7 35-16.5zm-78.3 37.9L320 32 256 48V272h4c2.2-5.2 4.7-10.3 7.6-15.3c3.1-5.3 7-11.3 11.9-17.7l10.2-25.5zM96 304L64 224H49.2 0l10.7 48L64 512H256V464H102.5L77.6 352H96 256V304H96zm128-32V240 32L160 0V272h64zm112 29.1c.7-1.3 1.6-3.1 2.8-5.1c3.5-5.8 9.3-13.8 18.5-22c3.1-2.8 6.7-5.7 10.8-8.5c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.7-5.7 33-10 55.7-11.3c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.7 1.3 41 5.6 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c4.1 2.8 7.7 5.7 10.8 8.5c9.2 8.2 15 16.2 18.5 22c1.2 2 2.1 3.7 2.8 5.1v35H336v-35zm0 115H592v48H336v-48zm-48-40v8 8 96 24h24H616h24v-24-96-8-8-8-8-64-4l-1.3-3.8L616 296.1c22.7-7.8 22.7-7.8 22.7-7.8l0 0 0-.1-.1-.2-.2-.4c-.1-.3-.3-.7-.5-1.2c-.4-.9-.9-2.2-1.6-3.6c-1.3-3-3.3-6.9-6.1-11.5c-5.6-9.2-14.4-21.2-27.6-33c-27-24.1-70.7-46.1-138.7-46.1s-111.7 22-138.7 46.1c-13.3 11.8-22.1 23.8-27.6 33c-2.8 4.6-4.8 8.6-6.1 11.5c-.7 1.5-1.2 2.7-1.6 3.6c-.2 .5-.3 .9-.5 1.2l-.2 .4-.1 .2 0 .1 0 0c0 0 0 0 22.7 7.8l-22.7-7.8-1.3 3.8v4 64 8 8z'
      
    ]
  };

  

  
  

  var faGuaraniSign = {
    prefix: 'fasr',
    iconName: 'guarani-sign',
    icon: [
      384,
      512,
      [],
      'e19a',
      
      'M216 0H168V65.5C73.3 77.3 0 158.1 0 256s73.3 178.7 168 190.5V512h48V446.5c94.7-11.8 168-92.6 168-190.5V232H360 216V114c29.7 5 56.2 19 76.8 39.2l33.6-34.3C297.2 90.2 258.8 70.8 216 65.5V0zM168 114V398C99.9 386.6 48 327.4 48 256s51.9-130.6 120-142zm48 284V280H334c-10.1 60.3-57.7 107.9-118 118z'
      
    ]
  };

  

  
  

  var faGingerbreadMan = {
    prefix: 'fasr',
    iconName: 'gingerbread-man',
    icon: [
      448,
      512,
      [],
      'f79d',
      
      'M224 0C157.7 0 104 53.7 104 120c0 8.2 .8 16.2 2.4 24H88 24 0v24V296v24H24 88h4.1L37.6 385.5 32 392.1v8.7V488v24H56h94 11.2l7.2-8.6L221.2 440h5.6l52.8 63.4 7.2 8.6H298h94 24V488 400.8v-8.7l-5.6-6.7L355.9 320H360h64 24V296 168 144H424 360 341.6c1.6-7.8 2.4-15.8 2.4-24C344 53.7 290.3 0 224 0zM152 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 13.2-3.5 25.4-9.6 36l-20.8 36h41.6H360h40v80H360 320 296v24 18.4 8.7l5.6 6.7L368 409.5V464H309.3l-52.8-63.4-7.2-8.6H238 210 198.7l-7.2 8.6L138.7 464H80V409.5l66.4-79.7 5.6-6.7v-8.7V296 272H128 88 48V192H88h52.8 41.6l-20.8-36c-6.1-10.6-9.6-22.8-9.6-36zm72 120a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM208 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM240 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCommentQuestion = {
    prefix: 'fasr',
    iconName: 'comment-question',
    icon: [
      512,
      512,
      [],
      'e14b',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM168 168l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8h56.9c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 220.6v13.9V256v24h48V256v-7.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H224c-30.9 0-56 25.1-56 56zm64 200h48V320H232v48z'
      
    ]
  };

  

  
  

  var faAlicorn = {
    prefix: 'fasr',
    iconName: 'alicorn',
    icon: [
      640,
      512,
      [],
      'f6b0',
      
      'M84.1 160.1c7-10.1 15.6-18.9 25.5-26.2c5.6 16.6 12.6 31.8 20.6 45.5C119 191 112 206.8 112 224.2c0 8.2 1.6 16.3 4.6 23.9l25.3 63.3 3.5 8.6-3.3 8.7-20.6 54.8-2.7 7.3 2.1 7.5L139.1 464h49.8l-17.6-63.4-2.1-7.5 2.7-7.3 15.8-42.1c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3l-.7-32.7 31.4 9.2 88 25.7c2.1 .6 4.2 1.1 6.3 1.6l19 4v19.4V464h48V318.2 308.1l7.3-7.1c15.1-14.8 24.7-35.3 24.7-58.8c0-11.2-2.2-21.7-6.2-31.4l-1.8-4.4v-4.8V184 160h24 8 9.9l7 7 28.3 28.3 42.7-19V115.3L483.2 48H480h-8H440c-53 0-96.8 39.7-103.2 91l-2.6 21H320h-7H296h-6.8l-5.8-3.5L181.3 94.1c9.5 38.9 30.2 66.9 51.1 86.4c14.3 13.4 28.6 22.8 39.4 28.8c5.3 3 9.7 5.1 12.7 6.5c1.5 .7 2.6 1.1 3.3 1.4l.7 .3 0 0c0 0 0 0-8.4 22.5s-8.4 22.5-8.5 22.5l0 0-.1 0-.2-.1-.5-.2c-.4-.1-.8-.3-1.4-.6c-1.2-.5-2.8-1.2-4.9-2.1c-4-1.8-9.7-4.6-16.3-8.3c-13.3-7.5-30.9-19.1-48.6-35.7C163.9 182 128 128 128 48V5.2l36.5 22.3 130.2 79.6C313.9 45.1 371.7 0 440 0h32 8 16 12.8H536h24V48H540.8l10.7 16H640V80l-64 21.3V108v84 15.6l-14.3 6.3-72 32-15.1 6.7L464 241.9l0 .3c0 33.2-12.2 62.9-32 85.5V488v24H408 312 288V488 364.5l-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-13 34.8 24 86.3 8.5 30.4H220.5 120.8 102.6l-4.9-17.6L74.6 411.3l-4.2-15.1-2.1-7.5 2.7-7.3 5.5-14.6 17.3-46.1L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248v64 24H0V312 248c0-47.3 37.3-85.9 84.1-87.9zM448 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faAlarmPlus = {
    prefix: 'fasr',
    iconName: 'alarm-plus',
    icon: [
      512,
      512,
      [],
      'f844',
      
      'M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L423 489l17 17L473.9 472l-17-17-26.5-26.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L55 455l-17 17L72 505.9l17-17 26.5-26.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 176H232v24 64H168 144v48h24 64v64 24h48V376 312h64 24V264H344 280V200 176z'
      
    ]
  };

  

  
  

  var faMattressPillow = {
    prefix: 'fasr',
    iconName: 'mattress-pillow',
    icon: [
      640,
      512,
      [],
      'e525',
      
      'M240 112V400H48V112H240zm48 0H592V400H288V112zM48 64H0v48V400v48H48 592h48V400 112 64H592 48zm32 80V368H208V144H80z'
      
    ]
  };

  

  
  

  var faMemoPad = {
    prefix: 'fasr',
    iconName: 'memo-pad',
    icon: [
      448,
      512,
      [],
      'e1da',
      
      'M400 128V464H48V128H400zM48 0H0V48 464v48H48 400h48V464 48 0H400 48zM96 176v48h24H328h24V176H328 120 96zm0 96v48h24H328h24V272H328 120 96zm0 96v48h24H232h24V368H232 120 96z'
      
    ]
  };

  

  
  

  var faRabbitRunning = {
    prefix: 'fasr',
    iconName: 'rabbit-running',
    icon: [
      576,
      512,
      ["rabbit-fast"],
      'f709',
      
      'M501.8 167.2l-21.9-17.8-6.6-5.4h-2C452.6 93.2 410.4 54.1 357.5 39.6l-12.2-3.3-9.7-2.6-8.7 5-27.6 16L283 64l5.4 18.2 13.8 46.3c1.2 4 2.5 8 4 11.9l-57.1-20.8c-13.8-5-28.4-7.6-43.1-7.6H193.7c-30.1 0-57.5 11.7-77.9 30.9C103.7 133.5 88.5 128 72 128c-39.8 0-72 32.2-72 72s32.2 72 72 72c5.9 0 11.5-.7 17-2c6 14.1 14.8 27 26.1 37.8l41.6 39.8L113 381.3 81.3 405.7l-19 14.6 14.6 19L101 470.6l7.2 9.4H120h66.4 8.2l6.5-5 49.2-37.9 21.1 20.2 7 6.7H288 456h24V440 360v-8h72 24V328 239.1 227.7l-8.8-7.2-41.1-33.5c13.7-52.6-2.2-108.6-41.8-146.2L475 32l-28.5 3.3L443 47.5c-1 3.4-1.8 6.9-2.5 10.3c28.6 25.3 49.6 59 59.3 97.3c1 4 1.7 8.1 2 12.1zM215.2 403.6l-37 28.4H131.8l-2.3-2.9 12.7-9.8 49.6-38.1 23.4 22.4zM72 176c6.4 0 12.2 2.5 16.5 6.5c-5.1 12.4-8.1 25.9-8.4 40.1c-2.5 .9-5.2 1.4-8 1.4c-13.3 0-24-10.7-24-24s10.7-24 24-24zM342.3 85.2l2.5 .7c42 11.5 74.5 44.7 85.1 86.8l3.8 22.1 22.4-2.4 .5-.1L528 250.5V304H392h-9.9l-7 7-9.9 9.9c-9.7-43.6-43.3-79.2-88-90.4l-23.3-5.8-11.6 46.6 23.3 5.8c32.1 8 54.5 36.8 54.5 69.8v13 24h24 40v0h48v32H297.6L148.3 273.1c-13-12.4-20.3-29.5-20.3-47.5c0-36.3 29.4-65.7 65.7-65.7H206c9.1 0 18.1 1.6 26.7 4.7l129.4 47.1 23.3-41.2c-17.6-14.3-30.7-33.7-37.3-55.8l-8.4-28.1 2.5-1.5zM480 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faRabbitFast = faRabbitRunning;
  

  
  

  var faHandshakeSimpleSlash = {
    prefix: 'fasr',
    iconName: 'handshake-simple-slash',
    icon: [
      640,
      512,
      ["handshake-alt-slash"],
      'e05f',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L503.3 368H584h24V320H584 456 441.5L341.1 242.1l35.1-32.4 17.6-16.3-32.6-35.3-17.6 16.3-41 37.9-39.3-30.5L337.5 112h77.4l65.2 57.9 6.8 6.1H496h88 24V128H584 505.1L439.9 70.1 433.1 64H424 328h-9.5l-6.9 6.5L225 151.9l-31.8-24.7L209.5 112h15.3l48-48H200h-9.5l-6.9 6.5-28.7 27L48.4 14.8zm336 384.1l-38-29.9-37 37-21-21-17-17-17 17-23.3 23.3-21.3-21.3-17-17-7-7-52-52-7-7h-9.9H56 32v48H56h51l45 45 7 7 17 17 38.2 38.2 17 17 17-17 23.3-23.3 21 21 17 17 17-17 58-58zM101.5 176L40.6 128H32v48H56h45.5z'
      
    ]
  };

  
    var faHandshakeAltSlash = faHandshakeSimpleSlash;
  

  
  

  var faCatSpace = {
    prefix: 'fasr',
    iconName: 'cat-space',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M243.4 44.6L296 64 243.4 83.4 224 136 204.6 83.4 152 64l52.6-19.4L224-8l19.4 52.6zM144 279c34.5-46.4 85.2-80.1 144.3-92.7c-.2-3.4-.3-6.9-.3-10.3C288 78.8 366.8 0 464 0s176 78.8 176 176c0 68.4-39 127.7-96 156.8V488v24H520 440 416V488 403.8l-80 32.9V464h24 24v48H360 120 96V488l0-64 0-.1V184c0-22.1-17.9-40-40-40H32V96H56c48.6 0 88 39.4 88 88v95zm0 144.9V464H288V400c0-17.7-14.3-32-32-32H224V320h32c39.2 0 71.8 28.2 78.7 65.4l91.2-37.6c-60-13.3-108.5-57.1-128.3-114.4C209 252.6 144 331.2 144 423.9zM464 368v96h32V349.1c-10.4 1.9-21.1 2.9-32 2.9l0 16zm0-64c70.7 0 128-57.3 128-128c0-32.5-12.1-62.1-32-84.7V176c0 53-43 96-96 96s-96-43-96-96V91.3c-19.9 22.6-32 52.2-32 84.7c0 70.7 57.3 128 128 128zM397.8 66.4L432 112h64l34.2-45.6C510.9 54.7 488.2 48 464 48s-46.9 6.7-66.2 18.4zM432 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faDrawCircle = {
    prefix: 'fasr',
    iconName: 'draw-circle',
    icon: [
      512,
      512,
      [],
      'f5ed',
      
      'M256 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm54.8 17.1C299.6 115.6 279.2 128 256 128s-43.6-12.4-54.8-30.9c-48.7 16.8-87.3 55.4-104.1 104.1C115.6 212.4 128 232.8 128 256s-12.4 43.6-30.9 54.8c16.8 48.7 55.4 87.3 104.1 104.1C212.4 396.4 232.8 384 256 384s43.6 12.4 54.8 30.9c48.7-16.8 87.3-55.4 104.1-104.1C396.4 299.6 384 279.2 384 256s12.4-43.6 30.9-54.8c-16.8-48.7-55.4-87.3-104.1-104.1zm152.1 96.6c28.2 6.7 49.1 32 49.1 62.3s-20.9 55.5-49.1 62.3c-20.8 69.2-75.4 123.8-144.6 144.6c-6.7 28.2-32 49.1-62.3 49.1s-55.5-20.9-62.3-49.1C124.5 442.1 69.9 387.5 49.1 318.3C20.9 311.5 0 286.2 0 256s20.9-55.5 49.1-62.3C69.9 124.5 124.5 69.9 193.7 49.1C200.5 20.9 225.8 0 256 0s55.5 20.9 62.3 49.1c69.2 20.8 123.8 75.4 144.6 144.6zM256 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faEnvelopeOpen = {
    prefix: 'fasr',
    iconName: 'envelope-open',
    icon: [
      512,
      512,
      [62135],
      'f2b6',
      
      'M48 271.9V464H464V271.9l-194.5 132L256 413l-13.5-9.1L48 271.9zm414.5-57L256 60 49.5 214.9 256 355 462.5 214.9zM0 192L256 0 512 192V464v48H464 48 0V464 192z'
      
    ]
  };

  

  
  

  var faListTree = {
    prefix: 'fasr',
    iconName: 'list-tree',
    icon: [
      512,
      512,
      [],
      'e1d2',
      
      'M96 48H0v96H24V256 416v24H48h80v24h96V368H128v24H72V280h56v24h96V208H128v24H72V144H96V48zm64 24v48h24H488h24V72H488 184 160zM288 232v48h24H488h24V232H488 312 288zm0 160v48h24H488h24V392H488 312 288z'
      
    ]
  };

  

  
  

  var faLollipop = {
    prefix: 'fasr',
    iconName: 'lollipop',
    icon: [
      512,
      512,
      [127853,"lollypop"],
      'e424',
      
      'M210.8 334.8C265.3 314.2 304 261.6 304 200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72V176H176v16c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 53-43 96-96 96h-8C94.6 296 48 249.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192C0 298 86 384 192 384c44.4 0 85.2-15 117.7-40.3L479 513 513 479 343.7 309.7C369 277.2 384 236.4 384 192C384 86 298 0 192 0S0 86 0 192z'
      
    ]
  };

  
    var faLollypop = faLollipop;
  

  
  

  var faSignalStrong = {
    prefix: 'fasr',
    iconName: 'signal-strong',
    icon: [
      640,
      512,
      ["signal-4"],
      'f68f',
      
      'M472 96v24V488v24H424V488 120 96h48zM344 192v24V488v24H296V488 216 192h48zM216 288v24V488v24H168V488 312 288h48zM88 384v24 80 24H40V488 408 384H88z'
      
    ]
  };

  
    var faSignal4 = faSignalStrong;
  

  
  

  var faUserLargeSlash = {
    prefix: 'fasr',
    iconName: 'user-large-slash',
    icon: [
      640,
      512,
      ["user-alt-slash"],
      'f4fa',
      
      'M576 512H528l-60.9-48H136l40-96H345.2l-60.9-48H144L84 464 64 512h52H524h52l0 0zM382.2 273.9C430.6 250.7 464 201.3 464 144C464 64.5 399.5 0 320 0C250.1 0 191.8 49.9 178.7 116L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L382.2 273.9zm-45.5-35.4L224.3 151.4c-.2-2.4-.3-4.9-.3-7.4c0-53 43-96 96-96s96 43 96 96c0 47.4-34.3 86.7-79.4 94.6z'
      
    ]
  };

  
    var faUserAltSlash = faUserLargeSlash;
  

  
  

  var faChalkboard = {
    prefix: 'fasr',
    iconName: 'chalkboard',
    icon: [
      576,
      512,
      ["blackboard"],
      'f51b',
      
      'M56 32H32V56 400H80V80H496V400h48V56 32H520 56zM224 352v24 56H24 0v48H24 224h24H392h24H552h24V432H552 416V376 352H392 248 224zm144 48v32H272V400h96z'
      
    ]
  };

  
    var faBlackboard = faChalkboard;
  

  
  

  var faMeterDroplet = {
    prefix: 'fasr',
    iconName: 'meter-droplet',
    icon: [
      640,
      512,
      [],
      'e1ea',
      
      'M256 464c48.8 0 93.8-16.8 129.2-45c2.3 17.2 7.6 33.5 15.4 48.3C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C369.8 0 466.3 74.3 499.6 177l-36.8 56.5C451.6 129.2 363.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zM192 152v48 24H144V200 152 128h48v24zm88 0v48 24H232V200 152 128h48v24zm88 0v48 24H320V200 152 128h48v24zm160 40l93.5 143.6c12.1 18.5 18.5 40.2 18.5 62.3V400c0 61.9-50.1 112-112 112s-112-50.1-112-112v-2.1c0-22.1 6.4-43.7 18.5-62.3L528 192z'
      
    ]
  };

  

  
  

  var faChildren = {
    prefix: 'fasr',
    iconName: 'children',
    icon: [
      640,
      512,
      [],
      'e4e1',
      
      'M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-96a72 72 0 1 1 0 144A72 72 0 1 1 160 0zM104.7 160h12.2 9.8H144h32 17.3 9.8 12.2l7.2 9.9 81.7 112 14.1 19.4-38.8 28.3-14.1-19.4-40.6-55.7 38 113.9L273.3 400H240 224v88 24H176V488 400H144v88 24H96V488 400H80 46.7l10.5-31.6 38-113.9L54.6 310.1 40.4 329.5 1.7 301.2l14.1-19.4 81.7-112 7.2-9.9zm8.6 192h93.4L160 211.9 113.3 352zM504 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 408 72zm30.5 88h83 13.3l7.1 11.2 70.5 112 12.8 20.3-40.6 25.6-12.8-20.3-27.7-44V488v24H496V488 384H464V488v24H416V488 264.8l-27.7 44-12.8 20.3-40.6-25.6 12.8-20.3 70.5-112 7.1-11.2h13.3zM496 336V208H464V336h32z'
      
    ]
  };

  

  
  

  var faWreath = {
    prefix: 'fasr',
    iconName: 'wreath',
    icon: [
      448,
      512,
      [],
      'f7e2',
      
      'M192.9 51.8L224 78.2l31.1-26.4c2.8-2.4 6.3-3.8 10.3-3.8c6.9 0 12.9 4.4 15.1 10.7l15.2 43 43.7-13c1.4-.4 2.9-.7 4.6-.7c8.8 0 16 7.2 16 16c0 1.7-.2 3.2-.7 4.6l-13 43.7 43 15.2c6.3 2.2 10.7 8.2 10.7 15.1c0 4-1.4 7.5-3.8 10.3L369.8 224l26.4 31.1c2.4 2.8 3.8 6.3 3.8 10.3c0 6.9-4.4 12.9-10.7 15.1l-43 15.2 13 43.7c.4 1.4 .7 2.9 .7 4.6c0 5.9-3.2 11.1-8 13.9V384v23.5c31.6-3.9 56-30.9 56-63.5c0-6.3-.9-12.5-2.6-18.2c24.8-8.8 42.6-32.5 42.6-60.3c0-15.8-5.7-30.2-15.2-41.4c9.5-11.2 15.2-25.6 15.2-41.4c0-27.9-17.8-51.6-42.6-60.3c1.7-5.8 2.6-11.9 2.6-18.2c0-35.3-28.7-64-64-64c-6.3 0-12.5 .9-18.2 2.6C317 17.8 293.3 0 265.4 0C249.6 0 235.2 5.7 224 15.2C212.8 5.7 198.4 0 182.6 0C154.7 0 131 17.8 122.2 42.6C116.5 40.9 110.3 40 104 40c-35.3 0-64 28.7-64 64c0 6.3 .9 12.5 2.6 18.2C17.8 131 0 154.7 0 182.6c0 15.8 5.7 30.2 15.2 41.4C5.7 235.2 0 249.6 0 265.4c0 27.9 17.8 51.6 42.6 60.3C40.9 331.5 40 337.7 40 344c0 32.6 24.4 59.6 56 63.5V384 357.9c-4.8-2.8-8-7.9-8-13.9c0-1.7 .2-3.2 .7-4.6l13-43.7-43-15.2c-6.3-2.2-10.7-8.2-10.7-15.1c0-4 1.4-7.5 3.8-10.3L78.2 224 51.8 192.9c-2.4-2.8-3.8-6.3-3.8-10.3c0-6.9 4.4-12.9 10.7-15.1l43-15.2-13-43.7c-.4-1.4-.7-2.9-.7-4.6c0-8.8 7.2-16 16-16c1.7 0 3.2 .2 4.6 .7l43.7 13 15.2-43c2.2-6.3 8.2-10.7 15.1-10.7c4 0 7.5 1.4 10.3 3.8zM128 512l96-32 96 32V384l-96 32-96-32V512zm96-392l-27 28.9-2.8 3-4.2-.1-39.5-1.3 1.3 39.5 .1 4.2-3 2.8L120 224l28.9 27 3 2.8-.1 4.2-1.3 39.5 39.5-1.3 4.2-.1 2.8 3L224 328l27-28.9 2.8-3 4.2 .1 39.5 1.3L296.2 258l-.1-4.2 3-2.8L328 224l-28.9-27-3-2.8 .1-4.2 1.3-39.5L258 151.8l-4.2 .1-2.8-3L224 120zm9.7 80.6l14.2-.5-.5 14.2 10.4 9.7-10.4 9.7 .5 14.2-14.2-.5L224 257.7l-9.7-10.4-14.2 .5 .5-14.2L190.3 224l10.4-9.7-.5-14.2 14.2 .5 9.7-10.4 9.7 10.4z'
      
    ]
  };

  

  
  

  var faCloudArrowDown = {
    prefix: 'fasr',
    iconName: 'cloud-arrow-down',
    icon: [
      640,
      512,
      [62337,"cloud-download","cloud-download-alt"],
      'f0ed',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM223 313l-17-17L240 262.1l17 17 39 39V184 160h48v24V318.1l39-39 17-17L433.9 296l-17 17-80 80-17 17-17-17-80-80z'
      
    ]
  };

  
    var faCloudDownload = faCloudArrowDown;
  
    var faCloudDownloadAlt = faCloudArrowDown;
  

  
  

  var faHouseLock = {
    prefix: 'fasr',
    iconName: 'house-lock',
    icon: [
      640,
      512,
      [],
      'e510',
      
      'M288 .5l15.5 13.2L485.7 168.3c-15.6 6.4-29.5 16.2-40.6 28.5L288 63.5 112 212.8V464h80V296 272h24H360h24v24V464h0l0 48H88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zM336 464V320H240V464h96zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H416V320h32V272z'
      
    ]
  };

  

  
  

  var faArrowsLeftRight = {
    prefix: 'fasr',
    iconName: 'arrows-left-right',
    icon: [
      512,
      512,
      ["arrows-h"],
      'f07e',
      
      'M493.8 273l17-17-17-17-96-96-17-17L346.9 160l17 17 55 55L93.1 232l55-55 17-17-33.9-33.9-17 17-96 96-17 17 17 17 96 96 17 17L165.1 352l-17-17-55-55 325.7 0-55 55-17 17 33.9 33.9 17-17 96-96z'
      
    ]
  };

  
    var faArrowsH = faArrowsLeftRight;
  

  
  

  var faObjectsAlignCenterVertical = {
    prefix: 'fasr',
    iconName: 'objects-align-center-vertical',
    icon: [
      512,
      512,
      [],
      'e3bd',
      
      'M112 80V432h64V80H112zM64 32h48 64 48V80 232h64V144 96h48 64 48v48 88h64v48H448v88 48H400 336 288V368 280H224V432v48H176 112 64V432 280H0V232H64V80 32zM336 144V368h64V144H336z'
      
    ]
  };

  

  
  

  var faSquareDown = {
    prefix: 'fasr',
    iconName: 'square-down',
    icon: [
      448,
      512,
      [11015,"arrow-alt-square-down"],
      'f350',
      
      'M400 80L48 80l0 352 352 0 0-352zm48 400H400L48 480H0V432 80 32H48 400h48V80l0 352v48zM336 288L224 384 112 288l0-32h64l0-128 96 0V256h64v32z'
      
    ]
  };

  
    var faArrowAltSquareDown = faSquareDown;
  

  
  

  var faFilePowerpoint = {
    prefix: 'fasr',
    iconName: 'file-powerpoint',
    icon: [
      384,
      512,
      [],
      'f1c4',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM136 208H112v24V336v56 24h48V392 360h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V256h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z'
      
    ]
  };

  

  
  

  var faFileWord = {
    prefix: 'fasr',
    iconName: 'file-word',
    icon: [
      384,
      512,
      [],
      'f1c2',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM114.7 224H65.3l47.5 189.8 4.5 18.2H136h8 18.4l4.8-17.7 24.8-92 24.8 92 4.8 17.7H240h8 18.7l4.5-18.2L318.7 224H269.3l-26 104L220 241.7 215.2 224H196.8h-9.6H168.8L164 241.7 140.7 328l-26-104z'
      
    ]
  };

  

  
  

  var faLeft = {
    prefix: 'fasr',
    iconName: 'left',
    icon: [
      448,
      512,
      ["arrow-alt-left"],
      'f355',
      
      'M208 288l48 0 144 0 0-64-144 0-48 0 0-48 0-60.1L67.9 256 208 396.1l0-60.1 0-48zm48 112l0 48-48 0-16 0L33.9 289.9 0 256l33.9-33.9L192 64l16 0 48 0 0 48 0 16 0 48 48 0 96 0 48 0 0 48 0 64 0 48-48 0-96 0-48 0 0 48 0 16z'
      
    ]
  };

  
    var faArrowAltLeft = faLeft;
  

  
  

  var faWavesSine = {
    prefix: 'fasr',
    iconName: 'waves-sine',
    icon: [
      640,
      512,
      [],
      'e65d',
      
      'M95.9 381.1c12.7-21.1 23.5-46.7 33.7-75c7.4 22 15.6 44.7 24.9 66.4c-5.4 11.8-11.2 23-17.5 33.4C112.4 446.8 77.2 480 24 480H0V432H24c29 0 51.3-16.8 71.9-50.9zM248.1 130.9c-12.7 21.1-23.5 46.7-33.7 75c-7.4-22-15.6-44.7-24.9-66.4c5.4-11.8 11.2-23 17.5-33.4C231.6 65.2 266.8 32 320 32s88.4 33.2 113 74.1c24 39.8 41.2 91.9 57.2 140.7l0 0 0 0 .6 1.7c16.7 50.8 32.4 97.9 53.3 132.6C564.7 415.2 587 432 616 432h24v48H616c-53.2 0-88.4-33.2-113-74.1c-24-39.8-41.2-91.9-57.2-140.7l-.6-1.7c-16.7-50.8-32.4-97.9-53.3-132.6C371.3 96.8 349 80 320 80s-51.3 16.8-71.9 50.9zM391.9 381.1c12.7-21.1 23.5-46.7 33.7-75c7.4 22 15.6 44.7 24.9 66.4c-5.4 11.8-11.2 23-17.5 33.4C408.4 446.8 373.2 480 320 480s-88.4-33.2-113-74.1c-24-39.8-41.2-91.9-57.2-140.7l-.6-1.7c-16.7-50.8-32.4-97.9-53.3-132.6C75.3 96.8 53 80 24 80H0V32H24c53.2 0 88.4 33.2 113 74.1c24 39.8 41.2 91.9 57.2 140.7l.6 1.7c16.7 50.8 32.4 97.9 53.3 132.6C268.7 415.2 291 432 320 432s51.3-16.8 71.9-50.9zM544.1 130.9c-12.7 21.1-23.5 46.7-33.7 75c-7.4-22-15.6-44.7-24.9-66.4c5.4-11.8 11.2-23 17.5-33.4C527.6 65.2 562.8 32 616 32h24V80H616c-29 0-51.3 16.8-71.9 50.9z'
      
    ]
  };

  

  
  

  var faCircle6 = {
    prefix: 'fasr',
    iconName: 'circle-6',
    icon: [
      512,
      512,
      [],
      'e0f3',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-96-48c0-31.7 11.9-62.3 33.3-85.7L261.4 128h65.1l-14.9 16.2-44.4 48.4C315 198.2 352 238.8 352 288c0 53-43 96-96 96s-96-43-96-96z'
      
    ]
  };

  

  
  

  var faChessKingPiece = {
    prefix: 'fasr',
    iconName: 'chess-king-piece',
    icon: [
      256,
      512,
      ["chess-king-alt"],
      'f440',
      
      'M144 16V0H112V16 32H96 80V64H96h16V96H72 24v40l3.1 8 24.6 64H32v48H56h5.8L48.7 352H97.2l13.1-96h35.5l13.1 96h48.4l-13.1-96H200h24V208H204.3l24.6-64 3.1-8V96H184 144V64h16 16V32H160 144V16zm8.9 192H103.1L78.5 144h99l-24.6 64zM53.8 464l17.8-32H184.5l17.8 32H53.8zM256 461.9L212.7 384H43.3L0 461.9V464v48H48 208h48V464v-2.1z'
      
    ]
  };

  
    var faChessKingAlt = faChessKingPiece;
  

  
  

  var faTombstoneBlank = {
    prefix: 'fasr',
    iconName: 'tombstone-blank',
    icon: [
      448,
      512,
      [129702,"tombstone-alt"],
      'f721',
      
      'M368 192V432h48V192C416 86 330 0 224 0S32 86 32 192V432H80V192c0-79.5 64.5-144 144-144s144 64.5 144 144zM24 464H0v48H24 424h24V464H424 24z'
      
    ]
  };

  
    var faTombstoneAlt = faTombstoneBlank;
  

  
  

  var faFaceSmileWink = {
    prefix: 'fasr',
    iconName: 'face-smile-wink',
    icon: [
      512,
      512,
      [128521,"smile-wink"],
      'f4da',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm124 77.3L164 306.7C176 324.8 211.9 352 256 352s80-27.2 92-45.3L388 333.3C368 363.2 317.9 400 256 400s-112-36.8-132-66.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm151.3 26.3l-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0z'
      
    ]
  };

  
    var faSmileWink = faFaceSmileWink;
  

  
  

  var faProjector = {
    prefix: 'fasr',
    iconName: 'projector',
    icon: [
      640,
      512,
      [],
      'f8d6',
      
      'M424 24V0H376V24v80 24h48V104 24zM265 39l-17-17L214.1 56l17 17 56 56 17 17L337.9 112 321 95 265 39zM569 73l17-17L552 22.1 535 39 479 95l-17 17L496 145.9l17-17 56-56zM288 320a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm272 0c0-29.1-7.8-56.5-21.4-80H592V400H538.6c13.6-23.5 21.4-50.9 21.4-80zM400 480c36 0 69.3-11.9 96-32h16v40 24h48V488 448h32 48V400 240 192H592 496c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H48 0v48V400v48H48 80v40 24h48V488 448H304c26.7 20.1 60 32 96 32zM240 320c0 29.1 7.8 56.5 21.4 80H48V240H261.4c-13.6 23.5-21.4 50.9-21.4 80zm-112 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faText = {
    prefix: 'fasr',
    iconName: 'text',
    icon: [
      448,
      512,
      [],
      'f893',
      
      'M0 32H24 424h24V56v72 24H400V128 80H248l0 352h48 24v48H296 152 128V432h24 48l0-352H48v48 24H0V128 56 32z'
      
    ]
  };

  

  
  

  var faCircleDownLeft = {
    prefix: 'fasr',
    iconName: 'circle-down-left',
    icon: [
      512,
      512,
      [],
      'e107',
      
      'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 192l24-24 52 52 76-76 56 56-76 76 52 52-24 24H160V192z'
      
    ]
  };

  

  
  

  var faWatch = {
    prefix: 'fasr',
    iconName: 'watch',
    icon: [
      384,
      512,
      [8986],
      'f2e1',
      
      'M320 0H64V112h1C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144H64V512H320V400h-1c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h1V0zM48 256a144 144 0 1 1 288 0A144 144 0 1 1 48 256zm168-80V152H168v24 80 12.8l10.7 7.1 48 32 20 13.3 26.6-39.9-20-13.3L216 243.2V176z'
      
    ]
  };

  

  
  

  var faTextSlash = {
    prefix: 'fasr',
    iconName: 'text-slash',
    icon: [
      640,
      512,
      ["remove-format"],
      'f87d',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-272-211.2L396.4 80H521.3l-16 64h49.5l20.5-82.2L582.7 32H552 184 165.3l-4.5 18.2L149.9 93.6 48.4 14.8zm142.9 111L202.7 80H346.5L308 216.4 191.3 125.7zM320.5 348.5l-40.8-32.1L248.9 425.5c-.6 2.2-.9 4.4-.9 6.5H192 168v48h24H352h24V432H352 296.9l23.6-83.5z'
      
    ]
  };

  
    var faRemoveFormat = faTextSlash;
  

  
  

  var faChartLineUpDown = {
    prefix: 'fasr',
    iconName: 'chart-line-up-down',
    icon: [
      512,
      512,
      [],
      'e5d7',
      
      'M48 32l0 24 0 376 440 0 24 0 0 48-24 0L24 480 0 480l0-24L0 56 0 32l48 0zM352 64l24 0 80 0 24 0 0 24 0 80 0 24-48 0 0-24 0-22.1L305 273l-17 17-17-17-63-63-63 63-17 17L94.1 256l17-17 80-80 17-17 17 17 63 63L398.1 112 376 112l-24 0 0-48zm24 320l-24 0 0-48 24 0 22.1 0-47-47L385 255l47 47 0-22.1 0-24 48 0 0 24 0 80 0 24-24 0-80 0z'
      
    ]
  };

  

  
  

  var faCloudBolt = {
    prefix: 'fasr',
    iconName: 'cloud-bolt',
    icon: [
      512,
      512,
      [127785,"thunderstorm"],
      'f76c',
      
      'M368 176V128c0-26.5-21.5-48-48-48c-9.7 0-18.7 2.8-26.2 7.7l-38.8 25.3L228.4 75.2C216.7 58.7 197.6 48 176 48c-35.3 0-64 28.7-64 64v21.5 33.9L80 178.7c-18.7 6.6-32 24.5-32 45.3v48H96 207.2L144 320H96 48 0V272 224c0-41.8 26.7-77.4 64-90.5V112C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c53 0 96 43 96 96c53 0 96 43 96 96v48 48H464 416 400v0H323.5l15-48H416h48V224c0-26.5-21.5-48-48-48H368zM232 384H144V360L320 224 280 352h88v24L192 512l40-128z'
      
    ]
  };

  
    var faThunderstorm = faCloudBolt;
  

  
  

  var faMessageCheck = {
    prefix: 'fasr',
    iconName: 'message-check',
    icon: [
      512,
      512,
      ["comment-alt-check"],
      'f4a2',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM369 153l17-17L352 102.1l-17 17-111 111-47-47-17-17L126.1 200l17 17 64 64 17 17 17-17L369 153z'
      
    ]
  };

  
    var faCommentAltCheck = faMessageCheck;
  

  
  

  var faHandHoldingSeedling = {
    prefix: 'fasr',
    iconName: 'hand-holding-seedling',
    icon: [
      576,
      512,
      [],
      'f4bf',
      
      'M104 0H80V24c0 83.9 68.1 152 152 152h32v80 24h48V256 176 152C312 68.1 243.9 0 160 0H104zM232 128c-49.2 0-90.4-34.1-101.2-80H160c49.2 0 90.4 34.1 101.2 80H232zM168 304h-7.3l-6 4-90 60H24 0v48H24 72h7.3l6-4 90-60H360v32H320 296 256 232v48h24 40 24 48 32 7l5.9-3.7 80.4-51 15 24L416.6 464H24 0v48H24 424h7.4l6.1-4.2 116.8-80 19-13-12.2-19.5-40-64-12.8-20.5-20.4 13L408 374.5V328 304H384 168zM352 176c83.9 0 152-68.1 152-152V0H480 424c-44.1 0-83.9 18.8-111.6 48.8c10 14.7 17.9 30.9 23.3 48.3C354 67.6 386.7 48 424 48h29.2c-10.8 45.9-52 80-101.2 80h-9.6c1 7.9 1.6 15.9 1.6 24v24l8 0z'
      
    ]
  };

  

  
  

  var faPhoneArrowRight = {
    prefix: 'fasr',
    iconName: 'phone-arrow-right',
    icon: [
      512,
      512,
      [],
      'e5be',
      
      'M272.4 369.2l31.9 18.4 26-26 33.2-33.2L457.7 366l-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM413.8 23l-17-17L362.9 40l17 17 39 39H312 288v48h24H418.9l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80z'
      
    ]
  };

  

  
  

  var faSquareDollar = {
    prefix: 'fasr',
    iconName: 'square-dollar',
    icon: [
      448,
      512,
      ["dollar-square","usd-square"],
      'f2e9',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM244.2 149.4c18.3 2.6 36.2 7 54.1 11.5l-10.5 41.9c-16.3-4.1-32.5-8.1-49.1-10.6c-16.4-2.4-30.1-.5-39.3 3.5c-11 4.7-18 16.2-6.3 23.7c8.5 5.4 21.5 9.2 39.4 14.3l.8 .2c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2V400H201V361.1c-11.7-2.6-26.7-7.4-36.6-10.6l0 0c-6.6-2.1-13.1-4.2-19.7-6.2c-2.3-.7-4.5-1.4-6.8-2.1l12.9-41.2c2.2 .7 4.4 1.4 6.6 2.1c7.3 2.3 14.6 4.6 21.9 6.9l0 0c12.1 3.9 26.4 8.4 34.5 9.7c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c3.9-21.5 19.9-35.8 37.8-43.5c5.8-2.5 12.1-4.4 18.6-5.7V112h43.2v37.4z'
      
    ]
  };

  
    var faDollarSquare = faSquareDollar;
  
    var faUsdSquare = faSquareDollar;
  

  
  

  var faArrowDownWideShort = {
    prefix: 'fasr',
    iconName: 'arrow-down-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-asc","sort-amount-down"],
      'f160',
      
      'M111 461.8l17 17 17-17 96-96 17-17L224 314.9l-17 17-55 55V56 32H104V56 386.9l-55-55-17-17L-1.9 348.8l17 17 96 96zM312 480h48 24V432H360 312 288v48h24zm0-128H424h24V304H424 312 288v48h24zm0-128H488h24V176H488 312 288v48h24zm0-128H552h24V48H552 312 288V96h24z'
      
    ]
  };

  
    var faSortAmountAsc = faArrowDownWideShort;
  
    var faSortAmountDown = faArrowDownWideShort;
  

  
  

  var faCandyCane = {
    prefix: 'fasr',
    iconName: 'candy-cane',
    icon: [
      512,
      512,
      [],
      'f786',
      
      'M343 82.3L332.8 51.9c9.1-2.6 18.6-3.9 28.1-3.9c22.7 0 43.6 7.3 60.7 19.7l-23 23C387.7 83.9 374.8 80 361 80c-6.1 0-12.1 .8-18 2.3zm78.3 31.1l23-23c12.4 17 19.7 38 19.7 60.7v5.6c0 7-.7 13.8-2 20.5l-30.7-10.2c.5-3.4 .7-6.8 .7-10.3V151c0-13.8-3.9-26.7-10.8-37.6zm30.2 93.9c-8.8 16.7-22 31.1-38.5 41.4L375 272.5l-30.2-18.9 51.2-32c10.1-6.3 18.4-14.8 24.5-24.6l30.9 10.3zm-106.6 84l-77 48.1-30.2-18.9 77-48.1 30.2 18.9zm-107.2 67l-73 45.6-30.2-18.9 73-45.6 30.2 18.9zM134.4 422.9l-36.8 23-17-27.1L104.2 404l30.2 18.9zM303.6 65.4L314 96.6l-30.5 19.1-17-27.1 37-23.1zm5.4 91l39.8-24.9c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L55.2 378 14.5 403.5 40 444.2l17 27.1L82.4 512l40.7-25.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80 23L241.1 47.8 200.4 73.3 225.9 114l17 27.1 25.4 40.7L309 156.4z'
      
    ]
  };

  

  
  

  var faSquare9 = {
    prefix: 'fasr',
    iconName: 'square-9',
    icon: [
      448,
      512,
      [],
      'e25e',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm96-48c0-53-43-96-96-96s-96 43-96 96c0 49.2 37 89.8 84.7 95.3l-44.4 48.4L153.4 384h65.1l68.1-74.3c21.4-23.4 33.3-54 33.3-85.7z'
      
    ]
  };

  

  
  

  var faBowlFood = {
    prefix: 'fasr',
    iconName: 'bowl-food',
    icon: [
      512,
      512,
      [],
      'e4c6',
      
      'M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zM144 431.8v.2H368v-.2V401.5l27.4-13c33.7-16 58.6-47.1 66.2-84.5H50.4c7.6 37.4 32.5 68.5 66.2 84.5l27.4 13v30.3zm-48 0C46.1 408.1 9.8 360.6 1.7 304C.6 296.2 0 288.1 0 280V256H48 464h48v24c0 8.1-.6 16.2-1.7 24c-8.1 56.6-44.4 104.1-94.3 127.8v.2 48H368 144 96V432v-.2z'
      
    ]
  };

  

  
  

  var faGroupArrowsRotate = {
    prefix: 'fasr',
    iconName: 'group-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e4f6',
      
      'M158.3 81.4c21-11.8 44.3-19.9 69.1-23.4l-6.8-47.5c-32.5 4.6-63 15.6-90.1 31.6C120.5 35.7 108.7 32 96 32C60.7 32 32 60.7 32 96c0 12.7 3.7 24.5 10.1 34.5c-16 27.2-26.9 57.6-31.6 90.1L58 227.4c3.5-24.8 11.6-48.1 23.4-69.1C86.1 159.4 91 160 96 160c35.3 0 64-28.7 64-64c0-5-.6-9.9-1.7-14.6zm272.2 76.9c11.8 21 19.9 44.3 23.4 69.1l47.5-6.8c-4.6-32.5-15.6-63-31.6-90.1c6.4-10 10.1-21.8 10.1-34.5c0-35.3-28.7-64-64-64c-12.7 0-24.5 3.7-34.5 10.1c-27.2-16-57.6-26.9-90.1-31.6L284.6 58c24.8 3.5 48.1 11.6 69.1 23.4C352.6 86.1 352 91 352 96c0 35.3 28.7 64 64 64c5 0 9.9-.6 14.6-1.7zM81.4 353.7c-11.8-21-19.9-44.3-23.4-69.1l-47.5 6.8c4.6 32.5 15.6 63 31.6 90.1C35.7 391.5 32 403.3 32 416c0 35.3 28.7 64 64 64c12.7 0 24.5-3.7 34.5-10.1c27.2 16 57.6 26.9 90.1 31.6l6.8-47.5c-24.8-3.5-48.1-11.6-69.1-23.4c1.1-4.7 1.7-9.6 1.7-14.6c0-35.3-28.7-64-64-64c-5 0-9.9 .6-14.6 1.7zm272.2 76.9c-21 11.8-44.3 19.9-69.1 23.4l6.8 47.5c32.5-4.6 63-15.6 90.1-31.6c10 6.4 21.8 10.1 34.5 10.1c35.3 0 64-28.7 64-64c0-12.7-3.7-24.5-10.1-34.5c16-27.2 26.9-57.6 31.6-90.1L454 284.6c-3.5 24.8-11.6 48.1-23.4 69.1c-4.7-1.1-9.6-1.7-14.6-1.7c-35.3 0-64 28.7-64 64c0 5 .6 9.9 1.7 14.6zM80 96a16 16 0 1 1 32 0A16 16 0 1 1 80 96zm0 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM400 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM227.7 313.8c-20.8-10.6-34.9-32.2-34.9-57c0-15.6 5.6-29.9 14.9-41.1l25.9 25.9 0-81.6L152 160l21.7 21.7c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8l21.8-42.7zm93.1-58.6c0 15.6-5.6 29.9-14.9 41.1L280 270.4l0 81.6h81.6l-21.7-21.7c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8l-21.8 42.7c20.8 10.6 34.9 32.2 34.9 57z'
      
    ]
  };

  

  
  

  var faFileJpg = {
    prefix: 'fasr',
    iconName: 'file-jpg',
    icon: [
      512,
      512,
      [],
      'e646',
      
      'M48 464H96v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zm160 48c-26.5 0-48-21.5-48-48V448 432h32v16 16c0 8.8 7.2 16 16 16s16-7.2 16-16V368 352h32v16 96c0 26.5-21.5 48-48 48zM456 352h16c22.1 0 40 17.9 40 40v16H480V392c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8H464V432h16 16 16v16 24c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm-168 0h16 32c30.9 0 56 25.1 56 56s-25.1 56-56 56H320v32 16H288V496 448 368 352zm32 80h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H320v48z'
      
    ]
  };

  

  
  

  var faFlashlight = {
    prefix: 'fasr',
    iconName: 'flashlight',
    icon: [
      640,
      512,
      [128294],
      'f8b8',
      
      'M413.8 314.4l-13-10.4H384 48V208H384h16.8l13-10.4 0 0 .2-.2c.3-.2 .9-.7 1.8-1.3c1.8-1.3 4.6-3.3 8.5-5.8c7.7-5 19.3-11.9 34.1-18.8c15.2-7.1 33.2-14.1 53.6-19.3V359.8c-20.3-5.1-38.4-12.1-53.6-19.3c-14.7-6.9-26.3-13.8-34.1-18.8c-3.9-2.5-6.7-4.5-8.5-5.8c-.9-.6-1.5-1.1-1.8-1.3l-.2-.2 0 0zM576 368c-5.4 0-10.8-.2-16-.5v-223c5.2-.3 10.6-.5 16-.5h16V368H576zM592 96H576c-112 0-192 64-192 64H48 0v48 96 48H48 384s80 64 192 64h16 48V368 144 96H592zM248 232H224v48h24 48 24V232H296 248z'
      
    ]
  };

  

  
  

  var faCircleArrowLeft = {
    prefix: 'fasr',
    iconName: 'circle-arrow-left',
    icon: [
      512,
      512,
      ["arrow-circle-left"],
      'f0a8',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM135 239l-17 17 17 17 88 88 17 17L273.9 344l-17-17-47-47L360 280l24 0 0-48-24 0-150.1 0 47-47 17-17L240 134.1l-17 17-88 88z'
      
    ]
  };

  
    var faArrowCircleLeft = faCircleArrowLeft;
  

  
  

  var faBoxesPacking = {
    prefix: 'fasr',
    iconName: 'boxes-packing',
    icon: [
      640,
      512,
      [],
      'e4c7',
      
      'M592 48H304v80H256V48 0h48H592h48V48 464v48H592 384V464H592V48zM497 247l64 64L527 345l-23-23V392v24H456V392 321.9l-23 23L399 311l64-64 17-17 17 17zM336 208H48v48H80 304h32V208zM0 304V256 208 160H48 336h48v48 48 48H352V464v48H304 80 32V464 304H0zM80 464H304V304H80V464zM256 336v48H128V336H256z'
      
    ]
  };

  

  
  

  var faLeftRight = {
    prefix: 'fasr',
    iconName: 'left-right',
    icon: [
      512,
      512,
      [8596,"arrows-alt-h"],
      'f337',
      
      'M288 328l48 0 0 8 0 40 0 8 48 0 94.1-94.1L512 256l-33.9-33.9L384 128l-48 0 0 8 0 40 0 8-48 0-64 0-48 0 0-8 0-40 0-8-48 0L33.9 222.1 0 256l33.9 33.9L128 384l48 0 0-8 0-40 0-8 48 0 64 0zM128 316.1L67.9 256 128 195.9l0 36.1 48 0 160 0 48 0 0-36.1L444.1 256 384 316.1l0-36.1-48 0-160 0-48 0 0 36.1z'
      
    ]
  };

  
    var faArrowsAltH = faLeftRight;
  

  
  

  var faClockSeven = {
    prefix: 'fasr',
    iconName: 'clock-seven',
    icon: [
      512,
      512,
      [],
      'e350',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V248.7l-60 90-13.3 20 39.9 26.6 13.3-20 64-96 4-6V256 120 96H232v24z'
      
    ]
  };

  

  
  

  var faSeedling = {
    prefix: 'fasr',
    iconName: 'seedling',
    icon: [
      512,
      512,
      [127793,"sprout"],
      'f4d8',
      
      'M512 32V0H464h-8C370.5 0 296.1 48 258.4 118.5c12.1 14.5 22.7 30.2 31.6 47.1C314 97.1 379.3 48 456 48h7.3c-7.5 83.3-73.1 149.9-156 159c4.9 15.1 8.4 30.9 10.5 47.1c104.4-13.9 186.1-99.7 193.6-206c.4-5.3 .6-10.6 .6-16zM56 112c97.2 0 176 78.8 176 176v16h-8c-97.2 0-176-78.8-176-176V112h8zM279.9 280C275.6 160 177 64 56 64H48 0v48 16C0 251.7 100.3 352 224 352h8V488v24h48V488 352 304 288v-8h-.1z'
      
    ]
  };

  
    var faSprout = faSeedling;
  

  
  

  var faArrowsDownToPeople = {
    prefix: 'fasr',
    iconName: 'arrows-down-to-people',
    icon: [
      640,
      512,
      [],
      'e4b9',
      
      'M168 0V24l0 118.1 23-23 17-17L241.9 136l-17 17-64 64-17 17-17-17L63 153l-17-17L80 102.1l17 17 23 23L120 24l0-24h48zM280 200a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-22.3 56H272h96 14.3l6.8 12.6L434 352h14 96 14.1l6.9 12.3 56 100.8 11.7 21-42 23.3-11.7-21-19-34.2V488v24H536 456 432V488 454.2l-19 34.2-11.7 21-42-23.3 11.7-21 35.3-63.4-3.4-6.3-18.9-35V408v24H360 280 256V408 360.3l-18.9 35-3.4 6.3L269 465.1l11.7 21-42 23.3-11.7-21-19-34.2V488v24H184 104 80V488 454.2L61 488.5l-11.7 21-42-23.3 11.7-21L75 364.3 81.9 352H96h96 14l44.9-83.4 6.8-12.6zM304 304v80h32V304H304zm152-8a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 464h32V400H128v64zM520 24l0 118.1 23-23 17-17L593.9 136l-17 17-64 64-17 17-17-17-64-64-17-17L432 102.1l17 17 23 23L472 24V0h48V24zM480 400v64h32V400H480z'
      
    ]
  };

  

  
  

  var faBullseyeArrow = {
    prefix: 'fasr',
    iconName: 'bullseye-arrow',
    icon: [
      512,
      512,
      [127919],
      'f648',
      
      'M361.5 218.4c4.2 11.8 6.5 24.4 6.5 37.6c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c13.2 0 25.9 2.3 37.6 6.5l4.9-4.9-7.6-45.8C279.6 97.3 268 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-12-1.3-23.6-3.8-34.9l-45.8-7.6-4.9 4.9zm97.4-8.1c3.3 14.7 5 30 5 45.7c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c15.7 0 31 1.7 45.7 5l38.8-38.8C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5L459 210.3zm-93.9-29.4L432 192l80-80L432 80 400 0 320 80l11.2 66.9L231 247 265 281 365.1 180.8z'
      
    ]
  };

  

  
  

  var faFerry = {
    prefix: 'fasr',
    iconName: 'ferry',
    icon: [
      576,
      512,
      [],
      'e4ea',
      
      'M192 0h32H352h32V32h52 52L468 80h36 24v24V304v7.6l-4.3 6.2-56 80-39.3-27.5L463.5 320H448 400 176 128 112.5l35.2 50.2-39.3 27.5-56-80L48 311.6V304 104 80H72h36L88 32h52 52V0zM480 272V128H448 128 96V272h32V184 160h24H424h24v24 88h32zm-80 0V208H176v64H400zM79 488.9C59.7 499.8 31.5 512 0 512V464c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  

  
  

  var faTrianglePersonDigging = {
    prefix: 'fasr',
    iconName: 'triangle-person-digging',
    icon: [
      640,
      512,
      ["construction"],
      'f85d',
      
      'M0 512l30-48L291.7 45.3 320 0l28.3 45.3L610 464l30 48H583.4 56.6 0zM320 90.6L86.6 464H553.4L320 90.6zM312 176a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-26.1 65.1l40 16 5.6 2.3 2.7 5.4 27.6 55.3 52.1 31.3L432 320l64 112H368l30.2-52.8-56.7-34-85.7-51.4-14.4-8.6 9.3-14 16-24 7.2-10.8 12.1 4.8zm-33.8 91.6l60.3 37.7 7.5 4.7V384v32 16H304 288V416 392.9l-37.9-23.7L218.9 432H183.1l2.6-5.1 43.7-87.7 7.9-15.8 14.9 9.3z'
      
    ]
  };

  
    var faConstruction = faTrianglePersonDigging;
  

  
  

  var faCircleEnvelope = {
    prefix: 'fasr',
    iconName: 'circle-envelope',
    icon: [
      512,
      512,
      ["envelope-circle"],
      'e10c',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 188.2l128 67.2 128-67.2V160H128v28.2zm135.4 99.5l-7.4 3.9-7.4-3.9L128 224.3V352H384V224.3L263.4 287.6z'
      
    ]
  };

  
    var faEnvelopeCircle = faCircleEnvelope;
  

  
  

  var faInboxFull = {
    prefix: 'fasr',
    iconName: 'inbox-full',
    icon: [
      512,
      512,
      [],
      'e1ba',
      
      'M48 432V336h81.2l25.4 50.7 6.6 13.3H176 336h14.8l6.6-13.3L382.8 336H464v96H48zM402.5 80l52 208H368 353.2l-6.6 13.3L321.2 352H190.8l-25.4-50.7L158.8 288H144 57.5l52-208h293zM0 320V432v48H48 464h48V432 320L440 32H72L0 320zM184 128H160v48h24H328h24V128H328 184zm-32 80H128v48h24H360h24V208H360 152z'
      
    ]
  };

  

  
  

  var faPig = {
    prefix: 'fasr',
    iconName: 'pig',
    icon: [
      640,
      512,
      [128022],
      'f706',
      
      'M472 32h-3l-2.9 .7L417.1 45c-21.1 5.3-38.6 18-50.2 35H240C162.6 80 98 135 83.2 208H47.4c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2 15.5-3.9-7.8-31-15.5 3.9-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240H80v16c0 55.8 31.8 104.2 78.1 128.1L184 463.4l5.4 16.6h17.4H280h24V456 416h16 32v40 24h24 73.1 17.4l5.4-16.6 17.3-53.1c26.1-7.5 49.6-22.2 67.8-42.4H616h24V344 216 192H616 583.3c-6.7-4.7-12.5-10.5-17.2-17.3l-.1-.1c21.1-15.2 33.9-39.8 33.9-66.4V104 80H576 552v24 4.2c0 12.5-6.9 23.9-17.8 29.8c-4.1-3.8-8.3-7.4-12.7-10.8c4.2-10.3 6.5-21.5 6.5-33.2V56 32H504 472zM428.8 91.5L475 80h5V94c0 9.4-3.3 18.2-8.9 25.1l-16.9 21L477 154.5c19.3 12.2 36.3 28.2 49.7 47.6c9.9 14.2 22.7 26.1 37.7 34.7l5.6 3.2h6.4H592v80H545.8 533.9l-7.2 9.5c-14.7 19.4-36.2 32.6-60.3 37L452.3 369l-4.5 13.6L431.7 432H400V392 368H376 320 280 256v24 40H224.3l-23.7-72.7-3.4-10.4L187 344.6c-34.7-14.5-59-48.8-59-88.6V240c0-61.9 50.1-112 112-112H381h15.8l6.2-14.5c4.6-10.7 13.9-19 25.7-21.9zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  

  
  

  var faVest = {
    prefix: 'fasr',
    iconName: 'vest',
    icon: [
      448,
      512,
      [],
      'e085',
      
      'M143 0h10.8 5.1l6 14.2 .1 .1c.2 .4 .7 1.2 1.4 2.3c1.5 2.2 4.1 5.4 8.3 8.8C182.6 31.9 197.5 40 224 40s41.4-8.1 49.3-14.6c4.1-3.4 6.8-6.6 8.3-8.8c.7-1.1 1.2-1.9 1.4-2.3l.1-.1 6-14.2h5.1H305h7 64 24V24 128v65.4l44.6 74.3 3.4 5.7V280 488v24H424 232 208V488 288v-3.6l1-3.4 60.6-200C256.9 85.3 241.8 88 224 88s-32.9-2.7-45.6-6.9l28.9 95.4-25.1 82.8L118.2 48H96v80 72 6.6l-3.4 5.7L48 286.6V398.1l55-55 17-17L153.9 360l-17 17-87 87H176v24 24H24 0V488 280v-6.6l3.4-5.7L48 193.4V128 24 0H72h64 7zM329.8 48L256 291.6V464H398.1l-87-87-17-17L328 326.1l17 17 55 55V286.6l-44.6-74.3-3.4-5.7V200 128 48H329.8z'
      
    ]
  };

  

  
  

  var faArrowsTurnRight = {
    prefix: 'fasr',
    iconName: 'arrows-turn-right',
    icon: [
      448,
      512,
      [],
      'e4c0',
      
      'M315.3 6.1L333 22.3 422.1 104H424v1.7l5 4.6L448.3 128 429 145.7l-5 4.6V152h-1.9L333 233.7l-17.7 16.2-32.4-35.4 17.7-16.2L351.1 152H48V264v24H0V264 128 104H24 351.1L300.6 57.7 282.9 41.5 315.3 6.1zm-84.8 256l17.7 16.2 96 88L363.5 384l-19.3 17.7-96 88-17.7 16.2-32.4-35.4 17.7-16.2L266.3 408H48v80 24H0V488 384 360H24 266.3l-50.5-46.3-17.7-16.2 32.4-35.4z'
      
    ]
  };

  

  
  

  var faObjectsAlignRight = {
    prefix: 'fasr',
    iconName: 'objects-align-right',
    icon: [
      512,
      512,
      [],
      'e3bf',
      
      'M512 512L512 0 464 0l0 512 48 0zM336 176L48 176l0-64 288 0 0 64zm48-64l0-48-48 0L48 64 0 64l0 48 0 64 0 48 48 0 288 0 48 0 0-48 0-64zM336 400l-160 0 0-64 160 0 0 64zm48-64l0-48-48 0-160 0-48 0 0 48 0 64 0 48 48 0 160 0 48 0 0-48 0-64z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fasr',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      'M384 0h24H520h24V24 136v24H496V136 81.9l-1 .8-160 128-15.1 12.1-15-12.2L191.3 118.3l-137 101L34.9 233.6 6.4 194.9l19.3-14.2 152-112 15-11 14.4 11.7 113 91.8L461.6 48H408 384V0zM200 264H184V440h16V264zm-16-40h16 40v40V440v40H200 184 144V440 264 224h40zM72 360H56v80H72V360zM56 320H72h40v40 80 40H72 56 16V440 360 320H56zm232 48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM467.3 426l25.3 25.3 22.6-22.6L490 403.3c13.2-21.6 13.2-49.1 0-70.7l25.3-25.3-22.6-22.6L467.3 310c-21.6-13.2-49.1-13.2-70.7 0l-25.3-25.3-22.6 22.6L374 332.7c-13.2 21.6-13.2 49.1 0 70.7l-25.3 25.3 22.6 22.6L396.7 426c21.6 13.2 49.1 13.2 70.7 0z'
      
    ]
  };

  

  
  

  var faTransporter4 = {
    prefix: 'fasr',
    iconName: 'transporter-4',
    icon: [
      512,
      512,
      [],
      'e2a5',
      
      'M224 0h64 16V32H288 224 208V0h16zm0 64h64 16V96H288 224 208V64h16zm-48 64H336h16v32H336 176 160V128h16zm-32 64H368h16v32H368 144 128V192h16zm-32 64H400h16v32H400 112 96V256h16zm64 64H336h16v32H336 176 160V320h16zm0 64H336h16v32H336 176 160V384h16zM464 128l16 32 32 16-32 16-16 32-16-32-32-16 32-16 16-32zM48 352l16 32 32 16L64 416 48 448 32 416 0 400l32-16 16-32zM96 464h24H392h24v48H392 120 96V464z'
      
    ]
  };

  

  
  

  var faPalette = {
    prefix: 'fasr',
    iconName: 'palette',
    icon: [
      512,
      512,
      [127912],
      'f53f',
      
      'M464 256v16H355.9c-64 0-115.9 51.9-115.9 115.9c0 20.2 5.3 39.9 15.1 57.2L237 463.1C131 453.5 48 364.5 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208zM320 448l-12.1-12.1c-12.7-12.7-19.9-30-19.9-48c0-37.5 30.4-67.9 67.9-67.9H464h48V272 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512l30.1-30.1L320 448zM256 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm224-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCloudArrowUp = {
    prefix: 'fasr',
    iconName: 'cloud-arrow-up',
    icon: [
      640,
      512,
      [62338,"cloud-upload","cloud-upload-alt"],
      'f0ee',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM223 255l80-80 17-17 17 17 80 80 17 17L400 305.9l-17-17-39-39V384v24H296V384 249.9l-39 39-17 17L206.1 272l17-17z'
      
    ]
  };

  
    var faCloudUpload = faCloudArrowUp;
  
    var faCloudUploadAlt = faCloudArrowUp;
  

  
  

  var faFontAwesome = {
    prefix: 'fasr',
    iconName: 'font-awesome',
    icon: [
      512,
      512,
      [62501,62694,"font-awesome-flag","font-awesome-logo-full"],
      'f2b4',
      
      'M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 48 0 256 0 48 0 64 48 0 0-64 368 0 48 0 0-32-7.1-16L432 272l56.9-128 7.1-16 0-32-48 0L91.7 96zM80 400l0-256 356.4 0L388.1 252.5 379.5 272l8.7 19.5L436.4 400 80 400z'
      
    ]
  };

  
    var faFontAwesomeFlag = faFontAwesome;
  
    var faFontAwesomeLogoFull = faFontAwesome;
  

  
  

  var faGasPumpSlash = {
    prefix: 'fasr',
    iconName: 'gas-pump-slash',
    icon: [
      640,
      512,
      [],
      'f5f4',
      
      'M564.3 415.3C571.7 404 576 390.5 576 376V136v-9.9l-7-7L481 31l-17-17L430.1 48l17 17 33 33V160c0 29.8 20.4 54.9 48 62V376c0 3.4-.7 6.7-2 9.6L384 275.4V48 0H336 144 96V48v3.8l-47.6-37L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-56.6-43.9zM144 89V48H336V238.1L144 89zM384 398.5l-48-37.8V464H144V209.5L96 171.6V464l-32 0v48H96h48H336h48 32V464l-32 0V398.5z'
      
    ]
  };

  

  
  

  var faCrutch = {
    prefix: 'fasr',
    iconName: 'crutch',
    icon: [
      512,
      512,
      [],
      'f7f7',
      
      'M340.2 18.2L493.8 171.8l17 17-33.9 33.9-17-17L306.2 52.2l-17-17L323.2 1.3l17 17zM151 215L287.4 78.6l33.9 33.9L249.9 184 328 262.1l71.4-71.4 33.9 33.9L297 361l-4.9 4.9-6.8 1.5L148 397.9 52.2 493.8l-17 17L1.3 476.8l17-17L114.1 364l30.5-137.2 1.5-6.8L151 215zm143 81L216 217.9 189.9 244 167.6 344.4 268 322.1 294.1 296z'
      
    ]
  };

  

  
  

  var faSquareALock = {
    prefix: 'fasr',
    iconName: 'square-a-lock',
    icon: [
      576,
      512,
      [],
      'e44d',
      
      'M48 80H400V180.1c14-9.8 30.3-16.4 48-18.9V80 32H400 48 0V80 432v48H48 320l0-48H48V80zm197.7 61.8L239.2 128H208.8l-6.5 13.8L88.6 384h53l22.5-48H283.8l22.5 48H320l0-83.9L245.7 141.8zM224 208.5L261.3 288H186.7L224 208.5zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48H352V512H576V320H544V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faUserVneckHairLong = {
    prefix: 'fasr',
    iconName: 'user-vneck-hair-long',
    icon: [
      448,
      512,
      [],
      'e463',
      
      'M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H208l32-32 16 16h41.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16 48L48 240v32H224 400V240l-48-48V144 128C352 57.3 294.7 0 224 0zM185.6 444.8L200 464H66.6l32-96H128l57.6 76.8zM381.4 464H248l14.4-19.2L320 368h29.4l32 96zM384 320H296l-42 56-30 40-30-40-42-56H64L16 464 0 512H50.6 397.4 448l-16-48L384 320z'
      
    ]
  };

  

  
  

  var faCircleCaretUp = {
    prefix: 'fasr',
    iconName: 'circle-caret-up',
    icon: [
      512,
      512,
      ["caret-circle-up"],
      'f331',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 272v32H384V272L256 144 128 272z'
      
    ]
  };

  
    var faCaretCircleUp = faCircleCaretUp;
  

  
  

  var faUfoBeam = {
    prefix: 'fasr',
    iconName: 'ufo-beam',
    icon: [
      576,
      512,
      [],
      'e048',
      
      'M152.5 163.3l-16.9 17c-4-4-6.5-9.2-7-14.9c-.6-7-.8-14-.5-20.7c-22 6.7-40.3 14.6-53.9 23C52.5 181.2 48 192.2 48 197.9c0 4.1 2.2 11 12.6 20.2c10.4 9.1 26.8 18.4 49.1 26.7C154.2 261.3 217.2 272 288 272s133.8-10.7 178.3-27.2c22.3-8.3 38.7-17.6 49.1-26.7c10.4-9.2 12.6-16 12.6-20.2c0-5.7-4.5-16.7-26.2-30.1c-13.7-8.4-31.9-16.3-53.9-23c.3 6.8 .1 13.7-.5 20.7c-.5 5.6-3 10.9-7 14.9l-16.9-17c16.9 17 16.9 17 16.9 17.1l0 0 0 0-.1 .1-.3 .3c-.2 .2-.4 .4-.7 .7c-.6 .5-1.3 1.1-2.1 1.9c-1.8 1.5-4.2 3.3-7.3 5.5c-6.3 4.3-15.4 9.7-27.7 14.9C377.4 214.2 340.3 224 288 224s-89.4-9.8-114.1-20.2c-12.3-5.2-21.4-10.6-27.7-14.9c-3.1-2.2-5.6-4-7.3-5.5c-.9-.7-1.6-1.4-2.1-1.9c-.3-.3-.5-.5-.7-.7l-.3-.3-.1-.1 0 0 0 0c0 0 0 0 16.9-17.1zM49 126.9c24-14.8 55.6-26.7 91.7-35.2C165.7 36.3 224.3 0 288 0s122.3 36.3 147.3 91.7c36.1 8.6 67.8 20.4 91.7 35.2c26.1 16.1 49 39.7 49 70.9c0 23-12.6 41.9-28.9 56.2c-16.3 14.4-38.6 26.2-64.1 35.7C432 308.7 363 320 288 320s-144-11.3-195-30.2c-25.4-9.5-47.7-21.3-64.1-35.7C12.6 239.8 0 220.8 0 197.9c0-31.2 22.9-54.8 49-70.9zm351 24c-.5-57.5-50.3-103-112-103s-111.4 45.5-112 103c3.8 2.4 9.3 5.5 16.7 8.6c18.4 7.8 49.1 16.4 95.3 16.4s76.9-8.6 95.3-16.4c7.4-3.1 12.9-6.2 16.7-8.6zM117.5 362.7l-64 128L42.7 512.2-.2 490.7l10.7-21.5 64-128 10.7-21.5 42.9 21.5-10.7 21.5zm384-21.5l64 128 10.7 21.5-42.9 21.5-10.7-21.5-64-128-10.7-21.5 42.9-21.5 10.7 21.5z'
      
    ]
  };

  

  
  

  var faSmog = {
    prefix: 'fasr',
    iconName: 'smog',
    icon: [
      640,
      512,
      [],
      'f75f',
      
      'M331.1 252l-13.6-12H299.3 176 80V144c0-53 43-96 96-96c23 0 44.1 8.1 60.6 21.5l31.7 25.8 30.6-27.2C313 55.6 331.6 48 352 48c30.6 0 57.3 17.2 70.8 42.7L441 125.1l37.4-10.7c5.5-1.6 11.4-2.4 17.6-2.4c35.3 0 64 28.7 64 64v64H496 468.7 450.5l-13.6 12c-14.1 12.5-32.6 20-52.9 20s-38.8-7.5-52.9-20zM32 288H80h96H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496h64 48V240 176c0-61.9-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144v96 48zm584 80H280 256v48h24H616h24V368H616zm-64 96H440 416v48h24H552h24V464H552zm-192 0H24 0v48H24 360h24V464H360zM224 368H200 96 72v48H96 200h24V368z'
      
    ]
  };

  

  
  

  var faBlindsRaised = {
    prefix: 'fasr',
    iconName: 'blinds-raised',
    icon: [
      512,
      512,
      [],
      'f8fd',
      
      'M0 0V48H20L12 80 0 128H49.5 112V80H61.5l8-32H112h32V80v48 80 48V372.1C116 382 96 408.6 96 440c0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.4-20-58-48-67.9V256 208 128 80 48h32H442.5l8 32H224v48H462.5 512L500 80l-8-32h20V0H488h-8H192 144 32 24 0zM144 440a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 208H63l13.2-48H26.5L13.2 208 0 256H49.8 112V208zm112 48H462.2 512l-13.2-48-13.2-48H435.7L449 208H224v48z'
      
    ]
  };

  

  
  

  var faMoneyBills = {
    prefix: 'fasr',
    iconName: 'money-bills',
    icon: [
      640,
      512,
      [],
      'e1f3',
      
      'M528 80c0 35.3 28.7 64 64 64V272c-35.3 0-64 28.7-64 64H208c0-35.3-28.7-64-64-64V144c35.3 0 64-28.7 64-64H528zM144 32H96V80 336v48h48H592h48V336 80 32H592 144zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120V96H0v24V456v24H24 520h24V432H520 48V120z'
      
    ]
  };

  

  
  

  var faFaceTired = {
    prefix: 'fasr',
    iconName: 'face-tired',
    icon: [
      512,
      512,
      [128555,"tired"],
      'f5c8',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 368c-41.8 0-80.5 12.2-112 33l0-1c0-61.9 50.1-112 112-112s112 50.1 112 112l0 1c-31.5-20.8-70.2-33-112-33zM112 144l118.9 64L112 272l45.7-64L112 144zm169.1 64L400 144l-45.7 64L400 272 281.1 208z'
      
    ]
  };

  
    var faTired = faFaceTired;
  

  
  

  var faHouseLaptop = {
    prefix: 'fasr',
    iconName: 'house-laptop',
    icon: [
      640,
      512,
      ["laptop-house"],
      'e066',
      
      'M240 1.3l15 12 200 160 18.7 15-30 37.5-18.7-15-9-7.2V240H368V165.1L240 62.7 112 165.1V368H272v48H88 64V392 203.5l-9 7.2-18.7 15-30-37.5 18.7-15 200-160 15-12zM288 192v48H272v48H192V192h96zM544 320H352V464H544V320zm-240 0V272h48H544h48v48V464h48v24l-24 24H592 544 352 304 280l-24-24V464h48V320z'
      
    ]
  };

  
    var faLaptopHouse = faHouseLaptop;
  

  
  

  var faBurst = {
    prefix: 'fasr',
    iconName: 'burst',
    icon: [
      512,
      512,
      [],
      'e4dc',
      
      'M312.8 118.8L282.6 55.6 256 0 229.4 55.6 220 75.3l-20.8 43.5L157.8 94.1l-71-42.4L0 0 51.8 86.8l42.4 71 24.7 41.4L75.3 220l-19.7 9.4L0 256l55.6 26.6 63.2 30.2-23.3 66L75 437l58.1-20.5 66-23.3 30.2 63.2L256 512l26.6-55.6 30.2-63.2 66 23.3L437 437l-20.5-58.2-23.3-66 63.2-30.2L512 256l-55.6-26.6-63.2-30.2 23.3-66L437 75 378.9 95.5l-66 23.3zm45.5 34.8l-10.4 29.5-14.4 40.7 38.9 18.6L400.7 256l-28.3 13.5-38.9 18.6 14.4 40.7 10.4 29.5-29.5-10.4-40.7-14.4-18.6 38.9L256 400.7l-13.5-28.3-18.6-38.9-40.7 14.4-29.5 10.4 10.4-29.5 14.4-40.7-38.9-18.6L111.3 256l28.3-13.5L187 219.8l-27-45.2-21.5-36 36 21.5 45.2 27 22.7-47.5L256 111.3l13.5 28.3 18.6 38.9 40.7-14.4 29.5-10.4z'
      
    ]
  };

  

  
  

  var faIntegral = {
    prefix: 'fasr',
    iconName: 'integral',
    icon: [
      320,
      512,
      [],
      'f667',
      
      'M136 0h24H272h24V24 96v24H248V96 48H184V488v24H160 48 24V488 416 392H72v24 48h64V24 0z'
      
    ]
  };

  

  
  

  var faDiamondTurnRight = {
    prefix: 'fasr',
    iconName: 'diamond-turn-right',
    icon: [
      512,
      512,
      ["directions"],
      'f5eb',
      
      'M33.9 289.9L0 256l33.9-33.9L222.1 33.9 256 0l33.9 33.9L478.1 222.1 512 256l-33.9 33.9L289.9 478.1 256 512l-33.9-33.9L33.9 289.9zM67.9 256L256 444.1 444.1 256 256 67.9 67.9 256zM304 144l80 80-80 80H288V248H224v48 24H176V296 224 200h24 88V144h16z'
      
    ]
  };

  
    var faDirections = faDiamondTurnRight;
  

  
  

  var faSubscript = {
    prefix: 'fasr',
    iconName: 'subscript',
    icon: [
      512,
      512,
      [],
      'f12c',
      
      'M24 64H0v48H24 51.2l96 144-96 144H24 0v48H24 64 76.8L84 437.3l92-138 92 138 7.1 10.7H288h40 24V400H328 300.8l-96-144 96-144H328h24V64H328 288 275.2L268 74.7l-92 138L84 74.7 76.8 64H64 24zM408 288H384v48h24 16V464H408 384v48h24 16 48 16 24V464H488 472V312 288H448 408z'
      
    ]
  };

  

  
  

  var faGlobeSnow = {
    prefix: 'fasr',
    iconName: 'globe-snow',
    icon: [
      448,
      512,
      [],
      'f7a3',
      
      'M400 224c0 71-42 132.2-102.6 160h83.3c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160h83.3C90 356.2 48 295 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zm-96 32V240l-80-80-80 80v16h32l-48 48v16h72v64h48V320h72V304l-48-48h32zM256 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-200-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM0 512H448l-64-96H64L0 512z'
      
    ]
  };

  

  
  

  var faScaleUnbalancedFlip = {
    prefix: 'fasr',
    iconName: 'scale-unbalanced-flip',
    icon: [
      640,
      512,
      ["balance-scale-right"],
      'f516',
      
      'M400 80c0 2.8-.1 5.5-.4 8.3l127.7 40.9 22.9 7.3-14.6 45.7-22.9-7.3L380.4 132.5c-9.6 11-22.1 19.4-36.4 23.8V488v24H320 120 96V464h24H296V156.3c-30.1-9.5-52.5-36.2-55.6-68.6L112.7 46.9 127.3 1.1 250.4 40.5C264.2 16.3 290.2 0 320 0c44.2 0 80 35.8 80 80zM542.5 224l6.7 12.9 88 168 2.7 5.2V416v32 9.9l-7 7-40 40-7 7H576 448h-9.9l-7-7-40-40-7-7V448l0-32v-5.9l2.7-5.2 88-168 6.7-12.9H496h32 14.5zm-29 48h-3L435.1 416H588.9L513.5 272zM144 96h14.5l6.7 12.9 88 168 2.7 5.2V288v32 9.9l-7 7-40 40-7 7H192 64 54.1l-7-7L7 337l-7-7V320 288v-5.9l2.7-5.2 88-168L97.5 96H112h32zm60.9 192L129.5 144h-3L51.1 288H204.9zM320 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faBalanceScaleRight = faScaleUnbalancedFlip;
  

  
  

  var faAddressCard = {
    prefix: 'fasr',
    iconName: 'address-card',
    icon: [
      576,
      512,
      [62140,"contact-card","vcard"],
      'f2bb',
      
      'M528 80V432H48V80H528zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 384H320l-32-96H128L96 384zM376 144H352v48h24 80 24V144H456 376zm0 96H352v48h24 80 24V240H456 376z'
      
    ]
  };

  
    var faContactCard = faAddressCard;
  
    var faVcard = faAddressCard;
  

  
  

  var faTrashCanPlus = {
    prefix: 'fasr',
    iconName: 'trash-can-plus',
    icon: [
      448,
      512,
      [],
      'e2ac',
      
      'M160 0H147.2L140 10.7 93.8 80H80 32 0v48H32V464v48H80 368h48V464 128h32V80H416 368 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM80 464V128H368V464H80zm120-64h48V376 312h64 24V264H312 248V200l0-24H200v24 64H136 112v48h24 64v64 24z'
      
    ]
  };

  

  
  

  var faRegistered = {
    prefix: 'fasr',
    iconName: 'registered',
    icon: [
      512,
      512,
      [174],
      'f25d',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v24V264v96 24h48V360 288h42.9l61.3 96h57l-62.7-98.1c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80H184 160zm48 112V176h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H264 208z'
      
    ]
  };

  

  
  

  var faGaugeLow = {
    prefix: 'fasr',
    iconName: 'gauge-low',
    icon: [
      512,
      512,
      ["tachometer-alt-slow"],
      'f627',
      
      'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56c0-14 5.1-26.8 13.7-36.6L146 161.7l-9.7-22 43.9-19.3 9.7 22L257.6 296c30.2 .8 54.4 25.6 54.4 56c0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  
    var faTachometerAltSlow = faGaugeLow;
  

  
  

  var faBomb = {
    prefix: 'fasr',
    iconName: 'bomb',
    icon: [
      512,
      512,
      [128163],
      'f1e2',
      
      'M432 0l26.7 53.3L512 80l-53.3 26.7L432 160l-26.7-53.3L352 80l53.3-26.7L432 0zM290.9 163.7l-28.7-10.3c-16.9-6.1-35.1-9.4-54.2-9.4c-88.4 0-160 71.6-160 160s71.6 160 160 160s160-71.6 160-160c0-19.1-3.3-37.4-9.4-54.2l-10.3-28.7L361.4 208 304 150.6l-13.1 13.1zm47-47l57.4 57.4 11.3 11.3L429.3 208l-22.6 22.6-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9L304 82.7l22.6 22.6 11.3 11.3zM208 224c-44.2 0-80 35.8-80 80H80c0-70.7 57.3-128 128-128v48z'
      
    ]
  };

  

  
  

  var faTemperatureEmpty = {
    prefix: 'fasr',
    iconName: 'temperature-empty',
    icon: [
      320,
      512,
      ["temperature-0","thermometer-0","thermometer-empty"],
      'f2cb',
      
      'M85.3 307.7L96 294.5v-17V48H224V277.5v17l10.7 13.2C248 324.2 256 345.1 256 368c0 53-43 96-96 96s-96-43-96-96c0-22.9 8-43.8 21.3-60.3zM272 0H224 96 48V48 277.5C28 302.2 16 333.7 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5V48 0zM160 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faTemperature0 = faTemperatureEmpty;
  
    var faThermometer0 = faTemperatureEmpty;
  
    var faThermometerEmpty = faTemperatureEmpty;
  

  
  

  var faHillAvalanche = {
    prefix: 'fasr',
    iconName: 'hill-avalanche',
    icon: [
      576,
      512,
      [],
      'e507',
      
      'M41 71L0 30.1V88 488v24H24 424h57.9l-41-41L41 71zm7 393V145.9L366.1 464H48zm503.1-72.9c34.4-34.4 34.4-90.1 0-124.4s-90.1-34.4-124.5 0l33.9 33.9c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8zM448 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faPlaneEngines = {
    prefix: 'fasr',
    iconName: 'plane-engines',
    icon: [
      576,
      512,
      [9992,"plane-alt"],
      'f3de',
      
      'M576 256c0-14.7-6.3-27.2-13.9-36.7c-7.6-9.5-17.4-17.3-27.5-23.3c-19.6-11.9-44.3-20-64.6-20l-99.5 0-27.4-48H368V64H306.5L276.8 12.1 269.9 0H256 176 144.2l8.7 30.6L194.5 176 164 176l-40.8-54.4L116 112l-12 0H32-1.3L9.2 143.6 36.7 226C24.6 230.6 16 242.3 16 256s8.6 25.4 20.7 30L9.2 368.4-1.3 400H32h72 12l7.2-9.6L164 336l30.5 0L152.9 481.4 144.2 512H176l80 0h13.9l6.9-12.1L306.5 448H368V384H343.1l27.4-48H470c20.2 0 44.9-7.8 64.5-19.6C553 305.4 576 285.1 576 256zM470 224c9.5 0 25.8 4.6 39.7 13c6.7 4.1 11.8 8.4 14.9 12.3c3.1 3.9 3.3 6.1 3.3 6.7c0 2.4-3 10.1-18.1 19.2C496 283.6 479.8 288 470 288H356.6 342.6l-6.9 12.1L242.1 464H207.8l41.5-145.4 8.7-30.6H226.3L152 288H140l-7.2 9.6L92 352H65.3l29.5-88.4 2.5-7.6-2.5-7.6L65.3 160H92l40.8 54.4L140 224h12l74.3 0 31.8 0-8.7-30.6L207.8 48h34.3l93.7 163.9 6.9 12.1h13.9L470 224z'
      
    ]
  };

  
    var faPlaneAlt = faPlaneEngines;
  

  
  

  var faClockEightThirty = {
    prefix: 'fasr',
    iconName: 'clock-eight-thirty',
    icon: [
      512,
      512,
      [],
      'e346',
      
      'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V300.8L173.3 340l-20 13.3-26.6-39.9 20-13.3 96-64L280 211.2V256 392v24H232V392z'
      
    ]
  };

  

  
  

  var faPause = {
    prefix: 'fasr',
    iconName: 'pause',
    icon: [
      320,
      512,
      [9208],
      'f04c',
      
      'M48 112V400H96V112H48zM0 64H48 96h48v48V400v48H96 48 0V400 112 64zm224 48V400h48V112H224zM176 64h48 48 48v48V400v48H272 224 176V400 112 64z'
      
    ]
  };

  

  
  

  var faLocationPinLock = {
    prefix: 'fasr',
    iconName: 'location-pin-lock',
    icon: [
      512,
      512,
      [],
      'e51f',
      
      'M249.2 365.8c2.3-3.1 4.6-6.3 6.8-9.5l0 79.9c-11.7 14.9-22.7 28.2-32.2 39.4C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-16.9 2.8-32.6 9.4-46.1 18.9C329.6 106.3 267.6 48 192 48C112.5 48 48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm288 48c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H288V320h32V272z'
      
    ]
  };

  

  
  

  var faStrawberry = {
    prefix: 'fasr',
    iconName: 'strawberry',
    icon: [
      512,
      512,
      [],
      'e32b',
      
      'M360 0s-40 40-40 80c0 33.9 11 44.3 29.4 61.7l0 0c3.3 3.1 6.9 6.5 10.6 10.3s7.1 7.3 10.3 10.6l0 0 0 0C387.7 181 398.1 192 432 192c40 0 80-40 80-40s-29.5-36.8-74.3-39.8c.7-.7 1.5-1.5 2.2-2.2c21.5-21.5 48.2-52.2 62.1-84.5L457.9 6.5C447.8 30.2 426.5 55.5 406 76c-2 2-4.1 4-6 5.9c0-.6 0-1.3 0-2c0-48-40-80-40-80zM192.2 112c20.5 0 40.8 7.8 56.4 23.4l128 128c15.6 15.6 23.4 36 23.4 56.6c0 59.2-62.9 144-224 144H48V336c0-161 84.9-224 144.2-224zm0-48C96.2 64 0 160 0 336V464v48H48 176c176 0 272-96 272-192c0-32.8-12.5-65.5-37.5-90.5l-128-128C257.6 76.6 224.9 64.1 192.2 64zM180.8 188.8c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6zm-24 88c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6zm57.6 20.8s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6s9.6-35.2 9.6-35.2zm46.4 83.2c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6zM134.4 329.6s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6s9.6-35.2 9.6-35.2zm38.4 83.2c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6zm73.6-195.2s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6s9.6-35.2 9.6-35.2zm38.4 83.2c11.9-11.9 9.6-35.2 9.6-35.2s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6zm73.6 20.8s-23.3-2.3-35.2 9.6s-9.6 35.2-9.6 35.2s23.3 2.3 35.2-9.6s9.6-35.2 9.6-35.2z'
      
    ]
  };

  

  
  

  var faArrowLeftFromLine = {
    prefix: 'fasr',
    iconName: 'arrow-left-from-line',
    icon: [
      448,
      512,
      [8612,"arrow-from-right"],
      'f344',
      
      'M400 88l0-24 48 0 0 24 0 336 0 24-48 0 0-24 0-336zM18.8 273.5L.2 256l18.6-17.5 136-128 17.5-16.4 32.9 35-17.5 16.4L95.7 232 296 232l24 0 0 48-24 0L95.7 280l91.9 86.5L205.1 383l-32.9 35-17.5-16.5-136-128z'
      
    ]
  };

  
    var faArrowFromRight = faArrowLeftFromLine;
  

  
  

  var faSpa = {
    prefix: 'fasr',
    iconName: 'spa',
    icon: [
      576,
      512,
      [],
      'f5bb',
      
      'M221.7 221.4c11.3-38.9 28.1-70.3 44.6-94.3c7.5-11 14.9-20.3 21.7-28.2c6.8 7.8 14.2 17.2 21.7 28.2c16.5 24 33.3 55.4 44.6 94.3c13.2-9.9 27.3-18.8 42-26.6C360.4 86.3 288 32 288 32s-72.4 54.3-108.3 162.8c14.8 7.7 28.8 16.6 42 26.6zM4 240C23.3 355.2 111 447.2 224 472.9c17.3 3.9 35.9 7.1 53.7 7.1h20.6c17.8 0 36.4-3.2 53.7-7.1C465 447.2 552.7 355.2 572 240c2.6-15.6 4-31.6 4-48c-4.6 0-9.2 0-13.8-.1c-11.4-.1-22.8-.2-34.2 .3c-67.9 2.5-129.4 29.7-176 72.8c-26.9 24.9-48.8 55.1-64 89c-15.2-33.9-37.1-64.1-64-89c-46.6-43.1-108.1-70.3-176-72.8c-11.4-.4-22.8-.3-34.2-.3C9.2 192 4.6 192 0 192c0 16.4 1.4 32.4 4 48zm220 97.8c18.8 27.2 31.8 58.7 37.2 92.7c-12.7-1.4-25.1-3.8-37.2-7.1C137.8 399.6 71 328.9 52.9 240.5c71 4.7 133 42.1 171.1 97.3zm128 0c38.1-55.2 100.1-92.6 171.1-97.3C505 328.9 438.2 399.6 352 423.4c-12 3.3-24.5 5.7-37.2 7.1c5.4-34 18.4-65.5 37.2-92.7z'
      
    ]
  };

  

  
  

  var faScroll = {
    prefix: 'fasr',
    iconName: 'scroll',
    icon: [
      576,
      512,
      [128220],
      'f70e',
      
      'M48 112c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 44.2 35.8 80 80 80H496c44.2 0 80-35.8 80-80V328 304H552h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H541h-.7-.7H539h-.7-.7H537h-.7-.7H535h-.7-.7H533h-.7-.7H531h-.7-.7H529h-.7-.7H527h-.7-.7-.6-.7-.6-.6-.6-.6-.6-.6-.6-.6-.6H518h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H511h-.6-.6-.6-.6-.6-.6-.6H506h-.6-.6-.6-.6-.6-.6-.6H501h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H490h-.6-.6-.6-.6H487h-.6-.6-.6-.6H484h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H477h-.6-.6-.6-.6H474h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H463h-.6-.6-.6-.6-.6-.6H459h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H450h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H441h-.6-.6-.6-.6-.6-.6-.6-.6H436h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H430h-.6-.5-.6-.6-.5-.6-.5-.5H425h-.6-.5-.5-.5-.5-.5-.5-.5-.5-.5H419h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H413h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H406h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H400h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H394h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H387h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H381h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H375h-.5-.5-.5-.6-.5-.6-.6-.5H370h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H364h-.6-.6-.6-.6-.6-.6-.6-.6H359h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H350h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H341h-.6-.6-.6-.6-.6-.6H337h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H326h-.6-.6-.6-.6H323h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H316h-.6-.6-.6-.6H313h-.6-.6-.6-.6H310h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H299h-.6-.6-.6-.6-.6-.6-.6H294h-.6-.6-.6-.6-.6-.6-.6H289h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H282h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.7-.7-.7-.7H273h-.7-.7H271h-.7-.7H269h-.7-.7H267h-.7-.7H265h-.7-.7H263h-.7-.7H261h-.7-.7H259h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H248 224v24 72c0 17.7-14.3 32-32 32s-32-14.3-32-32V112c0-11.4-2.4-22.2-6.7-32H400c17.7 0 32 14.3 32 32V272h48V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v72 24H24 80V160H48V112zM496 432H265.3c4.3-9.8 6.7-20.6 6.7-32V352h.3 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .6 .6 .5 .6 .5 .5 .5 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .5 .5 .6 .5 .6 .6 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .7 .6 .7 .7 .7 .3v48c0 17.7-14.3 32-32 32z'
      
    ]
  };

  

  
  

  var faSquareF = {
    prefix: 'fasr',
    iconName: 'square-f',
    icon: [
      448,
      512,
      [],
      'e270',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm152 96H296h24v48H296 176v64h88 24v48H264 176v72 24H128V360 264 152 128h24z'
      
    ]
  };

  

  
  

  var faBoxOpen = {
    prefix: 'fasr',
    iconName: 'box-open',
    icon: [
      640,
      512,
      [],
      'f49e',
      
      'M0 160l224 64L320 64 64 32 0 160zM320 64l96 160 224-64L576 32 320 64zm-1.1 64h2.2l0 0h-2.2l0 0zM528 225.3V378.5l-184 46V192H296V424.5l-184-46V225.3L64 211.6V416l256 64 256-64V211.6l-48 13.7z'
      
    ]
  };

  

  
  

  var faKerning = {
    prefix: 'fasr',
    iconName: 'kerning',
    icon: [
      640,
      512,
      [],
      'f86f',
      
      'M442.6 41.5l9.5-22L408 .5l-9.5 22-193.1 448-9.5 22 44.1 19 9.5-22 193.1-448zM1.4 96L138.1 401.8l6.4 14.2h31.1l6.4-14.2L318.6 96H266L160 333.2 54 96H1.4zm463.1 0l-6.3 14.2L321.4 416H374l28.6-64H557.4L586 416h52.6L501.9 110.2 495.6 96H464.4zM480 178.8L536 304H424l56-125.2z'
      
    ]
  };

  

  
  

  var faLightEmergencyOn = {
    prefix: 'fasr',
    iconName: 'light-emergency-on',
    icon: [
      640,
      512,
      [],
      'e420',
      
      'M69.3 36l-20-13.3L22.7 62.7 42.7 76l48 32 20 13.3 26.6-39.9L117.3 68l-48-32zM597.3 76l20-13.3L590.7 22.7 570.7 36l-48 32-20 13.3 26.6 39.9 20-13.3 48-32zM24 192H0v48H24 72 96V192H72 24zm544 0H544v48h24 48 24V192H616 568zM448 208v96h48V208c0-97.2-78.8-176-176-176s-176 78.8-176 176v96h48V208c0-70.7 57.3-128 128-128s128 57.3 128 128zM144 432V384H496v48H144zM96 336v48 48 48h48H496h48V432 384 336H496 144 96zM320 144V112c-53 0-96 43-96 96h32c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faSquareArrowUpRight = {
    prefix: 'fasr',
    iconName: 'square-arrow-up-right',
    icon: [
      448,
      512,
      ["external-link-square"],
      'f14c',
      
      'M400 80V432H48V80H400zm48-48H400 48 0V80 432v48H48 400h48V432 80 32zM312 144H160 136v48h24 94.1L119 327l-17 17L136 377.9l17-17 135-135V328v24h48V328 168 144H312z'
      
    ]
  };

  
    var faExternalLinkSquare = faSquareArrowUpRight;
  

  
  

  var faBanjo = {
    prefix: 'fasr',
    iconName: 'banjo',
    icon: [
      512,
      512,
      [129685],
      'f8a3',
      
      'M363.3 114.7L376 64 448 0l64 64-64 72-50.7 12.7-52.5 52.5-17 17-1.2 1.2c16.5 22 27.7 48.2 31.7 76.6H360h24v48H360h-1.7c-4.1 28.5-15.3 54.6-31.7 76.6l1.2 1.2 17 17-33.9 33.9-17-17-1.2-1.2c-22 16.5-48.2 27.7-76.6 31.7V488v24H168V488v-1.7c-28.5-4.1-54.6-15.3-76.6-31.7l-1.2 1.2-17 17L39.3 438.8l17-17 1.2-1.2C41 398.6 29.8 372.5 25.7 344H24 0V296H24h1.7c4.1-28.5 15.3-54.6 31.7-76.6l-1.2-1.2-17-17 33.9-33.9 17 17 1.2 1.2c22-16.5 48.2-27.7 76.6-31.7V152 128h48v24 1.7c28.5 4.1 54.6 15.3 76.6 31.7l1.2-1.2 17-17 52.5-52.5zM192 448a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM153 311l48 48 17 17L184 409.9l-17-17-48-48-17-17L136 294.1l17 17z'
      
    ]
  };

  

  
  

  var faFileImport = {
    prefix: 'fasr',
    iconName: 'file-import',
    icon: [
      512,
      512,
      ["arrow-right-to-file"],
      'f56f',
      
      'M464 464H176V368H128v96 48h48H464h48V464 128L384 0H176 128V48 256h48V48H352V160H464V464zM297 215l-17-17L246.1 232l17 17 39 39H24 0v48H24 302.1l-39 39-17 17L280 425.9l17-17 80-80 17-17-17-17-80-80z'
      
    ]
  };

  
    var faArrowRightToFile = faFileImport;
  

  
  

  var faCommentPen = {
    prefix: 'fasr',
    iconName: 'comment-pen',
    icon: [
      512,
      512,
      ["comment-edit"],
      'f4ae',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM304.8 144l-29.1 29.1L323 220.4l29.1-29.1L304.8 144zm-51.7 51.7l-85.2 85.2L160 336.1l55.3-7.9L300.4 243l-47.3-47.3z'
      
    ]
  };

  
    var faCommentEdit = faCommentPen;
  

  
  

  var faCircleArrowDown = {
    prefix: 'fasr',
    iconName: 'circle-arrow-down',
    icon: [
      512,
      512,
      ["arrow-circle-down"],
      'f0ab',
      
      'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM239 377l17 17 17-17 88-88 17-17L344 238.1l-17 17-47 47L280 152l0-24-48 0 0 24 0 150.1-47-47-17-17L134.1 272l17 17 88 88z'
      
    ]
  };

  
    var faArrowCircleDown = faCircleArrowDown;
  

  
  

  var faCameraRetro = {
    prefix: 'fasr',
    iconName: 'camera-retro',
    icon: [
      512,
      512,
      [128247],
      'f083',
      
      'M192 112H48v80H156.1c23.5-29.3 59.5-48 99.9-48s76.5 18.7 99.9 48H464V80H267.3l-53.9 26.9c-6.7 3.3-14 5.1-21.5 5.1zM48 240V432H464V240H380c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32H48zM192 64l64-32H464h48V80 432v48H464 48 0V432 112 64H48 64V32h96V64h32zM336 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faFilterCircleDollar = {
    prefix: 'fasr',
    iconName: 'filter-circle-dollar',
    icon: [
      576,
      512,
      ["funnel-dollar"],
      'f662',
      
      'M224 254.4V272v56.9l32.5 26c-.3 4.3-.5 8.7-.5 13.1c0 19.2 3.1 37.7 8.8 55L176 352V272L0 64V48 0H48 496h48V48 64L435.7 192c-1.2 0-2.4 0-3.7 0c-25.8 0-50.2 5.5-72.3 15.5L494.7 48H49.3L212.6 241 224 254.4zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L465.9 301c-5.6-1.4-11.6-2.7-17.9-3.7V288 272H416v16 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8L372 425.2l15.3 4.8c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4 16h32v-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z'
      
    ]
  };

  
    var faFunnelDollar = faFilterCircleDollar;
  

  
  

  var faBinaryLock = {
    prefix: 'fasr',
    iconName: 'binary-lock',
    icon: [
      640,
      512,
      [],
      'e33d',
      
      'M224 0V48h24 32V176H248 224v48h24 56 56 24V176H360 328V24 0H304 248 224zM0 288v48H24 56V464H24 0v48H24 80h56 24V464H136 104V312 288H80 24 0zM24 0H0V24 200v24H24 168h24V200 24 0H168 24zM48 176V48h96V176H48zM192 288v24V488v24h24H360h24V488 312 288H360 216 192zm48 48h96V464H240V336zm288-96c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48H416V512H640V320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fasr',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      'M297 57L265 89l-17 17L214.1 72l17-17 32-32 17-17L313.9 40 297 57zM489 249l-32 32-17 17L406.1 264l17-17 32-32 17-17L505.9 232l-17 17zm17-209L489 57 361 185l-17 17L310.1 168l17-17L455 23l17-17L505.9 40zM220.2 198.2l33 66.9 73.8 10.7 59.8 8.7-43.3 42.2-53.4 52.1 12.6 73.5L313 512l-53.5-28.1-66-34.7-66 34.7L73.9 512l10.2-59.6 12.6-73.5L43.3 326.8 0 284.6l59.8-8.7 73.8-10.7 33-66.9L193.5 144l26.8 54.2zm26.1 114.4l-25-3.6-11.2-22.6-16.7-33.9-16.7 33.9L165.6 309l-25 3.6-37.4 5.4 27.1 26.4 18.1 17.6L144 387l-6.4 37.3 33.5-17.6 22.3-11.7 22.3 11.7 33.5 17.6L242.9 387l-4.3-24.9 18.1-17.6 27.1-26.4-37.4-5.4z'
      
    ]
  };

  

  
  

  var faPersonSkating = {
    prefix: 'fasr',
    iconName: 'person-skating',
    icon: [
      448,
      512,
      ["skating"],
      'f7c5',
      
      'M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 96h24H336h9.9l7 7 12 12 17 17-17 17L268.9 245l69.3 60c8.8 7.6 13.8 18.6 13.8 30.2V424v24H304V424 339l-85.4-74c-24.8-21.5-26-59.7-1.9-82.5c11.9-11.2 26.8-25.1 41.6-38.5H152 128V96zM79 367L179.4 266.6c4.8 8.5 11.2 16.4 19 23.2l13.7 11.9L113 401l-17 17L62.1 384l17-17zm309.3 77.6l31 7.8-3.9 15.5-8 32-3 12.1H392 288 272V480h16 91.5l5-19.9 3.9-15.5zM135.2 478.3l-32 16-10.3 5.2-8.2-8.2-72-72L1.4 408 24 385.4l11.3 11.3 63.8 63.8 21.7-10.8 14.3-7.2 14.3 28.6-14.3 7.2z'
      
    ]
  };

  
    var faSkating = faPersonSkating;
  

  
  

  var faSuitcase = {
    prefix: 'fasr',
    iconName: 'suitcase',
    icon: [
      512,
      512,
      [129523],
      'f0f2',
      
      'M152 0H128V24 96H48 0v48V432v48H48 464h48V432 144 96H464 384V24 0H360 152zM336 96H176V48H336V96zM152 144H360h8V432H144V144h8zM48 144H96V432H48V144zM464 432H416V144h48V432z'
      
    ]
  };

  

  
  

  var faReplyAll = {
    prefix: 'fasr',
    iconName: 'reply-all',
    icon: [
      576,
      512,
      ["mail-reply-all"],
      'f122',
      
      'M106.4 184.4L224 76.6V32H192L0 208 192 384h32V339.4L106.4 231.6 80.6 208l25.7-23.6zM448 480s41.8-15.7 77.7-53c26.9-28 50.3-68.1 50.3-123c0-97.2-78.8-176-176-176H352V80 67.8v-.9V32H320L304 46.7 163.5 175.4 128 208l35.5 32.6L304 369.3 320 384h32V349.1v-.9V336 288h16c11.1 0 21.9 1.6 32 4.6c46.3 13.8 80 56.6 80 107.4c0 1.4 0 2.9-.1 4.3C478.1 449.9 448 480 448 480zm80-176c0 17-3.1 32-8.2 45.4C498.6 285.8 438.7 240 368 240H352 304v48 16.2L199 208l105-96.2V128v48h48 48c70.7 0 128 57.3 128 128z'
      
    ]
  };

  
    var faMailReplyAll = faReplyAll;
  

  
  

  var faCrystalBall = {
    prefix: 'fasr',
    iconName: 'crystal-ball',
    icon: [
      448,
      512,
      [],
      'e362',
      
      'M400 224c0 71-42 132.2-102.6 160h83.3c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160h83.3C90 356.2 48 295 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zM177.3 126.7L160 80l-17.3 46.7L96 144l46.7 17.3L160 208l17.3-46.7L224 144l-46.7-17.3zM288 128l-25.9 70.1L192 224l70.1 25.9L288 320l25.9-70.1L384 224l-70.1-25.9L288 128zM0 512H448l-64-96H64L0 512z'
      
    ]
  };

  

  
  

  var faCertificate = {
    prefix: 'fasr',
    iconName: 'certificate',
    icon: [
      512,
      512,
      [],
      'f0a3',
      
      'M226.5 32.7L256 57.2l29.5-24.6L324.6 0l17.6 47.9 13.2 36 37.8-6.6 50.2-8.7-8.7 50.2-6.6 37.8 36 13.2L512 187.4l-32.7 39.1L454.8 256l24.6 29.5L512 324.6l-47.9 17.6-36 13.2 6.6 37.8 8.7 50.2-50.2-8.7-37.8-6.6-13.2 36L324.6 512l-39.1-32.7L256 454.8l-29.5 24.6L187.4 512l-17.6-47.9-13.2-36-37.8 6.6-50.2 8.7 8.7-50.2 6.6-37.8-36-13.2L0 324.6l32.7-39.1L57.2 256 32.7 226.5 0 187.4l47.9-17.6 36-13.2-6.6-37.8L68.6 68.6l50.2 8.7 37.8 6.6 13.2-36L187.4 0l39.1 32.7zM209 80.5l-7.3 19.9L187.9 138l-39.5-6.8-20.9-3.6 3.6 20.9 6.8 39.5-37.6 13.8L80.5 209l13.6 16.3L119.7 256 94.1 286.7 80.5 303l19.9 7.3L138 324.1l-6.8 39.5-3.6 20.9 20.9-3.6 39.5-6.8 13.8 37.6 7.3 19.9 16.3-13.6L256 392.3l30.7 25.7L303 431.5l7.3-19.9L324.1 374l39.5 6.8 20.9 3.6-3.6-20.9L374 324.1l37.6-13.8 19.9-7.3-13.6-16.3L392.3 256l25.7-30.7L431.5 209l-19.9-7.3L374 187.9l6.8-39.5 3.6-20.9-20.9 3.6L324.1 138l-13.8-37.6L303 80.5 286.7 94.1 256 119.7 225.3 94.1 209 80.5z'
      
    ]
  };

  

  
  

  var faTentArrowDownToLine = {
    prefix: 'fasr',
    iconName: 'tent-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e57e',
      
      'M231.9 153.9L249.9 138 218 102.1l-17.9 15.9L168 146.6 168 24V0H120V24l0 122.6L87.9 118.1 70 102.1 38.1 138l17.9 15.9 72 64L144 232.1l15.9-14.2 72-64zM24 512H136h49.3H582.7 616h16 8V464H620.8L576 272 384 128 192 272 147.2 464H24 0v48H24zM533.2 299.9L571.5 464H472L408 336V206l125.2 93.9zM360 206V464H196.5l38.3-164.1L360 206z'
      
    ]
  };

  

  
  

  var faArrowDownLong = {
    prefix: 'fasr',
    iconName: 'arrow-down-long',
    icon: [
      384,
      512,
      ["long-arrow-down"],
      'f175',
      
      'M175 495l17 17 17-17L345 359l17-17L328 308.1l-17 17-95 95L216 24l0-24L168 0l0 24 0 396.1-95-95-17-17L22.1 342.1l17 17L175 495z'
      
    ]
  };

  
    var faLongArrowDown = faArrowDownLong;
  

  
  

  var faUpToBracket = {
    prefix: 'fasr',
    iconName: 'up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66e',
      
      'M256 384l0-48 48 0 28.1 0L224 227.9 115.9 336l28.1 0 48 0 0 48 0 80 64 0 0-80zm1.9-190.1L384 320l0 16 0 48-32 0-16 0-32 0 0 48 0 32 0 48-48 0-64 0-48 0 0-48 0-32 0-48-32 0-16 0-32 0 0-48 0-16L190.1 193.9 224 160l33.9 33.9zM48 168l0 24L0 192l0-24L0 24 0 0 24 0 424 0l24 0 0 24 0 144 0 24-48 0 0-24 0-120L48 48l0 120z'
      
    ]
  };

  

  
  

  var faUserTie = {
    prefix: 'fasr',
    iconName: 'user-tie',
    icon: [
      448,
      512,
      [],
      'f508',
      
      'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM209.1 359.2L176 304h48 48l-33.1 55.2 15.9 59.2L304 320h80l48 144 16 48H397.4 280 261.7 186.3 168 50.6 0l16-48L64 320h80l49.2 98.4 15.9-59.2zM381.4 464l-32-96H333.7l-48 96h95.7zM114.3 368H98.6l-32 96h95.7l-48-96z'
      
    ]
  };

  

  
  

  var faSquarePersonConfined = {
    prefix: 'fasr',
    iconName: 'square-person-confined',
    icon: [
      448,
      512,
      [],
      'e577',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm208 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm70.1 88H288h40 24v24V348c0 31.8-24.7 57.8-56 59.9v.1c-.7 0-1.5 0-2.2 0c-.6 0-1.2 0-1.8 0c-5.7 0-11.1-.8-16.3-2.2c-19.6-4.4-37.5-15.1-50.7-30.7L180.1 322 133 406.9 91 383.5l64-115.2 39.3-3.8L232 309V256v-9.9l7-7 32-32 7-7zm15.3 159.9c6-.7 10.6-5.8 10.6-11.9V248h-6.1L280 265.9V348c0 5.2 3.2 9.5 7.8 11.2c1.8 .3 3.7 .6 5.6 .7z'
      
    ]
  };

  

  
  

  var faViruses = {
    prefix: 'fasr',
    iconName: 'viruses',
    icon: [
      640,
      512,
      [],
      'e076',
      
      'M345.6 216c-35.6 0-52.6 43.1-27.4 68.3l26.5 26.5-33.9 33.9-26.5-26.5 0 0C259 293 216 310 216 345.6V384H168V345.6c0-35.6-43.1-52.6-68.3-27.4l0 0L73.2 344.7 39.3 310.8l26.5-26.5C91 259.1 74 216 38.4 216H0V168H38.4c34.5 0 56.2-37.6 30-65.6c-.8-.9-1.7-1.8-2.6-2.6L39.3 73.2 73.2 39.3 99.7 65.8C124.9 91 168 74 168 38.4V0h48V38.4C216 74 259.1 91 284.3 65.8l26.5-26.5 33.9 33.9L318.2 99.7C293 124.9 310 168 345.6 168H384v48H345.6zm-60.4-24c-17.8-17.3-27.3-41.9-26.5-66.7c-11.2 .4-22.3-1.4-32.8-5c-12.7-4.5-24.4-11.7-33.9-21.5c-16.7 17.2-40.4 26.7-64.4 26.6c.7 13.2-1.8 26.4-7.4 38.9c-5 10.9-12.1 20.5-20.8 28.3c17.4 17.2 26.7 41.6 25.9 66.1c24.8-.8 49.4 8.8 66.7 26.5c17.3-17.8 41.9-27.3 66.7-26.5c-.8-24.8 8.8-49.4 26.5-66.7zM176 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm385.1 85.5l-11.3 11.3C574.5 312.1 591 352 624 352h16v32H624c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-22.6 22.6-11.3-11.3C551.9 446.5 512 463 512 496v16H480V496c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-22.6-22.6 11.3-11.3C417.5 423.9 401 384 368 384H352V352h16c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 22.6-22.6 11.3 11.3C440.1 289.5 480 273 480 240V224h32v16c0 33 39.9 49.5 63.2 26.2l11.3-11.3 22.6 22.6zM480 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faBatteryExclamation = {
    prefix: 'fasr',
    iconName: 'battery-exclamation',
    icon: [
      576,
      512,
      [],
      'e0b0',
      
      'M48 96H0v48V368v48H48 208V368H48V144H208V96H48zM496 368H336v48H496h48V368 320h32V192H544V144 96H496 336v48H496V368zM296 96H248v24V312v24h48V312 120 96zM248 368v48h48V368H248z'
      
    ]
  };

  

  
  

  var faSterlingSign = {
    prefix: 'fasr',
    iconName: 'sterling-sign',
    icon: [
      320,
      512,
      [163,"gbp","pound-sign"],
      'f154',
      
      'M96 158c0-43.1 34.9-78 78-78c9.1 0 18.1 1.6 26.7 4.7l71.1 25.9 22.6 8.2 16.4-45.1-22.6-8.2L217.1 39.6c-13.8-5-28.4-7.6-43.1-7.6C104.4 32 48 88.4 48 158v66H0v48H48v51.4L1.7 439.1 0 443.4V448v8 24H24 296h24V432H296 56.2l38-95.1 1.7-4.3V328 272H256V224H96V158z'
      
    ]
  };

  
    var faGbp = faSterlingSign;
  
    var faPoundSign = faSterlingSign;
  

  
  

  var faSmoke = {
    prefix: 'fasr',
    iconName: 'smoke',
    icon: [
      640,
      512,
      [],
      'f760',
      
      'M80 128c0-44.2 35.8-80 80-80c31.1 0 58 17.7 71.3 43.7l12.2 23.8c4.1-2.3 8.4-4.3 12.8-6.2l12-10.2c14-11.9 32-19 51.8-19c24.3 0 46.1 10.8 60.7 27.9c4.9 2 9.7 4.3 14.4 6.8c9.3-9.9 19.8-18.6 31.2-25.9C403.4 54.5 364.3 32 320 32c-21.9 0-42.6 5.5-60.7 15.3C235.9 18.5 200.1 0 160 0C89.3 0 32 57.3 32 128c0 32 11.7 61.2 31.1 83.6c16.1-8.3 33.6-14.3 52.2-17.3C94 180 80 155.6 80 128zm512 96c0 27.5-13.8 51.7-34.9 66.1c12.3 10.4 22.8 22.9 31 36.8C619.6 303.6 640 266.2 640 224c0-70.7-57.3-128-128-128c-46.6 0-87.3 24.8-109.7 62c-22.2-18.7-51-30-82.3-30c-51.6 0-96 30.5-116.3 74.4c10.7 3.9 20.9 8.7 30.5 14.5c7.9-5 16.2-9.4 25-13C273.9 186.8 295.7 176 320 176c24.3 0 46.1 10.8 60.7 27.9c17.7 7.3 33.8 17.6 47.7 30.4l5.1-25.9c7.2-36.7 39.7-64.4 78.5-64.4c44.2 0 80 35.8 80 80zM48 368c0-53 43-96 96-96c29.5 0 55.9 13.3 73.5 34.3l19.7 23.5 18-24.8c14.6-20 38.1-33 64.7-33c36.6 0 67.5 24.6 77 58.2l8.4 29.7 26.7-15.4c9.4-5.4 20.2-8.5 31.9-8.5c35.3 0 64 28.7 64 64v64H464 144 48V368zm96-144C64.5 224 0 288.5 0 368V488v24H24 144 464h88 24V488 400c0-61.9-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.7 0-62.5 12.2-85.1 32.3C210.2 236.1 178.5 224 144 224z'
      
    ]
  };

  

  
  

  var faMaskSnorkel = {
    prefix: 'fasr',
    iconName: 'mask-snorkel',
    icon: [
      576,
      512,
      [],
      'e3b7',
      
      'M576 32V56 160H528V56 32h48zM528 192h48V384c0 70.7-57.3 128-128 128s-128-57.3-128-128v-8V352h48v24 8c0 44.2 35.8 80 80 80s80-35.8 80-80V192zM264 288l-13.2-26.3-13.5-27L232 224H216l-5.3 10.7-13.5 27L184 288H48 0V240 112 64H48 400h48v48V240v48H400 264zm-90.9-85.5L186.3 176H216h16 29.7l13.3 26.5L293.7 240H400V112H48V240H154.3l18.7-37.5z'
      
    ]
  };

  

  
  

  var faImageSlash = {
    prefix: 'fasr',
    iconName: 'image-slash',
    icon: [
      640,
      512,
      [],
      'e1b7',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L576 424.4V80 32H528 112 70.5L48.4 14.8zm84 65.2H528V387.2l-66.9-51.9L387.4 233.9 367.8 207 348.5 234l-6.3 8.8L256 176c0-26.5-21.5-48-48-48c-4.1 0-8.1 .5-11.9 1.5L132.4 80zm355 400L286.1 321.4l-27.8 38.9L225 327l-17.9-17.9-16.9 18.8-72 80-6.2 6.8V184.2L64 146.4V432v48h48H487.4z'
      
    ]
  };

  

  
  

  var faPersonWalkingDashedLineArrowRight = {
    prefix: 'fasr',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
      640,
      512,
      [],
      'e553',
      
      'M256 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM82.6 201.5l36.3-18.2-22.7 68c-7.4 22.1-.3 46.5 17.8 61.2l104.6 85 22.1 88.2 5.8 23.3 46.6-11.6-5.8-23.3-24-96-1.9-7.8-6.2-5-54.4-44.2 25.7-82.3 6.4 23.4 1.7 6.1L239 273l40 40L313 279l-35.5-35.5-22.3-81.9-3.6-13.2-13.2-3.6-88-24-8.8-2.4-8.2 4.1-80 40-7.9 3.9-3.5 8.1-24 56L8.5 252.6l44.1 18.9 9.5-22.1 20.5-47.9zm59.2 65.1l30-90.1 22.1 6c-.3 .8-.6 1.5-.9 2.3L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zM75.5 402.5L18.2 459.8l-17 17 33.9 33.9 17-17L113 433l3.5-3.5 1.8-4.6 20.4-51.1-39-31.7L75.5 402.5zM416 24V0H368V24 72 96h48V72 24zM541.8 159l-17-17L490.9 176l17 17 39 39H392 368v48h24H546.9l-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80zM416 128H368v24 16 24h48V168 152 128zm0 216V320H368v24 16 24h48V360 344zm0 72H368v24 48 24h48V488 440 416z'
      
    ]
  };

  

  
  

  var faStocking = {
    prefix: 'fasr',
    iconName: 'stocking',
    icon: [
      384,
      512,
      [],
      'f7d5',
      
      'M384 0V96H64V0H384zM144 281.7l-21.4 14.2L82.3 322.8C60.9 337.1 48 361.2 48 386.9v2.2c0 41.3 33.5 74.8 74.8 74.8c14.8 0 29.2-4.4 41.5-12.6L304 358.3V128h48V384L190.9 491.4c-20.2 13.4-43.9 20.6-68.1 20.6C55 512 0 457 0 389.2v-2.2c0-41.8 20.9-80.9 55.7-104.1L96 256V128h48V256v25.7z'
      
    ]
  };

  

  
  

  var faTeddyBear = {
    prefix: 'fasr',
    iconName: 'teddy-bear',
    icon: [
      576,
      512,
      [],
      'e3cf',
      
      'M144 80c0-17.7 14.3-32 32-32c14 0 25.9 9 30.3 21.5l7 20.1L234 85.1c16-3.5 34.2-5.1 54-5.1s38 1.7 54 5.1l20.8 4.5 7-20.1C374.1 57 386 48 400 48c17.7 0 32 14.3 32 32c0 11.5-6.1 21.7-15.4 27.3l-15.1 9.2 4.4 17.2c1.3 5.3 2.1 11.3 2.1 18.3c0 54.9-51 104-120 104s-120-49.1-120-104c0-6.9 .8-13 2.1-18.3l4.4-17.2-15.1-9.2C150.1 101.7 144 91.5 144 80zM176 0C131.8 0 96 35.8 96 80c0 22.8 9.5 43.3 24.7 57.9c-.3 2.6-.5 5.3-.6 8l-17.3 13.6L27.4 218.9 8.6 233.7l14.9 18.9 25.8 32.7c11.9 15.1 24.9 28.7 38.7 40.9L28 336.3 5.3 340.2 8.2 363l16 128 2.6 21H48 96h24H480h22.1l0 0H528h21.2l2.6-21 16-128 2.8-22.8L548 336.3l-60-10.2c13.9-12.2 26.8-25.8 38.7-40.9l25.8-32.7 14.9-18.9-18.9-14.9-75.4-59.4-17.3-13.6c-.1-2.7-.3-5.3-.6-8C470.5 123.3 480 102.8 480 80c0-44.2-35.8-80-80-80c-27.5 0-51.8 13.9-66.1 35c-14.8-2.1-30.2-3-45.9-3s-31.1 .9-45.9 3C227.8 13.9 203.5 0 176 0zM58.7 379.8l51.9-8.8c.5 2.5 .9 5.1 1.1 7.5l2.2 21.5h21.6 .5 24V376 332.5 319.4l-11-7.1c-22.9-14.8-44-33.7-62.1-56.8L76 241.7 113.7 212l10.9 13.9c83.3 105.7 243.5 105.7 326.8 0L462.3 212 500 241.7l-10.9 13.9c-18.1 23-39.2 41.9-62.1 56.8l-11 7.1v13.1V376v24h24 .5 21.6l2.2-21.5c.3-2.4 .6-5 1.1-7.5l51.9 8.8L506.8 464H480 457.9l0 0H376V392v-9.9l-7-7-32-32-7-7H320 256h-9.9l-7 7-32 32-7 7V392v72H120 96 69.2L58.7 379.8zM248 464V401.9L265.9 384h44.1L328 401.9V464H248zm8-320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 32c0-13.3-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24s32-10.7 32-24z'
      
    ]
  };

  

  
  

  var faVolcano = {
    prefix: 'fasr',
    iconName: 'volcano',
    icon: [
      512,
      512,
      [127755],
      'f770',
      
      'M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64H304l-32 48H240l-32-48H160zM48 458.2V464H464v-5.8L361.3 342.7 336 368H304l-64-64H208 185.1L48 458.2zM192 224H320L512 440v24 48H464 48 0V464 440L192 224z'
      
    ]
  };

  

  
  

  var faLariSign = {
    prefix: 'fasr',
    iconName: 'lari-sign',
    icon: [
      384,
      512,
      [],
      'e1c8',
      
      'M168 32V97.5c7.9-1 15.9-1.5 24-1.5s16.1 .5 24 1.5V32h48v78c70.4 28.5 120 97.5 120 178H336c0-53.3-29-99.8-72-124.7V288H216l0-142c-7.8-1.3-15.8-2-24-2s-16.2 .7-24 2l0 142H120l0-124.7C77 188.2 48 234.7 48 288c0 79.5 64.5 144 144 144H384v48H192 0V432H65C25.1 396.8 0 345.3 0 288c0-80.6 49.6-149.6 120-178l0-78h48z'
      
    ]
  };

  

  
  

  var faUserPolice = {
    prefix: 'fasr',
    iconName: 'user-police',
    icon: [
      448,
      512,
      [],
      'e333',
      
      'M80 99.2L48 80V48L224 0 400 48V80L368 99.2V128c-16 10.7-67.2 32-144 32s-128-21.3-144-32V99.2zM227 48.6l-3-1.2-3 1.2L189 61.4l-5 2v5.4c0 17.2 7 46.1 36.9 58.6l3.1 1.3 3.1-1.3C257 114.9 264 86 264 68.8V63.4l-5-2L227 48.6zM96 192c0-7.9 .7-15.7 2.1-23.2c14 5.4 28.5 9.9 43.3 13.4c-.4 3.2-.6 6.5-.6 9.8c0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8c14.8-3.6 29.3-8.1 43.3-13.4c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128zM208 464l-12.8-9.6L122.7 400h-39L64.5 464H208zm145 0h30.5l-19.2-64h-39l-72.5 54.4L240 464h63l-8.3-6-12.1-8.7 14.9 0 19.8 0 6.1-18.8 4.6-14.2 4.6 14.2 6.1 18.8 19.8 0 14.9 0L361.2 458l-8.3 6zM309.3 352H400l33.6 112L448 512H397.9 50.1 0l14.4-48L48 352h90.7L224 416l85.3-64z'
      
    ]
  };

  

  
  

  var faCircleChevronUp = {
    prefix: 'fasr',
    iconName: 'circle-chevron-up',
    icon: [
      512,
      512,
      ["chevron-circle-up"],
      'f139',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm17-345l-17-17-17 17L135 271l-17 17L152 321.9l17-17 87-87 87 87 17 17L393.9 288l-17-17L273 167z'
      
    ]
  };

  
    var faChevronCircleUp = faCircleChevronUp;
  

  
  

  var faUpRight = {
    prefix: 'fasr',
    iconName: 'up-right',
    icon: [
      384,
      512,
      [],
      'e2be',
      
      'M248 244.1l-33.9 33.9L112 380.1 67.9 336 169.9 233.9 203.9 200l-33.9-33.9L131.9 128H320V316.1l-38.1-38.1L248 244.1zm38.1 105.9L320 384l33.9-33.9L368 336V128 80H320 112L97.9 94.1 64 128l33.9 33.9 4.1 4.1L136 200l-33.9 33.9L33.9 302.1 0 336l33.9 33.9 44.1 44.1L112 448l33.9-33.9 68.1-68.1L248 312l33.9 33.9 4.1 4.1z'
      
    ]
  };

  

  
  

  var faFileMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'file-magnifying-glass',
    icon: [
      384,
      512,
      ["file-search"],
      'f865',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zm16 304c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L263 425.1l17 17 33.9-33.9-17-17-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faFileSearch = faFileMagnifyingGlass;
  

  
  

  var faGearComplex = {
    prefix: 'fasr',
    iconName: 'gear-complex',
    icon: [
      512,
      512,
      [],
      'e5e9',
      
      'M216 0H197.1l-4.4 18.4L180 71l-1.1 .4L132.8 43.2l-16.1-9.9L103.3 46.7 46.7 103.3 33.3 116.6l9.9 16.1 28.2 46.2L71 180 18.4 192.7 0 197.1V216v80 18.9l18.4 4.4L71 332l.4 1.1L43.2 379.3l-9.9 16.1 13.4 13.4 56.6 56.6 13.4 13.4 16.1-9.9 46.2-28.2 1.1 .4 12.7 52.6 4.4 18.4H216h80 18.9l4.4-18.4L332 441l1.1-.4 46.2 28.2 16.1 9.9 13.4-13.4 56.6-56.6 13.4-13.4-9.9-16.1-28.2-46.2 .4-1.1 52.6-12.7 18.4-4.4V296 216 197.1l-18.4-4.4L441 180l-.4-1.1 28.2-46.2 9.9-16.1-13.4-13.4L408.7 46.7 395.4 33.3l-16.1 9.9L333.1 71.4 332 71 319.3 18.4 314.9 0H296 216zm7.6 94.6L234.9 48h42.2l11.3 46.6 3.1 12.9 12.6 4.2c6.8 2.3 13.5 5 19.9 8.2l11.9 6 11.4-6.9 40.9-25L418 123.8l-25 40.9L386 176.1l6 11.9c3.2 6.4 6 13 8.2 19.9l4.2 12.6 12.9 3.1L464 234.9v42.2l-46.6 11.3-12.9 3.1-4.2 12.6c-2.3 6.8-5 13.5-8.2 19.9l-6 11.9 6.9 11.4 25 40.9L388.2 418l-40.9-25L335.9 386 324 392c-6.4 3.2-13 6-19.9 8.2l-12.6 4.2-3.1 12.9L277.1 464H234.9l-11.3-46.6-3.1-12.9-12.6-4.2c-6.8-2.3-13.5-5-19.9-8.2l-11.9-6L164.8 393l-40.9 25L94 388.2l25-40.9 6.9-11.4L120 324c-3.2-6.4-6-13-8.2-19.9l-4.2-12.6-12.9-3.1L48 277.1V234.9l46.6-11.3 12.9-3.1 4.2-12.6c2.3-6.8 5-13.5 8.2-19.9l6-11.9L119 164.8 94 123.8 123.8 94l40.9 25 11.4 6.9 11.9-6c6.4-3.2 13-6 19.9-8.2l12.6-4.2 3.1-12.9zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faUniversalAccess = {
    prefix: 'fasr',
    iconName: 'universal-access',
    icon: [
      512,
      512,
      [],
      'f29a',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160.4-86.5L220.4 192h71.3l59.9-22.5 22.5-8.4L390.9 206l-22.5 8.4-64 24-.4 .2v53.5l30.8 92.3 7.6 22.8-45.5 15.2-7.6-22.8L262.7 320H249.3l-26.5 79.6-7.6 22.8-45.5-15.2 7.6-22.8L208 292.1V238.6l-.4-.2-64-24L121.1 206 138 161.1l22.5 8.4zM256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  

  
  

  var faAperture = {
    prefix: 'fasr',
    iconName: 'aperture',
    icon: [
      512,
      512,
      [],
      'e2df',
      
      'M404.7 401.5L348.4 304 323 348 256 464c58.2 0 110.9-23.9 148.7-62.5zM436.2 360c17.7-30.6 27.8-66.1 27.8-104c0-19.4-2.7-38.2-7.6-56H343.8l25.4 44 67 116zm0-208c-27.6-47.8-73.7-83.5-128.5-97.5L251.4 152h50.8 134zM256 48c-58.2 0-110.9 23.9-148.7 62.5L163.6 208 189 164 256 48zM75.8 152C58.1 182.6 48 218.1 48 256c0 19.4 2.7 38.2 7.6 56H168.2l-25.4-44-67-116zm0 208c27.6 47.8 73.7 83.5 128.5 97.5L260.6 360H209.8 75.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm223.7-56l-32.3 56 32.3 56h64.7l32.3-56-32.3-56H223.7z'
      
    ]
  };

  

  
  

  var faHelicopterSymbol = {
    prefix: 'fasr',
    iconName: 'helicopter-symbol',
    icon: [
      512,
      512,
      [],
      'e502',
      
      'M461.6 224H510C495.6 108.2 403.8 16.4 288 2V50.5C377.3 64.2 447.8 134.8 461.6 224zM510 288H461.6C447.8 377.3 377.3 447.8 288 461.6V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V461.6C134.7 447.8 64.2 377.3 50.4 288H2zm0-64H50.4C64.2 134.8 134.7 64.2 224 50.5V2C108.2 16.4 16.4 108.2 2 224zm190-64V136H144v24V352v24h48V352 280H320v72 24h48V352 160 136H320v24 72H192V160z'
      
    ]
  };

  

  
  

  var faTreeLarge = {
    prefix: 'fasr',
    iconName: 'tree-large',
    icon: [
      448,
      512,
      [],
      'f7dd',
      
      'M392 208.6V192l-14-16L255.9 36.4 224 0 192.1 36.4 70 176 56 192v16.6V224h48L69.7 272 35.4 320 24 336v27.8V368H72h8L45.7 416 11.4 464 0 480v32H48 400h48V480l-11.4-16-34.3-48L368 368h8 48v-4.2V336l-11.4-16-34.3-48L344 224h48V208.6zM314.2 176H250.7l54.2 75.9L353.6 320H274.7l54.2 75.9L377.6 464H70.4l48.6-68.1L173.3 320H94.4l48.6-68.1L197.3 176H133.8L224 72.9 314.2 176z'
      
    ]
  };

  

  
  

  var faBatteryBolt = {
    prefix: 'fasr',
    iconName: 'battery-bolt',
    icon: [
      576,
      512,
      [],
      'f376',
      
      'M48 368H184.5l-15 48H48 0V368 144 96H48 307.5l-63.2 48H48V368zm188.5 48l63.2-48H496V144H359.5l15-48H496h48v48 48h32V320H544v48 48H496 236.5zM208 400l40-128H160V248L336 112 296 240h88v24L208 400z'
      
    ]
  };

  

  
  

  var faSquareArrowDownLeft = {
    prefix: 'fasr',
    iconName: 'square-arrow-down-left',
    icon: [
      448,
      512,
      [],
      'e261',
      
      'M48 432V80H400V432H48zM0 480H48 400h48V432 80 32H400 48 0V80 432v48zM136 368H288h24V320H288 193.9L329 185l17-17L312 134.1l-17 17-135 135V184 160H112v24V344v24h24z'
      
    ]
  };

  

  
  

  var faFaceLaughBeam = {
    prefix: 'fasr',
    iconName: 'face-laugh-beam',
    icon: [
      512,
      512,
      [128513,"laugh-beam"],
      'f59a',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM258.2 408c-69.2 0-126.1-52.6-132.8-120H391c-6.7 67.4-63.6 120-132.8 120zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z'
      
    ]
  };

  
    var faLaughBeam = faFaceLaughBeam;
  

  
  

  var faBinBottles = {
    prefix: 'fasr',
    iconName: 'bin-bottles',
    icon: [
      640,
      512,
      [],
      'e5f5',
      
      'M256 0V32h16V64H256 128 112V32h16V0H256zM32 144l96-48H256l63.6 31.8L352 144h0v48h32V144 124.2l-17.7-8.8L321.8 93.1l61.8-29V0h128V64.1l64 30V136v56H592h16 32v48H608L576 512H64L32 240H0V192H32V144zm527.7 96H80.3l26.4 224H533.3l26.4-224z'
      
    ]
  };

  

  
  

  var faMarker = {
    prefix: 'fasr',
    iconName: 'marker',
    icon: [
      512,
      512,
      [],
      'f5a1',
      
      'M10.2 461L0 512l51-10.2L160 480 485.5 154.5c17-17 26.5-40 26.5-64C512 40.5 471.5 0 421.5 0c-24 0-47 9.5-64 26.5L313 71 265 23l-17-17L231 23l-96 96-17 17L152 169.9l17-17 79-79 31 31L32 352 10.2 461zm51-10.2l15-75.1L193 258.9 253.1 319 136.3 435.8l-75.1 15zM226.9 225L391.4 60.5c8-8 18.8-12.5 30.1-12.5C445 48 464 67 464 90.5c0 11.3-4.5 22.1-12.5 30.1L287 285.1 226.9 225z'
      
    ]
  };

  

  
  

  var faKazoo = {
    prefix: 'fasr',
    iconName: 'kazoo',
    icon: [
      640,
      512,
      [],
      'f8c7',
      
      'M560 256c0 29.6-8.9 57.1-24.2 80H592V176H535.8c15.3 22.9 24.2 50.4 24.2 80zm32 128H482c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16H224L0 320V192l224-64H350c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16H592h48v48V336v48H592zM230.7 336h65.5c-15.3-22.9-24.2-50.4-24.2-80s8.9-57.1 24.2-80H230.7L48 228.2v55.6L230.7 336zM416 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM398.1 209.9L416 227.7l17.9-17.9L448 195.7 476.3 224l-14.1 14.1L444.3 256l17.9 17.9L476.3 288 448 316.3l-14.1-14.1L416 284.3l-17.9 17.9L384 316.3 355.7 288l14.1-14.1L387.7 256l-17.9-17.9L355.7 224 384 195.7l14.1 14.1z'
      
    ]
  };

  

  
  

  var faIdBadge = {
    prefix: 'fasr',
    iconName: 'id-badge',
    icon: [
      384,
      512,
      [],
      'f2c1',
      
      'M128 48V96H256V48h80V464H48V48h80zM48 0H0V48 464v48H48 336h48V464 48 0H336 48zM192 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM80 416H304l-32-96H112L80 416z'
      
    ]
  };

  

  
  

  var faNeuter = {
    prefix: 'fasr',
    iconName: 'neuter',
    icon: [
      384,
      512,
      [9906],
      'f22c',
      
      'M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4V488v24h48V488 350.4z'
      
    ]
  };

  

  
  

  var faPersonShelter = {
    prefix: 'fasr',
    iconName: 'person-shelter',
    icon: [
      512,
      512,
      [],
      'e54f',
      
      'M48 172.1V512H0V144L256 0 512 144V512H464V172.1L256 55.1 48 172.1zM256 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-62.3 96H208h96 14.3l6.8 12.6 56 104 11.4 21.1-42.3 22.8-11.4-21.1-18.9-35V488v24H272V488 416H240v72 24H192V488 328.3l-18.9 35-11.4 21.1-42.3-22.8 11.4-21.1 56-104 6.8-12.6zM240 368h32V272H240v96z'
      
    ]
  };

  

  
  

  var faIcicles = {
    prefix: 'fasr',
    iconName: 'icicles',
    icon: [
      512,
      512,
      [],
      'f7ad',
      
      'M389.2 394.3L359.6 263.7 336 160 310.8 260.9l-.6 2.3L288 352l-19.4-64.5L261 262l-21-70-20.9 97.4-2.6 12L192 416 167.5 301.5l-2.6-12L144 192l-21.9 73.1-6.7 22.3L96 352 72.1 264.5 13.1 48 0 0H49.8 151.5h.5 80.1 .5 94 22.3H463.2 512l-9 48L438.3 393.3 416 512 389.2 394.3zM289.4 148.4L302.5 96h68.2l12.1 53.4 28.7 126.2L454.2 48H400 359.8 314.5 246.9 221.8 162.2 137.1 96 62.8L98.2 177.6 113.1 128h66.3l11.6 53.9 1.1 5 1.1-5L204.6 128h66.3l12.9 42.9 5.6-22.6z'
      
    ]
  };

  

  
  

  var faCarWrench = {
    prefix: 'fasr',
    iconName: 'car-wrench',
    icon: [
      512,
      512,
      ["car-mechanic"],
      'f5e3',
      
      'M80 0c32.8 0 61 19.7 73.3 48H358.7C371 19.7 399.2 0 432 0c12.5 0 24.4 2.9 34.9 8c19.6 9.5 34.8 26.9 41.4 48H480 453.2 432v48h21.2H480h28.3c-6.6 21.1-21.8 38.5-41.4 48c-10.6 5.1-22.4 8-34.9 8c-32.8 0-61-19.7-73.3-48H153.3C141 140.3 112.8 160 80 160c-12.5 0-24.4-2.9-34.9-8c-19.6-9.5-34.8-26.9-41.4-48H32 58.8 80V56H58.8 32 3.7C10.3 34.9 25.4 17.5 45.1 8C55.6 2.9 67.5 0 80 0zm55.1 160H152 360h16.9l5.7 15.9L416.9 272H464v48 80 16 32 64H416V448H96v64H48V448 416 400 320 272H95.1l34.3-96.1 5.7-15.9zM400.6 320c-.4 0-.7 0-1.1 0H112.6c-.4 0-.7 0-1.1 0H96v80H416V320H400.6zM343.1 208H168.9l-22.9 64H365.9l-22.9-64zM160 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faCarMechanic = faCarWrench;
  

  
  

  var faChopsticks = {
    prefix: 'fasr',
    iconName: 'chopsticks',
    icon: [
      640,
      512,
      [],
      'e3f7',
      
      'M347.9 16.3L328 .6 313.4 21.5 15.5 447.8l-13 18.6 17.8 14 21.4 16.8 17.8 14 15-17L418.4 103.9l16.8-19.1-20-15.7L347.9 16.3zM160.7 323.9L338.3 69.8l27.3 21.5L160.7 323.9zM568.4 74L551.9 54.7 533.6 72.3 149.8 439l-16.4 15.7L148.2 472l17.5 20.4 14.8 17.3 18-13.8L619.7 172.7l20.1-15.4L623.3 138 568.4 74zm2 76.1L323.5 339.5l225-215L570.3 150z'
      
    ]
  };

  

  
  

  var faCalendarCircleMinus = {
    prefix: 'fasr',
    iconName: 'calendar-circle-minus',
    icon: [
      576,
      512,
      [],
      'e46f',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48H432 400 352 48V464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 192 144 64H104V24 0h48zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16V352H496 368 352v32h16H496h16z'
      
    ]
  };

  

  
  

  var faPlateWheat = {
    prefix: 'fasr',
    iconName: 'plate-wheat',
    icon: [
      512,
      512,
      [],
      'e55a',
      
      'M400 32c44.2 0 80 35.8 80 80v32H464c-44.2 0-80-35.8-80-80V32h16zM56 64h48 24v48H104 56 32V64H56zM24 136H136h24v48H136 24 0V136H24zm8 72H56h48 24v48H104 56 32V208zM272 32h16c44.2 0 80 35.8 80 80v32H352c-44.2 0-80-35.8-80-80V32zm-96 0c44.2 0 80 35.8 80 80v32H240c-44.2 0-80-35.8-80-80V32h16zM480 176v32c0 44.2-35.8 80-80 80H384V256c0-44.2 35.8-80 80-80h16zm-128 0h16v32c0 44.2-35.8 80-80 80H272V256c0-44.2 35.8-80 80-80zm-96 0v32c0 44.2-35.8 80-80 80H160V256c0-44.2 35.8-80 80-80h16zM128 432H384V406.3l30-12.1c13.6-5.5 25.4-14.6 34-26.2H64c8.7 11.6 20.4 20.7 34 26.2l30 12.1V432zm-48 6.7c-32.1-13-57.7-38.6-70.7-70.7C3.3 353.2 0 337 0 320H48 464h48c0 17-3.3 33.2-9.3 48c-13 32.1-38.6 57.7-70.7 70.7V480H384 128 80V438.7z'
      
    ]
  };

  

  
  

  var faCompassDrafting = {
    prefix: 'fasr',
    iconName: 'compass-drafting',
    icon: [
      512,
      512,
      ["drafting-compass"],
      'f568',
      
      'M304 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-19.6 91.7c-9 2.8-18.5 4.3-28.4 4.3s-19.4-1.5-28.4-4.3L158.1 306.4C187.9 320.3 221 328 256 328c85.8 0 160.8-46.6 201-116l41.5 24C450.2 319.6 359.7 376 256 376c-43.8 0-85.3-10.1-122.2-28L50.2 490.7 38.1 511.4-3.3 487.2 8.8 466.5 92.6 323.4C60.4 300.2 33.4 270.4 13.5 236L55 212c15.8 27.2 36.9 51 61.9 69.7l69.8-119.2C170.2 145.2 160 121.8 160 96c0-53 43-96 96-96s96 43 96 96c0 25.8-10.2 49.2-26.7 66.5l53.5 91.4c-12.6 9.8-26.4 18.1-41.1 24.7l-53.2-90.9zM503.1 466.4l12.1 20.7-41.4 24.2-12.1-20.7L394.4 375.7c14.4-7.1 28.2-15.4 41.2-24.6l67.5 115.3z'
      
    ]
  };

  
    var faDraftingCompass = faCompassDrafting;
  

  
  

  var faArrowUpToBracket = {
    prefix: 'fasr',
    iconName: 'arrow-up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66a',
      
      'M241 167l-17-17-17 17L79 295l-17 17L96 345.9l17-17 87-87L200 488l0 24 48 0 0-24 0-246.1 87 87 17 17L385.9 312l-17-17L241 167zM48 168L48 48l352 0 0 120 0 24 48 0 0-24 0-144 0-24L424 0 24 0 0 0 0 24 0 168l0 24 48 0 0-24z'
      
    ]
  };

  

  
  

  var faPhoneRotary = {
    prefix: 'fasr',
    iconName: 'phone-rotary',
    icon: [
      512,
      512,
      [9742],
      'f8d3',
      
      'M0 208V128s96-96 256-96s256 96 256 96v80H416l-32-80s-48-24-128-24s-128 24-128 24L96 208H0zM256 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM32 480V384L160 160H352L480 384v96H32zm400-48V396.7L324.1 208H187.9L80 396.7V432H432z'
      
    ]
  };

  

  
  

  var faHeadSideHeadphones = {
    prefix: 'fasr',
    iconName: 'head-side-headphones',
    icon: [
      512,
      512,
      [],
      'f8c2',
      
      'M112 361.7v19.6V448v16 48H96 64V480 464 381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1V264v24 16 32H496 480 464 448v48 16 16 32H416 400 368 320v16 16 16 16H288 272V464 448 400h48 80V336 288h48 16V270.1l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48H232V98.6c50.3 11 88 55.8 88 109.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-53.6 37.7-98.4 88-109.4v-46C106.1 70.7 48 140.8 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faCircleStop = {
    prefix: 'fasr',
    iconName: 'circle-stop',
    icon: [
      512,
      512,
      [62094,"stop-circle"],
      'f28d',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm352-96V352H160V160H352z'
      
    ]
  };

  
    var faStopCircle = faCircleStop;
  

  
  

  var faBat = {
    prefix: 'fasr',
    iconName: 'bat',
    icon: [
      576,
      512,
      [],
      'f6b5',
      
      'M267.3 128l-11.1-6.3-1-.6-9 35.9L232 213.9l-53-25.2L110.3 156c-34 49.1-54.8 106.1-60.6 165.5l24.9-12.4 39.8-19.9 22.9 38.1 16.4 27.3 20.5-20.5 38.7-38.7L246 338.7l42 54.5 42-54.5 33.3-43.3 38.7 38.7 20.5 20.5 16.4-27.3 22.9-38.1 39.8 19.9 24.9 12.4c-5.8-59.4-26.7-116.4-60.6-165.5L397 188.7l-53 25.2L329.8 157l-9-35.9-1 .6L308.7 128H296 280 267.3zm41.5-55.3L352 48l12.1 48.4 .4 1.5 11.9 47.5 44.2-21.1L480 96c59.9 69.9 93.8 158.4 95.9 250.3c.1 3.1 .1 6.2 .1 9.2V400l-48-24-48-24-22.5 37.6L432 432l-29.8-29.8L397 397l-29-29-29.5 38.4-20.2 26.3L288 472l-30.3-39.4-20.2-26.3L208 368l-29 29-5.2 5.2L144 432l-25.5-42.4L96 352 48 376 0 400V355.5c0-3.1 0-6.2 .1-9.2C2.2 254.4 36.1 165.9 96 96l59.4 28.3 44.2 21.1 11.9-47.5 .4-1.5L224 48l43.3 24.7L280 80h16l12.7-7.3z'
      
    ]
  };

  

  
  

  var faMoneySimpleFromBracket = {
    prefix: 'fasr',
    iconName: 'money-simple-from-bracket',
    icon: [
      640,
      512,
      [],
      'e313',
      
      'M24 0H616h24V24 168v24H592V168 48H48V168v24H0V168 24 0H24zM464 464l0-368h48l0 392v24H488 152l-24 0V488l0-392h48l0 368H464zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z'
      
    ]
  };

  

  
  

  var faHandHoldingCircleDollar = {
    prefix: 'fasr',
    iconName: 'hand-holding-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e621',
      
      'M128 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L305.9 77c-5.6-1.4-11.6-2.7-17.9-3.7V64 48H256V64v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8L212 201.2l15.3 4.8c1.6 .5 3.3 1 5 1.6l0 0 0 0c7.1 2.3 15.1 4.9 23.7 6.6v11.4 16h32v-16V214.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6zM160.7 304H168 384h24v24 46.5l79.9-50.8 20.4-13 12.8 20.5 40 64 12.2 19.5-19 13-116.8 80-6.1 4.2H424 24 0V464H24 416.6l91.7-62.8-15-24-80.4 51L407 432h-7H368 320 296 256 232V384h24 40 24 40V352H175.3l-90 60-6 4H72 24 0V368H24 64.7l90-60 6-4z'
      
    ]
  };

  

  
  

  var faSquareDashedCirclePlus = {
    prefix: 'fasr',
    iconName: 'square-dashed-circle-plus',
    icon: [
      576,
      512,
      [],
      'e5c2',
      
      'M24 32H0V56 160H48V80h80V32H24zM0 192V320H48V192H0zM0 352V456v24H24 128V432H48V352H0zM400 80V192h48V56 32H424 320V80h80zM160 480h96V432H160v48zm0-400H288V32H160V80zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48 16v32H496 448v48 16H416V432 384H368 352V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faCircleCheck = {
    prefix: 'fasr',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faChair = {
    prefix: 'fasr',
    iconName: 'chair',
    icon: [
      448,
      512,
      [129681],
      'f6c0',
      
      'M296 48V224H248V48H200V224H152V48H112V224H64V48 0h48H336h48V48 224H336V48H296zM0 368l6.9-16L48 256H400l41.1 96 6.9 16v32H416v88 24H368V488 400H80v88 24H32V488 400H0V368zm79.7-64L59.1 352H388.9l-20.6-48H79.7z'
      
    ]
  };

  

  
  

  var faEuroSign = {
    prefix: 'fasr',
    iconName: 'euro-sign',
    icon: [
      320,
      512,
      [8364,"eur","euro"],
      'f153',
      
      'M48.6 240c-.4 5.3-.6 10.6-.6 16s.2 10.7 .6 16H0v48H57.3C84.8 412.5 170.5 480 272 480h24 24V432H296 272c-74.6 0-138.4-46.4-164-112H288V272H96.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H288V192H108c25.6-65.6 89.4-112 164-112h24 24V32H296 272C170.5 32 84.8 99.5 57.3 192H0v48H48.6z'
      
    ]
  };

  
    var faEur = faEuroSign;
  
    var faEuro = faEuroSign;
  

  
  

  var faEthernet = {
    prefix: 'fasr',
    iconName: 'ethernet',
    icon: [
      512,
      512,
      [],
      'f796',
      
      'M136 320v24 56h48V344 320h48v24 56h48V344 320h48v24 56h48V344 320h48v24 56h40V240H448 400V192 176H384 336V128 112H176v16 48H128 112v16 48H64 48V400H88V344 320h48zM48 448H0V400 240 192H16 48 64V176 144 128H80h32 16V112 80 64h48H336h48V80v32 16h16 32 16v16 32 16h16 32 16v48V400v48H464 424 400 376 328 304 280 232 208 184 136 112 88 48z'
      
    ]
  };

  

  
  

  var fa360Degrees = {
    prefix: 'fasr',
    iconName: '360-degrees',
    icon: [
      640,
      512,
      [],
      'e2dc',
      
      'M640 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM496 400c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32s32 14.3 32 32V368c0 17.7-14.3 32-32 32zm0-336c-44.2 0-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80V144c0-44.2-35.8-80-80-80zM24 64H0v48H24h86L36.8 209.6 32 216v8 8 24H56 88c30.9 0 56 25.1 56 56v40c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3H0v3c0 53 43 96 96 96s96-43 96-96V312c0-54.2-41.4-98.7-94.3-103.6l73.5-98L176 104V96 88 64H152 24zM323.2 88c-11.3-21.2-11.3-21.2-11.3-21.2l0 0 0 0-.1 .1-.3 .1-.9 .5c-.7 .4-1.7 1-2.9 1.7c-2.4 1.4-5.7 3.5-9.7 6.1c-7.9 5.3-18.4 13.1-29 23.3c-20.7 19.8-45 51.7-45 93.3v80 16 24 56c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80c-11.4 0-22.2 2.4-32 6.7V192c0-22.3 13.3-42.5 30.2-58.7c8.2-7.8 16.4-14 22.7-18.2c3.1-2.1 5.6-3.7 7.3-4.7c.9-.5 1.5-.9 1.9-1.1l.4-.2 0 0 0 0 21.1-11.2L333.1 55.5 311.9 66.8 323.2 88zM272 272c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V312 288 272z'
      
    ]
  };

  

  
  

  var faTablets = {
    prefix: 'fasr',
    iconName: 'tablets',
    icon: [
      640,
      512,
      [],
      'f490',
      
      'M608.8 254.9c-4.7 6.4-9.9 12.5-15.7 18.2s-11.9 11-18.2 15.7c-62.6 46.2-151.3 41-208-15.7s-62-145.4-15.7-208c4.7-6.4 9.9-12.5 15.7-18.2s11.9-11 18.2-15.7c62.6-46.2 151.3-41 208 15.7s62 145.4 15.7 208zM559.2 80.8c-37.9-37.9-96.2-43-139.6-15.1L574.3 220.4c27.8-43.4 22.8-101.7-15.1-139.6zM540.4 254.3L385.7 99.6c-27.8 43.4-22.8 101.7 15.1 139.6s96.2 43 139.6 15.1zM318.2 328c1.2 7.8 1.8 15.8 1.8 24s-.6 16.2-1.8 24c-11.6 77-78 136-158.2 136S13.4 453 1.8 376C.6 368.2 0 360.2 0 352s.6-16.2 1.8-24c11.6-77 78-136 158.2-136s146.6 59 158.2 136zM160 240c-53.6 0-98.4 37.7-109.4 88H269.4c-11-50.3-55.8-88-109.4-88zm0 224c53.6 0 98.4-37.7 109.4-88H50.6c11 50.3 55.8 88 109.4 88z'
      
    ]
  };

  

  
  

  var faLocationArrowUp = {
    prefix: 'fasr',
    iconName: 'location-arrow-up',
    icon: [
      448,
      512,
      [],
      'e63a',
      
      'M224 307.2l29.5 22.9 86.2 67L224 146.5 108.3 397.2l86.2-67L224 307.2zM32 448L197.6 89.3 224 32l26.4 57.3L416 448l-48 32L224 368 80 480 32 448z'
      
    ]
  };

  

  
  

  var faArrowUpRightAndArrowDownLeftFromCenter = {
    prefix: 'fasr',
    iconName: 'arrow-up-right-and-arrow-down-left-from-center',
    icon: [
      512,
      512,
      [],
      'e0a0',
      
      'M295 183l-17 17L312 233.9l17-17 135-135V168v24h48V168 24 0H488 344 320V48h24 86.1L295 183zM217 329l17-17L200 278.1l-17 17L48 430.1V344 320H0v24V488v24H24 168h24V464H168 81.9L217 329z'
      
    ]
  };

  

  
  

  var faCirclePlay = {
    prefix: 'fasr',
    iconName: 'circle-play',
    icon: [
      512,
      512,
      [61469,"play-circle"],
      'f144',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm384 0L176 384V128L384 256z'
      
    ]
  };

  
    var faPlayCircle = faCirclePlay;
  

  
  

  var faCannabis = {
    prefix: 'fasr',
    iconName: 'cannabis',
    icon: [
      512,
      512,
      [],
      'f55f',
      
      'M208.3 307.8l-66-66c-6.1-6.1-17-13.2-33.2-20.3c-14.8-6.5-31.7-12-48.3-16.5c9.3 29.7 23.7 60.1 44.9 81.4l41.1 41.1L98.4 359.7l-14 9.3c18.3 8.9 38.8 15.3 59.6 15.3h47.7v29.2c8.1-3.9 16.5-8.2 24.8-13L232 416V344 320h48v24 72l15.5-15.5c8.3 4.8 16.7 9.2 24.8 13V384.3H368c20.8 0 41.3-6.4 59.6-15.3l-14-9.3-48.4-32.3 41.1-41.1c21.2-21.2 35.7-51.7 44.9-81.4c-16.6 4.5-33.4 10-48.3 16.5c-16.2 7.1-27.2 14.3-33.2 20.3l-66 66-15.4-11.5V208c0-52.1-15.8-95.1-32.3-125.8c-16.6 30.7-32.3 73.6-32.3 125.8v88.2l-15.4 11.5zM232 446.5c-40.9 22.4-80 33.5-80 33.5s-3.3-6.6-5.7-19.8c-1.3-7.2-2.3-16.4-2.3-27.6l0-.6c-41.1 0-77.9-16.9-104.1-33.3C15.1 383.1 0 368 0 368l31.7-21.1 9.2-6.2L72 320c-11.4-11.4-21-24.3-29.1-37.9C25 252.4 14.4 219.6 8.3 193.5C1.5 164.7 0 144 0 144s20.9 2.6 49 8.9c24.4 5.5 54.3 13.7 80.5 25.4c18.2 8.1 34.7 17.9 46.4 29.7c0-19.9 1.9-38.7 5.2-56.2c9.1-48.6 28.5-87.2 45.3-113.4C242.4 13.6 256 0 256 0s13.6 13.6 29.5 38.4c16.8 26.2 36.2 64.8 45.3 113.4c3.3 17.5 5.2 36.2 5.2 56.2c11.7-11.7 28.2-21.5 46.4-29.7c26.2-11.7 56.1-20 80.5-25.4c28.1-6.3 49-8.9 49-8.9s-1.5 20.7-8.3 49.5c-6.2 26.1-16.7 58.9-34.6 88.6C461 295.7 451.4 308.6 440 320l31 20.7 9.2 6.2L512 368s-15.1 15.1-39.9 30.7C445.9 415.1 409.1 432 368 432l0 .6c0 11.2-1 20.4-2.3 27.6C363.3 473.4 360 480 360 480s-39.1-11.2-80-33.5V488v24H232V488 446.5z'
      
    ]
  };

  

  
  

  var faTruckRampCouch = {
    prefix: 'fasr',
    iconName: 'truck-ramp-couch',
    icon: [
      640,
      512,
      ["truck-couch"],
      'f4dd',
      
      'M352 0h24H616h24V48H616 400V360.3l26-6.7 0 0c17.6-38.7 56.7-65.6 102-65.6c61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.9 0-108.9-47.1-111.9-106.3L38 503.2l-23.2 6-12-46.5 23.2-6 326-84.1V24 0zM592 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2V334.8l-38.7 10.4L126.7 386.6 34 411.5 13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8z'
      
    ]
  };

  
    var faTruckCouch = faTruckRampCouch;
  

  
  

  var faAnglesRight = {
    prefix: 'fasr',
    iconName: 'angles-right',
    icon: [
      512,
      512,
      [187,"angle-double-right"],
      'f101',
      
      'M273 273l17-17-17-17L113 79l-17-17L62.1 96l17 17 143 143L79 399l-17 17L96 449.9l17-17L273 273zm192 0l17-17-17-17L305 79l-17-17L254.1 96l17 17 143 143L271 399l-17 17L288 449.9l17-17L465 273z'
      
    ]
  };

  
    var faAngleDoubleRight = faAnglesRight;
  

  
  

  var faSnowplow = {
    prefix: 'fasr',
    iconName: 'snowplow',
    icon: [
      640,
      512,
      [],
      'f7d2',
      
      'M136 0H112V24 128H72 48v24V308.1C19 328.3 0 361.9 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-20.4-5.5-39.5-15-56h47v56 9.3l6.2 6.9 80 88 35.5-32.3L560 390.7V249.3l73.8-81.1-35.5-32.3-80 88-6.2 6.9V240v56H432V232 208v-5.4l-2.3-4.9-88-184L335.1 0H320 136zM381.4 208H219.5l-56.8-71-2.7-3.4V48H304.9l76.5 160zM132.5 176l56.8 71 7.2 9H208 384v33.1c-5.2-.7-10.6-1.1-16-1.1H112c-5.4 0-10.8 .4-16 1.1V176h16 20.5zM112 336H368c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64zm32 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faAlignSlash = {
    prefix: 'fasr',
    iconName: 'align-slash',
    icon: [
      640,
      512,
      [],
      'f846',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L472.4 344H520h24V296H520 410.6l-103-80H520h24V168H520 245.7l-103-80H520h24V40H520 120 96V51.8l-47.6-37zM477.2 472l-60.9-48H120 96v48h24H477.2zM314.8 344l-60.9-48H120 96v48h24H314.8zM152.3 216L96 171.6V216h24 32.3z'
      
    ]
  };

  

  
  

  var faOctagonXmark = {
    prefix: 'fasr',
    iconName: 'octagon-xmark',
    icon: [
      512,
      512,
      ["times-octagon","xmark-octagon"],
      'f2f0',
      
      'M48 332.1V179.9L179.9 48H332.1L464 179.9V332.1L332.1 464H179.9L48 332.1zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM353.9 192L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faTimesOctagon = faOctagonXmark;
  
    var faXmarkOctagon = faOctagonXmark;
  

  
  

  var faMonument = {
    prefix: 'fasr',
    iconName: 'monument',
    icon: [
      384,
      512,
      [],
      'f5a6',
      
      'M141.2 118.7L95.5 432H47L96 96l62.1-62.1L192 0l33.9 33.9L288 96l49 336H288.5L242.8 118.7 192 67.9l-50.8 50.8zM344 512H296 88 40 24 0V464H24 42.3 90.8 293.2h48.5H360h24v48H360 344zM144 336V288h96v48H144z'
      
    ]
  };

  

  
  

  var faRefrigerator = {
    prefix: 'fasr',
    iconName: 'refrigerator',
    icon: [
      384,
      512,
      [],
      'e026',
      
      'M336 48V160H288V120 96H240v24 40H48V48H336zM240 208V344v24h48V344 208h48V464H48V208H240zM48 0H0V48 464v48H48 336h48V464 48 0H336 48z'
      
    ]
  };

  

  
  

  var faMinimize = {
    prefix: 'fasr',
    iconName: 'minimize',
    icon: [
      512,
      512,
      ["compress-arrows-alt"],
      'f78c',
      
      'M40 6.1L6.1 40 23 57l64 64L57.9 150.1 24 184l33.9 33.9L64 224l112 0h48l0-48 0-112-6.1-6.1L184 24 150.1 57.9 121 87 57 23 40 6.1zM505.9 40L472 6.1 455 23 391 87 361.9 57.9 328 24 294.1 57.9 288 64V176v48h48l112 0 6.1-6.1L488 184l-33.9-33.9L425 121l64-64 17-17zM57.9 361.9L87 391 23 455l-17 17L40 505.9l17-17 64-64 29.1 29.1L184 488l33.9-33.9L224 448V336 288H176 64l-6.1 6.1L24 328l33.9 33.9zM425 391l29.1-29.1L488 328l-33.9-33.9L448 288H336 288v48V448l6.1 6.1L328 488l33.9-33.9L391 425l64 64 17 17L505.9 472l-17-17-64-64zM176 412.1L99.9 336H176v76.1zm160 0V336h76.1L336 412.1zm0-312.2L412.1 176 336 176V99.9zm-160 0V176l-76.1 0L176 99.9z'
      
    ]
  };

  
    var faCompressArrowsAlt = faMinimize;
  

  
  

  var faSmoking = {
    prefix: 'fasr',
    iconName: 'smoking',
    icon: [
      640,
      512,
      [128684],
      'f48d',
      
      'M416 0h48V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v43H512V245c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V0zM640 288H592V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V0h48V43c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v43zm-80 88V488v24H512V488 376 352h48v24zm80 0V488v24H592V488 376 352h48v24zM224 464H432V400H224v64zM0 352H48 432h48v48 64 48H432 48 0V464 400 352z'
      
    ]
  };

  

  
  

  var faDolly = {
    prefix: 'fasr',
    iconName: 'dolly',
    icon: [
      576,
      512,
      ["dolly-box"],
      'f472',
      
      'M24 0H0V48H24h86.6l93.7 287.1C177.7 352.1 160 382 160 416c0 53 43 96 96 96s96-43 96-96c0-2.8-.1-5.5-.3-8.2L560 334.6l22.6-8-15.9-45.3-22.6 8L335.8 362.5C318.5 336.9 289.2 320 256 320c-2 0-4 .1-6 .2L150.8 16.6C147.6 6.7 138.4 0 128 0H24zM256 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM446.5 87.7l-8.2-22.2L416 73.4 224.9 140.5l14.9 45.6 57.5-20.2 24.1 66.3 8.2 22.6 45.1-16.4-8.2-22.6L342.6 150l67-23.5 57.3 156 45.3-15.9L446.5 87.7z'
      
    ]
  };

  
    var faDollyBox = faDolly;
  

  
  

  var faGem = {
    prefix: 'fasr',
    iconName: 'gem',
    icon: [
      512,
      512,
      [128142],
      'f3a5',
      
      'M289 445l-33 35-33-35L0 208 112 32H400L512 208 289 445zM431 224H256 81L256 410 431 224zm3.7-48L385 97.9 311.5 176H434.7zM336 80H176l80 85 80-85zM127 97.9L77.3 176H200.5L127 97.9z'
      
    ]
  };

  

  
  

  var faHandshake = {
    prefix: 'fasr',
    iconName: 'handshake',
    icon: [
      640,
      512,
      [],
      'f2b5',
      
      'M272.8 64l-48 48H209.5l-61.2 57.5-6.9 6.5h-9.5H96V304h20.9 9.9l7 7 52 52 7 7 17 17 21.3 21.3L254.5 385l17-17 17 17 21 21L339.4 376l17-17 17 17 9.7 9.7 49-49v-1.8L340.1 243l-67.9 62.6-18 16.6-16.2-18.3-64-72-15.5-17.4 17-16 136-128 6.9-6.5H328h96 9.1l6.8 6.1L505.1 128H544h40 24 32V384H544V368H468.5l-68.6 68.6-17 17-17-17-9.7-9.7-29.9 29.9-17 17-17-17-21-21-23.3 23.3-17 17-17-17L176 421l-17-17-7-7-45-45H96v32H0V128H32 56 96h26.3l61.2-57.5 6.9-6.5H200h72.8zM544 320V176H496h-9.1l-6.8-6.1L414.9 112H337.5L225.4 217.5l32.3 36.3 86-79.4 17.6-16.3 32.6 35.3-17.6 16.3-.8 .8L483.8 318.8 485 320h59zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faHeadSideMask = {
    prefix: 'fasr',
    iconName: 'head-side-mask',
    icon: [
      576,
      512,
      [],
      'e063',
      
      'M144 361.7v19.6V448v16 48H128 96V480 464 381.2c-41-41.9-64-98.3-64-157C32 100.6 132.2 0 256 0h32C389.8 0 473.1 79.2 479.6 179.4l56.3 63.4 8.1 9.1V264v8 16 16 16L480 512H352 320 304 256V464 320v-3.2L81.6 200.6c-1 7.7-1.6 15.6-1.6 23.7c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM95.4 152.1L275.3 272H304 496v-1.9l-52.3-58.8-11-12.3-1.1-16.5C426.8 107.4 364.3 48 288 48H256C184.5 48 122.9 90.8 95.4 152.1zM368 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM493.4 320H304V464H445.4l8-24H368 352V408h16 96.1l10.7-32H368 352V344h16H485.4l8-24z'
      
    ]
  };

  

  
  

  var faLemon = {
    prefix: 'fasr',
    iconName: 'lemon',
    icon: [
      448,
      512,
      [127819],
      'f094',
      
      'M448 80l-21.3 63.7c45.1 87.3 14.5 190.7-54.9 260.1s-172.8 100-260.1 54.9L48 480 0 432l21.2-63.8C-23.9 281 6.8 177.5 76.2 108.2S249 8.1 336.2 53.2L400 32l48 48zM96.6 413.2l19.2-6.4 18 9.3c63.6 32.9 145 12.9 204.1-46.2S417 229.4 384.1 165.8l-9.3-18 6.4-19.2L393.1 93l-6-6L351.4 98.8l-19.2 6.4-18-9.3C250.6 63 169.2 83 110.1 142.1S31 282.6 63.9 346.2l9.3 18-6.4 19.2L54.9 419l6 6 35.6-11.9zM135 278.7L89 265.3c19.8-67.7 76.6-124.5 144.3-144.3L246.7 167c-52 15.2-96.5 59.7-111.7 111.7z'
      
    ]
  };

  

  
  

  var faTick = {
    prefix: 'fasr',
    iconName: 'tick',
    icon: [
      192,
      512,
      [],
      'e32f',
      
      'M72 108L96 252l24-144 0-28L72 80l0 28zm48-76l48 0 0 48 0 32L136 304l-80 0L24 112l0-32 0-48 48 0 48 0z'
      
    ]
  };

  

  
  

  var faSquareA = {
    prefix: 'fasr',
    iconName: 'square-a',
    icon: [
      448,
      512,
      [],
      'e25f',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm208.8 96h30.5l6.5 13.8L359.4 384h-53l-22.5-48H164.2l-22.5 48h-53L202.3 141.8l6.5-13.8zM224 208.5L186.7 288h74.6L224 208.5z'
      
    ]
  };

  

  
  

  var faTableColumns = {
    prefix: 'fasr',
    iconName: 'table-columns',
    icon: [
      512,
      512,
      ["columns"],
      'f0db',
      
      'M48 432V160H232V432H48zm232 0V160H464V432H280zM48 32H0V80 432v48H48 464h48V432 80 32H464 48z'
      
    ]
  };

  
    var faColumns = faTableColumns;
  

  
  

  var faRotateLeft = {
    prefix: 'fasr',
    iconName: 'rotate-left',
    icon: [
      512,
      512,
      ["rotate-back","rotate-backward","undo-alt"],
      'f2ea',
      
      'M139.8 123.8C170.8 96.5 211.5 80 256 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2l-28.8 38.4C159 463.3 205.6 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-57.8 0-110.5 21.9-150.2 57.8L89.9 73.9 56 40 22.1 73.9 16 80v96 48H64h96l6.1-6.1L200 184l-33.9-33.9-26.3-26.3zM64 115.9L124.1 176H64V115.9z'
      
    ]
  };

  
    var faRotateBack = faRotateLeft;
  
    var faRotateBackward = faRotateLeft;
  
    var faUndoAlt = faRotateLeft;
  

  
  

  var faMartiniGlass = {
    prefix: 'fasr',
    iconName: 'martini-glass',
    icon: [
      512,
      512,
      [127864,"glass-martini-alt"],
      'f57b',
      
      'M0 0V48L222.1 270.1 232 280V464H152 128v48h24H256 360h24V464H360 280V280l9.9-9.9L512 48V0H464 48 0zM316.1 176L256 236.1 195.9 176H316.1zm48-48H147.9l-80-80H444.1l-80 80z'
      
    ]
  };

  
    var faGlassMartiniAlt = faMartiniGlass;
  

  
  

  var faBracketSquareRight = {
    prefix: 'fasr',
    iconName: 'bracket-square-right',
    icon: [
      192,
      512,
      [],
      '5d',
      
      'M192 32H168 72 48V80H72h72V432H72 48v48H72h96 24V456 56 32z'
      
    ]
  };

  

  
  

  var faArrowUpFromGroundWater = {
    prefix: 'fasr',
    iconName: 'arrow-up-from-ground-water',
    icon: [
      576,
      512,
      [],
      'e4b5',
      
      'M288-1.9l17 17 80 80 17 17L368 145.9l-17-17-39-39V328v24H264V328 89.9l-39 39-17 17L174.1 112l17-17 80-80 17-17zM48 192H192v48H48V401c-2.4 1.3-4.8 2.5-7.3 3.7C27.6 410.7 13 415 0 415V240 192H48zM576 415c-13 0-27.6-4.3-40.7-10.3c-2.5-1.1-4.9-2.4-7.3-3.7V240H384V192H528h48v48V415zM79 488.9C59.7 499.8 31.5 512 0 512V464c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  

  
  

  var faForklift = {
    prefix: 'fasr',
    iconName: 'forklift',
    icon: [
      640,
      512,
      [],
      'f47a',
      
      'M120 0H96V24 160H48 0v48V368v48c0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6V288 240v-4.7l-1.8-4.4-88-216L320.1 0H304 120zM240 240l-96-68.6V48H287.9l78.2 192H240zm-15.4 48H240 368v33.3c-5.2-.9-10.5-1.3-16-1.3c-35.5 0-66.6 19.3-83.2 48H179.2c-16.6-28.7-47.6-48-83.2-48c-17.5 0-33.9 4.7-48 12.8V208h64.6l99.5 71.1 12.5 8.9zM96 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM528 24V0H480V24 424v24h24H616h24V400H616 528V24z'
      
    ]
  };

  

  
  

  var faSquareNfi = {
    prefix: 'fasr',
    iconName: 'square-nfi',
    icon: [
      448,
      512,
      [],
      'e576',
      
      'M48 80H400v48h48V80 32H400 48 0V80v48H48V80zm0 304H0v48 48H48 400h48V432 384H400v48H48V384zM32 160v24V328v24H80V328 262.9l48.4 77.8 7 11.3h13.3H152h24V328 184 160H128v24 65.1L79.6 171.3l-7-11.3H59.2 56 32zm184 0v24 80 64 24h48V328 288h40 24V240H304 264V208h40 24V160H304 240 216zm200 24V160H368v24V328v24h48V328 184z'
      
    ]
  };

  

  
  

  var faHouseTsunami = {
    prefix: 'fasr',
    iconName: 'house-tsunami',
    icon: [
      576,
      512,
      [],
      'e515',
      
      'M50 176.4C62 104.5 127.8 48 209.4 48c18.8 0 36.7 3 53.4 8.5l15-45.6C256.4 3.8 233.4 0 209.4 0C95 0 0 88.4 0 200c0 93.2 54.7 174 144.8 194.8c12.7 3.4 26 5.2 39.7 5.2c.6 0 1.2 0 1.8-.1c1.8 0 3.6 .1 5.4 .1c.1 0 .3 0 .4 0v0c31.5 0 59.7-12.2 79-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V352c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9v0c-.1 0-.3 0-.4 0c-12.9 0-25.2-1.4-36.7-4.2c-43.4-12.7-75-52.6-75-99.8c0-57.4 46.7-104 104.4-104c15.9 0 30.9 3.5 44.3 9.8L249 110.3C229.4 101.1 207.5 96 184.4 96C126.3 96 75.6 128.5 50 176.4zM368 285.1V152l79.9-60L527.5 152l.3 120.9c2.5 1.4 5 2.6 7.6 3.8c13.1 6 27.5 10.3 40.5 10.3l-.3-159L448 32 320 128V262.9c8.1 5.6 15.2 10 23.3 13.7c7.9 3.6 16.4 6.7 24.7 8.5zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V464c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6 0 0c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4 0 0c-13 11.6-24.8 22.2-40.2 30.9C39.5 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1z'
      
    ]
  };

  

  
  

  var faFolderClosed = {
    prefix: 'fasr',
    iconName: 'folder-closed',
    icon: [
      512,
      512,
      [],
      'e185',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V192H464V144H272zM48 240V432H464V240H48z'
      
    ]
  };

  

  
  

  var faCircleSortDown = {
    prefix: 'fasr',
    iconName: 'circle-sort-down',
    icon: [
      512,
      512,
      ["sort-circle-down"],
      'e031',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM144 320l112 96 112-96V288H144v32zm0-96h32H336h32V192L256 96 144 192v32zm112-85.9L318.8 192H193.2L256 138.1z'
      
    ]
  };

  
    var faSortCircleDown = faCircleSortDown;
  

  
  

  var faScrewdriver = {
    prefix: 'fasr',
    iconName: 'screwdriver',
    icon: [
      512,
      512,
      [129691],
      'f54a',
      
      'M368 120v24h24l56.6-75.5-5.1-5.1L368 120zM512 64L416 192H368 353.9l-82.3 82.3-33.9-33.9L320 158.1V144 96L448 0l64 64zM129.9 478.1L96 512 62.1 478.1 33.9 449.9 0 416l33.9-33.9L150.1 265.9 184 232l33.9 33.9 28.1 28.1L280 328l-33.9 33.9L129.9 478.1zM212.1 328L184 299.9 67.9 416 96 444.1 212.1 328z'
      
    ]
  };

  

  
  

  var faShieldXmark = {
    prefix: 'fasr',
    iconName: 'shield-xmark',
    icon: [
      512,
      512,
      ["shield-times"],
      'e24c',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM353.9 192L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faShieldTimes = faShieldXmark;
  

  
  

  var faCaretUp = {
    prefix: 'fasr',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M48 320H0V272L160 128 320 272v48H272 48zm200.2-48L160 192.6 71.8 272H248.2z'
      
    ]
  };

  

  
  

  var faDownFromLine = {
    prefix: 'fasr',
    iconName: 'down-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-top"],
      'f349',
      
      'M224 256l0 48 48 0 28.1 0L192 412.1 83.9 304l28.1 0 48 0 0-48 0-80 64 0 0 80zm1.9 190.1L352 320l0-16 0-48-32 0-16 0-32 0 0-48 0-32 0-48-48 0-64 0-48 0 0 48 0 32 0 48-32 0-16 0-32 0 0 48 0 16L158.1 446.1 192 480l33.9-33.9zM24 80l336 0 24 0 0-48-24 0L24 32 0 32 0 80l24 0z'
      
    ]
  };

  
    var faArrowAltFromTop = faDownFromLine;
  

  
  

  var faSquareRing = {
    prefix: 'fasr',
    iconName: 'square-ring',
    icon: [
      448,
      512,
      [],
      'e44f',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM304 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 256a128 128 0 1 1 256 0A128 128 0 1 1 96 256z'
      
    ]
  };

  

  
  

  var fa3 = {
    prefix: 'fasr',
    iconName: '3',
    icon: [
      320,
      512,
      [],
      '33',
      
      'M304 32H280 24 0V80H24 220.3L71.4 222.7 64 229.8V264H88 188c46.4 0 84 37.6 84 84s-37.6 84-84 84H97.4c-21.2 0-40.6-12-50.1-31l-1.9-3.8L2.5 418.7l1.9 3.8C22 457.7 58.1 480 97.4 480H188c72.9 0 132-59.1 132-132s-59.1-132-132-132H147.7L296.6 73.3l7.4-7.1V32z'
      
    ]
  };

  

  
  

  var faFileZip = {
    prefix: 'fasr',
    iconName: 'file-zip',
    icon: [
      512,
      512,
      [],
      'e5ee',
      
      'M48 464H160v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zM240 352h64 16v16 8 4.2l-2.1 3.7L263 480h41 16v32H304 240 224V496v-8-4.2l2.1-3.7L281 384H240 224V352h16zm144 16V496v16H352V496 368 352h32v16zm32-16h16 24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32 16H416V496 448 368 352zm32 80h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z'
      
    ]
  };

  

  
  

  var faCow = {
    prefix: 'fasr',
    iconName: 'cow',
    icon: [
      640,
      512,
      [128004],
      'f6c8',
      
      'M72 184c0-23 10.7-43.4 27.5-56.6C97.2 135.2 96 143.5 96 152V424v24h24 80 24V424 378.6c2.5 .6 5.2 1.2 8 1.7V392v16h32V392v-8.1c2.6 .1 5.3 .1 8 .1s5.4 0 8-.1V392v16h32V392 380.4c2.8-.5 5.5-1.1 8-1.7V424v24h24 80 24V424 267.7l16 20.6V336v7l3.8 5.9 56 88 7.1 11.1H544h72 24V424 264v-8.2l-5-6.5-11-14.2V224 168 144H576v24 5l-48.2-62.4C505.1 81.2 470 64 432.9 64H256 184 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v32H8c35.3 0 64-28.7 64-64V224 184zm91.2-66.1c3.6 12.3 10.3 23.6 19.5 32.8l7.4 7.4C211.8 179.8 241.3 192 272 192s60.2-12.2 81.9-33.9l7.4-7.4c10.7-10.7 17.9-24.1 21-38.6h50.5c22.3 0 43.3 10.3 57 28L592 272.2V400H557.2L512 329V280v-8.2l-5.1-6.5-56-72-7.2-9.3H432h-8H400v24V400H368V352v-8-8c0-53-43-96-96-96s-96 43-96 96v8 8 48H144V152c0-14.5 7.7-27.1 19.2-34.1zm62.4 211.4l-1.1-.4C228 305.7 247.9 288 272 288s44 17.7 47.5 40.9l-1.1 .4c-9.7 3.2-25.1 6.8-46.4 6.8s-36.7-3.5-46.4-6.8zM576 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMicrophone = {
    prefix: 'fasr',
    iconName: 'microphone',
    icon: [
      384,
      512,
      [],
      'f130',
      
      'M144 48h96V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V48zM96 0V48 256c0 53 43 96 96 96s96-43 96-96V48 0H240 144 96zM64 216V192H16v24 40c0 89.1 66.2 162.7 152 174.4V464H120 96v48h24 72 72 24V464H264 216V430.4c85.8-11.7 152-85.3 152-174.4V216 192H320v24 40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z'
      
    ]
  };

  

  
  

  var faWindowFrame = {
    prefix: 'fasr',
    iconName: 'window-frame',
    icon: [
      512,
      512,
      [129695],
      'e04f',
      
      'M80 464H232V272H80V464zm-48 0V48 0H80 432h48V48 464h8 24v48H488h-8H432 80 32 24 0V464H24h8zm400 0V272H280V464H432zM80 224H232V48H80V224zm200 0H432V48H280V224z'
      
    ]
  };

  

  
  

  var faImage = {
    prefix: 'fasr',
    iconName: 'image',
    icon: [
      512,
      512,
      [],
      'f03e',
      
      'M464 80V427.2l-12.6-17.3-128-176L303.8 207 284.5 234 194.3 360.3 161 327l-17.9-17.9-16.9 18.8-72 80L48 414.8V80H464zM48 32H0V80 432v48H48 464h48V432 80 32H464 48zM192 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faFloppyDiskPen = {
    prefix: 'fasr',
    iconName: 'floppy-disk-pen',
    icon: [
      576,
      512,
      [],
      'e182',
      
      'M0 480H48 258l6.9-48H48V80H80V184v24h24H296h24V184 83.9l80 80V284.4l48-48V144L336 32H48 0V80 432v48zM128 160V80H272v80H128zm96 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM505 224l-41.3 41.3 71 71L576 294.9l-71-71zm-63.9 63.9L299.9 429.1 288 512l82.9-11.9L512.1 358.9l-71-71z'
      
    ]
  };

  

  
  

  var faBucket = {
    prefix: 'fasr',
    iconName: 'bucket',
    icon: [
      448,
      512,
      [],
      'e4cf',
      
      'M75.5 0H96 352h20.5l3.2 20.3L397.8 160H349.2L331.5 48h-215L98.8 160H50.2L72.3 20.3 75.5 0zM0 192H32 80.2 367.8 416h32v48H411.2L384 512H64L36.8 240H0V192zm85 48l22.4 224H340.6L363 240H85z'
      
    ]
  };

  

  
  

  var faFrog = {
    prefix: 'fasr',
    iconName: 'frog',
    icon: [
      576,
      512,
      [],
      'f52e',
      
      'M312.8 142.2l-30.6 3.4C150.4 160.5 48 272.3 48 408v24H240l-1-1 56.8-56.8c10.4-10.3 16.2-24.4 16.2-39c0-30.5-24.7-55.2-55.2-55.2c-14.6 0-28.7 5.8-39 16.2L169 345l-17 17L118.1 328l17-17 48.8-48.8c19.4-19.4 45.6-30.2 73-30.2c48.4 0 89 33.3 100.2 78.3l5.9-4.8 5.1-5.4 .7 .7 2.4-1.9c4.6-3.8 9.5-7.3 14.5-10.5L528 197.7V179.5l-80-24.6-27.3-8.4-5.6-28C410.6 96.5 391.2 80 368 80c-21.2 0-39.3 13.8-45.6 33l-9.6 29.3zM576 224L442 309.3l-30.7 19.6c-3.5 2.2-6.8 4.6-9.9 7.2l1.8 1.9 31 33.4L490.5 432H528h24 24v48H552 528 490.5 480 469.5l-7.1-7.7-7.1-7.7L432 439.6l-7-7.6-24.3-26.2L384 387.9l-3.6-3.9-12.5-13.4L355.4 384l-20.3 21.8L310.9 432H336h23.5 .5 16.4H384v26.4V480H360 336 310.9 200.8 48 24 0V456 432 408C0 247.6 121.1 115.5 276.8 98c12.6-38.3 48.7-66 91.2-66c46.5 0 85.3 33.1 94.1 77L576 144v80zM368 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMessageLines = {
    prefix: 'fasr',
    iconName: 'message-lines',
    icon: [
      512,
      512,
      ["comment-alt-lines"],
      'f4a6',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM152 144H128v48h24H360h24V144H360 152zm0 96H128v48h24H264h24V240H264 152z'
      
    ]
  };

  
    var faCommentAltLines = faMessageLines;
  

  
  

  var faCloudExclamation = {
    prefix: 'fasr',
    iconName: 'cloud-exclamation',
    icon: [
      640,
      512,
      [],
      'e491',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM344 160v24V296v24H296V296 184 160h48zM296 352h48v48H296V352z'
      
    ]
  };

  

  
  

  var faToriiGate = {
    prefix: 'fasr',
    iconName: 'torii-gate',
    icon: [
      512,
      512,
      [9961],
      'f6a1',
      
      'M416 80h7.8l7.4-2.5L464 66.6V104l-32 24-152 0H232L80 128 48 104V66.6L80.8 77.5 88.2 80H96 416zM232 176v64l-120 0V176H232zM64 288V488v24h48V488 288l144 0 144 0V488v24h48V488 288h40 24V240H488 448V176l64-48V50.6 0L464 16 416 32H96L48 16 0 0V50.6 128l64 48v64H24 0v48H24 64zm336-48l-120 0V176H400v64z'
      
    ]
  };

  

  
  

  var faPanelEws = {
    prefix: 'fasr',
    iconName: 'panel-ews',
    icon: [
      512,
      512,
      [],
      'e42e',
      
      'M48 48V294.7C76.3 307 96 335.2 96 368v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352H128V256h96v96H192v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-14.2-6.2-27-16-35.8V464H464V48H48zM0 0H48 464h48V48 464v48H464 48 0V464 48 0zM112 96h96 16v32H208 112 96V96h16zm192 0h96 16v32H400 304 288V96h16zM112 160h96 16v32H208 112 96V160h16zm192 0h96 16v32H400 304 288V160h16zm112 96V416H288V256H416z'
      
    ]
  };

  

  
  

  var faSubtitles = {
    prefix: 'fasr',
    iconName: 'subtitles',
    icon: [
      576,
      512,
      [],
      'e60f',
      
      'M48 80V432H528V80H48zM0 32H48 528h48V80 432v48H528 48 0V432 80 32zM120 240H296h24v48H296 120 96V240h24zm256 0h80 24v48H456 376 352V240h24zM120 336h80 24v48H200 120 96V336h24zm160 0H456h24v48H456 280 256V336h24z'
      
    ]
  };

  

  
  

  var faSunrise = {
    prefix: 'fasr',
    iconName: 'sunrise',
    icon: [
      576,
      512,
      [127749],
      'f766',
      
      'M305 18.2l-17-17-17 17L194.2 95l-17 17 33.9 33.9 17-17L264 93.1V200v24h48V200 93.1L347.8 129l17 17L398.7 112l-17-17L305 18.2zM288 281.1l-62.9-33.9L182 224l-14.1 46.9-20.5 68.4L78.9 359.9 32 374l23.2 43.1L80.5 464H24 0v48H24 552h24V464H552 495.5l25.3-46.9L544 374l-46.9-14.1-68.4-20.5-20.5-68.4L394 224l-43.1 23.2L288 281.1zM177.1 464H135l-3.6-6.8L102.2 403l59-17.7 24.8-7.4 7.4-24.8 17.7-59 54.2 29.2L288 335.6l22.8-12.3L365 294.2l17.7 59 7.4 24.8 24.8 7.4 59 17.7-29.2 54.2L441 464H398.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96zM288 416c29.8 0 54.9 20.4 62 48H226c7.1-27.6 32.2-48 62-48z'
      
    ]
  };

  

  
  

  var faHockeyMask = {
    prefix: 'fasr',
    iconName: 'hockey-mask',
    icon: [
      448,
      512,
      [],
      'f6ee',
      
      'M224 464c82 0 119.4-18.7 140-45.4c23.4-30.3 36-83.6 36-178.6V48H224 48V240c0 95.1 12.6 148.4 36 178.6c20.6 26.7 58 45.4 140 45.4zm0 48C48 512 0 432 0 240V48 0H48 224 400h48V48 240c0 192-48 272-224 272zM200 208c0 35.3-28.7 64-64 64s-64-28.7-64-64V176H200v32zm112 64c-35.3 0-64-28.7-64-64V176H376v32c0 35.3-28.7 64-64 64zM176 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm32 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM176 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faLacrosseStick = {
    prefix: 'fasr',
    iconName: 'lacrosse-stick',
    icon: [
      512,
      512,
      [],
      'e3b5',
      
      'M261.5 107.5l-14.7 44.1-1.4 4.2-2.8 3.4-50.7 61.9c-10.3 12.6-15.9 28.3-15.9 44.5c0 38.8 31.5 70.3 70.3 70.3c16.2 0 32-5.6 44.5-15.9l61.9-50.7 3.4-2.8 4.2-1.4 44.1-14.7C440 238.7 464 205.4 464 168h0l0-.3c0-22.9-15.2-53-40.9-78.8S367.2 48 344.3 48l-.3 0v0c-37.4 0-70.7 24-82.5 59.5zM344 0V0l.3 0C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3h0c0 58.1-37.2 109.7-92.3 128.1l-39.9 13.3-58.5 47.9c-21.1 17.3-47.6 26.7-74.9 26.7c-24 0-46.3-7.1-65-19.4L52.2 493.8l-17 17L1.3 476.8l17-17L147.4 330.6c-12.3-18.6-19.4-41-19.4-65c0-27.3 9.5-53.8 26.7-74.9l47.9-58.5 13.3-39.9C234.3 37.2 285.9 0 344 0z'
      
    ]
  };

  

  
  

  var faCustard = {
    prefix: 'fasr',
    iconName: 'custard',
    icon: [
      576,
      512,
      [127854],
      'e403',
      
      'M134.6 239.1L103.1 368H53.7L128 64H448l74.3 304H472.9L441.4 239.1 385 225l-89.4 29.8-7.6 2.5-7.6-2.5L191 225l-56.4 14.1zm12.9-52.7l38.7-9.7L193 175l6.6 2.2L288 206.7l88.4-29.5L383 175l6.8 1.7 38.7 9.7L410.3 112H165.7l-18.2 74.4zM0 400H24 552h24v48H552 24 0V400z'
      
    ]
  };

  

  
  

  var faMistletoe = {
    prefix: 'fasr',
    iconName: 'mistletoe',
    icon: [
      576,
      512,
      [],
      'f7b4',
      
      'M312 0V24 86.1l98 98 8.7 1.7 65.9 12.7C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-12.7-65.9-1.7-8.7L312 153.9V288l6 8 46.8 62.4C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L258 296l6-8V153.9L199.9 218l-1.4 7.4c3-.9 6.2-1.4 9.5-1.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-7.6 0-14.7-2.7-20.2-7.2l-2.3 11.9C175.4 345.7 129 384 75 384c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l65.9-12.7 8.7-1.7 98-98V24 0h48zM100.4 245.6C70 251.4 48 278 48 309c0 14.9 12.1 27 27 27c30.9 0 57.5-22 63.4-52.4l9.1-47.1-47.1 9.1zm328.2-9.1l9.1 47.1C443.4 314 470 336 501 336c14.9 0 27-12.1 27-27c0-30.9-22-57.5-52.4-63.4l-47.1-9.1zM249.6 387.2c-6.2 8.3-9.6 18.4-9.6 28.8c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L288 336l-38.4 51.2zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faBowlScoops = {
    prefix: 'fasr',
    iconName: 'bowl-scoops',
    icon: [
      448,
      512,
      [127813],
      'e3df',
      
      'M224 208c0-22.7 6.7-43.8 18.3-61.4c19.8-30.2 53.8-50.2 92.6-50.6l1.1 0c61.9 0 112 50.1 112 112c0 5.4-.4 10.8-1.1 16H225.1c-.7-5.2-1.1-10.6-1.1-16zM0 208C0 146.1 50.1 96 112 96l1.1 0c38.7 .4 72.7 20.4 92.6 50.6C196.9 165.2 192 186 192 208c0 5.4 .3 10.7 .9 16H1.1C.4 218.8 0 213.4 0 208zM325.4 64.4c-40.9 3-77.1 23-101.4 53.1c-24.3-30.1-60.5-50.1-101.4-53.1C140.5 26.3 179.2 0 224 0s83.5 26.3 101.4 64.4zM443.2 304c-7.2 57.5-52.1 102.3-108.2 110.6c-6.2 .9-12.4 1.4-18.8 1.4H272l42.7 48L336 488v24H309 293.1 288 160h-5.1H139 112V488l21.3-24L176 416H131.8c-6.4 0-12.7-.5-18.8-1.4C56.9 406.3 12.1 361.5 4.8 304c-.1-1.1-.3-2.2-.4-3.3L0 256H48.2 399.8 448l-4.5 44.7c-.1 1.1-.2 2.2-.4 3.3zm-207 143.9L224 434.2l-12.1 13.6L197.6 464h52.9l-14.3-16.1zM176 368h96 10.9 33.3c38.4 0 70.9-27.1 78.4-64H53.4c7.5 36.9 40 64 78.4 64h33.3H176z'
      
    ]
  };

  

  
  

  var faSquarePlus = {
    prefix: 'fasr',
    iconName: 'square-plus',
    icon: [
      448,
      512,
      [61846,"plus-square"],
      'f0fe',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM200 368V344 280H136 112V232h24 64V168 144h48l0 24v64h64 24v48H312 248v64 24H200z'
      
    ]
  };

  
    var faPlusSquare = faSquarePlus;
  

  
  

  var faCircleV = {
    prefix: 'fasr',
    iconName: 'circle-v',
    icon: [
      512,
      512,
      [],
      'e12a',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM383.9 144H331.5L256 316.2 180.5 144H128.1L234 385.6l6.3 14.4h31.4l6.3-14.4L383.9 144z'
      
    ]
  };

  

  
  

  var faFileBinary = {
    prefix: 'fasr',
    iconName: 'file-binary',
    icon: [
      384,
      512,
      [],
      'e175',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM96 240H72v24V392v24H96h80 24V392 264 240H176 96zm24 128V288h32v80H120zM240 240H216v48h24v80H216v48h24 24 24 24V368H288V264 240H264 240z'
      
    ]
  };

  

  
  

  var faNfcMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'nfc-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e1f9',
      
      'M400 80H48V432H333.7c29 29.6 69.5 48 114.3 48H400 48 0V432 80 32H48 400h48V80v80c-16.7 0-32.8 2.6-48 7.3V80zm-32 56v45.4c-18.7 10.8-35.1 25.4-48 42.6V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V136 112h24H344h24v24zM309.4 400H104 80V376 136 112h24 32 24v48H136h-8V352H291.2c3.5 17.2 9.7 33.3 18.2 48zm138.6 .2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426c-20.5 14-45.3 22.1-72 22.1z'
      
    ]
  };

  

  
  

  var faWindowRestore = {
    prefix: 'fasr',
    iconName: 'window-restore',
    icon: [
      512,
      512,
      [],
      'f2d2',
      
      'M464 48H176V96H128V48 0h48H464h48V48 336v48H464 416V336h48V48zM48 464H336V256H48V464zm0-336H336h48v48V464v48H336 48 0V464 176 128H48z'
      
    ]
  };

  

  
  

  var faSailboat = {
    prefix: 'fasr',
    iconName: 'sailboat',
    icon: [
      576,
      512,
      [],
      'e445',
      
      'M256 320H528L256 0V320zM56 352H0l28.8 48L96 512H480l67.2-112L576 352H520 56zm28.8 48H491.2l-38.4 64H123.2L84.8 400zM224 64L48 320H224V64z'
      
    ]
  };

  

  
  

  var faCassetteBetamax = {
    prefix: 'fasr',
    iconName: 'cassette-betamax',
    icon: [
      576,
      512,
      ["betamax"],
      'f8a4',
      
      'M48 432V160H528V432H48zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM368 256h80v80H368V256zm-48-48v48 80 48h48 80 48V336 256 208H448 368 320zM184 240a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm0-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faBetamax = faCassetteBetamax;
  

  
  

  var faCrow = {
    prefix: 'fasr',
    iconName: 'crow',
    icon: [
      640,
      512,
      [],
      'f520',
      
      'M112.3 384L69 419.4 50.4 434.6 31.8 449.8 1.4 412.6 20 397.4l18.6-15.2 43.3-35.4L95.2 336 336 139.2V104C336 46.6 382.6 0 440 0c29.5 0 56.1 12.3 75 32h77l48 32V96l-96 24v8 64c0 88-59.1 162.1-139.8 184.8L459.8 512H407.9L355.2 384c-1.1 0-2.1 0-3.2 0H311.1l52.7 128H311.9L259.2 384H112.3zm116.8-75.9c53-11.6 93-53.1 104-104.5L196.4 315.2l32.6-7.1zM384 152v23.2c0 68.1-37.4 129-94.5 160.8H352c79.5 0 144-64.5 144-144V128 104c0-30.9-25.1-56-56-56s-56 25.1-56 56v35.2 12.7l0 .1zm32-48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var fa00 = {
    prefix: 'fasr',
    iconName: '00',
    icon: [
      640,
      512,
      [],
      'e467',
      
      'M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM48 176c0-53 43-96 96-96s96 43 96 96V336c0 53-43 96-96 96s-96-43-96-96V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM400 176c0-53 43-96 96-96s96 43 96 96V336c0 53-43 96-96 96s-96-43-96-96V176z'
      
    ]
  };

  

  
  

  var faHexagonDivide = {
    prefix: 'fasr',
    iconName: 'hexagon-divide',
    icon: [
      512,
      512,
      [],
      'e1ad',
      
      'M55.3 256L155.9 80H356.1L456.7 256 356.1 432H155.9L55.3 256zM128 32L0 256 128 480H384L512 256 384 32H128zm160 96H224v64h64V128zM168 232H144v48h24H344h24V232H344 168zm56 88v64h64V320H224z'
      
    ]
  };

  

  
  

  var faUserUnlock = {
    prefix: 'fasr',
    iconName: 'user-unlock',
    icon: [
      640,
      512,
      [],
      'e058',
      
      'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM65 464L99.5 352H320h28.5H384l0-48H64L14.8 464 0 512H50.2 384l0-48h-1H320 65zM496 272c0-17.7 14.3-32 32-32s32 14.3 32 32h48c0-44.2-35.8-80-80-80s-80 35.8-80 80v48H416V512H640V320H608 560 512 496V272z'
      
    ]
  };

  

  
  

  var faSensorFire = {
    prefix: 'fasr',
    iconName: 'sensor-fire',
    icon: [
      640,
      512,
      [],
      'e02a',
      
      'M48 80H400v75.1c11.3-9.2 21.9-16.7 31-22.4l17-10.6V80 32H400 48 0V80 432v48H48 337c-12.8-14.2-23.5-30.4-31.5-48H48V80zm96 72V128H96v24V264v24h48V264 152zm96 0V128H192v24V264v24h48V264 152zm208 8c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z'
      
    ]
  };

  

  
  

  var faFaceExhaling = {
    prefix: 'fasr',
    iconName: 'face-exhaling',
    icon: [
      576,
      512,
      [],
      'e480',
      
      'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 7-.3 13.9-1 20.7c11.6-8 25.6-12.7 40.8-12.7c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-7.7-2.3c-34.1 24.5-76 39-121.3 39C141.1 464 48 370.9 48 256zm71.7-18.3L87.5 261.5c36 48.7 108.2 48.7 144.2 0l-32.2-23.8c-20 27.1-59.8 27.1-79.8 0zm271.8 0c-20 27.1-59.8 27.1-79.8 0l-32.2 23.8c36 48.7 108.2 48.7 144.2 0l-32.2-23.8zM296 384a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm247.4-45.5c.1-.8 .1-1.7 .1-2.5c0-22.1-17.9-40-39.9-40c-16.9 0-31.4 10.5-37.2 25.4c-3.3-.9-6.9-1.4-10.5-1.4c-22.1 0-39.9 17.9-39.9 40L336 384l80.6 24.2c-.5 2.5-.8 5.1-.8 7.8c0 22.1 17.9 40 39.9 40c4.9 0 9.6-.9 14-2.5c7.1 11.1 19.5 18.5 33.7 18.5c22.1 0 39.9-17.9 39.9-40c0-.8 0-1.7-.1-2.5c19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z'
      
    ]
  };

  

  
  

  var faTrafficLightGo = {
    prefix: 'fasr',
    iconName: 'traffic-light-go',
    icon: [
      320,
      512,
      [],
      'f638',
      
      'M48 48V352c0 61.9 50.1 112 112 112s112-50.1 112-112V48H48zM0 0H48 272h48V48 352c0 88.4-71.6 160-160 160S0 440.4 0 352V48 0zM160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-184a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM144 136a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faEyeLowVision = {
    prefix: 'fasr',
    iconName: 'eye-low-vision',
    icon: [
      640,
      512,
      ["low-vision"],
      'f2a8',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L524 384.1c41.9-44 70.2-93.9 84-128.1C578 181.3 478.4 32 320 32c-66.9 0-123.2 26.6-168.3 63L48.4 14.8zM190.8 125.4C227.6 98 270.8 80 320 80c63 0 116.2 29.5 158.9 70.6c35.6 34.3 61.5 74.5 76.6 105.4c-14.1 28.9-37.6 65.8-69.6 98.5L434 314.2c8.9-17.5 14-37.2 14-58.2c0-70.7-57.3-128-128-128c-8.6 0-17 .8-25.1 2.5c-22.5 4.5-42.9 14.9-59.5 29.5l-44.6-34.6zM395 283.9l-82.2-63.8-8.5-42.6c5.1-1 10.3-1.5 15.7-1.5c44.2 0 80 35.8 80 80c0 9.8-1.8 19.2-5 27.9zM85.7 163.5c-10.9 14.3-20.4 28.6-28.5 42.2L393.1 469c18.3-5.7 35.6-13.3 51.8-22.4L85.7 163.5zM320 480c3.1 0 6.1-.1 9.2-.2l-75.6-59.2c-34.9-12.2-65.7-33.4-92.4-59.2c-14.3-13.7-27-28.4-38-43.1L34.9 249.2c-1 2.3-2 4.6-2.9 6.8c30 74.7 129.6 224 288 224z'
      
    ]
  };

  
    var faLowVision = faEyeLowVision;
  

  
  

  var faUpFromDottedLine = {
    prefix: 'fasr',
    iconName: 'up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e456',
      
      'M256 256V208h48 28.1L224 99.9 115.9 208H144h48v48 80h64V256zm1.9-190.1L384 192v16 48H352 336 304v48 32 48H256 192 144V336 304 256H112 96 64V208 192L190.1 65.9 224 32l33.9 33.9zM64 416v64H0V416H64zm96 0v64H96V416h64zm32 64V416h64v64H192zm160-64v64H288V416h64zm32 0h64v64H384V416z'
      
    ]
  };

  

  
  

  var faTrain = {
    prefix: 'fasr',
    iconName: 'train',
    icon: [
      448,
      512,
      [128646],
      'f238',
      
      'M48 48V192H400V48H48zm0 192V400H400V240H48zM0 0H48 400h48V48 400v48H400 385.9l47 47 17 17H382.1l-64-64H129.9l-64 64H-1.9l17-17 47-47H48 0V400 48 0zM184 320a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'
      
    ]
  };

  

  
  

  var faLessThanEqual = {
    prefix: 'fasr',
    iconName: 'less-than-equal',
    icon: [
      448,
      512,
      [],
      'f537',
      
      'M47.6 169.5L416 32.3V83.5L124.8 192 416 300.5v51.2L47.6 214.5 32 208.7V175.3l15.6-5.8zM24 432H424h24v48H424 24 0V432H24z'
      
    ]
  };

  

  
  

  var faHandsBubbles = {
    prefix: 'fasr',
    iconName: 'hands-bubbles',
    icon: [
      576,
      512,
      ["hands-wash"],
      'e05e',
      
      'M0 261.5L0 83.6l130.6 0L180.5 0l55.4 32L254.4 0l97 56L335.9 81.7 260 117.4l25.9-43.9-13.9-8-37.7 64-2 .9c-26.3 12.4-49.3 29.8-67.8 50.9l-12.3-7.1L211.9 73.6l-13.9-8L112.3 211.3 80 202.1l0-70.5-32 0 0 129.9c0 29.9 13.6 57.6 36 75.9c-13.7 8.7-25.4 20.3-34.2 33.9C18.7 344.1 0 304.3 0 261.5zM312 512c-26.9 0-52.4-6.3-75-17.6c8.9-13.3 15.1-28.5 17.6-45c17 9.3 36.6 14.6 57.3 14.6H456h8V448H392 368V400h24l72 0 24 0 8 0V384H392 368V336h24H504l24 0V320h-8H496l-104 0H368V272h24H496V256h-8H335.9 316l-9.2-36.8 18.9-8.9 25.1-11.8 14.5-6.8-13.6-29-14.5 6.8-70.9 33.3c-41.6 19.6-69.4 59.6-73.7 104.7l-.1 1.4-.3 1.3c-.1 .5-.2 1.1-.2 1.7v8 10.8c-14.5-6.9-30.8-10.8-48-10.8v-8c0-3.5 .3-6.9 .9-10.2c6.3-61.4 44.3-115.7 101-142.3l70.9-33.3 36.2-17 21.7-10.2 10.2 21.7 34.1 72.4L426 208h62 32 24v24 40h8 24v24 64 24H552h-8v40 24l-24 0-8 0v40 24H488 456 312zM416 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM528 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM144 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  
    var faHandsWash = faHandsBubbles;
  

  
  

  var faChartBar = {
    prefix: 'fasr',
    iconName: 'chart-bar',
    icon: [
      512,
      512,
      ["bar-chart"],
      'f080',
      
      'M48 32V56 432H488h24v48H488 24 0V456 56 32H48zm80 80l24 0 208 0 24 0v48H360l-208 0H128l0-48zm24 96H296h24v48H296 152 128V208h24zm0 96H424h24v48H424 152 128V304h24z'
      
    ]
  };

  
    var faBarChart = faChartBar;
  

  
  

  var faCloudShowersWater = {
    prefix: 'fasr',
    iconName: 'cloud-showers-water',
    icon: [
      576,
      512,
      [],
      'e4e4',
      
      'M248 48c-33.9 0-61.7 26.4-63.9 59.8l-1.4 22.5H160.2 152c-22.1 0-40 17.9-40 40V192H464V170.3c0-22.1-17.9-40-40-40h-1.5H403.2l-4.1-18.9c-3.9-18-20-31.4-39.1-31.4c-8.4 0-16.2 2.6-22.6 7l-21.2 14.6L303.1 79.5C291.9 60.6 271.4 48 248 48zM139.8 83.1C152.5 35.3 196.1 0 248 0c33 0 62.6 14.3 83.1 36.9c9.1-3.2 18.8-4.9 28.9-4.9c35.7 0 66.4 21.2 80.2 51.8c40.9 7.6 71.8 43.4 71.8 86.5V216v24H488 88 64V216 170.3c0-44.4 33-81.2 75.8-87.2zM95 272h48L80 384H32L95 272zm112 0h48L192 384H144l63-112zm112 0h48L304 384H256l63-112zm112 0h48L416 384H368l63-112zM79 488.9C59.7 499.8 31.5 512 0 512V464c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.8 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  

  
  

  var faSquareCaretUp = {
    prefix: 'fasr',
    iconName: 'square-caret-up',
    icon: [
      448,
      512,
      ["caret-square-up"],
      'f151',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM96 288L224 160 352 288v32H96V288z'
      
    ]
  };

  
    var faCaretSquareUp = faSquareCaretUp;
  

  
  

  var faTally = {
    prefix: 'fasr',
    iconName: 'tally',
    icon: [
      640,
      512,
      ["tally-5"],
      'f69c',
      
      'M152 40V64 286.7L232 260V64 40h48V64 244l80-26.7V64 40h48V64 201.4l80-26.7V64 40h48V64v94.7l64.4-21.5 22.8-7.6 15.2 45.5-22.8 7.6L536 209.3V448v24H488V448 225.3L408 252V448v24H360V448 268l-80 26.7V448v24H232V448 310.6l-80 26.7V448v24H104V448 353.3L39.6 374.8l-22.8 7.6L1.6 336.8l22.8-7.6L104 302.7V64 40h48z'
      
    ]
  };

  
    var faTally5 = faTally;
  

  
  

  var faGridRound5 = {
    prefix: 'fasr',
    iconName: 'grid-round-5',
    icon: [
      448,
      512,
      [],
      'e5de',
      
      'M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM128 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faHandBackFist = {
    prefix: 'fasr',
    iconName: 'hand-back-fist',
    icon: [
      448,
      512,
      ["hand-rock"],
      'f255',
      
      'M120 0H96V24 124L41.6 164.8 32 172v12 49.5c0 51.8 23 100.9 62.8 134c10.3 8.6 21.4 15.9 33.2 21.8V488v24h48V488 373.8 357.4l-15.3-5.9c-12.7-4.9-24.6-11.9-35.2-20.7C96.7 306.7 80 271.1 80 233.5V196l32-24v36 16h32V208 148 136v-8V112 48h32v8V80h24 40v8 24h24 40v8 24h24 40V264c0 .7-.1 1.4-.2 2l-.4 1.5-.2 1.5c-4.1 33-23.6 61.2-51.2 77.2L304 353v13.8V488v24h48V488 379.9c33.5-23.8 57-61 62.7-103.8c.9-3.9 1.3-8 1.3-12.1V120 96H392 352V88 64H328 288V56 32H264 224V24 0H200 120z'
      
    ]
  };

  
    var faHandRock = faHandBackFist;
  

  
  

  var faMarsStrokeRight = {
    prefix: 'fasr',
    iconName: 'mars-stroke-right',
    icon: [
      640,
      512,
      [9897,"mars-stroke-h"],
      'f22b',
      
      'M80 256a128 128 0 1 1 256 0A128 128 0 1 1 80 256zm302.4-24C370.7 146.2 297.1 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152H416v48 24h48V328 280h78.1l-31 31-17 17L528 361.9l17-17 72-72 17-17-17-17-72-72-17-17L494.1 184l17 17 31 31H464V184 160H416v24 48H382.4z'
      
    ]
  };

  
    var faMarsStrokeH = faMarsStrokeRight;
  

  
  

  var faPersonChalkboard = {
    prefix: 'fasr',
    iconName: 'person-chalkboard',
    icon: [
      640,
      512,
      [],
      'e53d',
      
      'M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32h-14L120 140.2l-76.9 136 41.8 23.6L128 223.6V488v24h48V488 352h32V488v24h48V488 176H392h24V128H392 368V48H592V272H368V224H320v48 48h48H592h48V272 48 0H592 368 320V48v80H243.1 140.9zM208 304H176V176h32V304z'
      
    ]
  };

  

  
  

  var faRightLongToLine = {
    prefix: 'fasr',
    iconName: 'right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e444',
      
      'M640 88V64H592V88 424v24h48V424 88zM304 232h48V184 163.9L444.1 256 352 348.1V328 280H304 48V232H304zm208 24l-33.9-33.9L352 96H304v40 8 40H256 48 0v48 48 48H48 256h48v40 8 40h48L478.1 289.9 512 256z'
      
    ]
  };

  

  
  

  var faSwapArrows = {
    prefix: 'fasr',
    iconName: 'swap-arrows',
    icon: [
      640,
      512,
      [],
      'e60a',
      
      'M128 6.1l17 17 88 88 17 17L216 161.9l-17-17-47-47V432H296V56 32h24l192 0h24V56 212 414.1l47-47 17-17L633.9 384l-17 17-88 88-17 17-17-17-88-88-17-17L424 350.1l17 17 47 47V212 80L344 80V456v24H320 128 104V456 98L57 145l-17 17L6.1 128l17-17 88-88 17-17z'
      
    ]
  };

  

  
  

  var faGrid5 = {
    prefix: 'fasr',
    iconName: 'grid-5',
    icon: [
      448,
      512,
      [],
      'e199',
      
      'M0 32H64V96H0V32zm0 96H64v64H0V128zm64 96v64H0V224H64zM0 320H64v64H0V320zm64 96v64H0V416H64zM96 32h64V96H96V32zm64 96v64H96V128h64zM96 224h64v64H96V224zm64 96v64H96V320h64zM96 416h64v64H96V416zM256 32V96H192V32h64zm-64 96h64v64H192V128zm64 96v64H192V224h64zm-64 96h64v64H192V320zm64 96v64H192V416h64zM288 32h64V96H288V32zm64 96v64H288V128h64zm-64 96h64v64H288V224zm64 96v64H288V320h64zm-64 96h64v64H288V416zM448 32V96H384V32h64zm-64 96h64v64H384V128zm64 96v64H384V224h64zm-64 96h64v64H384V320zm64 96v64H384V416h64z'
      
    ]
  };

  

  
  

  var faArrowDownToLine = {
    prefix: 'fasr',
    iconName: 'arrow-down-to-line',
    icon: [
      384,
      512,
      ["arrow-to-bottom"],
      'f33d',
      
      'M24 480L0 480l0-48 24 0 336 0 24 0 0 48-24 0L24 480zM209.5 344.4L192 363l-17.5-18.6-128-136L30.1 191l35-32.9 16.4 17.5L168 267.5l0-83.5 0-128 0-24 48 0 0 24 0 128 0 83.5 86.5-91.9L319 158.1l35 32.9-16.4 17.5-128 136z'
      
    ]
  };

  
    var faArrowToBottom = faArrowDownToLine;
  

  
  

  var faRepeat1 = {
    prefix: 'fasr',
    iconName: 'repeat-1',
    icon: [
      512,
      512,
      [128258],
      'f365',
      
      'M448 96L352 0H320V72H24 0V96 256v24H48V256 120H320v72h32l96-96zM216 240h8 16v56 24h48V296 216 192H264 224h-8v48zm296 16V232l-48 0v24l0 136-272 0V320H160L64 416l96 96h32V440l296 0h24V416l0-160z'
      
    ]
  };

  

  
  

  var faBuildingCircleCheck = {
    prefix: 'fasr',
    iconName: 'building-circle-check',
    icon: [
      640,
      512,
      [],
      'e4d2',
      
      'M48 48H336V294.6c11.1-24.3 27.7-45.5 48-62.3V48 0H336 48 0V48 464v48H48 336h48v-8.2c-20.3-16.8-36.9-38.1-48-62.3V464H240V352H144V464H48V48zM88 88v80h80V88H88zm208 0H216v80h80V88zM88 216v80h80V216H88zm208 0H216v80h80V216zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faBurgerCheese = {
    prefix: 'fasr',
    iconName: 'burger-cheese',
    icon: [
      512,
      512,
      [127828,"cheeseburger"],
      'f7f1',
      
      'M32 224V192s0-6.1 1.7-16C40.6 135.5 75.9 32 256 32s215.4 103.5 222.3 144c1.7 9.9 1.7 16 1.7 16v32H432 80 32zm67.3-84.5c-9.1 13-14 26.2-16.6 36.5H429.3c-2.6-10.3-7.5-23.4-16.6-36.5c-8.4-12-22-26.2-44.8-37.7c.1 .7 .2 1.5 .2 2.2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.1 2.4-9.6 6.1-12.6c-19.2-6-42.8-10.2-72.1-11.2c1.3 2.3 2 4.9 2 7.8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.5 2-7.8c-29.3 1-52.9 5.2-72.1 11.2c3.7 2.9 6.1 7.5 6.1 12.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 .1-1.5 .1-2.2c-22.8 11.5-36.4 25.7-44.8 37.7zM80 432H432V400H80v32zM32 352H80 432h48v48 32 48H432 80 32V432 400 352zm208-96l80 40 80-40h48 48v64H16V256H192h48z'
      
    ]
  };

  
    var faCheeseburger = faBurgerCheese;
  

  
  

  var faChessBoard = {
    prefix: 'fasr',
    iconName: 'chess-board',
    icon: [
      448,
      512,
      [],
      'f43c',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM128 96v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z'
      
    ]
  };

  

  
  

  var faBringFront = {
    prefix: 'fasr',
    iconName: 'bring-front',
    icon: [
      640,
      512,
      [],
      'f857',
      
      'M48 48H208V64h48V48 0H208 48 0V48 208v48H48h80V208H48V48zM384 464v48h48H592h48V464 304 256H592 512v48h80V464H432V448H384v16zM480 96H160V416H480V96z'
      
    ]
  };

  

  
  

  var faUpLeft = {
    prefix: 'fasr',
    iconName: 'up-left',
    icon: [
      384,
      512,
      [],
      'e2bd',
      
      'M136 244.1l33.9 33.9L272 380.1 316.1 336 214.1 233.9 180.1 200l33.9-33.9L252.1 128H64V316.1l38.1-38.1L136 244.1zM97.9 350.1L64 384 30.1 350.1 16 336V128 80H64 272l14.1 14.1L320 128l-33.9 33.9-4.1 4.1L248 200l33.9 33.9 68.1 68.1L384 336l-33.9 33.9-44.1 44.1L272 448l-33.9-33.9-68.1-68.1L136 312l-33.9 33.9-4.1 4.1z'
      
    ]
  };

  

  
  

  var faSquareQuote = {
    prefix: 'fasr',
    iconName: 'square-quote',
    icon: [
      448,
      512,
      [],
      'e329',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM208 160H96V272h64v8c0 13.3-10.7 24-24 24H112v48h24c39.8 0 72-32.2 72-72v-8V216 192 160zm32 0V272h64v8c0 13.3-10.7 24-24 24H256v48h24c39.8 0 72-32.2 72-72v-8V216 192 160H240z'
      
    ]
  };

  

  
  

  var faHoodCloak = {
    prefix: 'fasr',
    iconName: 'hood-cloak',
    icon: [
      576,
      512,
      [],
      'f6ef',
      
      'M0 464l64-80V288C64 128 160 0 288 0H412.1 480L441.6 38.4 432 48 407.2 72.8c13.2 9 25.5 19.4 36.7 31.2C485.6 147.8 512 210.4 512 288v96l64 80v48H528 48 0V464zM288 48c-90.5 0-176 94-176 240v96 16.8L101.5 414l-40 50H160V336c0-70.7 57.3-128 128-128s128 57.3 128 128V464h98.5l-40-50L464 400.8V384 288c0-83.7-35.5-142.6-83.8-175.5L332.3 79.9 364.1 48H288zM208 464H368V336c0-44.2-35.8-80-80-80s-80 35.8-80 80V464z'
      
    ]
  };

  

  
  

  var faGlasses = {
    prefix: 'fasr',
    iconName: 'glasses',
    icon: [
      576,
      512,
      [],
      'f530',
      
      'M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6l0 0-.3 1c-8.1 29-16.1 57.8-26.2 100.6H232h24v24 8h64v-8V272h24H527.3c-10.1-42.8-18.1-71.7-26.2-100.6l-.3-1 0 0 0 0 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7V272v0 24 56 24 80 24H552 344 320V456 368H256v88 24H232 24 0V456 376 352 296 272v0-2.8l.6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM528 320H368v16 96H528V376 352 320zM48 352v24 56H208V336 320H48v32z'
      
    ]
  };

  

  
  

  var faPaintbrushFine = {
    prefix: 'fasr',
    iconName: 'paintbrush-fine',
    icon: [
      576,
      512,
      ["paint-brush-alt","paint-brush-fine","paintbrush-alt"],
      'f5a9',
      
      'M493.8 18.2l-17-17-17 17L204.3 273.7c-6.6-1.1-13.4-1.7-20.3-1.7c-66.3 0-120 53.7-120 120v24 48H48 24 16 0v48H24 48 64h48 72c66.3 0 120-53.7 120-120c0-6.9-.6-13.7-1.7-20.3L557.8 116.2l17-17-17-17-64-64zM210.5 325L251 365.5c3.3 8.2 5 17.2 5 26.5c0 39.8-32.2 72-72 72H112V392c0-39.8 32.2-72 72-72c9.4 0 18.3 1.8 26.5 5zm125.7-55.3l-30.1-30.1L476.8 69.1l30.1 30.1L336.3 269.8z'
      
    ]
  };

  
    var faPaintBrushAlt = faPaintbrushFine;
  
    var faPaintBrushFine = faPaintbrushFine;
  
    var faPaintbrushAlt = faPaintbrushFine;
  

  
  

  var faChessQueen = {
    prefix: 'fasr',
    iconName: 'chess-queen',
    icon: [
      512,
      512,
      [9819],
      'f445',
      
      'M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM150.6 88h-20L127 107.7c-5.4 29.8-31.6 52.4-63 52.4c-10.1 0-19.6-2.3-28.1-6.5L24 147.8l-11.3 6.9-1.3 .8L-8.4 167.8 3.2 188 97.6 352H153l-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l94.4-164 11.6-20.2-19.9-12.2-1.3-.8L488 147.8l-11.9 5.8c-8.5 4.1-18 6.5-28.1 6.5c-31.4 0-57.5-22.6-63-52.4L381.4 88h-20H343.3 327.9l-6.4 14c-11.4 24.8-36.5 42-65.5 42s-54.1-17.2-65.5-42l-6.4-14H168.7 150.6zM116.7 464l16.6-32H378.8l16.6 32H116.7zM448 461.3L408 384H104L64 461.3V464v48h48H400h48V464v-2.7z'
      
    ]
  };

  

  
  

  var faTreasureChest = {
    prefix: 'fasr',
    iconName: 'treasure-chest',
    icon: [
      576,
      512,
      [],
      'f723',
      
      'M160 80H416V240H352V192H224v48H160V80zM48 160c0-38.7 27.5-71 64-78.4V240H48V160zm0 272V288h64V432H48zm368 0H160V288h64v64H352V288h64V432zm112 0H464V288h64V432zm0-272v80H464V81.6c36.5 7.4 64 39.7 64 78.4zM128 32C57.3 32 0 89.3 0 160V432v48H48 528h48V432 160c0-70.7-57.3-128-128-128H128zM304 256v32 16H272V288 256 240h32v16z'
      
    ]
  };

  

  
  

  var faMessageArrowUpRight = {
    prefix: 'fasr',
    iconName: 'message-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e1dd',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM216 128H192v48h24 54.1l-87 87-17 17L200 313.9l17-17 87-87V264v24h48V264 152 128H328 216z'
      
    ]
  };

  

  
  

  var faFileSlash = {
    prefix: 'fasr',
    iconName: 'file-slash',
    icon: [
      640,
      512,
      [],
      'e3a7',
      
      'M512 374.7l108.9 84.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L128 76.6V48 0h48H384L512 128V374.7zM176 113.9L464 337.5V160H352V48H176v65.9zM512 499.4V512H464 176 128V464 196.8l48 37.8V464H464v-2.4l48 37.8z'
      
    ]
  };

  

  
  

  var faCoinFront = {
    prefix: 'fasr',
    iconName: 'coin-front',
    icon: [
      512,
      512,
      [],
      'e3fc',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm24-248V160H232v24V328v24h48V328 184z'
      
    ]
  };

  

  
  

  var faGaugeCircleBolt = {
    prefix: 'fasr',
    iconName: 'gauge-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e496',
      
      'M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6V120 96h48v24V301.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm24 64L416 384h66.7L472 448l104-96H509.3L520 288z'
      
    ]
  };

  

  
  

  var faTransporter5 = {
    prefix: 'fasr',
    iconName: 'transporter-5',
    icon: [
      512,
      512,
      [],
      'e2a6',
      
      'M464 0l16 32 32 16L480 64 464 96 448 64 416 48l32-16L464 0zM48 128l16 32 32 16L64 192 48 224 32 192 0 176l32-16 16-32zM96 464h24H392h24v48H392 120 96V464zM224 0h64 16V32H288 224 208V0h16zM176 128H336h16v32H336 176 160V128h16zM112 256H400h16v32H400 112 96V256h16zm64 128H336h16v32H336 176 160V384h16z'
      
    ]
  };

  

  
  

  var faVolume = {
    prefix: 'fasr',
    iconName: 'volume',
    icon: [
      576,
      512,
      [128265,"volume-medium"],
      'f6a8',
      
      'M191.9 316.1L178.2 304H160 80V208h80 18.2l13.6-12.1L304 96.2V415.8L191.9 316.1zM32 352H80h80L304 480h48V432 80 32H304L160 160H80 32v48 96 48zm409.6-19.2C464.9 315.3 480 287.4 480 256s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4zm57.6 76.8c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2s-22.6 88.9-57.6 115.2l28.8 38.4z'
      
    ]
  };

  
    var faVolumeMedium = faVolume;
  

  
  

  var faDiceTwo = {
    prefix: 'fasr',
    iconName: 'dice-two',
    icon: [
      448,
      512,
      [9857],
      'f528',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faGift = {
    prefix: 'fasr',
    iconName: 'gift',
    icon: [
      512,
      512,
      [127873],
      'f06b',
      
      'M231.9 44.4C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88c0 14.4 3.5 28 9.6 40H48 0v48 64 48H32V464v48H80 432h48V464 288h32V240 176 128H464 438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176v64H432 288V176h72H464zm-240 0v64H80 48V176H152h72zm0 112V464H80V288H224zm64 176V288H432V464H288zm72-336H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0H152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8L225.3 128H224z'
      
    ]
  };

  

  
  

  var faMemoCircleInfo = {
    prefix: 'fasr',
    iconName: 'memo-circle-info',
    icon: [
      576,
      512,
      [],
      'e49a',
      
      'M48 48H336V220.5c14.6-9.5 30.8-17 48-21.8V48 0H336 48 0V48 464v48H48 330.8c-18.3-12.9-34.1-29.2-46.3-48H48V48zM288 224H264 120 96v48h24H264h20.5c1.1-1.8 2.3-3.5 3.5-5.2V224zM120 128H96v48h24H264h24V128H264 120zm0 192H96v48h24 48 24V320H168 120zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm15.3-224v32h-32V288h32zm1.2 64v16 64l15.5 0 0 32-15.5 0H448l-32 0-16 0 0-32 16 0 .5 0V384l-.5 0-16 0 0-32 16 0 16.5 0 16 0z'
      
    ]
  };

  

  
  

  var faMailboxFlagUp = {
    prefix: 'fasr',
    iconName: 'mailbox-flag-up',
    icon: [
      576,
      512,
      [],
      'e5bb',
      
      'M352 224V200 88 56 32h24 64 24V56 88v24l-24 0H400v88 24H352zM144 112c-53 0-96 43-96 96V400H240V208c0-53-43-96-96-96zm107.3 0c22.8 25.5 36.7 59.1 36.7 96V400H528V208c0-28.4-12.4-54-32-71.6V88 79c47.4 23.6 80 72.5 80 129V400v48H528 288 240 48 0V400 208C0 128.5 64.5 64 144 64l176 0V88v24H251.3zM104 192h80 24v48H184 104 80V192h24z'
      
    ]
  };

  

  
  

  var faFaceDowncastSweat = {
    prefix: 'fasr',
    iconName: 'face-downcast-sweat',
    icon: [
      512,
      512,
      [],
      'e371',
      
      'M116.6 41.2C156.7 15.2 204.6 0 256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-35.8 7.3-69.9 20.6-100.8c8.6 3.1 17.8 4.8 27.4 4.8c8.9 0 17.6-1.5 25.7-4.2C57.3 185.5 48 219.7 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208s-93.1-208-208-208c-48.7 0-93.4 16.7-128.9 44.7c.6-3.8 .9-7.7 .9-11.7c0-11.4-3.8-22.4-7.1-30.5c-1.3-3.1-2.7-6.2-4.3-9.3zM96 80.6c0 .1 0 .3 0 .4c0 26-21.5 47-48 47c-4.4 0-8.7-.6-12.8-1.7c0 0 0 0 0 0C14.9 120.7 0 102.1 0 80C0 69.6 3.4 59.5 9.6 51.2L48 0 86.4 51.2C92.6 59.5 96 69.6 96 80c0 .2 0 .4 0 .6zM96 256h16 96 16v32H208 112 96V256zm208 0h96 16v32H400 304 288V256h16zM201.2 425.9l-35.1-32.7 16.4-17.5C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5z'
      
    ]
  };

  

  
  

  var faCarBattery = {
    prefix: 'fasr',
    iconName: 'car-battery',
    icon: [
      512,
      512,
      ["battery-car"],
      'f5df',
      
      'M80 64H208V96h96V64H432V96h32 48v48V400v48H464 48 0V400 144 96H48 80V64zM48 144V400H464V144H48zm336 32v16 32h32 16v32H416 384v32 16H352V288 256H320 304V224h16 32V192 176h32zM96 224h96 16v32H192 96 80V224H96z'
      
    ]
  };

  
    var faBatteryCar = faCarBattery;
  

  
  

  var faDogLeashed = {
    prefix: 'fasr',
    iconName: 'dog-leashed',
    icon: [
      576,
      512,
      [129454],
      'f6d4',
      
      'M336 319.8v59.8V464h48V274.3L302.2 224H290.7 288V330.5l48-10.6zm-96 15.9V224H144 112.1l-.1 .9V464h48V379.6 319.8l58.4 12.9c7 1.5 14.2 2.6 21.6 3zm97.1-146.6l52 32L394 192h40.7H480c26.5 0 48-21.5 48-48V112H496 476.1L462.1 97.9 444.1 80H368 355.3L338 183.9l-.9 5.2zm-272.9 31c-1.1-.3-2.2-.7-3.3-1.1c-17.3-6-32.2-17.3-42.8-32.2C12 178.2 7.3 168.2 4.6 157.4l0 0 0 0L.7 141.8l46.6-11.6 3.9 15.5 0 0C55.6 163.5 71.6 176 90 176h54 86.9L88.7 58.5 70.2 43.2l30.6-37 18.5 15.3L292.6 164.6 313.5 39.3l3.1-18.7L320 0h24l3.4 4.6 16.7 22.3L368 32h96l32 32h32 48v48 32c0 53-43 96-96 96H434.7L432 256V464v48H384 336 288V464 428.6 379.6c-10.4 2.3-21.1 3.7-32 4.2c-2.7 .1-5.3 .2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2v48.9V464v48H160 112 64V464 224c0-1.3 .1-2.6 .2-3.8zM416 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faMugHot = {
    prefix: 'fasr',
    iconName: 'mug-hot',
    icon: [
      512,
      512,
      [9749],
      'f7b6',
      
      'M112 0V24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C152.6 76.6 176 97.1 176 136v24H128V136c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C87.4 83.4 64 62.9 64 24V0h48zM48 240V464H336V240H48zM0 192H48 336h16 32 16c61.9 0 112 50.1 112 112s-50.1 112-112 112H384v48 48H336 48 0V464 240 192zM384 368h16c35.3 0 64-28.7 64-64s-28.7-64-64-64H384V368zM224 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C264.6 76.6 288 97.1 288 136v24H240V136c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C199.4 83.4 176 62.9 176 24V0h48V24z'
      
    ]
  };

  

  
  

  var faArrowDownSquareTriangle = {
    prefix: 'fasr',
    iconName: 'arrow-down-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-down-alt"],
      'f889',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM296 480l27.7-48 64.6-112L416 272l27.7 48 64.6 112L536 480H480.6 351.4 296zm156.9-48L416 368.1 379.1 432h73.8zM368 80v96h96V80H368zM320 32h48 96 48V80v96 48H464 368 320V176 80 32z'
      
    ]
  };

  
    var faSortShapesDownAlt = faArrowDownSquareTriangle;
  

  
  

  var faSquarePollVertical = {
    prefix: 'fasr',
    iconName: 'square-poll-vertical',
    icon: [
      448,
      512,
      ["poll"],
      'f681',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM152 224V384H104V224h48zm48-96h48V384H200V128zM344 288v96H296V288h48z'
      
    ]
  };

  
    var faPoll = faSquarePollVertical;
  

  
  

  var faJedi = {
    prefix: 'fasr',
    iconName: 'jedi',
    icon: [
      576,
      512,
      [],
      'f669',
      
      'M220.1 252.1l25.1 50.2L192 320l53.2 17.7-25.1 50.2L267.9 364l-2.2 65.8C214.5 419.4 176 374.2 176 320c0-29.6 11.5-56.5 30.2-76.5l17.1-18.2-18.9-16.3C177.2 185.4 160 150.7 160 112c0-26.9 8.3-51.9 22.5-72.5L150.5 5.2C70.1 52.4 16 139.9 16 240c0 150.2 121.8 272 272 272s272-121.8 272-272C560 139.9 505.9 52.4 425.4 5.2L393.5 39.5C407.7 60.1 416 85.1 416 112c0 38.7-17.2 73.4-44.4 96.9l-18.9 16.3 17.1 18.2c18.8 20 30.2 46.9 30.2 76.5c0 54.2-38.5 99.4-89.7 109.8L308.1 364l47.7 23.9-25.1-50.2L384 320l-53.2-17.7 25.1-50.2-50.6 25.3L296 0H280l-9.2 277.4-50.6-25.3zm-156-18.7c.3-10.7 1.4-21.3 3.1-31.6l17.5 17.5L96 230.6 118.6 208l-11.3-11.3L76.5 165.9c8.3-23.7 20.5-45.6 35.8-64.9c-.2 3.6-.3 7.3-.3 11c0 44.9 16.8 85.8 44.4 116.9C138.5 254.8 128 286.2 128 320c0 44.5 18.1 84.7 47.4 113.7c-54.9-32-94.9-86.6-107.4-151l16.6 16.6L96 310.6 118.6 288l-11.3-11.3L64.1 233.5zm447.8 0l-43.2 43.2L457.4 288 480 310.6l11.3-11.3 16.6-16.6c-12.4 64.4-52.5 119.1-107.4 151c29.3-29 47.4-69.2 47.4-113.7c0-33.8-10.5-65.2-28.4-91.1c27.6-31.1 44.4-72 44.4-116.9c0-3.7-.1-7.4-.3-11c15.3 19.3 27.5 41.2 35.8 64.9l-30.8 30.8L457.4 208 480 230.6l11.3-11.3 17.5-17.5c1.8 10.3 2.8 20.9 3.1 31.6z'
      
    ]
  };

  

  
  

  var faTilde = {
    prefix: 'fasr',
    iconName: 'tilde',
    icon: [
      448,
      512,
      [63135],
      '7e',
      
      'M0 128H24 136h11.1l7.2 8.5L323.1 336H400V192 168h48v24V360v24H424 312 300.9l-7.2-8.5L124.9 176H48V320v24H0V320 152 128z'
      
    ]
  };

  

  
  

  var faMapLocationDot = {
    prefix: 'fasr',
    iconName: 'map-location-dot',
    icon: [
      576,
      512,
      ["map-marked-alt"],
      'f5a0',
      
      'M408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 70 120 200 120 200s120-130 120-200zm-160-8a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM373.9 265.1C366.4 275.3 359 285 352 293.9V452.2L224 405.7V293.9c-7-8.8-14.4-18.5-21.9-28.8c-8.8-12.1-17.8-25.1-26.1-38.6V405.3l-128 41V195l96.6-30.9c-5.2-14.6-8.6-29.6-8.6-44.1c0-1.2 0-2.4 0-3.5L0 160V461.6 512l48-15.4L200 448l176 64 200-64V146.4 96l-48 15.4-90 28.8c-3.6 19-11.5 38.1-20.3 55.2l-1.1 2L528 161.8V413l-128 41V226.5c-8.4 13.4-17.3 26.5-26.1 38.6z'
      
    ]
  };

  
    var faMapMarkedAlt = faMapLocationDot;
  

  
  

  var faBorderTopLeft = {
    prefix: 'fasr',
    iconName: 'border-top-left',
    icon: [
      448,
      512,
      ["border-style"],
      'f853',
      
      'M0 456l0 24 48 0 0-24L48 80l376 0 24 0 0-48-24 0L24 32 0 32 0 56 0 456zm96-40l0 64 64 0 0-64-64 0zm192 0l0 64 64 0 0-64-64 0zm-96 64l64 0 0-64-64 0 0 64zm192-64l0 64 64 0 0-64-64 0zm0-128l64 0 0-64-64 0 0 64zm0 32l0 64 64 0 0-64-64 0zm0-128l64 0 0-64-64 0 0 64z'
      
    ]
  };

  
    var faBorderStyle = faBorderTopLeft;
  

  
  

  var faNotEqual = {
    prefix: 'fasr',
    iconName: 'not-equal',
    icon: [
      448,
      512,
      [],
      'f53e',
      
      'M349.5 32h58l-3.7 5.5L331.4 144H408h24v48H408 298.8l-87 128H408h24v48H408 179.1L102.9 480h-58l9.5-14L121 368H40 16V320H40 153.7l87-128H40 16V144H40 273.4L349.5 32z'
      
    ]
  };

  

  
  

  var faMoneyCheckPen = {
    prefix: 'fasr',
    iconName: 'money-check-pen',
    icon: [
      640,
      512,
      ["money-check-edit"],
      'f872',
      
      'M528 112H48V400H348.4L331 417.4 326.6 448H48 0V400 112 64H48 528h48v48 60.4L564.4 184l0 0L528 220.4V112zM352 272v48H96V272H352zM96 176H448v48H96V176zm473 47.8l71 71-41.3 41.3-71-71L569 223.8zm-63.9 63.9l71 71L434.9 500 352 511.9 363.9 429 505.1 287.8z'
      
    ]
  };

  
    var faMoneyCheckEdit = faMoneyCheckPen;
  

  
  

  var faManatSign = {
    prefix: 'fasr',
    iconName: 'manat-sign',
    icon: [
      384,
      512,
      [],
      'e1d5',
      
      'M216 32H168V97.5C73.3 109.3 0 190.1 0 288V456v24H48V456 288c0-71.4 51.9-130.6 120-142V480h48V146c68.1 11.4 120 70.7 120 142V456v24h48V456 288c0-97.9-73.3-178.7-168-190.5V32z'
      
    ]
  };

  

  
  

  var faSquareK = {
    prefix: 'fasr',
    iconName: 'square-k',
    icon: [
      448,
      512,
      [],
      'e274',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm337.1 96l-1 1.1L238.3 238.3 330 376.7l4.8 7.3H277.2L205.1 275.2 176 307.7V360v24H128V360 298.5 152 128h48v24 83.8L190.1 220l82.5-92h64.5z'
      
    ]
  };

  

  
  

  var faCircleDownRight = {
    prefix: 'fasr',
    iconName: 'circle-down-right',
    icon: [
      512,
      512,
      [],
      'e108',
      
      'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 192l-24-24-52 52-76-76-56 56 76 76-52 52 24 24H352V192z'
      
    ]
  };

  

  
  

  var faEngineWarning = {
    prefix: 'fasr',
    iconName: 'engine-warning',
    icon: [
      640,
      512,
      ["engine-exclamation"],
      'f5f2',
      
      'M424 112l-24 0-72 0v32h88l96 64V400v48H464 224l-51.2-64H128 80V336 280H48v72 24H0V352 160 136H48v24 72H80V192 144h48 32 32 88V112l-72 0H184V64h24H400h24v48zM210.3 354l36.8 46H464V233.7L401.5 192H192 160 128V336h44.8 23.1l14.4 18zM544 192h96V448H544V192zM324 212v20 56 20H284V288 232 212h40zM280 328h48v48H280V328z'
      
    ]
  };

  
    var faEngineExclamation = faEngineWarning;
  

  
  

  var faTransporter3 = {
    prefix: 'fasr',
    iconName: 'transporter-3',
    icon: [
      512,
      512,
      [],
      'e045',
      
      'M480 32L464 0 448 32 416 48l32 16 16 32 16-32 32-16L480 32zM64 128L48 96 32 128 0 144l32 16 16 32 16-32 32-16L64 128zm56 336H96v48h24H392h24V464H392 120zM304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 128H160v32h16H336h16V128H336 176zm-32 64H128v32h16H368h16V192H368 144zm-32 64H96v32h16H400h16V256H400 112zm64 64H160v32h16H336h16V320H336 176zm0 64H160v32h16H336h16V384H336 176z'
      
    ]
  };

  

  
  

  var faBuildingNgo = {
    prefix: 'fasr',
    iconName: 'building-ngo',
    icon: [
      384,
      512,
      [],
      'e4d7',
      
      'M336 48H48 0V0H48 336h48V48H336zm0 192h48V464v48H336 48 0V464 240H48V464h96V352h96V464h96V240zM32 80H48h8 9.9l4.4 8.8L96 140.2V96 80h32V96v96 16H112h-8H94.1l-4.4-8.8L64 147.8V192v16H32V192 96 80zm136 0h48 16v32H216 184v64h16V160 144h32v16 32 16H216 168 152V192 96 80h16zm120 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16-48c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V128c0-26.5 21.5-48 48-48zM168 248v80H88V248h80zm128 80H216V248h80v80z'
      
    ]
  };

  

  
  

  var faAnchorLock = {
    prefix: 'fasr',
    iconName: 'anchor-lock',
    icon: [
      640,
      512,
      [],
      'e4ad',
      
      'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216 192v48h24 48V464H120V352h72L96 256 0 352H72V488v24H96 288h96l0-48H312V240h48 24V192H360 312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zm96 352l0 0v0h0zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48H416V512H640V320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faBold = {
    prefix: 'fasr',
    iconName: 'bold',
    icon: [
      384,
      512,
      [],
      'f032',
      
      'M0 32H24 48 72 88h24H212c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124H112 88 72 48 24 0V432H24 48V256 80H24 0V32zM96 432h16H244c42 0 76-34 76-76s-34-76-76-76H212 96V432zm0-200H212c42 0 76-34 76-76s-34-76-76-76H112 96V232z'
      
    ]
  };

  

  
  

  var faStroopwafel = {
    prefix: 'fasr',
    iconName: 'stroopwafel',
    icon: [
      512,
      512,
      [],
      'f551',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm97.6-45.3l22.6 22.6 45.3-45.3-22.6-22.6-11.3-11.3 22.6-22.6 11.3 11.3 22.6 22.6 45.3-45.3L210.7 97.6 199.4 86.3l22.6-22.6L233.4 75 256 97.6 278.6 75l11.3-11.3 22.6 22.6L301.3 97.6l-22.6 22.6 45.3 45.3 22.6-22.6 11.3-11.3 22.6 22.6-11.3 11.3-22.6 22.6 45.3 45.3 22.6-22.6 11.3-11.3 22.6 22.6L437 233.4 414.4 256 437 278.6l11.3 11.3-22.6 22.6-11.3-11.3-22.6-22.6-45.3 45.3 22.6 22.6 11.3 11.3-22.6 22.6-11.3-11.3-22.6-22.6-45.3 45.3 22.6 22.6 11.3 11.3-22.6 22.6L278.6 437 256 414.4 233.4 437l-11.3 11.3-22.6-22.6 11.3-11.3 22.6-22.6-45.3-45.3-22.6 22.6-11.3 11.3-22.6-22.6 11.3-11.3 22.6-22.6-45.3-45.3L97.6 301.3 86.3 312.6 63.7 289.9 75 278.6 97.6 256 75 233.4 63.7 222.1l22.6-22.6 11.3 11.3zm90.5 0L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zm113.1-22.6L256 142.9l-45.3 45.3L256 233.4l45.3-45.3zM369.1 256l-45.3-45.3L278.6 256l45.3 45.3L369.1 256zM256 278.6l-45.3 45.3L256 369.1l45.3-45.3L256 278.6z'
      
    ]
  };

  

  
  

  var faSignature = {
    prefix: 'fasr',
    iconName: 'signature',
    icon: [
      640,
      512,
      [],
      'f5b7',
      
      'M176 128c0-26.5 21.5-48 48-48s48 21.5 48 48v7.9c0 27.5-2.3 55-7 82.1L112.9 265.1 96 270.3V288 456v24h24 72 13.6l7-11.7 29.3-48.8c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8L381.9 320H416 552h24V272H552 450.1l28.5-79.9 16.1-45.2-45.8 14.2-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96s-96 43-96 96v40 24h48V168 128zM144 305.7l109.1-33.8c-11.7 43.2-29.4 84.5-52.4 123L178.4 432H144V305.7zM64 368H24 0v48H24 64V368zm216.8 48H616h24V368H616 304.1c-7 16.3-14.8 32.4-23.3 48z'
      
    ]
  };

  

  
  

  var faCaduceus = {
    prefix: 'fasr',
    iconName: 'caduceus',
    icon: [
      512,
      512,
      [],
      'e681',
      
      'M280 89.6c14.3-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 6.4 0 11.3L137.6 66l-15-6.6L111 71 7 175l-7 7L0 192l0 8 0 24 24 0 122.1 0c30 0 59.5-7.3 85.9-21.3l0 127.7-20.6-12.3c-12-7.2-19.4-20.2-19.4-34.3l0-3.8 0-24-48 0 0 24 0 3.8c0 30.9 16.2 59.6 42.7 75.5l22.6 13.6-6.6 4c-26.5 15.9-42.7 44.5-42.7 75.5l0 3.8 0 24 48 0 0-24 0-3.8c0-14.1 7.4-27.1 19.4-34.3l4.6-2.7 0 32.8 0 64 48 0 0-64 0-32.8 4.6 2.7c12 7.2 19.4 20.2 19.4 34.3l0 3.8 0 24 48 0 0-24 0-3.8c0-30.9-16.2-59.6-42.7-75.5l-6.6-4 22.6-13.6c26.5-15.9 42.7-44.5 42.7-75.5l0-3.8 0-24-48 0 0 24 0 3.8c0 14.1-7.4 27.1-19.4 34.3L280 330.4l0-130.7c36.3 15.9 75.6 24.2 115.5 24.2l92.5 0 24 0 0-24 0-8 0-9.9-7-7L401 71 389.4 59.4l-15 6.6L280 107.3 280 96l0-6.4zM73.9 176l59.4-59.4 86.4 37.8-1.6 1c-21.6 13.5-46.6 20.7-72.1 20.7l-72.2 0zm220.2-22.5l84.4-36.9L438.1 176l-42.6 0c-35.1 0-69.7-7.7-101.3-22.5z'
      
    ]
  };

  

  
  

  var faSquareO = {
    prefix: 'fasr',
    iconName: 'square-o',
    icon: [
      448,
      512,
      [],
      'e278',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM144 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faBinarySlash = {
    prefix: 'fasr',
    iconName: 'binary-slash',
    icon: [
      640,
      512,
      [],
      'e33e',
      
      'M224 0h24 56 24V24 176h32 24v48H360 317.9L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 18.2 14.6 0 0V0H24 168h24V24 126.3L256 176h24V48H248 224V0zM144 89V48H91.2L144 89zM48 133.8V176H96v48H24 0V200 96l48 37.8zM243.7 288l60.9 48H240V464h96V360.7l48 37.8V488v24H360 216 192V488 312 288h24 27.7zM0 288H24 80h24v24V464h32 24v48H136 80 24 0V464H24 56V336H24 0V288z'
      
    ]
  };

  

  
  

  var faUserPen = {
    prefix: 'fasr',
    iconName: 'user-pen',
    icon: [
      640,
      512,
      ["user-edit"],
      'f4ff',
      
      'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM65 464L99.5 352H348.5l11.3 36.6 38.4-38.4L384 304H64L14.8 464 0 512H50.2 317.4l6.9-48H65zM569 223.8l-41.3 41.3 71 71L640 294.8l-71-71zm-63.9 63.9L363.9 429 352 511.9 434.9 500 576.1 358.7l-71-71z'
      
    ]
  };

  
    var faUserEdit = faUserPen;
  

  
  

  var faPrescriptionBottlePill = {
    prefix: 'fasr',
    iconName: 'prescription-bottle-pill',
    icon: [
      576,
      512,
      [],
      'e5c0',
      
      'M336 48V80H48V48H336zM48 0H0V48 80v48H48 336h48V80 48 0H336 48zM32 160V464v48H80 304h26.8c-18.3-12.9-34.1-29.2-46.3-48H80V416h56 24V368H136 80V320h56 24V272H136 80V224h56 24V176H136 80V160H32zm320 0H304v87.2c13.8-14.6 30-26.8 48-36V160zm80 112a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM400 302.1L366.1 336l17 17 64 64 17 17L497.9 400l-17-17-64-64-17-17z'
      
    ]
  };

  

  
  

  var faUnderline = {
    prefix: 'fasr',
    iconName: 'underline',
    icon: [
      448,
      512,
      [],
      'f0cd',
      
      'M16 32H40h96 24V80H136 112V224c0 61.9 50.1 112 112 112s112-50.1 112-112V80H312 288V32h24 96 24V80H408 384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V80H40 16V32zM0 432H24 424h24v48H424 24 0V432z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCirclePlus = {
    prefix: 'fasr',
    iconName: 'rectangle-history-circle-plus',
    icon: [
      640,
      512,
      [],
      'e4a3',
      
      'M48 464l300.5 0c12.3 18.8 28 35.1 46.3 48L48 512H0V464 208 160H48l416 0h48v32.7c-5.3-.5-10.6-.7-16-.7c-26.2 0-51.1 5.7-73.4 16L48 208l0 256zM464 80v48L48 128V80l416 0zM416 0V48L96 48V0H416zm80 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80V288H480v16 48H432 416v32h16 48v48 16h32V432 384h48 16V352H560 512V304z'
      
    ]
  };

  

  
  

  var faUmbrellaSimple = {
    prefix: 'fasr',
    iconName: 'umbrella-simple',
    icon: [
      512,
      512,
      ["umbrella-alt"],
      'e2bc',
      
      'M280 0V24v9.1C394.1 43.7 486.5 129.2 507.5 240c3 15.5 4.5 31.6 4.5 48H464 48 0c0-16.4 1.5-32.5 4.5-48C25.5 129.2 117.9 43.7 232 33.1V24 0h48zM256 80C157.6 80 75.2 148.3 53.6 240H458.4C436.8 148.3 354.4 80 256 80zm24 358.6c0 40.6-32.9 73.4-73.4 73.4c-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7-10.7-21.5 42.9-21.5 10.7 21.5 2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1c14.1 0 25.4-11.4 25.4-25.4V320h48V438.6z'
      
    ]
  };

  
    var faUmbrellaAlt = faUmbrellaSimple;
  

  
  

  var faBath = {
    prefix: 'fasr',
    iconName: 'bath',
    icon: [
      512,
      512,
      [128705,"bathtub"],
      'f2cd',
      
      'M32 0H56h64 9.9l7 7 18 18c11.1-5.8 23.7-9.1 37-9.1c23.6 0 44.9 10.2 59.5 26.5L264 30.1 297.9 64 281 81 177 185l-17 17L126.1 168l12.5-12.5C122.2 140.9 112 119.6 112 96c0-13.4 3.3-25.9 9.1-37l-11-11H80V256H432h48 8 24v48H488h-8H432 80 32 24 0V256H24h8V24 0zm0 336H80v32c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V336h48v32c0 28.4-12.4 54-32 71.6V488v24H400V488 462.7c-5.2 .9-10.5 1.3-16 1.3H128c-5.5 0-10.8-.5-16-1.3V488v24H64V488 439.6C44.4 422 32 396.4 32 368V336zM192 64c-17.7 0-32 14.3-32 32c0 10.4 4.9 19.6 12.6 25.5l44.8-44.8C211.6 68.9 202.4 64 192 64z'
      
    ]
  };

  
    var faBathtub = faBath;
  

  
  

  var faMessages = {
    prefix: 'fasr',
    iconName: 'messages',
    icon: [
      640,
      512,
      ["comments-alt"],
      'f4b6',
      
      'M96 384l48-24 80-40H368h48V272 48 0H368 48 0V48 272v48H48 96v10.3V368v16zM202.5 277.1L144 306.3V272H96 48V48H368V272H224 212.7l-10.1 5.1zM256 400v48h48H416l80 40 48 24V496 458.3 448h48 48V400 176 128H592 448v48H592V400H544 496v34.3l-58.5-29.3L427.3 400H416 304V352H256v48z'
      
    ]
  };

  
    var faCommentsAlt = faMessages;
  

  
  

  var faWifi = {
    prefix: 'fasr',
    iconName: 'wifi',
    icon: [
      640,
      512,
      ["wifi-3","wifi-strong"],
      'f1eb',
      
      'M33.7 191.3C109.1 122.2 209.6 80 320 80s210.9 42.2 286.3 111.3l32.4-35.4C554.8 79 442.9 32 320 32S85.2 79 1.2 155.9l32.4 35.4zM320 256c64.9 0 123.9 24.9 168.1 65.6l32.5-35.3C467.9 237.7 397.4 208 320 208s-147.9 29.7-200.6 78.4l32.5 35.3C196.1 280.9 255.1 256 320 256zm56 168a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z'
      
    ]
  };

  
    var faWifi3 = faWifi;
  
    var faWifiStrong = faWifi;
  

  
  

  var faFileArrowUp = {
    prefix: 'fasr',
    iconName: 'file-arrow-up',
    icon: [
      384,
      512,
      ["file-upload"],
      'f574',
      
      'M48 48H224V160H336V464H48V48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM216 408V305.9l31 31 17 17L297.9 320l-17-17-72-72-17-17-17 17-72 72-17 17L120 353.9l17-17 31-31V408v24h48V408z'
      
    ]
  };

  
    var faFileUpload = faFileArrowUp;
  

  
  

  var faHouseCircleExclamation = {
    prefix: 'fasr',
    iconName: 'house-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e50a',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 394.8c-18.3-12.9-34.1-29.2-46.3-48H336v0H240V320h86.6c4.9-17.2 12.3-33.4 21.8-48H216 192v24V464H112V212.8L288 63.5 447.5 198.8c15.4-4.4 31.7-6.8 48.5-6.8c6.4 0 12.7 .3 18.8 1L303.5 13.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64H480V416h32v32zm0-176v16 80 16H480V368 288 272h32z'
      
    ]
  };

  

  
  

  var faClipboard = {
    prefix: 'fasr',
    iconName: 'clipboard',
    icon: [
      384,
      512,
      [128203],
      'f328',
      
      'M304 64h32 48v48V464v48H336 48 0V464 112 64H48 80h33.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H304zM48 112V464H336V112H304v48H192 80V112H48zm144-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faHexagonPlus = {
    prefix: 'fasr',
    iconName: 'hexagon-plus',
    icon: [
      512,
      512,
      ["plus-hexagon"],
      'f300',
      
      'M55.3 256L155.9 80H356.1L456.7 256 356.1 432H155.9L55.3 256zM128 32L0 256 128 480H384L512 256 384 32H128zM232 368h48V344 280h64 24V232H344 280V168 144H232v24 64H168 144v48h24 64v64 24z'
      
    ]
  };

  
    var faPlusHexagon = faHexagonPlus;
  

  
  

  var faTaco = {
    prefix: 'fasr',
    iconName: 'taco',
    icon: [
      512,
      512,
      [127790],
      'f826',
      
      'M325.9 86.1l88.3-2.7 24.7 84.9L512 218l-22.2 61.8C437.5 207.2 352.3 160 256 160s-181.5 47.2-233.8 119.8L0 218l73.1-49.7L97.8 83.4l88.3 2.7L256 32l69.9 54.1zM511.5 432c.3 5.3 .5 10.6 .5 16v32H464 48 0V448c0-5.4 .2-10.7 .5-16C8.8 298.1 120 192 256 192s247.2 106.1 255.5 240zM48.6 432H463.4C455.2 324.6 365.5 240 256 240S56.8 324.6 48.6 432zM184 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-64 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faChampagneGlasses = {
    prefix: 'fasr',
    iconName: 'champagne-glasses',
    icon: [
      640,
      512,
      [129346,"glass-cheers"],
      'f79f',
      
      'M129.5 194.9c-19.2 36.5-1.8 81.5 36.9 95.6s81-9.2 89.7-49.5l7.6-34.9L146.2 163.3l-16.6 31.6zM274 158.8l14.6-67.4-87.8-32-32.1 61L274 158.8zM87 172.6L177.9 0 320 51.7 462.1 0 553 172.6c28.9 54.9 9.2 121.2-41.3 152.5l35.6 97.7L601 403.3l22.6-8.2L640 440.2l-22.6 8.2-76.3 27.8-76.3 27.8-22.6 8.2L425.8 467l22.6-8.2 53.8-19.6-35.6-97.7c-58.8 8.4-116.5-29.7-129.7-90.3L320 173.2l-16.9 77.9c-13.2 60.7-70.9 98.8-129.7 90.3l-35.6 97.7 53.8 19.6 22.6 8.2-16.4 45.1-22.6-8.2L98.9 476.1 22.6 448.4 0 440.2 16.4 395 39 403.3l53.8 19.6 35.6-97.7C77.9 293.8 58.1 227.5 87 172.6zm423.4 22.4l-16.6-31.6L376.2 206.1l7.6 34.9c8.7 40.3 51 63.6 89.7 49.5s56.1-59.1 36.9-95.6zM366 158.8l105.3-38.3-32.1-61-87.8 32L366 158.8z'
      
    ]
  };

  
    var faGlassCheers = faChampagneGlasses;
  

  
  

  var faMarsStrokeUp = {
    prefix: 'fasr',
    iconName: 'mars-stroke-up',
    icon: [
      320,
      512,
      [9896,"mars-stroke-v"],
      'f22a',
      
      'M175.6 13.8L160 .4 144.4 13.8l-56 48L70.2 77.4l31.2 36.4 18.2-15.6 16.4-14V128H104 80v48h24 32v17.8C59 205.4 0 271.8 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-80.2-59-146.6-136-158.2V176h32 24V128H216 184V84.2l16.4 14 18.2 15.6 31.2-36.4L231.6 61.8l-56-48zM160 240a112 112 0 1 1 0 224 112 112 0 1 1 0-224z'
      
    ]
  };

  
    var faMarsStrokeV = faMarsStrokeUp;
  

  
  

  var faUserMinus = {
    prefix: 'fasr',
    iconName: 'user-minus',
    icon: [
      640,
      512,
      [],
      'f503',
      
      'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM99.5 352H348.5L383 464H65L99.5 352zM384 304H64L14.8 464 0 512H50.2 397.8 448l-14.8-48L384 304zm88-104H448v48h24H616h24V200H616 472z'
      
    ]
  };

  

  
  

  var faSignalSlash = {
    prefix: 'fasr',
    iconName: 'signal-slash',
    icon: [
      640,
      512,
      [],
      'f695',
      
      'M552 512h48v0H552v0zm0-106.2V24 0h48V24 443l20.9 16.2 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L296 207V192h48v24 28.3l80 62.1V120 96h48v24V343.7l80 62.1zm-80 62.1V488v24H424V488 430.1l48 37.8zM344 367V488v24H296V488 329.2L344 367zM216 288v24V488v24H168V488 312 288h48zM88 384v24 80 24H40V488 408 384H88z'
      
    ]
  };

  

  
  

  var faRoadCircleXmark = {
    prefix: 'fasr',
    iconName: 'road-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e566',
      
      'M95.6 432L196.2 80H296v24 24h48V104 80h99.8l32.3 113.1c6.5-.7 13.2-1.1 19.9-1.1c10.4 0 20.6 .9 30.5 2.6L480 32H344 296 160L45.7 432 32 480H81.9 360.2c-21.9-26.6-36.2-59.7-39.5-96H296v24 24H95.6zM344 216V192H296v24 80 24h30.6c4.1-14.4 10-28.1 17.4-40.8V216zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faStoreSlash = {
    prefix: 'fasr',
    iconName: 'store-slash',
    icon: [
      640,
      512,
      [],
      'e071',
      
      'M528 512h16v0H496 144 96V464 384 336 252.6c3.9 1 7.9 1.7 12 2.3l.1 0c5.3 .7 10.7 1.1 16.3 1.1c6.7 0 13.3-.6 19.6-1.6V336H304.6l60.9 48H144v80H467.1L528 512zm16-112.4l76.9 59.7 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L94.8 50.9 128 0H512l67.6 103.8c29.7 46.9 3.4 112-52.1 119.4c-4 .5-7.9 .8-12.1 .8c-19.7 0-37.7-6.5-52.2-17.2c-4.7-3.5-9.1-7.4-13-11.8c-3.9 4.3-8.2 8.2-12.9 11.7c-14.5 10.8-32.5 17.3-52.3 17.3c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 12c-1.9 1.4-3.8 2.7-5.7 3.9L462.1 336H496V254.4c6.3 1 12.8 1.6 19.4 1.6c5.6 0 10.9-.4 16.2-1.1l.1 0c4.2-.6 8.3-1.3 12.3-2.3V336v48 15.6zm-351.6-273L256 176c11.3-.4 21.3-5.4 28.3-13.1l35.6-39.4 35.6 39.4c7.3 8.1 17.8 13.2 29.6 13.2c11.9 0 22.3-5.1 29.6-13.2l35.5-39.3 35.6 39.2c7.4 8.2 18 13.2 29.7 13.2c2 0 3.8-.1 5.8-.4c9-1.2 16.1-6.8 20.1-16c4.1-9.5 3.6-20.7-2.1-29.9L486 48H154L132.9 80.4 189.1 124l.5-.6 2.9 3.2zM48.9 134.5l106.4 83.9c-9.6 3.6-20 5.6-31 5.6c-4.1 0-8.2-.3-12.1-.8c-43.9-5.9-69.4-48.1-63.3-88.7z'
      
    ]
  };

  

  
  

  var faH4 = {
    prefix: 'fasr',
    iconName: 'h4',
    icon: [
      640,
      512,
      [],
      'f86a',
      
      'M48 64V88 224H272V88 64h48V88 248 424v24H272V424 272H48V424v24H0V424 248 88 64H48zm592 0V88 424v24H592V424 304H392 362.5l6-28.9L412.5 64h49l-40 192H592V88 64h48z'
      
    ]
  };

  

  
  

  var faBadgerHoney = {
    prefix: 'fasr',
    iconName: 'badger-honey',
    icon: [
      640,
      512,
      [129441],
      'f6b4',
      
      'M426.3 64H432h64 5.3l4.8 2.3 120 56 13.8 6.5V144v48 9.9l-7 7-32 32-7 7H590l-30 48-26.4-42.2c-39 8.7-74.8 26.4-103.4 45.6l25.5 152.7 4.7 27.9H432 336 315.7l-3.3-20.1L294.3 352H220.4l-10.9 25.4L231 449.1l9.3 30.9H208 112 94.1L89 462.9l-24-80-2-6.7 1.9-6.8 8.5-29.6c-9.1-4.3-17.6-9.6-25.4-15.9V328v24H0V328 224C0 153.3 57.3 96 128 96H362.3l58.9-29.5 5.1-2.5zM48 224c0 37.4 25.7 68.9 60.4 77.6l24 6-6.8 23.8L113 375.8 129.9 432h45.9L161 382.9l-2.5-8.3 3.4-8 20.6-48 6.2-14.5h15.8H314.7 335l3.3 20.1 18 107.9h47.3L380.4 292.3 378 277.8l11.9-8.7c44.1-32.5 110-66 184-68.9L592 182.1V176H511.6c-1.9 9.1-9.9 16-19.6 16s-17.7-6.9-19.6-16h-52L264.2 269.7l-3.8 2.3H256 224c-69.3 0-127.2-49-140.9-114.2C61.9 172.2 48 196.5 48 224zm65.3-78.7C121.7 199 168 240 224 240h27.6l156.2-93.7 3.8-2.3H416 559.2l-68.6-32h-53l-58.9 29.5-5.1 2.5H368 128c-5 0-9.9 .5-14.7 1.3z'
      
    ]
  };

  

  
  

  var faHeadset = {
    prefix: 'fasr',
    iconName: 'headset',
    icon: [
      512,
      512,
      [],
      'f590',
      
      'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208V440.1L320 440V416H240c-26.5 0-48 21.5-48 48s21.5 48 48 48h80V488l168 .1 24 0v-24V256C512 114.6 397.4 0 256 0S0 114.6 0 256v40 24H48V296 256zm70.1-80l-7 7L87 207l-7 7V224v56 80 24h24 80 24V360 200 176H184 128h-9.9zm9.9 57.9l9.9-9.9H160V336H128V280 233.9zM384 176H328 304v24V360v24h24 80 24V360 280 224v-9.9l-7-7-24-24-7-7H384zm-9.9 48l9.9 9.9V280v56H352V224h22.1z'
      
    ]
  };

  

  
  

  var faColonSign = {
    prefix: 'fasr',
    iconName: 'colon-sign',
    icon: [
      384,
      512,
      [],
      'e140',
      
      'M113.4 413L96.7 482.4l46.7 11.3 13.9-57.6c9.2 3.4 18.8 6.2 28.7 8.1l-9.2 38.2 46.7 11.3 11.1-45.9c58.5-3.1 110.1-32.5 143.2-76.5l-38.4-28.8c-22.1 29.4-55 50-92.9 55.9l62.4-258.7c11.6 8.4 21.8 18.6 30.4 30l38.4-28.8c-15.3-20.4-34.7-37.7-56.9-50.7l14.6-60.5L288.7 18.4 275.9 71.1c-9.5-2.7-19.2-4.6-29.2-5.8l8.6-35.7L208.7 18.4 197.2 65.9C103.9 78.9 32 159.1 32 256c0 64.9 32.2 122.2 81.4 157zm55.2-24l66.7-276.5c10.1 .8 19.9 2.6 29.3 5.4L197.2 397.5c-9.9-1.9-19.5-4.8-28.6-8.5zm16.2-271.5l-58.9 244C97.6 335.1 80 297.6 80 256c0-65.9 44.3-121.5 104.8-138.6z'
      
    ]
  };

  

  
  

  var faUnlock = {
    prefix: 'fasr',
    iconName: 'unlock',
    icon: [
      448,
      512,
      [128275],
      'f09c',
      
      'M144 128c0-44.2 35.8-80 80-80c35.6 0 65.8 23.2 76.1 55.4l45.7-14.8C329.2 37.2 281 0 224 0C153.3 0 96 57.3 96 128v64H48 0v48V464v48H48 400h48V464 240 192H400 144V128zM48 464V240H400V464H48z'
      
    ]
  };

  

  
  

  var faSheep = {
    prefix: 'fasr',
    iconName: 'sheep',
    icon: [
      640,
      512,
      [128017],
      'f711',
      
      'M576 135.8l14.5 6.2 22.1 9.5 18.9-44.1-22.1-9.5L554.3 74.3 512 32H448L405.7 74.3 350.5 97.9l-22.1 9.5 18.9 44.1 22.1-9.5 14.5-6.2V288H576V135.8zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM302.3 83.8c-6.5-6.9-14.6-12.3-23.6-15.7C271.6 65.5 264 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0L120 512h88V426.3c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V512h88l22.5-120c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8h-49l1 4.1c.3 1.2 .5 2.5 .5 3.9c0 8.8-7.2 16-16 16c-.9 0-1.7-.1-2.5-.2L370 337.1l-10.4 42.7c-1.7 7-8.1 12.1-15.5 12.1c-3.8 0-7.2-1.3-9.9-3.4L298.2 360l-30.2 34.5c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5L213.8 360l-35.9 28.5c-2.7 2.2-6.1 3.4-9.9 3.4c-7.5 0-13.8-5.1-15.5-12.1L142 337.1l-43.5 6.7c-.8 .1-1.6 .2-2.5 .2c-8.8 0-16-7.2-16-16c0-1.4 .2-2.7 .5-3.9l9-36.3-33-17.6C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2l33-17.6-9-36.3c-.3-1.2-.5-2.5-.5-3.9c0-8.8 7.2-16 16-16c.9 0 1.7 .1 2.5 .2l43.5 6.7 10.4-42.7c1.7-7 8.1-12.1 15.5-12.1c3.8 0 7.2 1.3 9.9 3.5L213.8 152l30.2-34.5c3-3.4 7.3-5.5 12.1-5.5c5.8 0 10.9 3 13.7 7.8l34.8 57.7 12.7-15.2L286.5 90.6l15.8-6.8z'
      
    ]
  };

  

  
  

  var faCitrusSlice = {
    prefix: 'fasr',
    iconName: 'citrus-slice',
    icon: [
      512,
      512,
      [],
      'e2f5',
      
      'M464 208c0 141.4-114.6 256-256 256c-49.2 0-95.2-13.9-134.2-37.9L101 398.9c33.3 21 72.7 33.1 115 33.1c119.3 0 216-96.7 216-216c0-42.3-12.1-81.7-33.1-115l27.2-27.2c24.1 39 37.9 85 37.9 134.2zM63.3 368.7L35.2 396.8l-34 34c11.8 11 24.5 21 37.9 30C87.4 493.1 145.5 512 208 512c167.9 0 304-136.1 304-304c0-62.5-18.9-120.6-51.2-168.9c-9-13.4-19-26.1-30-37.9l-34 34L368.7 63.3 334.8 97.2 240 192l-48 48L97.2 334.8 63.3 368.7zM224 288c11.3 0 22.5-3 32.5-8.9l66.4 66.4c-27.1 22.4-61.4 36.5-98.9 38.2V288zm55.1-31.5c5.9-10 8.9-21.3 8.9-32.5h95.8c-1.8 37.5-15.8 71.8-38.2 98.9l-66.4-66.4zM136.1 363.8L192 307.9v74.4c-20-2.9-38.9-9.2-55.9-18.5zM307.9 192l55.9-55.9c9.3 17.1 15.6 35.9 18.5 55.9H307.9z'
      
    ]
  };

  

  
  

  var faPepperHot = {
    prefix: 'fasr',
    iconName: 'pepper-hot',
    icon: [
      512,
      512,
      [127798],
      'f816',
      
      'M423.9 44.4L419 35.7l42-23.3 4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 33.1-10.1 63.9-27.3 89.4L448 256H336L320 144l-88-9.8C261.3 101 304.2 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8zm-251.6 260l84.2-141.8 35 7.8 3.1 22L213.5 328.9c-24.8 41.8-65.7 71.4-113.2 82L48 422.5V464h55.2c133.7 0 254.1-68.7 323.6-176h1.4l23.9 47.8C372.3 443.9 244.3 512 103.2 512H48 0V464 384l90-20c34.5-7.7 64.3-29.2 82.3-59.6z'
      
    ]
  };

  

  
  

  var faClockTwelve = {
    prefix: 'fasr',
    iconName: 'clock-twelve',
    icon: [
      512,
      512,
      [],
      'e358',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V256v24H232V256 120 96h48v24z'
      
    ]
  };

  

  
  

  var faMicrophoneLines = {
    prefix: 'fasr',
    iconName: 'microphone-lines',
    icon: [
      384,
      512,
      [127897,"microphone-alt"],
      'f3c9',
      
      'M144 48h96V96H208 192v32h16 32v32H208 192v32h16 32v32H208 192v32h16 32c0 26.5-21.5 48-48 48s-48-21.5-48-48V48zM96 0V48 256c0 53 43 96 96 96s96-43 96-96V48 0H240 144 96zM64 216V192H16v24 40c0 89.1 66.2 162.7 152 174.4V464H120 96v48h24 72 72 24V464H264 216V430.4c85.8-11.7 152-85.3 152-174.4V216 192H320v24 40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z'
      
    ]
  };

  
    var faMicrophoneAlt = faMicrophoneLines;
  

  
  

  var faSignalBarsWeak = {
    prefix: 'fasr',
    iconName: 'signal-bars-weak',
    icon: [
      640,
      512,
      ["signal-alt-1"],
      'f691',
      
      'M96 432v32H64V432H96zM64 384H16v48 32 48H64 96h48V464 432 384H96 64z'
      
    ]
  };

  
    var faSignalAlt1 = faSignalBarsWeak;
  

  
  

  var faCity = {
    prefix: 'fasr',
    iconName: 'city',
    icon: [
      640,
      512,
      [127961],
      'f64f',
      
      'M128 0V24 64h48V24 0h48V24 64 88v8 16H176 128 80 48V464H224v48H24 0V488 88 64H24 80V24 0h48zM512 112v48h48 32 48v48V464v48H592 512 304 256V464 160 48 0h48H464h48V48v64zM464 48H304V160 464H512h80V208H512 464V160 48zM352 352V288h64v64H352zM416 96v64H352V96h64zM352 256V192h64v64H352zm192 96v64H480V352h64zM96 320V256h64v64H96zm0 96V352h64v64H96zm64-256v64H96V160h64zM480 320V256h64v64H480z'
      
    ]
  };

  

  
  

  var faCodeFork = {
    prefix: 'fasr',
    iconName: 'code-fork',
    icon: [
      448,
      512,
      [],
      'e13b',
      
      'M112 48v64H48V48h64zM48 0H0V48v64 48H48h8v32c0 48.6 39.4 88 88 88h56v72h-8H144v48 64 48h48 64 48V464 400 352H256h-8V280h56c48.6 0 88-39.4 88-88V160h8 48V112 48 0H400 336 288V48v64 48h48 8v32c0 22.1-17.9 40-40 40H144c-22.1 0-40-17.9-40-40V160h8 48V112 48 0H112 48zM400 48v64H336V48h64zM192 400h64v64H192V400z'
      
    ]
  };

  

  
  

  var faHeartCirclePlus = {
    prefix: 'fasr',
    iconName: 'heart-circle-plus',
    icon: [
      576,
      512,
      [],
      'e500',
      
      'M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1l4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-14.4-6.6-29.8-11.4-45.9-14c2.7-8.5 4.1-17.4 4.1-26.4c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  

  
  

  var faFlatbread = {
    prefix: 'fasr',
    iconName: 'flatbread',
    icon: [
      512,
      512,
      [129747],
      'e40b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM177 369L143 335 335 143 369 177 177 369zm64-224l-96 96L111 207l96-96L241 145zm64 256L271 367l96-96L401 305l-96 96z'
      
    ]
  };

  

  
  

  var faBowlHot = {
    prefix: 'fasr',
    iconName: 'bowl-hot',
    icon: [
      512,
      512,
      ["soup"],
      'f823',
      
      'M176 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C218.8 99 240 122.9 240 168v24H192V168c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C149.2 93 128 69.1 128 24V0h48V24zm128 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C346.8 99 368 122.9 368 168v24H320V168c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C277.2 93 256 69.1 256 24V0h48V24zM176 464H336V443.1l26.7-13.2c55.1-27.3 93.9-82.4 97.8-147.5l.6-10.3H50.9l.6 10.3c3.8 65.1 42.7 120.3 97.8 147.5L176 443.1V464zM3.6 285.2L2.8 272 0 224H48.1 463.9 512l-2.8 48-.8 13.2C503.5 368.1 454 438.2 384 472.9V512H336 176 128V472.9C58 438.2 8.5 368.1 3.6 285.2z'
      
    ]
  };

  
    var faSoup = faBowlHot;
  

  
  

  var faCandy = {
    prefix: 'fasr',
    iconName: 'candy',
    icon: [
      640,
      512,
      [127852],
      'e3e7',
      
      'M309 399.6L198.5 178.7C184.3 201 176 227.5 176 256c0 75.8 58.6 137.9 133 143.6zM233.3 141L360 394.4c17.1-4.9 32.8-12.9 46.7-23.4L280 117.6c-17.1 4.9-32.8 12.9-46.7 23.4zM331 112.4L441.5 333.3C455.7 311 464 284.5 464 256c0-75.8-58.6-137.9-133-143.6zM504.6 308.9C481.7 389.2 407.7 448 320 448s-161.7-58.8-184.6-139.1L35.2 365.2 7 327l35.6-35.6L0 279V233l42.6-12.5L7 185l28.2-38.2 100.1 56.3C158.3 122.8 232.3 64 320 64s161.7 58.8 184.6 139.1l100.1-56.3L633 185l-35.6 35.6L640 233v46l-42.6 12.5L633 327l-28.2 38.2L504.6 308.9z'
      
    ]
  };

  

  
  

  var faAlbumCollectionCircleUser = {
    prefix: 'fasr',
    iconName: 'album-collection-circle-user',
    icon: [
      640,
      512,
      [],
      'e48f',
      
      'M32 0V48H56 456h24V0H456 56 32zM320 368c0-40.2 13.4-77.2 36.1-106.8C330.2 243.1 294.9 232 256 232c-79.5 0-144 46.6-144 104s64.5 104 144 104c26.9 0 52-5.3 73.6-14.6c-6.2-18-9.6-37.3-9.6-57.4zM53.8 208H422.6c22.3-10.3 47.2-16 73.4-16c4.1 0 8.2 .1 12.3 .4L512 160H463.7 48.3 0l5.5 48L40 512H394.8c-18.3-12.9-34.1-29.2-46.3-48H82.9L53.8 208zM40 80H16v48H40 472h24V80H472 40zM256 368c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zm384 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-63.3 77.7c-20.4 21.2-49 34.3-80.7 34.3s-60.3-13.2-80.7-34.3L440 416H552l24.7 29.7zM448 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faFolderOpen = {
    prefix: 'fasr',
    iconName: 'folder-open',
    icon: [
      576,
      512,
      [61717,128194,128449],
      'f07c',
      
      'M272 96L208 32H48 0V80 432v48H48 384h64L576 224H128L48 384V80H188.1l49.9 49.9L252.1 144H272 432v48h48V144 96H432 272z'
      
    ]
  };

  

  
  

  var faFaceLaugh = {
    prefix: 'fasr',
    iconName: 'face-laugh',
    icon: [
      512,
      512,
      ["laugh"],
      'f599',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM258.2 408c-69.2 0-126.1-52.6-132.8-120H391c-6.7 67.4-63.6 120-132.8 120zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faLaugh = faFaceLaugh;
  

  
  

  var faChartPieSimple = {
    prefix: 'fasr',
    iconName: 'chart-pie-simple',
    icon: [
      512,
      512,
      ["chart-pie-alt"],
      'f64e',
      
      'M511.4 240c.4-5.3 .6-10.6 .6-16C512 100.3 411.7 0 288 0c-5.4 0-10.7 .2-16 .6V240H511.4zM176 288v48h48H421.1C394.7 410.6 323.6 464 240 464C134 464 48 378 48 272c0-83.6 53.4-154.7 128-181.1V288zm303.5 0H431.3 272 224V240 80.7 32.5c-16.5 1.1-32.6 3.8-48 8.1C74.5 68.6 0 161.6 0 272C0 404.6 107.5 512 240 512c110.4 0 203.4-74.5 231.4-176c4.3-15.4 7-31.5 8.1-48z'
      
    ]
  };

  
    var faChartPieAlt = faChartPieSimple;
  

  
  

  var faShirtLongSleeve = {
    prefix: 'fasr',
    iconName: 'shirt-long-sleeve',
    icon: [
      640,
      512,
      [],
      'e3c7',
      
      'M131.6 24V0H117.4l-6.8 12.4 21 11.6zM117.9 48.9l-21-11.6 21 11.6zm-88 160l21 11.6h0l-21-11.6zM24 219.7L3 208.1l-3 5.4v6.2H24zM24 424H0v24H24V424zm96 0v24h24V424H120zm0-179.7L99 232.8l-3 5.4v6.2h24zM184 128h24l-45-11.6L184 128zm0 360H160v24h24V488zm272 0v24h24V488H456zm0-360l21-11.6L432 128h24zm64 116.4h24v-6.2l-3-5.4-21 11.6zM520 424H496v24h24V424zm96 0v24h24V424H616zm0-204.3h24v-6.2l-3-5.4-21 11.6zm-5.9-10.8l-21 11.6v0l21-11.6zm-88-160L501 60.4v0l21-11.6zM508.4 24l21-11.6L522.6 0H508.4V24zM400 24V0H376V24h24zM240 24h24V0H240V24zM131.6 48H160V0H131.6V48zM139 60.4l13.7-24.9L110.6 12.4 96.9 37.3 139 60.4zm-88 160l88-160L96.9 37.3l-88 160L51 220.4zM45 231.2L51 220.4 8.9 197.3 3 208.1 45 231.2zm3 .8V219.7H0V232H48zm0 192V232H0V424H48zm72-24H24v48h96V400zM96 244.3V424h48V244.3H96zm67-127.9L99 232.8 141 255.9l64-116.4L163 116.4zM160 128V488h48V128H160zm24 384H456V464H184v48zm296-24V128H432V488h48zm61-255.2L477 116.4 435 139.5l64 116.4L541 232.8zM544 424V244.3H496V424h48zm72-24H520v48h96V400zM592 232V424h48V232H592zm0-12.3V232h48V219.7H592zm-3 .8l5.9 10.8L637 208.1l-5.9-10.8L589 220.4zm-88-160l88 160 42.1-23.1-88-160L501 60.4zM487.4 35.6L501 60.4l42.1-23.1L529.4 12.4 487.4 35.6zM480 48h28.4V0H480V48zm-24 0h24V0H456V48zm0-48H444V48h12V0zM444 0H400V48h44V0zM376 24c0 30.9-25.1 56-56 56v48c57.4 0 104-46.6 104-104H376zM320 80c-30.9 0-56-25.1-56-56H216c0 57.4 46.6 104 104 104V80zM240 0H196V48h44V0zM196 0H184V48h12V0zM160 48h24V0H160V48z'
      
    ]
  };

  

  
  

  var faShuttleSpace = {
    prefix: 'fasr',
    iconName: 'shuttle-space',
    icon: [
      640,
      512,
      ["space-shuttle"],
      'f197',
      
      'M32 384H24 0V360 328 184 152 128H24h8V80 32H80 192L405.3 160H456c70.4 0 127.6 23.5 171.2 81.6L638 256l-10.8 14.4C583.6 328.5 526.4 352 456 352H405.3L192 480H80 32V432 384zm280-32H160.9L128 371.4V432h50.7L312 352zm0-192L178.7 80H128v60.6L160.9 160H312zM48 184V328v8H93.5l48.8-28.7 5.6-3.3h6.5H456c34.4 0 63.3-6.5 88-21.1V229.1c-24.7-14.7-53.6-21.1-88-21.1H154.4h-6.5l-5.6-3.3L93.5 176H48v8zm432 40v64H448V224h32z'
      
    ]
  };

  
    var faSpaceShuttle = faShuttleSpace;
  

  
  

  var faHouseDay = {
    prefix: 'fasr',
    iconName: 'house-day',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M160 0L119.6 62.4 46.9 46.9l15.6 72.7L0 160l62.4 40.4L46.9 273.1l72.7-15.6 7.9 12.2 21.1-17.2L163 240.9c-1 0-2 .1-2.9 .1c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 6.6-.8 12.9-2.3 19.1l50.1-40.8-30.3-19.6 15.6-72.7L200.4 62.4 160 0zm48 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm207-50.7l-15-12-15 12-200 160-18.7 15 30 37.5 18.7-15 9-7.2V488v24h24H552h24V488 299.5l9 7.2 18.7 15 30-37.5-18.7-15-200-160zM528 261.1V464H272V261.1L400 158.7 528 261.1zM352 288v96h96V288H352z'
      
    ]
  };

  

  
  

  var faBedPulse = {
    prefix: 'fasr',
    iconName: 'bed-pulse',
    icon: [
      640,
      512,
      ["procedures"],
      'f487',
      
      'M472 0h16 14.8l6.6 13.3L534.8 64H616h24v48H616 520 505.2l-6.6-13.3L480.4 62.5 429.7 170.2 423.2 184H408 392 376.4l-6.3-14.3L344.4 112H216 192V64h24H360h15.6l6.3 14.3 18.5 41.5 49.9-106L456.8 0H472zM312 160h18.7l10.1 22.7L352.1 208H336V368H592V280c0-39.8-32.2-72-72-72H447.3l11.4-24.2L469.9 160H520c66.3 0 120 53.7 120 120V392 496v24H592V496 416H312 48v72 24H0V488 392 88 64H48V88 368H288V184 160h24zM208 248a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM80 248a88 88 0 1 1 176 0A88 88 0 1 1 80 248z'
      
    ]
  };

  
    var faProcedures = faBedPulse;
  

  
  

  var faFire = {
    prefix: 'fasr',
    iconName: 'fire',
    icon: [
      448,
      512,
      [128293],
      'f06d',
      
      'M227.2 119.4c-9.9-12.4-30-32.8-49.4-51.6l-1.8-1.7c-14.7 14.8-32.7 34.3-50.7 56.6c-20.7 25.6-40.5 54.1-55 83C55.8 234.8 48 261.6 48 284.5C48 386.3 125.6 464 224 464c97.2 0 176-77.8 176-179.5c0-41.7-25.6-90.4-58.3-133.7c-11.3-14.9-22.6-28.1-32.5-38.9c-1.9 1.8-3.4 3.3-4.6 4.6c-1.3 1.3-1.8 2-1.9 2.1c0 0 0 0 0 0l-37.3 48.7-38.3-47.9zM0 284.5C0 152 176 0 176 0s29.4 27 55.9 53.8c12.8 12.9 24.9 25.8 32.7 35.6c6.8-8.9 23.5-23.3 35.1-32.9c7.1-5.8 12.3-9.9 12.3-9.9s136 121.4 136 237.9C448 412.2 348.2 512 224 512C98.4 512 0 412.1 0 284.5zM225.7 416C162.6 416 112 375.4 112 306.8c0-33.6 21.1-63 63.2-114.8c5.6 7 87.1 110.6 87.1 110.6l50.6-58.8c4.2 5.6 7 11.2 9.8 16.8c25.3 46.2 14 105-28.1 134.4c-21.1 14-43.5 21-68.8 21z'
      
    ]
  };

  

  
  

  var faStars = {
    prefix: 'fasr',
    iconName: 'stars',
    icon: [
      512,
      512,
      [],
      'f762',
      
      'M356 60l60 20-60 20-20 60-20-60L256 80l60-20L336 0l20 60zM464 208l48 16-48 16-16 48-16-48-48-16 48-16 16-48 16 48zm-243.8-9.8l33 66.9 73.8 10.7 59.8 8.7-43.3 42.2-53.4 52.1 12.6 73.5L313 512l-53.5-28.1-66-34.7-66 34.7L73.9 512l10.2-59.6 12.6-73.5L43.3 326.8 0 284.6l59.8-8.7 73.8-10.7 33-66.9L193.5 144l26.8 54.2zm26.1 114.4l-25-3.6-11.2-22.6-16.7-33.9-16.7 33.9L165.6 309l-25 3.6-37.4 5.4 27.1 26.4 18.1 17.6L144 387l-6.4 37.3 33.5-17.6 22.3-11.7 22.3 11.7 33.5 17.6L242.9 387l-4.3-24.9 18.1-17.6 27.1-26.4-37.4-5.4z'
      
    ]
  };

  

  
  

  var faCircleZ = {
    prefix: 'fasr',
    iconName: 'circle-z',
    icon: [
      512,
      512,
      [],
      'e130',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-352.5V128H328 184 160v48h24 98.2L164.3 346.3l-4.3 6.2V384h24H328h24V336H328 229.8L347.7 165.7l4.3-6.2z'
      
    ]
  };

  

  
  

  var faDownToBracket = {
    prefix: 'fasr',
    iconName: 'down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e4e7',
      
      'M256 128l0 48 48 0 28.1 0L224 284.1 115.9 176l28.1 0 48 0 0-48 0-80 64 0 0 80zm1.9 190.1L384 192l0-16 0-48-32 0-16 0-32 0 0-48 0-32 0-48L256 0 192 0 144 0l0 48 0 32 0 48-32 0-16 0-32 0 0 48 0 16L190.1 318.1 224 352l33.9-33.9zM48 344l0-24L0 320l0 24L0 488l0 24 24 0 400 0 24 0 0-24 0-144 0-24-48 0 0 24 0 120L48 464l0-120z'
      
    ]
  };

  

  
  

  var faSignalStream = {
    prefix: 'fasr',
    iconName: 'signal-stream',
    icon: [
      576,
      512,
      [],
      'f8dd',
      
      'M48 256c0-56.2 19.3-107.8 51.6-148.7L61.9 77.5C23.2 126.6 0 188.6 0 256s23.2 129.4 61.9 178.5l37.7-29.7C67.3 363.8 48 312.2 48 256zm64 0c0 41.2 14.2 79.1 37.9 109.1l37.7-29.7C170.3 313.5 160 286 160 256s10.3-57.5 27.5-79.3l-37.7-29.7C126.2 176.9 112 214.8 112 256zM426.1 146.9l-37.7 29.7C405.7 198.5 416 226 416 256s-10.3 57.5-27.5 79.3l37.7 29.7c23.7-30 37.9-67.9 37.9-109.1s-14.2-79.1-37.9-109.1zM528 256c0 56.2-19.3 107.8-51.6 148.7l37.7 29.7C552.8 385.4 576 323.4 576 256s-23.2-129.4-61.9-178.5l-37.7 29.7C508.7 148.2 528 199.8 528 256zM288 296a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'
      
    ]
  };

  

  
  

  var faL = {
    prefix: 'fasr',
    iconName: 'l',
    icon: [
      320,
      512,
      [108],
      '4c',
      
      'M80 32V56 432H296h24v48H296 56 32V456 56 32H80z'
      
    ]
  };

  

  
  

  var faPersonWalking = {
    prefix: 'fasr',
    iconName: 'person-walking',
    icon: [
      320,
      512,
      [128694,"walking"],
      'f554',
      
      'M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM118.9 183.4L82.6 201.5 62.1 249.5l-9.5 22.1L8.5 252.6l9.5-22.1 24-56 3.5-8.1 7.9-3.9 80-40 8.2-4.1 8.8 2.4 88 24 13.2 3.6 3.6 13.2 22.3 81.9L313 279 279 313l-40-40-4.5-4.5-1.7-6.1-6.4-23.4-25.7 82.3 54.4 44.2 6.2 5 1.9 7.8 24 96 5.8 23.3-46.6 11.6-5.8-23.3-22.1-88.2L114 312.6C96 297.9 88.9 273.5 96.2 251.4l22.7-68zm52.9-6.9l-30 90.1c-1.1 3.2 0 6.6 2.5 8.7l16.4 13.3 32.4-103.8c.3-.8 .5-1.6 .9-2.3l-22.1-6zM99.7 342.2l39 31.7-20.4 51.1-1.8 4.6L113 433 52.2 493.8l-17 17L1.3 476.8l17-17 57.3-57.3 24.1-60.4z'
      
    ]
  };

  
    var faWalking = faPersonWalking;
  

  
  

  var faRectangleVertical = {
    prefix: 'fasr',
    iconName: 'rectangle-vertical',
    icon: [
      384,
      512,
      ["rectangle-portrait"],
      'f2fb',
      
      'M336 464H48L48 48l288 0 0 416zM384 48V0L336 0 48 0 0 0 0 48 0 464l0 48 48 0H336h48V464l0-416z'
      
    ]
  };

  
    var faRectanglePortrait = faRectangleVertical;
  

  
  

  var faToggleOn = {
    prefix: 'fasr',
    iconName: 'toggle-on',
    icon: [
      576,
      512,
      [],
      'f205',
      
      'M48 112V400H528V112H48zM0 64H48 528h48v48V400v48H528 48 0V400 112 64zm480 96V352H288V160H480z'
      
    ]
  };

  

  
  

  var faCircleArrowUp = {
    prefix: 'fasr',
    iconName: 'circle-arrow-up',
    icon: [
      512,
      512,
      ["arrow-circle-up"],
      'f0aa',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm17-377l-17-17-17 17-88 88-17 17L168 273.9l17-17 47-47V360v24h48V360 209.9l47 47 17 17L377.9 240l-17-17-88-88z'
      
    ]
  };

  
    var faArrowCircleUp = faCircleArrowUp;
  

  
  

  var faBedEmpty = {
    prefix: 'fasr',
    iconName: 'bed-empty',
    icon: [
      640,
      512,
      [128719],
      'f8f9',
      
      'M48 56V32H0V56 160v48V360v96 24H48V456 384H592v80 24h48V464 360 184 160H616 48V56zM592 336H48V208H592V336z'
      
    ]
  };

  

  
  

  var faPianoKeyboard = {
    prefix: 'fasr',
    iconName: 'piano-keyboard',
    icon: [
      576,
      512,
      [127929],
      'f8d5',
      
      'M528 224H448v64 32H432v80h96V224zM400 400V320H384V288 224H320v64 32H304v80h96zm-128 0V320H256V288 224H192v64 32H176v80h96zm-128 0V320H128V288 224H48V400h96zM528 176V112H48v64h80 64 64 64 64 64 80zm48 0v24 24V400v48H528 48 0V400 224 200 176 112 64H48 528h48v48 64z'
      
    ]
  };

  

  
  

  var faUserPilotTie = {
    prefix: 'fasr',
    iconName: 'user-pilot-tie',
    icon: [
      448,
      512,
      [],
      'e2c1',
      
      'M80 99.2L48 80V48L224 0 400 48V80L368 99.2V128c-16 10.7-67.2 32-144 32s-128-21.3-144-32V99.2zm88.8-40.7L154.5 87.2l14.3 7.2 48 24 7.2 3.6 7.2-3.6 48-24 14.3-7.2L279.2 58.5l-14.3 7.2L224 86.1 183.2 65.7l-14.3-7.2zM96 192c0-7.9 .7-15.7 2.1-23.2c14 5.4 28.5 9.9 43.3 13.4c-.4 3.2-.6 6.5-.6 9.8c0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8c14.8-3.6 29.3-8.1 43.3-13.4c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128zM208 416l-32-64h96l-32 64 12.2 48.9 .6-.9L320 352h80l33.6 112L448 512H397.9 280 256 224 192 168 50.1 0l14.4-48L48 352h80l67.2 112 .6 .9L208 416zm175.5 48l-19.2-64H347.2l-38.4 64h74.7zM100.8 400H83.7L64.5 464h74.7l-38.4-64z'
      
    ]
  };

  

  
  

  var faWheelchair = {
    prefix: 'fasr',
    iconName: 'wheelchair',
    icon: [
      512,
      512,
      [],
      'f193',
      
      'M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 352c0 61.9 50.1 112 112 112c42.8 0 80-24 98.9-59.3l42.3 22.6C274.3 477.7 221.2 512 160 512C71.6 512 0 440.4 0 352c0-68.5 43.1-126.9 103.5-149.7l16.9 44.9C78.1 263.2 48 304.1 48 352zM211.3 124.1l4.3 23.6 5.1 28.3H344h24v48H344 229.5l13.4 73.4c.7 3.8 4 6.6 7.9 6.6H384h15.7l6.3 14.4 47.2 107.9 27.2-9.1 22.8-7.6 15.2 45.5-22.8 7.6-48 16-20.8 6.9L418 465.6 368.3 352H250.7c-27.1 0-50.3-19.4-55.1-46L168.4 156.3l-4.3-23.6 47.2-8.6z'
      
    ]
  };

  

  
  

  var faTriangleInstrument = {
    prefix: 'fasr',
    iconName: 'triangle-instrument',
    icon: [
      576,
      512,
      ["triangle-music"],
      'f8e2',
      
      'M312 24V0H264V24 72l-4 6.6L28.8 464 0 512H56 520h56l-28.8-48L437.7 281.5l-35 35L491.2 464H84.8L288 125.3l72.3 120.5-53.5 53.5c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l45-45 35-35L537 137l17-17L520 86.1l-17 17L395.3 210.8 316 78.6 312 72V24z'
      
    ]
  };

  
    var faTriangleMusic = faTriangleInstrument;
  

  
  

  var faCommentPlus = {
    prefix: 'fasr',
    iconName: 'comment-plus',
    icon: [
      512,
      512,
      [],
      'f4b2',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM232 352h48V328 264h64 24V216H344 280V152 128H232v24 64H168 144v48h24 64v64 24z'
      
    ]
  };

  

  
  

  var faSquareChevronDown = {
    prefix: 'fasr',
    iconName: 'square-chevron-down',
    icon: [
      448,
      512,
      ["chevron-square-down"],
      'f329',
      
      'M400 80L48 80l0 352 352 0 0-352zm48-48l0 48 0 352 0 48-48 0L48 480 0 480l0-48L0 80 0 32l48 0 352 0 48 0zM313 273L209 377l-17 17L158.1 360l17-17 87-87-87-87-17-17L192 118.1l17 17L313 239l17 17-17 17z'
      
    ]
  };

  
    var faChevronSquareDown = faSquareChevronDown;
  

  
  

  var faObjectsColumn = {
    prefix: 'fasr',
    iconName: 'objects-column',
    icon: [
      448,
      512,
      [],
      'e3c1',
      
      'M48 80V240h96V80H48zM0 32H48h96 48V80 240v48H144 48 0V240 80 32zM304 272V432h96V272H304zm-48-48h48 96 48v48V432v48H400 304 256V432 272 224zM144 368H48v64h96V368zM48 320h96 48v48 64 48H144 48 0V432 368 320H48zM304 80v64h96V80H304zM256 32h48 96 48V80v64 48H400 304 256V144 80 32z'
      
    ]
  };

  

  
  

  var faViolin = {
    prefix: 'fasr',
    iconName: 'violin',
    icon: [
      640,
      512,
      [127931],
      'f8ed',
      
      'M496 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM333.8 52.2L52.2 333.8l-17 17L1.3 316.8l17-17L299.8 18.2l17-17 33.9 33.9-17 17zM176 512l-48-48 27.6-22.1C138.2 416.3 128 385.3 128 352c0-50 22.9-94.6 58.8-123.9c10.5 7.5 23.3 11.9 37.2 11.9c35.3 0 64-28.7 64-64c0-1.6-.1-3.2-.2-4.8l.5-.5c41.7-41.7 108-44.7 157.4-10.3L583 23l17-17L633.9 40 617 57 479.7 194.3C514.1 243.6 511 310 469.4 351.7l-.5 .5c-1.6-.1-3.2-.2-4.8-.2c-35.3 0-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2C382.6 489.1 338 512 288 512c-33.3 0-64.3-10.2-89.9-27.6L176 512zm52.2-65.3C245.5 457.7 266 464 288 464c25.1 0 48.3-8.2 67-22.2c-2-8.3-3-16.9-3-25.8c0-55.4 40.2-101.3 92.9-110.4c13.3-21.7 14.3-51.1 0-76.6l-84 84-17 17L310.1 296l17-17 84-84c-25.5-14.3-54.9-13.3-76.6 0c-9.1 52.8-55 92.9-110.4 92.9c-8.9 0-17.5-1-25.8-3c-14 18.7-22.2 41.9-22.2 67c0 22 6.3 42.5 17.3 59.8L208 400l32 32-11.8 14.7zM448 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBurrito = {
    prefix: 'fasr',
    iconName: 'burrito',
    icon: [
      512,
      512,
      [127791],
      'f7ed',
      
      'M242 62c8.2-35.5 40-62 78-62c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c2.7 6.1 4.6 12.7 5.7 19.6c6.6 41.7-20.4 81-61 90.4L208 512H112L0 400V304L242 62zM54.1 317.8c18 6.6 37.5 10.2 57.9 10.2c75.6 0 139.5-49.9 160.6-118.6c4.8-15.6 7.4-32.2 7.4-49.4c0-20.3-3.6-39.8-10.2-57.9L54.1 317.8zM48 380.1L131.9 464h56.2L409.9 242.2c-18-6.6-37.5-10.2-57.9-10.2c-13 0-25.7 1.5-37.9 4.3C283.3 317.9 204.5 376 112 376c-22.3 0-43.8-3.4-64-9.6v13.8z'
      
    ]
  };

  

  
  

  var faCommentMinus = {
    prefix: 'fasr',
    iconName: 'comment-minus',
    icon: [
      512,
      512,
      [],
      'f4b1',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM184 216H160v48h24H328h24V216H328 184z'
      
    ]
  };

  

  
  

  var faBinaryCircleCheck = {
    prefix: 'fasr',
    iconName: 'binary-circle-check',
    icon: [
      640,
      512,
      [],
      'e33c',
      
      'M224 0h24 56 24V24 176h32 24v48H360 304 248 224V176h24 32V48H248 224V0zM0 288H24 80h24v24V464h32 24v48H136 80 24 0V464H24 56V336H24 0V288zM24 0H168h24V24 200v24H168 24 0V200 24 0H24zM48 176h96V48H48V176zM192 288h24H339.2c-7.6 14.9-13.2 31-16.3 48H240V464l48 0h60.5c9.8 15 21.8 28.4 35.5 39.8V512H360 216 192V488 312 288zm160 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faPanelFire = {
    prefix: 'fasr',
    iconName: 'panel-fire',
    icon: [
      640,
      512,
      [],
      'e42f',
      
      'M400 80H48V432H305.5c8.1 17.6 18.8 33.8 31.5 48H48 0V432 80 32H48 400h48V80v42.1l-17 10.6c-9.1 5.7-19.7 13.2-31 22.4V80zM292.5 312H264V264h45.8c-7.4 15-13.4 31.1-17.2 48zM343 212.3c-3 3.8-6 7.7-8.9 11.7H96V128H352v73.4c-3.1 3.5-6.1 7.1-9 10.9zM232 264v48H184V264h48zm-80 0v48H104V264h48zM448 160l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faBoltSlash = {
    prefix: 'fasr',
    iconName: 'bolt-slash',
    icon: [
      640,
      512,
      [],
      'e0b8',
      
      'M460.4 334.7L544 272V224l-68.2-9.1-47.9-6.4 11.7-46.9 22-87.8L480 0 419.1 45.7 250.8 171.9 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L460.4 334.7zM290.1 202.4l110.6-82.9-19.3 77.4-13 52.1 53.3 7.1 54.1 7.2-54.5 40.9-131-101.7zm89.7 192.8l-39-30.7-37.4 28 12-48L274 311.9l-9.6 38.4-22 87.8L224 512l60.9-45.7 94.8-71.1zM171.7 231.3L160 240v48l68.2 9.1 32.5 4.3-89.1-70.2z'
      
    ]
  };

  

  
  

  var faCodeSimple = {
    prefix: 'fasr',
    iconName: 'code-simple',
    icon: [
      576,
      512,
      [],
      'e13d',
      
      'M367 114.8l-16.9-17L384.1 64 401 81 558 239.1 574.8 256 558 272.9 401 431l-16.9 17-34.1-33.8 16.9-17L507.2 256 367 114.8zm-173.1-.9L67.2 256 193.9 398.2l16 17.9L174.1 448l-16-17.9L17.1 272 2.9 256l14.2-16 141-158.1 16-17.9L209.9 96l-16 17.9z'
      
    ]
  };

  

  
  

  var faFaceLaughSquint = {
    prefix: 'fasr',
    iconName: 'face-laugh-squint',
    icon: [
      512,
      512,
      ["laugh-squint"],
      'f59b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM258.2 408c-69.2 0-126.1-52.6-132.8-120H391c-6.7 67.4-63.6 120-132.8 120zM112 128l118.9 64L112 256l45.7-64L112 128zm169.1 64L400 128l-45.7 64L400 256 281.1 192z'
      
    ]
  };

  
    var faLaughSquint = faFaceLaughSquint;
  

  
  

  var faPalletBoxes = {
    prefix: 'fasr',
    iconName: 'pallet-boxes',
    icon: [
      640,
      512,
      [57863,"palette-boxes","pallet-alt"],
      'f483',
      
      'M272 48H112V208H272V48zM112 0H272h48V48 208v48H272 112 64V208 48 0h48zM528 112H432v96h96V112zM432 64h96 48v48 96 48H528 432 384V208 112 64h48zM0 320H24 64 88h24H296h24 24H528h24 24 40 24v48H616 576v96h40 24v48H616 576 552 528 344 320 296 112 88 64 24 0V464H24 64V368H24 0V320zM112 464H296V368H112v96zm232 0H528V368H344v96z'
      
    ]
  };

  
    var faPaletteBoxes = faPalletBoxes;
  
    var faPalletAlt = faPalletBoxes;
  

  
  

  var faBarsSort = {
    prefix: 'fasr',
    iconName: 'bars-sort',
    icon: [
      448,
      512,
      [],
      'e0ae',
      
      'M0 64H448v48H0V64zM0 224H320v48H0V224zM192 384v48H0V384H192z'
      
    ]
  };

  

  
  

  var faChessKnight = {
    prefix: 'fasr',
    iconName: 'chess-knight',
    icon: [
      448,
      512,
      [9822],
      'f441',
      
      'M88 0H64V24 56 68l9.6 7.2L80 80l-6.4 4.8L64 92l0 12-.4 151.6 0 12.4 10.1 7.2 19.3 13.8L75.5 299.5l-11.5 7L64 320l0 32h48l0-18.5 124.5-75.9L257 245.1l-25-41-20.5 12.5-74 45.1-25.9-18.5L112 116l22.4-16.8L160 80 134.4 60.8 117.3 48H226.6C304.7 48 368 111.3 368 189.4c0 8.3-.7 16.6-2.2 24.8L341.3 352h48.8l23-129.4c1.9-10.9 2.9-22 2.9-33.2C416 84.8 331.2 0 226.6 0H88zM68.7 464l16.6-32H362.8l16.6 32H68.7zM432 461.3L392 384H56L16 461.3V464v48H64 384h48V464v-2.7zM172 168a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  

  
  

  var faFarm = {
    prefix: 'fasr',
    iconName: 'farm',
    icon: [
      576,
      512,
      ["barn-silo"],
      'f864',
      
      'M48 464h80v24 24H48 0V464 112C0 50.1 50.1 0 112 0c54.6 0 100.1 39.1 110 90.8l-4.4 1.9-19.4 8.5-8.9 19.2-26 55.7H48V464zM176 128V112c0-35.3-28.7-64-64-64s-64 28.7-64 64v16H176zm32 336h96V368H432v96h96V273.5L483.1 164.6 368 116.1 252.9 164.6 208 273.5V464zm-48 0V264l56-136L368 64l152 64 56 136V464v48H528 208 160V464zM416 224v96H320V224h96z'
      
    ]
  };

  
    var faBarnSilo = faFarm;
  

  
  

  var faSquareT = {
    prefix: 'fasr',
    iconName: 'square-t',
    icon: [
      448,
      512,
      [],
      'e280',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM120 144H224 328h24v48H328 248V360v24H200V360 192H120 96V144h24z'
      
    ]
  };

  

  
  

  var faTvRetro = {
    prefix: 'fasr',
    iconName: 'tv-retro',
    icon: [
      512,
      512,
      [128250],
      'f401',
      
      'M168 6.1l17 17 71 71 71-71 17-17L377.9 40 361 57l-39 39H464h48v48V464v48H464 48 0V464 144 96H48 190.1L151 57l-17-17L168 6.1zM48 144V464H464V144H48zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 192V416H96V192H352z'
      
    ]
  };

  

  
  

  var faScannerImage = {
    prefix: 'fasr',
    iconName: 'scanner-image',
    icon: [
      576,
      512,
      [],
      'f8f3',
      
      'M66.2 42.3L44.4 32.1 24.1 75.6 45.8 85.7 478.2 288H48 0v48 96 48H48 528h48V432 408 384 336 296v-8-7.3l-13.8-6.5-496-232zM528 336v48 24 24H48V336H528zM152 360v48h48V360H152zm-32 0H72v48h48V360z'
      
    ]
  };

  

  
  

  var faSnooze = {
    prefix: 'fasr',
    iconName: 'snooze',
    icon: [
      448,
      512,
      [128164,"zzz"],
      'f880',
      
      'M184 0H160V48h24 62.1l-79 79-7 7V144v8 24h24H296h24V128H296 233.9l79-79 7-7V32 24 0H296 184zM312 224H288v48h24 66.1l-84.2 96.2L288 375v9 8 24h24H424h24V368H424 357.9l84.2-96.2L448 265v-9-8V224H424 312zM24 224H0v48H24 156.9L5.1 465.2 0 471.7V480v8 24H24 200h24V464H200 67.1L218.9 270.8l5.1-6.5V256v-8V224H200 24z'
      
    ]
  };

  
    var faZzz = faSnooze;
  

  
  

  var faBlockQuestion = {
    prefix: 'fasr',
    iconName: 'block-question',
    icon: [
      640,
      512,
      [],
      'e3dd',
      
      'M144 80V432H496V80H144zM96 32h48H496h48V80 432v48H496 144 96V432 80 32zM232 184c0-30.9 25.1-56 56-56h56.9c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L344 264.4V272v24H296V272 250.5 236.6l12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H288c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 152h48v48H296V336zM160 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM456 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 392a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faPlayPause = {
    prefix: 'fasr',
    iconName: 'play-pause',
    icon: [
      640,
      512,
      [],
      'e22f',
      
      'M64 448V388 124 64l48 36L280 226l40 30-40 30L112 412 64 448zM240 256L112 160V352l128-96zM432 88V424v24H384V424 88 64h48V88zm144 0V424v24H528V424 88 64h48V88z'
      
    ]
  };

  

  
  

  var faLayerPlus = {
    prefix: 'fasr',
    iconName: 'layer-plus',
    icon: [
      576,
      512,
      ["layer-group-plus"],
      'f5ff',
      
      'M484 24V60h36 20v40H520 484v36 20H444V136 100H408 388V60h20 36V24 4h40V24zM118.2 256L288 331.5 457.8 256 288 180.5 118.2 256zM288 128L516.9 229.7 576 256l-59.1 26.3L288 384 59.1 282.3 0 256l59.1-26.3L288 128zM104.6 337.5l59.1 26.3L118.2 384 288 459.5 457.8 384l-45.5-20.2 59.1-26.3 45.5 20.2L576 384l-59.1 26.3L288 512 59.1 410.3 0 384l59.1-26.3 45.5-20.2z'
      
    ]
  };

  
    var faLayerGroupPlus = faLayerPlus;
  

  
  

  var faArrowUpAZ = {
    prefix: 'fasr',
    iconName: 'arrow-up-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-up"],
      'f15e',
      
      'M431.4 32l6.4 14 89.3 194H474.2l-14.8-32.2c-1.1 .2-2.2 .2-3.4 .2H372.5l-14.7 32H304.9L394.2 46l6.4-14h30.8zm6 128L416 113.4 394.6 160h42.8zM143 50.2l17-17 17 17 96 96 17 17L256 197.1l-17-17-55-55V456v24H136V456 125.1l-55 55-17 17L30.1 163.2l17-17 96-96zM352 288H480h24v24 8 9.9l-7 7-95 95H480h24v48H480 352 328V456v-8-9.9l7-7 95-95H352 328V288h24z'
      
    ]
  };

  
    var faSortAlphaUp = faArrowUpAZ;
  

  
  

  var faUserGroup = {
    prefix: 'fasr',
    iconName: 'user-group',
    icon: [
      640,
      512,
      [128101,"user-friends"],
      'f500',
      
      'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM99.5 352H348.5L383 464H65L99.5 352zM384 304H64L14.8 464 0 512H50.2 397.8 448l-14.8-48L384 304zM640 512L576 320H422.4l56.2 182.6 2.9 9.4H640zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7C377.4 75.9 384 101.2 384 128c0 35.6-11.6 68.5-31.3 95.1C373 243.4 401 256 432 256z'
      
    ]
  };

  
    var faUserFriends = faUserGroup;
  

  
  

  var faBooks = {
    prefix: 'fasr',
    iconName: 'books',
    icon: [
      512,
      512,
      [128218],
      'f5db',
      
      'M48 416v48h64V416H48zm64 96H48 0V464 416 392 368 144 120 96 48 0H48h64 48 64 48V30.1l11.2-3 54.9-14.7L384.4 0l12.4 46.4 11 41.2 6.2 23.2 6.2 23.2 54.8 204.6 6.2 23.2 6.2 23.2 11 41.2L511 472.4l-46.4 12.4-54.9 14.7L363.4 512 351 465.6l-11-41.2-6.2-23.2-6.2-23.2L272.7 173.5l-.7-2.5V368v24 24 48 48H224 160 112zm48-48h64V416H160v48zM112 48H48V96h64V48zm0 96H48V368h64V144zm48-48h64V48H160V96zm64 272V144H160V368h64zm173.3 85.2l54.9-14.7-11-41.2L386.3 412l11 41.2zm-23.5-87.5L428.8 351 374 146.3 319 161l54.8 204.6zm-67.2-251L361.5 100l-11-41.2L295.6 73.5l11 41.2z'
      
    ]
  };

  

  
  

  var faStarExclamation = {
    prefix: 'fasr',
    iconName: 'star-exclamation',
    icon: [
      576,
      512,
      [],
      'f2f3',
      
      'M315.2 51.4L374.6 164l125.4 21.7 57.3 9.9-40.5 41.7L428 328.5l18.3 127.4 8.1 56.1-51.8-23L288.1 438.2 173.5 489l-51.8 23 8.1-56.1 18.3-127.4L59.4 237.3 18.9 195.6l57.3-9.9L201.6 164 260.9 51.4 288.1 0l27.1 51.4zm51.2 159.8l-23.3-4-11-20.9-44.1-83.5L244 186.4l-11 20.9-23.3 4-93 16.1 65.8 67.7L199 312l-3.4 23.4-14 97.6 87-38.6 19.5-8.6 19.5 8.6 87 38.6-14-97.6L377.2 312l16.4-16.9 65.8-67.7-93-16.1zM312 176v24 64 24H264V264 200 176h48zM264 320h48v48H264V320z'
      
    ]
  };

  

  
  

  var faArrowUpToArc = {
    prefix: 'fasr',
    iconName: 'arrow-up-to-arc',
    icon: [
      512,
      512,
      [],
      'e617',
      
      'M256 48C141.1 48 48 141.1 48 256v24H0V256C0 114.6 114.6 0 256 0S512 114.6 512 256H464c0-114.9-93.1-208-208-208zM134.4 279.7l104-112L256 148.7l17.6 18.9 104 112 16.3 17.6-35.2 32.7-16.3-17.6L280 245.1 280 488v24H232V488l0-242.9-62.4 67.2-16.3 17.6-35.2-32.7 16.3-17.6z'
      
    ]
  };

  

  
  

  var faWeightScale = {
    prefix: 'fasr',
    iconName: 'weight-scale',
    icon: [
      512,
      512,
      ["weight"],
      'f496',
      
      'M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm304 0c0-22.6-4.3-44.2-12-64h44V464H48V112H92c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H48 0v48V464v48H48 464h48V464 112 64H464 391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3 6.3-14.7L295.6 91l-6.3 14.7L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z'
      
    ]
  };

  
    var faWeight = faWeightScale;
  

  
  

  var faHandBackPointUp = {
    prefix: 'fasr',
    iconName: 'hand-back-point-up',
    icon: [
      448,
      512,
      [],
      'e1a2',
      
      'M104 0H80V24 251.2l-56.1 51L16 309.4V320v38.5c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7H296c66.3 0 120-53.7 120-120v-8V288 248 224H392 352v-8V192H328 280v-8V160H256 208V24 0H184 104zM232 240h24 48v8 24h24 40v16 96 8c0 39.8-32.2 72-72 72H170.6c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5C83.6 429.7 64 395.5 64 358.5V330.6l32-29.1V344v16h32V344 272.4 264v-2.2V248 48h32V184v24h24 48v8 24z'
      
    ]
  };

  

  
  

  var faFlowerDaffodil = {
    prefix: 'fasr',
    iconName: 'flower-daffodil',
    icon: [
      512,
      512,
      [9880],
      'f800',
      
      'M256 82.4l30.6-25.2c6.9-5.7 15.7-9.1 25.4-9.1c22.1 0 40 17.9 40 40c0 9.7-3.4 18.5-9.1 25.4L317.6 144l25.2 30.6c5.7 6.9 9.1 15.7 9.1 25.4c0 22.1-17.9 40-40 40c-9.7 0-18.5-3.4-25.4-9.1L256 205.6l-30.6 25.2c-6.9 5.7-15.7 9.1-25.4 9.1c-22.1 0-40-17.9-40-40c0-9.7 3.4-18.5 9.1-25.4L194.4 144l-25.2-30.6c-5.7-6.9-9.1-15.7-9.1-25.4c0-22.1 17.9-40 40-40c9.7 0 18.5 3.4 25.4 9.1L256 82.4zM379.9 144c12.6-15.2 20.1-34.7 20.1-56c0-48.6-39.4-88-88-88c-21.3 0-40.8 7.5-56 20.1C240.8 7.5 221.3 0 200 0c-48.6 0-88 39.4-88 88c0 21.3 7.5 40.8 20.1 56c-12.6 15.2-20.1 34.7-20.1 56c0 48.6 39.4 88 88 88c11.3 0 22.1-2.1 32-6v91.4C191 321.4 127.4 288 56 288H48 0c0 16.5 1.8 32.5 5.2 48C27.1 436.6 116.8 512 224 512h8 48 8c107.2 0 196.9-75.4 218.8-176c3.4-15.5 5.2-31.5 5.2-48H464h-8c-71.4 0-135 33.4-176 85.4V282c9.9 3.9 20.7 6 32 6c48.6 0 88-39.4 88-88c0-21.3-7.5-40.8-20.1-56zM225.4 464H224c-80.6 0-148.5-54.1-169.4-128H56c80.6 0 148.5 54.1 169.4 128zm61.2 0c20.9-73.9 88.8-128 169.4-128h1.4C436.5 409.9 368.6 464 288 464h-1.4zM256 184l40-40-40-40-40 40 40 40z'
      
    ]
  };

  

  
  

  var faCalendarRange = {
    prefix: 'fasr',
    iconName: 'calendar-range',
    icon: [
      448,
      512,
      [],
      'e0d6',
      
      'M152 24V0H104V24 64H0v80 48V464v48H48 400h48V464 192 144 64H344V24 0H296V24 64H152V24zM48 192H400V464H48V192zm48 64v64h64V256H96zm192 96v64h64V352H288zm-96-88v48H352V264H192zM96 360v48H256V360H96z'
      
    ]
  };

  

  
  

  var faTableCellsLock = {
    prefix: 'fasr',
    iconName: 'table-cells-lock',
    icon: [
      640,
      512,
      [],
      'e679',
      
      'M360 80l0 88 104 0 0-88L360 80zm-48 0L200 80l0 88 112 0 0-88zM152 80L48 80l0 88 104 0 0-88zM48 216l0 80 104 0 0-80L48 216zm0 128l0 88 104 0 0-88L48 344zm152 88l112 0 0-88-112 0 0 88zm160 0l24 0 0 48L48 480 0 480l0-48L0 80 0 32l48 0 416 0 48 0 0 48 0 81.1c-34.7 5-64.2 25.8-81 54.9l-71 0 0 80 24 0 0 48-24 0 0 88zM200 296l112 0 0-80-112 0 0 80zm328-56c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z'
      
    ]
  };

  

  
  

  var faFilePrescription = {
    prefix: 'fasr',
    iconName: 'file-prescription',
    icon: [
      384,
      512,
      [],
      'f572',
      
      'M48 48H224V160H336V464H48V48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM104 192H80v24 80 64 24h48V360 320h24l-1 1 55 55-23 23-17 17L200 449.9l17-17 23-23 23 23 17 17L313.9 416l-17-17-23-23 23-23 17-17L280 302.1l-17 17-23 23-31.1-31.1C227.5 299.7 240 279.3 240 256c0-35.3-28.7-64-64-64H104zm72 80H128V240h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z'
      
    ]
  };

  

  
  

  var faXmarksLines = {
    prefix: 'fasr',
    iconName: 'xmarks-lines',
    icon: [
      640,
      512,
      [],
      'e59a',
      
      'M24 32H0V80H24 616h24V32H616 24zm0 400H0v48H24 616h24V432H616 24zM57 183l-17-17L6.1 200l17 17 39 39L23 295l-17 17L40 345.9l17-17 39-39 39 39 17 17L185.9 312l-17-17-39-39 39-39 17-17L152 166.1l-17 17-39 39L57 183zm224 0l-17-17L230.1 200l17 17 39 39-39 39-17 17L264 345.9l17-17 39-39 39 39 17 17L409.9 312l-17-17-39-39 39-39 17-17L376 166.1l-17 17-39 39-39-39zm224 0l-17-17L454.1 200l17 17 39 39-39 39-17 17L488 345.9l17-17 39-39 39 39 17 17L633.9 312l-17-17-39-39 39-39 17-17L600 166.1l-17 17-39 39-39-39z'
      
    ]
  };

  

  
  

  var faWeightHanging = {
    prefix: 'fasr',
    iconName: 'weight-hanging',
    icon: [
      512,
      512,
      [],
      'f5cd',
      
      'M216 88a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm118.4 40c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 14.4 3.5 28 9.6 40H88L11 464 0 512H49.2 462.8 512l-11-48L424 128H334.4zM256 176H385.8l66 288H60.2l66-288H256z'
      
    ]
  };

  

  
  

  var faCrown = {
    prefix: 'fasr',
    iconName: 'crown',
    icon: [
      576,
      512,
      [128081],
      'f521',
      
      'M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-5.8 11.6L214 212.1 192 256l-38.3-30.7L89.1 173.7 72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0l4.4 23.9L96 480H480l50.9-280.1 4.4-23.9c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-17.1 13.7-64.6 51.7L384 256l-22-43.9-47.2-94.4L309 106zM234.9 277.5L288 171.3l53.1 106.1 26.6 53.1L414 293.5l59.8-47.9L439.9 432H136.1L102.2 245.6 162 293.5l46.4 37.1 26.6-53.1z'
      
    ]
  };

  

  
  

  var faLeftLongToLine = {
    prefix: 'fasr',
    iconName: 'left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e41e',
      
      'M0 88V64H48V88 424v24H0V424 88zM336 232H288V184 163.9L195.9 256 288 348.1V328 280h48H592V232H336zM128 256l33.9-33.9L288 96h48v40 8 40h48H592h48v48 48 48H592 384 336v40 8 40H288L161.9 289.9 128 256z'
      
    ]
  };

  

  
  

  var faMicrochip = {
    prefix: 'fasr',
    iconName: 'microchip',
    icon: [
      512,
      512,
      [],
      'f2db',
      
      'M184 24V0H136V24 64H112 64v48 24H24 0v48H24 64v48H24 0v48H24 64v48H24 0v48H24 64v24 48h48 24v40 24h48V488 448h48v40 24h48V488 448h48v40 24h48V488 448h24 48V400 376h40 24V328H488 448V280h40 24V232H488 448V184h40 24V136H488 448V112 64H400 376V24 0H328V24 64H280V24 0H232V24 64H184V24zm216 88V400H112V112H400zm-96 96v96H208V208h96zm-96-48H160v48 96 48h48 96 48V304 208 160H304 208z'
      
    ]
  };

  

  
  

  var faTemperatureHigh = {
    prefix: 'fasr',
    iconName: 'temperature-high',
    icon: [
      512,
      512,
      [],
      'f769',
      
      'M416 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM416 0a96 96 0 1 1 0 192A96 96 0 1 1 416 0zM160 96v16V322.8c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112 96h32zM80 294.5L69.3 307.7C56 324.2 48 345.1 48 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L208 294.5v-17V48H80V277.5v17zM208 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S0 447.6 0 368c0-34.3 12-65.8 32-90.5V48 0H80 208z'
      
    ]
  };

  

  
  

  var faTrashCanXmark = {
    prefix: 'fasr',
    iconName: 'trash-can-xmark',
    icon: [
      448,
      512,
      [],
      'e2ae',
      
      'M160 0H147.2L140 10.7 93.8 80H80 32 0v48H32V464v48H80 368h48V464 128h32V80H416 368 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM80 464V128H368V464H80zM321.9 224L288 190.1l-17 17-47 47-47-47-17-17L126.1 224l17 17 47 47-47 47-17 17L160 385.9l17-17 47-47 47 47 17 17L321.9 352l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  

  
  

  var faFolderUser = {
    prefix: 'fasr',
    iconName: 'folder-user',
    icon: [
      512,
      512,
      [],
      'e18e',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H149.3L176 352H336l26.7 80H464V144H272zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faPeopleCarryBox = {
    prefix: 'fasr',
    iconName: 'people-carry-box',
    icon: [
      640,
      512,
      ["people-carry"],
      'f4ce',
      
      'M176 48A48 48 0 1 0 80 48a48 48 0 1 0 96 0zM72 128H48v24V272.4c0 17.2 7.9 33.4 21.4 44l92.2 72.4L179.2 512h48.5L207.8 372.6l-1.4-9.5-7.6-5.9L168 332.9V328 263l10.8 20.3 2.5 4.7 4.3 3.2 32 24L224 320h8 40 24 47.9 24 .1 39.9 8 .1v-.1l6.3-4.7 32-24 4.3-3.2 2.5-4.7L471.9 263v65 4.9L441 357.1l-7.6 5.9-1.4 9.5L412.2 512h48.5l17.6-123.1 92.2-72.4c13.5-10.6 21.4-26.9 21.4-44V152 128h-24-64H489.5l-6.8 12.7L472.4 160h-.5v1l-50.7 95-5.2 3.9V176 128H368 272 224v48 84l-5.3-4L168 161v-1h-.5l-10.3-19.3L150.4 128H136 72zM368 272h-.1-24H296 272V176h96v96zM120 184V295.2L99.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3V176h24v8zM49.3 341.4L8.8 489.7 2.8 512H52.5l2.6-9.7L90.3 373.6l-41-32.2zM511.9 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm8 199.2V184v-8h24v96.4c0 2.5-1.1 4.8-3.1 6.3l-20.9 16.5zM631 489.7L590.6 341.4l-41 32.2 35.1 128.7 2.6 9.7h49.8L631 489.7z'
      
    ]
  };

  
    var faPeopleCarry = faPeopleCarryBox;
  

  
  

  var faClockTenThirty = {
    prefix: 'fasr',
    iconName: 'clock-ten-thirty',
    icon: [
      512,
      512,
      [],
      'e355',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V256 243.2L269.3 236l-96-64-20-13.3-26.6 39.9 20 13.3L232 268.8V392v24h48V392z'
      
    ]
  };

  

  
  

  var faCloudsMoon = {
    prefix: 'fasr',
    iconName: 'clouds-moon',
    icon: [
      640,
      512,
      [],
      'f745',
      
      'M448 140c0 72.9 59.1 132 132 132c20.8 0 40.5-4.8 58-13.4C608.7 296 563.2 320 512 320c-4 0-7.9-.1-11.8-.4c-11.2-9.8-24.2-17.7-38.4-23.1c-9.9-53.2-52.6-94.8-106.4-103c-2.3-10.8-3.5-22-3.5-33.5C352 71.6 423.6 0 512 0c18.5 0 36.2 3.1 52.7 8.9C499 16.5 448 72.3 448 140zM383.3 320c0-26.5-21.5-48-48-48s-48 21.5-48 48v8h-49c-3.5-13.8-16.1-24-31-24c-17.7 0-32 14.3-32 32v40 24h-24-7.4c-17.7 0-32 14.3-32 32v32h32 7.4 24v0h88 0H399.5l0 0h31.8 32.6V416c0-26.5-21.5-48-48-48h-8.6-24V344 320zm-256 192v0H87.9h-24V488 432c0-38.5 27.2-70.7 63.4-78.3V336c0-44.2 35.8-80 80-80c17 0 32.8 5.3 45.8 14.4c16.8-27.8 47.3-46.4 82.2-46.4c53 0 96 43 96 96v1.2c45.7 7.4 80.6 47 80.6 94.8v72 24h-24H463.1l0 0H431.3h-24-144 0-112-24zm106-335.9H202l-12.6-28.8c-5-11.4-16.3-19.2-29.3-19.2c-15.4 0-28.4 11-31.3 25.5l-7.8 38.5H81.7 72.1c-13.2 0-24 10.7-24 24v24h24 48l0 0h30.2c-18.8 11.4-33.9 28.1-43.4 48H72.1l0 0h-24H.1v-48-24c0-39.8 32.2-72 72-72h9.6c7.4-36.5 39.7-64 78.4-64c32.8 0 61 19.7 73.3 48H256c35.3 0 64 28.6 64 64v.9c-17.3 2.2-33.6 7.8-48 16.2V192.1c0-8.8-7.2-16-16-16H233.4z'
      
    ]
  };

  

  
  

  var faCircle8 = {
    prefix: 'fasr',
    iconName: 'circle-8',
    icon: [
      512,
      512,
      [],
      'e0f5',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128c39.8 0 72 32.2 72 72c0 15.7-5 30.1-13.5 42c18 14.7 29.5 37 29.5 62c0 44.2-35.8 80-80 80H240c-44.2 0-80-35.8-80-80c0-25 11.5-47.4 29.5-62C181 230.1 176 215.7 176 200c0-39.8 32.2-72 72-72h16zm-16 96s0 0 0 0h16s0 0 0 0c13.2 0 24-10.8 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24s10.7 24 24 24zm16 48H248h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8z'
      
    ]
  };

  

  
  

  var faHeartPulse = {
    prefix: 'fasr',
    iconName: 'heart-pulse',
    icon: [
      512,
      512,
      ["heartbeat"],
      'f21e',
      
      'M256 163.9L289.9 130l24.2-24.2C330.6 89.3 353 80 376.2 80c48.5 0 87.8 39.3 87.8 87.8c0 23.3-9.2 45.6-25.7 62.1l-24.2 24.2-1.9 1.9H360.6l-27.3-40.9-13.3-20-13.3 20-49.5 74.3L197.9 184.2l-14.8-26.3-13.5 27L134.1 256H99.9l-1.9-1.9L73.7 229.8C57.2 213.4 48 191.1 48 167.8C48 119.3 87.3 80 135.8 80c23.3 0 45.6 9.2 62.1 25.7L222.1 130 256 163.9zm0 248.2L163.9 320H96L222.1 446.1 256 480l33.9-33.9L416 320H348.1L256 412.1zM343.4 288H352h28.1H448l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.7l0 0L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288h67.9H144h9.9l4.4-8.8 26.5-53 57.2 101.7 12.8 22.7 14.5-21.7 50.7-76 18.7 28 4.7 7.1z'
      
    ]
  };

  
    var faHeartbeat = faHeartPulse;
  

  
  

  var faInboxIn = {
    prefix: 'fasr',
    iconName: 'inbox-in',
    icon: [
      512,
      512,
      [128229,"inbox-arrow-down"],
      'f310',
      
      'M280 24V230.1l63-63 17-17L393.9 184l-17 17L273 305l-17 17-17-17L135 201l-17-17L152 150.1l17 17 63 63V24 0h48V24zM160 320l32 64H320l32-64H464h48v48 96 48H464 48 0V464 368 320H48 160zm202.9 85.5L349.7 432H320 192 162.3l-13.3-26.5L130.3 368H48v96H464V368H381.7l-18.7 37.5z'
      
    ]
  };

  
    var faInboxArrowDown = faInboxIn;
  

  
  

  var faPassport = {
    prefix: 'fasr',
    iconName: 'passport',
    icon: [
      448,
      512,
      [],
      'f5ab',
      
      'M400 48V464H48V48H400zM48 0H0V48 464v48H48 400h48V464 48 0H400 48zM96 384v32h16H336h16V384H336 112 96zm33.3-160h39.1c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zM224 304l-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.3 0zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8c6.8-17.1 12.9-40.4 14.6-70.8h39.1zm0-32H279.6c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8zM224 112l.3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.3 0zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8H129.3zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256z'
      
    ]
  };

  

  
  

  var faVenus = {
    prefix: 'fasr',
    iconName: 'venus',
    icon: [
      384,
      512,
      [9792],
      'f221',
      
      'M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4V400H120 96v48h24 48v40 24h48V488 448h48 24V400H264 216V350.4z'
      
    ]
  };

  

  
  

  var faCommentSmile = {
    prefix: 'fasr',
    iconName: 'comment-smile',
    icon: [
      512,
      512,
      [],
      'f4b4',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM192 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM168.4 254.1l-35.8 32 16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32l-16-17.9z'
      
    ]
  };

  

  
  

  var faSquareRight = {
    prefix: 'fasr',
    iconName: 'square-right',
    icon: [
      448,
      512,
      [10145,"arrow-alt-square-right"],
      'f352',
      
      'M400 80L48 80l0 352 352 0 0-352zm48-48V80l0 352v48H400L48 480H0V432 80 32H48 400h48zM256 144l96 112L256 368H224V304H96l0-96H224V144h32z'
      
    ]
  };

  
    var faArrowAltSquareRight = faSquareRight;
  

  
  

  var faVideoPlus = {
    prefix: 'fasr',
    iconName: 'video-plus',
    icon: [
      576,
      512,
      [],
      'f4e1',
      
      'M336 112V400H48V112H336zM48 64H0v48V400v48H48 336h48V400 352 160 112 64H336 48zM528 370.3l-112-56V368l112 56 48 24V394.3 117.7 64L528 88 416 144v53.7l112-56V370.3zM216 184V160H168v24 48H120 96v48h24 48v48 24h48V328 280h48 24V232H264 216V184z'
      
    ]
  };

  

  
  

  var faRightToBracket = {
    prefix: 'fasr',
    iconName: 'right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in-alt"],
      'f2f6',
      
      'M128 224l48 0 0-48 0-28.1L284.1 256 176 364.1l0-28.1 0-48-48 0-80 0 0-64 80 0zm190.1-1.9L192 96l-16 0-48 0 0 32 0 16 0 32-48 0-32 0L0 176l0 48 0 64 0 48 48 0 32 0 48 0 0 32 0 16 0 32 48 0 16 0L318.1 289.9 352 256l-33.9-33.9zM344 432l-24 0 0 48 24 0 144 0 24 0 0-24 0-400 0-24-24 0L344 32l-24 0 0 48 24 0 120 0 0 352-120 0z'
      
    ]
  };

  
    var faSignInAlt = faRightToBracket;
  

  
  

  var faFireHydrant = {
    prefix: 'fasr',
    iconName: 'fire-hydrant',
    icon: [
      384,
      512,
      [],
      'e17f',
      
      'M224 32V0H160V32v4c-45 11.6-80.4 47-92 92H56 32v48H56 328h24V128H328 316c-11.6-45-47-80.4-92-92V32zM192 376a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM56 464H32v48H56 88 296h32 24V464H328h-8V384h48V256H320V232 208H272v24V464H112V232 208H64v24 24H16V384H64v80H56z'
      
    ]
  };

  

  
  

  var faFilePng = {
    prefix: 'fasr',
    iconName: 'file-png',
    icon: [
      512,
      512,
      [],
      'e666',
      
      'M112 464l-64 0L48 48l176 0 0 112 112 0 0 144 48 0 0-176L256 0 48 0 0 0 0 48 0 464l0 48 48 0 64 0 0-48zm64-112l-16 0 0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80l-16 0 0 16 0 128 0 16 32 0 0-16 0-58.9 27.7 65.1 4.1 9.7 10.6 0 5.6 0 16 0 0-16 0-128 0-16-32 0 0 16 0 62.6-29.3-68.9-4.1-9.7L308 352l-4 0zm112 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24 0-16-16 0-16 0-16 0 0 32 16 0 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 32 0 0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faApostrophe = {
    prefix: 'fasr',
    iconName: 'apostrophe',
    icon: [
      192,
      512,
      [],
      '27',
      
      'M72 352c66.3 0 120-53.7 120-120v-8V176 128 80 32H144 48 0V80v96 48H48h96v8c0 39.8-32.2 72-72 72H56 32v48H56 72zm72-176H48V80h96v48 48z'
      
    ]
  };

  

  
  

  var faPersonBreastfeeding = {
    prefix: 'fasr',
    iconName: 'person-breastfeeding',
    icon: [
      448,
      512,
      [],
      'e53a',
      
      'M192 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0A80 80 0 1 0 144 80a80 80 0 1 0 160 0zM136 192H123.9l-7.2 9.7L12.7 342.4 8 348.8v7.9 57.4 15.7L22.3 436l168 73.9L209.7 466 56 398.4V364.6L148.1 240H300.6l87.6 107.7-64 94.8-13.4 19.9 39.8 26.9 13.4-19.9 74-109.6 10-14.8-11.2-13.8-106-130.4-7.2-8.9H312 136zm56 136V304H144v24 56 13.2l11.1 7.1 88 56L249 464h7 24V416H263l-71-45.2V328zm80 56a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faGaugeMax = {
    prefix: 'fasr',
    iconName: 'gauge-max',
    icon: [
      512,
      512,
      ["tachometer-alt-fastest"],
      'f626',
      
      'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56s25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4 19.8-13.6 27.1 39.6-19.8 13.6L311.3 343.2c.4 2.9 .7 5.8 .7 8.8c0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM112 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  
    var faTachometerAltFastest = faGaugeMax;
  

  
  

  var faBuildingWheat = {
    prefix: 'fasr',
    iconName: 'building-wheat',
    icon: [
      640,
      512,
      [],
      'e4db',
      
      'M336 48V464H240V352H144V464H48V48H336zM48 0H0V48 464v48H48 336h48V464 48 0H336 48zM168 88H88v80h80V88zm48 0v80h80V88H216zM168 216H88v80h80V216zm48 0v80h80V216H216zm424-24H624c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80V192zm0 128V304H624c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zm0 112V416H624c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zM512 496c0-44.2-35.8-80-80-80H416v16c0 44.2 35.8 80 80 80h16V496zm0-96V384c0-44.2-35.8-80-80-80H416v16c0 44.2 35.8 80 80 80h16zm0-128c0-44.2-35.8-80-80-80H416v16c0 44.2 35.8 80 80 80h16V272zM552 32l-48 0V56 160v24h48V160 56 32zm72 64V72H576V96v32 24h48V128 96zM480 72H432V96v32 24l48 0V128 96 72z'
      
    ]
  };

  

  
  

  var faCircleE = {
    prefix: 'fasr',
    iconName: 'circle-e',
    icon: [
      512,
      512,
      [],
      'e109',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H160v24V256 360v24h24H328h24V336H328 208V280h88 24V232H296 208V176H328h24V128H328 184z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleCurrency = {
    prefix: 'fasr',
    iconName: 'chart-pie-simple-circle-currency',
    icon: [
      640,
      512,
      [],
      'e604',
      
      'M496 192c-46.8 0-89.3 18.2-120.8 48H272V.6c5.3-.4 10.6-.6 16-.6C401 0 494.5 83.7 509.8 192.5c-4.6-.4-9.2-.5-13.8-.5zM272 288h67.2c-7.6 14.9-13.2 31-16.3 48H224 176V288 90.9C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192c34.5 0 66.9-9.1 94.9-25c6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 161.6 74.5 68.6 176 40.6c15.4-4.3 31.5-7 48-8.1V80.7 240v48h48zm80 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l25.3 25.3 22.6-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l25.3-25.3-22.6-22.6L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-25.3-25.3-22.6 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-25.3 25.3 22.6 22.6L460.7 426c21.6 13.2 49.1 13.2 70.7 0z'
      
    ]
  };

  

  
  

  var faLayerMinus = {
    prefix: 'fasr',
    iconName: 'layer-minus',
    icon: [
      576,
      512,
      ["layer-group-minus"],
      'f5fe',
      
      'M408 60H388v40h20H520h20V60H520 408zM288 331.5L118.2 256 288 180.5 457.8 256 288 331.5zM516.9 229.7L288 128 59.1 229.7 0 256l59.1 26.3L288 384 516.9 282.3 576 256l-59.1-26.3zm-353.2 134l-59.1-26.3L59.1 357.7 0 384l59.1 26.3L288 512 516.9 410.3 576 384l-59.1-26.3-45.5-20.2-59.1 26.3L457.8 384 288 459.5 118.2 384l45.5-20.2z'
      
    ]
  };

  
    var faLayerGroupMinus = faLayerMinus;
  

  
  

  var faLightbulbExclamation = {
    prefix: 'fasr',
    iconName: 'lightbulb-exclamation',
    icon: [
      384,
      512,
      [],
      'f671',
      
      'M320 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7l0 0 0 0 0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8l0 0c-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM112 416v96H272V416H112zm96-304H176v16 80 16h32V208 128 112zM176 256v32h32V256H176z'
      
    ]
  };

  

  
  

  var faMessageArrowUp = {
    prefix: 'fasr',
    iconName: 'message-arrow-up',
    icon: [
      512,
      512,
      ["comment-alt-arrow-up"],
      'e1dc',
      
      'M160 464v48l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464zm117.4-87.9L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM280 296V185.9l31 31 17 17L361.9 200l-17-17-72-72-17-17-17 17-72 72-17 17L184 233.9l17-17 31-31V296v24h48V296z'
      
    ]
  };

  
    var faCommentAltArrowUp = faMessageArrowUp;
  

  
  

  var faPaperPlaneTop = {
    prefix: 'fasr',
    iconName: 'paper-plane-top',
    icon: [
      512,
      512,
      ["paper-plane-alt","send"],
      'e20a',
      
      'M137.9 280H356.7L78.3 419.2 137.9 280zm218.7-48H137.9L78.3 92.8 356.7 232zm101.7-2.8L64 32H52.2 0L20.6 80 96 256 20.6 432 0 480H52.2 64L458.3 282.8 512 256l-53.7-26.8z'
      
    ]
  };

  
    var faPaperPlaneAlt = faPaperPlaneTop;
  
    var faSend = faPaperPlaneTop;
  

  
  

  var faPersonSeatReclined = {
    prefix: 'fasr',
    iconName: 'person-seat-reclined',
    icon: [
      512,
      512,
      [],
      'e21f',
      
      'M176 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32H130.1l6.5 29.2L163 308.1c5.7 25.6 28.4 43.9 54.7 43.9H335.6l42 107.9 7.4 19 20-4.3 44.8-9.6 23.5-5-10.1-46.9-23.5 5-24.8 5.3L374.4 319.3l-6-15.3H352 283.3l-10.7-48H328h24V208H328 261.9l-6.5-29.2L251.3 160H232 160zm52.7 48l21.3 96H217.7c-3.7 0-7-2.6-7.8-6.3L189.9 208h22.8zM79.6 147.8l-4.2-23.6-47.3 8.3 4.2 23.6 48 272L83.9 448H104 280h24V400H280 124.1L79.6 147.8z'
      
    ]
  };

  

  
  

  var faHourglassClock = {
    prefix: 'fasr',
    iconName: 'hourglass-clock',
    icon: [
      576,
      512,
      [],
      'e41b',
      
      'M24 0H0V48H24h8v72 9.9l7 7 119 119L39 375l-7 7V392v72H24 0v48H24 330.8c-18.3-12.9-34.1-29.2-46.3-48H80V401.9l112-112 64.5 64.5c1.5-19.3 6-37.7 13.2-54.7L225.9 256 345 137l7-7V120 48h8 24V0H360 24zM304 48v62.1l-112 112L80 110.1V48H304zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 288v16 48h32 16v32H480 432 416V368 304 288h32z'
      
    ]
  };

  

  
  

  var faBlenderPhone = {
    prefix: 'fasr',
    iconName: 'blender-phone',
    icon: [
      576,
      512,
      [],
      'f6b6',
      
      'M153.6 44.8L84.9 0 72.4 12.8c-96.6 99-96.6 259.4 0 358.4L84.9 384l68.7-44.8-25-89.6-58.9 6.7c-12.6-41.8-12.6-86.8 0-128.6l58.9 6.7 25-89.6zM272 48H514.5l-12 48H368 352v32h16H494.5l-16 64H368 352v32h16H470.5l-28 112H272V48zM492 336l52-208 20-80L576 0H526.5 272 224V48 336H192v48 80 48h48H496h48V464 384 336H496h-4zM240 384h32H480h16v80H240V384zm152 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faUserHairBuns = {
    prefix: 'fasr',
    iconName: 'user-hair-buns',
    icon: [
      448,
      512,
      [],
      'e3d3',
      
      'M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H192l32-32 32 32h46.4c1 5.2 1.6 10.5 1.6 16zM40 192h65.3c19 46.9 65 80 118.7 80s99.7-33.1 118.7-80H408V64H334.9C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64H40V192zM66.6 464l32-96H349.4l32 96H66.6zM64 320L16 464 0 512H50.6 397.4 448l-16-48L384 320H64z'
      
    ]
  };

  

  
  

  var faHourglassStart = {
    prefix: 'fasr',
    iconName: 'hourglass-start',
    icon: [
      384,
      512,
      ["hourglass-1"],
      'f251',
      
      'M0 512H24 360h24V464H360h-8V392v-9.9l-7-7-119-119L345 137l7-7V120 48h8 24V0H360 24 0V48H24h8v72 9.9l7 7 119 119L39 375l-7 7V392v72H24 0v48zm80-48V401.9l112-112 112 112V464H80zM80 96V48H304V96H80z'
      
    ]
  };

  
    var faHourglass1 = faHourglassStart;
  

  
  

  var faFamily = {
    prefix: 'fasr',
    iconName: 'family',
    icon: [
      512,
      512,
      [],
      'e300',
      
      'M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM78 208h50 50 4.7c-4.3-9.8-6.7-20.6-6.7-32c0-5.5 .6-10.8 1.6-16H32L26 304l-2 48H64V488v24h48V488 352h32V304H112 74l4-96zm258-32c0 11.4-2.4 22.2-6.7 32h26.9H384h27.8l36.6 128H368v48h32V488v24h48V488 384h14.1H512l-13.7-48L448 160H334.4c1 5.2 1.6 10.5 1.6 16zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 368V304h64v64H224zm112 48V368 304 256H288 224 176v48 64 48h32v96h96V416h32z'
      
    ]
  };

  

  
  

  var faShopLock = {
    prefix: 'fasr',
    iconName: 'shop-lock',
    icon: [
      640,
      512,
      [],
      'e4a5',
      
      'M515.5 48l69.6 127.6c19.1 11.3 34.5 28.2 44.1 48.4H640V176L544 0H96L0 176v48H48 64V488v24H88 360h24V488 224h42.8c9.5-20 24.7-36.7 43.5-48H54.7L124.5 48h391zM336 224v96H112V224H336zM112 464V368H336v96H112zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48H416V512H640V320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faIntersection = {
    prefix: 'fasr',
    iconName: 'intersection',
    icon: [
      384,
      512,
      [8898],
      'f668',
      
      'M48 480V456 224c0-79.5 64.5-144 144-144s144 64.5 144 144V456v24h48V456 224c0-106-86-192-192-192S0 118 0 224V456v24H48z'
      
    ]
  };

  

  
  

  var faVirusCovidSlash = {
    prefix: 'fasr',
    iconName: 'virus-covid-slash',
    icon: [
      640,
      512,
      [],
      'e4a9',
      
      'M472.4 344c11.2-19.3 18.8-41 21.9-64H528v16 24h48V296 216 192H528v24 16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3 17 17 33.9-33.9-17-17L472.7 46.7l-17-17L421.8 63.7l17 17L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16 24V0H360 280 256V48h24 16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3 17-17L184.2 29.7l-17 17-34 34L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L472.4 344zM235.4 160c22.6-19.9 52.2-32 84.6-32c70.7 0 128 57.3 128 128c0 21-5 40.7-14 58.2L235.4 160zM401.3 412.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-43.1-34c-1.5 6-2.7 12.2-3.5 18.5H112V216 192H64v24 80 24h48l0-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3-17-17L93.7 391.8l17 17 56.6 56.6 17 17 33.9-33.9-17-17L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280 256v48h24 80 24V464H360 344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z'
      
    ]
  };

  

  
  

  var faServer = {
    prefix: 'fasr',
    iconName: 'server',
    icon: [
      512,
      512,
      [],
      'f233',
      
      'M48 80v96H464V80H48zM0 32H48 464h48V80v96 48H464 48 0V176 80 32zM48 336v96H464V336H48zM0 288H48 464h48v48 96 48H464 48 0V432 336 288zm392 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM328 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBadgeSheriff = {
    prefix: 'fasr',
    iconName: 'badge-sheriff',
    icon: [
      448,
      512,
      [],
      'f8a2',
      
      'M253.6 66.9C260.1 59.8 264 50.3 264 40c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 10.3 3.9 19.8 10.4 26.9l-40 68.6-77.8 .3C70.3 121.8 56.3 112 40 112c-22.1 0-40 17.9-40 40s17.9 40 40 40c2.7 0 5.2-.3 7.8-.8l37 64.8-37 64.8c-2.5-.5-5.1-.8-7.8-.8c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.3 0 30.3-9.8 36.6-23.8l77.8 .3 40 68.6c-6.4 7.1-10.4 16.5-10.4 26.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-10.3-3.9-19.8-10.4-26.9l40-68.6 77.8-.3c6.2 14 20.3 23.8 36.6 23.8c22.1 0 40-17.9 40-40s-17.9-40-40-40c-2.7 0-5.2 .3-7.8 .8l-37-64.8 37-64.8c2.5 .5 5.1 .8 7.8 .8c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.3 0-30.3 9.8-36.6 23.8l-77.8-.3-40-68.6zM224 312l56-56-56-56-56 56 56 56zm69.4-128.6l55.9 .2-27.7 48.5L307.9 256l13.6 23.8 27.7 48.5-55.9 .2-27.5 .1-13.8 23.7L224 400.7l-28.1-48.3L182 328.7l-27.5-.1-55.9-.2 27.7-48.5L140.1 256l-13.6-23.8L98.7 183.7l55.9-.2 27.5-.1 13.8-23.7L224 111.3l28.1 48.3L266 183.3l27.5 .1z'
      
    ]
  };

  

  
  

  var faGridRound = {
    prefix: 'fasr',
    iconName: 'grid-round',
    icon: [
      448,
      512,
      [],
      'e5da',
      
      'M88 96A24 24 0 1 1 40 96a24 24 0 1 1 48 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM88 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM248 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm88 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zm88 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z'
      
    ]
  };

  

  
  

  var faSlidersSimple = {
    prefix: 'fasr',
    iconName: 'sliders-simple',
    icon: [
      512,
      512,
      [],
      'e253',
      
      'M48 400l64 0 0-64-64 0 0 64zM0 448l0-48 0-64 0-48 48 0 64 0 48 0 0 48 0 8 328 0 24 0 0 48-24 0-328 0 0 8 0 48-48 0-64 0L0 448zM24 168L0 168l0-48 24 0 328 0 0-8 0-48 48 0 64 0 48 0 0 48 0 64 0 48-48 0-64 0-48 0 0-48 0-8L24 168zm376-56l0 64 64 0 0-64-64 0z'
      
    ]
  };

  

  
  

  var faWindTurbine = {
    prefix: 'fasr',
    iconName: 'wind-turbine',
    icon: [
      512,
      512,
      [],
      'f89b',
      
      'M340.8 425L317.1 202.8 415.4 2 234.8 133.7l-223 15.2 204.4 90.6L340.8 425zM232 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm48 199.9l-48-71.4V464H152 128v48h24H256 360h24V464H360 280V391.9z'
      
    ]
  };

  

  
  

  var faShopSlash = {
    prefix: 'fasr',
    iconName: 'shop-slash',
    icon: [
      640,
      512,
      ["store-alt-slash"],
      'e070',
      
      'M515.5 48l69.8 128H256L114.6 66.2 124.5 48h391zM76.2 36.4L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L576 424.4V224h16 48V176L544 0H96L76.2 36.4zM528 387.2L317.9 224H528V387.2zM54.7 176l14.1-25.8L30.5 120 0 176v48H48 64V488v24H88 360h24V488 398.5L284.3 320H112V224h50.5l-60.9-48H54.7zM552 512l-.2 0h.5l-.2 0zM112 464V368H336v96H112z'
      
    ]
  };

  
    var faStoreAltSlash = faShopSlash;
  

  
  

  var faSquare6 = {
    prefix: 'fasr',
    iconName: 'square-6',
    icon: [
      448,
      512,
      [],
      'e25b',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-49.2-37-89.8-84.7-95.3l44.4-48.4L294.6 128H229.4l-68.1 74.3c-21.4 23.4-33.3 54-33.3 85.7z'
      
    ]
  };

  

  
  

  var faPersonSkiLift = {
    prefix: 'fasr',
    iconName: 'person-ski-lift',
    icon: [
      512,
      512,
      ["ski-lift"],
      'f7c8',
      
      'M256 207.9l-32 7.5V0h32V207.9zM35.3 168l10.4 21.7L125 355.6l68.7-18.7 23.2-6.3 12.6 46.3-23.2 6.3-88 24L99 412.4l-8.6-18.1-88-184L-8 188.7 35.3 168zM512 288v24 40c0 10-6.3 19-15.7 22.5l-344 127.1L129.8 510l-16.6-45 22.5-8.3L272 406.2V286.3l-93.3 22c-19 4.5-38.4-5.4-46-23.4l-38-90-8.8-20.8 20.2-10 19.2-9.6 23-11.5 9.9 23.7L195 255.1l95.5-22.5L320 256V388.5l144-53.2V312 288h48zM64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80z'
      
    ]
  };

  
    var faSkiLift = faPersonSkiLift;
  

  
  

  var faNfcLock = {
    prefix: 'fasr',
    iconName: 'nfc-lock',
    icon: [
      576,
      512,
      [],
      'e1f8',
      
      'M400 80H48V432H320l0 48H48 0V432 80 32H48 400h48V80v81.1c-17.7 2.5-34 9.2-48 18.9V80zm-32 56v78.3c-10.2 16.9-16 36.6-16 57.7v16H320V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V136 112h24H344h24v24zM128 352H320l0 48H104 80V376 136 112h24 32 24v48H136h-8V352zM464 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H352V320h32V272z'
      
    ]
  };

  

  
  

  var faCannon = {
    prefix: 'fasr',
    iconName: 'cannon',
    icon: [
      640,
      512,
      [],
      'e642',
      
      'M127.6 207.2C192 176 559 51.3 559 51.3l81 161.9s-51.5 35.2-117.2 79.5c-8.5-13.9-19.3-26.2-31.9-36.4c26.7-18 51.2-34.6 71.2-48.1l16.2-11-43.4-86.9-18.6 6.4c-35.4 12.2-83.1 28.7-132.9 46.2c-101.1 35.5-205.1 73.2-234.6 87.4c-47.2 23.8-66.3 81.3-42.7 128.7s81.2 66.6 128.5 43c6.2-3.2 15.3-8.5 26.6-15.4c4.4 15.8 11.4 30.5 20.6 43.6c-10.5 6.4-19.2 11.3-25.4 14.5c-56.1 28-121.7 16.1-164.4-25.1L42.9 464.2 0 378.3l49.1-24.5c-7.3-58.9 22.5-118.5 78.5-146.6zM400 432a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-176a112 112 0 1 1 0 224 112 112 0 1 1 0-224z'
      
    ]
  };

  

  
  

  var faFilesMedical = {
    prefix: 'fasr',
    iconName: 'files-medical',
    icon: [
      448,
      512,
      [],
      'f7fd',
      
      'M400 368H144V48H320v80h80V368zM448 96L352 0H144 96V48 368v48h48H400h48V368 96zM48 120V96H0v24V488v24H24 328h24V464H328 48V120zm197.3 56v53.3H192v53.3h53.3V336h53.3V282.7H352V229.3H298.7V176H245.3z'
      
    ]
  };

  

  
  

  var faPegasus = {
    prefix: 'fasr',
    iconName: 'pegasus',
    icon: [
      576,
      512,
      [],
      'f703',
      
      'M109.6 133.9c-9.9 7.3-18.5 16.1-25.5 26.2C37.3 162.1 0 200.7 0 248v64 24H48V312 248c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6L76.6 366.7l-5.5 14.6-2.7 7.3 2.1 7.5 4.2 15.1 23.1 83.2 4.9 17.6h18.2 99.6 31.6l-8.5-30.4-24-86.3 13-34.8c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5V488v24h24 96 24V488 327.8c19.8-22.6 32-52.3 32-85.5l0-.3 10.7 10.7 15.1-6.7 72-32 14.3-6.3V192 108v-7.3l-4-6L540.8 48H560V0H536 508.8 496 480h-8H440C371.7 0 313.9 45.1 294.7 107.1L164.5 27.5 128 5.2V48c0 80 35.9 134 71.6 167.5c17.7 16.6 35.4 28.2 48.6 35.7c6.7 3.7 12.3 6.5 16.3 8.3c2 .9 3.7 1.6 4.9 2.1c.6 .2 1.1 .4 1.4 .6l.5 .2 .2 .1 .1 0 0 0c0 0 0 0 8.5-22.5s8.4-22.5 8.4-22.5l0 0-.7-.3c-.7-.3-1.8-.8-3.3-1.4c-3-1.3-7.3-3.5-12.7-6.5c-10.7-6-25.1-15.4-39.4-28.8c-20.9-19.5-41.6-47.5-51.1-86.4l102.2 62.4 5.8 3.5H296h17 7 14.2l2.6-21C343.2 87.7 387 48 440 48h32 8 3.2L528 115.3v61.1l-42.7 19L457 167l-7-7H440h-8H408v24 17.7 4.8l1.8 4.4c4 9.6 6.2 20.2 6.2 31.4c0 23.5-9.6 44.1-24.7 58.8l-7.3 7.1v10.1V464H336V346.2 326.8l-19-4c-2.1-.4-4.2-1-6.3-1.6l-88-25.7-31.4-9.2 .7 32.7c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L172 385.8l-2.7 7.3 2.1 7.5L188.9 464H139.1l-18.2-65.6-2.1-7.5 2.7-7.3 20.6-54.8 3.3-8.7-3.5-8.6-25.3-63.3c-3-7.6-4.6-15.7-4.6-23.9c0-17.4 7-33.3 18.2-44.8c-8-13.7-15-28.9-20.6-45.5zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faArrowRightToBracket = {
    prefix: 'fasr',
    iconName: 'arrow-right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in"],
      'f090',
      
      'M344 80l120 0 0 352-120 0-24 0 0 48 24 0 144 0 24 0 0-24 0-400 0-24-24 0L344 32l-24 0 0 48 24 0zm1 193l17-17-17-17L217 111l-17-17L166.1 128l17 17 87 87L24 232 0 232l0 48 24 0 246.1 0-87 87-17 17L200 417.9l17-17L345 273z'
      
    ]
  };

  
    var faSignIn = faArrowRightToBracket;
  

  
  

  var faComputerMouse = {
    prefix: 'fasr',
    iconName: 'computer-mouse',
    icon: [
      384,
      512,
      [128433,"mouse"],
      'f8cc',
      
      'M192 224H48V352c0 61.9 50.1 112 112 112h64c61.9 0 112-50.1 112-112V224H192zm192-48v24 24V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V224 200 176 48 0H48 168h24 24H336h48V48 176zM336 48H216V176H336V48zM168 48H48V176H168V48z'
      
    ]
  };

  
    var faMouse = faComputerMouse;
  

  
  

  var faCalendarStar = {
    prefix: 'fasr',
    iconName: 'calendar-star',
    icon: [
      448,
      512,
      [],
      'f736',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zM253.6 295.2l76.9 6.2-58.6 50.2 17.9 75L224 386.4l-65.8 40.2 17.9-75-58.6-50.2 76.9-6.2L224 224l29.6 71.2z'
      
    ]
  };

  

  
  

  var faPersonToPortal = {
    prefix: 'fasr',
    iconName: 'person-to-portal',
    icon: [
      512,
      512,
      ["portal-enter"],
      'e022',
      
      'M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM136 112h-8l-6.4 4.8-64 48L38.4 179.2l28.8 38.4 19.2-14.4L144 160h33.4l-31.8 95.4c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L215.4 512h50.3l45.3-144.8 5.8-18.5-16.9-9.5-43.4-24.4 28.1-84.4 12.5 40.8 5.2 16.9H320h32 16.5H392h24V240H392 368.1c1.2-82.9 11.4-134.5 24.1-164c12.4-28.7 22.4-28.1 23.7-28l.1 0 .1 0c1.3-.1 11.3-.7 23.7 28c13.5 31.4 24.2 87.7 24.2 180s-10.7 148.6-24.2 180c-12.4 28.7-22.4 28.1-23.7 28l-.1 0-.1 0c-1.3 .1-11.3 .7-23.7-28c-10.1-23.4-18.6-60.5-22.2-116H352 321.9c8.8 140.7 47.6 192 94.1 192c53 0 96-66.6 96-256S469 0 416 0c-46.2 0-84.8 50.6-93.9 189l-11.1-36.1-3.9-12.6-12.7-3.5-88-24-3.1-.8H200 136zm55.1 158.5l34.2-102.7 27 7.4L213.8 290.7l-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5zM103.4 368H24 0v48H24h96 16.6l5.9-15.5 18-47.9-4.9-2.8c-14.1-8-25.4-19.3-33-32.6L103.4 368z'
      
    ]
  };

  
    var faPortalEnter = faPersonToPortal;
  

  
  

  var faSlash = {
    prefix: 'fasr',
    iconName: 'slash',
    icon: [
      640,
      512,
      [],
      'f715',
      
      'M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z'
      
    ]
  };

  

  
  

  var faLasso = {
    prefix: 'fasr',
    iconName: 'lasso',
    icon: [
      576,
      512,
      [],
      'f8c8',
      
      'M576 176c0 97.2-128.9 176-288 176c-14.9 0-29.6-.7-43.9-2c7.7 15.3 11.9 32.4 11.9 50.2C256 461.9 205.9 512 144.2 512H56 32V464H56h88.2c35.2 0 63.8-28.6 63.8-63.8c0-24.9-14.5-47.5-37.1-57.9l-44.3-20.5C50.2 290.1 0 236.6 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 304c132.5 0 240-57.3 240-128s-107.5-128-240-128S48 105.3 48 176s107.5 128 240 128z'
      
    ]
  };

  

  
  

  var faCircleQuarterStroke = {
    prefix: 'fasr',
    iconName: 'circle-quarter-stroke',
    icon: [
      512,
      512,
      [],
      'e5d3',
      
      'M464 256c0-114.9-93.1-208-208-208l0 208L48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faLocationXmark = {
    prefix: 'fasr',
    iconName: 'location-xmark',
    icon: [
      384,
      512,
      ["map-marker-times","map-marker-xmark"],
      'f60e',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zm-94.1-64l-17 17-47 47 47 47 17 17L256 289.9l-17-17-47-47-47 47-17 17L94.1 256l17-17 47-47-47-47-17-17L128 94.1l17 17 47 47 47-47 17-17L289.9 128z'
      
    ]
  };

  
    var faMapMarkerTimes = faLocationXmark;
  
    var faMapMarkerXmark = faLocationXmark;
  

  
  

  var faSpellCheck = {
    prefix: 'fasr',
    iconName: 'spell-check',
    icon: [
      576,
      512,
      [],
      'f891',
      
      'M95.2 0h33.7l5.7 15.8L221.4 256h-51l-14.5-40H68.1L53.6 256H2.6L89.4 15.8 95.2 0zm43.4 168L112 94.6 85.5 168h53.1zM280 0h76c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C436.3 133.6 448 155.4 448 180c0 42-34 76-76 76H280 256V232 128 24 0h24zM384 76c0-15.5-12.5-28-28-28H304v56h52c15.5 0 28-12.5 28-28zM304 208h68c15.5 0 28-12.5 28-28s-12.5-28-28-28H356 304v56zm270.7 83.5l-17.1 16.8L368.8 493.9l-17 16.7L335 493.8l-104-104-17-17L248 338.9l17 17L352.1 443 524 274.1l17.1-16.8 33.6 34.2z'
      
    ]
  };

  

  
  

  var faCoffinCross = {
    prefix: 'fasr',
    iconName: 'coffin-cross',
    icon: [
      384,
      512,
      [],
      'e051',
      
      'M52.8 154.3L135.5 48h113l82.7 106.3L243.7 464H140.3L52.8 154.3zM104 512H280L384 144 272 0H112L0 144 104 512zM216 120V96H168v24 40H120 96v48h24 48V328v24h48V328 208h48 24V160H264 216V120z'
      
    ]
  };

  

  
  

  var faGoalNet = {
    prefix: 'fasr',
    iconName: 'goal-net',
    icon: [
      640,
      512,
      [],
      'e3ab',
      
      'M24 32H0V56 456v24H48V456 80H592V456v24h48V456 56 32H616 24zm168 96H160v64H96v32h64v64H96v32h64v64H96v32h64v64h32V416h64v64h32V416h64v64h32V416h64v64h32V416h64V384H480V320h64V288H480V224h64V192H480V128H448v64H384V128H352v64H288V128H256v64H192V128zm64 256H192V320h64v64zm96 0H288V320h64v64zm96 0H384V320h64v64zm0-96H384V224h64v64zm-96 0H288V224h64v64zm-96 0H192V224h64v64z'
      
    ]
  };

  

  
  

  var faXRay = {
    prefix: 'fasr',
    iconName: 'x-ray',
    icon: [
      512,
      512,
      [],
      'f497',
      
      'M24 32H0V80H24h8V432H24 0v48H24 56 456h32 24V432H488h-8V80h8 24V32H488 456 56 24zM80 432V80H432V432H80zM272 96H240v16 32H176 160v32h16 64v32H144 128v32h16 96v54.6L181.3 272H128v57.6L170.7 384H341.3L384 329.6V272H330.7L272 294.6V240h96 16V208H368 272V176h64 16V144H336 272V112 96zM208 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faArrowDownFromBracket = {
    prefix: 'fasr',
    iconName: 'arrow-down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e667',
      
      'M241 493.8l-17 17-17-17L79 365.8l-17-17L96 314.9l17 17 87 87L200 184l0-24 48 0 0 24 0 234.9 87-87 17-17 33.9 33.9-17 17-128 128zM48 168l0 24L0 192l0-24L0 24 0 0 24 0 424 0l24 0 0 24 0 144 0 24-48 0 0-24 0-120L48 48l0 120z'
      
    ]
  };

  

  
  

  var faDiagramVenn = {
    prefix: 'fasr',
    iconName: 'diagram-venn',
    icon: [
      640,
      512,
      [],
      'e15a',
      
      'M270 425.9c-47.8-41.1-78-102-78-169.9s30.3-128.8 78-169.9c-14.7-4-30.1-6.1-46-6.1C126.8 80 48 158.8 48 256s78.8 176 176 176c15.9 0 31.4-2.1 46-6.1zM252 320H388c5.9-15.1 9.8-31.2 11.3-48H240.7c1.5 16.8 5.4 32.9 11.3 48zm16.5 32c13.4 20.6 31 38.1 51.5 51.5c20.6-13.4 38.1-31 51.5-51.5H268.5zM252 192c-5.9 15.1-9.8 31.2-11.3 48H399.3c-1.5-16.8-5.4-32.9-11.3-48H252zm119.5-32c-13.4-20.6-31-38.1-51.5-51.5c-20.6 13.4-38.1 31-51.5 51.5H371.5zM320 458.4c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6z'
      
    ]
  };

  

  
  

  var faFileLock = {
    prefix: 'fasr',
    iconName: 'file-lock',
    icon: [
      576,
      512,
      [],
      'e3a6',
      
      'M48 464H320l0 48H48 0V464 48 0H48 256L384 128v65.6c-19.8 20.2-32 47.9-32 78.4v16H336V160H224V48H48V464zM464 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H352V320h32V272z'
      
    ]
  };

  

  
  

  var faEar = {
    prefix: 'fasr',
    iconName: 'ear',
    icon: [
      384,
      512,
      [128066],
      'f5f0',
      
      'M263.7 316.9l-25.9 14.9 1.9 29.8c.1 2.1 .2 4.2 .2 6.4c0 53-43 96-96 96s-96-43-96-96V192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 53.3-29 100-72.3 124.9zM288 368c0-3.2-.1-6.4-.3-9.5C345.3 325.3 384 263.2 384 192C384 86 298 0 192 0S0 86 0 192V368c0 79.5 64.5 144 144 144s144-64.5 144-144zM128 192c0-35.3 28.7-64 64-64s64 28.7 64 64v8 24h48V200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192v40 14.8l13.3 6.6L128 270.8v5.9L88.6 309.6 70.2 324.9l30.7 36.9 18.4-15.4 48-40 8.6-7.2V288 256 241.2l-13.3-6.6L128 217.2V192z'
      
    ]
  };

  

  
  

  var faPlaneCircleExclamation = {
    prefix: 'fasr',
    iconName: 'plane-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e556',
      
      'M219.3 13.9C228.8 6.3 241.3 0 256 0c29.1 0 49.4 23.1 60.4 41.4C328.2 61.1 336 85.8 336 106l0 51.5 87.6 50C407 215 391.8 225 378.4 237l-78.3-44.8L288 185.4l0-13.9 0-65.5c0-9.7-4.4-26-12.8-39.8C266.1 51 258.4 48 256 48c-.6 0-2.8 .2-6.7 3.3c-3.9 3.1-8.2 8.1-12.3 14.9c-8.5 14-13 30.2-13 39.7l0 65.5 0 13.9-12.1 6.9L48 285.9l0 34.3 145.4-41.5 30.6-8.7 0 31.8 0 66.3 0 12-9.6 7.2L160 428l0 32.4 88.9-27.4 7.1-2.2 7.1 2.2 81.8 25.2c12.7 21.2 29.8 39.6 49.9 53.8L384 512l-24 0-3.6 0-3.4-1.1L256 481.1l-96.9 29.8-3.4 1.1-3.6 0-16 0-24 0 0-24 0-72 0-12 9.6-7.2L176 356l0-22.5L30.6 375.1 0 383.8 0 352l0-80 0-13.9 12.1-6.9L176 157.5l0-51.5c0-20.3 8.1-45.1 20-64.6c6.1-10 13.8-19.9 23.3-27.5zm99.3 264.8l22.2 6.3c-13.3 24.7-20.8 53-20.8 83c0 13.5 1.5 26.7 4.4 39.3l-26.8-20.1L288 380l0-12 0-66.3 0-31.8 30.6 8.7zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 16 0 80 0 16 32 0 0-16 0-80 0-16z'
      
    ]
  };

  

  
  

  var faWindow = {
    prefix: 'fasr',
    iconName: 'window',
    icon: [
      512,
      512,
      [],
      'f40e',
      
      'M0 32H512V160v48 16V432v48H464L48 480H0V432 224 208 160 32zM464 224H48l0 208 416 0 0-208zM128 96H64v64h64V96zm32 0v64h64V96H160zm160 0H256v64h64V96z'
      
    ]
  };

  

  
  

  var faFaceAstonished = {
    prefix: 'fasr',
    iconName: 'face-astonished',
    icon: [
      512,
      512,
      [],
      'e36b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 48c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V352c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 159.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H192zm141 .9c-4.3-.6-8.6-.9-13-.9H304V112h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faPipeSmoking = {
    prefix: 'fasr',
    iconName: 'pipe-smoking',
    icon: [
      640,
      512,
      [],
      'e3c4',
      
      'M501.1 0h2 11.5H616h24V48H616 528.2L413.1 238.3l8.7 6.1 19.4 13.6-13.3 19.6L318.7 438.3c-31.3 46.1-83.3 73.7-139 73.7H168C75.2 512 0 436.8 0 344V200 176H24 248h24v24 41.4l37-48.1 14-18.2 18.8 13.2 6.2 4.3L495 10.2 501.1 0zM48 224V344c0 66.3 53.7 120 120 120h11.7c39.8 0 77-19.7 99.3-52.6l95.9-141.3L333 240.8l-66 85.8L224 312V224H48z'
      
    ]
  };

  

  
  

  var faFileInvoiceDollar = {
    prefix: 'fasr',
    iconName: 'file-invoice-dollar',
    icon: [
      384,
      512,
      [],
      'f571',
      
      'M336 160H224V48H48V464H336V160zM48 0H256L384 128V464v48H336 48 0V464 48 0H48zM212 222.7v20 3.4c6.6 1.1 16.3 2.8 20.6 3.8l19.5 4.6-9.2 38.9-19.5-4.6c-3.9-.9-17.5-3.3-21.9-3.9c-6.3-.9-35.1-3.2-37.2 8c-.2 1.1-.2 1.7-.2 1.9c5.3 7.4 16 9.4 25.6 11.2c3.1 .6 6 1.1 8.6 1.8c12.1 3.2 28.1 7.5 40.1 15.3c6.6 4.3 13.2 10.3 17.4 18.9c4.3 8.9 5.2 18.7 3.3 28.7c-3.6 18.6-17.2 30.2-32.3 36c-4.6 1.8-9.6 3.1-14.7 3.9v2.7 20H172v-20-3.5c-9.3-1.9-21.4-5.6-29.2-8l0 0c-1.7-.5-3.3-1-4.5-1.4l-19.2-5.7 11.4-38.4c4.9 1.4 9.8 3.1 14.9 4.7l0 0 0 0c12.3 4 24.9 8.1 37.2 9.9c13.1 1.8 23.4 .7 29.9-1.8c6.1-2.3 7-4.9 7.3-6.2c.6-3.2-.4-4.6-3.2-6.3c-10.6-6.8-23.1-9.9-35.6-13l0 0 0 0c-12-2.9-24-5.9-34.5-12.2c-6.5-3.9-13.3-9.6-17.8-18c-4.7-8.7-5.7-18.5-3.8-28.3c3.5-18 17.5-29.3 31.8-35.1c4.8-1.9 9.9-3.4 15.2-4.4v-3.2-20h40zM96 96h80 16v32H176 96 80V96H96zm0 64h80 16v32H176 96 80V160H96z'
      
    ]
  };

  

  
  

  var faScalpelLineDashed = {
    prefix: 'fasr',
    iconName: 'scalpel-line-dashed',
    icon: [
      576,
      512,
      ["scalpel-path"],
      'f61e',
      
      'M458.8 84.9c3.4-4 5.2-9.1 5.2-14.4V66.2c0-10.1-8.2-18.2-18.2-18.2c-5.2 0-10.2 2.2-13.6 6.1L266.9 240h62.6L458.8 84.9l36.9 30.7L352 288H224.2 160l42.7-48L396.2 22.2C408.8 8.1 426.8 0 445.8 0C482.3 0 512 29.7 512 66.2v4.2c0 16.5-5.8 32.5-16.3 45.1L458.8 84.9zM0 512L176 320H288C288 496 0 512 0 512zm248-48h48 24v48H296 248 224V464h24zm128 0h48 24v48H424 376 352V464h24zm176 0h24v48H552 504 480V464h24 48z'
      
    ]
  };

  
    var faScalpelPath = faScalpelLineDashed;
  

  
  

  var faHandsBound = {
    prefix: 'fasr',
    iconName: 'hands-bound',
    icon: [
      640,
      512,
      [],
      'e4f9',
      
      'M160 0H136 40 16V24 256v9.9l7 7 79 79H96v48h24H520h24V352h-6.1l79-79 7-7V256 24 0H600 504 480V24 142.1l-31-31-17-17-17 17-95 95-95-95-17-17-17 17-31 31V24 0zM344 249.9l88-88L458.1 188l-51 51-17 17L424 289.9l17-17 80-80 7-7V176 48h48V246.1L474.2 347.8l-4.2 4.2H344v-8V249.9zM296 352H169.9l-12.2-12.2L64 246.1V48h48V176v9.9l7 7 80 80 17 17L249.9 256l-17-17-51-51L208 161.9l88 88V344v8zM96 424v48h24 8v16 24h48V488 472H296v16 24h48V488 472H464v16 24h48V488 472h8 24V424H520 120 96z'
      
    ]
  };

  

  
  

  var faClockThree = {
    prefix: 'fasr',
    iconName: 'clock-three',
    icon: [
      512,
      512,
      [],
      'e356',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256v24h24H360h24V232H360 280V120 96H232v24z'
      
    ]
  };

  

  
  

  var faSpider = {
    prefix: 'fasr',
    iconName: 'spider',
    icon: [
      512,
      512,
      [128375],
      'f717',
      
      'M0 139.9V118.7l39.2-13.1 7.6 22.8L67 189l84.2 28.1L79 145 67.7 133.6l6.2-14.8 40-96L123.1 .6l44.3 18.5-9.2 22.2-33.8 81.2L160 158.1c.6-32.8 17.8-61.6 43.3-78.4l23.3-15.3 11.7 25.3L256 128.1l17.7-38.3 11.7-25.3 23.3 15.3c25.6 16.8 42.7 45.5 43.3 78.4l35.7-35.7L353.8 41.2l-9.2-22.2L388.9 .6l9.2 22.2 40 96 6.2 14.8L433 145l-72.1 72.1L445 189l20.2-60.6 7.6-22.8L512 118.7v21.2l-1.2 3.7-24 72L483 227l-11.4 3.8L395.9 256l75.7 25.2L483 285l3.8 11.4 24 72 1.2 3.7v21.2l-39.2 13.1-7.6-22.8L445 323l-72.6-24.2c.8 3.2 1.5 6.4 2 9.7L433 367l11.4 11.4-6.2 14.8-40 96-9.2 22.2-44.3-18.5 9.2-22.2 33.8-81.2-15.5-15.5C358.8 425.8 311.9 464 256 464s-102.8-38.2-116.2-89.9l-15.5 15.5 33.8 81.2 9.2 22.2-44.3 18.5-9.2-22.2-40-96-6.2-14.8L79 367l58.6-58.6c.5-3.3 1.2-6.5 2-9.7L67 323 46.8 383.6l-7.6 22.8L0 393.3V372.1l1.2-3.7 24-72L29 285l11.4-3.8L116.1 256 40.4 230.8 29 227l-3.8-11.4-24-72L0 139.9zm210.6 4.4c-1.7 4.9-2.6 10.2-2.6 15.7v88c0 3.4 .4 6.7 1 9.9l2.5 12.1-8.4 9.1C191.2 292 184 309.1 184 328v16c0 39.8 32.2 72 72 72s72-32.2 72-72V328c0-18.9-7.2-36-19.1-48.9l-8.4-9.1 2.5-12.1c.7-3.2 1-6.5 1-9.9V160c0-5.5-.9-10.8-2.6-15.7l-15.6 33.8L279.4 192H264 248 232.6l-6.4-13.9-15.6-33.8z'
      
    ]
  };

  

  
  

  var faBracketCurlyRight = {
    prefix: 'fasr',
    iconName: 'bracket-curly-right',
    icon: [
      256,
      512,
      [],
      '7d',
      
      'M168 32h24V56 182.1l57 57 7 7v19.9l-7 7-57 57V456v24H168 56 32V432H56h88V320v-9.9l7-7 47-47-47-47-7-7V192 80H56 32V32H56 168z'
      
    ]
  };

  

  
  

  var faFileDashedLine = {
    prefix: 'fasr',
    iconName: 'file-dashed-line',
    icon: [
      640,
      512,
      ["page-break"],
      'f877',
      
      'M464 464H176V368H128v96 48h48H464h48V464 368H464v96zm0-304v96h48V128L384 0H176 128V48 256h48V48H352V160H464zM56 288H32v48H56 168h24V288H168 56zm224 0H256v48h24 80 24V288H360 280zm192 0H448v48h24H584h24V288H584 472z'
      
    ]
  };

  
    var faPageBreak = faFileDashedLine;
  

  
  

  var faArrowUpFromSquare = {
    prefix: 'fasr',
    iconName: 'arrow-up-from-square',
    icon: [
      512,
      512,
      [],
      'e09c',
      
      'M272.7 18L256 1.7 239.3 18l-112 108.8-17.2 16.7 33.4 34.4 17.2-16.7L232 92V352v24h48V352 92l71.3 69.2 17.2 16.7 33.4-34.4-17.2-16.7L272.7 18zM24 32H0V56 488v24H24 488h24V488 56 32H488 416 392V80h24 48V464H48V80H96h24V32H96 24z'
      
    ]
  };

  

  
  

  var faBinBottlesRecycle = {
    prefix: 'fasr',
    iconName: 'bin-bottles-recycle',
    icon: [
      640,
      512,
      [],
      'e5f6',
      
      'M256 0V32h16V64H256 128 112V32h16V0H256zM32 144l96-48H256l63.6 31.8L352 144h0v48h32V144 124.2l-17.7-8.8L321.8 93.1l61.8-29V0h128V64.1l64 30V136v56H592h16 32v48H608L576 512H64L32 240H0V192H32V144zM533.3 464l26.4-224H80.3l26.4 224H533.3zM304 272h32 8.6l4.7 7.2 26.3 40-27.1 17L327.4 304H312.6l-20.3 30.5-27.1-17 25.6-38.4 4.8-7.1H304zm89.3 73.9l19.3 29.3 2.6 4V384v32 16h-16H337.7V400h45.5V388.8l-17.1-25.9 27.1-17zM305.7 432H240 224V416 384v-4.8l2.7-4 20.6-31 27.1 17L256 388.8V400h49.7v32z'
      
    ]
  };

  

  
  

  var faGripLinesVertical = {
    prefix: 'fasr',
    iconName: 'grip-lines-vertical',
    icon: [
      192,
      512,
      [],
      'f7a5',
      
      'M56 32H8V480H56V32zm128 0H136V480h48V32z'
      
    ]
  };

  

  
  

  var faMobileRetro = {
    prefix: 'fasr',
    iconName: 'mobile-retro',
    icon: [
      320,
      512,
      [],
      'e527',
      
      'M272 48V464H48V48H272zM48 0H0V48 464v48H48 272h48V464 48 0H272 48zM80 128V256H240V128H80zm48-64H112V96h16 64 16V64H192 128zM72 304v48h48V304H72zm48 80H72v48h48V384zm16-80v48h48V304H136zm48 80H136v48h48V384zm16-80v48h48V304H200zm48 80H200v48h48V384z'
      
    ]
  };

  

  
  

  var faPersonRunning = {
    prefix: 'fasr',
    iconName: 'person-running',
    icon: [
      448,
      512,
      [127939,"running"],
      'f70c',
      
      'M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 112h8 64 3.2l3.1 .8 88 24 12.7 3.5 3.9 12.6L337.7 240H392h24v48H392 320 302.3l-5.2-16.9-12.5-40.8-28.1 84.4 43.4 24.4 16.9 9.5-5.8 18.5L265.6 512H215.4l43.9-140.6-88-49.5c-23.4-13.2-34.2-41.1-25.7-66.5L177.4 160H144L86.4 203.2 67.2 217.6 38.4 179.2l19.2-14.4 64-48L128 112zm97.4 55.8L191.1 270.5c-1.2 3.6 .3 7.6 3.7 9.5l19 10.7 38.5-115.6-27-7.4zM122.5 317.1c7.7 13.3 18.9 24.7 33 32.6l4.9 2.8-18 47.9L136.6 416H120 24 0V368H24h79.4l19.1-50.9z'
      
    ]
  };

  
    var faRunning = faPersonRunning;
  

  
  

  var faShuffle = {
    prefix: 'fasr',
    iconName: 'shuffle',
    icon: [
      512,
      512,
      [128256,"random"],
      'f074',
      
      'M429.8 47l57 57H488v1.3l5.8 5.8 17 17-17 17-5.8 5.8V152h-1.3l-57 57-17 17L378.9 192l17-17 23-23H332l-58 77.3-30-40 56.8-75.7L308 104h12 98.9l-23-23-17-17 33.9-33.9 17 17zM204 322.7l-56.8 75.7L140 408H128 24 0V360H24h92l58-77.3 30 40zm208.8-36.6l17 17 57 57H488v1.3l5.8 5.8 17 17-17 17-5.8 5.8V408h-1.3l-57 57-17 17L378.9 448l17-17 23-23H320 308l-7.2-9.6L116 152H24 0V104H24 128h12l7.2 9.6L332 360h86.9l-23-23-17-17 33.9-33.9z'
      
    ]
  };

  
    var faRandom = faShuffle;
  

  
  

  var faPeanuts = {
    prefix: 'fasr',
    iconName: 'peanuts',
    icon: [
      640,
      512,
      [129372],
      'e431',
      
      'M306.9 139.9c-.9-12.6-4-25.3-9.4-37.5L251.9 0 149.4 45.6c-13.9 6.2-25.9 14.8-35.7 25.2c-9.8 10.3-17.8 22.7-23.3 36.9l-.2 .4c-5.4 14.1-7.7 28.6-7.3 42.9c.2 7.8 1.2 15.7 3.1 23.5c4.2 18.4 6.4 37.9-.4 55.5s-21.4 30.6-36.8 41.5c-6.6 4.5-12.7 9.7-18 15.3c-9.9 10.4-17.9 22.8-23.4 37C2 338-.3 352.6 0 366.9c.4 14.3 3.5 28.8 9.7 42.7L55.3 512 96 493.9V364c0-48.6 18.3-92.9 52.7-127.3c26.5-26.5 59-43.2 94.7-49.8c22.9-4.6 39.5-10.9 50-21.5c5.5-5.5 9.7-13.5 13.4-25.6zM597.1 252.2C623.6 225.4 640 188.6 640 148V48 0H592 492c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364V464v48h48H276c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9zM176 464V364c0-13.6 2.7-26.5 7.6-38.3l0 0c4.9-11.7 12.1-22.8 21.7-32.4c9.7-9.7 20.7-16.9 32.5-21.7l0 0c6.4-2.7 13.2-4.7 20.2-5.9l.4-.1 .4-.1c26.6-5.3 63.2-15.3 91.3-43.4s38.2-64.7 43.4-91.3l.1-.4 .1-.4c1.3-7 3.3-13.8 5.9-20.2l0 0c4.8-11.7 12-22.6 21.5-32.2l0 0 .3-.3c9.6-9.6 20.6-16.8 32.3-21.6l0 0C465.5 50.7 478.4 48 492 48H592V148c0 27.5-11 52.3-29 70.4l0 0-.6 .6 0 0c-9.6 9.5-20.5 16.6-32.2 21.4l0 0c-6.4 2.7-13.2 4.7-20.2 5.9l-.4 .1-.4 .1c-26.6 5.3-63.2 15.3-91.3 43.4s-38.2 64.7-43.4 91.3l-.1 .4-.1 .4c-1.3 7-3.3 13.8-5.9 20.2l0 0c-4.8 11.5-11.8 22.3-21.1 31.9l0 0c-.2 .2-.5 .5-.7 .7c-.1 .1-.3 .3-.4 .4l32.7 33.2-32.7-33.2C328.1 453.1 303.4 464 276 464H176zM520 155.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-192 192a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 392a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM520 219.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 328a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z'
      
    ]
  };

  

  
  

  var faTransporter1 = {
    prefix: 'fasr',
    iconName: 'transporter-1',
    icon: [
      512,
      512,
      [],
      'e043',
      
      'M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H192.9l-7.2 9.7-83.3 112L88 268.9l38.5 28.7 14.3-19.3L192 209.6V288h48V176h32V288h48V209.6l51.1 68.7 14.3 19.3L424 268.9l-14.3-19.3-83.3-112-7.2-9.7H307.1 204.9zM480 160l-16-32-16 32-32 16 32 16 16 32 16-32 32-16-32-16zM64 352L48 320 32 352 0 368l32 16 16 32 16-32 32-16L64 352zm56 112H96v48h24H392h24V464H392 120zm56-144H160v32h16H336h16V320H336 176zm0 64H160v32h16H336h16V384H336 176z'
      
    ]
  };

  

  
  

  var faArrowUpLeft = {
    prefix: 'fasr',
    iconName: 'arrow-up-left',
    icon: [
      384,
      512,
      [],
      'e09d',
      
      'M56 96H32v24V360v24H80V360 177.9L303 401l17 17L353.9 384l-17-17-223-223H296h24V96H296 56z'
      
    ]
  };

  

  
  

  var faSquarePhoneHangup = {
    prefix: 'fasr',
    iconName: 'square-phone-hangup',
    icon: [
      448,
      512,
      ["phone-square-down"],
      'e27a',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM334.4 315.2l-67.2-18.7 5-44.2c-31.4-9.5-65.1-9.5-96.5 0l5 44.1-67.2 18.7L80 263.7l9.6-9.4c74.2-72.4 194.6-72.4 268.8 0l9.6 9.4-33.6 51.5z'
      
    ]
  };

  
    var faPhoneSquareDown = faSquarePhoneHangup;
  

  
  

  var faShieldSlash = {
    prefix: 'fasr',
    iconName: 'shield-slash',
    icon: [
      640,
      512,
      [],
      'e24b',
      
      'M496.8 363l124.1 96.3 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 77.8 60.4L308.4 4.5 320 0l11.6 4.5L539.1 85l19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9c-7.2 16.5-15.6 32.9-25.3 49zM170.4 109.5L458.6 333.3c7.4-12.6 13.9-25.5 19.5-38.5C505 232.9 512.9 169.5 512 126L320 51.5l-149.6 58zM435.5 439.1c-28.1 26.5-62 49.7-102.8 67.3L320 512l-12.7-5.5c-98.4-42.6-156.7-117.3-189.4-192.6c-23.5-54.1-34.1-109-37-154.2l53.3 42c5.2 29.5 13.9 61.5 27.7 93c28.2 64.9 77 127.7 158.1 164.8c30-13.7 55.6-31 77.3-50.5l38.2 30.1z'
      
    ]
  };

  

  
  

  var faCircleU = {
    prefix: 'fasr',
    iconName: 'circle-u',
    icon: [
      512,
      512,
      [],
      'e127',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168V144H144v24V288c0 61.9 50.1 112 112 112s112-50.1 112-112V168 144H320v24V288c0 35.3-28.7 64-64 64s-64-28.7-64-64V168z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMax = {
    prefix: 'fasr',
    iconName: 'gauge-simple-max',
    icon: [
      512,
      512,
      ["tachometer-fastest"],
      'f62b',
      
      'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 352c0-30.9 25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4 19.8-13.6 27.1 39.6-19.8 13.6L311.3 343.2c.4 2.9 .7 5.8 .7 8.8c0 30.9-25.1 56-56 56s-56-25.1-56-56z'
      
    ]
  };

  
    var faTachometerFastest = faGaugeSimpleMax;
  

  
  

  var faPlaneTail = {
    prefix: 'fasr',
    iconName: 'plane-tail',
    icon: [
      512,
      512,
      [],
      'e22c',
      
      'M-8 0L61.5 308.8 17.6 320.9 0 325.7V344v56 16.6l15.5 5.9 232 88 4.1 1.6H256 488h24V464H488 260.4L48 383.4V362.3L259.2 304H488h24V256H488 384L136 0H-8zM216 352H192v48h24H360h24V352H360 216z'
      
    ]
  };

  

  
  

  var faShapes = {
    prefix: 'fasr',
    iconName: 'shapes',
    icon: [
      512,
      512,
      ["triangle-circle-square"],
      'f61f',
      
      'M160 224h55.3H360.7 416l-27.4-48L315.6 48.4 288 0 260.4 48.4 187.4 176 160 224zM288 96.7L333.3 176H242.7L288 96.7zM128 304a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM464 320V448H336V320H464zM336 272H288v48V448v48h48H464h48V448 320 272H464 336z'
      
    ]
  };

  
    var faTriangleCircleSquare = faShapes;
  

  
  

  var faChargingStation = {
    prefix: 'fasr',
    iconName: 'charging-station',
    icon: [
      576,
      512,
      [],
      'f5e7',
      
      'M80 48V464H272V48H80zM32 464V48 0H80 272h48V48 256h8c48.6 0 88 39.4 88 88v28c0 15.5 12.5 28 28 28s28-12.5 28-28V268.3c-32.5-10.2-56-40.5-56-76.3V152 128h24 8V80 64h32V80v48h32V80 64h32V80v48h8 24v24 40c0 35.8-23.5 66.1-56 76.3V372c0 42-34 76-76 76s-76-34-76-76V344c0-22.1-17.9-40-40-40h-8V464l32 0v48H320 272 80 32 0V464l32 0zM464 192c0 17.7 14.3 32 32 32s32-14.3 32-32V176H464v16zM96 224L224 112l-22.9 80H256L128 304l22.9-80H96z'
      
    ]
  };

  

  
  

  var faMaximize = {
    prefix: 'fasr',
    iconName: 'maximize',
    icon: [
      512,
      512,
      ["expand-arrows-alt"],
      'f31e',
      
      'M72 232l33.9-33.9L135 169l87 87-87 87-29.1-29.1L72 280 38.1 313.9 32 320V432v48l48 0H192l6.1-6.1L232 440l-33.9-33.9L169 377l87-87 87 87-29.1 29.1L280 440l33.9 33.9L320 480H432l48 0V432 320l-6.1-6.1L440 280l-33.9 33.9L377 343l-87-87 87-87 29.1 29.1L440 232l33.9-33.9L480 192V80l0-48H432 320l-6.1 6.1L280 72l33.9 33.9L343 135l-87 87-87-87 29.1-29.1L232 72 198.1 38.1 192 32H80 32V80 192l6.1 6.1L72 232zm8-75.9L80 80h76.1L80 156.1zM156.1 432H80l0-76.1L156.1 432zm199.8 0L432 355.9V432H355.9zm0-352L432 80v76.1L355.9 80z'
      
    ]
  };

  
    var faExpandArrowsAlt = faMaximize;
  

  
  

  var faLightbulbGear = {
    prefix: 'fasr',
    iconName: 'lightbulb-gear',
    icon: [
      576,
      512,
      [],
      'e5fd',
      
      'M316.6 205.5c2.2-9.5 3.4-19.4 3.4-29.5c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0c96.7 0 175.1 77.9 176 174.4H340v44.6l-23.4-13.5zM251 416l21 36.3V512H112V416H251zM144 176H112c0-44.2 35.8-80 80-80v32c-26.5 0-48 21.5-48 48zm228 30.4h88.1v42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8V497H372V454.8c-8-3.4-15.6-7.7-22.5-12.9l-34.9 20.1-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9V206.4zm92.1 145.3a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z'
      
    ]
  };

  

  
  

  var faCactus = {
    prefix: 'fasr',
    iconName: 'cactus',
    icon: [
      512,
      512,
      [127797],
      'f8a7',
      
      'M304 464H208V320 224 96c0-26.5 21.5-48 48-48s48 21.5 48 48V464zM48 320H160V464v48h48 96 48V464 448H464h48V400 272 224H416v48 80H352V96c0-53-43-96-96-96s-96 43-96 96V224H96V144 96H0v48V272v48H48zM256 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSignalBarsGood = {
    prefix: 'fasr',
    iconName: 'signal-bars-good',
    icon: [
      640,
      512,
      ["signal-alt-3"],
      'f693',
      
      'M416 176V464H384V176h32zm-32-48H336v48V464v48h48 32 48V464 176 128H416 384zM256 304V464H224V304h32zm-32-48H176v48V464v48h48 32 48V464 304 256H256 224zM64 432H96v32H64V432zM16 384v48 32 48H64 96h48V464 432 384H96 64 16z'
      
    ]
  };

  
    var faSignalAlt3 = faSignalBarsGood;
  

  
  

  var faClockFourThirty = {
    prefix: 'fasr',
    iconName: 'clock-four-thirty',
    icon: [
      512,
      512,
      [],
      'e34b',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V300.8L338.7 340l20 13.3 26.6-39.9-20-13.3-96-64L232 211.2V256 392v24h48V392z'
      
    ]
  };

  

  
  

  var faArrowPointer = {
    prefix: 'fasr',
    iconName: 'arrow-pointer',
    icon: [
      320,
      512,
      ["mouse-pointer"],
      'f245',
      
      'M170.5 320H272h48l-.1-42-7-6L32 32 0 46.9V423.4 432l29 31.8 30.8-37.5 68.4-83.4 53.7 115.3L192 479.9l43.5-20.3-10.1-21.8L170.5 320zm-60.7-30.4L48 364.9V108.8L239 272H146.9 124.2l-14.4 17.6z'
      
    ]
  };

  
    var faMousePointer = faArrowPointer;
  

  
  

  var faClockSevenThirty = {
    prefix: 'fasr',
    iconName: 'clock-seven-thirty',
    icon: [
      512,
      512,
      [],
      'e351',
      
      'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V335.3l-20 30-13.3 20-39.9-26.6 13.3-20 64-96L280 256V392v24H232V392z'
      
    ]
  };

  

  
  

  var faVenusMars = {
    prefix: 'fasr',
    iconName: 'venus-mars',
    icon: [
      640,
      512,
      [9892],
      'f228',
      
      'M176 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM352 176c0 89.1-66.2 162.7-152 174.4V400h48 24v48H248 200v40 24H152V488 448H104 80V400h24 48V350.4C66.2 338.7 0 265.1 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c14.6-7.6 28.1-16.8 40.4-27.5C335.2 354.8 366 368 400 368c70.7 0 128-57.3 128-128s-57.3-128-128-128c-8.6 0-17.1 .9-25.2 2.5c-4.9-15.8-11.6-30.7-19.9-44.7C369.3 66 384.4 64 400 64c39.9 0 76.8 13.3 106.3 35.7L558.1 48H504 480V0h24H616h24V24 136v24H592V136 81.9l-51.7 51.7C562.7 163.2 576 200.1 576 240c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z'
      
    ]
  };

  

  
  

  var faBox = {
    prefix: 'fasr',
    iconName: 'box',
    icon: [
      448,
      512,
      [128230],
      'f466',
      
      'M59.6 160L95.2 80H200v80H59.6zM248 160V80H352.8l35.6 80H248zm152 48V432H48V208H400zM384 32H64L0 176V432v48H48 400h48V432 176L384 32z'
      
    ]
  };

  

  
  

  var faPageCaretDown = {
    prefix: 'fasr',
    iconName: 'page-caret-down',
    icon: [
      384,
      512,
      ["file-caret-down"],
      'e429',
      
      'M336 131.9V464H48V48H252.1L336 131.9zM384 112L272 0H48 0V48 464v48H48 336h48V464 112zM96 224v32l96 96 96-96V224H96z'
      
    ]
  };

  
    var faFileCaretDown = faPageCaretDown;
  

  
  

  var faCross = {
    prefix: 'fasr',
    iconName: 'cross',
    icon: [
      384,
      512,
      [10013,128327],
      'f654',
      
      'M136 0H112V24v88H24 0v24V248v24H24h88V488v24h24H248h24V488 272h88 24V248 136 112H360 272V24 0H248 136zm24 136V48h64v88 24h24 88v64H248 224v24V464H160V248 224H136 48V160h88 24V136z'
      
    ]
  };

  

  
  

  var faRepeat = {
    prefix: 'fasr',
    iconName: 'repeat',
    icon: [
      512,
      512,
      [128257],
      'f363',
      
      'M0 280V256 96 72H24 304V48 0h48l62.1 62.1L448 96l-33.9 33.9L352 192H304V144 120H48V256v24H0zM352 124.1L380.1 96 352 67.9v56.2zM512 232v24l0 160v24l-24 0-280 0 0 24v48H160L97.9 449.9 64 416l33.9-33.9L160 320h48v48 24l256 0 0-136V232h48zM160 444.1V387.9L131.9 416 160 444.1z'
      
    ]
  };

  

  
  

  var faDialMin = {
    prefix: 'fasr',
    iconName: 'dial-min',
    icon: [
      576,
      512,
      [],
      'e161',
      
      'M320 0H256V64h64V0zM128 64H64v64h64V64zm384 0H448v64h64V64zm0 192v64h64V256H512zm0 192H448v64h64V448zM64 448v64h64V448H64zM0 256v64H64V256H0zm271 15l-77.4 77.4c-27.8-43.4-22.8-101.7 15.1-139.6c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4c-37.9 37.9-96.2 43-139.6 15.1L305 305l17-17L288 254.1l-17 17zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1z'
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fasr',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M374.6 164L315.2 51.4 288.1 0 260.9 51.4 201.5 164 76.2 185.7l-57.3 9.9 40.5 41.7 88.7 91.2L130 454.4 121.7 512l52.2-25.7 114.2-56.1 114.2 56.1L454.4 512l-8.3-57.6L428 328.5l88.7-91.2 40.5-41.7-57.3-9.9L374.6 164zm84.8 63.4l-65.8 67.7L377.2 312l3.4 23.4L394 428.8l-84.7-41.7-21.2-10.4-21.2 10.4-84.7 41.7 13.4-93.4L199 312l-16.4-16.9-65.8-67.7 93-16.1 23.3-4 11-20.9 44.1-83.5 44.1 83.5 11 20.9 23.3 4 93 16.1z'
      
    ]
  };

  

  
  

  var faDiamondExclamation = {
    prefix: 'fasr',
    iconName: 'diamond-exclamation',
    icon: [
      512,
      512,
      [],
      'e405',
      
      'M33.9 289.9L0 256l33.9-33.9L222.1 33.9 256 0l33.9 33.9L478.1 222.1 512 256l-33.9 33.9L289.9 478.1 256 512l-33.9-33.9L33.9 289.9zM67.9 256L256 444.1 444.1 256 256 67.9 67.9 256zM232 152v-8h48v8V264v24H232V264 152zm48 216H232V320h48v48z'
      
    ]
  };

  

  
  

  var faSignalBars = {
    prefix: 'fasr',
    iconName: 'signal-bars',
    icon: [
      640,
      512,
      ["signal-alt","signal-alt-4","signal-bars-strong"],
      'f690',
      
      'M544 48V464h32V48H544zM496 0h48 32 48V48 464v48H576 544 496V464 48 0zM384 176V464h32V176H384zm-48-48h48 32 48v48V464v48H416 384 336V464 176 128zM256 304H224V464h32V304zm-32-48h32 48v48V464v48H256 224 176V464 304 256h48zM64 432v32H96V432H64zM16 384H64 96h48v48 32 48H96 64 16V464 432 384z'
      
    ]
  };

  
    var faSignalAlt = faSignalBars;
  
    var faSignalAlt4 = faSignalBars;
  
    var faSignalBarsStrong = faSignalBars;
  

  
  

  var faSprayCanSparkles = {
    prefix: 'fasr',
    iconName: 'spray-can-sparkles',
    icon: [
      512,
      512,
      ["air-freshener"],
      'f5d0',
      
      'M96 0V128H224V0H96zM224 208c26.5 0 48 21.5 48 48V464H48V256c0-26.5 21.5-48 48-48H224zM96 160c-53 0-96 43-96 96V464v48H48 272h48V464 256c0-53-43-96-96-96H96zM400 96l-16 32-32 16 32 16 16 32 16-32 32-16-32-16L400 96zM320 32L288 48l32 16 16 32 16-32 32-16L352 32 336 0 320 32zM464 0L448 32 416 48l32 16 16 32 16-32 32-16L480 32 464 0zm16 224l-16-32-16 32-32 16 32 16 16 32 16-32 32-16-32-16zM160 400a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faAirFreshener = faSprayCanSparkles;
  

  
  

  var faCommentText = {
    prefix: 'fasr',
    iconName: 'comment-text',
    icon: [
      512,
      512,
      [],
      'e14d',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM184 160H160v48h24 48V312v24h48V312 208h48 24V160H328 256 184z'
      
    ]
  };

  

  
  

  var faSunDust = {
    prefix: 'fasr',
    iconName: 'sun-dust',
    icon: [
      512,
      512,
      [],
      'f764',
      
      'M193.1 23.2L256 57.1l62.9-33.9L362 0l14.1 46.9 20.5 68.4 0 0-38.6 38.6 0 0-7.4-24.8L333 70.2 278.8 99.4 256 111.6 233.2 99.4 179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2L111.6 256 99.4 278.8 70.2 333l59 17.7 24.8 7.4 0 0-38.6 38.6 0 0L46.9 376.1 0 362l23.2-43.1L57.1 256 23.2 193.1 0 150l46.9-14.1 68.4-20.5 20.5-68.4L150 0l43.1 23.2zM256 144c30.9 0 58.9 12.5 79.2 32.8l-33.9 33.9C289.7 199.2 273.7 192 256 192c-35.3 0-64 28.7-64 64c0 17.7 7.2 33.7 18.7 45.3l-33.9 33.9C156.5 314.9 144 286.9 144 256c0-61.9 50.1-112 112-112zm192 16a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM240 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM368 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faCameraRotate = {
    prefix: 'fasr',
    iconName: 'camera-rotate',
    icon: [
      640,
      512,
      [],
      'e0d8',
      
      'M437.3 96L416 32H224L202.7 96H112 64v48V432v48h48H528h48V432 144 96H528 437.3zM528 144V432H112V144h90.7 34.6l10.9-32.8L258.6 80H381.4l10.4 31.2L402.7 144h34.6H528zM208 384l16 16 23.9-23.9c20.7 15.4 46 23.9 72.1 23.9c32 0 62.6-12.7 85.3-35.3L425 345 391 311l-19.7 19.7C357.7 344.4 339.2 352 320 352c-13.3 0-26.3-3.7-37.5-10.5L304 320l-16-16H208v80zM432 272V192l-16-16-23.9 23.9c-20.7-15.4-46-23.9-72.1-23.9c-32 0-62.6 12.7-85.3 35.3L215 231 249 265l19.7-19.7C282.3 231.6 300.8 224 320 224c13.3 0 26.3 3.7 37.5 10.5L336 256l16 16h80z'
      
    ]
  };

  

  
  

  var faUniformMartialArts = {
    prefix: 'fasr',
    iconName: 'uniform-martial-arts',
    icon: [
      640,
      512,
      [],
      'e3d1',
      
      'M117.4 0h14.2H240h14.6l6.7 13L320 127.1 378.7 13l6.7-13H400 508.4h14.2l6.8 12.4L637 208.1l3 5.4v6.2V424v24H616 520 496V424 250.5l-16-29.1V288H432V128l45-11.6 64 116.4 3 5.4v6.2V400h48V225.8L494.2 48H414.6L341.3 190.5 291.2 288h-54L293 179.6 225.4 48H145.8L48 225.8V400H96V244.3v-6.2l3-5.4 64-116.4L208 128V288H160V221.4l-16 29.1V424v24H120 24 0V424 219.7v-6.2l3-5.4L110.6 12.4 117.4 0zM432 384h48V488v24H456 184 160V488 384h48v80H432V384zM176 320H320 464h16v32H464 349.9l47.4 71.1-26.6 17.8-50.7-76-50.7 76-26.6-17.8L290.1 352H176 160V320h16z'
      
    ]
  };

  

  
  

  var faFaceWeary = {
    prefix: 'fasr',
    iconName: 'face-weary',
    icon: [
      512,
      512,
      [],
      'e3a1',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 368c-41.8 0-80.5 12.2-112 33l0-1c0-61.9 50.1-112 112-112s112 50.1 112 112l0 1c-31.5-20.8-70.2-33-112-33zM222.6 176l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 153.4 222.6 176zm78.1 11.3L289.4 176 312 153.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faEggFried = {
    prefix: 'fasr',
    iconName: 'egg-fried',
    icon: [
      512,
      512,
      [],
      'f7fc',
      
      'M403.9 162.5c-26.9-6.9-56.4-20.3-82.6-35.6s-52.4-34.3-71.6-54.3c-30.6-31.9-81.3-32.9-113.1-2.2c-14.5 14-22.6 32-24.3 50.6C107.7 173.6 92.7 244.5 63 296c-30.9 53.6-12.6 122.1 41 153s122.1 12.6 153-41c14.7-25.4 38.1-45.6 61.1-59.7c23.3-14.3 50.6-25.3 77.1-29c12.7-1.8 25.3-6.7 36.4-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.4-27.2-25.4-44.4-29.8zM284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7c27.5 7 52.8 23.2 71 47.8c42.1 56.8 30.2 137-26.6 179.1c-17.8 13.2-37.9 21.1-58.4 24c-37.2 5.2-84.5 32.7-103.3 65.2c-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM112 240a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm104-48V160c-39.8 0-72 32.2-72 72h32c0-22.1 17.9-40 40-40z'
      
    ]
  };

  

  
  

  var faCircleBookmark = {
    prefix: 'fasr',
    iconName: 'circle-bookmark',
    icon: [
      512,
      512,
      ["bookmark-circle"],
      'e100',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 384l96-64 96 64V128H160V384z'
      
    ]
  };

  
    var faBookmarkCircle = faCircleBookmark;
  

  
  

  var faBellExclamation = {
    prefix: 'fasr',
    iconName: 'bell-exclamation',
    icon: [
      448,
      512,
      [],
      'f848',
      
      'M256 0H192V51.2C119 66 64 130.6 64 208v88L0 368v48H48 400h48V368l-64-72V208c0-77.4-55-142-128-156.8V0zm80 314.2l12.1 13.6L383.8 368H64.2l35.7-40.1L112 314.2V296 208c0-61.9 50.1-112 112-112s112 50.1 112 112v88 18.2zM288 448H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM248 128H200v24 80 24h48V232 152 128zm0 168H200v48h48V296z'
      
    ]
  };

  

  
  

  var faBan = {
    prefix: 'fasr',
    iconName: 'ban',
    icon: [
      512,
      512,
      [128683,"cancel"],
      'f05e',
      
      'M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faCancel = faBan;
  

  
  

  var faScalpel = {
    prefix: 'fasr',
    iconName: 'scalpel',
    icon: [
      512,
      512,
      [],
      'f61d',
      
      'M459.1 83.6c3.2-3.6 4.9-8.3 4.9-13.1c0-10.4-7.9-19-18.2-19.8c-6.2-.5-12.3 1.9-16.5 6.6L266.9 240h55.3L459.1 83.6zm36.1 31.6L344 288H224.2 160l42.7-48L393.5 25.3C407.7 9.4 428.5 1 449.8 2.8C485 5.7 512 35.2 512 70.5c0 16.4-6 32.4-16.8 44.7zM176 320H288C288 496 0 512 0 512L176 320z'
      
    ]
  };

  

  
  

  var faPersonCircleMinus = {
    prefix: 'fasr',
    iconName: 'person-circle-minus',
    icon: [
      576,
      512,
      [],
      'e540',
      
      'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM94.8 128h14.1H211.1h14.1l6.9 12.4 64.1 115.7c-11.8 14.3-21.4 30.5-28.2 48.1l-2.5-4.6L224 224.9V488v24H176V488 352H144V488v24H96V488 224.9L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128zM144 304h32V176H144V304zm144 64a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16V352H496 368 352v32h16H496h16z'
      
    ]
  };

  

  
  

  var faCircleThreeQuartersStroke = {
    prefix: 'fasr',
    iconName: 'circle-three-quarters-stroke',
    icon: [
      512,
      512,
      [],
      'e5d4',
      
      'M460.2 296H240 216V272 51.8C120.3 70.5 48 154.8 48 256c0 114.9 93.1 208 208 208c101.2 0 185.5-72.3 204.2-168zm3.7-48C459.7 139.5 372.5 52.3 264 48.2V248H463.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faHouseFlag = {
    prefix: 'fasr',
    iconName: 'house-flag',
    icon: [
      640,
      512,
      [],
      'e50d',
      
      'M496 0H448V24v8V192 512h48V192H640V32H496V24 0zM416 133L286.3 36.7 272 26.1 257.7 36.7 19.4 213.5 .2 227.8l28.6 38.5L48 252.1l16-11.9V488v24H88 192v.6h48V512l64 0v.6h48V512l64 0V464H352V328 304H328 216 192v24V464H112V218.4 204.6L272 85.9 416 192.7V133zM304 352V464l-64 0V352h64z'
      
    ]
  };

  

  
  

  var faChartArea = {
    prefix: 'fasr',
    iconName: 'chart-area',
    icon: [
      512,
      512,
      ["area-chart"],
      'f1fe',
      
      'M48 56V32H0V56 456v24H24 488h24V432H488 48V56zm209.9 73.9L224 96l-33.9 33.9L96 224V336v48h48H432h48V336 240l-64.7-75.4L384 128l-30.1 30.1-4 4-30 30-33.9-33.9-28.1-28.1zm96 96l27.3-27.3L432 257.8V336H144V243.9l80-80 62.1 62.1L320 259.9l33.9-33.9z'
      
    ]
  };

  
    var faAreaChart = faChartArea;
  

  
  

  var faMoneyBillWave = {
    prefix: 'fasr',
    iconName: 'money-bill-wave',
    icon: [
      576,
      512,
      [],
      'f53a',
      
      'M276.1 405.2l5.6-1.4 0 0c55.2-14.1 117.5-30 182.8-28.1c4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9c-49.9-1.8-103.1 11.1-164.1 26.6l-5.6 1.4c-55.2 14.1-117.5 30-182.8 28.1C107.4 167.7 80.5 192 48 192V368c35.3 0 63.9 28.6 64 63.9c49.9 1.8 103.1-11.1 164.1-26.6zM0 60.3c16 8.2 32 14.3 48 18.7c80 22.1 160 1.7 240-18.7c96-24.5 192-48.9 288 0V398.9v52.8c-16-8.2-32-14.3-48-18.7c-80-22.1-160-1.7-240 18.7c-96 24.5-192 48.9-288 0V113.1 60.3zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z'
      
    ]
  };

  

  
  

  var faPizzaSlice = {
    prefix: 'fasr',
    iconName: 'pizza-slice',
    icon: [
      512,
      512,
      [],
      'f818',
      
      'M13.2 459.2L0 512l52.8-13.2L512 384C512 171.9 340.1 0 128 0L13.2 459.2zm407.9-102C402.2 219.1 292.9 109.8 154.8 90.9L165 50C321 67.1 444.9 191 462 347l-40.9 10.2zM374.2 369L66 446 143 137.8C264 152 360 248 374.2 369zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faTruckBolt = {
    prefix: 'fasr',
    iconName: 'truck-bolt',
    icon: [
      640,
      512,
      [],
      'e3d0',
      
      'M48 48V368H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h48V48H48zM480 512c-53 0-96-43-96-96h-8-8H320 256c0 53-43 96-96 96s-96-43-96-96H48 0V368 48 0H48 368h48V48 96h56 9.9l7 7L601 215l7 7V232 368h8 24v48H616 576c0 53-43 96-96 96zm78.1-272l-96-96H416v96H558.1zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 211.2L246.4 96l-19.2 76.8H304L169.6 288l19.2-76.8H112z'
      
    ]
  };

  

  
  

  var faSignPosts = {
    prefix: 'fasr',
    iconName: 'sign-posts',
    icon: [
      576,
      512,
      [],
      'e625',
      
      'M64 0l0 32H48 0V80 368v48H48 64l0 96h48l0-96H464l0 96h48l0-96h16 48V368 80 32H528 512l0-32H464l0 32H112l0-32H64zM528 80V368H48V80H528z'
      
    ]
  };

  

  
  

  var faMailbox = {
    prefix: 'fasr',
    iconName: 'mailbox',
    icon: [
      576,
      512,
      [128234],
      'f813',
      
      'M48 208c0-53 43-96 96-96s96 43 96 96V400H48V208zM240 448h48H528h48V400 208c0-79.5-64.5-144-144-144H144C64.5 64 0 128.5 0 208V400v48H48 240zm48-240c0-36.9-13.9-70.5-36.7-96H432c53 0 96 43 96 96V400H288V208zM104 192H80v48h24 80 24V192H184 104zm256 0H336v48h24 56v24 24h24 16 24V264 216 192H456 440 360z'
      
    ]
  };

  

  
  

  var faChartLineUp = {
    prefix: 'fasr',
    iconName: 'chart-line-up',
    icon: [
      512,
      512,
      [],
      'e0e5',
      
      'M48 56V32H0V56 456v24H24 488h24V432H488 48V56zm296 72H320v48h24 54.1L304 270.1l-79-79-17-17-17 17-80 80-17 17L128 321.9l17-17 63-63 79 79 17 17 17-17 111-111V264v24h48V264 152 128H456 344z'
      
    ]
  };

  

  
  

  var faBuildingLock = {
    prefix: 'fasr',
    iconName: 'building-lock',
    icon: [
      576,
      512,
      [],
      'e4d6',
      
      'M48 48H336V288h16V272c0-30.5 12.2-58.2 32-78.4V48 0H336 48 0V48 464v48H48 320l0-48H240V352H144V464H48V48zM88 88v80h80V88H88zm208 0H216v80h80V88zM88 216v80h80V216H88zm208 0H216v80h80V216zm168 24c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48H352V512H576V320H544V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCircleUser = {
    prefix: 'fasr',
    iconName: 'rectangle-history-circle-user',
    icon: [
      640,
      512,
      [],
      'e4a4',
      
      'M48 464l300.5 0c12.3 18.8 28 35.1 46.3 48L48 512H0V464 208 160H48l416 0h48v32.7c-5.3-.5-10.6-.7-16-.7c-26.2 0-51.1 5.7-73.4 16L48 208l0 256zM464 80v48L48 128V80l416 0zM416 0V48L96 48V0H416zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224.7 77.7L552 416H440l-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faPersonDressFairy = {
    prefix: 'fasr',
    iconName: 'person-dress-fairy',
    icon: [
      640,
      512,
      [],
      'e607',
      
      'M384 64A64 64 0 1 0 256 64a64 64 0 1 0 128 0zM292.2 208h55.6l36.6 128H255.6l36.6-128zM384 160H256L205.7 336 192 384h49.9H256V488v24h48V488 384h32V488v24h48V488 384h14.1H448l-13.7-48L384 160zM34.9 32H24 0V56v56c0 86.7 40.6 163.9 103.7 213.7C78.7 360 64 402.3 64 448v8 24H88h24c41.2 0 79.7-12 112-32.7V416H181.8c-20.9 10.2-44.3 15.9-69.1 16c2.9-29 13.5-55.7 29.7-78l13.6-18.7 13.6-18.7-18.1-14.3L133.4 288C81.3 246.9 48 183.4 48 112V80.4c69.6 3.8 131.2 37.6 172.1 88.7l15.5-54.4C184.1 63.6 113.2 32 34.9 32zM527.2 432c-24.7-.1-48.2-5.8-69.1-16H416v31.3C448.3 468 486.8 480 528 480h24 24V456v-8c0-45.7-14.7-88-39.7-122.3C599.4 275.9 640 198.7 640 112V56 32H616 605.1c-78.3 0-149.3 31.6-200.8 82.7l15.5 54.4C460.8 118 522.4 84.2 592 80.4V112c0 71.4-33.3 134.9-85.4 176l-18.1 14.3-18.1 14.3 13.6 18.7L497.5 354c16.3 22.3 26.9 49 29.7 78z'
      
    ]
  };

  

  
  

  var faTabletButton = {
    prefix: 'fasr',
    iconName: 'tablet-button',
    icon: [
      448,
      512,
      [],
      'f10a',
      
      'M48 48V464H400V48H48zM0 0H48 400h48V48 464v48H400 48 0V464 48 0zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faC = {
    prefix: 'fasr',
    iconName: 'c',
    icon: [
      384,
      512,
      [99],
      '43',
      
      'M343.5 131.7C275.8 63 166 63 98.3 131.7s-67.7 180 0 248.7s177.5 68.7 245.2 0l33.7 34.2c-86.3 87.5-226.3 87.5-312.6 0s-86.3-229.5 0-317s226.3-87.5 312.6 0l-33.7 34.2z'
      
    ]
  };

  

  
  

  var faLocationArrow = {
    prefix: 'fasr',
    iconName: 'location-arrow',
    icon: [
      448,
      512,
      [],
      'f124',
      
      'M272 208v48 85.8l78.7-212.5L138.2 208H224h48zM0 208L372.7 70 432 48l-22 59.3L272 480H224V432 304 256H176 48 0V208z'
      
    ]
  };

  

  
  

  var faMessagePlus = {
    prefix: 'fasr',
    iconName: 'message-plus',
    icon: [
      512,
      512,
      ["comment-alt-plus"],
      'f4a8',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM232 320h48V296 232h64 24V184H344 280V120 96H232v24 64H168 144v48h24 64v64 24z'
      
    ]
  };

  
    var faCommentAltPlus = faMessagePlus;
  

  
  

  var faFaceSmileTear = {
    prefix: 'fasr',
    iconName: 'face-smile-tear',
    icon: [
      512,
      512,
      [],
      'e393',
      
      'M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c29.4 0 57.4-6.1 82.7-17.1c4.3 .7 8.8 1.1 13.3 1.1c43.4 0 80-34.6 80-79c0-.7 0-1.4 0-2c20.3-32.1 32-70.2 32-111zM280 408H256c-58 0-98.8-29.4-122.1-56.3l-15.7-18.1 36.3-31.4 15.7 18.1C187 339.8 215.5 360 256 360h16.7c-.5 2.9-.7 6-.7 9c0 12.5 2.9 24.2 8 34.5V408zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm352 32l38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8L352 288zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faRoadBridge = {
    prefix: 'fasr',
    iconName: 'road-bridge',
    icon: [
      640,
      512,
      [],
      'e563',
      
      'M320 48V0h48H592h48V48 464v48H592 368 320V464 48zM504 464h88V48H504v56 24H456V104 48H368V464h88V408 384h48v24 56zm0-272v24 80 24H456V296 216 192h48zM24 96H288v48H248v64h40v48H224 96 24 0V208H24 72V144H24 0V96H24zM272 304h16v48H272c-30.9 0-56 25.1-56 56v80 24H192 96 72V488 400c0-26.5-21.5-48-48-48H0V304H24c53 0 96 43 96 96v64h48V408c0-57.4 46.6-104 104-104zM200 144H120v64h80V144z'
      
    ]
  };

  

  
  

  var faCalendarPen = {
    prefix: 'fasr',
    iconName: 'calendar-pen',
    icon: [
      448,
      512,
      ["calendar-edit"],
      'f333',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48V464v48H400 48 0V464 192 144 64H104V24 0h48zM400 192H48V464H400V192zM192 424l-64 8 8-64 88.7-88.7 56 56L192 424zM303.3 312.7l-56-56L280 224l56 56-32.7 32.7z'
      
    ]
  };

  
    var faCalendarEdit = faCalendarPen;
  

  
  

  var faFolderImage = {
    prefix: 'fasr',
    iconName: 'folder-image',
    icon: [
      512,
      512,
      [],
      'e18a',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zM128 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 384V352l88-96 37.7 41.1L296 208 416 352v32H272 176 96z'
      
    ]
  };

  

  
  

  var faPersonHalfDress = {
    prefix: 'fasr',
    iconName: 'person-half-dress',
    icon: [
      320,
      512,
      [],
      'e548',
      
      'M154.3 .3a48 48 0 1 1 11.3 95.3A48 48 0 1 1 154.3 .3zM176 128h35.1 14.1l6.9 12.4 75.3 136 11.6 21-42 23.3-11.6-21L224 224.9V488v24H176V488 352h0V304h0V176h0V128zm-81.2 0h14.1H128h16V237.7L113.3 336H144v48h0V488v24H96V488 384H48l15-48 37-118.3L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128z'
      
    ]
  };

  

  
  

  var faFileChartColumn = {
    prefix: 'fasr',
    iconName: 'file-chart-column',
    icon: [
      384,
      512,
      ["file-chart-line"],
      'f659',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM216 280V256H168v24V408v24h48V408 280zm88 32V288H256v24 96 24h48V408 312zM128 344V320H80v24 64 24h48V408 344z'
      
    ]
  };

  
    var faFileChartLine = faFileChartColumn;
  

  
  

  var faSynagogue = {
    prefix: 'fasr',
    iconName: 'synagogue',
    icon: [
      640,
      512,
      [128333],
      'f69b',
      
      'M192 288V464h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v80h64V288 166.7L320 62 192 166.7V288zm-48-48V144L320 0 496 144v96l14.1-14.1L544 192l33.9 33.9L640 288V464v48H592 496 448 192 144 48 0V464 288l62.1-62.1L96 192l33.9 33.9L144 240zm0 67.9l-48-48-48 48V464h96V307.9zm352 0V464h96V307.9l-48-48-48 48zM341.3 155.1H384L362.7 192 384 228.9H341.3L320 265.9l-21.3-36.9H256L277.4 192 256 155.1h42.7L320 118.1l21.3 36.9z'
      
    ]
  };

  

  
  

  var faGlobe = {
    prefix: 'fasr',
    iconName: 'globe',
    icon: [
      512,
      512,
      [127760],
      'f0ac',
      
      'M197.1 455.5c-54.6-16.1-99.8-54-125.6-103.5h70.7c13.4 43.5 34.5 77.9 54.9 103.5zm33.2-35.5c-13.6-18-27.3-40.6-37.5-68.1H319.2c-10.2 27.4-23.8 50-37.5 68.1c-8.9 11.8-17.8 21.6-25.7 29.4c-7.9-7.8-16.8-17.6-25.7-29.4zM176 256c0-17.1 1.4-33 4-48H332c2.5 15 4 30.9 4 48s-1.4 33-4 48H180c-2.5-15-4-30.9-4-48zm-44.6-48c-2.2 15.1-3.4 31.1-3.4 48s1.2 32.9 3.4 48H53.6c-3.6-15.4-5.6-31.5-5.6-48s1.9-32.6 5.6-48h77.8zm61.4-48c10.2-27.4 23.8-50 37.5-68.1c8.9-11.8 17.8-21.6 25.7-29.4c7.9 7.8 16.8 17.6 25.7 29.4c13.6 18 27.3 40.6 37.5 68.1H192.8zm187.8 48h77.8c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48H380.6c2.2-15.1 3.4-31.1 3.4-48s-1.2-32.9-3.4-48zm60-48H369.8c-13.4-43.5-34.5-77.9-54.9-103.5c54.6 16.1 99.8 54 125.6 103.5zm-298.4 0H71.4c25.8-49.6 71.1-87.4 125.6-103.5c-20.4 25.6-41.5 60-54.9 103.5zM314.9 455.5c20.4-25.6 41.5-60 54.9-103.5h70.7c-25.8 49.6-71.1 87.4-125.6 103.5zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faPersonDolly = {
    prefix: 'fasr',
    iconName: 'person-dolly',
    icon: [
      512,
      512,
      [],
      'f4d0',
      
      'M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM0 340.3c.5 .4 1.1 .9 1.6 1.3L48 378.1 48 488l0 24L0 512l0-24L0 340.3zM0 128H24 88h13.1l7.1 11 64.9 101h38.2l-10.5-42.2-5.8-23.3 46.6-11.6 5.8 23.3 49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6 23.3-5.8 11.6 46.6-23.3 5.8L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L223.3 288H160 146.9l-7.1-11L120 246.2V328v4.9l30.8 24.2 7.6 5.9 1.4 9.5L179.7 512H131.2L113.6 388.9 21.4 316.5C7.9 305.9 0 289.6 0 272.4V152 128zM72 295.2V184v-8H48v96.4c0 2.5 1.1 4.8 3.1 6.3L72 295.2zM288 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm38.4-80L288 230.4 441.6 192 480 345.6 326.4 384z'
      
    ]
  };

  

  
  

  var faLocationCrosshairsSlash = {
    prefix: 'fasr',
    iconName: 'location-crosshairs-slash',
    icon: [
      640,
      512,
      ["location-slash"],
      'f603',
      
      'M485.2 353.9c13.2-22.2 22-47.2 25.3-73.9H552h24V232H552 510.5C499.7 145.2 430.8 76.3 344 65.5V24 0H296V24 65.5c-43.4 5.4-82.4 25.3-111.8 54.8L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L485.2 353.9zm-38.3-29.8l-38.7-30.1c5.1-11.7 7.9-24.6 7.9-38.1c0-53-43-96-96-96c-22.1 0-42.5 7.5-58.7 20.1L222.5 150c25.6-23.6 59.9-38 97.5-38c79.5 0 144 64.5 144 144c0 24.7-6.2 47.9-17.1 68.2zm-145-112.6c5.6-2.3 11.7-3.6 18.2-3.6c26.5 0 48 21.5 48 48c0 2.2-.2 4.4-.4 6.6l-65.7-51zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2l-41.9-33c-2.7 9.5-4.7 19.2-6 29.3H88 64v48H88h41.5c10.8 86.8 79.7 155.7 166.5 166.5V488v24h48V488 446.5c25.5-3.2 49.5-11.4 70.9-23.6l-41.9-33z'
      
    ]
  };

  
    var faLocationSlash = faLocationCrosshairsSlash;
  

  
  

  var faSteak = {
    prefix: 'fasr',
    iconName: 'steak',
    icon: [
      576,
      512,
      [129385],
      'f824',
      
      'M301.5 72.6c-15.9 14.8-25.5 34.1-32.8 50.6c-4.2 9.6-7.7 18-10.9 25.7l-1.3 3.2c-9.3 22.5-18.4 44.6-39.1 65.3c-26.6 26.6-56.8 42.7-81.6 55.3c-2.8 1.4-5.5 2.8-8.1 4.1l0 0c-22.4 11.4-39.6 20.1-55.1 32.5C57.7 321.2 48 337.8 48 360V464H240c70.2 0 140.7-26.7 194-66.3c52.5-39.1 94-95.4 94-157.7c0-48.1-19-95-47-130c-27.6-34.5-67.9-62-113-62c-27.4 0-49.4 8.6-66.5 24.6zM240 512H48 0V464 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512zm65.6-352.5c2.5-6 4.8-11.8 7.1-17c6.9-15.7 13.3-27.1 21.5-34.7c7.5-7 17.5-11.7 33.9-11.7c25.4 0 53.3 16.2 75.5 44c22 27.5 36.5 64.1 36.5 100c0 40.8-28.3 84.6-74.7 119.2C359.4 393.4 298.6 416 240 416H96V360c0-9 2.6-13.2 6.9-16.9c5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8c28.6-28.6 42.9-63.7 54.3-91.9zM416 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faBullhorn = {
    prefix: 'fasr',
    iconName: 'bullhorn',
    icon: [
      512,
      512,
      [128226,128363],
      'f0a1',
      
      'M438.1 0H448h8 24V24 179.6c18.6 8.8 32 32.5 32 60.4s-13.4 51.6-32 60.4V456v24H456h-8-9.9l-7-7-43.6-43.6c-47.8-47.8-112-75.4-179.4-77.2V464v48H160 112 64V464 352H48 0V304 176 128H48 160h40.7c70 0 137.2-27.8 186.7-77.3L431 7l7-7zM421.3 395.4L432 406.1V73.9L421.3 84.6C364.5 141.4 288.1 174 208 175.9v.1V304v0 .1c80.1 1.9 156.5 34.5 213.3 91.3zM48 176V304H64v0h48 48V176H48zm64 176V464h48V352H112z'
      
    ]
  };

  

  
  

  var faBoxCheck = {
    prefix: 'fasr',
    iconName: 'box-check',
    icon: [
      448,
      512,
      [],
      'f467',
      
      'M200 160V80H95.2L59.6 160H200zm188.4 0L352.8 80H248v80H388.4zM48 208V432H400V208H48zM64 32H384l64 144V432v48H400 48 0V432 176L64 32zM337 265L209 393l-17 17-17-17-64-64-17-17L128 278.1l17 17 47 47L303 231l17-17L353.9 248l-17 17z'
      
    ]
  };

  

  
  

  var faTamale = {
    prefix: 'fasr',
    iconName: 'tamale',
    icon: [
      320,
      512,
      [129748],
      'e451',
      
      'M320 48L295.4 208H246.8L268 70.5c-1.9-1-3.9-2-6.1-3c-4.8-2.2-10.4-4.5-16.9-6.7L229.2 208H197.1L213.7 52.7c-11.1-2.1-23.7-3.6-37.7-4.3V208H160 144V48.4c-14 .7-26.6 2.2-37.7 4.3L122.9 208H90.8L75 60.8c-6.4 2.2-12.1 4.5-16.9 6.7c-2.2 1-4.2 2-6.1 3L73.2 208H24.6L0 48S48 0 160 0S320 48 320 48zM256 304h39.4L320 464s-48 48-160 48S0 464 0 464L24.6 304H64L44.8 329.6 66.7 346 52 441.4c1.9 1 3.9 2 6.1 3c4.8 2.2 10.4 4.5 16.9 6.7l9.8-91.6 29.8 22.3-8.3 77.4c11.1 2.1 23.7 3.6 37.7 4.3V357.3l6.4-8.5L160 336l9.6 12.8 6.4 8.5V463.6c14-.7 26.6-2.2 37.7-4.3l-8.3-77.4 29.8-22.3 9.8 91.6c6.4-2.2 12.1-4.5 16.9-6.7c2.2-1 4.2-2 6.1-3L253.3 346l21.9-16.4L256 304zM24 240H160 296h16v32H296 192l28.8 38.4 9.6 12.8-25.6 19.2-9.6-12.8L160 282.7l-35.2 46.9-9.6 12.8L89.6 323.2l9.6-12.8L128 272H24 8V240H24z'
      
    ]
  };

  

  
  

  var faHatSanta = {
    prefix: 'fasr',
    iconName: 'hat-santa',
    icon: [
      640,
      512,
      [],
      'f7a7',
      
      'M442 207.8l25.6 7 .2-.3-2.6-19.4-4.4-32.5 30.8-3.4L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8L64 352h51.7l78.6-196.4C212.5 109.9 256.8 80 305.9 80c35.4 0 69 15.6 91.8 42.6L423.5 153l-26.9-7.3-23.8-6.5-44 44 10.6 26.6L396.3 352H448L406.3 247.8 384 192l58 15.8zm108.2-47.2L530 187.1l-33.1 3.7 4.5 33-20.8 26L507.1 270l3.7 33.1 33-4.5 26 20.8L590 292.9l33.1-3.7-4.5-33 20.8-26L612.9 210l-3.7-33.1-33 4.5-26-20.8zM0 384v96H48 464h48V384H464 48 0z'
      
    ]
  };

  

  
  

  var faArrowLeftToBracket = {
    prefix: 'fasr',
    iconName: 'arrow-left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e669',
      
      'M168 80L48 80l0 352 120 0 24 0 0 48-24 0L24 480 0 480l0-24L0 56 0 32l24 0 144 0 24 0 0 48-24 0zm-1 193l-17-17 17-17L295 111l17-17L345.9 128l-17 17-87 87L488 232l24 0 0 48-24 0-246.1 0 87 87 17 17L312 417.9l-17-17L167 273z'
      
    ]
  };

  

  
  

  var faKey = {
    prefix: 'fasr',
    iconName: 'key',
    icon: [
      512,
      512,
      [128273],
      'f084',
      
      'M315.7 302.4l-24.2-3.8-17.3 17.3L254.1 336H224 176v48 16H160 112v48 16H48V385.9L196.1 237.8l17.3-17.3-3.8-24.2c-1-6.6-1.6-13.4-1.6-20.3c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128c-6.9 0-13.7-.5-20.3-1.6zM272 384h1.9l7-7 27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 9.5 .7 18.8 2.2 27.9L7 359l-7 7V376v88 24 24H24 48h64 24 24V496v-8V464 448h16 24 8 16V432v-8V400 384h40 8zm96-208a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faWavePulse = {
    prefix: 'fasr',
    iconName: 'wave-pulse',
    icon: [
      640,
      512,
      ["heart-rate"],
      'f5f8',
      
      'M291.8 0H312h16 19.3l4.1 18.9 69.2 318.2 37.2-90.3 6.1-14.9H480 616h24v48H616 496.1L446.2 401.1 440.1 416H424 408 388.7l-4.1-18.9L321.8 108.4 255.7 492.1 252.2 512H232 216 197.1l-4.4-18.4L141.1 280H24 0V232H24 160h18.9l4.4 18.4 38.1 157.8L288.3 19.9 291.8 0z'
      
    ]
  };

  
    var faHeartRate = faWavePulse;
  

  
  

  var faHighlighter = {
    prefix: 'fasr',
    iconName: 'highlighter',
    icon: [
      576,
      512,
      [],
      'f591',
      
      'M184 315.9l-14.1 14.1L131.9 368 184 420.1l38.1-38.1L236.1 368H256h47.4l16.2-22.5-113-113L184 248.6V296v19.9zm62-111.8L347.9 306 489.2 109.1 442.9 62.8 246 204.1zM136 224L448 0 552 104 328 416H256l-38.1 38.1-33.7 33.7-.2 .2-.3-.3L169 473l-32 32-7 7H120 24 0V488 472v-9.9l7-7 72-72L64 368l72-72V224zM113 417l-47 47h44.1l25-25L113 417z'
      
    ]
  };

  

  
  

  var faSquareCaretLeft = {
    prefix: 'fasr',
    iconName: 'square-caret-left',
    icon: [
      448,
      512,
      ["caret-square-left"],
      'f191',
      
      'M48 432l352 0 0-352L48 80l0 352zM0 480l0-48L0 80 0 32l48 0 352 0 48 0 0 48 0 352 0 48-48 0L48 480 0 480zm256-96L128 256 256 128l32 0 0 256-32 0z'
      
    ]
  };

  
    var faCaretSquareLeft = faSquareCaretLeft;
  

  
  

  var faLightSwitch = {
    prefix: 'fasr',
    iconName: 'light-switch',
    icon: [
      384,
      512,
      [],
      'e017',
      
      'M168 64V48H48V464H168V448h48v16H336V48H216V64H168zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM144 368h96V280H144v88zm0-136h96V144H144v88zM96 96h48 96 48v48V368v48H240 144 96V368 144 96z'
      
    ]
  };

  

  
  

  var faBuildingUser = {
    prefix: 'fasr',
    iconName: 'building-user',
    icon: [
      640,
      512,
      [],
      'e4da',
      
      'M48 48V464h96V352h96V464h96V48H48zM0 0H48 336h48V48 359L317.1 512H48 0V464 48 0zM88 88h80v80H88V88zm208 0v80H216V88h80zM88 216h80v80H88V216zm208 0v80H216V216h80zm120 56a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM584 384l56 128H352l56-128H584z'
      
    ]
  };

  

  
  

  var faVanShuttle = {
    prefix: 'fasr',
    iconName: 'van-shuttle',
    icon: [
      640,
      512,
      [128656,"shuttle-van"],
      'f5b6',
      
      'M24 32H0V56 360v24H24 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h40 24V360 216v-8.8l-5.7-6.7-136-160L491.1 32H480 360 200 24zM480 288c-35.5 0-66.6 19.3-83.2 48H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H48V240H200 360 592v96H563.2c-16.6-28.7-47.6-48-83.2-48zM48 192V80H176V192H48zm176 0V80H336V192H224zm160 0V80h84.9l95.2 112H384zm48 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faShuttleVan = faVanShuttle;
  

  
  

  var faDumpster = {
    prefix: 'fasr',
    iconName: 'dumpster',
    icon: [
      576,
      512,
      [],
      'f793',
      
      'M32 32L0 160H114.9L140.5 32H32zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0H576L544 32H435.5l25.6 128zM86.4 240H489.6l-20 160H106.4l-20-160zM42 272L64 448v8 24h48V456v-8H464v8 24h48V456v-8l22-176h18 24V224H552 540l4-32H495.6 80.4 32l4 32H24 0v48H24 42z'
      
    ]
  };

  

  
  

  var faArrowDownToArc = {
    prefix: 'fasr',
    iconName: 'arrow-down-to-arc',
    icon: [
      512,
      512,
      [],
      'e4ae',
      
      'M377.6 232.3l-104 112L256 363.3l-17.6-18.9-104-112-16.3-17.6 35.2-32.7 16.3 17.6L232 266.9V24 0h48V24 266.9l62.4-67.2 16.3-17.6 35.2 32.7-16.3 17.6zM256 464c114.9 0 208-93.1 208-208V232h48v24c0 141.4-114.6 256-256 256S0 397.4 0 256H48c0 114.9 93.1 208 208 208z'
      
    ]
  };

  

  
  

  var faLightEmergency = {
    prefix: 'fasr',
    iconName: 'light-emergency',
    icon: [
      448,
      512,
      [],
      'e41f',
      
      'M352 304V208c0-70.7-57.3-128-128-128S96 137.3 96 208v96H48V208c0-97.2 78.8-176 176-176s176 78.8 176 176v96H352zM48 384v48H400V384H48zm0-48H400h48v48 48 48H400 48 0V432 384 336H48zM160 208H128c0-53 43-96 96-96v32c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faToiletPaperUnder = {
    prefix: 'fasr',
    iconName: 'toilet-paper-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse"],
      'e2a0',
      
      'M48 192c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3H324.7c-3-4.5-5.7-9.3-8.2-14.1C298.5 287.4 288 241.5 288 192s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H112c-10.9 0-26.6 8.9-41 36.3C57.2 110.7 48 148.7 48 192zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 464V351.1c-16.6 19.3-38.1 32.9-64 32.9H112c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0H400c37.7 0 66 28.7 83.5 62.1C501.5 96.6 512 142.5 512 192V488v24H488 184 160V488 416h48v48H464zM400 240c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48zM112 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faToiletPaperReverse = faToiletPaperUnder;
  

  
  

  var faSchoolCircleCheck = {
    prefix: 'fasr',
    iconName: 'school-circle-check',
    icon: [
      640,
      512,
      [],
      'e56b',
      
      'M466.7 144l-11.4-6.8L320 56 184.7 137.2 173.3 144H160 48V464H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-4.3 15.2-6.5 31.1-6.5 47.7c0 59.5 29.6 112.2 74.8 144H48 0V464 144 96H48 160L320 0 480 96H592h48v48V266.8c-12.9-18.3-29.2-34.1-48-46.3V144H480 466.7zm-74 81.5c-15 10.9-28.2 24.1-39.1 39.1C343.3 269.4 332 272 320 272c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 12-2.6 23.3-7.3 33.5zM160 192v96H96V192h64zM96 320h64v96H96V320zM336 160V144H304v16 32 16h16 24 16V176H344h-8V160zm16 208a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faComma = {
    prefix: 'fasr',
    iconName: 'comma',
    icon: [
      192,
      512,
      [],
      '2c',
      
      'M112 362.9L66.8 439.8 81.6 336H112v26.9zM40 288L14.9 464 8 512H56.5 80l80-136V336 288H112 40z'
      
    ]
  };

  

  
  

  var faSensor = {
    prefix: 'fasr',
    iconName: 'sensor',
    icon: [
      448,
      512,
      [],
      'e028',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM144 152V264v24H96V264 152 128h48v24zm96 0V264v24H192V264 152 128h48v24z'
      
    ]
  };

  

  
  

  var faUser = {
    prefix: 'fasr',
    iconName: 'user',
    icon: [
      448,
      512,
      [62144,128100],
      'f007',
      
      'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM65 464H383L348.5 352H99.5L65 464zM64 304H384l49.2 160L448 512H397.8 50.2 0l14.8-48L64 304z'
      
    ]
  };

  

  
  

  var faRotateReverse = {
    prefix: 'fasr',
    iconName: 'rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e631',
      
      'M418 187.1C391.2 124.1 328.7 80 256 80c-39.7 0-77.8 15.8-105.9 43.9L145 129l21.1 21.1L200 184l-33.9 33.9L160 224H64 16V176 80l6.1-6.1L56 40 89.9 73.9 111 95l5.1-5.1C153.2 52.8 203.5 32 256 32c92.6 0 172.1 56.2 206.2 136.3L418 187.1zM94.1 325.2C121 388.1 183.4 432 256 432c39.7 0 77.8-15.8 105.9-43.9L367 383l-21.1-21.1L312 328l33.9-33.9L352 288h96 48v48 96l-6.1 6.1L456 472l-33.9-33.9L401 417l-5.1 5.1C358.8 459.2 308.5 480 256 480c-92.5 0-171.8-56-206-135.9l44.1-18.9zm30-149.2L64 115.9V176h60.1zM387.9 336L448 396.1V336H387.9z'
      
    ]
  };

  

  
  

  var faBadgePercent = {
    prefix: 'fasr',
    iconName: 'badge-percent',
    icon: [
      512,
      512,
      [],
      'f646',
      
      'M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5L321 99.1l19-5.8c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1l-5.8 19 17.5 9.3c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7L412.9 321l5.8 19c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7l-19-5.8-9.3 17.5c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5L191 412.9l-19 5.8c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340l5.8-19-17.5-9.3C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7L99.1 191l-5.8-19c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2l19 5.8 9.3-17.5zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209l17-17L320 158.1l-17 17L175 303l-17 17L192 353.9l17-17L337 209z'
      
    ]
  };

  

  
  

  var faBridgeCircleExclamation = {
    prefix: 'fasr',
    iconName: 'bridge-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ca',
      
      'M56 32H32V80H56h48v64H56 32v48H56h48 48 80 48H496h88 24V144H584 536V80h40 24V32H576 56zM338 290.3c7.4-15 16.9-28.9 28.1-41.1c-14.2-5.9-29.8-9.2-46.1-9.2c-66.3 0-120 53.7-120 120v72H152V336c0-53-43-96-96-96H32v48H56c26.5 0 48 21.5 48 48V456v24h24 96 24V456 360c0-39.8 32.2-72 72-72c6.2 0 12.3 .8 18 2.3zM488 80v64H408V80h80zM360 80v64H280V80h80zM232 80v64H152V80h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-240v16 80 16H480V368 288 272h32zm0 176H480V416h32v32z'
      
    ]
  };

  

  
  

  var faPenClip = {
    prefix: 'fasr',
    iconName: 'pen-clip',
    icon: [
      512,
      512,
      ["pen-alt"],
      'f305',
      
      'M10.2 461L0 512l51-10.2L160 480 399 241l0 0L433 207l0 0 45.1-45.1L512 128 478.1 94.1 448.4 64.4 448 64l-.4-.4L417.9 33.9 384 0 350.1 33.9 305 79 257 31l-17-17L223 31 103 151l-17 17L120 201.9l17-17 103-103 31 31L32 352 10.2 461zM305 146.9L365.1 207 136.3 435.8l-75.1 15 15-75.1L305 146.9z'
      
    ]
  };

  
    var faPenAlt = faPenClip;
  

  
  

  var faH3 = {
    prefix: 'fasr',
    iconName: 'h3',
    icon: [
      640,
      512,
      [],
      'f315',
      
      'M48 88V64H0V88 248 424v24H48V424 272H272V424v24h48V424 248 88 64H272V88 224H48V88zM600 64H400 376v48h24H542.1L423 231l-7 7V272h24 88c35.3 0 64 28.7 64 64s-28.7 64-64 64H457.4c-16.1 0-29.8-12-31.8-28L423.8 357l-47.6 6 1.9 14.9c5 40 39 70.1 79.4 70.1H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H497.9L617 105l7-7V64H600z'
      
    ]
  };

  

  
  

  var faBowlChopsticksNoodles = {
    prefix: 'fasr',
    iconName: 'bowl-chopsticks-noodles',
    icon: [
      512,
      512,
      [],
      'e2ea',
      
      'M0 128V96L128 72V56 32h48V56v7 37.5 38V176v48h32V176 137.5v-42V57 40 16h48V40v8V88v48 40 48h32H463.9 512l-2.8 48-.8 13.2C503.5 368.1 454 438.2 384 472.9V512H336 176 128V472.9C58 438.2 8.5 368.1 3.6 285.2L2.8 272 0 224H48.1 128V176H0V144l128-4V108L0 128zM288 83V42L512 0V48L288 83zm0 52l224-7v48H288V135zM176 464H336V443.1l26.7-13.2c55.1-27.3 93.9-82.4 97.8-147.5l.6-10.3H50.9l.6 10.3c3.8 65.1 42.7 120.3 97.8 147.5L176 443.1V464z'
      
    ]
  };

  

  
  

  var faPizza = {
    prefix: 'fasr',
    iconName: 'pizza',
    icon: [
      576,
      512,
      [127829],
      'f817',
      
      'M289.9 222.1L403.1 108.9 437 75c-11.4-11.4-23.8-21.7-37.1-30.7C358.9 16.3 309.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c53.3 0 102.9-16.3 143.9-44.2c13.3-9.1 25.8-19.4 37.1-30.7l-33.9-33.9L289.9 289.9 256 256l33.9-33.9zm-35.7 100c-8.4 3.8-14.2 12.2-14.2 21.9c0 13.3 10.7 24 24 24c9.8 0 18.2-5.8 21.9-14.2L318.1 386c-18.8 9-39.8 14-62.1 14c-79.5 0-144-64.5-144-144s64.5-144 144-144c22.2 0 43.3 5 62.1 14l-96 96L188.1 256l33.9 33.9 32.1 32.1zm87.6 87.6l23.4 23.4C333.5 452.7 296.1 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c40.1 0 77.5 11.3 109.2 30.9l-23.4 23.4C316.4 88.1 287.1 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c31.1 0 60.4-8.1 85.8-22.3zm155.3-44.5l-23.4-23.4C487.9 316.4 496 287.1 496 256s-8.1-60.4-22.3-85.8l23.4-23.4C516.7 178.5 528 215.9 528 256s-11.3 77.5-30.9 109.2zM464 256c0 22.2-5 43.3-14 62.1L387.9 256 450 193.9c9 18.8 14 39.8 14 62.1zm67.8 143.9c27.9-41 44.2-90.5 44.2-143.9s-16.3-102.9-44.2-143.9C522.7 98.8 512.4 86.3 501 75l-33.9 33.9L353.9 222.1 320 256l33.9 33.9L467.1 403.1 501 437c11.4-11.4 21.7-23.8 30.7-37.1zM216 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faE = {
    prefix: 'fasr',
    iconName: 'e',
    icon: [
      320,
      512,
      [101],
      '45',
      
      'M24 32H0V56 256 456v24H24 296h24V432H296 48V272H232h24V224H232 48V80H296h24V32H296 24z'
      
    ]
  };

  

  
  

  var faLambda = {
    prefix: 'fasr',
    iconName: 'lambda',
    icon: [
      448,
      512,
      [],
      'f66e',
      
      'M24 32H0V80H24 137.4l12.7 24.3L3.1 480H54.6L179.5 160.9 338.7 467.1l6.7 12.9H360h64 24V432H424 374.6L173.3 44.9 166.6 32H152 24z'
      
    ]
  };

  

  
  

  var faWandMagicSparkles = {
    prefix: 'fasr',
    iconName: 'wand-magic-sparkles',
    icon: [
      576,
      512,
      ["magic-wand-sparkles"],
      'e2ca',
      
      'M234.7 42.7L256 0l21.3 42.7L320 64 277.3 85.3 256 128 234.7 85.3 192 64l42.7-21.3zM64 96L96 32l32 64 64 32-64 32L96 224 64 160 0 128 64 96zM448 288l32 64 64 32-64 32-32 64-32-64-64-32 64-32 32-64zM177.9 478.1L144 512l-33.9-33.9L65.9 433.9 32 400l33.9-33.9L398.1 33.9 432 0l33.9 33.9 44.1 44.1L544 112l-33.9 33.9L177.9 478.1zM357.1 231L313 186.9 99.9 400 144 444.1 357.1 231zM391 197.1L476.1 112 432 67.9 346.9 153 391 197.1z'
      
    ]
  };

  
    var faMagicWandSparkles = faWandMagicSparkles;
  

  
  

  var faGauge = {
    prefix: 'fasr',
    iconName: 'gauge',
    icon: [
      512,
      512,
      ["dashboard","gauge-med","tachometer-alt-average"],
      'f624',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6V120 96H232v24V301.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faDashboard = faGauge;
  
    var faGaugeMed = faGauge;
  
    var faTachometerAltAverage = faGauge;
  

  
  

  var faVial = {
    prefix: 'fasr',
    iconName: 'vial',
    icon: [
      512,
      512,
      [129514],
      'f492',
      
      'M340.2 18.2l-17-17L289.3 35.2l17 17 3.8 3.8L30.2 335.8C10.9 355.2 0 381.4 0 408.8C0 465.8 46.2 512 103.2 512c27.4 0 53.6-10.9 73-30.2L456 201.9l3.8 3.8 17 17 33.9-33.9-17-17L473 151 361 39 340.2 18.2zM177.9 256L344 89.9 422.1 168l-88 88H177.9z'
      
    ]
  };

  

  
  

  var faSquareBolt = {
    prefix: 'fasr',
    iconName: 'square-bolt',
    icon: [
      448,
      512,
      [],
      'e265',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM200 272H112V248L288 112 248 240h88v24L160 400l40-128z'
      
    ]
  };

  

  
  

  var faLeafOak = {
    prefix: 'fasr',
    iconName: 'leaf-oak',
    icon: [
      512,
      512,
      [],
      'f6f7',
      
      'M470.3 258.4L512 248V176l-48-32 16-64L432 32 368 48 336 0H264L253.6 41.7 240 96 209.9 65.9l-9.5-9.5L176 32 142.1 65.9 128 80l6.9 48.2L144 192 96 160l-4.4 4.4L32 224l48 96 0 64v14.1L18.2 459.8l-17 17 33.9 33.9 17-17L113.9 432H128h64l96 48 59.6-59.6L352 416l-32-48 63.8 9.1L432 384l14.1-14.1L480 336l-24.4-24.4-9.5-9.5L416 272l54.3-13.6zM161.9 384L313.9 232.1l17-17-33.9-33.9-17 17L128 350.1V320 308.7l-5.1-10.1L90.4 233.5l11.7-11.7 15.3 10.2 20.8 13.9 54.2-54.2-.9-6.4-11.6-81.4 26.2 26.2 24 24L290 94l11.5-46h8.8l17.8 26.6 18.8 28.1 32.8-8.2 37.6-9.4 9.6 9.6-9.4 37.6-8.2 32.8 28.1 18.8L464 201.7v8.8L418 222l-59.9 59.9 24 24 26.2 26.2-81.4-11.6-6.4-.9-54.2 54.2 13.9 20.8 10.2 15.3-11.7 11.7-65.1-32.5L203.3 384H192 161.9z'
      
    ]
  };

  

  
  

  var faMarsStroke = {
    prefix: 'fasr',
    iconName: 'mars-stroke',
    icon: [
      512,
      512,
      [9894],
      'f229',
      
      'M352 0h24H488h24V24 136v24H464V136 81.9L409.9 136l31 31 17 17L424 217.9l-17-17-31-31-27.7 27.7C370.7 227.2 384 264.1 384 304c0 97.2-78.8 176-176 176s-176-78.8-176-176s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L342.1 136l-31-31-17-17L328 54.1l17 17 31 31L430.1 48H376 352V0zM208 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256z'
      
    ]
  };

  

  
  

  var faCircleParking = {
    prefix: 'fasr',
    iconName: 'circle-parking',
    icon: [
      512,
      512,
      ["parking-circle"],
      'f615',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 128h88c53 0 96 43 96 96s-43 96-96 96H216v40 24H168V360 320 272 152 128h24zm88 144c26.5 0 48-21.5 48-48s-21.5-48-48-48H216v96h64z'
      
    ]
  };

  
    var faParkingCircle = faCircleParking;
  

  
  

  var faCrutches = {
    prefix: 'fasr',
    iconName: 'crutches',
    icon: [
      640,
      512,
      [],
      'f7f8',
      
      'M374.8 408.7l85 85 17 17 33.9-33.9-17-17-63.4-63.4-55.5 12.3zM56 201.9L207.4 353.4l5.4-5.4 10.4-46.6L89.9 168 168 89.9l95.4 95.4 33.9-33.9L201.9 56l3.8-3.8 17-17L188.8 1.3l-17 17L18.2 171.8l-17 17 33.9 33.9 17-17 3.8-3.8zM451.2 1.3L417.3 35.2l17 17L587.8 205.8l17 17 33.9-33.9-17-17L468.2 18.2l-17-17zM415.4 78.6L279 215l-4.9 4.9-1.5 6.8L242.1 364l-95.9 95.9-17 17 33.9 33.9 17-17L276 397.9l137.2-30.5 6.8-1.5L425 361 561.4 224.6l-33.9-33.9L456 262.1 377.9 184l71.4-71.4L415.4 78.6zM344 217.9L422.1 296 396 322.1 295.6 344.4 317.9 244 344 217.9z'
      
    ]
  };

  

  
  

  var faChartSimple = {
    prefix: 'fasr',
    iconName: 'chart-simple',
    icon: [
      448,
      512,
      [],
      'e473',
      
      'M240 80V432H208V80h32zM208 32H160V80 432v48h48 32 48V432 80 32H240 208zM80 272V432H48V272H80zM48 224H0v48V432v48H48 80h48V432 272 224H80 48zm320-80h32V432H368V144zM320 96v48V432v48h48 32 48V432 144 96H400 368 320z'
      
    ]
  };

  

  
  

  var faBagSeedling = {
    prefix: 'fasr',
    iconName: 'bag-seedling',
    icon: [
      512,
      512,
      [],
      'e5f2',
      
      'M91.9 150.1C84 181.9 80 214.4 80 247.2v17.7c0 32.7 4 65.3 11.9 97L97.5 384h317l5.5-22.1c7.9-31.7 11.9-64.3 11.9-97V247.2c0-32.7-4-65.3-11.9-97L414.5 128H97.5l-5.5 22.1zM417.5 48H94.5L103 80H409l8.5-32zm-316 384l-8 32h325l-8-32h-309zM44.8 48L32 0H81.7 430.3 480L467.2 48l-12 44.9 11.4 45.6c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7L456 416l12 48 12 48H430.5 81.5 32l12-48 12-48L45.4 373.5C36.5 338 32 301.5 32 264.8V247.2c0-36.6 4.5-73.1 13.4-108.7L56.8 92.9 44.8 48zM160 160c40.7 0 76.4 21.8 96 54.3c19.6-32.5 55.3-54.3 96-54.3h32v16c0 59.2-45.9 107.6-104 111.7V328v24H232V328 287.7c-58.1-4.1-104-52.6-104-111.7V160h32z'
      
    ]
  };

  

  
  

  var faPenCircle = {
    prefix: 'fasr',
    iconName: 'pen-circle',
    icon: [
      512,
      512,
      [],
      'e20e',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144 32L252.7 179.3l80 80L224 368l-96 16 16-96zm256-96l-44.7 44.7-80-80L320 112l80 80z'
      
    ]
  };

  

  
  

  var faRadiation = {
    prefix: 'fasr',
    iconName: 'radiation',
    icon: [
      512,
      512,
      [],
      'f7b9',
      
      'M155.1 177.2c-7.3 9.3-13.3 19.6-17.8 30.8l-83.7 0c9.5-40.2 30.6-75.8 59.7-103.3l41.9 72.5zM176 256c0-29.6 16.1-55.5 40-69.3l0 0L152 75.8 128 34.3c-14 8.1-27.1 17.5-39.3 28C45.9 99.2 15.5 150.2 4.5 208C1.5 223.5 0 239.6 0 256H48l80 0h48zm40 69.3l-24 41.6L128 477.7l.4 .2c13.7 7.9 28.2 14.6 43.4 19.9C198.2 507 226.5 512 256 512s57.8-5 84.2-14.2c15.2-5.3 29.7-11.9 43.4-19.9l.4-.2L320 366.9l-24-41.6-.1 .1C284.1 332.1 270.5 336 256 336s-28.1-3.9-39.9-10.6l-.1-.1zM256 464c-20.8 0-40.8-3-59.7-8.7l41.9-72.6c5.8 .8 11.7 1.2 17.8 1.2s12-.4 17.8-1.2l41.9 72.6C296.8 461 276.8 464 256 464zM507.5 208c-11-57.8-41.4-108.8-84.2-145.8C411.2 51.7 398 42.4 384 34.3L360 75.8 296 186.7c23.9 13.8 40 39.7 40 69.3h48l80 0h48l0-.1c0-16.4-1.5-32.4-4.5-47.9zM398.8 104.7c29.1 27.4 50.2 63.1 59.7 103.3l-83.8 0c-4.5-11.1-10.5-21.5-17.8-30.8l41.9-72.5zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faPlaneUpSlash = {
    prefix: 'fasr',
    iconName: 'plane-up-slash',
    icon: [
      640,
      512,
      [],
      'e22e',
      
      'M493.3 360.2l52.2 14.9 30.6 8.7V352 272 258.1l-12.1-6.9L400 157.5V106c0-20.2-7.8-44.9-19.6-64.5C369.4 23.1 349.1 0 320 0c-14.7 0-27.2 6.3-36.7 13.9c-9.5 7.6-17.3 17.4-23.3 27.5c-11.9 19.6-20 44.3-20 64.6v51.5l-4.5 2.6L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L493.3 360.2zM276.5 191.9l11.5-6.6V171.4 106c0-9.6 4.6-25.8 13-39.7c4.1-6.7 8.4-11.8 12.3-14.9c3.9-3.1 6.1-3.3 6.7-3.3c2.4 0 10.1 3 19.2 18.1C347.6 80 352 96.2 352 106v65.5 13.9l12.1 6.9L528 285.9v34.3l-136.5-39-115-89.3zM464 461.6l-48-37.8v36.7l-88.9-27.4-7.1-2.2-7.1 2.2L224 460.4V428l54.4-40.8L288 380V368l0-45.1L238.6 284 112 320.2V285.9l74.8-42.7-40.7-32-70 40L64 258.1V272v80 31.8l30.6-8.7L240 333.5l0 22.5-54.4 40.8L176 404v12 72 24h24 16 3.6l3.4-1.1L320 481.1l96.9 29.8 3.4 1.1H424h16 24V488 461.6z'
      
    ]
  };

  

  
  

  var faMug = {
    prefix: 'fasr',
    iconName: 'mug',
    icon: [
      576,
      512,
      [],
      'f874',
      
      'M80 112V400H368V112H80zM32 64H80 368h16 32 32c70.7 0 128 57.3 128 128s-57.3 128-128 128H416v80 48H368 80 32V400 112 64zM416 272h32c44.2 0 80-35.8 80-80s-35.8-80-80-80H416V272z'
      
    ]
  };

  

  
  

  var faMicrochipAi = {
    prefix: 'fasr',
    iconName: 'microchip-ai',
    icon: [
      512,
      512,
      [],
      'e1ec',
      
      'M184 0V24 64h48V24 0h48V24 64h48V24 0h48V24 64h24 48v48 24h40 24v48H488 448v48h40 24v48H488 448v48h40 24v48H488 448v24 48H400 376v40 24H328V488 448H280v40 24H232V488 448H184v40 24H136V488 448H112 64V400 376H24 0V328H24 64V280H24 0V232H24 64V184H24 0V136H24 64V112 64h48 24V24 0h48zM400 112H112V400H400V112zm-44 64v16V320v16H316V320 192 176h40zm-124.7 0l3.4 8.8L293.3 336H250.4l-7.8-20H189.4l-7.8 20H138.8l58.6-151.2 3.4-8.8h30.5zM204.9 276h22.2L216 247.4 204.9 276z'
      
    ]
  };

  

  
  

  var faFileWaveform = {
    prefix: 'fasr',
    iconName: 'file-waveform',
    icon: [
      448,
      512,
      ["file-medical-alt"],
      'f478',
      
      'M400 464H112V352H64V464v48h48H400h48V464 128L320 0H112 64V48 240h48V48H288V160H400V464zM276.8 228.1l-22.2-38.9-20.1 40.1-45.5 91L164 282.7 156.8 272H144 24 0v48H24 131.2L172 381.3 195 415.7l18.5-37 43.9-87.9 9.8 17.1 6.9 12.1H288h40 24V272H328 301.9l-25.1-43.9z'
      
    ]
  };

  
    var faFileMedicalAlt = faFileWaveform;
  

  
  

  var faCreditCardBlank = {
    prefix: 'fasr',
    iconName: 'credit-card-blank',
    icon: [
      576,
      512,
      [],
      'f389',
      
      'M48 80V432H528V80H48zM0 32H48 528h48V80 432v48H528 48 0V432 80 32zM96 336h96v48H96V336zm128 0H384v48H224V336z'
      
    ]
  };

  

  
  

  var faFaceAnxiousSweat = {
    prefix: 'fasr',
    iconName: 'face-anxious-sweat',
    icon: [
      576,
      512,
      [],
      'e36a',
      
      'M496 256c0 114.9-93.1 208-208 208c-65.5 0-124-30.3-162.1-77.7c-4 17-13.4 32-26.4 42.9C146.3 480.1 213.4 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256l16-21.3 25.6 34.1L81.3 279c-.8-7.6-1.3-15.2-1.3-23C80 141.1 173.1 48 288 48s208 93.1 208 208zM36.4 303.5L9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48c12 0 22.9-4.4 31.3-11.6C89.5 395.6 96 382.5 96 368c0-10.4-3.4-20.5-9.6-28.8L68 314.7 48 288 36.4 303.5zM208 400v16H368V400c0-44.2-35.8-80-80-80s-80 35.8-80 80zm159.6-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-192-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.7-100.7L238.6 160 216 137.4l-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zM337.4 160l11.3 11.3 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4L360 137.4 337.4 160z'
      
    ]
  };

  

  
  

  var faFolder = {
    prefix: 'fasr',
    iconName: 'folder',
    icon: [
      512,
      512,
      [61716,128193,128447,"folder-blank"],
      'f07b',
      
      'M272 96L224 32H48 0V80 432v48H48 464h48V432 144 96H464 272zm192 48V432H48V80H200l33.6 44.8L248 144h24H464z'
      
    ]
  };

  
    var faFolderBlank = faFolder;
  

  
  

  var faObjectsAlignTop = {
    prefix: 'fasr',
    iconName: 'objects-align-top',
    icon: [
      512,
      512,
      [],
      'e3c0',
      
      'M512 0H0V48H512V0zM176 176V464H112V176h64zm-64-48H64v48V464v48h48 64 48V464 176 128H176 112zm288 48V336H336V176h64zm-64-48H288v48V336v48h48 64 48V336 176 128H400 336z'
      
    ]
  };

  

  
  

  var faFileCad = {
    prefix: 'fasr',
    iconName: 'file-cad',
    icon: [
      512,
      512,
      [],
      'e672',
      
      'M112 464l-64 0L48 48l176 0 0 112 112 0 0 144 48 0 0-176L256 0 48 0 0 0 0 48 0 464l0 48 48 0 64 0 0-48zm88-112c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8 0-16-32 0 0 16 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8 0 16 32 0 0-16 0-8c0-22.1-17.9-40-40-40l-16 0zm232 0l-16 0 0 16 0 128 0 16 16 0 32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm16 32l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-16 0 0-96zm-160 8l0 56 0 48 0 16 32 0 0-16 0-32 32 0 0 32 0 16 32 0 0-16 0-48 0-56c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm32 0c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 40-32 0 0-40z'
      
    ]
  };

  

  
  

  var faTrashPlus = {
    prefix: 'fasr',
    iconName: 'trash-plus',
    icon: [
      448,
      512,
      [],
      'e2b2',
      
      'M160 0H147.2L140 10.7 93.8 80H80.1 32 0v48H35.6L64 512H384l28.4-384H448V80H416 367.9 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM108.6 464L83.7 128H364.3L339.4 464H108.6zm95.3-67.9h40.2V376 308.1H312h20.1V267.9H312 244.1V200 179.9H203.9V200v67.9H136 115.9v40.2H136h67.9V376v20.1z'
      
    ]
  };

  

  
  

  var faHeadSideGear = {
    prefix: 'fasr',
    iconName: 'head-side-gear',
    icon: [
      512,
      512,
      [],
      'e611',
      
      'M112 361.7v19.6V448v16 48H96 64V480 464 381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1V264v24 16 32H496 480 464 448v48 16 16 32H416 400 368 320v16 16 16 16H288 272V464 448 400h48 80V336 288h48 16V270.1l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48H224C126.8 48 48 127 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM256 133.5c11.2 4 21.5 10 30.4 17.6l32.5-18.7 32 55.4-32.5 18.7c1.1 5.7 1.6 11.6 1.6 17.6s-.5 11.9-1.6 17.5l32.5 18.7-32 55.4L286.4 297c-8.9 7.6-19.2 13.6-30.4 17.6V352H192V314.5c-11.2-4-21.5-10-30.4-17.6l-32.5 18.7-32-55.4 32.5-18.7c-1.1-5.7-1.6-11.6-1.6-17.5s.5-11.9 1.6-17.6L97.1 187.7l32-55.4L161.6 151c8.9-7.6 19.1-13.6 30.4-17.6V96h64v37.5zm8 90.5a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faArrowUpFromBracket = {
    prefix: 'fasr',
    iconName: 'arrow-up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e09a',
      
      'M241 18.2l-17-17-17 17L79 146.2l-17 17L96 197.1l17-17 87-87L200 328l0 24 48 0 0-24 0-234.9 87 87 17 17 33.9-33.9-17-17L241 18.2zM48 344l0-24L0 320l0 24L0 488l0 24 24 0 400 0 24 0 0-24 0-144 0-24-48 0 0 24 0 120L48 464l0-120z'
      
    ]
  };

  

  
  

  var faHandPointDown = {
    prefix: 'fasr',
    iconName: 'hand-point-down',
    icon: [
      384,
      512,
      [],
      'f0a7',
      
      'M40 512l-24 0 0-24 0-216L0 272l0-24 0-56 0 0 0-24s0 0 0 0C0 75.2 75.2 0 168 0l48 0c92.7 0 167.9 75.1 168 167.9c0 0 0 .1 0 .1l0 0 0 88 0 40 0 24-24 0-56 0 0 16-24 0-56 0 0 8 0 24-24 0-56 0 0 120 0 24-24 0-80 0zM336 256l0-80-32 0 0 96 32 0 0-16zm-6.8-128C312.7 81.4 268.2 48 216 48l-48 0C101.7 48 48 101.7 48 168c0 0 0 0 0 0l0 24 0 0 0 32 72 0 56 0 0-32-56 0-24 0 0-48 24 0 56 0 24 0 24 0 32 0 0-16 24 0 49.2 0zM96 272l-32 0 0 192 32 0 0-96 0-24 0-72zm80 0l-32 0 0 48 32 0 0-8 0-40zm48 16l32 0 0-96-32 0 0 56 0 40z'
      
    ]
  };

  

  
  

  var faRaccoon = {
    prefix: 'fasr',
    iconName: 'raccoon',
    icon: [
      512,
      512,
      [],
      'e613',
      
      'M296 0h-8-3.4H224h-9.9l-4.4 8.8-16 32-3 5.9 2.1 6.3L207 95.5l-33.6 41.4-5.4 6.6V152v40 17.9l17.1 5.1 76.6 23 45 30 6 4H320h32 7.3l6-4 45-30 76.6-23 17.1-5.1V192 152v-8l-4.8-6.4L465.8 93.1l13.3-40 2.1-6.3-3-5.9-16-32L457.9 0H448 396 384 296zM216 160.5l24.5-30.2 38.8-23.3c14.4-8.6 32.9-.4 36.2 16c1.8 8.9-1.6 18-8.6 23.7l-49.6 39.7L216 174.1V160.5zM336 93.1c-11.4-14.5-29.5-22.5-47.8-21.4L307.4 48H372l18.4 24.5c-20.6-3.8-41.6 4.4-54.4 20.6zm0 69.5c2.6 3.4 5.7 6.5 9.1 9.2l35.4 28.3-20.6 13.8C358.8 201.6 348.5 192 336 192s-22.8 9.6-23.9 21.9l-20.6-13.8 35.4-28.3c3.4-2.7 6.5-5.8 9.1-9.2zm78.8 23.9l-49.6-39.7c-7.1-5.7-10.4-14.8-8.6-23.7c3.3-16.4 21.9-24.7 36.2-16l42.9 25.7L456 160v14.1l-41.2 12.4zM144 244.4V56 32H120 24 0V56 200v24V392c0 66.3 53.7 120 120 120H456h24V488 464v-8c0-39.8-32.2-72-72-72H384v48h24c13.3 0 24 10.7 24 24v8H352v-8c0-39.8-32.2-72-72-72H232 208v48h24 48c13.3 0 24 10.7 24 24v8H120c-39.8 0-72-32.2-72-72V360H82.4c-1.6 10.4-2.4 21.1-2.4 32v24h48V392c0-54.6 27.3-102.8 69.1-131.7l-23.5-7L144 244.4zM96 311.9l-.1 .1H48V264H96v47.9zM96 216H48V200 168H96v48zm0-96H48V80H96v40zM332.7 323.6l-64-40-20.4-12.7-25.4 40.7 20.4 12.7 64 40 25.4-40.7zm102.6-40l-64 40 25.4 40.7 64-40 20.4-12.7-25.4-40.7-20.4 12.7zM288 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faOption = {
    prefix: 'fasr',
    iconName: 'option',
    icon: [
      640,
      512,
      [],
      'e318',
      
      'M176 64h11l7.2 8.4L475 400H616h24v48H616 464 453l-7.2-8.4L165 112H24 0V64H24 176zm440 0h24v48H616 440 416V64h24H616z'
      
    ]
  };

  

  
  

  var faBacon = {
    prefix: 'fasr',
    iconName: 'bacon',
    icon: [
      576,
      512,
      [129363],
      'f7e5',
      
      'M0 352c16.2-7.3 31-14.3 44.6-21.1c118.5-59 141.5-98.6 166.2-141C239.1 141.4 269.6 89.2 448 0l97.4 121.7L576 160c-15.6 7.8-30 15.3-43.4 22.5C392.3 258.3 364.7 305.7 338.8 350c-27.5 47.2-53 91-210.8 162L30.9 390.7 0 352zm100.4 48.7c49.3-26.4 81.3-50 104.7-72c24.3-23 39.9-44.8 56.9-68.5l1.9-2.6c17.7-24.8 37-51.3 68.5-80.6c28.9-27 67.8-56 124.8-88.9L435.1 60.7c-64.8 34.5-103.6 61.8-128.5 84.1c-27.9 25-40 45-53.1 67.4l-1.5 2.5c-13.9 23.8-30.2 51.9-64.8 82.3c-26 22.9-61.2 46.3-112 72.2l25.2 31.4zm20.3 25.4l21.2 26.5c56.7-27.5 89.3-49.4 109.9-67.6c22.8-20.1 32.6-36.9 46.1-60l.7-1.2c14.9-25.5 32.9-55.6 71.9-90.6c29.9-26.8 71.3-55.7 131.6-88.8l-24.9-31.1c-57.8 32.9-95.7 61.4-123.2 87c-29 27.1-46.8 51.4-64.3 75.8l-2.2 3.1c-16.8 23.5-33.9 47.5-60.6 72.7c-25 23.6-57.9 47.8-106.3 74.1z'
      
    ]
  };

  

  
  

  var faTrashList = {
    prefix: 'fasr',
    iconName: 'trash-list',
    icon: [
      640,
      512,
      [],
      'e2b1',
      
      'M160 0H147.2L140 10.7 93.8 80H80.1 32 0v48H35.6L64 512H352l28.4-384H416V80H384 335.9 322.2L276 10.7 268.8 0H256 160zM264.5 80h-113l21.3-32h70.3l21.3 32zM108.6 464L83.7 128H296.5l.9 1.3 1.9-1.3h33L307.4 464H108.6zM640 128H448v48H640V128zM608 256H448v48H608V256zM448 384v48h96V384H448z'
      
    ]
  };

  

  
  

  var faMessageCaptions = {
    prefix: 'fasr',
    iconName: 'message-captions',
    icon: [
      512,
      512,
      ["comment-alt-captions"],
      'e1de',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM120 192H96v48h24H264h24V192H264 120zm224 0H320v48h24 48 24V192H392 344zM120 272H96v48h24 48 24V272H168 120zm128 0H224v48h24H392h24V272H392 248z'
      
    ]
  };

  
    var faCommentAltCaptions = faMessageCaptions;
  

  
  

  var faSushi = {
    prefix: 'fasr',
    iconName: 'sushi',
    icon: [
      576,
      512,
      [127843,"nigiri"],
      'e48a',
      
      'M576 352L554.7 224.4c-6.4-38.1-23.7-72.1-48.5-98.8L405.9 295.5 576 352zM393.5 66.1L282.2 254.4l92.7 30.8L482.1 103.6c-25.4-19.5-55.8-32.7-88.7-37.5zm-36-2.1H246.6L96.1 318.7l139.4-48.3L357.5 64zM21.3 224.4L0 352l32-11.1 1.5-.5 15.9-5.5L80 324.3v0L49.4 334.9 209.5 64c-93.3 .6-172.8 68.2-188.2 160.4zM32 374.8V376c0 39.8 32.2 72 72 72c16.6 0 31.8-5.6 44-15c12.2 9.4 27.4 15 44 15c18.4 0 35.3-6.9 48-18.3c12.7 11.4 29.6 18.3 48 18.3s35.3-6.9 48-18.3c12.7 11.4 29.6 18.3 48 18.3c16.6 0 31.8-5.6 44-15c12.2 9.4 27.4 15 44 15c39.8 0 72-32.2 72-72v-.9l-48-15.9V376c0 13.3-10.7 24-24 24c-5.6 0-10.6-1.8-14.6-5L428 372.3 398.6 395c-4.1 3.1-9.1 5-14.6 5c-6.2 0-11.7-2.3-16-6.1l-32-28.7-32 28.7c-4.3 3.8-9.8 6.1-16 6.1s-11.7-2.3-16-6.1l-32-28.7-32 28.7c-4.3 3.8-9.8 6.1-16 6.1c-5.6 0-10.6-1.8-14.6-5L148 372.3 118.6 395c-4.1 3.1-9.1 5-14.6 5c-13.3 0-24-10.7-24-24V358.1L32 374.8z'
      
    ]
  };

  
    var faNigiri = faSushi;
  

  
  

  var faBullseye = {
    prefix: 'fasr',
    iconName: 'bullseye',
    icon: [
      512,
      512,
      [],
      'f140',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-272a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faArrowLeftToLine = {
    prefix: 'fasr',
    iconName: 'arrow-left-to-line',
    icon: [
      448,
      512,
      [8676,"arrow-to-left"],
      'f33e',
      
      'M0 88L0 64l48 0 0 24 0 336 0 24L0 448l0-24L0 88zM135.6 273.5L117 256l18.6-17.5 136-128L289 94.1l32.9 35-17.5 16.4L212.5 232l83.5 0 128 0 24 0 0 48-24 0-128 0-83.5 0 91.9 86.5L321.9 383l-32.9 35-17.5-16.4-136-128z'
      
    ]
  };

  
    var faArrowToLeft = faArrowLeftToLine;
  

  
  

  var faLocationSmile = {
    prefix: 'fasr',
    iconName: 'location-smile',
    icon: [
      384,
      512,
      ["map-marker-smile"],
      'f60d',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zM136 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM111.4 251.1l33.3-22.2c4.5 6.7 21.6 23.1 47.4 23.1s42.9-16.4 47.4-23.1l33.3 22.2C262.9 265.7 234.5 292 192 292s-70.9-26.3-80.6-40.9z'
      
    ]
  };

  
    var faMapMarkerSmile = faLocationSmile;
  

  
  

  var faHelmetUn = {
    prefix: 'fasr',
    iconName: 'helmet-un',
    icon: [
      512,
      512,
      [],
      'e503',
      
      'M240 48c106 0 192 86 192 192H256 240.5l-6.4 14.1L196.9 336H48V240C48 134 134 48 240 48zm80 372.7l-77.7-68.6L271.5 288H320V420.7zm48 42.4V288H488h24V240H488h-8C480 107.5 372.5 0 240 0S0 107.5 0 240V360v24H24 205.9l2.3 2 136 120 6.8 6H360h96 24V464H456 369.1l-1.1-.9zM160 112V96H128v16 64c0 26.5 21.5 48 48 48s48-21.5 48-48V112 96H192v16 64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112zM272 96H256v16 96 16h32V208 164.4l31.1 51.8 4.7 7.8h9.1H336h16V208 112 96H320v16 43.6l-31.1-51.8L284.3 96h-9.1H272z'
      
    ]
  };

  

  
  

  var faUmbrellaBeach = {
    prefix: 'fasr',
    iconName: 'umbrella-beach',
    icon: [
      576,
      512,
      [127958],
      'f5ca',
      
      'M572.1 268.8c-.5 16.2-2.6 32.5-6.3 48.8l-45.5-16.6-77.6-28.3 0 0L214.9 189.9l0 0L134 160.4 88.4 143.9C96 129 104.9 115.2 115 102.4c66.5-84.6 182.2-121 288.8-82.2s171.8 141 168.4 248.6zM473 124.2c.4 35-4.5 69.8-14.5 103.3L524 251.3c-2.2-47-20.3-91.9-51-127.2zM396.3 68.9c-3-1.2-5.9-2.4-9-3.5c-1-.4-1.9-.7-2.9-1c-18.2-5.9-38.3-.9-51.5 13.1c-23.3 24.6-42.2 53.1-55.9 84L413.3 211c9.4-32.5 13.2-66.4 11.2-100.2c-1.1-18.2-12-34.2-28.2-41.9zM288.8 54.6c-48 6.4-92.7 29.5-125.8 65.4l68.8 25c14.2-32.9 33.4-63.4 57-90.4zM552 464l24 0 0 48-24 0L24 512 0 512l0-48 24 0 192.7 0 76.9-211.4L338.7 269l-71 195L552 464z'
      
    ]
  };

  

  
  

  var faBrainArrowCurvedRight = {
    prefix: 'fasr',
    iconName: 'brain-arrow-curved-right',
    icon: [
      640,
      512,
      ["mind-share"],
      'f677',
      
      'M313.6 464H280V424v-4-4V96 88 48h40c2.7 0 5.4 .3 8 .8c18.3 3.7 32 19.8 32 39.2l0 .7c20.7 3.5 36.9 20.1 39.6 41c.3 2.1 .4 4.2 .4 6.3c0 5.7-1 11.2-2.8 16.3c7.8 .8 15.1 3.5 21.3 7.7c11.5 7.6 19.6 20.1 21.2 34.6c.2 1.8 .3 3.6 .3 5.5c0 14.5-6.5 27.6-16.7 36.4c15.5 6.1 28.1 18 34.9 33.1c.4 .8 .7 1.7 1.1 2.5H480V224 208 161.6c-7.1-16.3-18.7-30.3-33.1-40.3c-4.5-28.9-21.8-53.5-45.9-67.8C387.5 22 356.3 0 320 0H280 232 192c-36.3 0-67.5 22-80.9 53.4C86.9 67.7 69.6 92.3 65.1 121.2C40.3 138.6 24 167.4 24 200c0 8 1 15.8 2.8 23.3C10.1 242.8 0 268.2 0 296c0 30.6 12.2 58.2 32 78.4c0 .5 0 1.1 0 1.6c0 47.3 34.1 86.5 79.1 94.5c16.4 25 44.7 41.5 76.9 41.5h44 48 44c7 0 13.9-.8 20.5-2.3c-11.1-11.3-22.9-26.6-30.9-45.7zM152 88.7l0-.7c0-19.4 13.7-35.5 32-39.2c2.6-.5 5.3-.8 8-.8h40V88v8V416v4 4 40H188c-1.3 0-2.7-.1-4-.2c-12.6-1.1-23.7-7.6-31-17.1c-5.4-7.1-8.7-15.9-9-25.4c-5 1.8-10.4 2.7-16 2.7c-4.7 0-9.2-.7-13.4-1.9C94.6 416.3 80 397.8 80 376c0-6.5 1.3-12.6 3.6-18.3c.5-1.2 1.1-2.4 1.7-3.6c-1.6-.7-3.2-1.5-4.7-2.4C61.1 340.8 48 319.9 48 296c0-9.5 2.1-18.4 5.7-26.5c6.9-15.1 19.4-27 34.9-33.1C78.5 227.6 72 214.5 72 200c0-1.8 .1-3.7 .3-5.5c1.6-14.4 9.7-26.9 21.2-34.6c6.2-4.1 13.5-6.8 21.3-7.7c-1.8-5.1-2.8-10.6-2.8-16.3c0-2.1 .1-4.2 .4-6.3c2.7-20.9 18.9-37.6 39.6-41zM528 240H512v64H448c-61.9 0-112 50.1-112 112c0 64 64 96 64 96V464c0-35.3 28.7-64 64-64h48v64h16L640 352 528 240z'
      
    ]
  };

  
    var faMindShare = faBrainArrowCurvedRight;
  

  
  

  var fa6 = {
    prefix: 'fasr',
    iconName: '6',
    icon: [
      320,
      512,
      [],
      '36',
      
      'M272 320c0-61.9-50.1-112-112-112c-32.3 0-61.5 13.7-81.9 35.6l-5.1 6.3C56.8 269.7 48 294.5 48 320c0 61.9 50.1 112 112 112s112-50.1 112-112zM145.7 160.6c4.7-.4 9.5-.6 14.3-.6c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-41.5 15.8-79.4 41.8-107.8L188.6 32h61.9L145.7 160.6z'
      
    ]
  };

  

  
  

  var faCreditCardFront = {
    prefix: 'fasr',
    iconName: 'credit-card-front',
    icon: [
      576,
      512,
      [],
      'f38a',
      
      'M48 80V432H528V80H48zM0 32H48 528h48V80 432v48H528 48 0V432 80 32zM96 336h96v48H96V336zm128 0H384v48H224V336zM96 256H480v48H96V256zM480 128v96H352V128H480z'
      
    ]
  };

  

  
  

  var faBatteryLow = {
    prefix: 'fasr',
    iconName: 'battery-low',
    icon: [
      576,
      512,
      ["battery-1"],
      'e0b1',
      
      'M496 144V368H48V144H496zM48 96H0v48V368v48H48 496h48V368 320h32V192H544V144 96H496 48zm112 96H96V320h64V192z'
      
    ]
  };

  
    var faBattery1 = faBatteryLow;
  

  
  

  var faAlignJustify = {
    prefix: 'fasr',
    iconName: 'align-justify',
    icon: [
      448,
      512,
      [],
      'f039',
      
      'M24 40H0V88H24 424h24V40H424 24zm0 128H0v48H24 424h24V168H424 24zM0 296v48H24 424h24V296H424 24 0zM24 424H0v48H24 424h24V424H424 24z'
      
    ]
  };

  

  
  

  var faFanTable = {
    prefix: 'fasr',
    iconName: 'fan-table',
    icon: [
      448,
      512,
      [],
      'e004',
      
      'M224 400a176 176 0 1 0 0-352 176 176 0 1 0 0 352zM448 224c0 115.6-87.6 210.8-200 222.7V464H360h24v48H360 224 88 64V464H88 200V446.7C87.6 434.8 0 339.6 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM118.4 197.6c-16.6-41 3.2-87.6 44.2-104.1l22.3-9 38.2 94.4c16.7-23.7 45.8-37.5 76.6-33.2c43.8 6.1 74.2 46.6 68.1 90.4l-3.3 23.8L263.5 245.7c12.2 26.4 9.6 58.4-9.6 82.9c-27.2 34.8-77.5 41-112.3 13.8l-18.9-14.8 62.7-80.3c-28.9-2.6-55.4-21-67-49.7zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBookmark = {
    prefix: 'fasr',
    iconName: 'bookmark',
    icon: [
      384,
      512,
      [61591,128278],
      'f02e',
      
      'M192 344.4l24.2 14.1L336 428.4V48H48V428.4l119.8-69.9L192 344.4zM48 484L0 512V456.4 48 0H48 336h48V48 456.4 512l-48-28L192 400 48 484z'
      
    ]
  };

  

  
  

  var faSemicolon = {
    prefix: 'fasr',
    iconName: 'semicolon',
    icon: [
      192,
      512,
      [],
      '3b',
      
      'M72 104v48h48V104H72zM24 56H72h48 48v48 48 48H120 72 24V152 104 56zM64.5 512H16l6.9-48L48 288h64 48v48 48L80 512H64.5zM89.6 336l-13 90.8L112 370.2V336H89.6z'
      
    ]
  };

  

  
  

  var faSquareExclamation = {
    prefix: 'fasr',
    iconName: 'square-exclamation',
    icon: [
      448,
      512,
      ["exclamation-square"],
      'f321',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm248 96v24V264v24H200V264 152 128h48zM200 320h48v48H200V320z'
      
    ]
  };

  
    var faExclamationSquare = faSquareExclamation;
  

  
  

  var faTrainSubwayTunnel = {
    prefix: 'fasr',
    iconName: 'train-subway-tunnel',
    icon: [
      512,
      512,
      ["subway-tunnel"],
      'e2a3',
      
      'M256 48C141.1 48 48 141.1 48 256V488v24H0V488 256C0 114.6 114.6 0 256 0S512 114.6 512 256V488v24H464V488 256c0-114.9-93.1-208-208-208zM160 192v64H352V192H160zm0 112v96H352V304H160zM112 144h48H352h48v48V400v48H353.9l47 47 17 17H350.1l-64-64H225.9l-64 64H94.1l0 0 17-17 47-47H112V400 192 144zm64 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm136-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faSubwayTunnel = faTrainSubwayTunnel;
  

  
  

  var faSquareUp = {
    prefix: 'fasr',
    iconName: 'square-up',
    icon: [
      448,
      512,
      [11014,"arrow-alt-square-up"],
      'f353',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM112 224l112-96 112 96v32H272V384H176V256H112V224z'
      
    ]
  };

  
    var faArrowAltSquareUp = faSquareUp;
  

  
  

  var faFaceHoldingBackTears = {
    prefix: 'fasr',
    iconName: 'face-holding-back-tears',
    icon: [
      512,
      512,
      [129401],
      'e482',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-16a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 32v16 16 16H208V304c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7V320v16H96V320 288c-10-13.4-16-30-16-48c0-19 6.6-36.5 17.7-50.2L94 160.1l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2 30.8 8.8-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6v32zm112 16a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64 0v32 16H384V320v-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2 30.8-8.8 1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4-3.7 29.7C425.4 203.5 432 221 432 240c0 18-6 34.6-16 48zm-56 93.3C344 405.2 304.7 434 256 434s-88-28.8-104-52.7L192 354.7c8.1 12.1 33.2 31.3 64 31.3s56-19.2 64-31.3L360 381.3zM128 240c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z'
      
    ]
  };

  

  
  

  var faBowlSoftServe = {
    prefix: 'fasr',
    iconName: 'bowl-soft-serve',
    icon: [
      512,
      512,
      [],
      'e46b',
      
      'M256 0H211.2L236 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7H172c-42 0-76 34-76 76c0 4.9 .5 9.8 1.4 14.5C50.8 164.8 16 206.3 16 256v72 24H40h8.3c4.1 53.7 49 96 103.7 96h32l-24 64H352l-24-64h32c54.7 0 99.6-42.3 103.7-96H472h24V328 256c0-49.9-35.2-91.6-82.1-101.7c1.4-5.9 2.1-12 2.1-18.3C416 60.9 355.1 0 280 0H256zm40 57.3c0-2.7-.2-5.3-.6-8C336.7 56.6 368 92.7 368 136c0 5.8-1.5 11.3-4.3 16H280 256v48h24 36.4 58.8H384h8c30.9 0 56 25.1 56 56v48H64V256c0-30.9 25.1-56 56-56h8 6.5H168h22.8H192V152H168 146.7c-1.7-3.6-2.7-7.7-2.7-12c0-15.5 12.5-28 28-28h69.3c30.2 0 54.7-24.5 54.7-54.7z'
      
    ]
  };

  

  
  

  var faBaguette = {
    prefix: 'fasr',
    iconName: 'baguette',
    icon: [
      640,
      512,
      [129366],
      'e3d8',
      
      'M578.6 83.6c-24.5-36.8-74.2-46.7-110.9-22.2l-69.7 46.5L433 143l17 17L416 193.9l-17-17-41.9-41.9-74.5 49.6L321 223l17 17L304 273.9l-17-17-45.1-45.1-74.5 49.6L209 303l17 17L192 353.9l-17-17-48.3-48.3L83.6 317.4c-36.8 24.5-46.7 74.2-22.2 110.9s74.2 46.7 110.9 22.2l384-256c36.8-24.5 46.7-74.2 22.2-110.9zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z'
      
    ]
  };

  

  
  

  var faBarcodeRead = {
    prefix: 'fasr',
    iconName: 'barcode-read',
    icon: [
      576,
      512,
      [],
      'f464',
      
      'M0 0H24 136h24V48H136 48v88 24H0V136 24 0zM144 128V384H96V128h48zm32 0h32V384H176V128zm272 0h32V384H448V128zm-208 0h48V384H240V128zm176 0V384H368V128h48zM552 0h24V24 136v24H528V136 48H440 416V0h24H552zM0 512V488 376 352H48v24 88h88 24v48H136 24 0zm552 0H440 416V464h24 88V376 352h48v24V488v24H552z'
      
    ]
  };

  

  
  

  var faArrowUpBigSmall = {
    prefix: 'fasr',
    iconName: 'arrow-up-big-small',
    icon: [
      576,
      512,
      ["sort-size-up"],
      'f88e',
      
      'M368 208V80H496V208H368zm-48 48h48H496h48V208 80 32H496 368 320V80 208v48zM160 33.3l-17 17-96 96-17 17L64 197.1l17-17 55-55V456v24h48V456 125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM432 432H368V368h64v64zm-64 48h64 48V432 368 320H432 368 320v48 64 48h48z'
      
    ]
  };

  
    var faSortSizeUp = faArrowUpBigSmall;
  

  
  

  var faMoneyBill = {
    prefix: 'fasr',
    iconName: 'money-bill',
    icon: [
      576,
      512,
      [],
      'f0d6',
      
      'M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 64H48 528h48v48V400v48H528 48 0V400 112 64zm288 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faHandPointUp = {
    prefix: 'fasr',
    iconName: 'hand-point-up',
    icon: [
      384,
      512,
      [9757],
      'f0a6',
      
      'M40 0H16V24 240H0v24 56 0 24s0 0 0 0c0 92.8 75.2 168 168 168h48c92.7 0 167.9-75.1 168-167.9c0 0 0-.1 0-.1v0V256 216 192H360 304V176H280 224v-8V144H200 144V24 0H120 40zM336 256v80H304V240h32v16zm-6.8 128c-16.5 46.6-60.9 80-113.2 80H168c-66.3 0-120-53.7-120-120c0 0 0 0 0 0V320v0V288h72 56v32H120 96v48h24 56 24 24 32v16h24 49.2zM96 240H64V48H96v96 24 72zm80 0H144V192h32v8 40zm48-16h32v96H224V264 224z'
      
    ]
  };

  

  
  

  var faSquareJ = {
    prefix: 'fasr',
    iconName: 'square-j',
    icon: [
      448,
      512,
      [],
      'e273',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM304 152V288c0 53-43 96-96 96s-96-43-96-96v-8V256h48v24 8c0 26.5 21.5 48 48 48s48-21.5 48-48V152 128h48v24z'
      
    ]
  };

  

  
  

  var faBagShoppingPlus = {
    prefix: 'fasr',
    iconName: 'bag-shopping-plus',
    icon: [
      448,
      512,
      [],
      'e651',
      
      'M160 112v48H288V112c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 48V112C112 50.1 162.1 0 224 0h24V2.6c50.3 11 88 55.8 88 109.4v48h64 48v48V464v48H400 48 0V464 208 160H48h64zm0 48H48V464H400V208H336 288 160 112zm8 104h24 56V256 232h48v24 56h56 24v48H304 248v56l0 24H200l0-24V360H144 120V312z'
      
    ]
  };

  

  
  

  var faSquareDashed = {
    prefix: 'fasr',
    iconName: 'square-dashed',
    icon: [
      448,
      512,
      [],
      'e269',
      
      'M24 32H128V80H48v80H0V56 32H24zM0 192H48V320H0V192zm400 0h48V320H400V192zm48-32H400V80H320V32H424h24V56 160zm0 192V456v24H424 320V432h80V352h48zM48 352v80h80v48H24 0V456 352H48zM288 480H160V432H288v48zM160 80V32H288V80H160z'
      
    ]
  };

  

  
  

  var faFaceFrownOpen = {
    prefix: 'fasr',
    iconName: 'face-frown-open',
    icon: [
      512,
      512,
      [128550,"frown-open"],
      'f57a',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM255.6 368c-38.7 0-74.5 11.4-103.6 30.6c4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 379.4 294.3 368 255.6 368z'
      
    ]
  };

  
    var faFrownOpen = faFaceFrownOpen;
  

  
  

  var faFileVector = {
    prefix: 'fasr',
    iconName: 'file-vector',
    icon: [
      384,
      512,
      [],
      'e64c',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM240 224H144V208H80v64H96v96H80v64h64V416h96v16h64V368H288V272h16V208H240v16zm0 144H144V272h96v96z'
      
    ]
  };

  

  
  

  var faTally1 = {
    prefix: 'fasr',
    iconName: 'tally-1',
    icon: [
      640,
      512,
      [],
      'e294',
      
      'M152 40V64 448v24H104V448 64 40h48z'
      
    ]
  };

  

  
  

  var faPooStorm = {
    prefix: 'fasr',
    iconName: 'poo-storm',
    icon: [
      448,
      512,
      ["poo-bolt"],
      'f75a',
      
      'M161.2 0h33.6c58.8 0 132.5 41.8 140.5 121.2C364.2 135.7 384 165.5 384 200v6.6c37.4 14.4 64 50.7 64 93.2V376v24H424 341l11-8.3V352h48V299.8c0-25.9-19-47.3-43.7-51.2L336 245.5V224.9 200c0-18.6-12.7-34.3-30-38.7l-18.7-4.8 .7-19.3c0-.5 0-1 0-1.5c0-40.2-26.7-68.8-58.4-81c1.3 5.6 2.4 11.6 2.4 16.8c0 37.8-19.4 60.9-38.8 73.5c-18.2 11.9-36.2 14.6-37.8 14.8l-1.7 .2H152h0c-22.1 0-40 17.9-40 40v24.9 20.5l-20.3 3.2C67 252.5 48 274 48 299.8V352H64v48H24 0V376 299.8c0-42.5 26.6-78.8 64-93.2V200c0-47.8 38.1-86.7 85.6-88c2.8-.6 10.2-2.6 17.5-7.3c8.6-5.6 17-14.8 17-33.3c0 0 0 0 0 0c0-.3-.2-1.5-.7-4c-.6-2.8-1.5-6.1-2.6-9.9c-2.2-7.4-4.9-15.2-7-21.1l-.1-.2 0 0 0-.1c-.5-1.6-1.1-3.1-1.5-4.3L161.2 0zM184 384H96V360L272 224 232 352h88v24L144 512l40-128z'
      
    ]
  };

  
    var faPooBolt = faPooStorm;
  

  
  

  var faCapsules = {
    prefix: 'fasr',
    iconName: 'capsules',
    icon: [
      576,
      512,
      [],
      'f46b',
      
      'M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64V256H48V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm283.4 73.3c-20.9-30.4-13.3-72.2 15.8-93c28.5-20.4 68-13.7 88.5 16.2l66.9 97.5L348.5 312.2l-65.1-94.9z'
      
    ]
  };

  

  
  

  var faDonut = {
    prefix: 'fasr',
    iconName: 'donut',
    icon: [
      512,
      512,
      [127849,"doughnut"],
      'e406',
      
      'M48 294.1l7.2 3.6 2.3 1.2 1.8 1.8 44 44 74.3 7.4 1.5 .2 1.5 .4L256 375.3l75.4-22.6 1.5-.4 1.5-.2 74.3-7.4 44-44 1.8-1.8 2.3-1.2 7.2-3.6V304c0 21.7-14.2 48.5-52.4 72.4C374 399.9 319.1 416 256 416s-118-16.1-155.6-39.6C62.2 352.5 48 325.7 48 304v-9.9zM256 48C114.6 48 0 119.6 0 208v96c0 88.4 114.6 160 256 160s256-71.6 256-160V208c0-88.4-114.6-160-256-160zm38.6 48l-11.3 11.3-16 16L256 134.6 233.4 112l11.3-11.3 16-16L272 73.4 294.6 96zm-112 16l-11.3 11.3-32 32L128 166.6 105.4 144l11.3-11.3 32-32L160 89.4 182.6 112zM384 121.4l11.3 11.3 32 32L438.6 176 416 198.6l-11.3-11.3-32-32L361.4 144 384 121.4zM48 192H64 96h16v32H96 64 48V192zm336 25.4l11.3 11.3 32 32L438.6 272 416 294.6l-11.3-11.3-32-32L361.4 240 384 217.4zm-240 16l11.3 11.3 32 32L198.6 288 176 310.6l-11.3-11.3-32-32L121.4 256 144 233.4zM342.6 272l-11.3 11.3-32 32L288 326.6 265.4 304l11.3-11.3 32-32L320 249.4 342.6 272zM256 224c-35.3 0-64-14.3-64-32s28.7-32 64-32s64 14.3 64 32s-28.7 32-64 32z'
      
    ]
  };

  
    var faDoughnut = faDonut;
  

  
  

  var faDongSign = {
    prefix: 'fasr',
    iconName: 'dong-sign',
    icon: [
      384,
      512,
      [],
      'e169',
      
      'M320 32H272V64H192v48h80v76.1c-21.9-17.6-49.7-28.1-80-28.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c30.3 0 58.1-10.5 80-28.1V416h48V288 112h32V64H320V32zM112 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM384 496V448H0v48H384z'
      
    ]
  };

  

  
  

  var faTemperatureHalf = {
    prefix: 'fasr',
    iconName: 'temperature-half',
    icon: [
      320,
      512,
      [127777,"temperature-2","thermometer-2","thermometer-half"],
      'f2c9',
      
      'M96 294.5L85.3 307.7C72 324.2 64 345.1 64 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L224 294.5v-17V48H96V277.5v17zM224 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5V48 0H96 224zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V200 184h32v16V322.8c18.6 6.6 32 24.4 32 45.3z'
      
    ]
  };

  
    var faTemperature2 = faTemperatureHalf;
  
    var faThermometer2 = faTemperatureHalf;
  
    var faThermometerHalf = faTemperatureHalf;
  

  
  

  var faCommentImage = {
    prefix: 'fasr',
    iconName: 'comment-image',
    icon: [
      512,
      512,
      [],
      'e148',
      
      'M112.7 358.8l-10.8 28.9-7 18.5 57.6-17.3 13.9-4.2 13.9 4.2c23.3 7.1 48.8 11 75.7 11c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 35.1 15 68.9 42.9 96.9l21.8 21.9zm-39 103.9L16 480l21.2-56.5 19.8-52.7C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L73.8 462.7zM144 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM400 304v16H272 192 144V304l64-80 22 27.4L296 160 400 304z'
      
    ]
  };

  

  
  

  var faEscalator = {
    prefix: 'fasr',
    iconName: 'escalator',
    icon: [
      640,
      512,
      [],
      'e171',
      
      'M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm206.9 64h9 24H552h64 24v24V264v24H616 552 481.1L249.9 490.2l-18.1 15.8-6.8 5.9h-9H192 88 24 0V488 360 336H24 88h70.9L390.1 133.8l18.1-15.8 6.8-5.9zm18 48l-11.3 9.9L183.8 378.1 177 384h-9H88 48v80H88 192h15l11.3-9.9L456.2 245.9 463 240h9 80 40V160H552 448 433zM320 128v24.5l-128 112V128H320z'
      
    ]
  };

  

  
  

  var faCarWash = {
    prefix: 'fasr',
    iconName: 'car-wash',
    icon: [
      448,
      512,
      [],
      'f5e6',
      
      'M224 128c-26.5 0-48-21.5-48-48c0-32 48-80 48-80s48 48 48 80s-21.5 48-48 48zM103.1 160H120 328h16.9l5.7 15.9L384.9 272H432v48 80 16 32 64H384V448H64v64H16V448 416 400 320 272H63.1l34.3-96.1 5.7-15.9zM368.6 320c-.4 0-.7 0-1.1 0H80.6c-.4 0-.7 0-1.1 0H64v80H384V320H368.6zM311.1 208H136.9l-22.9 64H333.9l-22.9-64zM112 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 80c0 32-21.5 48-48 48s-48-21.5-48-48C16 48 64 0 64 0s48 48 48 80zm272 48c-26.5 0-48-21.5-48-48c0-32 48-80 48-80s48 48 48 80s-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faNotesMedical = {
    prefix: 'fasr',
    iconName: 'notes-medical',
    icon: [
      512,
      512,
      [],
      'f481',
      
      'M144 416H96V368 80 32h48H432h48V80 320l-96 96H144zm220.1-48L432 300.1V80H144V368H364.1zM320 128v64h64v64H320v64H256V256H192V192h64V128h64zM296 464h24v48H296 24 0V488 152 128l48 0v24l0 312H296z'
      
    ]
  };

  

  
  

  var faSlotMachine = {
    prefix: 'fasr',
    iconName: 'slot-machine',
    icon: [
      640,
      512,
      [],
      'e3ce',
      
      'M400 416v48H384 360 112V416H400zM112 512H360h24 16 48H592h24V488 217.6c14.3-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6V464H448V416h16 48V368 144 96H464 448V48 0H400 112 64V48 96H48 0v48V368v48H48 64v48 48l48 0zm0-416l0-48 288 0V96H112zm352 48V368H48V144H464zM192 204.2V176H168 112 88v48h24 21.9L95.4 331.9 93.9 336h51l45.7-127.9 1.4-3.9zM312 176H288 232 208v48h24 21.9L215.4 331.9l-1.5 4.1h51l45.7-127.9 1.4-3.9V176zm120 28.2V176H408 352 328v48h24 21.9L335.4 331.9l-1.5 4.1h51l45.7-127.9 1.4-3.9z'
      
    ]
  };

  

  
  

  var faWineGlassCrack = {
    prefix: 'fasr',
    iconName: 'wine-glass-crack',
    icon: [
      320,
      512,
      ["fragile"],
      'f4bb',
      
      'M75.8 48H168L96 120l96 104L160 120l64-40-6.4-32h26.6l13.5 149c5.2 57.5-40 107-97.7 107s-102.9-49.5-97.7-107L75.8 48zM136 0H32L14.5 192.7C7.4 270.1 61.9 337.8 136 350V464H48v48H160 272V464H184V350c74.1-12.2 128.6-80 121.5-157.4L288 0H208 136z'
      
    ]
  };

  
    var faFragile = faWineGlassCrack;
  

  
  

  var faG = {
    prefix: 'fasr',
    iconName: 'g',
    icon: [
      448,
      512,
      [103],
      '47',
      
      'M224 80C126.8 80 48 158.8 48 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152h-149-24V232h24H424h24v24c0 123.7-100.3 224-224 224S0 379.7 0 256S100.3 32 224 32c66.7 0 126.7 29.2 167.7 75.5l-35.9 31.8C323.5 102.9 276.4 80 224 80z'
      
    ]
  };

  

  
  

  var faWhistle = {
    prefix: 'fasr',
    iconName: 'whistle',
    icon: [
      640,
      512,
      [],
      'f460',
      
      'M119 95.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L536 448l71.2-76.7L640 336l-37.8-29.9L352.5 108.7C315.9 79.7 270.6 64 224 64c-38.8 0-74.8 11.5-105 31.2zM68.5 143.4c-1.4 .4-2.9 .6-4.5 .6c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16c0 .3 0 .7 0 1c-4 4.6-7.9 9.4-11.5 14.3zM402.9 324.4L365.8 305l-24.2 34.2C315.4 376.1 272.5 400 224 400c-79.5 0-144-64.5-144-144s64.5-144 144-144c35.8 0 70.6 12.1 98.7 34.3l70 55.4-11.9 15.9-14.4 19.2 38.4 28.8 14.4-19.2 11.2-14.9 139.1 110-43.7 47.1L402.9 324.4zM224 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fasr',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      'M0 256C0 167.6 71.6 96 160 96h72 24v48H232 160C98.1 144 48 194.1 48 256s50.1 112 112 112h72 24v48H232 160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H344 320V368h24 72c61.9 0 112-50.1 112-112s-50.1-112-112-112H344 320V96h24 72c88.4 0 160 71.6 160 160zM184 232H392h24v48H392 184 160V232h24z'
      
    ]
  };

  

  
  

  var faMonitorWaveform = {
    prefix: 'fasr',
    iconName: 'monitor-waveform',
    icon: [
      576,
      512,
      ["monitor-heart-rate"],
      'f611',
      
      'M48 80V240H176h13.6l7 11.7 25.5 42.5 60.4-120.9 19.6-39.1 22.5 37.5 41 68.3H424h24v48H424 352 338.4l-7-11.7-25.5-42.5L245.5 354.7l-19.6 39.1-22.5-37.5-41-68.3H48V432H528V80H48zM0 32H48 528h48V80 432v48H528 48 0V432 80 32z'
      
    ]
  };

  
    var faMonitorHeartRate = faMonitorWaveform;
  

  
  

  var faQ = {
    prefix: 'fasr',
    iconName: 'q',
    icon: [
      448,
      512,
      [113],
      '51',
      
      'M48 256c0 97.2 78.8 176 176 176c31 0 60.1-8 85.4-22.1L194.9 256h59.8l93 125.1C380 349.2 400 304.9 400 256c0-97.2-78.8-176-176-176S48 158.8 48 256zM338.2 448.7C304.8 468.6 265.7 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 64.7-27.5 123.1-71.4 163.9L445.1 512H385.3l-47-63.3z'
      
    ]
  };

  

  
  

  var faHorse = {
    prefix: 'fasr',
    iconName: 'horse',
    icon: [
      576,
      512,
      [128014],
      'f6f0',
      
      'M336.8 139l-2.6 21H313 256 198.9 176.2c-35.5 0-64.2 28.8-64.2 64.2c0 8.2 1.6 16.3 4.6 23.9l25.3 63.3 3.5 8.6-3.3 8.7-20.6 54.8-2.7 7.3 2.1 7.5L139.1 464h49.8l-17.6-63.4-2.1-7.5 2.7-7.3 15.8-42.1c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3l-.7-32.7 31.4 9.2 88 25.7c2.1 .6 4.2 1.1 6.3 1.6l19 4v19.4V464h48V318.2 308.1l7.3-7.1c15.1-14.8 24.7-35.3 24.7-58.8c0-11.2-2.2-21.7-6.2-31.4l-1.8-4.4v-4.8V184 160h24 8 9.9l7 7 28.3 28.3 42.7-19V115.3L483.2 48H480h-8H440c-53 0-96.8 39.7-103.2 91zm204-91L572 94.7l4 6V108v84 15.6l-14.3 6.3-72 32-15.1 6.7L464 241.9l0 .3c0 33.2-12.2 62.9-32 85.5V488v24H408 312 288V488 364.5l-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-13 34.8 24 86.3 8.5 30.4H220.5 120.8 102.6l-4.9-17.6L74.6 411.3l-4.2-15.1-2.1-7.5 2.7-7.3 5.5-14.6 17.3-46.1L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248v64 24H0V312 248c0-47.3 37.3-85.9 84.1-87.9c20.3-29.1 54-48.1 92.1-48.1h22.6H256h37.3C310.9 47.5 369.9 0 440 0h32 8 16 12.8H536h24V48H540.8zM448 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faDialMed = {
    prefix: 'fasr',
    iconName: 'dial-med',
    icon: [
      576,
      512,
      [],
      'e15f',
      
      'M320 0H256V64h64V0zM128 64H64v64h64V64zm384 0H448v64h64V64zm0 192v64h64V256H512zm0 192H448v64h64V448zM64 448v64h64V448H64zM0 256v64H64V256H0zm176 32c0-53.6 37.7-98.4 88-109.4V288v24h48V288 178.6c50.3 11 88 55.8 88 109.4c0 61.9-50.1 112-112 112s-112-50.1-112-112zM288 128a160 160 0 1 0 0 320 160 160 0 1 0 0-320z'
      
    ]
  };

  

  
  

  var faAngleRight = {
    prefix: 'fasr',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      'M289.9 256l-17 17L113 433l-17 17L62.1 416l17-17 143-143L79 113l-17-17L96 62.1l17 17L273 239l17 17z'
      
    ]
  };

  

  
  

  var faBellOn = {
    prefix: 'fasr',
    iconName: 'bell-on',
    icon: [
      640,
      512,
      [128365],
      'f8fa',
      
      'M352 0H288V51.2C215 66 160 130.6 160 208v88L96 368v48h48H496h48V368l-64-72V208c0-77.4-55-142-128-156.8V0zm80 314.2l12.1 13.6L479.8 368H160.2l35.7-40.1L208 314.2V296 208c0-61.9 50.1-112 112-112s112 50.1 112 112v88 18.2zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM0 176v48H24h80 24V176H104 24 0zm536 0H512v48h24 80 24V176H616 536zM608.2 50.7L586.7 7.8 565.3 18.5l-64 32L479.8 61.3l21.5 42.9 21.5-10.7 64-32 21.5-10.7zM53.3 61.5l64 32 21.5 10.7 21.5-42.9L138.7 50.5l-64-32L53.3 7.8 31.8 50.7 53.3 61.5z'
      
    ]
  };

  

  
  

  var faFilters = {
    prefix: 'fasr',
    iconName: 'filters',
    icon: [
      640,
      512,
      [],
      'e17e',
      
      'M384 272V254.9l-10.9-13.3L240.9 80H591.1L458.9 241.6 448 254.9V272 380.1l-64-51.2V272zM192 32V80 96L336 272v80l112 89.6L496 480V418.5 272L640 96V80 32H592 240 192zM304 283.4l-9.5-11.6-27.6 33.8L256 318.9V336v76.1l-64-51.2V336 318.9l-10.8-13.3L48.9 144h141l-22.7-27.7-7.2-8.8V96H48 0v48 16L144 336v48l112 89.6L304 512V450.5 367.4 352 336 283.4z'
      
    ]
  };

  

  
  

  var faMugMarshmallows = {
    prefix: 'fasr',
    iconName: 'mug-marshmallows',
    icon: [
      512,
      512,
      [],
      'f7b7',
      
      'M226.7 32l-73.4 73.4L130.7 128H32V32H226.7zM176 128l96-96 96 96H176zm-24 80v56 24H104V264 208H48V432H336V208H152zM0 160H48 336h16 32 16c61.9 0 112 50.1 112 112s-50.1 112-112 112H384v48 48H336 48 0V432 208 160zM384 336h16c35.3 0 64-28.7 64-64s-28.7-64-64-64H384V336z'
      
    ]
  };

  

  
  

  var faHorseSaddle = {
    prefix: 'fasr',
    iconName: 'horse-saddle',
    icon: [
      576,
      512,
      [],
      'f8c3',
      
      'M440 48h32 8 3.2L528 115.3v61.1l-42.7 19L457 167l-7-7H440h-8H408v24 17.7 4.8l1.8 4.4c4 9.6 6.2 20.2 6.2 31.4c0 23.5-9.6 44.1-24.7 58.8l-7.3 7.1v10.1V464H336V346.2 326.8l-19-4c-2.1-.4-4.2-1-6.3-1.6L272 309.8V264h40 24V240 145.4l.8-6.5C343.2 87.7 387 48 440 48zM224 295.8l-1.3-.4-31.4-9.2 .7 32.7c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L172 385.8l-2.7 7.3 2.1 7.5L188.9 464H139.1l-18.2-65.6-2.1-7.5 2.7-7.3 20.6-54.8 3.3-8.7-3.5-8.6-25.3-63.3c-3-7.6-4.6-15.7-4.6-23.9c0-29.9 20.4-55 48-62.2V240v24h24 40v31.8zM208 160h48 32v56H248 208V160zM572 94.7L540.8 48H560V0H536 508.8 496 480h-8H440C369.9 0 310.9 47.5 293.3 112H256 198.9 176.2c-38.1 0-71.8 19-92.1 48.1C37.3 162.1 0 200.7 0 248v64 24H48V312 248c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6L76.6 366.7l-5.5 14.6-2.7 7.3 2.1 7.5 4.2 15.1 23.1 83.2 4.9 17.6h18.2 99.6 31.6l-8.5-30.4-24-86.3 13-34.8c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5V488v24h24 96 24V488 327.8c19.8-22.6 32-52.3 32-85.5l0-.3 10.7 10.7 15.1-6.7 72-32 14.3-6.3V192 108v-7.3l-4-6zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faJoint = {
    prefix: 'fasr',
    iconName: 'joint',
    icon: [
      640,
      512,
      [],
      'f595',
      
      'M464 0H416V43c0 50.9 20.2 99.8 56.2 135.8l21 21c12 12 18.7 28.3 18.7 45.3v43h48V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C479.2 117.8 464 81.2 464 43V0zM592 288h48V245c0-50.9-20.2-99.8-56.2-135.8l-21-21C550.7 76.2 544 60 544 43V0H496V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v43zM262.6 400.6L315.4 464H288c-73.9 0-135.5-15.4-180.3-32c39.6-14.7 92.2-28.4 154.9-31.4zM377.9 464l-53.3-64h97.5l53.3 64H377.9zm160 0l-53.3-64H592v64H537.9zM0 432s17 12.1 48.1 26.9C96.9 482.2 180.5 512 288 512H592h48V464 400 352H592 288c-107.5 0-191.1 29.8-239.9 53.1C17 419.9 0 432 0 432z'
      
    ]
  };

  

  
  

  var faBracketRound = {
    prefix: 'fasr',
    iconName: 'bracket-round',
    icon: [
      192,
      512,
      ["parenthesis"],
      '28',
      
      'M168.9 64.3L148.3 76.6C115.3 96.3 48 160.7 48 256s67.3 159.7 100.3 179.4l20.6 12.3-24.6 41.2-20.6-12.3C82 451.8 0 374.1 0 256S82 60.2 123.7 35.4l20.6-12.3 24.6 41.2z'
      
    ]
  };

  
    var faParenthesis = faBracketRound;
  

  
  

  var faIgloo = {
    prefix: 'fasr',
    iconName: 'igloo',
    icon: [
      576,
      512,
      [],
      'f7ae',
      
      'M528 368v64H400V368H528zm0-48H480V192h11.1c23.4 37 36.9 80.9 36.9 128zM432 192V320H395.4c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80H144V192H432zM96 320H48c0-47.1 13.5-91 36.9-128H96V320zM288 80c5.4 0 10.7 .2 16 .5V144H124.8C167.7 104.3 225 80 288 80zm64 64V88.6c37.6 10.4 71.4 29.6 99.2 55.4H352zM176 368v64H48V368H176zM48 480H176 400 528h48V432 320C576 160.9 447.1 32 288 32S0 160.9 0 320V432v48H48zM288 288c35.3 0 64 28.7 64 64v80H224V352c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faSchool = {
    prefix: 'fasr',
    iconName: 'school',
    icon: [
      640,
      512,
      [127979],
      'f549',
      
      'M466.7 144l-11.4-6.8L320 56 184.7 137.2 173.3 144H160 48V464H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64v80H592V144H480 466.7zM592 96h48v48V464v48H592 48 0V464 144 96H48 160L320 0 480 96H592zM160 192v96H96V192h64zm320 0h64v96H480V192zM160 320v96H96V320h64zm320 0h64v96H480V320zM240 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm96-48H304v16 32 16h16 24 16V176H344h-8V160 144z'
      
    ]
  };

  

  
  

  var faBriefcaseBlank = {
    prefix: 'fasr',
    iconName: 'briefcase-blank',
    icon: [
      512,
      512,
      [],
      'e0c8',
      
      'M152 0H128V24 96H48 0v48V432v48H48 464h48V432 144 96H464 384V24 0H360 152zM336 96H176V48H336V96zM152 144H360 464V432H48V144H152z'
      
    ]
  };

  

  
  

  var faChartCandlestick = {
    prefix: 'fasr',
    iconName: 'chart-candlestick',
    icon: [
      512,
      512,
      [],
      'e0e2',
      
      'M48 56V32H0V56 456v24H24 488h24V432H488 48V56zm272-8V32H288V48 96H256V256h32v48 16h32V304 256h32V96H320V48zm64 144V320h32v48 16h32V368 320h32V192H448V144 128H416v16 48H384zM224 128H192V80 64H160V80v48H128V320h32v48 16h32V368 320h32V128z'
      
    ]
  };

  

  
  

  var faRoadBarrier = {
    prefix: 'fasr',
    iconName: 'road-barrier',
    icon: [
      640,
      512,
      [],
      'e562',
      
      'M48 56V32H0V56 456v24H48V456l0-152H592l0 152v24h48V456l0-152V256 128 80l0-24V32H592V56l0 24H48h0V56zm544 72V256H506.8l64-128H592zm-277.2 0h74.3l-64 128H250.8l64-128zM453.2 256H378.8l64-128h74.3l-64 128zm-192-128l-64 128H122.8l64-128h74.3zm-128 0l-64 128H48V128h85.2z'
      
    ]
  };

  

  
  

  var faMortarPestle = {
    prefix: 'fasr',
    iconName: 'mortar-pestle',
    icon: [
      512,
      512,
      [],
      'f5a7',
      
      'M252.3 160L469.5 0l40.6 47.2L397.3 160H252.3zM480 256c0 63.2-25.4 116.1-73.4 150.3c-12.6 9-26.7 16.6-42.3 22.9c6.8 10.3 11.6 22.1 14.7 34.8c.4 1.6 .8 3.2 1.1 4.8c2.8 13.5 4 28 4 43.2H336 176 128c0-15.2 1.2-29.7 4-43.2c.3-1.6 .7-3.2 1.1-4.8c3.1-12.7 7.9-24.5 14.7-34.8c-15.6-6.2-29.8-13.9-42.3-22.9C57.4 372.1 32 319.2 32 256V240H24 0V192H24h8H48 80 432h32 16 8 24v48H488h-8v16zM324.2 455.6l-32.5-49.2 54.8-21.8C402.6 362.2 432 317 432 256V240H80v16c0 61 29.4 106.2 85.6 128.6l54.8 21.8-32.5 49.2c-1.6 2.4-3.1 5.2-4.4 8.4H328.6c-1.3-3.1-2.8-5.9-4.4-8.4z'
      
    ]
  };

  

  
  

  var faShieldCheck = {
    prefix: 'fasr',
    iconName: 'shield-check',
    icon: [
      512,
      512,
      [],
      'f2f7',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z'
      
    ]
  };

  

  
  

  var faUserAlien = {
    prefix: 'fasr',
    iconName: 'user-alien',
    icon: [
      448,
      512,
      [],
      'e04a',
      
      'M112 167c0-67.7 52.1-119 112-119s112 51.3 112 119c0 39.3-27.6 81.6-65.7 119c-16.5 16.2-33.1 29.7-46.3 39.6c-13.2-9.9-29.9-23.4-46.3-39.6C139.6 248.6 112 206.3 112 167zm86.9 176l0 0c0 0 0 0 0 0zM224 0C135.6 0 64 74.8 64 167c0 119.3 160 217 160 217l-9.8 16h0l9.8-16 9.8 16h0L224 384s160-97.7 160-217C384 74.8 312.4 0 224 0zM180.1 392.7c-13.5-10-31-23.7-49.2-40.7H48L14.4 464 0 512H50.1 397.9 448l-14.4-48L400 352H317.1c-18.1 16.9-35.6 30.7-49.2 40.7c-3.7 2.7-7.1 5.2-10.2 7.3H364.3l19.2 64H64.5l19.2-64H190.3c-3.1-2.2-6.5-4.6-10.2-7.3zM208 224c0-30.9-25.1-56-56-56H128v8c0 30.9 25.1 56 56 56h24v-8zm88-56c-30.9 0-56 25.1-56 56v8h24c30.9 0 56-25.1 56-56v-8H296z'
      
    ]
  };

  

  
  

  var faSnowman = {
    prefix: 'fasr',
    iconName: 'snowman',
    icon: [
      512,
      512,
      [9731,9924],
      'f7d0',
      
      'M256 0C189.7 0 136 53.7 136 120c0 19 4.4 37 12.3 53c-7.2 9.3-13.2 19.6-17.8 30.6L104 192.2V152 128H56v24 19.6l-14.5-6.2-22.1-9.5L.5 200l22.1 9.5 48 20.6 49.5 21.2c-.1 1.6-.1 3.1-.1 4.7c0 12.5 1.7 24.7 4.9 36.3C106.7 318.2 96 349.9 96 384c0 49.1 22.1 93 56.9 122.3l6.7 5.7h8.8H343.6h8.8l6.7-5.7C393.9 477 416 433.1 416 384c0-34.1-10.7-65.8-28.9-91.7c3.2-11.6 4.9-23.7 4.9-36.3c0-1.6 0-3.1-.1-4.7l49.5-21.2 48-20.6 22.1-9.5-18.9-44.1-22.1 9.5L456 171.6V152 128H408v24 40.2l-26.5 11.4c-4.6-11-10.6-21.3-17.8-30.6c7.9-16 12.3-34 12.3-53C376 53.7 322.3 0 256 0zM184 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 15.6-5 30-13.4 41.8l-12 16.8L317.4 193c16.4 16 26.6 38.3 26.6 63c0 11.3-2.1 22.1-6 32l-5.2 13.2 9.1 10.9C358.2 331.6 368 356.6 368 384c0 31.3-12.8 59.6-33.6 80H177.6c-20.8-20.4-33.6-48.7-33.6-80c0-27.4 9.8-52.4 26.1-71.8l9.1-10.9L174 288c-3.9-9.9-6-20.7-6-32c0-24.7 10.2-47 26.6-63l14.8-14.4-12-16.8C189 150 184 135.6 184 120zm88 104H240v32h32V224zm0 96V288H240v32h32zm0 32H240v32h32V352zM224 120a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 40.3c0 2.9 .8 5.8 2.3 8.3L256 176l13.7-23.4c1.5-2.5 2.3-5.4 2.3-8.3V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v.3z'
      
    ]
  };

  

  
  

  var faWheatAwnCircleExclamation = {
    prefix: 'fasr',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e598',
      
      'M493.8 52.2l17-17L476.8 1.3l-17 17L330.4 147.7c-.8-8-2.3-15.9-4.5-23.6L329 121l64-64 17-17L376 6.1 359 23 302.5 79.5c-1.5-1.9-3.1-3.7-4.7-5.5c-1.1-1.2-2.3-2.5-3.5-3.7l-.9-.9L264 40 231.2 72.8l-.9 .9-.3 .3c-16.9 17.4-27 38.9-30.4 61.2L184 120l-30.5 28.6c-19.4 18.2-30.8 41.6-34.2 66L104 200 74.4 227.8C28.2 271.1 27.1 344 71.8 388.7l8.7 8.7 0 0L18.2 459.8l-17 17 33.9 33.9 17-17 62.4-62.4 8.8 8.8c44.7 44.7 117.5 43.6 160.8-2.5L312 408l-9.1-9.5c6.4-1.4 12.7-3.5 18.7-6.2c-1.1-7.9-1.7-16-1.7-24.3c0-13 1.4-25.7 4.1-37.8l-7.1 7.5c-18.6 19.7-49.7 20.2-68.9 1.1L229 319.7c29.6-18.6 68.8-15.8 95.6 8.1c4.8-20.5 13.2-39.7 24.5-56.8c-8.4-2-16.5-6.2-23.1-12.8l-16.8-16.8c21.7-13.7 48.6-16 72-6.8c17.4-15 37.7-26.6 60-33.9L489 153l17-17L472 102.1l-17 17-64 64-3.1 3.1c-7.7-2.3-15.6-3.8-23.6-4.5L493.8 52.2zm-388 302.6c-24.4-24.4-24.9-63.3-2.1-88.4c24.3 26.6 27.4 65.7 9.2 95.5l-7.1-7.1zm139.8 53.5c-25 22.9-64 22.3-88.4-2L150 399c29.9-18.2 69-15.1 95.6 9.3zM184.9 275.6c-24.6-24.6-24.9-64-1.5-89c24.5 26.8 27.5 66.4 8.8 96.3l-7.3-7.3zm78.9-167.5c23 26.9 25.3 65.5 6.8 94.7l-5.5-5.5c-24.6-24.6-25-64.1-1.3-89.2zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64H480V416h32v32zm0-176v16 80 16H480V368 288 272h32z'
      
    ]
  };

  

  
  

  var faGunSquirt = {
    prefix: 'fasr',
    iconName: 'gun-squirt',
    icon: [
      576,
      512,
      [],
      'e19d',
      
      'M128 56V32H80V56v9.3C34.6 72.9 0 112.4 0 160c0 50.4 38.8 91.7 88.1 95.7L44 432 32 480H81.5 192l26-104h54v16 24h48V392 352 312 288H272v24 16H230l18-72H520h24V232 192h32V128H544V88 64H520 128V56zm82.5 152H100 96c-26.5 0-48-21.5-48-48s21.5-48 48-48h32H496v96H260 210.5zM93.5 432l44-176h61l-44 176h-61zM96 144H80v32H96 448h16V144H448 96z'
      
    ]
  };

  

  
  

  var faPiano = {
    prefix: 'fasr',
    iconName: 'piano',
    icon: [
      512,
      512,
      [],
      'f8d4',
      
      'M432 384v32 16H400V416 384H368v32 16H336V416 384H240v32 16H208V416 384H176v32 16H144V416 384H112v32 16H80V416 384H48v80H464V384H432zM48 336H464V317.7L362.5 266.9 336 253.7V224 192c0-79.5-64.5-144-144-144S48 112.5 48 192V336zm464-48v48 24 24 80 48H464 48 0V464 384 360 336 192C0 86 86 0 192 0S384 86 384 192v32l128 64z'
      
    ]
  };

  

  
  

  var faPepper = {
    prefix: 'fasr',
    iconName: 'pepper',
    icon: [
      512,
      512,
      [129745],
      'e432',
      
      'M277.8 102.3c-4.5-26.6-15.2-49-25.5-65.4c-6.8-10.8-13.6-19.4-18.7-25.4c-2.6-3-4.8-5.3-6.4-7c-.8-.8-1.5-1.5-2-2l-.6-.6-.2-.2-.1-.1 0 0 0 0s0 0-16.4 17.5s-16.4 17.5-16.4 17.5l0 0 0 0 0 0 .2 .2c.2 .2 .6 .6 1.1 1.1c1 1 2.6 2.7 4.5 4.9c3.9 4.5 9.1 11.1 14.3 19.4c6.6 10.6 12.9 23.4 16.7 37.9c-16.2-5-34-5.8-51.6-1.4l0 0 0 0c-10.5 2.6-20.1 6.9-28.7 12.4C126.5 97.5 99.5 92.2 72.7 98.9C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.9c10.5-2.6 20.1-6.9 28.7-12.4c5.7 3.6 11.8 6.7 18.3 9.2c10.6 4 22 6.1 33.7 6.1h0l0-24 0 24h0c11.7 0 23.1-2.1 33.7-6.1c6.5-2.4 12.6-5.5 18.3-9.2c8.6 5.5 18.3 9.8 28.7 12.4c51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.9-116.4c-26.8-6.7-53.8-1.4-75.3 12.4c-8.6-5.6-18.3-9.8-28.7-12.4c-19.8-5-39.7-3.4-57.4 3.4zM84.4 145.4c10.5-2.6 21.1-1.6 30.4 2.4c-10.4 20-13.8 43.8-7.9 67.5l33.6 134.4 5.8 23.3 46.6-11.6L187 338.1 153.4 203.6c-6.2-25 8.3-50.3 32.7-57.6c.7-.2 1.5-.4 2.2-.6c18.7-4.7 37.6 2.3 49 16.4l18.7 23 18.7-23c11.4-14.1 30.3-21.1 49-16.4c9.2 2.3 17 7 23 13.3L364 176.9l17.3-18.1c11.6-12.1 29-17.7 46.3-13.4c25.7 6.4 41.4 32.5 34.9 58.2l-56 224c-6.4 25.7-32.5 41.4-58.2 34.9c-9.2-2.3-17-7-23-13.3L308 431.1l-17.3 18.1c-.2 .2-.5 .5-.7 .7l0 0c-4.7 4.7-10.5 8.5-17.1 11l0 0c-5.3 2-11 3.1-16.8 3.1h0c-5.8 0-11.5-1.1-16.8-3.1l0 0c-6.6-2.4-12.3-6.2-17-10.9l0 0c-.2-.2-.5-.5-.7-.8L204 431.1l-17.3 18.1c-6 6.3-13.9 11-23 13.3c-25.7 6.4-51.8-9.2-58.2-34.9l-56-224c-6.4-25.7 9.2-51.8 34.9-58.2z'
      
    ]
  };

  

  
  

  var faTruckMedical = {
    prefix: 'fasr',
    iconName: 'truck-medical',
    icon: [
      640,
      512,
      [128657,"ambulance"],
      'f0f9',
      
      'M48 48V368H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h48V48H48zM480 512c-53 0-96-43-96-96h-8-8H320 256c0 53-43 96-96 96s-96-43-96-96H48 0V368 48 0H48 368h48V48 96h56 9.9l7 7L601 215l7 7V232 368h8 24v48H616 576c0 53-43 96-96 96zm78.1-272l-96-96H416v96H558.1zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80h64v64h64v64H240v64H176V208H112V144h64V80z'
      
    ]
  };

  
    var faAmbulance = faTruckMedical;
  

  
  

  var faApartment = {
    prefix: 'fasr',
    iconName: 'apartment',
    icon: [
      576,
      512,
      [],
      'e468',
      
      'M496 192H448V144 48 0H400 176 128V48 96H80 48 0v48V464v48H48h80H256h32 32H448h80 48V464 240 192H528 496zM320 384H256v80H128 48V144h80 48V96 48H400V192v48h48 80V464H448 320V384zm-16-48h64V272H304v64zm192 96V368H432v64h64zM80 336h64V272H80v64zm64 96V368H80v64h64zm64-96h64V272H208v64zM368 80H304v64h64V80zM208 80v64h64V80H208zM368 240V176H304v64h64zm64 96h64V272H432v64zM144 240V176H80v64h64zm64 0h64V176H208v64z'
      
    ]
  };

  

  
  

  var faTriangle = {
    prefix: 'fasr',
    iconName: 'triangle',
    icon: [
      512,
      512,
      [9650],
      'f2ec',
      
      'M0 480l27.4-48L228.4 80.4 256 32l27.6 48.4L484.6 432 512 480H456.7 55.3 0zM256 128.7L82.7 432H429.3L256 128.7z'
      
    ]
  };

  

  
  

  var faFileMov = {
    prefix: 'fasr',
    iconName: 'file-mov',
    icon: [
      512,
      512,
      [],
      'e647',
      
      'M48 464H64v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zm208-96V496v16H224V496 421.8l-17.9 33.7-13.9 26.2-14.3-26L160 423v73 16H128V496 368 352l16 0 4 0 9.5 0 4.6 8.3 29.7 54 28.5-53.8 4.5-8.5 9.6 0 5.6 0 16 0v16zm192 0v35c0 17.3 3.1 34.4 9.2 50.6l6.8 18.2 6.8-18.2c6.1-16.2 9.2-33.3 9.2-50.6V368 352h32v16 35c0 21.1-3.8 42-11.2 61.8L487 501.6 483.1 512H472 456 444.9L441 501.6l-13.8-36.8C419.8 445 416 424.1 416 403V368 352h32v16zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z'
      
    ]
  };

  

  
  

  var faHeadSideCoughSlash = {
    prefix: 'fasr',
    iconName: 'head-side-cough-slash',
    icon: [
      640,
      512,
      [],
      'e062',
      
      'M112 381.2V448v16 48H96 64V480 464 381.2c-41-41.9-64-98.3-64-157c0-38.7 9.8-75.1 27.1-106.9l38.4 30.3C54.3 170.8 48 196.8 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14v19.6zM462.1 336L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 40 31C126 17.1 173 0 224 0h32C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1V264v24 16 32H496 480 464h-1.9zm-61.8-48H448h16V270.1l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48H224c-35.4 0-68.4 10.5-96 28.6L400.3 288zM320 368l19.2-4.8L448 449v23 24H424 320v16H272V488 472 448h24H400V424v-9.3L320 408V368zm272 16a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faPear = {
    prefix: 'fasr',
    iconName: 'pear',
    icon: [
      512,
      512,
      [],
      'e20c',
      
      'M510.7 35.2l-17 17L457.9 88c33.9 49.8 28.8 118.3-15.4 162.5l-58.8 58.8c.2 3.5 .3 7.1 .3 10.7c0 106-86 192-192 192S0 426 0 320S86 128 192 128c3.6 0 7.2 .1 10.7 .3l58.8-58.8c44.2-44.2 112.6-49.3 162.5-15.4l35.9-35.9 17-17 33.9 33.9zM367 111l22-22c-30.2-15.7-68.2-10.9-93.6 14.4l-58.8 58.8-15.2 15.2-21.4-1.2c-2.7-.1-5.3-.2-8.1-.2c-79.5 0-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144c0-2.7-.1-5.4-.2-8.1l-1.2-21.4 15.2-15.2 58.8-58.8c25.3-25.3 30.1-63.4 14.4-93.6l-22 22-17 17L350.1 128l17-17zM256 320h32c0 53-43 96-96 96V384c35.3 0 64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faStaffSnake = {
    prefix: 'fasr',
    iconName: 'staff-snake',
    icon: [
      384,
      512,
      ["rod-asclepius","rod-snake","staff-aesculapius"],
      'e579',
      
      'M208 511l0 1H176l0-1-2-63H120 96V400h24 52.5l-2-64H144c-44.2 0-80-35.8-80-80c0-41.5 31.6-75.6 72-79.6V225c-13.8 3.6-24 16.1-24 31c0 17.7 14.3 32 32 32h25L163 96H127.4c.4 2.6 .6 5.3 .6 8c0 30.9-25.1 56-56 56H0V112C0 76.7 28.7 48 64 48h8 89.5L160 0h64l-1.5 48H296c48.6 0 88 39.4 88 88s-39.4 88-88 88H248V176h48c22.1 0 40-17.9 40-40s-17.9-40-40-40H221l-6 192h25c44.2 0 80 35.8 80 80s-35.8 80-80 80V400c17.7 0 32-14.3 32-32s-14.3-32-32-32H213.5L208 511zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faRodAsclepius = faStaffSnake;
  
    var faRodSnake = faStaffSnake;
  
    var faStaffAesculapius = faStaffSnake;
  

  
  

  var faSpiderBlackWidow = {
    prefix: 'fasr',
    iconName: 'spider-black-widow',
    icon: [
      512,
      512,
      [],
      'f718',
      
      'M0 118.7v21.2l1.2 3.7 24 72L29 227l11.4 3.8L116.1 256 40.4 281.2 29 285l-3.8 11.4-24 72L0 372.1v21.2l39.2 13.1 7.6-22.8L67 323l72.6-24.2c-.8 3.2-1.5 6.4-2 9.7L79 367 67.7 378.4l6.2 14.8 40 96 9.2 22.2 44.3-18.5-9.2-22.2-33.8-81.2 15.5-15.5C153.2 425.8 200.1 464 256 464s102.8-38.2 116.2-89.9l15.5 15.5-33.8 81.2-9.2 22.2 44.3 18.5 9.2-22.2 40-96 6.2-14.8L433 367l-58.6-58.6c-.5-3.3-1.2-6.5-2-9.7L445 323l20.2 60.6 7.6 22.8L512 393.3V372.1l-1.2-3.7-24-72L483 285l-11.4-3.8L395.9 256l75.7-25.2L483 227l3.8-11.4 24-72 1.2-3.7V118.7l-39.2-13.1-7.6 22.8L445 189l-84.2 28.1L433 145l11.4-11.4-6.2-14.8-40-96L388.9 .6 344.6 19.1l9.2 22.2 33.8 81.2L352 158.1c-.6-32.8-17.8-61.6-43.3-78.4L285.4 64.4 273.7 89.7 256 128.1 238.3 89.7 226.6 64.4 203.3 79.7c-25.6 16.8-42.7 45.5-43.3 78.4l-35.7-35.7 33.8-81.2 9.2-22.2L123.1 .6l-9.2 22.2-40 96-6.2 14.8L79 145l72.1 72.1L67 189 46.8 128.4l-7.6-22.8L0 118.7zM208 160c0-5.5 .9-10.8 2.6-15.7l15.6 33.8 6.4 13.9H248h16 15.4l6.4-13.9 15.6-33.8c1.7 4.9 2.6 10.2 2.6 15.7v88c0 3.4-.4 6.7-1 9.9L300.4 270l8.4 9.1C320.8 292 328 309.1 328 328v16c0 39.8-32.2 72-72 72s-72-32.2-72-72V328c0-18.9 7.2-36 19.1-48.9l8.4-9.1L209 257.9c-.7-3.2-1-6.5-1-9.9V160zm8 128v16l24 32-24 32v16h80V368l-24-32 24-32V288H216z'
      
    ]
  };

  

  
  

  var faCircleD = {
    prefix: 'fasr',
    iconName: 'circle-d',
    icon: [
      512,
      512,
      [],
      'e104',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H160v24V360v24h24 72c70.7 0 128-57.3 128-128s-57.3-128-128-128H184zm72 208H208V176h48c44.2 0 80 35.8 80 80s-35.8 80-80 80z'
      
    ]
  };

  

  
  

  var faHammerWar = {
    prefix: 'fasr',
    iconName: 'hammer-war',
    icon: [
      384,
      512,
      [],
      'f6e4',
      
      'M216 24V0H168V24 58.7L48 32H0V80 240v48H48l144-32 144 32h48V240 80 32H336L216 58.7V24zm0 270.1l-24-5.3-24 5.3V488v24h48V488 294.1zm-34.4-85L48 238.8V81.2l133.6 29.7c6.9 1.5 14 1.5 20.8 0L336 81.2V238.8L202.4 209.1c-6.9-1.5-14-1.5-20.8 0z'
      
    ]
  };

  

  
  

  var faBicycle = {
    prefix: 'fasr',
    iconName: 'bicycle',
    icon: [
      640,
      512,
      [128690],
      'f206',
      
      'M312 32H288V80h24 25.7l34.6 64H222.9l-27.4-38-7.2-10H176 120 96v48h24 43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49 13.7l7-11.8 84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L373.1 44.6 366.3 32H352 312zM454.6 296.3l36.3 67.1 11.4 21.1 42.2-22.8-11.4-21.1-36.3-67.1c4.9-.9 10-1.4 15.2-1.4c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-21.7 8.6-41.3 22.6-55.7zM136.9 272.5l-30.4 60.8L128 368h78.4c-7.4 36.5-39.7 64-78.4 64c-44.2 0-80-35.8-80-80s35.8-80 80-80c3 0 6 .2 8.9 .5zM166.8 320l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z'
      
    ]
  };

  

  
  

  var faBangladeshiTakaSign = {
    prefix: 'fasr',
    iconName: 'bangladeshi-taka-sign',
    icon: [
      384,
      512,
      [],
      'e2e6',
      
      'M-2 80H40c22.1 0 40 17.9 40 40v56H0v48H80V392c0 48.6 39.4 88 88 88h32c101.6 0 184-82.4 184-184V264c0-48.6-39.4-88-88-88H280 256v48h24 16c22.1 0 40 17.9 40 40v32c0 75.1-60.9 136-136 136H168c-22.1 0-40-17.9-40-40V224h64V176H128V120c0-48.6-39.4-88-88-88H-2V80z'
      
    ]
  };

  

  
  

  var faCalendars = {
    prefix: 'fasr',
    iconName: 'calendars',
    icon: [
      512,
      512,
      [],
      'e0d7',
      
      'M248 0V24 64H360V24 0h48V24 64H512v64 48 16V368v48H464 144 96V368 192 176 128 64H200V24 0h48zM144 192V368H464V192H144zm-96-8V464H392h24v48H392 24 0V488 184 160H48v24z'
      
    ]
  };

  

  
  

  var faCircleArrowUpRight = {
    prefix: 'fasr',
    iconName: 'circle-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e0fc',
      
      'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm88 144h24v24V328v24H320V328 225.9L185 361l-17 17L134.1 344l17-17 135-135H192 168V144h24H344z'
      
    ]
  };

  

  
  

  var faLeafyGreen = {
    prefix: 'fasr',
    iconName: 'leafy-green',
    icon: [
      576,
      512,
      [129388],
      'e41d',
      
      'M226.4 37.9c-7.8 12.9-13.4 27.3-16.2 42.7L144 146.7v96l-48 48v98.7L72.1 413.4l0-80.4L17.9 278.9V206.3c-25.3-30.1-23.8-75.1 4.5-103.4C34.3 91.1 49 83.9 64.3 81.4c1.8-20.2 10.4-39.8 25.8-55.3c34.9-34.9 91.5-34.9 126.4 0c3.7 3.7 7 7.6 9.9 11.7zM489.1 181.7l24-28.6c9.3-11.1 14.9-25.4 14.9-41.1c0-35.3-28.7-64-64-64c-15.7 0-29.9 5.6-41.1 14.9l-28.6 24L364 65c-7.9-5.7-17.5-9-28-9c-25.1 0-45.7 19.3-47.8 43.8l-1.5 17.4-12.4 12.4L224 179.9V256v19.9l-14.1 14.1L176 323.9v42.2l96-96V184 160h48v24 38.1l7-7L439 103l17-17L489.9 120l-17 17-71 71H440h24v48H440 353.9l-41 41-103 103h42.2l33.9-33.9L300.1 352H320h76.1l50.3-50.3 12.4-12.4 17.4-1.5c24.5-2.1 43.8-22.7 43.8-47.8c0-10.5-3.3-20.2-9-28l-21.9-30.3zM416 400H320l-48 48-110.1 0-28.8 28.8-17 17-17 17L65.3 476.8l17-17 17-17L128 414.1V304l48-48V160l64.4-64.4C244.6 46.5 285.8 8 336 8c21 0 40.3 6.7 56.1 18.1C411.6 9.8 436.6 0 464 0c61.9 0 112 50.1 112 112c0 27.4-9.8 52.4-26.1 71.9C561.3 199.7 568 219 568 240c0 50.2-38.5 91.4-87.6 95.6L416 400z'
      
    ]
  };

  

  
  

  var faSquid = {
    prefix: 'fasr',
    iconName: 'squid',
    icon: [
      512,
      512,
      [129425],
      'e450',
      
      'M512 0c-43.4 7.2-81.7 16-115.7 26L283.4 8.2 261.2 4.7l3.9 22.1 8.8 49.7c-81.7 47.1-111.8 102.9-116.4 147.9l-36.3-36.3c-6.2-6.2-6.2-16.4 0-22.6l56.3-56.3c18.9-18.9 18.7-49.6-.4-68.3l-29-28.4-10-9.8-11 8.6-3.7 2.9C86.6 42.9 83.6 95.6 113 128.4L98.5 142.9c-18.7 18.7-18.7 49.1 0 67.9L143.8 256l-33.9 33.9L76.5 256.6c-19.1-19.1-50.2-18.7-68.7 .9L4.4 261l23.2 22 3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l55.4 55.4c-6.7 1.8-13.2 4.9-19.1 9.4l-26.2 20c-3.5 2.6-7.7 4.1-12 4.1c-11 0-19.9-8.9-19.9-19.9V336l0-16H0l0 16 0 12.1C0 376.8 23.2 400 51.9 400c11.4 0 22.4-3.7 31.4-10.6l26.2-20c9.2-7 22.2-6.1 30.4 2.1c8.1 8.1 9.1 20.9 2.3 30.1L122.1 429c-6.6 9-10.1 19.8-10.1 30.9c0 28.8 23.3 52.1 52.1 52.1H176h16V480H176 164.1c-11.1 0-20.1-9-20.1-20.1c0-4.3 1.4-8.5 3.9-11.9L168 420.6c4.2-5.7 7.1-11.9 8.8-18.4l56 56c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5L250.6 508l2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8L223 403.1l33.9-33.9 45.3 45.3c18.7 18.7 49.1 18.7 67.9 0l14.5-14.5c32.7 29.2 85.3 26.1 113.6-10.9l2.5-3.3 8.3-10.9-9.5-9.9-27.5-28.6c-18.6-19.4-49.5-19.7-68.6-.7l-56.1 56.1c-6.2 6.2-16.4 6.2-22.6 0l-37.2-37.2c44.9-4.6 100.7-34.4 147.7-115.8l50.8 9 22.1 3.9-3.5-22.1L486.5 114.2C496.3 80.7 504.9 42.7 512 0zM184.9 264a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm32 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm5.5-112.6c5.9-43 48-118.6 234.2-159.2C416 242.5 340.4 284.6 297.5 290.5l-75-75z'
      
    ]
  };

  

  
  

  var faSparkles = {
    prefix: 'fasr',
    iconName: 'sparkles',
    icon: [
      512,
      512,
      [10024],
      'f890',
      
      'M384 64L320 96l64 32 32 64 32-64 64-32L448 64 416 0 384 64zM256 320l74.3-37.2L384 256l-53.7-26.8L256 192l-37.2-74.3L192 64l-26.8 53.7L128 192 53.7 229.2 0 256l53.7 26.8L128 320l37.2 74.3L192 448l26.8-53.7L256 320zm-64 20.7l-21.1-42.1-7.2-14.3-14.3-7.2L107.3 256l42.1-21.1 14.3-7.2 7.2-14.3L192 171.3l21.1 42.1 7.2 14.3 14.3 7.2L276.7 256l-42.1 21.1-14.3 7.2-7.2 14.3L192 340.7zM416 320l-32 64-64 32 64 32 32 64 32-64 64-32-64-32-32-64z'
      
    ]
  };

  

  
  

  var faV = {
    prefix: 'fasr',
    iconName: 'v',
    icon: [
      384,
      512,
      [118],
      '56',
      
      'M329.3 32L192 389.1 54.7 32H3.3L169.6 464.6l5.9 15.4h33l5.9-15.4L380.7 32H329.3z'
      
    ]
  };

  

  
  

  var faObjectsAlignBottom = {
    prefix: 'fasr',
    iconName: 'objects-align-bottom',
    icon: [
      512,
      512,
      [],
      'e3bb',
      
      'M512 512H0V464H512v48zM176 336V48H112V336h64zm-64 48H64V336 48 0h48 64 48V48 336v48H176 112zm288-48V176H336V336h64zm-64 48H288V336 176 128h48 64 48v48V336v48H400 336z'
      
    ]
  };

  

  
  

  var faBasketballHoop = {
    prefix: 'fasr',
    iconName: 'basketball-hoop',
    icon: [
      640,
      512,
      [],
      'f435',
      
      'M75.9 96.9c-31 29.7-58 64.9-75.9 104.2V372.8l134.3 58.4-8-55.8L48 341.3V212c14.8-29.2 36.1-56.5 61.1-80.4C152.8 89.7 221 48 320 48s167.2 41.7 210.9 83.6c25 23.9 46.3 51.2 61.1 80.4V341.3l-78.3 34.1-8 55.8L640 372.8V201.1c-17.8-39.2-44.8-74.5-75.9-104.2C513.6 48.5 434 0 320 0S126.4 48.5 75.9 96.9zM184 128H160v24 56h48V176H432v32h48V152 128H456 184zM512 240h-8H480 432 208 160 136h-8H112v48h24 10.1l7.2 50.3 22.9 160 2 13.7H192h8 7.2l4.8-5.3 44.2-49.5L300 506.6l4.8 5.4H312h16 7.2l4.8-5.4 43.9-49.4 44.2 49.5 4.8 5.3H440h8 13.9l2-13.7 22.9-160 7.2-50.3H504h24V240H512zM183.7 324.6L178.4 288H184h43.7l-44 36.6zM276.6 289l1.2-1h84.4l1.2 1L320 337.6 276.6 289zm179.7 35.6l-44-36.6H456h5.6l-5.2 36.6zm-19.8 25.2l-52.7 59.3-42.4-47.5L388 309.4l48.5 40.3zm-31.3 83.4l42.3-47.6-11.7 81.9-30.6-34.3zm-42.9 0L320.8 480h-1.6l-41.6-46.8L320 385.6l42.4 47.5zM256.2 409.1l-52.7-59.3L252 309.4l46.6 52.2-42.4 47.5zm-63.8-23.6l42.3 47.6-30.6 34.3-11.7-81.9z'
      
    ]
  };

  

  
  

  var faTooth = {
    prefix: 'fasr',
    iconName: 'tooth',
    icon: [
      448,
      512,
      [129463],
      'f5c9',
      
      'M64 143.3c0 12.5 2.9 24.9 8.5 36.1l28.9 57.9 1.5 3 .6 3.2L139.8 432h1.9l35.1-126.4 4.9-17.6H200h48 18.2l4.9 17.6L306.2 432h1.9l36.3-188.5 .6-3.2 1.5-3 26.9-53.8c6.9-13.9 10.6-29.2 10.6-44.8c0-32.4-26.3-58.7-58.7-58.7H314.6C298 80 282 85.9 269.4 96.7l-7 6 8.1 6 19.2 14.4-28.8 38.4-19.2-14.4L225 134.8l-15.4-11.6-32-24-8-6C158.2 84.6 144.3 80 130 80h-2.7C92.3 80 64 108.3 64 143.3zm159-70l15.1-13C259.4 42 286.5 32 314.6 32h10.7C384.2 32 432 79.8 432 138.7c0 23-5.4 45.7-15.6 66.2l-25.4 50.8L351.6 460.5 347.8 480H328 288 269.8l-4.9-17.6L229.8 336H218.2L183.1 462.4 178.2 480H160 120 100.2l-3.7-19.5L57.1 255.8 29.6 200.8C20.7 183 16 163.3 16 143.3C16 81.8 65.8 32 127.3 32H130c24.7 0 48.7 8 68.4 22.8l8 6L223 73.2z'
      
    ]
  };

  

  
  

  var faFaceGrinWide = {
    prefix: 'fasr',
    iconName: 'face-grin-wide',
    icon: [
      512,
      512,
      [128515,"grin-alt"],
      'f581',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z'
      
    ]
  };

  
    var faGrinAlt = faFaceGrinWide;
  

  
  

  var faPills = {
    prefix: 'fasr',
    iconName: 'pills',
    icon: [
      576,
      512,
      [],
      'f484',
      
      'M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64V256H48V144zM112 32C50.1 32 0 82.1 0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zM510.3 380.4L355.6 225.7C373 214.5 393.8 208 416 208c61.9 0 112 50.1 112 112c0 22.2-6.5 43-17.7 60.4zm-33.9 33.9C459 425.5 438.2 432 416 432c-61.9 0-112-50.1-112-112c0-22.2 6.5-43 17.7-60.4L476.4 414.3zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faArrowDownLeftAndArrowUpRightToCenter = {
    prefix: 'fasr',
    iconName: 'arrow-down-left-and-arrow-up-right-to-center',
    icon: [
      512,
      512,
      [],
      'e092',
      
      'M489 57l17-17L472 6.1 455 23l-135 135V72 48H272V72 216v24h24H440h24V192H440 353.9L489 57zM23 455l-17 17L40 505.9l17-17 135-135V440v24h48V440 296 272H216 72 48v48H72h86.1L23 455z'
      
    ]
  };

  

  
  

  var faHryvniaSign = {
    prefix: 'fasr',
    iconName: 'hryvnia-sign',
    icon: [
      384,
      512,
      [8372,"hryvnia"],
      'f6f2',
      
      'M105.7 104.6C125.6 88.7 150.3 80 175.8 80H227c33.7 0 61 27.3 61 61c0 20.7-10.5 39.8-27.5 51H0v48H171l-65.3 34.8c-7 3.7-13.5 8.2-19.4 13.2H0v48H53.8C50 347.1 48 358.9 48 371c0 60.2 48.8 109 109 109h51.2c36.4 0 71.7-12.4 100.1-35.1l2.7-2.2 18.7-15-30-37.5-18.7 15-2.7 2.2c-19.9 15.9-44.6 24.6-70.1 24.6H157c-33.7 0-61-27.3-61-61c0-12.8 4-24.9 11-35H384V288H183l90-48H384V192H323.3c8.2-15.4 12.7-32.9 12.7-51c0-60.2-48.8-109-109-109H175.8c-36.4 0-71.7 12.4-100.1 35.1L73 69.3l-18.7 15 30 37.5 18.7-15 2.7-2.2z'
      
    ]
  };

  
    var faHryvnia = faHryvniaSign;
  

  
  

  var faI = {
    prefix: 'fasr',
    iconName: 'i',
    icon: [
      320,
      512,
      [105],
      '49',
      
      'M24 32H0V80H24 136V432H24 0v48H24 296h24V432H296 184V80H296h24V32H296 160 24z'
      
    ]
  };

  

  
  

  var faUserHelmetSafety = {
    prefix: 'fasr',
    iconName: 'user-helmet-safety',
    icon: [
      448,
      512,
      [128119,"user-construction","user-hard-hat"],
      'f82c',
      
      'M256 0H192V80L163.6 23.1C125.6 43.5 99 82.6 96.2 128H96 72v48H96 352h24V128H352h-.2C349 82.6 322.4 43.5 284.4 23.1L256 80V0zM162 304c18.4 10.2 39.5 16 62 16s43.6-5.8 62-16c34.9-19.4 59.8-54.6 65-96H302.4c-7.4 36.5-39.7 64-78.4 64s-71-27.5-78.4-64H97c5.2 41.4 30.1 76.6 65 96zm-11.4 48H48L14.4 464 0 512H50.1 397.9 448l-14.4-48L400 352H297.4 224 150.6zM83.7 400H364.3l19.2 64H64.5l19.2-64z'
      
    ]
  };

  
    var faUserConstruction = faUserHelmetSafety;
  
    var faUserHardHat = faUserHelmetSafety;
  

  
  

  var faDialHigh = {
    prefix: 'fasr',
    iconName: 'dial-high',
    icon: [
      576,
      512,
      [],
      'e15c',
      
      'M320 0H256V64h64V0zM128 64H64v64h64V64zm384 0H448v64h64V64zm0 192v64h64V256H512zm0 192H448v64h64V448zM64 448v64h64V448H64zM0 256v64H64V256H0zm288 56H397.4c-11 50.3-55.8 88-109.4 88c-61.9 0-112-50.1-112-112s50.1-112 112-112c53.6 0 98.4 37.7 109.4 88H288 264v48h24zm160-24a160 160 0 1 0 -320 0 160 160 0 1 0 320 0z'
      
    ]
  };

  

  
  

  var faGlassEmpty = {
    prefix: 'fasr',
    iconName: 'glass-empty',
    icon: [
      384,
      512,
      [],
      'e191',
      
      'M84.4 464H299.6L332.1 48H51.9L84.4 464zM344 512H40L3.8 48 0 0H48.1 335.9 384l-3.8 48L344 512z'
      
    ]
  };

  

  
  

  var faDroneFront = {
    prefix: 'fasr',
    iconName: 'drone-front',
    icon: [
      640,
      512,
      ["drone-alt"],
      'f860',
      
      'M160 96v16H264h24v48H264 160 112 24 0V112H24h88V96h48zm368 64H480 376 352V112h24H480V96h48v16h88 24v48H616 528zM112 256V192h48v49.6l10.8 5.7 47.7-27.8c30.8-18 65.9-27.5 101.6-27.5s70.7 9.5 101.6 27.5l47.7 27.8 10.8-5.7V192h48v64 14.4l-12.8 6.8-51.6 27.3 26.8 32.1 5.6 6.7V352v40 24H448V392 360.7l-27.7-33.2-41.1 21.7L374 352h-6H272h-6l-5.3-2.8-41.1-21.7L192 360.7V392v24H144V392 352v-8.7l5.6-6.7 26.8-32.1-51.6-27.3L112 270.4V256zm307.3 17.7l-21.9-12.8C373.9 247.2 347.2 240 320 240s-53.9 7.2-77.4 20.9l-21.9 12.8L278 304H362l57.2-30.3z'
      
    ]
  };

  
    var faDroneAlt = faDroneFront;
  

  
  

  var faStairs = {
    prefix: 'fasr',
    iconName: 'stairs',
    icon: [
      576,
      512,
      [],
      'e289',
      
      'M384 32h24H552h24V80H552 432V200v24H408 304V328v24H280 176V456v24H152 24 0V432H24 128V328 304h24H256V200 176h24H384V56 32z'
      
    ]
  };

  

  
  

  var faToiletPaperUnderSlash = {
    prefix: 'fasr',
    iconName: 'toilet-paper-under-slash',
    icon: [
      640,
      512,
      ["toilet-paper-reverse-slash"],
      'e2a1',
      
      'M528 512h48v0H552 248 224V488 416h48v48H467.1L528 512zm48-87.6l44.9 34.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L97.6 53C115.3 23.7 141.8 0 176 0H464c37.7 0 66 28.7 83.5 62.1C565.5 96.6 576 142.5 576 192V424.4zM135.9 82.7l222 172.4C354.1 235.2 352 214 352 192c0-49.5 10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H176c-10.7 0-26 8.5-40.1 34.7zM462 335.9c.7 .1 1.4 .1 2 .1c10.9 0 26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C490.6 56.9 474.9 48 464 48s-26.6 8.9-41 36.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c2.1 4.1 4.3 7.7 6.5 11L462 335.9zm44.6 34.6L528 387.2V351.1c-6.4 7.5-13.6 14.1-21.4 19.4zM64 192c0-14.9 .9-29.4 2.8-43.4l45.3 35.7c-.1 2.5-.1 5.1-.1 7.7c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3H304.6l60.9 48H176c-37.7 0-66-28.7-83.5-62.1C74.5 287.4 64 241.5 64 192zm424 0c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48z'
      
    ]
  };

  
    var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
  

  
  

  var faDrawSquare = {
    prefix: 'fasr',
    iconName: 'draw-square',
    icon: [
      448,
      512,
      [],
      'f5ef',
      
      'M80 96A16 16 0 1 1 48 96a16 16 0 1 1 32 0zM64 32C28.7 32 0 60.7 0 96c0 26.9 16.5 49.9 40 59.3V356.7C16.5 366.1 0 389.1 0 416c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H324.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V155.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H123.3C113.9 48.5 90.9 32 64 32zM360 356.7c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V155.3c16-6.5 28.9-19.3 35.3-35.3H324.7c6.5 16 19.3 28.9 35.3 35.3V356.7zM64 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM400 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM384 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faFilePlus = {
    prefix: 'fasr',
    iconName: 'file-plus',
    icon: [
      384,
      512,
      [],
      'f319',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM216 208H168v24 48H120 96v48h24 48v48 24h48V376 328h48 24V280H264 216V232 208z'
      
    ]
  };

  

  
  

  var faStamp = {
    prefix: 'fasr',
    iconName: 'stamp',
    icon: [
      512,
      512,
      [],
      'f5bf',
      
      'M292 127.7l-12 13.6v18.2V256v48h48 88c26.5 0 48 21.5 48 48v16H48V352c0-26.5 21.5-48 48-48h88 48V256 159.5 141.3l-12-13.6c-7.5-8.5-12-19.5-12-31.7c0-26.5 21.5-48 48-48s48 21.5 48 48c0 12.2-4.5 23.2-12 31.7zM512 416V368 352c0-53-43-96-96-96H376 328V208 159.5c14.9-16.9 24-39.2 24-63.5c0-53-43-96-96-96s-96 43-96 96c0 24.3 9.1 46.6 24 63.5V208v48H136 96c-53 0-96 43-96 96v16 48H48 464h48zM32 448v16 32 16H80 432h48V496 464 448H432 80 32z'
      
    ]
  };

  

  
  

  var faSaltShaker = {
    prefix: 'fasr',
    iconName: 'salt-shaker',
    icon: [
      384,
      512,
      [129474],
      'e446',
      
      'M384 512l-7.5-48L321.3 110.7C311.3 47 256.5 0 192 0S72.7 47 62.7 110.7L7.5 464 0 512H48.6 335.4 384zm-56.1-48H56.1L98.6 192H285.4l42.5 272zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleDollar = {
    prefix: 'fasr',
    iconName: 'chart-mixed-up-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e5d9',
      
      'M384 0h24H520h24V24 136v24H496V136 81.9l-1 .8-160 128-15.1 12.1-15-12.2L191.3 118.3l-137 101L34.9 233.6 6.4 194.9l19.3-14.2 152-112 15-11 14.4 11.7 113 91.8L461.6 48H408 384V0zM200 264H184V440h16V264zm-16-40h16 40v40V440v40H200 184 144V440 264 224h40zM72 360H56v80H72V360zM56 320H72h40v40 80 40H72 56 16V440 360 320H56zm232 48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L465.9 301c-5.6-1.4-11.6-2.7-17.9-3.7V288 272H416v16 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8L372 425.2l15.3 4.8c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4 16h32v-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z'
      
    ]
  };

  

  
  

  var faICursor = {
    prefix: 'fasr',
    iconName: 'i-cursor',
    icon: [
      256,
      512,
      [],
      'f246',
      
      'M128 48C106.1 18.8 71.3 0 32 0H16V48H32c39.8 0 72 32.2 72 72V232H64 40v48H64h40V392c0 39.8-32.2 72-72 72H16v48H32c39.3 0 74.1-18.8 96-48c21.9 29.1 56.7 48 96 48h16V464H224c-39.8 0-72-32.2-72-72V280h40 24V232H192 152V120c0-39.8 32.2-72 72-72h16V0H224c-39.3 0-74.1 18.8-96 48z'
      
    ]
  };

  

  
  

  var faSquareArrowUpLeft = {
    prefix: 'fasr',
    iconName: 'square-arrow-up-left',
    icon: [
      448,
      512,
      [],
      'e263',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM136 144H288h24v48H288 193.9L329 327l17 17L312 377.9l-17-17-135-135V328v24H112V328 168 144h24z'
      
    ]
  };

  

  
  

  var fa5 = {
    prefix: 'fasr',
    iconName: '5',
    icon: [
      320,
      512,
      [],
      '35',
      
      'M34.9 32H56 264h24V80H264 77.1L59.3 216H188c72.9 0 132 59.1 132 132s-59.1 132-132 132H92.5c-36.4 0-69.6-20.5-85.9-53.1l-4.1-8.2 42.9-21.5 4.1 8.2C57.7 421.7 74.3 432 92.5 432H188c46.4 0 84-37.6 84-84s-37.6-84-84-84H32 4.7l3.5-27.1 24-184L34.9 32z'
      
    ]
  };

  

  
  

  var faLandMineOn = {
    prefix: 'fasr',
    iconName: 'land-mine-on',
    icon: [
      640,
      512,
      [],
      'e51b',
      
      'M344 24V168v24H296V168 24 0h48V24zM69.7 132.3l104 72 19.7 13.7-27.3 39.5-19.7-13.7-104-72L22.6 158.1l27.3-39.5 19.7 13.7zm528 39.5l-104 72-19.7 13.7-27.3-39.5 19.7-13.7 104-72 19.7-13.7 27.3 39.5-19.7 13.7zM192 288H448v64h64l44.8 112L576 512H524.3 115.7 64l19.2-48L128 352h64V288zM160.5 400l-25.6 64H505.1l-25.6-64h-319z'
      
    ]
  };

  

  
  

  var faTricycle = {
    prefix: 'fasr',
    iconName: 'tricycle',
    icon: [
      512,
      512,
      [],
      'e5c3',
      
      'M280 32H256V80h24 88v21l-47.6 40.8-2.6 2.2H307.2c-58.8 0-114 23.9-154.1 64.6L133.6 176H136h24V128H136 56 32v48H56 77.6l44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7c-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4c30.7-48.1 84-77.6 141.6-77.6h12.1l11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-2.4 0-4.8 .1-7.2 .2l-13.9-55.6 44.7-38.3L416 123V112 56 32H392 280zm62.2 251.8l18.5 74 5.8 23.3 46.6-11.6-5.8-23.3-18.5-74c42 2.5 75.2 37.3 75.2 79.9c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-28.9 15.3-54.2 38.2-68.2zM112 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faFaceZany = {
    prefix: 'fasr',
    iconName: 'face-zany',
    icon: [
      512,
      512,
      [],
      'e3a4',
      
      'M436.1 152C378.7 52.5 251.5 18.4 152 75.9S18.4 260.5 75.9 360c25 43.3 63.2 74.2 106.5 90.6c-4.1-10.7-6.4-22.4-6.4-34.6V403.5c-16-10.5-30.2-24-41.9-40.2L409.9 204.1c29.4 65.1 11.7 141.7-41.9 187.4V416c0 5.5-.5 10.9-1.4 16.1C461 373 492.3 249.2 436.1 152zM384 477.7c-27.9 16.1-57.5 26.3-87.5 31.1c-7.8 2.1-16 3.2-24.5 3.2c-1.9 0-3.7-.1-5.6-.2c-92 3.7-182.9-42.6-232.1-127.8C-36.4 261.6 5.6 105 128 34.3S407 5.6 477.7 128s28.7 279-93.7 349.7zM296.4 160c-11.1 0-20.4-7.5-23.2-17.7c-.8 3.1-1.2 6.4-1.2 9.7c0 22.1 17.9 40 40 40s40-17.9 40-40s-17.9-40-40-40c-3 0-6 .3-8.8 1c9.9 2.9 17.2 12.1 17.2 23c0 13.3-10.7 24-24 24zM312 80a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 80 224zm48 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM272 480c35.3 0 64-28.7 64-64V368H288v24H256V368H208v48c0 35.3 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faSquareRss = {
    prefix: 'fasr',
    iconName: 'square-rss',
    icon: [
      448,
      512,
      ["rss-square"],
      'f143',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm96 80c150.2 0 272 121.8 272 272H320c0-123.7-100.3-224-224-224V112zm0 96c97.2 0 176 78.8 176 176H224c0-70.7-57.3-128-128-128V208zm0 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  
    var faRssSquare = faSquareRss;
  

  
  

  var faOctagonMinus = {
    prefix: 'fasr',
    iconName: 'octagon-minus',
    icon: [
      512,
      512,
      ["minus-octagon"],
      'f308',
      
      'M48 332.1V179.9L179.9 48H332.1L464 179.9V332.1L332.1 464H179.9L48 332.1zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zm24 232H160v48h24H328h24V232H328 184z'
      
    ]
  };

  
    var faMinusOctagon = faOctagonMinus;
  

  
  

  var faDiceFive = {
    prefix: 'fasr',
    iconName: 'dice-five',
    icon: [
      448,
      512,
      [9860],
      'f523',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm128 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faRoadCircleCheck = {
    prefix: 'fasr',
    iconName: 'road-circle-check',
    icon: [
      640,
      512,
      [],
      'e564',
      
      'M95.6 432L196.2 80H296v24 24h48V104 80h99.8l32.3 113.1c6.5-.7 13.2-1.1 19.9-1.1c10.4 0 20.6 .9 30.5 2.6L480 32H344 296 160L45.7 432 32 480H81.9 360.2c-21.9-26.6-36.2-59.7-39.5-96H296v24 24H95.6zM344 216V192H296v24 80 24h30.6c4.1-14.4 10-28.1 17.4-40.8V216zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faFaceRelieved = {
    prefix: 'fasr',
    iconName: 'face-relieved',
    icon: [
      512,
      512,
      [],
      'e389',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm193 87c11.8 11.8 32.7 25 63 25s51.2-13.1 63-25l17-17L369.9 360l-17 17c-19.1 19.1-51.6 39-97 39s-77.9-19.9-97-39l-17-17L176 326.1l17 17zM391.5 237.7l32.2 23.8c-36 48.7-108.2 48.7-144.2 0l32.2-23.8c20 27.1 59.8 27.1 79.8 0zm-271.8 0c20 27.1 59.8 27.1 79.8 0l32.2 23.8c-36 48.7-108.2 48.7-144.2 0l32.2-23.8zm92.5-115.6l-15.2 5.1-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5-8.9 13.3L89.8 180.4l8.9-13.3 7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1 15.2-5.1 10.1 30.4zm102.7 5.1l-15.2-5.1 10.1-30.4 15.2 5.1 6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5 8.9 13.3-26.6 17.8-8.9-13.3L379 173.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z'
      
    ]
  };

  

  
  

  var faEclipse = {
    prefix: 'fasr',
    iconName: 'eclipse',
    icon: [
      640,
      512,
      [],
      'f749',
      
      'M193.1 23.2L256 57.1l62.9-33.9L362 0l14.1 46.9L381.5 65c-15.3 6.6-29.6 15-42.7 24.8L333 70.2 278.8 99.4 256 111.6 233.2 99.4 179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2L111.6 256 99.4 278.8 70.2 333l59 17.7 24.8 7.4 7.4 24.8 17.7 59 54.2-29.2L256 400.4l22.8 12.3L333 441.8l5.9-19.7c13.1 9.9 27.4 18.3 42.7 24.8l-5.4 18L362 512l-43.1-23.2L256 454.9l-62.9 33.9L150 512l-14.1-46.9-20.5-68.4L46.9 376.1 0 362l23.2-43.1L57.1 256 23.2 193.1 0 150l46.9-14.1 68.4-20.5 20.5-68.4L150 0l43.1 23.2zM256 144c10.4 0 20.6 1.4 30.1 4.1c-8.4 13.9-15.3 28.9-20.3 44.6c-3.2-.5-6.5-.7-9.8-.7c-35.3 0-64 28.7-64 64s28.7 64 64 64c3.3 0 6.6-.3 9.8-.7c5 15.8 11.9 30.7 20.3 44.6c-9.6 2.7-19.7 4.1-30.1 4.1c-61.9 0-112-50.1-112-112s50.1-112 112-112zM592 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-304 0a176 176 0 1 1 352 0 176 176 0 1 1 -352 0z'
      
    ]
  };

  

  
  

  var faAlarmClock = {
    prefix: 'fasr',
    iconName: 'alarm-clock',
    icon: [
      512,
      512,
      [9200],
      'f34e',
      
      'M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L423 489l17 17L473.9 472l-17-17-26.5-26.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L55 455l-17 17L72 505.9l17-17 26.5-26.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 184V160H232v24V288v9.9l7 7 48 48 17 17L337.9 336l-17-17-41-41V184z'
      
    ]
  };

  

  
  

  var faEarDeaf = {
    prefix: 'fasr',
    iconName: 'ear-deaf',
    icon: [
      512,
      512,
      ["deaf","deafness","hard-of-hearing"],
      'f2a4',
      
      'M489 57l-48 48-17 17L390.1 88l17-17 48-48 17-17L505.9 40 489 57zM185 361L57 489l-17 17L6.1 472l17-17L151 327l17-17L201.9 344l-17 17zm55-249c-70.7 0-128 57.3-128 128v24H64V240c0-97.2 78.8-176 176-176s176 78.8 176 176c0 50.8-21.6 96.6-56 128.7V376c0 75.1-60.9 136-136 136H200V464h24c48.6 0 88-39.4 88-88V357.9 346.5l8.8-7.2C349.7 315.7 368 280 368 240c0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40v24H152V240c0-48.6 39.4-88 88-88s88 39.4 88 88v24H280V240c0-22.1-17.9-40-40-40z'
      
    ]
  };

  
    var faDeaf = faEarDeaf;
  
    var faDeafness = faEarDeaf;
  
    var faHardOfHearing = faEarDeaf;
  

  
  

  var faClockThreeThirty = {
    prefix: 'fasr',
    iconName: 'clock-three-thirty',
    icon: [
      512,
      512,
      [],
      'e357',
      
      'M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V256 232h24H360h24v48H360 280V392v24H232V392z'
      
    ]
  };

  

  
  

  var faFaceGrinWink = {
    prefix: 'fasr',
    iconName: 'face-grin-wink',
    icon: [
      512,
      512,
      ["grin-wink"],
      'f58c',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm255.9 62.8c50.3 0 97.2-8.6 136.5-23.5C378.6 355.2 322.7 400 255.9 400s-122.7-44.8-136.5-104.6c39.3 14.9 86.2 23.5 136.5 23.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm151.3 26.3l-32.2-23.8c36-48.7 108.2-48.7 144.2 0l-32.2 23.8c-20-27.1-59.8-27.1-79.8 0z'
      
    ]
  };

  
    var faGrinWink = faFaceGrinWink;
  

  
  

  var faHatWitch = {
    prefix: 'fasr',
    iconName: 'hat-witch',
    icon: [
      576,
      512,
      [],
      'f6e7',
      
      'M512 224l26.6-46.6L576 112 448 0 208 128 96 384h52.4l96.9-221.5L441.3 58l73.5 64.3-3.3 5.7h-5.9H480 432 402.3l-13.3 26.5-16 32L363.8 205l7.1 19.4 58 159.6H480L416 208l16-32h48l2.2 3.3L512 224zM336 304H240v80h96V304zM0 416v32l128 64H448l128-64V416H0z'
      
    ]
  };

  

  
  

  var faCoffeeBeans = {
    prefix: 'fasr',
    iconName: 'coffee-beans',
    icon: [
      512,
      512,
      [],
      'e13f',
      
      'M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8s-39.9 141.2 22.6 203.6S426.8 308 476.8 258zm-77.9-76.1l32.3 50.8c-28.8 16-79.8 13.1-124.1-31.3c-33.5-33.5-43.4-70.8-39.3-99.5l29.3 46 101.8 33.9zm21.3-93.6c33.5 33.5 43.4 70.8 39.3 99.5l-29.3-46L328.4 107.8 296.1 57C324.9 41 375.8 44 420.2 88.3zM126.7 403.1l-13.1 58.8C82 452.8 48 414.7 48 352c0-47.4 19.4-80.7 42.6-98.1l-10 44.9-1.8 8.3 3.8 7.6 44.2 88.4zM208 352c0 47.4-19.4 80.8-42.6 98.1l10-44.9 1.8-8.3-3.8-7.6-44.2-88.4 13.1-58.8C174 251.2 208 289.3 208 352zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z'
      
    ]
  };

  

  
  

  var faMessageSms = {
    prefix: 'fasr',
    iconName: 'message-sms',
    icon: [
      512,
      512,
      [],
      'e1e5',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM152 144H132.8C112.5 144 96 160.5 96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8H112 96v32h16 27.2c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8H152h16V144h-8v0h-8zm40 16v96 16h32V256 208l19.2 25.6L256 250.7l12.8-17.1L288 208v48 16h32V256 160 144H296l-4.8 6.4L256 197.3l-35.2-46.9L216 144H192v16zm144 20.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8H352 336v32h16 27.2c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8H392h16V144H392h-8v0H372.7c-20.3 .1-36.7 16.6-36.7 36.8z'
      
    ]
  };

  

  
  

  var faChessBishop = {
    prefix: 'fasr',
    iconName: 'chess-bishop',
    icon: [
      320,
      512,
      [9821],
      'f43a',
      
      'M80 48H97.2c-7.6 7.8-15.6 16.6-23.7 26.2C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352H96V325 310.3l-13-6.7c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191l-17 17L176 241.9l17-17 57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7l-13 6.7V325v27h48V338.7c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8-9.6-16-18.4-23.7-26.2H240V0H216 167.8l0 0H152.2l0 0H104 80V48zM69.2 432H250.8l16.6 32H52.7l16.6-32zM320 464v-2.7L280 384H40L0 461.3V464v48H48 272h48V464z'
      
    ]
  };

  

  
  

  var faSealExclamation = {
    prefix: 'fasr',
    iconName: 'seal-exclamation',
    icon: [
      512,
      512,
      [],
      'e242',
      
      'M289.9 33.9l41 41 58 0 48 0 0 48 0 58 41 41L512 256l-33.9 33.9-41 41 0 58 0 48-48 0-58 0-41 41L256 512l-33.9-33.9-41-41-58 0-48 0 0-48 0-58-41-41L0 256l33.9-33.9 41-41 0-58 0-48 48 0 58 0 41-41L256 0l33.9 33.9zm41 89l-19.9 0L297 108.9l-41-41-41 41L200.9 123 181 123l-58 0 0 58 0 19.9L108.9 215l-41 41 41 41L123 311.1l0 19.9 0 58 58 0 19.9 0L215 403.1l41 41 41-41L311.1 389l19.9 0 58 0 0-58 0-19.9L403.1 297l41-41-41-41L389 200.9l0-19.9 0-58-58 0zm-51 5l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM232 320l48 0 0 48-48 0 0-48z'
      
    ]
  };

  

  
  

  var faGrateDroplet = {
    prefix: 'fasr',
    iconName: 'grate-droplet',
    icon: [
      576,
      512,
      [],
      'e194',
      
      'M0 32H24 128h96 96H424h24V56 157.9l-48 73.7V80H344V232h55.8l-56.1 86.1c-15.4 23.7-23.7 51.4-23.7 79.7V400c0 29.6 8.9 57.1 24.2 80H320 224 128 24 0V456 256 56 32zM48 80V232h56V80H48zm0 352h56V280H48V432zm152 0V280H152V432h48zm96 0V280H248V432h48zM248 80V232h48V80H248zM200 232V80H152V232h48zm264-40l93.5 143.6c12.1 18.5 18.5 40.2 18.5 62.3V400c0 61.9-50.1 112-112 112s-112-50.1-112-112v-2.1c0-22.1 6.4-43.7 18.5-62.3L464 192z'
      
    ]
  };

  

  
  

  var faVideoArrowUpRight = {
    prefix: 'fasr',
    iconName: 'video-arrow-up-right',
    icon: [
      576,
      512,
      [],
      'e2c9',
      
      'M336 112V400H48V112H336zM48 64H0v48V400v48H48 336h48V400 352 160 112 64H336 48zM528 370.3l-112-56V368l112 56 48 24V394.3 117.7 64L528 88 416 144v53.7l112-56V370.3zM152 160H128v48h24 54.1L103 311l-17 17L120 361.9l17-17 103-103V296v24h48V296 184 160H264 152z'
      
    ]
  };

  

  
  

  var faAcorn = {
    prefix: 'fasr',
    iconName: 'acorn',
    icon: [
      448,
      512,
      [],
      'f6ae',
      
      'M259.7 48.4l13.7-19.7L233.9 1.4 220.3 21.1c-9 12.9-15.1 27.6-18.1 42.9H96C43 64 0 107 0 160v48H48 400h48V160c0-53-43-96-96-96H251.8c1.9-5.5 4.6-10.7 8-15.6zM352 112c26.5 0 48 21.5 48 48H48c0-26.5 21.5-48 48-48H352zM48.4 240C52.6 320.1 89.3 435.1 224 480c134.7-44.9 171.4-159.9 175.6-240H351.5C347.7 305.6 319 390 224 428.8C129 390 100.3 305.6 96.5 240H48.4z'
      
    ]
  };

  

  
  

  var faFlute = {
    prefix: 'fasr',
    iconName: 'flute',
    icon: [
      640,
      512,
      [],
      'f8b9',
      
      'M144 304V208H592v96H144zm-48 0H48V208H96v96zm24-144H96 48 0v48 96 48H48 96h24 24H592h48V304 208 160H592 144 120zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRaygun = {
    prefix: 'fasr',
    iconName: 'raygun',
    icon: [
      576,
      512,
      [],
      'e025',
      
      'M288 64H192L64 0V74.8C26.2 92.8 0 131.3 0 176c0 61.9 50.1 112 112 112L53.5 405.1 32 448l42.9 21.5 42.1 21.1L160 512l21.5-42.9L272 288h16v8 24h48V296v-8V240 112 64 56 32H288V56v8zM218.3 288L138.5 447.6 96.4 426.5 165.7 288h52.7zM136 240H112c-35.3 0-64-28.7-64-64s28.7-64 64-64H288V240H256 242.3 240 136zM416 64H368V88 264v24h48V264 208h64l96 48V96l-96 48H416V88 64zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faSkeletonRibs = {
    prefix: 'fasr',
    iconName: 'skeleton-ribs',
    icon: [
      640,
      512,
      [],
      'e5cb',
      
      'M344 24V0H296V24 64H216 201.8l-6.8 12.5L216 88c-21.1-11.5-21.1-11.5-21.1-11.5l0 0 0 0-.1 .1-.2 .4-.9 1.6c-.7 1.4-1.8 3.4-3.2 6C187.9 90 184 97.5 179.4 107c-9.2 18.9-21.4 45.4-33.7 76.1C121.5 243.6 96 323.2 96 392v64 24h24 64 5.4l4.9-2.3L296 429.8V488v24h48V488 429.8l101.8 47.9 4.9 2.3H456h64 24V456 392c0-68.8-25.5-148.4-49.7-208.9c-12.3-30.7-24.5-57.2-33.7-76.1c-4.6-9.5-8.4-17-11.2-22.2c-1.4-2.6-2.4-4.6-3.2-6l-.9-1.6-.2-.4-.1-.1 0 0 0 0s0 0-21.1 11.5l21.1-11.5L438.2 64H424 344V24zm-48 88v60.3L193.6 192.8c10.6-25.9 21-48.4 29-64.8c3.1-6.3 5.7-11.7 8-16H296zM173.6 245.8L296 221.3V278L152.7 319.8c5.3-24.7 12.7-49.8 21-74.1zM144.8 372.1L296 328v48.8L178.6 432H144V392c0-6.5 .3-13.1 .8-19.9zM344 376.8V328l151.2 44.1c.5 6.8 .8 13.4 .8 19.9v40H461.4L344 376.8zm143.3-57L344 278V221.3l122.4 24.5c8.3 24.2 15.6 49.4 21 74.1zm-40.9-127L344 172.3V112h65.5c2.2 4.3 4.9 9.7 8 16c8 16.4 18.4 38.9 29 64.8zM0 64V88 194.4 208v24 24V488v24H48V488 256 232 221.6l21.7-13c36.1-21.7 58.3-60.7 58.3-102.9V88 64H104 24 0zM48 165.5V112H79.7c-1.9 21.7-13.6 41.4-31.7 53.5zM616 64H536 512V88v17.6c0 42.2 22.1 81.2 58.3 102.9l21.7 13V232v24V488v24h48V488 256 232 208 194.4 88 64H616zm-24 48v53.5c-18.2-12.1-29.8-31.8-31.7-53.5H592z'
      
    ]
  };

  

  
  

  var faThoughtBubble = {
    prefix: 'fasr',
    iconName: 'thought-bubble',
    icon: [
      512,
      512,
      [],
      'e32e',
      
      'M145.1 112h27.7l13.9-24c13.9-24 39.8-40 69.3-40s55.4 16 69.3 40l13.9 24h27.7H368c53 0 96 43 96 96s-43 96-96 96H334.4 314.8l-14 13.7C289.2 329.1 273.5 336 256 336s-33.2-6.9-44.8-18.3l-14-13.7H177.6 144c-53 0-96-43-96-96s43-96 96-96h1.1zM256 0c-47.4 0-88.7 25.7-110.9 64H144C64.5 64 0 128.5 0 208s64.5 144 144 144h33.6c20.2 19.8 47.9 32 78.4 32s58.2-12.2 78.4-32H368c79.5 0 144-64.5 144-144s-64.5-144-144-144h-1.1C344.7 25.7 303.4 0 256 0zM104 472h80V392H104v80zM0 448v64H64V448H0z'
      
    ]
  };

  

  
  

  var faUpToDottedLine = {
    prefix: 'fasr',
    iconName: 'up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e457',
      
      'M64 32V96H0V32H64zm96 0V96H96V32h64zm32 0h64V96H192V32zm160 0V96H288V32h64zm32 0h64V96H384V32zM256 352V304h48 28.1L224 195.9 115.9 304H144h48v48 80h64V352zm1.9-190.1L384 288v16 48H352 336 304v48 32 48H256 192 144V432 400 352H112 96 64V304 288L190.1 161.9 224 128l33.9 33.9z'
      
    ]
  };

  

  
  

  var faFaceGrinTongue = {
    prefix: 'fasr',
    iconName: 'face-grin-tongue',
    icon: [
      512,
      512,
      [128539,"grin-tongue"],
      'f589',
      
      'M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V363.6c-20-18-34.4-41.6-40.6-68.2c39.3 14.9 86.2 23.5 136.5 23.5s97.2-8.6 136.5-23.5c-6.1 26.5-20.5 50.1-40.4 68.1V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416V352H272v24H240V352H192v64c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  
    var faGrinTongue = faFaceGrinTongue;
  

  
  

  var faPeriod = {
    prefix: 'fasr',
    iconName: 'period',
    icon: [
      192,
      512,
      [],
      '2e',
      
      'M120 392l0 48-48 0 0-48 48 0zM72 344l-48 0 0 48 0 48 0 48 48 0 48 0 48 0 0-48 0-48 0-48-48 0-48 0z'
      
    ]
  };

  

  
  

  var faBridgeCircleXmark = {
    prefix: 'fasr',
    iconName: 'bridge-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4cb',
      
      'M56 32H32V80H56h48v64H56 32v48H56h48 48 80 48H496h88 24V144H584 536V80h40 24V32H576 56zM338 290.3c7.4-15 16.9-28.9 28.1-41.1c-14.2-5.9-29.8-9.2-46.1-9.2c-66.3 0-120 53.7-120 120v72H152V336c0-53-43-96-96-96H32v48H56c26.5 0 48 21.5 48 48V456v24h24 96 24V456 360c0-39.8 32.2-72 72-72c6.2 0 12.3 .8 18 2.3zM488 80v64H408V80h80zM360 80v64H280V80h80zM232 80v64H152V80h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faFaceKiss = {
    prefix: 'fasr',
    iconName: 'face-kiss',
    icon: [
      512,
      512,
      [128535,"kiss"],
      'f596',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416l-3.9-15 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1 0 0 0 0 0 0 0 0V329l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0 0 0 3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faKiss = faFaceKiss;
  

  
  

  var faWindowFrameOpen = {
    prefix: 'fasr',
    iconName: 'window-frame-open',
    icon: [
      512,
      512,
      [],
      'e050',
      
      'M432 240H280V48H432V240zm-200 0H80V48H232V240zM32 0V48 240v48H80 432h48V240 48 0H432 80 32zM24 464H0v48H24 56 456h32 24V464H488h-8V320H432V464H80V320H32V464H24z'
      
    ]
  };

  

  
  

  var faLightbulbCfl = {
    prefix: 'fasr',
    iconName: 'lightbulb-cfl',
    icon: [
      320,
      512,
      [],
      'e5a6',
      
      'M160.5 0c-2.1 0-4.2 .2-6.4 .7L0 39.3V88.7l160-40V0h.5zM0 184.7l320-80V55.3L0 135.3v49.5zm0 96l320-80V151.3L0 231.3v49.5zm320-33.5L194.2 278.7 176 283.3V302v82l-32 0V290.9l-48 12V384H64v96h72v8 24h48V488v-8h72V384l-32 0V320.7l96-24V247.3z'
      
    ]
  };

  

  
  

  var faCommentArrowDown = {
    prefix: 'fasr',
    iconName: 'comment-arrow-down',
    icon: [
      512,
      512,
      [],
      'e143',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM280 152V128H232v24V262.1l-31-31-17-17L150.1 248l17 17 72 72 17 17 17-17 72-72 17-17L328 214.1l-17 17-31 31V152z'
      
    ]
  };

  

  
  

  var faCameraWeb = {
    prefix: 'fasr',
    iconName: 'camera-web',
    icon: [
      448,
      512,
      ["webcam"],
      'f832',
      
      'M224 48a168 168 0 1 1 0 336 168 168 0 1 1 0-336zM342.3 396.7C401.2 358.1 440 291.6 440 216C440 96.7 343.3 0 224 0S8 96.7 8 216c0 75.6 38.8 142.1 97.7 180.7L53.3 464 16 512H76.8 371.2 432l-37.3-48-52.3-67.3zm-193 22c23.3 8.6 48.4 13.3 74.7 13.3s51.4-4.7 74.7-13.3L333.9 464H114.1l35.2-45.3zM224 144a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm0 192a120 120 0 1 0 0-240 120 120 0 1 0 0 240z'
      
    ]
  };

  
    var faWebcam = faCameraWeb;
  

  
  

  var faSquareM = {
    prefix: 'fasr',
    iconName: 'square-m',
    icon: [
      448,
      512,
      [],
      'e276',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM96 152V128h36.3l7.2 9.9L224 255l84.5-117.1 7.2-9.9H352v24V360v24H304V360 226.2l-60.5 83.8L224 337l-19.5-26.9L144 226.2V360v24H96V360 152z'
      
    ]
  };

  

  
  

  var faFaceScream = {
    prefix: 'fasr',
    iconName: 'face-scream',
    icon: [
      640,
      512,
      [],
      'e38b',
      
      'M523.5 299.4c3-14 4.5-28.5 4.5-43.4c0-114.9-93.1-208-208-208s-208 93.1-208 208c0 14.9 1.6 29.4 4.5 43.4L102.9 288 82.3 306 71 315.9c-4.6-19.2-7-39.3-7-59.9C64 114.6 178.6 0 320 0S576 114.6 576 256c0 20.6-2.4 40.6-7 59.8L557.7 306l-20.6-18-13.7 11.4zM433 430.7c-6.9 20.3-11.7 41.1-14.8 61.8C388 505.1 354.8 512 320 512c-34.8 0-67.9-6.9-98.1-19.5c-3.1-20.7-7.9-41.5-14.8-61.8C239.6 451.8 278.4 464 320 464c41.7 0 80.5-12.2 113-33.3zM183.3 282.7c-27.3-14.9-31.1-56.9-8.7-93.7s62.8-54.7 90.1-39.8s31.1 56.9 8.7 93.7s-62.8 54.7-90.1 39.8zm273.4 0c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7s67.6 2.9 90.1 39.8s18.6 78.8-8.7 93.7zM320 304c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V352c0-26.5 21.5-48 48-48zM192 512L82.3 512c.4-50.5-16.7-85.7-43.2-125.7l64.3-56.2C157.2 375 185 443.6 192 512zm365.7 0L448 512c7-68.5 34.8-137 88.6-181.9l64.3 56.2c-26.4 40-43.6 75.3-43.2 125.7z'
      
    ]
  };

  

  
  

  var faArrowUpSquareTriangle = {
    prefix: 'fasr',
    iconName: 'arrow-up-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-up-alt"],
      'f88b',
      
      'M368 80h96v96H368V80zM320 32V80v96 48h48 96 48V176 80 32H464 368 320zM160 33.3l-17 17-96 96-17 17L64 197.1l17-17 55-55V456v24h48V456 125.1l55 55 17 17 33.9-33.9-17-17-96-96-17-17zM296 480h55.4H480.6 536l-27.7-48L443.7 320 416 272l-27.7 48L323.7 432 296 480zm156.9-48H379.1L416 368.1 452.9 432z'
      
    ]
  };

  
    var faSortShapesUpAlt = faArrowUpSquareTriangle;
  

  
  

  var faFieldHockeyStickBall = {
    prefix: 'fasr',
    iconName: 'field-hockey-stick-ball',
    icon: [
      512,
      512,
      [127953,"field-hockey"],
      'f44c',
      
      'M414 7.1l19.9 13.5 66.2 44.9L520 79 506.5 98.8 484 131.9 270.3 447c-27.4 40.4-72.9 64.6-121.7 64.7C66.5 512 0 445.2 .6 363.1l0-2.6c.2-28.8 8.7-56.9 24.4-81L42.4 253l21.9-33.5 13.1-20.1 20.1 13.1 67 43.8 20.1 13.1-13.1 20.1L149.6 323l-17.3 26.5c-2.3 3.5-3.6 7.7-3.6 11.9l0 2.6c-.1 10.9 8.7 19.7 19.6 19.7c6.5 0 12.5-3.2 16.1-8.6L378.1 60.1 400.6 27 414 7.1zm-11.2 159l-25.6-19.2L204.1 402.1c-12.5 18.5-33.4 29.6-55.7 29.6c-37.6 .1-68-30.5-67.8-68.1l0-2.6c.1-13.4 4.1-26.6 11.4-37.8l17.3-26.5 8.8-13.4L91.4 265.9l-8.8 13.4L65.3 305.8c-10.7 16.4-16.5 35.5-16.6 55.1l0 2.6c-.4 55.4 44.5 100.5 99.9 100.3c32.9-.1 63.6-16.4 82.1-43.7L402.8 166.1zM432 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  
    var faFieldHockey = faFieldHockeyStickBall;
  

  
  

  var faSquare2 = {
    prefix: 'fasr',
    iconName: 'square-2',
    icon: [
      448,
      512,
      [],
      'e257',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM161.7 146.5c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336H296h24v48H296 152 128V349.6l7.6-7.1L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3L174.5 197l-19.1 14.5-29.1-38.2 19.1-14.5 16.2-12.3z'
      
    ]
  };

  

  
  

  var faSaxophone = {
    prefix: 'fasr',
    iconName: 'saxophone',
    icon: [
      640,
      512,
      [127927],
      'f8dc',
      
      'M488 32h-9.9l-7 7-23 23-16-16L398.1 80l16 16L400 110l-16-16L350.1 128l16 16L352 158l-16-16L302.1 176l16 16-88.3 88.2-1.2-.9L265 176h23V128h-6.1H264 248 56 36.7 24 0v48H24h2.1L4 275.3c-2.7 12-4 24.2-4 36.5C0 404.7 75.3 480 168.2 480h9.1c51.9 0 101.2-22.7 134.9-62.2L539.1 152H616h24V128 96 86.1l-7-7L593 39l-7-7H576 488zM75.3 176H214.1L177.4 280l-5.9 16.7 14.2 10.6 32 23.8 16.6 12.4L249 328.8 352 225.9l0 0L385.9 192l0 0L400 177.9l0 0L433.9 144l0 0L448 129.9l0 0L481.9 96l0 0 16-16h68.1l24 24H528 516.9l-7.2 8.4L275.6 386.6c-24.6 28.8-60.5 45.4-98.3 45.4h-9.1C101.8 432 48 378.2 48 311.8c0-8.8 1-17.5 2.9-26.1L75.3 176zM136 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faStopwatch = {
    prefix: 'fasr',
    iconName: 'stopwatch',
    icon: [
      448,
      512,
      [9201],
      'f2f2',
      
      'M144 0H304V48H248V97.4c43.4 5 82.8 23.3 113.8 50.9L391 119l17-17L441.9 136l-17 17-31 31c24 33.9 38.1 75.3 38.1 120c0 114.9-93.1 208-208 208S16 418.9 16 304C16 197.2 96.4 109.3 200 97.4V48H144V0zm80 464a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm24-248V320v24H200V320 216 192h48v24z'
      
    ]
  };

  

  
  

  var faBlinds = {
    prefix: 'fasr',
    iconName: 'blinds',
    icon: [
      512,
      512,
      [],
      'f8fb',
      
      'M0 0H24 488h24V48H498.7L504 80l8 48H463.3 224V80H455.3L450 48H192V164.1c28 9.9 48 36.6 48 67.9c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-31.3 20-58 48-67.9V48H62L56.7 80H112v48H48.7 0L8 80l5.3-32H0V0zM66.8 208C65 215.7 64 223.7 64 232s1 16.3 2.8 24H48.7 0l8-48 8-48H64.7l-8 48H66.8zm202.4 48c1.8-7.7 2.8-15.7 2.8-24s-1-16.3-2.8-24H455.3l-8-48H496l8 48 8 48H463.3 269.2zM168 336H455.3l-8-48H496l8 48 8 48H463.3 48.7 0l8-48 8-48H64.7l-8 48H168zM16 416H64.7l-8 48H455.3l-8-48H496l8 48 8 48H463.3 48.7 0l8-48 8-48zM168 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCommand = {
    prefix: 'fasr',
    iconName: 'command',
    icon: [
      512,
      512,
      [],
      'e142',
      
      'M0 0H24 160h24V24 136H328V24 0h24H488h24V24 168v24H488 376V320H488h24v24V488v24H488 352 328V488 376H184V488v24H160 24 0V488 344 320H24 136V192H24 0V168 24 0zM136 144v-8V48H48v96h88zm48 176v8H328v-8V192v-8H184v8V320zm-48 48H48v96h88V376v-8zm240 8v88h88V368H376v8zm0-232h88V48H376v88 8z'
      
    ]
  };

  

  
  

  var faPopsicle = {
    prefix: 'fasr',
    iconName: 'popsicle',
    icon: [
      320,
      512,
      [],
      'e43e',
      
      'M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160V336h88V184 160h48v24V336h88V160zM136 384H48 0V336 160C0 71.6 71.6 0 160 0s160 71.6 160 160V336v48H272 184V488v24H136V488 384z'
      
    ]
  };

  

  
  

  var faBookArrowUp = {
    prefix: 'fasr',
    iconName: 'book-arrow-up',
    icon: [
      448,
      512,
      [],
      'e0ba',
      
      'M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80h96V464H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V352H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H400V352H304v48h64v64H304v48H424h24V464H424h-8V400h8 24V376 24 0H424 88zm55 215l-17 17L160 265.9l17-17 39-39L216 512h48V209.9l39 39 17 17L353.9 232l-17-17-80-80-17-17-17 17-80 80z'
      
    ]
  };

  

  
  

  var faCircleMicrophone = {
    prefix: 'fasr',
    iconName: 'circle-microphone',
    icon: [
      512,
      512,
      ["microphone-circle"],
      'e116',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 0V96h96V256c0 26.5-21.5 48-48 48s-48-21.5-48-48zm-32-24v24c0 44.2 35.8 80 80 80s80-35.8 80-80V232h48v24c0 62.5-44.8 114.5-104 125.8V392v24H232V392 381.8C172.8 370.5 128 318.5 128 256V232h48z'
      
    ]
  };

  
    var faMicrophoneCircle = faCircleMicrophone;
  

  
  

  var faSpiderWeb = {
    prefix: 'fasr',
    iconName: 'spider-web',
    icon: [
      576,
      512,
      [128376],
      'f719',
      
      'M144.6 4.7l19.8 3.7L288 31.6 411.6 8.4l19.8-3.7 7.1 18.9L485 147.8l77.4 92.9L575.2 256l-12.8 15.4L485 364.2 438.5 488.4l-7.1 18.9-19.8-3.7L288 480.4 164.4 503.6l-19.8 3.7-7.1-18.9L91 364.2 13.6 271.4 .8 256l12.8-15.4L91 147.8 137.5 23.6l7.1-18.9zm19.9 83.6l-30.1 80.1-1.4 3.8-2.6 3.1L83.2 232h49.9l34.8-39.8 21.4-60.6L164.5 88.3zm42.1-23.1l24.1 42.1L288 123.9l57.4-16.6 24.1-42.1-77 14.4-4.4 .8-4.4-.8-77-14.4zM411.5 88.3l-24.8 43.3 21.4 60.6L442.9 232h49.9l-47.2-56.6-2.6-3.1-1.4-3.8L411.5 88.3zM492.8 280H442.9l-34.7 39.6-20.9 61.7 24.2 42.4 30.1-80.1 1.4-3.8 2.6-3.1L492.8 280zM369.4 446.8l-22.2-38.8-59.7-19.8-56.9 16.5-24.1 42.1 77-14.4 4.4-.8 4.4 .8 77 14.4zM164.5 423.7l24.8-43.3-21.4-60.6L133.1 280H83.2l47.2 56.6 2.6 3.1 1.4 3.8 30.1 80.1zM196.9 280l10.2 11.6 3 3.5 1.5 4.4 9.1 25.9L246.6 280H196.9zm68 64.9l16.5-4.8 7.2-2.1 7.1 2.3 16.1 5.3L288 304.4l-23.1 40.5zm90.6-19.2l8.8-26 1.5-4.5 3.1-3.6L379.1 280H329.4l26.1 45.7zM379.1 232l-10.2-11.6-3-3.5-1.5-4.4-9.1-25.9L329.4 232h49.8zm-68-64.9l-16.5 4.8-6.7 1.9-6.7-1.9-16.5-4.8L288 207.6l23.1-40.5zm-90.4 19.5l-9.1 25.9-1.5 4.4-3 3.5L196.9 232h49.8l-25.9-45.3z'
      
    ]
  };

  

  
  

  var faHandSpock = {
    prefix: 'fasr',
    iconName: 'hand-spock',
    icon: [
      576,
      512,
      [128406],
      'f259',
      
      'M287.8 24.9L281.7 1.7 258.5 7.9 181.2 28.4 158 34.6l6.2 23.2 1.7 6.4-11.4 5.1-73 32.7-21.9 9.8 9.8 21.9 16.3 36.5 52.6 117.6-2.9-2.3-31.6-24.6L84.8 246.2 70 265.1 20.9 328.3 6.2 347.2 25.1 362l31.6 24.6 92 71.6C193.6 493 248.9 512 305.9 512h25.9 0l.1 0 4.2 0 9.5 0c66.1 0 123.7-45 139.7-109.1l56.9-227.4 9.7-38.8 5.8-23.3-23.3-5.8L466 90.5l4-22.7 4.2-23.6L450.6 40 371.8 26l-23.6-4.2L344 45.4l-7 39.4-13.3 75.1L298.1 63.6 287.8 24.9zM387 77.4L418.6 83l-2.8 15.8-27.2 153-5 28.2h28.6 2.6 18.7l4.5-18.2 26.4-105.7 3.9-15.5 31 7.8-3.9 15.5L438.7 391.3C428 434 389.6 464 345.5 464l-9.5 0-4.2 0h0l-.1 0H305.9c-46.3 0-91.2-15.4-127.7-43.8l-92-71.6-12.6-9.8 19.6-25.3 12.6 9.8L180 381l39.4-29.5-89.9-201-6.5-14.6 29.2-13.1 6.5 14.6L216 265.8l6.4 14.2h15.6 3.6 31.2l-8-30.2-44-165.7-4.1-15.5 30.9-8.2 4.1 15.5 49.4 186.3 4.7 17.8h18.5 6.6H351l3.5-19.8 29.7-167L387 77.4z'
      
    ]
  };

  

  
  

  var faCircleCamera = {
    prefix: 'fasr',
    iconName: 'circle-camera',
    icon: [
      512,
      512,
      ["camera-circle"],
      'e103',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm196-96l12-32h96l12 32h68V352H128V160h68zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faCameraCircle = faCircleCamera;
  

  
  

  var faFacePersevering = {
    prefix: 'fasr',
    iconName: 'face-persevering',
    icon: [
      512,
      512,
      [],
      'e385',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5-35.1-32.7 16.4-17.5C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5zM222.6 112l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 89.4 222.6 112zm78.1 11.3L289.4 112 312 89.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM112 208l118.9 64L112 336l45.7-64L112 208zm169.1 64L400 208l-45.7 64L400 336 281.1 272z'
      
    ]
  };

  

  
  

  var faGaugeSimpleLow = {
    prefix: 'fasr',
    iconName: 'gauge-simple-low',
    icon: [
      512,
      512,
      ["tachometer-slow"],
      'f62c',
      
      'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 352c0-14 5.1-26.8 13.7-36.6L146 161.7l-9.7-22 43.9-19.3 9.7 22L257.6 296c30.2 .8 54.4 25.6 54.4 56c0 30.9-25.1 56-56 56s-56-25.1-56-56z'
      
    ]
  };

  
    var faTachometerSlow = faGaugeSimpleLow;
  

  
  

  var faFaceSaluting = {
    prefix: 'fasr',
    iconName: 'face-saluting',
    icon: [
      640,
      512,
      [129761],
      'e484',
      
      'M169.9 155.4l-9.9 7.2-14.2 10.4L128 185.8V146.8l27.3-18.5 26.5-18 26.5-18 30.9-21 26.5-18-18-26.5-2.5-3.6L229.7 .4l-26.5 18L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c18.9 15.4 43.2 20.9 66 16.5c11.1-2.2 21.9-6.8 31.6-13.8L144 253.3l66.8-48.6 25.9-18.8-37.6-51.8L173.2 153l-3.3 2.4zm-23 135.4c-13.8 9.9-29.2 16.3-45.2 19.2C126.5 425.5 229.2 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-26.5 0-52.1 4-76.1 11.5l16.2 23.9 12.3 18.1C319.7 49.9 335.6 48 352 48c114.9 0 208 93.1 208 208s-93.1 208-208 208c-103 0-188.6-74.9-205.1-173.2zm97.6-67.1c5.5 9.8 15.9 16.4 27.9 16.4c17.7 0 32-14.3 32-32c0-9.5-4.1-17.9-10.6-23.8l-49.3 39.4zm29.6 166.1c21.7 7.7 48.4 13.3 77.9 13.3s56.2-5.5 77.9-13.3c21.3-7.6 39.3-17.7 50.5-28.2l-32.8-35c-4.8 4.5-16.3 11.8-33.7 18c-17 6-38.3 10.5-61.9 10.5s-44.8-4.5-61.9-10.5c-17.5-6.2-28.9-13.5-33.7-18l-32.8 35c11.2 10.5 29.2 20.7 50.5 28.2zM464.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fasr',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256 94.1l17 17L465 303l17 17L448 353.9l-17-17-175-175L81 337l-17 17L30.1 320l17-17L239 111l17-17z'
      
    ]
  };

  

  
  

  var faSquareI = {
    prefix: 'fasr',
    iconName: 'square-i',
    icon: [
      448,
      512,
      [],
      'e272',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm152 96h72 72 24v48H296 248V336h48 24v48H296 248 200 152 128V336h24 48V176H152 128V128h24z'
      
    ]
  };

  

  
  

  var faCalendarCircleExclamation = {
    prefix: 'fasr',
    iconName: 'calendar-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e46e',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48H432 400 352 48V464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 192 144 64H104V24 0h48zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224V416H416v32h32zm0-176H416v16 80 16h32V368 288 272z'
      
    ]
  };

  

  
  

  var faPlug = {
    prefix: 'fasr',
    iconName: 'plug',
    icon: [
      384,
      512,
      [128268],
      'f1e6',
      
      'M120 24V0H72V24v88h48V24zm192 0V0H264V24v88h48V24zM24 144H0v48H24h8v64c0 80.2 59 146.6 136 158.2V512h48V414.2c77-11.6 136-78 136-158.2V192h8 24V144H360h-8H304 80 32 24zM192 368c-61.9 0-112-50.1-112-112V192H304v64c0 61.9-50.1 112-112 112z'
      
    ]
  };

  

  
  

  var faHouseCircleXmark = {
    prefix: 'fasr',
    iconName: 'house-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e50b',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5V488v24H88 394.8c-18.3-12.9-34.1-29.2-46.3-48H336v0H240V320h86.6c4.9-17.2 12.3-33.4 21.8-48H216 192v24V464H112V212.8L288 63.5 447.5 198.8c15.4-4.4 31.7-6.8 48.5-6.8c6.4 0 12.7 .3 18.8 1L303.5 13.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faWorm = {
    prefix: 'fasr',
    iconName: 'worm',
    icon: [
      512,
      512,
      [],
      'e599',
      
      'M400 192V368c0 35.3-28.7 64-64 64s-64-28.7-64-64V320c0-53-43-96-96-96s-96 43-96 96V448v16h32V448 320c0-35.3 28.7-64 64-64s64 28.7 64 64v48c0 53 43 96 96 96s96-43 96-96V192 120 48H336c-26.5 0-48 21.5-48 48s21.5 48 48 48h16 48v48zM176 176c15.9 0 31.2 2.6 45.5 7.3c27.7 9.2 51.7 26.6 69 49.3c5.1 6.7 9.6 13.8 13.5 21.3c10.2 19.8 16 42.2 16 66v20.3V368c0 8.8 7.2 16 16 16s16-7.2 16-16V340.3 320 243.1 240 192H336c-6.3 0-12.5-.6-18.5-1.8c-27.6-5.4-51-22.6-64.7-46.2c-8.2-14.1-12.8-30.5-12.8-48c0-53 43-96 96-96h96 48V48v72 72V368c0 79.5-64.5 144-144 144c-55.7 0-104.1-31.7-128-78c-10.2-19.8-16-42.2-16-66V347.7 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v27.7V368v76.9V448v16 48H112 80 32V464 448 320c0-79.5 64.5-144 144-144zM376 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faFaceShush = {
    prefix: 'fasr',
    iconName: 'face-shush',
    icon: [
      512,
      512,
      [],
      'e38c',
      
      'M464 256c0 57.2-23.1 109-60.5 146.6l38.7 29C485.5 385.8 512 324 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 357.2 58.7 444.7 144 486.3V432v-.7C86.3 394.3 48 329.6 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208zM208.4 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM176 217.4L153.4 240l11.3 11.3c8.7 8.7 20.5 17.7 35.3 24.6V248v-8.8c-4.9-3.4-9.2-7-12.7-10.5L176 217.4zm136 58.5c14.8-6.9 26.6-15.9 35.3-24.6L358.6 240 336 217.4l-11.3 11.3c-3.5 3.5-7.7 7.1-12.7 10.5V248v27.9zM280 248V224H232v24 72h48V248zM200 352H176v24 56 56 24h24 80 40 11.2l7.2-8.6 40-48 15.4-18.4-36.9-30.7-15.4 18.4L308.8 464H287.6L224 419.5V400h24 24v32h48V376 352H296 248 200z'
      
    ]
  };

  

  
  

  var faFlaskRoundPotion = {
    prefix: 'fasr',
    iconName: 'flask-round-potion',
    icon: [
      448,
      512,
      ["flask-potion"],
      'f6e1',
      
      'M176 196.5V167.4 48h96V167.4v29.1L297.8 210c51.3 26.7 86.2 80.3 86.2 141.9c-64.4-.9-94.8-12.3-122.5-22.7c-23.8-9-45.7-17.2-85.5-17.2c-55.8 0-92.3 16.1-111.5 27.9C68.7 283.4 102.3 235 150.2 210L176 196.5zm144-29.1V48h8 24V0H328h-8H272 176 128h-8H96V48h24 8V167.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160H356.9c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6z'
      
    ]
  };

  
    var faFlaskPotion = faFlaskRoundPotion;
  

  
  

  var faPi = {
    prefix: 'fasr',
    iconName: 'pi',
    icon: [
      448,
      512,
      [],
      'f67e',
      
      'M24 64H0v48H24h88V361.4L75.4 422.9l41.2 24.6 40-67.2 3.4-5.7V368 112H304V424v24h24 72 15.5l6.4-14.2 14.4-32 9.8-21.9-43.8-19.7-9.8 21.9-8 17.8H352V112h72 24V64H424 24z'
      
    ]
  };

  

  
  

  var faOm = {
    prefix: 'fasr',
    iconName: 'om',
    icon: [
      512,
      512,
      [128329],
      'f679',
      
      'M368 0L336 32l32 32 32-32L368 0zm24 200h-9.9l-7 7-57 57H231.6C242 247.8 248 228.6 248 208c0-57.4-46.6-104-104-104c-23.4 0-45 7.7-62.4 20.8l28.8 38.4c9.4-7 21-11.2 33.6-11.2c30.9 0 56 25.1 56 56s-25.1 56-56 56H88l24 48h32 12c42 0 76 34 76 76c0 41.5-33.2 75.2-74.5 76C47.5 462.6 16 368 16 368s-15.7 141.6 140 144v0c.5 0 1.1 0 1.6 0c.8 0 1.6 0 2.4 0v-.1c66.6-2.1 120-56.8 120-123.9c0-28.6-9.7-55-26-76h74 9.9l7-7 57-57H424c22.1 0 40 17.9 40 40V400c0 17.7-14.3 32-32 32c-64 0-80-48-80-48v48s0 48 80 48c44.2 0 80-35.8 80-80V288c0-48.6-39.4-88-88-88H392zm88-88V64s-66.5 32-112 32s-112-32-112-32s16 80 120 80c72 0 104-32 104-32z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftDown = {
    prefix: 'fasr',
    iconName: 'arrow-turn-left-down',
    icon: [
      384,
      512,
      [],
      'e633',
      
      'M329 373.8l17-17L312 322.9l-17 17-79 79L216 48l144 0 24 0 0-48L360 0 192 0 168 0l0 24 0 394.9-79-79-17-17L38.1 356.8l17 17 113 113 0 1.3 1.3 0 5.8 5.8 17 17 17-17 5.8-5.8 1.3 0 0-1.3 113-113z'
      
    ]
  };

  

  
  

  var faFolderBookmark = {
    prefix: 'fasr',
    iconName: 'folder-bookmark',
    icon: [
      512,
      512,
      [],
      'e186',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zM416 144V320l-80-56-80 56V144h-8l-14.4-19.2L200 80H48V432H464V144H416z'
      
    ]
  };

  

  
  

  var faTurnRight = {
    prefix: 'fasr',
    iconName: 'turn-right',
    icon: [
      512,
      512,
      [],
      'e639',
      
      'M352 248l-48 0-160 0-48 0 0 48 0 136-48 0 0-232 256 0 48 0 0-48 0-20.1L444.1 224 352 316.1l0-20.1 0-48zm126.1 9.9L512 224l-33.9-33.9L352 64l-48 0 0 40 0 8 0 40-48 0L48 152 0 152l0 48L0 432l0 48 48 0 48 0 48 0 0-48 0-88 0-48 48 0 64 0 48 0 0 40 0 8 0 40 48 0L478.1 257.9z'
      
    ]
  };

  

  
  

  var faPrintMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'print-magnifying-glass',
    icon: [
      640,
      512,
      ["print-search"],
      'f81a',
      
      'M176 48V160H128V48 0h48H448l64 64v96H464V83.9L428.1 48H176zM295.3 368H192v96H378.2c21.1 10.2 44.8 16 69.8 16c16.7 0 32.8-2.6 48-7.3V512H448 192 144V464 400H112 64V352 240 192h48H352c-17.2 12.9-31.7 29.3-42.6 48H112V352h32V320h48 96c0 16.7 2.6 32.8 7.3 48zM448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426c-20.5 14-45.3 22.1-72 22.1z'
      
    ]
  };

  
    var faPrintSearch = faPrintMagnifyingGlass;
  

  
  

  var faUtensilsSlash = {
    prefix: 'fasr',
    iconName: 'utensils-slash',
    icon: [
      640,
      512,
      [],
      'e464',
      
      'M544 352v47.6l76.9 59.7 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 66.7 51.8L122.5 0h48.3L159.6 101.1 200 132.5V24 0h48V24 168v1.8l43.1 33.5c3.1-5.7 4.9-12.3 4.9-19.2V169.3L280.1 26.7 277.2 0h48.3l2.4 21.3 16 144 .1 1.3V168v16c0 18.1-5.4 34.9-14.8 48.8L384 275.4V176C384 57.1 460.4 14.5 496 3.3C503.5 1 509.2 0 512 0h32V48 224v24 56 48zM104 184v-6.1L248 291.4V488v24H200V488 272h-8c-48.6 0-88-39.4-88-88zm328-8V304h64V248 224 55.1c-7.1 3.6-14.9 8.5-22.6 15.2C453.7 87.4 432 118.3 432 176z'
      
    ]
  };

  

  
  

  var faPersonBikingMountain = {
    prefix: 'fasr',
    iconName: 'person-biking-mountain',
    icon: [
      640,
      512,
      [128693,"biking-mountain"],
      'f84b',
      
      'M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-24.5 59.2l13.4 8.5L423 168h57 24v48H480 416h-7l-5.9-3.8-74.6-47.5-59 40.6c-10 6.9-9 22 1.9 27.5l67.4 33.7 13.3 6.6V288 416v24H304V416 302.8l-54.1-27c-43.6-21.8-47.8-82.4-7.6-110l72.1-49.6 13.1-9zM96 256h64v20.6c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3H256v64H235.4c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8V512H96V491.4c-7.4-2.2-14.6-5.2-21.3-8.8L60.1 497.1 14.9 451.9l14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3H0V352H20.6c2.2-7.4 5.2-14.6 8.8-21.3L14.9 316.1l45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8V256zm96 128A64 64 0 1 0 64 384a64 64 0 1 0 128 0zM544 256v20.6c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3H640v64H619.4c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8V512H480V491.4c-7.4-2.2-14.6-5.2-21.3-8.8l-14.6 14.6-45.3-45.3 14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3H384V352h20.6c2.2-7.4 5.2-14.6 8.8-21.3l-14.6-14.6 45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8V256h64zM512 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM176 176L112 96 213.3 20H256l48 60L176 176z'
      
    ]
  };

  
    var faBikingMountain = faPersonBikingMountain;
  

  
  

  var faHand = {
    prefix: 'fasr',
    iconName: 'hand',
    icon: [
      512,
      512,
      [9995,129306,"hand-paper"],
      'f256',
      
      'M216 0H192V24v8h0H136 112V56 261.5l-7.5-7.5L76.2 225.7l-17-17-17 17L7 260.9l-7 7v9.9 42.7 9.9l7 7 6.9 6.9L106.5 437c48 48 113.1 75 181 75H296c101.6 0 184-82.4 184-184h0V304 120 96H456 400V56 32H376 320V24l0-24H296 216zM192 80V232v24h48V232 80h0V56 48h32v8V232v24h48V232 80h32v8h0v24V232v24h48V232 144h32V280h0v24 24c0 75.1-60.9 136-136 136h-8.5c-55.2 0-108.1-21.9-147.1-60.9L48 310.6V287.8l11.2-11.2 11.3 11.3 40.8 40.8 17 17 17-17L153 321l7-7V304 80h32z'
      
    ]
  };

  
    var faHandPaper = faHand;
  

  
  

  var faHeadSideBrain = {
    prefix: 'fasr',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      'M112 361.7v19.6V448v16 48H96 64V480 464 381.2c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0h32C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1V264v24 16 32H496 480 464 448v48 16 16 32H416 400 368 320v16 16 16 16H288 272V464 448 400h48 80V336 288h48 16V270.1l-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48H224C126.8 48 48 127 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM312 192H272v16c0 22.1-17.9 40-40 40h-8v48 24H176V296 248H160c-22.1 0-40-17.9-40-40v-3.3c-14.1-6.2-24-20.3-24-36.7c0-22.1 17.9-40 40-40l.2 0c2-18 17.2-32 35.8-32c6.2 0 12.1 1.6 17.2 4.3C196 88.2 209.1 80 224 80s28 8.2 34.8 20.3c5.1-2.8 10.9-4.3 17.2-4.3c12.7 0 23.8 6.5 30.2 16.4c1.9-.3 3.8-.4 5.8-.4c22.1 0 40 17.9 40 40s-17.9 40-40 40z'
      
    ]
  };

  

  
  

  var faCucumber = {
    prefix: 'fasr',
    iconName: 'cucumber',
    icon: [
      512,
      512,
      [129362],
      'e401',
      
      'M71.4 440.6c-31.2-31.2-31.2-81.9 0-113.1l256-256c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1L385.1 240H336v49.1L184.6 440.6c-31.2 31.2-81.9 31.2-113.1 0zM37.5 474.5c47.8 47.8 123.9 49.9 174.2 6.4L232 501.3 277.3 456l-20.1-20.1L435.9 257.1 456 277.3 501.3 232l-20.4-20.4c43.5-50.3 41.4-126.4-6.4-174.2c-50-50-131-50-181 0L172.1 158.9 152 138.7 106.7 184l20.1 20.1L37.5 293.5c-50 50-50 131 0 181zM184 296H136v48h48V296zM376 104H328v48h48V104z'
      
    ]
  };

  

  
  

  var faPoliceBox = {
    prefix: 'fasr',
    iconName: 'police-box',
    icon: [
      384,
      512,
      [],
      'e021',
      
      'M208 0V16 32H320V64h32v48V464h32v48H352 304 80 32 0V464H32V112 64H64V32H176V16 0h32zM80 464H304V112H80V464zm24-328h32v32H104V136zm0 48h32v32H104V184zm80-48v32H152V136h32zm-32 48h32v32H152V184zm80-48v32H200V136h32zm0 48v32H200V184h32zm16-48h32v32H248V136zm32 48v32H248V184h32zM104 232h80v80H104V232z'
      
    ]
  };

  

  
  

  var faFlaskVial = {
    prefix: 'fasr',
    iconName: 'flask-vial',
    icon: [
      640,
      512,
      [],
      'e4f3',
      
      'M224 0h32V48H224V309.9l-59.3 96.3-4.7 7.7v9.1 19.6c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V48H0V0H32 80h96 48zM192 422.9l29-47.2c-.4 1.4-.7 2.8-1.2 4.1L320 217.2V48h-8H288V0h24H520h24V48H520h-8V217.2L636.4 419.4l3.6 5.8V432v56 24H616 216 192V488 432v-6.8l2.4-3.8c-.8 .7-1.6 1.5-2.4 2.2v-.6zM80 48V160h96V48H80zm0 160V352c0 26.5 21.5 48 48 48s48-21.5 48-48V208H80zM464 48H368V224v6.8l-3.6 5.8L313.1 320H518.9l-51.3-83.4-3.6-5.8V224 48zM240 438.8V464H592V438.8L548.4 368H283.6L240 438.8z'
      
    ]
  };

  

  
  

  var faEyeSlash = {
    prefix: 'fasr',
    iconName: 'eye-slash',
    icon: [
      640,
      512,
      [],
      'f070',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L524 384.1c41.9-44 70.2-93.9 84-128.1C578 181.3 478.4 32 320 32c-66.9 0-123.2 26.6-168.3 63L48.4 14.8zM190.8 125.4C227.6 98 270.8 80 320 80c63 0 116.2 29.5 158.9 70.6c35.6 34.3 61.5 74.5 76.6 105.4c-14.1 28.9-37.6 65.8-69.6 98.5L434 314.2c8.9-17.5 14-37.2 14-58.2c0-70.7-57.3-128-128-128c-8.6 0-17 .8-25.1 2.5c-22.5 4.5-42.9 14.9-59.5 29.5l-44.6-34.6zM395 283.9l-82.2-63.8-8.5-42.6c5.1-1 10.3-1.5 15.7-1.5c44.2 0 80 35.8 80 80c0 9.8-1.8 19.2-5 27.9zm49.9 162.7l-41.6-32.7C377.9 425.3 350.1 432 320 432c-63.1 0-116.2-29.5-158.9-70.6C125.6 327.2 99.7 286.9 84.5 256c9.1-18.7 22.2-40.7 38.9-62.8L85.7 163.5C60.2 197.1 42.1 230.8 32 256c30 74.7 129.6 224 288 224c46.9 0 88.6-13.1 124.9-33.4zm-86.7-68.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z'
      
    ]
  };

  

  
  

  var faFacePleading = {
    prefix: 'fasr',
    iconName: 'face-pleading',
    icon: [
      512,
      512,
      [],
      'e386',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM266.5 412.4c-2-2.1-5.3-4.4-10.5-4.4s-8.5 2.3-10.5 4.4l-16.4 17.5-35.1-32.7 16.4-17.5c8.9-9.5 24.2-19.6 45.5-19.6s36.7 10.1 45.5 19.6l16.4 17.5-35.1 32.7-16.4-17.5zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 32c-44.2 0-80-35.8-80-80c0-19 6.6-36.5 17.7-50.2L94 160.1l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2 30.8 8.8-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80zm240-80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 0c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2 30.8-8.8 1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4-3.7 29.7C425.4 203.5 432 221 432 240zm-304 0c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z'
      
    ]
  };

  

  
  

  var faUsers = {
    prefix: 'fasr',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      
      'M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM48 192L0 320H235.3c-26.6-23.5-43.3-57.8-43.3-96c0-11 1.4-21.8 4-32H48zM640 320L592 192H444c2.6 10.2 4 21 4 32c0 38.2-16.8 72.5-43.3 96H640zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM211.7 400H428.3l19.2 64h-255l19.2-64zM464 352H176L142.4 464 128 512h50.1H461.9 512l-14.4-48L464 352z'
      
    ]
  };

  

  
  

  var faCircleF = {
    prefix: 'fasr',
    iconName: 'circle-f',
    icon: [
      512,
      512,
      [],
      'e10e',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H160v24V264v96 24h48V360 288h88 24V240H296 208V176H328h24V128H328 184z'
      
    ]
  };

  

  
  

  var faRight = {
    prefix: 'fasr',
    iconName: 'right',
    icon: [
      448,
      512,
      [11157,"arrow-alt-right"],
      'f356',
      
      'M240 224l-48 0L48 224l0 64 144 0 48 0 0 48 0 60.1L380.1 256 240 115.9l0 60.1 0 48zM192 112l0-48 48 0 16 0L414.1 222.1 448 256l-33.9 33.9L256 448l-16 0-48 0 0-48 0-16 0-48-48 0-96 0L0 336l0-48 0-64 0-48 48 0 96 0 48 0 0-48 0-16z'
      
    ]
  };

  
    var faArrowAltRight = faRight;
  

  
  

  var faPersonRays = {
    prefix: 'fasr',
    iconName: 'person-rays',
    icon: [
      512,
      512,
      [],
      'e54d',
      
      'M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H190.8l-6.9 12.4-75.3 136L97 297.4l42 23.3 11.6-21L192 224.9V488v24h48V488 352h32V488v24h48V488 224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136L321.2 128H307.1 204.9zM272 304H240V176h32V304zM57 23L40 6.1 6.1 40 23 57l64 64 17 17L137.9 104 121 87 57 23zM489 57l17-17L472 6.1 455 23 391 87l-17 17L408 137.9l17-17 64-64zM121 425l17-17L104 374.1 87 391 23 455l-17 17L40 505.9l17-17 64-64zM425 391l-17-17L374.1 408l17 17 64 64 17 17L505.9 472l-17-17-64-64z'
      
    ]
  };

  

  
  

  var faReplyClock = {
    prefix: 'fasr',
    iconName: 'reply-clock',
    icon: [
      640,
      512,
      ["reply-time"],
      'e239',
      
      'M640 144a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 64V80v48h32 16v32H544 496 480V144 80 64h32zm0 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-11.4 0-22.6-1.1-33.4-3.2c.9 6.3 1.4 12.7 1.4 19.2c0 17-3.1 32-8.2 45.4C434.6 317.8 374.7 272 304 272H224 176v48 16.2L71 240l105-96.2V160v48h48H332c-5.9-15.1-9.8-31.2-11.3-48H272 224V112 99.8v-.9V64H192L176 78.7 35.5 207.4 0 240l35.5 32.6L176 401.3 192 416h32V381.1v-.9V368 320h48 32c61.9 0 112 50.1 112 112c0 1.4 0 2.9-.1 4.3C414.1 481.9 384 512 384 512s41.8-15.7 77.7-53c26.9-28 50.3-68.1 50.3-123z'
      
    ]
  };

  
    var faReplyTime = faReplyClock;
  

  
  

  var faMitten = {
    prefix: 'fasr',
    iconName: 'mitten',
    icon: [
      448,
      512,
      [],
      'f7b5',
      
      'M0 135.6C0 60.7 60.7 0 135.6 0c58.4 0 110.2 37.3 128.6 92.7L297 191.2l21.2-23.3 16.4-18 17.8 16.7 76.8 72 15.2 14.3-12.1 17.1L352 383.6v.4H304v-8-7.6l4.4-6.2 72.7-102.9-43.8-41L305 253.8l-27.6 30.3-13-38.9L218.7 107.9C206.7 72.1 173.3 48 135.6 48C87.2 48 48 87.2 48 135.6v9.5c0 7.9 1 15.8 2.9 23.5l52.4 209.5 .7 2.9v3H55.3L4.3 180.3C1.5 168.8 0 157 0 145.1v-9.5zM384 416v96H32V416H384z'
      
    ]
  };

  

  
  

  var faArrowDownZA = {
    prefix: 'fasr',
    iconName: 'arrow-down-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-desc","sort-alpha-down-alt"],
      'f881',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM328 32h24H480h24V56v8 9.9l-7 7-95 95H480h24v48H480 352 328V200v-8-9.9l7-7 95-95H352 328V32zm72.6 240h30.8l6.4 14 89.3 194H474.2l-14.8-32.2c-1.1 .2-2.2 .2-3.4 .2H372.5l-14.7 32H304.9l89.3-194 6.4-14zM416 353.4L394.6 400h42.8L416 353.4z'
      
    ]
  };

  
    var faSortAlphaDesc = faArrowDownZA;
  
    var faSortAlphaDownAlt = faArrowDownZA;
  

  
  

  var faBagShopping = {
    prefix: 'fasr',
    iconName: 'bag-shopping',
    icon: [
      448,
      512,
      ["shopping-bag"],
      'f290',
      
      'M160 112v48H288V112c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 96H48V464H400V208H336v56 24H288V264 208H160v56 24H112V264 208zm0-48V112C112 50.1 162.1 0 224 0s112 50.1 112 112v48h64 48v48V464v48H400 48 0V464 208 160H48h64z'
      
    ]
  };

  
    var faShoppingBag = faBagShopping;
  

  
  

  var faHandHeart = {
    prefix: 'fasr',
    iconName: 'hand-heart',
    icon: [
      512,
      512,
      [],
      'f4bc',
      
      'M192 0h24 80 24l0 24v8h56 24V56 96h56 24v24V304v24h0c0 101.6-82.4 184-184 184h-8.5c-67.9 0-133-27-181-75L13.9 344.5 7 337.5l-7-7v-9.9V277.8v-9.9l7-7 35.2-35.2 17-17 17 17 28.3 28.3 7.5 7.5V56 32h24 56 0V24 0zM160 80V304v9.9l-7 7-7.7 7.7-17 17-17-17L70.5 287.9 59.2 276.6 48 287.8v22.9l92.5 92.5c39 39 91.9 60.9 147.1 60.9H296c75.1 0 136-60.9 136-136V304 280h0V144H400v88 24H352V232 112 88h0V80H320V232v24H272V232 56 48H240v8V80h0V232v24H192V232 80H160zm48 247.5c0-21.8 17.7-39.5 39.5-39.5h1.6c10.6 0 20.8 4.1 28.5 11.5l5.1 4.9 5.1-4.9c7.7-7.4 17.9-11.5 28.5-11.5h1.6c21.8 0 39.5 17.7 39.5 39.5c0 10.7-4.4 21-12.1 28.4L290.1 409l-7.4 7.1-7.4-7.1-55.2-53.1c-7.7-7.4-12.1-17.7-12.1-28.4z'
      
    ]
  };

  

  
  

  var faTruckContainerEmpty = {
    prefix: 'fasr',
    iconName: 'truck-container-empty',
    icon: [
      640,
      512,
      [],
      'e2b5',
      
      'M432 144h24 88 11.4l7.2 8.8 72 88 5.4 6.6V256v32V400H608c0 44.2-35.8 80-80 80s-80-35.8-80-80H432 288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32H432V256 168 144zm100.6 48H480v64H585l-52.4-64zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faCalendarExclamation = {
    prefix: 'fasr',
    iconName: 'calendar-exclamation',
    icon: [
      448,
      512,
      [],
      'f334',
      
      'M152 24V0H104V24 64H0v80 48V464v48H48 400h48V464 192 144 64H344V24 0H296V24 64H152V24zM48 192H400V464H48V192zm200 32H200v24 80 24h48V328 248 224zm0 160H200v48h48V384z'
      
    ]
  };

  

  
  

  var faSink = {
    prefix: 'fasr',
    iconName: 'sink',
    icon: [
      512,
      512,
      [],
      'e06d',
      
      'M280 88c0-22.1 17.9-40 40-40s40 17.9 40 40v24 24h48V112 88c0-48.6-39.4-88-88-88s-88 39.4-88 88V288H160V232 208H136 56 32v48H56h56v32H24 0v48H24 232h48H488h24V288H488 400V256h64 24V208H464 376 352v24 56H280V88zM32 368v24c0 66.3 53.7 120 120 120H360c66.3 0 120-53.7 120-120V368H432v24c0 39.8-32.2 72-72 72H152c-39.8 0-72-32.2-72-72V368H32z'
      
    ]
  };

  

  
  

  var faSunset = {
    prefix: 'fasr',
    iconName: 'sunset',
    icon: [
      576,
      512,
      [127751],
      'f767',
      
      'M305 217l80-80 17-17L368 86.1l-17 17-39 39V24 0H264V24 142.1l-39-39-17-17L174.1 120l17 17 80 80 17 17 17-17zm-17 64.1l-62.9-33.9L182 224l-14.1 46.9-20.5 68.4L78.9 359.9 32 374l23.2 43.1L80.5 464H24 0v48H24 552h24V464H552 495.5l25.3-46.9L544 374l-46.9-14.1-68.4-20.5-20.5-68.4L394 224l-43.1 23.2L288 281.1zM177.1 464H135l-3.6-6.8L102.2 403l59-17.7 24.8-7.4 7.4-24.8 17.7-59 54.2 29.2L288 335.6l22.8-12.3L365 294.2l17.7 59 7.4 24.8 24.8 7.4 59 17.7-29.2 54.2L441 464H398.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96zM288 416c29.8 0 54.9 20.4 62 48H226c7.1-27.6 32.2-48 62-48z'
      
    ]
  };

  

  
  

  var faMicroscope = {
    prefix: 'fasr',
    iconName: 'microscope',
    icon: [
      512,
      512,
      [128300],
      'f610',
      
      'M256 0H160V32H128V80 272v48h32v32h96V320h32V272 80 32H256V0zM176 80h64V272H176V80zM24 464H0v48H24 320 488h24V464H488 447c39.9-35.2 65-86.7 65-144c0-106-86-192-192-192h0v48h0c79.5 0 144 64.5 144 144s-64.5 144-144 144h0H24zm72-80v48h24H296h24V384H296 120 96z'
      
    ]
  };

  

  
  

  var faHourglassHalf = {
    prefix: 'fasr',
    iconName: 'hourglass-half',
    icon: [
      384,
      512,
      ["hourglass-2"],
      'f252',
      
      'M0 0H24 360h24V48H360h-8v72 9.9l-7 7-119 119L345 375l7 7V392v72h8 24v48H360 24 0V464H24h8V392v-9.9l7-7 119-119L39 137l-7-7V120 48H24 0V0zM80 48v62.1L97.9 128H286.1L304 110.1V48H80zM97.9 384H286.1L192 289.9 97.9 384z'
      
    ]
  };

  
    var faHourglass2 = faHourglassHalf;
  

  
  

  var faCircleCalendar = {
    prefix: 'fasr',
    iconName: 'circle-calendar',
    icon: [
      512,
      512,
      ["calendar-circle"],
      'e102',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM224 112v16 16h64V128 112h32v16 16h16 48v48 32 96 48H336 176 128V320 224 192 144h48 16V128 112h32zM176 224v96H336V224H176z'
      
    ]
  };

  
    var faCalendarCircle = faCircleCalendar;
  

  
  

  var faCircleW = {
    prefix: 'fasr',
    iconName: 'circle-w',
    icon: [
      512,
      512,
      [],
      'e12c',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM409.5 152h-50L318.8 293.5 278.9 168.7 273.5 152h-35l-5.3 16.7L193.2 293.5 152.5 152h-50l66.4 230.6 5 17.4h35.6l5.3-16.7L256 254.7l41.1 128.6 5.3 16.7h35.6l5-17.4L409.5 152z'
      
    ]
  };

  

  
  

  var faHeartCircleMinus = {
    prefix: 'fasr',
    iconName: 'heart-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ff',
      
      'M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1l4.5-4.5c4 17.3 10.5 33.7 19.2 48.6L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-14.4-6.6-29.8-11.4-45.9-14c2.7-8.5 4.1-17.4 4.1-26.4c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16V352H496 368 352v32h16H496h16z'
      
    ]
  };

  

  
  

  var faWaveSine = {
    prefix: 'fasr',
    iconName: 'wave-sine',
    icon: [
      640,
      512,
      [8767],
      'f899',
      
      'M47.3 245.6s0 0-23.3-5.6S.7 234.4 .7 234.4l0 0 0-.1 0-.2 .1-.5c.1-.4 .2-1 .4-1.7c.4-1.4 .9-3.4 1.6-5.9c1.4-5 3.6-12 6.5-20.4c5.8-16.7 14.9-39.1 27.8-61.7C62.3 100.2 106.5 48 176 48c54.7 0 90.4 29.6 114.9 68.8c23.2 37.2 37.9 85.7 51.5 130.3l.6 1.9c14.3 46.9 27.4 89.5 46.9 120.8C408.4 399.6 430.7 416 464 416c42.5 0 74.3-31.8 97.2-71.9c11.1-19.4 19-38.9 24.2-53.8c2.6-7.4 4.4-13.5 5.6-17.7c.6-2.1 1-3.7 1.3-4.8l.3-1.2 .1-.2 0 0s0 0 23.3 5.6s23.3 5.6 23.3 5.6l0 0 0 .1 0 .2-.1 .5c-.1 .4-.2 1-.4 1.7c-.4 1.4-.9 3.4-1.6 5.9c-1.4 5-3.6 12-6.5 20.4c-5.8 16.7-14.9 39.1-27.8 61.7C577.7 411.8 533.5 464 464 464c-54.7 0-90.4-29.6-114.9-68.8c-23.2-37.2-37.9-85.7-51.5-130.3L297 263c-14.3-46.9-27.4-89.5-46.9-120.8C231.6 112.4 209.3 96 176 96c-42.5 0-74.3 31.8-97.2 71.9c-11.1 19.4-19 38.9-24.2 53.8c-2.6 7.4-4.4 13.5-5.6 17.7c-.6 2.1-1 3.7-1.3 4.8l-.3 1.2-.1 .2 0 0z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleDollar = {
    prefix: 'fasr',
    iconName: 'display-chart-up-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e5e6',
      
      'M48 48H528V194.9c17 3.1 33.1 8.7 48 16.3V48 0H528 48 0V48 368v48H48 211.7l-8 48H152 128v48h24 72H352h42.8c-18.3-12.9-34.1-29.2-46.3-48H323.7 280 252.3l8-48H280h35.7 11c-4.3-15.3-6.6-31.4-6.6-48H48V48zm432 72V96H456 376 352v48h24 22.1L304 238.1l-63-63-17-17-17 17L103 279 137 313l87-87 63 63 17 17 17-17 111-111V200v4c15.1-5.9 31.2-9.8 48-11.3V120zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8 16H480v-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L436 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288 272h32v16 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z'
      
    ]
  };

  

  
  

  var faShareNodes = {
    prefix: 'fasr',
    iconName: 'share-nodes',
    icon: [
      448,
      512,
      ["share-alt"],
      'f1e0',
      
      'M448 128c0 53-43 96-96 96c-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1L279.6 321c17.6-20.2 43.5-33 72.4-33c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-6.9 .7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33c-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1c0-53 43-96 96-96s96 43 96 96zM96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM352 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faShareAlt = faShareNodes;
  

  
  

  var faKnife = {
    prefix: 'fasr',
    iconName: 'knife',
    icon: [
      512,
      512,
      ["utensil-knife"],
      'f2e4',
      
      'M461.8 0H472h16 24V24 83.6c0 65.5-25.9 128.4-72.1 174.9L330 368.9l-17 17.1-17-17-62.8-62.8L57.3 488.7 40.6 505.9 6.1 472.6l16.7-17.3 432-448L461.8 0zM266.6 271.6L313 318l92.9-93.4c37.3-37.5 58.2-88.2 58.2-141V66.9L266.6 271.6z'
      
    ]
  };

  
    var faUtensilKnife = faKnife;
  

  
  

  var faLightbulbOn = {
    prefix: 'fasr',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      'M448 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8 11.3-12.7 17.7l0 0 0 0 0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8l0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C200.4 228.3 192 203.2 192 176c0-70.7 57.3-128 128-128s128 57.3 128 128zm-176 0c0-26.5 21.5-48 48-48V96c-44.2 0-80 35.8-80 80h32zM240 512H400V416H240v96zM87.3 16L67.3 2.7 40.7 42.7 60.7 56l6 4 24 16 20 13.3 26.6-39.9L117.3 36l-24-16-6-4zM579.3 56l20-13.3L572.7 2.7 552.7 16l-6 4-24 16-20 13.3 26.6 39.9 20-13.3 24-16 6-4zM24 160H0v48H24 72 96V160H72 24zm544 0H544v48h24 48 24V160H616 568zM117.3 332l20-13.3-26.6-39.9L90.7 292l-24 16-6 4-20 13.3 26.6 39.9 20-13.3 6-4 24-16zm432-39.9l-20-13.3-26.6 39.9 20 13.3 24 16 6 4 20 13.3 26.6-39.9-20-13.3-6-4-24-16z'
      
    ]
  };

  

  
  

  var faMessageMiddleTop = {
    prefix: 'fasr',
    iconName: 'message-middle-top',
    icon: [
      512,
      512,
      ["comment-middle-top-alt"],
      'e1e2',
      
      'M173.7 96H48 0v48V464v48H48 464h48V464 144 96H464 338.3L287.6 36.9 256 0 224.4 36.9 173.7 96zM464 144V464H48V144H173.7h22.1l14.4-16.8L256 73.8l45.8 53.5L316.2 144h22.1H464z'
      
    ]
  };

  
    var faCommentMiddleTopAlt = faMessageMiddleTop;
  

  
  

  var faCarSide = {
    prefix: 'fasr',
    iconName: 'car-side',
    icon: [
      640,
      512,
      [128663],
      'f5e4',
      
      'M111.8 32H128 384h11.5l7.2 9L523.5 192H592h48v48V352v48H592 574.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H48 0V352 240 192H47.8l58-144.9 6-15.1zM389.5 352c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H592V240H48V352H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H389.5zm45.3 48a48 48 0 1 0 90.5-32 48 48 0 1 0 -90.5 32zM208 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM99.4 192H224V176 96 80H144.2L99.4 192zM272 192H462.1L372.5 80H272V96v80 16z'
      
    ]
  };

  

  
  

  var faSquareSliders = {
    prefix: 'fasr',
    iconName: 'square-sliders',
    icon: [
      448,
      512,
      ["sliders-h-square"],
      'f3f0',
      
      'M48 432l352 0 0-352L48 80l0 352zM0 80L0 32l48 0 352 0 48 0 0 48 0 352 0 48-48 0L48 480 0 480l0-48L0 80zM96 200l0-48 24 0 32 0 0-16 0-24 48 0 0 24 0 16 128 0 24 0 0 48-24 0-128 0 0 16 0 24-48 0 0-24 0-16-32 0-24 0zm24 160l-24 0 0-48 24 0 128 0 0-16 0-24 48 0 0 24 0 16 32 0 24 0 0 48-24 0-32 0 0 16 0 24-48 0 0-24 0-16-128 0z'
      
    ]
  };

  
    var faSlidersHSquare = faSquareSliders;
  

  
  

  var faPenToSquare = {
    prefix: 'fasr',
    iconName: 'pen-to-square',
    icon: [
      512,
      512,
      ["edit"],
      'f044',
      
      'M330 137.9L374.1 182 233.7 322.4l-50.4 6.3 6.3-50.4L330 137.9zM425 199l17-17 36.1-36.1L512 112 478.1 78.1 433.9 33.9 400 0 366.1 33.9 330 70 313 87l-17 17L144 256l-9.9 78.9L128 384l49.1-6.1L256 368 408 216l17-17zm-17-50.9L363.9 104 400 67.9 444.1 112 408 148.1zM24 64H0V88 488v24H24 424h24V488 312 288H400v24V464H48V112H200h24V64H200 24z'
      
    ]
  };

  
    var faEdit = faPenToSquare;
  

  
  

  var faSackDollar = {
    prefix: 'fasr',
    iconName: 'sack-dollar',
    icon: [
      512,
      512,
      [128176],
      'f81d',
      
      'M360.2 80.9L382.9 48 416 0H357.7 154.3 96l33.1 48 22.7 32.9L179 120.4c-8.2 5.3-17.8 11.7-28.2 19.4C89.4 185.5 0 274.8 0 416v48 48H48 464h48V464 416c0-141.2-89.4-230.5-150.8-276.1c-10.4-7.7-20-14.2-28.2-19.4l27.3-39.5zM464 464H48V416c0-139 102.9-220.6 156.9-255.2l13.8-8.8h74.6l13.8 8.8C361.1 195.4 464 277 464 416v48zM293.5 93.2L286 104H226l-7.5-10.8L187.4 48H324.6L293.5 93.2zM276 224V204H236v20 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4.1c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.2l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5l0 0c7.9 2.7 20.3 7 29.9 9.1V416v20h40V416v-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l0 0 0 0-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V224z'
      
    ]
  };

  

  
  

  var faCrosshairsSimple = {
    prefix: 'fasr',
    iconName: 'crosshairs-simple',
    icon: [
      512,
      512,
      [],
      'e59f',
      
      'M462.6 232H392 368v48h24 70.6c-11 95.7-86.9 171.6-182.6 182.6V440 392 368H232v24 48 22.6C136.3 451.6 60.4 375.7 49.4 280H120h24V232H120 49.4C60.4 136.3 136.3 60.4 232 49.4V120v24h48V120 49.4c95.7 11 171.6 86.9 182.6 182.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faBridgeLock = {
    prefix: 'fasr',
    iconName: 'bridge-lock',
    icon: [
      640,
      512,
      [],
      'e4cc',
      
      'M32 32H56 576h24V80H576 536v64h48 24v48h-1.6c-20.2-19.8-47.9-32-78.4-32s-58.2 12.2-78.4 32H280 232 152 104 56 32V144H56h48V80H56 32V32zM384 258.5V288v39c-12-23.2-36.1-39-64-39c-39.8 0-72 32.2-72 72v96 24H224 128 104V456 336c0-26.5-21.5-48-48-48H32V240H56c53 0 96 43 96 96v96h48V360c0-66.3 53.7-120 120-120c23.5 0 45.5 6.8 64 18.5zM408 80v64h80V80H408zm-48 64V80H280v64h80zM152 80v64h80V80H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32V512H416V320h32V272z'
      
    ]
  };

  

  
  

  var faFolderArrowUp = {
    prefix: 'fasr',
    iconName: 'folder-arrow-up',
    icon: [
      512,
      512,
      ["folder-upload"],
      'e054',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm8 232v24H232V376 273.9l-31 31-17 17L150.1 288l17-17 72-72 17-17 17 17 72 72 17 17L328 321.9l-17-17-31-31V376z'
      
    ]
  };

  
    var faFolderUpload = faFolderArrowUp;
  

  
  

  var faSquareSmall = {
    prefix: 'fasr',
    iconName: 'square-small',
    icon: [
      320,
      512,
      [],
      'e27e',
      
      'M272 144V368H48V144H272zM48 96H0v48V368v48H48 272h48V368 144 96H272 48z'
      
    ]
  };

  

  
  

  var faBackpack = {
    prefix: 'fasr',
    iconName: 'backpack',
    icon: [
      448,
      512,
      [127890],
      'f5d4',
      
      'M136 0h24H288h24V24 80h8c70.7 0 128 57.3 128 128V464v48H400 368 320 128 80 48 0V464 208C0 137.3 57.3 80 128 80h8V24 0zm-8 464H320V400H128v64zm240 0h32V208c0-44.2-35.8-80-80-80H288 160 128c-44.2 0-80 35.8-80 80V464H80V376 264 240h24H344h24v24V376v88zM264 48H184V80h80V48zM144 160H304h24v48H304 144 120V160h24zM320 352V288H128v64H320z'
      
    ]
  };

  

  
  

  var faArrowsCross = {
    prefix: 'fasr',
    iconName: 'arrows-cross',
    icon: [
      448,
      512,
      [],
      'e0a2',
      
      'M280 32H256V80h24 86.1L18.2 427.8l-17 17 33.9 33.9 17-17L400 113.9V200v24h48V200 56 32H424 280zM52.2 50.2l-17-17L1.3 67.2l17 17 147 147 34.3-33.6L52.2 50.2zM366.1 432H280 256v48h24H424h24V456 312 288H400v24 86.1L278.7 276.8l-34.3 33.6L366.1 432z'
      
    ]
  };

  

  
  

  var faTree = {
    prefix: 'fasr',
    iconName: 'tree',
    icon: [
      448,
      512,
      [127794],
      'f1bb',
      
      'M392 188.1V176l-15.3-16L257.2 34.8 224 0 190.8 34.8 71.3 160 56 176v12.1V208H89.5h2.3H104L56 256 40 272 24 288v24.2V320H56h3.9H72h8L40 368 13.3 400 0 416v32H48 200v40 24h48V488 448H400h48V416l-13.3-16L408 368l-40-48h8 12.1H392h32v-7.8V288l-16-16-16-16-48-48h12.2 2.3H392V188.1zM248 400V216 192H200v24V400H75.8l41.1-49.3L144 318.2V272H107.9l30.1-30.1L176 203.9V160H137.6L224 69.5 310.4 160H272v43.9l38.1 38.1L340.1 272H304v46.2l27.1 32.6L372.2 400H248z'
      
    ]
  };

  

  
  

  var faCommentsQuestionCheck = {
    prefix: 'fasr',
    iconName: 'comments-question-check',
    icon: [
      640,
      512,
      [],
      'e14f',
      
      'M85.7 298.9l11-27.4L77.2 249.4C58.2 227.8 48 202.5 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.5 0-26.6-1.3-39-3.9l-10.2-2.1-10.1 2.3-70 16.2 7.1-17.6zM0 384l57-13.1 102.6-23.7c15.6 3.1 31.8 4.8 48.5 4.8c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 39.4 15.3 75.8 41.2 105.1L21.7 329.7 0 384zm432 96c16.7 0 32.9-1.7 48.5-4.8L583 498.9 640 512l-21.7-54.3-19.4-48.6C624.7 379.8 640 343.4 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 26.5-10.2 51.8-29.2 73.4l-19.5 22.2 11 27.4 7.1 17.6-70.1-16.2-10.1-2.3L471 428.1c-12.4 2.5-25.5 3.9-39 3.9c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480zM185.3 86.3c-21.4 0-38.7 17.3-38.7 38.7l0 4.6 32 0 0-4.6c0-3.7 3-6.7 6.7-6.7h40.3c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18-8 4.6v9.3 15.2 16h32v-16-5.9L247.4 168c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7H185.3zM225 232.7H191v34h34v-34zm314.3 56l11.3-11.3L528 254.7 516.7 266l-74 74-31.4-31.4L400 297.4 377.4 320l11.3 11.3L431.4 374l11.3 11.3L454 374l85.3-85.3z'
      
    ]
  };

  

  
  

  var faHouseFloodWater = {
    prefix: 'fasr',
    iconName: 'house-flood-water',
    icon: [
      576,
      512,
      [],
      'e50e',
      
      'M301.9 12.4L288 2.6l-13.9 9.8-192 136L62.5 162.3l27.7 39.2 19.6-13.9 2.1-1.5v65.4l2.6 1.9 1.1 .8c13.9 10 23.6 17 35.5 22.5c2.8 1.3 5.8 2.5 8.7 3.6V152.1L288 61.4l128 90.7V280.3c3-1.1 5.9-2.3 8.7-3.6c12-5.5 21.7-12.5 35.5-22.5l0 0 3.7-2.7V186.1l2.1 1.5 19.6 13.9 27.7-39.2-19.6-13.9-192-136zM96 366.2c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V352c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6 0 0c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4 0 0c-13 11.6-24.8 22.2-40.2 30.9C39.5 344.2 19.7 352 0 352v48c31.5 0 59.7-12.2 79-23.1c6.5-3.7 12.2-7.4 16.9-10.7zM79 488.9c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.7 3.3 10.5 7 16.9 10.7c19.3 11 47.6 23.1 79.1 23.1s59.7-12.2 79.1-23.1c6.5-3.7 12.2-7.4 16.9-10.7c4.8 3.3 10.5 7 17 10.7c19.3 11 47.6 23.1 79.1 23.1V464c-19.7 0-39.5-7.8-55.4-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.9 9-35.6 16.9-55.3 16.9s-39.5-7.8-55.3-16.9c-15.4-8.7-27.2-19.3-40.3-30.9l-.4-.4-.4 .4c-13 11.6-24.8 22.2-40.2 30.9C39.5 456.2 19.7 464 0 464v48c31.5 0 59.7-12.2 79-23.1z'
      
    ]
  };

  

  
  

  var faMapLocation = {
    prefix: 'fasr',
    iconName: 'map-location',
    icon: [
      576,
      512,
      ["map-marked"],
      'f59f',
      
      'M408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 70 120 200 120 200s120-130 120-200zM373.9 265.1C366.4 275.3 359 285 352 293.9V452.2L224 405.7V293.9c-7-8.8-14.4-18.5-21.9-28.8c-8.8-12.1-17.8-25.1-26.1-38.6V405.3l-128 41V195l96.6-30.9c-5.2-14.6-8.6-29.6-8.6-44.1c0-1.2 0-2.4 0-3.5L0 160V461.6 512l48-15.4L200 448l176 64 200-64V146.4 96l-48 15.4-90 28.8c-3.6 19-11.5 38.1-20.3 55.2l-1.1 2L528 161.8V413l-128 41V226.5c-8.4 13.4-17.3 26.5-26.1 38.6z'
      
    ]
  };

  
    var faMapMarked = faMapLocation;
  

  
  

  var faBlanket = {
    prefix: 'fasr',
    iconName: 'blanket',
    icon: [
      448,
      512,
      [],
      'f498',
      
      'M24 32H0V56 256v24 24V456v24H24 424h24V432H424 48V304H400v40H120 96v48h24H424h24V368 304 280 256 56 32H424 24zM400 256H48V80H400V256z'
      
    ]
  };

  

  
  

  var faGlobePointer = {
    prefix: 'fasr',
    iconName: 'globe-pointer',
    icon: [
      512,
      512,
      [],
      'e60e',
      
      'M246.6 439.7l-20.7 70.5c9.9 1.2 19.9 1.8 30.1 1.8c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 10.2 .6 20.2 1.8 30.1l46.9-13.8c-.4-5.4-.6-10.8-.6-16.3c0-16.5 1.9-32.6 5.6-48h77.8c-1.9 13-3 26.7-3.3 41l48.7-14.3c.7-9.2 1.8-18.1 3.2-26.7H332c2.5 15 4 30.9 4 48s-1.4 33-4 48H286.5l-14.1 48h46.8c-10.2 27.4-23.8 50-37.5 68.1c-8.9 11.8-17.8 21.6-25.7 29.4c-3-3-6.1-6.2-9.4-9.8zM281.7 91.9c13.6 18 27.3 40.6 37.5 68.1H192.8c10.2-27.4 23.8-50 37.5-68.1c8.9-11.8 17.8-21.6 25.7-29.4c7.9 7.8 16.8 17.6 25.7 29.4zM384 256c0-16.9-1.2-32.9-3.4-48h77.8c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48H380.6c2.2-15.1 3.4-31.1 3.4-48zm-14.2-96c-13.4-43.5-34.5-77.9-54.9-103.5c54.6 16.1 99.8 54 125.6 103.5H369.8zM71.4 160c25.8-49.6 71.1-87.4 125.6-103.5c-20.4 25.6-41.5 60-54.9 103.5H71.4zM369.8 352h70.7c-25.8 49.6-71.1 87.4-125.6 103.5c20.4-25.6 41.5-60 54.9-103.5zM0 320l96 48 1.4 1.4-96 96 45.3 45.3 96-96L144 416l48 96 80-272L0 320z'
      
    ]
  };

  

  
  

  var faHotTubPerson = {
    prefix: 'fasr',
    iconName: 'hot-tub-person',
    icon: [
      512,
      512,
      ["hot-tub"],
      'f593',
      
      'M64 0a64 64 0 1 1 0 128A64 64 0 1 1 64 0zm64 160l128 96H376l24 0 64 0h48v48V464v48H464 48 0V464 336 280 256 208 160H48h80zm-16 48H48v48l88 0h40l-64-48zM48 336V464h64V304H48v32zM232 464V304H160V464h72zm120 0V304l-72 0V464h72zm48 0h64V304H400V464zM272 24c0 26.7 14.3 46.4 35 73.4l1.4 1.9C327.5 124 352 155.8 352 200v24H304V200c0-26.7-14.3-46.4-35-73.4l-1.4-1.9C248.5 100 224 68.2 224 24V0h48V24zm112 0c0 26.7 14.3 46.4 35 73.4l1.4 1.9C439.5 124 464 155.8 464 200v24H416V200c0-26.7-14.3-46.4-35-73.4l-1.4-1.9C360.5 100 336 68.2 336 24V0h48V24z'
      
    ]
  };

  
    var faHotTub = faHotTubPerson;
  

  
  

  var faHouseNight = {
    prefix: 'fasr',
    iconName: 'house-night',
    icon: [
      640,
      512,
      [],
      'e010',
      
      'M146 5.3C135.3 1.8 123.8 0 112 0C50.1 0 0 50.1 0 112s50.1 112 112 112c40.6 0 76.1-21.6 95.8-53.9c-9.9 3.8-20.6 5.9-31.8 5.9c-48.6 0-88-39.4-88-88c0-38.1 24.2-70.5 58-82.7zM256 0L234.7 42.7 192 64l42.7 21.3L256 128l21.3-42.7L320 64 277.3 42.7 256 0zM96 320L74.7 362.7 32 384l42.7 21.3L96 448l21.3-42.7L160 384l-42.7-21.3L96 320zM415 109.3l-15-12-15 12-200 160-18.7 15 30 37.5 18.7-15 9-7.2V488v24h24H552h24V488 299.5l9 7.2 18.7 15 30-37.5-18.7-15-200-160zM528 261.1V464H272V261.1L400 158.7 528 261.1zM352 288v96h96V288H352z'
      
    ]
  };

  

  
  

  var faRectanglePro = {
    prefix: 'fasr',
    iconName: 'rectangle-pro',
    icon: [
      640,
      512,
      ["pro"],
      'e235',
      
      'M48 80V432H592V80H48zM0 32H48 592h48V80 432v48H592 48 0V432 80 32zM80 160h24 56c35.3 0 64 28.7 64 64s-28.7 64-64 64H128v40 24H80V328 264 184 160zm48 80h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128v32zm272 8c0-48.6 39.4-88 88-88s88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88V248zm88-40c-22.1 0-40 17.9-40 40v16c0 22.1 17.9 40 40 40s40-17.9 40-40V248c0-22.1-17.9-40-40-40zM264 160h56c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5 23 36.7H346.7l-7-11.3-33-52.7H288v40 24H240V328 264 184 160h24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H288v32h32z'
      
    ]
  };

  
    var faPro = faRectanglePro;
  

  
  

  var faMonkey = {
    prefix: 'fasr',
    iconName: 'monkey',
    icon: [
      576,
      512,
      [128018],
      'f6fb',
      
      'M160 416c0-86.2 48.7-161 120-198.4V256v18c-43.7 32-72 83.7-72 142v48H400V440c0-39.8-32.2-72-72-72H312 288V320h24 16c27 0 51.9 8.9 72 24V320 288h49.9L569 407l7 7V424v64 24H528V488 433.9l-80-80V440v24h8 24v48H456h-8H400 208 160h-8C68.1 512 0 443.9 0 360V24 0H24 200h24V24 168v24H200 120 96V144h24 56V48H48V360c0 57.4 46.6 104 104 104h8V416zM448 256H416 400 312v-.6V224 203.8 191.5c-31.6-3.9-56-30.9-56-63.5c0-35.3 28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64c0 32.6-24.4 59.6-56 63.5V256H448zM384 64c-26.5 0-48 21.5-48 48c0 23.8 17.3 43.5 40 47.3V208h80V159.3c22.7-3.8 40-23.6 40-47.3c0-26.5-21.5-48-48-48H384zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faSignalBarsSlash = {
    prefix: 'fasr',
    iconName: 'signal-bars-slash',
    icon: [
      640,
      512,
      ["signal-alt-slash"],
      'f694',
      
      'M624 512v0H576 544v0h80zm0-50.3L639.9 474l-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L336 238.1V176 128h48 32 48v48V337.5l32 24.8V48 0h48 32 48V48 461.7zm-80-62.1l32 24.8V48H544V399.6zM416 300.2V176H384v99.4l32 24.8zm-32 98.3V464h32V423.8l48 37.8V464v48H416 384 336V464 360.7l48 37.8zM203.1 256L304 335.5V464v48H256 224 176V464 304 256h27.1zM224 304V464h32V304H224zM96 432H64v32H96V432zM64 384H96h48v48 32 48H96 64 16V464 432 384H64z'
      
    ]
  };

  
    var faSignalAltSlash = faSignalBarsSlash;
  

  
  

  var faGasPump = {
    prefix: 'fasr',
    iconName: 'gas-pump',
    icon: [
      512,
      512,
      [9981],
      'f52f',
      
      'M272 48V192H80V48H272zm0 192V464H80l0-224H272zM32 48V464L0 464v48H32 80 272h48 32V464l-32 0V304h8c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V136v-9.9l-7-7L417 31l-17-17L366.1 48l17 17 33 33V160c0 29.8 20.4 54.9 48 62V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88h-8V48 0H272 80 32V48z'
      
    ]
  };

  

  
  

  var faArrowDownFromLine = {
    prefix: 'fasr',
    iconName: 'arrow-down-from-line',
    icon: [
      384,
      512,
      [8615,"arrow-from-top"],
      'f345',
      
      'M209.3 461.5L192 479.4l-17.3-17.9L46.7 328.7 30.1 311.4l34.6-33.3 16.7 17.3 86.7 90L168 184l0-24 48 0 0 24 0 201.3 86.7-90 16.7-17.3 34.6 33.3-16.7 17.3-128 132.8zM24 80L0 80 0 32l24 0 336 0 24 0 0 48-24 0L24 80z'
      
    ]
  };

  
    var faArrowFromTop = faArrowDownFromLine;
  

  
  

  var faLock = {
    prefix: 'fasr',
    iconName: 'lock',
    icon: [
      448,
      512,
      [128274],
      'f023',
      
      'M144 128v64H304V128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h48 48v48V464v48H400 48 0V464 240 192H48 96zM48 464H400V240H48V464z'
      
    ]
  };

  

  
  

  var faPaintbrush = {
    prefix: 'fasr',
    iconName: 'paintbrush',
    icon: [
      576,
      512,
      [128396,"paint-brush"],
      'f1fc',
      
      'M274.5 216L505.9 61.8l8.3 8.4L360 301.5 274.5 216zM199.1 321.6l55.4 55.4c1 4.9 1.6 9.9 1.6 15.1c0 39.8-32.2 72-72 72H112V392c0-39.8 32.2-72 72-72c5.2 0 10.2 .5 15.1 1.6zM512 0L224 192l-32 80 .3 .3c-2.7-.2-5.5-.3-8.3-.3c-66.3 0-120 53.7-120 120v24 48H48 24 16 0v48H24 48 64h48 72c66.3 0 120-53.7 120-120c0-2.8-.1-5.5-.3-8.3l.3 .3 80-32L576 64 512 0z'
      
    ]
  };

  
    var faPaintBrush = faPaintbrush;
  

  
  

  var faSnowBlowing = {
    prefix: 'fasr',
    iconName: 'snow-blowing',
    icon: [
      640,
      512,
      [],
      'f761',
      
      'M200 64V88v25.4l12.7-12.7L224 89.4 246.6 112l-11.3 11.3L200 158.6v55.8l48.3-27.9 12.9-48.2 4.1-15.5 30.9 8.3-4.1 15.5-4.6 17.3 15-8.7 20.8-12 24 41.6-20.8 12-15 8.7 17.3 4.6 15.5 4.1L336 245.2 320.6 241l-48.2-12.9L224 256l48.3 27.9L320.6 271l15.5-4.1 8.3 30.9-15.5 4.1-17.3 4.6 15 8.7 20.8 12-24 41.6-20.8-12-15-8.7 4.6 17.3 4.1 15.5-30.9 8.3-4.1-15.5-12.9-48.2L200 297.6v55.8l35.3 35.3L246.6 400 224 422.6l-11.3-11.3L200 398.6V424v24H152V424 398.6l-12.7 12.7L128 422.6 105.4 400l11.3-11.3L152 353.4V297.6l-48.3 27.9L90.7 373.7l-4.1 15.5-30.9-8.3 4.1-15.5 4.6-17.3-15 8.7-20.8 12-24-41.6 20.8-12 15-8.7-17.3-4.6L7.7 297.7 16 266.8 31.4 271l48.2 12.9L128 256 79.7 228.1 31.4 241 16 245.2 7.7 214.3l15.5-4.1 17.3-4.6-15-8.7-20.8-12 24-41.6 20.8 12 15 8.7-4.6-17.3-4.1-15.5 30.9-8.3 4.1 15.5 12.9 48.2L152 214.4V158.6l-35.3-35.3L105.4 112 128 89.4l11.3 11.3L152 113.4V88 64h48zM480 448V400h24 48c22.1 0 40-17.9 40-40s-17.9-40-40-40H408 384V272h24H552c48.6 0 88 39.4 88 88s-39.4 88-88 88H504 480zM504 64h48c48.6 0 88 39.4 88 88s-39.4 88-88 88H408 384V192h24H552c22.1 0 40-17.9 40-40s-17.9-40-40-40H504 480V64h24z'
      
    ]
  };

  

  
  

  var faFutbol = {
    prefix: 'fasr',
    iconName: 'futbol',
    icon: [
      512,
      512,
      [9917,"futbol-ball","soccer-ball"],
      'f1e3',
      
      'M412.4 118.9l-34.7 97.6L463.1 275c-2.9 31.7-12.9 61.4-28.4 87.4l-103.5-2.8-29.3 99.4c-14.8 3.3-30.2 5.1-45.9 5.1s-31.2-1.8-45.9-5.1l-29.3-99.4L77.2 362.4c-15.5-26-25.5-55.7-28.4-87.4l85.4-58.5L99.6 118.9c20.3-23.1 45.6-41.7 74.3-54.1L256 128l82.1-63.2c28.7 12.3 54 30.9 74.3 54.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-336l-76.1 55.3L209 320.7h94l29.1-89.4L256 176z'
      
    ]
  };

  
    var faFutbolBall = faFutbol;
  
    var faSoccerBall = faFutbol;
  

  
  

  var faJug = {
    prefix: 'fasr',
    iconName: 'jug',
    icon: [
      448,
      512,
      [],
      'f8c6',
      
      'M181.9 125.5L80 256.5V288H368V256.5l-101.9-131-10.1-13V96 48H192V96v16.5l-10.1 13zM80 416v48H368V416H80zM304 48V96l18.5 23.8C335.7 105.2 354.8 96 376 96c39.8 0 72 32.2 72 72c0 27.6-15.6 51.7-38.4 63.7L416 240V464v48H368 80 32V464 240L144 96V48H120V0h24 48 64 48 24V48H304zm49.5 111.6l25.1 32.2c12.1-1.3 21.4-11.5 21.4-23.9c0-13.3-10.7-24-24-24c-10.3 0-19.1 6.5-22.5 15.6z'
      
    ]
  };

  

  
  

  var faFolderPlus = {
    prefix: 'fasr',
    iconName: 'folder-plus',
    icon: [
      512,
      512,
      [],
      'f65e',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zM232 400V376 312H168 144V264h24 64V200 176h48v24 64h64 24v48H344 280v64 24H232z'
      
    ]
  };

  

  
  

  var faCampground = {
    prefix: 'fasr',
    iconName: 'campground',
    icon: [
      576,
      512,
      [9978],
      'f6bb',
      
      'M385.8 30.5L370.4 49l-51.1 61.2L562.4 401l5.6 6.7v8.7V488v24H544 430.1l-2.2 1.7-1.3-1.7H312 288 264 149.4l-1.3 1.7-2.2-1.7H32 8V488 416.4v-8.7l5.6-6.7L256.7 110.1 205.6 49 190.2 30.5 227-.2l15.4 18.4L288 72.7l45.6-54.5L349-.2l36.8 30.8zM187 464h77 24 24 77L288 334.9 187 464zm263 0h70V425.1L288 147.5 56 425.1V464h70L269.1 281.2 288 257.1l18.9 24.2L450 464z'
      
    ]
  };

  

  
  

  var faClockNineThirty = {
    prefix: 'fasr',
    iconName: 'clock-nine-thirty',
    icon: [
      512,
      512,
      [],
      'e34d',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V256 232H256 152 128v48h24 80V392v24h48V392z'
      
    ]
  };

  

  
  

  var faWatchFitness = {
    prefix: 'fasr',
    iconName: 'watch-fitness',
    icon: [
      384,
      512,
      [],
      'f63e',
      
      'M320 0H64V64H48 0v48V400v48H48 64v64H320V448h16 48V400 112 64H336 320V0zm16 112V400H48V112H336zM93.7 225.1c0 14.3 5.9 28 16.4 37.8l70.9 66.4L192 339.5l10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8c0-28.6-23.2-51.8-51.8-51.8H235c-14 0-27.5 5.3-37.8 14.9l-5.2 4.8-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9h-3.5c-28.6 0-51.8 23.2-51.8 51.8z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleXmark = {
    prefix: 'fasr',
    iconName: 'house-medical-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e513',
      
      'M288 .5l15.5 13.2L514.8 193c-6.2-.7-12.5-1-18.8-1c-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8V464H348.5c12.3 18.8 28 35.1 46.3 48H88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v64H256V320H192V256h64V192h64v64zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faUpToLine = {
    prefix: 'fasr',
    iconName: 'up-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-top"],
      'f34d',
      
      'M224 352l0-48 48 0 28.1 0L192 195.9 83.9 304l28.1 0 48 0 0 48 0 80 64 0 0-80zm1.9-190.1L352 288l0 16 0 48-32 0-16 0-32 0 0 48 0 32 0 48-48 0-64 0-48 0 0-48 0-32 0-48-32 0-16 0-32 0 0-48 0-16L158.1 161.9 192 128l33.9 33.9zM24 80L0 80 0 32l24 0 336 0 24 0 0 48-24 0L24 80z'
      
    ]
  };

  
    var faArrowAltToTop = faUpToLine;
  

  
  

  var faEgg = {
    prefix: 'fasr',
    iconName: 'egg',
    icon: [
      384,
      512,
      [129370],
      'f7fb',
      
      'M192 448c-74.7 0-144-75.4-144-160c0-48.3 14.1-107.7 41.3-153.5C116.4 88.8 151.1 64 192 64s75.6 24.8 102.7 70.5C321.9 180.3 336 239.7 336 288c0 84.6-69.3 160-144 160zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zm112 0c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2l-21.6-23.6c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288v16h32V288z'
      
    ]
  };

  

  
  

  var faFaceDizzy = {
    prefix: 'fasr',
    iconName: 'face-dizzy',
    icon: [
      512,
      512,
      ["dizzy"],
      'f567',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM120 118.1l17 17 23 23 23-23 17-17L233.9 152l-17 17-23 23 23 23 17 17L200 265.9l-17-17-23-23-23 23-17 17L86.1 232l17-17 23-23-23-23-17-17L120 118.1zm192 0l17 17 23 23 23-23 17-17L425.9 152l-17 17-23 23 23 23 17 17L392 265.9l-17-17-23-23-23 23-17 17L278.1 232l17-17 23-23-23-23-17-17L312 118.1z'
      
    ]
  };

  
    var faDizzy = faFaceDizzy;
  

  
  

  var faClipboardMedical = {
    prefix: 'fasr',
    iconName: 'clipboard-medical',
    icon: [
      384,
      512,
      [],
      'e133',
      
      'M336 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H80 48 0v48V464v48H48 336h48V464 112 64H336zM80 112v48H192 304V112h32V464H48V112H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 208H96v64h64v64h64V352h64V288H224V224H160v64z'
      
    ]
  };

  

  
  

  var faCircleDot = {
    prefix: 'fasr',
    iconName: 'circle-dot',
    icon: [
      512,
      512,
      [128280,"dot-circle"],
      'f192',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  
    var faDotCircle = faCircleDot;
  

  
  

  var faBorderCenterV = {
    prefix: 'fasr',
    iconName: 'border-center-v',
    icon: [
      448,
      512,
      [],
      'f89d',
      
      'M448 480l0-64-64 0 0 64 64 0zm0-96l0-64-64 0 0 64 64 0zM64 384l0-64L0 320l0 64 64 0zM384 192l64 0 0-64-64 0 0 64zM64 192l0-64L0 128l0 64 64 0zm320 96l64 0 0-64-64 0 0 64zM64 288l0-64L0 224l0 64 64 0zM384 96l64 0 0-64-64 0 0 64zM0 96l64 0 0-64L0 32 0 96zM64 480l0-64L0 416l0 64 64 0zM288 288l64 0 0-64-64 0 0 64zM352 96l0-64-64 0 0 64 64 0zM288 480l64 0 0-64-64 0 0 64zM160 96l0-64L96 32l0 64 64 0zM96 480l64 0 0-64-64 0 0 64zm64-192l0-64-64 0 0 64 64 0zm40 168l0 24 48 0 0-24 0-400 0-24-48 0 0 24 0 400z'
      
    ]
  };

  

  
  

  var faGamepad = {
    prefix: 'fasr',
    iconName: 'gamepad',
    icon: [
      640,
      512,
      [],
      'f11b',
      
      'M48 112V400H592V112H48zM0 64H48 592h48v48V400v48H592 48 0V400 112 64zM232 200v32h32 24v48H264 232v32 24H184V312 280H152 128V232h24 32V200 176h48v24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faCartPlus = {
    prefix: 'fasr',
    iconName: 'cart-plus',
    icon: [
      576,
      512,
      [],
      'f217',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 488h24V336H488 179.9l-9.1-48H480h17.8l5.2-17L575.4 32H525.2l-63 208H161.6l-42-220.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM232 88v48h24 40v40 24h48V176 136h40 24V88H384 344V48 24l-48 0V48 88H256 232z'
      
    ]
  };

  

  
  

  var faSquarePhoneFlip = {
    prefix: 'fasr',
    iconName: 'square-phone-flip',
    icon: [
      448,
      512,
      ["phone-square-alt"],
      'f87b',
      
      'M400 80V432H48V80H400zm48-48H400 48 0V80 432v48H48 400h48V432 80 32zM280 128l-40 72 41.9 33.5c-18.1 34.2-46.2 62.3-80.4 80.4L168 272 96 312l16 72h16c123.7 0 224-100.3 224-224l0-16-72-16z'
      
    ]
  };

  
    var faPhoneSquareAlt = faSquarePhoneFlip;
  

  
  

  var faTreePalm = {
    prefix: 'fasr',
    iconName: 'tree-palm',
    icon: [
      576,
      512,
      [127796],
      'f82b',
      
      'M96 80l37.2 61.9c-4 3.5-8 7.2-12 11.2C41.9 232.3 64.6 322.8 98.5 356.8L236 219.3c2.7 10.6 4.8 23.2 6.1 38c4.3 49.9-1.7 123.4-33 223.6L199.4 512H232 352h21.2l2.6-21c8.4-66.9 4.1-139.4-8.2-205.4c-6.2-32.9-14.5-64.7-24.5-93.6H451.2L480 144l28.8 48H576c0-48-48-128-160-128c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0C48 0 0 80 0 128H67.2L96 80zM292 192c11.5 29.9 21.3 64.8 28.4 102.4c10.3 55 14.5 114.3 9.9 169.6H264.1c24.9-89.5 30.3-159.2 25.8-210.9c-2.1-24-6.3-44.4-11.9-61.1H292z'
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fasr',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      'M112 48H16v96h96V48zm72 24H160v48h24H488h24V72H488 184zm0 160H160v48h24H488h24V232H488 184zm0 160H160v48h24H488h24V392H488 184zM16 208v96h96V208H16zm96 160H16v96h96V368z'
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faFilmSimple = {
    prefix: 'fasr',
    iconName: 'film-simple',
    icon: [
      512,
      512,
      ["film-alt"],
      'f3a0',
      
      'M160 432H352V320 192 80H160V192 320 432zM112 80H48v88h64V80zm0 136H48v80h64V216zm0 128H48v88h64V344zM400 80v88h64V80H400zm64 136H400v80h64V216zm0 128H400v88h64V344zm0-312h48V80 432v48H464 48 0V432 80 32H48 464z'
      
    ]
  };

  
    var faFilmAlt = faFilmSimple;
  

  
  

  var faAbacus = {
    prefix: 'fasr',
    iconName: 'abacus',
    icon: [
      576,
      512,
      [129518],
      'f640',
      
      'M528 80V208H448V176h8 24V128H456h-8V80h80zM416 128h-8H384v48h24 8v32H288V176h8 24V128H296h-8V80H416v48zm-160 0h-8H224v48h24 8v32H160V176h8 24V128H168h-8V80h96v48zm-128 0h-8H96v48h24 8v32H48V80h80v48zM48 432V240h80v24h-8H96v48h24 8v24h-8H96v48h24 8v48H48zm112-48h8 24V336H168h-8V312h8 24V264H168h-8V240h96v24h-8H224v48h24 8v24h-8H224v48h24 8v48H160V384zm128-72h8 24V264H296h-8V240H416v96h-8H384v48h24 8v48H288V384h8 24V336H296h-8V312zm160 72h8 24V336H456h-8V240h80V432H448V384zM48 32H0V80 432v48H48 528h48V432 80 32H528 48z'
      
    ]
  };

  

  
  

  var faHockeySticks = {
    prefix: 'fasr',
    iconName: 'hockey-sticks',
    icon: [
      640,
      512,
      [],
      'f454',
      
      'M307.9 320L466.7 13 509.3 35l-240 464-6.7 13H248 24 0V488 344 320H24 304h3.9zM283 368H144v96h89.4L283 368zM48 368v96H96V368H48zM173.3 13L302 261.7 288.4 288H261.5L130.7 35 173.3 13zM496 368H373.1l24.8-48H616h24v24V488v24H616 392 377.4l-6.7-13L338 435.9l27-52.2L406.6 464H496V368zm48 0v96h48V368H544z'
      
    ]
  };

  

  
  

  var faFaceAnguished = {
    prefix: 'fasr',
    iconName: 'face-anguished',
    icon: [
      512,
      512,
      [],
      'e369',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 64c44.2 0 80 35.8 80 80v16H176V400c0-44.2 35.8-80 80-80zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 159.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H192zm141 .9c-4.3-.6-8.6-.9-13-.9H304V112h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faGhost = {
    prefix: 'fasr',
    iconName: 'ghost',
    icon: [
      384,
      512,
      [128123],
      'f6e2',
      
      'M384 426.3V480l-48-24-16-8-24.4 27.9L264 512l-35.9-31.9L192 448l-36.1 32.1L120 512 88.4 475.9 64 448l-16 8L0 480V426.3 192C0 86 86 0 192 0S384 86 384 192V426.3zm-48-24V192c0-79.5-64.5-144-144-144S48 112.5 48 192V402.3l27.7-13.8 24.4 27.9L124.3 444l35.8-31.9L192 383.8l31.9 28.3L259.7 444l24.1-27.6 24.4-27.9L336 402.3zM96 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faHeading = {
    prefix: 'fasr',
    iconName: 'heading',
    icon: [
      448,
      512,
      ["header"],
      'f1dc',
      
      'M0 32H24 136h24V80H136 104V224H344V80H312 288V32h24H424h24V80H424 392V248 432h32 24v48H424 312 288V432h24 32V272H104V432h32 24v48H136 24 0V432H24 56V248 80H24 0V32z'
      
    ]
  };

  
    var faHeader = faHeading;
  

  
  

  var faTrainTunnel = {
    prefix: 'fasr',
    iconName: 'train-tunnel',
    icon: [
      512,
      512,
      [],
      'e454',
      
      'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208V488v24h48V488 256C512 114.6 397.4 0 256 0S0 114.6 0 256V488v24H48V488 256zm304 0H160V192H352v64zM160 400V304H352v96H160zm0-256H112v48V400v48h46l-47 47-17 17 0 0h67.9l64-64h60.1l64 64h67.9l-17-17-47-47H400V400 192 144H352 160zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faSquareParkingSlash = {
    prefix: 'fasr',
    iconName: 'square-parking-slash',
    icon: [
      640,
      512,
      ["parking-slash"],
      'f617',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L544 399.6V80 32H496 144 96V51.8l-47.6-37zM144 89V80H496V362.3l-87.1-67.6C428 277.2 440 252 440 224c0-53-43-96-96-96H256 232v24 5.3L144 89zM369.9 264.4L280 194.6V176h64c26.5 0 48 21.5 48 48c0 17-8.8 31.9-22.1 40.4zM426.5 432H144V209.5L96 171.6V432v48h48H487.4l-60.9-48zM280 320v-3.4l-48-37.8V320v40 24h48V360v-8V320z'
      
    ]
  };

  
    var faParkingSlash = faSquareParkingSlash;
  

  
  

  var faPesetaSign = {
    prefix: 'fasr',
    iconName: 'peseta-sign',
    icon: [
      384,
      512,
      [],
      'e221',
      
      'M72 32H48V56 176H0v48H48V328 456v24H96V456 352h96c77.4 0 142-55 156.8-128H384V176H351.2C343.2 95.1 275 32 192 32H72zM302.9 176H96V80h96c56.4 0 103.1 41.7 110.9 96zM96 224H299.4c-13.8 46.3-56.6 80-107.4 80H96V224z'
      
    ]
  };

  

  
  

  var faSandwich = {
    prefix: 'fasr',
    iconName: 'sandwich',
    icon: [
      512,
      512,
      [129386],
      'f81f',
      
      'M464 112v32H48V112H464zM48 64H0v48 32 48H48 464h48V144 112 64H464 48zM464 400H48V368H464v32zM48 320H0v48 32 48H48 464h48V400 368 320H464 48zm94.2-103.2l-5.8-1.5-5.8 1.3-104 24L3.2 246 14 292.8l23.4-5.4 98.2-22.7 114.2 30.5 6.2 1.6 6.2-1.6 114.2-30.5 98.2 22.7 23.4 5.4L508.8 246l-23.4-5.4-104-24-5.8-1.3-5.8 1.5L256 247.2 142.2 216.8z'
      
    ]
  };

  

  
  

  var faBookOpenCover = {
    prefix: 'fasr',
    iconName: 'book-open-cover',
    icon: [
      640,
      512,
      ["book-open-alt"],
      'e0c0',
      
      'M512 337.2V55.6L344 80.2V373l168-35.8zM296 373V80.2L128 55.6V337.2L296 373zM80 0l48 7L320 35.2 512 7l48-7V48.5 376L333.4 424.4c-8.8 1.9-17.9 1.9-26.7 0L80 376V48.5 0zM48 25.6l.5 .1c-.3 2.7-.5 5.4-.5 8.1V74.6 342.1v66.5L320 463l272-54.4V342.1 74.6 33.8c0-2.8-.2-5.5-.5-8.1l.5-.1L640 16V65 448L320 512 0 448V65 16l48 9.6z'
      
    ]
  };

  
    var faBookOpenAlt = faBookOpenCover;
  

  
  

  var faShredder = {
    prefix: 'fasr',
    iconName: 'shredder',
    icon: [
      512,
      512,
      [],
      'f68a',
      
      'M112 192V48H364.1L400 83.9V192H112zm352 0H448V64L384 0H112 64V48 192H48 0v48 96 48H48 464h48V336 240 192H464zm0 48v96H48V240H464zM40 488v24H88V488 416H40v72zm96 0v24h48V488 416H136v72zm96 0v24h48V488 416H232v72zm96 0v24h48V488 416H328v72zm96 0v24h48V488 416H424v72z'
      
    ]
  };

  

  
  

  var faSquareCheck = {
    prefix: 'fasr',
    iconName: 'square-check',
    icon: [
      448,
      512,
      [9745,9989,61510,"check-square"],
      'f14a',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM337 209L209 337l-17 17-17-17-64-64-17-17L128 222.1l17 17 47 47L303 175l17-17L353.9 192l-17 17z'
      
    ]
  };

  
    var faCheckSquare = faSquareCheck;
  

  
  

  var faLuchadorMask = {
    prefix: 'fasr',
    iconName: 'luchador-mask',
    icon: [
      448,
      512,
      ["luchador","mask-luchador"],
      'f455',
      
      'M400 224c0-97.2-78.8-176-176-176S48 126.8 48 224V464H400V224zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224V464v48H400 48 0V464 224zM128 384c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm-32 0c0-29.8 20.4-54.9 48-62V288c-44.2 0-80-35.8-80-80V192 160H96h48c44.2 0 80 35.8 80 80c0-44.2 35.8-80 80-80h48 32v32 16c0 44.2-35.8 80-80 80v34c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64zm80-80v16h96V304l-16-16-32-32-32 32-16 16zm82.7-80c-1.8 5-2.7 10.4-2.7 16v16h32 16c20.9 0 38.7-13.4 45.3-32c1.8-5 2.7-10.4 2.7-16V192H320 304c-20.9 0-38.7 13.4-45.3 32zM144 192H128 96v16c0 5.6 1 11 2.7 16c6.6 18.6 24.4 32 45.3 32h16 32V240c0-5.6-1-11-2.7-16c-6.6-18.6-24.4-32-45.3-32z'
      
    ]
  };

  
    var faLuchador = faLuchadorMask;
  
    var faMaskLuchador = faLuchadorMask;
  

  
  

  var faCommentLines = {
    prefix: 'fasr',
    iconName: 'comment-lines',
    icon: [
      512,
      512,
      [],
      'f4b0',
      
      'M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM152 176H128v48h24H360h24V176H360 152zm0 96H128v48h24H264h24V272H264 152z'
      
    ]
  };

  

  
  

  var faKeySkeletonLeftRight = {
    prefix: 'fasr',
    iconName: 'key-skeleton-left-right',
    icon: [
      640,
      512,
      [],
      'e3b4',
      
      'M592 128c0-44.2-35.8-80-80-80c-44 0-79.7 35.6-80 79.5v1c.3 44 36 79.5 80 79.5c44.2 0 80-35.8 80-80zM386.2 104C397.5 44.8 449.5 0 512 0c70.7 0 128 57.3 128 128s-57.3 128-128 128c-62.5 0-114.5-44.8-125.8-104H304v48 24H256V200 152H208l0 48 0 24-48 0 0-24 0-72 0-24 24 0 202.2 0zM48 384c0 44.2 35.8 80 80 80c44 0 79.7-35.6 80-79.5v-1c-.3-44-36-79.5-80-79.5c-44.2 0-80 35.8-80 80zm205.8 24C242.5 467.2 190.5 512 128 512C57.3 512 0 454.7 0 384s57.3-128 128-128c62.5 0 114.5 44.8 125.8 104l82.2 0V312 288h48v24 48h48l0-48 0-24 48 0 0 24 0 72 0 24H456 253.8z'
      
    ]
  };

  

  
  

  var faAsterisk = {
    prefix: 'fasr',
    iconName: 'asterisk',
    icon: [
      384,
      512,
      [10033,61545],
      '2a',
      
      'M216 32V56 212.9l131.4-81.3 25.3 40.8L237.6 256l135 83.6-25.3 40.8L216 299.1V456v24H168V456 299.1L36.6 380.4 11.4 339.6l135-83.6-135-83.6 25.3-40.8L168 212.9V56 32h48z'
      
    ]
  };

  

  
  

  var faHandsHoldingChild = {
    prefix: 'fasr',
    iconName: 'hands-holding-child',
    icon: [
      640,
      512,
      [],
      'e4fa',
      
      'M320 80a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM290.5 96h-8.8l-6.7 5.7-50.5 42.7-18.3 15.5 31 36.7L255.5 181l19.8-16.7L264.2 253l-3 23.8 47.6 6 3-23.8 4.4-35h7.6l4.4 35 3 23.8 47.6-6-3-23.8-11.1-88.8L384.5 181l18.3 15.5 31-36.7-18.3-15.5L365 101.7 358.3 96h-8.8H290.5zM144 64H120 24 0V88 392v9.9l7 7 84.8 84.8 17 17 33.9-33.9-17-17L48 382.1V112H96V312v9.9l7 7 7 7 17 17 40 40 16 16 1 1 16 16L233.9 392l-16-16-1-1-16-16-23-23L208 305.9l88 88V488v24h24 24V488 393.9l88-88L462.1 336l-23 23 0 0-16 16-17 17L440 425.9l17-17 16-16 0 0 40-40 17-17 7-7 7-7V312 112h48V382.1l-77.8 77.8-17 17 33.9 33.9 17-17L633 409l7-7V392 88 64H616 520 496V88 302.1l-47-47-17-17-17 17-95 95-95-95-17-17-17 17-47 47V88 64z'
      
    ]
  };

  

  
  

  var faAnkh = {
    prefix: 'fasr',
    iconName: 'ankh',
    icon: [
      320,
      512,
      [9765],
      'f644',
      
      'M80 128c0 42.7 23 81.6 51.4 112.6c9.9 10.8 19.9 20.1 28.6 27.4c8.7-7.4 18.7-16.6 28.6-27.4C217 209.6 240 170.7 240 128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM95.1 272C63.4 237.1 32 187.4 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 59.4-31.4 109.1-63.1 144H296h24v48H296 184V488v24H136V488 320H24 0V272H24 95.1z'
      
    ]
  };

  

  
  

  var faWheatAwn = {
    prefix: 'fasr',
    iconName: 'wheat-awn',
    icon: [
      512,
      512,
      ["wheat-alt"],
      'e2cd',
      
      'M493.8 52.2l17-17L476.8 1.3l-17 17L330.4 147.7c-.8-8-2.3-15.9-4.5-23.6L329 121l64-64 17-17L376 6.1 359 23 302.5 79.5c-1.5-1.9-3.1-3.7-4.7-5.5c-1.1-1.2-2.3-2.5-3.5-3.7l-.9-.9L264 40 231.2 72.8l-.9 .9-.3 .3c-16.9 17.4-27 38.9-30.4 61.2L184 120l-30.5 28.6c-19.4 18.2-30.8 41.6-34.2 66L104 200 74.4 227.8C28.2 271.1 27.1 344 71.8 388.7l8.7 8.7 0 0L18.2 459.8l-17 17 33.9 33.9 17-17 62.4-62.4 8.8 8.8c44.7 44.7 117.5 43.6 160.8-2.5L312 408l-9.1-9.5c18.1-4 35.3-13.4 49-27.9L392 328l-10-10.3c16.8-3.9 32.8-12.5 45.9-25.6l10.2-10.2L472 248l-29.5-29.5c-1.5-1.5-3-2.9-4.5-4.3c-1.8-1.6-3.6-3.2-5.5-4.7L489 153l17-17L472 102.1l-17 17-64 64-3.1 3.1c-7.7-2.3-15.6-3.8-23.6-4.5L493.8 52.2zm-388 302.6c-24.4-24.4-24.9-63.3-2.1-88.4c24.3 26.6 27.4 65.7 9.2 95.5l-7.1-7.1zm139.8 53.5c-25 22.9-64 22.3-88.4-2L150 399c29.9-18.2 69-15.1 95.6 9.3zM184.9 275.6c-24.6-24.6-24.9-64-1.5-89c24.5 26.8 27.5 66.4 8.8 96.3l-7.3-7.3zm140.6 53.1l-8.5 9.1c-18.6 19.7-49.7 20.2-68.9 1.1L229 319.7c30-18.8 69.7-15.8 96.5 8.9zM263.8 108.1c23 26.9 25.3 65.5 6.8 94.7l-5.5-5.5c-24.6-24.6-25-64.1-1.3-89.2zm45.4 133.3c29.2-18.5 67.8-16.2 94.7 6.8l-10 10c-18.7 18.7-49.1 18.7-67.9 0l-16.8-16.8z'
      
    ]
  };

  
    var faWheatAlt = faWheatAwn;
  

  
  

  var faCompress = {
    prefix: 'fasr',
    iconName: 'compress',
    icon: [
      448,
      512,
      [],
      'f066',
      
      'M160 56V32H112V56v88H24 0v48H24 136h24V168 56zM24 320H0v48H24h88v88 24h48V456 344 320H136 24zM336 56V32H288V56 168v24h24H424h24V144H424 336V56zM312 320H288v24V456v24h48V456 368h88 24V320H424 312z'
      
    ]
  };

  

  
  

  var faCircleN = {
    prefix: 'fasr',
    iconName: 'circle-n',
    icon: [
      512,
      512,
      [],
      'e118',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48-384v24V283.2L203.7 138.3 196.6 128H160v24V360v24h48V360 228.8L308.3 373.7l7.2 10.3H352V360 152 128H304z'
      
    ]
  };

  

  
  

  var faAlbum = {
    prefix: 'fasr',
    iconName: 'album',
    icon: [
      448,
      512,
      [128189],
      'f89f',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM80 256a144 144 0 1 1 288 0A144 144 0 1 1 80 256zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCloudSunRain = {
    prefix: 'fasr',
    iconName: 'cloud-sun-rain',
    icon: [
      640,
      512,
      [127782],
      'f743',
      
      'M121.3 0L104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104L160 388.9V291.2c-28.7-16.6-48-47.6-48-83.2c0-53 43-96 96-96c18.4 0 35.6 5.2 50.2 14.1c11.9-19.9 29.1-36.2 49.6-47.2L294.7 0 208 60.7 121.3 0zM294.5 415.9l.1 .1H248l-64 96h56l64-96h-9.3l0-.1h-.2zM242.1 168.4c.8-4.3 1.8-8.5 3-12.6C234.7 148.4 221.8 144 208 144c-35.3 0-64 28.7-64 64c0 18.5 7.8 35.1 20.3 46.8c10.6-39.7 39.9-71.8 77.8-86.4zM320.6 192c0-26.5 21.5-48 48-48s48 21.5 48 48v13.9l48 .9c.6-17.1 14.7-30.8 32-30.8c17.7 0 32 14.3 32 32v40 24h24H560c17.7 0 32 14.3 32 32v32H560h-7.4-24v0h-88 0H304.4l0 0H272.6 240V288c0-26.5 21.5-48 48-48h8.6 24V216 192zm256 192v0H616h24V360 304c0-38.5-27.2-70.7-63.4-78.3V208c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C434 114.6 403.4 96 368.6 96c-53 0-96 43-96 96v1.2c-45.7 7.4-80.6 47-80.6 94.8v72 24h24 24.8l0 0h31.8 24 144 0 112 24zM344 416l-64 96h56l64-96H344zm152 0H440l-64 96h56l64-96zm40 0l-64 96h56l64-96H536z'
      
    ]
  };

  

  
  

  var faSwords = {
    prefix: 'fasr',
    iconName: 'swords',
    icon: [
      512,
      512,
      [9876],
      'f71d',
      
      'M339.3 367.4L54.5 82.6 52.2 52.2l30.5 2.3L367.4 339.3l33.9-33.9L104 8 48.4 3.7 0 0 3.7 48.4 8 104 305.4 401.4l33.9-33.9zM408 456l56 56 48-48-56-56 24-72-32-32L304 448l32 32 72-24zM137.4 278.6L88 328 64 304 32 336l24 72L0 464l48 48 56-56 72 24 32-32-24-24 49.4-49.4-33.9-33.9-49.4 49.4-28.1-28.1 49.4-49.4-33.9-33.9zm203.3-79.2l33.9 33.9L504 104l4.3-55.6L512 0 463.6 3.7 408 8 278.6 137.4l33.9 33.9L429.4 54.5l30.5-2.3-2.3 30.5L340.7 199.4z'
      
    ]
  };

  

  
  

  var faCommentSlash = {
    prefix: 'fasr',
    iconName: 'comment-slash',
    icon: [
      640,
      512,
      [],
      'f4b3',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L513.7 376c38.8-36.5 62.3-84 62.3-136C576 125.1 461.4 32 320 32c-68.2 0-130.2 21.7-176 57L48.4 14.8zm135 104.8C218.6 95.5 265.3 80 320 80c124.7 0 208 80.5 208 160c0 38.1-19.2 76.5-52.9 106.1L183.4 119.6zM424.1 430.1l-46-36.3c-18.1 4-37.5 6.2-58 6.2c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2-57.6 17.3 7-18.5 10.8-28.9-21.8-21.9c-28-28-42.9-61.8-42.9-96.9c0-16.2 3.4-32.4 10-47.9l-39-30.8C70.7 185.6 64 212.2 64 240c0 49.6 21.3 95.1 56.9 130.8l-19.8 52.7L80 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c37 0 72.3-6.4 104.1-17.9z'
      
    ]
  };

  

  
  

  var faBoxTaped = {
    prefix: 'fasr',
    iconName: 'box-taped',
    icon: [
      448,
      512,
      ["box-alt"],
      'f49a',
      
      'M160 160l26.7-80H95.2L59.6 160 160 160zm0 48H48V432H400V208H288v80H160V208zm128-48H388.4L352.8 80H261.3L288 160zM64 32H384l64 144V432v48H400 48 0V432 176L64 32z'
      
    ]
  };

  
    var faBoxAlt = faBoxTaped;
  

  
  

  var faXmarkToSlot = {
    prefix: 'fasr',
    iconName: 'xmark-to-slot',
    icon: [
      576,
      512,
      ["times-to-slot","vote-nay"],
      'f771',
      
      'M144 80V360H432V80H144zM96 360V80 32h48H432h48V80 360h24v48H480 432 144 96 72V360H96zM64 288v48H48v96H528V336H512V288h16 48v48 96 48H528 48 0V432 336 288H48 64zM385.9 152l-17 17-47 47 47 47 17 17L352 313.9l-17-17-47-47-47 47-17 17L190.1 280l17-17 47-47-47-47-17-17L224 118.1l17 17 47 47 47-47 17-17L385.9 152z'
      
    ]
  };

  
    var faTimesToSlot = faXmarkToSlot;
  
    var faVoteNay = faXmarkToSlot;
  

  
  

  var faVolumeLow = {
    prefix: 'fasr',
    iconName: 'volume-low',
    icon: [
      448,
      512,
      [128264,"volume-down"],
      'f027',
      
      'M159.9 316.1L146.2 304H128 48V208h80 18.2l13.6-12.1L272 96.2V415.8L159.9 316.1zM0 352H48h80L272 480h48V432 80 32H272L128 160H48 0v48 96 48zm409.6-19.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4z'
      
    ]
  };

  
    var faVolumeDown = faVolumeLow;
  

  
  

  var faFeather = {
    prefix: 'fasr',
    iconName: 'feather',
    icon: [
      512,
      512,
      [129718],
      'f52d',
      
      'M311.9 166.1L112 366.1V243.9L276.7 79.2c20-20 47.1-31.2 75.3-31.2s55.3 11.2 75.3 31.2l5.5 5.5c20 20 31.2 47.1 31.2 75.3c0 16.8-4 33.3-11.4 48H337.9l7.9-7.9 17-17-33.9-33.9-17 17zm-22 89.9H412.1l-48 48H241.9l48-48zm26.2 96l-48 48H145.9l48-48H316.1zM64 224V414.1L18.2 459.8l-17 17 33.9 33.9 17-17L97.9 448H288L466.7 269.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L64 224z'
      
    ]
  };

  

  
  

  var faSquareCode = {
    prefix: 'fasr',
    iconName: 'square-code',
    icon: [
      448,
      512,
      [],
      'e267',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM185 209l-47 47 47 47 17 17L168 353.9l-17-17L87 273l-17-17 17-17 64-64 17-17L201.9 192l-17 17zM297 175l64 64 17 17-17 17-64 64-17 17L246.1 320l17-17 47-47-47-47-17-17L280 158.1l17 17z'
      
    ]
  };

  

  
  

  var faDisplayChartUp = {
    prefix: 'fasr',
    iconName: 'display-chart-up',
    icon: [
      576,
      512,
      [],
      'e5e3',
      
      'M528 48H48V368H528V48zM48 416H0V368 48 0H48 528h48V48 368v48H528 364.3l8 48H424h24v48H424 352 224 152 128V464h24 51.7l8-48H48zm212.3 0l-8 48h71.3l-8-48H260.3zM376 96h80 24v24 80 24H432V200 177.9L321 289l-17 17-17-17-63-63-87 87L103 279 207 175l17-17 17 17 63 63L398.1 144H376 352V96h24z'
      
    ]
  };

  

  
  

  var faChartScatter3d = {
    prefix: 'fasr',
    iconName: 'chart-scatter-3d',
    icon: [
      512,
      512,
      [],
      'e0e8',
      
      'M64 32H0V96H64V32zM280 56V32H232V56 276.7L51.9 426.3 33.4 441.7l30.7 36.9 18.5-15.3L256 319.2 429.5 463.3l18.5 15.3 30.7-36.9-18.5-15.3L280 276.7V56zM0 224v64H64V224H0zm160-96H96v64h64V128zM352 32V96h64V32H352zm160 96H448v64h64V128zM352 224v64h64V224H352zM288 416H224v64h64V416z'
      
    ]
  };

  

  
  

  var faHanukiah = {
    prefix: 'fasr',
    iconName: 'hanukiah',
    icon: [
      640,
      512,
      [128334],
      'f6e6',
      
      'M320 0c.9 1.6 2.3 3.6 3.9 6C331.2 17.1 344 36.3 344 56c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50c1.6-2.4 3-4.5 3.9-6zM24 48c.9 1.6 2.3 3.6 3.9 6C35.2 65.1 48 84.3 48 104c0 13.3-10.7 24-24 24s-24-10.7-24-24C0 84.3 12.8 65.1 20.1 54c1.6-2.4 3-4.5 3.9-6zm84.1 6c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6l0 0c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM176 48c.9 1.6 2.3 3.6 3.9 6l0 0c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50c1.6-2.4 3-4.5 3.9-6zm60.1 6c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6l0 0c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM400 48c.9 1.6 2.3 3.6 3.9 6c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50c1.6-2.4 3-4.5 3.9-6zm124.1 6c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM464 48c.9 1.6 2.3 3.6 3.9 6c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50c1.6-2.4 3-4.5 3.9-6zm148.1 6c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM344 112v24V336H552c22.1 0 40-17.9 40-40V184 160h48v24V296c0 48.6-39.4 88-88 88H344v80H496h24v48H496 320 144 120V464h24H296V384H88c-48.6 0-88-39.4-88-88V184 160H48v24V296c0 22.1 17.9 40 40 40H296V136 112h48zM128 176V288v16H96V288 176 160h32v16zm64 0V288v16H160V288 176 160h32v16zm64 0V288v16H224V288 176 160h32v16zm160 0V288v16H384V288 176 160h32v16zm64 0V288v16H448V288 176 160h32v16zm64 0V288v16H512V288 176 160h32v16z'
      
    ]
  };

  

  
  

  var faFaceCowboyHat = {
    prefix: 'fasr',
    iconName: 'face-cowboy-hat',
    icon: [
      512,
      512,
      [],
      'e36e',
      
      'M192 0L136.6 110.8C100.1 99.7 67.7 83.7 41.3 64L24 81.3C51.2 163.5 144.8 224 256 224s204.8-60.5 232-142.7L470.7 64c-26.4 19.7-58.8 35.7-95.3 46.8L320 0 256 32 192 0zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104c-12.8 9.3-26.6 17.5-41.2 24.6c13.4 23.4 21 50.5 21 79.3c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-28.9 7.6-55.9 21-79.3c-14.6-7.1-28.4-15.4-41.2-24.6zM376.4 339.1c-34.6 13.8-75.9 21.7-120.2 21.7s-85.6-8-120.2-21.7c12.2 55.4 61.4 96.9 120.2 96.9s108-41.5 120.2-96.9zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fasr',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      'M48 24V0H0V24 64 350.5 400v88 24H48V488 388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368V69.7 16L400 40l-6.4 3.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52V24zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8V334.7l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5v-237z'
      
    ]
  };

  

  
  

  var faArrowUpToLine = {
    prefix: 'fasr',
    iconName: 'arrow-up-to-line',
    icon: [
      384,
      512,
      ["arrow-to-top"],
      'f341',
      
      'M24 32L0 32 0 80l24 0 336 0 24 0 0-48-24 0L24 32zM209.5 167.6L192 149l-17.5 18.6-128 136L30.1 321l35 32.9 16.4-17.5L168 244.5l0 83.5 0 128 0 24 48 0 0-24 0-128 0-83.5 86.5 91.9L319 353.9l35-32.9-16.4-17.5-128-136z'
      
    ]
  };

  
    var faArrowToTop = faArrowUpToLine;
  

  
  

  var faSquirrel = {
    prefix: 'fasr',
    iconName: 'squirrel',
    icon: [
      512,
      512,
      [],
      'f71a',
      
      'M147.7 48C92.7 48 48 92.7 48 147.7s44.7 99.7 99.7 99.7h12.8 24v24 30.9 10.1l-7.2 7.1c-15.6 15.3-25.3 36.6-25.3 60.2V464h64.8c-15.6-20.4-24.8-46-24.8-73.7c0-25 7.7-49.3 22-69.8L304 192V144 128 96 64c20.4 0 38.2 10.9 48 27.1C361.8 74.9 379.6 64 400 64V96h32 6.6l5.7 3.4 56 33.4 11.7 7v13.6V200v8.7l-5.6 6.7-40 48-7.2 8.6H448 432v54c24.3 19 40 48.7 40 82c0 20.6-6 39.8-16.3 56h33.4 24v48h-24H368 352 313.7 236.3 128 104V488 379.7c0-32.3 11.6-61.9 30.8-84.8C59.3 288.3 0 225 0 147.7C0 66.1 66.1 0 147.7 0C207.3 0 258.6 35.3 282 86L238.4 106c-15.8-34.3-50.5-58-90.6-58zM352 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56c-5.9 0-11.5 .9-16.8 2.6l-14.4-45.8c9.9-3.1 20.4-4.8 31.2-4.8c5.4 0 10.8 .4 16 1.2V248 224h24 28.8L464 191.3V167l-38.6-23H400 352v48 15.1l-8.7 12.4-90 128.6c-8.7 12.4-13.3 27.1-13.3 42.2c0 40.7 33 73.7 73.7 73.7H352zm32-288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faFireBurner = {
    prefix: 'fasr',
    iconName: 'fire-burner',
    icon: [
      640,
      512,
      [],
      'e4f1',
      
      'M288 0l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 256H56h48 24v48H104 80v80H560V304H536 512V256h24 48 24v24V384h32v48 32 48H592 48 0V464 432 384H32V280 256zM352 448c0 5.8-1.6 11.3-4.3 16h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H347.7c2.7 4.7 4.3 10.2 4.3 16zm128 0c0 5.8-1.6 11.3-4.3 16H592V432H475.7c2.7 4.7 4.3 10.2 4.3 16zM164.3 432H48v32H164.3c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16zm55.4 0c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H219.7z'
      
    ]
  };

  

  
  

  var faRoadSpikes = {
    prefix: 'fasr',
    iconName: 'road-spikes',
    icon: [
      640,
      512,
      [],
      'e568',
      
      'M80 212.2V304h57.4L80 212.2zM64 96l16 25.6 80 128V144v-8.6V116 96h32l16 25.6 80 128V144v-8.6V116 96h32l16 25.6 80 128V144v-8.6V116 96h32l16 25.6L578 304l30 48H551.4 480 464 423.4 416 352 336 295.4 288 224 208 167.4 160 80 32V304 144v-8.6V116 96H64zM0 400H24 616h24v48H616 24 0V400zm208-96h57.4L208 212.2V304zm128-91.8V304h57.4L336 212.2zM464 304h57.4L464 212.2V304z'
      
    ]
  };

  

  
  

  var faFaceSleeping = {
    prefix: 'fasr',
    iconName: 'face-sleeping',
    icon: [
      512,
      512,
      [],
      'e38d',
      
      'M48 256C48 141.1 141.1 48 256 48c30.7 0 59.9 6.7 86.1 18.6l19.9-43.7C329.6 8.2 293.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.7-8.2-73.6-22.9-105.9l-43.7 19.9C457.3 196.1 464 225.3 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256zM256 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM391.5 237.7c-20 27.1-59.8 27.1-79.8 0l-32.2 23.8c36 48.7 108.2 48.7 144.2 0l-32.2-23.8zm-271.8 0L87.5 261.5c36 48.7 108.2 48.7 144.2 0l-32.2-23.8c-20 27.1-59.8 27.1-79.8 0zM288 96v32h16 26.7l-36.3 27.2L288 160v8 8 16h16 64 16V160H368 341.3l36.3-27.2L384 128v-8-8V96H368 304 288zM432 0H416V32h16 26.7L422.4 59.2 416 64v8 8V96h16 64 16V64H496 469.3l36.3-27.2L512 32V24 16 0H496 432z'
      
    ]
  };

  

  
  

  var faMemory = {
    prefix: 'fasr',
    iconName: 'memory',
    icon: [
      576,
      512,
      [],
      'f538',
      
      'M0 112V64H48 528h48v48 50.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3V400v48H528 48 0V400 253.3c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3V112zm48 24.5C67.6 154 80 179.5 80 208s-12.4 54-32 71.5V304H528V279.5c-19.6-17.6-32-43.1-32-71.5s12.4-54 32-71.5V112H48v24.5zM528 352H48v48h56V376h48v24h32V376h48v24h32V376h48v24h32V376h48v24h32V376h48v24h56V352zM192 144v24 80 24H144V248 168 144h48zm120 0v24 80 24H264V248 168 144h48zm120 0v24 80 24H384V248 168 144h48z'
      
    ]
  };

  

  
  

  var faCircleDollarToSlot = {
    prefix: 'fasr',
    iconName: 'circle-dollar-to-slot',
    icon: [
      512,
      512,
      ["donate"],
      'f4b9',
      
      'M256 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352H24 0v24V488v24H24 488h24V488 376 352H488 448c-13.6 18.2-29.8 34.3-48 48h64v64H48V400h64c-18.2-13.7-34.3-29.8-48-48zM276 112V92H236v20 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5l0 0c7.9 2.7 20.3 7 29.9 9.1V304v20h40V304v-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l0 0 0 0-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4V112z'
      
    ]
  };

  
    var faDonate = faCircleDollarToSlot;
  

  
  

  var faSpaceStationMoonConstruction = {
    prefix: 'fasr',
    iconName: 'space-station-moon-construction',
    icon: [
      512,
      512,
      ["space-station-moon-alt"],
      'e034',
      
      'M208.2 53.5C223.5 49.9 239.5 48 256 48c54.9 0 104.8 21.2 142 56H368 344v48h24 81.5l20-37.3C423.7 45.6 345.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c81.4 0 153.9-38 200.7-97.1l-37.6-29.8C381 433.2 322.1 464 256 464c-80.8 0-150.8-46.1-185.3-113.3C109.9 362.7 168.9 376 256 376c116.9 0 183.2-23.9 218.9-36.8l0 0c4.8-1.7 9-3.2 12.7-4.5l12-4 3.5-12.2 .6-2.1c5.5-19.3 8.3-39.3 8.3-59.3V256 232H464v24 1.1c0 12.3-1.3 24.5-4 36.5l-.8 .3C424.3 306.5 364.4 328 256 328s-168.3-21.5-203.2-34.1l-1.5-.5C49.1 281.2 48 268.8 48 256c0-40.8 11.7-78.8 32-110.9c.6 52.5 43.3 94.9 96 94.9c53 0 96-43 96-96c0-41.7-26.6-77.2-63.8-90.5zM128 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm248 40H352v48h24 48 24V184H424 376z'
      
    ]
  };

  
    var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
  

  
  

  var faPipeSection = {
    prefix: 'fasr',
    iconName: 'pipe-section',
    icon: [
      640,
      512,
      [],
      'e438',
      
      'M48 120V96H0v24 8 24 24V336v24 24 8 24H48V392v-8H592v8 24h48V392v-8V360 336 176 152 128v-8V96H592v24 8H320 48v-8zm0 56H320 592V336H48V176z'
      
    ]
  };

  

  
  

  var faSitemap = {
    prefix: 'fasr',
    iconName: 'sitemap',
    icon: [
      576,
      512,
      [],
      'f0e8',
      
      'M320 80v64H256V80h64zM256 32H208V80v64 48h48 8v40H80 56v24 64H48 0v48 64 48H48h64 48V432 368 320H112h-8V280H264v40h-8H208v48 64 48h48 64 48V432 368 320H320h-8V280H472v40h-8H416v48 64 48h48 64 48V432 368 320H528h-8V256 232H496 312V192h8 48V144 80 32H320 256zM48 432V368h64v64H48zm208-64h64v64H256V368zm208 64V368h64v64H464z'
      
    ]
  };

  

  
  

  var faHeadphonesSimple = {
    prefix: 'fasr',
    iconName: 'headphones-simple',
    icon: [
      512,
      512,
      ["headphones-alt"],
      'f58f',
      
      'M256 80C141.1 80 48 173.1 48 288V392v24H0V392 288C0 146.6 114.6 32 256 32s256 114.6 256 256V392v24H464V392 288c0-114.9-93.1-208-208-208zM160 320H128V432h32V320zm-32-48h32 48v48V432v48H160 128 80V432 320 272h48zm256 48H352V432h32V320zm48-48v48V432v48H384 352 304V432 320 272h48 32 48z'
      
    ]
  };

  
    var faHeadphonesAlt = faHeadphonesSimple;
  

  
  

  var faCloudShowersHeavy = {
    prefix: 'fasr',
    iconName: 'cloud-showers-heavy',
    icon: [
      512,
      512,
      [],
      'f740',
      
      'M368 128v48h48c26.5 0 48 21.5 48 48v48H416 96 48V224c0-20.8 13.3-38.7 32-45.3l32-11.3V133.5 112c0-35.3 28.7-64 64-64c21.6 0 40.7 10.7 52.4 27.2l26.7 37.9 38.8-25.3c7.5-4.9 16.4-7.7 26.2-7.7c26.5 0 48 21.5 48 48zM0 320H48 96 416h48 48V272 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v48 48zM0 512H48l72-160H72L0 512zM192 352L120 512h48l72-160H192zm160 0H304L232 512h48l72-160zm72 0L352 512h48l72-160H424z'
      
    ]
  };

  

  
  

  var faTemperatureList = {
    prefix: 'fasr',
    iconName: 'temperature-list',
    icon: [
      512,
      512,
      [],
      'e299',
      
      'M80 294.5L69.3 307.7C56 324.2 48 345.1 48 368c0 53 43 96 96 96s96-43 96-96c0-22.9-8-43.8-21.3-60.3L208 294.5v-17V48H80V277.5v17zM208 0h48V48 277.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S0 447.6 0 368c0-34.3 12-65.8 32-90.5V48 0H80 208zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V176 160h32v16V322.8c18.6 6.6 32 24.4 32 45.3zM320 32h24H488h24V80H488 344 320V32zm0 128h24H488h24v48H488 344 320V160zm32 128h24H488h24v48H488 376 352V288z'
      
    ]
  };

  

  
  

  var faUnlockKeyhole = {
    prefix: 'fasr',
    iconName: 'unlock-keyhole',
    icon: [
      448,
      512,
      ["unlock-alt"],
      'f13e',
      
      'M224 48c-44.2 0-80 35.8-80 80v64H400h48v48V464v48H400 48 0V464 240 192H48 96V128C96 57.3 153.3 0 224 0c57 0 105.2 37.2 121.8 88.6l-45.7 14.8C289.8 71.2 259.6 48 224 48zM48 240V464H400V240H48zM256 376H192 168V328h24 64 24v48H256z'
      
    ]
  };

  
    var faUnlockAlt = faUnlockKeyhole;
  

  
  

  var faSidebarFlip = {
    prefix: 'fasr',
    iconName: 'sidebar-flip',
    icon: [
      512,
      512,
      [],
      'e24f',
      
      'M288 80V432H48V80H288zM512 32H464 48 0V80 432v48H48 464h48V432 80 32zM448 96v48H352V96h96zm-96 96h96v48H352V192zm96 96v48H352V288h96z'
      
    ]
  };

  

  
  

  var faCircleChevronDown = {
    prefix: 'fasr',
    iconName: 'circle-chevron-down',
    icon: [
      512,
      512,
      ["chevron-circle-down"],
      'f13a',
      
      'M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM239 345l17 17 17-17L377 241l17-17L360 190.1l-17 17-87 87-87-87-17-17L118.1 224l17 17L239 345z'
      
    ]
  };

  
    var faChevronCircleDown = faCircleChevronDown;
  

  
  

  var faFaceFrownSlight = {
    prefix: 'fasr',
    iconName: 'face-frown-slight',
    icon: [
      512,
      512,
      [],
      'e376',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM388 370.7L348 397.3C336 379.2 300.1 352 256 352s-80 27.2-92 45.3L124 370.7c19.9-29.9 70-66.7 132-66.7s112 36.8 132 66.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faArrowRightFromBracket = {
    prefix: 'fasr',
    iconName: 'arrow-right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out"],
      'f08b',
      
      'M168 80l24 0 0-48-24 0L24 32 0 32 0 56 0 456l0 24 24 0 144 0 24 0 0-48-24 0L48 432 48 80l120 0zM493.8 273l17-17-17-17-128-128-17-17L314.9 128l17 17 87 87L184 232l-24 0 0 48 24 0 234.9 0-87 87-17 17 33.9 33.9 17-17 128-128z'
      
    ]
  };

  
    var faSignOut = faArrowRightFromBracket;
  

  
  

  var faSchoolCircleXmark = {
    prefix: 'fasr',
    iconName: 'school-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e56d',
      
      'M466.7 144l-11.4-6.8L320 56 184.7 137.2 173.3 144H160 48V464H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-4.3 15.2-6.5 31.1-6.5 47.7c0 59.5 29.6 112.2 74.8 144H48 0V464 144 96H48 160L320 0 480 96H592h48v48V266.8c-12.9-18.3-29.2-34.1-48-46.3V144H480 466.7zm-74 81.5c-15 10.9-28.2 24.1-39.1 39.1C343.3 269.4 332 272 320 272c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 12-2.6 23.3-7.3 33.5zM160 192v96H96V192h64zM96 320h64v96H96V320zM336 160V144H304v16 32 16h16 24 16V176H344h-8V160zm160 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faCircleExclamation = {
    prefix: 'fasr',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-384H232v24V264v24h48V264 152 128zM232 368h48V320H232v48z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faBlock = {
    prefix: 'fasr',
    iconName: 'block',
    icon: [
      640,
      512,
      [],
      'e46a',
      
      'M496 80V432H144V80H496zM144 32H96V80 432v48h48H496h48V432 80 32H496 144zm64 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTrashCanList = {
    prefix: 'fasr',
    iconName: 'trash-can-list',
    icon: [
      640,
      512,
      [],
      'e2ab',
      
      'M131.2 0H144 272h12.8L292 10.7 338.2 80H384h32v48H384V464v48H336 80 32V464 128H0V80H32 77.8L124 10.7 131.2 0zm4.4 80h145L259.2 48H156.8L135.5 80zM80 128V464H336V128H80zm96 48v16V400v16H144V400 192 176h32zm96 0v16V400v16H240V400 192 176h32zm368-48v48H448V128H640zM608 256v48H448V256H608zM448 384h96v48H448V384z'
      
    ]
  };

  

  
  

  var faCommentMiddle = {
    prefix: 'fasr',
    iconName: 'comment-middle',
    icon: [
      512,
      512,
      [],
      'e149',
      
      'M290.2 366.6L279.4 384 256 421.4 232.6 384l-10.8-17.3-20-4.2C106.3 342.4 48 275.4 48 208c0-79.5 83.3-160 208-160s208 80.5 208 160c0 67.4-58.3 134.4-153.7 154.4l-20 4.2zM227.7 466.7L256 512l28.3-45.3 35.8-57.3C430.5 386.3 512 304.9 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 96.9 81.5 178.3 191.9 201.4l35.8 57.3z'
      
    ]
  };

  

  
  

  var faCaretLeft = {
    prefix: 'fasr',
    iconName: 'caret-left',
    icon: [
      256,
      512,
      [],
      'f0d9',
      
      'M192 144l0-48-48 0L0 256 144 416l48 0 0-48 0-224zM144 344.2L64.6 256 144 167.8l0 176.5z'
      
    ]
  };

  

  
  

  var faLightbulb = {
    prefix: 'fasr',
    iconName: 'lightbulb',
    icon: [
      384,
      512,
      [128161],
      'f0eb',
      
      'M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48H112c0-44.2 35.8-80 80-80v32zM112 416H272v96H112V416z'
      
    ]
  };

  

  
  

  var faPeopleRobbery = {
    prefix: 'fasr',
    iconName: 'people-robbery',
    icon: [
      576,
      512,
      [],
      'e536',
      
      'M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM16 128l0 24 0 336 0 24 48 0 0-24 0-136H96V488v24h48V488 285.1L96 215.7v.3 88H64l0-128h43.4l64.8 93.7 7.2 10.3H192h48 24V232H240 204.6l-64.8-93.7L132.6 128H120 40 16zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM272.6 165.5L277 184h19 40V488v24h48V488 352h32V488v24h48V488 184h40 19l4.4-18.5 32-136-46.7-11L485 136l-170 0L287.4 18.5l-46.7 11 32 136zM416 184V304H384V184h32z'
      
    ]
  };

  

  
  

  var faSquareTerminal = {
    prefix: 'fasr',
    iconName: 'square-terminal',
    icon: [
      448,
      512,
      [],
      'e32a',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM86.1 169.5l17.7 16.2L180.5 256l-76.7 70.3L86.1 342.5l32.4 35.4 17.7-16.2 96-88L251.5 256l-19.3-17.7-96-88-17.7-16.2L86.1 169.5zM216 336H192v48h24H328h24V336H328 216z'
      
    ]
  };

  

  
  

  var faCassetteTape = {
    prefix: 'fasr',
    iconName: 'cassette-tape',
    icon: [
      576,
      512,
      [128429],
      'f8ab',
      
      'M528 80V432H472l-33.8-81.2L432 336H416 160 144l-6.2 14.8L104 432H48V80H528zM420 432H156l20-48H400l20 48zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM176 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16c0-5.5-.7-10.9-2-16H338c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16H238c1.3-5.1 2-10.5 2-16zm224 0c0-35.3-28.7-64-64-64H176c-35.3 0-64 28.7-64 64s28.7 64 64 64H400c35.3 0 64-28.7 64-64zm-80 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faShieldCross = {
    prefix: 'fasr',
    iconName: 'shield-cross',
    icon: [
      512,
      512,
      [9960],
      'f712',
      
      'M64.1 126L256 51.5 448 126c1 43.5-6.9 106.9-33.8 168.8C385.9 359.7 337.1 422.4 256 459.6c-81.1-37.1-129.9-99.8-158.1-164.8C71 232.9 63.1 169.5 64.1 126zm431.4-13l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM280 120V96H232v24 48H136 112v48h24 96V392v24h48V392 216h96 24V168H376 280V120z'
      
    ]
  };

  

  
  

  var fa8 = {
    prefix: 'fasr',
    iconName: '8',
    icon: [
      320,
      512,
      [],
      '38',
      
      'M304 156c0-68.5-55.5-124-124-124H140C71.5 32 16 87.5 16 156c0 37.7 16.8 71.4 43.3 94.2C23.7 272 0 311.2 0 356c0 68.5 55.5 124 124 124h72c68.5 0 124-55.5 124-124c0-44.8-23.7-84-59.3-105.8C287.2 227.4 304 193.7 304 156zM180.1 280H196c42 0 76 34 76 76s-34 76-76 76H124c-42 0-76-34-76-76s34-76 76-76h15.9c0 0 0 0 .1 0h40c0 0 0 0 .1 0zm0-48c0 0 0 0 0 0H140c0 0 0 0 0 0c-42 0-76-34-76-76c0-42 34-76 76-76l40 0c42 0 76 34 76 76c0 42-34 76-76 76z'
      
    ]
  };

  

  
  

  var faRulerHorizontal = {
    prefix: 'fasr',
    iconName: 'ruler-horizontal',
    icon: [
      640,
      512,
      [],
      'f547',
      
      'M48 336l544 0V176l-64 0v48 16H496V224 176l-64 0v48 16H400V224 176l-64 0v48 16H304V224 176l-64 0v48 16H208V224 176l-64 0v48 16H112V224 176l-64 0 0 160zM0 384V336 176 128H48 592h48v48V336v48H592L48 384H0z'
      
    ]
  };

  

  
  

  var faCoconut = {
    prefix: 'fasr',
    iconName: 'coconut',
    icon: [
      512,
      512,
      [],
      'e2f6',
      
      'M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zM395.2 28.9C361.5-4.8 309.6-5.7 260.4 9.5C210 25 155.3 59.1 107.2 107.2S25 210 9.5 260.4C-5.7 309.6-4.8 361.5 28.9 395.2l41 41C118.4 484.7 184.3 512 253 512c10.6 0 21-.6 31.2-1.9l3.8 3.8 5-5C404 491.7 491.7 404 508.9 293l5-5-3.8-3.8c1.2-10.2 1.9-20.7 1.9-31.2c0-68.7-27.3-134.6-75.9-183.2L395.2 28.9zM265 423l-17-17L214.1 440l17 17 6.5 6.5c-39.9-2.9-78.1-17.2-110.1-40.9c12.1-1.5 24.2-4.3 36.3-8c50.4-15.5 105-49.7 153.1-97.8s82.2-102.7 97.8-153.1c3.7-12 6.5-24.2 8-36.3c23.7 32 37.9 70.2 40.9 110.1L457 231l-17-17L406.1 248l17 17 35.6 35.6c-7.2 31.1-21.2 59.6-40.4 83.7L377 343l-17-17L326.1 360l17 17 41.2 41.2c-24.2 19.2-52.6 33.3-83.7 40.4L265 423zm-9-167c62.5-62.5 92.9-133.4 67.9-158.4s-95.9 5.4-158.4 67.9S72.6 298.9 97.6 323.9s95.9-5.4 158.4-67.9z'
      
    ]
  };

  

  
  

  var faFilm = {
    prefix: 'fasr',
    iconName: 'film',
    icon: [
      512,
      512,
      [127902],
      'f008',
      
      'M352 432H160V320 280H352v40V432zm0-200H160V192 80H352V192v40zM48 80h64v88H48V80zm0 136h64v80H48V216zm64 216H48V344h64v88zM400 168V80h64v88H400zm0 48h64v80H400V216zm0 128h64v88H400V344zM512 32H464 48 0V80 432v48H48 464h48V432 80 32z'
      
    ]
  };

  

  
  

  var faSickle = {
    prefix: 'fasr',
    iconName: 'sickle',
    icon: [
      512,
      512,
      [],
      'f822',
      
      'M218.2 90.2c56.2-56.2 147.4-56.2 203.6 0c2.3 2.3 4.5 4.7 6.7 7.1c-16.4-6-34-9.3-52.5-9.3c-83.9 0-152 68.1-152 152c0 17.8 3.1 35 8.7 50.9l-8.7 8.7-5.8-5.8c-56.2-56.2-56.2-147.4 0-203.6zM455.8 56.2c-75-75-196.5-75-271.5 0s-75 196.5 0 271.5L207 350.6l17 17 17-17 37.1-37.1 12.2-12.2-7.6-15.4C275.8 272.1 272 256.5 272 240c0-57.4 46.6-104 104-104c38.7 0 72.5 21.1 90.5 52.6l44.8-14c-3.9-43.2-22.4-85.3-55.4-118.4zM0 448l64 64 88-88 24 24 48-48L112 288 64 336l24 24L0 448z'
      
    ]
  };

  

  
  

  var faRadar = {
    prefix: 'fasr',
    iconName: 'radar',
    icon: [
      512,
      512,
      [],
      'e024',
      
      'M316.4 161.7C299 150.5 278.2 144 256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112s112-50.1 112-112h48c0 78.2-56.1 143.3-130.3 157.2c-7.3-8.1-17.9-13.2-29.7-13.2s-22.4 5.1-29.7 13.2c-64.5-12.1-115.4-63-127.5-127.5c8.1-7.3 13.2-17.9 13.2-29.7s-5.1-22.4-13.2-29.7C112.7 152.1 177.8 96 256 96c35.5 0 68.3 11.6 94.9 31.2l34.2-34.2C349.7 64.8 304.8 48 256 48C152.7 48 66.9 123.4 50.7 222.1C39.5 229.2 32 241.7 32 256s7.5 26.8 18.7 33.9c14.4 87.7 83.6 157 171.4 171.4c7.1 11.3 19.6 18.7 33.9 18.7s26.8-7.5 33.9-18.7C388.6 445.1 464 359.3 464 256h48c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L455 23l17-17L505.9 40 489 57l-174 174c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l35.4-35.4z'
      
    ]
  };

  

  
  

  var faPhotoFilmMusic = {
    prefix: 'fasr',
    iconName: 'photo-film-music',
    icon: [
      640,
      512,
      [],
      'e228',
      
      'M592 48H240V272h15.6l69.1-94.2L344 151.4l19.4 26.4 10.3 14 63.7-78.9L456 89.8l18.7 23.1 37.6 46.6L368 207.6V320H240 192V272 48 0h48H592h48V48v69l-48 16V48zM160 400H326c-2.2 1.4-4.4 2.9-6.5 4.5c-13.8 10.3-25.3 25.3-29.7 43.5H160 136 112 48 0V400 160 112H48h64 24 24v48 72 88 8 72zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 208V160H48v48h64zm0 192V352H48v48h64zm0-96V256H48v48h64zM640 152v33.3 48 160c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V266.6l-144 48V465.3c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V297.3v-48V232l16.4-5.5 192-64L640 152z'
      
    ]
  };

  

  
  

  var faRollerCoaster = {
    prefix: 'fasr',
    iconName: 'roller-coaster',
    icon: [
      640,
      512,
      [],
      'e324',
      
      'M104 91.7C70.7 109.1 48 143.9 48 184V456v24H0V456 184C0 100.1 68.1 32 152 32h5.1c49.8 0 96.4 24.4 124.8 65.3L398.4 265c23.9 34.4 63.2 55 105.1 55H512c44.2 0 80-35.8 80-80v-8c0-40.3-27.1-74.2-64-84.7v138c-5 1.8-10.4 2.7-16 2.7h-8.5c-8 0-15.9-1-23.5-2.9v-140c-16.2 2.2-31.8 7.6-45.9 16L416 172v62.3l-58-83.5 51.4-30.9c26.1-15.7 56-23.9 86.4-23.9H504c75.1 0 136 60.9 136 136v8V456v24H592V456 339.9c-16 12.8-35.1 21.9-56 25.8V456v24H488V456 367.3c-16.6-1.5-32.7-5.3-48-11.2V456v24H392V456 328.2c-12.5-10.2-23.6-22.2-33.1-35.8L344 270.9V456v24H296V456 201.8l-48-69.1V456v24H200V456 89.3c-13.3-6-27.9-9.3-42.9-9.3H152V456v24H104V456 91.7z'
      
    ]
  };

  

  
  

  var faCorn = {
    prefix: 'fasr',
    iconName: 'corn',
    icon: [
      512,
      512,
      [127805],
      'f6c7',
      
      'M441 292c9.4-12.2 15-27.4 15-44c0-.8 0-1.5 0-2.3c14.7-13.2 24-32.3 24-53.7c0-.8 0-1.5 0-2.3c14.7-13.2 24-32.3 24-53.7c0-8.4-1.4-16.5-4.1-24c7.6-11.4 12.1-25.2 12.1-40c0-39.8-32.2-72-72-72c-14.8 0-28.5 4.5-40 12.1C392.5 9.4 384.4 8 376 8c-21.4 0-40.5 9.3-53.7 24c-.8 0-1.5 0-2.3 0c-21.4 0-40.5 9.3-53.7 24c-.8 0-1.5 0-2.3 0c-18.1 0-34.6 6.6-47.2 17.6l9.3 9.3c8.3 8.3 15.7 17.3 22.2 26.9c4.2-3.6 9.7-5.8 15.7-5.8c2.4 0 4.6 .3 6.7 .9l18.9 5.5L298.7 93c4-7.8 12.1-13 21.3-13c2.4 0 4.6 .3 6.7 .9l18.9 5.5L354.7 69c4-7.8 12.1-13 21.3-13c5.2 0 9.9 1.6 13.8 4.3l17.8 12.5 14.2-16.5c4.4-5.2 10.9-8.4 18.2-8.4c13.3 0 24 10.7 24 24c0 7.3-3.2 13.8-8.4 18.2l-16.5 14.2 12.5 17.8c2.7 3.9 4.3 8.6 4.3 13.8c0 9.2-5.2 17.3-13 21.3l-17.5 9.1 5.5 18.9c.6 2.1 .9 4.3 .9 6.7c0 9.2-5.2 17.3-13 21.3l-17.5 9.1 5.5 18.9c.6 2.1 .9 4.3 .9 6.7c0 5.3-1.7 10.1-4.6 14.1c10.4 6.7 20.2 14.3 29.5 22.6L441 292zM169 71l-30-30L128.7 82.2l-22.4 89.6L7 271l-7 7V288v96 9.4l6.4 6.9 96 104 7.1 7.7H120 224h9.9l7-7L341 405l90.6-30.2 39.1-13-30.6-27.6-28.5-25.7C374 274.7 325.3 256 274.8 256c-9 0-17.9 .6-26.8 1.8V213c0-40.3-16-79-44.5-107.5L169 71zm31 142v57.1c-25.9 10.2-49.7 25.7-69.8 45.7L59.3 386.8 48 374.6V297.9l97-97 4.7-4.7 1.6-6.4L165 134.9l4.5 4.5C189 159 200 185.4 200 213zM130.5 464L91.8 422.1l72.3-72.3c29.3-29.3 69.1-45.8 110.6-45.8c37.7 0 74.1 13.6 102.5 38.3l-56.9 19L315 363l-4 4-97 97H130.5z'
      
    ]
  };

  

  
  

  var faFaceKissBeam = {
    prefix: 'fasr',
    iconName: 'face-kiss-beam',
    icon: [
      512,
      512,
      [128537,"kiss-beam"],
      'f597',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432l-3.9-15 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0 0 0V345l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0 0 0 3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z'
      
    ]
  };

  
    var faKissBeam = faFaceKissBeam;
  

  
  

  var faSquareUpRight = {
    prefix: 'fasr',
    iconName: 'square-up-right',
    icon: [
      448,
      512,
      [8599,"external-link-square-alt"],
      'f360',
      
      'M400 80V432H48V80H400zm48-48H400 48 0V80 432v48H48 400h48V432 80 32zM320 320V160H160l-24 24 52 52-76 76 56 56 76-76 52 52 24-24z'
      
    ]
  };

  
    var faExternalLinkSquareAlt = faSquareUpRight;
  

  
  

  var faDropletPercent = {
    prefix: 'fasr',
    iconName: 'droplet-percent',
    icon: [
      384,
      512,
      ["humidity"],
      'f750',
      
      'M336 320c0-14.5-7.4-39.2-24.7-72.8c-16.5-32-39-66.6-62.3-99c-20.2-28.1-40.5-53.9-57-74.1c-16.5 20.2-36.8 46-57 74.1c-23.3 32.4-45.8 66.9-62.3 99C55.4 280.8 48 305.5 48 320c0 79.5 64.5 144 144 144s144-64.5 144-144zM0 320C0 241.2 106.1 102.8 160.5 36.9C179.3 14.1 192 0 192 0s12.7 14.1 31.5 36.9C277.9 102.8 384 241.2 384 320c0 106-86 192-192 192S0 426 0 320zm278.6-64l-11.3 11.3-128 128L128 406.6 105.4 384l11.3-11.3 128-128L256 233.4 278.6 256zM136 240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faHumidity = faDropletPercent;
  

  
  

  var faFaceBeamHandOverMouth = {
    prefix: 'fasr',
    iconName: 'face-beam-hand-over-mouth',
    icon: [
      512,
      512,
      [129325],
      'e47c',
      
      'M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1v10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 113.1-73.3 209.1-175.1 242.9l52.3-52.3L411.9 424l-15-15c41.3-38 67.1-92.5 67.1-153c0-114.9-93.1-208-208-208zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm-75 67.2l-11.3 11.3-56 56 9.4 9.4 72-72L328 289.4 350.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L344 337.4 366.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L344 401.4 366.6 424l-11.3 11.3-48.8 48.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V404 384 354.4v-20h40v20 15l84.7-84.7L280 273.4 302.6 296z'
      
    ]
  };

  

  
  

  var faHeartCrack = {
    prefix: 'fasr',
    iconName: 'heart-crack',
    icon: [
      512,
      512,
      [128148,"heart-broken"],
      'f7a9',
      
      'M230.1 137.9L160 208 288 320 224 208l96-80-6.2-21.9 .4-.4C330.6 89.3 353 80 376.2 80c48.5 0 87.8 39.3 87.8 87.8c0 23.3-9.2 45.6-25.7 62.1l-24.2 24.2L256 412.1 97.9 254.1 73.7 229.8C57.2 213.4 48 191.1 48 167.8C48 119.3 87.3 80 135.8 80c23.3 0 45.6 9.2 62.1 25.7L222.1 130l8 8zM256 480l33.9-33.9L448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.7l0 0L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288 222.1 446.1 256 480z'
      
    ]
  };

  
    var faHeartBroken = faHeartCrack;
  

  
  

  var faHourglassEnd = {
    prefix: 'fasr',
    iconName: 'hourglass-end',
    icon: [
      384,
      512,
      [8987,"hourglass-3"],
      'f253',
      
      'M0 0H24 360h24V48H360h-8v72 9.9l-7 7-119 119L345 375l7 7V392v72h8 24v48H360 24 0V464H24h8V392v-9.9l7-7 119-119L39 137l-7-7V120 48H24 0V0zM80 48v62.1l112 112 112-112V48H80z'
      
    ]
  };

  
    var faHourglass3 = faHourglassEnd;
  

  
  

  var faPeopleGroup = {
    prefix: 'fasr',
    iconName: 'people-group',
    icon: [
      640,
      512,
      [],
      'e533',
      
      'M264 88a56 56 0 1 1 112 0A56 56 0 1 1 264 88zm-8 156.7l-23.1 40.4L256 317.4V244.7zM256 400L176 288l64-112H400l64 112L384 400v56 24H360 280 256V456 400zm128-82.6l23.1-32.3L384 244.7v72.7zM336 224H304V432h32V224zM208 167.5V160H160 48L0 272 64 384v40 24H88h80 24V424 384 365.5l-48-67.2V304v96H112V208h32v59.2V272v7.5l64-112zm240 198V384v40 24h24 80 24V424 384l64-112L592 160H480 432v7.5l64 112V272v-4.8V208h32V400H496V304v-5.7l-48 67.2zM128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM53.5 268.9L64 244.5v42.7L53.5 268.9zM512 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64 159.3V244.5l10.5 24.4L576 287.3z'
      
    ]
  };

  

  
  

  var faKeyboardLeft = {
    prefix: 'fasr',
    iconName: 'keyboard-left',
    icon: [
      640,
      512,
      [],
      'e1c3',
      
      'M592 112V400H208V112H592zM208 64H160v48V400v48h48H592h48V400 112 64H592 208zm96 256v48H496V320H304zm80-88H336v48h48V232zm-136 0v48h48V232H248zm48-80H248v48h48V152zm40 0v48h48V152H336zm128 0H416v48h48V152zm40 0v48h48V152H504zm48 80H504v48h48V232zm-136 0v48h48V232H416zM117.8 209l17-17-33.9-33.9-17 17-64 64-17 17 17 17 64 64 17 17L134.7 320l-17-17-47-47 47-47z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fasr',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 64H448v48H0V64zM0 224H448v48H0V224zM448 384v48H0V384H448z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faPrescriptionBottle = {
    prefix: 'fasr',
    iconName: 'prescription-bottle',
    icon: [
      384,
      512,
      [],
      'f485',
      
      'M336 48V80H48V48H336zM48 0H0V48 80v48H48 336h48V80 48 0H336 48zM32 160V464v48H80 304h48V464 160H304V464H80V416h56 24V368H136 80V320h56 24V272H136 80V224h56 24V176H136 80V160H32z'
      
    ]
  };

  

  
  

  var faSwatchbook = {
    prefix: 'fasr',
    iconName: 'swatchbook',
    icon: [
      512,
      512,
      [],
      'f5c3',
      
      'M0 400c0 61.9 50.1 112 112 112H488h24V488 312 288H488 385.9l79-79 17-17-17-17L337 47l-17-17L303 47l-79 79V24 0H200 24 0V24 400zm209.9 64l128-128H464V464H209.9zM414.1 192L224 382.1V193.9l96-96L414.1 192zM112 464c-35.3 0-64-28.7-64-64V304H176v96c0 35.3-28.7 64-64 64zM48 256V176H176v80H48zm0-128V48l128 0v80H48zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRectangleVerticalHistory = {
    prefix: 'fasr',
    iconName: 'rectangle-vertical-history',
    icon: [
      576,
      512,
      [],
      'e237',
      
      'M240 48V464H528V48H240zM192 0h48H528h48V48 464v48H528 240 192V464 48 0zM96 48h48V464H96V48zM0 96H48V416H0V96z'
      
    ]
  };

  

  
  

  var faGrillFire = {
    prefix: 'fasr',
    iconName: 'grill-fire',
    icon: [
      576,
      512,
      [],
      'e5a4',
      
      'M400 80H48V96c0 97.2 78.8 176 176 176c6.2 0 12.4-.3 18.4-1c-7 15.3-12.4 31.7-15.5 48.9c-1 0-1.9 0-2.9 0c-16.9 0-33.4-1.9-49.3-5.4L151.8 368h72.8c1.4 16.7 4.9 32.8 10.3 48H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96V80 32H48 400h48V80 96c0 24.8-4 48.7-11.5 71.1l-39.3-39.3C399 117.4 400 106.8 400 96V80zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM384 160l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faJoystick = {
    prefix: 'fasr',
    iconName: 'joystick',
    icon: [
      448,
      512,
      [128377],
      'f8c5',
      
      'M224 48a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 173.4c50.3-11 88-55.8 88-109.4C336 50.1 285.9 0 224 0S112 50.1 112 112c0 53.6 37.7 98.4 88 109.4V320h48V221.4zM128 320H64v32H48 0v48 64 48H48 400h48V464 400 352H400 128V320zM64 400h64H400v64H48V400H64z'
      
    ]
  };

  

  
  

  var faLaptopCode = {
    prefix: 'fasr',
    iconName: 'laptop-code',
    icon: [
      640,
      512,
      [],
      'f5fc',
      
      'M112 80H528V320h48V80 32H528 112 64V80 320h48V80zM51.9 400H588.1l-32 32H83.9l-32-32zM640 416V400 352H592 48 0v48 16l64 64H576l64-64zM281 177l17-17L264 126.1l-17 17-48 48-17 17 17 17 48 48 17 17L297.9 256l-17-17-31-31 31-31zM393 143l-17-17L342.1 160l17 17 31 31-31 31-17 17L376 289.9l17-17 48-48 17-17-17-17-48-48z'
      
    ]
  };

  

  
  

  var faTruckUtensils = {
    prefix: 'fasr',
    iconName: 'truck-utensils',
    icon: [
      640,
      512,
      [],
      'e628',
      
      'M48 48V368H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h48V48H48zM480 512c-53 0-96-43-96-96h-8-8H320 256c0 53-43 96-96 96s-96-43-96-96H48 0V368 48 0H48 368h48V48 96h56 9.9l7 7L601 215l7 7V232 368h8 24v48H616 576c0 53-43 96-96 96zm78.1-272l-96-96H416v96H558.1zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM97.2 167.7L112 80h16l5.3 94.9H144L152 80h16l8 94.9h10.7L192 80h16l14.8 87.7c.8 4.8 1.2 9.6 1.2 14.5c0 27.9-21 50.9-48 54.2V272v16H144V272 236.4c-27-3.2-48-26.3-48-54.2c0-4.9 .4-9.7 1.2-14.5zM304 112v16V240v64 16H272V304 240H240v-69c0-70.7 52-90.9 52-90.9h12v32z'
      
    ]
  };

  

  
  

  var faFileCircleQuestion = {
    prefix: 'fasr',
    iconName: 'file-circle-question',
    icon: [
      576,
      512,
      [],
      'e4ef',
      
      'M48 464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 48 0H48 256L384 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48V464zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-22.4 56c-23 0-41.6 18.6-41.6 41.6V328l32 0v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8-8.6 4.5v9.7V376v16h32V378.9l23.5-12.3c10.2-5.4 17.8-14.2 21.7-24.6H496v-16c0-25.4-20.6-45.9-45.9-45.9H409.6zM448 416H416v32h32V416z'
      
    ]
  };

  

  
  

  var faHeartHalfStroke = {
    prefix: 'fasr',
    iconName: 'heart-half-stroke',
    icon: [
      512,
      512,
      ["heart-half-alt"],
      'e1ac',
      
      'M256 412.1L414.1 254.1l24.2-24.2c16.5-16.5 25.7-38.8 25.7-62.1c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9V412.1zM256 96l24.2-24.2 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 289.9 446.1 256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8c0 0 0 0 0 0s0 0 0 0C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96v0z'
      
    ]
  };

  
    var faHeartHalfAlt = faHeartHalfStroke;
  

  
  

  var faSquareCaretDown = {
    prefix: 'fasr',
    iconName: 'square-caret-down',
    icon: [
      448,
      512,
      ["caret-square-down"],
      'f150',
      
      'M48 432V80H400V432H48zM0 480H48 400h48V432 80 32H400 48 0V80 432v48zM96 224L224 352 352 224V192H96v32z'
      
    ]
  };

  
    var faCaretSquareDown = faSquareCaretDown;
  

  
  

  var faCompass = {
    prefix: 'fasr',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM128 384l64-192 192-64L320 320 128 384zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faBird = {
    prefix: 'fasr',
    iconName: 'bird',
    icon: [
      512,
      512,
      [],
      'e469',
      
      'M224 208H48.7c8.1 89.7 83.5 160 175.3 160c97.2 0 176-78.8 176-176V112c0-35.3-28.7-64-64-64s-64 28.7-64 64v48 48H224zm0 208c-1 0-2 0-3 0l50.8 96H217.6L162.1 407.4C73.4 381.9 7.3 303.2 .6 208c-.4-5.3-.6-10.6-.6-16V160H48 176h48V112C224 50.1 274.1 0 336 0c51.7 0 95.3 35.1 108.1 82.8L512 128l-64 42.7V192c0 93.9-57.7 174.3-139.7 207.6L367.9 512H313.6l-52.4-99.1C249 415 236.6 416 224 416zM336 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faHelicopter = {
    prefix: 'fasr',
    iconName: 'helicopter',
    icon: [
      640,
      512,
      [128641],
      'f533',
      
      'M128 48H336v80H137.9L81 71l-7-7H64 32 2.7L8.5 92.7l24 120 2.4 12.2 11.4 5 139.9 62.2L287 393l7 7H304 552h24V376 280c0-83.9-68.1-152-152-152H384V48H576V0H128V48zm0 128H336V352H313.9l-97-97c-2.1-2.1-4.5-3.8-7.2-5l-132.6-59L63.1 121l48 48c4.5 4.5 10.6 7 17 7zM528 352H384V176h40c57.4 0 104 46.6 104 104v72zM640 488V432H592v32H224v48H616h24V488z'
      
    ]
  };

  

  
  

  var faSquareMinus = {
    prefix: 'fasr',
    iconName: 'square-minus',
    icon: [
      448,
      512,
      [61767,"minus-square"],
      'f146',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM152 232H296h24v48H296 152 128V232h24z'
      
    ]
  };

  
    var faMinusSquare = faSquareMinus;
  

  
  

  var faHouseFire = {
    prefix: 'fasr',
    iconName: 'house-fire',
    icon: [
      640,
      512,
      [],
      'e50c',
      
      'M288 .5l15.5 13.2L438.4 128.1l-7.3 4.6c-9.6 6-21 14.1-33.1 24.1L288 63.5 112 212.8V464h80V296 272h24 90c-6.8 15.1-12.1 31.1-15.1 48H240V464h84.1c13.6 18.9 30.5 35.1 49.9 48H88 64V488 253.5L39.5 274.3 8.5 237.7l264-224L288 .5zM448 160l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faEmptySet = {
    prefix: 'fasr',
    iconName: 'empty-set',
    icon: [
      512,
      512,
      [216,8709],
      'f656',
      
      'M430.5 115.5L505 41 471 7 396.5 81.5C358.1 50.6 309.2 32 256 32C132.3 32 32 132.3 32 256c0 53.2 18.6 102.1 49.5 140.5L7 471 41 505l74.5-74.5c38.4 31 87.3 49.5 140.5 49.5c123.7 0 224-100.3 224-224c0-53.2-18.6-102.1-49.5-140.5zm-68.1 .2L115.7 362.3C93.3 332.8 80 295.9 80 256c0-97.2 78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7zM149.7 396.3L396.3 149.7C418.7 179.2 432 216.1 432 256c0 97.2-78.8 176-176 176c-39.9 0-76.8-13.3-106.3-35.7z'
      
    ]
  };

  

  
  

  var faStarAndCrescent = {
    prefix: 'fasr',
    iconName: 'star-and-crescent',
    icon: [
      512,
      512,
      [9770],
      'f699',
      
      'M120 256c0-110.8 86.6-201.3 195.7-207.6c4.1-.2 8.2-.4 12.3-.4c44.1 0 85 13.7 118.6 37.1c-31.4-35-72.3-61.3-118.6-74.9c-2.6-.8-5.2-1.5-7.8-2.1C299.7 2.8 278.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c22.2 0 43.7-2.8 64.2-8.1c2.6-.7 5.2-1.4 7.8-2.1c46.3-13.6 87.2-39.9 118.6-74.9C413 450.3 372.1 464 328 464c-4.1 0-8.2-.1-12.3-.4C206.6 457.3 120 366.8 120 256zm-40 0c0 85.4 43.2 160.8 109 205.4C102.5 433.2 40 351.9 40 256s62.5-177.2 149-205.4C123.2 95.2 80 170.6 80 256zm330.8-81.8L384 120l-26.8 54.2-15.6 31.5-34.8 5.1L247 219.5l43.3 42.2 25.2 24.5-5.9 34.6-10.2 59.6 53.5-28.1L384 336l31.1 16.4 53.5 28.1-10.2-59.6-5.9-34.6 25.2-24.5L521 219.5l-59.8-8.7-34.8-5.1-15.6-31.5zm-16.3 75.4l23.4 3.4-16.9 16.5 4 23.3-20.9-11-20.9 11 4-23.3L350.2 253l23.4-3.4L384 228.5l10.4 21.2z'
      
    ]
  };

  

  
  

  var faReply = {
    prefix: 'fasr',
    iconName: 'reply',
    icon: [
      512,
      512,
      [61714,"mail-reply"],
      'f3e5',
      
      'M461.7 427c-35.8 37.4-77.7 53-77.7 53s30.1-30.1 31.9-75.7c.1-1.4 .1-2.8 .1-4.3c0-61.9-50.1-112-112-112H272 224v48 12.2 .9V384H192l-16-14.7L35.5 240.6 0 208l35.5-32.6L176 46.7 192 32h32V66.9v.9V80v48h48 64c97.2 0 176 78.8 176 176c0 54.8-23.5 95-50.3 123zm-5.8-77.6C460.9 336 464 321 464 304c0-70.7-57.3-128-128-128H224 176V128 111.8L71 208l105 96.2V288 240h48 80c70.7 0 130.6 45.8 151.8 109.4z'
      
    ]
  };

  
    var faMailReply = faReply;
  

  
  

  var faMeat = {
    prefix: 'fasr',
    iconName: 'meat',
    icon: [
      512,
      512,
      [127830],
      'f814',
      
      'M476.3 101.5c-8.7-12.5-18.7-24.6-30-35.8C416.6 35.9 381.1 14.3 345.8 5c-34-8.9-78-8.3-109.5 23.2l-52 52c-36 36-56.2 84.8-56.2 135.8v94.5l-26.4 26.3C90.9 326.4 76.2 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60H72v12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-16.2-6.4-30.9-16.8-41.7L201.5 384H296c50.9 0 99.8-20.2 135.8-56.2L483.5 276l.3-.3c23.7-23.7 29.9-54.3 27.8-82.5c-.7-9.4-2.3-18.5-4.6-27c-5.8-22-16.4-44.1-30.7-64.8zM462.8 216.6c-2 9.9-6.2 18.6-12.9 25.3l-.2 .2c-29 28.7-92.5 11.9-142-37.6C258 154.8 241.2 91.1 270.2 62.2c1.8-1.8 3.7-3.4 5.8-4.8c.5-.4 1-.7 1.6-1.1c2.9-1.9 6-3.4 9.3-4.6c.9-.3 1.9-.7 2.8-1c32.7-10.1 82.4 8.5 122.8 48.9c10.9 10.9 20.2 22.5 27.8 34.3c9.7 15 16.5 30.2 20.3 44.6c.4 1.6 .8 3.2 1.2 4.9c2.5 11.4 3 22.1 1.3 31.7c-.1 .5-.2 1-.3 1.6zm-73.9 85.5C363 323.9 330.1 336 296 336H176V216c0-34.1 12.1-67 33.9-92.8c.8 5 1.9 9.9 3.1 14.6c9.3 35.3 30.9 70.9 60.6 100.6s65.3 51.4 100.6 60.6c4.7 1.2 9.6 2.3 14.6 3.1zm-1.2-122.4c8.9-8.9 3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5s-3.8 28.5 11.5 43.8s34.9 20.4 43.8 11.5z'
      
    ]
  };

  

  
  

  var faClover = {
    prefix: 'fasr',
    iconName: 'clover',
    icon: [
      448,
      512,
      [],
      'e139',
      
      'M277.2 32H256h-9.9l-7 7-15 15L209 39l-7-7H192 170.8C129.5 32 96 65.5 96 106.8c0 8.8 1.6 17.5 4.6 25.7c-8.2-3-16.9-4.6-25.7-4.6C33.5 128 0 161.5 0 202.8V224v9.9l7 7 15 15L7 271l-7 7V288v21.2C0 350.5 33.5 384 74.8 384c8.8 0 17.5-1.6 25.7-4.6c-3 8.2-4.6 16.9-4.6 25.7c0 41.3 33.5 74.8 74.8 74.8H192h9.9l7-7 15-15 15 15 7 7H256h21.2c41.3 0 74.8-33.5 74.8-74.8c0-8.8-1.6-17.5-4.6-25.7c8.2 3 16.9 4.6 25.7 4.6c41.3 0 74.8-33.5 74.8-74.8V288v-9.9l-7-7-15-15 15-15 7-7V224 202.8c0-41.3-33.5-74.8-74.8-74.8c-8.8 0-17.5 1.6-25.7 4.6c3-8.2 4.6-16.9 4.6-25.7C352 65.5 318.5 32 277.2 32zM241 105l25-25 11.2 0C292 80 304 92 304 106.8c0 4.6-1.2 9-3.4 13L267 180.3l-13.8 24.9 21.6 21.6L299.7 213l60.5-33.6c4-2.2 8.5-3.4 13-3.4c14.8 0 26.8 12 26.8 26.8v11.2l-25 25-17 17 17 17 25 25v11.2c0 14.8-12 26.8-26.8 26.8c-4.6 0-9-1.2-13-3.4L299.7 299l-24.9-13.8-21.6 21.6L267 331.7l33.6 60.5c2.2 4 3.4 8.5 3.4 13c0 14.8-12 26.8-26.8 26.8H265.9l-25-25-17-17-17 17-25 25H170.8C156 432 144 420 144 405.2c0-4.6 1.2-9 3.4-13L181 331.7l13.8-24.9-21.6-21.6L148.3 299 87.9 332.6c-4 2.2-8.5 3.4-13 3.4C60 336 48 324 48 309.2V297.9l25-25 17-17L73 239l-25-25V202.8C48 188 60 176 74.8 176c4.6 0 9 1.2 13 3.4L148.3 213l24.9 13.8 21.6-21.6L181 180.3l-33.6-60.5c-2.2-4-3.4-8.5-3.4-13C144 92 156 80 170.8 80h11.2l25 25 17 17 17-17z'
      
    ]
  };

  

  
  

  var faUsersSlash = {
    prefix: 'fasr',
    iconName: 'users-slash',
    icon: [
      640,
      512,
      [],
      'e073',
      
      'M202.6 134.5C215.9 120.2 224 101.1 224 80c0-44.2-35.8-80-80-80C115.7 0 90.9 14.6 76.7 36.8l-28.3-22L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L441.5 320H640L592 192H444c2.6 10.2 4 21 4 32c0 30.1-10.4 57.7-27.7 79.5L395 283.9c13.1-16.4 21-37.2 21-59.9c0-53-43-96-96-96c-31.3 0-59.1 15-76.6 38.2l-40.8-31.7zm78.7 61.1C290 183.7 304.1 176 320 176c26.5 0 48 21.5 48 48c0 11.6-4.1 22.2-10.9 30.5l-75.8-58.9zM48 192L0 320H235.3c-20.6-18.2-35.3-42.8-40.8-70.8L121.8 192H48zM176 352L142.4 464 128 512h50.1H461.9 512l-5-16.5-65.6-51.7 6.1 20.2h-255l19.2-64H385.8l-60.9-48H176zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faStarSharpHalf = {
    prefix: 'fasr',
    iconName: 'star-sharp-half',
    icon: [
      576,
      512,
      [],
      'e28c',
      
      'M185.2 316.4L145 440.4 121.7 512l63.6-40.4 126.8-80.5V117.5 0l-48 107.2-39.5 88.3h-124H18.9l66.1 48 100.3 72.9zm-18.6-72.9h57.9 31.1l8.4-18.9v140L208.6 400l22.3-68.7 10.8-33.2-28.2-20.5-46.8-34z'
      
    ]
  };

  

  
  

  var faPickleball = {
    prefix: 'fasr',
    iconName: 'pickleball',
    icon: [
      576,
      512,
      [],
      'e435',
      
      'M129.9 369.9l20-20-7.8-27.2L117.9 238l19.2-19.2 137.4 137c3.2-17.8 9.3-34.7 17.9-49.9L171 184.9l117-117L444.6 224.5c27.1 2.1 52.3 11 74 24.9L528 240l-33.9-33.9L321.9 33.9 288 0 254.1 33.9l-129 129c-2.1 1.1-4 2.5-5.7 4.3c-1.7 1.7-3.1 3.6-4.2 5.7L64 224 96 336 49.9 382.1 16 416l33.9 33.9 28.1 28.1L112 512l33.9-33.9L192 432l99.4 28.4c-9.1-16.8-15.3-35.3-18-55.1l-68.2-19.5L178 378.1l-20 20L112 444.1 83.9 416l46.1-46.1zM560 384a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM368 368a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm32-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 32a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM464 304a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  

  
  

  var faFaceMask = {
    prefix: 'fasr',
    iconName: 'face-mask',
    icon: [
      576,
      512,
      [],
      'e37f',
      
      'M128 388.9c-29.1-35-46.9-79.7-48-128.5l48 19.2V388.9zM36.4 208.5l-13.3-5.3L11.2 232.9l14.9 5.9 6.4 2.5c-.3 4.8-.4 9.7-.4 14.6c0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.9-.1-9.8-.4-14.6l6.4-2.5 14.9-5.9-11.9-29.7-13.3 5.3C517.3 89.8 413.2 0 288 0S58.7 89.8 36.4 208.5zM82 226.8C96.2 125.7 183 48 288 48s191.8 77.7 206 178.8l-53 21.2H424 152 135.1L82 226.8zM496 260.5c-1 48.8-18.9 93.5-48 128.5V279.6l48-19.2zM170.4 207.4c4.8-5.7 26.7-23.4 61.6-23.4h24V136H232c-50.4 0-85.4 25-98.4 40.6l-15.4 18.4 36.9 30.7 15.4-18.4zM400 352v32H176V352H400zm0-56v24H176V296H400zM203.2 440l-20-24H392.8l-20 24H288 203.2zM344 184c36.4 0 58.7 15.3 63 19.6l17 17 33.9-33.9-17-17c-13.5-13.5-48.1-33.7-97-33.7H320v48h24z'
      
    ]
  };

  

  
  

  var faTachographDigital = {
    prefix: 'fasr',
    iconName: 'tachograph-digital',
    icon: [
      640,
      512,
      ["digital-tachograph"],
      'f566',
      
      'M48 112V400H592V112H48zM0 64H48 592h48v48V400v48H592 48 0V400 112 64zm368 80v96H80V144H368zM80 336H96 352h16v32H352 96 80V336zm320 0h16H544h16v32H544 416 400V336zM112 272v32H80V272h32zm32 0h32v32H144V272zm96 0v32H208V272h32zm32 0h32v32H272V272zm96 0v32H336V272h32z'
      
    ]
  };

  
    var faDigitalTachograph = faTachographDigital;
  

  
  

  var faMagnifyingGlassArrowRight = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
      512,
      512,
      [],
      'e521',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm33-289l-17-17L190.1 144l17 17 23 23H128 104v48h24H230.1l-23 23-17 17L224 305.9l17-17 64-64 17-17-17-17-64-64z'
      
    ]
  };

  

  
  

  var faSensorTriangleExclamation = {
    prefix: 'fasr',
    iconName: 'sensor-triangle-exclamation',
    icon: [
      640,
      512,
      ["sensor-alert"],
      'e029',
      
      'M48 80H400V181.2l48-88V80 32H400 48 0V80 432v48H48 237l26.2-48H48V80zm96 72V128H96v24V264v24h48V264 152zm96 0V128H192v24V264v24h48V264 152zm208 8L256 512H640L448 160zm16 144v64 16H432V368 304 288h32v16zM432 416h32v32H432V416z'
      
    ]
  };

  
    var faSensorAlert = faSensorTriangleExclamation;
  

  
  

  var faUsersMedical = {
    prefix: 'fasr',
    iconName: 'users-medical',
    icon: [
      640,
      512,
      [],
      'f830',
      
      'M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM48 192H196c-2.6 10.2-4 21-4 32c0 38.2 16.8 72.5 43.3 96H0L48 192zM640 320H608V288H576 512 480v32H404.7c26.6-23.5 43.3-57.8 43.3-96c0-11-1.4-21.8-4-32H592l48 128zM176 352H416v32 16H211.7l-19.2 64H416v16h32 32v32H461.9 178.1 128l14.4-48L176 352zm144-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM512 320h64v64h64v64H576v64H512V448H448V384h64V320z'
      
    ]
  };

  

  
  

  var faMessageImage = {
    prefix: 'fasr',
    iconName: 'message-image',
    icon: [
      512,
      512,
      ["comment-alt-image"],
      'e1e0',
      
      'M208 480l-48 32V464v-9.7V416H112 48 0V368 48 0H48 464h48V48 368v48H464 304l-96 64zm0-57.7l69.4-46.2 12.1-8.1H304 464V48H48V368H160h48v48 6.3zM144 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM400 288v16H272 192 144V288l64-80 22 27.4L296 144 400 288z'
      
    ]
  };

  
    var faCommentAltImage = faMessageImage;
  

  
  

  var faUserChef = {
    prefix: 'fasr',
    iconName: 'user-chef',
    icon: [
      448,
      512,
      [],
      'e3d2',
      
      'M384 48c0 20.9-13.4 38.7-32 45.3V112v64c0 70.7-57.3 128-128 128s-128-57.3-128-128V112 93.3C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM304 176V160H144v16c0 44.2 35.8 80 80 80s80-35.8 80-80zm48 144v32h8 40l33.6 112L448 512H397.9 50.1 0l14.4-48L48 352H88h8V320l48 12 80 20 80-20 48-12zM64.5 464H128V440v-9.9l8.8-4.4L198.2 395 144 381.5V400H96 83.7L64.5 464zM160 449.9V464H383.5l-19.2-64H352 304V381.5l-14.4 3.6L160 449.9zM272 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTable = {
    prefix: 'fasr',
    iconName: 'table',
    icon: [
      512,
      512,
      [],
      'f0ce',
      
      'M48 264V160H232V264H48zm0 48H232V432H48V312zM280 432V312H464V432H280zM464 264H280V160H464V264zM48 32H0V80 432v48H48 464h48V432 80 32H464 48z'
      
    ]
  };

  

  
  

  var faHyphen = {
    prefix: 'fasr',
    iconName: 'hyphen',
    icon: [
      320,
      512,
      [],
      '2d',
      
      'M0 232H24 296h24v48H296 24 0V232z'
      
    ]
  };

  

  
  

  var faMustache = {
    prefix: 'fasr',
    iconName: 'mustache',
    icon: [
      640,
      512,
      [],
      'e5bc',
      
      'M182.8 112H192h80 8.7l6.7 5.6L320 144.8l32.6-27.2 6.7-5.6H368h80 9.2l6.8 6.2 68.3 61.5 73.7-33.5L640 130.7l0 37.3 0 34v0c0 109.4-88.6 198-198 198c-42.8 0-84.5-13.9-118.8-39.6L320 358l-3.2 2.4C282.5 386.1 240.8 400 198 400C88.6 400 0 311.4 0 202v0l0-34 0-37.3 33.9 15.4 73.7 33.5 68.3-61.5 6.8-6.2zm18.4 48l-73.2 65.8-11.7 10.5-14.3-6.5L48 205.3C49.8 286.6 116.3 352 198 352c32.5 0 64-10.5 90-30l17.6-13.2L320 298l14.4 10.8L352 322c26 19.5 57.5 30 90 30c81.7 0 148.2-65.4 150-146.7l-54 24.6-14.3 6.5-11.7-10.5L438.8 160H376.7l-41.3 34.4L320 207.2l-15.4-12.8L263.3 160H201.2z'
      
    ]
  };

  

  
  

  var faHockeyPuck = {
    prefix: 'fasr',
    iconName: 'hockey-puck',
    icon: [
      512,
      512,
      [],
      'f453',
      
      'M81.8 212.4C111.1 233.1 164.1 256 256 256s144.9-22.9 174.2-43.6c14.8-10.4 24-20.6 29.4-27.8l.5-.6-.5-.6c-5.4-7.2-14.6-17.3-29.4-27.8C400.9 134.9 347.9 112 256 112s-144.9 22.9-174.2 43.6C67 166 57.8 176.2 52.4 183.4L52 184l.5 .6c5.4 7.2 14.6 17.3 29.4 27.8zm428.4-37.6c0 0 0 0-22.1 9.2l22.2-9.2c1.2 2.9 1.8 6.1 1.8 9.2V328v4.8l-1.8 4.4L488 328c22.2 9.2 22.2 9.2 22.1 9.2l0 0 0 .1-.1 .2-.2 .5c-.2 .4-.4 .9-.7 1.4c-.5 1.1-1.3 2.6-2.3 4.3c-2 3.5-4.8 8.2-8.9 13.6c-8.1 10.8-20.9 24.7-40.1 38.2C419.3 422.9 356.2 448 256 448s-163.3-25.1-201.9-52.4C34.9 382 22.1 368.2 14 357.4C10 352 7.1 347.3 5.1 343.8c-1-1.7-1.7-3.2-2.3-4.3c-.3-.6-.5-1-.7-1.4l-.2-.5-.1-.2 0-.1 0 0c0 0 0 0 22.1-9.2L1.8 337.2 0 332.8V328 184c0-3.1 .6-6.3 1.8-9.2L24 184c-22.2-9.2-22.2-9.2-22.1-9.2l0 0 0-.1 .1-.2 .2-.5c.2-.4 .4-.9 .7-1.4c.5-1.1 1.3-2.6 2.3-4.3c2-3.5 4.8-8.1 8.9-13.6c8.1-10.8 20.9-24.7 40.1-38.2C92.7 89.1 155.8 64 256 64s163.3 25.1 201.9 52.4c19.2 13.6 32 27.4 40.1 38.2c4.1 5.4 6.9 10.1 8.9 13.6c1 1.7 1.7 3.2 2.3 4.3c.3 .6 .5 1 .7 1.4l.2 .5 .1 .2 0 .1 0 0zM48 247.1v74.9c1 1.7 2.5 3.9 4.4 6.5c5.4 7.2 14.6 17.3 29.4 27.8C111.1 377.1 164.1 400 256 400s144.9-22.9 174.2-43.6c14.8-10.4 24-20.6 29.4-27.8c2-2.6 3.4-4.9 4.4-6.5V247.1c-2 1.5-4 3-6.1 4.5C419.3 278.9 356.2 304 256 304s-163.3-25.1-201.9-52.4c-2.1-1.5-4.1-3-6.1-4.5z'
      
    ]
  };

  

  
  

  var faToiletsPortable = {
    prefix: 'fasr',
    iconName: 'toilets-portable',
    icon: [
      576,
      512,
      [],
      'e584',
      
      'M0 0H24 232h24V24 488v24H208V488v-8H48v8 24H0V488 24 0zM208 320H160V224h48V144H48V432H208V320zm0-224V48H48V96H208zM320 0h24H552h24V24 488v24H528V488v-8H368v8 24H320V488 24 0zM528 320H480V224h48V144H368V432H528V320zm0-224V48H368V96H528z'
      
    ]
  };

  

  
  

  var faSunPlantWilt = {
    prefix: 'fasr',
    iconName: 'sun-plant-wilt',
    icon: [
      640,
      512,
      [],
      'e57a',
      
      'M202.2 58l21.1-3.3 49.8-7.8-7.8 49.8L262 117.8l17.2 12.6L320 160l-40.8 29.7L262 202.2l3.3 21.1 7.8 49.8-49.8-7.8L202.2 262l-12.6 17.2L160 320l-29.7-40.8L117.8 262l-21.1 3.3-49.8 7.8 7.8-49.8L58 202.2 40.8 189.7 0 160l40.8-29.7L58 117.8 54.7 96.7 46.9 46.9l49.8 7.8L117.8 58l12.6-17.2L160 0l29.7 40.8L202.2 58zM156.6 86.3L139.3 110l-29-4.6-5.8-.9 .9 5.8 4.6 29L86.3 156.6 81.5 160l4.7 3.4L110 180.7l-4.6 29-.9 5.8 5.8-.9 29-4.6 17.3 23.7 3.4 4.7 3.4-4.7L180.7 210l29 4.6 5.8 .9-.9-5.8-4.6-29 23.7-17.3 4.7-3.4-4.7-3.4L210 139.3l4.6-29 .9-5.8-5.8 .9-29 4.6L163.4 86.3 160 81.5l-3.4 4.7zM536 144c-17.7 0-32 14.3-32 32v96 8V464l112 0h24v48H616 24 0V464H24l432 0V280v-8c0-17.7-14.3-32-32-32s-32 14.3-32 32v21.4c14.8 7.7 24 23.1 24 44.6c0 19.3-21.5 52.9-48 78c-26.5-25-48-58.4-48-78c0-21.5 9.2-37 24-44.6V272c0-44.2 35.8-80 80-80c11.4 0 22.2 2.4 32 6.7V176c0-44.2 35.8-80 80-80s80 35.8 80 80v53.4c14.8 7.7 24 23.1 24 44.6c0 19.3-21.5 52.9-48 78c-26.5-25-48-58.4-48-78c0-21.5 9.2-37 24-44.6V176c0-17.7-14.3-32-32-32zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faListMusic = {
    prefix: 'fasr',
    iconName: 'list-music',
    icon: [
      512,
      512,
      [],
      'f8c9',
      
      'M384 84.7V128v17.2l80-21.8V62.8L384 84.7zM336 366.3V208 158.2 128 48L464 13.1 512 0V49.8 160L384 194.9V432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c23.8 0 45.9 5.3 64 14.3zm0 65.7c0-2.6-1.4-9.4-12.7-17.5c-11.2-8-29.2-14.5-51.3-14.5s-40.1 6.5-51.3 14.5C209.4 422.6 208 429.4 208 432s1.4 9.4 12.7 17.5c11.2 8 29.2 14.5 51.3 14.5s40.1-6.5 51.3-14.5c11.3-8.1 12.7-14.9 12.7-17.5zM24 48H264h24V96H264 24 0V48H24zm0 128H264h24v48H264 24 0V176H24zm0 128H136h24v48H136 24 0V304H24z'
      
    ]
  };

  

  
  

  var faScissors = {
    prefix: 'fasr',
    iconName: 'scissors',
    icon: [
      512,
      512,
      [9984,9986,9988,"cut"],
      'f0c4',
      
      'M512.3 413l-30.8 36.8L463 434.4 312.4 308.2l37.4-31.3L493.9 397.6 512.3 413zM112 48a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0-48c61.9 0 112 50.1 112 112c0 17.9-4.2 34.8-11.6 49.8l75.1 62.9L472.6 69.6 491 54.2 521.8 91l-18.4 15.4-291 243.8c7.4 15 11.6 31.9 11.6 49.8c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c26.6 0 51.1 9.3 70.3 24.8L250.1 256l-67.8-56.8C163.1 214.7 138.6 224 112 224C50.1 224 0 173.9 0 112S50.1 0 112 0zm64 400A64 64 0 1 0 48 400a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faCut = faScissors;
  

  
  

  var faSquareCaretRight = {
    prefix: 'fasr',
    iconName: 'square-caret-right',
    icon: [
      448,
      512,
      ["caret-square-right"],
      'f152',
      
      'M400 80L48 80l0 352 352 0 0-352zm48-48l0 48 0 352 0 48-48 0L48 480 0 480l0-48L0 80 0 32l48 0 352 0 48 0zM192 128L320 256 192 384l-32 0 0-256 32 0z'
      
    ]
  };

  
    var faCaretSquareRight = faSquareCaretRight;
  

  
  

  var faTombstone = {
    prefix: 'fasr',
    iconName: 'tombstone',
    icon: [
      448,
      512,
      [],
      'f720',
      
      'M368 432V192c0-79.5-64.5-144-144-144S80 112.5 80 192V432H32V192C32 86 118 0 224 0S416 86 416 192V432H368zM0 464H24 424h24v48H424 24 0V464zM248 152v40h48 24v48H296 248V360v24H200V360 240H152 128V192h24 48V152 128h48v24z'
      
    ]
  };

  

  
  

  var faMarsAndVenusBurst = {
    prefix: 'fasr',
    iconName: 'mars-and-venus-burst',
    icon: [
      640,
      512,
      [],
      'e523',
      
      'M222.7 79L203.9 47.1 176 0 148.1 47.1 129.3 79 92.6 73.8 38.4 66.3l19.4 51.2L71 152 44.1 177.5 4.4 215.2l52.1 16.7 35.2 11.3L94.9 280l4.7 54.6 45.6-30.3L176 283.7l30.8 20.5 29 19.3c-13.6-22.4-22.8-47.9-26.2-75.1l-6.9-4.6L176 226l-26.6 17.7-8.9 5.9-.9-10.6-2.7-31.9-30.4-9.8-10.1-3.3 7.7-7.3 23.2-22L115.9 135l-3.8-10 10.6 1.5 31.7 4.4 16.3-27.5 5.4-9.2 5.4 9.2 16.3 27.5 31.7-4.4 5.7-.8c12.9-21.6 29.9-40.4 49.9-55.4l-25.6 3.6L222.7 79zM520 0H496V48h24 38.1l-54.2 54.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59 146.6 136 158.2V416H344 320v48h24 32v24 24h48V488 464h32 24V416H456 424V382.2c77-11.6 136-78 136-158.2c0-31.4-9-60.7-24.7-85.4L592 81.9V112v24h48V112 24 0H616 520zm-8 224c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c28.3 0 54.2 10.5 73.9 27.8l10.3 10.3C501.5 169.8 512 195.7 512 224z'
      
    ]
  };

  

  
  

  var faFaceAngryHorns = {
    prefix: 'fasr',
    iconName: 'face-angry-horns',
    icon: [
      640,
      512,
      [],
      'e368',
      
      'M171.3 47.6C213.2 17.6 264.6 0 320 0s106.8 17.6 148.7 47.6C582.9 42.8 640 0 640 0c0 80.1-55.6 160.1-74.1 184.5c6.6 22.7 10.1 46.7 10.1 71.5c0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.8 3.5-48.8 10.1-71.5C55.6 160.1 0 80.1 0 0C0 0 57.1 42.8 171.3 47.6zM320 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM272.4 256c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2-15.2-5.1 10.1-30.4 15.2 5.1 96 32 15.2 5.1-10.1 30.4-15.2-5.1-10.9-3.6c.2 1.5 .3 2.9 .3 4.4zm128 32c-17.7 0-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9-15.2 5.1-10.1-30.4 15.2-5.1 96-32 15.2-5.1 10.1 30.4-15.2 5.1-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32zM358.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5-35.1-32.7 16.4-17.5C260.7 360.3 285.4 344 320 344s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5z'
      
    ]
  };

  

  
  

  var faSignPost = {
    prefix: 'fasr',
    iconName: 'sign-post',
    icon: [
      512,
      512,
      [],
      'e624',
      
      'M232 0h48V64H432l80 96-80 96H280V512H232V256H80 32V208 112 64H80 232V0zM449.5 160l-40-48H80v96H409.5l40-48z'
      
    ]
  };

  

  
  

  var faPeopleArrows = {
    prefix: 'fasr',
    iconName: 'people-arrows',
    icon: [
      640,
      512,
      ["people-arrows-left-right"],
      'e068',
      
      'M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM78 208l-4 96h30.8l39.6 39.6L192 391.2V488v24H144V488 352H112V488v24H64V488 352H24l2-48 6-144H224l1 23.8-16.6 16.6-29.5 29.5L178 208H78zM448 488V391.2l47.6-47.6L535.2 304H566l-4-96H462l-.9 21.9-29.5-29.5L415 183.8l1-23.8H608l6 144 2 48H576V488v24H528V488 352H496V488v24H448V488zm0-424a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM265 257l-23 23H398.1l-23-23-17-17L392 206.1l17 17 64 64 17 17-17 17-64 64-17 17L358.1 368l17-17 23-23H241.9l23 23 17 17L248 401.9l-17-17-64-64-17-17 17-17 64-64 17-17L281.9 240l-17 17z'
      
    ]
  };

  
    var faPeopleArrowsLeftRight = faPeopleArrows;
  

  
  

  var faAlbumCollectionCirclePlus = {
    prefix: 'fasr',
    iconName: 'album-collection-circle-plus',
    icon: [
      640,
      512,
      [],
      'e48e',
      
      'M32 0V48H56 456h24V0H456 56 32zM320 368c0-40.2 13.4-77.2 36.1-106.8C330.2 243.1 294.9 232 256 232c-79.5 0-144 46.6-144 104s64.5 104 144 104c26.9 0 52-5.3 73.6-14.6c-6.2-18-9.6-37.3-9.6-57.4zM53.8 208H422.6c22.3-10.3 47.2-16 73.4-16c4.1 0 8.2 .1 12.3 .4L512 160H463.7 48.3 0l5.5 48L40 512H394.8c-18.3-12.9-34.1-29.2-46.3-48H82.9L53.8 208zM40 80H16v48H40 472h24V80H472 40zM256 368c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48 16v32H560 512v48 16H480V432 384H432 416V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faSquareRoot = {
    prefix: 'fasr',
    iconName: 'square-root',
    icon: [
      576,
      512,
      [8730],
      'f697',
      
      'M320 32H301.8l-4.9 17.5-96 342.7L117.1 236.6 110.3 224H96 24 0v48H24 81.7L186.9 467.4l6.8 12.6h32.5l4.9-17.5L338.2 80H552h24V32H552 320z'
      
    ]
  };

  

  
  

  var faChessRookPiece = {
    prefix: 'fasr',
    iconName: 'chess-rook-piece',
    icon: [
      320,
      512,
      ["chess-rook-alt"],
      'f448',
      
      'M16 96H40 280h24v24V224v8.7l-5.6 6.7-33.9 40.7 4.2 71.9H220.7L216 273.4l-.6-9.5 6.1-7.3L256 215.3V144H216v16 16H184V160 144H136v16 16H104V160 144H64v71.3l34.4 41.3 6.1 7.3-.6 9.5L99.3 352H51.3l4.2-71.9L21.6 239.4 16 232.7V224 120 96zM136 248c0-13.3 10.7-24 24-24s24 10.7 24 24v40H136V248zM53.8 464H266.2l-17.8-32H71.5L53.8 464zM320 461.9V464v48H272 48 0V464v-2.1L43.3 384H276.7L320 461.9z'
      
    ]
  };

  
    var faChessRookAlt = faChessRookPiece;
  

  
  

  var faArrowProgress = {
    prefix: 'fasr',
    iconName: 'arrow-progress',
    icon: [
      512,
      512,
      [],
      'e5df',
      
      'M256 88v40h24l72-64L280 0H256V40H24 0V64 256v24H24 464V424H416V384H376 328 288v40 48 40h40 48 40V472h72 24V448 256 232H488 48V88H256zM160 384v40H128V384H88 40 0v40 48 40H40 88h40V472h32v40h24l72-64-72-64H160zM424 40h48V88H424V40zM384 0V40 88v40h40 48 40V88 40 0H472 424 384zM88 424v48H40V424H88zm240 0h48v48H328V424z'
      
    ]
  };

  

  
  

  var faFileMp3 = {
    prefix: 'fasr',
    iconName: 'file-mp3',
    icon: [
      512,
      512,
      [],
      'e648',
      
      'M48 464H64v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zm208-96V496v16H224V496 421.8l-17.9 33.7-13.9 26.2-14.3-26L160 423v73 16H128V496 368 352l16 0 4 0 9.5 0 4.6 8.3 29.7 54 28.5-53.8 4.5-8.5 9.6 0 5.6 0 16 0v16zm48-16h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H320v32 16H288V496 448 368 352h16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H320v48h16zm96-80h32c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48H432 416V480h16 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H440 424V416h16 24c8.8 0 16-7.2 16-16s-7.2-16-16-16H432 416V352h16z'
      
    ]
  };

  

  
  

  var faPenRuler = {
    prefix: 'fasr',
    iconName: 'pen-ruler',
    icon: [
      512,
      512,
      ["pencil-ruler"],
      'f5ae',
      
      'M384 512l33.9-33.9 60.1-60.1L512 384l-33.9-33.9-67.5-67.5-33.9 33.9 18.2 18.2-14.1 14.1L369.4 360 392 382.6l11.3-11.3 14.1-14.1L444.1 384 384 444.1l-67.5-67.5-33.9 33.9 67.5 67.5L384 512zM229.5 101.5L161.9 33.9 128 0 94.1 33.9 33.9 94.1 0 128l33.9 33.9 67.6 67.6 33.9-33.9L67.9 128 128 67.9l26.7 26.7-14.1 14.1L129.4 120 152 142.6l11.3-11.3 14.1-14.1 18.2 18.2 33.9-33.9zM10.2 461L0 512l51-10.2L160 480 478.1 161.9 512 128 478.1 94.1 417.9 33.9 384 0 350.1 33.9 32 352 10.2 461zm51-10.2l15-75.1L321.9 129.9l60.1 60.1L136.3 435.8l-75.1 15z'
      
    ]
  };

  
    var faPencilRuler = faPenRuler;
  

  
  

  var faBellConcierge = {
    prefix: 'fasr',
    iconName: 'bell-concierge',
    icon: [
      512,
      512,
      [128718,"concierge-bell"],
      'f562',
      
      'M216 64H192v48h24 16v33.3C119.6 157.2 32 252.4 32 368H80c0-97.2 78.8-176 176-176s176 78.8 176 176h48c0-115.6-87.6-210.8-200-222.7V112h16 24V64H296 256 216zM24 400H0v48H24 488h24V400H488 24z'
      
    ]
  };

  
    var faConciergeBell = faBellConcierge;
  

  
  

  var faMessagePen = {
    prefix: 'fasr',
    iconName: 'message-pen',
    icon: [
      512,
      512,
      ["comment-alt-edit","message-edit"],
      'f4a4',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zm27.4-264l-29.1 29.1L323 188.4l29.1-29.1L304.8 112zm-51.7 51.7l-85.2 85.2L160 304.1l55.3-7.9L300.4 211l-47.3-47.3z'
      
    ]
  };

  
    var faCommentAltEdit = faMessagePen;
  
    var faMessageEdit = faMessagePen;
  

  
  

  var faBadge = {
    prefix: 'fasr',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      'M256 48c-24.1 0-45.1 13.5-55.7 33.5L191 99.1l-19-5.8c-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172l5.8 19-17.5 9.3C61.5 210.9 48 231.9 48 256s13.5 45.1 33.5 55.7L99.1 321l-5.8 19c-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7l19-5.8 9.3 17.5c10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5l9.3-17.5 19 5.8c21.6 6.6 46.1 1.4 63.1-15.7s22.3-41.5 15.7-63.1l-5.8-19 17.5-9.3c20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7L412.9 191l5.8-19c6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2l-19 5.8-9.3-17.5C301.1 61.5 280.1 48 256 48zm-88.1-4.6C188.2 17 220.1 0 256 0s67.8 17 88.1 43.4c33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93C495 188.2 512 220.1 512 256s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6s-35.9-60-31.6-93C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6z'
      
    ]
  };

  

  
  

  var faSunglasses = {
    prefix: 'fasr',
    iconName: 'sunglasses',
    icon: [
      576,
      512,
      [128374],
      'f892',
      
      'M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6l0 0-.3 1c-8.1 29-16.1 57.8-26.2 100.6H232h24v24 8h64v-8V272h24H527.3c-10.1-42.8-18.1-71.7-26.2-100.6l-.3-1 0 0 0 0 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7V272v0 24 16h0V472h0v8H552 344 320V456 368H256V472h0v8H232 24 0V456 376 352 296 272v0-2.8l.6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM200 320H48v32 24 20l152-76zm168 0v16 60l152-76H368z'
      
    ]
  };

  

  
  

  var faTireFlat = {
    prefix: 'fasr',
    iconName: 'tire-flat',
    icon: [
      512,
      512,
      [],
      'f632',
      
      'M439.7 385.6c15.5-29 24.3-62.2 24.3-97.6c0-114.9-93.1-208-208-208S48 173.1 48 288c0 35.4 8.8 68.5 24.3 97.6l14.3 26.9L68.3 436.9 48 464h84H380l84 0-20.3-27.1-18.3-24.4 14.3-26.9zm42.4 22.6L512 448v16 48H464 380 132 48 0V464 448l29.9-39.9C10.8 372.3 0 331.4 0 288C0 146.6 114.6 32 256 32s256 114.6 256 256c0 43.4-10.8 84.3-29.9 120.1zM376 288c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5l0 .9 39.2 12.8c.5-4.5 .8-9 .8-13.6zm-54.9 46.5c-10 14-24.4 24.6-41.2 29.9l0 41.3c34.4-7 63.5-28.7 80.4-58.3l-39.3-12.8zM232 364.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3l0-41.3zM136 288c0 4.6 .3 9.2 .8 13.6L176 288.9l0-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 228.4 136 256.8 136 288zm120-80c8.9 0 17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8L228.8 210l1.6 2.2c8-2.7 16.6-4.2 25.6-4.2zM88 288a168 168 0 1 1 336 0A168 168 0 1 1 88 288zm200 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faTreeChristmas = {
    prefix: 'fasr',
    iconName: 'tree-christmas',
    icon: [
      448,
      512,
      [127876],
      'f7db',
      
      'M144 81.3l53.3-28L224 0l26.7 53.3L304 80l-53.3 26.7L224 160l-26.7-53.3L144 81.3zM35.4 304L162.8 125.7l10.8 5.2 18.3 36.6L94.4 304h72.2l-45.9 73.4L66.6 464H381.4l-54.1-86.6L281.4 304h72.2L256.1 167.5l18.5-36.9 10.4-5.2L412.6 304 424 320v31 1H376h-8l30 48 40 64 10 16v32H400 48 0V480l10-16 40-64 30-48H72 24v-1V320l11.4-16zM176 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faMotorcycle = {
    prefix: 'fasr',
    iconName: 'motorcycle',
    icon: [
      640,
      512,
      [127949],
      'f21c',
      
      'M456 32h-8.7l-6.7 5.6-49 41.1L373.1 44.6 366.3 32H352 280 256V80h24 57.7l16.4 30.3-95.2 80C223.1 161.3 177.6 144 128 144H56 32v48H56h72c88.4 0 160 71.6 160 160v32h16v0h48V352c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H488h24V104 56 32H488 456zM392.6 181.6c-32 22.5-57.4 53.7-72.6 90.2c-7.1-17-16.4-32.8-27.5-47.2l84.9-71.3 15.3 28.2zM432 352c0-21.7 8.6-41.3 22.6-55.7l36.3 67.1 11.4 21.1 42.2-22.8-11.4-21.1-36.3-67.1c4.9-.9 10-1.4 15.2-1.4c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80zM204.3 328H149.2c-5.6-5-13.1-8-21.2-8c-17.7 0-32 14.3-32 32s14.3 32 32 32c8.1 0 15.5-3 21.2-8h55.2c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80s35.8-80 80-80c35.8 0 66.1 23.5 76.3 56zM128 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z'
      
    ]
  };

  

  
  

  var faChartBullet = {
    prefix: 'fasr',
    iconName: 'chart-bullet',
    icon: [
      512,
      512,
      [],
      'e0e1',
      
      'M288 32V56v8H464h48v48 64 48H464 288v8 24H240V232v-8H48 0V176 112 64H48 240V56 32h48zM160 112v64h80V112H160zm128 0v64H464V112H288zm-176 0H48v64h64V112zM384 256v24 8h80 48v48 64 48H464 384v8 24H336V456v-8H48 0V400 336 288H48 336v-8V256h48zM224 336v64H336V336H224zm160 0v64h80V336H384zm-208 0H48v64H176V336z'
      
    ]
  };

  

  
  

  var faStarChristmas = {
    prefix: 'fasr',
    iconName: 'star-christmas',
    icon: [
      512,
      512,
      [],
      'f7d4',
      
      'M237.5 304.8L256 360.2l18.5-55.4 7.6-22.8 22.8-7.6L360.2 256l-55.4-18.5-22.8-7.6-7.6-22.8L256 151.8l-18.5 55.4-7.6 22.8-22.8 7.6L151.8 256l55.4 18.5 22.8 7.6 7.6 22.8zM192 320L75.9 281.3 0 256l75.9-25.3L192 192 230.7 75.9 256 0l25.3 75.9L320 192l116.1 38.7L512 256l-75.9 25.3L320 320 281.3 436.1 256 512l-25.3-75.9L192 320zM54.1 88L88 54.1l17 17 48 48 17 17L136 169.9l-17-17L71 105l-17-17zm403.9 0l-17 17-48 48-17 17L342.1 136l17-17 48-48 17-17L457.9 88zM441 407l17 17L424 457.9l-17-17-48-48-17-17L376 342.1l17 17 48 48zM54.1 424l17-17 48-48 17-17L169.9 376l-17 17-48 48-17 17L54.1 424z'
      
    ]
  };

  

  
  

  var faCircleC = {
    prefix: 'fasr',
    iconName: 'circle-c',
    icon: [
      512,
      512,
      [],
      'e101',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80c28.7 0 53.8 15.1 68 37.8l40.8-25.4C342.2 152.2 301.9 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c45.9 0 86.2-24.2 108.7-60.5L324 298.2c-14.2 22.8-39.3 37.8-68 37.8c-44.2 0-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faBoxTissue = {
    prefix: 'fasr',
    iconName: 'box-tissue',
    icon: [
      512,
      512,
      [],
      'e05b',
      
      'M64 0h49.2H208c40 0 52 24 64 48s24 48 64 48h61.4H448l-16 48-21.3 64-16 48L384 288h32v48H96V288h32l-7.1-32-10.7-48L74.7 48 64 0zM177.2 288H333.4l48-144H336c-31.1 0-56.2-9.9-75.5-28.2c-15.8-15-25.1-33.7-30.5-44.6l-.9-1.8C222.3 56 219.8 52 217.5 49.8c-.5-.5-.8-.6-1.3-.8c-.7-.3-3-1-8.2-1H123.8l53.3 240zM464 256H428.4l16-48H464h48v48V464v48H464 48 0V464 256 208H48 77.4l10.7 48H48V368H464V256zM48 416v48H464V416H48z'
      
    ]
  };

  

  
  

  var faMicrophoneSlash = {
    prefix: 'fasr',
    iconName: 'microphone-slash',
    icon: [
      640,
      512,
      [],
      'f131',
      
      'M472.4 344c15-25.9 23.6-56 23.6-88V216 192H448v24 40c0 21-5 40.7-14 58.2l-25.9-20.1c5.1-11.7 7.9-24.6 7.9-38.1V48 0H368 272 224V48 151.1L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L472.4 344zM272 188.4V48h96V256c0 2.2-.2 4.4-.4 6.6L272 188.4zm86.2 189.8C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7l-48-37.8V216v40c0 89.1 66.2 162.7 152 174.4V464H248 224v48h24 72 72 24V464H392 344V430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z'
      
    ]
  };

  

  
  

  var faBinoculars = {
    prefix: 'fasr',
    iconName: 'binoculars',
    icon: [
      512,
      512,
      [],
      'f1e5',
      
      'M96 32h96V80H96V32zM68 112H88 200h24v24 24h64V136 112h24H424h20l3.6 19.7 15.2 83.7 45.8 76.2 3.4 5.7V304 456v24H488 312 288V456 288H224V456v24H200 24 0V456 304v-6.6l3.4-5.7 45.7-76.2 15.2-83.7L68 112zM108 160L95.6 228.3l-.8 4.3-2.3 3.8L48 310.6V432H176V160H108zM404 160H336V432H464V310.6l-44.6-74.3-2.2-3.8-.8-4.3L404 160zM416 32V80H320V32h96z'
      
    ]
  };

  

  
  

  var faTruckRamp = {
    prefix: 'fasr',
    iconName: 'truck-ramp',
    icon: [
      640,
      512,
      [],
      'f4e0',
      
      'M376 0H352V24 372.7L26 456.8l-23.2 6 12 46.5 23.2-6 378.2-97.5C419.1 464.9 468.1 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-45.3 0-84.3 26.9-102 65.6l0 0-26 6.7V48H616h24V0H616 376zM528 336a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faMusicSlash = {
    prefix: 'fasr',
    iconName: 'music-slash',
    icon: [
      640,
      512,
      [],
      'f8d1',
      
      'M576 32V-.3L545.1 9l-320 96L208 110.1V128v10.7L48.4 14.8 29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7-60.8-47.2c10-12.6 15.9-27.8 15.9-44.1v0V144 32zM522 382.5l-57.7-44.8c4.7-1.1 9.9-1.7 15.7-1.7c35.1 0 48 22.1 48 32v0c0 3.7-1.8 9.2-6 14.5zm-100.5-78L332.1 235 528 176.3V298.7c-14.1-6.8-30.5-10.7-48-10.7c-22 0-42.2 6.2-58.4 16.5zM285.5 198.9L256 176V145.9L528 64.3v61.9L285.5 198.9zM256 297.7l-48-37.8V362.7c-14.1-6.8-30.5-10.7-48-10.7c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80v0V297.7zM208 432v0c0 9.9-12.9 32-48 32s-48-22.2-48-32s12.9-32 48-32s48 22.1 48 32z'
      
    ]
  };

  

  
  

  var faTrillium = {
    prefix: 'fasr',
    iconName: 'trillium',
    icon: [
      448,
      512,
      [],
      'e588',
      
      'M176.3 228.5l-24.2 13.9L117 262.7C97.4 274.1 79.8 301.4 66.6 335c-2 5.1-3.8 10.2-5.4 15c5 1 10.3 2 15.7 2.8c35.7 5.4 68.2 3.8 87.8-7.5L199.8 325 224 311.1 248.2 325l35.1 20.3c19.7 11.4 52.1 12.9 87.8 7.5c5.4-.8 10.7-1.8 15.7-2.8c-1.6-4.8-3.4-9.9-5.4-15c-13.1-33.7-30.8-61-50.4-72.3l-35.1-20.3-24.2-13.9V200.6 160c0-22.7-14.8-51.6-37.4-79.8c-3.4-4.3-6.9-8.4-10.3-12.2c-3.4 3.8-6.8 7.9-10.3 12.2c-22.6 28.2-37.4 57.1-37.4 79.8v40.6 27.9zM128 200.6V160C128 80 224 0 224 0s96 80 96 160v40.6l35.1 20.3c69.3 40 90.6 163.1 90.6 163.1s-117.3 43.1-186.6 3.1L224 366.9l-35.1 20.3C119.6 427.1 2.3 384 2.3 384s21.3-123.1 90.6-163.1L128 200.6zm-26.9-78.2C97.9 134.5 96 147.1 96 160v22.1l-19.1 11c-9.2 5.3-17.6 11.6-25.2 18.6C-5.5 163.3-4 120.5-4 120.5s35.7-22.3 105.1 1.9zM352 160c0-12.6-1.8-25-4.9-37c70.6-25.2 106.9-2.5 106.9-2.5s1.5 43.3-56.6 92.2c-7.9-7.4-16.6-14-26.2-19.5l-19.1-11V160zM204.9 414.9l19.1-11 19.1 11c9.6 5.6 19.8 9.8 30.2 13C258.5 493.7 224 512 224 512s-34.5-18.3-49.3-84.2c10.4-3.2 20.6-7.4 30.2-13zM224 216a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  

  
  

  var faBrowsers = {
    prefix: 'fasr',
    iconName: 'browsers',
    icon: [
      576,
      512,
      [],
      'e0cb',
      
      'M144 368V128H528V368H144zM144 0H96V48 368v48h48H528h48V368 48 0H528 144zM48 120V96H0v24V488v24H24 456h24V464H456 48V120z'
      
    ]
  };

  

  
  

  var faSprinklerCeiling = {
    prefix: 'fasr',
    iconName: 'sprinkler-ceiling',
    icon: [
      384,
      512,
      [],
      'e44c',
      
      'M0 0V96v19.9l19.5 3.7L128 140.2V91.4L48 76.1V0H0zM256 91.4v48.9l108.5-20.7 19.5-3.7V96 0H336V76.1L256 91.4zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 496a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM216 56V32H168V56 208H88 64v48H88 192 296h24V208H296 216V56z'
      
    ]
  };

  

  
  

  var faGavel = {
    prefix: 'fasr',
    iconName: 'gavel',
    icon: [
      512,
      512,
      ["legal"],
      'f0e3',
      
      'M271.2 82.7L217.9 136 376 294.1l53.3-53.3L271.2 82.7zM184 169.9l-16 16L134.1 152l17-17 16-16 87.2-87.3 13.6-13.5 17-17 33.9 33.9L305.2 48.8 463.3 206.8l13.5-13.6 33.9 33.9-17 17-13.5 13.6L393 345l-16 16-17 17L326.1 344l16-16L184 169.9zM129.9 478.1L96 512 62.1 478.1 33.9 449.9 0 416l33.9-33.9 76.1-76.1L144 272l31 31 48.4-48.4 33.9 33.9L209 337l31 31-33.9 33.9-76.1 76.1zM172.1 368L144 339.9 67.9 416 96 444.1 172.1 368z'
      
    ]
  };

  
    var faLegal = faGavel;
  

  
  

  var faReflectBoth = {
    prefix: 'fasr',
    iconName: 'reflect-both',
    icon: [
      512,
      512,
      [],
      'e66f',
      
      'M289.9 158.1L256 192l-33.9-33.9L112 48 96 32 96 0l32 0 3.9 0L144 0 368 0l12.1 0L384 0l32 0 0 32L400 48 289.9 158.1zM332.1 48L179.9 48 256 124.1 332.1 48zM192 256l-33.9 33.9L48 400 32 416 0 416l0-32 0-3.9L0 368 0 144l0-12.1L0 128 0 96l32 0 16 16L158.1 222.1 192 256zm-67.9 0L48 179.9l0 152.2L124.1 256zM320 256l33.9-33.9L464 112l16-16 32 0 0 32 0 3.9 0 12.1 0 224 0 12.1 0 3.9 0 32-32 0-16-16L353.9 289.9 320 256zm67.9 0L464 332.1l0-152.2L387.9 256zM256 320l33.9 33.9L400 464l16 16 0 32-32 0-3.9 0L368 512l-224 0-12.1 0-3.9 0-32 0 0-32 16-16L222.1 353.9 256 320zm0 67.9L179.9 464l152.2 0L256 387.9z'
      
    ]
  };

  

  
  

  var faTrashClock = {
    prefix: 'fasr',
    iconName: 'trash-clock',
    icon: [
      576,
      512,
      [],
      'e2b0',
      
      'M147.2 0H160 288h12.8L308 10.7 354.2 80h13.7H416h32v48H412.4l-4.9 65.7c-17.3 2.4-33.9 7.3-49.2 14.4l5.9-80.1h-33l-1.9 1.3-.9-1.3h-209l-.9 1.3-1.9-1.3h-33l24.9 336H284.5c12.3 18.8 28 35.1 46.3 48H64L35.6 128H0V80H32 80.1 93.8L140 10.7 147.2 0zm4.4 80h145L275.2 48H172.8L151.5 80zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80H416v16 64 16h16 48 16V352H480 448V304 288z'
      
    ]
  };

  

  
  

  var faCartCircleArrowUp = {
    prefix: 'fasr',
    iconName: 'cart-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e3f0',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H510.7L475.3 193.2c6.8-.8 13.7-1.2 20.7-1.2c10 0 19.7 .8 29.2 2.4L561 80l15-48H525.7 122l-2.4-12.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM417.4 360l11.3-11.3 56-56L496 281.4l11.3 11.3 56 56L574.6 360 552 382.6l-11.3-11.3L512 342.6V432v16H480V432 342.6l-28.7 28.7L440 382.6 417.4 360z'
      
    ]
  };

  

  
  

  var faTentArrowLeftRight = {
    prefix: 'fasr',
    iconName: 'tent-arrow-left-right',
    icon: [
      576,
      512,
      [],
      'e57f',
      
      'M121.9 52.8L101.2 72H479.6L458.9 52.8 441.3 36.5 473.9 1.3l17.6 16.3 65.6 60.8 19.4 18L556.7 114l-68.8 60.8-18 15.9-31.8-36 18-15.9L477.4 120h-374l21.3 18.8 18 15.9-31.8 36-18-15.9L24.1 114 4.2 96.4l19.4-18L89.3 17.6 106.9 1.3l32.6 35.2L121.9 52.8zM112.5 512H64l6.9-48L96 288 288 160 480 288l25.1 176 6.9 48H463.5h-351zM264 233.7L140.5 316 119.3 464H264V233.7zm48 0V360l62.4 104h82.3L435.5 316 312 233.7z'
      
    ]
  };

  

  
  

  var faChfSign = {
    prefix: 'fasr',
    iconName: 'chf-sign',
    icon: [
      640,
      512,
      [],
      'e602',
      
      'M240 56V32H192V56 456v24h48V456 272H368V456v24h48V456 56 32H368V56 224H240V56zM472 32H448V56 456v24h48V456 272h88 24V224H584 496V80H616h24V32H616 472zM88 40C43.8 40 8 75.8 8 120V408c0 44.2 35.8 80 80 80s80-35.8 80-80V392H120v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V120c0-17.7 14.3-32 32-32s32 14.3 32 32v16h48V120c0-44.2-35.8-80-80-80z'
      
    ]
  };

  

  
  

  var faMicrowave = {
    prefix: 'fasr',
    iconName: 'microwave',
    icon: [
      576,
      512,
      [],
      'e01b',
      
      'M528 80V400H48V80H528zM48 32H0V80 400v48H48 64v32h48V448H464v32h48V448h16 48V400 80 32H528 48zm384 80V368h48V112H432zm-48 16H96V352H384V128z'
      
    ]
  };

  

  
  

  var faHospitalUser = {
    prefix: 'fasr',
    iconName: 'hospital-user',
    icon: [
      576,
      512,
      [],
      'f80d',
      
      'M48 48V272h88 24v48H136 48v48h88 24v48H136 48v48H272V48H48zM0 0H48 272h48V48 359L253.1 512H48 0V464 48 0zM136 96h48v40h40v48H184v40H136V184H96V136h40V96zM352 272a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM520 384l56 128H288l56-128H520z'
      
    ]
  };

  

  
  

  var faFaceFlushed = {
    prefix: 'fasr',
    iconName: 'face-flushed',
    icon: [
      512,
      512,
      [128563,"flushed"],
      'f579',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336H168v48h24H320h24V336H320 192zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faFlushed = faFaceFlushed;
  

  
  

  var faSquare3 = {
    prefix: 'fasr',
    iconName: 'square-3',
    icon: [
      448,
      512,
      [],
      'e258',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm280 96h24v34.6l-7.8 7.1-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H210.7c-32.2 0-61.6-18.2-76-47l-4.2-8.3 42.9-21.5 4.2 8.3c6.3 12.5 19.1 20.4 33 20.4h25.2c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3-24.1 .1V229.4l7.8-7.1L218.3 176H152 128V128h24H280z'
      
    ]
  };

  

  
  

  var faTrowelBricks = {
    prefix: 'fasr',
    iconName: 'trowel-bricks',
    icon: [
      512,
      512,
      [],
      'e58a',
      
      'M256 152V256H208L0 128 208 0h48V104h88V80H512v96H344V152H256zm32 184V288 272 224h48H464h48v48 64 88 40 48H464 48 0V464 384 336H48 240h48zm48 0H464V272H336v64zm0 48H304 288 256v80H464V424 384H336zm-128 0H48v80H208V384z'
      
    ]
  };

  

  
  

  var faCloud = {
    prefix: 'fasr',
    iconName: 'cloud',
    icon: [
      640,
      512,
      [9729],
      'f0c2',
      
      'M96 200.2C40.1 220 0 273.3 0 336v96 48H48h96H512h80 48V432 352c0-59.6-40.8-109.8-96-124V208c0-70.7-57.3-128-128-128c-13.9 0-27.3 2.2-39.9 6.3C346.8 53 303.9 32 256 32C167.6 32 96 103.6 96 192v8.2zM592 432H512 144 48V336c0-41.7 26.6-77.3 64-90.5l32-11.3V200.2 192c0-61.9 50.1-112 112-112c33.5 0 63.5 14.6 84.1 38L361 141.8l30.1-9.8c7.8-2.5 16.1-3.9 24.9-3.9c44.2 0 80 35.8 80 80v20 37.2l36 9.3c34.5 8.9 60 40.3 60 77.5v80z'
      
    ]
  };

  

  
  

  var faMessageQuestion = {
    prefix: 'fasr',
    iconName: 'message-question',
    icon: [
      512,
      512,
      [],
      'e1e3',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM168 136l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8h56.9c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 188.6v13.9V224v24h48V224v-7.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H224c-30.9 0-56 25.1-56 56zm64 152v48h48V288H232z'
      
    ]
  };

  

  
  

  var faPaw = {
    prefix: 'fasr',
    iconName: 'paw',
    icon: [
      512,
      512,
      [],
      'f1b0',
      
      'M193.9 189.7c32.3-10.6 46.9-53.9 32.6-96.8S174.4 23.8 142.1 34.3s-46.9 53.9-32.6 96.8s52.1 69.1 84.4 58.5zm217.7 8.9c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3s14.3-70.1-10.2-84.1s-59.7 .9-78.5 33.3zm-311.3 0c-18.9-32.4-54-47.3-78.5-33.3s-29.1 51.7-10.2 84.1s54 47.3 78.5 33.3s29.1-51.7 10.2-84.1zM277.5 92.9c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5s-.3-86.2-32.6-96.8S291.8 50 277.5 92.9zm-9.9 292.6L256 382.5l-11.6 2.9L119.1 416.8c10.1-42.6 29.8-74.7 51.7-97.7C204.2 284 240.4 272 256 272s51.8 12 85.2 47.1c21.9 23 41.6 55.1 51.7 97.7L267.6 385.4zM64 480l48.2-12.1L256 432l143.8 35.9L448 480c0-17.8-1.3-34.6-3.7-50.4C422.8 288.7 313.5 224 256 224s-166.8 64.7-188.3 205.6C65.3 445.4 64 462.2 64 480z'
      
    ]
  };

  

  
  

  var faTabletScreenButton = {
    prefix: 'fasr',
    iconName: 'tablet-screen-button',
    icon: [
      448,
      512,
      ["tablet-alt"],
      'f3fa',
      
      'M48 464H400V368H48v96zm0-144H400V48H48V320zM0 0H48 400h48V48 464v48H400 48 0V464 48 0zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faTabletAlt = faTabletScreenButton;
  

  
  

  var faCircleNotch = {
    prefix: 'fasr',
    iconName: 'circle-notch',
    icon: [
      512,
      512,
      [],
      'f1ce',
      
      'M198.6 56C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200L326.6 9.9C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9L198.6 56z'
      
    ]
  };

  

  
  

  var faRainbow = {
    prefix: 'fasr',
    iconName: 'rainbow',
    icon: [
      640,
      512,
      [127752],
      'f75b',
      
      'M320 88C169.8 88 48 209.8 48 360v96 24H0V456 360C0 183.3 143.3 40 320 40s320 143.3 320 320v96 24H592V456 360C592 209.8 470.2 88 320 88zm0 224c-26.5 0-48 21.5-48 48v96 24H224V456 360c0-53 43-96 96-96s96 43 96 96v96 24H368V456 360c0-26.5-21.5-48-48-48zM160 360v96 24H112V456 360c0-114.9 93.1-208 208-208s208 93.1 208 208v96 24H480V456 360c0-88.4-71.6-160-160-160s-160 71.6-160 160z'
      
    ]
  };

  

  
  

  var faEarthAfrica = {
    prefix: 'fasr',
    iconName: 'earth-africa',
    icon: [
      512,
      512,
      [127757,"globe-africa"],
      'f57c',
      
      'M464 256c0-22.3-3.5-43.8-10-64H352v32l32 32v64H352v48l-48 48H256V320H160V232l40-40h88l64-64H256l-32 32H192V58C108.4 85 48 163.5 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faGlobeAfrica = faEarthAfrica;
  

  
  

  var faElephant = {
    prefix: 'fasr',
    iconName: 'elephant',
    icon: [
      640,
      512,
      [128024],
      'f6da',
      
      'M192 0h24 79.7c31.4 0 60.1 12.1 81.6 32H384c88.4 0 160 71.6 160 160V308.9c-11.2 6.2-24.6 9.9-39.3 9.9c-3 0-5.9-.2-8.7-.4V192c0-53-36.8-97.3-86.2-109c2.8 8.6 4.6 17.7 5.4 27l.7 8-47.8 4-.7-8c-3.1-37.3-34.3-66-71.8-66H240v64c0 35.3 28.7 64 64 64h8 24v48H312h-8c-61.9 0-112-50.1-112-112V89.6C126.8 112.6 80 174.9 80 248v40 4.6l-1.7 4.3-32 80L1.7 359.1 32 283.4V248C32 148.1 99.9 64 192 39.3V24 0zM528 381v18.7c0 17.8 14.5 32.3 32.3 32.3c15.8 0 29.3-11.4 31.9-27l.2-1 47.3 7.9-.2 1c-6.5 38.7-40 67.1-79.2 67.1C516 480 480 444 480 399.7V380.9c-23.9-3.8-45.9-13.1-64-27V488v24H392 296 272V488 411.7c-21.2 2.8-42.8 2.8-64 0V488v24H184 88 64V488 408 384h48v24 56h48V384 356.3l27.4 3.9 24.3 3.5c18.8 2.7 37.8 2.7 56.6 0l24.3-3.5 27.4-3.9V384v80h48V328 304h48v4.6c18.6 25.7 50.9 42.2 88.7 42.2c30.1 0 57.1-11.4 76.3-29.6l22 23.3c-19.9 18.9-46 31.9-75 36.5zM432 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSquareB = {
    prefix: 'fasr',
    iconName: 'square-b',
    icon: [
      448,
      512,
      [],
      'e264',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm128 96h24 92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76H152 128V360 280 256 232 152 128zm144 76c0-15.5-12.5-28-28-28H176v56h68c15.5 0 28-12.5 28-28zM176 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H244 176v56z'
      
    ]
  };

  

  
  

  var faCodePullRequestDraft = {
    prefix: 'fasr',
    iconName: 'code-pull-request-draft',
    icon: [
      448,
      512,
      [],
      'e3fa',
      
      'M48 48v64h64V48H48zM0 0H48h64 48V48v64 48H112h-8V352h8 48v48 64 48H112 48 0V464 400 352H48h8V160H48 0V112 48 0zM48 400v64h64V400H48zm352 0H336v64h64V400zm-64-48h64 48v48 64 48H400 336 288V464 400 352h48zM320 192h96v96H320V192zM416 32v96H320V32h96z'
      
    ]
  };

  

  
  

  var faW = {
    prefix: 'fasr',
    iconName: 'w',
    icon: [
      576,
      512,
      [119],
      '57',
      
      'M145.2 463.4L5.2 32H55.7L167.1 375.5 265 49.1 270.1 32h35.7L311 49.1l97.9 326.4L520.3 32h50.5l-140 431.4L425.4 480H390.1L385 462.9 288 139.5 191 462.9 185.9 480H150.6l-5.4-16.6z'
      
    ]
  };

  

  
  

  var faGiftCard = {
    prefix: 'fasr',
    iconName: 'gift-card',
    icon: [
      576,
      512,
      [],
      'f663',
      
      'M353.5 68.8L318.7 128H320h72c22.1 0 40-17.9 40-40s-17.9-40-40-40h-2.2c-14.9 0-28.8 7.9-36.3 20.8zM288 197.5l-61.6 73.9-15.4 18.4-36.9-30.7 15.4-18.4L243.4 176H184 48V320H528V176H392 332.6l53.9 64.6 15.4 18.4-36.9 30.7-15.4-18.4L288 197.5zM48 384v80H528V384H48zM256 128h1.3L222.5 68.8C214.9 55.9 201.1 48 186.2 48H184c-22.1 0-40 17.9-40 40s17.9 40 40 40h72zm7.9-83.6l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0H392c48.6 0 88 39.4 88 88c0 14.4-3.5 28-9.6 40H528h48v48V464v48H528 48 0V464 176 128H48h57.6C99.5 116 96 102.4 96 88c0-48.6 39.4-88 88-88h2.2c31.9 0 61.5 16.9 77.7 44.4z'
      
    ]
  };

  

  
  

  var faTruckMonster = {
    prefix: 'fasr',
    iconName: 'truck-monster',
    icon: [
      640,
      512,
      [],
      'f63b',
      
      'M224 0h24H384h11.8L403 9.4 482 112H584h24v24 94.3c6.1 5.1 12 10.6 17.5 16.4L640 262.1V266l-33 31.1-16.5-17.5C562.8 250.3 523.6 232 480 232c-53.3 0-100.3 27.5-127.4 69.1L345.5 312h-13H307.5h-13l-7.1-10.9C260.3 259.5 213.3 232 160 232c-43.6 0-82.8 18.3-110.5 47.7L33 297.1 0 266v-3.9l14.5-15.4c5.5-5.8 11.3-11.3 17.5-16.4V136 112H56 224V24 0zm48 112H421.4L372.2 48H272v64zM80 200.6c24.5-10.7 51.6-16.6 80-16.6c65.5 0 123.5 31.5 160 80c36.5-48.5 94.6-80 160-80c28.4 0 55.5 5.9 80 16.6V160H80v40.6zm112 76c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3H288v64H267.4c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8V512H128V491.4c-7.4-2.2-14.6-5.2-21.3-8.8L92.1 497.1 46.9 451.9l14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3H32V352H52.6c2.2-7.4 5.2-14.6 8.8-21.3L46.9 316.1l45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8V256h64v20.6zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 256v20.6c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3H608v64H587.4c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8V512H448V491.4c-7.4-2.2-14.6-5.2-21.3-8.8l-14.6 14.6-45.3-45.3 14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3H352V352h20.6c2.2-7.4 5.2-14.6 8.8-21.3l-14.6-14.6 45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8V256h64zM480 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faScarecrow = {
    prefix: 'fasr',
    iconName: 'scarecrow',
    icon: [
      448,
      512,
      [],
      'f70d',
      
      'M224 160a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c-29.5 0-56.1-12.3-75-32H80v32h56 26.5l-2.6 26.4L148.5 348.1l15.6-8.9 12.9-7.4 12.3 8.2L224 363.2 258.7 340l12.3-8.2 12.9 7.4 15.6 8.9L288.1 234.4 285.5 208H312h56V176H299c-18.9 19.7-45.6 32-75 32zM328 104c0 8.3-1 16.3-2.8 24H376h16 24 16l-16 32 32 32-32 32 16 32H416 392 376 338.5l13.4 133.6 4.6 46.3-40.4-23.1L273 388.2 237.3 412 224 420.8 210.7 412 175 388.2l-43.1 24.6L91.5 435.9l4.6-46.3L109.5 256H72 56 32 16l16-32L0 192l32-32L16 128H32 56 72h50.8c-1.8-7.7-2.8-15.7-2.8-24C120 46.6 166.6 0 224 0s104 46.6 104 104zM200 72a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm32 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM200 488V443.3l24 16 24-16V488v24H200V488z'
      
    ]
  };

  

  
  

  var faAlarmSnooze = {
    prefix: 'fasr',
    iconName: 'alarm-snooze',
    icon: [
      512,
      512,
      [],
      'f845',
      
      'M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L423 489l17 17L473.9 472l-17-17-26.5-26.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L55 455l-17 17L72 505.9l17-17 26.5-26.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192H176v48h24 55.2L195 348.3 175.2 384H216h96 24V336H312 256.8L317 227.7 336.8 192H296 200z'
      
    ]
  };

  

  
  

  var faSprayCan = {
    prefix: 'fasr',
    iconName: 'spray-can',
    icon: [
      512,
      512,
      [],
      'f5bd',
      
      'M224 0H96V128H224V0zm0 208c26.5 0 48 21.5 48 48V464H48V256c0-26.5 21.5-48 48-48H224zM96 160c-53 0-96 43-96 96V464v48H48 272h48V464 256c0-53-43-96-96-96H96zM224 336A64 64 0 1 0 96 336a64 64 0 1 0 128 0zM320 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM512 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM480 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faShishKebab = {
    prefix: 'fasr',
    iconName: 'shish-kebab',
    icon: [
      512,
      512,
      [],
      'f821',
      
      'M368 96c0-26.5 21.5-48 48-48s48 21.5 48 48c0 9.9-3 19.1-8.1 26.7l39.9 26.7C506 134.1 512 115.7 512 96c0-53-43-96-96-96s-96 43-96 96c0 17.8 4.9 34.5 13.3 48.8L303 175l-45.1-45.1L224 96l-33.9 33.9-60.1 60.1L128 192 96 224l-1.9 1.9L33.9 286.1 0 320l33.9 33.9L79 399 2.2 475.8l33.9 33.9L113 433l45.1 45.1L192 512l33.9-33.9 60.1-60.1L288 416l32-32 1.9-1.9 60.1-60.1L416 288l-33.9-33.9L337 209l45.1-45.1 17-17-17-17C373.3 121.2 368 109.3 368 96zM288 348.1L163.9 224 224 163.9 348.1 288 288 348.1zm-96 96L67.9 320 128 259.9 252.1 384 192 444.1z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueSquint = {
    prefix: 'fasr',
    iconName: 'face-grin-tongue-squint',
    icon: [
      512,
      512,
      [128541,"grin-tongue-squint"],
      'f58a',
      
      'M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V392.7c-31.9-23.3-55.2-57.8-64-97.9c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29c-8.8 40.2-32.3 75-64.5 98.3V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm230.9-48L112 272l45.7-64L112 144l118.9 64zM400 144l-45.7 64L400 272 281.1 208 400 144zM256 480c35.3 0 64-28.7 64-64V368H272v24H240V368H192v48c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faGrinTongueSquint = faFaceGrinTongueSquint;
  

  
  

  var faArrowDown91 = {
    prefix: 'fasr',
    iconName: 'arrow-down-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-desc","sort-numeric-down-alt"],
      'f886',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55V56 32h48V56 386.9l55-55 17-17 33.9 33.9-17 17-96 96-17 17zM360 288h24 48 24v24V432h24 24v48H480 432 384 360V432h24 24V336H384 360V288zm24-168a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm128 0c0 20.6-6.4 40.7-18.4 57.5L437.5 256h-59l10-13.9 24.8-34.7C369.7 202.1 336 165 336 120c0-48.6 39.4-88 88-88s88 39.4 88 88z'
      
    ]
  };

  
    var faSortNumericDesc = faArrowDown91;
  
    var faSortNumericDownAlt = faArrowDown91;
  

  
  

  var faCircleCaretDown = {
    prefix: 'fasr',
    iconName: 'circle-caret-down',
    icon: [
      512,
      512,
      ["caret-circle-down"],
      'f32d',
      
      'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM128 240V208H384v32L256 368 128 240z'
      
    ]
  };

  
    var faCaretCircleDown = faCircleCaretDown;
  

  
  

  var faCalendarImage = {
    prefix: 'fasr',
    iconName: 'calendar-image',
    icon: [
      448,
      512,
      [],
      'e0d4',
      
      'M152 24V0H104V24 64H0v80 48V464v48H48 400h48V464 192 144 64H344V24 0H296V24 64H152V24zM48 192H400V464H48V192zM160 312L80 416H368L256 240 184 344l-24-32zm-32-24a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faCircleM = {
    prefix: 'fasr',
    iconName: 'circle-m',
    icon: [
      512,
      512,
      [],
      'e115',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 152V360v24h48V360 226.2l60.5 83.8L256 337l19.5-26.9L336 226.2V360v24h48V360 152 128H347.7l-7.2 9.9L256 255 171.5 137.9l-7.2-9.9H128v24z'
      
    ]
  };

  

  
  

  var faDialMax = {
    prefix: 'fasr',
    iconName: 'dial-max',
    icon: [
      576,
      512,
      [],
      'e15e',
      
      'M320 0H256V64h64V0zM128 64H64v64h64V64zm384 0H448v64h64V64zm0 192v64h64V256H512zm0 192H448v64h64V448zM64 448v64h64V448H64zM0 256v64H64V256H0zm271 49l77.4 77.4c-43.4 27.8-101.7 22.8-139.6-15.1c-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0c37.9 37.9 43 96.2 15.1 139.6L305 271l-17-17L254.1 288l17 17zm130.1 96.2A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1z'
      
    ]
  };

  

  
  

  var faPersonDrowning = {
    prefix: 'fasr',
    iconName: 'person-drowning',
    icon: [
      576,
      512,
      [],
      'e545',
      
      'M176 32V56 190.2l160.5 48.8 177.4-46.3 23.2-6.1 12.1 46.4L526 239.2 372.4 279.3 356 377.8c-4.3-1.5-8.6-3.2-12.8-5.1c-10.8-5-19.8-11.2-31.8-19.7l11.3-67.8-81-24.6-20.9 117c-9.7 3.4-19.8 5.6-29 5.6c-6.5 0-13.4-1.1-20.3-2.9l23.9-133.7L145 231l-17-5.2V208 56 32h48zm88 96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM79 456.9C59.7 467.8 31.5 480 0 480V432c19.7 0 39.4-7.8 55.3-16.9c15.4-8.7 27.2-19.3 40.2-30.9l.4-.4 .4 .4c13 11.6 24.9 22.2 40.3 30.9c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c15.4-8.7 27-19.1 40-30.7l.7-.6 .7 .6c13 11.6 24.6 22 40 30.7c15.9 9 35.7 16.9 55.4 16.9v48c-31.5 0-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.4 7-16.9 10.7z'
      
    ]
  };

  

  
  

  var faGrapes = {
    prefix: 'fasr',
    iconName: 'grapes',
    icon: [
      512,
      512,
      [],
      'e306',
      
      'M360 0s-40 40-40 80s7.3 55.3 32 80s40 32 80 32s80-40 80-40s-32-40-80-40c-32 0-40 8-40 8s8-8 8-40c0-48-40-80-40-80zm48 264c0-44.2-35.8-80-80-80c0-44.2-35.8-80-80-80c-28 0-52.6 14.4-66.9 36.1C167 127.6 148.4 120 128 120c-44.2 0-80 35.8-80 80c0 18 6 34.6 16 48c-19.4 14.6-32 37.8-32 64c0 17.6 5.7 33.8 15.2 47C19.4 371.5 0 399.5 0 432c0 44.2 35.8 80 80 80c32.5 0 60.5-19.4 73-47.2c13.2 9.6 29.4 15.2 47 15.2c26.2 0 49.4-12.6 64-32c13.4 10 30 16 48 16c44.2 0 80-35.8 80-80c0-20.4-7.6-39-20.1-53.1C393.6 316.6 408 292 408 264zM248 144a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM72 312a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm8 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm80 8a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm152-56a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM184 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm144-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fasr',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      'M464 80H48v48H80 432h32V80zm16 96H464 432 80 48 32 0V128 80 32H48 464h48V80v48 48H480zM160 224h24H328h24v48H328 184 160V224zm272-16h48V432v48H432 80 32V432 208H80V432H432V208z'
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faFaceSmileHorns = {
    prefix: 'fasr',
    iconName: 'face-smile-horns',
    icon: [
      640,
      512,
      [],
      'e391',
      
      'M171.3 47.6C213.2 17.6 264.6 0 320 0s106.8 17.6 148.7 47.6C582.9 42.8 640 0 640 0c0 80.1-55.6 160.1-74.1 184.5c6.6 22.7 10.1 46.7 10.1 71.5c0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.8 3.5-48.8 10.1-71.5C55.6 160.1 0 80.1 0 0C0 0 57.1 42.8 171.3 47.6zM320 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM272.4 256c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2-15.2-5.1 10.1-30.4 15.2 5.1 96 32 15.2 5.1-10.1 30.4-15.2-5.1-10.9-3.6c.2 1.5 .3 2.9 .3 4.4zm128 32c-17.7 0-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9-15.2 5.1-10.1-30.4 15.2-5.1 96-32 15.2-5.1 10.1 30.4-15.2 5.1-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32zM188 349.3L228 322.7C240 340.8 275.9 368 320 368s80-27.2 92-45.3L452 349.3C432 379.2 381.9 416 320 416s-112-36.8-132-66.7z'
      
    ]
  };

  

  
  

  var faToggleOff = {
    prefix: 'fasr',
    iconName: 'toggle-off',
    icon: [
      576,
      512,
      [],
      'f204',
      
      'M528 112V400H48V112H528zm48-48H528 48 0v48V400v48H48 528h48V400 112 64zM96 160V352H288V160H96z'
      
    ]
  };

  

  
  

  var faDialOff = {
    prefix: 'fasr',
    iconName: 'dial-off',
    icon: [
      576,
      512,
      [],
      'e162',
      
      'M320 0H256V64h64V0zM128 64H64v64h64V64zm384 0H448v64h64V64zm0 192v64h64V256H512zm0 192H448v64h64V448zM64 448v64h64V448H64zM0 256v64H64V256H0zm264 32V397.4c-50.3-11-88-55.8-88-109.4c0-61.9 50.1-112 112-112s112 50.1 112 112c0 53.6-37.7 98.4-88 109.4V288 264H264v24zm24 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faFaceAwesome = {
    prefix: 'fasr',
    iconName: 'face-awesome',
    icon: [
      512,
      512,
      ["gave-dandy"],
      'e409',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-32V200c0-2-.1-3.9-.4-5.8c-4.2 3.6-9.6 5.8-15.6 5.8c-13.3 0-24-10.7-24-24c0-6 2.2-11.4 5.8-15.6c-1.9-.3-3.8-.4-5.8-.4c-22.1 0-40 17.9-40 40v24h80zm-40-96c39.8 0 72 32.2 72 72v24 32H192 112 80V224 200c0-39.8 32.2-72 72-72zm216 72c-13.3 0-24-10.7-24-24c0-5.4 1.8-10.3 4.7-14.3c-4.1-1.1-8.3-1.7-12.7-1.7c-26.5 0-48 21.5-48 48v16h96V208c0-4.4-.6-8.7-1.7-12.7c-4 3-8.9 4.7-14.3 4.7zm-32-72c44.2 0 80 35.8 80 80v16 32H384 288 256V224 208c0-44.2 35.8-80 80-80zM100.2 307L96 288h20.3 12.5H383.2h12.5H416l-4.2 19-.1 .4-.1 .3c-3.9 17.4-10.6 33.6-19.5 48.2l-.1-.1c-28.2 45.9-78.6 75.7-134.9 76.1l-1.1 0c-29.6 0-57.6-8.1-81.7-22.5c-36.6-21.8-64.1-57.9-73.9-101.6l-.2-.9zm263.9 33.1c-8.1-2.7-16.8-4.1-25.8-4.1c-39.2 0-71.9 27.3-80.2 64c44.1-.7 83.6-24 106.1-59.8z'
      
    ]
  };

  
    var faGaveDandy = faFaceAwesome;
  

  
  

  var faSquareV = {
    prefix: 'fasr',
    iconName: 'square-v',
    icon: [
      448,
      512,
      [],
      'e284',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zM351.9 136L246 377.6 239.7 392H208.3L202 377.6 96.1 136h52.4L224 308.2 299.5 136h52.4z'
      
    ]
  };

  

  
  

  var faDrumstick = {
    prefix: 'fasr',
    iconName: 'drumstick',
    icon: [
      512,
      512,
      [127831],
      'f6d6',
      
      'M233.5 352l-58.4 58.3C185.6 421.1 192 435.8 192 452c0 33.1-26.9 60-60 60s-60-26.9-60-60V440H60c-33.1 0-60-26.9-60-60s26.9-60 60-60c16.2 0 30.9 6.4 41.6 16.8L160 278.5V256 232 176C160 78.8 238.8 0 336 0s176 78.8 176 176s-78.8 176-176 176H280 256 233.5zM256 304h80c70.7 0 128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128v80 14.1L241.9 304H256z'
      
    ]
  };

  

  
  

  var faBroomBall = {
    prefix: 'fasr',
    iconName: 'broom-ball',
    icon: [
      576,
      512,
      ["quidditch","quidditch-broom-ball"],
      'f458',
      
      'M544 0L336 208l-34.1-34.1-1.1-1.1L288 160H256l-21.6 75.5-.6-.1c-46.4-7.1-93.5 8.3-126.7 41.5c-16.7 16.7-29 37.1-36.1 59.2c-1.9 6-3.5 12.2-4.6 18.4c-1.6 8.7-2.4 17.6-2.4 26.6V384H96L64 416 48 432 16 464 0 480v32H32h3.9H48l146.9 0c39.1 0 76.6-15.5 104.2-43.2c33.2-33.2 48.6-80.2 41.5-126.7l-.1-.6L416 320V288l-12.8-12.8-1.1-1.1L368 240 576 32 544 0zM278.8 254.8l8-28.1 62.4 62.4-28.1 8-42.3-42.3zm-42.5 29.5l55.4 55.4 1.5 9.8c4.8 31.3-5.6 63-28 85.4c-18.6 18.6-43.9 29.1-70.3 29.1L83.9 464l46.1-46.1L211.9 336H122.8c4.7-9.2 10.9-17.8 18.3-25.2c22.4-22.4 54.1-32.8 85.4-28l9.8 1.5zM464 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faQuidditch = faBroomBall;
  
    var faQuidditchBroomBall = faBroomBall;
  

  
  

  var faUp = {
    prefix: 'fasr',
    iconName: 'up',
    icon: [
      384,
      512,
      ["arrow-alt-up"],
      'f357',
      
      'M160 240v48V432h64V288 240h48 60.1L192 99.9 51.9 240H112h48zM48 288H0V240 224L158.1 65.9 192 32l33.9 33.9L384 224v16 48H336 320 272v48 96 48H224 160 112V432 336 288H64 48z'
      
    ]
  };

  
    var faArrowAltUp = faUp;
  

  
  

  var faFence = {
    prefix: 'fasr',
    iconName: 'fence',
    icon: [
      512,
      512,
      [],
      'e303',
      
      'M48 115.9l16-16 16 16V432H48V115.9zM30.1 65.9L0 96V432v48H48 80h48V432 400h64v32 48h48 32 48V432 400h64v32 48h48 32 48V432 96L481.9 65.9 448 32 414.1 65.9 384 96v64H320V96L289.9 65.9 256 32 222.1 65.9 192 96v64H128V96L97.9 65.9 64 32 30.1 65.9zM384 352H320V208h64V352zm-192 0H128V208h64V352zm48-236.1l16-16 16 16V432H240V115.9zM432 432V115.9l16-16 16 16V432H432z'
      
    ]
  };

  

  
  

  var faBlindsOpen = {
    prefix: 'fasr',
    iconName: 'blinds-open',
    icon: [
      512,
      512,
      [],
      'f8fc',
      
      'M24 0H0V48H24 144V160v48 36.1C116 254 96 280.7 96 312c0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.3-20-58-48-67.9V208 160 48H488h24V0H488 24zM144 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM0 464v48H24 488h24V464H488 24 0zM64.3 320H24 0v48H24 80.3c-9-14.1-14.7-30.4-16-48zm191.3 48H488h24V320H488 271.7c-1.3 17.6-7 33.9-16 48zM24 160H0v48H24h88V160H24zm200 48H488h24V160H488 224v48z'
      
    ]
  };

  

  
  

  var faWebhook = {
    prefix: 'fasr',
    iconName: 'webhook',
    icon: [
      576,
      512,
      [],
      'e5d5',
      
      'M208 128c0-44.2 35.8-80 80-80s80 35.8 80 80c0 10.7-2.1 20.8-5.8 30l44.5 18c6-14.9 9.3-31.1 9.3-48.1C416 57.3 358.7 0 288 0S160 57.3 160 128c0 37.1 15.8 70.5 41 93.9L129.7 336c-.6 0-1.1 0-1.7 0c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l82.8-132.5 12.7-20.3-20.3-12.7C223 181.7 208 156.6 208 128zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm42.4 38.5c3.6-6.7 5.6-14.4 5.6-22.5c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c.6 0 1.1 0 1.7 0l82.8 132.5 12.7 20.4 20.4-12.8c12.3-7.7 26.8-12.1 42.4-12.1c44.2 0 80 35.8 80 80s-35.8 80-80 80c-22.2 0-42.2-9-56.8-23.6l-34.1 33.8C380.3 497.5 412.5 512 448 512c70.7 0 128-57.3 128-128s-57.3-128-128-128c-16.3 0-31.9 3.1-46.3 8.6L330.4 150.5zM112 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm320 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48c26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.8 0-33.3 9.7-41.6 24H232 208v24c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-39.7 28.9-72.7 66.8-78.9L107 257.7C46.3 267.7 0 320.4 0 384c0 70.7 57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H406.4c8.3 14.3 23.8 24 41.6 24z'
      
    ]
  };

  

  
  

  var faScrollTorah = {
    prefix: 'fasr',
    iconName: 'scroll-torah',
    icon: [
      640,
      512,
      ["torah"],
      'f6a0',
      
      'M48 48V464h64V416 96 48H48zM160 464v48H112 48 0V464 48 0H48h64 48V48H480V0h48 64 48V48 464v48H592 528 480V464H160zm320-48V96H160V416H480zm48 48h64V48H528V96 416v48zM187.1 332l10.5-18 33.8-58-33.8-58-10.5-18H208h67.8l33.9-58L320 104.2l10.4 17.8 33.9 58H432h20.9l-10.5 18-33.8 58 33.8 58 10.5 18H432 364.2l-33.9 58L320 407.8 309.6 390l-33.9-58H208 187.1zM320 360.2L336.4 332H303.6L320 360.2zM289.6 308h60.9l30.3-52-30.3-52H289.6l-30.3 52 30.3 52zm105.1-28.2L378.2 308h32.9l-16.4-28.2zM411.1 204H378.2l16.4 28.2L411.1 204zM320 151.8L303.6 180h32.9L320 151.8zm-74.7 80.4L261.8 204H228.9l16.4 28.2zM261.8 308l-16.4-28.2L228.9 308h32.9z'
      
    ]
  };

  
    var faTorah = faScrollTorah;
  

  
  

  var faDownRight = {
    prefix: 'fasr',
    iconName: 'down-right',
    icon: [
      384,
      512,
      [],
      'e16b',
      
      'M248 267.9l-33.9-33.9L112 131.9 67.9 176 169.9 278.1 203.9 312l-33.9 33.9L131.9 384H320V195.9l-38.1 38.1L248 267.9zm38.1-105.9L320 128l33.9 33.9L368 176V384v48H320 112L97.9 417.9 64 384l33.9-33.9 4.1-4.1L136 312l-33.9-33.9L33.9 209.9 0 176l33.9-33.9L78.1 97.9 112 64l33.9 33.9 68.1 68.1L248 200l33.9-33.9 4.1-4.1z'
      
    ]
  };

  

  
  

  var faPersonArrowUpFromLine = {
    prefix: 'fasr',
    iconName: 'person-arrow-up-from-line',
    icon: [
      640,
      512,
      [],
      'e539',
      
      'M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32H126.8l-6.9 12.4-75.3 136L33 297.4l42 23.3 11.6-21L128 224.9V464H24 0v48H24 616h24V464H616 256V224.9l41.4 74.8 11.6 21 42-23.3-11.6-21-75.3-136L257.2 128H243.1 140.9zM208 464H176V352h32V464zm0-160H176V176h32V304zM512.1 38.2L496 23.6 479.9 38.2l-88 80 32.3 35.5L472 110.3 472 392v24h48V392 110.3l47.9 43.5 32.3-35.5-88-80z'
      
    ]
  };

  

  
  

  var faBowlingPins = {
    prefix: 'fasr',
    iconName: 'bowling-pins',
    icon: [
      512,
      512,
      [],
      'f437',
      
      'M64 176L14.7 367.9 55.9 512H200.1l41.2-144.1L192 176c1.6-7.1 3.3-13.6 4.8-19.9l0 0C202.9 131.2 208 110.8 208 82V80c0-44.2-35.8-80-80-80S48 35.8 48 80v2c0 28.9 5.1 49.3 11.2 74.1c1.6 6.3 3.2 12.9 4.8 19.9zM191.6 367.2L163.9 464H92.1L64.4 367.2 105.3 208h45.3l40.9 159.2zm-40.8-225c-1.3 5.4-2.7 11.2-4.3 17.7H109.6c-1.5-6.5-3-12.4-4.3-17.7C99.5 118.7 96 104.6 96 82V80c0-17.7 14.3-32 32-32s32 14.3 32 32v2c0 22.6-3.5 36.8-9.3 60.3l0 0zM320 176L270.7 367.9 311.9 512H456.1l41.2-144.1L448 176c1.6-7.1 3.3-13.6 4.8-19.9l0 0C458.9 131.2 464 110.8 464 82V80c0-44.2-35.8-80-80-80s-80 35.8-80 80v2c0 28.9 5.1 49.3 11.2 74.1c1.6 6.3 3.2 12.9 4.8 19.9zM447.6 367.2L419.9 464H348.1l-27.6-96.8L361.3 208h45.3l40.9 159.2zm-40.8-225c-1.3 5.4-2.7 11.2-4.3 17.7H365.6c-1.5-6.5-3-12.4-4.3-17.7c-5.8-23.6-9.3-37.7-9.3-60.3V80c0-17.7 14.3-32 32-32s32 14.3 32 32v2c0 22.6-3.5 36.8-9.3 60.3z'
      
    ]
  };

  

  
  

  var faPencilSlash = {
    prefix: 'fasr',
    iconName: 'pencil-slash',
    icon: [
      640,
      512,
      [],
      'e215',
      
      'M64 512l51-10.2L224 480l19.2-19.2 .8 .5 2.6-3.8 93.5-93.5-38-29.9-42.2 42.2-48.1-12-12-48.1L234.8 281l-38-29.9-78.3 78.3-3.8 2.6 .5 .8L96 352 74.2 461 64 512zM409.1 294.9L542.1 161.9 576 128 542.1 94.1 481.9 33.9 448 0 414.1 33.9 265 183 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L409.1 294.9zm-38.2-29.7l-67.7-52.5 82.7-82.7 60.1 60.1-75.1 75.1zM140.2 375.7l8.9-8.9 11.9-7.9 7.7 31 3.5 14 14 3.5 31 7.7-7.9 11.9-8.9 8.9-75.1 15 15-75.1z'
      
    ]
  };

  

  
  

  var faUserNinja = {
    prefix: 'fasr',
    iconName: 'user-ninja',
    icon: [
      448,
      512,
      [129399],
      'f504',
      
      'M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0c-49.6 0-92.6 28.2-113.8 69.4c-3-5.8-6.8-11.3-11.7-16.1c-25-25-67.9-22.6-67.9-22.6s-2.4 42.9 22.6 67.9c5.8 5.8 12.6 10.1 19.6 13.4c-7 3.2-13.8 7.6-19.6 13.4c-25 25-22.6 67.9-22.6 67.9s42.9 2.4 67.9-22.6c1.2-1.2 2.4-2.5 3.5-3.8c16.4 51.8 64.8 89.3 122 89.3zM160 96H288h16v32H288 160 144V96h16zm97.3 322.6l.6-.6L323.9 352h24.7L383 464H302.7l-45.4-45.4zM292.8 512h105H448l-14.8-48L384 304H304l-46.1 46.1L224 384l-33.9-33.9L144 304H64L14.8 464 0 512H50.2 292.8zm-57.9-48H65L99.5 352h23.4l112 112z'
      
    ]
  };

  

  
  

  var fa7 = {
    prefix: 'fasr',
    iconName: '7',
    icon: [
      320,
      512,
      [],
      '37',
      
      'M320 32H296 24 0V80H24 253.6L13.6 480h56l247-411.7 3.4-5.7V32z'
      
    ]
  };

  

  
  

  var faBlog = {
    prefix: 'fasr',
    iconName: 'blog',
    icon: [
      512,
      512,
      [],
      'f781',
      
      'M512 320C512 143.3 368.7 0 192 0V48c150.2 0 272 121.8 272 272h48zm-96 0C416 196.3 315.7 96 192 96v48c97.2 0 176 78.8 176 176h48zM48 120V96H0v24V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144h-8H112v48h24 8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96V120z'
      
    ]
  };

  

  
  

  var faCircle9 = {
    prefix: 'fasr',
    iconName: 'circle-9',
    icon: [
      512,
      512,
      [],
      'e0f6',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-80a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm96 48c0 31.7-11.9 62.3-33.3 85.7L250.6 384H185.4l14.9-16.2 44.4-48.4C197 313.8 160 273.2 160 224c0-53 43-96 96-96s96 43 96 96z'
      
    ]
  };

  

  
  

  var faSheetPlastic = {
    prefix: 'fasr',
    iconName: 'sheet-plastic',
    icon: [
      384,
      512,
      [],
      'e571',
      
      'M48 48V464H224V352H336V48H48zM256 512H48 0V464 48 0H48 336h48V48 384L256 512zM203.3 107.3l-96 96L96 214.6 73.4 192l11.3-11.3 96-96L192 73.4 214.6 96l-11.3 11.3zm96 32l-160 160L128 310.6 105.4 288l11.3-11.3 160-160L288 105.4 310.6 128l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faFaceUnamused = {
    prefix: 'fasr',
    iconName: 'face-unamused',
    icon: [
      512,
      512,
      [],
      'e39f',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 392.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4l-16.4 17.5-35.1-32.7 16.4-17.5C196.7 344.3 221.4 328 256 328s59.3 16.3 73.5 31.6l16.4 17.5-35.1 32.7-16.4-17.5zM208 224c0 17.7-14.3 32-32 32s-32-14.3-32-32H112 96V192h16 64c17.7 0 32 14.3 32 32zm192 0c0 17.7-14.3 32-32 32s-32-14.3-32-32H304 288V192h16 64c17.7 0 32 14.3 32 32z'
      
    ]
  };

  

  
  

  var faMessageArrowDown = {
    prefix: 'fasr',
    iconName: 'message-arrow-down',
    icon: [
      512,
      512,
      ["comment-alt-arrow-down"],
      'e1db',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM280 120V96H232v24V238.1l-31-31-17-17L150.1 224l17 17 72 72 17 17 17-17 72-72 17-17L328 190.1l-17 17-31 31V120z'
      
    ]
  };

  
    var faCommentAltArrowDown = faMessageArrowDown;
  

  
  

  var faGolfFlagHole = {
    prefix: 'fasr',
    iconName: 'golf-flag-hole',
    icon: [
      512,
      512,
      [],
      'e3ac',
      
      'M161.4 17.9L128 3.8V40 160v56 8 28.2 34.9 49.8V384c0 .7 0 1.5 .1 2.2c-.1 .6-.1 1.2-.1 1.8c0 19.9 35.8 36 80 36s80-16.1 80-36s-35.8-36-80-36c-11.4 0-22.2 1.1-32 3V326.2c24.6-3.9 51.5-6.2 80-6.2c61.7 0 116.4 10.4 154.9 26.3c19.3 8 33.3 16.9 42.1 25.5c8.7 8.6 11 15.4 11 20.2s-2.3 11.7-11 20.2c-8.8 8.6-22.8 17.5-42.1 25.5C372.4 453.6 317.7 464 256 464s-116.4-10.4-154.9-26.3c-19.3-8-33.3-16.9-42.1-25.5c-8.7-8.6-11-15.4-11-20.2s2.3-11.7 11-20.2c8-7.9 20.3-15.9 37-23.3V296.8c-4.5 1.6-9 3.3-13.2 5.1c-22.7 9.4-42.7 21.2-57.3 35.5C10.7 351.9 0 370.3 0 392s10.7 40.1 25.4 54.5c14.7 14.3 34.6 26.1 57.3 35.5C128.3 500.9 189.6 512 256 512s127.7-11.1 173.2-29.9c22.7-9.4 42.7-21.2 57.3-35.5C501.3 432.1 512 413.7 512 392s-10.7-40.1-25.4-54.5c-14.6-14.3-34.6-26.1-57.3-35.5C383.7 283.1 322.4 272 256 272c-27.8 0-54.8 1.9-80 5.6V231.9l193.4-81.8L421.6 128l-52.2-22.1-208-88zM176 179.8V76.2L298.4 128 176 179.8z'
      
    ]
  };

  

  
  

  var faBookBlank = {
    prefix: 'fasr',
    iconName: 'book-blank',
    icon: [
      448,
      512,
      [128213,128215,128216,128217,"book-alt"],
      'f5d9',
      
      'M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H424h24V464H424h-8V400h8 24V376 24 0H424 88zM368 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H368zM80 352c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H400V352H80z'
      
    ]
  };

  
    var faBookAlt = faBookBlank;
  

  
  

  var faVialVirus = {
    prefix: 'fasr',
    iconName: 'vial-virus',
    icon: [
      512,
      512,
      [],
      'e597',
      
      'M32 32H0V48 64 80H32V384c0 53 43 96 96 96c22.6 0 43.3-7.8 59.7-20.8l-11-11 39.6-39.6 .6-.6H216 169.6c-8.3 14.3-23.8 24-41.6 24c-26.5 0-48-21.5-48-48V240h96v16l16-16 .2 .3L224 208.5V80h32V64 48 32H224 176 80 32zM80 192V80h96V192H80zM216 376c28.8 0 43.2 34.8 22.9 55.2l-17 17 17 17 17 17 17-17c20.4-20.4 55.2-5.9 55.2 22.9l0 .2V512h24 24V488v-.2c.1-28.7 34.9-43 55.2-22.7l17 17 17-17 17-17-17-17C444.8 410.8 459.2 376 488 376l0 0h24V352 328H488h-.1c-28.8 0-43.2-34.8-22.8-55.2l17-17-17-17-17-17-17 17c-20.3 20.3-55.1 6-55.2-22.7V216 192H352 328v23.9l0 .1c0 28.8-34.8 43.2-55.2 22.9l-17-17-17 17-17 17 17 17c20.4 20.4 6 55.2-22.8 55.2H216 192v24 24h24l0 0zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faCloudXmark = {
    prefix: 'fasr',
    iconName: 'cloud-xmark',
    icon: [
      640,
      512,
      [],
      'e35f',
      
      'M0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c47.9 0 90.8 21 120.1 54.3C388.7 82.2 402.1 80 416 80c70.7 0 128 57.3 128 128v20c55.2 14.2 96 64.3 96 124v80 48H592 512 144 48 0V432 336zm592 16c0-37.2-25.4-68.6-60-77.5l-36-9.3V228 208c0-44.2-35.8-80-80-80c-8.8 0-17.1 1.4-24.9 3.9L361 141.8 340.1 118C319.5 94.6 289.5 80 256 80c-61.9 0-112 50.1-112 112v8.2 33.9l-32 11.3C74.6 258.7 48 294.3 48 336v96h96H512h80V352zM417.9 224l-17 17-47 47 47 47 17 17L384 385.9l-17-17-47-47-47 47-17 17L222.1 352l17-17 47-47-47-47-17-17L256 190.1l17 17 47 47 47-47 17-17L417.9 224z'
      
    ]
  };

  

  
  

  var faUserCheck = {
    prefix: 'fasr',
    iconName: 'user-check',
    icon: [
      640,
      512,
      [],
      'f4fc',
      
      'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM99.5 352H348.5L383 464H65L99.5 352zM384 304H64L14.8 464 0 512H50.2 397.8 448l-14.8-48L384 304zM617 177l17-17L600 126.1l-17 17-111 111-47-47-17-17L374.1 224l17 17 64 64 17 17 17-17L617 177z'
      
    ]
  };

  

  
  

  var faArrowDownToSquare = {
    prefix: 'fasr',
    iconName: 'arrow-down-to-square',
    icon: [
      512,
      512,
      [],
      'e096',
      
      'M272.7 353.2l112-108.8 17.2-16.7-33.4-34.4L351.3 210 280 279.2V19.2v-24H232v24 260L160.7 210l-17.2-16.7-33.4 34.4 17.2 16.7 112 108.8L256 369.5l16.7-16.2zM24 32H0V56 488v24H24 488h24V488 56 32H488 392 368V80h24 72V464H48V80h72 24V32H120 24z'
      
    ]
  };

  

  
  

  var faNote = {
    prefix: 'fasr',
    iconName: 'note',
    icon: [
      448,
      512,
      [],
      'e1ff',
      
      'M400 80V320H288V432H48V80H400zM48 480H288h32L448 352V320 80 32H400 48 0V80 432v48H48zm80-352H80v48h48V128zM80 232v48h48V232H80zm48 104H80v48h48V336z'
      
    ]
  };

  

  
  

  var faTruckRampBox = {
    prefix: 'fasr',
    iconName: 'truck-ramp-box',
    icon: [
      640,
      512,
      ["truck-loading"],
      'f4de',
      
      'M352 0h24H616h24V48H616 400V360.3l26-6.7 0 0c17.6-38.7 56.7-65.6 102-65.6c61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.9 0-108.9-47.1-111.9-106.3L38 503.2l-23.2 6-12-46.5 23.2-6 326-84.1V24 0zM592 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM14.8 176.8l77.3-20.7 24.8 92.7 61.8-16.6-24.8-92.7 77.3-20.7 58 216.4-216.4 58-58-216.4z'
      
    ]
  };

  
    var faTruckLoading = faTruckRampBox;
  

  
  

  var faBlueberries = {
    prefix: 'fasr',
    iconName: 'blueberries',
    icon: [
      512,
      512,
      [],
      'e2e8',
      
      'M512 176C512 78.8 433.2 0 336 0C255.4 0 187.4 54.2 166.6 128.2c3.1-.1 6.3-.2 9.4-.2c114.9 0 208 93.1 208 208c0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM384 64V96h32 16v32H416 384v32 16H352V160 128H320 304V96h16 32V64 48h32V64zM176 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-256V240H144v16 32H112 96v32h16 32v32 16h32V352 320h32 16V288H208 176V256z'
      
    ]
  };

  

  
  

  var faPenField = {
    prefix: 'fasr',
    iconName: 'pen-field',
    icon: [
      640,
      512,
      [],
      'e211',
      
      'M458 137.9L502.1 182 393.7 290.4l-50.4 6.3 6.3-50.4L458 137.9zM553 199l17-17 36.1-36.1L640 112 606.1 78.1 561.9 33.9 528 0 494.1 33.9 458 70 441 87l-17 17L304 224l-9.9 78.9L288 352l49.1-6.1L416 336 536 216l17-17zm-17-50.9L491.9 104 528 67.9 572.1 112 536 148.1zM24 128H0v24V488v24H24 552h24V488 312 288H528v24V464H48V176H264h24V128H264 24zM160 288H96v64h64V288zm32 0v64h64V288H192z'
      
    ]
  };

  

  
  

  var faClipboardList = {
    prefix: 'fasr',
    iconName: 'clipboard-list',
    icon: [
      384,
      512,
      [],
      'f46d',
      
      'M336 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H80 48 0v48V464v48H48 336h48V464 112 64H336zM80 112v48H192 304V112h32V464H48V112H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-136H160v32h16 96 16V256H272 176zm0 96H160v32h16 96 16V352H272 176zm-64-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPumpkin = {
    prefix: 'fasr',
    iconName: 'pumpkin',
    icon: [
      576,
      512,
      [],
      'f707',
      
      'M352 118.1V32L288 0 230.3 115.3c-27.7 11.4-51.4 30.7-68 55.1l39.7 27C220.8 170 252.3 152 288 152s67.2 18 86 45.5l39.7-27c-15.4-22.5-36.7-40.7-61.7-52.4zM141.3 144.9c12.8-16.9 28.5-31.5 46.4-43.2C176.4 98 164.4 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6c45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-12.4 0-24.4 2-35.8 5.7c17.9 11.6 33.6 26.3 46.4 43.2c21.7 3.5 42.9 17.9 60.1 42.7c20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4C474.7 449.3 449.3 464 424 464c-18 0-35.8-7.4-51.9-21.9L356 427.6l-16.1 14.5C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9L220 427.6l-16.1 14.5C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4c17.3-24.8 38.5-39.2 60.2-42.7z'
      
    ]
  };

  

  
  

  var faCodePullRequest = {
    prefix: 'fasr',
    iconName: 'code-pull-request',
    icon: [
      512,
      512,
      [],
      'e13c',
      
      'M112 48H48v64h64V48zM48 0h64 48V48v64 48H112h-8V352h8 48v48 64 48H112 48 0V464 400 352H48h8V160H48 0V112 48 0H48zm0 400v64h64V400H48zm352 0v64h64V400H400zm-48-48h48 8V192c0-39.8-32.2-72-72-72H320v72H288L192 96 288 0h32V72h16c66.3 0 120 53.7 120 120V352h8 48v48 64 48H464 400 352V464 400 352z'
      
    ]
  };

  

  
  

  var faDesktopArrowDown = {
    prefix: 'fasr',
    iconName: 'desktop-arrow-down',
    icon: [
      576,
      512,
      [],
      'e155',
      
      'M48 0H224V48H48V256H528V48H352V0H528h48V48 256v48 64 48H528 364.3l8 48H424h24v48H424 352 224 152 128V464h24 51.7l8-48H48 0V368 304 256 48 0H48zm0 304v64H528V304H48zM252.3 464h71.3l-8-48H260.3l-8 48zM312 24V134.1l39-39 17-17L401.9 112l-17 17-80 80-17 17-17-17-80-80-17-17L208 78.1l17 17 39 39V24 0h48V24z'
      
    ]
  };

  

  
  

  var faPaste = {
    prefix: 'fasr',
    iconName: 'paste',
    icon: [
      512,
      512,
      ["file-clipboard"],
      'f0ea',
      
      'M80 96v48h80V128 96h32 64 16 48V48H272 215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48H48 0V96 400v48H48 160V400H48V96H80zm64-40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM464 464H240V176H396.1L464 243.9V464zm48-240l-96-96H240 192v48V464v48h48H464h48V464 224z'
      
    ]
  };

  
    var faFileClipboard = faPaste;
  

  
  

  var faComments = {
    prefix: 'fasr',
    iconName: 'comments',
    icon: [
      640,
      512,
      [61670,128490],
      'f086',
      
      'M85.7 298.9l11-27.4L77.2 249.4C58.2 227.8 48 202.5 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.5 0-26.6-1.3-39-3.9l-10.2-2.1-10.1 2.3-70 16.2 7.1-17.6zM0 384l57-13.1 102.6-23.7c15.6 3.1 31.8 4.8 48.5 4.8c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 39.4 15.3 75.8 41.2 105.1L21.7 329.7 0 384zm432 96c16.7 0 32.9-1.7 48.5-4.8L583 498.9 640 512l-21.7-54.3-19.4-48.6C624.7 379.8 640 343.4 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 26.5-10.2 51.8-29.2 73.4l-19.5 22.2 11 27.4 7.1 17.6-70.1-16.2-10.1-2.3L471 428.1c-12.4 2.5-25.5 3.9-39 3.9c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z'
      
    ]
  };

  

  
  

  var faCaretRight = {
    prefix: 'fasr',
    iconName: 'caret-right',
    icon: [
      256,
      512,
      [],
      'f0da',
      
      'M64 144l0-48 48 0L256 256 112 416l-48 0 0-48 0-224zm48 200.2L191.4 256 112 167.8l0 176.5z'
      
    ]
  };

  

  
  

  var faBackward = {
    prefix: 'fasr',
    iconName: 'backward',
    icon: [
      512,
      512,
      [9194],
      'f04a',
      
      'M43.3 284.8L0 256l43.3-28.8L240 96l48-32v57.7 76.7L464 92.8 512 64v56V392v56l-48-28.8L288 313.6v76.7V448l-48-32L43.3 284.8zM288 257.6L464 363.2V148.8L288 254.4v3.2zM240 358.3V153.7L86.5 256 240 358.3z'
      
    ]
  };

  

  
  

  var faPencil = {
    prefix: 'fasr',
    iconName: 'pencil',
    icon: [
      512,
      512,
      [9999,61504,"pencil-alt"],
      'f303',
      
      'M0 512l10.2-51L32 352l19.2-19.2-.5-.8 3.8-2.6L350.1 33.9 384 0l33.9 33.9 60.1 60.1L512 128l-33.9 33.9L182.5 457.5l-2.6 3.8-.8-.5L160 480 51 501.8 0 512zM76.2 375.7l-15 75.1 75.1-15 8.9-8.9 7.9-11.9-31-7.7-14-3.5-3.5-14-7.7-31-11.9 7.9-8.9 8.9zM382.1 190.1l-60.1-60.1L135.8 316.1l12 48.1 48.1 12L382.1 190.1zm-66.7 28.7l-96 96L208 326.1l-22.6-22.6 11.3-11.3 96-96L304 184.8l22.6 22.6-11.3 11.3z'
      
    ]
  };

  
    var faPencilAlt = faPencil;
  

  
  

  var faLips = {
    prefix: 'fasr',
    iconName: 'lips',
    icon: [
      576,
      512,
      [128068,128482],
      'f600',
      
      'M192 64l96 48 96-48L576 224s-80 224-240 224H240C80 448 0 224 0 224L192 64zm117.5 90.9c-13.5 6.8-29.4 6.8-42.9 0l-67.9-34L58.2 238l.2 .4c9.2 19.3 22.8 44.7 40.7 69.7C136.4 360.4 183.9 400 240 400h96c56.1 0 103.6-39.6 140.9-91.9c17.9-25.1 31.5-50.5 40.7-69.7l.2-.4L377.4 121l-67.9 34zM96 236l123.4-28s41.3 14 68.6 14s68.6-14 68.6-14L480 236s-68.6 84-192 84s-192-84-192-84z'
      
    ]
  };

  

  
  

  var faLandmarkFlag = {
    prefix: 'fasr',
    iconName: 'landmark-flag',
    icon: [
      512,
      512,
      [],
      'e51c',
      
      'M272 0H240V128H48 24v48H48 464h24V128H464 272V96h96V0H272zM112 208H64V384H56 32v48H56 456h24V384H456h-8V208H400V384H336V208H288V384H224V208H176V384H112V208zM0 464v48H24 488h24V464H488 24 0z'
      
    ]
  };

  

  
  

  var faRam = {
    prefix: 'fasr',
    iconName: 'ram',
    icon: [
      640,
      512,
      [128015],
      'f70a',
      
      'M336 64v8V96h48V72 64c0-8.8 7.2-16 16-16s16 7.2 16 16V96l-10.3 10.3-55.2 23.6-22.1 9.5 18.9 44.1 22.1-9.5 14.5-6.2V320H576V167.8l14.5 6.2 22.1 9.5 18.9-44.1-22.1-9.5-55.1-23.6L544 96V64c0-8.8 7.2-16 16-16s16 7.2 16 16v8V96h48V72 64c0-35.3-28.7-64-64-64s-64 28.7-64 64H464c0-35.3-28.7-64-64-64s-64 28.7-64 64zM304 85.7c-7.7-8.7-17.8-15.4-29.2-18.9C268.8 65 262.5 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0L120 512h88V426.3c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V512h88l22.5-120c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40h-109l-6.8 27.9c-1.7 7-8.1 12.1-15.5 12.1c-3.8 0-7.2-1.3-9.9-3.4L298.2 360l-30.2 34.5c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5L213.8 360l-35.9 28.5c-2.7 2.2-6.1 3.4-9.9 3.4c-7.5 0-13.8-5.1-15.5-12.1L142 337.1l-43.5 6.7c-.8 .1-1.6 .2-2.5 .2c-8.8 0-16-7.2-16-16c0-1.4 .2-2.7 .5-3.9l9-36.3-33-17.6C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2l33-17.6-9-36.3c-.3-1.2-.5-2.5-.5-3.9c0-8.8 7.2-16 16-16c.9 0 1.7 .1 2.5 .2l43.5 6.7 10.4-42.7c1.7-7 8.1-12.1 15.5-12.1c3.8 0 7.2 1.3 9.9 3.5L213.8 152l30.2-34.5c3-3.4 7.3-5.5 12.1-5.5c5.3 0 10 2.5 13 6.7l6.2 8.7L304 115.1V85.7zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faExcavator = {
    prefix: 'fasr',
    iconName: 'excavator',
    icon: [
      640,
      512,
      [],
      'e656',
      
      'M96 0h24H264h12.4l7.2 10.2 96 136 4.4 6.2V160v48 16 48 48H336 48 0V272 208 160H48 96V24 0zM251.6 48H144V160H330.6L251.6 48zM48 208v64H336V224 208H48zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zM0 432c0-44.2 35.8-80 80-80H336c44.2 0 80 35.8 80 80s-35.8 80-80 80H80c-44.2 0-80-35.8-80-80zm448 32L592 320V207.8 144l-48 42L416 298V234.2L560.4 107.9 592 80.2V49.7L416 202.2V138.7L576 0h16 48V38.2 48v96V320v16 48 48c0 44.2-35.8 80-80 80H448V464z'
      
    ]
  };

  

  
  

  var faEggplant = {
    prefix: 'fasr',
    iconName: 'eggplant',
    icon: [
      512,
      512,
      [],
      'e16c',
      
      'M511.4 34.6L480 65.9V224l-48-16-16-48-48-16L352 96 304 80 288 32H446.1L477.4 .6l33.9 33.9zM169.9 139.3C205.3 122.1 241 104.8 271 82.3l2.6 7.8 5.1 15.2 15.2 5.1 13.6 4.5c-15.9 12.7-32.7 23.4-49.3 32.9c-21.5 12.3-47 24.8-70.4 36.2l0 0c-13.9 6.8-27 13.2-38 18.9c-33.6 17.6-59 34.3-76.1 54.5c-15.7 18.5-26.2 42-25.6 77.9c1 70 59 128.7 128.5 128.7c59 .1 115.4-40.1 163.9-107c27.7-38.3 50.3-82 66.9-123.6l14.7 4.9 30.9 10.3C404.3 372 306.9 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z'
      
    ]
  };

  

  
  

  var faFolderGrid = {
    prefix: 'fasr',
    iconName: 'folder-grid',
    icon: [
      512,
      512,
      [],
      'e188',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm-96 96v96H80V240h96zm32 0h96v96H208V240zm224 0v96H336V240h96z'
      
    ]
  };

  

  
  

  var faGaugeMin = {
    prefix: 'fasr',
    iconName: 'gauge-min',
    icon: [
      512,
      512,
      ["tachometer-alt-slowest"],
      'f628',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 408c30.9 0 56-25.1 56-56s-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6L117.6 228.2 97.7 214.6 70.6 254.3l19.8 13.6 110.2 75.4c-.4 2.9-.7 5.8-.7 8.8c0 30.9 25.1 56 56 56zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM400 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faTachometerAltSlowest = faGaugeMin;
  

  
  

  var faDiagramPrevious = {
    prefix: 'fasr',
    iconName: 'diagram-previous',
    icon: [
      512,
      512,
      [],
      'e478',
      
      'M464 336L48 336l0 96 416 0V336zm48-48v48 96 48H464 48 0V432 336 288H48 232V201.9l-23 23-17 17L158.1 208l17-17 64-64 17-17 17 17 64 64 17 17L320 241.9l-17-17-23-23V288H464h48zM96.8 224L0 224V32l512 0V224H415.2l-39.6-39.6-80-80L256 64.8l-39.6 39.6-80 80L96.8 224z'
      
    ]
  };

  

  
  

  var faK = {
    prefix: 'fasr',
    iconName: 'k',
    icon: [
      320,
      512,
      [107],
      '4b',
      
      'M48 265.2L256.8 32h64.4l-5.4 6L156.3 216.2 319.9 480H263.4L122.9 253.5 48 337.2V456v24H0V456 328 56 32H48V56 265.2z'
      
    ]
  };

  

  
  

  var faPage = {
    prefix: 'fasr',
    iconName: 'page',
    icon: [
      384,
      512,
      [],
      'e428',
      
      'M48 464H336V131.9L252.1 48H48V464zM272 0L384 112V464v48H336 48 0V464 48 0H48 272z'
      
    ]
  };

  

  
  

  var faStrikethrough = {
    prefix: 'fasr',
    iconName: 'strikethrough',
    icon: [
      512,
      512,
      [],
      'f0cc',
      
      'M145.5 138c4-21.5 17.9-37.4 41.7-47.4c24.7-10.4 59.4-13.7 99.9-7.5c12.8 2 52.4 9.5 64.9 12.8l23.2 6.1 12.1-46.4L364 49.4c-14.7-3.8-56.1-11.7-69.7-13.8c-46.2-7.1-90.4-4.1-125.7 10.7c-36.1 15.1-63.3 43.1-70.5 83.9c-.1 .4-.1 .9-.2 1.3c-2.8 23.4 .5 44.2 9.8 62.2c9.2 17.8 23.2 31.2 38.8 41.5c2.4 1.6 5 3.2 7.5 4.7H24 0v48H24 488h24V240H488 295.8c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8c-10.9-7.2-18.2-14.9-22.6-23.5c-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3c-3.8 21.8-17.8 37.9-41.8 48c-24.7 10.4-59.4 13.7-99.8 7.5c-20.1-3.2-54.3-14.6-81.2-23.6l0 0 0 0c-5.9-2-11.4-3.8-16.3-5.4l-22.8-7.4L89.7 438l22.8 7.4c4 1.3 8.8 2.9 14 4.7c26.6 8.9 66.4 22.2 90.9 26.2l.1 0c46.2 7.1 90.4 4.1 125.7-10.7c36.1-15.1 63.3-43.1 70.5-83.9c4-22.9 2.4-43.5-5-61.7H351.6c5.7 5.3 9.7 11 12.3 17.1z'
      
    ]
  };

  

  
  

  var faTrees = {
    prefix: 'fasr',
    iconName: 'trees',
    icon: [
      640,
      512,
      [],
      'f724',
      
      'M352 168.7V160l-14.4-16L240.3 35.9 208 0 175.7 35.9 78.4 144 64 160v8.7V192H96L64 236l-2.9 4L43.6 264 32 280v15.7V312H80L43.1 360 12.3 400 0 416v32H48 184v40 24h48V488 448h40 96 40v40 24h48V488 448H592h48V416l-12.3-16-30.8-40L560 312h48V295.7 280l-11.6-16-17.5-24-2.9-4-32-44h32V168.7 160l-14.4-16L464.3 35.9 432 0 399.7 35.9l-58.2 64.7 32.3 35.9L432 71.8 497 144H480v41.6l25.2 34.6L537 264H496v43.5l26 33.7L567.1 400H456V216 192H408v24V400h-4.3l-30.8-40L336 312h48V295.7 280l-11.6-16-17.5-24-2.9-4-32-44h32V168.7zM72.9 400L118 341.3l26-33.7V264H103l31.8-43.8L160 185.6V144H143l65-72.2L273 144H256v41.6l25.2 34.6L313 264H272v43.5l26 33.7L343.1 400H296.9 236.3 232V216 192H184v24V400H72.9z'
      
    ]
  };

  

  
  

  var faHandLove = {
    prefix: 'fasr',
    iconName: 'hand-love',
    icon: [
      512,
      512,
      [],
      'e1a5',
      
      'M136 0H112V24 261.5l-7.5-7.5L76.2 225.7l-17-17-17 17L7 260.9l-7 7v9.9 42.7 9.9l7 7 6.9 6.9L106.5 437c48 48 113.1 75 181 75H296h24v-1.6c90.3-11.8 160-89 160-182.4c0-3.5-.1-6.9-.3-10.3c.2-1.9 .3-3.8 .3-5.7V88 64H456 376 352V88v88H320v-8V144H296 240V24 0H216 136zM400 344V256 216h0V112h32V312c0 .4 0 .9-.1 1.3l-.4 2.6 .2 2.7c.2 3.1 .3 6.3 .3 9.4c0 75.1-60.9 136-136 136l-8.8 0c-55-.1-107.8-22-146.7-60.9L48 310.6V287.8l11.2-11.2 11.3 11.3 40.8 40.8 17 17 17-17L153 321l7-7V304 48h32v96h0v24V344v24h24 56 24 24 56 24V344zM352 224v32 64H320V224h32zM240 320V216h0V192h32v8V320H240z'
      
    ]
  };

  

  
  

  var faFootballHelmet = {
    prefix: 'fasr',
    iconName: 'football-helmet',
    icon: [
      512,
      512,
      [],
      'f44f',
      
      'M305 249.9L256 256l17.3 46.2L280 320h41.7l-13.2-70.6-3.5 .4zm189.2-23.7L340.3 245.5l14 74.5H496h16v16 72 72 16H496 368 354.7l-2.4-13.1-13.5-72L327.7 352H292l7.7 20.5c2.9 7.6 4.3 15.7 4.3 23.8v1.3c0 36.7-29.7 66.4-66.4 66.4c-9 0-17.9-1.8-26.1-5.4L112 416H77.1C39.1 373.5 16 317.5 16 256C16 123.5 123.5 16 256 16c105.7 0 195.4 68.3 227.4 163.2c5 14.9 8.6 30.4 10.6 46.4l.1 .6zM100 368h12 9.9l9.1 3.9 99.5 42.6c2.3 1 4.8 1.5 7.2 1.5c10.1 0 18.4-8.2 18.4-18.4v-1.3c0-2.4-.4-4.7-1.3-6.9L211.1 272.9l-21.4-56.9 60.3-7.5 184.5-23.1C406.4 114.3 337.1 64 256 64C150 64 64 150 64 256c0 41.8 13.3 80.5 36 112zm260.3-16l7.5 40H480V352H360.3zM480 424H373.8l7.5 40H480V424zM176 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faGrid = {
    prefix: 'fasr',
    iconName: 'grid',
    icon: [
      448,
      512,
      ["grid-3"],
      'e195',
      
      'M88 72v48H40V72H88zM40 32H0V72v48 40H40 88h40V120 72 32H88 40zM88 232v48H40V232H88zM40 192H0v40 48 40H40 88h40V280 232 192H88 40zm0 200H88v48H40V392zM0 352v40 48 40H40 88h40V440 392 352H88 40 0zM248 72v48H200V72h48zM200 32H160V72v48 40h40 48 40V120 72 32H248 200zm0 200h48v48H200V232zm-40-40v40 48 40h40 48 40V280 232 192H248 200 160zm88 200v48H200V392h48zm-48-40H160v40 48 40h40 48 40V440 392 352H248 200zM360 72h48v48H360V72zM320 32V72v48 40h40 48 40V120 72 32H408 360 320zm88 200v48H360V232h48zm-48-40H320v40 48 40h40 48 40V280 232 192H408 360zm0 200h48v48H360V392zm-40-40v40 48 40h40 48 40V440 392 352H408 360 320z'
      
    ]
  };

  
    var faGrid3 = faGrid;
  

  
  

  var faPanFrying = {
    prefix: 'fasr',
    iconName: 'pan-frying',
    icon: [
      576,
      512,
      [127859],
      'e42c',
      
      'M400 224A176 176 0 1 0 48 224a176 176 0 1 0 352 0zM364.8 398.3C326.3 429.4 277.3 448 224 448C100.3 448 0 347.7 0 224S100.3 0 224 0S448 100.3 448 224c0 33.4-7.3 65.1-20.4 93.6l140.3 90.7L487.2 512 364.8 398.3zM504 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8zM272 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faAddressBook = {
    prefix: 'fasr',
    iconName: 'address-book',
    icon: [
      512,
      512,
      [62138,"contact-book"],
      'f2b9',
      
      'M400 48V464H80V48H400zM80 0H32V48 464v48H80 400h48V464 48 0H400 80zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM128 384H352l-32-96H160l-32 96zM512 80V64H480V80v64 16h32V144 80zm0 112H480v16 64 16h32V272 208 192zm0 144V320H480v16 64 16h32V400 336z'
      
    ]
  };

  
    var faContactBook = faAddressBook;
  

  
  

  var faCartMinus = {
    prefix: 'fasr',
    iconName: 'cart-minus',
    icon: [
      576,
      512,
      [],
      'e0db',
      
      'M0 0H24 96h19.9l3.7 19.5 42 220.5H462.2l63-208h50.2L503 271l-5.2 17H480 170.7l9.1 48H488h24v48H488 160 140.1l-3.7-19.5L76.1 48H24 0V0zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM256 96H384h24v48H384 256 232V96h24z'
      
    ]
  };

  

  
  

  var faPager = {
    prefix: 'fasr',
    iconName: 'pager',
    icon: [
      512,
      512,
      [128223],
      'f815',
      
      'M48 112V400H464V112H48zM0 64H48 464h48v48V400v48H464 48 0V400 112 64zm96 96H416v96H96V160zm96 144v48H96V304h96zm32 48V304h96v48H224z'
      
    ]
  };

  

  
  

  var faMerge = {
    prefix: 'fasr',
    iconName: 'merge',
    icon: [
      512,
      512,
      [],
      'e526',
      
      'M0 64H24 96h64 11.9l7.2 9.5L299.9 232h119l-39-39-17-17 33.9-33.9 17 17 80 80 17 17-17 17-80 80-17 17L362.9 336l17-17 39-39h-119L179.1 438.5l-7.2 9.5H160 96 24 0V400H24 96h52.1L257.8 256 148.1 112H96 24 0V64z'
      
    ]
  };

  

  
  

  var faCircleH = {
    prefix: 'fasr',
    iconName: 'circle-h',
    icon: [
      512,
      512,
      [9405,"hospital-symbol"],
      'f47e',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V128H320v24 80H192V152 128H144v24 80 48l0 80v24h48V360l0-80H320v80 24h48V360 256 152z'
      
    ]
  };

  
    var faHospitalSymbol = faCircleH;
  

  
  

  var faHexagonXmark = {
    prefix: 'fasr',
    iconName: 'hexagon-xmark',
    icon: [
      512,
      512,
      ["times-hexagon","xmark-hexagon"],
      'f2ee',
      
      'M55.3 256L155.9 80H356.1L456.7 256 356.1 432H155.9L55.3 256zM128 32L0 256 128 480H384L512 256 384 32H128zM353.9 192L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faTimesHexagon = faHexagonXmark;
  
    var faXmarkHexagon = faHexagonXmark;
  

  
  

  var faCartXmark = {
    prefix: 'fasr',
    iconName: 'cart-xmark',
    icon: [
      576,
      512,
      [],
      'e0dd',
      
      'M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 488h24V336H488 179.9l-9.1-48H480h17.8l5.2-17L575.4 32H525.2l-63 208H161.6l-42-220.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM274.7 48.8L240.8 82.7l17 17L286.1 128l-28.3 28.3-17 17 33.9 33.9 17-17L320 161.9l28.3 28.3 17 17 33.9-33.9-17-17L353.9 128l28.3-28.3 17-17L365.3 48.8l-17 17L320 94.1 291.7 65.8l-17-17z'
      
    ]
  };

  

  
  

  var faBowArrow = {
    prefix: 'fasr',
    iconName: 'bow-arrow',
    icon: [
      512,
      512,
      [127993],
      'f6b9',
      
      'M512 0L352 32l47 47L149.9 328.2 96 312 38.5 369.4 0 408l52.2 15.7L80 432l8.3 27.8L104 512l38.5-38.6L200 416l-16.2-53.9L433 113l47 47L512 0zM109.7 366.2l22 6.6c.9 1.5 2 2.9 3.3 4.1s2.7 2.4 4.1 3.3l6.6 22-18.9 18.9-.9-3-7.4-24.8L93.8 386l-3-.9 18.9-18.9zm-57-251.5l-.5-.5-17-17L1.3 131.2l17 17L151.4 281.4l33.9-33.9-98-98c61.2-37.6 138.2-39.2 200.8-4.9l35.1-35.1c-82.8-51.7-189.4-50-270.6 5.2zm314.7 109c34.3 62.6 32.7 139.6-4.9 200.8l-98-98-33.9 33.9L363.8 493.8l17 17 33.9-33.9-17-17-.5-.5c55.2-81.2 57-187.8 5.2-270.6l-35.1 35.1z'
      
    ]
  };

  

  
  

  var faFileCircleExclamation = {
    prefix: 'fasr',
    iconName: 'file-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4eb',
      
      'M48 464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 48 0H48 256L384 128v70.6c-17.2 4.9-33.4 12.3-48 21.8V160H224V48H48V464zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224V416H416v32h32zm0-176H416v16 80 16h32V368 288 272z'
      
    ]
  };

  

  
  

  var faEnvelopesBulk = {
    prefix: 'fasr',
    iconName: 'envelopes-bulk',
    icon: [
      640,
      512,
      ["mail-bulk"],
      'f674',
      
      'M112 48H432V96h48V48 0H432 112 64V48 192h48V48zM48 272H336v3.6L192 378.5 48 275.6V272zm0 62.6l130.1 92.9 13.9 10 13.9-10 130-92.9V464H48V334.6zM0 224v48V464v48H48 336h48V464 272 224H336 48 0zm272-32V176H592V368H416v48H592h48V368 176 128H592 272 224v48 16h48zm288 16H496v64h64V208z'
      
    ]
  };

  
    var faMailBulk = faEnvelopesBulk;
  

  
  

  var faJarWheat = {
    prefix: 'fasr',
    iconName: 'jar-wheat',
    icon: [
      320,
      512,
      [],
      'e517',
      
      'M32 0V48H288V0H32zM272 128V464H48V128H272zM48 80H0v48V464v48H48 272h48V464 128 80H272 48zM192 320c35.3 0 64-28.7 64-64H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7H64c0 35.3 28.7 64 64 64h16 32 16zm0-96c35.3 0 64-28.7 64-64H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7H64c0 35.3 28.7 64 64 64h16 32 16zm0 192c35.3 0 64-28.7 64-64H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7H64c0 35.3 28.7 64 64 64h16v16 16h32V432 416h16z'
      
    ]
  };

  

  
  

  var faSpoon = {
    prefix: 'fasr',
    iconName: 'spoon',
    icon: [
      512,
      512,
      [61873,129348,"utensil-spoon"],
      'f2e5',
      
      'M272 160.2c0-21.1 13.5-48.9 42.7-73.3C343.4 63 380.8 48 416 48c26.5 0 48 21.5 48 48c0 35.2-15 72.6-38.9 101.3C400.7 226.5 373 240 351.8 240H332.1l-14.1-14.1-32-32L272 179.9V160.2zm13.1 100.7L312.2 288h39.6C432 288 512 192 512 96c0-53-43-96-96-96C320 0 224 80 224 160.2v39.6l27.1 27.1L18.2 459.8l-17 17 33.9 33.9 17-17L285.1 260.9z'
      
    ]
  };

  
    var faUtensilSpoon = faSpoon;
  

  
  

  var faCheeseSwiss = {
    prefix: 'fasr',
    iconName: 'cheese-swiss',
    icon: [
      512,
      512,
      [129472],
      'f7f0',
      
      'M48 432V304H332.2c8.8 9.8 21.6 16 35.8 16s27-6.2 35.8-16H464V432H48zM368 224c-20.9 0-38.7 13.4-45.3 32H78.2l118.2-91.9C204 180.6 220.7 192 240 192c26.5 0 48-21.5 48-48c0-15.1-7-28.5-17.8-37.3l33.4-26C393.5 88.6 464 164.1 464 256H413.3c-6.6-18.6-24.4-32-45.3-32zM288 32L0 256V432v48H48 464h48V432 256C512 132.3 411.7 32 288 32zM176 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faHouseBuilding = {
    prefix: 'fasr',
    iconName: 'house-building',
    icon: [
      640,
      512,
      [],
      'e1b1',
      
      'M336 48H592V464H416v48H592h48V464 48 0H592 336 288V48v86.3l48 40V48zm80 208h32V192H384v22.3l20.5 17.1L416 241v15zm0 96h32V288H416v64zm64-160v64h64V192H480zm64 96H480v64h64V288zM448 96H384v64h64V96zm32 0v64h64V96H480zM48 278.5l144-120 144 120V464H48V278.5zM0 256V464v48H48 336h48V464 256L192 96 0 256zm240 16H144v96h96V272z'
      
    ]
  };

  

  
  

  var faLeafHeart = {
    prefix: 'fasr',
    iconName: 'leaf-heart',
    icon: [
      512,
      512,
      [],
      'f4cb',
      
      'M320 144H272c-70.7 0-128 57.3-128 128c0 70.7 57.3 128 127.9 128h.1l.8 0 .1 0C370.2 399.5 464 299.7 464 156.6c0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144H320v0zM450.6 67.5c14.9-13.3 26.2-30.5 32.3-50.1c8.8 19.7 15.9 40.8 20.8 63c5.4 24.3 8.3 49.8 8.3 76.2C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.4 48 440v16 24H0V456 440c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96l48 0h56c28.7 0 54.8-10.8 74.6-28.5zM189.7 241.1c0-28.6 23.2-51.8 51.8-51.8H245c14 0 27.5 5.3 37.8 14.9l5.2 4.8 5.2-4.8c10.3-9.6 23.8-14.9 37.8-14.9h3.5c28.6 0 51.8 23.2 51.8 51.8c0 14.3-5.9 28-16.4 37.8l-70.9 66.4L288 355.5l-10.9-10.2-70.9-66.4c-10.5-9.8-16.4-23.5-16.4-37.8z'
      
    ]
  };

  

  
  

  var faArrowsRotateReverse = {
    prefix: 'fasr',
    iconName: 'arrows-rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e630',
      
      'M394 187.1C367.2 124.1 304.7 80 232 80c-39.7 0-77.8 15.8-105.9 43.9L73.9 176H128h24v48H128 16-8V200 88 64H40V88v54.1L92.1 89.9C129.2 52.8 179.5 32 232 32c92.6 0 172.1 56.2 206.2 136.3L394 187.1zm30 182.8l-52.1 52.1C334.8 459.2 284.5 480 232 480c-92.5 0-171.8-56-206-135.9l44.1-18.9C97 388.1 159.4 432 232 432c39.7 0 77.8-15.8 105.9-43.9L390.1 336H336 312V288h24H448h24v24V424v24H424V424 369.9z'
      
    ]
  };

  

  
  

  var faArrowDownUpAcrossLine = {
    prefix: 'fasr',
    iconName: 'arrow-down-up-across-line',
    icon: [
      576,
      512,
      [],
      'e4af',
      
      'M160 505.9l17-17 96-96 17-17L256 342.1l-17 17-55 55V280H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H440V97.9l55 55 17 17L545.9 136l-17-17L433 23l-17-17L399 23l-96 96-17 17L320 169.9l17-17 55-55V232H184 136 24c-13.3 0-24 10.7-24 24s10.7 24 24 24H136V414.1L81 359l-17-17L30.1 376l17 17 96 96 17 17zM136 56V192h48V56 32H136V56zM392 320V456v24h48V456 320H392z'
      
    ]
  };

  

  
  

  var faSpaghettiMonsterFlying = {
    prefix: 'fasr',
    iconName: 'spaghetti-monster-flying',
    icon: [
      640,
      512,
      ["pastafarianism"],
      'f67b',
      
      'M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-10.9 63.8c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7h24v48H616c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c2.4 7.1 4.5 14.1 6.5 20.6l0 0 0 0 0 0L489 331c3.4 11.2 6.4 20.3 9.8 27.8c3.4 7.5 6.6 11.5 9.4 13.8c2.3 1.8 5.5 3.4 11.7 3.4c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8h24v48H616c-13.4 0-24.7 5.2-39.7 13.2c-1 .5-2.1 1.1-3.2 1.7l0 0 0 0C559.9 414 541.4 424 520 424c-16.2 0-30.2-4.8-41.7-13.9c-10.9-8.7-18-20.2-23-31.1c-5-10.9-8.8-22.9-12.2-34l-.8-2.7c-16.4 12.2-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464h24v48H448c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512H168V464h24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3l-.8 2.7c-3.4 11-7.2 23.1-12.2 34c-5.1 10.9-12.1 22.4-23 31.1C150.2 419.2 136.2 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2H0V344H24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.3 0 9.5-1.6 11.7-3.4c2.8-2.2 6-6.3 9.4-13.8c3.5-7.5 6.4-16.6 9.8-27.8l1.3-4.2 0 0c2-6.5 4.1-13.5 6.5-20.6c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3H0V200H24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2zM182 258.3c6.3 8.8 15.8 20.5 28.3 32.2C235.5 313.8 272 336 320 336s84.5-22.2 109.7-45.6c12.6-11.7 22-23.4 28.3-32.2c.5-.7 1-1.3 1.4-2c-5.4-6.9-10.8-13.8-16.7-20.7C416.3 204.6 382.4 176 320 176s-96.3 28.6-122.7 59.6c-5.9 6.9-11.3 13.8-16.7 20.7c.4 .6 .9 1.3 1.4 2zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faPastafarianism = faSpaghettiMonsterFlying;
  

  
  

  var faTruckFlatbed = {
    prefix: 'fasr',
    iconName: 'truck-flatbed',
    icon: [
      640,
      512,
      [],
      'e2b6',
      
      'M368 96h24 80 9.9l7 7L601 215l7 7V232 368h8 24v48H616 576c0 53-43 96-96 96s-96-43-96-96h-8H256c0 53-43 96-96 96s-96-43-96-96H24 0V368H24 76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V120 96zm94.1 48H416v96H558.1l-96-96zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faClarinet = {
    prefix: 'fasr',
    iconName: 'clarinet',
    icon: [
      640,
      512,
      [],
      'f8ad',
      
      'M224 96h16 32 96 96 32 16v32H496 480v32h57.8l66.6-37L640 103.2V144 368v40.8L604.3 389l-66.6-37H104h-3.5l-3.4-1-80-24L0 321.9V304 208 190.1L17.1 185l80-24 3.4-1H104 256V128H240 224V96zm64 64h64V128H288v32zm96 0h64V128H384v32zM248 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm115.7-51l-5.4 3H544 107.5L48 225.9v60.3L107.5 304H544h6.2l5.4 3L592 327.2V184.8L555.7 205z'
      
    ]
  };

  

  
  

  var faBong = {
    prefix: 'fasr',
    iconName: 'bong',
    icon: [
      448,
      512,
      [],
      'f55c',
      
      'M120 259.2C95.5 273.4 75.6 294.6 63 320H321c-12.6-25.4-32.5-46.6-57.1-60.8l-24-13.9V217.7 48H144V217.7v27.7l-24 13.9zM288 48V217.7c14.2 8.2 27.2 18.2 38.8 29.6L366.1 208l-7-7-17-17L376 150.1l17 17 24 24 24 24 17 17L424 265.9l-17-17-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 49.2-18.5 94-48.9 128H48.9C18.5 478 0 433.2 0 384c0-71.1 38.6-133.1 96-166.3V48H88 64V0H88h8 48 96 48 8 24V48H296h-8z'
      
    ]
  };

  

  
  

  var faCameraMovie = {
    prefix: 'fasr',
    iconName: 'camera-movie',
    icon: [
      576,
      512,
      [127909,127910],
      'f8a9',
      
      'M224 120A72 72 0 1 0 80 120a72 72 0 1 0 144 0zM344 240H152C85.7 240 32 186.3 32 120S85.7 0 152 0c39.3 0 74.1 18.8 96 48c21.9-29.1 56.7-48 96-48c66.3 0 120 53.7 120 120s-53.7 120-120 120zM272 120a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zM168 320H144 112V464H368V320H168zm0-48H368h48v48V464v48H368 112 64V464 320H24 0V272H24 64h48 32 24zM448 467.7V416.9l80 27.7V323.4l-80 27.7V300.3l80-27.7L576 256v50.8V461.2 512l-48-16.6-80-27.7z'
      
    ]
  };

  

  
  

  var faSigma = {
    prefix: 'fasr',
    iconName: 'sigma',
    icon: [
      384,
      512,
      [8721],
      'f68b',
      
      'M0 480H24 360h24V456 376 352H336v24 56H81.9L241 273l17-17-17-17L81.9 80H336v56 24h48V136 56 32H360 24 0V65.9l7 7 183 183L7 439l-7 7V480z'
      
    ]
  };

  

  
  

  var faFaceGrinStars = {
    prefix: 'fasr',
    iconName: 'face-grin-stars',
    icon: [
      512,
      512,
      [129321,"grin-stars"],
      'f587',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM182.7 131.6l-6.7-10-6.7 10-20.5 31-35.8 10-11.6 3.2 7.5 9.4L132 214.3l-1.6 37.1-.5 12 11.3-4.2 34.8-13 34.8 13 11.3 4.2-.5-12L220 214.3l23.1-29.1 7.5-9.4L239 172.5l-35.8-10-20.5-31zm160 0l-6.7-10-6.7 10-20.5 31-35.8 10-11.6 3.2 7.5 9.4L292 214.3l-1.6 37.1-.5 12 11.3-4.2 34.8-13 34.8 13 11.3 4.2-.5-12L380 214.3l23.1-29.1 7.5-9.4L399 172.5l-35.8-10-20.5-31zM255.9 318.8c-50.3 0-97.2-8.6-136.5-23.5C133.2 355.2 189.1 400 255.9 400s122.7-44.8 136.5-104.6c-39.3 14.9-86.2 23.5-136.5 23.5z'
      
    ]
  };

  
    var faGrinStars = faFaceGrinStars;
  

  
  

  var faSquareP = {
    prefix: 'fasr',
    iconName: 'square-p',
    icon: [
      448,
      512,
      [],
      'e279',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm152 96h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H176v48 24H128V360 288 152 128h24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44H176v88h68z'
      
    ]
  };

  

  
  

  var faBringForward = {
    prefix: 'fasr',
    iconName: 'bring-forward',
    icon: [
      512,
      512,
      [],
      'f856',
      
      'M208 464H464V208H384V160h80 48v48V464v48H464 208 160V464 384h48v80zM0 352V0H352V352H0z'
      
    ]
  };

  

  
  

  var faRecordVinyl = {
    prefix: 'fasr',
    iconName: 'record-vinyl',
    icon: [
      512,
      512,
      [],
      'f8d9',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm120 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faTruckPlane = {
    prefix: 'fasr',
    iconName: 'truck-plane',
    icon: [
      640,
      512,
      [],
      'e58f',
      
      'M224 0c-14.7 0-27.2 6.3-36.7 13.9c-9.5 7.6-17.3 17.4-23.3 27.5c-11.9 19.6-20 44.3-20 64.6v59.6L10.1 260.4 0 267.6V280v80 34.6l32.4-12.2L144 340.6l0 15.4L89.6 396.8 80 404v12 72 24h24 16 3.6l3.4-1.1L224 481.1l32 9.8V440.7l-24.9-7.7-7.1-2.2-7.1 2.2L128 460.4V428l54.4-40.8L192 380V368l0-62 0-34.6-32.4 12.2L48 325.4v-33l133.9-94.8 10.1-7.2V178 106c0-9.6 4.6-25.8 13-39.7c4.1-6.7 8.4-11.8 12.3-14.9c3.9-3.1 6.1-3.3 6.7-3.3c2.4 0 10.1 3 19.2 18.1c5.9 9.8 9.8 20.8 11.6 29.9H256h47.4c-2-18-9.1-38.1-19-54.6C273.4 23.1 253.1 0 224 0zM592 176V296.2l-2.5-7.4-16-48L562.6 208H528 400 365.4l-10.9 32.8-16 48-2.5 7.4V176H592zM336 416V352h48H544h48v64H560 368 336zm272 48h32V416 176 128H592 336 288v48V416v48h32v48h48V464H560v48h48V464zM384 304l16-48 128 0 16 48H493.4 434.6 384zM552 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM400 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCircleHeart = {
    prefix: 'fasr',
    iconName: 'circle-heart',
    icon: [
      512,
      512,
      ["heart-circle"],
      'f4c7',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.2 287.1L160 311.9l96 96 96-96 24.8-24.8c14.9-14.9 23.2-35 23.2-56v-3.6c0-41.8-33.9-75.6-75.6-75.6c-23 0-44.7 10.4-59.1 28.4L256 191.9l-9.3-11.6c-14.4-17.9-36.1-28.4-59.1-28.4c-41.8 0-75.6 33.9-75.6 75.6v3.6c0 21 8.3 41.1 23.2 56z'
      
    ]
  };

  
    var faHeartCircle = faCircleHeart;
  

  
  

  var faChevronsLeft = {
    prefix: 'fasr',
    iconName: 'chevrons-left',
    icon: [
      512,
      512,
      ["chevron-double-left"],
      'f323',
      
      'M47 239l-17 17 17 17L239 465l17 17L289.9 448l-17-17L97.9 256 273 81l17-17L256 30.1 239 47 47 239zm192 0l-17 17 17 17L431 465l17 17L481.9 448l-17-17-175-175L465 81l17-17L448 30.1 431 47 239 239z'
      
    ]
  };

  
    var faChevronDoubleLeft = faChevronsLeft;
  

  
  

  var faUnion = {
    prefix: 'fasr',
    iconName: 'union',
    icon: [
      384,
      512,
      [8899],
      'f6a2',
      
      'M48 32V56 288c0 79.5 64.5 144 144 144s144-64.5 144-144V56 32h48V56 288c0 106-86 192-192 192S0 394 0 288V56 32H48z'
      
    ]
  };

  

  
  

  var faMenorah = {
    prefix: 'fasr',
    iconName: 'menorah',
    icon: [
      640,
      512,
      [],
      'f676',
      
      'M4.2 48.7L32 0 59.8 48.7C62.6 53.5 64 58.9 64 64.4C64 81.8 49.8 96 32.4 96h-.8C14.2 96 0 81.8 0 64.4c0-5.5 1.4-10.9 4.2-15.7zm96 0L128 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C160 81.8 145.8 96 128.4 96h-.8C110.2 96 96 81.8 96 64.4c0-5.5 1.4-10.9 4.2-15.7zM224 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C256 81.8 241.8 96 224.4 96h-.8C206.2 96 192 81.8 192 64.4c0-5.5 1.4-10.9 4.2-15.7L224 0zm68.2 48.7L320 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C352 81.8 337.8 96 320.4 96h-.8C302.2 96 288 81.8 288 64.4c0-5.5 1.4-10.9 4.2-15.7zM416 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C448 81.8 433.8 96 416.4 96h-.8C398.2 96 384 81.8 384 64.4c0-5.5 1.4-10.9 4.2-15.7L416 0zm68.2 48.7L512 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C544 81.8 529.8 96 512.4 96h-.8C494.2 96 480 81.8 480 64.4c0-5.5 1.4-10.9 4.2-15.7zM608 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C640 81.8 625.8 96 608.4 96h-.8C590.2 96 576 81.8 576 64.4c0-5.5 1.4-10.9 4.2-15.7L608 0zM48 128v24V280c0 22.1 17.9 40 40 40H296V152 128h48v24V320H552c22.1 0 40-17.9 40-40V152 128h48v24V280c0 48.6-39.4 88-88 88H344v96H488h24v48H488 320 152 128V464h24H296V368H88c-48.6 0-88-39.4-88-88V152 128H48zm104 24V288H104V152 128h48v24zm96 0V288H200V152 128h48v24zm192 0V288H392V152 128h48v24zm96 0V288H488V152 128h48v24z'
      
    ]
  };

  

  
  

  var faFileCsv = {
    prefix: 'fasr',
    iconName: 'file-csv',
    icon: [
      512,
      512,
      [],
      'f6dd',
      
      'M48 464H96v48H48 0V464 48 0H48 256L384 128V288H336V160H224V48H48V464zM200 352h16c22.1 0 40 17.9 40 40v8 16H224V400v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8V448h32v16 8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368h16v32H368 333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304 288V480h16 42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zM448 352v16 61.1l16 42.7 16-42.7V368 352h32v16 64 2.9l-1 2.7-24 64L483.1 512H472 456 444.9L441 501.6l-24-64-1-2.7V432 368 352h32z'
      
    ]
  };

  

  
  

  var faLaptop = {
    prefix: 'fasr',
    iconName: 'laptop',
    icon: [
      640,
      512,
      [128187],
      'f109',
      
      'M528 80H112V320H64V80 32h48H528h48V80 320H528V80zM83.9 432H556.1l32-32H51.9l32 32zM576 480H64L0 416V400 352H48 592h48v48 16l-64 64z'
      
    ]
  };

  

  
  

  var faPerson = {
    prefix: 'fasr',
    iconName: 'person',
    icon: [
      320,
      512,
      [129485,"male"],
      'f183',
      
      'M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM94.8 128h14.1H211.1h14.1l6.9 12.4 75.3 136 11.6 21-42 23.3-11.6-21L224 224.9V488v24H176V488 352H144V488v24H96V488 224.9L54.6 299.6 43 320.6 1 297.4l11.6-21 75.3-136L94.8 128zM144 304h32V176H144V304z'
      
    ]
  };

  
    var faMale = faPerson;
  

  
  

  var faFireFlameSimple = {
    prefix: 'fasr',
    iconName: 'fire-flame-simple',
    icon: [
      384,
      512,
      ["burn"],
      'f46a',
      
      'M180.9 9.7L192 0l11.1 9.7c76.7 67.1 135.2 152.5 170 248.3c7.2 19.9 10.9 41.1 10.9 62.2C384 425.4 297.2 512 192 512S0 425.4 0 320.2C0 299 3.7 277.8 10.9 258c34.8-95.8 93.3-181.2 170-248.3zM56 274.4c-5.3 14.5-8 30.2-8 45.8C48 398.8 113.3 464 192 464s144-65.2 144-143.8c0-15.6-2.7-31.2-8-45.8C299.1 195 252.6 123.3 192 64.7C131.4 123.3 84.9 195 56 274.4zm225.7 15.6c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l.9-2.1c16.4-36.8 40.5-69.6 70.8-96.1L192 176l18 15.7c30.3 26.5 54.5 59.3 70.8 96.1l.9 2.1z'
      
    ]
  };

  
    var faBurn = faFireFlameSimple;
  

  
  

  var faPersonCarryBox = {
    prefix: 'fasr',
    iconName: 'person-carry-box',
    icon: [
      384,
      512,
      ["person-carry"],
      'f4cf',
      
      'M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM0 488l0 24 48 0 0-24 0-109.9L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 488zM24 128H0v24V272.4c0 17.2 7.9 33.4 21.4 44l92.2 72.4L131.2 512h48.5L159.8 372.6l-1.4-9.5-7.6-5.9L120 332.9V328 246.2L139.8 277l7.1 11H160h32 40 8 16 80 48V240 144 96H336 240 192v48 96H173.1L108.2 139l-7.1-11H88 24zM240 240V144h96v96H256 240zM72 184V295.2L51.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3V176H72v8z'
      
    ]
  };

  
    var faPersonCarry = faPersonCarryBox;
  

  
  

  var faArrowUpLong = {
    prefix: 'fasr',
    iconName: 'arrow-up-long',
    icon: [
      384,
      512,
      ["long-arrow-up"],
      'f176',
      
      'M209 17L192 0 175 17 39 153l-17 17L56 203.9l17-17 95-95V488v24h48V488 91.9l95 95 17 17 33.9-33.9-17-17L209 17z'
      
    ]
  };

  
    var faLongArrowUp = faArrowUpLong;
  

  
  

  var faCalendarCircleUser = {
    prefix: 'fasr',
    iconName: 'calendar-circle-user',
    icon: [
      576,
      512,
      [],
      'e471',
      
      'M152 0V24 64H296V24 0h48V24 64H448v80 48H432 400 352 48V464H284.5c12.3 18.8 28 35.1 46.3 48H48 0V464 192 144 64H104V24 0h48zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224.7 77.7L488 416H376l-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3zM480 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faTransporter = {
    prefix: 'fasr',
    iconName: 'transporter',
    icon: [
      512,
      512,
      [],
      'e042',
      
      'M464 0l16 32 32 16L480 64 464 96 448 64 416 48l32-16L464 0zM48 64L64 96l32 16L64 128 48 160 32 128 0 112 32 96 48 64zM96 464h24H392h24v48H392 120 96V464zM208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-15.1 80h12.1H307.1h12.1l7.2 9.7 83.3 112L424 268.9l-38.5 28.7-14.3-19.3L320 209.6V432H272V320H240V432H192V209.6l-51.1 68.7-14.3 19.3L88 268.9l14.3-19.3 83.3-112 7.2-9.7zM240 272h32V176H240v96z'
      
    ]
  };

  

  
  

  var faDiagramPredecessor = {
    prefix: 'fasr',
    iconName: 'diagram-predecessor',
    icon: [
      512,
      512,
      [],
      'e477',
      
      'M369 119l-17-17L318.1 136l17 17 64 64 17 17 17-17 64-64 17-17L480 102.1l-17 17-23 23L440 56l0-24-24 0L288 32l-80 0-24 0L0 32 0 224l288 0 0-144 104 0 0 62.1-23-23zm95 313L48 432l0-96 416 0 0 96zm48 48l0-48 0-96 0-48-48 0L48 288 0 288l0 48 0 96 0 48 48 0 416 0 48 0z'
      
    ]
  };

  

  
  

  var faCrateEmpty = {
    prefix: 'fasr',
    iconName: 'crate-empty',
    icon: [
      512,
      512,
      [],
      'e151',
      
      'M48 272v72H464V272H48zm0 120v72H464V392H48zM0 224H48 464h48v48V464v48H464 48 0V464 272 224zm400 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBeerMugEmpty = {
    prefix: 'fasr',
    iconName: 'beer-mug-empty',
    icon: [
      512,
      512,
      ["beer"],
      'f0fc',
      
      'M336 80H80V432H336V368.6c0-.4 0-.7 0-1.1V80zm48 303.7V432v48H336 80 32V432 80 32H80 336h48V80 96H488h24v24V312v15.7L497.6 334 384 383.7zM384 144V331.3l80-35V144H384zM160 128v16V368v16H128V368 144 128h32zm64 0v16V368v16H192V368 144 128h32zm64 0v16V368v16H256V368 144 128h32z'
      
    ]
  };

  
    var faBeer = faBeerMugEmpty;
  

  
  

  var faPeopleLine = {
    prefix: 'fasr',
    iconName: 'people-line',
    icon: [
      640,
      512,
      [],
      'e534',
      
      'M280 72a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-22.3 56H272h96 14.3l6.8 12.6L434 224h14 96 14.1l6.9 12.3 56 100.8 11.7 21-42 23.3-11.7-21-19-34.2V360v24H536 456 432V360 326.2l-19 34.2-11.7 21-42-23.3 11.7-21 35.2-63.5-3.4-6.3-18.9-35V280v24H360 280 256V280 232.3l-18.9 35-3.4 6.3L269 337.1l11.7 21-42 23.3-11.7-21-19-34.2V360v24H184 104 80V360 326.2L61 360.5l-11.7 21-42-23.3 11.7-21L75 236.3 81.9 224H96h96 14l44.9-83.4 6.8-12.6zM304 176v80h32V176H304zm192-48a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM24 432H616h24v48H616 24 0V432H24zM144 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 336h32V272H128v64zm352 0h32V272H480v64z'
      
    ]
  };

  

  
  

  var faLightbulbExclamationOn = {
    prefix: 'fasr',
    iconName: 'lightbulb-exclamation-on',
    icon: [
      640,
      512,
      [],
      'e1ca',
      
      'M425.2 248.9C439.6 228.3 448 203.2 448 176c0-70.7-57.3-128-128-128s-128 57.3-128 128c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H237c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0 0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H354.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM240 512V416H400v96H240zm96-384v80 16H304V208 128 112h32v16zm0 128v32H304V256h32zM87.3 16l6 4 24 16 20 13.3L110.7 89.3 90.7 76l-24-16-6-4-20-13.3L67.3 2.7 87.3 16zM579.3 56l-6 4-24 16-20 13.3L502.7 49.3l20-13.3 24-16 6-4 20-13.3 26.6 39.9L579.3 56zM24 160H72 96v48H72 24 0V160H24zm544 0h48 24v48H616 568 544V160h24zM117.3 332l-24 16-6 4-20 13.3L40.7 325.3l20-13.3 6-4 24-16 20-13.3 26.6 39.9-20 13.3zm432-39.9l24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9 20 13.3z'
      
    ]
  };

  

  
  

  var faLocationPlus = {
    prefix: 'fasr',
    iconName: 'location-plus',
    icon: [
      384,
      512,
      ["map-marker-plus"],
      'f60a',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zM168 304V280 216H104 80V168h24 64V104 80h48l0 24v64h64 24v48H280 216v64 24H168z'
      
    ]
  };

  
    var faMapMarkerPlus = faLocationPlus;
  

  
  

  var faSquareArrowRight = {
    prefix: 'fasr',
    iconName: 'square-arrow-right',
    icon: [
      448,
      512,
      ["arrow-square-right"],
      'f33b',
      
      'M400 80L48 80l0 352 352 0 0-352zm48-48l0 48 0 352 0 48-48 0L48 480 0 480l0-48L0 80 0 32l48 0 352 0 48 0zM345 273l-88 88-17 17L206.1 344l17-17 47-47L120 280l-24 0 0-48 24 0 150.1 0-47-47-17-17L240 134.1l17 17 88 88 17 17-17 17z'
      
    ]
  };

  
    var faArrowSquareRight = faSquareArrowRight;
  

  
  

  var faPeopleRoof = {
    prefix: 'fasr',
    iconName: 'people-roof',
    icon: [
      640,
      512,
      [],
      'e537',
      
      'M332.2 11.3L320 4.1l-12.2 7.2L23 179.3 2.3 191.5l24.4 41.3 20.7-12.2L320 59.9 592.6 220.7l20.7 12.2 24.4-41.3L617 179.3 332.2 11.3zM496 336a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-48 16H434l-44.9-83.4L382.3 256H368 272 257.7l-6.8 12.6L206 352H192 96 81.9L75 364.3 19 465.1l-11.7 21 42 23.3 11.7-21 19-34.2V488v24h24 80 24V488 454.2l19 34.2 11.7 21 42-23.3-11.7-21-35.2-63.4 3.4-6.3 18.9-35V408v24h24 80 24V408 360.3l18.9 35 3.4 6.3L371 465.1l-11.7 21 42 23.3 11.7-21 19-34.2V488v24h24 80 24V488 454.2l19 34.2 11.7 21 42-23.3-11.7-21L565 364.3 558.1 352H544 448zm32 112V400h32v64H480zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM304 304h32v80H304V304zM144 336a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM128 464V400h32v64H128z'
      
    ]
  };

  

  
  

  var faUsersRectangle = {
    prefix: 'fasr',
    iconName: 'users-rectangle',
    icon: [
      640,
      512,
      [],
      'e594',
      
      'M0 0H24 616h24V24 488v24H616 24 0V488 24 0zM48 48V464H592V48H48zm79.8 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM120 240h79L193 264.2 179 320H96l24-80zm424 80H461L447 264.2 441 240h79l24 80zM416 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM253.5 352h133l-8-32h-117l-8 32zM224 272H416l20 80 12 48H398.5h-157H192l12-48 20-80zM344 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0z'
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fasr',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      'M241 273l-17 17-17-17L47 113l-17-17L64 62.1 81 79l143 143L367 79l17-17L417.9 96l-17 17L241 273zm0 192l-17 17-17-17L47 305l-17-17L64 254.1l17 17 143 143L367 271l17-17L417.9 288l-17 17L241 465z'
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  

  
  

  var faCrop = {
    prefix: 'fasr',
    iconName: 'crop',
    icon: [
      512,
      512,
      [],
      'f125',
      
      'M128 0V24 350.1L350.1 128 160 128V80l238.1 0 57-57 17-17L505.9 40 489 57l-57 57L432 384h56 24v48H488 432v56 24H384V488l0-326.1L161.9 384H328h24v48H328 104 80V408 128H24 0V80H24 80V24 0h48z'
      
    ]
  };

  

  
  

  var faSchoolCircleExclamation = {
    prefix: 'fasr',
    iconName: 'school-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e56c',
      
      'M466.7 144l-11.4-6.8L320 56 184.7 137.2 173.3 144H160 48V464H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-4.3 15.2-6.5 31.1-6.5 47.7c0 59.5 29.6 112.2 74.8 144H48 0V464 144 96H48 160L320 0 480 96H592h48v48V266.8c-12.9-18.3-29.2-34.1-48-46.3V144H480 466.7zm-74 81.5c-15 10.9-28.2 24.1-39.1 39.1C343.3 269.4 332 272 320 272c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 12-2.6 23.3-7.3 33.5zM160 192v96H96V192h64zM96 320h64v96H96V320zM336 160V144H304v16 32 16h16 24 16V176H344h-8V160zm160 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224V416H480v32h32zm0-176H480v16 80 16h32V368 288 272z'
      
    ]
  };

  

  
  

  var faUserVneck = {
    prefix: 'fasr',
    iconName: 'user-vneck',
    icon: [
      448,
      512,
      [],
      'e461',
      
      'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm88.1 330.6l3.6 5.4H65L99.5 352H113l71.1 106.6zM219.6 512h8.7H397.8 448l-14.8-48L384 304H309.3l-56.5 84.7L224 432l-28.8-43.3L138.7 304H64L14.8 464 0 512H50.2 219.6zm40.7-48l3.6-5.4L335 352h13.5L383 464H260.4z'
      
    ]
  };

  

  
  

  var faFootball = {
    prefix: 'fasr',
    iconName: 'football',
    icon: [
      512,
      512,
      [127944,"football-ball"],
      'f44e',
      
      'M66 153.6C5.8 251.8 6.9 378.3 24.4 463.1l4.4 21.5 21.6 3.6c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5l-4.4-21.5-21.6-3.6c-103.9-17.4-187-11-252.6 13.3C142.9 61.6 96.7 103.6 66 153.6zM442.6 69.4c4.9 27.5 7.8 58.5 7.3 90.6l-98-98c27.6 .1 57.8 2.4 90.7 7.4zm-217 12.7c18.8-7 39.6-12.3 62.8-15.8L444.5 222.4c-6.4 38.9-18.8 77.2-39.5 110.9c-25.4 41.4-63.3 76-118.6 96.5c-18.8 7-39.6 12.3-62.8 15.8L67.5 289.6c6.4-38.9 18.8-77.2 39.5-110.9c25.4-41.4 63.3-76 118.6-96.5zM62.1 352l98 98c-27.6-.1-57.8-2.4-90.7-7.4c-4.9-27.5-7.8-58.5-7.3-90.6zM297 151l-17-17L246.1 168l17 17 64 64 17 17L377.9 232l-17-17-64-64zm-56 56l-17-17L190.1 224l17 17 64 64 17 17L321.9 288l-17-17-64-64zm-56 56l-17-17L134.1 280l17 17 64 64 17 17L265.9 344l-17-17-64-64z'
      
    ]
  };

  
    var faFootballBall = faFootball;
  

  
  

  var faChevronsUp = {
    prefix: 'fasr',
    iconName: 'chevrons-up',
    icon: [
      512,
      512,
      ["chevron-double-up"],
      'f325',
      
      'M273 47l-17-17L239 47 47 239l-17 17L64 289.9l17-17 175-175L431 273l17 17L481.9 256l-17-17L273 47zm0 192l-17-17-17 17L47 431l-17 17L64 481.9l17-17 175-175L431 465l17 17L481.9 448l-17-17L273 239z'
      
    ]
  };

  
    var faChevronDoubleUp = faChevronsUp;
  

  
  

  var faFlagCheckered = {
    prefix: 'fasr',
    iconName: 'flag-checkered',
    icon: [
      448,
      512,
      [127937],
      'f11e',
      
      'M48 0V24 52l85-21.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0L400 40l48-24V69.7 368l-55.5 20.8c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L48 388V488v24H0V488 400 350.5 64 24 0H48zm0 150.7l80-17.4V81.5l-80 20v49.3zm0 49.1v46.9l80-17.4V182.5L48 199.9zm0 96v42.7l68.6-17.2c3.8-.9 7.6-1.8 11.4-2.5V278.5L48 295.9zm128 18.8c33.1 .7 65.9 8.7 96 23.7V288.5l-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6v46zm144 37c18.7 1.5 37.7-1.1 55.6-7.8l24.4-9.1V288L374.3 294c-17.9 4.1-36.1 5.5-54.3 4.3v53.5zm80-113V192L374.3 198c-17.9 4.1-36.1 5.5-54.3 4.3v47.8c14.5 1.4 29.2 .4 43.5-2.9l36.5-8.4zm0-96V92.9c-25.6 10.4-52.8 15.6-80 15.6v45.5c14.5 1.4 29.2 .4 43.5-2.9l36.5-8.4zM272 103.1c-16.1-3.7-31.9-9.4-47-16.9c-15.3-7.7-32.1-11.8-49-12.3v50.6c18.2-1.3 36.5 .6 54.1 5.8L272 142.5V103.1zm0 89.5l-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6v47.8c18.2-1.3 36.5 .6 54.1 5.8L272 238.5v-46z'
      
    ]
  };

  

  
  

  var faUtilityPoleDouble = {
    prefix: 'fasr',
    iconName: 'utility-pole-double',
    icon: [
      512,
      512,
      [],
      'e2c4',
      
      'M280 24V0H232V24 80H128V56 32H80V56 80H48V56 32H0V56v48 24H24 80h3.2L232 227.2V272H128V248 224H80v24 24H48V248 224H0v24 48 24H24 80h3.2L232 419.2V488v24h48V488 419.2L428.8 320H432h56 24V296 248 224H464v24 24H432V248 224H384v24 24H280V227.2L428.8 128H432h56 24V104 56 32H464V56 80H432V56 32H384V56 80H280V24zm91.2 104L280 188.8V128h91.2zM232 188.8L140.8 128H232v60.8zM371.2 320L280 380.8V320h91.2zM232 380.8L140.8 320H232v60.8z'
      
    ]
  };

  

  
  

  var faBuildingMemo = {
    prefix: 'fasr',
    iconName: 'building-memo',
    icon: [
      640,
      512,
      [],
      'e61e',
      
      'M48 48H336V64h48V48 0H336 48 0V48 464v48H48 288V464H240V352H144V464H48V48zM216 88v80h72V88H216zm0 128v80h72V216H216zM88 88v80h80V88H88zm0 128v80h80V216H88zM640 96H320V512H640V96zM400 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM376 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm64-184h16 96 16v32H576 480 464V192zm16 96h96 16v32H576 480 464V288h16zm-16 96h16 96 16v32H576 480 464V384z'
      
    ]
  };

  

  
  

  var faSquareX = {
    prefix: 'fasr',
    iconName: 'square-x',
    icon: [
      448,
      512,
      [],
      'e286',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm349.1 96L253.9 256l95.2 128H289.3L224 296.2 158.7 384H98.9l95.2-128L98.9 128h59.8L224 215.8 289.3 128h59.8z'
      
    ]
  };

  

  
  

  var faBowlScoop = {
    prefix: 'fasr',
    iconName: 'bowl-scoop',
    icon: [
      448,
      512,
      [127847,"bowl-shaved-ice"],
      'e3de',
      
      'M32 224C32 118 118 32 224 32s192 86 192 192H32zm411.2 80c-7.2 57.5-52.1 102.3-108.2 110.6c-6.2 .9-12.4 1.4-18.8 1.4H272l42.7 48L336 488v24H309 293.1 288 160h-5.1H139 112V488l21.3-24L176 416H131.8c-6.4 0-12.7-.5-18.8-1.4C56.9 406.3 12.1 361.5 4.8 304c-.1-1.1-.3-2.2-.4-3.3L0 256H48.2 399.8 448l-4.5 44.7c-.1 1.1-.2 2.2-.4 3.3zm-207 143.9L224 434.2l-12.1 13.6L197.6 464h52.9l-14.3-16.1zM176 368h96 10.9 33.3c38.4 0 70.9-27.1 78.4-64H53.4c7.5 36.9 40 64 78.4 64h33.3H176z'
      
    ]
  };

  
    var faBowlShavedIce = faBowlScoop;
  

  
  

  var faMessageExclamation = {
    prefix: 'fasr',
    iconName: 'message-exclamation',
    icon: [
      512,
      512,
      ["comment-alt-exclamation"],
      'f4a5',
      
      'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM280 80H232v24V216v24h48V216 104 80zM232 272v48h48V272H232z'
      
    ]
  };

  
    var faCommentAltExclamation = faMessageExclamation;
  

  
  

  var faLightCeiling = {
    prefix: 'fasr',
    iconName: 'light-ceiling',
    icon: [
      512,
      512,
      [],
      'e016',
      
      'M280 24V0H232V24 161.1C117.9 171.7 25.5 257.2 4.5 368C1.5 383.5 0 399.6 0 416H48 464h48c0-16.4-1.5-32.5-4.5-48C486.5 257.2 394.1 171.7 280 161.1V24zM256 208c98.4 0 180.8 68.3 202.4 160H53.6C75.2 276.3 157.6 208 256 208zm0 304c35.3 0 64-28.7 64-64H192c0 35.3 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faFaceSmileBeam = {
    prefix: 'fasr',
    iconName: 'face-smile-beam',
    icon: [
      512,
      512,
      [128522,"smile-beam"],
      'f5b8',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm124 77.3L164 306.7C176 324.8 211.9 352 256 352s80-27.2 92-45.3L388 333.3C368 363.2 317.9 400 256 400s-112-36.8-132-66.7zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z'
      
    ]
  };

  
    var faSmileBeam = faFaceSmileBeam;
  

  
  

  var faForwardStep = {
    prefix: 'fasr',
    iconName: 'forward-step',
    icon: [
      320,
      512,
      ["step-forward"],
      'f051',
      
      'M240 88V64h48V88 232v48V424v24H240V424 309.6L64 418.4 16 448V391.6 120.4 64L64 93.6 240 202.4V88zm-4.5 168L64 150.1V361.9L235.5 256z'
      
    ]
  };

  
    var faStepForward = faForwardStep;
  

  
  

  var faMessageBot = {
    prefix: 'fasr',
    iconName: 'message-bot',
    icon: [
      640,
      512,
      [],
      'e3b8',
      
      'M272 480l-48 32V464v-9.7V416H176 144 96V368 208H64v16H0V160H64v16H96V48 0h48H496h48V48 176h32V160h64v64H576V208H544V368v48H496 368l-96 64zM144 368h80 48v48 6.3l69.4-46.2 12.1-8.1H368 496V192 48H144V192 368zM464 96V288H176V96H464zM240 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassLocation = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-location',
    icon: [
      512,
      512,
      ["search-location"],
      'f689',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm80-240c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 64 80 144 80 144s80-80 80-144zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  
    var faSearchLocation = faMagnifyingGlassLocation;
  

  
  

  var faHandPointRight = {
    prefix: 'fasr',
    iconName: 'hand-point-right',
    icon: [
      512,
      512,
      [],
      'f0a4',
      
      'M512 104l0-24-24 0L272 80l0-16-24 0-56 0 0 0-24 0s0 0 0 0C75.2 64 0 139.2 0 232l0 48c0 92.7 75.1 167.9 167.9 168c0 0 .1 0 .1 0l0 0 88 0 40 0 24 0 0-24 0-56 16 0 0-24 0-56 8 0 24 0 0-24 0-56 120 0 24 0 0-24 0-80zM256 400l-80 0 0-32 96 0 0 32-16 0zm-128-6.8C81.4 376.7 48 332.2 48 280l0-48c0-66.3 53.7-120 120-120c0 0 0 0 0 0l24 0 0 0 32 0 0 72 0 56-32 0 0-56 0-24-48 0 0 24 0 56 0 24 0 24 0 32-16 0 0 24 0 49.2zM272 160l0-32 192 0 0 32-96 0-24 0-72 0zm0 80l0-32 48 0 0 32-8 0-40 0zm16 48l0 32-96 0 0-32 56 0 40 0z'
      
    ]
  };

  

  
  

  var faH1 = {
    prefix: 'fasr',
    iconName: 'h1',
    icon: [
      576,
      512,
      [],
      'f313',
      
      'M48 88V64H0V88 248 424v24H48V424 272H272V424v24h48V424 248 88 64H272V88 224H48V88zm336.4 83.1l20.4-12.7 51.3-32V400H408 384v48h24 72 72 24V400H552 504V88 64H480h-8-6.9l-5.8 3.6-75.3 47v55.8l.4 .6z'
      
    ]
  };

  

  
  

  var faStandardDefinition = {
    prefix: 'fasr',
    iconName: 'standard-definition',
    icon: [
      576,
      512,
      ["rectangle-sd"],
      'e28a',
      
      'M528 80V432H48V80H528zM48 32H0V80 432v48H48 528h48V432 80 32H528 48zM304 160v24V328v24h24 56c53 0 96-43 96-96s-43-96-96-96H328 304zm48 48h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H352V208zm-189.8 4.5c.7-.7 2.1-1.9 5.4-2.9c7.1-2.3 18.8-2.9 35.5-.6c5.1 .7 21 3.3 25.6 4.4l23.4 5.3 10.7-46.8-23.4-5.3c-6.6-1.5-24.1-4.4-29.9-5.2c-19-2.5-39.3-3.1-56.7 2.5c-19.2 6.2-34.9 20.3-39.6 43.5c-.1 .4-.2 .9-.2 1.3c-1.7 11.7-.3 23 5.2 33.2c5.3 9.9 13.3 16.7 21.1 21.3c13.9 8.3 32 12.5 45.5 15.6l1.8 .4c16.1 3.8 26.9 6.5 33.6 10.5c1.4 .8 2.2 1.5 2.7 2c.5 .4 .6 .7 .6 .7c0 0 .1 .1 .1 .5c.1 .4 .1 1.4-.1 3.2c-.4 2.4-1 3.2-1.3 3.5c-.4 .5-1.8 1.6-5.1 2.7c-7.3 2.3-19.5 2.8-36.2 .6c-7.2-1-20-4.7-31.1-8l0 0 0 0c-2.6-.7-5-1.5-7.3-2.1l-23.1-6.6-13.2 46.2 23.1 6.6c1.4 .4 3.2 .9 5.3 1.5c10.8 3.2 28.6 8.4 39.7 9.9l.1 0c19 2.5 39.6 3.2 57.1-2.4c9.1-2.9 18.2-7.7 25.6-15.6c7.6-8.1 12.1-18.1 13.8-29.3c1.7-11.7 .3-23-5.2-33.2c-5.3-9.9-13.3-16.7-21.1-21.3c-13.9-8.3-32-12.5-45.5-15.6l-1.8-.4c-16.1-3.8-26.9-6.5-33.6-10.5c-1.4-.8-2.2-1.5-2.7-2c-.5-.4-.6-.7-.6-.7l0 0c0 0-.1-.1-.1-.5s-.1-1.2 0-2.5c.5-2.3 1.3-3.3 1.8-3.8z'
      
    ]
  };

  
    var faRectangleSd = faStandardDefinition;
  

  
  

  var faSkiBoot = {
    prefix: 'fasr',
    iconName: 'ski-boot',
    icon: [
      512,
      512,
      [],
      'e3cc',
      
      'M387.7 4.4l-4.1 23.7-45 262.4 128.1 64 13.3 6.6V376v88h8 24v48H488 456 32 2.6l5.9-28.8 88-432L100.4 32H120 334.3l2.1-12.1 4.1-23.7 47.3 8.1zM182.1 80H139.6L100.5 272h43.2L182.1 80zm32.6 0L172.5 291.1 169.9 304H156.8 94L61.4 464H432V390.8L301.3 325.5 290.3 320H224 208V288h16 66.4l11-64H256 240V192h16 50.8L326 80H214.7z'
      
    ]
  };

  

  
  

  var faFingerprint = {
    prefix: 'fasr',
    iconName: 'fingerprint',
    icon: [
      512,
      512,
      [],
      'f577',
      
      'M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5l15.6 18.2 36.4-31.3L450.2 89.2C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40 24H48V296 256zm458.5-52.9l-4.9-23.5-47 9.9 4.9 23.5c2.9 13.9 4.5 28.3 4.5 43.1v40 24h48V296 256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-32.3 0-62.5 8.7-88.5 23.8l32 37.3c17.1-8.4 36.3-13.1 56.6-13.1c70.7 0 128 57.3 128 128v24.9c0 34.6-2.8 69.1-8.4 103.1h48.6c5.2-34 7.8-68.5 7.8-103.1V256c0-97.2-78.8-176-176-176zM129.7 133.5C98.9 165.2 80 208.4 80 256v24.9c0 35-5.5 69.8-16.2 103.1h50.1c9.3-33.5 14.1-68.2 14.1-103.1V256c0-33 12.5-63.2 33.1-85.9l-31.4-36.7zM256 160c-53 0-96 43-96 96v24.9c0 46-7.6 91.6-22.5 135.1h46.3c13.4-43.7 20.3-89.2 20.3-135.1V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 45.6-5.5 91-16.4 135.1h45.2c10.1-44.2 15.2-89.5 15.2-135.1V256c0-53-43-96-96-96zm24 96H232v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3-3.3 8.6h51.4l2.6-6.7C267.9 411.9 280 346.7 280 280.9V256z'
      
    ]
  };

  

  
  

  var faPumpMedical = {
    prefix: 'fasr',
    iconName: 'pump-medical',
    icon: [
      448,
      512,
      [],
      'e06a',
      
      'M136 0H248h24V24 40h64 9.9l7 7 56 56 17 17L392 153.9l-17-17-49-49H272v40H224V48H160v80H112V24 0h24zM80.1 512H32l3.3-48L56 160H328l20.7 304 3.3 48H303.9 80.1zm220.5-48L283.2 208H100.8L83.4 464H300.6zM216 296v16h16 24v48H232 216v16 24H168V376 360H152 128V312h24 16V296 272h48v24z'
      
    ]
  };

  

  
  

  var faLocationMinus = {
    prefix: 'fasr',
    iconName: 'location-minus',
    icon: [
      384,
      512,
      ["map-marker-minus"],
      'f609',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zM120 168H264h24v48H264 120 96V168h24z'
      
    ]
  };

  
    var faMapMarkerMinus = faLocationMinus;
  

  
  

  var faSlidersUp = {
    prefix: 'fasr',
    iconName: 'sliders-up',
    icon: [
      512,
      512,
      ["sliders-v"],
      'f3f1',
      
      'M120 0H72V24 80H64 16v48 64 48H64h8V488v24h48V488 240h8 48V192 128 80H128h-8V24 0zm8 128v64H64V128h64zM288 320v64H224V320h64zm-64-48H176v48 64 48h48 8v56 24h48V488 432h8 48V384 320 272h48 8V488v24h48V488 272h8 48V224 160 112H448h-8V24 0H392V24v88h-8H336v48 64 48H288h-8V24 0H232V24 272h-8zM384 160h64v64H384V160z'
      
    ]
  };

  
    var faSlidersV = faSlidersUp;
  

  
  

  var faBridgeCircleCheck = {
    prefix: 'fasr',
    iconName: 'bridge-circle-check',
    icon: [
      640,
      512,
      [],
      'e4c9',
      
      'M56 32H32V80H56h48v64H56 32v48H56h48 48 80 48H496h88 24V144H584 536V80h40 24V32H576 56zM338 290.3c7.4-15 16.9-28.9 28.1-41.1c-14.2-5.9-29.8-9.2-46.1-9.2c-66.3 0-120 53.7-120 120v72H152V336c0-53-43-96-96-96H32v48H56c26.5 0 48 21.5 48 48V456v24h24 96 24V456 360c0-39.8 32.2-72 72-72c6.2 0 12.3 .8 18 2.3zM488 80v64H408V80h80zM360 80v64H280V80h80zM232 80v64H152V80h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faCalculatorSimple = {
    prefix: 'fasr',
    iconName: 'calculator-simple',
    icon: [
      512,
      512,
      ["calculator-alt"],
      'f64c',
      
      'M280 0V24 232H488h24v48H488 280V488v24H232V488 280H24 0V232H24 232V24 0h48zM400 32h24V56 88h32 24v24 24H456 424v32 24H400 376V168 136H344 320V112 88h24 32V56 32h24zM72.4 326.5l17 17L112 366.1l22.6-22.6 17-17 33.9 33.9-17 17L145.9 400l22.6 22.6 17 17-33.9 33.9-17-17L112 433.9 89.4 456.6l-17 17L38.5 439.6l17-17L78.1 400 55.4 377.4l-17-17 33.9-33.9zM64 88h96 24v48H160 64 40V88H64zM352 336h96 24v48H448 352 328V336h24zm0 80h96 24v48H448 352 328V416h24z'
      
    ]
  };

  
    var faCalculatorAlt = faCalculatorSimple;
  

  
  

  var faClosedCaptioningSlash = {
    prefix: 'fasr',
    iconName: 'closed-captioning-slash',
    icon: [
      640,
      512,
      [],
      'e135',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-12.9-10V432 80 32H560 80 70.5L48.4 14.8zm84 65.2H560V412l-91.4-71c14.9-7.8 27.5-19.5 36.5-33.6l-40.5-25.7C456 295.1 441 304 424 304c-1.1 0-2.2 0-3.2-.1L378.4 271c-1.6-4.7-2.4-9.8-2.4-15c0-26.5 21.5-48 48-48c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-46.9-44.6-81.1-44.6c-45.4 0-83.4 31.5-93.4 73.9L302 211.7l11.1-7.1c-16.4-25.8-44.9-43.4-77.6-44.6L132.4 80zM32 432v48H80 487.4l-60.9-48H80V159L32 121.2V432zM136 256c0 53 43 96 96 96c24.1 0 46.2-8.9 63-23.6l-39.1-30.8c-7 4.1-15.2 6.4-23.9 6.4c-26.5 0-48-21.5-48-48c0-4.7 .7-9.2 1.9-13.5l-39.1-30.8C139.9 224.9 136 240 136 256z'
      
    ]
  };

  

  
  

  var faMicrophoneLinesSlash = {
    prefix: 'fasr',
    iconName: 'microphone-lines-slash',
    icon: [
      640,
      512,
      ["microphone-alt-slash"],
      'f539',
      
      'M472.4 344c15-25.9 23.6-56 23.6-88V216 192H448v24 40c0 21-5 40.7-14 58.2l-25.9-20.1c5.1-11.7 7.9-24.6 7.9-38.1V48 0H368 272 224V48 151.1L48.4 14.8 29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7L472.4 344zM272 188.4V48h96V96H336 320v32h16 32v32H336 320v32h16 32v64c0 2.2-.2 4.4-.4 6.6L272 188.4zm86.2 189.8C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7l-48-37.8V216v40c0 89.1 66.2 162.7 152 174.4V464H248 224v48h24 72 72 24V464H392 344V430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z'
      
    ]
  };

  
    var faMicrophoneAltSlash = faMicrophoneLinesSlash;
  

  
  

  var faIcons = {
    prefix: 'fasr',
    iconName: 'icons',
    icon: [
      512,
      512,
      ["heart-music-camera-bolt"],
      'f86d',
      
      'M125.5 21.5C111.7 7.7 92.8 0 73.3 0C33.2 0 0 32.5 0 72.6c0 20.1 8.3 39.2 22.9 52.9L128 224l105.1-98.5C247.7 111.8 256 92.6 256 72.6C256 32.5 222.8 0 182.7 0c-19.5 0-38.5 7.7-52.3 21.5L128 24l-2.5-2.5zM128 158.2L55.8 90.5c-5-4.6-7.8-11.1-7.8-17.9C48 59.6 59.1 48 73.3 48c7 0 13.7 2.8 18.3 7.5l33.7-33.7L91.6 55.5l2.5 2.5L128 91.9l33.9-33.9 2.5-2.5c4.6-4.6 11.4-7.5 18.3-7.5C196.9 48 208 59.6 208 72.6c0 6.8-2.8 13.3-7.8 17.9L128 158.2zM224 288l-16-32H80L64 288H48 0v48V464v48H48 240h48V464 336 288H240 224zm16 48V464H48V336H64 93.7l13.3-26.5 2.7-5.5h68.7l2.7 5.5L194.3 336H224h16zm-48 56a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM457.1 256L320 400l72.2 10.5L374.9 512 512 368l-72.2-10.5L457.1 256zM288 256c35.3 0 64-21.5 64-48V83.7L464 61.3v68.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V32 2.7L483.3 8.5l-160 32L304 44.3V64v97.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48z'
      
    ]
  };

  
    var faHeartMusicCameraBolt = faIcons;
  

  
  

  var faSoap = {
    prefix: 'fasr',
    iconName: 'soap',
    icon: [
      512,
      512,
      [129532],
      'e06e',
      
      'M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 192H209.1c2.5 17.7 9.2 34 18.9 48H48V464H464V240H411.9c9.8-14 16.4-30.3 18.9-48H464h48v48V464v48H464 48 0V464 240 192H48zm80 96H320h64 32v32 64 32H384 128 96V384 320 288h32zm0 96H384V320H128v64zM320 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faAtom = {
    prefix: 'fasr',
    iconName: 'atom',
    icon: [
      512,
      512,
      [9883],
      'f5d2',
      
      'M306.3 417.2c-16.3-4.7-33.1-10.9-50.3-18.4c-17.1 7.5-34 13.6-50.3 18.4C224.1 455.5 243.1 464 256 464s31.9-8.5 50.3-46.8zM293 325.7c14.8-8.9 28.7-18.1 41.4-27.6c1-13.5 1.6-27.6 1.6-42.1s-.5-28.6-1.6-42.1c-12.8-9.4-26.6-18.7-41.4-27.6c-12.5-7.5-24.9-14.2-37-20.2c-12.1 6-24.5 12.7-37 20.2c-14.8 8.9-28.7 18.1-41.4 27.6c-1 13.5-1.6 27.6-1.6 42.1s.5 28.6 1.6 42.1c12.8 9.4 26.6 18.7 41.4 27.6c12.5 7.5 24.9 14.2 37 20.2c12.1-6 24.5-12.7 37-20.2zm120.5-32.2c-10.2 10.2-21.3 20.2-33.4 29.9c-2.4 20.1-5.8 39.2-10.3 57c37.2 2.2 51.9-9.1 57.8-19.7c6.5-11.7 8.2-32.8-14.1-67.2zM469.6 128c20.7 37.1 9.4 82.8-23.6 128c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2zM84.4 360.7c5.9 10.6 20.6 22 57.8 19.7c-4.5-17.8-7.9-36.9-10.3-57c-12-9.7-23.2-19.8-33.4-29.9C76.2 327.8 77.8 349 84.4 360.7zM98.5 218.5c10.2-10.2 21.3-20.2 33.4-29.9c2.4-20.1 5.8-39.2 10.3-57c-37.2-2.3-51.9 9.1-57.8 19.7c-6.5 11.7-8.2 32.8 14.1 67.2zM256 113.2c17.1-7.5 34-13.6 50.3-18.4C287.9 56.5 268.9 48 256 48s-31.9 8.5-50.3 46.8c16.3 4.7 33.1 10.9 50.3 18.4zm124.2 75.4c12 9.7 23.2 19.8 33.4 29.9c22.3-34.3 20.6-55.5 14.1-67.2c-5.9-10.6-20.6-22-57.8-19.7c4.5 17.8 7.9 36.9 10.3 57zM216 256l40-40 40 40-40 40-40-40z'
      
    ]
  };

  

  
  

  var faNfc = {
    prefix: 'fasr',
    iconName: 'nfc',
    icon: [
      448,
      512,
      [],
      'e1f7',
      
      'M400 80V432H48V80H400zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM272 256c0-17.8-9.7-33.3-24-41.6V160h72V352H128V160h8 24V112H136 104 80v24V376v24h24H344h24V376 136 112H344 224 200v24 78.4c-14.3 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48z'
      
    ]
  };

  

  
  

  var faFaceGlasses = {
    prefix: 'fasr',
    iconName: 'face-glasses',
    icon: [
      512,
      512,
      [],
      'e377',
      
      'M256 464C141.1 464 48 370.9 48 256c0-22.3 3.5-43.8 10-64h6v96 16H80 224h16V288 192h32v96 16h16H432h16V288 192h6c6.5 20.2 10 41.7 10 64c0 114.9-93.1 208-208 208zM256 0C148.6 0 56.6 66.2 18.6 160H16 0v32H8.1C2.8 212.5 0 233.9 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.1-2.8-43.5-8.1-64H512V160H496h-2.6C455.4 66.2 363.4 0 256 0zM240 160V144H224 80.7c37-57.7 101.7-96 175.3-96s138.3 38.3 175.3 96H288 272v16H240zm16 256c61.9 0 112-36.8 132-66.7L348 322.7C336 340.8 300.1 368 256 368s-80-27.2-92-45.3L124 349.3c19.9 29.9 70 66.7 132 66.7zm48-144V176H416v96H304zM96 176H208v96H96V176zm96.4 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faRightFromBracket = {
    prefix: 'fasr',
    iconName: 'right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out-alt"],
      'f2f5',
      
      'M288 288l48 0 0 48 0 28.1L444.1 256 336 147.9l0 28.1 0 48-48 0-80 0 0 64 80 0zm190.1 1.9L352 416l-16 0-48 0 0-32 0-16 0-32-48 0-32 0-48 0 0-48 0-64 0-48 48 0 32 0 48 0 0-32 0-16 0-32 48 0 16 0L478.1 222.1 512 256l-33.9 33.9zM168 80L48 80l0 352 120 0 24 0 0 48-24 0L24 480 0 480l0-24L0 56 0 32l24 0 144 0 24 0 0 48-24 0z'
      
    ]
  };

  
    var faSignOutAlt = faRightFromBracket;
  

  
  

  var faFilms = {
    prefix: 'fasr',
    iconName: 'films',
    icon: [
      576,
      512,
      [],
      'e17a',
      
      'M256 264V232H416v32 72H256V264zm0-80V152 80H416v72 32H256zM440 32H416 256 232 208 144 96V80v48 24 24 64 24 24 48 48h48 64 24 24H416h24 24 64 48V336 288 264 240 176 152 128 80 32H528 464 440zM144 80h64v48H144V80zm0 96h64v32 32H144V176zm0 112h64v48H144V288zm384 48H464V288h64v48zm0-96H464V208 176h64v64zm0-112H464V80h64v48zM48 120V96H0v24V456v24H24 456h24V432H456 48V120z'
      
    ]
  };

  

  
  

  var faDoorOpen = {
    prefix: 'fasr',
    iconName: 'door-open',
    icon: [
      576,
      512,
      [],
      'f52b',
      
      'M320 0L272 12 64 64V464H24 0v48H24 64 96h16H272h48V464 49.5 0zM272 61.5V464H112V101.5l160-40zM224 288c13.2 0 24-14.4 24-32s-10.8-32-24-32s-24 14.4-24 32s10.7 32 24 32zM352 112H464V488v24h24 64 24V464H552 512V88 64H488 352v48z'
      
    ]
  };

  

  
  

  var faShovel = {
    prefix: 'fasr',
    iconName: 'shovel',
    icon: [
      512,
      512,
      [],
      'f713',
      
      'M350.1 33.9L384 0l33.9 33.9 60.1 60.1L512 128l-33.9 33.9-35.5 35.5c-17 17-40 26.5-64 26.5c-16.3 0-31.6-4.3-44.7-11.8L233 313l37.1 37.1L304 384l-33.9 33.9L176 512H48 0V464 336l94.1-94.1L128 208l33.9 33.9L199 279 299.8 178.2C292.3 165 288 149.8 288 133.5c0-24 9.5-47 26.5-64l35.5-35.5zM444.1 128L384 67.9l-35.5 35.5c-8 8-12.5 18.8-12.5 30.1c0 23.5 19 42.5 42.5 42.5c11.3 0 22.1-4.5 30.1-12.5L444.1 128zM48 464H156.1l80-80L128 275.9l-80 80V464z'
      
    ]
  };

  

  
  

  var faFaceIcicles = {
    prefix: 'fasr',
    iconName: 'face-icicles',
    icon: [
      512,
      512,
      [],
      'e37c',
      
      'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 1.5 .1 3 .4 4.5L488 512l23.6-251.5c.3-1.5 .4-3 .4-4.5C512 114.6 397.4 0 256 0S0 114.6 0 256c0 2.1 .3 4 .7 6L24 448 47.3 262c.5-1.9 .7-3.9 .7-6zm96 98.7V320h32v48H157.3L144 354.7zM208 368V320h32v48H208zm64 0V320h32v48H272zm82.7 0H336V320h32v34.7L354.7 368zM400 320V288H368 144 112v32 48l32 32H284.7l14 48 16-48h33.6l14.4 80 19.3-93.9L400 368V320zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 512c23.8 0 46.9-3.3 68.8-9.4l-2-19.4-.3-3.3H301.3 296 271l-4.1-16.3c-3.6 .2-7.3 .3-10.9 .3c-79.8 0-149.1-44.9-184-110.9l-6.2 74.3C112.7 479.3 180.5 512 256 512zm151.3-49.5c12.8-9.4 24.7-20 35.6-31.6l-4.7-74.6c-6.7 12.2-14.6 23.6-23.5 34.1l-7.4 72z'
      
    ]
  };

  

  
  

  var faCircleMinus = {
    prefix: 'fasr',
    iconName: 'circle-minus',
    icon: [
      512,
      512,
      ["minus-circle"],
      'f056',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H160v48h24H328h24V232H328 184z'
      
    ]
  };

  
    var faMinusCircle = faCircleMinus;
  

  
  

  var faFolderArrowDown = {
    prefix: 'fasr',
    iconName: 'folder-arrow-down',
    icon: [
      512,
      512,
      ["folder-download"],
      'e053',
      
      'M224 32l48 64H464h48v48V432v48H464 48 0V432 80 32H48 224zm48 112H248l-14.4-19.2L200 80H48V432H464V144H272zm8 56V302.1l31-31 17-17L361.9 288l-17 17-72 72-17 17-17-17-72-72-17-17L184 254.1l17 17 31 31V200 176h48v24z'
      
    ]
  };

  
    var faFolderDownload = faFolderArrowDown;
  

  
  

  var faSortDown = {
    prefix: 'fasr',
    iconName: 'sort-down',
    icon: [
      320,
      512,
      ["sort-desc"],
      'f0dd',
      
      'M48 288H0v48L160 480 320 336V288H272 48zm200.2 48L160 415.4 71.8 336H248.2z'
      
    ]
  };

  
    var faSortDesc = faSortDown;
  

  
  

  var faBarcodeScan = {
    prefix: 'fasr',
    iconName: 'barcode-scan',
    icon: [
      640,
      512,
      [],
      'f465',
      
      'M112 32H64V192h48V32zM64 480h48V320H64V480zm96 0h32V320H160V480zm64 0h48V320H224V480zm0-288h48V32H224V192zM336 480h48V320H336V480zm0-288h48V32H336V192zM464 480h32V320H464V480zm0-288h32V32H464V192zm64 288h48V320H528V480zm0-288h48V32H528V192zm-368 0h32V32H160V192zM0 232v48l640 0V232L0 232z'
      
    ]
  };

  

  
  

  var faMobileSignal = {
    prefix: 'fasr',
    iconName: 'mobile-signal',
    icon: [
      512,
      512,
      [],
      'e1ef',
      
      'M48 48H304V312.8c14.5-15.1 30.6-28.6 48-40.3V48 0H304 48 0V48 464v48H48 224c0-16.4 1.4-32.4 4-48H48V48zm96 352H128v32h16 64 16V400H208 144zm368-96V256c-141.4 0-256 114.6-256 256h48c0-114.9 93.1-208 208-208zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 0c0-61.9 50.1-112 112-112V352c-88.4 0-160 71.6-160 160h48z'
      
    ]
  };

  

  
  

  var faArrowsUpToLine = {
    prefix: 'fasr',
    iconName: 'arrows-up-to-line',
    icon: [
      576,
      512,
      [],
      'e4c2',
      
      'M24 80l528 0 24 0 0-48-24 0L24 32 0 32 0 80l24 0zM40 273.9l17-17 47-47L104 456l0 24 48 0 0-24 0-246.1 47 47 17 17L249.9 240l-17-17-88-88-17-17-17 17L23 223l-17 17L40 273.9zm320 0l17-17 47-47L424 456l0 24 48 0 0-24 0-246.1 47 47 17 17L569.9 240l-17-17-88-88-17-17-17 17-88 88-17 17L360 273.9z'
      
    ]
  };

  

  
  

  var faFork = {
    prefix: 'fasr',
    iconName: 'fork',
    icon: [
      512,
      512,
      ["utensil-fork"],
      'f2e3',
      
      'M512 136l-34.3-34.3L376.8 236.3c-2 2.6-4.1 5.1-6.4 7.4l-1.9 1.9C356.7 257.4 340.7 264 324 264c-16.4 0-32.2-6.4-44-17.9L265.9 232c-11.5-11.7-17.9-27.5-17.9-44c0-16.7 6.6-32.7 18.4-44.5l1.9-1.9c2.3-2.3 4.8-4.5 7.4-6.4L410.3 34.3 376 0 246.9 96.8c-4.4 3.3-8.6 7-12.6 10.9l-1.9 1.9c-20.8 20.8-32.5 49-32.5 78.4c0 24.5 8.1 48.1 22.8 67.3L18.2 459.8l-17 17 33.9 33.9 17-17L256.7 289.2C275.9 303.9 299.5 312 324 312c29.4 0 57.6-11.7 78.4-32.5l1.9-1.9c3.9-3.9 7.6-8.1 10.9-12.6L512 136l0 0zM457 89l4-4L427 51l-4 4L307 171l-17 17L324 221.9l17-17L457 89z'
      
    ]
  };

  
    var faUtensilFork = faFork;
  

  
  

  var faUfo = {
    prefix: 'fasr',
    iconName: 'ufo',
    icon: [
      640,
      512,
      [128760],
      'e047',
      
      'M176.6 246.3c-17.5 16.4-17.5 16.4-17.5 16.5l0 0 0 .1 .1 .1 .3 .3c.2 .2 .4 .4 .7 .7c.6 .5 1.3 1.2 2.2 2.1c1.8 1.6 4.3 3.7 7.6 6.2c6.6 4.8 16.1 10.9 29.1 16.8c26.1 11.9 65.3 23 120.8 23s94.7-11.1 120.8-23c13-5.9 22.6-12 29.1-16.8c3.3-2.4 5.8-4.5 7.6-6.2c.9-.8 1.6-1.5 2.2-2.1c.3-.3 .5-.5 .7-.7l.3-.3 .1-.1 0-.1 0 0c0 0 0 0-17.5-16.5l17.5 16.4c3.7-3.9 6-9 6.4-14.4c.5-5.8 .7-11.6 .6-17.2c30 8.9 54.6 19.9 72.5 31.8c24.1 16.2 31.5 30.9 31.5 41.6c0 7.9-3.8 17.7-15.8 29.1c-12 11.5-30.8 23-55.8 33.1C470.3 387 399.4 400 320 400s-150.3-13-200.3-33.2c-25.1-10.1-43.8-21.6-55.8-33.1C51.8 322.2 48 312.4 48 304.5c0-10.7 7.4-25.4 31.5-41.6c17.9-12 42.4-23 72.5-31.8c-.1 5.7 .1 11.4 .6 17.2c.5 5.4 2.7 10.5 6.4 14.4l17.5-16.4zm302.8-67.2C456.8 110.9 392.6 64 320 64s-136.8 46.9-159.4 115.1c-42.7 10.5-80 25.4-107.8 44C23.4 242.9 0 270.2 0 304.5c0 25.1 12.7 46.7 30.7 63.9c17.9 17.1 42.6 31.4 71 42.9C158.8 434.3 236 448 320 448s161.2-13.7 218.3-36.7c28.5-11.5 53.1-25.8 71-42.9c18-17.1 30.7-38.7 30.7-63.9c0-34.3-23.4-61.7-52.8-81.4c-27.8-18.6-65.1-33.5-107.8-44zM440 234.6c-4.1 2.9-10.4 6.8-19.1 10.8c-19.6 8.9-52 18.7-100.9 18.7s-81.3-9.7-100.9-18.7c-8.7-4-15-7.9-19.1-10.8C199.2 164.7 255 112 320 112s120.8 52.7 120 122.6zM96 312l32 32 32-32-32-32L96 312zm192 40l32 32 32-32-32-32-32 32zm224-72l-32 32 32 32 32-32-32-32z'
      
    ]
  };

  

  
  

  var faTextSize = {
    prefix: 'fasr',
    iconName: 'text-size',
    icon: [
      640,
      512,
      [],
      'f894',
      
      'M24 32H0V56v72 24H48V128 80H168l0 352H120 96v48h24H264h24V432H264 216l0-352H336v48 24h48V128 56 32H360 24zM336 224H312v24 48 24h48V296 272h96l0 160H424 400v48h24H536h24V432H536 504l0-160h88v24 24h48V296 248 224H616 336z'
      
    ]
  };

  

  
  

  var faSunHaze = {
    prefix: 'fasr',
    iconName: 'sun-haze',
    icon: [
      640,
      512,
      [],
      'f765',
      
      'M257.1 23.2L320 57.1l62.9-33.9L426 0l14.1 46.9 20.5 68.4 68.4 20.5L576 150l-23.2 43.1L518.9 256l0 0H464.4l0 0 12.3-22.8L505.8 179l-59-17.7-24.8-7.4-7.4-24.8L397 70.2 342.8 99.4 320 111.6 297.2 99.4 243 70.2l-17.7 59-7.4 24.8-24.8 7.4-59 17.7 29.2 54.2L175.6 256l0 0H121.1l0 0L87.2 193.1 64 150l46.9-14.1 68.4-20.5 20.5-68.4L214 0l43.1 23.2zM432 256v0H384v0c0-35.3-28.7-64-64-64s-64 28.7-64 64v0H208v0c0-61.9 50.1-112 112-112s112 50.1 112 112zm184 32h24v48H616 504 480V288h24H616zm-208 0h24v48H408 88 64V288H88 408zm168 88v48H552 24 0V376H24 552h24zM88 464H200h24v48H200 88 64V464H88zm208 0H616h24v48H616 296 272V464h24z'
      
    ]
  };

  

  
  

  var faVolleyball = {
    prefix: 'fasr',
    iconName: 'volleyball',
    icon: [
      512,
      512,
      [127952,"volleyball-ball"],
      'f45f',
      
      'M378.8 423.9l-5.4-.7L191.6 399.7l-5.1 52.4c21.7 7.7 45.1 11.9 69.5 11.9c45.9 0 88.4-14.9 122.8-40.1zm63.4-75c12.1-24.2 19.6-51 21.4-79.4l-53.6 24.4-6 2.7-6.6-.7L267.1 281.4l-53.5 72.8 160 20.7 68.6-25.9zm18.4-130.8C448 149.7 401.9 93 340 65.7l2.1 5.1 70.5 169.1 47.9-21.8zM140.5 429l5.7-58.7 .6-6.6 3.9-5.3 77.6-105.5-36.2-82.7L94.3 298.4 82.5 370.7c15.3 23.1 35.1 42.9 58.1 58.3zM49.2 278.3l3.3-4.3L163.7 128.4 121 97.8C76.3 135.9 48 192.7 48 256c0 7.6 .4 15 1.2 22.3zM163.9 69.5l48 34.3 5.4 3.8 2.6 6 52.6 120 89.8 10-62-148.9L243.4 48.4c-28.4 1.7-55.4 9.1-79.6 21.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faVolleyballBall = faVolleyball;
  

  
  

  var faBuildingCircleArrowRight = {
    prefix: 'fasr',
    iconName: 'building-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e4d1',
      
      'M48 48H336V294.6c11.1-24.3 27.7-45.5 48-62.3V48 0H336 48 0V48 464v48H48 336h48v-8.2c-20.3-16.8-36.9-38.1-48-62.3V464H240V352H144V464H48V48zM88 88v80h80V88H88zm208 0H216v80h80V88zM88 216v80h80V216H88zm208 0H216v80h80V216zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 289.4l11.3 11.3 56 56L582.6 368l-11.3 11.3-56 56L504 446.6 481.4 424l11.3-11.3L521.4 384H432 416V352h16 89.4l-28.7-28.7L481.4 312 504 289.4z'
      
    ]
  };

  

  
  

  var faRectangleHistory = {
    prefix: 'fasr',
    iconName: 'rectangle-history',
    icon: [
      512,
      512,
      [],
      'e4a2',
      
      'M464 208L48 208l0 256 416 0 0-256zm48-48l0 48 0 256 0 48-48 0L48 512 0 512l0-48L0 208l0-48 48 0 416 0 48 0zM464 80l0 48L48 128l0-48 416 0zM416 0l0 48L96 48 96 0 416 0z'
      
    ]
  };

  

  
  

  var faTally4 = {
    prefix: 'fasr',
    iconName: 'tally-4',
    icon: [
      640,
      512,
      [],
      'e297',
      
      'M152 64V40H104V64 448v24h48V448 64zm128 0V40H232V64 448v24h48V448 64zM408 40H360V64 448v24h48V448 64 40zM536 64V40H488V64 448v24h48V448 64z'
      
    ]
  };

  

  
  

  var faAnchorCircleCheck = {
    prefix: 'fasr',
    iconName: 'anchor-circle-check',
    icon: [
      640,
      512,
      [],
      'e4aa',
      
      'M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216 192v48h24 48V464H120V352h72L96 256 0 352H72V488v24H96 288 394.8c-18.3-12.9-34.1-29.2-46.3-48H312V240h48 15.2c2.8-2.7 5.8-5.3 8.8-7.8V192H360 312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faMp3Player = {
    prefix: 'fasr',
    iconName: 'mp3-player',
    icon: [
      384,
      512,
      [],
      'f8ce',
      
      'M336 48V464H48V48H336zM48 0H0V48 464v48H48 336h48V464 48 0H336 48zM192 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM304 80H80V192H304V80z'
      
    ]
  };

  

  
  

  var faCalendarDays = {
    prefix: 'fasr',
    iconName: 'calendar-days',
    icon: [
      448,
      512,
      ["calendar-alt"],
      'f073',
      
      'M152 24V0H104V24 64H0v80 48V464v48H48 400h48V464 192 144 64H344V24 0H296V24 64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v56H320V408h80zm-128 0v56H176V408h96zm-144 0v56H48V408h80zM272 248H176V192h96v56z'
      
    ]
  };

  
    var faCalendarAlt = faCalendarDays;
  

  
  

  var faWifiFair = {
    prefix: 'fasr',
    iconName: 'wifi-fair',
    icon: [
      640,
      512,
      ["wifi-2"],
      'f6ab',
      
      'M151.9 321.6C196.1 280.9 255.1 256 320 256s123.9 24.9 168.1 65.6l32.5-35.3C467.9 237.7 397.4 208 320 208s-147.9 29.7-200.6 78.4l32.5 35.3zM320 480a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  
    var faWifi2 = faWifiFair;
  

  
  

  var faTirePressureWarning = {
    prefix: 'fasr',
    iconName: 'tire-pressure-warning',
    icon: [
      512,
      512,
      [],
      'f633',
      
      'M400 0V24 54.5c0 30.1 4.9 60 14.4 88.5l2.5 7.4c6.1 18.4 14.4 35.6 22.2 51.5c15 30.5 26.3 66.3 22 105.3c-4 36.7-22.3 79.2-70.5 124.8H121.4c-48.2-45.6-66.4-88.1-70.5-124.8c-4.3-39 7-74.8 22-105.3c7.8-15.8 16.1-33 22.2-51.5l2.5-7.4c9.5-28.6 14.4-58.4 14.4-88.5V24 0H64V24 54.5c0 24.9-4 49.7-11.9 73.4l-2.5 7.4c-5 15-11.9 29.6-19.7 45.4C12.7 215.5-2.5 260.9 3.2 312.4c5.5 49.7 30 102.1 84.8 154.1V512h48V480h48v32h48V480h48v32h48V480h48v32h48V466.5c54.8-51.9 79.3-104.3 84.8-154.1c5.7-51.5-9.5-96.9-26.7-131.8c-7.8-15.8-14.7-30.4-19.7-45.4l-2.5-7.4C452 104.2 448 79.4 448 54.5V24 0H400zM280 96H232v24V232v24h48V232 120 96zM232 288v48h48V288H232z'
      
    ]
  };

  

  
  

  var faDiceThree = {
    prefix: 'fasr',
    iconName: 'dice-three',
    icon: [
      448,
      512,
      [9858],
      'f527',
      
      'M48 80V432H400V80H48zM0 32H48 400h48V80 432v48H400 48 0V432 80 32zm128 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faBuildingUn = {
    prefix: 'fasr',
    iconName: 'building-un',
    icon: [
      384,
      512,
      [],
      'e4d9',
      
      'M48 48V464h96V352h96V464h96V48H48zM0 0H48 336h48V48 464v48H336 48 0V464 48 0zM168 328H88V248h80v80zm48-80h80v80H216V248zM112 96v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96 80h32V96v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V96 80h32V96zM224 80h8 9.9l4.4 8.8L272 140.2V96 80h32V96v96 16H288h-8-9.9l-4.4-8.8L240 147.8V192v16H208V192 96 80h16z'
      
    ]
  };

  

  
  

  var faRing = {
    prefix: 'fasr',
    iconName: 'ring',
    icon: [
      512,
      512,
      [],
      'f70b',
      
      'M0 224V200 160c21.3-32 102.4-96 256-96s234.7 64 256 96v40 24V352c-21.3 32-102.4 96-256 96S21.3 384 0 352V224zm464 43.3c-42.3 27-110.6 52.7-208 52.7s-165.7-25.7-208-52.7v67.4C70.8 357 135.3 400 256 400s185.2-43 208-65.3V267.3zM396 248c-34-13.4-80.1-24-140-24s-106 10.6-140 24c34 13.4 80.1 24 140 24s106-10.6 140-24zm52.5-28.4c6.4-4.7 11.5-9.1 15.4-13V200 177.3C441.2 155 376.7 112 256 112s-185.2 43-208 65.3L48 200v6.7c3.9 3.8 9 8.3 15.4 13C106.2 196.2 169.6 176 256 176s149.8 20.2 192.6 43.6z'
      
    ]
  };

  

  
  

  var faWaveSquare = {
    prefix: 'fasr',
    iconName: 'wave-square',
    icon: [
      640,
      512,
      [],
      'f83e',
      
      'M136 32h24H320h24V56 432H456V256 232h24H616h24v48H616 504V456v24H480 320 296V456 80H184V256v24H160 24 0V232H24 136V56 32z'
      
    ]
  };

  

  
  

  var faFileLines = {
    prefix: 'fasr',
    iconName: 'file-lines',
    icon: [
      384,
      512,
      [61686,128441,128462,"file-alt","file-text"],
      'f15c',
      
      'M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM120 256H96v48h24H264h24V256H264 120zm0 96H96v48h24H264h24V352H264 120z'
      
    ]
  };

  
    var faFileAlt = faFileLines;
  
    var faFileText = faFileLines;
  

  
  

  var faExplosion = {
    prefix: 'fasr',
    iconName: 'explosion',
    icon: [
      576,
      512,
      [],
      'e4e9',
      
      'M312 24V0H264V24 72 96h48V72 24zM24 464H0v48H24 552h24V464H552 389.2c-10.8-45.9-52-80-101.2-80s-90.4 34.1-101.2 80H24zm213.4 0c9-18.9 28.3-32 50.6-32s41.6 13.1 50.6 32H237.4zM32 336l29.5 48 29.5 48h56.4l-29.5-48H128h53.6l-5.9-53.3-4.9-43.8L198 304.4 252 339 270 277.5l17.6-59.9 10.2 35.6 24.9 87.3 58.1-69.7 54.6-65.5L401.8 322.8 384.4 384H448h10.1l-29.5 48h56.4l29.5-48L544 336H497.9 487.6 448l13.7-48 49.7-173.9L544 0 468 91.2 381.2 195.4 344 240l-16-55.8L312 128H264l-25.9 88L224 264l-42.1-27L164 225.4 112 192l6.8 61.5 3.8 34.5 5.3 48H88.4 79.7 32z'
      
    ]
  };

  

  
  

  var faDownLeftAndUpRightToCenter = {
    prefix: 'fasr',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
      512,
      512,
      ["compress-alt"],
      'f422',
      
      'M478.1 129.9l-4.1 4.1L440 168l6.1 6.1 27.9 27.9L480 208l-33.9 33.9L432 256H304 256V208 80l14.1-14.1L304 32l6.1 6.1 27.9 27.9L344 72l33.9-33.9 4.1-4.1L416 0l33.9 33.9 28.1 28.1L512 96l-33.9 33.9zM256 256v48V432l-14.1 14.1L208 480l-6.1-6.1-27.9-27.9L168 440l-33.9 33.9-4.1 4.1L96 512 62.1 478.1 33.9 449.9 0 416l33.9-33.9 4.1-4.1L72 344l-6.1-6.1L38.1 310.1 32 304l33.9-33.9L80 256H208h48zm150.1-54.1L372.1 168l33.9-33.9L444.1 96 416 67.9l-38.1 38.1L344 139.9l-33.9-33.9L304 99.9V208H412.1l-6.1-6.1zM105.9 310.1L139.9 344l-33.9 33.9L67.9 416 96 444.1l38.1-38.1L168 372.1l33.9 33.9 6.1 6.1V304H99.9l6.1 6.1z'
      
    ]
  };

  
    var faCompressAlt = faDownLeftAndUpRightToCenter;
  

  
  

  var faSquareUser = {
    prefix: 'fasr',
    iconName: 'square-user',
    icon: [
      448,
      512,
      [],
      'e283',
      
      'M400 80V432H373.3L336 320H112L74.7 432H48V80H400zM322.7 432H125.3l21.3-64H301.4l21.3 64zM48 32H0V80 432v48H48 400h48V432 80 32H400 48zM224 240a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z'
      
    ]
  };

  

  
  

  var faFaceHandPeeking = {
    prefix: 'fasr',
    iconName: 'face-hand-peeking',
    icon: [
      640,
      512,
      [129763],
      'e481',
      
      'M320 464c58.5 0 111.4-24.2 149.2-63.1h51.6c3.5 0 7.1-.1 10.6-.4C485.3 467.8 407.8 512 320 512c-105.9 0-196.8-64.3-235.7-156c11.3 3.2 23 4.9 34.9 4.9h21.2C176.4 422.6 243.4 464 320 464zm128-95.1v-32h32V328l-72 0 0-17.5 0-14.5h32 2.6H480v-8H452.4 448h-8H408l0-10.3 0 0V256h30 2 13.4l6 0h7.1l7.4 0 17.4 0V243.8l-12.1-8.7-4.9-3.5L463.7 224l-17-12.1-32-22.8 8.3-11.6L433.3 163l37.2 25.6 2.9 2 52.5 36.1 7.9 5.4 11.6 8V220.4l-8.2-8.2-19-19 0 0-3.6-3.6 1.8-1.8 3.8-3.8 0 0 17-17 5.7-5.7 22.6 22.6 .1 .1 22.4 22.4 .8 .8c36.4 37.2 36.1 96.9-.8 133.8c-10.2 10.2-22.4 17.8-35.7 22.5c-9.4 3.3-19.4 5.2-29.6 5.4c-.7 0-1.4 0-2 0H512 494.7 448zM407.3 144.4L390.4 168c-30.2 .9-54.4 25.6-54.4 56c0 25.4 16.9 46.8 40 53.7V296v14.5c-41-7.5-72-43.4-72-86.5c0-48.6 39.4-88 88-88c6.8 0 13.3 .8 19.7 2.2l-4.4 6.2zM320 48c-60.3 0-114.5 25.6-152.5 66.6l-3.6-3.6L135.6 82.7l-2.1-2.1C180.2 31 246.5 0 320 0c92 0 172.6 48.5 217.7 121.3l-17.4 17.4-17.7 17.7C467.4 91.8 398.8 48 320 48zM71 315.8c-6.9-4.1-13.4-9-19.1-14.8c-36.9-36.9-37.2-96.6-.8-133.8l.8-.8L113 105.3l0 0 5.6 5.6 17 17 5.7 5.7L130.8 144l-12.2 12.2-6.1 6.1L98.8 176h19.3 9.8H240v32H160v8h80v32l-80 0v8h80l.3 32H160v8.9h32v32l-66.9 0-5.9 0c-17.1 0-33.7-4.6-48.2-13.1zM384 400c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48s64 21.5 64 48zm32.4-176c0 6.1-2.3 11.8-6.1 16H374.5c-3.8-4.2-6.1-9.9-6.1-16c0-13.3 10.7-24 24-24s24 10.7 24 24z'
      
    ]
  };

  

  
  

  var faTheta = {
    prefix: 'fasr',
    iconName: 'theta',
    icon: [
      384,
      512,
      [],
      'f69e',
      
      'M56 256c0-55 16.6-103.9 42.1-138.4S157.2 64 192 64s68.3 19 93.9 53.6S328 201 328 256s-16.6 103.9-42.1 138.5S226.8 448 192 448s-68.3-19-93.9-53.5S56 311 56 256zM192 16C138.4 16 91.9 45.4 59.6 89S8 191.7 8 256s19.3 123.4 51.6 167s78.9 73 132.4 73s100.1-29.4 132.4-73S376 320.3 376 256s-19.3-123.4-51.6-167S245.6 16 192 16zM120 232H96v48h24H264h24V232H264 120z'
      
    ]
  };

  

  
  

  var faFonduePot = {
    prefix: 'fasr',
    iconName: 'fondue-pot',
    icon: [
      512,
      512,
      [129749],
      'e40d',
      
      'M379.6 163.5l-19 28.5H322.1l30.8-46.2-13.3-8.9L430.9 0l53.3 35.5L392.9 172.4l-13.3-8.9zM264.5 192h-33l9.2-36.8-15.5-3.9L263 0l62.1 15.5L287.3 166.8l-15.5-3.9L264.5 192zM192 272v48H144V272H128v80H80V272H48v48c0 61.9 50.1 112 112 112H288c61.9 0 112-50.1 112-112V272h-8H192zm256 0v48c0 52.3-25.1 98.8-64 128v40 24H336V488 472.7c-15.2 4.8-31.3 7.3-48 7.3H160c-16.7 0-32.8-2.6-48-7.3V488v24H64V488 448C25.1 418.8 0 372.3 0 320V272 224H48 392h8 16 32 40 24v48H488 448z'
      
    ]
  };

  

  
  

  var faRingDiamond = {
    prefix: 'fasr',
    iconName: 'ring-diamond',
    icon: [
      384,
      512,
      [],
      'e5ab',
      
      'M144 0H131.2L124 10.7l-32 48L83.9 70.9 91 83.7l31.8 57.2C51 168.6 0 238.4 0 320C0 426 86 512 192 512s192-86 192-192c0-81.6-51-151.4-122.8-179.1L293 83.7l7.1-12.8L292 58.7l-32-48L252.8 0H240 144zm68.8 129.1C206 128.4 199 128 192 128s-14 .4-20.8 1.1l-31.1-56L156.8 48h70.3l16.8 25.1-31.1 56zM48 320a144 144 0 1 1 288 0A144 144 0 1 1 48 320z'
      
    ]
  };

  

  
  

  var faRobotAstromech = {
    prefix: 'fasr',
    iconName: 'robot-astromech',
    icon: [
      512,
      512,
      [],
      'e2d2',
      
      'M256 0C185.3 0 128 57.3 128 128v16H56 32v24V410.3L2.5 469.3 0 474.3V480v8 24H24 136h24V488 415.1l22.1 24.8 7.2 8.1H200 312h10.8l7.2-8.1L352 415.1V488v24h24H488h24V488v-8-5.7l-2.5-5.1L480 410.3V168 144H456 384V128C384 57.3 326.7 0 256 0zM192 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 342.9V192H352V342.9L301.2 400H210.8L160 342.9zM112 192V352 464H58.8l18.6-37.3 2.5-5.1V416 192h32zm288 0h32V416v5.7l2.5 5.1L453.2 464H400V352 192zM208 224H192v32h16 96 16V224H304 208zm0 64H192v32h16 96 16V288H304 208z'
      
    ]
  };

  

  
  

  var faInfo = {
    prefix: 'fasr',
    iconName: 'info',
    icon: [
      192,
      512,
      [],
      'f129',
      
      'M128 32v80H48V32h80zM16 176H40 96h24v24V464h48 24v48H168 24 0V464H24 72V224H40 16V176z'
      
    ]
  };

  

  
  

  var faSalad = {
    prefix: 'fasr',
    iconName: 'salad',
    icon: [
      512,
      512,
      [129367,"bowl-salad"],
      'f81e',
      
      'M416 96c2.6 0 5.2 .1 7.8 .2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4C43 64 0 107 0 160s43 96 96 96h73.4L84.7 171.3 73.4 160 96 137.4l11.3 11.3L208 249.4V112 96h32v16V256h52c-2.6-10.2-4-21-4-32c0-70.7 57.3-128 128-128zM144 433.5l-27.4-13C82.9 404.5 58 373.4 50.4 336H461.6c-7.6 37.4-32.5 68.5-66.2 84.5l-27.4 13v30.3 .2H144v-.2V433.5zM1.7 336C9.8 392.6 46.1 440.1 96 463.8v.2 48h48H368h48V464v-.2c49.9-23.7 86.2-71.2 94.3-127.8c1.1-7.8 1.7-15.9 1.7-24V288H464 48 0v24c0 8.1 .6 16.2 1.7 24zM464 224c0 12.3-4.6 23.5-12.2 32h54.8c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32h54.8c-7.6-8.5-12.2-19.7-12.2-32c0-26.5 21.5-48 48-48s48 21.5 48 48z'
      
    ]
  };

  
    var faBowlSalad = faSalad;
  

  
  

  var faMessage = {
    prefix: 'fasr',
    iconName: 'message',
    icon: [
      512,
      512,
      ["comment-alt"],
      'f27a',
      
      'M208 480l-48 32V464v-9.7V416H112 48 0V368 48 0H48 464h48V48 368v48H464 304l-96 64zm0-57.7l69.4-46.2 12.1-8.1H304 464V48H48V368H160h48v48 6.3z'
      
    ]
  };

  
    var faCommentAlt = faMessage;
  

  
  

  var faCoffin = {
    prefix: 'fasr',
    iconName: 'coffin',
    icon: [
      384,
      512,
      [9904],
      'f6c6',
      
      'M140.3 464H243.7l87.5-309.7L248.5 48h-113L52.8 154.3 140.3 464zM280 512H104L0 144 112 0H272L384 144 280 512z'
      
    ]
  };

  

  
  

  var faStethoscope = {
    prefix: 'fasr',
    iconName: 'stethoscope',
    icon: [
      576,
      512,
      [129658],
      'f0f1',
      
      'M150.9 46l-22.5 8.4L80 72.6V200c0 57.4 46.6 104 104 104h8 8c57.4 0 104-46.6 104-104V72.6L255.6 54.5 233.1 46 250 1.1l22.5 8.4 64 24L352 39.4V56 200c0 78.5-59.5 143.1-135.8 151.1C219.9 414.1 272.1 464 336 464c66.3 0 120-53.7 120-120V268.3c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V344c0 92.8-75.2 168-168 168c-90.4 0-164.1-71.4-167.8-160.8C91.7 343.3 32 278.6 32 200V56 39.4l15.6-5.8 64-24L134 1.1 150.9 46zM480 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMin = {
    prefix: 'fasr',
    iconName: 'gauge-simple-min',
    icon: [
      512,
      512,
      ["tachometer-slowest"],
      'f62d',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-30.9-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6L117.6 228.2 97.7 214.6 70.6 254.3l19.8 13.6 110.2 75.4c-.4 2.9-.7 5.8-.7 8.8c0 30.9 25.1 56 56 56s56-25.1 56-56z'
      
    ]
  };

  
    var faTachometerSlowest = faGaugeSimpleMin;
  

  
  

  var faFaceHandYawn = {
    prefix: 'fasr',
    iconName: 'face-hand-yawn',
    icon: [
      512,
      512,
      [],
      'e379',
      
      'M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 60.5-25.8 115-67.1 153l15 15-22.6 22.6-52.3 52.3C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5V406.1C72.6 368.2 48 315 48 256zm208-48c-52.5 0-95.1 42.1-96 94.4h24 21.7l51.7-51.7L280 228.1l22.6 22.6 9.4 9.4 16-16 10.1 10.1C321.3 226.5 290.8 208 256 208zm-14.3-84.3l-30-37.5-18.7 15-80 64-18.7 15 30 37.5 18.7-15 80-64 18.7-15zm47.3 15l80 64 18.7 15 30-37.5-18.7-15-80-64-18.7-15-30 37.5 18.7 15zM302.6 296L280 273.4l-11.3 11.3L184 369.4v-15-20H144v20V384v20 12.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l48.8-48.8L366.6 424 344 401.4l-11.3 11.3-24 24-9.4-9.4 56-56L366.6 360 344 337.4l-11.3 11.3-56 56-9.4-9.4 72-72L350.6 312 328 289.4l-11.3 11.3-72 72-9.4-9.4 56-56L302.6 296z'
      
    ]
  };

  

  
  

  var faUserXmark = {
    prefix: 'fasr',
    iconName: 'user-xmark',
    icon: [
      640,
      512,
      ["user-times"],
      'f235',
      
      'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM99.5 352H348.5L383 464H65L99.5 352zM384 304H64L14.8 464 0 512H50.2 397.8 448l-14.8-48L384 304zM633.9 160L600 126.1l-17 17-47 47-47-47-17-17L438.1 160l17 17 47 47-47 47-17 17L472 321.9l17-17 47-47 47 47 17 17L633.9 288l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faUserTimes = faUserXmark;
  

  
  

  var faTextHeight = {
    prefix: 'fasr',
    iconName: 'text-height',
    icon: [
      576,
      512,
      [],
      'f034',
      
      'M24 32H0V56v72 24H48V128 80h88l0 352H88 64v48H88 232h24V432H232 184l0-352h88v48 24h48V128 56 32H296 24zM497 50.2l-17-17-17 17L402.2 111l-17 17 33.9 33.9 17-17L456 125.1V386.9L436.2 367l-17-17L385.3 384l17 17L463 461.8l17 17 17-17L557.8 401l17-17-33.9-33.9-17 17L504 386.9V125.1L523.8 145l17 17L574.7 128l-17-17L497 50.2z'
      
    ]
  };

  

  
  

  var faHeadSideGoggles = {
    prefix: 'fasr',
    iconName: 'head-side-goggles',
    icon: [
      512,
      512,
      ["head-vr"],
      'f6ea',
      
      'M112 381.2V448v16 48H96 64V480 464 381.2C26.7 343.1 4.3 292.9 .6 240H48.7c3.6 40.4 21.1 78.5 49.6 107.7l13.7 14v19.6zM224 48c-37.6 0-72.5 11.8-101.1 32h93.6C234 60.4 259.6 48 288 48H256 240 224zm159 0h1 24 24 32 48V96v96 48H464 432 408 384 288c-28.4 0-54-12.4-71.6-32H24 0V184 104 80H24 52.5C93.6 31.1 155.2 0 224 0h32c48.7 0 93.2 18.1 127 48zm81 224h48v16 16 32H496 480 464 448v48 16 16 32H416 400 368 320v16 16 16 16H288 272V464 448 400h48 80V336 288h48 16V272zM48 128v32H193.3c-.9-5.2-1.3-10.5-1.3-16s.5-10.8 1.3-16H48zM464 96H432v96h32V96zm-80 0H288c-26.5 0-48 21.5-48 48s21.5 48 48 48h96V96z'
      
    ]
  };

  
    var faHeadVr = faHeadSideGoggles;
  

  
  

  var faCircleL = {
    prefix: 'fasr',
    iconName: 'circle-l',
    icon: [
      512,
      512,
      [],
      'e114',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152V128H160v24V360v24h24H328h24V336H328 208V152z'
      
    ]
  };

  

  
  

  var faTrashCan = {
    prefix: 'fasr',
    iconName: 'trash-can',
    icon: [
      448,
      512,
      [61460,"trash-alt"],
      'f2ed',
      
      'M160 0H147.2L140 10.7 93.8 80H80 32 0v48H32V464v48H80 368h48V464 128h32V80H416 368 354.2L308 10.7 300.8 0H288 160zM296.5 80h-145l21.3-32H275.2l21.3 32zM80 464V128H368V464H80zm80-272V176H128v16V400v16h32V400 192zm80 0V176H208v16V400v16h32V400 192zm80 0V176H288v16V400v16h32V400 192z'
      
    ]
  };

  
    var faTrashAlt = faTrashCan;
  

  
  

  var faPhoneArrowUpRight = {
    prefix: 'fasr',
    iconName: 'phone-arrow-up-right',
    icon: [
      512,
      512,
      ["phone-arrow-up","phone-outgoing"],
      'e224',
      
      'M272.4 369.2l31.9 18.4 26-26 33.2-33.2L457.7 366l-17.8 97.9C225.4 459.7 52.3 286.6 48.1 72L146 54.2l37.7 94.2-33.2 33.2-26 26 18.4 31.9c31 53.8 75.8 98.6 129.6 129.6zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM303 175l-17 17L320 225.9l17-17 127-127V128v24h48V128 24 0H488 384 360V48h24 46.1L303 175z'
      
    ]
  };

  
    var faPhoneArrowUp = faPhoneArrowUpRight;
  
    var faPhoneOutgoing = faPhoneArrowUpRight;
  

  
  

  var faRectanglesMixed = {
    prefix: 'fasr',
    iconName: 'rectangles-mixed',
    icon: [
      576,
      512,
      [],
      'e323',
      
      'M272 80V208H48V80H272zM48 32H0V80 208v48H48 272h48V208 80 32H272 48zM528 80V336H432V80h96zM432 32H384V80 336v48h48 96 48V336 80 32H528 432zM112 352H288v80H112V352zM64 304v48 80 48h48H288h48V432 352 304H288 112 64z'
      
    ]
  };

  

  
  

  var faAt = {
    prefix: 'fasr',
    iconName: 'at',
    icon: [
      512,
      512,
      [61946],
      '40',
      
      'M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208h32v48H256C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v96 24H488 440c-36.9 0-69.6-17.8-90-45.4c-22 27.6-55.9 45.4-94 45.4c-66.3 0-120-53.7-120-120s53.7-120 120-120c27 0 51.9 8.9 72 24v-8h48v24 80 8c0 35.3 28.7 64 64 64h24V256c0-114.9-93.1-208-208-208zm72 208a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z'
      
    ]
  };

  

  
  

  var faTransporter7 = {
    prefix: 'fasr',
    iconName: 'transporter-7',
    icon: [
      512,
      512,
      [],
      'e2a8',
      
      'M480 64L464 32 448 64 416 80l32 16 16 32 16-32 32-16L480 64zM64 288L48 256 32 288 0 304l32 16 16 32 16-32 32-16L64 288zm56 176H96v48h24H392h24V464H392 120z'
      
    ]
  };

  

  
  

  var faBagel = {
    prefix: 'fasr',
    iconName: 'bagel',
    icon: [
      640,
      512,
      [129391],
      'e3d7',
      
      'M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c5.7-10.8 10.6-22.1 14.6-33.8L478.8 352l56.7-1.6 19-53.4 44.9-34.6-16-54.4 16-54.4L554.5 119l-19-53.4L478.8 64 432 32 385.2 64l-56.7 1.6-9.2 25.7c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zm-144 0c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64zM48 304a160 160 0 1 0 320 0A160 160 0 1 0 48 304zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm136-96l24-24 24 24-24 24-24-24zM96 296L72 272l24-24 24 24L96 296zm32 112l-24-24 24-24 24 24-24 24zM304 264l-24-24 24-24 24 24-24 24zM216 416l24-24 24 24-24 24-24-24zm88-8l-24-24 24-24 24 24-24 24zM192 304a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z'
      
    ]
  };

  

  
  

  var faLineHeight = {
    prefix: 'fasr',
    iconName: 'line-height',
    icon: [
      576,
      512,
      [],
      'f871',
      
      'M95.6 33.7l17 16.1 64 60.8 17.4 16.5-33.1 34.8-17.4-16.5L120 123.1V386.9L139.8 367l17-17L190.7 384l-17 17L113 461.8l-17 17-17-17L18.2 401l-17-17 33.9-33.9 17 17L72 386.9V125.1L52.2 145l-17 17L1.3 128l17-17L79 50.2 95.6 33.7zM248 72H552h24v48H552 248 224V72h24zm0 160H552h24v48H552 248 224V232h24zM224 392h24H552h24v48H552 248 224V392z'
      
    ]
  };

  

  
  

  var faWagonCovered = {
    prefix: 'fasr',
    iconName: 'wagon-covered',
    icon: [
      640,
      512,
      [],
      'f8ee',
      
      'M.2 1.3l33.2 2L248.7 16H391.3L606.6 3.6l33.2-1.9-8.6 32.1L567.3 272H576v48H554.4l0 0h-12c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96H286.9c-7.8 54.3-54.4 96-110.9 96c-61.9 0-112-50.1-112-112c0-31.3 12.9-59.7 33.6-80h-12l0 0H64V272h8.7L8.8 33.4 .2 1.3zM517.6 272L576.2 53.4 416 62.7 416 272H517.6zM272 272h96V64H272V272zM63.8 53.1L122.4 272H224V62.6L63.8 53.1zM160 416H114c5.8 22.5 23.5 40.2 46 46V416zm0-32V338c-22.5 5.8-40.2 23.5-46 46h46zm32 78c22.5-5.8 40.2-23.5 46-46H192v46zm0-124v46h46c-5.8-22.5-23.5-40.2-46-46zM448 462V416H402c5.8 22.5 23.5 40.2 46 46zm-46-78h46V338c-22.5 5.8-40.2 23.5-46 46zm124 32H480v46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46v46h46z'
      
    ]
  };

  

  
  

  var faCircleChevronRight = {
    prefix: 'fasr',
    iconName: 'circle-chevron-right',
    icon: [
      512,
      512,
      ["chevron-circle-right"],
      'f138',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm345 17l17-17-17-17L241 135l-17-17L190.1 152l17 17 87 87-87 87-17 17L224 393.9l17-17L345 273z'
      
    ]
  };

  
    var faChevronCircleRight = faCircleChevronRight;
  

  
  

  var faArrowsToCircle = {
    prefix: 'fasr',
    iconName: 'arrows-to-circle',
    icon: [
      640,
      512,
      [],
      'e4bd',
      
      'M52.2 18.2l-17-17L1.3 35.2l17 17L126.1 160H88 64v48H88h96 24V184 88 64H160V88v38.1L52.2 18.2zM621.8 52.2l17-17L604.8 1.3l-17 17L480 126.1V88 64H432V88v96 24h24 96 24V160H552 513.9L621.8 52.2zM126.1 352L18.2 459.8l-17 17 33.9 33.9 17-17L160 385.9V424v24h48V424 328 304H184 88 64v48H88h38.1zM480 385.9L587.8 493.8l17 17 33.9-33.9-17-17L513.9 352H552h24V304H552 456 432v24 96 24h48V424 385.9zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faFillDrip = {
    prefix: 'fasr',
    iconName: 'fill-drip',
    icon: [
      576,
      512,
      [],
      'f576',
      
      'M0 272l33.9 33.9L206.1 478.1 240 512l33.9-33.9L478.1 273.9 512 240l-33.9-33.9L305.9 33.9 272 0 238.1 33.9 161 111 73 23 56 6.1 22.1 40 39 57l88 88L33.9 238.1 0 272zm161-93.1L191 209l17 17L241.9 192l-17-17L194.9 145 272 67.9 444.1 240l-48 48H83.9l-16-16L161 178.9zM512 320l-55.7 97.4c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L512 320z'
      
    ]
  };

  



export {

  faTurnUp,
  
  faLevelUpAlt,
  

  faMessageText,
  
  faCommentAltText,
  

  faSquareZ,
  

  faPersonCircleCheck,
  

  faHandHoldingMedical,
  

  faGraduationCap,
  
  faMortarBoard,
  

  faMessageMiddle,
  
  faCommentMiddleAlt,
  

  faVideo,
  
  faVideoCamera,
  

  faSquareSlidersVertical,
  
  faSlidersVSquare,
  

  faPlusMinus,
  

  faBulldozer,
  

  faBarcode,
  

  faFileMp4,
  

  faShieldKeyhole,
  

  faReflectVertical,
  

  faSquareShareNodes,
  
  faShareAltSquare,
  

  faComet,
  

  faJetFighter,
  
  faFighterJet,
  

  faPageCaretUp,
  
  faFileCaretUp,
  

  faHandshakeSimple,
  
  faHandshakeAlt,
  

  faEyes,
  

  faCircleJ,
  

  faGalleryThumbnails,
  

  faHandPointLeft,
  

  faPineapple,
  

  faCloudQuestion,
  

  faFaceWoozy,
  

  faKipSign,
  

  faFileGif,
  

  faMasksTheater,
  
  faTheaterMasks,
  

  faStapler,
  

  faD,
  

  faBedFront,
  
  faBedAlt,
  

  faHorizontalRule,
  

  faTrowel,
  

  faUmbrella,
  

  faCameraCctv,
  
  faCctv,
  

  faGrid2,
  

  faSack,
  

  faCircleT,
  

  faBuildingColumns,
  
  faBank,
  
  faInstitution,
  
  faMuseum,
  
  faUniversity,
  

  faPersonMilitaryPointing,
  

  faUsersGear,
  
  faUsersCog,
  

  faMagnifyingGlassDollar,
  
  faSearchDollar,
  

  faX,
  

  faSkullCow,
  

  faComputerSpeaker,
  

  faFerrisWheel,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faCircleWaveformLines,
  
  faWaveformCircle,
  

  faFaceNoseSteam,
  

  faTurkishLiraSign,
  
  faTry,
  
  faTurkishLira,
  

  faPrint,
  

  faCommentXmark,
  
  faCommentTimes,
  

  faFaceSmileRelaxed,
  

  faArrowsSpin,
  

  faExclamation,
  

  faTentArrowsDown,
  

  faPlane,
  

  faFaceSadTear,
  
  faSadTear,
  

  faBlockBrickFire,
  
  faFirewall,
  

  faUserInjured,
  

  faBrainCircuit,
  

  faSkiBootSki,
  

  faKeyboardBrightnessLow,
  

  faBenchTree,
  

  faCircle3,
  

  faCardsBlank,
  

  faBone,
  

  faFileCheck,
  

  faArrowUpFromWaterPump,
  

  faBoot,
  

  faTruckContainer,
  

  faPenFancySlash,
  

  faToggleLargeOff,
  

  faLightSwitchOff,
  

  faCupcake,
  

  faBugSlash,
  

  faFaceSadSweat,
  

  faLocationPinSlash,
  
  faMapMarkerSlash,
  

  faWindWarning,
  
  faWindCircleExclamation,
  

  faPaperclipVertical,
  

  faHundredPoints,
  
  fa100,
  

  faDown,
  
  faArrowAltDown,
  

  faNoteSticky,
  
  faStickyNote,
  

  faDiceD12,
  

  faGramophone,
  

  faJar,
  

  faMagnet,
  

  faCircle2,
  

  fa1,
  

  faFalafel,
  

  faPenSwirl,
  

  faCommentExclamation,
  

  faGripDots,
  

  faSquareFull,
  

  faStopwatch20,
  

  faShieldExclamation,
  

  faCloudSun,
  

  faSyringe,
  

  faBoombox,
  

  faUserNurse,
  

  faTrashCheck,
  

  faBridgeSuspension,
  

  faTrainTram,
  

  faStarshipFreighter,
  

  faUserLarge,
  
  faUserAlt,
  

  faCirclesOverlap,
  

  faRulerVertical,
  

  faRightLeftLarge,
  

  faArrowDownFromArc,
  

  faFlower,
  

  faMagnifyingGlassMinus,
  
  faSearchMinus,
  

  faCalendarHeart,
  

  faMask,
  

  faTreeDecorated,
  

  faBrush,
  

  faMugSaucer,
  
  faCoffee,
  

  faGarlic,
  

  faCommentArrowUp,
  

  faRectangleWide,
  

  faWindowMinimize,
  

  faFileInvoice,
  

  faHandDots,
  
  faAllergies,
  

  faArrowDownToDottedLine,
  

  faClockTwelveThirty,
  

  faOnion,
  

  faUserClock,
  

  faCloudShowers,
  

  faThumbsUp,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faIdCardClip,
  
  faIdCardAlt,
  

  faEarthAsia,
  
  faGlobeAsia,
  

  faHotel,
  

  fa9,
  

  faAlbumCollection,
  

  faGifts,
  

  faCircle4,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faCalendarMinus,
  

  faBandage,
  
  faBandAid,
  

  faClapperboardPlay,
  

  faSensorCloud,
  
  faSensorSmoke,
  

  faBookUser,
  

  faWatchSmart,
  

  faBrain,
  

  faPompebled,
  

  faBowlingBall,
  

  faUnicorn,
  

  faDice,
  

  faSquareEnvelope,
  
  faEnvelopeSquare,
  

  faPersonWalkingArrowRight,
  

  faRectangleBarcode,
  
  faBarcodeAlt,
  

  faSquareS,
  

  faTurnDown,
  
  faLevelDownAlt,
  

  faWheelchairMove,
  
  faWheelchairAlt,
  

  faFaceGrimace,
  
  faGrimace,
  

  faChessPawnPiece,
  
  faChessPawnAlt,
  

  faArrowsUpDown,
  
  faArrowsV,
  

  faWaterLadder,
  
  faLadderWater,
  
  faSwimmingPool,
  

  faCalendarDay,
  

  faBellRing,
  

  faAudioDescriptionSlash,
  

  faFileSpreadsheet,
  

  faWheat,
  

  faTurnLeft,
  

  faCircleCaretRight,
  
  faCaretCircleRight,
  

  faHands,
  
  faSignLanguage,
  
  faSigning,
  

  faLifeRing,
  

  faMoneyBill1Wave,
  
  faMoneyBillWaveAlt,
  

  faEngine,
  

  faTire,
  

  faScannerGun,
  
  faScanner,
  

  faAlignRight,
  

  faWindowFlip,
  
  faWindowAlt,
  

  faInputText,
  

  faHandHoldingBox,
  

  faDungeon,
  

  faRoadCircleExclamation,
  

  faPaperPlane,
  

  faColumns3,
  

  faRightLeft,
  
  faExchangeAlt,
  

  faMessageDollar,
  
  faCommentAltDollar,
  

  faGridHorizontal,
  

  faCircleO,
  

  faScannerKeyboard,
  

  faHillRockslide,
  

  faMaskFace,
  

  faBottleDroplet,
  

  faTurnDownRight,
  

  faFaceThinking,
  

  faShare,
  
  faMailForward,
  

  faDownLeft,
  

  faDatabase,
  

  faNoteMedical,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

  faSnake,
  

  faHandcuffs,
  

  faInhaler,
  

  faBookJournalWhills,
  
  faJournalWhills,
  

  faBookOpen,
  

  faChevronsRight,
  
  faChevronDoubleRight,
  

  faCorner,
  

  faBahtSign,
  

  faCowbell,
  

  faLightbulbDollar,
  

  faTireRugged,
  

  faRectangleXmark,
  
  faRectangleTimes,
  
  faTimesRectangle,
  
  faWindowClose,
  

  faHandBackPointRibbon,
  

  faCartFlatbedSuitcase,
  
  faLuggageCart,
  

  faEarthEurope,
  
  faGlobeEurope,
  

  faPrintSlash,
  

  faRug,
  

  faUserTag,
  

  faImagePortrait,
  
  faPortrait,
  

  faPersonFalling,
  

  faBriefcase,
  

  faPotFood,
  

  faCloudMoon,
  

  faLocationPen,
  
  faMapMarkerEdit,
  

  faSlashForward,
  

  faShieldQuartered,
  

  faHandFist,
  
  faFistRaised,
  

  faAirplay,
  

  faLamp,
  

  faArrowsSplitUpAndLeft,
  

  faSquareW,
  

  faTruckArrowRight,
  

  faDiagramSuccessor,
  

  faCartFlatbedBoxes,
  
  faDollyFlatbedAlt,
  

  faAngleLeft,
  

  faBuildings,
  

  faHouseCircleCheck,
  

  faSwordLaser,
  

  faTomato,
  

  faBatteryThreeQuarters,
  
  faBattery4,
  

  faCheck,
  

  faIceSkate,
  

  faUserPlus,
  

  faBook,
  

  faTurkey,
  

  faClipboardListCheck,
  

  faRectangle,
  
  faRectangleLandscape,
  

  faCommentSms,
  
  faSms,
  

  faBasketShoppingMinus,
  

  faTableList,
  
  faThList,
  

  faHandBackPointDown,
  

  faH5,
  

  fa4,
  

  faSoftServe,
  
  faCreemee,
  

  faFaceViewfinder,
  

  faGripDotsVertical,
  

  faSpinnerScale,
  

  faM,
  

  faDesktop,
  
  faDesktopAlt,
  

  faDiceD8,
  

  faShower,
  

  faDoNotEnter,
  

  faGaugeSimpleHigh,
  
  faTachometer,
  
  faTachometerFast,
  

  faArrowDownBigSmall,
  
  faSortSizeDown,
  

  faCalendarLines,
  
  faCalendarNote,
  

  faScaleBalanced,
  
  faBalanceScale,
  

  faDrawPolygon,
  

  faFaceMonocle,
  

  faRss,
  
  faFeed,
  

  faArrowTrendDown,
  

  faCookieBite,
  

  faPeopleSimple,
  

  faFaceAngry,
  
  faAngry,
  

  faFunction,
  

  faBorderAll,
  

  faAnchor,
  

  faCircleQuarter,
  

  faBookQuran,
  
  faQuran,
  

  faDeleteRight,
  

  faFileCirclePlus,
  

  faTornado,
  

  faFireFlameCurved,
  
  faFireAlt,
  

  faArrowUpZA,
  
  faSortAlphaUpAlt,
  

  faPersonWalkingArrowLoopLeft,
  

  faClone,
  

  faLinkSlash,
  
  faChainBroken,
  
  faChainSlash,
  
  faUnlink,
  

  faPlugCircleExclamation,
  

  faHandHolding,
  

  faFaceGrinTongueWink,
  
  faGrinTongueWink,
  

  faCirclePlus,
  
  faPlusCircle,
  

  faShoePrints,
  

  faDragon,
  

  faWifiWeak,
  
  faWifi1,
  

  faBorderBottom,
  

  faVolumeSlash,
  

  faSdCard,
  

  faAmpGuitar,
  

  faLighthouse,
  

  faBahai,
  
  faHaykal,
  

  faUserDoctorMessage,
  
  faUserMdChat,
  

  faTrailer,
  

  faBoxHeart,
  

  faCalendar,
  

  faBoothCurtain,
  

  faCloudMoonRain,
  

  faUpDown,
  
  faArrowsAltV,
  

  faPencilMechanical,
  

  faTurtle,
  

  faCaravanSimple,
  
  faCaravanAlt,
  

  faPersonWalkingLuggage,
  

  faParagraphLeft,
  
  faParagraphRtl,
  

  faBagsShopping,
  

  faFan,
  

  faBlockBrick,
  
  faWallBrick,
  

  faVoicemail,
  

  faPersonArrowDownToLine,
  

  faObjectIntersect,
  

  faChimney,
  

  faVialCircleCheck,
  

  faInfinity,
  

  faCassetteVhs,
  
  faVhs,
  

  faChartColumn,
  

  faHippo,
  

  faTransformerBolt,
  

  faT,
  

  faOilCan,
  

  faUpRightAndDownLeftFromCenter,
  
  faExpandAlt,
  

  faHashtag,
  

  faFaceExplode,
  
  faExplodingHead,
  

  faSquareXmark,
  
  faTimesSquare,
  
  faXmarkSquare,
  

  faFacePouting,
  

  faContainerStorage,
  

  faEarthOceania,
  
  faGlobeOceania,
  

  faGopuram,
  

  faMelon,
  

  faLightbulbCflOn,
  

  faCardHeart,
  

  faShieldHeart,
  

  faVacuum,
  

  faBroom,
  

  faCoinBlank,
  

  faCircleArrowUpLeft,
  

  faCircleG,
  

  faSkeleton,
  

  faDisplayChartUpCircleCurrency,
  

  faPersonBiking,
  
  faBiking,
  

  faTemperatureLow,
  

  faCodeCommit,
  

  faFileMusic,
  

  faClockOne,
  

  faCompassSlash,
  

  faMusic,
  

  faYinYang,
  

  faSendBackward,
  

  faCheese,
  

  faSquareStar,
  

  faWineGlassEmpty,
  
  faWineGlassAlt,
  

  faPenSlash,
  

  faMoon,
  

  faArrowUpFromLine,
  
  faArrowFromBottom,
  

  faCarrot,
  

  faAmpersand,
  

  faAtomSimple,
  
  faAtomAlt,
  

  faPenLine,
  

  faDog,
  

  faWandMagic,
  
  faMagic,
  

  faTents,
  

  faCricketBatBall,
  
  faCricket,
  

  faDiagramCells,
  

  faFaceDiagonalMouth,
  

  faTentArrowTurnLeft,
  

  faBanParking,
  
  faParkingCircleSlash,
  

  faPenNib,
  

  faScythe,
  

  faHouseChimneyWindow,
  

  faCircleChevronLeft,
  
  faChevronCircleLeft,
  

  faGolfBallTee,
  
  faGolfBall,
  

  faHouseMedical,
  

  faPersonSeat,
  

  faDitto,
  

  faPhonePlus,
  

  faGlassesRound,
  
  faGlassesAlt,
  

  faBinary,
  

  faAvocado,
  

  faGunSlash,
  

  faArrowsRepeat1,
  
  faRepeat1Alt,
  

  faArrowUpShortWide,
  
  faSortAmountUpAlt,
  

  faShield,
  
  faShieldBlank,
  

  faFileExport,
  
  faArrowRightFromFile,
  

  faPhoneMissed,
  

  faFireSmoke,
  

  faFaceGrinBeamSweat,
  
  faGrinBeamSweat,
  

  faTrumpet,
  

  faClockRotateLeft,
  
  faHistory,
  

  faNestingDolls,
  

  faMagnifyingGlassMusic,
  

  faChairOffice,
  

  faFishCooked,
  

  faPenPaintbrush,
  
  faPencilPaintbrush,
  

  faBrowser,
  

  faFireplace,
  

  faDiceD10,
  

  faQrcode,
  

  faSubtitlesSlash,
  

  faAlbumCircleUser,
  

  faPancakes,
  

  faCamcorder,
  
  faVideoHandheld,
  

  faAnglesLeft,
  
  faAngleDoubleLeft,
  

  faBuilding,
  

  faTicketSimple,
  
  faTicketAlt,
  

  faAward,
  

  faUserGroupSimple,
  

  faConveyorBeltEmpty,
  

  faFlagPennant,
  
  faPennant,
  

  faPersonFallingBurst,
  

  faArrowRightToLine,
  
  faArrowToRight,
  

  faAnt,
  

  faLineColumns,
  

  faCardSpade,
  

  faSpade,
  

  faArrowTurnDown,
  
  faLevelDown,
  

  faBorderRight,
  

  faKnifeKitchen,
  

  faUpFromBracket,
  

  faMercury,
  

  faTransgender,
  
  faTransgenderAlt,
  

  faSimCard,
  

  faDiceFour,
  

  faMandolin,
  

  faMeter,
  

  faFaceGrinHearts,
  
  faGrinHearts,
  

  faSplotch,
  

  faSquareN,
  

  faArrowUpRightDots,
  

  faSquareFragile,
  
  faBoxFragile,
  
  faSquareWineGlassCrack,
  

  faLockKeyholeOpen,
  
  faLockOpenAlt,
  

  faConveyorBeltArm,
  

  faWarehouse,
  

  faSunBright,
  
  faSunAlt,
  

  faGears,
  
  faCogs,
  

  faPartyHorn,
  

  faPeace,
  

  faRobot,
  

  faWhale,
  

  faArrowUpTriangleSquare,
  
  faSortShapesUp,
  

  faTowerControl,
  

  faSpinner,
  

  faCircleQuarters,
  

  faRotate,
  
  faSyncAlt,
  

  faCircleTrash,
  
  faTrashCircle,
  

  faHandPeace,
  

  faDial,
  
  faDialMedHigh,
  

  faAlt,
  

  faDiagramLeanCanvas,
  

  faMugTeaSaucer,
  

  faTtyAnswer,
  
  faTeletypeAnswer,
  

  faSpeakers,
  

  faFaceVomit,
  

  faHammer,
  

  faPersonPraying,
  
  faPray,
  

  faCloudsSun,
  

  faTrophy,
  

  faWheatSlash,
  

  faThumbtack,
  
  faThumbTack,
  

  faSignatureSlash,
  

  faPhoneHangup,
  

  faFaceSmile,
  
  faSmile,
  

  faPersonSign,
  

  faDisplay,
  

  faCoinVertical,
  

  faLocationCheck,
  
  faMapMarkerCheck,
  

  faConveyorBelt,
  

  faGlassWaterDroplet,
  

  faTruckMoving,
  

  faPercent,
  
  faPercentage,
  

  faHandMiddleFinger,
  

  faBrightnessLow,
  

  faGaugeCircleMinus,
  

  faCarTilt,
  

  faVrCardboard,
  

  faShieldMinus,
  

  faThermometer,
  

  faCloudMinus,
  

  faTrafficLight,
  

  faCloudMusic,
  

  faDownToDottedLine,
  

  faFaceExpressionless,
  

  faBabyCarriage,
  
  faCarriageBaby,
  

  faRadio,
  

  faEllipsisStroke,
  
  faEllipsisHAlt,
  

  faBatteryQuarter,
  
  faBattery2,
  

  faVideoSlash,
  

  faFrame,
  

  faComputerClassic,
  

  faPumpSoap,
  

  faCarRear,
  
  faCarAlt,
  

  faRetweet,
  

  faClockFive,
  

  faSignalWeak,
  
  faSignal1,
  

  faChevronRight,
  

  faGenderless,
  

  faBriefcaseMedical,
  

  faTurntable,
  

  faPersonToDoor,
  

  faDisease,
  

  faNotdef,
  

  faTrashCanUndo,
  
  faTrashCanArrowTurnLeft,
  
  faTrashUndoAlt,
  

  faFilterSlash,
  

  faTablePivot,
  

  faHandLizard,
  

  faMoneyBillSimple,
  

  faClouds,
  

  faBacteria,
  

  faChevronLeft,
  

  faArrowLeftToArc,
  

  faNose,
  

  faHollyBerry,
  

  faLinkHorizontalSlash,
  
  faChainHorizontalSlash,
  

  faDrumstickBite,
  

  faDinosaur,
  

  faAngleUp,
  

  faMessageMinus,
  
  faCommentAltMinus,
  

  faFill,
  

  faGlassHalf,
  
  faGlassHalfEmpty,
  
  faGlassHalfFull,
  

  faMessageCode,
  

  faSchoolFlag,
  

  faTablet,
  
  faTabletAndroid,
  

  faCommentQuote,
  

  faCameraSlash,
  

  faCloudBoltSun,
  
  faThunderstormSun,
  

  faBellSlash,
  

  faStoreLock,
  

  faEyeDropperHalf,
  

  faBezierCurve,
  

  faSignalStreamSlash,
  

  faFolderCheck,
  

  faSquareDivide,
  

  faSignHanging,
  
  faSign,
  

  faVacuumRobot,
  

  faAngle,
  

  faOliveBranch,
  

  faPlugCircleMinus,
  

  faArrowTrendUp,
  

  faStore,
  

  faDisplayArrowDown,
  

  faCircleGf,
  

  faChartScatter,
  

  faFaceEyesXmarks,
  

  faPlanetMoon,
  

  faFolderMinus,
  

  faFloppyDiskCircleArrowRight,
  
  faSaveCircleArrowRight,
  

  faPhotoFilm,
  
  faPhotoVideo,
  

  faVideoArrowDownLeft,
  

  faCandleHolder,
  

  faClockTen,
  

  faSirenOn,
  

  faRocket,
  

  faClockEleven,
  

  faLassoSparkles,
  

  faFaceDisappointed,
  

  faFileCircleInfo,
  

  faArrowLeftFromArc,
  

  faMap,
  

  faUserHairLong,
  

  faAxeBattle,
  

  faCars,
  

  faShekelSign,
  
  faIls,
  
  faShekel,
  
  faSheqel,
  
  faSheqelSign,
  

  faTally2,
  

  faTeeth,
  

  faBlender,
  

  faWrenchSimple,
  

  faPeanut,
  

  faBuildingMagnifyingGlass,
  

  faCakeSlice,
  
  faShortcake,
  

  faEquals,
  

  faH2,
  

  faArrowRightFromLine,
  
  faArrowFromLeft,
  

  faIslandTropical,
  
  faIslandTreePalm,
  

  faBracketSquare,
  
  faBracket,
  
  faBracketLeft,
  

  faHighlighterLine,
  

  faFlaskGear,
  

  faCopyright,
  

  faSymbols,
  
  faIconsAlt,
  

  faRulerCombined,
  

  faSquareQ,
  

  faLinesLeaning,
  

  faArrowDownToBracket,
  

  faArrowDownUpLock,
  

  faTrashArrowUp,
  
  faTrashRestore,
  

  faKeySkeleton,
  

  faDownFromBracket,
  

  faTractor,
  

  faQuoteLeft,
  
  faQuoteLeftAlt,
  

  faUsersLine,
  

  faBaby,
  

  faCirclePhoneFlip,
  
  faPhoneCircleAlt,
  

  faBuildingShield,
  

  faCartCircleXmark,
  

  faFaceSmileTongue,
  

  faPesoSign,
  

  faClawMarks,
  

  faRhombus,
  

  faChalkboardUser,
  
  faChalkboardTeacher,
  

  faArrowsUpDownLeftRight,
  
  faArrows,
  

  faFaceSmirking,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faCloudCheck,
  

  faFort,
  

  faComputer,
  

  faExpand,
  

  faPlus,
  
  faAdd,
  

  faHatBeach,
  

  faSquarePhone,
  
  faPhoneSquare,
  

  fa2,
  

  faGun,
  

  faChildCombatant,
  
  faChildRifle,
  

  faKeynote,
  

  faShareFromSquare,
  
  faShareSquare,
  

  faGrip,
  
  faGripHorizontal,
  

  faJackOLantern,
  

  faUserVneckHair,
  

  faPartyBell,
  

  faPaintbrushPencil,
  

  faBarsFilter,
  

  faHandSparkles,
  

  faVolumeXmark,
  
  faVolumeMute,
  
  faVolumeTimes,
  

  faBurgerGlass,
  

  faCopy,
  

  faSnowmanHead,
  
  faFrostyHead,
  

  faSidebar,
  

  faChartPyramid,
  

  faPedestal,
  

  faDiagramProject,
  
  faProjectDiagram,
  

  faJetFighterUp,
  

  faAwardSimple,
  

  faCircleP,
  

  faBaseball,
  
  faBaseballBall,
  

  faGlobeStand,
  

  faFaceTongueSweat,
  

  faCircleRadiation,
  
  faRadiationAlt,
  

  faMusicNoteSlash,
  
  faMusicAltSlash,
  

  faMango,
  

  faLinkHorizontal,
  
  faChainHorizontal,
  

  faPhoneIntercom,
  

  faSquareChevronLeft,
  
  faChevronSquareLeft,
  

  faClapperboard,
  

  faDiamondHalfStroke,
  

  faSquareArrowDown,
  
  faArrowSquareDown,
  

  faArrowRightLongToLine,
  

  faCircleHalfStroke,
  
  faAdjust,
  

  faStarfighter,
  

  faUserGraduate,
  

  faObjectUnion,
  

  faCartShoppingFast,
  

  faHexagonExclamation,
  

  faMusicNote,
  
  faMusicAlt,
  

  faWaffle,
  

  faCloudFog,
  
  faFog,
  

  faFish,
  

  faCircleStar,
  
  faStarCircle,
  

  faCircle1,
  

  faCommentHeart,
  

  faStarSharp,
  

  faUserMagnifyingGlass,
  

  faTruckFast,
  
  faShippingFast,
  

  faLacrosseStickBall,
  

  faSquareChevronRight,
  
  faChevronSquareRight,
  

  faPersonSnowboarding,
  
  faSnowboarding,
  

  faArrowsRetweet,
  
  faRetweetAlt,
  

  faUserHeadset,
  

  faY,
  

  faCarBurst,
  
  faCarCrash,
  

  faBoxDollar,
  
  faBoxUsd,
  

  faWind,
  

  faCircleExclamationCheck,
  

  faWreathLaurel,
  

  faMegaphone,
  

  faUserShield,
  

  faMushroom,
  

  faPlanetRinged,
  

  faUserDoctorHair,
  

  faSquareY,
  

  faCircleUser,
  
  faUserCircle,
  

  faJugDetergent,
  

  faDiagramSubtask,
  

  faListCheck,
  
  faTasks,
  

  faShrimp,
  

  faCircleDivide,
  

  faBorderLeft,
  

  faTv,
  
  faTelevision,
  
  faTvAlt,
  

  faDownFromDottedLine,
  

  faArrowUp,
  

  faBoneBreak,
  

  faLandmarkDome,
  
  faLandmarkAlt,
  

  faBrazilianRealSign,
  

  faHatWinter,
  

  faMagnifyingGlassPlay,
  

  faPersonHarassing,
  

  faNfcPen,
  

  faChessKing,
  

  faRankingStar,
  

  faPhoneOffice,
  

  faEnvelopes,
  

  faDownLong,
  
  faLongArrowAltDown,
  

  faJugBottle,
  

  faSdCards,
  

  faTowerCell,
  

  faSchoolLock,
  

  faCircleEllipsis,
  

  faWatermelonSlice,
  

  faHandHoldingMagic,
  

  faListUl,
  
  faListDots,
  

  faCodeCompare,
  

  faDropletDegree,
  
  faDewpoint,
  

  faSkullCrossbones,
  

  faClub,
  

  faHospitals,
  

  faBookArrowRight,
  

  faBellPlus,
  

  faBatteryFull,
  
  faBattery,
  
  faBattery5,
  

  faChevronDown,
  

  faMoneyBillSimpleWave,
  

  faHandsHoldingDiamond,
  
  faHandReceiving,
  

  faTransporter2,
  

  faPersonCircleExclamation,
  

  faSuitcaseRolling,
  

  faDisplaySlash,
  
  faDesktopSlash,
  

  faCircleMicrophoneLines,
  
  faMicrophoneCircleAlt,
  

  faSquarePen,
  
  faPenSquare,
  
  faPencilSquare,
  

  faTablePicnic,
  

  faReceipt,
  

  faFilePen,
  
  faFileEdit,
  

  faWalkieTalkie,
  

  faWand,
  

  faCartArrowDown,
  

  faColon,
  

  faCartFlatbedEmpty,
  
  faDollyFlatbedEmpty,
  

  faLobster,
  

  faBracketCurly,
  
  faBracketCurlyLeft,
  

  faTaxiBus,
  

  faPeach,
  

  faNairaSign,
  

  faFloppyDiskCircleXmark,
  
  faFloppyDiskTimes,
  
  faSaveCircleXmark,
  
  faSaveTimes,
  

  faLocationQuestion,
  
  faMapMarkerQuestion,
  

  faSignalGood,
  
  faSignal3,
  

  faTrashCanArrowUp,
  
  faTrashRestoreAlt,
  

  faChevronsDown,
  
  faChevronDoubleDown,
  

  faPersonDotsFromLine,
  
  faDiagnoses,
  

  faTableTennisPaddleBall,
  
  faPingPongPaddleBall,
  
  faTableTennis,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faRupiahSign,
  

  faTableCellsRowLock,
  

  faBurgerLettuce,
  

  faSquareDownLeft,
  

  faCupTogo,
  
  faCoffeeTogo,
  

  faFont,
  

  faPlay,
  

  faTreeCity,
  

  faFileMinus,
  

  faEarListen,
  
  faAssistiveListeningSystems,
  

  faLink,
  
  faChain,
  

  faBallotCheck,
  

  faGrillHot,
  

  faLandmarkMagnifyingGlass,
  

  faBoxesStacked,
  
  faBoxes,
  
  faBoxesAlt,
  

  faTimer,
  

  faSpeaker,
  

  faCarBus,
  

  faStarHalf,
  

  faMoneyFromBracket,
  

  faCheckToSlot,
  
  faVoteYea,
  

  faCloudHail,
  

  faMeterFire,
  

  faSquareE,
  

  faHeadSideHeart,
  

  faParagraph,
  

  faFax,
  

  faDeerRudolph,
  

  faFishBones,
  

  faHeartCircleBolt,
  

  faIceCream,
  

  faScrubber,
  

  faDrum,
  

  faKite,
  

  faRectangleTerminal,
  

  faAngle90,
  

  faPersonWalkingWithCane,
  
  faBlind,
  

  faTransporterEmpty,
  

  faHotdog,
  

  faEarMuffs,
  

  faRouteInterstate,
  

  faBroccoli,
  

  faFaceSmilingHands,
  

  faOilCanDrip,
  

  faObjectsAlignLeft,
  

  faDharmachakra,
  

  faCircleUpLeft,
  

  faCloudHailMixed,
  

  faDiagramSankey,
  

  faBarsStaggered,
  
  faReorder,
  
  faStream,
  

  faUserBountyHunter,
  

  faChessRook,
  

  faWineBottle,
  

  faWhiskeyGlassIce,
  
  faGlassWhiskeyRocks,
  

  faPollPeople,
  

  faHospital,
  
  faHospitalAlt,
  
  faHospitalWide,
  

  faLampDesk,
  

  faEnvelopeOpenText,
  

  faSquareAmpersand,
  

  faGaugeHigh,
  
  faTachometerAlt,
  
  faTachometerAltFast,
  

  faSquareThisWayUp,
  
  faBoxUp,
  

  faSection,
  

  faSquare0,
  

  faInbox,
  

  faFaceSunglasses,
  

  faSocks,
  

  faGrid4,
  

  faBatteryEmpty,
  
  faBattery0,
  

  faSnowflakeDroplets,
  

  faDove,
  

  faHandBackPointRight,
  

  faHatChef,
  

  faGameBoard,
  

  faPersonBurst,
  

  faCrateApple,
  
  faAppleCrate,
  

  faFileSvg,
  

  faEarthAmericas,
  
  faEarth,
  
  faEarthAmerica,
  
  faGlobeAmericas,
  

  faHexagonImage,
  

  faEraser,
  

  faBullseyePointer,
  

  faDroplet,
  
  faTint,
  

  faCircleWifi,
  

  faNotebook,
  

  faFolderMagnifyingGlass,
  
  faFolderSearch,
  

  faCandyCorn,
  

  faMessageQuote,
  
  faCommentAltQuote,
  

  faUserRobotXmarks,
  

  faArrowDown,
  

  faPersonSwimming,
  
  faSwimmer,
  

  faTRex,
  

  faPretzel,
  

  faQuotes,
  

  faGreaterThan,
  

  faFile,
  

  faBoxOpenFull,
  
  faBoxFull,
  

  faCrab,
  

  faLocationDot,
  
  faMapMarkerAlt,
  

  faDialMedLow,
  

  faCircle0,
  

  faHandshakeAngle,
  
  faHandsHelping,
  

  faAccentGrave,
  

  faPaintRoller,
  

  faTrafficLightStop,
  

  faPhoneSlash,
  

  faStarOfLife,
  

  faPlugCircleXmark,
  

  faHexagonCheck,
  

  faBowlSpoon,
  

  faSuperscript,
  

  faArrowsFromLine,
  

  faFilePpt,
  

  faPinata,
  

  faXmarkLarge,
  

  faCandyBar,
  
  faChocolateBar,
  

  faBell,
  

  faTemperatureFull,
  
  faTemperature4,
  
  faThermometer4,
  
  faThermometerFull,
  

  faBee,
  

  faPodcast,
  

  faCalendarUsers,
  

  faSquareEllipsisVertical,
  

  faClockTwo,
  

  faSquareC,
  

  faSquareH,
  
  faHSquare,
  

  faBookCopy,
  

  faBed,
  

  faPersonFairy,
  

  faMedal,
  

  faTemperatureArrowUp,
  
  faTemperatureUp,
  

  faFileCircleXmark,
  

  faTruckDroplet,
  

  faDrone,
  

  faDiceD20,
  

  faBeerMug,
  
  faBeerFoam,
  

  faFileHeart,
  

  faMessageDots,
  
  faCommentAltDots,
  
  faMessaging,
  

  faHandBackPointLeft,
  

  faArrowsLeftRightToLine,
  

  faBluetooth,
  

  faChartSimpleHorizontal,
  

  faMountainSun,
  

  faCabin,
  

  faCircleX,
  

  faFamilyDress,
  

  faBookOpenReader,
  
  faBookReader,
  

  faMicrophoneStand,
  

  faUserHairMullet,
  
  faBusinessFront,
  
  faPartyBack,
  
  faTrianBalbot,
  

  faPodiumStar,
  

  faUserTieHair,
  

  faHandHoldingHand,
  

  faCar,
  
  faAutomobile,
  

  faBoxBallot,
  

  faCircleS,
  

  faCreditCard,
  
  faCreditCardAlt,
  

  faBowlChopsticks,
  

  faBug,
  

  faHandsHoldingCircle,
  

  faMagnifyingGlassWaveform,
  

  faEnvelopeDot,
  
  faEnvelopeBadge,
  

  faToolbox,
  

  faPersonThroughWindow,
  

  faBells,
  

  faGrid2Plus,
  

  faKitMedical,
  
  faFirstAid,
  

  faChessPawn,
  

  faNfcSlash,
  

  faEllipsis,
  
  faEllipsisH,
  

  faAnchorCircleXmark,
  

  faTentDoublePeak,
  

  faTicketsAirline,
  
  faTicketsPerforatedPlane,
  
  faTicketsPlane,
  

  faArrowRightLong,
  
  faLongArrowRight,
  

  faUserLock,
  

  faThumbsDown,
  

  faGripLines,
  

  faHeadSideCough,
  

  faPanFood,
  

  faPersonDollyEmpty,
  

  faCarTunnel,
  

  faOmega,
  

  faMountains,
  

  faAngleDown,
  

  faAirConditioner,
  

  faSquareQuestion,
  
  faQuestionSquare,
  

  faOilTemperature,
  
  faOilTemp,
  

  faFaceDrooling,
  

  faDisplayCode,
  
  faDesktopCode,
  

  faLessThan,
  

  faArrowDownShortWide,
  
  faSortAmountDesc,
  
  faSortAmountDownAlt,
  

  faFlorinSign,
  

  faChartMixed,
  
  faAnalytics,
  

  faArrowsTurnToDots,
  

  faGrill,
  

  faCircleDown,
  
  faArrowAltCircleDown,
  

  faPersonRunningFast,
  

  faTurnLeftDown,
  

  faWaveTriangle,
  

  faImagePolaroid,
  

  faIndustry,
  

  faBoreHole,
  

  faArrowsRepeat,
  
  faRepeatAlt,
  

  faHorseHead,
  

  faCircleDollar,
  
  faDollarCircle,
  
  faUsdCircle,
  

  faFaceLaughWink,
  
  faLaughWink,
  

  faSignalFair,
  
  faSignal2,
  

  faHouseTree,
  

  faHockeyStickPuck,
  

  faLaptopArrowDown,
  

  faBracketsSquare,
  
  faBrackets,
  

  faFaceSmileHearts,
  

  faSquare8,
  

  faSquareArrowLeft,
  
  faArrowSquareLeft,
  

  faGuitar,
  

  faScreenUsers,
  
  faUsersClass,
  

  faTrashCanSlash,
  
  faTrashAltSlash,
  

  faSun,
  

  faObjectsAlignCenterHorizontal,
  

  faChampagneGlass,
  
  faGlassChampagne,
  

  faTrashUndo,
  
  faTrashArrowTurnLeft,
  

  faRubleSign,
  
  faRouble,
  
  faRub,
  
  faRuble,
  

  faNotes,
  

  faGearCode,
  

  faYenSign,
  
  faCny,
  
  faJpy,
  
  faRmb,
  
  faYen,
  

  faPlaneCircleXmark,
  

  faToilet,
  

  faMars,
  

  faVault,
  

  faArrowTurnLeftUp,
  

  faPersonSimple,
  

  faOilWell,
  

  faGlassWater,
  

  faTrashCanCheck,
  

  faBolt,
  
  faZap,
  

  faMessageSlash,
  
  faCommentAltSlash,
  

  faShieldCat,
  

  faCaravan,
  

  faArrowUpArrowDown,
  
  faSortUpDown,
  

  faHandWave,
  

  faFolderGear,
  
  faFolderCog,
  

  faFolderMedical,
  

  faCameraWebSlash,
  
  faWebcamSlash,
  

  faSaxophoneFire,
  
  faSaxHot,
  

  faFileArrowDown,
  
  faFileDownload,
  

  faCompactDisc,
  

  faToiletPortable,
  

  faBrakeWarning,
  

  faCircleHalf,
  

  faWindsock,
  

  faMound,
  

  faPeoplePants,
  

  faGridRound2Plus,
  

  faHurricane,
  

  faUpload,
  

  faUpFromLine,
  
  faArrowAltFromBottom,
  

  faMoneyCheckDollarPen,
  
  faMoneyCheckEditAlt,
  

  faCodeMerge,
  

  faStop,
  

  faUpLong,
  
  faLongArrowAltUp,
  

  faBlockQuote,
  

  faTruckPickup,
  

  faTowerBroadcast,
  
  faBroadcastTower,
  

  faLoveseat,
  
  faCouchSmall,
  

  faPeopleDress,
  

  faHandHoldingSkull,
  

  faBanana,
  

  faHouseTurret,
  

  faChartScatterBubble,
  

  faCircleVideo,
  
  faVideoCircle,
  

  faGameBoardSimple,
  
  faGameBoardAlt,
  

  faSkull,
  

  faTimelineArrow,
  

  faBowlRice,
  

  faMillSign,
  

  faBalloons,
  

  faChartPieSimpleCircleDollar,
  

  faArrowUpWideShort,
  
  faSortAmountUp,
  

  faUtensils,
  
  faCutlery,
  

  faRotateRight,
  
  faRedoAlt,
  
  faRotateForward,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faGolfClub,
  

  faCastle,
  

  faKiwiBird,
  

  faBlanketFire,
  

  faButter,
  

  faHelmetBattle,
  

  faCircleA,
  

  faDiceOne,
  

  faPotato,
  

  faFileMedical,
  

  faPipe,
  

  faMoonOverSun,
  
  faEclipseAlt,
  

  faSeatAirline,
  

  faB,
  

  faSquareDownRight,
  

  faLaptopMedical,
  

  faFlyingDisc,
  

  faCalendarWeek,
  

  faCarCircleBolt,
  

  faVectorCircle,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faHeartCircleExclamation,
  

  faCourtSport,
  

  faOutdent,
  
  faDedent,
  

  faFaceWorried,
  

  faFaceDotted,
  

  faIdCard,
  
  faDriversLicense,
  

  faBookSkull,
  
  faBookDead,
  

  faAlignCenter,
  

  faFaceMeh,
  
  faMeh,
  

  faCodePullRequestClosed,
  

  faMobile,
  
  faMobileAndroid,
  
  faMobilePhone,
  

  faUserPilot,
  

  faForward,
  

  faLoader,
  

  faGlass,
  

  faFileCircleCheck,
  

  faRotateExclamation,
  

  faScribble,
  

  faCommentsQuestion,
  

  faCommentCaptions,
  

  faEyeDropper,
  
  faEyeDropperEmpty,
  
  faEyedropper,
  

  faCloudBinary,
  

  faOven,
  

  faDeleteLeft,
  
  faBackspace,
  

  faFaceGrin,
  
  faGrin,
  

  faCloudSnow,
  

  faShelves,
  
  faInventory,
  

  faAnglesUpDown,
  

  faDownload,
  

  faArrowsDownToLine,
  

  faTugrikSign,
  

  faBatterySlash,
  

  faClockSixThirty,
  

  faShip,
  

  faGameConsoleHandheld,
  

  faPersonSledding,
  
  faSledding,
  

  faBuildingCircleXmark,
  

  faSprinkler,
  

  faFaceLying,
  

  faCloudRain,
  

  faShovelSnow,
  

  faCableCar,
  
  faTram,
  

  faGarage,
  

  faSwap,
  

  faN,
  

  faPeoplePulling,
  

  faEyeEvil,
  

  faUserHair,
  

  faShuttlecock,
  

  faCalculator,
  

  faImages,
  

  faVenusDouble,
  

  faRightFromLine,
  
  faArrowAltFromLeft,
  

  faPersonHiking,
  
  faHiking,
  

  faClosedCaptioning,
  

  faBadminton,
  

  faHouseMedicalCircleExclamation,
  

  faGearComplexCode,
  

  faCirclePhoneHangup,
  
  faPhoneCircleDown,
  

  faCompressWide,
  

  faFaceSpiralEyes,
  

  faArrowUpFromArc,
  

  faPipeValve,
  

  faClockFiveThirty,
  

  faPersonRifle,
  

  faDiagramNext,
  

  faChartTreeMap,
  

  faTty,
  
  faTeletype,
  

  faLaptopFile,
  

  faFlagUsa,
  

  faCitrus,
  

  faLightsHoliday,
  

  faPipeCollar,
  

  faPersonDressSimple,
  

  faCircleB,
  

  faRightLong,
  
  faLongArrowAltRight,
  

  faLaptopSlash,
  

  faCoin,
  

  faPowerOff,
  

  faTicket,
  

  faSwordLaserAlt,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faRouter,
  

  faWandSparkles,
  

  faSquareU,
  

  faPersonPregnant,
  

  faFlask,
  

  faSwordsLaser,
  

  faCentSign,
  

  faHamsa,
  

  faMapPin,
  

  faCroissant,
  

  faNetworkWired,
  

  faFolderTree,
  

  faPeople,
  

  faCauldron,
  

  faSliders,
  
  faSlidersH,
  

  faOutlet,
  

  faFilterList,
  

  faKhanda,
  

  faOlive,
  

  faHoneyPot,
  

  faCoins,
  

  faMountainCity,
  

  faFluxCapacitor,
  

  faBatteryHalf,
  
  faBattery3,
  

  faBoltAuto,
  

  faIndustryWindows,
  
  faIndustryAlt,
  

  faCarMirrors,
  

  faRacquet,
  

  faPiggyBank,
  

  faCarBump,
  

  faSushiRoll,
  
  faMakiRoll,
  
  faMakizushi,
  

  faFaceHeadBandage,
  

  faCircleLocationArrow,
  
  faLocationCircle,
  

  faFolderHeart,
  

  faPlaneUp,
  

  faMobileScreen,
  
  faMobileAndroidAlt,
  

  faBellSchool,
  

  faTemperatureThreeQuarters,
  
  faTemperature3,
  
  faThermometer3,
  
  faThermometerThreeQuarters,
  

  faBoxingGlove,
  
  faGloveBoxing,
  

  faHouseChimneyMedical,
  
  faClinicMedical,
  

  faCards,
  

  faLocationDotSlash,
  
  faMapMarkerAltSlash,
  

  faCaretDown,
  

  faBallot,
  

  faUsbDrive,
  

  faArrowsFromDottedLine,
  

  faKeyboard,
  

  faTimeline,
  

  faS,
  

  faOverline,
  

  faSquareUpLeft,
  

  faBaseballBatBall,
  

  faPenNibSlash,
  

  faListRadio,
  

  faLampStreet,
  

  faCloudSleet,
  

  faFaucet,
  

  faArrowsMaximize,
  
  faExpandArrows,
  

  faCarBolt,
  

  faPallet,
  

  faBackwardStep,
  
  faStepBackward,
  

  faTruckTow,
  

  faInputNumeric,
  

  faClock,
  
  faClockFour,
  

  faDash,
  
  faMinusLarge,
  

  faRaindrops,
  

  faArrowDownArrowUp,
  
  faSortAlt,
  

  faLightSwitchOn,
  

  faSquareRootVariable,
  
  faSquareRootAlt,
  

  faArrowUpFromDottedLine,
  

  faU,
  

  faArrowTurnUp,
  
  faLevelUp,
  

  faMobileSignalOut,
  

  faGripVertical,
  

  faSquareD,
  

  faAxe,
  

  faChessClock,
  

  faPeapod,
  

  faShareAll,
  

  faDisplayMedical,
  
  faDesktopMedical,
  

  faFolderMusic,
  

  faHexagonVerticalNftSlanted,
  

  faTabletScreen,
  
  faTabletAndroidAlt,
  

  faToiletPaperBlank,
  
  faToiletPaperAlt,
  

  faFolderXmark,
  
  faFolderTimes,
  

  faFilmCanister,
  
  faFilmCannister,
  

  faSplit,
  

  faWaveformLines,
  
  faWaveformPath,
  

  faWaterArrowUp,
  
  faWaterRise,
  

  faPlaceOfWorship,
  

  faPersonSkiJumping,
  
  faSkiJump,
  

  faPlugCirclePlus,
  

  faCircle7,
  

  faScannerTouchscreen,
  

  faWaterArrowDown,
  
  faWaterLower,
  

  faFaceSwear,
  

  faRadioTuner,
  
  faRadioAlt,
  

  faFaceSmilePlus,
  
  faSmilePlus,
  

  faMoped,
  

  faTemperatureSnow,
  
  faTemperatureFrigid,
  

  faTabletRugged,
  

  faDistributeSpacingHorizontal,
  

  faEyeDropperFull,
  

  faVials,
  

  faShieldPlus,
  

  faBookFont,
  

  faCartShopping,
  
  faShoppingCart,
  

  faCarGarage,
  

  faPersonMilitaryRifle,
  

  faFlagSwallowtail,
  
  faFlagAlt,
  

  faStarOfDavid,
  

  faMosquito,
  

  faDuck,
  

  faMosque,
  

  faBookHeart,
  

  faDropletSlash,
  
  faTintSlash,
  

  faGear,
  
  faCog,
  

  faCameraSecurity,
  
  faCameraHome,
  

  faUserDoctorHairLong,
  

  faFileCertificate,
  
  faFileAward,
  

  faMessageXmark,
  
  faCommentAltTimes,
  
  faMessageTimes,
  

  faHousePersonReturn,
  
  faHousePersonArrive,
  
  faHouseReturn,
  

  faCartCircleArrowDown,
  

  faFaceSmileHalo,
  

  faCircleBolt,
  

  faPresentationScreen,
  
  faPresentation,
  

  faHandsAslInterpreting,
  
  faAmericanSignLanguageInterpreting,
  
  faAslInterpreting,
  
  faHandsAmericanSignLanguageInterpreting,
  

  faChartUser,
  
  faUserChart,
  

  faBookCircleArrowRight,
  

  faVolumeOff,
  

  faFlaskRoundPoison,
  
  faFlaskPoison,
  

  faFrancSign,
  

  faArrowDownLeft,
  

  faStreetView,
  

  faFontCase,
  

  faPlugCircleCheck,
  

  faArrowLeftLong,
  
  faLongArrowLeft,
  

  faTrashSlash,
  

  faChess,
  

  faGif,
  

  faRightToLine,
  
  faArrowAltToRight,
  

  faFireFlame,
  
  faFlame,
  

  faMinus,
  
  faSubtract,
  

  faCircle5,
  

  faCircleSterling,
  

  faBracketRoundRight,
  

  faVirusSlash,
  

  faDna,
  

  faTurnLeftUp,
  

  faCloudBoltMoon,
  
  faThunderstormMoon,
  

  faCircleUpRight,
  

  faKeyboardDown,
  

  faLeftLong,
  
  faLongArrowAltLeft,
  

  faMoneyBill1,
  
  faMoneyBillAlt,
  

  faCropSimple,
  
  faCropAlt,
  

  faIndianRupeeSign,
  
  faIndianRupee,
  
  faInr,
  

  faListTimeline,
  

  faMoneyBillsSimple,
  
  faMoneyBillsAlt,
  

  faBadgeDollar,
  

  faBallPile,
  

  faFaceSmileUpsideDown,
  

  faChartGantt,
  

  faTrainSubway,
  
  faSubway,
  

  faGameConsoleHandheldCrank,
  

  faSportsball,
  

  faSignalBarsFair,
  
  faSignalAlt2,
  

  faDistributeSpacingVertical,
  

  faCircleLeft,
  
  faArrowAltCircleLeft,
  

  faCowbellCirclePlus,
  
  faCowbellMore,
  

  faPlaneArrival,
  

  faPersonFromPortal,
  
  faPortalExit,
  

  faCalendarPlus,
  

  faPersonSkiingNordic,
  
  faSkiingNordic,
  

  faArrowDownRight,
  

  faGrate,
  

  faTrafficCone,
  

  faHouseMedicalCircleCheck,
  

  faAlarmExclamation,
  

  faTarpDroplet,
  

  faRectangleList,
  
  faListAlt,
  

  faDumbbell,
  

  faFaceGrinSquintTears,
  
  faGrinSquintTears,
  

  faReel,
  

  faHardDrive,
  
  faHdd,
  

  faTvMusic,
  

  faArrowRotateLeft,
  
  faArrowLeftRotate,
  
  faArrowRotateBack,
  
  faArrowRotateBackward,
  
  faUndo,
  

  faCookie,
  

  faOctagonDivide,
  

  faCommentArrowUpRight,
  

  faOctagon,
  

  faBorderBottomRight,
  
  faBorderStyleAlt,
  

  faCarBuilding,
  

  faMessageMusic,
  
  faCommentAltMusic,
  

  faCameraViewfinder,
  
  faScreenshot,
  

  faMoneyBillWheat,
  

  faPlusLarge,
  

  faBellSchoolSlash,
  

  faBowlingBallPin,
  

  faArrowDownAZ,
  
  faSortAlphaAsc,
  
  faSortAlphaDown,
  

  faCheckDouble,
  

  faPeopleDressSimple,
  

  faVestPatches,
  

  faLaptopBinary,
  

  faTent,
  

  faAlien,
  

  faPersonCane,
  

  faCloudRainbow,
  

  faCrosshairs,
  

  faMusicMagnifyingGlass,
  

  faTruck,
  

  faLandmark,
  

  faHouseWindow,
  

  faHoseReel,
  

  faFamilyPants,
  

  faPlateUtensils,
  

  faPrescriptionBottleMedical,
  
  faPrescriptionBottleAlt,
  

  faBraille,
  

  faCalendarClock,
  
  faCalendarTime,
  

  faClockDesk,
  

  faCalendarCheck,
  

  faPlaneProp,
  

  faNfcSignal,
  

  faStarSharpHalfStroke,
  
  faStarSharpHalfAlt,
  

  faWater,
  

  faWaveform,
  

  faTricycleAdult,
  

  faFileEps,
  

  faHandHoldingDroplet,
  
  faHandHoldingWater,
  

  faSquare4,
  

  faBuoyMooring,
  

  faArrowDown19,
  
  faSortNumericAsc,
  
  faSortNumericDown,
  

  faSleigh,
  

  faCarOn,
  

  faMeteor,
  

  faCartArrowUp,
  

  faSquareVirus,
  

  faCamera,
  
  faCameraAlt,
  

  faCameraPolaroid,
  

  faCloudMeatball,
  

  faMessageHeart,
  

  faHammerCrash,
  

  faFishingRod,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faSlashBack,
  

  faUserDoctor,
  
  faUserMd,
  

  faMeterBolt,
  

  faHouseChimneyBlank,
  

  faHouseHeart,
  
  faHomeHeart,
  

  faFileXmark,
  
  faFileTimes,
  

  faMountain,
  

  faHourglass,
  
  faHourglassEmpty,
  

  faNfcTrash,
  

  faTruckFieldUn,
  

  faPuzzlePieceSimple,
  
  faPuzzlePieceAlt,
  

  faTreeDeciduous,
  
  faTreeAlt,
  

  faIndent,
  

  faCommentMusic,
  

  faRugbyBall,
  

  faMessageMedical,
  
  faCommentAltMedical,
  

  faReflectHorizontal,
  

  faParachuteBox,
  

  faCircleNodes,
  

  faCircleWifiCircleWifi,
  
  faCircleWifiGroup,
  

  faArrowTurnDownLeft,
  

  faBorderNone,
  

  faCircleSmall,
  

  faBottleBaby,
  

  faLitecoinSign,
  

  faH6,
  

  faCircleY,
  

  faAppleCore,
  

  faArrowUp91,
  
  faSortNumericUpAlt,
  

  faPersonPinball,
  

  faLungs,
  

  faRibbon,
  

  faLockA,
  

  faArrowRightToCity,
  

  faChartLineDown,
  

  faPaperclip,
  

  faBinRecycle,
  

  faAnglesUp,
  
  faAngleDoubleUp,
  

  faFaceTissue,
  

  faDollyEmpty,
  

  faEnvelope,
  

  faTruckLadder,
  

  faHeadSide,
  

  faCakeCandles,
  
  faBirthdayCake,
  
  faCake,
  

  faSquare1,
  

  faComment,
  

  faEllipsisStrokeVertical,
  
  faEllipsisVAlt,
  

  faBracketsCurly,
  

  faCircleYen,
  

  faCoffeeBean,
  

  faInboxes,
  

  faBookSection,
  
  faBookLaw,
  

  faStretcher,
  

  faTag,
  

  faSteeringWheel,
  

  faPlaneLock,
  

  faTruckFire,
  

  faSatellite,
  

  faChessClockFlip,
  
  faChessClockAlt,
  

  faFilePlusMinus,
  

  faUserVisor,
  

  faLiraSign,
  

  faChild,
  

  faWashingMachine,
  
  faWasher,
  

  faBookSparkles,
  
  faBookSpells,
  

  faSquareArrowDownRight,
  

  faFilmSlash,
  

  faBusSchool,
  

  faClipboardUser,
  

  faFaceFearful,
  

  faLocationExclamation,
  
  faMapMarkerExclamation,
  

  faTableRows,
  
  faRows,
  

  faHatCowboySide,
  

  faDiscDrive,
  

  faPhoneVolume,
  
  faVolumeControlPhone,
  

  faSealQuestion,
  

  faSolarSystem,
  

  faBookTanakh,
  
  faTanakh,
  

  faTableCellsLarge,
  
  faThLarge,
  

  faCloudDrizzle,
  

  faPeoplePantsSimple,
  

  faFlowerTulip,
  

  faBusinessTime,
  
  faBriefcaseClock,
  

  faCommentDollar,
  

  faPersonDress,
  
  faFemale,
  

  faDreidel,
  

  faOtter,
  

  faUserSecret,
  

  faRv,
  

  faClockElevenThirty,
  

  faExpandWide,
  

  faBriefcaseArrowRight,
  

  faSuitcaseMedical,
  
  faMedkit,
  

  faO,
  

  faBookBible,
  
  faBible,
  

  faMessagesQuestion,
  

  faGamepadModern,
  
  faGamepadAlt,
  

  faCurlingStone,
  
  faCurling,
  

  faTankWater,
  

  faImageLandscape,
  
  faLandscape,
  

  faArrowUpToDottedLine,
  

  faSiren,
  

  faFilePdf,
  

  faBagShoppingMinus,
  

  faTableCells,
  
  faTh,
  

  faCircleSort,
  
  faSortCircle,
  

  faUpRightFromSquare,
  
  faExternalLinkAlt,
  

  faCherries,
  

  faFileVideo,
  

  faUsersViewfinder,
  

  faGalaxy,
  

  faJ,
  

  faHighDefinition,
  
  faRectangleHd,
  

  faRestroom,
  

  faDiceD6,
  

  faAlignLeft,
  

  faTemperatureSun,
  
  faTemperatureHot,
  

  faCupStrawSwoosh,
  

  faArrowLeftFromBracket,
  

  faRuler,
  

  faPersonCircleXmark,
  

  faArrowLeft,
  

  faLeafMaple,
  

  faRepublican,
  

  faHandsClapping,
  

  faSnowflakes,
  

  faCircleAmpersand,
  

  faCampfire,
  

  faHandsHolding,
  

  faHeadphones,
  

  faTengeSign,
  
  faTenge,
  

  faSquare7,
  

  faLampFloor,
  

  faSunCloud,
  

  faDivide,
  

  faEnvelopeOpenDollar,
  

  faCubes,
  

  faSquareR,
  

  faBillboard,
  

  fa0,
  

  faShirt,
  
  faTShirt,
  
  faTshirt,
  

  faClockSix,
  

  faHose,
  

  faPhoneXmark,
  

  faGuitars,
  

  faScrollOld,
  

  faQuoteRight,
  
  faQuoteRightAlt,
  

  faPenClipSlash,
  
  faPenAltSlash,
  

  faPoo,
  

  faFaceMelting,
  

  faBookMedical,
  

  faArrowDownSmallBig,
  
  faSortSizeDownAlt,
  

  faGaugeSimple,
  
  faGaugeSimpleMed,
  
  faTachometerAverage,
  

  faTrash,
  

  faHandFingersCrossed,
  

  faCloudWord,
  

  faPhoneArrowDownLeft,
  
  faPhoneArrowDown,
  
  faPhoneIncoming,
  

  faOrnament,
  

  faFileXml,
  

  faCarSideBolt,
  

  faBrightness,
  

  faBoxCircleCheck,
  

  faShowerDown,
  
  faShowerAlt,
  

  faPersonDigging,
  
  faDigging,
  

  faMouseField,
  

  faCoffeePot,
  

  faPenFancy,
  

  faChartKanban,
  

  faHatWizard,
  

  faSquareKanban,
  

  faGarageCar,
  

  faTextWidth,
  

  faPersonBooth,
  

  faBanBug,
  
  faDebug,
  

  faBridgeWater,
  

  faVentDamper,
  

  faMosquitoNet,
  

  faRocketLaunch,
  

  faStarfighterTwinIonEngine,
  
  faStarfighterAlt,
  

  faDiceSix,
  

  faStarfighterTwinIonEngineAdvanced,
  
  faStarfighterAltAdvanced,
  

  faShieldVirus,
  

  faConveyorBeltBoxes,
  
  faConveyorBeltAlt,
  

  faLaptopMobile,
  
  faPhoneLaptop,
  

  faDoorClosed,
  

  faDialLow,
  

  faOctagonExclamation,
  

  faArrowUp19,
  
  faSortNumericUp,
  

  faPipeCircleCheck,
  

  faUserGear,
  
  faUserCog,
  

  faPuzzle,
  

  faSquareHeart,
  
  faHeartSquare,
  

  faSquare5,
  

  faHouseBlank,
  
  faHomeBlank,
  

  faLightbulbSlash,
  

  faBooksMedical,
  

  faKeyboardBrightness,
  

  faHeadSideVirus,
  

  faRectangleCode,
  

  faTrafficLightSlow,
  

  faKiwiFruit,
  

  faPawClaws,
  

  faBorderInner,
  

  faToothbrush,
  

  faCalendarCirclePlus,
  

  faRampLoading,
  

  faNarwhal,
  

  faTableLayout,
  

  faChildReaching,
  

  faCalendarXmark,
  
  faCalendarTimes,
  

  faComputerMouseScrollwheel,
  
  faMouseAlt,
  

  faPhone,
  

  faFaceGrinTears,
  
  faGrinTears,
  

  faSpinnerThird,
  

  faLungsVirus,
  

  faUsersBetweenLines,
  

  faChildDress,
  

  faCardClub,
  

  faRulerTriangle,
  

  faHousePersonLeave,
  
  faHouseLeave,
  
  faHousePersonDepart,
  

  faLeftFromBracket,
  

  faMarsDouble,
  

  faLocationCrosshairs,
  
  faLocation,
  

  faChessQueenPiece,
  
  faChessQueenAlt,
  

  faBiohazard,
  

  faWebAwesome,
  

  faBalloon,
  

  faSensorOn,
  

  faMessagesDollar,
  
  faCommentsAltDollar,
  

  faArrowRotateRight,
  
  faArrowRightRotate,
  
  faArrowRotateForward,
  
  faRedo,
  

  faUserMusic,
  

  faFacePensive,
  

  faHandsPraying,
  
  faPrayingHands,
  

  faHandScissors,
  

  faDrumSteelpan,
  

  faHandPointer,
  

  faBacterium,
  

  faGridDividers,
  

  faHandHoldingDollar,
  
  faHandHoldingUsd,
  

  faCircleEllipsisVertical,
  

  faFaceGrinSquint,
  
  faGrinSquint,
  

  faSquareLeft,
  
  faArrowAltSquareLeft,
  

  faDiamond,
  

  faUserNurseHairLong,
  

  faAlbumCirclePlus,
  

  faScarf,
  

  faPlantWilt,
  

  faCommentDots,
  
  faCommenting,
  

  faCalendarArrowUp,
  
  faCalendarUpload,
  

  faSortUp,
  
  faSortAsc,
  

  faSquareL,
  

  faTennisBall,
  

  faFaceTongueMoney,
  

  faUserPoliceTie,
  

  faFileUser,
  

  faScaleUnbalanced,
  
  faBalanceScaleLeft,
  

  faFaceKissClosedEyes,
  

  faVihara,
  

  faFloppyDisk,
  
  faSave,
  

  faShop,
  
  faStoreAlt,
  

  faPrescription,
  

  faWalker,
  

  faScreencast,
  

  faDiploma,
  
  faScrollRibbon,
  

  faShirtTankTop,
  

  faChessBishopPiece,
  
  faChessBishopAlt,
  

  faFaceFrown,
  
  faFrown,
  

  faDryer,
  

  faWindowMaximize,
  

  faHouseChimney,
  
  faHomeLg,
  

  faArrowUpLeftFromCircle,
  

  faHeartCircleXmark,
  

  faBus,
  

  faPump,
  

  faSignal,
  
  faSignal5,
  
  faSignalPerfect,
  

  faFileCode,
  

  faToiletPaperBlankUnder,
  
  faToiletPaperReverseAlt,
  

  faFloppyDisks,
  

  faTowerObservation,
  

  faPen,
  

  faUserSlash,
  

  faManhole,
  

  faHexagon,
  

  faFileShield,
  

  faPersonMilitaryToPerson,
  

  faAudioDescription,
  

  faArrowsMinimize,
  
  faCompressArrows,
  

  faBootHeeled,
  

  faTicketAirline,
  
  faTicketPerforatedPlane,
  
  faTicketPlane,
  

  faHeat,
  

  faFaceSadCry,
  
  faSadCry,
  

  faEye,
  

  faBusSimple,
  
  faBusAlt,
  

  faChestnut,
  

  faTape,
  

  faBasketShopping,
  
  faShoppingBasket,
  

  faHouseMedicalFlag,
  

  faMobileButton,
  

  faTerminal,
  

  faCircleSortUp,
  
  faSortCircleUp,
  

  faBanSmoking,
  
  faSmokingBan,
  

  faCartFlatbed,
  
  faDollyFlatbed,
  

  faCircleR,
  

  faArrowUpRight,
  

  faDolphin,
  

  faArrowsToLine,
  

  faFaucetDrip,
  

  faBarsProgress,
  
  faTasksAlt,
  

  faNfcSymbol,
  

  faSquareChevronUp,
  
  faChevronSquareUp,
  

  faHouseSignal,
  

  faFaceRaisedEyebrow,
  

  faFaceZipper,
  

  faCardDiamond,
  

  faSquareParking,
  
  faParking,
  

  faUserRobot,
  

  faFaceMehBlank,
  
  faMehBlank,
  

  faForwardFast,
  
  faFastForward,
  

  faWineGlass,
  

  faTags,
  

  faArrowTurnRight,
  

  faHeadSideMedical,
  

  faFileCircleMinus,
  

  faUserTieHairLong,
  

  faTeethOpen,
  

  faCommentMedical,
  

  faPanorama,
  

  faClipboardQuestion,
  

  faCartCircleCheck,
  

  faRoute,
  

  faTruckField,
  

  faBasketShoppingPlus,
  

  faUserCrown,
  

  faFaceClouds,
  

  faAnchorCircleExclamation,
  

  faFiles,
  

  faCircleCaretLeft,
  
  faCaretCircleLeft,
  

  faTrashXmark,
  

  faCat,
  

  faTruckFront,
  

  faSquareQuarters,
  

  faFileDoc,
  

  faArrowDownFromDottedLine,
  

  faPhoneFlip,
  
  faPhoneAlt,
  

  faBridge,
  

  faHatCowboy,
  

  faWarehouseFull,
  
  faWarehouseAlt,
  

  faCodeBranch,
  

  faObjectSubtract,
  

  faHouseWater,
  
  faHouseFlood,
  

  faPopcorn,
  

  faFaceHandOverMouth,
  

  faCircleK,
  

  faArrowRightFromArc,
  

  faTypewriter,
  

  faCanFood,
  

  faBorderCenterH,
  

  faBookBookmark,
  

  faHandshakeSlash,
  

  faPlaneDeparture,
  

  faBuoy,
  

  faImageUser,
  

  faTicketsPerforated,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faFileImage,
  

  faRupeeSign,
  
  faRupee,
  

  faDiagramNested,
  

  faVectorPolygon,
  

  faBugs,
  

  faWrench,
  

  faArrowTurnLeft,
  

  faTransporter6,
  

  faUtilityPole,
  

  faBurger,
  
  faHamburger,
  

  faStaff,
  

  faChartRadar,
  

  faLockHashtag,
  

  faTurnDownLeft,
  

  faFileAudio,
  

  faPool8Ball,
  

  faTruckClock,
  
  faShippingTimed,
  

  faCartCirclePlus,
  

  faClipboardCheck,
  

  faFlatbreadStuffed,
  

  faOctagonCheck,
  

  faWallet,
  

  faUsersRays,
  

  faVolumeHigh,
  
  faVolumeUp,
  

  faCloudSlash,
  

  faInboxOut,
  
  faInboxArrowUp,
  

  faClockOneThirty,
  

  faMobileScreenButton,
  
  faMobileAlt,
  

  faSlider,
  

  faCircleUp,
  
  faArrowAltCircleUp,
  

  faBadgeCheck,
  

  faSatelliteDish,
  

  faForkKnife,
  
  faUtensilsAlt,
  

  faBasketball,
  
  faBasketballBall,
  

  faTrademark,
  

  faCircleDashed,
  

  faPlaneSlash,
  

  faInterrobang,
  

  faUserAstronaut,
  

  faRecycle,
  

  faBackwardFast,
  
  faFastBackward,
  

  faSword,
  

  faCartCircleExclamation,
  

  faLeftToBracket,
  

  faCircle,
  

  faSquarePollHorizontal,
  
  faPollH,
  

  faHouseFloodWaterCircleArrowRight,
  

  faMoneyBillTrendUp,
  

  faMoneyBillTransfer,
  

  faElevator,
  

  faTally3,
  

  faHouseChimneyHeart,
  

  faTableTree,
  

  faLockOpen,
  

  faSolarPanel,
  

  faShieldDog,
  

  faShutters,
  

  faBitcoinSign,
  

  faArrowDownTriangleSquare,
  
  faSortShapesDown,
  

  faCube,
  

  faHandsHoldingDollar,
  
  faHandsUsd,
  

  faToiletPaperXmark,
  

  faWifiSlash,
  

  faSquareInfo,
  
  faInfoSquare,
  

  faTemperatureQuarter,
  
  faTemperature1,
  
  faThermometer1,
  
  faThermometerQuarter,
  

  faR,
  

  faLockKeyhole,
  
  faLockAlt,
  

  faDiamondHalf,
  

  faKitchenSet,
  

  faAppleWhole,
  
  faAppleAlt,
  

  faCircleEuro,
  

  faToiletPaperSlash,
  

  faRabbit,
  

  faValueAbsolute,
  

  faAngel,
  

  faFolders,
  

  faGaugeCirclePlus,
  

  faCirclePause,
  
  faPauseCircle,
  

  faBottleWater,
  

  faFaceSurprise,
  
  faSurprise,
  

  faArrowRightToArc,
  

  faUserShakespeare,
  

  faMartiniGlassCitrus,
  
  faCocktail,
  

  faBracketsRound,
  
  faParentheses,
  

  faArrowLeftLongToLine,
  

  faPawSimple,
  
  faPawAlt,
  

  faHouseCrack,
  

  faLeftToLine,
  
  faArrowAltToLeft,
  

  faHexagonMinus,
  
  faMinusHexagon,
  

  faDumpsterFire,
  

  faCircleArrowDownLeft,
  

  faHouseUser,
  
  faHomeUser,
  

  faMarsAndVenus,
  

  faFileChartPie,
  

  faHeart,
  

  faFaceNauseated,
  

  faBookCircleArrowUp,
  

  faShirtRunning,
  

  faSignPostsWrench,
  

  faGridRound4,
  

  faFaceThermometer,
  

  faPlugCircleBolt,
  

  faTrophyStar,
  
  faTrophyAlt,
  

  faCircleThreeQuarters,
  

  faArrowsToEye,
  

  faScrewdriverWrench,
  
  faTools,
  

  faHandHorns,
  

  faFaceSleepy,
  

  faTarp,
  

  faHammerBrush,
  

  faClockNine,
  

  faHandsHoldingHeart,
  
  faHandsHeart,
  

  faBasketShoppingSimple,
  
  faShoppingBasketAlt,
  

  faH,
  

  faLeftFromLine,
  
  faArrowAltFromRight,
  

  faCupStraw,
  

  faMessageSmile,
  
  faCommentAltSmile,
  

  faSpaceStationMoon,
  

  faMelonSlice,
  

  faPersonCircleQuestion,
  

  faCashRegister,
  

  faOctagonPlus,
  
  faPlusOctagon,
  

  faSignsPost,
  
  faMapSigns,
  

  faArrowRight,
  

  faSignatureLock,
  

  faTickets,
  

  faMaskVentilator,
  

  faSendBack,
  

  faCalendarArrowDown,
  
  faCalendarDownload,
  

  faChartLine,
  
  faLineChart,
  

  faFrenchFries,
  

  faObjectGroup,
  

  faRingsWedding,
  

  faBreadLoaf,
  

  faFaceRollingEyes,
  
  faMehRollingEyes,
  

  faHexagonVerticalNft,
  

  faUserCowboy,
  

  faSeal,
  

  faPlaneCircleCheck,
  

  faCircleRight,
  
  faArrowAltCircleRight,
  

  faEject,
  

  faStarship,
  

  faSimCards,
  

  faCommentCode,
  

  faHelmetSafety,
  
  faHardHat,
  
  faHatHard,
  

  faToiletPaper,
  

  faKaaba,
  

  faSquareList,
  

  faLocationPin,
  
  faMapMarker,
  

  faTelescope,
  

  faObjectExclude,
  

  faPoop,
  

  faHandPointRibbon,
  

  faAlien8bit,
  
  faAlienMonster,
  

  faCircleArrowDownRight,
  

  faFaceDisguise,
  

  faObjectUngroup,
  

  faFaceGrinBeam,
  
  faGrinBeam,
  

  faBuildingFlag,
  

  faCircleQ,
  

  faFishFins,
  

  faFileContract,
  

  faFileExcel,
  

  faFileXls,
  

  faSackXmark,
  

  faClockEight,
  

  faBoltLightning,
  

  faChartPie,
  
  faPieChart,
  

  faPersonCirclePlus,
  

  faTaxi,
  
  faCab,
  

  faRoad,
  

  faBedBunk,
  

  faLeaf,
  

  faF,
  

  faCloudPlus,
  

  faAustralSign,
  

  faChessKnightPiece,
  
  faChessKnightAlt,
  

  faPie,
  

  faSquareEllipsis,
  

  faVirusCovid,
  

  faImagePolaroidUser,
  

  faWonSign,
  
  faKrw,
  
  faWon,
  

  faImagesUser,
  

  faCubesStacked,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faMagnifyingGlassChart,
  

  faMobileNotch,
  
  faMobileIphone,
  

  faClothesHanger,
  

  faBuildingCircleExclamation,
  

  faMoonStars,
  

  faWhiskeyGlass,
  
  faGlassWhiskey,
  

  faCode,
  

  faFileExclamation,
  

  faStarHalfStroke,
  
  faStarHalfAlt,
  

  faMoneyCheck,
  

  faPuzzlePiece,
  

  faTrainTrack,
  

  faArrowUpSmallBig,
  
  faSortSizeUpAlt,
  

  faHandHoldingHeart,
  

  faHouseChimneyUser,
  

  faDryerHeat,
  
  faDryerAlt,
  

  faUpDownLeftRight,
  
  faArrowsAlt,
  

  faToggleLargeOn,
  

  faFileSignature,
  

  faQuestion,
  

  faUserNurseHair,
  

  faClipboardPrescription,
  

  faCirclePhone,
  
  faPhoneCircle,
  

  faSquareG,
  

  faFilter,
  

  faDownToLine,
  
  faArrowAltToBottom,
  

  faRouteHighway,
  

  faMemoCircleCheck,
  

  faPodium,
  

  faDagger,
  

  faFaceKissWinkHeart,
  
  faKissWinkHeart,
  

  faWheatAwnSlash,
  

  faLanguage,
  

  faBreadSlice,
  

  faVectorSquare,
  

  faMoneyCheckDollar,
  
  faMoneyCheckAlt,
  

  faDiceD4,
  

  faPersonDressBurst,
  

  faChartNetwork,
  

  faWifiExclamation,
  

  faKidneys,
  

  faFaceParty,
  

  faSparkle,
  

  faChartWaterfall,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faSort,
  
  faUnsorted,
  

  faLocust,
  

  faFilterCircleXmark,
  

  faToiletPaperCheck,
  

  faCircleI,
  

  faUserGroupCrown,
  
  faUsersCrown,
  

  faCircleArrowRight,
  
  faArrowCircleRight,
  

  faBreadSliceButter,
  

  faMoonCloud,
  

  faArrowTurnDownRight,
  

  faGuitarElectric,
  

  faRectangleAd,
  
  faAd,
  

  faNewspaper,
  

  faStomach,
  

  faSnowflake,
  

  faBroomWide,
  

  faP,
  

  faTrashCanClock,
  

  faSausage,
  

  faFeatherPointed,
  
  faFeatherAlt,
  

  faMace,
  

  faTemperatureArrowDown,
  
  faTemperatureDown,
  

  faBookmarkSlash,
  

  faA,
  

  faRoadLock,
  

  faInputPipe,
  

  faDeer,
  

  faPersonSkiing,
  
  faSkiing,
  

  faZ,
  

  faPinball,
  

  faFaceConfused,
  

  faDemocrat,
  

  faLinkSimpleSlash,
  

  faPickaxe,
  

  faTicketsSimple,
  

  faCommentsDollar,
  

  faFaceHushed,
  

  faPersonSnowmobiling,
  
  faSnowmobile,
  

  faChurch,
  

  faTableCellsColumnLock,
  

  faCalendarLinesPen,
  

  faGlassCitrus,
  

  faItalic,
  

  faCediSign,
  

  faCouch,
  

  faMartiniGlassEmpty,
  
  faGlassMartini,
  

  faMemo,
  

  faSquare,
  

  faCommentCheck,
  

  faHeartHalf,
  

  faTicketPerforated,
  

  faFileZipper,
  
  faFileArchive,
  

  faHouseChimneyCrack,
  
  faHouseDamage,
  

  faHeartCircleCheck,
  

  faArchway,
  

  faClockTwoThirty,
  

  faHashtagLock,
  

  faBorderOuter,
  

  faArrowsToDot,
  

  faRestroomSimple,
  

  faLayerGroup,
  

  faEnvelopeCircleCheck,
  

  faWave,
  

  faCommentMiddleTop,
  

  faGridRound2,
  

  faVirus,
  

  faBookAtlas,
  
  faAtlas,
  

  faTruckPlow,
  

  faShieldHalved,
  
  faShieldAlt,
  

  faFaceConfounded,
  

  faPalletBox,
  

  faGreaterThanEqual,
  

  faSquareArrowUp,
  
  faArrowSquareUp,
  

  faBurgerSoda,
  

  faCabinetFiling,
  

  faListDropdown,
  

  faWatchCalculator,
  

  faWatchApple,
  

  faCruzeiroSign,
  

  faShelvesEmpty,
  

  faGarageOpen,
  

  faMagnifyingGlassArrowsRotate,
  

  faFireExtinguisher,
  

  faArrowsToDottedLine,
  

  faCircleBookOpen,
  
  faBookCircle,
  

  faArrowsRotate,
  
  faRefresh,
  
  faSync,
  

  faBorderTop,
  

  faMugTea,
  

  faBurgerFries,
  

  faGuaraniSign,
  

  faGingerbreadMan,
  

  faCommentQuestion,
  

  faAlicorn,
  

  faAlarmPlus,
  

  faMattressPillow,
  

  faMemoPad,
  

  faRabbitRunning,
  
  faRabbitFast,
  

  faHandshakeSimpleSlash,
  
  faHandshakeAltSlash,
  

  faCatSpace,
  

  faDrawCircle,
  

  faEnvelopeOpen,
  

  faListTree,
  

  faLollipop,
  
  faLollypop,
  

  faSignalStrong,
  
  faSignal4,
  

  faUserLargeSlash,
  
  faUserAltSlash,
  

  faChalkboard,
  
  faBlackboard,
  

  faMeterDroplet,
  

  faChildren,
  

  faWreath,
  

  faCloudArrowDown,
  
  faCloudDownload,
  
  faCloudDownloadAlt,
  

  faHouseLock,
  

  faArrowsLeftRight,
  
  faArrowsH,
  

  faObjectsAlignCenterVertical,
  

  faSquareDown,
  
  faArrowAltSquareDown,
  

  faFilePowerpoint,
  

  faFileWord,
  

  faLeft,
  
  faArrowAltLeft,
  

  faWavesSine,
  

  faCircle6,
  

  faChessKingPiece,
  
  faChessKingAlt,
  

  faTombstoneBlank,
  
  faTombstoneAlt,
  

  faFaceSmileWink,
  
  faSmileWink,
  

  faProjector,
  

  faText,
  

  faCircleDownLeft,
  

  faWatch,
  

  faTextSlash,
  
  faRemoveFormat,
  

  faChartLineUpDown,
  

  faCloudBolt,
  
  faThunderstorm,
  

  faMessageCheck,
  
  faCommentAltCheck,
  

  faHandHoldingSeedling,
  

  faPhoneArrowRight,
  

  faSquareDollar,
  
  faDollarSquare,
  
  faUsdSquare,
  

  faArrowDownWideShort,
  
  faSortAmountAsc,
  
  faSortAmountDown,
  

  faCandyCane,
  

  faSquare9,
  

  faBowlFood,
  

  faGroupArrowsRotate,
  

  faFileJpg,
  

  faFlashlight,
  

  faCircleArrowLeft,
  
  faArrowCircleLeft,
  

  faBoxesPacking,
  

  faLeftRight,
  
  faArrowsAltH,
  

  faClockSeven,
  

  faSeedling,
  
  faSprout,
  

  faArrowsDownToPeople,
  

  faBullseyeArrow,
  

  faFerry,
  

  faTrianglePersonDigging,
  
  faConstruction,
  

  faCircleEnvelope,
  
  faEnvelopeCircle,
  

  faInboxFull,
  

  faPig,
  

  faVest,
  

  faArrowsTurnRight,
  

  faObjectsAlignRight,
  

  faChartMixedUpCircleCurrency,
  

  faTransporter4,
  

  faPalette,
  

  faCloudArrowUp,
  
  faCloudUpload,
  
  faCloudUploadAlt,
  

  faFontAwesome,
  
  faFontAwesomeFlag,
  
  faFontAwesomeLogoFull,
  

  faGasPumpSlash,
  

  faCrutch,
  

  faSquareALock,
  

  faUserVneckHairLong,
  

  faCircleCaretUp,
  
  faCaretCircleUp,
  

  faUfoBeam,
  

  faSmog,
  

  faBlindsRaised,
  

  faMoneyBills,
  

  faFaceTired,
  
  faTired,
  

  faHouseLaptop,
  
  faLaptopHouse,
  

  faBurst,
  

  faIntegral,
  

  faDiamondTurnRight,
  
  faDirections,
  

  faSubscript,
  

  faGlobeSnow,
  

  faScaleUnbalancedFlip,
  
  faBalanceScaleRight,
  

  faAddressCard,
  
  faContactCard,
  
  faVcard,
  

  faTrashCanPlus,
  

  faRegistered,
  

  faGaugeLow,
  
  faTachometerAltSlow,
  

  faBomb,
  

  faTemperatureEmpty,
  
  faTemperature0,
  
  faThermometer0,
  
  faThermometerEmpty,
  

  faHillAvalanche,
  

  faPlaneEngines,
  
  faPlaneAlt,
  

  faClockEightThirty,
  

  faPause,
  

  faLocationPinLock,
  

  faStrawberry,
  

  faArrowLeftFromLine,
  
  faArrowFromRight,
  

  faSpa,
  

  faScroll,
  

  faSquareF,
  

  faBoxOpen,
  

  faKerning,
  

  faLightEmergencyOn,
  

  faSquareArrowUpRight,
  
  faExternalLinkSquare,
  

  faBanjo,
  

  faFileImport,
  
  faArrowRightToFile,
  

  faCommentPen,
  
  faCommentEdit,
  

  faCircleArrowDown,
  
  faArrowCircleDown,
  

  faCameraRetro,
  

  faFilterCircleDollar,
  
  faFunnelDollar,
  

  faBinaryLock,
  

  faStarShooting,
  

  faPersonSkating,
  
  faSkating,
  

  faSuitcase,
  

  faReplyAll,
  
  faMailReplyAll,
  

  faCrystalBall,
  

  faCertificate,
  

  faTentArrowDownToLine,
  

  faArrowDownLong,
  
  faLongArrowDown,
  

  faUpToBracket,
  

  faUserTie,
  

  faSquarePersonConfined,
  

  faViruses,
  

  faBatteryExclamation,
  

  faSterlingSign,
  
  faGbp,
  
  faPoundSign,
  

  faSmoke,
  

  faMaskSnorkel,
  

  faImageSlash,
  

  faPersonWalkingDashedLineArrowRight,
  

  faStocking,
  

  faTeddyBear,
  

  faVolcano,
  

  faLariSign,
  

  faUserPolice,
  

  faCircleChevronUp,
  
  faChevronCircleUp,
  

  faUpRight,
  

  faFileMagnifyingGlass,
  
  faFileSearch,
  

  faGearComplex,
  

  faUniversalAccess,
  

  faAperture,
  

  faHelicopterSymbol,
  

  faTreeLarge,
  

  faBatteryBolt,
  

  faSquareArrowDownLeft,
  

  faFaceLaughBeam,
  
  faLaughBeam,
  

  faBinBottles,
  

  faMarker,
  

  faKazoo,
  

  faIdBadge,
  

  faNeuter,
  

  faPersonShelter,
  

  faIcicles,
  

  faCarWrench,
  
  faCarMechanic,
  

  faChopsticks,
  

  faCalendarCircleMinus,
  

  faPlateWheat,
  

  faCompassDrafting,
  
  faDraftingCompass,
  

  faArrowUpToBracket,
  

  faPhoneRotary,
  

  faHeadSideHeadphones,
  

  faCircleStop,
  
  faStopCircle,
  

  faBat,
  

  faMoneySimpleFromBracket,
  

  faHandHoldingCircleDollar,
  

  faSquareDashedCirclePlus,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faChair,
  

  faEuroSign,
  
  faEur,
  
  faEuro,
  

  faEthernet,
  

  fa360Degrees,
  

  faTablets,
  

  faLocationArrowUp,
  

  faArrowUpRightAndArrowDownLeftFromCenter,
  

  faCirclePlay,
  
  faPlayCircle,
  

  faCannabis,
  

  faTruckRampCouch,
  
  faTruckCouch,
  

  faAnglesRight,
  
  faAngleDoubleRight,
  

  faSnowplow,
  

  faAlignSlash,
  

  faOctagonXmark,
  
  faTimesOctagon,
  
  faXmarkOctagon,
  

  faMonument,
  

  faRefrigerator,
  

  faMinimize,
  
  faCompressArrowsAlt,
  

  faSmoking,
  

  faDolly,
  
  faDollyBox,
  

  faGem,
  

  faHandshake,
  

  faHeadSideMask,
  

  faLemon,
  

  faTick,
  

  faSquareA,
  

  faTableColumns,
  
  faColumns,
  

  faRotateLeft,
  
  faRotateBack,
  
  faRotateBackward,
  
  faUndoAlt,
  

  faMartiniGlass,
  
  faGlassMartiniAlt,
  

  faBracketSquareRight,
  

  faArrowUpFromGroundWater,
  

  faForklift,
  

  faSquareNfi,
  

  faHouseTsunami,
  

  faFolderClosed,
  

  faCircleSortDown,
  
  faSortCircleDown,
  

  faScrewdriver,
  

  faShieldXmark,
  
  faShieldTimes,
  

  faCaretUp,
  

  faDownFromLine,
  
  faArrowAltFromTop,
  

  faSquareRing,
  

  fa3,
  

  faFileZip,
  

  faCow,
  

  faMicrophone,
  

  faWindowFrame,
  

  faImage,
  

  faFloppyDiskPen,
  

  faBucket,
  

  faFrog,
  

  faMessageLines,
  
  faCommentAltLines,
  

  faCloudExclamation,
  

  faToriiGate,
  

  faPanelEws,
  

  faSubtitles,
  

  faSunrise,
  

  faHockeyMask,
  

  faLacrosseStick,
  

  faCustard,
  

  faMistletoe,
  

  faBowlScoops,
  

  faSquarePlus,
  
  faPlusSquare,
  

  faCircleV,
  

  faFileBinary,
  

  faNfcMagnifyingGlass,
  

  faWindowRestore,
  

  faSailboat,
  

  faCassetteBetamax,
  
  faBetamax,
  

  faCrow,
  

  fa00,
  

  faHexagonDivide,
  

  faUserUnlock,
  

  faSensorFire,
  

  faFaceExhaling,
  

  faTrafficLightGo,
  

  faEyeLowVision,
  
  faLowVision,
  

  faUpFromDottedLine,
  

  faTrain,
  

  faLessThanEqual,
  

  faHandsBubbles,
  
  faHandsWash,
  

  faChartBar,
  
  faBarChart,
  

  faCloudShowersWater,
  

  faSquareCaretUp,
  
  faCaretSquareUp,
  

  faTally,
  
  faTally5,
  

  faGridRound5,
  

  faHandBackFist,
  
  faHandRock,
  

  faMarsStrokeRight,
  
  faMarsStrokeH,
  

  faPersonChalkboard,
  

  faRightLongToLine,
  

  faSwapArrows,
  

  faGrid5,
  

  faArrowDownToLine,
  
  faArrowToBottom,
  

  faRepeat1,
  

  faBuildingCircleCheck,
  

  faBurgerCheese,
  
  faCheeseburger,
  

  faChessBoard,
  

  faBringFront,
  

  faUpLeft,
  

  faSquareQuote,
  

  faHoodCloak,
  

  faGlasses,
  

  faPaintbrushFine,
  
  faPaintBrushAlt,
  
  faPaintBrushFine,
  
  faPaintbrushAlt,
  

  faChessQueen,
  

  faTreasureChest,
  

  faMessageArrowUpRight,
  

  faFileSlash,
  

  faCoinFront,
  

  faGaugeCircleBolt,
  

  faTransporter5,
  

  faVolume,
  
  faVolumeMedium,
  

  faDiceTwo,
  

  faGift,
  

  faMemoCircleInfo,
  

  faMailboxFlagUp,
  

  faFaceDowncastSweat,
  

  faCarBattery,
  
  faBatteryCar,
  

  faDogLeashed,
  

  faMugHot,
  

  faArrowDownSquareTriangle,
  
  faSortShapesDownAlt,
  

  faSquarePollVertical,
  
  faPoll,
  

  faJedi,
  

  faTilde,
  

  faMapLocationDot,
  
  faMapMarkedAlt,
  

  faBorderTopLeft,
  
  faBorderStyle,
  

  faNotEqual,
  

  faMoneyCheckPen,
  
  faMoneyCheckEdit,
  

  faManatSign,
  

  faSquareK,
  

  faCircleDownRight,
  

  faEngineWarning,
  
  faEngineExclamation,
  

  faTransporter3,
  

  faBuildingNgo,
  

  faAnchorLock,
  

  faBold,
  

  faStroopwafel,
  

  faSignature,
  

  faCaduceus,
  

  faSquareO,
  

  faBinarySlash,
  

  faUserPen,
  
  faUserEdit,
  

  faPrescriptionBottlePill,
  

  faUnderline,
  

  faRectangleHistoryCirclePlus,
  

  faUmbrellaSimple,
  
  faUmbrellaAlt,
  

  faBath,
  
  faBathtub,
  

  faMessages,
  
  faCommentsAlt,
  

  faWifi,
  
  faWifi3,
  
  faWifiStrong,
  

  faFileArrowUp,
  
  faFileUpload,
  

  faHouseCircleExclamation,
  

  faClipboard,
  

  faHexagonPlus,
  
  faPlusHexagon,
  

  faTaco,
  

  faChampagneGlasses,
  
  faGlassCheers,
  

  faMarsStrokeUp,
  
  faMarsStrokeV,
  

  faUserMinus,
  

  faSignalSlash,
  

  faRoadCircleXmark,
  

  faStoreSlash,
  

  faH4,
  

  faBadgerHoney,
  

  faHeadset,
  

  faColonSign,
  

  faUnlock,
  

  faSheep,
  

  faCitrusSlice,
  

  faPepperHot,
  

  faClockTwelve,
  

  faMicrophoneLines,
  
  faMicrophoneAlt,
  

  faSignalBarsWeak,
  
  faSignalAlt1,
  

  faCity,
  

  faCodeFork,
  

  faHeartCirclePlus,
  

  faFlatbread,
  

  faBowlHot,
  
  faSoup,
  

  faCandy,
  

  faAlbumCollectionCircleUser,
  

  faFolderOpen,
  

  faFaceLaugh,
  
  faLaugh,
  

  faChartPieSimple,
  
  faChartPieAlt,
  

  faShirtLongSleeve,
  

  faShuttleSpace,
  
  faSpaceShuttle,
  

  faHouseDay,
  

  faBedPulse,
  
  faProcedures,
  

  faFire,
  

  faStars,
  

  faCircleZ,
  

  faDownToBracket,
  

  faSignalStream,
  

  faL,
  

  faPersonWalking,
  
  faWalking,
  

  faRectangleVertical,
  
  faRectanglePortrait,
  

  faToggleOn,
  

  faCircleArrowUp,
  
  faArrowCircleUp,
  

  faBedEmpty,
  

  faPianoKeyboard,
  

  faUserPilotTie,
  

  faWheelchair,
  

  faTriangleInstrument,
  
  faTriangleMusic,
  

  faCommentPlus,
  

  faSquareChevronDown,
  
  faChevronSquareDown,
  

  faObjectsColumn,
  

  faViolin,
  

  faBurrito,
  

  faCommentMinus,
  

  faBinaryCircleCheck,
  

  faPanelFire,
  

  faBoltSlash,
  

  faCodeSimple,
  

  faFaceLaughSquint,
  
  faLaughSquint,
  

  faPalletBoxes,
  
  faPaletteBoxes,
  
  faPalletAlt,
  

  faBarsSort,
  

  faChessKnight,
  

  faFarm,
  
  faBarnSilo,
  

  faSquareT,
  

  faTvRetro,
  

  faScannerImage,
  

  faSnooze,
  
  faZzz,
  

  faBlockQuestion,
  

  faPlayPause,
  

  faLayerPlus,
  
  faLayerGroupPlus,
  

  faArrowUpAZ,
  
  faSortAlphaUp,
  

  faUserGroup,
  
  faUserFriends,
  

  faBooks,
  

  faStarExclamation,
  

  faArrowUpToArc,
  

  faWeightScale,
  
  faWeight,
  

  faHandBackPointUp,
  

  faFlowerDaffodil,
  

  faCalendarRange,
  

  faTableCellsLock,
  

  faFilePrescription,
  

  faXmarksLines,
  

  faWeightHanging,
  

  faCrown,
  

  faLeftLongToLine,
  

  faMicrochip,
  

  faTemperatureHigh,
  

  faTrashCanXmark,
  

  faFolderUser,
  

  faPeopleCarryBox,
  
  faPeopleCarry,
  

  faClockTenThirty,
  

  faCloudsMoon,
  

  faCircle8,
  

  faHeartPulse,
  
  faHeartbeat,
  

  faInboxIn,
  
  faInboxArrowDown,
  

  faPassport,
  

  faVenus,
  

  faCommentSmile,
  

  faSquareRight,
  
  faArrowAltSquareRight,
  

  faVideoPlus,
  

  faRightToBracket,
  
  faSignInAlt,
  

  faFireHydrant,
  

  faFilePng,
  

  faApostrophe,
  

  faPersonBreastfeeding,
  

  faGaugeMax,
  
  faTachometerAltFastest,
  

  faBuildingWheat,
  

  faCircleE,
  

  faChartPieSimpleCircleCurrency,
  

  faLayerMinus,
  
  faLayerGroupMinus,
  

  faLightbulbExclamation,
  

  faMessageArrowUp,
  
  faCommentAltArrowUp,
  

  faPaperPlaneTop,
  
  faPaperPlaneAlt,
  
  faSend,
  

  faPersonSeatReclined,
  

  faHourglassClock,
  

  faBlenderPhone,
  

  faUserHairBuns,
  

  faHourglassStart,
  
  faHourglass1,
  

  faFamily,
  

  faShopLock,
  

  faIntersection,
  

  faVirusCovidSlash,
  

  faServer,
  

  faBadgeSheriff,
  

  faGridRound,
  

  faSlidersSimple,
  

  faWindTurbine,
  

  faShopSlash,
  
  faStoreAltSlash,
  

  faSquare6,
  

  faPersonSkiLift,
  
  faSkiLift,
  

  faNfcLock,
  

  faCannon,
  

  faFilesMedical,
  

  faPegasus,
  

  faArrowRightToBracket,
  
  faSignIn,
  

  faComputerMouse,
  
  faMouse,
  

  faCalendarStar,
  

  faPersonToPortal,
  
  faPortalEnter,
  

  faSlash,
  

  faLasso,
  

  faCircleQuarterStroke,
  

  faLocationXmark,
  
  faMapMarkerTimes,
  
  faMapMarkerXmark,
  

  faSpellCheck,
  

  faCoffinCross,
  

  faGoalNet,
  

  faXRay,
  

  faArrowDownFromBracket,
  

  faDiagramVenn,
  

  faFileLock,
  

  faEar,
  

  faPlaneCircleExclamation,
  

  faWindow,
  

  faFaceAstonished,
  

  faPipeSmoking,
  

  faFileInvoiceDollar,
  

  faScalpelLineDashed,
  
  faScalpelPath,
  

  faHandsBound,
  

  faClockThree,
  

  faSpider,
  

  faBracketCurlyRight,
  

  faFileDashedLine,
  
  faPageBreak,
  

  faArrowUpFromSquare,
  

  faBinBottlesRecycle,
  

  faGripLinesVertical,
  

  faMobileRetro,
  

  faPersonRunning,
  
  faRunning,
  

  faShuffle,
  
  faRandom,
  

  faPeanuts,
  

  faTransporter1,
  

  faArrowUpLeft,
  

  faSquarePhoneHangup,
  
  faPhoneSquareDown,
  

  faShieldSlash,
  

  faCircleU,
  

  faGaugeSimpleMax,
  
  faTachometerFastest,
  

  faPlaneTail,
  

  faShapes,
  
  faTriangleCircleSquare,
  

  faChargingStation,
  

  faMaximize,
  
  faExpandArrowsAlt,
  

  faLightbulbGear,
  

  faCactus,
  

  faSignalBarsGood,
  
  faSignalAlt3,
  

  faClockFourThirty,
  

  faArrowPointer,
  
  faMousePointer,
  

  faClockSevenThirty,
  

  faVenusMars,
  

  faBox,
  

  faPageCaretDown,
  
  faFileCaretDown,
  

  faCross,
  

  faRepeat,
  

  faDialMin,
  

  faStar,
  

  faDiamondExclamation,
  

  faSignalBars,
  
  faSignalAlt,
  
  faSignalAlt4,
  
  faSignalBarsStrong,
  

  faSprayCanSparkles,
  
  faAirFreshener,
  

  faCommentText,
  

  faSunDust,
  

  faCameraRotate,
  

  faUniformMartialArts,
  

  faFaceWeary,
  

  faEggFried,
  

  faCircleBookmark,
  
  faBookmarkCircle,
  

  faBellExclamation,
  

  faBan,
  
  faCancel,
  

  faScalpel,
  

  faPersonCircleMinus,
  

  faCircleThreeQuartersStroke,
  

  faHouseFlag,
  

  faChartArea,
  
  faAreaChart,
  

  faMoneyBillWave,
  

  faPizzaSlice,
  

  faTruckBolt,
  

  faSignPosts,
  

  faMailbox,
  

  faChartLineUp,
  

  faBuildingLock,
  

  faRectangleHistoryCircleUser,
  

  faPersonDressFairy,
  

  faTabletButton,
  

  faC,
  

  faLocationArrow,
  

  faMessagePlus,
  
  faCommentAltPlus,
  

  faFaceSmileTear,
  

  faRoadBridge,
  

  faCalendarPen,
  
  faCalendarEdit,
  

  faFolderImage,
  

  faPersonHalfDress,
  

  faFileChartColumn,
  
  faFileChartLine,
  

  faSynagogue,
  

  faGlobe,
  

  faPersonDolly,
  

  faLocationCrosshairsSlash,
  
  faLocationSlash,
  

  faSteak,
  

  faBullhorn,
  

  faBoxCheck,
  

  faTamale,
  

  faHatSanta,
  

  faArrowLeftToBracket,
  

  faKey,
  

  faWavePulse,
  
  faHeartRate,
  

  faHighlighter,
  

  faSquareCaretLeft,
  
  faCaretSquareLeft,
  

  faLightSwitch,
  

  faBuildingUser,
  

  faVanShuttle,
  
  faShuttleVan,
  

  faDumpster,
  

  faArrowDownToArc,
  

  faLightEmergency,
  

  faToiletPaperUnder,
  
  faToiletPaperReverse,
  

  faSchoolCircleCheck,
  

  faComma,
  

  faSensor,
  

  faUser,
  

  faRotateReverse,
  

  faBadgePercent,
  

  faBridgeCircleExclamation,
  

  faPenClip,
  
  faPenAlt,
  

  faH3,
  

  faBowlChopsticksNoodles,
  

  faPizza,
  

  faE,
  

  faLambda,
  

  faWandMagicSparkles,
  
  faMagicWandSparkles,
  

  faGauge,
  
  faDashboard,
  
  faGaugeMed,
  
  faTachometerAltAverage,
  

  faVial,
  

  faSquareBolt,
  

  faLeafOak,
  

  faMarsStroke,
  

  faCircleParking,
  
  faParkingCircle,
  

  faCrutches,
  

  faChartSimple,
  

  faBagSeedling,
  

  faPenCircle,
  

  faRadiation,
  

  faPlaneUpSlash,
  

  faMug,
  

  faMicrochipAi,
  

  faFileWaveform,
  
  faFileMedicalAlt,
  

  faCreditCardBlank,
  

  faFaceAnxiousSweat,
  

  faFolder,
  
  faFolderBlank,
  

  faObjectsAlignTop,
  

  faFileCad,
  

  faTrashPlus,
  

  faHeadSideGear,
  

  faArrowUpFromBracket,
  

  faHandPointDown,
  

  faRaccoon,
  

  faOption,
  

  faBacon,
  

  faTrashList,
  

  faMessageCaptions,
  
  faCommentAltCaptions,
  

  faSushi,
  
  faNigiri,
  

  faBullseye,
  

  faArrowLeftToLine,
  
  faArrowToLeft,
  

  faLocationSmile,
  
  faMapMarkerSmile,
  

  faHelmetUn,
  

  faUmbrellaBeach,
  

  faBrainArrowCurvedRight,
  
  faMindShare,
  

  fa6,
  

  faCreditCardFront,
  

  faBatteryLow,
  
  faBattery1,
  

  faAlignJustify,
  

  faFanTable,
  

  faBookmark,
  

  faSemicolon,
  

  faSquareExclamation,
  
  faExclamationSquare,
  

  faTrainSubwayTunnel,
  
  faSubwayTunnel,
  

  faSquareUp,
  
  faArrowAltSquareUp,
  

  faFaceHoldingBackTears,
  

  faBowlSoftServe,
  

  faBaguette,
  

  faBarcodeRead,
  

  faArrowUpBigSmall,
  
  faSortSizeUp,
  

  faMoneyBill,
  

  faHandPointUp,
  

  faSquareJ,
  

  faBagShoppingPlus,
  

  faSquareDashed,
  

  faFaceFrownOpen,
  
  faFrownOpen,
  

  faFileVector,
  

  faTally1,
  

  faPooStorm,
  
  faPooBolt,
  

  faCapsules,
  

  faDonut,
  
  faDoughnut,
  

  faDongSign,
  

  faTemperatureHalf,
  
  faTemperature2,
  
  faThermometer2,
  
  faThermometerHalf,
  

  faCommentImage,
  

  faEscalator,
  

  faCarWash,
  

  faNotesMedical,
  

  faSlotMachine,
  

  faWineGlassCrack,
  
  faFragile,
  

  faG,
  

  faWhistle,
  

  faLinkSimple,
  

  faMonitorWaveform,
  
  faMonitorHeartRate,
  

  faQ,
  

  faHorse,
  

  faDialMed,
  

  faAngleRight,
  

  faBellOn,
  

  faFilters,
  

  faMugMarshmallows,
  

  faHorseSaddle,
  

  faJoint,
  

  faBracketRound,
  
  faParenthesis,
  

  faIgloo,
  

  faSchool,
  

  faBriefcaseBlank,
  

  faChartCandlestick,
  

  faRoadBarrier,
  

  faMortarPestle,
  

  faShieldCheck,
  

  faUserAlien,
  

  faSnowman,
  

  faWheatAwnCircleExclamation,
  

  faGunSquirt,
  

  faPiano,
  

  faPepper,
  

  faTruckMedical,
  
  faAmbulance,
  

  faApartment,
  

  faTriangle,
  

  faFileMov,
  

  faHeadSideCoughSlash,
  

  faPear,
  

  faStaffSnake,
  
  faRodAsclepius,
  
  faRodSnake,
  
  faStaffAesculapius,
  

  faSpiderBlackWidow,
  

  faCircleD,
  

  faHammerWar,
  

  faBicycle,
  

  faBangladeshiTakaSign,
  

  faCalendars,
  

  faCircleArrowUpRight,
  

  faLeafyGreen,
  

  faSquid,
  

  faSparkles,
  

  faV,
  

  faObjectsAlignBottom,
  

  faBasketballHoop,
  

  faTooth,
  

  faFaceGrinWide,
  
  faGrinAlt,
  

  faPills,
  

  faArrowDownLeftAndArrowUpRightToCenter,
  

  faHryvniaSign,
  
  faHryvnia,
  

  faI,
  

  faUserHelmetSafety,
  
  faUserConstruction,
  
  faUserHardHat,
  

  faDialHigh,
  

  faGlassEmpty,
  

  faDroneFront,
  
  faDroneAlt,
  

  faStairs,
  

  faToiletPaperUnderSlash,
  
  faToiletPaperReverseSlash,
  

  faDrawSquare,
  

  faFilePlus,
  

  faStamp,
  

  faSaltShaker,
  

  faChartMixedUpCircleDollar,
  

  faICursor,
  

  faSquareArrowUpLeft,
  

  fa5,
  

  faLandMineOn,
  

  faTricycle,
  

  faFaceZany,
  

  faSquareRss,
  
  faRssSquare,
  

  faOctagonMinus,
  
  faMinusOctagon,
  

  faDiceFive,
  

  faRoadCircleCheck,
  

  faFaceRelieved,
  

  faEclipse,
  

  faAlarmClock,
  

  faEarDeaf,
  
  faDeaf,
  
  faDeafness,
  
  faHardOfHearing,
  

  faClockThreeThirty,
  

  faFaceGrinWink,
  
  faGrinWink,
  

  faHatWitch,
  

  faCoffeeBeans,
  

  faMessageSms,
  

  faChessBishop,
  

  faSealExclamation,
  

  faGrateDroplet,
  

  faVideoArrowUpRight,
  

  faAcorn,
  

  faFlute,
  

  faRaygun,
  

  faSkeletonRibs,
  

  faThoughtBubble,
  

  faUpToDottedLine,
  

  faFaceGrinTongue,
  
  faGrinTongue,
  

  faPeriod,
  

  faBridgeCircleXmark,
  

  faFaceKiss,
  
  faKiss,
  

  faWindowFrameOpen,
  

  faLightbulbCfl,
  

  faCommentArrowDown,
  

  faCameraWeb,
  
  faWebcam,
  

  faSquareM,
  

  faFaceScream,
  

  faArrowUpSquareTriangle,
  
  faSortShapesUpAlt,
  

  faFieldHockeyStickBall,
  
  faFieldHockey,
  

  faSquare2,
  

  faSaxophone,
  

  faStopwatch,
  

  faBlinds,
  

  faCommand,
  

  faPopsicle,
  

  faBookArrowUp,
  

  faCircleMicrophone,
  
  faMicrophoneCircle,
  

  faSpiderWeb,
  

  faHandSpock,
  

  faCircleCamera,
  
  faCameraCircle,
  

  faFacePersevering,
  

  faGaugeSimpleLow,
  
  faTachometerSlow,
  

  faFaceSaluting,
  

  faChevronUp,
  

  faSquareI,
  

  faCalendarCircleExclamation,
  

  faPlug,
  

  faHouseCircleXmark,
  

  faWorm,
  

  faFaceShush,
  

  faFlaskRoundPotion,
  
  faFlaskPotion,
  

  faPi,
  

  faOm,
  

  faArrowTurnLeftDown,
  

  faFolderBookmark,
  

  faTurnRight,
  

  faPrintMagnifyingGlass,
  
  faPrintSearch,
  

  faUtensilsSlash,
  

  faPersonBikingMountain,
  
  faBikingMountain,
  

  faHand,
  
  faHandPaper,
  

  faHeadSideBrain,
  

  faCucumber,
  

  faPoliceBox,
  

  faFlaskVial,
  

  faEyeSlash,
  

  faFacePleading,
  

  faUsers,
  

  faCircleF,
  

  faRight,
  
  faArrowAltRight,
  

  faPersonRays,
  

  faReplyClock,
  
  faReplyTime,
  

  faMitten,
  

  faArrowDownZA,
  
  faSortAlphaDesc,
  
  faSortAlphaDownAlt,
  

  faBagShopping,
  
  faShoppingBag,
  

  faHandHeart,
  

  faTruckContainerEmpty,
  

  faCalendarExclamation,
  

  faSink,
  

  faSunset,
  

  faMicroscope,
  

  faHourglassHalf,
  
  faHourglass2,
  

  faCircleCalendar,
  
  faCalendarCircle,
  

  faCircleW,
  

  faHeartCircleMinus,
  

  faWaveSine,
  

  faDisplayChartUpCircleDollar,
  

  faShareNodes,
  
  faShareAlt,
  

  faKnife,
  
  faUtensilKnife,
  

  faLightbulbOn,
  

  faMessageMiddleTop,
  
  faCommentMiddleTopAlt,
  

  faCarSide,
  

  faSquareSliders,
  
  faSlidersHSquare,
  

  faPenToSquare,
  
  faEdit,
  

  faSackDollar,
  

  faCrosshairsSimple,
  

  faBridgeLock,
  

  faFolderArrowUp,
  
  faFolderUpload,
  

  faSquareSmall,
  

  faBackpack,
  

  faArrowsCross,
  

  faTree,
  

  faCommentsQuestionCheck,
  

  faHouseFloodWater,
  

  faMapLocation,
  
  faMapMarked,
  

  faBlanket,
  

  faGlobePointer,
  

  faHotTubPerson,
  
  faHotTub,
  

  faHouseNight,
  

  faRectanglePro,
  
  faPro,
  

  faMonkey,
  

  faSignalBarsSlash,
  
  faSignalAltSlash,
  

  faGasPump,
  

  faArrowDownFromLine,
  
  faArrowFromTop,
  

  faLock,
  

  faPaintbrush,
  
  faPaintBrush,
  

  faSnowBlowing,
  

  faFutbol,
  
  faFutbolBall,
  
  faSoccerBall,
  

  faJug,
  

  faFolderPlus,
  

  faCampground,
  

  faClockNineThirty,
  

  faWatchFitness,
  

  faHouseMedicalCircleXmark,
  

  faUpToLine,
  
  faArrowAltToTop,
  

  faEgg,
  

  faFaceDizzy,
  
  faDizzy,
  

  faClipboardMedical,
  

  faCircleDot,
  
  faDotCircle,
  

  faBorderCenterV,
  

  faGamepad,
  

  faCartPlus,
  

  faSquarePhoneFlip,
  
  faPhoneSquareAlt,
  

  faTreePalm,
  

  faList,
  
  faListSquares,
  

  faFilmSimple,
  
  faFilmAlt,
  

  faAbacus,
  

  faHockeySticks,
  

  faFaceAnguished,
  

  faGhost,
  

  faHeading,
  
  faHeader,
  

  faTrainTunnel,
  

  faSquareParkingSlash,
  
  faParkingSlash,
  

  faPesetaSign,
  

  faSandwich,
  

  faBookOpenCover,
  
  faBookOpenAlt,
  

  faShredder,
  

  faSquareCheck,
  
  faCheckSquare,
  

  faLuchadorMask,
  
  faLuchador,
  
  faMaskLuchador,
  

  faCommentLines,
  

  faKeySkeletonLeftRight,
  

  faAsterisk,
  

  faHandsHoldingChild,
  

  faAnkh,
  

  faWheatAwn,
  
  faWheatAlt,
  

  faCompress,
  

  faCircleN,
  

  faAlbum,
  

  faCloudSunRain,
  

  faSwords,
  

  faCommentSlash,
  

  faBoxTaped,
  
  faBoxAlt,
  

  faXmarkToSlot,
  
  faTimesToSlot,
  
  faVoteNay,
  

  faVolumeLow,
  
  faVolumeDown,
  

  faFeather,
  

  faSquareCode,
  

  faDisplayChartUp,
  

  faChartScatter3d,
  

  faHanukiah,
  

  faFaceCowboyHat,
  

  faFlag,
  

  faArrowUpToLine,
  
  faArrowToTop,
  

  faSquirrel,
  

  faFireBurner,
  

  faRoadSpikes,
  

  faFaceSleeping,
  

  faMemory,
  

  faCircleDollarToSlot,
  
  faDonate,
  

  faSpaceStationMoonConstruction,
  
  faSpaceStationMoonAlt,
  

  faPipeSection,
  

  faSitemap,
  

  faHeadphonesSimple,
  
  faHeadphonesAlt,
  

  faCloudShowersHeavy,
  

  faTemperatureList,
  

  faUnlockKeyhole,
  
  faUnlockAlt,
  

  faSidebarFlip,
  

  faCircleChevronDown,
  
  faChevronCircleDown,
  

  faFaceFrownSlight,
  

  faArrowRightFromBracket,
  
  faSignOut,
  

  faSchoolCircleXmark,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faBlock,
  

  faTrashCanList,
  

  faCommentMiddle,
  

  faCaretLeft,
  

  faLightbulb,
  

  faPeopleRobbery,
  

  faSquareTerminal,
  

  faCassetteTape,
  

  faShieldCross,
  

  fa8,
  

  faRulerHorizontal,
  

  faCoconut,
  

  faFilm,
  

  faSickle,
  

  faRadar,
  

  faPhotoFilmMusic,
  

  faRollerCoaster,
  

  faCorn,
  

  faFaceKissBeam,
  
  faKissBeam,
  

  faSquareUpRight,
  
  faExternalLinkSquareAlt,
  

  faDropletPercent,
  
  faHumidity,
  

  faFaceBeamHandOverMouth,
  

  faHeartCrack,
  
  faHeartBroken,
  

  faHourglassEnd,
  
  faHourglass3,
  

  faPeopleGroup,
  

  faKeyboardLeft,
  

  faBars,
  
  faNavicon,
  

  faPrescriptionBottle,
  

  faSwatchbook,
  

  faRectangleVerticalHistory,
  

  faGrillFire,
  

  faJoystick,
  

  faLaptopCode,
  

  faTruckUtensils,
  

  faFileCircleQuestion,
  

  faHeartHalfStroke,
  
  faHeartHalfAlt,
  

  faSquareCaretDown,
  
  faCaretSquareDown,
  

  faCompass,
  

  faBird,
  

  faHelicopter,
  

  faSquareMinus,
  
  faMinusSquare,
  

  faHouseFire,
  

  faEmptySet,
  

  faStarAndCrescent,
  

  faReply,
  
  faMailReply,
  

  faMeat,
  

  faClover,
  

  faUsersSlash,
  

  faStarSharpHalf,
  

  faPickleball,
  

  faFaceMask,
  

  faTachographDigital,
  
  faDigitalTachograph,
  

  faMagnifyingGlassArrowRight,
  

  faSensorTriangleExclamation,
  
  faSensorAlert,
  

  faUsersMedical,
  

  faMessageImage,
  
  faCommentAltImage,
  

  faUserChef,
  

  faTable,
  

  faHyphen,
  

  faMustache,
  

  faHockeyPuck,
  

  faToiletsPortable,
  

  faSunPlantWilt,
  

  faListMusic,
  

  faScissors,
  
  faCut,
  

  faSquareCaretRight,
  
  faCaretSquareRight,
  

  faTombstone,
  

  faMarsAndVenusBurst,
  

  faFaceAngryHorns,
  

  faSignPost,
  

  faPeopleArrows,
  
  faPeopleArrowsLeftRight,
  

  faAlbumCollectionCirclePlus,
  

  faSquareRoot,
  

  faChessRookPiece,
  
  faChessRookAlt,
  

  faArrowProgress,
  

  faFileMp3,
  

  faPenRuler,
  
  faPencilRuler,
  

  faBellConcierge,
  
  faConciergeBell,
  

  faMessagePen,
  
  faCommentAltEdit,
  
  faMessageEdit,
  

  faBadge,
  

  faSunglasses,
  

  faTireFlat,
  

  faTreeChristmas,
  

  faMotorcycle,
  

  faChartBullet,
  

  faStarChristmas,
  

  faCircleC,
  

  faBoxTissue,
  

  faMicrophoneSlash,
  

  faBinoculars,
  

  faTruckRamp,
  

  faMusicSlash,
  

  faTrillium,
  

  faBrowsers,
  

  faSprinklerCeiling,
  

  faGavel,
  
  faLegal,
  

  faReflectBoth,
  

  faTrashClock,
  

  faCartCircleArrowUp,
  

  faTentArrowLeftRight,
  

  faChfSign,
  

  faMicrowave,
  

  faHospitalUser,
  

  faFaceFlushed,
  
  faFlushed,
  

  faSquare3,
  

  faTrowelBricks,
  

  faCloud,
  

  faMessageQuestion,
  

  faPaw,
  

  faTabletScreenButton,
  
  faTabletAlt,
  

  faCircleNotch,
  

  faRainbow,
  

  faEarthAfrica,
  
  faGlobeAfrica,
  

  faElephant,
  

  faSquareB,
  

  faCodePullRequestDraft,
  

  faW,
  

  faGiftCard,
  

  faTruckMonster,
  

  faScarecrow,
  

  faAlarmSnooze,
  

  faSprayCan,
  

  faShishKebab,
  

  faFaceGrinTongueSquint,
  
  faGrinTongueSquint,
  

  faArrowDown91,
  
  faSortNumericDesc,
  
  faSortNumericDownAlt,
  

  faCircleCaretDown,
  
  faCaretCircleDown,
  

  faCalendarImage,
  

  faCircleM,
  

  faDialMax,
  

  faPersonDrowning,
  

  faGrapes,
  

  faBoxArchive,
  
  faArchive,
  

  faFaceSmileHorns,
  

  faToggleOff,
  

  faDialOff,
  

  faFaceAwesome,
  
  faGaveDandy,
  

  faSquareV,
  

  faDrumstick,
  

  faBroomBall,
  
  faQuidditch,
  
  faQuidditchBroomBall,
  

  faUp,
  
  faArrowAltUp,
  

  faFence,
  

  faBlindsOpen,
  

  faWebhook,
  

  faScrollTorah,
  
  faTorah,
  

  faDownRight,
  

  faPersonArrowUpFromLine,
  

  faBowlingPins,
  

  faPencilSlash,
  

  faUserNinja,
  

  fa7,
  

  faBlog,
  

  faCircle9,
  

  faSheetPlastic,
  

  faFaceUnamused,
  

  faMessageArrowDown,
  
  faCommentAltArrowDown,
  

  faGolfFlagHole,
  

  faBookBlank,
  
  faBookAlt,
  

  faVialVirus,
  

  faCloudXmark,
  

  faUserCheck,
  

  faArrowDownToSquare,
  

  faNote,
  

  faTruckRampBox,
  
  faTruckLoading,
  

  faBlueberries,
  

  faPenField,
  

  faClipboardList,
  

  faPumpkin,
  

  faCodePullRequest,
  

  faDesktopArrowDown,
  

  faPaste,
  
  faFileClipboard,
  

  faComments,
  

  faCaretRight,
  

  faBackward,
  

  faPencil,
  
  faPencilAlt,
  

  faLips,
  

  faLandmarkFlag,
  

  faRam,
  

  faExcavator,
  

  faEggplant,
  

  faFolderGrid,
  

  faGaugeMin,
  
  faTachometerAltSlowest,
  

  faDiagramPrevious,
  

  faK,
  

  faPage,
  

  faStrikethrough,
  

  faTrees,
  

  faHandLove,
  

  faFootballHelmet,
  

  faGrid,
  
  faGrid3,
  

  faPanFrying,
  

  faAddressBook,
  
  faContactBook,
  

  faCartMinus,
  

  faPager,
  

  faMerge,
  

  faCircleH,
  
  faHospitalSymbol,
  

  faHexagonXmark,
  
  faTimesHexagon,
  
  faXmarkHexagon,
  

  faCartXmark,
  

  faBowArrow,
  

  faFileCircleExclamation,
  

  faEnvelopesBulk,
  
  faMailBulk,
  

  faJarWheat,
  

  faSpoon,
  
  faUtensilSpoon,
  

  faCheeseSwiss,
  

  faHouseBuilding,
  

  faLeafHeart,
  

  faArrowsRotateReverse,
  

  faArrowDownUpAcrossLine,
  

  faSpaghettiMonsterFlying,
  
  faPastafarianism,
  

  faTruckFlatbed,
  

  faClarinet,
  

  faBong,
  

  faCameraMovie,
  

  faSigma,
  

  faFaceGrinStars,
  
  faGrinStars,
  

  faSquareP,
  

  faBringForward,
  

  faRecordVinyl,
  

  faTruckPlane,
  

  faCircleHeart,
  
  faHeartCircle,
  

  faChevronsLeft,
  
  faChevronDoubleLeft,
  

  faUnion,
  

  faMenorah,
  

  faFileCsv,
  

  faLaptop,
  

  faPerson,
  
  faMale,
  

  faFireFlameSimple,
  
  faBurn,
  

  faPersonCarryBox,
  
  faPersonCarry,
  

  faArrowUpLong,
  
  faLongArrowUp,
  

  faCalendarCircleUser,
  

  faTransporter,
  

  faDiagramPredecessor,
  

  faCrateEmpty,
  

  faBeerMugEmpty,
  
  faBeer,
  

  faPeopleLine,
  

  faLightbulbExclamationOn,
  

  faLocationPlus,
  
  faMapMarkerPlus,
  

  faSquareArrowRight,
  
  faArrowSquareRight,
  

  faPeopleRoof,
  

  faUsersRectangle,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

  faCrop,
  

  faSchoolCircleExclamation,
  

  faUserVneck,
  

  faFootball,
  
  faFootballBall,
  

  faChevronsUp,
  
  faChevronDoubleUp,
  

  faFlagCheckered,
  

  faUtilityPoleDouble,
  

  faBuildingMemo,
  

  faSquareX,
  

  faBowlScoop,
  
  faBowlShavedIce,
  

  faMessageExclamation,
  
  faCommentAltExclamation,
  

  faLightCeiling,
  

  faFaceSmileBeam,
  
  faSmileBeam,
  

  faForwardStep,
  
  faStepForward,
  

  faMessageBot,
  

  faMagnifyingGlassLocation,
  
  faSearchLocation,
  

  faHandPointRight,
  

  faH1,
  

  faStandardDefinition,
  
  faRectangleSd,
  

  faSkiBoot,
  

  faFingerprint,
  

  faPumpMedical,
  

  faLocationMinus,
  
  faMapMarkerMinus,
  

  faSlidersUp,
  
  faSlidersV,
  

  faBridgeCircleCheck,
  

  faCalculatorSimple,
  
  faCalculatorAlt,
  

  faClosedCaptioningSlash,
  

  faMicrophoneLinesSlash,
  
  faMicrophoneAltSlash,
  

  faIcons,
  
  faHeartMusicCameraBolt,
  

  faSoap,
  

  faAtom,
  

  faNfc,
  

  faFaceGlasses,
  

  faRightFromBracket,
  
  faSignOutAlt,
  

  faFilms,
  

  faDoorOpen,
  

  faShovel,
  

  faFaceIcicles,
  

  faCircleMinus,
  
  faMinusCircle,
  

  faFolderArrowDown,
  
  faFolderDownload,
  

  faSortDown,
  
  faSortDesc,
  

  faBarcodeScan,
  

  faMobileSignal,
  

  faArrowsUpToLine,
  

  faFork,
  
  faUtensilFork,
  

  faUfo,
  

  faTextSize,
  

  faSunHaze,
  

  faVolleyball,
  
  faVolleyballBall,
  

  faBuildingCircleArrowRight,
  

  faRectangleHistory,
  

  faTally4,
  

  faAnchorCircleCheck,
  

  faMp3Player,
  

  faCalendarDays,
  
  faCalendarAlt,
  

  faWifiFair,
  
  faWifi2,
  

  faTirePressureWarning,
  

  faDiceThree,
  

  faBuildingUn,
  

  faRing,
  

  faWaveSquare,
  

  faFileLines,
  
  faFileAlt,
  
  faFileText,
  

  faExplosion,
  

  faDownLeftAndUpRightToCenter,
  
  faCompressAlt,
  

  faSquareUser,
  

  faFaceHandPeeking,
  

  faTheta,
  

  faFonduePot,
  

  faRingDiamond,
  

  faRobotAstromech,
  

  faInfo,
  

  faSalad,
  
  faBowlSalad,
  

  faMessage,
  
  faCommentAlt,
  

  faCoffin,
  

  faStethoscope,
  

  faGaugeSimpleMin,
  
  faTachometerSlowest,
  

  faFaceHandYawn,
  

  faUserXmark,
  
  faUserTimes,
  

  faTextHeight,
  

  faHeadSideGoggles,
  
  faHeadVr,
  

  faCircleL,
  

  faTrashCan,
  
  faTrashAlt,
  

  faPhoneArrowUpRight,
  
  faPhoneArrowUp,
  
  faPhoneOutgoing,
  

  faRectanglesMixed,
  

  faAt,
  

  faTransporter7,
  

  faBagel,
  

  faLineHeight,
  

  faWagonCovered,
  

  faCircleChevronRight,
  
  faChevronCircleRight,
  

  faArrowsToCircle,
  

  faFillDrip,
  

};
